import * as i1 from '@angular/cdk/observers';
import { ObserversModule } from '@angular/cdk/observers';
import * as i2 from '@angular/cdk/scrolling';
import { CdkScrollable, ScrollingModule, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import * as i1$2 from '@angular/common';
import { DOCUMENT, isPlatformBrowser, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Directive, Inject, Input, Output, InjectionToken, Injectable, forwardRef, Pipe, Optional, HostListener, HostBinding, PLATFORM_ID, NgModule, Component, ChangeDetectionStrategy, ViewChild, ContentChild, ContentChildren, Self, Injector, ViewChildren, TemplateRef, ViewContainerRef, SimpleChange, ElementRef, RendererStyleFlags2, Host, ChangeDetectorRef } from '@angular/core';
import { ESCAPE, DOWN_ARROW, UP_ARROW, ENTER, TAB, SPACE, DELETE, BACKSPACE, LEFT_ARROW, RIGHT_ARROW } from '@angular/cdk/keycodes';
import * as i10 from 'rxjs';
import { Subject, fromEvent, merge, timer, asapScheduler, BehaviorSubject, of, switchMap as switchMap$1, forkJoin, ReplaySubject, filter as filter$1, takeUntil as takeUntil$1, asyncScheduler, interval, animationFrameScheduler, throwError, combineLatest, from, EMPTY, Observable, switchMapTo, toArray, race, startWith as startWith$1, map as map$1, tap as tap$1, distinctUntilChanged as distinctUntilChanged$1 } from 'rxjs';
import { map, filter, tap, mergeMap, debounceTime, startWith, pairwise, distinctUntilChanged, takeUntil, finalize, buffer, switchMap, takeWhile, skip, take, first, withLatestFrom, observeOn, catchError, delay, repeat, concatMap, mapTo, throttleTime, debounce, endWith } from 'rxjs/operators';
import ResizeObserver$1 from 'resize-observer-polyfill';
import * as i1$3 from '@angular/forms';
import { NG_VALIDATORS, FormsModule, Validators, UntypedFormGroup, UntypedFormControl, ReactiveFormsModule, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Settings, DateTime, FixedOffsetZone, SystemZone } from 'luxon';
import Color from 'color';
import * as i1$1 from '@angular/animations';
import { style, animate, trigger, state, transition, sequence, group, query, animation, stagger, keyframes } from '@angular/animations';
import { v4 } from 'uuid';
import * as i1$4 from '@angular/cdk/overlay';
import { OverlayConfig, OverlayModule as OverlayModule$1, CdkConnectedOverlay, ConnectionPositionPair } from '@angular/cdk/overlay';
import * as i2$1 from '@angular/cdk/portal';
import { CdkPortalOutlet, ComponentPortal, DomPortalOutlet, PortalInjector, PortalModule, TemplatePortal, DomPortal } from '@angular/cdk/portal';
import * as i1$5 from '@angular/cdk/a11y';
import { ActiveDescendantKeyManager, A11yModule } from '@angular/cdk/a11y';
import * as i1$6 from '@angular/cdk/stepper';
import { CdkStepLabel, CdkStepHeader, CdkStepper, CdkStep, CdkStepperModule } from '@angular/cdk/stepper';
import { ComponentStore } from '@ngrx/component-store';
import { difference, orderBy, snakeCase, isEmpty, isEqual, uniq, cloneDeep, chunk, flattenDeep, xor } from 'lodash';
import * as i1$9 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i1$7 from '@angular/cdk/layout';
import * as i4 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i3 from '@angular/cdk/collections';
import * as Mime from 'mime/lite';
import * as i1$8 from '@angular/platform-browser';
import * as i1$a from '@angular/router';
import { CstParser, Lexer, tokenMatcher } from 'chevrotain';
import * as i11 from '@angular/cdk/text-field';
import { TextFieldModule } from '@angular/cdk/text-field';
import * as i7 from '@angular/cdk-experimental/scrolling';
import { ScrollingModule as ScrollingModule$1 } from '@angular/cdk-experimental/scrolling';
import { CdkAccordionItem, CdkAccordionModule } from '@angular/cdk/accordion';
import * as i4$1 from '@ngneat/transloco';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';

/**
 * the [avnDrag] directive will emit mouse move events while the element it is applied on is being dragged
 * i.e. take mouse events on mouse down until mouse up
 * The following events will be emitted:
 * - IDragStartEvent: when the dragging starts
 * - IDragMoveEvent: when the mouse is moving while dragging
 * - IDragEndEvent: when the dragging ends
 */
class DragDirective {
    /** @ignore */
    constructor(_elementRef, _document) {
        this._elementRef = _elementRef;
        this._document = _document;
        /**  Debounce time to emit the mouse move events */
        this.debounceTime = 100;
        /** Specifies if drag event should be sent while the mouse move occurs outside of the dragged element */
        this.allowOutsideMove = true;
        /**
         * Specifies the axis to watch while dragging.
         * e.g if 'x' is set then it won't emit move event when only the 'y' position has changed
         */
        this.axis = 'xy';
        /** Specifies the cursor displayed while dragging */
        this.cursor = 'col-resize';
        /**
         * When dragging, a full screen overlay is created to avoid interacting with other elements on the page
         * Basically this indicates if the overlay should visible (darkened) or transparent
         **/
        this.showDraggingOverlay = true;
        /** Emits when the element starts being dragged */
        this.dragStart = new EventEmitter();
        /** Emits when the element is being dragged */
        this.dragMove = new EventEmitter();
        /** Emits when the element being dragged is released */
        this.dragEnd = new EventEmitter();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngAfterViewInit() {
        this._elementRef.nativeElement.style.cursor = this.cursor;
        const mapMouseEvent = map((event) => ({
            clientX: event.clientX,
            clientY: event.clientY,
            event,
        }));
        // Note: touchend event will have the touches in 'changedTouches' rather than 'touches'
        const getTouchesArray = (event) => (event.touches?.length > 0 ? event.touches : event.changedTouches);
        const mapTouchEvent = map((event) => ({
            clientX: getTouchesArray(event)[0].clientX,
            clientY: getTouchesArray(event)[0].clientY,
            event,
        }));
        // check if the drag is
        const mousedown$ = fromEvent(this._elementRef.nativeElement, 'mousedown').pipe(mapMouseEvent);
        const mouseup$ = fromEvent(this._document, 'mouseup').pipe(mapMouseEvent);
        const mousemove$ = fromEvent(this.allowOutsideMove ? this._document : this._elementRef.nativeElement, 'mousemove').pipe(mapMouseEvent);
        const touchstart$ = fromEvent(this._elementRef.nativeElement, 'touchstart').pipe(mapTouchEvent);
        const touchend$ = fromEvent(this._document, 'touchend').pipe(mapTouchEvent);
        const touchmove$ = fromEvent(this.allowOutsideMove ? this._document : this._elementRef.nativeElement, 'touchmove').pipe(mapTouchEvent);
        const escapeKeypress$ = fromEvent(this._document, 'keydown').pipe(filter((event) => event.keyCode === ESCAPE));
        let dragOverlay;
        let initialClientX;
        let initialClientY;
        let lastMoveEvent;
        let escapeKeypressed;
        merge(mousedown$, touchstart$)
            .pipe(tap((event) => {
            // prevent any other bound event on the element (e.g. drag and drop in a datatable header cell)
            event.event.stopImmediatePropagation();
            if (event.event.cancelable) {
                event.event.preventDefault();
            }
            initialClientX = event.clientX;
            initialClientY = event.clientY;
            escapeKeypressed = false;
            lastMoveEvent = null;
            dragOverlay = null;
        }), mergeMap((mouseDownEvent) => merge(mousemove$, touchmove$).pipe(debounceTime(this.debounceTime), startWith(mouseDownEvent), pairwise(), map(([prev, current]) => {
            // prevent the default to avoid text selection
            if (current.event.cancelable) {
                current.event.preventDefault();
            }
            // on the first mouse move, emit drag start event
            if (['mousedown', 'touchstart'].includes(prev.event.type)) {
                this.dragStart.emit({
                    clientX: prev.clientX,
                    clientY: prev.clientY,
                });
            }
            // remember the last event
            lastMoveEvent = current;
            // create the overlay on the first mouse move event
            if (!dragOverlay) {
                // sets the cursor
                dragOverlay = this._createDraggingOverlay();
            }
            return {
                clientX: current.clientX,
                clientY: current.clientY,
                initialDiffX: current.clientX - initialClientX,
                initialDiffY: current.clientY - initialClientY,
                diffX: current.clientX - prev.clientX,
                diffY: current.clientY - prev.clientY,
            };
        }), distinctUntilChanged(), 
        // filter only the requested axis
        filter((e) => this.axis === 'xy' || (this.axis === 'x' && e.diffX !== 0) || (this.axis === 'y' && e.diffY !== 0)), 
        // complete inner observable on mouseup event
        takeUntil(merge(mouseup$, touchend$, escapeKeypress$.pipe(tap(() => (escapeKeypressed = true))))), finalize(() => {
            // remove the overlay
            // remove the dragging overlay (it might not have been created if the user just clicked with no mouse move)
            if (dragOverlay) {
                this._document.body.removeChild(dragOverlay);
            }
            // emit the drag end event if any dragging occurred
            const hasDragged = !!lastMoveEvent && !escapeKeypressed;
            if (hasDragged) {
                this.dragEnd.emit({
                    initialClientX,
                    initialClientY,
                    finalClientX: lastMoveEvent.clientX,
                    finalClientY: lastMoveEvent.clientY,
                    diffX: lastMoveEvent.clientX - initialClientX,
                    diffY: lastMoveEvent.clientY - initialClientY,
                });
            }
        }))), takeUntil(this._componentDestroyed$))
            .subscribe((e) => this.dragMove.emit(e));
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @ignore Creates a full screen overlay to avoid interacting with other elements while dragging **/
    _createDraggingOverlay() {
        const overlay = this._document.createElement('div');
        overlay.id = 'drag-overlay';
        overlay.style.position = 'absolute';
        overlay.style.top = '0px';
        overlay.style.left = '0px';
        overlay.style.right = '0px';
        overlay.style.bottom = '0px';
        if (this.showDraggingOverlay) {
            overlay.style.backgroundColor = '#000';
        }
        else {
            overlay.style.backgroundColor = 'transparent';
        }
        overlay.style.opacity = '0.1';
        // put the wrapper above all elements
        overlay.style.zIndex = '999999';
        overlay.style.cursor = this.cursor;
        this._document.body.appendChild(overlay);
        return overlay;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDirective, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: DragDirective, selector: "[avnDrag]", inputs: { debounceTime: "debounceTime", allowOutsideMove: "allowOutsideMove", axis: "axis", cursor: "cursor", showDraggingOverlay: "showDraggingOverlay" }, outputs: { dragStart: "dragStart", dragMove: "dragMove", dragEnd: "dragEnd" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnDrag]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { debounceTime: [{
                type: Input
            }], allowOutsideMove: [{
                type: Input
            }], axis: [{
                type: Input
            }], cursor: [{
                type: Input
            }], showDraggingOverlay: [{
                type: Input
            }], dragStart: [{
                type: Output
            }], dragMove: [{
                type: Output
            }], dragEnd: [{
                type: Output
            }] } });

/**
 * the [avnInputRegex] directive will only allow text matching the provided regex into an input field
 * Emits the input field value change with the inputChange event
 */
class InputRegexDirective {
    /** @ignore */
    constructor(_inputElement) {
        this._inputElement = _inputElement;
        /** the last valid value. this input can be used to update the last valid value of the input */
        this.lastValidValue = '';
        /** Emits when a valid input is set */
        this.inputChange = new EventEmitter();
        /** Emits when an invalid input is set. Emits the invalid value and the cursor position at which an invalid char was entered */
        this.inputInvalid = new EventEmitter();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngAfterViewInit() {
        fromEvent(this._inputElement.nativeElement, 'input')
            .pipe(map((evt) => `${evt.target.value || ''}`), takeUntil(this._componentDestroyed$))
            .subscribe((value) => {
            const matchFullText = (text, regex) => (text.match(regex) || []).reduce((p, c) => p || c === text, false);
            const isValid = value.length === 0 || !this.regex || matchFullText(value, this.regex);
            if (isValid) {
                this.lastValidValue = value;
                this.inputChange.emit(value);
            }
            else {
                // remember the cursor position
                const cursorPosition = this._inputElement.nativeElement.selectionStart;
                this._inputElement.nativeElement.value = this.lastValidValue;
                this.inputInvalid.emit({
                    value,
                    cursorPosition,
                });
            }
        });
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputRegexDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: InputRegexDirective, selector: "input[avnInputRegex]", inputs: { regex: ["avnInputRegex", "regex"], lastValidValue: "lastValidValue" }, outputs: { inputChange: "inputChange", inputInvalid: "inputInvalid" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputRegexDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'input[avnInputRegex]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { regex: [{
                type: Input,
                args: ['avnInputRegex']
            }], lastValidValue: [{
                type: Input
            }], inputChange: [{
                type: Output
            }], inputInvalid: [{
                type: Output
            }] } });

/**
 * the [avnMultiClick] directive will emit an event after the specified number of clicks is made on the host element
 * Time between clicks is configurable
 */
class MultiClickDirective {
    /** @ignore */
    constructor(_elementRef, _document) {
        this._elementRef = _elementRef;
        this._document = _document;
        /** Number of clicks that must be made for the event to be emitted (e.g. 2 = double click) */
        this.clickCount = 2;
        /** Time in millisecs within which the clicks must occur */
        this.clickTime = 250;
        /** Emits when a multi click occurs */
        this.avnMultiClick = new EventEmitter();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngAfterViewInit() {
        const clicked$ = fromEvent(this._elementRef.nativeElement, 'click');
        // collect clicks (buffer) while clicks occur within the clickTime
        clicked$
            .pipe(buffer(clicked$.pipe(debounceTime(this.clickTime))), filter((clicks) => clicks.length === this.clickCount), takeUntil(this._componentDestroyed$))
            .subscribe(() => this.avnMultiClick.emit());
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MultiClickDirective, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: MultiClickDirective, selector: "[avnMultiClick]", inputs: { clickCount: "clickCount", clickTime: "clickTime" }, outputs: { avnMultiClick: "avnMultiClick" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MultiClickDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnMultiClick]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { clickCount: [{
                type: Input
            }], clickTime: [{
                type: Input
            }], avnMultiClick: [{
                type: Output
            }] } });

/**
 * Injection token to set the default theme for the application (alternative to set it via css mixin import when it
 * is not possible, e.g. with encapsulated angular elements)
 */
const DEFAULT_THEME = new InjectionToken('DEFAULT_THEME');
/**
 * Injection token to set available themes for the application
 */
const AVAILABLE_THEMES = new InjectionToken('AVAILABLE_THEMES');
var ThemeAspect;
(function (ThemeAspect) {
    ThemeAspect["DMB"] = "dmb-aspect";
    ThemeAspect["NONE"] = "";
    ThemeAspect["NEUMORPHISM"] = "neumorphism";
})(ThemeAspect || (ThemeAspect = {}));
/**
 * The theme aspect. Used for modals that require adding the aspect on dynamically rendered component
 */
const THEME_ASPECT = new InjectionToken('THEME_ASPECT');

var ToastAlignmentType;
(function (ToastAlignmentType) {
    ToastAlignmentType["BottomLeft"] = "bottomLeft";
    ToastAlignmentType["BottomRight"] = "bottomRight";
    ToastAlignmentType["TopLeft"] = "topLeft";
    ToastAlignmentType["TopRight"] = "topRight";
})(ToastAlignmentType || (ToastAlignmentType = {}));

/**
 * Injection token to use in your custom toast that will enable the injection of custom data.
 */
const TOAST_DATA = new InjectionToken('TOAST_DATA');
/**
 * Injection token to set the settings for toasts.
 */
const TOAST_SETTINGS = new InjectionToken('TOAST_SETTINGS');
/**
 * default toast settings
 */
const DEFAULT_TOAST_SETTINGS = {
    /**
     * Default toast position set to bottom right
     */
    alignment: ToastAlignmentType.BottomRight,
    /**
     * Offset from the y axis depending on alignment.
     */
    yOffset: 50,
    /**
     * Offset on the x axis depending on alignment.
     */
    xOffset: 10,
    /**
     * The time that a toast will stay displayed.
     */
    dismissTime: 8000,
};

/**
 * Global configuration for all date time components (calendar / timepicker)
 */
const DATE_TIME_OPTIONS = new InjectionToken('DATE_TIME_OPTIONS');
const DEFAULT_DATE_TIME_OPTIONS = {
    timezone: 'local',
    showTimeKeypad: true,
};

/**
 * The [avnHasChildClass] directive is responsible for adding a class to the host element
 * when it has children. It also tracks changes to the underlying DOM for mutations and
 * and adds the class as children are added.
 */
class HasChildClassDirective {
    constructor(renderer, elementRef, contentObserver) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.contentObserver = contentObserver;
        this.domMutationSub = this.contentObserver
            .observe(this.elementRef.nativeElement)
            .pipe(filter((mutations) => mutations.findIndex((m) => m.type === 'childList') !== -1))
            .subscribe((_) => {
            this.toggleClass();
        });
    }
    /**
     * @ignore
     */
    ngAfterViewInit() {
        this.toggleClass();
    }
    ngOnDestroy() {
        this.domMutationSub.unsubscribe();
    }
    /**
     * @ignore
     */
    toggleClass() {
        if (this.elementRef.nativeElement.children && this.elementRef.nativeElement.children.length > 0) {
            this.renderer.addClass(this.elementRef.nativeElement, this.avnHasChildClass);
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement, this.avnHasChildClass);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: HasChildClassDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1.ContentObserver }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: HasChildClassDirective, selector: "[avnHasChildClass]", inputs: { avnHasChildClass: "avnHasChildClass" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: HasChildClassDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnHasChildClass]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1.ContentObserver }]; }, propDecorators: { avnHasChildClass: [{
                type: Input
            }] } });

/**
 * the [avnLongPress] directive will emit the initial click event at given interval once the directive element
 * is clicked and while mouse click has not been released
 */
class LongPressDirective {
    /** @ignore */
    constructor(_elementRef, _document) {
        this._elementRef = _elementRef;
        this._document = _document;
        /** Time in ms after which the long press start event is emitted  */
        this.longPressStartTimeMs = 300;
        /**  Interval at which the initial mouse down event will be emitted once it has started. Leave blank for no interval emission */
        this.longPressIntervalTimeMs = null;
        /** Specifies if the long press is active. Sometimes we need to disable it once its active (e.g. reached a scroll edge) */
        this.longPressActive = true;
        /** Emits when the element is being pressed long enough (includes end press) */
        this.longPress = new EventEmitter();
        /** Emits when the long press has ended */
        this.longPressEnd = new EventEmitter();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngAfterViewInit() {
        const mousedown$ = fromEvent(this._elementRef.nativeElement, 'mousedown');
        const mouseup$ = fromEvent(this._document, 'mouseup');
        const touchstart$ = fromEvent(this._elementRef.nativeElement, 'touchstart');
        const touchend$ = fromEvent(this._elementRef.nativeElement, 'touchend');
        merge(mousedown$, touchstart$)
            .pipe(tap((event) => {
            // prevent any other bound event on the element
            event.stopImmediatePropagation();
            event.preventDefault();
        }), switchMap((triggerEvent) => timer(this.longPressStartTimeMs, this.longPressIntervalTimeMs).pipe(takeWhile(() => this.longPressActive), tap(() => this.longPress.emit(triggerEvent)), takeUntil(merge(mouseup$, touchend$)), finalize(() => this.longPressEnd.emit(triggerEvent)))), takeUntil(this._componentDestroyed$))
            .subscribe();
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LongPressDirective, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: LongPressDirective, selector: "[avnLongPress]", inputs: { longPressStartTimeMs: "longPressStartTimeMs", longPressIntervalTimeMs: "longPressIntervalTimeMs", longPressActive: "longPressActive" }, outputs: { longPress: "longPress", longPressEnd: "longPressEnd" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LongPressDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnLongPress]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { longPressStartTimeMs: [{
                type: Input
            }], longPressIntervalTimeMs: [{
                type: Input
            }], longPressActive: [{
                type: Input
            }], longPress: [{
                type: Output
            }], longPressEnd: [{
                type: Output
            }] } });

/**
 * the [avnResize] directive facilitates listening to changes in size of
 * an element using the native ResizeObserver or a ponyfill for browsers
 * that are behind.
 *
 * will emit initial values of the element.
 */
class ResizeDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Debounce time to emit the new size of the element. Default set to 100.
         * Increase if the element does not need to response to frequent change of its size.
         */
        this.debounceTime = 100;
        /**
         * Specifies if the initial resize event should be emitted.
         * The initial event is triggered when the element is loaded.
         */
        this.emitInitialEvent = true;
        /**
         * dispatched when the element's size changes.
         */
        this.avnResize = new EventEmitter();
        this.sizeSubject = new Subject();
        this.componentDestroyed$ = new Subject();
        this.resizeCount = 0;
    }
    ngAfterViewInit() {
        this.sizeSubject
            .asObservable()
            .pipe(skip(this.emitInitialEvent ? 0 : 1), debounceTime(this.debounceTime), startWith(null), pairwise(), takeUntil(this.componentDestroyed$))
            .subscribe(([previousSize, currentSize]) => {
            this.avnResize.next({ ...currentSize, isFirstResize: this.resizeCount === 0, previousWidth: previousSize?.width, previousHeight: previousSize?.height });
            this.resizeCount++;
        });
        this.resizeObserver = new ResizeObserver$1((mutations) => {
            mutations.forEach((mutation) => {
                this.sizeSubject.next({
                    width: mutation.contentRect.width,
                    height: mutation.contentRect.height,
                });
            });
        });
        this.resizeObserver.observe(this.elementRef.nativeElement);
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ResizeDirective, selector: "[avnResize]", inputs: { debounceTime: "debounceTime", emitInitialEvent: "emitInitialEvent" }, outputs: { avnResize: "avnResize" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnResize]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { debounceTime: [{
                type: Input
            }], emitInitialEvent: [{
                type: Input
            }], avnResize: [{
                type: Output
            }] } });

/**
 * A DI Token representing the scroll options for the slims scroll directive.
 */
const SCROLL_OPTIONS = new InjectionToken('SCROLL_OPTIONS');
const DEFAULT_SCROLL_OPTIONS = {
    scrollSize: 'thin',
    borderThumbRadius: '3px',
    borderTrackRadius: '3px',
};

class ScrollService {
    constructor(defaults, document) {
        this.document = document;
        this._options = { ...defaults };
    }
    get scrollThumbColor() {
        return 'var(--scrollbar-thumb)';
    }
    get scrollTrackColor() {
        return 'var(--scrollbar-track)';
    }
    get scrollSize() {
        return this._options.scrollSize;
    }
    appendScrollStylesOnce(element) {
        // hack to wait before executing the code otherwise with a router outlet and lazy loading its seems the DOM is not ready yet and element.getRootNode() does not return the ShadowRoot...
        asapScheduler.schedule(() => {
            const rootNode = element.getRootNode ? element.getRootNode() : this.document;
            if (rootNode instanceof Document && !this.document.getElementById('avnScrollStyles')) {
                const scrollStyle = this._createScrollStyleNode();
                this.document.head.appendChild(scrollStyle);
            }
            else if (rootNode instanceof ShadowRoot && !rootNode.getElementById('avnScrollStyles')) {
                const scrollStyle = this._createScrollStyleNode();
                rootNode.appendChild(scrollStyle);
            }
        });
    }
    _createScrollStyleNode() {
        const scrollStyle = this.document.createElement('style');
        scrollStyle.id = 'avnScrollStyles';
        scrollStyle.textContent = `
            .avnScrollElement {
                overflow: auto;
            }
            .avnScrollElement::-webkit-scrollbar {
                width: ${this.resolveScrollWidthForWebkit()};
                height: ${this.resolveScrollWidthForWebkit()};
                background-color: transparent;
            }
            .avnScrollElement::-webkit-scrollbar-track {
                background-color: ${this.scrollTrackColor};
                border: none;
                border-radius: ${this._options.borderTrackRadius};
            }
            .avnScrollElement::-webkit-scrollbar-thumb {
                background-color: ${this.scrollThumbColor};
                border-radius: ${this._options.borderThumbRadius};
            }
            .avnScrollElement::-webkit-scrollbar-corner {
                background-color: transparent;
            }
        `;
        return scrollStyle;
    }
    /**
     * resolves the webkit impl of scrollbar size based on the Mozilla impl of the in progress W3C
     * spec.
     */
    resolveScrollWidthForWebkit() {
        switch (this._options.scrollSize) {
            case 'auto':
                return '17px';
            case 'none':
                return '0px';
            case 'thin':
            default:
                return '6px';
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ScrollService, deps: [{ token: SCROLL_OPTIONS }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ScrollService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ScrollService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SCROLL_OPTIONS]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

/**
 * The avnScroll directive adds a stylish theme-aware scroll bar to any element.
 */
class ScrollDirective extends CdkScrollable {
    constructor(_renderer, elementRef, document, scrollDispatcher, ngZone, scrollService) {
        super(elementRef, scrollDispatcher, ngZone);
        this._renderer = _renderer;
        this.document = document;
        this.scrollService = scrollService;
        /** Activate emission of the scroll event when element is scrolled **/
        this.emitScrollEvent = false;
        /**
         * Emits when the element on which the directive is applied is scrolled
         * Limitation: Only emit events for the host element. will not emit scrolls of the targetElementSelector when it is specified
         * **/
        this.scrolled = new EventEmitter();
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
        this.selfNativeEl = elementRef.nativeElement;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.emitScrollEvent) {
            this.elementScrolled()
                .pipe(map((event) => ({ scrollLeft: event.target.scrollLeft, event })), startWith({ scrollLeft: this.selfNativeEl.scrollLeft, event: null }), pairwise(), takeUntil(this._componentDestroyed$))
                .subscribe(([prev, curr]) => {
                const direction = prev.scrollLeft !== curr.scrollLeft ? 'horizontal' : 'vertical';
                this.scrolled.emit({ direction, event: curr.event });
            });
        }
    }
    ngAfterViewInit() {
        this.setInlineStyles();
    }
    setInlineStyles() {
        // apply a style to the specified target element (if any) or the host element
        const targetElement = this.targetElementSelector ? this.document.querySelector(this.targetElementSelector) : this.selfNativeEl;
        this.scrollService.appendScrollStylesOnce(targetElement);
        if (targetElement) {
            this._renderer.addClass(targetElement, 'avnScrollElement');
            // Not sure if the following 2 inline styles are necessary. They are compatible only with Firefox.
            // I have tried to remove them in Firefox and the scrollbar looks fine without them. (Tested with Firefox
            // versions 72 & 73. Will keep them for now in case older versions require them.
            this._renderer.setStyle(targetElement, 'scrollbar-color', `${this.scrollService.scrollThumbColor} ${this.scrollService.scrollTrackColor}`);
            this._renderer.setStyle(targetElement, 'scrollbar-width', this.scrollService.scrollSize);
        }
    }
    /** @ignore */
    ngOnDestroy() {
        super.ngOnDestroy();
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ScrollDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: DOCUMENT }, { token: i2.ScrollDispatcher }, { token: i0.NgZone }, { token: ScrollService }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ScrollDirective, selector: "[avnScroll]", inputs: { targetElementSelector: ["avnScroll", "targetElementSelector"], emitScrollEvent: ["avnScrollEmitScrollEvent", "emitScrollEvent"] }, outputs: { scrolled: "scrolled" }, exportAs: ["avnScroll"], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ScrollDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnScroll]',
                    exportAs: 'avnScroll',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i2.ScrollDispatcher }, { type: i0.NgZone }, { type: ScrollService }]; }, propDecorators: { targetElementSelector: [{
                type: Input,
                args: ['avnScroll']
            }], emitScrollEvent: [{
                type: Input,
                args: ['avnScrollEmitScrollEvent']
            }], scrolled: [{
                type: Output
            }] } });

/**
 * Enum that describes all the available theme types (color groups).
 * Mainly used to apply a theme type to a component via an Input() property.
 * see @ITheme
 */
var ThemeType;
(function (ThemeType) {
    ThemeType["PRIMARY"] = "primary";
    ThemeType["SECONDARY"] = "secondary";
    ThemeType["HIGHLIGHT"] = "highlight";
    ThemeType["DANGER"] = "danger";
    ThemeType["WARNING"] = "warning";
    ThemeType["SUCCESS"] = "success";
    ThemeType["INFO"] = "info";
})(ThemeType || (ThemeType = {}));

class SelectedHighlightDirective {
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        /**
         * whether the underlying item is selected or not
         */
        this.avnSelectedHighlight = true;
        /**
         * theme to use on the border
         */
        this.avnSelectedHighlightTheme = ThemeType.SUCCESS;
        /**
         * width of the border to apply
         */
        this.avnSelectedHighlightBorder = 2;
        /**
         * track the the view is initiated
         */
        this.viewInit = false;
    }
    ngOnChanges() {
        if (this.viewInit) {
            this.drawChanges(this.avnSelectedHighlight);
        }
    }
    ngAfterViewInit() {
        this.viewInit = true;
        this.drawChanges(this.avnSelectedHighlight);
    }
    drawChanges(isSelected) {
        if (isSelected) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'border', `${this.avnSelectedHighlightBorder}px solid`);
            this.renderer.setStyle(this.elementRef.nativeElement, 'border-color', `var(--${this.avnSelectedHighlightTheme}-base)`);
        }
        else {
            this.renderer.setStyle(this.elementRef.nativeElement, 'border-width', `${this.avnSelectedHighlightBorder}px solid`);
            this.renderer.setStyle(this.elementRef.nativeElement, 'border-color', 'transparent');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SelectedHighlightDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: SelectedHighlightDirective, selector: "[avnSelectedHighlight]", inputs: { avnSelectedHighlight: "avnSelectedHighlight", avnSelectedHighlightTheme: "avnSelectedHighlightTheme", avnSelectedHighlightBorder: "avnSelectedHighlightBorder" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SelectedHighlightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnSelectedHighlight]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { avnSelectedHighlight: [{
                type: Input
            }], avnSelectedHighlightTheme: [{
                type: Input
            }], avnSelectedHighlightBorder: [{
                type: Input
            }] } });

const numberRangeValidator = (from, to) => (control) => {
    if ((control.value !== undefined && isNaN(control.value)) || control.value < from || control.value > to) {
        return { numberRange: true };
    }
    return null;
};
const fieldMatcherValidator = (field1, field2) => (control) => {
    const checkControl = control.get(field1);
    const confirmControl = control.get(field2);
    if (!checkControl || checkControl.pristine || confirmControl.pristine) {
        return null;
    }
    if (checkControl.value === confirmControl.value) {
        if (checkControl.errors && checkControl.errors.fieldMatch) {
            delete checkControl.errors.fieldMatch;
            if (Object.keys(checkControl.errors).length === 0) {
                checkControl.setErrors(null);
            }
        }
        if (confirmControl.errors && confirmControl.errors.fieldMatch) {
            delete confirmControl.errors.fieldMatch;
            if (Object.keys(confirmControl.errors).length === 0) {
                confirmControl.setErrors(null);
            }
        }
        return null;
    }
    else {
        checkControl.setErrors({ fieldMatch: true });
        confirmControl.setErrors({ fieldMatch: true });
        return { fieldMatch: true };
    }
};
const dateRangeValidator = (minSelectableDate, maxSelectableDate) => (control) => {
    if (!control.value) {
        return null;
    }
    const isOutOfRange = (minSelectableDate && control.value < minSelectableDate) || (maxSelectableDate && control.value > maxSelectableDate);
    if (isOutOfRange) {
        return { dateRange: true };
    }
    return null;
};

class FieldMatcherDirective {
    constructor() { }
    ngOnChanges() {
        this.validator = fieldMatcherValidator(this.field1, this.field2);
    }
    validate(control) {
        return this.validator ? this.validator(control) : null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FieldMatcherDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FieldMatcherDirective, selector: "[avnFieldMatcher]", inputs: { field1: ["avnFieldMatcher", "field1"], field2: "field2" }, providers: [
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef((() => FieldMatcherDirective)),
                multi: true,
            },
        ], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FieldMatcherDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnFieldMatcher]',
                    providers: [
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((() => FieldMatcherDirective)),
                            multi: true,
                        },
                    ],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { field1: [{
                type: Input,
                args: ['avnFieldMatcher']
            }], field2: [{
                type: Input
            }] } });

/**  A DI Token representing the form control validation options. */
const FORM_CONTROL_VALIDATION_OPTIONS = new InjectionToken('FORM_CONTROL_VALIDATION_OPTIONS');
/**
 * Default value for the form control validation options when none is specified in the Core module
 * configuration
 */
const DEFAULT_FORM_CONTROL_VALIDATION_OPTIONS = {
    enableInvalidTheme: true,
    enableValidTheme: true,
};

/**
 * This pipe concatenates an array of string into one string using the separator specified.
 * If no separator defined, comma will be used.
 */
class ConcatStringPipe {
    /***
     *
     * @param value An array of strings to concatenate
     * @param separator Separator
     */
    transform(value, separator) {
        // if no value just return an empty string
        if (!value || value.length === 0) {
            return '';
        }
        return value.join(separator ? separator : ', ');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ConcatStringPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ConcatStringPipe, name: "concatString" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ConcatStringPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'concatString' }]
        }] });

/**
 * This service allow to set the locale for date components.
 * Bind your locale changes from your app using this service.
 */
class DateLocaleService {
    constructor() {
        this._localeSubject = new BehaviorSubject(Settings.defaultLocale);
        this._componentDestroyed$ = new Subject();
        this._localeSubject.pipe(takeUntil(this._componentDestroyed$)).subscribe((locale) => (Settings.defaultLocale = locale));
    }
    setLocale(locale) {
        this._localeSubject.next(locale);
    }
    get locale$() {
        return this._localeSubject.asObservable();
    }
    get locale() {
        return this._localeSubject.value;
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DateLocaleService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DateLocaleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DateLocaleService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

/**
 * Short representation of a date. Example:
 * [fr]: 10/09/2022
 * [en]: 09/10/2022
 */
const DATE_FORMAT_SHORT = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};
/**
 * Medium representation of a date. Example:
 * [fr]: 10 Sept. 2022
 * [en]: Sept 10, 2022
 */
const DATE_FORMAT_MEDIUM = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
};
/**
 * Long representation of a date. Example:
 * [fr]: 10 Septembre 2022
 * [en]: September 10, 2022
 */
const DATE_FORMAT_LONG = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
};
/**
 * Short representation of a time without seconds. Example:
 * 10:12
 */
const TIME_FORMAT = {
    hour: '2-digit',
    minute: '2-digit',
};
/**
 * Short representation of a time without seconds. Example:
 * 10:12
 */
const TIME_FORMAT_SECONDS = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
};
/**
 * Short representation of a time with seconds and milliseconds. Example:
 * 10:12.555
 */
const TIME_FORMAT_MILLISECONDS = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3,
};
/**
 * Short representation of a datetime. Example:
 * [fr]: 10/09/2022 10:10
 * [en]: 09/10/2022 10:10
 */
const DATE_TIME_FORMAT_SHORT = {
    ...DATE_FORMAT_SHORT,
    ...TIME_FORMAT,
};
/**
 * Short representation of a datetime. Example:
 * [fr]: 10/09/2022 10:10:45
 * [en]: 09/10/2022 10:10:45
 */
const DATE_TIME_FORMAT_SHORT_SECS = {
    ...DATE_FORMAT_SHORT,
    ...TIME_FORMAT_SECONDS,
};
/**
 * Medium representation of a datetime. Example:
 * [fr]: 10 Sept. 2022 10:10
 * [en]: Sept 10, 2022 10:10
 */
const DATE_TIME_FORMAT_MEDIUM = {
    ...DATE_FORMAT_MEDIUM,
    ...TIME_FORMAT,
};
/**
 * Medium representation of a datetime. Example:
 * [fr]: 10 Sept. 2022 10:10:45
 * [en]: Sept 10, 2022 10:10:45
 */
const DATE_TIME_FORMAT_MEDIUM_SECS = {
    ...DATE_FORMAT_MEDIUM,
    ...TIME_FORMAT_SECONDS,
};
/**
 * Medium representation of a datetime. Example:
 * [fr]: 10 Septembre 2022 10:10
 * [en]: September 10, 2022 10:10
 */
const DATE_TIME_FORMAT_LONG = {
    ...DATE_FORMAT_LONG,
    ...TIME_FORMAT,
};
/**
 * Medium representation of a datetime. Example:
 * [fr]: 10 Septembre 2022 10:10
 * [en]: September 10, 2022 10:10
 */
const DATE_TIME_FORMAT_LONG_SECS = {
    ...DATE_FORMAT_LONG,
    ...TIME_FORMAT_SECONDS,
};

const DateTimeFormatOptionsMap = {
    date_short: DATE_FORMAT_SHORT,
    date_medium: DATE_FORMAT_MEDIUM,
    date_long: DATE_FORMAT_LONG,
    time: TIME_FORMAT,
    time_secs: TIME_FORMAT_SECONDS,
    time_ms: TIME_FORMAT_MILLISECONDS,
    datetime_short: DATE_TIME_FORMAT_SHORT,
    datetime_medium: DATE_TIME_FORMAT_MEDIUM,
    datetime_long: DATE_TIME_FORMAT_LONG,
    datetime_short_secs: DATE_TIME_FORMAT_SHORT_SECS,
    datetime_medium_secs: DATE_TIME_FORMAT_MEDIUM_SECS,
    datetime_long_secs: DATE_TIME_FORMAT_LONG_SECS,
};
/**
 * This pipe formats a date/timestamp using the specified date format pattern
 */
class DateFormatPipe {
    constructor(_dateLocaleService) {
        this._dateLocaleService = _dateLocaleService;
    }
    /***
     *
     * @param value the date value to be transformed
     * @param dateFormat Optional. the date format pattern to use (e.g. DD/MM/YYYY HH:mm). When omitted it will use the specified locale (or the default locale if no locale is provided).
     * @returns a formatted text representation of the date
     */
    transform(value, dateFormat = DATE_TIME_FORMAT_SHORT, locale = this._dateLocaleService.locale) {
        // if no value just return an empty string
        if (!value) {
            return '';
        }
        let dateTime;
        if (value instanceof Date) {
            dateTime = DateTime.fromJSDate(value);
        }
        else if (typeof value === 'string') {
            dateTime = DateTime.fromISO(value);
        }
        else if (typeof value === 'number') {
            dateTime = DateTime.fromMillis(value);
        }
        else {
            dateTime = value;
        }
        if (!dateFormat) {
            return dateTime.toLocaleString(null, { locale });
        }
        // backwards compat with hardcoded format
        const isPrebuildFormat = typeof dateFormat === 'string' && Object.keys(DateTimeFormatOptionsMap).includes(dateFormat);
        const isCustomFormat = typeof dateFormat === 'string' && !isPrebuildFormat;
        if (isCustomFormat) {
            return dateTime.toFormat(this._toLuxonFormat(dateFormat));
        }
        if (isPrebuildFormat) {
            dateFormat = DateTimeFormatOptionsMap[dateFormat];
        }
        // toLocaleString auto adds commas between date and time, we dont want that so format the date and time separately
        const dateTimeFormatOptions = dateFormat;
        const { hour, minute, second, fractionalSecondDigits, hour12, hourCycle, ...dateFormatOptions } = dateTimeFormatOptions;
        const hasDateInfo = Object.keys(dateFormatOptions).length > 0;
        const hasTimeInfo = hour || minute || second || fractionalSecondDigits;
        if (!hasDateInfo || !hasTimeInfo) {
            return dateTime.toLocaleString(dateTimeFormatOptions, { locale });
        }
        const formattedDate = dateTime.toLocaleString(dateFormatOptions, { locale });
        const formattedTime = dateTime.toLocaleString({ hour, minute, second, fractionalSecondDigits, hour12, hourCycle }, { locale });
        return `${formattedDate} ${formattedTime}`;
    }
    // for backwards compatibility with old momentjs format
    _toLuxonFormat(dateFormat) {
        return dateFormat.replace(/D/g, 'd').replace(/Y/g, 'y');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DateFormatPipe, deps: [{ token: DateLocaleService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: DateFormatPipe, name: "dateFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DateFormatPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'dateFormat' }]
        }], ctorParameters: function () { return [{ type: DateLocaleService }]; } });

/**
 * This Pipe can be used to display a nested property of an object
 * Can also apply an extra pipe to the
 *
 * usage: object | nestedProperty:prop:pipeInstance
 *
 * e.g. Retrieve street number of user address (user.address.streetNumber)
 * user | nestedProperty:user.address.streetNumber
 */
/* eslint-disable no-prototype-builtins */
class NestedPropertyPipe {
    /**
     * @param An array containing the nested properties for which to retrieve the value
     * @param A pipe to apply to the retrieved nested property value
     */
    transform(obj, nestedProps, pipe) {
        if (!obj || !nestedProps) {
            return '';
        }
        const props = nestedProps.split('.');
        const value = this.getValue(obj, props, 0);
        if (pipe) {
            return pipe.transform(value);
        }
        return value;
    }
    /** recursively parse the nested properties to find the value */
    getValue(obj, nestedProps, i) {
        if (!obj) {
            return '';
        }
        // If this is the last property
        if (i === nestedProps.length - 1) {
            const value = obj[nestedProps[i]];
            return value === undefined || value === null ? '' : obj[nestedProps[i]];
        }
        // is Array, concatenate all values
        if (nestedProps[i].includes('[]')) {
            const values = [];
            const currentProp = nestedProps[i].replace('[]', '');
            if (obj.hasOwnProperty(currentProp)) {
                obj[currentProp].forEach((subObject) => {
                    const value = this.getValue(subObject, nestedProps.slice(i + 1), 0);
                    if (value !== '') {
                        values.push(value);
                    }
                });
            }
            return values.length > 0 ? values.join(', ') : '';
        }
        // Otherwise let's traverse to the next property
        return this.getValue(obj[nestedProps[i]], nestedProps, ++i);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NestedPropertyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: NestedPropertyPipe, name: "nestedProperty" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NestedPropertyPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'nestedProperty' }]
        }] });

/**
 * This Pipe can be used to map an object to a single property of this object
 *
 * usage: object | map:prop
 *
 * e.g. map a list of user to an array of user ids (user = {id: 1, name: 'hodor'})
 * users | nestedProperty:'id'
 */
class MapToPipe {
    /**
     * @param obj An array containing the objects to map
     * @param prop A pipe to apply to the retrieved nested property value
     */
    transform(array, prop) {
        if (!array) {
            return array;
        }
        return array.map((obj) => new NestedPropertyPipe().transform(obj, prop));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MapToPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: MapToPipe, name: "mapTo" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MapToPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mapTo' }]
        }] });

/**
 * Filters undefined and null values
 */
const filterNil = () => filter((value) => value !== null && value !== undefined);
/**
 * Filters falsy values
 */
const isTruthy = () => filter((value) => !!value);
/**
 * Filters truthy values
 */
const isFalsy = () => filter((value) => !value);

/**
 * This pipe formats a date/timestamp to a relative time (e.g. 1 hour ago, 2 days ago)
 * Returns an observable that emit the updated relative time text as time passes
 */
class TimeAgoPipe {
    constructor() {
        this._timerIntervalChanged = new BehaviorSubject(null);
    }
    /***
     *
     * @param value   the date value to be transformed
     * @returns a relative time representation of the date
     *
     * Uses the system locale unless overridden in the options
     */
    transform(value, options = { style: 'long' }) {
        // if no value just return an empty string
        if (!value) {
            return of(null);
        }
        let dateTime;
        if (value instanceof Date) {
            dateTime = DateTime.fromJSDate(value);
        }
        else if (typeof value === 'string') {
            dateTime = DateTime.fromISO(value);
        }
        else {
            dateTime = value;
        }
        if (!dateTime.isValid) {
            return of(null);
        }
        const showSeconds = !options?.unit || options.unit.includes('seconds');
        const relativeTime$ = this._timerIntervalChanged.pipe(filterNil(), startWith({ msBeforeNextRefresh: this._getMsBeforeNextRefresh(dateTime, showSeconds) }), switchMap$1(({ msBeforeNextRefresh }) => timer(0, msBeforeNextRefresh).pipe(tap(() => {
            // at each refresh, recheck next refresh time
            const newMsBeforeNextRefresh = this._getMsBeforeNextRefresh(dateTime, showSeconds);
            if (newMsBeforeNextRefresh !== msBeforeNextRefresh) {
                this._timerIntervalChanged.next({ msBeforeNextRefresh: newMsBeforeNextRefresh });
            }
        }), map(() => {
            // convert 1 day ago to 'yesterday'
            const diffDays = Math.abs(dateTime.diff(DateTime.now(), 'days').days);
            if (diffDays >= 1 && diffDays < 2) {
                return dateTime.toRelativeCalendar({
                    ...(options || {}),
                    unit: 'days',
                });
            }
            return dateTime.toRelative(options);
        }))));
        return relativeTime$;
    }
    _getMsBeforeNextRefresh(dateTime, isShowingSeconds) {
        // when seconds are shown (relative time is < 1 min ago), refresh every seconds, otherwise every minute is enough
        const diffSeconds = Math.abs(dateTime.diff(DateTime.now(), ['seconds']).seconds);
        if (isShowingSeconds && diffSeconds < 60) {
            return 1000;
        }
        return 1000 * 60;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimeAgoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TimeAgoPipe, name: "timeAgo" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimeAgoPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'timeAgo' }]
        }] });

/* Create a new injection token for injecting the window into a component. */
const WINDOW = new InjectionToken('WindowToken');
/* Define abstract class for obtaining reference to the global window object. */
class WindowRef {
    // eslint-disable-next-line @typescript-eslint/ban-types
    get nativeWindow() {
        throw new Error('Not implemented.');
    }
}
/* Define class that implements the abstract class and returns the native window object. */
class BrowserWindowRef extends WindowRef {
    constructor() {
        super();
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    get nativeWindow() {
        return window;
    }
}
/* Create an factory function that returns the native window object. */
// eslint-disable-next-line @typescript-eslint/ban-types
const windowFactory = (browserWindowRef, platformId) => {
    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }
    return new Object();
};

/**
 * Enum that describes all the variations of a theme type (color group).
 * Mainly used to apply a color shade to a component via an Input() property.
 * see @IThemeShade
 */
var ThemeShade;
(function (ThemeShade) {
    ThemeShade["S_50"] = "50";
    ThemeShade["S_100"] = "100";
    ThemeShade["S_200"] = "200";
    ThemeShade["S_300"] = "300";
    ThemeShade["S_400"] = "400";
    ThemeShade["S_500"] = "500";
    ThemeShade["S_600"] = "600";
    ThemeShade["S_700"] = "700";
    ThemeShade["S_800"] = "800";
    ThemeShade["S_900"] = "900";
})(ThemeShade || (ThemeShade = {}));

/**
 * Generates lighter and/or darker variations for a given color
 */
const generateColorInformation = (color, _isDarkTheme) => {
    const baseColor = toColorObj(color);
    const foregroundColor = resolveForegroundColor(color);
    const colorShades = generateThemeShades(baseColor);
    // resolve the foreground color for each of theses shades (either black or white)
    const colorShadesForeground = Object.values(ThemeShade).reduce((p, c) => {
        p[c] = resolveForegroundColor(colorShades[c]);
        return p;
    }, {});
    // For now always make the variant darker for both light/dark theme, we may change that later on
    return {
        base: baseColor,
        baseForeground: foregroundColor,
        // variant: colorShades[_isDarkTheme ? 700 : 300],
        // variantForeground: colorShadesForeground[isDarkTheme ? 700 : 300],
        variant: colorShades[ThemeShade.S_700],
        variantForeground: colorShadesForeground[ThemeShade.S_700],
        shades: colorShades,
        shadesForeground: colorShadesForeground,
    };
};
/**
 * Generates lighter and/or darker variations for a given color
 */
const generateThemeShades = (colour) => {
    const color = toColorObj(colour);
    // return object with empty values if specified color is null
    if (!color) {
        return Object.values(ThemeShade).reduce((p, c) => {
            p[c] = null;
            return p;
        }, {});
    }
    return {
        50: color.lighten(0.5).rgb(),
        100: color.lighten(0.4).rgb(),
        200: color.lighten(0.3).rgb(),
        300: color.lighten(0.2).rgb(),
        400: color.lighten(0.1).rgb(),
        500: color.rgb(),
        600: color.darken(0.1).rgb(),
        700: color.darken(0.3).rgb(),
        800: color.darken(0.5).rgb(),
        900: color.darken(0.6).rgb(),
    };
};
/**
 * Generates lighter and/or darker variations for a given color
 */
const resolveForegroundColor = (colour) => {
    // male sure to copy the color
    const themeColor = new Color(toColorObj(colour))['color'];
    // now find if either black or white is the most relevant color
    themeColor.forEach((color, i) => {
        color = color / 255;
        if (color <= 0.03928) {
            themeColor[i] = color / 12.92;
        }
        else {
            themeColor[i] = Math.pow((color + 0.055) / 1.055, 2.4);
        }
    });
    const L = 0.2126 * themeColor[0] + 0.7152 * themeColor[1] + 0.0722 * themeColor[2];
    if (L > 0.179) {
        return new Color('rgb(0, 0, 0)');
    }
    return new Color('rgb(255, 255, 255)');
};
/**
 * Convert a color to its rgb string representation
 */
const toRgbColorString = (value) => {
    if (!value || ['none', 'transparent', 'inherit'].includes(value.toString())) {
        return value;
    }
    if (!isNaN(value)) {
        return `${value}`;
    }
    if (value.constructor.name === 'String') {
        return new Color(value.toString().trim()).rgb().string();
    }
    return value?.toString();
};
const toHexColorString = (rgbColor) => {
    let hexVal;
    const rgbStr = rgbColor?.match(/[0-9]+,\s*[0-9]+,\s*[0-9]+/);
    if (rgbStr && rgbStr.length > 0) {
        let rgbArr = rgbStr[0].split(',');
        rgbArr = rgbArr.map((value) => {
            let val = Number(value.trim()).toString(16);
            if (val.length < 2) {
                val = `0${val}`;
            }
            return val;
        });
        hexVal = `#${rgbArr.join('')}`;
    }
    return hexVal;
};
/**
 * return all css variables of the root element
 * https://stackoverflow.com/questions/45763121/list-css-custom-properties-css-variables
 */
const getRootCssVariables = (document) => [].slice.call(document.styleSheets).reduce((prev, styleSheet) => {
    // use try catch to avoid ERROR DOMException: Failed to read the 'cssRules' property from 'CSSStyleSheet': Cannot access rules
    try {
        if (styleSheet.cssRules) {
            const vars = [].slice.call(styleSheet.cssRules).reduce((res, cssRule) => {
                if (cssRule.selectorText === ':root') {
                    let css = cssRule.cssText.split('{');
                    css = css[1].replace('}', '').split(';');
                    // eslint-disable-next-line @typescript-eslint/prefer-for-of
                    for (let i = 0; i < css.length; i++) {
                        const prop = css[i].split(':');
                        if (prop.length === 2 && prop[0].trim().startsWith('--')) {
                            res[prop[0].trim()] = prop[1].trim();
                        }
                    }
                }
                return res;
            }, {});
            Object.keys(vars).forEach((k) => (prev[k] = vars[k]));
        }
    }
    /* eslint-disable-next-line no-empty*/
    catch (e) { }
    return prev;
}, {});
/**
 * converts css variable name to theme property
 * eg. --main-background to mainBackground
 */
const cssVariableToThemeProperty = (name) => {
    name = name.slice(2);
    return !name ? '' : [...name].reduce((p, c, i) => `${p}${c === '-' ? '' : name[i - 1] === '-' ? c.toUpperCase() : c}`, '');
};
/**
 * converts theme property to css variable name
 * eg. mainBackground to --main-background
 */
const themePropertyToCssVariable = (cssVar) => `--${[...cssVar].reduce((p, c) => `${p}${c.toUpperCase() === c && isNaN(Number(c)) ? '-' : ''}${c.toLowerCase()}`, '')}`;
/**
 * converts theme name from css value to display name
 * eg. amp-dark to Amp Dark
 */
const toThemeNameDisplay = (themeNameCss) => !themeNameCss ? '' : [...themeNameCss].reduce((p, c, i) => `${p}${c === '-' ? ' ' : i === 0 || themeNameCss[i - 1] === '-' ? c.toUpperCase() : c}`, '');
/**
 * Generates lighter and/or darker variations for a given color
 */
const toColorObj = (color) => {
    if (!color) {
        return null;
    }
    return new Color(color);
};

/**
 * we pass a generated theme (key / value typescript object) and we generate our internal theme format
 * use css variables from provided theme, generate missing ones
 */
const generateThemeDefaults = (theme) => {
    theme = { ...theme };
    // we get the default theme for the imported sass theme
    const isDarkTheme = theme.themeType === 'dark';
    // get the main background color (it is required). if no background is set, show a warning and default to silver
    let mainBackgroundColorValue = theme.mainBackground ? new Color(theme.mainBackground) : null;
    if (!mainBackgroundColorValue) {
        console.warn(`You did not provide a main background color (--main-background). Please add it the theme mixin${theme.themeName ? ' [name=' + theme.themeName + ']' : ''}`);
        mainBackgroundColorValue = new Color('#C0C0C0');
    }
    const mainBackgroundShades = generateThemeShades(mainBackgroundColorValue);
    // resolve the foreground color for each of theses shades (either black or white)
    // Note: generating the shades from the main foreground color does not work properly (e.g. black is always returned for all shades if
    // trying to generate the shades for black..)
    const mainBackgroundOnShades = Object.values(ThemeShade).reduce((p, c) => {
        p[c] = resolveForegroundColor(mainBackgroundShades[c]);
        return p;
    }, {});
    const mainColorShades = {
        background: mainBackgroundShades,
        foreground: mainBackgroundOnShades,
    };
    // for each themeable variable, also generate the missing related variables
    // colors //TODO rename to ThemeColor
    generateColorVariables(theme, isDarkTheme);
    // Layout
    generateLayoutVariables(theme, mainColorShades, isDarkTheme);
    // Surface (widgets, cards, and other first level elements)
    generateSurfaceVariables(theme, mainColorShades, isDarkTheme);
    // Form controls
    generateFormControlVariables(theme, mainColorShades, isDarkTheme);
    // Modals (dialogs, drawers, etc..)
    generateModalVariables(theme, mainColorShades, isDarkTheme);
    // Selection components (dropdown, list, etc..)
    generateSelectionComponentVariables(theme, mainColorShades, isDarkTheme);
    // Data Table
    generateDataTableVariables(theme, mainColorShades, isDarkTheme);
    // Map
    generateMapVariables(theme, mainColorShades, isDarkTheme);
    // other components
    generateOtherComponentVariables(theme, mainColorShades, isDarkTheme);
    return theme;
};
const generateColorVariables = (theme, isDarkTheme) => {
    Object.values(ThemeType).forEach((color) => {
        const baseColor = `${color}Base`;
        const baseColorValue = theme[baseColor];
        // if the base color is not set, there is nothing we can do
        if (!baseColorValue) {
            console.warn(`You did not provide a base color for --${color}. Please add it the theme mixin${theme.themeName ? ' [name=' + theme.themeName + ']' : ''}`);
            return;
        }
        else {
            theme[baseColor] = toRgbColorString(baseColorValue);
        }
        // generate the color shades
        const colorShades = generateColorInformation(baseColorValue, isDarkTheme);
        // foreground color
        const foregroundColor = `${color}On`;
        theme[foregroundColor] = toRgbColorString(theme[foregroundColor] || colorShades.baseForeground);
        // variant color (if its a dark theme, use a lighter color)
        const variantColor = `${color}Variant`;
        theme[variantColor] = toRgbColorString(theme[variantColor] || colorShades.variant);
        // variant color on
        const variantColorOn = `${color}VariantOn`;
        theme[variantColorOn] = toRgbColorString(theme[variantColorOn] || colorShades.variantForeground);
    });
};
const generateLayoutVariables = (theme, mainColorShades, isDarkTheme) => {
    const layoutBackgroundColorDarkenRatios = {
        main: 0,
        ribbon: -0.1,
        topnav: 0.1,
        sidenav: 0.2,
    };
    Object.keys(layoutBackgroundColorDarkenRatios).forEach((layoutItem) => {
        // for each layout element, calculate the default color from the main background color
        // TODO should we rather use a shade of the main background instead
        const defaultColor = mainColorShades.background[ThemeShade.S_500].darken(layoutBackgroundColorDarkenRatios[layoutItem]);
        // if the base color is not set, use the default color
        const layoutItemBackground = `${layoutItem}Background`;
        theme[layoutItemBackground] = toRgbColorString(theme[layoutItemBackground] || defaultColor);
        // generate the color shades of the background color
        const backgroundShades = generateThemeShades(new Color(theme[layoutItemBackground]));
        // foreground color
        const layoutItemForeground = `${layoutItem}On`;
        theme[layoutItemForeground] = toRgbColorString(theme[layoutItemForeground] || resolveForegroundColor(theme[layoutItemBackground]));
        // variant color (if its a dark theme, use a lighter color)
        const variantBackground = `${layoutItem}VariantBackground`;
        theme[variantBackground] = toRgbColorString(theme[variantBackground] || backgroundShades[ThemeShade.S_700]);
        // variant color on
        const variantColorOn = `${layoutItem}VariantOn`;
        theme[variantColorOn] = toRgbColorString(theme[variantColorOn] || resolveForegroundColor(theme[variantBackground]));
    });
    theme.ribbonBorder = toRgbColorString(theme.ribbonBorder) || toRgbaColorString(theme.ribbonVariantBackground, isDarkTheme ? 1 : 0.25);
    theme.ribbonMobileBackground = toRgbColorString(theme.ribbonMobileBackground) || theme.ribbonBackground;
    theme.ribbonMobileBorder = toRgbColorString(theme.ribbonMobileBorder) || theme.ribbonBorder;
    // breadcrumbs
    // if not set use darker variations of the ribbon background
    // ribbon breadcrumb background (default to ribbon variant)
    theme.ribbonBreadcrumbBackground = toRgbColorString(theme.ribbonBreadcrumbBackground || theme.ribbonVariantBackground);
    // ribbon breadcrumb foreground
    theme.ribbonBreadcrumbOn = toRgbColorString(theme.ribbonBreadcrumbOn || resolveForegroundColor(theme.ribbonBreadcrumbBackground));
    // ribbon breadcrumb variant
    const ribbonVariantBackgroundShades = generateThemeShades(new Color(theme.ribbonVariantBackground));
    theme.ribbonBreadcrumbVariantBackground = toRgbColorString(theme.ribbonBreadcrumbVariantBackground || ribbonVariantBackgroundShades[isDarkTheme ? ThemeShade.S_700 : ThemeShade.S_300]);
    // ribbon breadcrumb variant foreground
    theme.ribbonBreadcrumbVariantOn = toRgbColorString(theme.ribbonBreadcrumbVariantOn || resolveForegroundColor(theme.ribbonBreadcrumbVariantBackground));
    // top nav title
    theme.topnavTitleBackground = toRgbColorString(theme.topnavTitleBackground) || theme.topnavVariantBackground;
    theme.topnavTitleOn = toRgbColorString(theme.topnavTitleOn) || theme.topnavVariantOn;
    // other variables for sidenav
    const sidenavBackgroundShades = generateThemeShades(new Color(theme.sidenavBackground));
    theme.sidenavOpenBackground = toRgbColorString(theme.sidenavOpenBackground) || sidenavBackgroundShades[ThemeShade.S_50];
    theme.sidenavOpenOn = toRgbColorString(theme.sidenavOpenOn) || resolveForegroundColor(theme.sidenavOpenBackground);
    theme.sidenavBorder = toRgbColorString(theme.sidenavBorder) || theme.ribbonBorder;
    // nav tab bar
    theme.navTabBarColor = toRgbColorString(theme.navTabBarColor) || theme.topnavOn;
    theme.navTabBarSelectedColor = toRgbColorString(theme.navTabBarSelectedColor) || theme.primaryBase;
};
const generateSurfaceVariables = (theme, mainColorShades, _isDarkTheme) => {
    // background color
    theme.surfaceBackground = toRgbColorString(theme.surfaceBackground || mainColorShades.background[ThemeShade.S_300]);
    // foreground color
    theme.surfaceOn = toRgbColorString(theme.surfaceOn || mainColorShades.foreground[ThemeShade.S_300]);
    // border color (none when not specified)
    theme.surfaceBorder = theme.surfaceBorder || 'none';
};
const generateFormControlVariables = (theme, mainColorShades, isDarkTheme) => {
    // background color
    theme.formControlBackground = toRgbColorString(theme.formControlBackground || mainColorShades.background[isDarkTheme ? ThemeShade.S_400 : ThemeShade.S_600]);
    // foreground color
    theme.formControlOn = toRgbColorString(theme.formControlOn || mainColorShades.foreground[isDarkTheme ? ThemeShade.S_400 : ThemeShade.S_600]);
    // border color
    theme.formControlBorder = toRgbColorString(theme.formControlBorder || mainColorShades.background[isDarkTheme ? ThemeShade.S_300 : ThemeShade.S_700]);
    // border hover color
    theme.formControlHoverBorder = toRgbColorString(theme.formControlHoverBorder || theme.formControlOn);
    // icon (if not set, will use the same as border color)
    theme.formControlIcon = toRgbColorString(theme.formControlIcon || theme.formControlBorder);
    // hovered form control's icon
    theme.formControlHoverIcon = toRgbColorString(theme.formControlHoverIcon || resolveForegroundColor(theme.formControlHoverBorder));
    // label (if not set, will set to a lighter shade)
    theme.formControlLabel = theme.formControlLabel || getShade(theme.formControlOn, isDarkTheme ? ThemeShade.S_300 : ThemeShade.S_700);
    // label case (if not set, set to normal)
    theme.formControlLabelCase = theme.formControlLabelCase || 'normal';
    // label size (if not set, set to 1rem)
    theme.formControlLabelSize = theme.formControlLabelSize || '1rem';
    // label letter spacing (if not set, do not set)
    theme.formControlLabelLetterSpacing = theme.formControlLabelLetterSpacing || 'unset';
    // label letter spacing (if not set, default to light grey - browser default)
    theme.formControlPlaceholder = theme.formControlPlaceholder || 'rgb(135, 135, 135)';
    // hint (if not set, will set same as label)
    theme.formControlHint = theme.formControlHint || theme.formControlLabel;
    // slider bar
    theme.sliderBar = theme.sliderBar || theme.formControlBackground;
    // slider bar selected
    theme.sliderBarSelected = theme.sliderBarSelected || theme.formControlOn;
    // slider handle
    theme.sliderHandle = theme.sliderHandle || theme.formControlOn;
    // checkbox / radio / switch
    theme.checkboxRadioBackground = toRgbColorString(theme.checkboxRadioBackground) || theme.formControlOn;
    // checkbox / radio / switch
    theme.checkboxRadioHoverBackground = toRgbColorString(theme.checkboxRadioHoverBackground) || theme.checkboxRadioBackground;
    theme.switchOffBackground = theme.switchOffBackground || theme.formControlBackground;
    theme.switchOnBackground = theme.switchOnBackground || theme.formControlBackground;
};
/**
 * Modal
 */
const generateModalVariables = (theme, mainColorShades, isDarkTheme) => {
    // background color
    theme.modalBackground = toRgbColorString(theme.modalBackground || mainColorShades.background[ThemeShade.S_500]);
    // foreground color
    theme.modalOn = toRgbColorString(theme.modalOn || mainColorShades.foreground[ThemeShade.S_500]);
    // border color
    theme.modalBorder = toRgbColorString(theme.modalBorder || mainColorShades.background[isDarkTheme ? ThemeShade.S_100 : ThemeShade.S_900]);
    // dialog
    theme.dialogBorderRadius = theme.dialogBorderRadius || '3px';
    // dialog header
    theme.dialogHeaderBackground = toRgbColorString(theme.dialogHeaderBackground) || theme.modalBackground;
    theme.dialogHeaderOn = toRgbColorString(theme.dialogHeaderOn) || theme.modalOn;
    // dialog footer
    theme.dialogFooterBackground = toRgbColorString(theme.dialogFooterBackground) || theme.modalBackground;
    theme.dialogFooterOn = toRgbColorString(theme.dialogFooterOn) || theme.modalOn;
    // surface background color
    const modalBackgroundColorShades = generateThemeShades(theme.modalBackground);
    theme.modalSurfaceBackground = toRgbColorString(theme.modalSurfaceBackground || modalBackgroundColorShades[isDarkTheme ? ThemeShade.S_400 : ThemeShade.S_600]);
    // surface foreground color
    theme.modalSurfaceOn = toRgbColorString(theme.modalSurfaceOn || resolveForegroundColor(theme.modalSurfaceBackground));
    // surface border color
    theme.modalSurfaceBorder = toRgbColorString(theme.modalSurfaceBorder) || 'none';
    // tooltip
    theme.tooltipBackground = toRgbColorString(theme.tooltipBackground || (isDarkTheme ? '#fff' : '#333'));
    theme.tooltipOn = toRgbColorString(theme.tooltipOn || resolveForegroundColor(theme.tooltipBackground));
    // slide dialog
    theme.slideDialogBackground = theme.slideDialogBackground || theme.modalBackground;
    theme.slideDialogOn = theme.slideDialogOn || theme.modalOn;
};
/**
 * Selection Components
 */
const generateSelectionComponentVariables = (theme, mainColorShades, isDarkTheme) => {
    // background color
    theme.selectionComponentBackground = toRgbColorString(theme.selectionComponentBackground || theme.formControlBackground);
    // foreground color
    theme.selectionComponentOn = toRgbColorString(theme.selectionComponentOn || theme.formControlOn);
    // hover / active background color
    theme.selectionComponentHoverBackground = toRgbColorString(theme.selectionComponentHoverBackground || mainColorShades.background[isDarkTheme ? ThemeShade.S_600 : ThemeShade.S_400]);
    // hover / active foreground color
    theme.selectionComponentHoverOn = toRgbColorString(theme.selectionComponentHoverOn || mainColorShades.foreground[isDarkTheme ? ThemeShade.S_600 : ThemeShade.S_400]);
    // selected background color
    theme.selectionComponentSelectedBackground = toRgbColorString(theme.selectionComponentSelectedBackground || mainColorShades.background[isDarkTheme ? ThemeShade.S_800 : ThemeShade.S_200]);
    // selected foreground color
    theme.selectionComponentSelectedOn = toRgbColorString(theme.selectionComponentSelectedOn || mainColorShades.foreground[isDarkTheme ? ThemeShade.S_800 : ThemeShade.S_200]);
};
/**
 * Data Table
 */
const generateDataTableVariables = (theme, mainColorShades, isDarkTheme) => {
    // header background
    theme.dataTableHeaderBackground = toRgbColorString(theme.dataTableHeaderBackground || mainColorShades.background[isDarkTheme ? ThemeShade.S_300 : ThemeShade.S_700]);
    // header background on
    theme.dataTableHeaderOn = toRgbColorString(theme.dataTableHeaderOn || mainColorShades.foreground[isDarkTheme ? ThemeShade.S_300 : ThemeShade.S_700]);
    // header hover
    const headerBackgroundColorShades = generateThemeShades(theme.dataTableHeaderBackground);
    theme.dataTableHeaderHoverBackground = toRgbColorString(theme.dataTableHeaderHoverBackground) || headerBackgroundColorShades[isDarkTheme ? ThemeShade.S_700 : ThemeShade.S_300];
    theme.dataTableHeaderHoverOn = toRgbColorString(theme.dataTableHeaderHoverOn) || theme.dataTableHeaderOn;
    // footer background
    theme.dataTableFooterBackground = toRgbColorString(theme.dataTableFooterBackground || theme.dataTableHeaderBackground);
    // footer background on
    theme.dataTableFooterOn = toRgbColorString(theme.dataTableFooterOn || (theme.dataTableFooterBackground === 'none' ? 'inherit' : resolveForegroundColor(theme.dataTableFooterBackground)));
    // row background
    theme.dataTableRowOddBackground = toRgbColorString(theme.dataTableRowOddBackground) || theme.selectionComponentBackground;
    theme.dataTableRowOddOn = toRgbColorString(theme.dataTableRowOddOn) || resolveForegroundColor(theme.dataTableRowOddBackground);
    theme.dataTableRowEvenBackground = toRgbColorString(theme.dataTableRowEvenBackground) || theme.selectionComponentBackground;
    theme.dataTableRowEvenOn = toRgbColorString(theme.dataTableRowEvenOn) || resolveForegroundColor(theme.dataTableRowEvenBackground);
    // row border
    theme.dataTableRowBorder = toRgbColorString(theme.dataTableRowBorder || 'none');
    // row hover /active background color--data-table-row-hover-background
    theme.dataTableRowHoverBackground = toRgbColorString(theme.dataTableRowHoverBackground) || theme.selectionComponentHoverBackground;
    // row hover /active foreground color
    theme.dataTableRowHoverOn = toRgbColorString(theme.dataTableRowHoverOn || theme.selectionComponentHoverOn);
    // row selected background color
    theme.dataTableRowSelectedBackground = toRgbColorString(theme.dataTableRowSelectedBackground || theme.selectionComponentSelectedBackground);
    // row selected foreground color
    theme.dataTableRowSelectedOn = toRgbColorString(theme.dataTableRowSelectedOn || theme.selectionComponentSelectedOn);
    // row active background color
    theme.dataTableRowActiveBackground = toRgbColorString(theme.dataTableRowActiveBackground || theme.dataTableRowSelectedBackground);
    // row active foreground color
    theme.dataTableRowActiveOn = toRgbColorString(theme.dataTableRowActiveOn || theme.dataTableRowSelectedOn);
    // resizer color
    theme.dataTableResizer = toRgbColorString(theme.dataTableResizer || mainColorShades.foreground[isDarkTheme ? ThemeShade.S_200 : ThemeShade.S_800]);
    // icons
    theme.dataTableActionIcon = toRgbColorString(theme.dataTableActionIcon) || 'inherit';
    theme.dataTableActionIconSelected = toRgbColorString(theme.dataTableActionIconSelected) || theme.dataTableActionIcon;
    theme.dataTableActionIconHover = toRgbColorString(theme.dataTableActionIconHover) || 'inherit';
    theme.dataTableSortIcon = toRgbColorString(theme.dataTableSortIcon) || 'inherit';
    theme.dataTableSortIconActive = toRgbColorString(theme.dataTableSortIconActive) || theme.infoBase;
    // navigation icons
    theme.dataTableNavigationIcon = toRgbColorString(theme.dataTableNavigationIcon) || 'inherit';
    theme.dataTableNavigationIconBackground = toRgbColorString(theme.dataTableNavigationIconBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.1);
    theme.dataTableNavigationIconHover = toRgbColorString(theme.dataTableNavigationIconHover) || 'inherit';
    theme.dataTableNavigationIconHoverBackground = toRgbColorString(theme.dataTableNavigationIconHoverBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.3);
    // body
    theme.dataTableBodyBackground = toRgbColorString(theme.dataTableBodyBackground || 'transparent');
    theme.dataTableBodyOn = toRgbColorString(theme.dataTableBodyOn || 'inherit');
};
/**
 * Map
 */
const generateMapVariables = (theme, _mainColorShades, _isDarkTheme) => {
    // Map theme accepts only hex color, do not change to RGB
    theme.administrativeLabelsTextFill = toHexColorString(theme.administrativeLabelsTextFill || theme.mainOn);
    theme.administrativeLabelsTextStroke = toHexColorString(theme.administrativeLabelsTextStroke || theme.mainVariantBackground);
    theme.landscapeLabelsTextFill = toHexColorString(theme.landscapeLabelsTextFill || theme.mainOn);
    theme.landscapeLabelsTextStroke = toHexColorString(theme.landscapeLabelsTextStroke || theme.mainVariantBackground);
    theme.landscapeManmadeAll = toHexColorString(theme.landscapeManmadeAll || theme.ribbonBreadcrumbBackground);
    theme.landscapeNaturalGeometry = toHexColorString(theme.landscapeNaturalGeometry || theme.ribbonBreadcrumbVariantBackground);
    theme.landscapeNaturalTerrainGeometry = toHexColorString(theme.landscapeNaturalTerrainGeometry || theme.ribbonBreadcrumbBackground);
    theme.poiGeometry = toHexColorString(theme.poiGeometry || theme.ribbonBackground);
    theme.poiLabelsTextFill = toHexColorString(theme.poiLabelsTextFill || theme.ribbonOn);
    theme.poiLabelsTextStroke = toHexColorString(theme.poiLabelsTextStroke || theme.ribbonVariantBackground);
    theme.transitGeometryFill = toHexColorString(theme.transitGeometryFill || theme.primaryBase);
    theme.transitLabelsTextFill = toHexColorString(theme.transitLabelsTextFill || theme.primaryOn);
    theme.transitLabelsTextStroke = toHexColorString(theme.transitLabelsTextStroke || theme.primaryVariant);
    theme.roadGeometry = toHexColorString(theme.roadGeometry || theme.infoBase);
    theme.roadLabelsTextFill = toHexColorString(theme.roadLabelsTextFill || theme.infoOn);
    theme.roadLabelsTextStroke = toHexColorString(theme.roadLabelsTextStroke || theme.infoVariant);
    theme.waterAll = toHexColorString(theme.waterAll || theme.sidenavBackground);
    theme.waterLabels = toHexColorString(theme.waterLabels || theme.sidenavOn);
};
/**
 * Other Components
 */
const generateOtherComponentVariables = (theme, mainColorShades, isDarkTheme) => {
    // master detail resizer (default to darker shade of background)
    theme.masterDetailResizer = toRgbColorString(theme.masterDetailResizer || mainColorShades.background[ThemeShade.S_600]);
    // stepper
    theme.stepperNumberIndicatorBackground = toRgbColorString(theme.stepperNumberIndicatorBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.1);
    theme.stepperNumberIndicatorOn = toRgbColorString(theme.stepperNumberIndicatorOn) || 'inherit';
    theme.stepperLineSeparator = toRgbColorString(theme.stepperLineSeparator) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.2);
    // progress bar
    theme.progressBarBackground = toRgbColorString(theme.progressBarBackground) || 'rgba(0, 0 , 0, 0.15)';
    // button
    theme.buttonBackground = toRgbColorString(theme.buttonBackground) || theme.formControlBackground;
    theme.buttonOn = toRgbColorString(theme.buttonOn) || theme.formControlOn;
    // scrollbar
    theme.scrollbarThumb = toRgbColorString(theme.scrollbarThumb) || theme.topnavBackground;
    theme.scrollbarTrack = toRgbColorString(theme.scrollbarTrack) || 'transparent';
    // calendar
    theme.calendarBackground = toRgbColorString(theme.calendarBackground) || theme.modalBackground;
    theme.calendarOn = toRgbColorString(theme.calendarOn) || (theme.calendarBackground === theme.modalBackground ? theme.modalOn : resolveForegroundColor(theme.calendarBackground));
    theme.calendarSelectedBackground = toRgbColorString(theme.calendarSelectedBackground) || theme.highlightBase;
    theme.calendarOn = toRgbColorString(theme.calendarOn) || (theme.calendarBackground === theme.modalBackground ? theme.modalOn : resolveForegroundColor(theme.calendarBackground));
    theme.calendarSelectedBackground = toRgbColorString(theme.calendarSelectedBackground) || theme.highlightBase;
    theme.calendarSelectedOn =
        toRgbColorString(theme.calendarSelectedOn) ||
            (theme.calendarSelectedBackground === theme.highlightBase ? theme.highlightOn : resolveForegroundColor(theme.calendarSelectedBackground));
    theme.calendarHoverBackground = toRgbColorString(theme.calendarHoverBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.2);
    theme.calendarHoverOn = toRgbColorString(theme.calendarHoverOn) || 'inherit';
    theme.calendarActiveMonthBackground = toRgbColorString(theme.calendarActiveMonthBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.05);
    theme.calendarActiveMonthOn = toRgbColorString(theme.calendarActiveMonthOn) || 'inherit';
    theme.calendarInactiveMonthBackground = toRgbColorString(theme.calendarInactiveMonthBackground) || 'none';
    theme.calendarInactiveMonthOn = toRgbColorString(theme.calendarInactiveMonthOn) || 'inherit';
    theme.calendarDivider = toRgbColorString(theme.calendarDivider) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.2);
    // time picker
    theme.timePickerBackground = toRgbColorString(theme.timePickerBackground) || theme.modalBackground;
    theme.timePickerOn =
        toRgbColorString(theme.timePickerOn) || (theme.timePickerBackground === theme.modalBackground ? theme.modalOn : resolveForegroundColor(theme.timePickerBackground));
    theme.timePickerTimeUnitBackground = toRgbColorString(theme.timePickerTimeUnitBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.05);
    theme.timePickerTimeUnitOn = toRgbColorString(theme.timePickerTimeUnitOn) || 'inherit';
    theme.timePickerActiveTimeUnitBackground = toRgbColorString(theme.timePickerActiveTimeUnitBackground) || theme.primaryBase;
    theme.timePickerActiveTimeUnitOn = toRgbColorString(theme.timePickerActiveTimeUnitOn) || theme.primaryOn;
    theme.timePickerKeypadBackground = toRgbColorString(theme.timePickerKeypadBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.05);
    theme.timePickerKeypadOn = toRgbColorString(theme.timePickerKeypadOn) || 'inherit';
    theme.timePickerKeypadHoverBackground = toRgbColorString(theme.timePickerKeypadHoverBackground) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.05);
    theme.timePickerKeypadHoverOn = toRgbColorString(theme.timePickerKeypadHoverOn) || 'inherit';
    // skeleton
    theme.skeletonBackground = toRgbColorString(theme.skeletonBackground) || toRgbaColorString(theme.surfaceBackground, 0.4);
    theme.skeletonFill = toRgbColorString(theme.skeletonFill) || toRgbaColorString(theme.surfaceBackground, 0.7);
    theme.skeletonTextColor = toRgbColorString(theme.skeletonTextColor) || theme.mainOn;
    theme.skeletonAnimationColor = toRgbColorString(theme.skeletonAnimationColor) || toRgbaColorString(theme.surfaceBackground, 0.2);
    // Fonts
    const text_base_size = '1rem';
    const text_scale = '1.25';
    theme.fontName = theme.fontName ? theme.fontName : 'fjalla-lato';
    theme.fontFamily = theme.fontFamily ? theme.fontFamily : 'Lato-400, sans-serif';
    theme.fontBase = theme.fontBase ? theme.fontBase : `${text_base_size} Lato-400, sans-serif`;
    theme.textBase = theme.textBase ? theme.textBase : `${text_base_size}`;
    theme.textScaling = theme.textScaling ? theme.textScaling : `${text_scale}`;
    theme.textXs = theme.textXs ? theme.textXs : `calc(${text_base_size} / (${text_scale} * ${text_scale}))`;
    theme.textSm = theme.textSm ? theme.textSm : `calc(${text_base_size} / ${text_scale})`;
    theme.textMd = theme.textMd ? theme.textMd : `calc(${text_base_size} * ${text_scale})`;
    theme.textBase = theme.textBase ? theme.textBase : `${text_base_size}`;
    theme.textLg = theme.textLg ? theme.textLg : `calc(var(--text-md) * ${text_scale})`;
    theme.textXl = theme.textXl ? theme.textXl : `calc(var(--text-lg) * ${text_scale})`;
    theme.textXxl = theme.textXxl ? theme.textXxl : `calc(var(--text-xl) * ${text_scale})`;
    theme.textXxxl = theme.textXxxl ? theme.textXxxl : `calc(var(--text-xxl) * ${text_scale})`;
    theme.fontH1 = theme.fontH1 ? theme.fontH1 : `var(--text-xxxl) Fjalla-600, sans-serif`;
    theme.fontH2 = theme.fontH2 ? theme.fontH2 : `var(--text-xxl) Fjalla-600, sans-serif`;
    theme.fontH3 = theme.fontH3 ? theme.fontH3 : `var(--text-xl) Fjalla-500, sans-serif`;
    theme.fontH4 = theme.fontH4 ? theme.fontH4 : `var(--text-lg) Fjalla-500, sans-serif`;
    theme.fontH5 = theme.fontH5 ? theme.fontH5 : `var(--text-md) Fjalla-500, sans-serif`;
    theme.fontH6 = theme.fontH6 ? theme.fontH6 : `var(--text-base) Fjalla-400, sans-serif`;
    // Dividers
    theme.mainDivider = toRgbColorString(theme.mainDivider) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.2);
    theme.surfaceDivider = toRgbColorString(theme.surfaceDivider) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.2);
    theme.modalDivider = toRgbColorString(theme.modalDivider) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.2);
    theme.modalSurfaceDivider = toRgbColorString(theme.modalSurfaceDivider) || toRgbaColorString(isDarkTheme ? '#FFF' : '#000', 0.2);
};
/**
 * Convert a color to its rgb with alpha transparency string representation
 */
const toRgbaColorString = (value, alpha) => {
    if (!value || ['none', 'transparent', 'inherit'].includes(value)) {
        return value;
    }
    if (value.constructor.name === 'Number') {
        return `${value} `;
    }
    if (value.constructor.name === 'String') {
        const rgb = new Color(value.trim()).rgb();
        const color = rgb.array();
        return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${alpha})`;
    }
    return value.string();
};
/**
 * Gets the specified shade of a color
 */
const getShade = (color, shade) => generateThemeShades(color)[shade].rgb().string();

/**
 * The theme service provides implementation of the different themes (color schemes)
 * Each theme contain several group of colours, each defining a base color with its lighter and
 * darker variations This class also provides methods to calculate the RGB color codes that apply to
 * a specific theme and shade. The shade is mostly used for effects like hovering on a component.
 */
class ThemeService {
    constructor(_document, _initialAvailableThemes, _defaultTheme) {
        this._document = _document;
        this._initialAvailableThemes = _initialAvailableThemes;
        this._defaultTheme = _defaultTheme;
        /**
         * Subject used for global theme changes
         *
         * @ignore
         */
        this.themeSubject = new BehaviorSubject(null);
        // Generate defaults for all themes available
        const availableThemes = (this._initialAvailableThemes || []).map((theme) => generateThemeDefaults(theme));
        this.availableThemesSubject = new BehaviorSubject(availableThemes);
        // if a valid default theme name was set, use it
        if (this._defaultTheme && this._initialAvailableThemes.some((theme) => theme.themeName === this._defaultTheme)) {
            this._init(this._defaultTheme);
            return;
        }
        // otherwise read the theme name from the css root variables (the user has provided the theme via css)
        // we need to wait that all document stylesheets are loaded before trying to read the root css variables otherwise the css
        // variables may not be available to read (CMUI-2176)
        let rootCssVariables = getRootCssVariables(this._document);
        if (rootCssVariables['--theme-name']) {
            this._init(rootCssVariables['--theme-name']);
            return;
        }
        const _themeNameFoundSubject$ = new Subject();
        _themeNameFoundSubject$.pipe(take(1)).subscribe((themeName) => this._init(themeName));
        const allStylesheetsLoadedObservable$ = Array.from(this._document.querySelectorAll('head link[rel=stylesheet]')).map((el) => fromEvent(el, 'load').pipe(take(1), tap(() => {
            rootCssVariables = getRootCssVariables(this._document);
            if (rootCssVariables['--theme-name']) {
                _themeNameFoundSubject$.next(rootCssVariables['--theme-name']);
            }
        }), // eslint-disable-next-line rxjs/no-unsafe-takeuntil
        takeUntil(timer(10000)), takeUntil(_themeNameFoundSubject$)));
        // if no theme could be found, create an empty theme (backward compat with all components piping current theme)
        const applyEmptyTheme = () => {
            const emptyTheme = {
                themeName: 'Empty Theme',
                themeType: 'light',
            };
            this.themeSubject.next(emptyTheme);
        };
        if (allStylesheetsLoadedObservable$.length === 0) {
            applyEmptyTheme();
        }
        else {
            forkJoin(allStylesheetsLoadedObservable$).subscribe(() => {
                if (!rootCssVariables['--theme-name']) {
                    applyEmptyTheme();
                }
            });
        }
    }
    /** @ignore inits reading and generating missing css variables **/
    _init(themeName) {
        // read the css variables from the root
        const rootCssVariables = getRootCssVariables(this._document);
        // find the theme in available themes
        let theme = this.availableThemes.find((availableTheme) => availableTheme.themeName === themeName);
        if (!theme) {
            const toThemeNameDisplay = (name) => !name ? '' : [...name].reduce((p, c, i) => `${p}${c === '-' ? ' ' : i === 0 || name[i - 1] === '-' ? c.toUpperCase() : c}`, '');
            // as a fallback we still read all the root variables and create a theme from it
            const fallbackTheme = {
                themeName: toThemeNameDisplay(themeName),
            };
            Object.keys(rootCssVariables).forEach((cssProp) => {
                const prop = cssVariableToThemeProperty(cssProp);
                fallbackTheme[prop] = rootCssVariables[cssProp];
            });
            theme = generateThemeDefaults(fallbackTheme);
            // add it to the list of available themes, in case the user switches themes and want to switch back to it
            this.availableThemesSubject.next([theme, ...this.availableThemes]);
        }
        // set the initial theme
        this.themeSubject.next(theme);
        this.setTheme(theme, false);
    }
    /**
     * Applies the specified theme
     */
    setTheme(theme, emit = true) {
        // get the current style element
        if (this._rootStyleElement) {
            this._document.head.removeChild(this._rootStyleElement);
        }
        // convert all theme properties to css variables
        const cssProperties = new Map();
        Object.keys(theme).forEach((key) => cssProperties.set(themePropertyToCssVariable(key), theme[key]));
        // create the style element with a root scope (so css variables polyfills can work)
        this._rootStyleElement = this._document.createElement('style');
        this._rootStyleElement.innerHTML = `:root {
      ${Array.from(cssProperties.keys())
            .map((cssProp) => `${cssProp}:${cssProperties.get(cssProp)};`)
            .join('')}
    }`;
        this._document.head.appendChild(this._rootStyleElement);
        if (emit) {
            this.themeSubject.next(theme);
        }
    }
    /**
     * Observable that can be subscribed to in order to listen for global theme changes
     * Emits the current theme on subscription if any
     */
    get theme$() {
        return this.themeSubject.asObservable().pipe(filter(theme => !!theme));
    }
    /**
     * This method calculates the RGB brgb(250, 133, 144) background color code for a specific theme
     * and shade.
     *
     * @param themeType the theme to apply
     * @param base the shade to apply
     * @returns a rgb representation of the calculated theme color
     */
    resolvePaletteColor(themeType, shade) {
        if (!shade) {
            shade = ThemeShade.S_500;
        }
        return generateThemeShades(this.currentTheme[`${themeType}Base`])[shade];
    }
    /**
     * Returns the list of available themes
     */
    get availableThemes() {
        return this.availableThemesSubject.getValue();
    }
    /**
     * Returns an observable of the list of available themes
     */
    get availableThemes$() {
        return this.availableThemesSubject.asObservable();
    }
    /**
     * Returns the current theme
     */
    get currentTheme() {
        return this.themeSubject.getValue();
    }
    /**
     * Adds a new theme to the list of available themes
     */
    addTheme(theme) {
        this.availableThemesSubject.next([...this.availableThemes, theme]);
    }
    /**
     * Removes a theme from the list of available themes
     */
    removeTheme(themeName) {
        this.availableThemesSubject.next(this.availableThemes.filter((t) => t.themeName !== themeName));
    }
    /**
     * Updates / Replaces the specified theme
     */
    updateTheme(theme) {
        const index = this.availableThemes.findIndex((t) => t.themeName === theme.themeName);
        if (index === -1) {
            return;
        }
        this.availableThemesSubject.next([...this.availableThemes.slice(0, index), theme, ...this.availableThemes.slice(index + 1)]);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemeService, deps: [{ token: DOCUMENT }, { token: AVAILABLE_THEMES }, { token: DEFAULT_THEME, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [AVAILABLE_THEMES]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DEFAULT_THEME]
                }] }]; } });

class BackgroundDirective {
    /**
     * applies a background palette base on a shade and its coresponding foreground color to an
     * element. When hover shade is provided it is applied on mouseover.
     */
    set avnBackground(backgroundSettings) {
        this._backgroundSettings = backgroundSettings;
        this._updateBackground();
    }
    /**
     * @ignore
     */
    constructor(themeService, elementRef, renderer) {
        this.themeService = themeService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._styleProp = {};
        this._hover = {};
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        // update the backgrounds
        this.themeService.theme$.pipe(takeUntil(this._componentDestroyed$)).subscribe(() => this._updateBackground());
    }
    _updateBackground() {
        if (this._backgroundSettings) {
            // if the css prop is set, get the color from that prop
            const themeProp = cssVariableToThemeProperty(this._backgroundSettings.cssProp || '--main-background');
            const themePalette = generateColorInformation(this.themeService.currentTheme[themeProp], this.themeService.currentTheme.themeType === 'dark');
            if (this._backgroundSettings.hoverShade) {
                this._hover['background-color'] = toRgbColorString(themePalette.shades[this._backgroundSettings.hoverShade]);
                this._hover['color'] = toRgbColorString(themePalette.shadesForeground[this._backgroundSettings.hoverShade]);
            }
            this._styleProp['background-color'] = toRgbColorString(themePalette.shades[this._backgroundSettings.shade]);
            this._styleProp['color'] = toRgbColorString(themePalette.shadesForeground[this._backgroundSettings.shade]);
            this.renderStyle();
        }
    }
    /**
     * Renders the hover theme on mouse over
     *
     * @ignore
     */
    onMouseOver() {
        if (this._hover && Object.keys(this._hover).length > 1) {
            Object.keys(this._hover).forEach((cssProp) => {
                this.renderer.setStyle(this.elementRef.nativeElement, cssProp, this._hover[cssProp]);
            });
        }
    }
    /**
     * Re-renders the original theme on mouse out
     *
     * @ignore
     */
    onMouseLeave() {
        this.renderStyle();
    }
    /**
     * Applies the themes to the CSS properties and renders it
     *
     * @ignore
     */
    renderStyle() {
        Object.keys(this._styleProp).forEach((cssProp) => {
            this.renderer.setStyle(this.elementRef.nativeElement, cssProp, this._styleProp[cssProp]);
        });
    }
    /** @ignore */
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BackgroundDirective, deps: [{ token: ThemeService }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: BackgroundDirective, selector: "[avnBackground]", inputs: { avnBackground: "avnBackground" }, host: { listeners: { "mouseenter": "onMouseOver()", "mouseleave": "onMouseLeave()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BackgroundDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnBackground]',
                }]
        }], ctorParameters: function () { return [{ type: ThemeService }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { avnBackground: [{
                type: Input
            }], onMouseOver: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class ThemeDirective {
    constructor(renderer, elRef) {
        this.renderer = renderer;
        this.elRef = elRef;
    }
    /**
     * @ignore
     */
    ngOnChanges({ avnTheme }) {
        if (avnTheme) {
            this.renderer.removeClass(this.elRef.nativeElement, `theme`);
            if (avnTheme.currentValue) {
                this.renderer.addClass(this.elRef.nativeElement, `theme-${avnTheme.currentValue}`);
                this.renderer.addClass(this.elRef.nativeElement, `theme`);
            }
            if (avnTheme.previousValue) {
                this.renderer.removeClass(this.elRef.nativeElement, `theme-${avnTheme.previousValue}`);
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemeDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ThemeDirective, selector: "[avnTheme]", inputs: { avnTheme: "avnTheme" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnTheme]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { avnTheme: [{
                type: Input
            }] } });

/**
 * Simple directive that applies a background and foreground color
 * to an element based on a theme using css vars defined by theming service
 */
class ThemifyDirective {
    set avnThemify(theme) {
        this._styleProp['background-color'] = theme ? `--${theme}-base` : null;
        this._styleProp['color'] = theme ? `--${theme}-on` : null;
        this.renderStyle();
    }
    /**
     * @ignore
     */
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._styleProp = {};
    }
    /**
     * Applies the themes to the CSS properties and renders it
     *
     * @ignore
     */
    renderStyle() {
        Object.keys(this._styleProp).forEach((cssProp) => {
            if (cssProp) {
                this.renderer.setStyle(this.elementRef.nativeElement, cssProp, `var(${this._styleProp[cssProp]})`);
            }
            else {
                this.renderer.removeStyle(this.elementRef.nativeElement, cssProp);
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemifyDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ThemifyDirective, selector: "[avnThemify]", inputs: { avnThemify: "avnThemify" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemifyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnThemify]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { avnThemify: [{
                type: Input
            }] } });

class ThemingDirective {
    /**
     * The CSS style property to target as a key and corresponding theme, shade and hover variants
     * will be applied to the element when theme is ready.
     */
    set avnTheming(themeSettings) {
        if (themeSettings) {
            Object.keys(themeSettings).forEach((k) => {
                const themeSetting = themeSettings[k];
                if (themeSetting.hoverTheme) {
                    this._hover[k] = {
                        theme: themeSetting.hoverTheme,
                        shade: themeSetting.hoverShade,
                    };
                }
                this._styleProp[k] = {
                    theme: themeSetting.theme,
                    shade: themeSetting.shade,
                };
            });
            this.renderStyle();
        }
    }
    /**
     * @ignore
     */
    constructor(themeService, elementRef, renderer) {
        this.themeService = themeService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._styleProp = {};
        this._hover = {};
    }
    /**
     * @ignore
     */
    ngOnInit() {
        // Listen for global theme changes
        this.themeSubsc = this.themeService.theme$.subscribe((theme) => {
            this.currentTheme = theme;
            this.renderStyle();
        });
    }
    /**
     * @ignore
     */
    ngOnChanges() {
        // Re-renders the theme whenever it is changed
        this.renderStyle();
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        // Unsubscribe on destroy
        if (this.themeSubsc) {
            this.themeSubsc.unsubscribe();
        }
    }
    /**
     * Renders the hover theme on mouse over
     *
     * @ignore
     */
    onMouseOver() {
        if (this.currentTheme) {
            Object.keys(this._hover).forEach((cssProp) => {
                this.renderer.setStyle(this.elementRef.nativeElement, cssProp, this.themeService.resolvePaletteColor(this._hover[cssProp].theme, this._hover[cssProp].shade));
            });
        }
    }
    /**
     * Re-renders the original theme on mouse out
     *
     * @ignore
     */
    onMouseLeave() {
        this.renderStyle();
    }
    /**
     * Applies the themes to the CSS properties and renders it
     *
     * @ignore
     */
    renderStyle() {
        if (this.currentTheme) {
            Object.keys(this._styleProp).forEach((cssProp) => {
                this.renderer.setStyle(this.elementRef.nativeElement, cssProp, this.themeService.resolvePaletteColor(this._styleProp[cssProp].theme, this._styleProp[cssProp].shade));
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemingDirective, deps: [{ token: ThemeService }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ThemingDirective, selector: "[avnTheming]", inputs: { avnTheming: "avnTheming" }, host: { listeners: { "mouseenter": "onMouseOver()", "mouseleave": "onMouseLeave()" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ThemingDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnTheming]',
                }]
        }], ctorParameters: function () { return [{ type: ThemeService }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { avnTheming: [{
                type: Input
            }], onMouseOver: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

/** Format a file size in bytes to a human-friendly format with appropriate unit (bytes, KB, MB, etc) */
const formatFileSize = (bytes = 0) => {
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
        return { value: NaN, unit: '?' };
    }
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let unit = 0;
    while (bytes >= 1024) {
        bytes /= 1024;
        unit++;
    }
    return { value: bytes, unit: units[unit] };
};

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 */
class FileSizePipe {
    transform(bytes = 0, precision = 2, fixPrecision = true) {
        const transformed = formatFileSize(bytes);
        let val;
        if (transformed.unit === 'bytes') {
            val = transformed.value.toString();
        }
        else if (fixPrecision) {
            val = transformed.value.toFixed(precision);
        }
        else {
            if (precision <= 0) {
                val = Math.round(transformed.value).toString();
            }
            else {
                val = (Math.round(transformed.value * Math.pow(10, precision)) / Math.pow(10, precision)).toString();
            }
        }
        return `${val} ${transformed.unit}`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: FileSizePipe, name: "fileSize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileSizePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'fileSize' }]
        }] });

/**
 * This directive allows an element to be able to toggle to full size of the container element.
 * - Listen on container element's resize event an adjust accordingly.
 *
 * It's normally added to an element to supply toggle functionality with listening on the click event of the element (a.k.a the host element)
 */
class ToggleFullscreenDirective {
    constructor(_elementRef, _renderer, _document, _builder) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._document = _document;
        this._builder = _builder;
        /** optional, Z-index when toggled to fullscreen*/
        // eslint-disable-next-line @angular-eslint/no-input-rename
        this.fullScreenZIndex = 500;
        /** optional, animation duration */
        // eslint-disable-next-line @angular-eslint/no-input-rename
        this.animationDurationMs = 200;
        /** optional, open and close animation, by default it's on */
        // eslint-disable-next-line @angular-eslint/no-input-rename
        this.animationEnabled = true;
        /** current toggle state change */
        this.toggleStateChange = new EventEmitter();
        /** Indicated if the widget is fullscreen  */
        this.isFullScreen = false;
        /** @ignore */
        this._componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.defaultZIndex = this.toggleElement.style.zIndex;
        this.defaultPosition = this.toggleElement.style.position;
        // resize the widget in full screen mode when its parent container size changes
        this._resizeObserver = new ResizeObserver$1((mutations) => {
            mutations.forEach(() => {
                if (this.isFullScreen) {
                    this.toggleOpen(false);
                }
            });
        });
        this._resizeObserver.observe(this.containerElement);
        // manual toggle
        fromEvent(this._elementRef.nativeElement, 'click')
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            this.onToggleElement();
        });
    }
    ngAfterViewInit() {
        this._elementRef.nativeElement.style.cursor = 'pointer';
        fromEvent(this._document, 'keydown')
            .pipe(filter((event) => this.isFullScreen && event.code === 'Escape'), takeUntil(this._componentDestroyed$))
            .subscribe(() => this.onToggleElement(false));
    }
    /** host element get toggled */
    onToggleElement(forceValue) {
        this.isFullScreen = forceValue !== undefined ? forceValue : !this.isFullScreen;
        if (this.isFullScreen) {
            this.toggleOpen(this.animationEnabled);
        }
        else {
            this.toggleClose(this.animationEnabled);
        }
        this.toggleStateChange.emit(this.isFullScreen);
    }
    toggleOpen(runAnimation) {
        const rect = this.containerElement.getBoundingClientRect();
        this._renderer.setStyle(this.containerElement, 'overflow', `hidden`);
        this._renderer.setStyle(this.toggleElement, 'top', `${rect.top}px`);
        this._renderer.setStyle(this.toggleElement, 'left', `${rect.left}px`);
        this._renderer.setStyle(this.toggleElement, 'width', `${rect.width}px`);
        this._renderer.setStyle(this.toggleElement, 'height', `${rect.height}px`);
        this._renderer.setStyle(this.toggleElement, 'position', 'fixed');
        this._renderer.setStyle(this.toggleElement, 'z-index', `${this.fullScreenZIndex}`);
        if (runAnimation) {
            this._runAnimation(this._toggleOpenAnimationMetadata());
        }
    }
    toggleClose(runAnimation) {
        this._renderer.removeStyle(this.toggleElement, 'top');
        this._renderer.removeStyle(this.toggleElement, 'left');
        this._renderer.removeStyle(this.toggleElement, 'width');
        this._renderer.removeStyle(this.toggleElement, 'height');
        this._renderer.setStyle(this.toggleElement, 'position', `${this.defaultPosition}`);
        this._renderer.setStyle(this.toggleElement, 'z-index', `${this.defaultZIndex}`);
        if (runAnimation) {
            this._runAnimation(this._toggleCloseAnimationMetadata());
        }
    }
    _runAnimation(animationMeta) {
        if (this._player) {
            this._player.destroy();
            this._player = undefined;
        }
        const factory = this._builder.build(animationMeta);
        this._player = factory.create(this.toggleElement);
        this._player.play();
    }
    _toggleOpenAnimationMetadata() {
        return [
            style({ opacity: 0.8, transform: 'scale(0.8)' }),
            animate(`${this.animationDurationMs}ms cubic-bezier(0, 0, 0.2, 1)`, style({ opacity: 1, transform: 'scale(1)' })),
        ];
    }
    _toggleCloseAnimationMetadata() {
        return [
            style({ opacity: 0.8, transform: 'scale(1.2)' }),
            animate(`${this.animationDurationMs}ms cubic-bezier(0, 0, 0.2, 1)`, style({ opacity: 1, transform: 'scale(1)' })),
        ];
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToggleFullscreenDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: DOCUMENT }, { token: i1$1.AnimationBuilder }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ToggleFullscreenDirective, selector: "[avnToggleFullscreen]", inputs: { toggleElement: ["avnToggleFullscreen", "toggleElement"], containerElement: ["avnToggleFullScreenContainerElement", "containerElement"], fullScreenZIndex: ["avnToggleFullScreenZIndex", "fullScreenZIndex"], animationDurationMs: ["avnToggleAnimationDurationMs", "animationDurationMs"], animationEnabled: ["avnToggleAnimationEnabled", "animationEnabled"] }, outputs: { toggleStateChange: "toggleStateChange" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToggleFullscreenDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnToggleFullscreen]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$1.AnimationBuilder }]; }, propDecorators: { toggleElement: [{
                type: Input,
                args: ['avnToggleFullscreen']
            }], containerElement: [{
                type: Input,
                args: ['avnToggleFullScreenContainerElement']
            }], fullScreenZIndex: [{
                type: Input,
                args: ['avnToggleFullScreenZIndex']
            }], animationDurationMs: [{
                type: Input,
                args: ['avnToggleAnimationDurationMs']
            }], animationEnabled: [{
                type: Input,
                args: ['avnToggleAnimationEnabled']
            }], toggleStateChange: [{
                type: Output
            }] } });

/**
 * This directive listens on current Router params changes (through avnCurrentRouterParam input to de-couple from Router)
 * to emit the watching param state
 * - true: current param is in router
 * - false: current param is not in router
 */
class QueryParamDirective {
    /**
     * Current Router params: passed through input to de-couple from Router
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set currentRouterParam(params) {
        this._currentRouterParam$.next(params);
    }
    constructor() {
        this._currentRouterParam$ = new ReplaySubject(1);
        /** current router param change */
        this.avnQueryParamStateChange = new EventEmitter();
        this._componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        this._currentRouterParam$
            .pipe(filter((p) => p !== null), map((params) => params[this.watchingParam.key]), takeUntil(this._componentDestroyed$))
            .subscribe((param) => {
            if (param === this.watchingParam.value) {
                this.avnQueryParamStateChange.emit(true);
            }
            else {
                this.avnQueryParamStateChange.emit(false);
            }
        });
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: QueryParamDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: QueryParamDirective, selector: "[avnQueryParam]", inputs: { watchingParam: ["avnQueryParam", "watchingParam"], currentRouterParam: ["avnCurrentRouterParam", "currentRouterParam"] }, outputs: { avnQueryParamStateChange: "avnQueryParamStateChange" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: QueryParamDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnQueryParam]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { watchingParam: [{
                type: Input,
                args: ['avnQueryParam']
            }], currentRouterParam: [{
                type: Input,
                args: ['avnCurrentRouterParam']
            }], avnQueryParamStateChange: [{
                type: Output
            }] } });

const DEFAULT_IMAGE_RETRY_COUNT = 2;
/**
 * This directive can be applied to a img element and allows retrying the fetching of an image when it errors.
 * Number of retries and delay between retries can be configured.
 * Once all retries are done but the image still has an error, then retryError event will be emitted
 */
class ImageRetryDirective {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        /** The amount of retries in case of error **/
        this.avnImageRetry = DEFAULT_IMAGE_RETRY_COUNT;
        /** The interval between retries in milliseconds **/
        this.avnImageRetryIntervalMs = 100;
        /** Event emitted after all retries are done but the image still has an error **/
        this.retryError = new EventEmitter();
        /** @ignore amount of retries left **/
        this._retryLeft = DEFAULT_IMAGE_RETRY_COUNT;
        /** @ignore Emits when the loading of the image should be cancelled **/
        this._cancelImageLoadingSubject = new Subject();
    }
    ngOnChanges({ src, avnImageRetry }) {
        if (src) {
            this._retryLeft = this.avnImageRetry;
            this._cancelImageLoadingSubject.next();
        }
        if (avnImageRetry) {
            this._retryLeft = avnImageRetry.currentValue ?? DEFAULT_IMAGE_RETRY_COUNT;
        }
    }
    onError() {
        if (this._retryLeft > 0) {
            timer(this.avnImageRetryIntervalMs)
                .pipe(takeUntil(merge(this._cancelImageLoadingSubject)))
                .subscribe(() => {
                this._retryLeft--;
                this._elementRef.nativeElement.src = this.src;
            });
        }
        else {
            this.retryError.emit();
        }
    }
    ngOnDestroy() {
        this._cancelImageLoadingSubject.next();
        this._cancelImageLoadingSubject.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ImageRetryDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ImageRetryDirective, selector: "img[avnImageRetry]", inputs: { src: "src", avnImageRetry: "avnImageRetry", avnImageRetryIntervalMs: "avnImageRetryIntervalMs" }, outputs: { retryError: "retryError" }, host: { listeners: { "error": "onError()" }, properties: { "src": "this.src" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ImageRetryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'img[avnImageRetry]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { src: [{
                type: HostBinding,
                args: ['src']
            }, {
                type: Input
            }], avnImageRetry: [{
                type: Input
            }], avnImageRetryIntervalMs: [{
                type: Input
            }], retryError: [{
                type: Output
            }], onError: [{
                type: HostListener,
                args: ['error']
            }] } });

/**
 * Service that keep trace of an element being dragged.
 * With the native html5 drag and drop, data between source and destination elements is usually passed via the dataTransfer object.
 * However drag events will only contain the data in the drop event (not while dragging). Since we need to support
 * conditional drop targets (i.e. activated only while dragging over specific elements), we store the currently dragged element and its
 * data in this service.
 */
class DragDropElementService {
    constructor() {
        this._draggedElementSubject = new BehaviorSubject(null);
        this._dragStartSubject = new Subject();
        this._dragEndSubject = new Subject();
    }
    get draggedElement$() {
        return this._draggedElementSubject.asObservable();
    }
    get draggedElement() {
        return this._draggedElementSubject.value;
    }
    set draggedElement(element) {
        this._draggedElementSubject.next(element);
    }
    registerDragStartEvent(event, element) {
        this._dragStartSubject.next({ event, source: element });
        this._draggedElementSubject.next(element);
    }
    registerDragEndEvent(event, element) {
        this._dragEndSubject.next({ event, source: element });
        this._draggedElementSubject.next(null);
    }
    get dragStart$() {
        return this._dragStartSubject.asObservable();
    }
    get dragEnd$() {
        return this._dragEndSubject.asObservable();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropElementService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropElementService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropElementService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class DragDropElementOriginDirective {
    /** @ignore */
    constructor(_elementRef, _dragDropService) {
        this._elementRef = _elementRef;
        this._dragDropService = _dragDropService;
        /** Specifies the cursor displayed while dragging */
        this.cursor = 'move';
        /** Disables the element as a drop origin **/
        this.disabled = false;
        /** Emits when the origin element starts being dragged **/
        this.dragStart = new EventEmitter();
        /** Emits when the origin element stops being dragged  **/
        this.dragEnd = new EventEmitter();
    }
    get draggable() {
        this.cursor = this.disabled ? '' : this.cursor;
        return !this.disabled;
    }
    /**
     * Called when the element starts being dragged
     * **/
    onDragStart(event) {
        if (this.disabled) {
            event.stopPropagation();
        }
        else {
            // Define as origin element the ref element if existed
            const originElement = this.ref ? this.ref : this._elementRef.nativeElement;
            // add an origin element attribute avn-drag-drop-id for reference element
            if (!originElement.getAttribute('avn-drag-drop-id')) {
                originElement.setAttribute('avn-drag-drop-id', v4());
            }
            // get origin element attribute avn-drag-drop-id as reference element
            const id = originElement.getAttribute('avn-drag-drop-id');
            const item = {
                commonId: this.commonId,
                id,
                draggableData: {
                    originIndex: this.index,
                    originData: this.data,
                },
            };
            event.dataTransfer.effectAllowed = 'move';
            // always position the drag ghost top left corner where the mouse cursor is
            const dragImage = this.disableGhostImage ? this._getTransparentGhostImage() : this._elementRef.nativeElement;
            event.dataTransfer.setDragImage(dragImage, 0, 0);
            // register the drag start event so that target elements can be notified that a drag has started
            this._dragDropService.registerDragStartEvent(event, item);
            this.dragStart.emit({
                event,
                source: item,
            });
        }
    }
    /**
     * Called when the element stops being dragged
     * **/
    onDragEnd(event) {
        const item = this._dragDropService.draggedElement;
        // register the drag end event so that target element can be notified that a drag has started
        this._dragDropService.registerDragEndEvent(event, item);
        this.dragEnd.emit({
            event,
            source: item,
        });
        this._dragDropService.draggedElement = null;
    }
    _getTransparentGhostImage() {
        const img = new Image();
        img.src = 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        return img;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropElementOriginDirective, deps: [{ token: i0.ElementRef }, { token: DragDropElementService }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: DragDropElementOriginDirective, selector: "[avnDragDropElementOrigin]", inputs: { cursor: ["avnDragDropElementOriginCursor", "cursor"], commonId: ["avnDragDropElementOrigin", "commonId"], data: ["avnDragDropElementOriginData", "data"], disableGhostImage: ["avnDragDropElementOriginDisableGhostImage", "disableGhostImage"], disabled: ["avnDragDropElementOriginDisabled", "disabled"], index: ["avnDragDropElementOriginIndex", "index"], ref: ["avnDragDropElementOriginRef", "ref"] }, outputs: { dragStart: "dragStart", dragEnd: "dragEnd" }, host: { listeners: { "dragstart": "onDragStart($event)", "dragend": "onDragEnd($event)" }, properties: { "style.cursor": "this.cursor", "draggable": "this.draggable" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropElementOriginDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnDragDropElementOrigin]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: DragDropElementService }]; }, propDecorators: { cursor: [{
                type: HostBinding,
                args: ['style.cursor']
            }, {
                type: Input,
                args: ['avnDragDropElementOriginCursor']
            }], commonId: [{
                type: Input,
                args: ['avnDragDropElementOrigin']
            }], data: [{
                type: Input,
                args: ['avnDragDropElementOriginData']
            }], disableGhostImage: [{
                type: Input,
                args: ['avnDragDropElementOriginDisableGhostImage']
            }], disabled: [{
                type: Input,
                args: ['avnDragDropElementOriginDisabled']
            }], index: [{
                type: Input,
                args: ['avnDragDropElementOriginIndex']
            }], ref: [{
                type: Input,
                args: ['avnDragDropElementOriginRef']
            }], dragStart: [{
                type: Output
            }], dragEnd: [{
                type: Output
            }], draggable: [{
                type: HostBinding,
                args: ['draggable']
            }], onDragStart: [{
                type: HostListener,
                args: ['dragstart', ['$event']]
            }], onDragEnd: [{
                type: HostListener,
                args: ['dragend', ['$event']]
            }] } });

class DragDropElementTargetDirective {
    constructor(_elementRef, _dragDropService, _renderer) {
        this._elementRef = _elementRef;
        this._dragDropService = _dragDropService;
        this._renderer = _renderer;
        /** Ids of the elements that can be dragged to this element **/
        this.allowedOriginElementIds = [];
        /** Indicates if the drop target should only show when the target is hovered while dragging **/
        this.showOnHoverOnly = true;
        /** Indicates if the drop target should disappear from the DOM when dragging is not active **/
        this.showOnDragOnly = false;
        /** Disables the element as a drop target **/
        this.disabled = false;
        /** Indicates if all the drag move events (while dragging over) should be emitted. By default only drag move when entering and leaving the target element are emitted. **/
        this.emitAllDragMoveEvents = false;
        /** Emits when the target element is dragged over (only when its a valid target) **/
        this.draggedOver = new EventEmitter();
        /** Emits when dragging has started and the current element is a target for the drag **/
        this.dragStart = new EventEmitter();
        /** Emits when dragging has end and the current element was a target for the drag **/
        this.dragEnd = new EventEmitter();
        /** Emits when the target element starts being dragged over (only when its a valid target) **/
        this.dragEnter = new EventEmitter();
        /** Emits when the target element ends being dragged over (only when its a valid target) **/
        this.dragLeave = new EventEmitter();
        /** Emits when an origin element is dropped to the element (only when its a valid target)**/
        this.elementDropped = new EventEmitter();
        /** @ignore Subject used to debounce the native dragover event **/
        this._dragOverSubject = new Subject();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
        this._isTargetForCurrentDrag = false;
    }
    ngOnInit() {
        this._initDragDropListeners();
        this._updateElementStyle();
    }
    _updateElementStyle() {
        // allows to restore the original display of the element if it is defined
        this._originalDisplay = this._elementRef.nativeElement.style.display ?? 'block';
        // allows to restore the original opacity of the element if it is defined
        this._originalOpacity = this._elementRef.nativeElement.style.opacity ?? 1;
        // allows to restore the original opacity of the element if it is defined
        this._originalBorder = this._elementRef.nativeElement.style.border ?? null;
        // show target element only when element is drag (if showOnDragOnly is true)
        if (this.showOnDragOnly) {
            this._renderer.setStyle(this._elementRef.nativeElement, 'display', 'none');
        }
        // if showOnHoverOnly is true, only show the target element on hover
        if (this.showOnHoverOnly) {
            this.addOpacity(null);
        }
    }
    _initDragDropListeners() {
        this._dragDropService.dragStart$
            .pipe(map((event) => {
            const isTargetForCurrentDrag = this.allowedOriginElementIds.includes(event.source?.commonId);
            return { event, isTargetForCurrentDrag };
        }), takeUntil(this._componentDestroyed$))
            .subscribe(({ event, isTargetForCurrentDrag }) => {
            if (isTargetForCurrentDrag) {
                this.dragStart.emit(event);
                this._onDragStart();
            }
        });
        this._dragDropService.dragEnd$
            .pipe(map((event) => {
            const isTargetForCurrentDrag = this.allowedOriginElementIds.includes(event.source?.commonId);
            return { event, isTargetForCurrentDrag };
        }), takeUntil(this._componentDestroyed$))
            .subscribe(({ event, isTargetForCurrentDrag }) => {
            if (isTargetForCurrentDrag) {
                this.dragEnd.emit(event);
                this._onDragEnd();
            }
        });
        // drag move
        const dragEnter$ = fromEvent(this._elementRef.nativeElement, 'dragenter');
        const dragOver$ = fromEvent(this._elementRef.nativeElement, 'dragover');
        dragEnter$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this._onDragEnter(event));
        dragOver$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this._onDragOver(event));
        // dropped
        const dropped$ = fromEvent(this._elementRef.nativeElement, 'drop');
        dropped$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this._onDrop(event));
        // drag leave
        const dragLeave$ = fromEvent(this._elementRef.nativeElement, 'dragleave');
        dragLeave$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this._onDragLeave(event));
        this._dragDropService.draggedElement$
            .pipe(filter(() => !this.disabled && this._elementRef.nativeElement.firstChild), takeUntil(this._componentDestroyed$))
            .subscribe((currentItem) => {
            // show target element only when element is hover (if showOnHoverOnly is true)
            const originalTransition = this._elementRef.nativeElement.style.transition;
            // add transition style to the target element if not added yet
            const transitionStyle = '250ms cubic-bezier(0.2, 1, 0.3, 1)';
            if (!(originalTransition || '').includes(transitionStyle)) {
                this._renderer.setStyle(this._elementRef.nativeElement, 'transition', [...(originalTransition ? [originalTransition] : []), transitionStyle].join(', '));
            }
            if (this.opacity) {
                this.addOpacity(currentItem);
            }
            if (this.border) {
                this._renderer.setStyle(this._elementRef.nativeElement, 'border', currentItem?.draggableData.originData && this.allowedOriginElementIds.find((id) => id === currentItem.commonId && !this.showOnDragOnly)
                    ? this._renderer.setStyle(this._elementRef.nativeElement, 'border', '2px ' + this.border)
                    : this._renderer.setStyle(this._elementRef.nativeElement, 'border', this._originalBorder));
            }
        });
        this._dragOverSubject
            .pipe(filter(() => !this.disabled), distinctUntilChanged((prev, curr) => {
            const isSameTargetElementHoveredState = prev.hovered === curr.hovered;
            if (!this.emitAllDragMoveEvents) {
                return isSameTargetElementHoveredState;
            }
            // drag over event constantly emits even when position has not changed, so make sure it has changed
            const isSameTargetElementPosition = prev.event.clientX === curr.event.clientX && prev.event.clientY === curr.event.clientY;
            return isSameTargetElementHoveredState && isSameTargetElementPosition;
        }), takeUntil(this._componentDestroyed$))
            .subscribe(({ hovered, source, event }) => {
            if (this.showOnHoverOnly) {
                this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', hovered ? this._originalOpacity : '0');
            }
            this.draggedOver.emit({ hovered, source, event });
        });
    }
    _onDragStart() {
        this._isTargetForCurrentDrag = true;
        if (this.showOnDragOnly) {
            this._renderer.setStyle(this._elementRef.nativeElement, 'display', this._originalDisplay);
        }
    }
    _onDragEnd() {
        this._isTargetForCurrentDrag = false;
        if (this.showOnDragOnly) {
            this._renderer.setStyle(this._elementRef.nativeElement, 'display', 'none');
        }
        if (this.showOnHoverOnly) {
            this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', '0');
        }
    }
    _onDragEnter(event) {
        // prevents the default behavior when the element being dragged. is from the drop same zone
        if (this._isTargetForCurrentDrag) {
            event.preventDefault();
            this._renderer.addClass(this._elementRef.nativeElement, 'dragged-over');
            const source = this._dragDropService.draggedElement;
            this.dragEnter.emit({ source, event });
            this._dragOverSubject.next({ hovered: true, source, event });
        }
    }
    _onDragOver(event) {
        // prevents the default behavior when the element being dragged. is from the drop same zone
        if (this._isTargetForCurrentDrag) {
            this._renderer.addClass(this._elementRef.nativeElement, 'dragged-over');
            event.preventDefault();
            this._dragOverSubject.next({ hovered: true, source: this._dragDropService.draggedElement, event });
        }
    }
    _onDragLeave(event) {
        if (this._isTargetForCurrentDrag) {
            event.preventDefault();
            this._renderer.removeClass(this._elementRef.nativeElement, 'dragged-over');
            const source = this._dragDropService.draggedElement;
            this.dragLeave.emit({ source, event });
            this._dragOverSubject.next({ hovered: false, source, event });
        }
    }
    _onDrop(event) {
        if (this._isTargetForCurrentDrag) {
            event.stopPropagation();
            event.preventDefault();
            // add an target element attribute avn-drag-drop-id for reference element
            if (!this._elementRef.nativeElement.getAttribute('avn-drag-drop-id')) {
                this._elementRef.nativeElement.setAttribute('avn-drag-drop-id', v4());
            }
            const targetId = this._elementRef.nativeElement.getAttribute('avn-drag-drop-id');
            const originData = this.data;
            const targetData = this._dragDropService.draggedElement.draggableData.originData;
            const draggableData = {
                originData: this.data,
                originIndex: this._dragDropService.draggedElement.draggableData?.originIndex,
                targetData,
                targetIndex: this.index,
            };
            if (targetId !== this._dragDropService.draggedElement.id) {
                if (originData || targetData) {
                    this._dragDropService.draggedElement = {
                        ...this._dragDropService.draggedElement,
                        draggableData,
                    };
                }
                const source = this._dragDropService.draggedElement;
                this.dragLeave.emit({ source, event });
                this._dragOverSubject.next({ hovered: false, dropped: true, source, event });
                this.elementDropped.emit(this._dragDropService.draggedElement);
            }
        }
    }
    addOpacity(currentItem) {
        this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', currentItem?.draggableData.originData && this.allowedOriginElementIds.find((id) => id === currentItem.commonId && !this.showOnDragOnly)
            ? this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', this.showOnHoverOnly ? '0' : this.opacity)
            : this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', this.showOnHoverOnly ? '0' : this._originalOpacity));
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropElementTargetDirective, deps: [{ token: i0.ElementRef }, { token: DragDropElementService }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: DragDropElementTargetDirective, selector: "[avnDragDropElementTarget]", inputs: { allowedOriginElementIds: ["avnDragDropElementTarget", "allowedOriginElementIds"], showOnHoverOnly: ["avnDragDropElementTargetShowOnHoverOnly", "showOnHoverOnly"], showOnDragOnly: ["avnDragDropElementTargetShowOnDragOnly", "showOnDragOnly"], disabled: ["avnDragDropElementTargetDisabled", "disabled"], opacity: ["avnDragDropElementTargetOpacity", "opacity"], border: ["avnDragDropElementTargetBorder", "border"], data: ["avnDragDropElementTargetData", "data"], index: ["avnDragDropElementTargetIndex", "index"], emitAllDragMoveEvents: ["avnDragDropElementTargetEmitAllDragMoveEvents", "emitAllDragMoveEvents"] }, outputs: { draggedOver: "draggedOver", dragStart: "dragStart", dragEnd: "dragEnd", dragEnter: "dragEnter", dragLeave: "dragLeave", elementDropped: "elementDropped" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropElementTargetDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnDragDropElementTarget]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: DragDropElementService }, { type: i0.Renderer2 }]; }, propDecorators: { allowedOriginElementIds: [{
                type: Input,
                args: ['avnDragDropElementTarget']
            }], showOnHoverOnly: [{
                type: Input,
                args: ['avnDragDropElementTargetShowOnHoverOnly']
            }], showOnDragOnly: [{
                type: Input,
                args: ['avnDragDropElementTargetShowOnDragOnly']
            }], disabled: [{
                type: Input,
                args: ['avnDragDropElementTargetDisabled']
            }], opacity: [{
                type: Input,
                args: ['avnDragDropElementTargetOpacity']
            }], border: [{
                type: Input,
                args: ['avnDragDropElementTargetBorder']
            }], data: [{
                type: Input,
                args: ['avnDragDropElementTargetData']
            }], index: [{
                type: Input,
                args: ['avnDragDropElementTargetIndex']
            }], emitAllDragMoveEvents: [{
                type: Input,
                args: ['avnDragDropElementTargetEmitAllDragMoveEvents']
            }], draggedOver: [{
                type: Output
            }], dragStart: [{
                type: Output
            }], dragEnd: [{
                type: Output
            }], dragEnter: [{
                type: Output
            }], dragLeave: [{
                type: Output
            }], elementDropped: [{
                type: Output
            }] } });

/**
 * Limitations:
 *  - It is not possible to know the amount of files dropped before they are actually dropped
 */
class DragDropFileTargetDirective {
    constructor(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.targetForFiles = [];
        /** Indicates if the drop target should only show when the target is hovered while dragging **/
        this.showOnHoverOnly = true;
        /** Disables the element as a drop target **/
        this.disabled = false;
        /** Emits when the target element is dragged over **/
        this.draggedOver = new EventEmitter();
        /** Emits when files are dropped to the element **/
        this.filesDropped = new EventEmitter();
        /** @ignore Subject used to debounce the native dragover event **/
        this._dragOverSubject = new Subject();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this._initDragDropListeners();
        this._originalOpacity = this._elementRef.nativeElement.style.opacity ?? 1;
        if (this.showOnHoverOnly) {
            this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', '0');
            const originalTransition = this._elementRef.nativeElement.style.transition;
            this._renderer.setStyle(this._elementRef.nativeElement, 'transition', [...(originalTransition ? [originalTransition] : []), 'opacity 250ms cubic-bezier(0.2, 1, 0.3, 1)'].join(', '));
        }
    }
    _initDragDropListeners() {
        // drag move
        const dragEnter$ = fromEvent(this._elementRef.nativeElement, 'dragenter');
        const dragOver$ = fromEvent(this._elementRef.nativeElement, 'dragover');
        merge(dragEnter$, dragOver$)
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((event) => this._onDragOver(event));
        // drag leave
        const dragLeave$ = fromEvent(this._elementRef.nativeElement, 'dragleave');
        dragLeave$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this._onDragLeave(event));
        // dropped
        const dropped$ = fromEvent(this._elementRef.nativeElement, 'drop');
        dropped$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this._onDrop(event));
        // debounce the html5 dragover event craziness
        this._dragOverSubject
            .pipe(filter(() => !this.disabled), distinctUntilChanged(), takeUntil(this._componentDestroyed$))
            .subscribe((hovered) => {
            if (this.showOnHoverOnly) {
                this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', hovered ? this._originalOpacity : '0');
            }
            if (hovered) {
                this._renderer.addClass(this._elementRef.nativeElement, 'dragged-over');
            }
            else {
                this._renderer.removeClass(this._elementRef.nativeElement, 'dragged-over');
            }
            this.draggedOver.emit(hovered);
        });
    }
    _onDragOver(event) {
        if (this._isFileDropped(event)) {
            event.stopPropagation();
            event.preventDefault();
            this._dragOverSubject.next(true);
        }
    }
    _onDragLeave(event) {
        if (this._isFileDropped(event)) {
            event.stopPropagation();
            event.preventDefault();
            this._dragOverSubject.next(false);
        }
    }
    _onDrop(event) {
        if (this._isFileDropped(event)) {
            event.stopPropagation();
            event.preventDefault();
            const droppedFiles = event.dataTransfer.files ? Array.from(event.dataTransfer.files) : [];
            this.filesDropped.emit(droppedFiles);
            this._dragOverSubject.next(false);
        }
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** Indicates if a file(s) is being dropped, as opposed to a html element **/
    _isFileDropped(event) {
        return (event.dataTransfer.types || []).includes('Files');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropFileTargetDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: DragDropFileTargetDirective, selector: "[avnDragDropFileTarget]", inputs: { targetForFiles: ["avnDragDropFileTarget", "targetForFiles"], showOnHoverOnly: ["avnDragDropFileTargetShowOnHoverOnly", "showOnHoverOnly"], disabled: ["avnDragDropFileTargetDisabled", "disabled"] }, outputs: { draggedOver: "draggedOver", filesDropped: "filesDropped" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragDropFileTargetDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnDragDropFileTarget]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { targetForFiles: [{
                type: Input,
                args: ['avnDragDropFileTarget']
            }], showOnHoverOnly: [{
                type: Input,
                args: ['avnDragDropFileTargetShowOnHoverOnly']
            }], disabled: [{
                type: Input,
                args: ['avnDragDropFileTargetDisabled']
            }], draggedOver: [{
                type: Output
            }], filesDropped: [{
                type: Output
            }] } });

/**
 * Takes in a function to apply to the value
 * That pipe helps with performance by avoid recalculations when change detection kicks in
 */
class ApplyFunctionPipe {
    transform(value, functionToApply, functionArgs = [], functionContext = this) {
        return functionToApply.bind(functionContext)(value, ...functionArgs);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ApplyFunctionPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ApplyFunctionPipe, name: "applyFunction" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ApplyFunctionPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'applyFunction' }]
        }] });

/**
 * Device information for layout
 * inspired by: https://material.io/design/layout/responsive-layout-grid.html#breakpoints
 * or code: https://github.com/angular/material2/blob/master/src/cdk/layout/breakpoints.ts
 * all dimensions
 */
var LayoutDeviceType;
(function (LayoutDeviceType) {
    /**
     * less than 600
     */
    LayoutDeviceType["HANDSET"] = "handset";
    /**
     * gt or equal to 600, less than 1280w
     */
    LayoutDeviceType["TABLET"] = "tablet";
    /**
     * gt or equal to 1280w, less than 1920w
     * includes HD ready, FHD screens
     */
    LayoutDeviceType["WEB"] = "web";
    /**
     * gt or equal to 1920w, less than 3840
     * 4K, UHD
     */
    LayoutDeviceType["HUGE"] = "huge";
    /**
     * gt or equal to 3840w, 7680w
     */
    LayoutDeviceType["YUGE"] = "yuge";
    /**
     * are you kidding ?
     * gt than 7680w
     * 8K
     */
    LayoutDeviceType["GIGANTIC"] = "gigantic";
})(LayoutDeviceType || (LayoutDeviceType = {}));
var LayoutDeviceBreakpoint;
(function (LayoutDeviceBreakpoint) {
    /**
     * less than 600
     */
    LayoutDeviceBreakpoint[LayoutDeviceBreakpoint["HANDSET"] = 600] = "HANDSET";
    /**
     * gt or equal to 560w, less than 1280w
     */
    LayoutDeviceBreakpoint[LayoutDeviceBreakpoint["TABLET"] = 1280] = "TABLET";
    /**
     * gt or equal to 1280w, less than 1920w
     * includes HD ready, FHD screens
     */
    LayoutDeviceBreakpoint[LayoutDeviceBreakpoint["WEB"] = 1920] = "WEB";
    /**
     * gt or equal to 1920w, less than 3840
     * 4K, UHD
     */
    LayoutDeviceBreakpoint[LayoutDeviceBreakpoint["HUGE"] = 3840] = "HUGE";
    /**
     * gt or equal to 3840w, 7680w
     */
    LayoutDeviceBreakpoint[LayoutDeviceBreakpoint["YUGE"] = 7680] = "YUGE";
})(LayoutDeviceBreakpoint || (LayoutDeviceBreakpoint = {}));

const MEDIA_BREAKPOINT_CONFIG = new InjectionToken('MEDIA_BREAKPOINT_CONFIG');
const DEFAULT_MEDIA_BREAKPOINT_CONFIG = {
    breakpoints: {
        [LayoutDeviceType.HANDSET]: '(max-width: 599px)',
        [LayoutDeviceType.TABLET]: '(min-width: 600px) and (max-width: 1279px)',
        [LayoutDeviceType.WEB]: '(min-width: 1280px) and (max-width: 1919px)',
        [LayoutDeviceType.HUGE]: '(min-width: 1920px) and (max-width: 3839px)',
        [LayoutDeviceType.YUGE]: '(min-width: 3840px) and (max-width: 7679px)',
        [LayoutDeviceType.GIGANTIC]: '(min-width: 7680px)',
    },
};

/**
 * The currently running tasks of the sticky tasks panel
 */
const TASK_PANEL_RUNNING_TASKS = new InjectionToken('PROCESSING_TASKS');
/**
 * Settings for the sticky tasks panel
 */
const TASK_PANEL_SETTINGS = new InjectionToken('TASK_PANEL_SETTINGS');
/**
 * Default settings for the sticky tasks panel
 */
const DEFAULT_TASK_PANEL_SETTINGS = {
    width: 500,
    progressTitle$: of('Tasks in progress...'),
    completionTitle$: of('All tasks completed!'),
    hideTaskOnCompletion: false,
};

/**
 * When active, this directive will apply a filter on input
 *  to make sure that the value is integer only, no decimal or other letters allowed
 *
 * e.g.  4, 56, -49, 0
 */
class IntegerOnlyDirective {
    constructor(el) {
        this.el = el;
        this.integerOnlyActive = true;
        this.NEGATIVE_SIGN = '-';
        this.navigationKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Clear'];
        this._componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        this.inputElement = this.el.nativeElement.nodeName === 'INPUT' ? this.el.nativeElement : this.el.nativeElement.querySelector('input');
        fromEvent(this.inputElement, 'keydown')
            .pipe(filter$1(() => this.integerOnlyActive), takeUntil$1(this._componentDestroyed$))
            .subscribe((e) => {
            if (this.navigationKeys.indexOf(e.key) > -1)
                return;
            // only do check for integer
            if (e.key === this.NEGATIVE_SIGN) {
                const selectionStart = e.target.selectionStart ?? 0;
                const selectionEnd = e.target.selectionEnd ?? 0;
                const oldValue = e.target.value;
                const newValue = oldValue.substring(0, selectionStart) + e.key + oldValue.substring(selectionEnd);
                if (newValue.charAt(0) !== this.NEGATIVE_SIGN || newValue.split(this.NEGATIVE_SIGN).length > 2) {
                    e.preventDefault();
                    return;
                }
            }
            else {
                // Ensure that it is a number and stop the keypress
                if (e.key === ' ' || isNaN(Number(e.key))) {
                    e.preventDefault();
                    return;
                }
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: IntegerOnlyDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: IntegerOnlyDirective, selector: "[avnIntegerOnly]", inputs: { integerOnlyActive: "integerOnlyActive" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: IntegerOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnIntegerOnly]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { integerOnlyActive: [{
                type: Input
            }] } });

/**
 * This Pipe can be used to add text-overflow: ellipsis to element tag
 *
 * usage: <h2 textOverFlow> Text </h2>
 */
class TextOverFlowDirective {
    constructor(renderer, hostElement) {
        this.renderer = renderer;
        this.renderer.setStyle(hostElement.nativeElement, 'text-overflow', 'ellipsis');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TextOverFlowDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: TextOverFlowDirective, selector: "[textOverFlow]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TextOverFlowDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[textOverFlow]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

class CoreModule {
    static forRoot(cfg) {
        return {
            ngModule: CoreModule,
            providers: [
                {
                    provide: SCROLL_OPTIONS,
                    useValue: cfg && cfg.scrollConfig ? cfg.scrollConfig : DEFAULT_SCROLL_OPTIONS,
                },
                {
                    provide: FORM_CONTROL_VALIDATION_OPTIONS,
                    useValue: cfg && cfg.formControlValidationOptions ? cfg.formControlValidationOptions : DEFAULT_FORM_CONTROL_VALIDATION_OPTIONS,
                },
                {
                    provide: TOAST_SETTINGS,
                    useValue: cfg && cfg.toastCfg ? cfg.toastCfg : DEFAULT_TOAST_SETTINGS,
                },
                {
                    provide: TASK_PANEL_SETTINGS,
                    ...(cfg?.tasksPanelSettingsProvider || {
                        useFactory: () => DEFAULT_TASK_PANEL_SETTINGS,
                    }),
                },
                {
                    provide: THEME_ASPECT,
                    useValue: (cfg && cfg?.themeAspect) || ThemeAspect.NONE,
                },
                {
                    provide: AVAILABLE_THEMES,
                    useValue: cfg && cfg.availableThemes ? cfg.availableThemes : [],
                },
                {
                    provide: DEFAULT_THEME,
                    useValue: cfg && cfg.defaultTheme ? cfg.defaultTheme : null,
                },
                { provide: WindowRef, useClass: BrowserWindowRef },
                {
                    provide: WINDOW,
                    useFactory: windowFactory,
                    deps: [WindowRef, PLATFORM_ID],
                },
                {
                    provide: DATE_TIME_OPTIONS,
                    useValue: cfg?.dateTimeOptions ?? DEFAULT_DATE_TIME_OPTIONS,
                },
                {
                    provide: MEDIA_BREAKPOINT_CONFIG,
                    useValue: cfg?.mediaBreakpointConfig ?? DEFAULT_MEDIA_BREAKPOINT_CONFIG,
                },
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: CoreModule, declarations: [HasChildClassDirective,
            FieldMatcherDirective,
            ResizeDirective,
            ScrollDirective,
            SelectedHighlightDirective,
            DragDirective,
            MultiClickDirective,
            LongPressDirective,
            InputRegexDirective,
            ThemingDirective,
            ThemifyDirective,
            BackgroundDirective,
            ThemeDirective,
            ConcatStringPipe,
            DateFormatPipe,
            NestedPropertyPipe,
            TimeAgoPipe,
            MapToPipe,
            FileSizePipe,
            ToggleFullscreenDirective,
            QueryParamDirective,
            ImageRetryDirective,
            DragDropElementOriginDirective,
            DragDropElementTargetDirective,
            DragDropFileTargetDirective,
            ApplyFunctionPipe,
            IntegerOnlyDirective,
            TextOverFlowDirective], imports: [CommonModule, ObserversModule, ScrollingModule], exports: [FieldMatcherDirective,
            HasChildClassDirective,
            ResizeDirective,
            ScrollDirective,
            SelectedHighlightDirective,
            DragDirective,
            MultiClickDirective,
            LongPressDirective,
            InputRegexDirective,
            ThemingDirective,
            ThemifyDirective,
            BackgroundDirective,
            ThemeDirective,
            ConcatStringPipe,
            DateFormatPipe,
            NestedPropertyPipe,
            TimeAgoPipe,
            MapToPipe,
            FileSizePipe,
            ToggleFullscreenDirective,
            QueryParamDirective,
            ImageRetryDirective,
            DragDropElementOriginDirective,
            DragDropElementTargetDirective,
            DragDropFileTargetDirective,
            ApplyFunctionPipe,
            IntegerOnlyDirective,
            TextOverFlowDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CoreModule, imports: [CommonModule, ObserversModule, ScrollingModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ObserversModule, ScrollingModule],
                    declarations: [
                        HasChildClassDirective,
                        FieldMatcherDirective,
                        ResizeDirective,
                        ScrollDirective,
                        SelectedHighlightDirective,
                        DragDirective,
                        MultiClickDirective,
                        LongPressDirective,
                        InputRegexDirective,
                        ThemingDirective,
                        ThemifyDirective,
                        BackgroundDirective,
                        ThemeDirective,
                        ConcatStringPipe,
                        DateFormatPipe,
                        NestedPropertyPipe,
                        TimeAgoPipe,
                        MapToPipe,
                        FileSizePipe,
                        ToggleFullscreenDirective,
                        QueryParamDirective,
                        ImageRetryDirective,
                        DragDropElementOriginDirective,
                        DragDropElementTargetDirective,
                        DragDropFileTargetDirective,
                        ApplyFunctionPipe,
                        IntegerOnlyDirective,
                        TextOverFlowDirective,
                    ],
                    exports: [
                        FieldMatcherDirective,
                        HasChildClassDirective,
                        ResizeDirective,
                        ScrollDirective,
                        SelectedHighlightDirective,
                        DragDirective,
                        MultiClickDirective,
                        LongPressDirective,
                        InputRegexDirective,
                        ThemingDirective,
                        ThemifyDirective,
                        BackgroundDirective,
                        ThemeDirective,
                        ConcatStringPipe,
                        DateFormatPipe,
                        NestedPropertyPipe,
                        TimeAgoPipe,
                        MapToPipe,
                        FileSizePipe,
                        ToggleFullscreenDirective,
                        QueryParamDirective,
                        ImageRetryDirective,
                        DragDropElementOriginDirective,
                        DragDropElementTargetDirective,
                        DragDropFileTargetDirective,
                        ApplyFunctionPipe,
                        IntegerOnlyDirective,
                        TextOverFlowDirective,
                    ],
                }]
        }] });

const ICONS_MATERIAL = [
    'action',
    'alert',
    'av',
    'communication',
    'content',
    'device',
    'editor',
    'file',
    'hardware',
    'image',
    'maps',
    'navigation',
    'notification',
    'places',
    'social',
    'toggle',
];
/**
 * The icon component - made with ♥
 *  - supports material icons and font-awesome
 *
 * Caveats
 *  - when clickable make sure to add the "click-icon" css class.
 *
 * Notes:
 *  - if click event emitter is binded, "click-icon" class will be automatically added.
 */
class IconComponent {
    get iconClass() {
        return this._iconClass;
    }
    get iconName() {
        return this._iconName;
    }
    get isSpin() {
        return this.rotate;
    }
    /**
     * change cursor to pointer, if click is bind by parent
     */
    get addClickableClass() {
        return this.click.observers.length > 0;
    }
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        /**
         * set to true if the icon needs to rotate.
         */
        this.rotate = false;
        /**
         * Indicates if the icon is disabled.
         * When disabled it will have a lighter opacity and will not emit the action when clicked
         */
        this.disabled = false;
        /**
         * Used only for binding css class
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.click = new EventEmitter();
        this.componentDestroyed$ = new Subject();
        this._iconClass = '';
        this._iconName = '';
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    ngOnChanges({ icon, fontSize }) {
        if (icon && icon.currentValue) {
            const iconNameSpaceAndName = icon.currentValue.split(':');
            if (iconNameSpaceAndName.length < 2) {
                throw new Error(`Icon should have a namespace and name seperated by ':'.`);
            }
            if (ICONS_MATERIAL.indexOf(iconNameSpaceAndName[0]) > -1) {
                this._iconClass = 'material-icons';
                this._iconName = iconNameSpaceAndName[1];
            }
            else {
                this._iconClass = `${iconNameSpaceAndName[0]} fa-${iconNameSpaceAndName[1]}`;
                this._iconName = '';
            }
        }
        if (fontSize && fontSize.currentValue && !fontSize.isFirstChange()) {
            this.iconSize(+fontSize.currentValue);
        }
    }
    ngAfterViewInit() {
        this.renderer.setStyle(this.iconElement.nativeElement, 'fontSize', 'inherit');
        this.iconSize(this.fontSize);
    }
    onClick(event) {
        if (this.disabled) {
            event.stopPropagation();
        }
    }
    /**
     * This method updates the font size
     */
    iconSize(fontSize = this.fontSize) {
        // if there is not font size set or its <= 0 => 24px
        if (fontSize !== undefined && fontSize > 0) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'fontSize', fontSize + 'px');
        }
        else {
            this.renderer.setStyle(this.elementRef.nativeElement, 'fontSize', '24px');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: IconComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: IconComponent, selector: "avn-icon", inputs: { icon: "icon", rotate: "rotate", fontSize: "fontSize", actionId: "actionId", disabled: "disabled" }, outputs: { click: "click" }, host: { properties: { "class.disabled": "this.disabled", "class.avn-spin": "this.isSpin", "class.clickable-icon": "this.addClickableClass" } }, viewQueries: [{ propertyName: "iconElement", first: true, predicate: ["iconElement"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<i [ngClass]=\"iconClass\" #iconElement (click)=\"onClick($event)\">{{ iconName }}</i>\n", styles: [":host{display:flex;position:relative;font-size:var(--text-lg);justify-content:center;align-content:center;outline:none;align-items:flex-end}:host.theme-primary{color:var(--primary-base)}:host.clickable-icon.theme-primary:hover:not(.disabled){color:var(--primary-variant)}:host.theme-secondary{color:var(--secondary-base)}:host.clickable-icon.theme-secondary:hover:not(.disabled){color:var(--secondary-variant)}:host.theme-highlight{color:var(--highlight-base)}:host.clickable-icon.theme-highlight:hover:not(.disabled){color:var(--highlight-variant)}:host.theme-danger{color:var(--danger-base)}:host.clickable-icon.theme-danger:hover:not(.disabled){color:var(--danger-variant)}:host.theme-warning{color:var(--warning-base)}:host.clickable-icon.theme-warning:hover:not(.disabled){color:var(--warning-variant)}:host.theme-info{color:var(--info-base)}:host.clickable-icon.theme-info:hover:not(.disabled){color:var(--info-variant)}:host.theme-success{color:var(--success-base)}:host.clickable-icon.theme-success:hover:not(.disabled){color:var(--success-variant)}:host.click-icon,:host.clickable-icon{cursor:pointer}:host.disabled{opacity:.5;cursor:not-allowed}:host.avn-spin>i{animation:avn-spin .5s infinite linear;transform-origin:center}@keyframes avn-spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<i [ngClass]=\"iconClass\" #iconElement (click)=\"onClick($event)\">{{ iconName }}</i>\n", styles: [":host{display:flex;position:relative;font-size:var(--text-lg);justify-content:center;align-content:center;outline:none;align-items:flex-end}:host.theme-primary{color:var(--primary-base)}:host.clickable-icon.theme-primary:hover:not(.disabled){color:var(--primary-variant)}:host.theme-secondary{color:var(--secondary-base)}:host.clickable-icon.theme-secondary:hover:not(.disabled){color:var(--secondary-variant)}:host.theme-highlight{color:var(--highlight-base)}:host.clickable-icon.theme-highlight:hover:not(.disabled){color:var(--highlight-variant)}:host.theme-danger{color:var(--danger-base)}:host.clickable-icon.theme-danger:hover:not(.disabled){color:var(--danger-variant)}:host.theme-warning{color:var(--warning-base)}:host.clickable-icon.theme-warning:hover:not(.disabled){color:var(--warning-variant)}:host.theme-info{color:var(--info-base)}:host.clickable-icon.theme-info:hover:not(.disabled){color:var(--info-variant)}:host.theme-success{color:var(--success-base)}:host.clickable-icon.theme-success:hover:not(.disabled){color:var(--success-variant)}:host.click-icon,:host.clickable-icon{cursor:pointer}:host.disabled{opacity:.5;cursor:not-allowed}:host.avn-spin>i{animation:avn-spin .5s infinite linear;transform-origin:center}@keyframes avn-spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { icon: [{
                type: Input
            }], rotate: [{
                type: Input
            }], fontSize: [{
                type: Input
            }], actionId: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: Input
            }], click: [{
                type: Output
            }], iconElement: [{
                type: ViewChild,
                args: ['iconElement', { static: false }]
            }], isSpin: [{
                type: HostBinding,
                args: ['class.avn-spin']
            }], addClickableClass: [{
                type: HostBinding,
                args: ['class.clickable-icon']
            }] } });

/**
 * <avn-count-icon>
 *  - is a special icon that can have count on top
 *  - requires <avn-icon> as it's content component
 */
class CountIconComponent {
    constructor() {
        /**
         * the theme to apply to the count element
         */
        this.countTheme = ThemeType.SECONDARY;
    }
    get displayCount() {
        if (!this.count) {
            return '';
        }
        else if (this.count && +this.count > 999) {
            return '999+';
        }
        return this.count.toString();
    }
    ngAfterContentInit() {
        if (!this.iconComponent) {
            throw new Error('<avn-icon> is required under <avn-count-icon>.');
        }
    }
    onClick($event) {
        this.iconComponent.onClick($event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CountIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CountIconComponent, selector: "avn-count-icon", inputs: { count: "count", countTheme: "countTheme" }, queries: [{ propertyName: "iconComponent", first: true, predicate: IconComponent, descendants: true }], ngImport: i0, template: "<ng-content></ng-content>\n<div *ngIf=\"count\" class=\"count\" #countElement [avnTheme]=\"countTheme\" (click)=\"onClick($event)\">\n  {{ displayCount }}\n</div>\n", styles: [":host{display:flex;align-items:flex-start}:host .count{position:relative;margin-top:-7px;cursor:default;box-shadow:0 2px 5px #00000029,0 2px 10px #0000001f;border-radius:2px;padding:1px 7px;font-size:var(--text-sm);font-weight:700;color:#fff;height:19px;max-width:60px;text-overflow:ellipsis;overflow:hidden}:host .count:hover{box-shadow:0 2px 5px #00000029,0 2px 10px #0000001f!important}:host .count.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .count.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .count.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .count.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .count.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .count.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .count.theme-success{background-color:var(--success-base);color:var(--success-on)}:host-context(.count-icon-cursor-inherit) .count{cursor:inherit}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CountIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-count-icon', template: "<ng-content></ng-content>\n<div *ngIf=\"count\" class=\"count\" #countElement [avnTheme]=\"countTheme\" (click)=\"onClick($event)\">\n  {{ displayCount }}\n</div>\n", styles: [":host{display:flex;align-items:flex-start}:host .count{position:relative;margin-top:-7px;cursor:default;box-shadow:0 2px 5px #00000029,0 2px 10px #0000001f;border-radius:2px;padding:1px 7px;font-size:var(--text-sm);font-weight:700;color:#fff;height:19px;max-width:60px;text-overflow:ellipsis;overflow:hidden}:host .count:hover{box-shadow:0 2px 5px #00000029,0 2px 10px #0000001f!important}:host .count.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .count.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .count.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .count.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .count.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .count.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .count.theme-success{background-color:var(--success-base);color:var(--success-on)}:host-context(.count-icon-cursor-inherit) .count{cursor:inherit}\n"] }]
        }], propDecorators: { count: [{
                type: Input
            }], countTheme: [{
                type: Input
            }], iconComponent: [{
                type: ContentChild,
                args: [IconComponent, { static: false }]
            }] } });

/**
 * <avn-status-icon>
 *  - is a special icon that can have a status sign on the bottom right
 *  - requires <avn-icon> as it's content component
 */
class StatusIconComponent {
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * Theme to place on the status element.
         */
        this.statusTheme = ThemeType.SECONDARY;
    }
    ngAfterContentInit() {
        if (!this.iconComponent) {
            throw new Error('<avn-icon> is required under <avn-status-icon>.');
        }
    }
    onClick($event) {
        this.iconComponent.onClick($event);
    }
    onResizeStatusIcon(event) {
        this.iconWidth = event.width / 10;
        this.cdr.detectChanges();
    }
    /**
     * change cursor to pointer, if click is bind by parent
     */
    get addClickableStatusIconClass() {
        return this.iconComponent.addClickableClass;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StatusIconComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: StatusIconComponent, selector: "avn-status-icon", inputs: { statusTheme: "statusTheme" }, host: { properties: { "class.clickable-status-icon": "this.addClickableStatusIconClass" } }, queries: [{ propertyName: "iconComponent", first: true, predicate: IconComponent, descendants: true }], ngImport: i0, template: "<div (avnResize)=\"onResizeStatusIcon($event)\" class=\"status-icon-container\">\n  <ng-content></ng-content>\n  <div class=\"status-icon\" [avnTheme]=\"statusTheme\" #statusElement (click)=\"onClick($event)\" [style.width.px]=\"iconWidth\" [style.height.px]=\"iconWidth\"></div>\n</div>\n", styles: [":host .status-icon-container{display:flex;align-items:flex-end;position:relative;min-width:30px;justify-content:space-between}:host .status-icon-container .status-icon{border-radius:2px;min-height:7px;min-width:7px}:host .status-icon-container .status-icon.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .status-icon-container .status-icon.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .status-icon-container .status-icon.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .status-icon-container .status-icon.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .status-icon-container .status-icon.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .status-icon-container .status-icon.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .status-icon-container .status-icon.theme-success{background-color:var(--success-base);color:var(--success-on)}:host.clickable-status-icon{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StatusIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-status-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div (avnResize)=\"onResizeStatusIcon($event)\" class=\"status-icon-container\">\n  <ng-content></ng-content>\n  <div class=\"status-icon\" [avnTheme]=\"statusTheme\" #statusElement (click)=\"onClick($event)\" [style.width.px]=\"iconWidth\" [style.height.px]=\"iconWidth\"></div>\n</div>\n", styles: [":host .status-icon-container{display:flex;align-items:flex-end;position:relative;min-width:30px;justify-content:space-between}:host .status-icon-container .status-icon{border-radius:2px;min-height:7px;min-width:7px}:host .status-icon-container .status-icon.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .status-icon-container .status-icon.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .status-icon-container .status-icon.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .status-icon-container .status-icon.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .status-icon-container .status-icon.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .status-icon-container .status-icon.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .status-icon-container .status-icon.theme-success{background-color:var(--success-base);color:var(--success-on)}:host.clickable-status-icon{cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { statusTheme: [{
                type: Input
            }], iconComponent: [{
                type: ContentChild,
                args: [IconComponent, { static: false }]
            }], addClickableStatusIconClass: [{
                type: HostBinding,
                args: ['class.clickable-status-icon']
            }] } });

class IconModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: IconModule, declarations: [IconComponent, StatusIconComponent, CountIconComponent], imports: [CommonModule, CoreModule], exports: [IconComponent, StatusIconComponent, CountIconComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: IconModule, imports: [CommonModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule],
                    declarations: [IconComponent, StatusIconComponent, CountIconComponent],
                    exports: [IconComponent, StatusIconComponent, CountIconComponent],
                }]
        }] });

var ButtonColorType;
(function (ButtonColorType) {
    ButtonColorType["normal"] = "normal";
    ButtonColorType["link"] = "link";
    ButtonColorType["outline"] = "outline";
})(ButtonColorType || (ButtonColorType = {}));

class ButtonComponent {
    constructor() {
        /**
         * the type of the button
         */
        this.type = 'button';
        /**
         * the buttonType of the button
         */
        this.buttonColorType = ButtonColorType.normal;
        /**
         * disables the button
         */
        this.disabled = false;
        /**
         * specifies the position of the icon
         */
        this.iconPosition = 'left';
        this.actioned = new EventEmitter();
        /**
         * unique id for the button
         */
        this.uuid = v4();
    }
    /** Returns the icon font size depending on the button size **/
    get iconFontSize() {
        switch (this.size) {
            case 'small':
                return 17;
            case 'large':
                return 30;
            default:
                return 21;
        }
    }
    ngAfterViewInit() {
        this.nativeButton.nativeElement.setAttribute('aria-label', this.label);
    }
    handleAction(event) {
        this.setAriaPressed();
        if (!this.disabled) {
            this.actioned.emit(event);
        }
    }
    get isIconButton() {
        return !!this.icon && !this.label;
    }
    setAriaPressed() {
        if (this.type === 'button') {
            const btnTarget = this.nativeButton.nativeElement;
            let pressed = undefined;
            if (!this.disabled) {
                const isBtnPressed = btnTarget.getAttribute('aria-pressed') === 'true';
                pressed = String(!isBtnPressed);
            }
            btnTarget.setAttribute('aria-pressed', pressed);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ButtonComponent, selector: "avn-button", inputs: { id: "id", label: "label", type: "type", size: "size", buttonColorType: "buttonColorType", disabled: "disabled", icon: "icon", iconPosition: "iconPosition", iconTheme: "iconTheme", fullWidth: "fullWidth" }, outputs: { actioned: "actioned" }, host: { properties: { "class.full-width": "this.fullWidth", "class.icon-only": "this.isIconButton" } }, viewQueries: [{ propertyName: "nativeButton", first: true, predicate: ["buttonRef"], descendants: true }], ngImport: i0, template: "<button\n  #buttonRef\n  aria-pressed=\"false\"\n  [id]=\"uuid\"\n  [type]=\"type\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"buttonColorType\"\n  [class.button-small]=\"size === 'small'\"\n  [class.button-large]=\"size === 'large'\"\n  [class.icon-right]=\"iconPosition === 'right'\"\n  (click)=\"handleAction($event)\"\n  (keyup.enter)=\"handleAction($event)\"\n  (keyup.space)=\"handleAction($event)\"\n>\n  <avn-icon *ngIf=\"icon\" role=\"presentation\" [icon]=\"icon\" [fontSize]=\"iconFontSize\" [avnTheme]=\"iconTheme\"> </avn-icon>\n  <span *ngIf=\"label\" role=\"presentation\" [ngStyle]=\"{ height: iconFontSize + 'px' }\">\n    {{ label }}\n  </span>\n</button>\n", styles: [":host.theme-primary>button{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>button{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>button{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>button{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>button{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>button{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>button{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary>button:focus{outline:none;box-shadow:0 0 0 2px var(--primary-variant)}:host.theme-secondary>button:focus{outline:none;box-shadow:0 0 0 2px var(--secondary-variant)}:host.theme-highlight>button:focus{outline:none;box-shadow:0 0 0 2px var(--highlight-variant)}:host.theme-danger>button:focus{outline:none;box-shadow:0 0 0 2px var(--danger-variant)}:host.theme-warning>button:focus{outline:none;box-shadow:0 0 0 2px var(--warning-variant)}:host.theme-info>button:focus{outline:none;box-shadow:0 0 0 2px var(--info-variant)}:host.theme-success>button:focus{outline:none;box-shadow:0 0 0 2px var(--success-variant)}:host.full-width{width:100%}:host.full-width>button{width:100%}:host>button{position:relative;display:flex;align-items:center;justify-content:center;transition:background-color .2s,color .2s,border-color .2s;will-change:background-color;will-change:color;will-change:border-color;padding:var(--space-sm) var(--space-md);border:1px solid transparent;border-radius:3px;color:var(--button-on);background-color:var(--button-background)}:host>button:disabled{cursor:not-allowed;opacity:.65}:host>button:hover:not(:disabled){opacity:.7}:host>button>span{display:inline-flex;align-items:center;justify-content:center}:host>button>avn-icon{order:1}:host>button>avn-icon+span{padding-left:var(--space-sm);order:2}:host>button.button-small{padding:var(--space-xs) var(--space-sm);font-size:var(--text-sm)}:host>button.button-small>avn-icon+span{padding-left:var(--space-xs)}:host>button.button-large{padding:var(--space-md) var(--space-lg);font-size:var(--text-md)}:host>button.button-large>avn-icon+span{padding-left:var(--space-md)}:host>button.icon-right>avn-icon{order:2}:host>button.icon-right>avn-icon+span{padding-left:0;padding-right:var(--space-sm);order:1}:host>button.icon-right.button-small>avn-icon+span{padding-right:var(--space-xs)}:host>button.icon-right.button-large>avn-icon+span{padding-right:var(--space-md)}:host>button.outline{background-color:transparent;color:var(--button-on);border-color:var(--button-on)}:host.theme-primary>button.outline{color:var(--primary-base);border-color:var(--primary-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-secondary>button.outline{color:var(--secondary-base);border-color:var(--secondary-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-highlight>button.outline{color:var(--highlight-base);border-color:var(--highlight-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-danger>button.outline{color:var(--danger-base);border-color:var(--danger-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-warning>button.outline{color:var(--warning-base);border-color:var(--warning-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-info>button.outline{color:var(--info-base);border-color:var(--info-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-success>button.outline{color:var(--success-base);border-color:var(--success-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host-context(.dmb-aspect) :host>button{padding:var(--space-md) var(--space-base);border:1px solid rgba(0,0,0,.6);text-shadow:1px 1px rgba(0,0,0,.3)}:host-context(.dmb-aspect) :host>button:after{content:\"\";position:absolute;background-image:linear-gradient(rgba(255,255,255,.1),rgba(0,0,0,0),60%,rgba(0,0,0,.1));inset:0}:host-context(.dmb-aspect) :host>button:hover:not(:disabled):after{background-image:linear-gradient(rgba(0,0,0,.4),rgba(0,0,0,.3),40%,rgba(0,0,0,.26))}:host-context(.dmb-aspect) :host>button.link{border:1px transparent;background:transparent}:host-context(.dmb-aspect) :host>button.link:after,:host-context(.dmb-aspect) :host>button.link:hover:not(:disabled):after{background:transparent}:host-context(.dmb-aspect) :host>button.link:hover:not(:disabled){text-decoration:underline}:host-context(.dmb-aspect) :host>button.button-small{padding:var(--space-xs) var(--space-sm);font-size:var(--text-sm)}:host-context(.dmb-aspect) :host>button.button-small>avn-icon+span{padding-left:var(--space-xs)}:host-context(.dmb-aspect) :host>button.button-large{padding:var(--space-md) var(--space-lg);font-size:var(--text-md)}:host-context(.dmb-aspect) :host>button.button-large>avn-icon+span{padding-left:var(--space-md)}:host-context(.neumorphism-aspect) :host>button{border-radius:5px;border:none;padding:var(--space-md) var(--space-xl)}:host-context(.neumorphism-aspect) :host>button:after{content:\"\";position:absolute;background-image:linear-gradient(145deg,rgba(255,255,255,0),rgba(255,255,255,.2));box-shadow:5px 5px 10px #0000004d,-5px -5px 10px #ffffff14;inset:0;border-radius:5px;border:none;padding:var(--space-md) var(--space-xl)}:host-context(.neumorphism-aspect) :host>button:hover:not(:disabled):after{background-image:linear-gradient(145deg,rgba(255,255,255,0),rgba(255,255,255,.2))}:host-context(.fab-button) button{overflow:hidden;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f;background-color:revert!important;color:revert!important;border-radius:50px!important}:host-context(.fab-button).icon-only button{width:32px;height:32px}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\n  #buttonRef\n  aria-pressed=\"false\"\n  [id]=\"uuid\"\n  [type]=\"type\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"buttonColorType\"\n  [class.button-small]=\"size === 'small'\"\n  [class.button-large]=\"size === 'large'\"\n  [class.icon-right]=\"iconPosition === 'right'\"\n  (click)=\"handleAction($event)\"\n  (keyup.enter)=\"handleAction($event)\"\n  (keyup.space)=\"handleAction($event)\"\n>\n  <avn-icon *ngIf=\"icon\" role=\"presentation\" [icon]=\"icon\" [fontSize]=\"iconFontSize\" [avnTheme]=\"iconTheme\"> </avn-icon>\n  <span *ngIf=\"label\" role=\"presentation\" [ngStyle]=\"{ height: iconFontSize + 'px' }\">\n    {{ label }}\n  </span>\n</button>\n", styles: [":host.theme-primary>button{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>button{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>button{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>button{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>button{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>button{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>button{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary>button:focus{outline:none;box-shadow:0 0 0 2px var(--primary-variant)}:host.theme-secondary>button:focus{outline:none;box-shadow:0 0 0 2px var(--secondary-variant)}:host.theme-highlight>button:focus{outline:none;box-shadow:0 0 0 2px var(--highlight-variant)}:host.theme-danger>button:focus{outline:none;box-shadow:0 0 0 2px var(--danger-variant)}:host.theme-warning>button:focus{outline:none;box-shadow:0 0 0 2px var(--warning-variant)}:host.theme-info>button:focus{outline:none;box-shadow:0 0 0 2px var(--info-variant)}:host.theme-success>button:focus{outline:none;box-shadow:0 0 0 2px var(--success-variant)}:host.full-width{width:100%}:host.full-width>button{width:100%}:host>button{position:relative;display:flex;align-items:center;justify-content:center;transition:background-color .2s,color .2s,border-color .2s;will-change:background-color;will-change:color;will-change:border-color;padding:var(--space-sm) var(--space-md);border:1px solid transparent;border-radius:3px;color:var(--button-on);background-color:var(--button-background)}:host>button:disabled{cursor:not-allowed;opacity:.65}:host>button:hover:not(:disabled){opacity:.7}:host>button>span{display:inline-flex;align-items:center;justify-content:center}:host>button>avn-icon{order:1}:host>button>avn-icon+span{padding-left:var(--space-sm);order:2}:host>button.button-small{padding:var(--space-xs) var(--space-sm);font-size:var(--text-sm)}:host>button.button-small>avn-icon+span{padding-left:var(--space-xs)}:host>button.button-large{padding:var(--space-md) var(--space-lg);font-size:var(--text-md)}:host>button.button-large>avn-icon+span{padding-left:var(--space-md)}:host>button.icon-right>avn-icon{order:2}:host>button.icon-right>avn-icon+span{padding-left:0;padding-right:var(--space-sm);order:1}:host>button.icon-right.button-small>avn-icon+span{padding-right:var(--space-xs)}:host>button.icon-right.button-large>avn-icon+span{padding-right:var(--space-md)}:host>button.outline{background-color:transparent;color:var(--button-on);border-color:var(--button-on)}:host.theme-primary>button.outline{color:var(--primary-base);border-color:var(--primary-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-secondary>button.outline{color:var(--secondary-base);border-color:var(--secondary-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-highlight>button.outline{color:var(--highlight-base);border-color:var(--highlight-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-danger>button.outline{color:var(--danger-base);border-color:var(--danger-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-warning>button.outline{color:var(--warning-base);border-color:var(--warning-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-info>button.outline{color:var(--info-base);border-color:var(--info-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host.theme-success>button.outline{color:var(--success-base);border-color:var(--success-base);filter:brightness(130%);box-shadow:0 0 .8px var(--button-on)}:host-context(.dmb-aspect) :host>button{padding:var(--space-md) var(--space-base);border:1px solid rgba(0,0,0,.6);text-shadow:1px 1px rgba(0,0,0,.3)}:host-context(.dmb-aspect) :host>button:after{content:\"\";position:absolute;background-image:linear-gradient(rgba(255,255,255,.1),rgba(0,0,0,0),60%,rgba(0,0,0,.1));inset:0}:host-context(.dmb-aspect) :host>button:hover:not(:disabled):after{background-image:linear-gradient(rgba(0,0,0,.4),rgba(0,0,0,.3),40%,rgba(0,0,0,.26))}:host-context(.dmb-aspect) :host>button.link{border:1px transparent;background:transparent}:host-context(.dmb-aspect) :host>button.link:after,:host-context(.dmb-aspect) :host>button.link:hover:not(:disabled):after{background:transparent}:host-context(.dmb-aspect) :host>button.link:hover:not(:disabled){text-decoration:underline}:host-context(.dmb-aspect) :host>button.button-small{padding:var(--space-xs) var(--space-sm);font-size:var(--text-sm)}:host-context(.dmb-aspect) :host>button.button-small>avn-icon+span{padding-left:var(--space-xs)}:host-context(.dmb-aspect) :host>button.button-large{padding:var(--space-md) var(--space-lg);font-size:var(--text-md)}:host-context(.dmb-aspect) :host>button.button-large>avn-icon+span{padding-left:var(--space-md)}:host-context(.neumorphism-aspect) :host>button{border-radius:5px;border:none;padding:var(--space-md) var(--space-xl)}:host-context(.neumorphism-aspect) :host>button:after{content:\"\";position:absolute;background-image:linear-gradient(145deg,rgba(255,255,255,0),rgba(255,255,255,.2));box-shadow:5px 5px 10px #0000004d,-5px -5px 10px #ffffff14;inset:0;border-radius:5px;border:none;padding:var(--space-md) var(--space-xl)}:host-context(.neumorphism-aspect) :host>button:hover:not(:disabled):after{background-image:linear-gradient(145deg,rgba(255,255,255,0),rgba(255,255,255,.2))}:host-context(.fab-button) button{overflow:hidden;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f;background-color:revert!important;color:revert!important;border-radius:50px!important}:host-context(.fab-button).icon-only button{width:32px;height:32px}\n"] }]
        }], propDecorators: { nativeButton: [{
                type: ViewChild,
                args: ['buttonRef', { static: false }]
            }], id: [{
                type: Input
            }], label: [{
                type: Input
            }], type: [{
                type: Input
            }], size: [{
                type: Input
            }], buttonColorType: [{
                type: Input
            }], disabled: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], iconTheme: [{
                type: Input
            }], fullWidth: [{
                type: HostBinding,
                args: ['class.full-width']
            }, {
                type: Input
            }], actioned: [{
                type: Output
            }], isIconButton: [{
                type: HostBinding,
                args: ['class.icon-only']
            }] } });

class ButtonModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ButtonModule, declarations: [ButtonComponent], imports: [CommonModule, CoreModule, IconModule], exports: [ButtonComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ButtonModule, imports: [CommonModule, CoreModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule],
                    declarations: [ButtonComponent],
                    exports: [ButtonComponent],
                }]
        }] });

/**
 * Defines the base color of a theme type (color group) together with its lighter and darker
 *variations
 **/

class ColorSetsService {
    /**
     * @ignore
     */
    constructor(themeService) {
        this.themeService = themeService;
        this.avnAppThemes = Object.values(ThemeType);
        this.avnAppMixTheme = 'mix';
        this.buildThemes();
    }
    /**
     * return available theme names
     */
    getThemeNames() {
        return this.defaultThemes.map((t) => t.name);
    }
    /**
     * return available color shades for a theme type
     */
    getAllShadesInTheme(theme) {
        return Object.values(generateThemeShades(this.themeService.currentTheme[`${theme}Base`]));
    }
    /**
     * return available base theme colors
     */
    getAllThemeBaseColors() {
        return Object.values(ThemeType).map((color) => this.themeService.currentTheme[`${color}Base`]);
    }
    /**
     * generate the base, mix & swimlane color sets (themes)
     */
    buildThemes() {
        this.defaultThemes = [];
        // Add scheme for color from theme store
        this.avnAppThemes.forEach((theme) => {
            this.defaultThemes.push({
                name: theme,
                domain: this.getAllShadesInTheme(theme),
            });
        });
        // Add a mix of base colors from the colors above in the theme store
        this.defaultThemes.push({
            name: this.avnAppMixTheme,
            domain: this.getAllThemeBaseColors(),
        });
        this.defaultThemes = [...this.defaultThemes];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ColorSetsService, deps: [{ token: ThemeService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ColorSetsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ColorSetsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: ThemeService }]; } });

class FormControlComponent {
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
    }
    /**
     * @ignore
     */
    constructor(ngControl, changeDetector) {
        this.ngControl = ngControl;
        this.changeDetector = changeDetector;
        /**
         * id for the native input field. Auto-generated when not specified.
         */
        this.id = v4();
        /**
         * specifies whether the component is disabled or not.
         * This field should not be used in a reactive form context. Rather the disabled state should be
         * set that way:
         *
         *   form = new FormGroup({
         *     first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),
         *     last: new FormControl('Drew', Validators.required)
         *   });
         *
         * or even:
         *
         *   form.get('first').disable()
         */
        this._disabled = false;
        /** Specifies if the validation theme should be applied to the component */
        this.applyValidationStyle = true;
        /**
         * The callback method that will be called when a change occurs on our component
         *
         * @ignore
         */
        this.propagateChange = () => { };
        /**
         * The callback method that will be called when a touch occurs on our component
         *
         * @ignore
         */
        this.propagateTouched = () => { };
        if (this.ngControl) {
            // Note: we provide the value accessor through here, instead of
            // the `providers` to avoid running into a circular import.
            this.ngControl.valueAccessor = this;
        }
    }
    /**
     * called when the component is initialized
     *
     * @ignore
     */
    ngOnInit() {
        // Retrieve the form control
        if (this.ngControl) {
            this.formControl = this.ngControl.control;
        }
    }
    /**
     * This method is called just before Angular destroys the directive/component.
     *
     * @ignore
     */
    ngOnDestroy() {
        if (this.touchedListener) {
            this.touchedListener.unsubscribe();
        }
    }
    /**
     * This method will be called by the forms API to write to the view when programmatic (model ->
     * view) changes are requested
     *
     * @ignore
     */
    writeValue(value) {
        this.updateValue(value);
        this.changeDetector.markForCheck();
        // run the validation of our component once its value has changed
        if (this.initFormControlIfNotSet()) {
            this.formControl.updateValueAndValidity();
        }
    }
    /**
     * called when the control's value changes in the UI.
     *
     * @ignore
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * called when the control receives a blur event.
     *
     * @ignore
     */
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
    /**
     * called by the forms API when the control status changes to or from "DISABLED". Depending on the
     * value, it should enable or disable the appropriate DOM element.
     *
     * @ignore
     */
    setDisabledState(isDisabled) {
        this.disabled = !!isDisabled;
    }
    /**
     * Registers a subscription for touch events that will be propagated
     *
     * @param target  The element to listen for events
     * @param event  The event to listen to
     */
    subscribeTouch(target, event) {
        this.touchedListener = fromEvent(target, event).subscribe((evt) => {
            this.onTouch(evt);
        });
    }
    /**
     * When the form control is touched
     *
     * @ignore
     */
    onTouch(_evt) {
        this.propagateTouched();
        if (this.initFormControlIfNotSet()) {
            this.formControl.updateValueAndValidity();
        }
    }
    initFormControlIfNotSet() {
        if (!this.formControl) {
            this.formControl = this.ngControl?.control;
        }
        return !!this.formControl;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormControlComponent, deps: [{ token: i1$3.NgControl }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FormControlComponent, inputs: { id: "id", name: "name", formControlName: "formControlName", disabled: "disabled" }, host: { properties: { "class.validation-theme": "this.applyValidationStyle" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormControlComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i1$3.NgControl }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], disabled: [{
                type: Input
            }], applyValidationStyle: [{
                type: HostBinding,
                args: ['class.validation-theme']
            }] } });

/**
 This component represents an error message to be shown underneath a form field.
 See FormFieldComponent for more details
 *
 */
class FormFieldErrorComponent {
    constructor() {
        /** Indicates whether the error message should be of fixed height */
        this.fixedHeight = true;
    }
    get classes() {
        return this.isFixedHeight() ? 'fixed-height' : undefined;
    }
    /**
     * This method indicates if the help text should be of fixed height
     *
     * @ignore
     */
    isFixedHeight() {
        // set the fixed height of the help text if it was requested or if a help text exist
        return this.fixedHeight || this.hasError;
    }
    /**
     * Specifies if there is an error message
     */
    get hasError() {
        return !!this.message;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: FormFieldErrorComponent, selector: "avn-form-field-error", inputs: { key: "key", message: "message", fixedHeight: "fixedHeight" }, host: { properties: { "class": "this.classes" } }, ngImport: i0, template: "<label>{{ message }}</label>\n", styles: [":host{display:block;white-space:nowrap;font-size:var(--text-sm);line-height:1em;overflow:hidden;margin-top:var(--space-xs);color:var(--danger-base)!important}:host.fixed-height{height:var(--text-base)}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-form-field-error', template: "<label>{{ message }}</label>\n", styles: [":host{display:block;white-space:nowrap;font-size:var(--text-sm);line-height:1em;overflow:hidden;margin-top:var(--space-xs);color:var(--danger-base)!important}:host.fixed-height{height:var(--text-base)}\n"] }]
        }], propDecorators: { key: [{
                type: Input
            }], message: [{
                type: Input
            }], fixedHeight: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 This component represents a hint message to be shown underneath a form field.
 *
 */
class FormFieldHintComponent {
    constructor() {
        this.disabled = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldHintComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: FormFieldHintComponent, selector: "avn-form-field-hint", inputs: { message: "message", disabled: "disabled" }, host: { properties: { "class.disabled": "this.disabled" } }, ngImport: i0, template: "{{ message }}\n", styles: [":host{display:block;white-space:nowrap;font-size:var(--text-sm);overflow:hidden;line-height:1em;margin-top:var(--space-xs);text-overflow:ellipsis;height:var(--text-base);color:inherit}:host.disabled{opacity:.3}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldHintComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-form-field-hint', template: "{{ message }}\n", styles: [":host{display:block;white-space:nowrap;font-size:var(--text-sm);overflow:hidden;line-height:1em;margin-top:var(--space-xs);text-overflow:ellipsis;height:var(--text-base);color:inherit}:host.disabled{opacity:.3}\n"] }]
        }], propDecorators: { message: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: Input
            }] } });

/**
 *  This component is a wrapper for the several form input components (FormControlComponent).
 *  It is meant to be used when the component are used within a form context (reactive or
 *template-driven). It manages the validation of the component. Depending on the validation status
 *of associated  form control, it will:
 *  - set the validation theme (DANGER if the associated form control has errors, SUCCESS otherwise)
 *  - display the error message (CAVEAT: one error message at a time) or the hint (only when no
 *error messages) It also adds a bottom margin as the component is placed within a form.
 **/
class FormFieldComponent {
    constructor(formControlValidationOptions, _changeDetector) {
        this.formControlValidationOptions = formControlValidationOptions;
        this._changeDetector = _changeDetector;
        this.statusSub = new Subject();
        this.status$ = this.statusSub.asObservable();
        /** control the font color if a form control is disabled */
        this.disabled = false;
        /** @ignore Pattern used to close all subscriptions **/
        this.componentDestroyed$ = new Subject();
    }
    /** @ignore */
    ngAfterContentInit() {
        // filter the errors to display only the first one found (refilter when error list changes)
        this.filterErrors();
        this.errors.changes.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.filterErrors());
        // make sure to keep trace of the control theme to be able to reset to it
        if (this.control) {
            if (this.control.formControl) {
                this.formControl = this.control.formControl;
                this.formControl.statusChanges
                    .pipe(tap((status) => {
                    this.statusSub.next(status);
                }), takeUntil(this.componentDestroyed$))
                    .subscribe();
                this._toggleEnability();
                // update the control theme when its validation status changes
                merge(this.formControl.statusChanges, this.formControl.valueChanges)
                    .pipe(takeUntil(this.componentDestroyed$))
                    .subscribe(() => {
                    // update the errors
                    this.filterErrors();
                    // apply the validation theme if set in the options or overridden by input
                    const enableValidTheme = this.enableValidTheme !== undefined ? this.enableValidTheme : this.formControlValidationOptions.enableValidTheme;
                    const enableInvalidTheme = this.enableInvalidTheme !== undefined ? this.enableInvalidTheme : this.formControlValidationOptions.enableInvalidTheme;
                    this.control.applyValidationStyle = (enableValidTheme && this.control.formControl.valid) || (enableInvalidTheme && this.control.formControl.invalid);
                    // refresh the component style (HostBinding for validation class)
                    this.control.changeDetector.markForCheck();
                    this._toggleEnability();
                    // detect changes as we have updated the errors
                    this._changeDetector.detectChanges();
                });
            }
        }
    }
    /**
     * @ignore filter the errors and set the error to display if there is any
     */
    filterErrors() {
        // only show the error if if the form field is touched or dirty
        const hasControl = this.control && this.control.formControl;
        const isUntouchedPristine = hasControl && this.control.formControl.untouched && this.control.formControl.pristine;
        const hasErrors = hasControl && this.control.formControl.errors && Object.keys(this.control.formControl.errors).length > 0;
        if (!hasControl || isUntouchedPristine || !hasErrors) {
            this.error = undefined;
        }
        else {
            // take the first error
            const formControlErrorKey = Object.keys(this.control.formControl.errors)[0];
            // see if our errors do have this error to display
            this.error = this.errors.filter((error) => error.key === formControlErrorKey)[0];
            // if a projected error component is found for the first error key found
            if (this.error) {
                this.errorMsg = this.error.message;
                // if no error message is set, use the actual key value message
                if (!this.errorMsg) {
                    this.errorMsg = this.control.formControl.errors[formControlErrorKey];
                }
                else if (this.error.message.includes(`{{${this.error.key}}}`)) {
                    // Note: Seems that this code is not used anymore
                    // The idea behind that was: "Instead of passing error message with the constraint value Max legnth is 10 to the form component,
                    // I passed the error message in this format: Max length is {{maxLength}}. Then in the form component, if I can find an error with
                    // the key maxLength, I replace this substring {{maxLength}} with the constraint value from the error object itself."
                    const errObj = this.control.formControl.errors[this.error.key];
                    this.errorMsg = this.error.message.replace(`{{${this.error.key}}}`, errObj[this.error.key]);
                }
            }
        }
    }
    /** Specifies if the component has an error to display */
    get hasErrors() {
        return !!this.error;
    }
    /** @ignore **/
    ngOnDestroy() {
        // unsubscribe all subscriptions
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    _toggleEnability() {
        if (this.hint) {
            if (this.hint.disabled !== this.control.formControl.disabled) {
                this.hint.disabled = this.control.formControl.disabled;
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldComponent, deps: [{ token: FORM_CONTROL_VALIDATION_OPTIONS }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: FormFieldComponent, selector: "avn-form-field", inputs: { enableValidTheme: "enableValidTheme", enableInvalidTheme: "enableInvalidTheme", disabled: "disabled" }, host: { properties: { "class.disabled": "this.disabled" } }, queries: [{ propertyName: "control", first: true, predicate: FormControlComponent, descendants: true }, { propertyName: "hint", first: true, predicate: FormFieldHintComponent, descendants: true }, { propertyName: "errors", predicate: FormFieldErrorComponent }], ngImport: i0, template: "<ng-content></ng-content>\n<ng-container *ngIf=\"(status$ | async) === 'PENDING'; else showMessages\">\n  <div class=\"loading-icon\">\n    <avn-icon class=\"icon\" [icon]=\"'action:autorenew'\" [fontSize]=\"14\" [rotate]=\"true\"></avn-icon>\n  </div>\n</ng-container>\n\n<ng-template #showMessages>\n  <ng-content select=\"avn-form-field-hint\" *ngIf=\"!error\"></ng-content>\n  <ng-content select=\"avn-form-field-error\" *ngIf=\"false\"></ng-content>\n  <!-- first form field error underneath with no message is to avoid flicker -->\n  <avn-form-field-error *ngIf=\"errors.length > 0 && !error\" [fixedHeight]=\"!hint\"></avn-form-field-error>\n  <avn-form-field-error *ngIf=\"error\" [message]=\"errorMsg\"></avn-form-field-error>\n</ng-template>\n", styles: [":host{display:block;margin-bottom:var(--space-base);height:inherit}:host div.loading-icon{display:flex;margin-top:var(--space-xs)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: FormFieldErrorComponent, selector: "avn-form-field-error", inputs: ["key", "message", "fixedHeight"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-form-field', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n<ng-container *ngIf=\"(status$ | async) === 'PENDING'; else showMessages\">\n  <div class=\"loading-icon\">\n    <avn-icon class=\"icon\" [icon]=\"'action:autorenew'\" [fontSize]=\"14\" [rotate]=\"true\"></avn-icon>\n  </div>\n</ng-container>\n\n<ng-template #showMessages>\n  <ng-content select=\"avn-form-field-hint\" *ngIf=\"!error\"></ng-content>\n  <ng-content select=\"avn-form-field-error\" *ngIf=\"false\"></ng-content>\n  <!-- first form field error underneath with no message is to avoid flicker -->\n  <avn-form-field-error *ngIf=\"errors.length > 0 && !error\" [fixedHeight]=\"!hint\"></avn-form-field-error>\n  <avn-form-field-error *ngIf=\"error\" [message]=\"errorMsg\"></avn-form-field-error>\n</ng-template>\n", styles: [":host{display:block;margin-bottom:var(--space-base);height:inherit}:host div.loading-icon{display:flex;margin-top:var(--space-xs)}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_CONTROL_VALIDATION_OPTIONS]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { control: [{
                type: ContentChild,
                args: [FormControlComponent, { static: false }]
            }], hint: [{
                type: ContentChild,
                args: [FormFieldHintComponent, { static: false }]
            }], errors: [{
                type: ContentChildren,
                args: [FormFieldErrorComponent]
            }], enableValidTheme: [{
                type: Input
            }], enableInvalidTheme: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: Input
            }] } });

class FormFieldModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: FormFieldModule, declarations: [FormFieldComponent, FormFieldErrorComponent, FormFieldHintComponent], imports: [CommonModule, IconModule], exports: [FormFieldComponent, FormFieldErrorComponent, FormFieldHintComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldModule, imports: [CommonModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FormFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule],
                    declarations: [FormFieldComponent, FormFieldErrorComponent, FormFieldHintComponent],
                    exports: [FormFieldComponent, FormFieldErrorComponent, FormFieldHintComponent],
                }]
        }] });

/**
 * Injection token for use in the input container and custom input that allows to inject the input
 * config.
 */
const INPUT_CONFIG = new InjectionToken('INPUT_CONFIG');
/**
 * defaults for the input settings.
 */
const DEFAULT_INPUT_CONFIG = {
    debounceTime: 300,
};

class InputComponent extends FormControlComponent {
    set showSpinButtonsForNumberInput(val) {
        this._showSpinButtonsForNumberInput = this.type === 'number' ? val : false;
    }
    get showSpinButtonsForNumberInput() {
        return this._showSpinButtonsForNumberInput;
    }
    /**
     * @ignore
     */
    constructor(ngControl, changeDetector, _inputConfig) {
        super(ngControl, changeDetector);
        this._inputConfig = _inputConfig;
        /**
         * The type for the input field (text, number, date)
         */
        this.type = 'text';
        /** Set to true to show arrow buttons in the input field for number type input. Default to false */
        this._showSpinButtonsForNumberInput = false;
        /**
         * The placeholder to display in input field
         */
        this.placeholder = '';
        /**
         * The value for the input field
         */
        this.value = '';
        /**
         * Specify whether value change should be emitted with distinct value or not
         * E.g. When the input component is used as a search input, it's preferred to emit distinct value to
         * prevent triggering duplicate api call. Whereas when the input component is used in some other context,
         * such as within multi-input component, it's preferred to emit all values, so that user can see appropriate
         * validation message.
         */
        this.emitDistinctValueChange = true;
        /**
         * Emits everytime the component value changes
         */
        this.changed = new EventEmitter();
        /**
         * Emits everytime the user press enter
         */
        this.submitted = new EventEmitter();
        this._valueChangedSubject$ = new Subject();
        /**
         * @ignore
         */
        this.componentDestroyed$ = new Subject();
    }
    /**
     * This method is called when the forms API to write to the view when programmatic (model -> view)
     * changes are requested
     *
     * @ignore
     */
    updateValue(value) {
        this.value = this.getTypedValue(value);
    }
    /**
     * child components and directives become available from AfterViewInit lifecycle hook
     *
     * @ignore
     */
    ngAfterViewInit() {
        this.debounceTime = this.debounceTime || this._inputConfig?.debounceTime;
        this.subscribeTouch(this.inputElement.nativeElement, 'blur');
        if (this.debounceTime) {
            this.frequentPropagate();
        }
        this._valueChangedSubject$.pipe(distinctUntilChanged((prev, curr) => this.emitDistinctValueChange ? prev === curr : false), takeUntil(this.componentDestroyed$)).subscribe((value) => {
            this.value = value;
            this.propagateChange(value);
            this.changed.emit(value);
        });
    }
    /**
     * if debounce time is set, input will use the debounce time
     *  to propagate change of keyup event frequently
     */
    frequentPropagate() {
        fromEvent(this.inputElement.nativeElement, 'keyup')
            .pipe(debounceTime(this.debounceTime), map((event) => event.target.value), takeUntil(this.componentDestroyed$))
            .subscribe((value) => this._valueChangedSubject$.next(this.getTypedValue(value)));
    }
    /**
     * Updates the value of our component when the native input value changes
     *
     * @ignore
     */
    onChange($event) {
        $event.stopPropagation();
        const value = this.getTypedValue($event.currentTarget.value);
        // set the value from the input value
        this._valueChangedSubject$.next(value);
    }
    /**
     * Emit the value of our component when the user press enter
     *
     * @ignore
     */
    onSubmit($event) {
        $event.stopPropagation();
        // set the value from the input value
        const value = this.getTypedValue($event.currentTarget.value);
        this._valueChangedSubject$.next(value);
        this.submitted.emit(value);
    }
    /** Return value based on the type of the html input (string or number) */
    getTypedValue(value) {
        if (this.type === 'number') {
            return value !== null && value !== undefined && value !== '' ? +value : undefined;
        }
        else {
            return value;
        }
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputComponent, deps: [{ token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }, { token: INPUT_CONFIG }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: InputComponent, selector: "avn-input", inputs: { label: "label", debounceTime: "debounceTime", type: "type", showSpinButtonsForNumberInput: "showSpinButtonsForNumberInput", min: "min", max: "max", placeholder: "placeholder", value: "value", emitDistinctValueChange: "emitDistinctValueChange" }, outputs: { changed: "changed", submitted: "submitted" }, providers: [{ provide: FormControlComponent, useExisting: InputComponent }], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<input\n  [id]=\"id\"\n  [class.show-spin-buttons]=\"showSpinButtonsForNumberInput\"\n  [class.hide-spin-buttons]=\"!showSpinButtonsForNumberInput\"\n  autocomplete=\"off\"\n  #inputElement\n  [type]=\"type\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [disabled]=\"disabled\"\n  [placeholder]=\"placeholder || ''\"\n  [value]=\"value === undefined ? '' : value\"\n  (change)=\"onChange($event)\"\n  (keyup.enter)=\"onSubmit($event)\"\n/>\n", styles: [":host.validation-theme.ng-valid.ng-touched>input,:host.validation-theme.ng-valid.ng-dirty>input{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched>input,:host.validation-theme.ng-invalid.ng-dirty>input{border-color:var(--danger-base)!important}:host>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;border:1px solid var(--form-control-border);color:var(--form-control-on);background:var(--form-control-background);display:block;width:100%;margin:0;height:calc(2.25rem + 2px);padding:var(--space-sm) var(--space-base);font-size:var(--text-base);font-weight:400;line-height:1.5;background-clip:padding-box;border-width:1px;border-radius:.25rem;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}:host>input::placeholder{color:var(--form-control-placeholder)}:host>input:hover,:host>input:focus,:host>input.focus{border-color:var(--form-control-hover-border)}:host>input:disabled,:host>input:disabled:hover,:host>input:disabled:focus,:host>input.disabled,:host>input.disabled:hover,:host>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host>input:after,:host>input:before{box-sizing:border-box}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host>input.show-spin-buttons[type=number]::-webkit-inner-spin-button,:host>input.show-spin-buttons[type=number]::-webkit-outer-spin-button{opacity:1;margin:0}:host>input.hide-spin-buttons[type=number]::-webkit-inner-spin-button,:host>input.hide-spin-buttons[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}:host-context(.neumorphism-aspect) :host{display:block}:host-context(.neumorphism-aspect) :host>input{border:1px solid transparent;outline:none;border-radius:10px;background:none;padding:20px 10px 20px 5px;background-image:linear-gradient(145deg,rgba(255,255,255,0),rgba(255,255,255,.2));box-shadow:5px 5px 10px #0000004d,-5px -5px 10px #ffffff14;color:var(--form-control-on);background:var(--form-control-background)}:host-context(.neumorphism-aspect) :host>input:hover,:host-context(.neumorphism-aspect) :host>input:focus,:host-context(.neumorphism-aspect) :host>input.focus{border-color:var(--form-control-hover-border)}:host-context(.neumorphism-aspect) :host>input:focus:not(:disabled){background-image:linear-gradient(145deg,rgba(255,255,255,.2),rgba(255,255,255,0));border:1px solid;border-color:var(--surface-border)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-input', providers: [{ provide: FormControlComponent, useExisting: InputComponent }], template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<input\n  [id]=\"id\"\n  [class.show-spin-buttons]=\"showSpinButtonsForNumberInput\"\n  [class.hide-spin-buttons]=\"!showSpinButtonsForNumberInput\"\n  autocomplete=\"off\"\n  #inputElement\n  [type]=\"type\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [disabled]=\"disabled\"\n  [placeholder]=\"placeholder || ''\"\n  [value]=\"value === undefined ? '' : value\"\n  (change)=\"onChange($event)\"\n  (keyup.enter)=\"onSubmit($event)\"\n/>\n", styles: [":host.validation-theme.ng-valid.ng-touched>input,:host.validation-theme.ng-valid.ng-dirty>input{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched>input,:host.validation-theme.ng-invalid.ng-dirty>input{border-color:var(--danger-base)!important}:host>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;border:1px solid var(--form-control-border);color:var(--form-control-on);background:var(--form-control-background);display:block;width:100%;margin:0;height:calc(2.25rem + 2px);padding:var(--space-sm) var(--space-base);font-size:var(--text-base);font-weight:400;line-height:1.5;background-clip:padding-box;border-width:1px;border-radius:.25rem;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}:host>input::placeholder{color:var(--form-control-placeholder)}:host>input:hover,:host>input:focus,:host>input.focus{border-color:var(--form-control-hover-border)}:host>input:disabled,:host>input:disabled:hover,:host>input:disabled:focus,:host>input.disabled,:host>input.disabled:hover,:host>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host>input:after,:host>input:before{box-sizing:border-box}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host>input.show-spin-buttons[type=number]::-webkit-inner-spin-button,:host>input.show-spin-buttons[type=number]::-webkit-outer-spin-button{opacity:1;margin:0}:host>input.hide-spin-buttons[type=number]::-webkit-inner-spin-button,:host>input.hide-spin-buttons[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}:host-context(.neumorphism-aspect) :host{display:block}:host-context(.neumorphism-aspect) :host>input{border:1px solid transparent;outline:none;border-radius:10px;background:none;padding:20px 10px 20px 5px;background-image:linear-gradient(145deg,rgba(255,255,255,0),rgba(255,255,255,.2));box-shadow:5px 5px 10px #0000004d,-5px -5px 10px #ffffff14;color:var(--form-control-on);background:var(--form-control-background)}:host-context(.neumorphism-aspect) :host>input:hover,:host-context(.neumorphism-aspect) :host>input:focus,:host-context(.neumorphism-aspect) :host>input.focus{border-color:var(--form-control-hover-border)}:host-context(.neumorphism-aspect) :host>input:focus:not(:disabled){background-image:linear-gradient(145deg,rgba(255,255,255,.2),rgba(255,255,255,0));border:1px solid;border-color:var(--surface-border)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [INPUT_CONFIG]
                }] }]; }, propDecorators: { label: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], type: [{
                type: Input
            }], showSpinButtonsForNumberInput: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], inputElement: [{
                type: ViewChild,
                args: ['inputElement', { static: false }]
            }], value: [{
                type: Input
            }], emitDistinctValueChange: [{
                type: Input
            }], changed: [{
                type: Output
            }], submitted: [{
                type: Output
            }] } });

class InputModule {
    static forRoot(cfg) {
        return {
            ngModule: InputModule,
            providers: [
                {
                    provide: INPUT_CONFIG,
                    useValue: !cfg ? DEFAULT_INPUT_CONFIG : { ...DEFAULT_INPUT_CONFIG, ...cfg },
                },
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: InputModule, declarations: [InputComponent], imports: [CommonModule, FormsModule, CoreModule], exports: [InputComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputModule, providers: [{ provide: INPUT_CONFIG, useValue: DEFAULT_INPUT_CONFIG }], imports: [CommonModule, FormsModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, CoreModule],
                    providers: [{ provide: INPUT_CONFIG, useValue: DEFAULT_INPUT_CONFIG }],
                    declarations: [InputComponent],
                    exports: [InputComponent],
                }]
        }] });

class DialogContentComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DialogContentComponent, selector: "avn-dialog-content", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{max-height:calc(100vh - calc(24px + 2 * var(--space-md)) - calc(24px + 2 * var(--space-md)));padding:var(--space-md) var(--space-md);overflow:auto;flex-grow:1}:host :host-context(.dmb-aspect){padding:20px}::ng-deep .form-control-row{display:flex}::ng-deep .form-control-row>avn-input,::ng-deep .form-control-row>avn-checkbox{flex:1 auto}::ng-deep .form-control-row>avn-input:not(:last-child),::ng-deep .form-control-row>avn-checkbox:not(:last-child){padding-right:var(--space-md)}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dialog-content', template: "<ng-content></ng-content>\n", styles: [":host{max-height:calc(100vh - calc(24px + 2 * var(--space-md)) - calc(24px + 2 * var(--space-md)));padding:var(--space-md) var(--space-md);overflow:auto;flex-grow:1}:host :host-context(.dmb-aspect){padding:20px}::ng-deep .form-control-row{display:flex}::ng-deep .form-control-row>avn-input,::ng-deep .form-control-row>avn-checkbox{flex:1 auto}::ng-deep .form-control-row>avn-input:not(:last-child),::ng-deep .form-control-row>avn-checkbox:not(:last-child){padding-right:var(--space-md)}\n"] }]
        }] });

class DialogFooterComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DialogFooterComponent, selector: "avn-dialog-footer", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{min-height:calc(24px + 2 * var(--space-md));padding:var(--space-md);overflow:hidden;display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-end;background-color:var(--dialog-footer-background);color:var(--dialog-footer-on)}:host>::ng-deep avn-button{display:block}:host>::ng-deep avn-button:not(:last-child){padding-right:10px}:host :host-context(.dmb-aspect){border-top:1px solid #1c1e22;padding:20px}:host :host-context(.dmb-aspect) ::ng-deep .avn-button-group{display:flex;justify-content:flex-end}:host :host-context(.dmb-aspect) ::ng-deep .avn-button-group avn-button{padding-left:var(--space-lg)}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dialog-footer', template: "<ng-content></ng-content>\n", styles: [":host{min-height:calc(24px + 2 * var(--space-md));padding:var(--space-md);overflow:hidden;display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-end;background-color:var(--dialog-footer-background);color:var(--dialog-footer-on)}:host>::ng-deep avn-button{display:block}:host>::ng-deep avn-button:not(:last-child){padding-right:10px}:host :host-context(.dmb-aspect){border-top:1px solid #1c1e22;padding:20px}:host :host-context(.dmb-aspect) ::ng-deep .avn-button-group{display:flex;justify-content:flex-end}:host :host-context(.dmb-aspect) ::ng-deep .avn-button-group avn-button{padding-left:var(--space-lg)}\n"] }]
        }] });

class DialogHeaderComponent {
    constructor() {
        /**
         * the icon to use. i.e tag, or any other ligature for supported fonts.
         * this should follow the format of namespace:icon name.
         * for example a font-awesome icon is fa:icon-name
         * https://fontawesome.com/icons?d=gallery
         * a material icon is action:name_of_icon ( places, social, maps )
         * https://material.io/tools/icons/?style=baseline
         */
        this.icon = 'action:close';
        /**
         * Indicates whether the close icon should be displayed or not
         */
        this.showCloseIcon = false;
        /**
         * dispatched when the header icon is clicked
         */
        this.closeClicked = new EventEmitter();
    }
    /**
     * @ignore
     */
    close() {
        this.closeClicked.emit(true);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DialogHeaderComponent, selector: "avn-dialog-header", inputs: { title: "title", template: "template", icon: "icon", showCloseIcon: "showCloseIcon" }, outputs: { closeClicked: "closeClicked" }, ngImport: i0, template: "<ng-container *ngIf=\"!!template; else defaultTitle\">\n  <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n</ng-container>\n<ng-template #defaultTitle>\n  <h5 textOverFlow>{{ title }}</h5>\n</ng-template>\n<avn-icon *ngIf=\"showCloseIcon\" [icon]=\"icon\" (click)=\"close()\"></avn-icon>\n", styles: [":host{min-height:calc(24px + 2 * var(--space-md));display:flex;flex-direction:row;justify-content:space-between;padding:var(--space-md);align-items:center;background-color:var(--dialog-header-background);color:var(--dialog-header-on)}:host>h5{display:block;margin:0}:host>avn-icon{display:block;padding:0;margin:0;cursor:pointer}:host :host-context(.dmb-aspect){border-bottom:1px solid #1c1e22;padding:15px}:host :host-context(.dmb-aspect) ::ng-deep h4{font-size:18px;margin:0}:host :host-context(.dmb-aspect) ::ng-deep avn-icon{float:right;font-size:var(--text-lg);font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: TextOverFlowDirective, selector: "[textOverFlow]" }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dialog-header', template: "<ng-container *ngIf=\"!!template; else defaultTitle\">\n  <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n</ng-container>\n<ng-template #defaultTitle>\n  <h5 textOverFlow>{{ title }}</h5>\n</ng-template>\n<avn-icon *ngIf=\"showCloseIcon\" [icon]=\"icon\" (click)=\"close()\"></avn-icon>\n", styles: [":host{min-height:calc(24px + 2 * var(--space-md));display:flex;flex-direction:row;justify-content:space-between;padding:var(--space-md);align-items:center;background-color:var(--dialog-header-background);color:var(--dialog-header-on)}:host>h5{display:block;margin:0}:host>avn-icon{display:block;padding:0;margin:0;cursor:pointer}:host :host-context(.dmb-aspect){border-bottom:1px solid #1c1e22;padding:15px}:host :host-context(.dmb-aspect) ::ng-deep h4{font-size:18px;margin:0}:host :host-context(.dmb-aspect) ::ng-deep avn-icon{float:right;font-size:var(--text-lg);font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], template: [{
                type: Input
            }], icon: [{
                type: Input
            }], showCloseIcon: [{
                type: Input
            }], closeClicked: [{
                type: Output
            }] } });

class DialogLayoutComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DialogLayoutComponent, selector: "avn-dialog-layout", ngImport: i0, template: "<ng-content select=\"avn-dialog-header\"> </ng-content>\n<ng-content class=\"avn-dialog-content\"> </ng-content>\n<ng-content select=\"avn-dialog-footer\"> </ng-content>\n", styles: [":host{display:flex;flex-direction:column;height:100%}:host-context(.dmb-aspect){width:100%;height:100%}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DialogLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dialog-layout', template: "<ng-content select=\"avn-dialog-header\"> </ng-content>\n<ng-content class=\"avn-dialog-content\"> </ng-content>\n<ng-content select=\"avn-dialog-footer\"> </ng-content>\n", styles: [":host{display:flex;flex-direction:column;height:100%}:host-context(.dmb-aspect){width:100%;height:100%}\n"] }]
        }] });

/**
 * The default animation of the modal container when it is opened
 * */
const defaultAnimationOpen = [
    style({
        opacity: 1,
        transform: 'scale(1.2)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        opacity: 1,
        transform: 'scale(1)',
    })),
];
/**
 * The default animation of the modal container when it is closed
 * */
const defaultAnimationClose = [
    style({
        opacity: 1,
        transform: 'scale(1)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        transform: 'scale(0.8)',
        opacity: 0,
    })),
];
/**
 * The default animation of the dialog container when it is opened
 * */
const dialogAnimationOpen = defaultAnimationOpen;
/**
 * The default animation of the dialog container when it is closed
 * */
const dialogAnimationClose = defaultAnimationClose;
/**
 * Animation of the drawer container when it is opened from the right side
 * */
const drawerAnimationOpenRight = [
    style({
        opacity: 1,
        transform: 'translateX(400px)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        opacity: 1,
        transform: 'translateX(0px)',
    })),
];
/**
 * Animation of the drawer container when it is closed from the right side
 * */
const drawerAnimationCloseRight = [
    style({
        opacity: 1,
        transform: 'translateX(0px)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        opacity: 0,
        transform: 'translateX(400px)',
    })),
];
/**
 * Animation of the drawer container when it is opened from the right side
 * */
const drawerAnimationOpenLeft = [
    style({
        opacity: 1,
        transform: 'translateX(-400px)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        opacity: 1,
        transform: 'translateX(0px)',
    })),
];
/**
 * Animation of the drawer container when it is closed from the right side
 * */
const drawerAnimationCloseLeft = [
    style({
        opacity: 1,
        transform: 'translateX(0px)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        opacity: 0,
        transform: 'translateX(-400px)',
    })),
];
/**
 *  Default open animation of the bottom sheet modal
 * */
const bottomSheetAnimationOpen = [
    style({
        transform: 'translateY(100%)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        transform: 'translateY(0%)',
    })),
];
/**
 *  Default close animation of the bottom sheet modal
 * */
const bottomSheetAnimationClose = [
    style({
        opacity: 1,
        transform: 'translateY(0%)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        opacity: 0,
        transform: 'translateY(100%)',
    })),
];
/**
 *  Default open animation of the sticky tasks panel
 * */
const taskPanelAnimationOpen = [
    style({
        transform: 'translateY(100%)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        transform: 'translateY(0%)',
    })),
];
/**
 *  Default close animation of the sticky tasks panel
 * */
const taskPanelAnimationClose = [
    style({
        opacity: 1,
        transform: 'translateY(0%)',
    }),
    animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
        opacity: 0,
        transform: 'translateY(100%)',
    })),
];

/** Represents the types of modal */
var ModalType;
(function (ModalType) {
    ModalType["Drawer"] = "drawer";
    ModalType["Dialog"] = "dialog";
    ModalType["BottomSheet"] = "bottom-sheet";
    ModalType["TaskPanel"] = "task-panel";
    ModalType["SlideDialog"] = "slide-dialog";
})(ModalType || (ModalType = {}));

/** Types of dialog */
var ModalDialogType;
(function (ModalDialogType) {
    ModalDialogType["Alert"] = "Alert";
    ModalDialogType["Confirm"] = "Confirm";
    ModalDialogType["ConfirmText"] = "ConfirmText";
})(ModalDialogType || (ModalDialogType = {}));
/** Represents the default configuration data of a standard dialog */
const DEFAULT_STANDARD_DIALOG_CONFIG = {
    showCloseIcon: true,
    closeOnBackdropClick: true,
};

/**
 * This service maintains a list of all opened modals and provide the ability to close them all
 * This is required because at the moment multiple instances of the modal service are being created in
 * each lazy module. If the modal service is created as a singleton and we only have
 * one instance for the whole application (root scope + lazy modules) then the
 * ComponentResolverFactory injected in the modal service will be the ComponentResolverFactory from
 * the root scope, and therefore it wont be able to find components defined in the entryComponents
 * of lazy modules. So we created this service in the root scope to which we pass references of the
 * modals once they have been created.
 *
 * See. https://github.com/angular/angular/issues/14324 for more details
 *
 * Note: This may be fixed with Ivy with the removal of entryComponents
 * *
 */
class ModalManagementService {
    constructor() {
        this._openedModals = [];
    }
    /** Adds the modal reference to the list of currently opened modals **/
    markModalAsOpened(modalRef) {
        this._openedModals.push(modalRef);
    }
    /** Removes the modal reference from the list of currently opened modals **/
    markModalAsClosed(modalRef) {
        this._openedModals = this._openedModals.filter((ref) => modalRef !== ref);
    }
    /** Closes all opened modals **/
    closeAllOpenedModals() {
        this._openedModals.forEach((ref) => {
            ref.close();
        });
        this._openedModals = [];
    }
    /** Returns an array of all the opened modals **/
    get openedModals() {
        return this._openedModals;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalManagementService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalManagementService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalManagementService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

let uniqueId = 0;
/**
 * Reference to a modal opened via the modal service.
 */
class ModalRef {
    constructor(overlayRef, container, id = `avn-modal-${uniqueId++}`) {
        this.overlayRef = overlayRef;
        this.container = container;
        this.id = id;
        /**
         * Emits when the modal container is being closed (before close animation)
         * - when the user hits ESC key
         * - when the user clicks on the backdrop
         * - when the user clicks on the Close button / icon in the modal
         **/
        this.closed = this.container.closed;
        /**
         * Emits when the modal container is closed (after close animation)
         **/
        this.afterClosed = this.container.afterClosed;
    }
    /** Triggers the close animation and closes the modal */
    close() {
        this.container.closeModal();
    }
}

/**
 * Injection token for use in the modal container and custom modal that allows to inject the modal
 * config.
 */
const MODAL_CONFIG = new InjectionToken('MODAL_CONFIG');
/**
 * Injection token for use in the modal container that specifies the type of modal
 * config.
 */
const MODAL_TYPE = new InjectionToken('MODAL_TYPE');
/**
 * Injection token for use in the modal container and custom modal that allows to inject the overlay
 * ref.
 */
const OVERLAY_REF = new InjectionToken('OVERLAY_REF');
/**
 * Injection token for use in the modal container that represents the open animation
 */
const MODAL_OPEN_ANIMATION = new InjectionToken('MODAL_OPEN_ANIMATION');
/**
 * Injection token for use in the modal container that represents the close animation
 */
const MODAL_CLOSE_ANIMATION = new InjectionToken('MODAL_CLOSE_ANIMATION');
/**
 * Injection token to inject modal data.
 */
const MODAL_DATA = new InjectionToken('MODAL_DATA');

// TODO add documentation
class StandardDialogComponent {
    constructor(modalRef, dialogConfig, formBuilder) {
        this.modalRef = modalRef;
        this.dialogConfig = dialogConfig;
        this.formBuilder = formBuilder;
        this.accepted = new EventEmitter();
        this.isConfirm = dialogConfig.data.type === ModalDialogType.Confirm;
        this.isConfirmText = dialogConfig.data.type === ModalDialogType.ConfirmText;
        this.isAlert = dialogConfig.data.type === ModalDialogType.Alert;
        if (!this.isAlert && this.dialogConfig.data.theme) {
            this.acceptButtonTheme = this.dialogConfig.data.theme;
        }
        if (this.isAlert && this.dialogConfig.data.theme) {
            this.closeButtonTheme = this.dialogConfig.data.theme;
        }
    }
    ngOnInit() {
        if (this.isConfirmText) {
            this.confirmForm = this.formBuilder.group({
                confirmText: ['', [Validators.required, Validators.pattern(`^${this.dialogConfig.data.confirmTextValue || ''}$`)]],
            });
        }
    }
    canClose() {
        return true;
    }
    onAccept() {
        if (this.isConfirmText && this.confirmInput.value !== this.dialogConfig.data.confirmTextValue) {
            return;
        }
        this.modalRef.close();
        this.accepted.emit(true);
    }
    onClose() {
        this.modalRef.close();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StandardDialogComponent, deps: [{ token: ModalRef }, { token: MODAL_CONFIG }, { token: i1$3.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: StandardDialogComponent, selector: "avn-standard-dialog", viewQueries: [{ propertyName: "confirmInput", first: true, predicate: InputComponent, descendants: true }], ngImport: i0, template: "<avn-dialog-layout [ngClass]=\"'dialog-' + dialogConfig.data.type.toLowerCase()\">\n  <avn-dialog-header\n      [showCloseIcon]=\"dialogConfig.showCloseIcon\"\n      [title]=\"dialogConfig.data.title\"\n      [template]=\"dialogConfig.data.titleTemplate\"\n      (closeClicked)=\"onClose()\">\n  </avn-dialog-header>\n\n  <avn-dialog-content avnScroll>\n    <!-- Display content as plain message -->\n    <span class=\"message\">{{ dialogConfig.data.message }}</span>\n\n    <!-- Or display content as template -->\n    <ng-container *ngIf=\"dialogConfig.data.messageTemplate\">\n      <ng-container *ngTemplateOutlet=\"dialogConfig.data.messageTemplate; context: dialogConfig.data.messageTemplateContext\"></ng-container>\n    </ng-container>\n\n    <!-- For Confirm text type dialog only -->\n    <form *ngIf=\"isConfirmText\" [formGroup]=\"confirmForm\" class=\"confirm-form\">\n      <avn-form-field>\n        <avn-input type=\"text\" [avnTheme]=\"confirmInputTheme\" formControlName=\"confirmText\"></avn-input>\n        <avn-form-field-hint *ngIf=\"!!dialogConfig.data.confirmTextLabel\" [message]=\"dialogConfig.data.confirmTextLabel\"></avn-form-field-hint>\n        <avn-form-field-error key=\"required\" [message]=\"this.dialogConfig.data.confirmInputHelpTextError\"></avn-form-field-error>\n        <avn-form-field-error key=\"pattern\" [message]=\"this.dialogConfig.data.confirmInputHelpTextError\"></avn-form-field-error>\n      </avn-form-field>\n    </form>\n  </avn-dialog-content>\n\n  <avn-dialog-footer>\n    <avn-button class=\"btn-close\" (click)=\"onClose()\" [label]=\"dialogConfig.data.closeActionLabel\" [avnTheme]=\"closeButtonTheme\"></avn-button>\n    <avn-button\n      class=\"btn-accept\"\n      *ngIf=\"!isAlert && dialogConfig.data.acceptActionLabel\"\n      (click)=\"onAccept()\"\n      [label]=\"dialogConfig.data.acceptActionLabel\"\n      [avnTheme]=\"acceptButtonTheme\"\n      [disabled]=\"!!confirmForm && confirmForm.invalid\"\n    ></avn-button>\n  </avn-dialog-footer>\n</avn-dialog-layout>\n", styles: [":host{display:block;width:100%;height:100%}:host .confirm-form{margin-top:var(--space-md)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: InputComponent, selector: "avn-input", inputs: ["label", "debounceTime", "type", "showSpinButtonsForNumberInput", "min", "max", "placeholder", "value", "emitDistinctValueChange"], outputs: ["changed", "submitted"] }, { kind: "component", type: FormFieldComponent, selector: "avn-form-field", inputs: ["enableValidTheme", "enableInvalidTheme", "disabled"] }, { kind: "component", type: FormFieldErrorComponent, selector: "avn-form-field-error", inputs: ["key", "message", "fixedHeight"] }, { kind: "component", type: FormFieldHintComponent, selector: "avn-form-field-hint", inputs: ["message", "disabled"] }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "directive", type: i1$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: DialogLayoutComponent, selector: "avn-dialog-layout" }, { kind: "component", type: DialogHeaderComponent, selector: "avn-dialog-header", inputs: ["title", "template", "icon", "showCloseIcon"], outputs: ["closeClicked"] }, { kind: "component", type: DialogFooterComponent, selector: "avn-dialog-footer" }, { kind: "component", type: DialogContentComponent, selector: "avn-dialog-content" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StandardDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-standard-dialog', template: "<avn-dialog-layout [ngClass]=\"'dialog-' + dialogConfig.data.type.toLowerCase()\">\n  <avn-dialog-header\n      [showCloseIcon]=\"dialogConfig.showCloseIcon\"\n      [title]=\"dialogConfig.data.title\"\n      [template]=\"dialogConfig.data.titleTemplate\"\n      (closeClicked)=\"onClose()\">\n  </avn-dialog-header>\n\n  <avn-dialog-content avnScroll>\n    <!-- Display content as plain message -->\n    <span class=\"message\">{{ dialogConfig.data.message }}</span>\n\n    <!-- Or display content as template -->\n    <ng-container *ngIf=\"dialogConfig.data.messageTemplate\">\n      <ng-container *ngTemplateOutlet=\"dialogConfig.data.messageTemplate; context: dialogConfig.data.messageTemplateContext\"></ng-container>\n    </ng-container>\n\n    <!-- For Confirm text type dialog only -->\n    <form *ngIf=\"isConfirmText\" [formGroup]=\"confirmForm\" class=\"confirm-form\">\n      <avn-form-field>\n        <avn-input type=\"text\" [avnTheme]=\"confirmInputTheme\" formControlName=\"confirmText\"></avn-input>\n        <avn-form-field-hint *ngIf=\"!!dialogConfig.data.confirmTextLabel\" [message]=\"dialogConfig.data.confirmTextLabel\"></avn-form-field-hint>\n        <avn-form-field-error key=\"required\" [message]=\"this.dialogConfig.data.confirmInputHelpTextError\"></avn-form-field-error>\n        <avn-form-field-error key=\"pattern\" [message]=\"this.dialogConfig.data.confirmInputHelpTextError\"></avn-form-field-error>\n      </avn-form-field>\n    </form>\n  </avn-dialog-content>\n\n  <avn-dialog-footer>\n    <avn-button class=\"btn-close\" (click)=\"onClose()\" [label]=\"dialogConfig.data.closeActionLabel\" [avnTheme]=\"closeButtonTheme\"></avn-button>\n    <avn-button\n      class=\"btn-accept\"\n      *ngIf=\"!isAlert && dialogConfig.data.acceptActionLabel\"\n      (click)=\"onAccept()\"\n      [label]=\"dialogConfig.data.acceptActionLabel\"\n      [avnTheme]=\"acceptButtonTheme\"\n      [disabled]=\"!!confirmForm && confirmForm.invalid\"\n    ></avn-button>\n  </avn-dialog-footer>\n</avn-dialog-layout>\n", styles: [":host{display:block;width:100%;height:100%}:host .confirm-form{margin-top:var(--space-md)}\n"] }]
        }], ctorParameters: function () { return [{ type: ModalRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONFIG]
                }] }, { type: i1$3.UntypedFormBuilder }]; }, propDecorators: { confirmInput: [{
                type: ViewChild,
                args: [InputComponent, { static: false }]
            }] } });

/**
 * This component is a container for the actual component to display in the modal.
 * It is mainly used to animate the modal and provide global styling of all modals.
 */
class ModalContainerComponent {
    constructor(_elementRef, animationBuilder, overlayRef, modalConfig, modalType, modalOpenAnimation, modalCloseAnimation, renderer) {
        this._elementRef = _elementRef;
        this.animationBuilder = animationBuilder;
        this.overlayRef = overlayRef;
        this.modalConfig = modalConfig;
        this.modalOpenAnimation = modalOpenAnimation;
        this.modalCloseAnimation = modalCloseAnimation;
        /** Emits when the modal container is being closed (before close animation) */
        this.closed = new EventEmitter();
        // emit after the modal close animation is finished and the modal has disappeared
        this.afterClosed = overlayRef.detachments().pipe(first());
        // add a class of the modal type
        renderer.addClass(this._elementRef.nativeElement, modalType);
    }
    /**
     * Attaches a component portal to a portal outlet.
     *
     * @param portal Component portal.
     * @returns A ComponentRef for the component attached to the container.
     */
    attachComponentPortal(portal) {
        const componentRef = this.portalOutlet.attachComponentPortal(portal);
        // close the modal on backdrop click (if configured) or on pressing ESC key
        const closeOnBackdropClick$ = this.overlayRef.backdropClick().pipe(filter(() => this.modalConfig.closeOnBackdropClick));
        const closeOnEscKeypress$ = this.overlayRef.keydownEvents().pipe(filter((event) => event.keyCode === ESCAPE));
        // only close if allowed by the modal component
        merge(closeOnBackdropClick$, closeOnEscKeypress$)
            .pipe(filter(() => componentRef.instance.canClose()))
            .subscribe(() => {
            // close the modal
            this.closeModal();
        });
        // play the animation now that the component has been attached
        this.openModal();
        return componentRef;
    }
    /** Open the modal by starting the opening animation */
    openModal() {
        if (this._player) {
            this._player.destroy();
        }
        // play the animation
        const factory = this.animationBuilder.build(this.modalOpenAnimation);
        this._player = factory.create(this._elementRef.nativeElement);
        this._player.play();
        this._player.onDone(() => {
            // close overlay when container close animation finishes
            this._opened = true;
        });
    }
    /** Closes the modal by starting the closing animation */
    closeModal() {
        this.closed.emit();
        // only play the close animation if the open animation was completed
        if (!this._opened) {
            this._closeOverlay();
            return;
        }
        // play the animation
        const factory = this.animationBuilder.build(this.modalCloseAnimation);
        this._player = factory.create(this._elementRef.nativeElement);
        // bind to animation event and emit at the differents steps of the animation (reuse the
        // animation event interface from angular)
        this._player.onStart(() => {
            // opening a modal while the closing animation from the previous opened modal has not
            // completed causes positioning issues so instead of detaching the backdrop before the end
            // animation starts, just make it transparent until the animation is completed. This way its
            // prevents the user to click another element
            this.overlayRef.backdropElement?.classList.remove('cdk-overlay-dark-backdrop');
        });
        // close overlay when container close animation finishesgi
        this._player.onDone(() => {
            this._closeOverlay();
        });
        this._player.play();
    }
    /** Closes the overlay and removes the backdrop */
    _closeOverlay() {
        this.overlayRef.dispose();
        this.overlayRef.detachBackdrop();
    }
    /** @ignore */
    ngOnDestroy() {
        if (this._player) {
            this._player.destroy();
        }
        this.closed.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalContainerComponent, deps: [{ token: i0.ElementRef }, { token: i1$1.AnimationBuilder }, { token: OVERLAY_REF }, { token: MODAL_CONFIG }, { token: MODAL_TYPE }, { token: MODAL_OPEN_ANIMATION }, { token: MODAL_CLOSE_ANIMATION }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ModalContainerComponent, selector: "avn-modal-container", viewQueries: [{ propertyName: "portalOutlet", first: true, predicate: CdkPortalOutlet, descendants: true, static: true }], ngImport: i0, template: "<ng-template cdkPortalOutlet></ng-template>\n", styles: [":host{width:100%;color:var(--modal-on);background-color:var(--modal-background)}:host.dialog{border-radius:var(--dialog-border-radius);border:1px solid var(--modal-border);overflow:hidden}:host.bottom-sheet{border-top-left-radius:var(--dialog-border-radius);border-top-right-radius:var(--dialog-border-radius);border-top:1px solid var(--modal-border);border-left:1px solid var(--modal-border);border-right:1px solid var(--modal-border);overflow:hidden}:host.task-panel{border-top-left-radius:var(--dialog-border-radius);border-top-right-radius:var(--dialog-border-radius);border-top:1px solid var(--modal-border);border-left:1px solid var(--modal-border);border-right:1px solid var(--modal-border);overflow:hidden;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host.slide-dialog{background-color:var(--slide-dialog-background);color:var(--slide-dialog-on);border-radius:var(--dialog-border-radius);border:1px solid var(--modal-border);overflow:hidden}:host :host-context(.dmb-aspect).dialog,:host :host-context(.dmb-aspect).drawer{box-shadow:0 5px 15px #00000080}:host :host-context(.dmb-aspect).slide-dialog{border-width:0}\n"], dependencies: [{ kind: "directive", type: i2$1.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-modal-container', template: "<ng-template cdkPortalOutlet></ng-template>\n", styles: [":host{width:100%;color:var(--modal-on);background-color:var(--modal-background)}:host.dialog{border-radius:var(--dialog-border-radius);border:1px solid var(--modal-border);overflow:hidden}:host.bottom-sheet{border-top-left-radius:var(--dialog-border-radius);border-top-right-radius:var(--dialog-border-radius);border-top:1px solid var(--modal-border);border-left:1px solid var(--modal-border);border-right:1px solid var(--modal-border);overflow:hidden}:host.task-panel{border-top-left-radius:var(--dialog-border-radius);border-top-right-radius:var(--dialog-border-radius);border-top:1px solid var(--modal-border);border-left:1px solid var(--modal-border);border-right:1px solid var(--modal-border);overflow:hidden;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host.slide-dialog{background-color:var(--slide-dialog-background);color:var(--slide-dialog-on);border-radius:var(--dialog-border-radius);border:1px solid var(--modal-border);overflow:hidden}:host :host-context(.dmb-aspect).dialog,:host :host-context(.dmb-aspect).drawer{box-shadow:0 5px 15px #00000080}:host :host-context(.dmb-aspect).slide-dialog{border-width:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.AnimationBuilder }, { type: i1$4.OverlayRef, decorators: [{
                    type: Inject,
                    args: [OVERLAY_REF]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONFIG]
                }] }, { type: ModalType, decorators: [{
                    type: Inject,
                    args: [MODAL_TYPE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_OPEN_ANIMATION]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CLOSE_ANIMATION]
                }] }, { type: i0.Renderer2 }]; }, propDecorators: { portalOutlet: [{
                type: ViewChild,
                args: [CdkPortalOutlet, { static: true }]
            }] } });

/**
 * Creates an new modal container component and attaches it to the specified overlay
 * **/
const attachModalContainer = (overlayRef, modalConfig, openAnimation, closeAnimation, modalType, parentInjector) => {
    const injector = Injector.create({
        providers: [
            { provide: MODAL_CONFIG, useValue: modalConfig },
            { provide: OVERLAY_REF, useValue: overlayRef },
            { provide: MODAL_OPEN_ANIMATION, useValue: openAnimation },
            { provide: MODAL_CLOSE_ANIMATION, useValue: closeAnimation },
            { provide: MODAL_TYPE, useValue: modalType },
        ],
        parent: parentInjector,
    });
    const containerPortal = new ComponentPortal(ModalContainerComponent, null, injector);
    const containerRef = overlayRef.attach(containerPortal);
    return containerRef.instance;
};
/**
 * Creates an new modal component and attaches it to the specified modal container
 * **/
const attachModalComponent = (component, modalContainer, modalConfig, modalRef, parentInjector, extraProviders = []) => {
    const injector = Injector.create({
        providers: [{ provide: ModalRef, useValue: modalRef }, { provide: MODAL_CONFIG, useValue: modalConfig }, ...extraProviders],
        parent: parentInjector,
    });
    const containerPortal = new ComponentPortal(component, null, injector);
    return modalContainer.attachComponentPortal(containerPortal);
};
/**
 * Returns the default overlay config for a dialog
 */
const getDefaultDialogOverlayConfig = (overlay, overrideConfig, positionStrategy) => {
    positionStrategy = positionStrategy || overlay.position().global().centerHorizontally().centerVertically();
    return new OverlayConfig({
        hasBackdrop: true,
        panelClass: 'modal-dialog-overlay-panel',
        scrollStrategy: overlay.scrollStrategies.block(),
        positionStrategy,
        width: '400px',
        disposeOnNavigation: true,
        ...(overrideConfig || {}),
    });
};
/**
 * Returns the default overlay config for a drawer
 */
const getDefaultDrawerOverlayConfig = (overlay, overrideConfig, positionStrategy) => {
    return new OverlayConfig({
        hasBackdrop: true,
        panelClass: 'modal-drawer-overlay-panel',
        scrollStrategy: overlay.scrollStrategies.block(),
        positionStrategy,
        height: '100vh',
        width: '450px',
        disposeOnNavigation: true,
        ...(overrideConfig || {}),
    });
};
/**
 * Returns the default overlay config for a bottom sheet
 */
const getDefaultBottomSheetOverlayConfig = (overlay, overrideConfig) => {
    const positionStrategy = overlay.position().global().centerHorizontally().bottom('0');
    return new OverlayConfig({
        hasBackdrop: true,
        panelClass: 'modal-bottom-sheet-overlay-panel',
        scrollStrategy: overlay.scrollStrategies.block(),
        positionStrategy,
        width: '100%',
        maxWidth: '100%',
        disposeOnNavigation: true,
        ...(overrideConfig || {}),
    });
};
/**
 * Returns the default overlay config for the task panel modal
 */
const getDefaultTaskPanelOverlayConfig = (overlay, toastSettings, taskPanelSettings) => {
    let positionStrategy = overlay.position().global();
    if (toastSettings.alignment === ToastAlignmentType.BottomLeft) {
        positionStrategy = positionStrategy.bottom().left(`${toastSettings.xOffset}px`);
    }
    else if (toastSettings.alignment === ToastAlignmentType.BottomRight) {
        positionStrategy = positionStrategy.bottom().right(`${toastSettings.xOffset}px`);
    }
    else if (toastSettings.alignment === ToastAlignmentType.TopLeft) {
        positionStrategy = positionStrategy.top().left(`${toastSettings.xOffset}px`);
    }
    else if (toastSettings.alignment === ToastAlignmentType.TopRight) {
        positionStrategy = positionStrategy.top().right(`${toastSettings.xOffset}px`);
    }
    return new OverlayConfig({
        hasBackdrop: false,
        panelClass: 'task-panel-overlay-panel',
        positionStrategy,
        width: taskPanelSettings.width,
        maxHeight: '30vh',
        disposeOnNavigation: false,
    });
};
/**
 * Returns the default overlay config for the task panel modal
 */
const addOverlayPanelClass = (overlayConfig, className) => {
    if (!overlayConfig) {
        return {
            panelClass: className,
        };
    }
    if (!overlayConfig.panelClass) {
        return {
            ...overlayConfig,
            panelClass: className,
        };
    }
    if (typeof overlayConfig.panelClass === 'string') {
        return {
            ...overlayConfig,
            panelClass: [overlayConfig.panelClass, className],
        };
    }
    return {
        ...overlayConfig,
        panelClass: [...overlayConfig.panelClass, className],
    };
};

/** Animations used by the stepper component. */
const avnStepperAnimations = {
    /** Animation that transitions the step along the X axis in a horizontal stepper. */
    horizontalStepTransition: trigger('horizontalStepTransition', [
        state('previous', style({ transform: 'translate3d(-100%, 0, 0)', visibility: 'hidden' })),
        state('current', style({ transform: 'none', visibility: 'visible' })),
        state('next', style({ transform: 'translate3d(100%, 0, 0)', visibility: 'hidden' })),
        transition('* => *', animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')),
    ]),
    /** Animation that transitions the step along the Y axis in a vertical stepper. */
    verticalStepTransition: trigger('verticalStepTransition', [
        state('previous', style({ height: '0px', visibility: 'hidden' })),
        state('next', style({ height: '0px', visibility: 'hidden' })),
        state('current', style({ height: '*', visibility: 'visible' })),
        transition('* <=> current', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
};

// workaround for https://github.com/angular/material2/issues/12760
const _CdkStepLabel = CdkStepLabel;
class StepperStepLabelDirective extends _CdkStepLabel {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperStepLabelDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: StepperStepLabelDirective, selector: "[avnStepLabel]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperStepLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnStepLabel]',
                }]
        }] });

class StepperStepHeaderComponent extends CdkStepHeader {
    /** @ignore **/
    constructor(elementRef, renderer) {
        super(elementRef);
        this.elementRef = elementRef;
        this.renderer = renderer;
        /**
         * Specifies the type of header:
         * - icon: show a custom icon (defined by headerIcon)
         * - number: use sequential number for each step
         * */
        this.headerType = 'number';
        this.componentDestroyed$ = new Subject();
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** Returns string label of given step if it is a text label. */
    getStringLabel() {
        return this.label instanceof StepperStepLabelDirective ? null : this.label;
    }
    /** Returns StepperStepLabelDirective if the label of given step is a template label. */
    getTemplateLabel() {
        return this.label instanceof StepperStepLabelDirective ? this.label : null;
    }
    /** @ignore added to make the component a FocusableOption **/
    focus() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperStepHeaderComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: StepperStepHeaderComponent, selector: "avn-step-header", inputs: { linear: "linear", state: "state", label: "label", iconName: "iconName", index: "index", selected: "selected", completed: "completed", active: "active", optional: "optional", headerType: "headerType", headerIcon: "headerIcon" }, host: { attributes: { "role": "tab" } }, viewQueries: [{ propertyName: "indicatorElement", first: true, predicate: ["indicator"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"avn-step-header-indicator\" #indicator [class.selected]=\"selected\" [class.number]=\"headerType === 'number'\" [ngSwitch]=\"headerType\">\n  <ng-container *ngSwitchCase=\"'number'\">\n    <span class=\"avn-step-icon-content\">\n      {{ index + 1 }}\n    </span>\n  </ng-container>\n\n  <ng-container *ngSwitchCase=\"'icon'\">\n    <avn-icon [icon]=\"headerIcon\" [class.selected]=\"selected\" class=\"avn-step-icon-content\"></avn-icon>\n  </ng-container>\n</div>\n<div class=\"avn-step-label\" [attr.aria-selected]=\"selected\">\n  <!-- If there is a label template, use it. -->\n  <ng-container *ngIf=\"getTemplateLabel()\" [ngTemplateOutlet]=\"getTemplateLabel()!.template\"> </ng-container>\n  <!-- It there is no label template, fall back to the text label. -->\n  <div class=\"avn-step-text-label\" *ngIf=\"getStringLabel()\">{{ label }}</div>\n</div>\n", styles: [":host-context(.avn-horizontal-stepper-header){display:flex;height:72px;overflow:hidden;align-items:center;padding:0}:host-context(.avn-horizontal-stepper-header) .avn-step-header-indicator{margin-right:8px;flex:none}:host-context(.avn-vertical-stepper-header){display:flex;align-items:center;padding:var(--space-lg) 0px;max-height:24px}:host-context(.avn-vertical-stepper-header) .avn-step-header-indicator{margin-right:12px}:host{overflow:hidden;outline:none;cursor:pointer;position:relative;box-sizing:content-box;-webkit-tap-highlight-color:transparent}:host .avn-step-header-indicator{border-radius:50%;height:24px;width:24px;flex-shrink:0;position:relative}:host .avn-step-header-indicator.number:not(.selected){background-color:var(--stepper-number-indicator-background);color:var(--stepper-number-indicator-on)}:host .avn-step-header-indicator .avn-step-icon-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host .avn-step-label{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:50px;vertical-align:middle}:host .avn-step-text-label{text-overflow:ellipsis;overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperStepHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-step-header', host: {
                        role: 'tab',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"avn-step-header-indicator\" #indicator [class.selected]=\"selected\" [class.number]=\"headerType === 'number'\" [ngSwitch]=\"headerType\">\n  <ng-container *ngSwitchCase=\"'number'\">\n    <span class=\"avn-step-icon-content\">\n      {{ index + 1 }}\n    </span>\n  </ng-container>\n\n  <ng-container *ngSwitchCase=\"'icon'\">\n    <avn-icon [icon]=\"headerIcon\" [class.selected]=\"selected\" class=\"avn-step-icon-content\"></avn-icon>\n  </ng-container>\n</div>\n<div class=\"avn-step-label\" [attr.aria-selected]=\"selected\">\n  <!-- If there is a label template, use it. -->\n  <ng-container *ngIf=\"getTemplateLabel()\" [ngTemplateOutlet]=\"getTemplateLabel()!.template\"> </ng-container>\n  <!-- It there is no label template, fall back to the text label. -->\n  <div class=\"avn-step-text-label\" *ngIf=\"getStringLabel()\">{{ label }}</div>\n</div>\n", styles: [":host-context(.avn-horizontal-stepper-header){display:flex;height:72px;overflow:hidden;align-items:center;padding:0}:host-context(.avn-horizontal-stepper-header) .avn-step-header-indicator{margin-right:8px;flex:none}:host-context(.avn-vertical-stepper-header){display:flex;align-items:center;padding:var(--space-lg) 0px;max-height:24px}:host-context(.avn-vertical-stepper-header) .avn-step-header-indicator{margin-right:12px}:host{overflow:hidden;outline:none;cursor:pointer;position:relative;box-sizing:content-box;-webkit-tap-highlight-color:transparent}:host .avn-step-header-indicator{border-radius:50%;height:24px;width:24px;flex-shrink:0;position:relative}:host .avn-step-header-indicator.number:not(.selected){background-color:var(--stepper-number-indicator-background);color:var(--stepper-number-indicator-on)}:host .avn-step-header-indicator .avn-step-icon-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host .avn-step-label{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:50px;vertical-align:middle}:host .avn-step-text-label{text-overflow:ellipsis;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { indicatorElement: [{
                type: ViewChild,
                args: ['indicator', { static: false }]
            }], linear: [{
                type: Input
            }], state: [{
                type: Input
            }], label: [{
                type: Input
            }], iconName: [{
                type: Input
            }], index: [{
                type: Input
            }], selected: [{
                type: Input
            }], completed: [{
                type: Input
            }], active: [{
                type: Input
            }], optional: [{
                type: Input
            }], headerType: [{
                type: Input
            }], headerIcon: [{
                type: Input
            }] } });

// The stepper and step components are declared in the same file to avoid circular reference
// warnings
class StepperComponent extends CdkStepper {
    /** The index of the selected step */
    get selectedIndex() {
        return super.selectedIndex;
    }
    set selectedIndex(val) {
        super.selectedIndex = val;
    }
    /**
     * TODO the 2 inputs above are already defined in CdkStepper, but we redefine them here because when compiling with Ivy in gui-ng,
     * TODO it reports that the input do not exist...It does work for other inputs like selectedItem tho...
     */
    /** The mode of the stepper, linear ensures steps are completed one after the other */
    get linear() {
        return super.linear;
    }
    set linear(val) {
        super.linear = val;
    }
    /** The selected step of the stepper */
    get selected() {
        return super.selected;
    }
    set selected(val) {
        super.selected = val;
    }
    constructor(focusMonitor, changeDetectorRef, stepperElementRef) {
        super(undefined, changeDetectorRef, stepperElementRef);
        this.focusMonitor = focusMonitor;
        this.stepperElementRef = stepperElementRef;
        /** Whether to display the stepper header or not */
        this.showHeader = true;
        /** Stepper was completed */
        this.stepperCompleted = new EventEmitter();
        /** The step was changed in the stepper */
        this.stepChanged = new EventEmitter();
        /** Stepper was cancelled/reset */
        this.stepperCancelled = new EventEmitter();
        // monitor the focus on the stepper for the elapsed time
        focusMonitor.monitor(stepperElementRef.nativeElement, true).subscribe(() => this.focus());
    }
    /** @ignore */
    ngOnInit() {
        // emit event each time the step selection changes
        this.selectionChange.pipe(takeUntil(this._destroyed)).subscribe((event) => {
            const elapsedTimeMs = Math.floor(Date.now()) - event.previouslySelectedStep.startTimeTs;
            this.stepChanged.emit({
                selectedStepIndex: event.selectedIndex,
                previouslySelectedStepIndex: event.previouslySelectedIndex,
                selectedStep: event.selectedStep,
                previouslySelectedStep: event.previouslySelectedStep,
                timeToCompleteMs: elapsedTimeMs,
            });
            // set the start time for the selected state
            event.selectedStep.resetStartTime();
            // clear the start time for the previous state
            event.previouslySelectedStep.resetStartTime(true);
        });
    }
    /** @ignore */
    ngOnChanges({ orientation }) {
        if (orientation && orientation.currentValue) {
            this.orientation = orientation.currentValue;
        }
    }
    /** @ignore */
    ngAfterContentInit() {
        super.ngAfterContentInit();
        // Mark the component for change detection whenever the content children query changes
        this._steps.changes.pipe(takeUntil(this._destroyed)).subscribe(() => this._stateChanged());
    }
    /**
     * When the stepper is cancelled / reset
     * overrides the cdk reset method
     */
    reset() {
        const currentStep = this.selected;
        const stepsNotCompletedCount = this._steps.length - this.selectedIndex;
        const stepsCompletedCount = this._steps.length - stepsNotCompletedCount;
        const elapsedTimeMs = Math.floor(Date.now()) - this.startTimeTs;
        this.stepperCancelled.emit({
            stepsCompletedCount,
            stepsNotCompletedCount,
            cancelledStep: currentStep,
            elapsedTimeMs,
        });
        // reset all steps
        this._steps.forEach((step) => step.resetStep());
        // reset the stepper
        super.reset();
        // reset the time start of the stepper
        this.resetStartTime(true);
    }
    /**
     * Reset the start time of the stepper
     *
     * @param clearTime Specifies whether the start time should be cleared rather than set to the
     *     current time
     */
    resetStartTime(clearTime) {
        this.startTimeTs = clearTime ? undefined : Math.floor(Date.now());
        // also reset each step
        this._steps.forEach((step) => step.resetStartTime(true));
    }
    /**
     * When the stepper is focused
     */
    focus() {
        // set the start time if not set yet
        if (!this.startTimeTs) {
            this.resetStartTime();
            // also set the start time of the selected step
            this.selected.startTimeTs = this.startTimeTs;
        }
    }
    /**
     * When the stepper is completed
     */
    complete() {
        // complete the current step
        const completionDateTs = this.selected.resetStartTime(true);
        // total completion time of the stepper
        const elapsedTimeMs = completionDateTs - this.startTimeTs;
        // completion time of each step
        const stepCompletionTimeMs = {};
        this._steps.forEach((step, i) => (stepCompletionTimeMs[i] = step.elapsedTimeMs));
        // reset the time start
        this.resetStartTime(true);
        // emit the completed event
        this.stepperCompleted.emit({
            completionTimeMs: elapsedTimeMs,
            stepCompletionTimeMs,
        });
    }
    /** @ignore **/
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.stepperElementRef.nativeElement);
        this.stepperCompleted.complete();
        this.stepperCancelled.complete();
        this.stepChanged.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperComponent, deps: [{ token: i1$5.FocusMonitor }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: StepperComponent, selector: "avn-stepper", inputs: { showHeader: "showHeader", selectedIndex: "selectedIndex", linear: "linear", selected: "selected" }, outputs: { stepperCompleted: "stepperCompleted", stepChanged: "stepChanged", stepperCancelled: "stepperCancelled" }, queries: [{ propertyName: "_steps", predicate: i0.forwardRef(function () { return StepperStepComponent; }), descendants: true }], viewQueries: [{ propertyName: "_stepHeader", predicate: StepperStepHeaderComponent, descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<ng-template [ngIf]=\"orientation === 'horizontal'\" [ngIfElse]=\"verticalStepper\">\n  <div class=\"avn-horizontal-stepper-header-container\" *ngIf=\"showHeader\">\n    <ng-container *ngFor=\"let step of _steps; let i = index; let isLast = last\">\n      <avn-step-header\n        class=\"avn-horizontal-stepper-header\"\n        [headerType]=\"step.headerType\"\n        [headerIcon]=\"step.headerIcon\"\n        (click)=\"step.select()\"\n        (keydown)=\"_onKeydown($event)\"\n        [tabIndex]=\"_getFocusIndex() === i ? 0 : -1\"\n        [id]=\"_getStepLabelId(i)\"\n        [index]=\"i\"\n        [state]=\"_getIndicatorType(i)\"\n        [label]=\"step.stepLabel || step.label\"\n        [selected]=\"selectedIndex === i\"\n        [completed]=\"selectedIndex > i\"\n        [active]=\"step.completed || selectedIndex === i || !linear\"\n        [optional]=\"step.optional\"\n        [linear]=\"step._stepper.linear\"\n      >\n      </avn-step-header>\n      <div *ngIf=\"!isLast\" class=\"avn-stepper-horizontal-line\"></div>\n    </ng-container>\n  </div>\n  <div class=\"avn-horizontal-content-container\">\n    <div\n      *ngFor=\"let step of _steps; let i = index\"\n      class=\"avn-horizontal-stepper-content\"\n      role=\"tabpanel\"\n      [@horizontalStepTransition]=\"_getAnimationDirection(i)\"\n      [id]=\"_getStepContentId(i)\"\n      [attr.aria-labelledby]=\"_getStepLabelId(i)\"\n      [attr.aria-expanded]=\"selectedIndex === i\"\n    >\n      <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #verticalStepper>\n  <div class=\"avn-vertical-step\" *ngFor=\"let step of _steps; let i = index; let isLast = last\">\n    <avn-step-header\n      *ngIf=\"showHeader\"\n      class=\"avn-vertical-stepper-header\"\n      [headerType]=\"step.headerType\"\n      [headerIcon]=\"step.headerIcon\"\n      (click)=\"step.select()\"\n      (keydown)=\"_onKeydown($event)\"\n      [tabIndex]=\"_getFocusIndex() === i ? 0 : -1\"\n      [id]=\"_getStepLabelId(i)\"\n      [index]=\"i\"\n      [state]=\"_getIndicatorType(i)\"\n      [label]=\"step.stepLabel || step.label\"\n      [selected]=\"selectedIndex === i\"\n      [completed]=\"selectedIndex > i\"\n      [active]=\"step.completed || selectedIndex === i || !linear\"\n      [optional]=\"step.optional\"\n      [linear]=\"step._stepper.linear\"\n    >\n    </avn-step-header>\n\n    <div class=\"avn-vertical-content-container\" [class.avn-stepper-vertical-line]=\"showHeader && !isLast\">\n      <div\n        class=\"avn-vertical-stepper-content\"\n        role=\"tabpanel\"\n        [@verticalStepTransition]=\"_getAnimationDirection(i)\"\n        [id]=\"_getStepContentId(i)\"\n        [attr.aria-labelledby]=\"_getStepLabelId(i)\"\n        [attr.aria-expanded]=\"selectedIndex === i\"\n      >\n        <div class=\"avn-vertical-content\" [class.no-header]=\"!showHeader\">\n          <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: [":host{display:block}:host.theme-primary avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--info-base);color:var(--info-on)}:host.theme-success avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--primary-base)}:host.theme-secondary avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--secondary-base)}:host.theme-highlight avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--highlight-base)}:host.theme-danger avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--danger-base)}:host.theme-warning avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--warning-base)}:host.theme-info avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--info-base)}:host.theme-success avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--success-base)}:host .avn-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}:host .avn-stepper-horizontal-line{border-top-width:1px;border-color:var(--stepper-line-separator);border-top-style:solid;flex:auto;height:0;margin:0 8px;min-width:8px}:host .avn-horizontal-content-container{overflow:hidden;padding:0}:host .avn-horizontal-content-container .avn-horizontal-stepper-content[aria-expanded=false]{height:0;overflow:hidden}:host .avn-vertical-step:last-child .avn-vertical-content-container{border:none}:host .avn-vertical-content-container{margin-left:12px;border:0;position:relative}:host .avn-vertical-content-container>.avn-vertical-stepper-content{overflow:hidden}:host .avn-vertical-content-container>.avn-vertical-stepper-content>.avn-vertical-content{padding:0 0 0 var(--space-lg)}:host .avn-vertical-content-container>.avn-vertical-stepper-content>.avn-vertical-content.no-header{padding-left:0}:host .avn-stepper-vertical-line:before{content:\"\";position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid;border-color:var(--stepper-line-separator)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: StepperStepHeaderComponent, selector: "avn-step-header", inputs: ["linear", "state", "label", "iconName", "index", "selected", "completed", "active", "optional", "headerType", "headerIcon"] }], animations: [avnStepperAnimations.horizontalStepTransition, avnStepperAnimations.verticalStepTransition], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-stepper', animations: [avnStepperAnimations.horizontalStepTransition, avnStepperAnimations.verticalStepTransition], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template [ngIf]=\"orientation === 'horizontal'\" [ngIfElse]=\"verticalStepper\">\n  <div class=\"avn-horizontal-stepper-header-container\" *ngIf=\"showHeader\">\n    <ng-container *ngFor=\"let step of _steps; let i = index; let isLast = last\">\n      <avn-step-header\n        class=\"avn-horizontal-stepper-header\"\n        [headerType]=\"step.headerType\"\n        [headerIcon]=\"step.headerIcon\"\n        (click)=\"step.select()\"\n        (keydown)=\"_onKeydown($event)\"\n        [tabIndex]=\"_getFocusIndex() === i ? 0 : -1\"\n        [id]=\"_getStepLabelId(i)\"\n        [index]=\"i\"\n        [state]=\"_getIndicatorType(i)\"\n        [label]=\"step.stepLabel || step.label\"\n        [selected]=\"selectedIndex === i\"\n        [completed]=\"selectedIndex > i\"\n        [active]=\"step.completed || selectedIndex === i || !linear\"\n        [optional]=\"step.optional\"\n        [linear]=\"step._stepper.linear\"\n      >\n      </avn-step-header>\n      <div *ngIf=\"!isLast\" class=\"avn-stepper-horizontal-line\"></div>\n    </ng-container>\n  </div>\n  <div class=\"avn-horizontal-content-container\">\n    <div\n      *ngFor=\"let step of _steps; let i = index\"\n      class=\"avn-horizontal-stepper-content\"\n      role=\"tabpanel\"\n      [@horizontalStepTransition]=\"_getAnimationDirection(i)\"\n      [id]=\"_getStepContentId(i)\"\n      [attr.aria-labelledby]=\"_getStepLabelId(i)\"\n      [attr.aria-expanded]=\"selectedIndex === i\"\n    >\n      <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #verticalStepper>\n  <div class=\"avn-vertical-step\" *ngFor=\"let step of _steps; let i = index; let isLast = last\">\n    <avn-step-header\n      *ngIf=\"showHeader\"\n      class=\"avn-vertical-stepper-header\"\n      [headerType]=\"step.headerType\"\n      [headerIcon]=\"step.headerIcon\"\n      (click)=\"step.select()\"\n      (keydown)=\"_onKeydown($event)\"\n      [tabIndex]=\"_getFocusIndex() === i ? 0 : -1\"\n      [id]=\"_getStepLabelId(i)\"\n      [index]=\"i\"\n      [state]=\"_getIndicatorType(i)\"\n      [label]=\"step.stepLabel || step.label\"\n      [selected]=\"selectedIndex === i\"\n      [completed]=\"selectedIndex > i\"\n      [active]=\"step.completed || selectedIndex === i || !linear\"\n      [optional]=\"step.optional\"\n      [linear]=\"step._stepper.linear\"\n    >\n    </avn-step-header>\n\n    <div class=\"avn-vertical-content-container\" [class.avn-stepper-vertical-line]=\"showHeader && !isLast\">\n      <div\n        class=\"avn-vertical-stepper-content\"\n        role=\"tabpanel\"\n        [@verticalStepTransition]=\"_getAnimationDirection(i)\"\n        [id]=\"_getStepContentId(i)\"\n        [attr.aria-labelledby]=\"_getStepLabelId(i)\"\n        [attr.aria-expanded]=\"selectedIndex === i\"\n      >\n        <div class=\"avn-vertical-content\" [class.no-header]=\"!showHeader\">\n          <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: [":host{display:block}:host.theme-primary avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--info-base);color:var(--info-on)}:host.theme-success avn-step-header>::ng-deep .avn-step-header-indicator.number.selected{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--primary-base)}:host.theme-secondary avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--secondary-base)}:host.theme-highlight avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--highlight-base)}:host.theme-danger avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--danger-base)}:host.theme-warning avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--warning-base)}:host.theme-info avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--info-base)}:host.theme-success avn-step-header>::ng-deep .avn-step-header-indicator:not(.number).selected>avn-icon>i{color:var(--success-base)}:host .avn-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}:host .avn-stepper-horizontal-line{border-top-width:1px;border-color:var(--stepper-line-separator);border-top-style:solid;flex:auto;height:0;margin:0 8px;min-width:8px}:host .avn-horizontal-content-container{overflow:hidden;padding:0}:host .avn-horizontal-content-container .avn-horizontal-stepper-content[aria-expanded=false]{height:0;overflow:hidden}:host .avn-vertical-step:last-child .avn-vertical-content-container{border:none}:host .avn-vertical-content-container{margin-left:12px;border:0;position:relative}:host .avn-vertical-content-container>.avn-vertical-stepper-content{overflow:hidden}:host .avn-vertical-content-container>.avn-vertical-stepper-content>.avn-vertical-content{padding:0 0 0 var(--space-lg)}:host .avn-vertical-content-container>.avn-vertical-stepper-content>.avn-vertical-content.no-header{padding-left:0}:host .avn-stepper-vertical-line:before{content:\"\";position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid;border-color:var(--stepper-line-separator)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$5.FocusMonitor }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { showHeader: [{
                type: Input
            }], selectedIndex: [{
                type: Input
            }], linear: [{
                type: Input
            }], selected: [{
                type: Input
            }], _stepHeader: [{
                type: ViewChildren,
                args: [StepperStepHeaderComponent]
            }], _steps: [{
                type: ContentChildren,
                args: [forwardRef(() => StepperStepComponent), { descendants: true }]
            }], stepperCompleted: [{
                type: Output
            }], stepChanged: [{
                type: Output
            }], stepperCancelled: [{
                type: Output
            }] } });
class StepperStepComponent extends CdkStep {
    /**
     * Resets the start time of the step
     * Also adds up the elapsed time spent on the step
     *
     * @param clearTime Specifies whether the start time should be cleared rather than set to the
     *     current time
     * return the completion time of the step (whether it was reset or completed)
     */
    resetStartTime(clearTime) {
        const completionTimeTs = Math.floor(Date.now());
        if (this.startTimeTs) {
            const duration = completionTimeTs - this.startTimeTs;
            this.elapsedTimeMs += duration;
        }
        this.startTimeTs = clearTime ? undefined : completionTimeTs;
        return completionTimeTs;
    }
    /**
     * Resets the step to an initial state
     */
    resetStep() {
        this.startTimeTs = undefined;
        this.elapsedTimeMs = 0;
    }
    constructor(stepper) {
        super(stepper);
        /**
         * Specifies the type of header:
         * - icon: show a custom icon (defined by headerIcon)
         * - number: use sequential number for each step
         * */
        this.headerType = 'number';
        /** The total of milliseconds spent on the step **/
        this.elapsedTimeMs = 0;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperStepComponent, deps: [{ token: forwardRef(() => StepperComponent) }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: StepperStepComponent, selector: "avn-step", inputs: { headerType: "headerType", headerIcon: "headerIcon" }, queries: [{ propertyName: "stepLabel", first: true, predicate: StepperStepLabelDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-template><ng-content></ng-content></ng-template>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-step', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template><ng-content></ng-content></ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: StepperComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => StepperComponent)]
                }] }]; }, propDecorators: { stepLabel: [{
                type: ContentChild,
                args: [StepperStepLabelDirective, { static: false }]
            }], headerType: [{
                type: Input
            }], headerIcon: [{
                type: Input
            }] } });

var ISlideButton;
(function (ISlideButton) {
    ISlideButton["FINISH_LATER"] = "finishLater";
    ISlideButton["OPT_OUT"] = "optOut";
    ISlideButton["FINISHED"] = "finished";
})(ISlideButton || (ISlideButton = {}));
/**
 * Specifies the default config for the slide slideshow dialog
 **/
const DEFAULT_SLIDE_DIALOG_CONFIG = {
    showCloseIcon: true,
    closeOnBackdropClick: false,
};

/** Button that moves to the next step in a stepper workflow. */
class StepperButtonNextDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    onClick() {
        // only allow going to the next step when it does not required a valid form to go to the next step
        const stepControl = this._stepper.selected.stepControl;
        if (stepControl && this._stepper.linear) {
            stepControl.markAsTouched({ onlySelf: true });
            stepControl.updateValueAndValidity();
            if (this._stepper.selected.stepControl instanceof UntypedFormGroup) {
                this.validateAllFormFields(this._stepper.selected.stepControl);
                stepControl.statusChanges
                    .pipe(startWith(stepControl.status), filter((status) => status !== 'PENDING'), take(1), tap((status) => {
                    if (status === 'VALID') {
                        this._stepper.next();
                    }
                }))
                    .subscribe();
            }
        }
        else {
            this._stepper.next();
        }
    }
    /**
     * Validates all controls of a form
     *
     * @param formGroup the form group to validate
     */
    validateAllFormFields(formGroup) {
        Object.keys(formGroup.controls).forEach((controlName) => {
            const control = formGroup.get(controlName);
            if (control instanceof UntypedFormControl) {
                // mark the control as touched and trigger the validation
                control.markAsTouched({ onlySelf: true });
                control.updateValueAndValidity();
            }
            else if (control instanceof UntypedFormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonNextDirective, deps: [{ token: i1$6.CdkStepper }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: StepperButtonNextDirective, selector: "[avnStepperNext]", host: { listeners: { "click": "onClick()" } }, providers: [{ provide: CdkStepper, useExisting: StepperComponent }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonNextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnStepperNext]',
                    providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
                }]
        }], ctorParameters: function () { return [{ type: i1$6.CdkStepper }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }] } });
/** Button that moves to the previous step in a stepper workflow. */
class StepperButtonPreviousDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    onClick() {
        this._stepper.previous();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonPreviousDirective, deps: [{ token: i1$6.CdkStepper }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: StepperButtonPreviousDirective, selector: "[avnStepperPrevious]", host: { listeners: { "click": "onClick()" } }, providers: [{ provide: CdkStepper, useExisting: StepperComponent }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonPreviousDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnStepperPrevious]',
                    providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
                }]
        }], ctorParameters: function () { return [{ type: i1$6.CdkStepper }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }] } });
/** Button that cancels the stepper. */
class StepperButtonCancelDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    onClick() {
        this._stepper.reset();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonCancelDirective, deps: [{ token: StepperComponent }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: StepperButtonCancelDirective, selector: "avn-button[avnStepperCancel]", host: { listeners: { "click": "onClick()" } }, providers: [{ provide: CdkStepper, useExisting: StepperComponent }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonCancelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'avn-button[avnStepperCancel]',
                    providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
                }]
        }], ctorParameters: function () { return [{ type: StepperComponent }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }] } });
/** Button that completes the stepper. */
class StepperButtonCompleteDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    onClick() {
        this._stepper.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonCompleteDirective, deps: [{ token: StepperComponent }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: StepperButtonCompleteDirective, selector: "avn-button[avnStepperComplete]", host: { listeners: { "click": "onClick()" } }, providers: [{ provide: CdkStepper, useExisting: StepperComponent }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperButtonCompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'avn-button[avnStepperComplete]',
                    providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
                }]
        }], ctorParameters: function () { return [{ type: StepperComponent }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * This component allows you to create a slideshow in a dialog
 * It consists of a stepper (slides) that will show/present the slides one after the other.
 *
 * An optional starter slide can be shown first before the slideshow actually starts.
 * Each slide's content is configurable. It can have a title, description and/or custom content
 * injected via custom template references.
 *
 * Descriptive media content can also be added and placed at top, middle or bottom of the slide.
 * It can be an icon, image or video (MP4, WebM, and Ogg).
 *
 * The slideshow can be temporarily dismissed at any time in order to be continued later. The user
 * can also permanently dismiss / opt out of the slideshow at any time.
 *
 * Events are emitted by the component when:
 * - a slide has been seen
 * - the slideshow is completed
 * - the slideshow was opted out / disabled
 * - when the slideshow dialog is closed
 *
 */
class SlideDialogComponent {
    get height() {
        return this.dialogConfig.overlayConfig.height;
    }
    /** @ingore */
    constructor(dialogRef, dialogConfig, cdk, renderer) {
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this.cdk = cdk;
        this.renderer = renderer;
        /** the min size for text  */
        this.textMinHeightPx = 130;
        /** Emits when a slide has been viewed */
        this.slideViewed = new EventEmitter();
        /** Emits when the slideshow was opted out / disabled */
        this.slideshowDisabled = new EventEmitter();
        /** Emits when the slideshow is completed */
        this.slideshowCompleted = new EventEmitter();
        this.themeType = ThemeType;
        this.iSlideButton = ISlideButton;
        /** The index of the deepest slide viewed */
        this.deepestSlideViewedIndex = -1;
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
        this.trackIndexFn = (_, item) => item.id;
        this._isLastSlide = false;
        if (!this.dialogConfig.data ||
            !this.dialogConfig.data.slides ||
            this.dialogConfig.data.slides.length === 0 ||
            this.dialogConfig.data.slides.filter((slide) => !slide.slideshowStarter).length === 0) {
            throw new Error('At least one non-starter slide item must be present.');
        }
        if (this.dialogConfig.data.slides.filter((f, i) => i > 0 && f.slideshowStarter).length > 0) {
            throw new Error('Only one starter slideshow is allowed and it must be the first slide item.');
        }
        this.theme = dialogConfig.data.theme ? dialogConfig.data.theme : ThemeType.PRIMARY;
    }
    /** @ingore */
    ngOnInit() {
        // When a step changed
        this.stepper.stepChanged.pipe(takeUntil(this._componentDestroyed$)).subscribe((evt) => {
            // go to the previous or next slide
            this._isLastSlide = evt.selectedStepIndex === this.stepper.steps.length - 1;
            this.goToSlide(evt.selectedStepIndex);
            this.cdk.detectChanges();
        });
        // When the stepper is cancelled
        this.stepper.stepperCancelled.pipe(takeUntil(this._componentDestroyed$)).subscribe(() => {
            this.slideshowDisabled.emit(this.currentSlide);
        });
        // When the stepper is completed
        this.stepper.stepperCompleted.pipe(takeUntil(this._componentDestroyed$)).subscribe(() => {
            this.slideshowCompleted.emit();
        });
        // position on the first slide item
        const startSlideIndex = this.dialogConfig.data.startSlideIndex ? this.dialogConfig.data.startSlideIndex : 0;
        this.stepper.selectedIndex = startSlideIndex;
        this.goToSlide(startSlideIndex);
    }
    /** when no buttons exist we need to make sure the user is not stuck */
    completeWhenLastSlideIsClickedForSomeReason(slideIdx) {
        if (slideIdx === this.stepper.steps.toArray().length - 1 && this.dialogConfig.data.hideButton.indexOf(ISlideButton.FINISHED) > -1) {
            this.slideshowCompleted.emit();
            this.onClose();
        }
    }
    /**
     * Navigates to the specified slide index and emit events
     *
     * @ingore
     * */
    goToSlide(index) {
        this.currentSlideIndex = index;
        this.currentSlide = this.dialogConfig.data.slides[index];
        // emit an event when the previous slide has been completed for the first time
        if (index > this.deepestSlideViewedIndex) {
            this.deepestSlideViewedIndex = index;
            this.slideViewed.emit(this.currentSlide);
        }
    }
    /** Specifies whether clicking the overlay closes the slideshow. */
    canClose() {
        return false;
    }
    /** Called when the dialog is closed */
    onClose() {
        this.dialogRef.close();
    }
    /** Checks if the specified value is a template reference */
    isTemplate(value) {
        return value instanceof TemplateRef;
    }
    /** Called when the opt out action is triggered */
    onOptOut() {
        this.slideshowDisabled.emit(this.currentSlide);
        this.onClose();
    }
    hideButtonConfig(buttonName) {
        if (this.dialogConfig.data.hideButton && buttonName && this.dialogConfig.data.hideButton.indexOf(buttonName) !== -1) {
            return true;
        }
        return false;
    }
    getVideoControlList(videoControls) {
        let controls = '';
        if (videoControls) {
            if (videoControls.indexOf('download') === -1) {
                controls += 'nodownload';
            }
            if (videoControls.indexOf('fullscreen') === -1) {
                controls += ' nofullscreen';
            }
            if (videoControls.indexOf('remote-playback') === -1) {
                controls += ' noremoteplayback';
            }
            if (videoControls.indexOf('playback-speed') === -1) {
                controls += ' noplaybackrate';
            }
            if (this.dialogConfig?.data?.videoLoop) {
                controls += ' loop';
            }
        }
        return controls;
    }
    isVideoControlActivate(control, videoControls) {
        return videoControls.indexOf(control) !== -1;
    }
    /** Specifies whether the current slide has media on top */
    get hasTopMedia() {
        return this.currentSlide && this.currentSlide.mediaType && this.currentSlide.mediaPosition === 'top';
    }
    /** Specifies whether the current slide has media on bottom */
    get hasBottomMedia() {
        return this.currentSlide && this.currentSlide.mediaType && (!this.currentSlide.mediaPosition || this.currentSlide.mediaPosition === 'bottom');
    }
    /** @ignore*/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SlideDialogComponent, deps: [{ token: ModalRef }, { token: MODAL_CONFIG }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SlideDialogComponent, selector: "avn-slide-dialog", inputs: { textMinHeightPx: "textMinHeightPx" }, outputs: { slideViewed: "slideViewed", slideshowDisabled: "slideshowDisabled", slideshowCompleted: "slideshowCompleted" }, host: { properties: { "class.top-media": "this.hasTopMedia", "class.bottom-media": "this.hasBottomMedia" } }, viewQueries: [{ propertyName: "stepper", first: true, predicate: StepperComponent, descendants: true, static: true }], ngImport: i0, template: "<avn-dialog-layout>\n  <avn-dialog-content>\n    <avn-stepper [linear]=\"false\" #stepper [showHeader]=\"false\">\n      <avn-step *ngFor=\"let slide of dialogConfig.data.slides; let i = index; let last = last; trackBy: trackIndexFn\">\n        <div *ngIf=\"currentSlideIndex === i\" class=\"slide-container\" [style.height]=\"height\">\n          <!-- top media -->\n          <div class=\"media-slide\" *ngIf=\"slide.mediaType && slide.mediaPosition === 'top'\" [ngSwitch]=\"slide.mediaType\">\n            <ng-container\n              *ngTemplateOutlet=\"\n                mediaTemplate;\n                context: {\n                  type: slide.mediaType,\n                  position: slide.mediaPosition,\n                  value: slide.mediaValue,\n                  enableVideoControls: slide.enableVideoControls ?? true,\n                  videoControls: slide.videoControls || []\n                }\n              \"\n            ></ng-container>\n          </div>\n\n          <!-- slideshow starter -->\n          <div class=\"slide starter\" *ngIf=\"slide.slideshowStarter; else slideshowItem\">\n            <!-- slideshow starter name -->\n            <div class=\"content-container top\">\n              <ng-container *ngIf=\"!isTemplate(slide.slideTitle); else slideTitleTemplate\">\n                <h2 *ngIf=\"slide.slideTitle\" [innerHtml]=\"slide.slideTitle\"></h2>\n              </ng-container>\n              <ng-template #slideTitleTemplate>\n                <ng-container *ngTemplateOutlet=\"slide.slideTitle\"> </ng-container>\n              </ng-template>\n              <!-- slideshow starter description -->\n              <ng-container *ngIf=\"!isTemplate(slide.slideDescription); else slideTemplate\"\n                ><p *ngIf=\"slide.slideDescription\" [innerHtml]=\"slide.slideDescription\"></p\n              ></ng-container>\n              <ng-template #slideTemplate><ng-container *ngTemplateOutlet=\"slide.slideDescription\"></ng-container></ng-template>\n            </div>\n            <!-- middle media -->\n            <ng-container *ngIf=\"slide.mediaType && slide.mediaPosition === 'middle'\" [ngSwitch]=\"slide.mediaType\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  mediaTemplate;\n                  context: {\n                    type: slide.mediaType,\n                    position: slide.mediaPosition,\n                    value: slide.mediaValue,\n                    enableVideoControls: slide.enableVideoControls ?? true,\n                    videoControls: slide.videoControls || []\n                  }\n                \"\n              ></ng-container>\n            </ng-container>\n            <div class=\"content-container bottom\">\n              <!-- start button -->\n              <avn-button [label]=\"dialogConfig.data.labels?.start\" [avnTheme]=\"themeType.INFO\" size=\"large\" avnStepperNext></avn-button>\n              <!-- unsubscribe -->\n              <ng-container\n                *ngTemplateOutlet=\"\n                  unsubscribeTemplate;\n                  context: {\n                    template: slide.unsubscribeTemplate ? slide.unsubscribeTemplate : dialogConfig.data.unsubscribeTemplate\n                  }\n                \"\n              ></ng-container>\n            </div>\n          </div>\n\n          <!-- slideshow slide -->\n          <ng-template #slideshowItem>\n            <div class=\"slide\">\n              <div class=\"content-container top\">\n                <div class=\"slide-button slide-previous\"  *ngIf=\"!slide.slideshowStarter\">\n                  <avn-icon\n                    [avnTheme]=\"themeType.PRIMARY\"\n                    [icon]=\"'navigation:chevron_left'\"\n                    avnStepperPrevious\n                    [hidden]=\"dialogConfig.data.hideButtonWhenDisabled && i < 1\"\n                    [fontSize]=\"36\"></avn-icon>\n                </div>\n                <div class=\"slide-content-text\" [style.min-height.px]=\"textMinHeightPx\">\n                  <!-- slideshow slide name -->\n                  <ng-container *ngIf=\"!isTemplate(slide.slideTitle); else slideTitleTemplate\"><h2 *ngIf=\"slide.slideTitle\" [innerHtml]=\"slide.slideTitle\"></h2></ng-container>\n                  <ng-template #slideTitleTemplate><ng-container *ngTemplateOutlet=\"slide.slideTitle\"></ng-container></ng-template>\n                  <!-- slideshow slide description -->\n                  <ng-container *ngIf=\"!isTemplate(slide.slideDescription); else slideDescriptionTemplate\"\n                    ><p *ngIf=\"slide.slideDescription\" [innerHtml]=\"slide.slideDescription\"></p\n                  ></ng-container>\n                  <ng-template #slideDescriptionTemplate><ng-container *ngTemplateOutlet=\"slide.slideDescription\"></ng-container></ng-template>\n                </div>\n                <div class=\"slide-button slide-next\" *ngIf=\"!slide.slideshowStarter\">\n                    <avn-icon\n                      [avnTheme]=\"themeType.PRIMARY\"\n                      [icon]=\"'navigation:chevron_right'\"\n                      [hidden]=\"dialogConfig.data.hideButtonWhenDisabled && last\"\n                      avnStepperNext\n                      (click)=\"completeWhenLastSlideIsClickedForSomeReason(i)\"\n                      [fontSize]=\"36\">\n                    </avn-icon>\n                </div>\n              </div>\n              <!-- middle media -->\n              <ng-container *ngIf=\"slide.mediaType && slide.mediaPosition === 'middle'\" [ngSwitch]=\"slide.mediaType\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    mediaTemplate;\n                    context: {\n                      type: slide.mediaType,\n                      position: slide.mediaPosition,\n                      value: slide.mediaValue,\n                      enableVideoControls: slide.enableVideoControls ?? true,\n                      videoControls: slide.videoControls || []\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n\n            </div>\n          </ng-template>\n\n          <div class=\"content-container bottom\" *ngIf=\"!hideButtonConfig(iSlideButton.FINISH_LATER) || !hideButtonConfig(iSlideButton.OPT_OUT) || !hideButtonConfig(iSlideButton.FINISHED) && last\">\n            <!-- action buttons -->\n            <div>\n              <avn-button *ngIf=\"!last\" [style.visibility]=\"hideButtonConfig(iSlideButton.FINISH_LATER) ? 'hidden' : 'visible'\" [label]=\"dialogConfig.data.labels?.finishLater\" (click)=\"onClose()\"></avn-button>\n            </div>\n            <div>\n              <avn-button *ngIf=\"last\" [hidden]=\"hideButtonConfig(iSlideButton.FINISHED)\" [label]=\"dialogConfig.data.labels?.finished\" [avnTheme]=\"themeType.PRIMARY\" (click)=\"onClose()\" avnStepperComplete></avn-button>\n            </div>\n            <!-- unsubscribe -->\n            <div>\n              <div [hidden]=\"hideButtonConfig(iSlideButton.OPT_OUT) || last\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    unsubscribeTemplate;\n                    context: {\n                      template: slide.unsubscribeTemplate ? slide.unsubscribeTemplate : dialogConfig.data.unsubscribeTemplate\n                    }\n                  \"\n                ></ng-container>\n              </div>\n            </div>\n          </div>\n\n          <!-- bottom media -->\n          <div class=\"media-slide\" *ngIf=\"slide.mediaType && (!slide.mediaPosition || slide.mediaPosition === 'bottom')\">\n            <ng-container\n              *ngTemplateOutlet=\"\n                mediaTemplate;\n                context: {\n                  type: slide.mediaType,\n                  position: 'bottom',\n                  value: slide.mediaValue,\n                  enableVideoControls: slide.enableVideoControls ?? true,\n                  videoControls: slide.videoControls || []\n                }\n              \"\n            ></ng-container>\n          </div>\n        </div>\n      </avn-step>\n    </avn-stepper>\n  </avn-dialog-content>\n</avn-dialog-layout>\n\n<!-- templates -->\n<ng-template #mediaTemplate let-type=\"type\" let-position=\"position\" let-value=\"value\" let-enableVideoControls=\"enableVideoControls\" let-videoControls=\"videoControls\">\n  <ng-container [ngSwitch]=\"type\">\n    <ng-container *ngSwitchCase=\"'image'\">\n        <img [src]=\"value\" class=\"image-container\" *ngIf=\"value\" />\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'icon'\">\n      <div [class]=\"'icon-container ' + position\">\n        <avn-icon [icon]=\"value\" *ngIf=\"value\"></avn-icon>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'video'\">\n      <div [class]=\"'video-container ' + position\">\n        <ng-container *ngTemplateOutlet=\"videoTemplate; context: { href: value, enableVideoControls: enableVideoControls, videoControls: videoControls }\"></ng-container>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-template>\n\n<ng-template #videoTemplate let-href=\"href\" let-enableVideoControls=\"enableVideoControls\" let-videoControls=\"videoControls\">\n  <video\n    *ngIf=\"href\"\n    id=\"slideshowVideo\"\n    preload=\"auto\"\n    [controls]=\"enableVideoControls ? 'true' : null\"\n    [controlsList]=\"getVideoControlList(videoControls)\"\n    [attr.disablepictureinpicture]=\"!isVideoControlActivate('picture-in-picture', videoControls) ? '' : null\"\n    [attr.disableremoteplayback]=\"!isVideoControlActivate('remote-playback', videoControls) ? '' : null\"\n    autoplay\n  >\n    <source [src]=\"href\" />\n  </video>\n</ng-template>\n\n<ng-template #unsubscribeTemplate let-template=\"template\">\n  <div class=\"unsubscribe\" *ngIf=\"template === undefined; else noUnsubscribeTemplate\">\n    {{ dialogConfig.data.labels?.notInterested }}\n    <a href=\"javascript:;\" (click)=\"onOptOut()\">{{ dialogConfig.data.labels?.optOut }}</a>\n  </div>\n  <ng-template #noUnsubscribeTemplate><ng-container *ngTemplateOutlet=\"template; context: { modalRef: dialogRef }\"></ng-container></ng-template>\n</ng-template>\n", styles: [":host{display:block;width:100%;height:100%}:host .slide-container{display:flex;flex-direction:column}:host .slide-container .media-slide{flex-grow:1;overflow:hidden}:host .slide-container .media-slide img,:host .slide-container .media-slide video{width:100%;height:100%;object-fit:contain;background-color:var(--slide-dialog-background)}:host avn-dialog-content{padding:0}:host .content-container{display:flex;justify-content:space-between;padding-left:var(--space-lg);padding-right:var(--space-lg);align-items:center}:host .content-container.bottom{padding-bottom:var(--space-lg)}:host .slide .slide-button{display:flex;align-items:center;min-width:36px}:host .slide .slide-content-text{flex-basis:85%;display:flex;flex-direction:column;justify-content:center;margin-left:var(--space-lg);margin-right:var(--space-lg)}:host .slide .slide-content-text.bottom{padding-bottom:var(--space-lg)}:host .slide.starter{display:flex;flex-direction:column;align-items:center}:host .slide.starter .content-container{flex-direction:column;justify-content:center;align-items:center}:host .slide.starter .content-container>avn-button{margin:var(--space-xl)}:host .slide.starter .content-container.top{padding-top:var(--space-lg)}:host .slide .actions-buttons{display:flex;flex-direction:row;justify-content:space-between}:host .slide .actions-buttons .step-actions{display:flex;flex-direction:row;justify-content:space-between}:host .slide .actions-buttons .step-actions>avn-button:not(:last-child){margin-right:var(--space-md)}:host .slide ::ng-deep .unsubscribe{margin-top:var(--space-md);font-size:var(--text-sm);color:var(--slide-dialog-on)}:host .slide ::ng-deep .unsubscribe a{color:var(--slide-dialog-on)}:host .slide .video-container.middle,:host .slide .icon-container.middle{width:100%;margin-bottom:var(--space-lg)}:host .icon-container{padding:var(--space-lg) var(--space-md);display:flex;align-items:center;justify-content:center}:host .icon-container:not(.bottom){margin-bottom:var(--space-lg)}:host .icon-container avn-icon{height:initial;width:initial}:host .icon-container avn-icon>::ng-deep i{font-size:5rem}:host .video-container{width:100%;height:100%;margin:auto;overflow:hidden}:host .video-container>video{width:100%;height:100%}:host.top-media ::ng-deep .avn-horizontal-content-container{border-top-left-radius:var(--dialog-border-radius);border-top-right-radius:var(--dialog-border-radius)}:host.bottom-media ::ng-deep .avn-horizontal-content-container{border-bottom-left-radius:var(--dialog-border-radius);border-bottom-right-radius:var(--dialog-border-radius)}:host h2{font-size:var(--text-lg)}:host-context(.dmb-aspect) :host .slide .content-container.top{padding-top:0}:host-context(.dmb-aspect) :host .slide .slide-button{position:relative}:host-context(.dmb-aspect) :host .slide .slide-button>avn-icon:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:var(--slide-dialog-on);opacity:.05;border-radius:50%}:host-context(.dmb-aspect) :host .slide .slide-button:hover>avn-icon:after{opacity:.13}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: StepperComponent, selector: "avn-stepper", inputs: ["showHeader", "selectedIndex", "linear", "selected"], outputs: ["stepperCompleted", "stepChanged", "stepperCancelled"] }, { kind: "component", type: StepperStepComponent, selector: "avn-step", inputs: ["headerType", "headerIcon"] }, { kind: "directive", type: StepperButtonNextDirective, selector: "[avnStepperNext]" }, { kind: "directive", type: StepperButtonPreviousDirective, selector: "[avnStepperPrevious]" }, { kind: "directive", type: StepperButtonCompleteDirective, selector: "avn-button[avnStepperComplete]" }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: DialogLayoutComponent, selector: "avn-dialog-layout" }, { kind: "component", type: DialogContentComponent, selector: "avn-dialog-content" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SlideDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-slide-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-dialog-layout>\n  <avn-dialog-content>\n    <avn-stepper [linear]=\"false\" #stepper [showHeader]=\"false\">\n      <avn-step *ngFor=\"let slide of dialogConfig.data.slides; let i = index; let last = last; trackBy: trackIndexFn\">\n        <div *ngIf=\"currentSlideIndex === i\" class=\"slide-container\" [style.height]=\"height\">\n          <!-- top media -->\n          <div class=\"media-slide\" *ngIf=\"slide.mediaType && slide.mediaPosition === 'top'\" [ngSwitch]=\"slide.mediaType\">\n            <ng-container\n              *ngTemplateOutlet=\"\n                mediaTemplate;\n                context: {\n                  type: slide.mediaType,\n                  position: slide.mediaPosition,\n                  value: slide.mediaValue,\n                  enableVideoControls: slide.enableVideoControls ?? true,\n                  videoControls: slide.videoControls || []\n                }\n              \"\n            ></ng-container>\n          </div>\n\n          <!-- slideshow starter -->\n          <div class=\"slide starter\" *ngIf=\"slide.slideshowStarter; else slideshowItem\">\n            <!-- slideshow starter name -->\n            <div class=\"content-container top\">\n              <ng-container *ngIf=\"!isTemplate(slide.slideTitle); else slideTitleTemplate\">\n                <h2 *ngIf=\"slide.slideTitle\" [innerHtml]=\"slide.slideTitle\"></h2>\n              </ng-container>\n              <ng-template #slideTitleTemplate>\n                <ng-container *ngTemplateOutlet=\"slide.slideTitle\"> </ng-container>\n              </ng-template>\n              <!-- slideshow starter description -->\n              <ng-container *ngIf=\"!isTemplate(slide.slideDescription); else slideTemplate\"\n                ><p *ngIf=\"slide.slideDescription\" [innerHtml]=\"slide.slideDescription\"></p\n              ></ng-container>\n              <ng-template #slideTemplate><ng-container *ngTemplateOutlet=\"slide.slideDescription\"></ng-container></ng-template>\n            </div>\n            <!-- middle media -->\n            <ng-container *ngIf=\"slide.mediaType && slide.mediaPosition === 'middle'\" [ngSwitch]=\"slide.mediaType\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  mediaTemplate;\n                  context: {\n                    type: slide.mediaType,\n                    position: slide.mediaPosition,\n                    value: slide.mediaValue,\n                    enableVideoControls: slide.enableVideoControls ?? true,\n                    videoControls: slide.videoControls || []\n                  }\n                \"\n              ></ng-container>\n            </ng-container>\n            <div class=\"content-container bottom\">\n              <!-- start button -->\n              <avn-button [label]=\"dialogConfig.data.labels?.start\" [avnTheme]=\"themeType.INFO\" size=\"large\" avnStepperNext></avn-button>\n              <!-- unsubscribe -->\n              <ng-container\n                *ngTemplateOutlet=\"\n                  unsubscribeTemplate;\n                  context: {\n                    template: slide.unsubscribeTemplate ? slide.unsubscribeTemplate : dialogConfig.data.unsubscribeTemplate\n                  }\n                \"\n              ></ng-container>\n            </div>\n          </div>\n\n          <!-- slideshow slide -->\n          <ng-template #slideshowItem>\n            <div class=\"slide\">\n              <div class=\"content-container top\">\n                <div class=\"slide-button slide-previous\"  *ngIf=\"!slide.slideshowStarter\">\n                  <avn-icon\n                    [avnTheme]=\"themeType.PRIMARY\"\n                    [icon]=\"'navigation:chevron_left'\"\n                    avnStepperPrevious\n                    [hidden]=\"dialogConfig.data.hideButtonWhenDisabled && i < 1\"\n                    [fontSize]=\"36\"></avn-icon>\n                </div>\n                <div class=\"slide-content-text\" [style.min-height.px]=\"textMinHeightPx\">\n                  <!-- slideshow slide name -->\n                  <ng-container *ngIf=\"!isTemplate(slide.slideTitle); else slideTitleTemplate\"><h2 *ngIf=\"slide.slideTitle\" [innerHtml]=\"slide.slideTitle\"></h2></ng-container>\n                  <ng-template #slideTitleTemplate><ng-container *ngTemplateOutlet=\"slide.slideTitle\"></ng-container></ng-template>\n                  <!-- slideshow slide description -->\n                  <ng-container *ngIf=\"!isTemplate(slide.slideDescription); else slideDescriptionTemplate\"\n                    ><p *ngIf=\"slide.slideDescription\" [innerHtml]=\"slide.slideDescription\"></p\n                  ></ng-container>\n                  <ng-template #slideDescriptionTemplate><ng-container *ngTemplateOutlet=\"slide.slideDescription\"></ng-container></ng-template>\n                </div>\n                <div class=\"slide-button slide-next\" *ngIf=\"!slide.slideshowStarter\">\n                    <avn-icon\n                      [avnTheme]=\"themeType.PRIMARY\"\n                      [icon]=\"'navigation:chevron_right'\"\n                      [hidden]=\"dialogConfig.data.hideButtonWhenDisabled && last\"\n                      avnStepperNext\n                      (click)=\"completeWhenLastSlideIsClickedForSomeReason(i)\"\n                      [fontSize]=\"36\">\n                    </avn-icon>\n                </div>\n              </div>\n              <!-- middle media -->\n              <ng-container *ngIf=\"slide.mediaType && slide.mediaPosition === 'middle'\" [ngSwitch]=\"slide.mediaType\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    mediaTemplate;\n                    context: {\n                      type: slide.mediaType,\n                      position: slide.mediaPosition,\n                      value: slide.mediaValue,\n                      enableVideoControls: slide.enableVideoControls ?? true,\n                      videoControls: slide.videoControls || []\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n\n            </div>\n          </ng-template>\n\n          <div class=\"content-container bottom\" *ngIf=\"!hideButtonConfig(iSlideButton.FINISH_LATER) || !hideButtonConfig(iSlideButton.OPT_OUT) || !hideButtonConfig(iSlideButton.FINISHED) && last\">\n            <!-- action buttons -->\n            <div>\n              <avn-button *ngIf=\"!last\" [style.visibility]=\"hideButtonConfig(iSlideButton.FINISH_LATER) ? 'hidden' : 'visible'\" [label]=\"dialogConfig.data.labels?.finishLater\" (click)=\"onClose()\"></avn-button>\n            </div>\n            <div>\n              <avn-button *ngIf=\"last\" [hidden]=\"hideButtonConfig(iSlideButton.FINISHED)\" [label]=\"dialogConfig.data.labels?.finished\" [avnTheme]=\"themeType.PRIMARY\" (click)=\"onClose()\" avnStepperComplete></avn-button>\n            </div>\n            <!-- unsubscribe -->\n            <div>\n              <div [hidden]=\"hideButtonConfig(iSlideButton.OPT_OUT) || last\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    unsubscribeTemplate;\n                    context: {\n                      template: slide.unsubscribeTemplate ? slide.unsubscribeTemplate : dialogConfig.data.unsubscribeTemplate\n                    }\n                  \"\n                ></ng-container>\n              </div>\n            </div>\n          </div>\n\n          <!-- bottom media -->\n          <div class=\"media-slide\" *ngIf=\"slide.mediaType && (!slide.mediaPosition || slide.mediaPosition === 'bottom')\">\n            <ng-container\n              *ngTemplateOutlet=\"\n                mediaTemplate;\n                context: {\n                  type: slide.mediaType,\n                  position: 'bottom',\n                  value: slide.mediaValue,\n                  enableVideoControls: slide.enableVideoControls ?? true,\n                  videoControls: slide.videoControls || []\n                }\n              \"\n            ></ng-container>\n          </div>\n        </div>\n      </avn-step>\n    </avn-stepper>\n  </avn-dialog-content>\n</avn-dialog-layout>\n\n<!-- templates -->\n<ng-template #mediaTemplate let-type=\"type\" let-position=\"position\" let-value=\"value\" let-enableVideoControls=\"enableVideoControls\" let-videoControls=\"videoControls\">\n  <ng-container [ngSwitch]=\"type\">\n    <ng-container *ngSwitchCase=\"'image'\">\n        <img [src]=\"value\" class=\"image-container\" *ngIf=\"value\" />\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'icon'\">\n      <div [class]=\"'icon-container ' + position\">\n        <avn-icon [icon]=\"value\" *ngIf=\"value\"></avn-icon>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'video'\">\n      <div [class]=\"'video-container ' + position\">\n        <ng-container *ngTemplateOutlet=\"videoTemplate; context: { href: value, enableVideoControls: enableVideoControls, videoControls: videoControls }\"></ng-container>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-template>\n\n<ng-template #videoTemplate let-href=\"href\" let-enableVideoControls=\"enableVideoControls\" let-videoControls=\"videoControls\">\n  <video\n    *ngIf=\"href\"\n    id=\"slideshowVideo\"\n    preload=\"auto\"\n    [controls]=\"enableVideoControls ? 'true' : null\"\n    [controlsList]=\"getVideoControlList(videoControls)\"\n    [attr.disablepictureinpicture]=\"!isVideoControlActivate('picture-in-picture', videoControls) ? '' : null\"\n    [attr.disableremoteplayback]=\"!isVideoControlActivate('remote-playback', videoControls) ? '' : null\"\n    autoplay\n  >\n    <source [src]=\"href\" />\n  </video>\n</ng-template>\n\n<ng-template #unsubscribeTemplate let-template=\"template\">\n  <div class=\"unsubscribe\" *ngIf=\"template === undefined; else noUnsubscribeTemplate\">\n    {{ dialogConfig.data.labels?.notInterested }}\n    <a href=\"javascript:;\" (click)=\"onOptOut()\">{{ dialogConfig.data.labels?.optOut }}</a>\n  </div>\n  <ng-template #noUnsubscribeTemplate><ng-container *ngTemplateOutlet=\"template; context: { modalRef: dialogRef }\"></ng-container></ng-template>\n</ng-template>\n", styles: [":host{display:block;width:100%;height:100%}:host .slide-container{display:flex;flex-direction:column}:host .slide-container .media-slide{flex-grow:1;overflow:hidden}:host .slide-container .media-slide img,:host .slide-container .media-slide video{width:100%;height:100%;object-fit:contain;background-color:var(--slide-dialog-background)}:host avn-dialog-content{padding:0}:host .content-container{display:flex;justify-content:space-between;padding-left:var(--space-lg);padding-right:var(--space-lg);align-items:center}:host .content-container.bottom{padding-bottom:var(--space-lg)}:host .slide .slide-button{display:flex;align-items:center;min-width:36px}:host .slide .slide-content-text{flex-basis:85%;display:flex;flex-direction:column;justify-content:center;margin-left:var(--space-lg);margin-right:var(--space-lg)}:host .slide .slide-content-text.bottom{padding-bottom:var(--space-lg)}:host .slide.starter{display:flex;flex-direction:column;align-items:center}:host .slide.starter .content-container{flex-direction:column;justify-content:center;align-items:center}:host .slide.starter .content-container>avn-button{margin:var(--space-xl)}:host .slide.starter .content-container.top{padding-top:var(--space-lg)}:host .slide .actions-buttons{display:flex;flex-direction:row;justify-content:space-between}:host .slide .actions-buttons .step-actions{display:flex;flex-direction:row;justify-content:space-between}:host .slide .actions-buttons .step-actions>avn-button:not(:last-child){margin-right:var(--space-md)}:host .slide ::ng-deep .unsubscribe{margin-top:var(--space-md);font-size:var(--text-sm);color:var(--slide-dialog-on)}:host .slide ::ng-deep .unsubscribe a{color:var(--slide-dialog-on)}:host .slide .video-container.middle,:host .slide .icon-container.middle{width:100%;margin-bottom:var(--space-lg)}:host .icon-container{padding:var(--space-lg) var(--space-md);display:flex;align-items:center;justify-content:center}:host .icon-container:not(.bottom){margin-bottom:var(--space-lg)}:host .icon-container avn-icon{height:initial;width:initial}:host .icon-container avn-icon>::ng-deep i{font-size:5rem}:host .video-container{width:100%;height:100%;margin:auto;overflow:hidden}:host .video-container>video{width:100%;height:100%}:host.top-media ::ng-deep .avn-horizontal-content-container{border-top-left-radius:var(--dialog-border-radius);border-top-right-radius:var(--dialog-border-radius)}:host.bottom-media ::ng-deep .avn-horizontal-content-container{border-bottom-left-radius:var(--dialog-border-radius);border-bottom-right-radius:var(--dialog-border-radius)}:host h2{font-size:var(--text-lg)}:host-context(.dmb-aspect) :host .slide .content-container.top{padding-top:0}:host-context(.dmb-aspect) :host .slide .slide-button{position:relative}:host-context(.dmb-aspect) :host .slide .slide-button>avn-icon:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:var(--slide-dialog-on);opacity:.05;border-radius:50%}:host-context(.dmb-aspect) :host .slide .slide-button:hover>avn-icon:after{opacity:.13}\n"] }]
        }], ctorParameters: function () { return [{ type: ModalRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONFIG]
                }] }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { stepper: [{
                type: ViewChild,
                args: [StepperComponent, { static: true }]
            }], textMinHeightPx: [{
                type: Input
            }], slideViewed: [{
                type: Output
            }], slideshowDisabled: [{
                type: Output
            }], slideshowCompleted: [{
                type: Output
            }], hasTopMedia: [{
                type: HostBinding,
                args: ['class.top-media']
            }], hasBottomMedia: [{
                type: HostBinding,
                args: ['class.bottom-media']
            }] } });

/**
 * A new instance of modal service will be provided in the shell and in each lazy module
 * This is required otherwise the modal service injector cannot retrieve entry components from lazy modules
 * To be rechecked when entry components are longer needed with ivy enabled
 *
 * https://dev.to/christiankohler/improved-dependeny-injection-with-the-new-providedin-scopes-any-and-platform-30bb
 */
class ModalService {
    /**
     * @ignore
     */
    constructor(overlay, injector, _modalManagementService) {
        this.overlay = overlay;
        this.injector = injector;
        this._modalManagementService = _modalManagementService;
    }
    /**
     * Opens a modal showing a standard dialog component
     *
     * @param dialogConfig The dialog configuration.
     * @param overlayConfig The overlay configuration.
     * @returns A reference for the attached dialog.
     */
    openStandardDialog(modalConfig, overlayConfig) {
        // set some default config for the standard dialog (props will be overridden by the passed
        // config if specified)
        modalConfig = { ...DEFAULT_STANDARD_DIALOG_CONFIG, ...modalConfig };
        return this.open(StandardDialogComponent, modalConfig, overlayConfig, ModalType.Dialog, dialogAnimationOpen, dialogAnimationClose);
    }
    /**
     * Opens a bottom sheet showing the custom component passed
     *
     * @param component type of the component to display in the modal
     * @param modalConfig The modal configuration.
     * @param overlayConfig The overlay configuration.
     * @returns A reference for the attached modal.
     */
    openBottomSheet(component, modalConfig, overlayConfig = {}) {
        return this.open(component, modalConfig, overlayConfig, ModalType.BottomSheet, bottomSheetAnimationOpen, bottomSheetAnimationClose);
    }
    /**
     * Opens a drawer showing the custom component passed
     *
     * @param component type of the component to display in the modal
     * @param modalConfig The modal configuration.
     * @param overlayConfig The overlay configuration.
     * @returns A reference for the attached modal.
     */
    openDrawer(component, modalConfig, overlayConfig = {}, position = 'right') {
        const drawerAnimationOpen = position === 'right' ? drawerAnimationOpenRight : drawerAnimationOpenLeft;
        const drawerAnimationClose = position === 'right' ? drawerAnimationCloseRight : drawerAnimationCloseLeft;
        const positionStrategy = position === 'right' ? this.overlay.position().global().right().centerVertically() : this.overlay.position().global().left().centerVertically();
        // auto add a class indicating the drawer position, so we can adjust drawer buttons location
        overlayConfig = addOverlayPanelClass(overlayConfig, position);
        return this.open(component, modalConfig, overlayConfig, ModalType.Drawer, drawerAnimationOpen, drawerAnimationClose, positionStrategy);
    }
    /**
     * Opens a slide dialog
     *
     * @param component type of the component to display in the modal
     * @param modalConfig The modal configuration.
     * @param overlayConfig The overlay configuration.
     * @returns A reference for the attached modal.
     */
    openSlideDialog(modalConfig, overlayConfig = {}) {
        return this.open(SlideDialogComponent, modalConfig, overlayConfig, ModalType.SlideDialog, dialogAnimationOpen, dialogAnimationClose);
    }
    /**
     * Opens a modal showing the custom component passed
     *
     * @param component type of the component to display in the modal
     * @param modalConfig The modal configuration.
     * @param overlayConfig The overlay configuration.
     * @returns A reference for the attached modal.
     */
    open(component, modalConfig, overlayConfig = {}, modalType = ModalType.Dialog, openAnimation = defaultAnimationOpen, closeAnimation = defaultAnimationClose, positionStrategy) {
        // get the overlay config depending on modal type
        const finalOverlayConfig = modalType === ModalType.Drawer
            ? getDefaultDrawerOverlayConfig(this.overlay, overlayConfig, positionStrategy)
            : modalType === ModalType.BottomSheet
                ? getDefaultBottomSheetOverlayConfig(this.overlay, overlayConfig)
                : getDefaultDialogOverlayConfig(this.overlay, overlayConfig, positionStrategy);
        modalConfig.overlayConfig = finalOverlayConfig;
        // create the overlay
        const overlayRef = this.overlay.create(finalOverlayConfig);
        // create a container for the modal component and attach it to the overlay
        const modalContainer = attachModalContainer(overlayRef, modalConfig, openAnimation, closeAnimation, modalType, this.injector);
        const modalRef = new ModalRef(overlayRef, modalContainer);
        // create a instance of the modal component and attach it to the container
        const componentRef = attachModalComponent(component, modalContainer, modalConfig, modalRef, this.injector);
        modalRef.componentInstance = componentRef.instance;
        // mark the modal as opened
        this._modalManagementService.markModalAsOpened(modalRef);
        // mark the modal as closed once its been closed=
        modalRef.closed.pipe(take(1)).subscribe(() => {
            this._modalManagementService.markModalAsClosed(modalRef);
        });
        return modalRef;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalService, deps: [{ token: i1$4.Overlay }, { token: i0.Injector }, { token: ModalManagementService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalService, providedIn: 'any' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'any' }]
        }], ctorParameters: function () { return [{ type: i1$4.Overlay }, { type: i0.Injector }, { type: ModalManagementService }]; } });

class FocalModalDirective {
    /** @ignore **/
    constructor(_modalService, _elementRef, _animationBuilder, _document) {
        this._modalService = _modalService;
        this._elementRef = _elementRef;
        this._animationBuilder = _animationBuilder;
        this._document = _document;
        /**
         * The type of component to display in the modal. Used to set the default position of the modal
         */
        this.modalType = ModalType.Dialog;
        /** The type of component to display in the modal */
        this.highlightOrigin = true;
        /** The type of component to display in the modal */
        this.animationDurationMs = 450;
        /** When the modal component is initiated */
        this.init = new EventEmitter();
        /** @ignore Specifies if the modal is opened */
        this._opened = false;
        /** @ignore internal configuration of the animation */
        this._animationConfig = {
            cubicBezier: 'cubic-bezier(0, 0, 0.2, 1)',
            modalFadeInMs: 75,
            modalBackgroundColor: 'var(--modal-background)',
        };
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngOnInit() {
        // start the animation and open the modal when the origin element is clicked
        fromEvent(this._elementRef.nativeElement, 'click')
            .pipe(filter(() => !this._opened), takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            // open the modal, the open animation will make it invisible at first, the time that the
            // clone morphs
            const modalRef = this._modalService.open(this.modalComponent, this.modalConfig, this.overlayConfig || {}, this.modalType, this._createFocalOpenAnimation(), defaultAnimationClose);
            // emit the modal ref
            this.init.emit(modalRef);
            this._opened = true;
            // once the modal is fully closed, remove the highlight clone + its overlay (if any)
            modalRef.afterClosed.subscribe(() => {
                if (this.highlightOrigin && this._overlayPaneElement) {
                    this._overlayPaneElement.removeChild(this._elementCloneHighlighted);
                    this._overlayPaneElement.removeChild(this._elementCloneHighlightedOverlay);
                    this._overlayPaneElement = undefined;
                }
                this._opened = false;
            });
            // schedule the the start of the focal / clone animation on the macro-task queue so we can
            // retrieve the dimensions of the modal to display and animate the morph properly
            asyncScheduler.schedule(() => {
                this._startFocalAnimation(modalRef);
            });
        });
    }
    /** Starts the focal animation **/
    _startFocalAnimation(modalRef) {
        this._overlayPaneElement = this._document.querySelector('.cdk-overlay-pane');
        // if the uses closes the modal too rapidly, the overlay pane will be null
        if (!this._overlayPaneElement) {
            return;
        }
        // create a clone of the origin element that will get animated
        this._elementCloneAnimated = this._createClone(this._elementRef.nativeElement);
        // if specified, create another clone of the origin element that will serve as highlight
        if (this.highlightOrigin) {
            this._elementCloneHighlighted = this._elementCloneAnimated.cloneNode(true);
            this._elementCloneHighlighted.classList.add('clone-highlighted');
            // set the zIndex one unit higher than the backdrop
            this._elementCloneHighlighted.style.zIndex = '1001';
            // create a transparent overlay to display above the highlighted element
            this._elementCloneHighlightedOverlay = this.createCloneOverlay(this._elementRef.nativeElement);
            // append the clones to the cdk overlay panel
            this._overlayPaneElement.appendChild(this._elementCloneHighlighted);
            this._overlayPaneElement.appendChild(this._elementCloneHighlightedOverlay);
        }
        // append the clone to the cdk overlay panel
        this._overlayPaneElement.appendChild(this._elementCloneAnimated);
        // now animate the clone
        const factory = this._animationBuilder.build(this.animateIn(modalRef.overlayRef.overlayElement.getBoundingClientRect()));
        this._player = factory.create(this._elementCloneAnimated);
        this._player.onDone(() => {
            // destroy the player after 75ms (the time for the modal container fade in)
            // this will css properties applied by the animations
            // also destroy the animated clone at this moment
            timer(this._animationConfig.modalFadeInMs).subscribe(() => {
                this._stopAnimation();
            });
        });
        // start the animation
        this._player.play();
        // when the modal is being closed, stop the focal animation
        modalRef.closed.pipe(take(1)).subscribe(() => {
            this._stopAnimation();
        });
    }
    /** @ignore stops the open animation */
    _stopAnimation() {
        if (this._player) {
            if (this._overlayPaneElement) {
                this._overlayPaneElement.removeChild(this._elementCloneAnimated);
            }
            this._player.destroy();
            this._player = undefined;
        }
    }
    /** @ignore Creates a clone of the provided element and put is into a wrapper **/
    _createClone(element) {
        const rect = element.getBoundingClientRect();
        const clone = element.cloneNode(true);
        // copy the css styles
        this._synchronizeCssStyles(element, clone, true);
        const wrapper = document.createElement('div');
        wrapper.appendChild(clone);
        wrapper.style.position = 'absolute';
        wrapper.style.top = `${rect.top}px`;
        wrapper.style.left = `${rect.left}px`;
        wrapper.style.right = `${rect.right}px`;
        wrapper.style.bottom = `${rect.bottom}px`;
        wrapper.style.width = `${rect.width}px`;
        wrapper.style.height = `${rect.height}px`;
        // put the wrapper above the backdrop
        wrapper.style.zIndex = '1001';
        // set the wrapper bgcolor to the modal background color, then we are going to fade the clone
        // out so it will look like the final modal
        wrapper.style.backgroundColor = this._animationConfig.modalBackgroundColor;
        return wrapper;
    }
    /** @ignore Creates a transparent overlay above the specified element **/
    createCloneOverlay(element) {
        const rect = element.getBoundingClientRect();
        const overlay = document.createElement('div');
        overlay.style.position = 'absolute';
        overlay.style.top = `${rect.top}px`;
        overlay.style.left = `${rect.left}px`;
        overlay.style.right = `${rect.right}px`;
        overlay.style.bottom = `${rect.bottom}px`;
        overlay.style.width = `${rect.width}px`;
        overlay.style.height = `${rect.height}px`;
        overlay.style.zIndex = '1002';
        overlay.style.backgroundColor = 'transparent';
        return overlay;
    }
    /** @ignore Creates the open animation for the modal being displayed via the modal service **/
    _createFocalOpenAnimation() {
        return [
            sequence([
                style({
                    opacity: 0,
                }),
                animate(`${this._animationConfig.modalFadeInMs}ms ${this.animationDurationMs}ms ${this._animationConfig.cubicBezier}`, style({
                    opacity: 1,
                })),
            ]),
        ];
    }
    /** @ignore Returns the animation metadata for the fade in **/
    animateIn(modalComponentRect) {
        return [
            group([
                sequence([
                    style({
                        left: this._elementCloneAnimated.style.left,
                        top: this._elementCloneAnimated.style.top,
                        width: this._elementCloneAnimated.style.width,
                        height: this._elementCloneAnimated.style.height,
                    }),
                    animate(`${this.animationDurationMs}ms ${this._animationConfig.cubicBezier}`, style({
                        left: `${modalComponentRect.left}px`,
                        top: `${modalComponentRect.top}px`,
                        width: modalComponentRect.width + 'px',
                        height: modalComponentRect.height + 'px',
                        // transform: 'translateX(-50%) translateX(-50%)'
                    })),
                ]),
                // select the cloned source element
                query(`${this._elementRef.nativeElement.tagName}`, [
                    style({
                        width: this._elementCloneAnimated.style.width,
                        height: this._elementCloneAnimated.style.height,
                    }),
                    animate(`${this.animationDurationMs}ms ${this._animationConfig.cubicBezier}`, style({
                        width: modalComponentRect.width + 'px',
                        height: modalComponentRect.height + 'px',
                    })),
                ]),
                query(`${this._elementRef.nativeElement.tagName}`, [
                    style({ opacity: '1' }),
                    animate(`${this.animationDurationMs}ms ${this._animationConfig.cubicBezier}`, style({ opacity: 0 })),
                ]),
            ]),
        ];
    }
    /**
     * @ignore Sync css styles
     * https://stackoverflow.com/questions/1848445/duplicating-an-element-and-its-style-with-javascript
     */
    _synchronizeCssStyles(source, destination, recursively) {
        // if recursively = true, then we assume the src dom structure and destination dom structure are
        // identical (ie: cloneNode was used) window.getComputedStyle vs
        // document.defaultView.getComputedStyle
        destination.style.cssText = document.defaultView.getComputedStyle(source).cssText;
        if (recursively) {
            const vSrcElements = source.getElementsByTagName('*');
            const vDstElements = destination.getElementsByTagName('*');
            for (let i = vSrcElements.length; i--;) {
                const vSrcElement = vSrcElements[i];
                const vDstElement = vDstElements[i];
                vDstElement.style.cssText = document.defaultView.getComputedStyle(vSrcElement).cssText;
            }
        }
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FocalModalDirective, deps: [{ token: ModalService }, { token: i0.ElementRef }, { token: i1$1.AnimationBuilder }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FocalModalDirective, selector: "[avnFocalModal]", inputs: { modalComponent: ["avnFocalModal", "modalComponent"], modalConfig: "modalConfig", modalType: "modalType", overlayConfig: "overlayConfig", highlightOrigin: "highlightOrigin", animationDurationMs: "animationDurationMs" }, outputs: { init: "init" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FocalModalDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnFocalModal]',
                }]
        }], ctorParameters: function () { return [{ type: ModalService }, { type: i0.ElementRef }, { type: i1$1.AnimationBuilder }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { modalComponent: [{
                type: Input,
                args: ['avnFocalModal']
            }], modalConfig: [{
                type: Input
            }], modalType: [{
                type: Input
            }], overlayConfig: [{
                type: Input
            }], highlightOrigin: [{
                type: Input
            }], animationDurationMs: [{
                type: Input
            }], init: [{
                type: Output
            }] } });

class DrawerContentComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DrawerContentComponent, selector: "avn-drawer-content", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{height:calc(100vh - 24px + 2 * var(--space-md) - var(--space-md));padding:0 var(--space-md);overflow:auto}:host p,:host label{font-size:var(--text-sm)}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-drawer-content', template: "<ng-content></ng-content>\n", styles: [":host{height:calc(100vh - 24px + 2 * var(--space-md) - var(--space-md));padding:0 var(--space-md);overflow:auto}:host p,:host label{font-size:var(--text-sm)}\n"] }]
        }] });

class DrawerFooterComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DrawerFooterComponent, selector: "avn-drawer-footer", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{padding:var(--space-lg) var(--space-md);overflow:hidden;display:flex;flex-direction:row;align-items:flex-start}:host ::ng-deep avn-button{display:block;margin-right:var(--space-md)}:host-context(.left){justify-content:flex-end}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-drawer-footer', template: "<ng-content></ng-content>\n", styles: [":host{padding:var(--space-lg) var(--space-md);overflow:hidden;display:flex;flex-direction:row;align-items:flex-start}:host ::ng-deep avn-button{display:block;margin-right:var(--space-md)}:host-context(.left){justify-content:flex-end}\n"] }]
        }] });

class DrawerHeaderComponent {
    constructor() {
        /**
         * the icon to use. i.e tag, or any other ligature for supported fonts.
         * this should follow the format of namespace:icon name.
         * for example a font-awesome icon is fa:icon-name
         * https://fontawesome.com/icons?d=gallery
         * a material icon is action:name_of_icon ( places, social, maps )
         * https://material.io/tools/icons/?style=baseline
         */
        this.icon = 'action:close';
        /**
         * dispatched when the header icon is clicked
         */
        this.closeClicked = new EventEmitter();
    }
    /**
     * @ignore
     */
    close() {
        this.closeClicked.emit(true);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DrawerHeaderComponent, selector: "avn-drawer-header", inputs: { title: "title", icon: "icon" }, outputs: { closeClicked: "closeClicked" }, ngImport: i0, template: "<h5>{{ title }}</h5>\n<avn-icon [icon]=\"icon\" (click)=\"close()\"></avn-icon>\n", styles: [":host{display:flex;flex-direction:row;justify-content:space-between;padding:var(--space-md);align-items:center}:host>h5{margin:var(--space-sm) 0;text-transform:capitalize}:host>avn-icon{display:block;padding:0;margin:0;cursor:pointer;align-self:flex-start}\n"], dependencies: [{ kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-drawer-header', template: "<h5>{{ title }}</h5>\n<avn-icon [icon]=\"icon\" (click)=\"close()\"></avn-icon>\n", styles: [":host{display:flex;flex-direction:row;justify-content:space-between;padding:var(--space-md);align-items:center}:host>h5{margin:var(--space-sm) 0;text-transform:capitalize}:host>avn-icon{display:block;padding:0;margin:0;cursor:pointer;align-self:flex-start}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], icon: [{
                type: Input
            }], closeClicked: [{
                type: Output
            }] } });

class DrawerLayoutComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DrawerLayoutComponent, selector: "avn-drawer-layout", ngImport: i0, template: "<ng-content select=\"avn-drawer-header\"> </ng-content>\n<ng-content class=\"avn-drawer-content\"> </ng-content>\n<ng-content select=\"avn-drawer-footer\"> </ng-content>\n", styles: [":host{display:flex;height:100vh;flex-direction:column}:host>avn-drawer-footer{height:var(--space-md)}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DrawerLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-drawer-layout', template: "<ng-content select=\"avn-drawer-header\"> </ng-content>\n<ng-content class=\"avn-drawer-content\"> </ng-content>\n<ng-content select=\"avn-drawer-footer\"> </ng-content>\n", styles: [":host{display:flex;height:100vh;flex-direction:column}:host>avn-drawer-footer{height:var(--space-md)}\n"] }]
        }] });

/**
 * Base component of a toast that can be extended from to create a customized toast component
 */
class ToastBaseComponent {
    onMouseOver() {
        this.componentHovered$.next(true);
    }
    onMouseOut() {
        this.componentHovered$.next(false);
    }
    constructor() {
        /**
         * Emit when the toast is destroyed
         */
        this.destroy = new EventEmitter();
        /**
         * Emit after close animation is done
         */
        this.closeAnimationDone = new EventEmitter();
        /**
         * Pattern used to close all subscriptions
         *
         * @ignore
         */
        this.componentDestroyed$ = new Subject();
        /**
         * Tracks if the component is hovered
         *
         * @ignore
         */
        this.componentHovered$ = new BehaviorSubject(false);
        this.componentHovered$
            .pipe(switchMap((val) => {
            if (val) {
                return interval(1000).pipe(map((_) => this.dismissalTimeMS));
            }
            return interval(1000).pipe(map((v) => this.dismissalTimeMS / 2 - v * 1000));
        }), filter((t) => t <= 0), takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            this.destroy.emit(this);
            this.destroy.complete();
        });
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToastBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ToastBaseComponent, outputs: { destroy: "destroy", closeAnimationDone: "closeAnimationDone" }, host: { listeners: { "mouseover": "onMouseOver()", "mouseout": "onMouseOut()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToastBaseComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return []; }, propDecorators: { destroy: [{
                type: Output
            }], closeAnimationDone: [{
                type: Output
            }], onMouseOver: [{
                type: HostListener,
                args: ['mouseover']
            }], onMouseOut: [{
                type: HostListener,
                args: ['mouseout']
            }] } });

const ANIM_SPEED$1 = '300ms';
const BEZIER = 'cubic-bezier(0.25, 0.8, 0.25, 1)';
class StandardToastComponent extends ToastBaseComponent {
    get hasIcon() {
        return !!this.toastCfg.icon;
    }
    /**
     * Binding for the animation to get the values for translateX and translateY
     */
    get toastState() {
        let startingTranslateXValueOnEnter;
        let endingTranslateYValueOnLeave;
        switch (this.toastSettings.alignment) {
            case ToastAlignmentType.BottomLeft:
                startingTranslateXValueOnEnter = '-100%';
                endingTranslateYValueOnLeave = '100%';
                break;
            case ToastAlignmentType.BottomRight:
                startingTranslateXValueOnEnter = '100%';
                endingTranslateYValueOnLeave = '100%';
                break;
            case ToastAlignmentType.TopLeft:
                startingTranslateXValueOnEnter = '-100%';
                endingTranslateYValueOnLeave = '-100%';
                break;
            case ToastAlignmentType.TopRight:
                startingTranslateXValueOnEnter = '100%';
                endingTranslateYValueOnLeave = '-100%';
                break;
        }
        const animationValues = {
            value: true,
            params: {
                startingTranslateXValueOnEnter,
                endingTranslateYValueOnLeave,
            },
        };
        return animationValues;
    }
    /**
     * Binding for animation when it's done
     *
     * @param event
     */
    animationDone(event) {
        if (event.phaseName === 'done' && event.toState === 'void') {
            this.closeAnimationDone.emit();
        }
    }
    constructor(toastCfg, toastSettings, renderer, elementRef) {
        super();
        this.toastCfg = toastCfg;
        this.toastSettings = toastSettings;
        this.renderer = renderer;
        this.elementRef = elementRef;
        /**
         * When an action in the toast is clicked
         */
        this.clicked = new EventEmitter();
    }
    ngOnInit() {
        if (this.toastCfg.theme) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'border-color', `var(--${this.toastCfg.theme}-base)`);
            this.renderer.addClass(this.elementRef.nativeElement, `theme-${this.toastCfg.theme}`);
        }
        else {
            this.renderer.setStyle(this.elementRef.nativeElement, 'border-color', `var(--selection-component-background)`);
        }
        if (this.toastCfg.className) {
            this.renderer.addClass(this.elementRef.nativeElement, this.toastCfg.className);
        }
    }
    onClick(action) {
        this.clicked.emit({ action, data: this.toastCfg.data });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StandardToastComponent, deps: [{ token: TOAST_DATA }, { token: TOAST_SETTINGS }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: StandardToastComponent, selector: "avn-standard-toast", outputs: { clicked: "clicked" }, host: { listeners: { "@openingClosingToast.done": "animationDone($event)" }, properties: { "class.has-icon": "this.hasIcon", "@openingClosingToast": "this.toastState" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"icon-message\">\n  <avn-icon *ngIf=\"toastCfg.icon\" [icon]=\"toastCfg?.icon\"></avn-icon>\n  <div class=\"message\">\n    <h3>{{ toastCfg?.title }}</h3>\n    <p>{{ toastCfg?.body }}</p>\n  </div>\n</div>\n\n<div class=\"actions\">\n  <avn-icon *ngFor=\"let action of toastCfg?.actions\" (click)=\"onClick(action)\" [icon]=\"action.icon\" [title]=\"action.title || ''\"></avn-icon>\n</div>\n", styles: [":host{width:350px;border-left:5px solid;padding:var(--space-md);border-radius:.2rem;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);color:var(--modal-on);background-color:var(--modal-background);display:block}:host:hover,:host:focus{box-shadow:0 -1px 0 -2px #00000040,0 2px 2px #0003,0 1px 5px #0000002b!important}:host.has-icon{padding:var(--space-md) var(--space-md) var(--space-md) 0}:host .icon-message{display:flex;flex-direction:row;align-items:center}:host .icon-message avn-icon{margin:var(--space-md);width:50px;height:50px}:host .icon-message avn-icon ::ng-deep .material-icons,:host .icon-message avn-icon ::ng-deep .fa{font-size:var(--text-xxxl)}:host h3{font-size:var(--text-sm);margin:0 0 var(--space-sm) 0}:host p{font-size:var(--text-sm);margin:0}:host .actions{display:flex;width:100%;justify-content:flex-end;margin-top:var(--space-sm)}:host .actions avn-icon:not(:last-child){margin-right:var(--space-md)}:host :host-context(.dmb-aspect){border-left:0}:host :host-context(.dmb-aspect) h3{font-size:14px}:host :host-context(.dmb-aspect) p{font-size:14px}:host :host-context(.dmb-aspect).theme-primary{background-color:var(--primary-base);color:var(--primary-on);border-color:var(--primary-variant)}:host :host-context(.dmb-aspect).theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on);border-color:var(--secondary-variant)}:host :host-context(.dmb-aspect).theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on);border-color:var(--highlight-variant)}:host :host-context(.dmb-aspect).theme-danger{background-color:var(--danger-base);color:var(--danger-on);border-color:var(--danger-variant)}:host :host-context(.dmb-aspect).theme-warning{background-color:var(--warning-base);color:var(--warning-on);border-color:var(--warning-variant)}:host :host-context(.dmb-aspect).theme-info{background-color:var(--info-base);color:var(--info-on);border-color:var(--info-variant)}:host :host-context(.dmb-aspect).theme-success{background-color:var(--success-base);color:var(--success-on);border-color:var(--success-variant)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], animations: [
            trigger('openingClosingToast', [
                transition(':enter', [
                    style({
                        transform: 'translateX({{startingTranslateXValueOnEnter}})',
                        opacity: 0,
                    }),
                    animate(`${ANIM_SPEED$1} ${BEZIER}`, style({
                        transform: 'translateX(0)',
                        opacity: 1,
                    })),
                ]),
                transition(':leave', [
                    style({
                        transform: 'translateY(0)',
                        opacity: 1,
                    }),
                    animate(`${ANIM_SPEED$1} ${BEZIER}`, style({
                        transform: 'translateY({{endingTranslateYValueOnLeave}})',
                        opacity: 0,
                    })),
                ]),
            ]),
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StandardToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-standard-toast', animations: [
                        trigger('openingClosingToast', [
                            transition(':enter', [
                                style({
                                    transform: 'translateX({{startingTranslateXValueOnEnter}})',
                                    opacity: 0,
                                }),
                                animate(`${ANIM_SPEED$1} ${BEZIER}`, style({
                                    transform: 'translateX(0)',
                                    opacity: 1,
                                })),
                            ]),
                            transition(':leave', [
                                style({
                                    transform: 'translateY(0)',
                                    opacity: 1,
                                }),
                                animate(`${ANIM_SPEED$1} ${BEZIER}`, style({
                                    transform: 'translateY({{endingTranslateYValueOnLeave}})',
                                    opacity: 0,
                                })),
                            ]),
                        ]),
                    ], template: "<div class=\"icon-message\">\n  <avn-icon *ngIf=\"toastCfg.icon\" [icon]=\"toastCfg?.icon\"></avn-icon>\n  <div class=\"message\">\n    <h3>{{ toastCfg?.title }}</h3>\n    <p>{{ toastCfg?.body }}</p>\n  </div>\n</div>\n\n<div class=\"actions\">\n  <avn-icon *ngFor=\"let action of toastCfg?.actions\" (click)=\"onClick(action)\" [icon]=\"action.icon\" [title]=\"action.title || ''\"></avn-icon>\n</div>\n", styles: [":host{width:350px;border-left:5px solid;padding:var(--space-md);border-radius:.2rem;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);color:var(--modal-on);background-color:var(--modal-background);display:block}:host:hover,:host:focus{box-shadow:0 -1px 0 -2px #00000040,0 2px 2px #0003,0 1px 5px #0000002b!important}:host.has-icon{padding:var(--space-md) var(--space-md) var(--space-md) 0}:host .icon-message{display:flex;flex-direction:row;align-items:center}:host .icon-message avn-icon{margin:var(--space-md);width:50px;height:50px}:host .icon-message avn-icon ::ng-deep .material-icons,:host .icon-message avn-icon ::ng-deep .fa{font-size:var(--text-xxxl)}:host h3{font-size:var(--text-sm);margin:0 0 var(--space-sm) 0}:host p{font-size:var(--text-sm);margin:0}:host .actions{display:flex;width:100%;justify-content:flex-end;margin-top:var(--space-sm)}:host .actions avn-icon:not(:last-child){margin-right:var(--space-md)}:host :host-context(.dmb-aspect){border-left:0}:host :host-context(.dmb-aspect) h3{font-size:14px}:host :host-context(.dmb-aspect) p{font-size:14px}:host :host-context(.dmb-aspect).theme-primary{background-color:var(--primary-base);color:var(--primary-on);border-color:var(--primary-variant)}:host :host-context(.dmb-aspect).theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on);border-color:var(--secondary-variant)}:host :host-context(.dmb-aspect).theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on);border-color:var(--highlight-variant)}:host :host-context(.dmb-aspect).theme-danger{background-color:var(--danger-base);color:var(--danger-on);border-color:var(--danger-variant)}:host :host-context(.dmb-aspect).theme-warning{background-color:var(--warning-base);color:var(--warning-on);border-color:var(--warning-variant)}:host :host-context(.dmb-aspect).theme-info{background-color:var(--info-base);color:var(--info-on);border-color:var(--info-variant)}:host :host-context(.dmb-aspect).theme-success{background-color:var(--success-base);color:var(--success-on);border-color:var(--success-variant)}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TOAST_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TOAST_SETTINGS]
                }] }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { clicked: [{
                type: Output
            }], hasIcon: [{
                type: HostBinding,
                args: ['class.has-icon']
            }], toastState: [{
                type: HostBinding,
                args: ['@openingClosingToast']
            }], animationDone: [{
                type: HostListener,
                args: ['@openingClosingToast.done', ['$event']]
            }] } });

/**
 * Reference of a toast component
 */
class ToastRef {
    constructor(portalHostRef) {
        this.portalHostRef = portalHostRef;
    }
    /**
     * Propagate destroy event down to the inner toast component
     */
    destroy() {
        this.componentInstance.destroy.emit(this.componentInstance);
        // ensure that subscriptions are closed.
        this.componentInstance.destroy.complete();
        // this.portalHostRef.detach();
    }
}

/**
 * This component is responsible for showing 'tasks' components (i.e. components responsible for giving feedback on long processing tasks) in a sticky modal.
 * - It can be minimized into an icon mode showing the count of active tasks.
 * - It cannot be closed until all tasks are completed
 */
class TaskPanelComponent {
    constructor(_dialogRef, runningTasks$, taskPanelSettings, _injector, elementRef) {
        this._dialogRef = _dialogRef;
        this._injector = _injector;
        /** Emits when the panel is closed **/
        this.closed = new EventEmitter();
        this._minimizedSubject = new BehaviorSubject(false);
        this._componentHeightSubject = new ReplaySubject(1);
        this._componentDestroyed$ = new Subject();
        this.title$ = taskPanelSettings.progressTitle$;
        this.componentHeightPx$ = this._componentHeightSubject.asObservable();
        this.minimized$ = this._minimizedSubject.asObservable();
        this._initModalDimensionsListener(elementRef);
        // update the modal width when it's minimized
        this._initialWidth = this._dialogRef.overlayRef.overlayElement.style.width;
        this.runningTasksCount$ = runningTasks$.pipe(map((tasks) => tasks.length));
        this.minimized$.pipe(takeUntil(this._componentDestroyed$)).subscribe((minimized) => {
            if (minimized) {
                this._dialogRef.overlayRef.overlayElement.style.width = 'auto';
            }
            else {
                this._dialogRef.overlayRef.overlayElement.style.width = this._initialWidth;
            }
        });
        // adjust the title based on completion
        this.title$ = this.runningTasksCount$.pipe(switchMap$1((taskCount) => (taskCount === 0 ? taskPanelSettings.completionTitle$ : taskPanelSettings.progressTitle$)));
        // auto open the modal when all tasks are completed
        this.runningTasksCount$.pipe(withLatestFrom(this.minimized$), takeUntil(this._componentDestroyed$)).subscribe(([tasksCount, minimized]) => {
            if (tasksCount === 0 && minimized) {
                this._minimizedSubject.next(false);
            }
        });
    }
    _initModalDimensionsListener(hostRef) {
        // To avoid duplication of the resize observer logic, reuse our resize directive and bind its events
        this._resizeDirective = new ResizeDirective(hostRef);
        this._resizeDirective.debounceTime = 0;
        this._resizeDirective.emitInitialEvent = true;
        this._resizeDirective.avnResize
            .pipe(startWith(hostRef.nativeElement.clientHeight), map((evt) => evt.height), takeUntil(this._componentDestroyed$))
            .subscribe((height) => this._componentHeightSubject.next(height));
        this._resizeDirective.ngAfterViewInit();
    }
    /** Minimizes the modal **/
    minimize() {
        this._minimizedSubject.next(true);
    }
    /** Expands the modal **/
    expand() {
        this._minimizedSubject.next(false);
    }
    get isMinimized() {
        return this._minimizedSubject.value;
    }
    canClose() {
        return false;
    }
    onClose() {
        this.closed.emit();
    }
    /** Dynamically creates an instance of a task component and insert it into the modal **/
    registerTaskComponent(component, data) {
        const injector = Injector.create({
            providers: [
                {
                    provide: MODAL_DATA,
                    useValue: data,
                },
            ],
            parent: this._injector,
        });
        const taskComponentRef = this._tasksContainer.createComponent(component, { injector });
        taskComponentRef.changeDetectorRef.detectChanges();
        return taskComponentRef;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
        this._resizeDirective.ngOnDestroy();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelComponent, deps: [{ token: ModalRef }, { token: TASK_PANEL_RUNNING_TASKS }, { token: TASK_PANEL_SETTINGS }, { token: i0.Injector }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TaskPanelComponent, selector: "avn-task-panel.component", outputs: { closed: "closed" }, viewQueries: [{ propertyName: "_tasksContainer", first: true, predicate: ["tasksContainer"], descendants: true, read: ViewContainerRef }], ngImport: i0, template: "<avn-dialog-layout>\n  <avn-dialog-header [template]=\"(minimized$ | async) ? minimizedHeader : regularHeader\" (click)=\"expand()\" [class.minimized]=\"minimized$ | async\"></avn-dialog-header>\n\n  <avn-dialog-content avnScroll [style.display]=\"(minimized$ | async) ? 'none' : 'block'\">\n    <ng-container #tasksContainer></ng-container>\n  </avn-dialog-content>\n</avn-dialog-layout>\n\n<ng-template #minimizedHeader>\n  <ng-container *ngTemplateOutlet=\"statusIcon; context: { showCount: true }\"></ng-container>\n</ng-template>\n\n<ng-template #regularHeader>\n  <div class=\"header-wrapper\">\n    <span>{{ title$ | async }}</span>\n    <ng-container *ngTemplateOutlet=\"statusIcon; context: { showCount: false }\"></ng-container>\n  </div>\n  <div class=\"icons-wrapper\">\n    <avn-icon *ngIf=\"(runningTasksCount$ | async) > 0\" [icon]=\"'action:expand_more'\" (click)=\"$event.stopPropagation(); minimize()\"></avn-icon>\n    <avn-icon *ngIf=\"(runningTasksCount$ | async) === 0\" [icon]=\"'action:close'\" (click)=\"onClose()\"></avn-icon>\n  </div>\n</ng-template>\n\n<ng-template #statusIcon let-showCount=\"showCount\">\n  <ng-container *ngIf=\"(runningTasksCount$ | async) > 0; else tasksCompleted\">\n    <ng-container *ngIf=\"showCount; else noCount\">\n      <avn-count-icon [countTheme]=\"'info'\" [count]=\"runningTasksCount$ | async\" class=\"count-icon-cursor-inherit\">\n        <avn-icon class=\"in-progress\"  [icon]=\"'notification:sync'\" [fontSize]=\"22\"></avn-icon>\n      </avn-count-icon>\n    </ng-container>\n    <ng-template #noCount>\n      <avn-icon class=\"in-progress\" [icon]=\"'notification:sync'\" [fontSize]=\"22\"></avn-icon>\n    </ng-template>\n  </ng-container>\n\n  <ng-template #tasksCompleted>\n    <avn-icon [icon]=\"'action:check_circle'\" [avnTheme]=\"'success'\" [fontSize]=\"22\"></avn-icon>\n  </ng-template>\n</ng-template>\n", styles: [":host{display:block;-webkit-user-select:none;user-select:none}:host avn-dialog-header{display:flex;justify-content:space-between}:host avn-dialog-header.minimized{cursor:pointer}:host avn-dialog-header .header-wrapper{display:grid;grid-auto-flow:column;grid-gap:var(--space-md);align-items:center}:host avn-dialog-header .icons-wrapper{display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-sm);-webkit-user-select:none;user-select:none}:host avn-dialog-content{padding:0}:host avn-dialog-content ::ng-deep>*:not(:last-child){border-bottom:1px solid var(--modal-divider)}:host avn-icon.in-progress{animation:avn-spin 1.5s infinite linear}@keyframes avn-spin{0%{transform:rotate(359deg)}to{transform:rotate(0)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: CountIconComponent, selector: "avn-count-icon", inputs: ["count", "countTheme"] }, { kind: "component", type: DialogLayoutComponent, selector: "avn-dialog-layout" }, { kind: "component", type: DialogHeaderComponent, selector: "avn-dialog-header", inputs: ["title", "template", "icon", "showCloseIcon"], outputs: ["closeClicked"] }, { kind: "component", type: DialogContentComponent, selector: "avn-dialog-content" }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-task-panel.component', changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-dialog-layout>\n  <avn-dialog-header [template]=\"(minimized$ | async) ? minimizedHeader : regularHeader\" (click)=\"expand()\" [class.minimized]=\"minimized$ | async\"></avn-dialog-header>\n\n  <avn-dialog-content avnScroll [style.display]=\"(minimized$ | async) ? 'none' : 'block'\">\n    <ng-container #tasksContainer></ng-container>\n  </avn-dialog-content>\n</avn-dialog-layout>\n\n<ng-template #minimizedHeader>\n  <ng-container *ngTemplateOutlet=\"statusIcon; context: { showCount: true }\"></ng-container>\n</ng-template>\n\n<ng-template #regularHeader>\n  <div class=\"header-wrapper\">\n    <span>{{ title$ | async }}</span>\n    <ng-container *ngTemplateOutlet=\"statusIcon; context: { showCount: false }\"></ng-container>\n  </div>\n  <div class=\"icons-wrapper\">\n    <avn-icon *ngIf=\"(runningTasksCount$ | async) > 0\" [icon]=\"'action:expand_more'\" (click)=\"$event.stopPropagation(); minimize()\"></avn-icon>\n    <avn-icon *ngIf=\"(runningTasksCount$ | async) === 0\" [icon]=\"'action:close'\" (click)=\"onClose()\"></avn-icon>\n  </div>\n</ng-template>\n\n<ng-template #statusIcon let-showCount=\"showCount\">\n  <ng-container *ngIf=\"(runningTasksCount$ | async) > 0; else tasksCompleted\">\n    <ng-container *ngIf=\"showCount; else noCount\">\n      <avn-count-icon [countTheme]=\"'info'\" [count]=\"runningTasksCount$ | async\" class=\"count-icon-cursor-inherit\">\n        <avn-icon class=\"in-progress\"  [icon]=\"'notification:sync'\" [fontSize]=\"22\"></avn-icon>\n      </avn-count-icon>\n    </ng-container>\n    <ng-template #noCount>\n      <avn-icon class=\"in-progress\" [icon]=\"'notification:sync'\" [fontSize]=\"22\"></avn-icon>\n    </ng-template>\n  </ng-container>\n\n  <ng-template #tasksCompleted>\n    <avn-icon [icon]=\"'action:check_circle'\" [avnTheme]=\"'success'\" [fontSize]=\"22\"></avn-icon>\n  </ng-template>\n</ng-template>\n", styles: [":host{display:block;-webkit-user-select:none;user-select:none}:host avn-dialog-header{display:flex;justify-content:space-between}:host avn-dialog-header.minimized{cursor:pointer}:host avn-dialog-header .header-wrapper{display:grid;grid-auto-flow:column;grid-gap:var(--space-md);align-items:center}:host avn-dialog-header .icons-wrapper{display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-sm);-webkit-user-select:none;user-select:none}:host avn-dialog-content{padding:0}:host avn-dialog-content ::ng-deep>*:not(:last-child){border-bottom:1px solid var(--modal-divider)}:host avn-icon.in-progress{animation:avn-spin 1.5s infinite linear}@keyframes avn-spin{0%{transform:rotate(359deg)}to{transform:rotate(0)}}\n"] }]
        }], ctorParameters: function () { return [{ type: ModalRef, decorators: [{
                    type: Inject,
                    args: [ModalRef]
                }] }, { type: i10.Observable, decorators: [{
                    type: Inject,
                    args: [TASK_PANEL_RUNNING_TASKS]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TASK_PANEL_SETTINGS]
                }] }, { type: i0.Injector }, { type: i0.ElementRef }]; }, propDecorators: { _tasksContainer: [{
                type: ViewChild,
                args: ['tasksContainer', { read: ViewContainerRef }]
            }], closed: [{
                type: Output
            }] } });

/**
 * This service is responsible for creating a sticky panel showing feedback for long running tasks.
 * You can register components to be inserted into the panel.
 * Those components need to implement the `IStickyModalTaskComponent` in order to give feedback about their completion.
 */
class TaskPanelService {
    constructor(overlay, injector, _modalManagementService, _toastSettings, taskPanelSettings) {
        this.overlay = overlay;
        this.injector = injector;
        this._modalManagementService = _modalManagementService;
        this._toastSettings = _toastSettings;
        this.taskPanelSettings = taskPanelSettings;
        /** Emits when the task panel is closed **/
        this.taskPanelClosed = new EventEmitter();
        this._taskPanelComponentRefSubject = new BehaviorSubject(null);
        this._tasksSubject = new BehaviorSubject([]);
        this._processingTasksSubject$ = new BehaviorSubject([]);
        this.taskPanelComponentRef$ = this._taskPanelComponentRefSubject.asObservable();
        this.tasks$ = this._tasksSubject.asObservable();
        this.ongoingTasks$ = this._processingTasksSubject$.asObservable();
    }
    /**
     * Adds a task component to the tasks panel
     * **/
    addTaskComponent(taskComponent, taskComponentData, openAnimation = taskPanelAnimationOpen, closeAnimation = taskPanelAnimationClose) {
        // make sure only one instance of a task component is opened at the same time (may change at some stage)
        const taskComponentAlreadyExists = this._tasksSubject.value.some((item) => item.constructor.name === taskComponent.name);
        if (taskComponentAlreadyExists) {
            return null;
        }
        const isPanelOpened = !!this._taskPanelComponentRefSubject.value;
        // create the panel if its not opened
        if (!isPanelOpened) {
            // get the overlay config depending on modal type
            const finalOverlayConfig = getDefaultTaskPanelOverlayConfig(this.overlay, this._toastSettings, this.taskPanelSettings);
            // create the overlay
            this._overlayRef = this.overlay.create(finalOverlayConfig);
            // create a container for the modal component and attach it to the overlay
            const modalContainer = attachModalContainer(this._overlayRef, {}, openAnimation, closeAnimation, ModalType.TaskPanel, this.injector);
            this._modalRef = new ModalRef(this._overlayRef, modalContainer);
            // create a instance of the modal component and attach it to the container
            const componentRef = attachModalComponent(TaskPanelComponent, modalContainer, {}, this._modalRef, this.injector, [
                {
                    provide: TASK_PANEL_RUNNING_TASKS,
                    useValue: this.ongoingTasks$,
                },
            ]);
            this._modalRef.componentInstance = componentRef.instance;
            componentRef.instance.closed.pipe(takeUntil(this._modalRef.afterClosed)).subscribe(() => {
                this._modalRef.close();
                this.taskPanelClosed.emit();
            });
            // mark the modal as opened
            this._modalManagementService.markModalAsOpened(this._modalRef);
            // mark the modal as closed once its been closed=
            this._modalRef.closed.pipe(take(1)).subscribe(() => {
                this._taskPanelComponentRefSubject.next(null);
                this._modalRef = null;
                this._overlayRef = null;
                this._modalManagementService.markModalAsClosed(this._modalRef);
                this._tasksSubject.next([]);
            });
            this._taskPanelComponentRefSubject.next(componentRef);
            componentRef.changeDetectorRef.detectChanges();
        }
        // insert the new task component in the panel
        const itemComponentRef = this._taskPanelComponentRefSubject.value.instance.registerTaskComponent(taskComponent, taskComponentData);
        itemComponentRef.changeDetectorRef.detectChanges();
        this._taskPanelComponentRefSubject.value.changeDetectorRef.detectChanges();
        this._tasksSubject.next([...this._tasksSubject.value, itemComponentRef.instance]);
        itemComponentRef.instance.completed$.pipe(startWith(false), distinctUntilChanged(), takeUntil(this.taskPanelClosed)).subscribe((completed) => {
            if (completed) {
                this._processingTasksSubject$.next(this._processingTasksSubject$.value.filter((item) => item !== itemComponentRef.instance));
            }
            else {
                this._processingTasksSubject$.next([...this._processingTasksSubject$.value, itemComponentRef.instance]);
            }
        });
        // check if the task should hide on completion (item settings overrides default settings)
        const hideTaskOnCompletion = itemComponentRef.instance.hideTaskOnCompletion ?? this.taskPanelSettings.hideTaskOnCompletion;
        if (hideTaskOnCompletion) {
            itemComponentRef.instance.completed$.pipe(filter(Boolean), take(1), takeUntil(this._modalRef.closed)).subscribe(() => {
                itemComponentRef.destroy();
            });
        }
        return itemComponentRef;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelService, deps: [{ token: i1$4.Overlay }, { token: i0.Injector }, { token: ModalManagementService }, { token: TOAST_SETTINGS }, { token: TASK_PANEL_SETTINGS }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$4.Overlay }, { type: i0.Injector }, { type: ModalManagementService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TOAST_SETTINGS]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TASK_PANEL_SETTINGS]
                }] }]; } });

/**
 * This class manage all toasts. It keeps track of a queue of toasts to open, opens one at time and
 * closes on timeout or on user's click event.
 */
class ToastQueueComponent {
    constructor(componentFactoryResolver, injector, appRef, toastSettings, overlayRef, _taskPanelService) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.appRef = appRef;
        this.toastSettings = toastSettings;
        this.overlayRef = overlayRef;
        this._taskPanelService = _taskPanelService;
        /**
         * Subject that will emit the next toast component to display
         */
        this.toastQSubject = new Subject();
        /**
         * A queue of toast components to display
         */
        this.toastQueue = [];
        /** the current showing toast */
        this.currentToast = undefined;
        /**
         * Boolean value that indicates if there is currently a toast displaying on UI
         */
        this.hasToastShowing = false;
        /**
         * Pattern used to close all subscriptions
         *
         * @ignore
         */
        this.componentDestroyed$ = new Subject();
        // Create a timer observable to pull the next toast to display from the toast queue periodically
        const toastCheckerTimer = timer(0, 200);
        toastCheckerTimer.pipe(takeUntil(this.componentDestroyed$)).subscribe((_) => {
            if (this.toastQueue.length > 0 && !this.hasToastShowing) {
                this.currentToast = this.toastQueue.shift();
                this.toastQSubject.next(this.currentToast);
            }
        });
        const isToastOnTop = this.toastSettings.alignment === ToastAlignmentType.TopRight || this.toastSettings.alignment === ToastAlignmentType.TopLeft;
        this._taskPanelService.taskPanelComponentRef$
            .pipe(observeOn(animationFrameScheduler), switchMap$1((ref) => {
            const taskPanelHeight$ = !ref ? of(0) : ref.instance.componentHeightPx$;
            return taskPanelHeight$.pipe(map((height) => {
                if (isToastOnTop) {
                    this.overlayRef.overlayElement.parentElement.style.paddingTop = `${height}px`;
                }
                else {
                    this.overlayRef.overlayElement.parentElement.style.paddingBottom = `${height}px`;
                }
                return height;
            }));
        }), takeUntil(this.componentDestroyed$))
            .subscribe();
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        // Unsubscribe all subscriptions
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /**
     * Adds the toast to the queue. A promise is returned with the reference to the toast
     * once the toast is created
     *
     * @param toast Type of the toast component to create
     * @param cfg Configuration of the toast
     * @param uuid Unique identifier to set in the toast
     *
     * @return A promise of the reference to the toast
     */
    addToast(toast, cfg, uuid) {
        if (cfg.showUniqueToast && this.currentToast) {
            if (!(this.currentToast.cfg.title === cfg.title && this.currentToast.cfg.body === cfg.body)) {
                this.toastQueue.push({ toast, cfg, uuid });
            }
        }
        else {
            // Add the toast component to the toast queue
            this.toastQueue.push({ toast, cfg, uuid });
        }
        return new Promise((resolve) => {
            this.toastQSubject
                .pipe(
            // There is one subscription for each toast component
            // It should live as long as this toast component is the one being processed or
            // it's still waiting in the queue
            takeWhile((toastToShow) => {
                const isAlive = toastToShow.uuid === uuid || this.toastQueue.map((t) => t.uuid).indexOf(uuid) > -1;
                return isAlive;
            }), 
            // This subscription should be killed when this toast queue component is destroyed
            // This is to ensure that the last toast subscription is killed when the component is
            // destroyed
            takeUntil(this.componentDestroyed$))
                .subscribe((toastToShow) => {
                // When there are multiple open toast requests come in, there would be multiple live
                // subscriptions. Need to verify the emitted toast is indeed the one needs to process.
                // E.g. If there are 3 open toast requests come in, when toast 2 is emitted, there are 2
                // live subscriptions at that time, subscription for toast 2 and 3 (sub. for toast 1 is
                // already killed). In this case, we only want to attach the toast in the portal in the
                // subscription of toast 2, not in toast 3
                if (toastToShow.uuid === uuid) {
                    this.hasToastShowing = true;
                    // Find the portal host of toasts in DOM
                    const portalHost = new DomPortalOutlet(document.querySelector('#portal'), this.componentFactoryResolver, this.appRef, this.injector);
                    const toastRef = new ToastRef(portalHost);
                    const toastInst = this.creatToastComponentPortal(toast, cfg, toastRef);
                    const toastHandle = portalHost.attach(toastInst);
                    toastRef.componentInstance = toastHandle.instance;
                    toastRef.componentInstance.dismissalTimeMS = this.toastSettings.dismissTime;
                    toastRef.componentInstance.uuid = uuid;
                    toastRef.componentInstance.destroy.subscribe(() => { }, () => { }, (_) => {
                        portalHost.detach();
                        this.currentToast = undefined;
                    });
                    toastRef.componentInstance.closeAnimationDone.pipe(take(1)).subscribe(() => {
                        this.hasToastShowing = false;
                    });
                    resolve({ toastRef, toast: toastHandle.instance });
                }
            });
        });
    }
    /**
     * @ignore
     */
    creatToastComponentPortal(component, toastConfig, toastRef) {
        const injector = this.createInjector(toastConfig, toastRef);
        const containerPortal = new ComponentPortal(component, null, injector);
        return containerPortal;
    }
    /**
     * Creates the injector to pass data to the toast component.
     *
     * @ignore
     */
    createInjector(toastConfig, toastRef) {
        const injectionTokens = new WeakMap([
            [ToastRef, toastRef],
            [TOAST_DATA, toastConfig],
        ]);
        return new PortalInjector(this.injector, injectionTokens);
    }
    /**
     * return the toast queue
     *
     * @ignore
     */
    getToastQueue() {
        return this.toastQueue;
    }
    /** Clears the toast queue */
    clearToastQueue() {
        this.toastQueue.length = 0;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToastQueueComponent, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.Injector }, { token: i0.ApplicationRef }, { token: TOAST_SETTINGS }, { token: OVERLAY_REF }, { token: TaskPanelService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ToastQueueComponent, selector: "avn-toast-queue", ngImport: i0, template: "<div id=\"portal\" [style.margin]=\"marginOffset$ | async\"></div>\n", styles: [":host{display:flex;align-items:flex-end;flex-direction:row-reverse;overflow:hidden}\n"], dependencies: [{ kind: "pipe", type: i1$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToastQueueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-toast-queue', template: "<div id=\"portal\" [style.margin]=\"marginOffset$ | async\"></div>\n", styles: [":host{display:flex;align-items:flex-end;flex-direction:row-reverse;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TOAST_SETTINGS]
                }] }, { type: i1$4.OverlayRef, decorators: [{
                    type: Inject,
                    args: [OVERLAY_REF]
                }] }, { type: TaskPanelService }]; } });

class BottomSheetContainerComponent {
    constructor() {
        this.closed = new EventEmitter();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BottomSheetContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: BottomSheetContainerComponent, selector: "avn-bottom-sheet-container", outputs: { closed: "closed" }, ngImport: i0, template: "<div class=\"content\">\n  <ng-content></ng-content>\n</div>\n<avn-icon [icon]=\"'content:clear'\" (click)=\"closed.emit()\"></avn-icon>\n", styles: [":host{-webkit-user-select:none;user-select:none;padding:var(--space-md);display:grid;grid-template-rows:1fr max-content;grid-gap:var(--space-md)}:host avn-icon{justify-self:center;background-color:var(--modal-surface-background);color:var(--modal-surface-on);padding:var(--space-sm);border-radius:50%}\n"], dependencies: [{ kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BottomSheetContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-bottom-sheet-container', template: "<div class=\"content\">\n  <ng-content></ng-content>\n</div>\n<avn-icon [icon]=\"'content:clear'\" (click)=\"closed.emit()\"></avn-icon>\n", styles: [":host{-webkit-user-select:none;user-select:none;padding:var(--space-md);display:grid;grid-template-rows:1fr max-content;grid-gap:var(--space-md)}:host avn-icon{justify-self:center;background-color:var(--modal-surface-background);color:var(--modal-surface-on);padding:var(--space-sm);border-radius:50%}\n"] }]
        }], propDecorators: { closed: [{
                type: Output
            }] } });

class OverlayComponent {
    /**
     * @ignore
     */
    constructor(renderer, document) {
        this.renderer = renderer;
        this.document = document;
    }
    /**
     * @ignore
     */
    ngOnChanges() {
        this.toggleOverlay();
    }
    /**
     * @ignore
     */
    toggleOverlay() {
        if (this.fullPage && this.visible) {
            this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
        }
        else if (this.fullPage && !this.visible) {
            this.renderer.removeStyle(this.document.body, 'overflow');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OverlayComponent, deps: [{ token: i0.Renderer2 }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: OverlayComponent, selector: "avn-overlay", inputs: { visible: "visible", fullPage: "fullPage" }, host: { properties: { "class.visible": "this.visible", "class.full-page": "this.fullPage" } }, usesOnChanges: true, ngImport: i0, template: "", styles: ["avn-overlay,:host{position:absolute;display:none;height:100%;width:100%;top:0;left:-100%;opacity:0;background-color:#00000080;will-change:opacity;transform:translateZ(0);transition:left 0ms cubic-bezier(.23,1,.32,1) 0ms,opacity .4s cubic-bezier(.23,1,.32,1) 0ms;z-index:999}avn-overlay.visible,:host.visible{display:block;left:0;opacity:1;cursor:pointer}avn-overlay.full-page,:host.full-page{position:fixed}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-overlay', changeDetection: ChangeDetectionStrategy.OnPush, template: "", styles: ["avn-overlay,:host{position:absolute;display:none;height:100%;width:100%;top:0;left:-100%;opacity:0;background-color:#00000080;will-change:opacity;transform:translateZ(0);transition:left 0ms cubic-bezier(.23,1,.32,1) 0ms,opacity .4s cubic-bezier(.23,1,.32,1) 0ms;z-index:999}avn-overlay.visible,:host.visible{display:block;left:0;opacity:1;cursor:pointer}avn-overlay.full-page,:host.full-page{position:fixed}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { visible: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.visible']
            }], fullPage: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.full-page']
            }] } });

class OverlayModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OverlayModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: OverlayModule, declarations: [OverlayComponent], exports: [OverlayComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OverlayModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OverlayModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [OverlayComponent],
                    exports: [OverlayComponent],
                }]
        }] });

/**
 * Use this directive to project custom content in the 'icon' area
 */
class TaskPanelItemIconSlotDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemIconSlotDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: TaskPanelItemIconSlotDirective, selector: "[avnTaskPanelItemIconSlot]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemIconSlotDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnTaskPanelItemIconSlot]' }]
        }] });
/**
 * Use this directive to project custom content in the 'feedback' area
 */
class TaskPanelItemFeedbackSlotDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemFeedbackSlotDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: TaskPanelItemFeedbackSlotDirective, selector: "[avnTaskPanelItemFeedbackSlot]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemFeedbackSlotDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnTaskPanelItemFeedbackSlot]' }]
        }] });
/**
 * Use this directive to project custom content in the 'action' area
 */
class TaskPanelItemActionSlotDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemActionSlotDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: TaskPanelItemActionSlotDirective, selector: "[avnTaskPanelItemActionSlot]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemActionSlotDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnTaskPanelItemActionSlot]' }]
        }] });
/**
 * This component is an utility component that can be used to display information about a long running task.
 * It contains 3 zones:
 * - icon: shows an icon/text for the current task
 * - feedback: shows a feedback text for the current task (typically a progress text)
 * - action: show custom content to perform an action for the current task (typically a button redirecting to a page with more details)
 */
class TaskPanelItemComponent {
    constructor() {
        this.iconTemplateExists = false;
        this.feedbackTemplateExists = false;
    }
    set iconSlotContent(directive) {
        this.iconTemplateExists = !!directive;
    }
    set feedbackSlotContent(directive) {
        this.feedbackTemplateExists = !!directive;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TaskPanelItemComponent, selector: "avn-task-panel-item", inputs: { icon: "icon", iconText: "iconText", feedbackText: "feedbackText" }, queries: [{ propertyName: "iconSlotContent", first: true, predicate: TaskPanelItemIconSlotDirective, descendants: true, static: true }, { propertyName: "feedbackSlotContent", first: true, predicate: TaskPanelItemFeedbackSlotDirective, descendants: true, static: true }], ngImport: i0, template: "<div class=\"icon-container\">\n  <ng-container *ngIf=\"!iconTemplateExists; else iconTemplate\">\n    <avn-icon *ngIf=\"icon\" [icon]=\"icon\"></avn-icon>\n    <span *ngIf=\"iconText\">{{ iconText }}</span>\n  </ng-container>\n\n  <ng-template #iconTemplate>\n    <ng-content select=\"[avnTaskPanelItemIconSlot]\"></ng-content>\n  </ng-template>\n</div>\n\n<div class=\"feedback-container\">\n  <ng-container *ngIf=\"!feedbackTemplateExists; else feedbackTemplate\">\n    <span *ngIf=\"feedbackText\">{{ feedbackText }}</span>\n  </ng-container>\n\n  <ng-template #feedbackTemplate>\n    <ng-content select=\"[avnTaskPanelItemFeedbackSlot]\"></ng-content>\n  </ng-template>\n</div>\n\n<div class=\"action-container\">\n  <ng-content select=\"[avnTaskPanelItemActionSlot]\"></ng-content>\n</div>\n", styles: [":host{display:grid;grid-template-columns:100px 1fr max-content;align-items:center;grid-gap:var(--space-xl);padding:var(--space-md)}:host .icon-container{display:flex;flex-direction:column;justify-content:center}:host .icon-container>span{padding-top:var(--space-xs);font-size:var(--text-sm);text-align:center}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TaskPanelItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-task-panel-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"icon-container\">\n  <ng-container *ngIf=\"!iconTemplateExists; else iconTemplate\">\n    <avn-icon *ngIf=\"icon\" [icon]=\"icon\"></avn-icon>\n    <span *ngIf=\"iconText\">{{ iconText }}</span>\n  </ng-container>\n\n  <ng-template #iconTemplate>\n    <ng-content select=\"[avnTaskPanelItemIconSlot]\"></ng-content>\n  </ng-template>\n</div>\n\n<div class=\"feedback-container\">\n  <ng-container *ngIf=\"!feedbackTemplateExists; else feedbackTemplate\">\n    <span *ngIf=\"feedbackText\">{{ feedbackText }}</span>\n  </ng-container>\n\n  <ng-template #feedbackTemplate>\n    <ng-content select=\"[avnTaskPanelItemFeedbackSlot]\"></ng-content>\n  </ng-template>\n</div>\n\n<div class=\"action-container\">\n  <ng-content select=\"[avnTaskPanelItemActionSlot]\"></ng-content>\n</div>\n", styles: [":host{display:grid;grid-template-columns:100px 1fr max-content;align-items:center;grid-gap:var(--space-xl);padding:var(--space-md)}:host .icon-container{display:flex;flex-direction:column;justify-content:center}:host .icon-container>span{padding-top:var(--space-xs);font-size:var(--text-sm);text-align:center}\n"] }]
        }], propDecorators: { iconSlotContent: [{
                type: ContentChild,
                args: [TaskPanelItemIconSlotDirective, { static: true }]
            }], feedbackSlotContent: [{
                type: ContentChild,
                args: [TaskPanelItemFeedbackSlotDirective, { static: true }]
            }], icon: [{
                type: Input
            }], iconText: [{
                type: Input
            }], feedbackText: [{
                type: Input
            }] } });

class ModalModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ModalModule, declarations: [DrawerLayoutComponent,
            StandardDialogComponent,
            DrawerHeaderComponent,
            DrawerFooterComponent,
            DrawerContentComponent,
            DialogLayoutComponent,
            DialogHeaderComponent,
            DialogFooterComponent,
            DialogContentComponent,
            ModalContainerComponent,
            ToastQueueComponent,
            StandardToastComponent,
            FocalModalDirective,
            BottomSheetContainerComponent,
            TaskPanelComponent,
            TaskPanelItemComponent,
            TaskPanelItemIconSlotDirective,
            TaskPanelItemFeedbackSlotDirective,
            TaskPanelItemActionSlotDirective], imports: [CommonModule,
            CoreModule,
            OverlayModule,
            OverlayModule$1,
            PortalModule,
            InputModule,
            FormFieldModule,
            ButtonModule,
            IconModule,
            FormsModule,
            ReactiveFormsModule,
            ScrollingModule], exports: [DrawerLayoutComponent,
            StandardDialogComponent,
            DrawerHeaderComponent,
            DrawerFooterComponent,
            DrawerContentComponent,
            DialogLayoutComponent,
            DialogHeaderComponent,
            DialogFooterComponent,
            DialogContentComponent,
            ModalContainerComponent,
            ToastQueueComponent,
            StandardToastComponent,
            FocalModalDirective,
            BottomSheetContainerComponent,
            TaskPanelItemComponent,
            TaskPanelItemIconSlotDirective,
            TaskPanelItemFeedbackSlotDirective,
            TaskPanelItemActionSlotDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalModule, imports: [CommonModule,
            CoreModule,
            OverlayModule,
            OverlayModule$1,
            PortalModule,
            InputModule,
            FormFieldModule,
            ButtonModule,
            IconModule,
            FormsModule,
            ReactiveFormsModule,
            ScrollingModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CoreModule,
                        OverlayModule,
                        OverlayModule$1,
                        PortalModule,
                        InputModule,
                        FormFieldModule,
                        ButtonModule,
                        IconModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ScrollingModule,
                    ],
                    declarations: [
                        DrawerLayoutComponent,
                        StandardDialogComponent,
                        DrawerHeaderComponent,
                        DrawerFooterComponent,
                        DrawerContentComponent,
                        DialogLayoutComponent,
                        DialogHeaderComponent,
                        DialogFooterComponent,
                        DialogContentComponent,
                        ModalContainerComponent,
                        ToastQueueComponent,
                        StandardToastComponent,
                        FocalModalDirective,
                        BottomSheetContainerComponent,
                        TaskPanelComponent,
                        TaskPanelItemComponent,
                        TaskPanelItemIconSlotDirective,
                        TaskPanelItemFeedbackSlotDirective,
                        TaskPanelItemActionSlotDirective,
                    ],
                    exports: [
                        DrawerLayoutComponent,
                        StandardDialogComponent,
                        DrawerHeaderComponent,
                        DrawerFooterComponent,
                        DrawerContentComponent,
                        DialogLayoutComponent,
                        DialogHeaderComponent,
                        DialogFooterComponent,
                        DialogContentComponent,
                        ModalContainerComponent,
                        ToastQueueComponent,
                        StandardToastComponent,
                        FocalModalDirective,
                        BottomSheetContainerComponent,
                        TaskPanelItemComponent,
                        TaskPanelItemIconSlotDirective,
                        TaskPanelItemFeedbackSlotDirective,
                        TaskPanelItemActionSlotDirective,
                    ]
                }]
        }] });

/** Get all rows in the data source that are not disabled */
const getEnabledItems = (data) => {
    return data.filter((item) => !item.datatableRowOptions?.disabled);
};
/**
 * Verify if the all selectable rows are selected.
 * Returns false if data set is not fully loaded.
 * Returns true if data set is fully loaded and all selected rows (rows that are not disabled) are selected.
 */
const isEntireDataSetSelected = (dataSource, idProp, selectedItems, selectedItemIds) => {
    if ((dataSource?.data || []).length === 0 || dataSource.data.length !== dataSource.total) {
        return false;
    }
    const selectableRows = getEnabledItems(dataSource.data);
    const allSelected = selectableRows.every((item) => {
        if (idProp) {
            return selectedItemIds.includes(item[idProp]);
        }
        else {
            return selectedItems.includes(item);
        }
    });
    return allSelected;
};
/**
 * Returns the new selected items based on the current selection and new datasource items.
 * Currently selected items not in the new datasource will be removed.
 * If autoselect all items is active, all non disabled items from the datasource will be selected
 * **/
const getUpdatedSelection = (currentSelectedItems, newDataSourceItems, autoSelectNewItems) => {
    if (autoSelectNewItems) {
        // select all non disabled items
        // return newDataSourceItems.filter((item) => !item.datatableRowOptions?.disabled);
        return getEnabledItems(newDataSourceItems);
    }
    // remove currently selected items that are not present anymore in the new datasource
    const removed = difference(currentSelectedItems, newDataSourceItems);
    if (removed.length > 0) {
        return currentSelectedItems.filter((item) => !removed.includes(item));
    }
    return currentSelectedItems;
};
/**
 * Returns the new selected items based on the current selection and new datasource items.
 * Currently selected items not in the new datasource will be removed.
 * If autoselect all items is active, all non disabled items from the datasource will be selected
 * Items from the initial selection will also be selected if they are present in the new datasource
 * **/
const getUpdatedSelectionById = (currentSelectedIds, newDataSourceItems, idProp, autoSelectNewItems, initialSelectedItemIds) => {
    if (autoSelectNewItems) {
        // select all non disabled items (except if they were initially selected)
        return newDataSourceItems.filter((item) => !item.datatableRowOptions?.disabled || initialSelectedItemIds.includes(item[idProp])).map((item) => item[idProp]);
    }
    // remove currently selected ids that are not present anymore in the new datasource
    const newDatasourceIds = newDataSourceItems.map((item) => item[idProp]);
    const removedItemIds = difference(currentSelectedIds, newDatasourceIds);
    let newSelectedIds = currentSelectedIds;
    if (removedItemIds.length > 0) {
        newSelectedIds = currentSelectedIds.filter((id) => !removedItemIds.includes(id));
    }
    // includes initially selected items if they are now present in the new datasource
    const loadedInitIdData = (initialSelectedItemIds || []).filter((id) => newDatasourceIds.includes(id));
    const initialSelectedIdsNotInCurrentSelection = loadedInitIdData.filter((id) => !newSelectedIds.includes(id));
    if (initialSelectedIdsNotInCurrentSelection.length > 0) {
        return [...initialSelectedIdsNotInCurrentSelection, ...newSelectedIds];
    }
    return newSelectedIds;
};
/**
 * Calculates changes from previous selection and returns an event
 * **/
const getSelectionChangeEventById = (currentDataSourceItems, idProp, previousSelectedItemIds, selectedItemIds) => {
    const addedIds = difference(selectedItemIds, previousSelectedItemIds);
    const removedIds = difference(previousSelectedItemIds, selectedItemIds);
    return {
        added: addedIds.map((id) => currentDataSourceItems.find((item) => item[idProp] === id)),
        removed: removedIds.map((id) => currentDataSourceItems.find((item) => item[idProp] === id)),
        selected: selectedItemIds.map((id) => currentDataSourceItems.find((item) => item[idProp] === id)),
    };
};
/**
 * Calculates changes from previous selection and returns an event
 * **/
const getSelectionChangeEventByInstance = (previousSelectedItems, selectedItems) => ({
    added: difference(selectedItems, previousSelectedItems),
    removed: difference(previousSelectedItems, selectedItems),
    selected: selectedItems,
});

/**
 * The datasource initial state
 */
const INITIAL_DATASOURCE_STATE = {
    dataSource: null,
    pendingData: true,
    maxRenderedItemIndex: null,
    offset: 0,
    selectedItems: [],
    selectedItemIds: [],
    focusedItemIndex: null,
};
/**
 * This is a store that can be used for components that want to implement infinite scroll in a list
 *
 */
class InfiniteScrollComponentStore extends ComponentStore {
    constructor() {
        // initial state
        super({
            infiniteScrollPreloadStrategy: 'page',
            infiniteScrollPreloadValue: 2,
            pageSize: 50,
            serverSorting: true,
            sort: null,
            dataSourceConfig: null,
            allItemsSelectionEnabled: false,
            entireDataSetSelected: false,
            initialSelectedItemIds: [],
            ...INITIAL_DATASOURCE_STATE,
        });
        /** Selectors */
        this.hasRecords$ = this.select((state) => this._hasRecords(state));
        this.allRecordsLoaded$ = this.select((state) => this._allDataLoaded(state));
        this.offset$ = this.select((state) => state.offset);
        this.sort$ = this.select((state) => state.sort);
        this.selectedItems$ = this.select((state) => state.selectedItems);
        this.selectedItemIds$ = this.select((state) => state.selectedItemIds);
        this.selectedItemCount$ = this.select((state) => state.dataSourceConfig?.id ? state.selectedItemIds.length : state.selectedItems.length);
        this.dataSource$ = this.select((state) => state.dataSource);
        this.totalRecordsCount$ = this.select((state) => state.dataSource.total);
        this.focusedItemIndex$ = this.select((state) => state.focusedItemIndex);
        this.pendingData$ = this.select((state) => state.pendingData);
        this.allItemsSelectionEnabled$ = this.select((state) => state.allItemsSelectionEnabled);
        this.entireDataSetSelected$ = this.select((state) => state.entireDataSetSelected);
        this.areAllItemsDisabled$ = this.select((state) => state.dataSource?.data?.length > 0 && state.dataSource?.data?.every((item) => item?.datatableRowOptions?.disabled));
        this.model$ = this.select(this.dataSource$, this.pendingData$, this.hasRecords$, this.allRecordsLoaded$, this.sort$, this.selectedItems$, this.selectedItemIds$, this.selectedItemCount$, this.focusedItemIndex$, (dataSource, pendingData, hasRecords, allRecordsLoaded, sort, selectedItems, selectedItemIds, selectedItemsCount, focusedItemIndex) => ({
            dataSource,
            pendingData,
            sort,
            selectedItems,
            selectedItemIds,
            selectedItemsCount,
            focusedItemIndex,
            hasRecords,
            allRecordsLoaded,
        }));
        /** Reducers **/
        /** Selects the specified item and deselects any previously selected item **/
        this.setSingleSelectedItem = this.updater((state, selectedItem) => {
            const idProp = this.dataSourceConfig?.id;
            if (idProp) {
                return {
                    ...state,
                    selectedItemIds: [selectedItem[idProp]],
                    initialSelectedItemIds: [],
                };
            }
            return {
                ...state,
                selectedItems: [selectedItem],
            };
        });
        /**
         * Sets the initial selection. Note that this can contain ids not yet in the datasource.
         * As new item are added to the datasource via infinite scroll, they will be automatically selected if present in the initial selection.
         * Items that get deselected manually will be removed from the initial selection.
         * - this will first clean previously set selectedItemIds if any
         * - If we have already loaded dataSource, populate selectedItemIds that exist in data source
         * **/
        this.setInitialSelectedItemIds = this.updater((state, initialSelectedItemIds = []) => {
            const datasourceIds = state.dataSource?.data?.map((item) => item[state.dataSourceConfig?.id]) || [];
            const newSelectedItemIds = initialSelectedItemIds.filter((selectedId) => datasourceIds.includes(selectedId));
            return {
                ...state,
                selectedItemIds: [...newSelectedItemIds],
                initialSelectedItemIds: [...initialSelectedItemIds],
                allItemsSelectionEnabled: newSelectedItemIds.length === state.dataSource?.total,
                entireDataSetSelected: newSelectedItemIds.length === state.dataSource?.total,
            };
        });
        /**
         * Add the specified items to the current selection.
         * **/
        this.addItemsToSelection = this.updater((state, selectedItems) => {
            const idProp = this.dataSourceConfig?.id;
            let changes;
            if (idProp) {
                changes = {
                    selectedItemIds: [...state.selectedItemIds, ...selectedItems.map((item) => item[idProp])],
                };
            }
            else {
                changes = {
                    selectedItems: [...state.selectedItems, ...selectedItems],
                };
            }
            const entireDataSetSelected = isEntireDataSetSelected(state.dataSource, idProp, changes.selectedItems, changes.selectedItemIds);
            if (entireDataSetSelected) {
                changes = {
                    ...changes,
                    entireDataSetSelected: true,
                    allItemsSelectionEnabled: true,
                };
            }
            return {
                ...state,
                ...changes,
            };
        });
        /**
         * Removes the specified item from the current selection.
         * **/
        this.removeItemFromSelection = this.updater((state, deselectedItem) => {
            const idProp = this.dataSourceConfig?.id;
            let changes;
            if (idProp) {
                const itemId = deselectedItem[idProp];
                changes = {
                    selectedItemIds: state.selectedItemIds.filter((id) => id !== itemId),
                    initialSelectedItemIds: state.initialSelectedItemIds.filter((id) => id !== itemId),
                };
            }
            else {
                changes = {
                    selectedItems: state.selectedItems.filter((item) => item !== deselectedItem),
                };
            }
            if (state.allItemsSelectionEnabled) {
                changes = {
                    ...changes,
                    allItemsSelectionEnabled: false,
                };
            }
            if (state.entireDataSetSelected) {
                changes = {
                    ...changes,
                    entireDataSetSelected: false,
                };
            }
            return {
                ...state,
                ...changes,
            };
        });
        /**
         * Selects all items of the current datasource that can be selected.
         * Disabled items are excluded from the selection.
         * **/
        this.selectAllItems = this.updater((state) => {
            const idProp = this.dataSourceConfig?.id;
            let newSelectedItems = state.selectedItems;
            let newSelectedItemIds = state.selectedItemIds;
            if (idProp) {
                newSelectedItemIds = getUpdatedSelectionById(state.selectedItemIds || [], state.dataSource?.data || [], idProp, true, state.initialSelectedItemIds);
            }
            else {
                newSelectedItems = getUpdatedSelection(state.selectedItems, state.dataSource?.data || [], true);
            }
            const entireDataSetSelected = isEntireDataSetSelected(state.dataSource, idProp, newSelectedItems, newSelectedItemIds);
            let changes = {
                selectedItems: newSelectedItems,
                selectedItemIds: newSelectedItemIds,
            };
            if (!state.entireDataSetSelected && entireDataSetSelected) {
                changes = {
                    ...changes,
                    entireDataSetSelected,
                };
            }
            return {
                ...state,
                ...changes,
            };
        });
        /**
         * Deselects all items of the current datasource that can be deselected.
         * Disabled items are excluded from the deselection.
         * **/
        this.deselectAllItems = this.updater((state) => {
            const idProp = this.dataSourceConfig?.id;
            let newSelectedItems = state.selectedItems;
            let newSelectedItemIds = state.selectedItemIds;
            let initialSelectedItemIds = state.initialSelectedItemIds;
            const currentDataSourceItems = state.dataSource?.data || [];
            const disabledItems = currentDataSourceItems.filter((item) => item.datatableRowOptions?.disabled);
            if (idProp) {
                const disabledSelectedItems = disabledItems.filter((item) => state.selectedItemIds.includes(item[idProp]));
                const disabledSelectedItemIds = disabledSelectedItems.map((item) => item[idProp]);
                newSelectedItemIds = disabledSelectedItemIds;
                // remove deselected items from initial selection
                initialSelectedItemIds = initialSelectedItemIds.filter((id) => disabledSelectedItemIds.includes(id));
            }
            else {
                // cannot deselect disabled + selected items
                const disabledSelectedItems = disabledItems.filter((item) => state.selectedItems.includes(item));
                newSelectedItems = disabledSelectedItems;
            }
            let changes = {
                selectedItems: newSelectedItems,
                selectedItemIds: newSelectedItemIds,
                initialSelectedItemIds,
            };
            if (state.entireDataSetSelected) {
                changes = {
                    ...changes,
                    entireDataSetSelected: false,
                };
            }
            return {
                ...state,
                ...changes,
            };
        });
        /**
         * Sets whether selection of all items is enabled. If enabled, new datasource items will be auto added to selection)
         */
        this.setAllItemsSelectionEnabled = this.updater((state, allItemsSelectionEnabled) => ({
            ...state,
            allItemsSelectionEnabled,
        }));
        /** Sets whether the entire data set is selected or not */
        this.setEntireDataSetSelected = this.updater((state, entireDataSetSelected) => ({
            ...state,
            entireDataSetSelected,
        }));
        this.setFocusedItemIndex = this.updater((state, index) => ({
            ...state,
            focusedItemIndex: index,
        }));
        this.setInfiniteScrollPreloadStrategy = this.updater((state, infiniteScrollPreloadStrategy) => ({
            ...state,
            infiniteScrollPreloadStrategy,
        }));
        this.setInfiniteScrollPreloadValue = this.updater((state, infiniteScrollPreloadValue) => ({
            ...state,
            infiniteScrollPreloadValue,
        }));
        this.setPageSize = this.updater((state, pageSize) => ({
            ...state,
            pageSize,
        }));
        this.setPendingData = this.updater((state, pendingData) => ({
            ...state,
            pendingData,
        }));
        this.setServerSorting = this.updater((state, serverSorting) => ({
            ...state,
            serverSorting,
        }));
        this.setSort = this.updater((state, sort) => ({
            ...state,
            sort,
        }));
        this.setDataSourceConfig = this.updater((state, dataSourceConfig) => ({
            ...state,
            dataSourceConfig,
        }));
        this.updateSort = this.updater((state, sort) => {
            if (state.sort && state.sort.id === sort.id && state.sort.prop === sort.prop && state.sort.direction === sort.direction) {
                return state;
            }
            let update = {};
            // if not all the data is loaded, we gotta refetch the data from scratch
            if (state.serverSorting && !this._allDataLoaded(state)) {
                update = {
                    ...INITIAL_DATASOURCE_STATE,
                };
            }
            else if (state.dataSource) {
                if (sort?.prop) {
                    update = {
                        dataSource: {
                            data: this._sortDataSource(state.dataSource.data, sort?.prop, sort.direction, sort?.isCaseInsensitive),
                            total: state.dataSource.total,
                        },
                    };
                }
            }
            return { ...state, sort, ...update };
        });
        this.setDatasource = this.updater((state, dataSource) => {
            // if no initial datasource, just do nothing
            if (!dataSource) {
                return state;
            }
            let newDatasource = dataSource;
            if (dataSource && state.sort?.prop && !state.serverSorting) {
                newDatasource = {
                    data: this._sortDataSource(dataSource.data, state.sort.prop, state.sort.direction, state.sort.isCaseInsensitive),
                    total: dataSource.total,
                };
            }
            // when a initial datasource is passed, reset the offset so the initial data fetch event is not sent, and mark as not loading
            return {
                ...state,
                dataSource: newDatasource,
                offset: null,
                pendingData: false,
            };
        });
        this.updateDatasource = this.updater((state, dataSource) => {
            if (!dataSource) {
                return {
                    ...state,
                    dataSource: null,
                    selectedItems: [],
                    selectedItemsIds: [],
                    focusedItemIndex: null,
                    maxRenderedItemIndex: null,
                };
            }
            let newDatasource = dataSource;
            if (dataSource && state.sort?.prop && !state.serverSorting) {
                newDatasource = {
                    data: this._sortDataSource(dataSource.data, state.sort.prop, state.sort.direction, state.sort.isCaseInsensitive),
                    total: dataSource.total,
                };
            }
            // deselect any selected item that does not exist anymore
            // and auto add new items to selection if needed
            const idProp = state.dataSourceConfig?.id;
            let newSelectedItems = state.selectedItems;
            let newSelectedItemIds = state.selectedItemIds;
            if (idProp) {
                newSelectedItemIds = getUpdatedSelectionById(state.selectedItemIds || [], dataSource?.data || [], idProp, state.allItemsSelectionEnabled, state.initialSelectedItemIds);
            }
            else {
                newSelectedItems = getUpdatedSelection(state.selectedItems, dataSource?.data || [], state.allItemsSelectionEnabled);
            }
            // readjust the max rendered offset if our datasource has changed
            const maxRenderedItemIndex = Math.min(dataSource.data.length, state.maxRenderedItemIndex);
            let changes = {
                ...state,
                offset: null,
                maxRenderedItemIndex,
                dataSource: newDatasource,
                pendingData: false,
                selectedItems: newSelectedItems,
                selectedItemIds: newSelectedItemIds,
            };
            /**
             * If Select All checkbox is checked, as user scrolls and new data are loaded, verify if the entire data set is
             * done loading. If so, mark entireDataSetSelected to be true. However, if entireDataSetSelected is already marked
             * to be true manually by the user before the entire data set is loaded, no need to reset the field to be true again.
             */
            if (state.allItemsSelectionEnabled) { // If Select All checkbox is checked
                if (!state.entireDataSetSelected) { // If user hasn't manually chose to select the entire data set
                    // Verify if all data are done loading, and all selectable rows are selected
                    const newEntireDataSetSelected = isEntireDataSetSelected(newDatasource, idProp, newSelectedItems, newSelectedItemIds);
                    if (state.entireDataSetSelected !== newEntireDataSetSelected) {
                        changes = { ...changes, entireDataSetSelected: newEntireDataSetSelected };
                    }
                }
            }
            return changes;
        });
        this.reset = this.updater((state) => ({
            ...state,
            dataSource: null,
            pendingData: true,
            maxRenderedItemIndex: null,
            offset: 0,
            selectedItems: [],
            selectedItemIds: [],
            focusedItemIndex: null,
            entireDataSetSelected: false,
        }));
        /** Effects **/
        this.onMaxRenderedItemIndexChange = this.effect((maxRenderedItemIndex$) => maxRenderedItemIndex$.pipe(tap((maxRenderedItemIndex) => {
            const state = this.get();
            if (!state.dataSource || this._allDataLoaded(state) || state.pendingData || maxRenderedItemIndex < state.maxRenderedItemIndex) {
                return;
            }
            // check if we need to load more data
            const currentRowCount = state.dataSource ? state.dataSource.data.length : 0;
            let loadMoreData = false;
            if (state.infiniteScrollPreloadStrategy === 'page') {
                // page: Load more data after n page of records are left to be scrolled in the available data
                const totalRowsBeforeNextLoad = state.infiniteScrollPreloadValue * state.pageSize;
                const totalRecordsLeftToDisplay = state.dataSource.data.length - maxRenderedItemIndex;
                loadMoreData = totalRecordsLeftToDisplay <= totalRowsBeforeNextLoad;
            }
            else if (state.infiniteScrollPreloadStrategy === 'left') {
                // left: Load more data when n% of current loaded data rows are left to be scrolled
                const percentage = state.infiniteScrollPreloadValue / 100;
                const totalRecordsInTable = state.dataSource.data.length;
                const totalRecordsLeftToDisplay = state.dataSource.data.length - maxRenderedItemIndex;
                loadMoreData = totalRecordsLeftToDisplay / totalRecordsInTable <= percentage;
            }
            else if (state.infiniteScrollPreloadStrategy === 'reached') {
                // reached: Load more data when n% of current loaded data rows have been scrolled
                const percentage = state.infiniteScrollPreloadValue / 100;
                const totalRecordsInTable = state.dataSource.data.length;
                const totalRecordsAlreadyScrolled = maxRenderedItemIndex;
                loadMoreData = totalRecordsAlreadyScrolled / totalRecordsInTable >= percentage;
            }
            const fetchDataUpdate = loadMoreData
                ? {
                    offset: currentRowCount,
                    pendingData: true,
                }
                : {};
            this.patchState({
                ...fetchDataUpdate,
                maxRenderedItemIndex,
            });
        })));
        /**** EVENTS *****/
        /**
         * Event emitted when data needs to be fetched (data offset changes)
         * **/
        this.fetchData$ = this.offset$.pipe(filter((dataFetchOffset) => dataFetchOffset !== null), withLatestFrom(this.state$), map(([offset, state]) => ({
            offset: offset || 0,
            pageSize: state.pageSize,
            sort: state.sort,
        })));
        /**
         * Event emitted the selection has changed
         * **/
        this.selectionChanged$ = merge(
        // selection by instance (when no id is provided in the datasource config)
        this.select(this.select((state) => state.selectedItems).pipe(pairwise()), ([previousSelectedItems, selectedItems]) => getSelectionChangeEventByInstance(previousSelectedItems, selectedItems)), 
        // selection by item (when an id is provided in the datasource config)
        this.select(this.select((state) => state.dataSourceConfig?.id).pipe(filterNil()), this.select((state) => state.selectedItemIds).pipe(pairwise()), (idProp, [previousSelectedItemIds, selectedItemIds]) => getSelectionChangeEventById(this.get().dataSource?.data || [], idProp, previousSelectedItemIds, selectedItemIds)));
    }
    get selectedItems() {
        return this.get().selectedItems;
    }
    get selectedItemIds() {
        return this.get().selectedItemIds;
    }
    get selectedItemCount() {
        return this.get().dataSourceConfig?.id ? this.get().selectedItemIds.length : this.get().selectedItems.length;
    }
    get allItemsSelectionEnabled() {
        return this.get().allItemsSelectionEnabled;
    }
    get entireDataSetSelected() {
        return this.get().entireDataSetSelected;
    }
    get focusedItemIndex() {
        return this.get().focusedItemIndex;
    }
    get dataSource() {
        return this.get().dataSource;
    }
    get isPendingData() {
        return this.get().pendingData;
    }
    get hasRecords() {
        return this._hasRecords(this.get());
    }
    get sort() {
        return this.get().sort;
    }
    get isServerSorting() {
        return this.get().serverSorting;
    }
    get dataSourceConfig() {
        return this.get().dataSourceConfig;
    }
    _allDataLoaded(state) {
        return !!state.dataSource && state.dataSource.data.length === state.dataSource.total;
    }
    _hasRecords(state) {
        return !!state.dataSource && state.dataSource.total > 0;
    }
    /** local sort of the datasource by data property **/
    _sortDataSource(rows, sortProp, direction, isCaseInsensitive) {
        if (!rows || rows.length <= 1) {
            return rows;
        }
        // create the value getter function using the previous function
        const valueGetterFn = (item) => {
            const value = new NestedPropertyPipe().transform(item, sortProp);
            return typeof value === 'string' && isCaseInsensitive ? value.toLowerCase() : value;
        };
        // sort the data and return the new array
        return orderBy(rows, [valueGetterFn], [direction]);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InfiniteScrollComponentStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InfiniteScrollComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InfiniteScrollComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * This service is the central point to open a toast and returns the reference of the toast to
 * callor
 */
class ToastService {
    constructor(overlay, injector, toastSettings) {
        this.overlay = overlay;
        this.injector = injector;
        this.toastSettings = toastSettings;
    }
    /**
     * Opens a customized toast component
     *
     * @param component Type of the toast component to create
     * @param toastConfig The toast configuration
     *
     * @returns A promise of the reference of the toast
     */
    open(component, toastConfig) {
        if (!this.toastQueueComponent) {
            const toastOverlayRef = this.createOverlay(this.getOverlayConfig({}));
            const queue = this.attachToastQueueContainer(ToastQueueComponent, toastOverlayRef);
            this.toastQueueComponent = queue.instance;
        }
        return this.toastQueueComponent.addToast(component, toastConfig, v4());
    }
    /**
     * Return a promise of a standard toast and its reference.
     */
    openStandardToast(toastConfig) {
        return this.open(StandardToastComponent, toastConfig);
    }
    /** Clears the toast queue */
    clearToastQueue() {
        if (this.toastQueueComponent) {
            this.toastQueueComponent.clearToastQueue();
        }
    }
    /**
     * @ignore
     */
    attachToastQueueContainer(component, toastOverlayRef) {
        const injectionTokens = new WeakMap([[OVERLAY_REF, toastOverlayRef]]);
        const injector = new PortalInjector(this.injector, injectionTokens);
        const toastContainerPortal = new ComponentPortal(component, null, injector);
        const queueRef = toastOverlayRef.attach(toastContainerPortal);
        return queueRef;
    }
    createOverlay(overlayConfig) {
        return this.overlay.create(overlayConfig);
    }
    /**
     * Configures the modal as an overlay
     *
     * @ignore
     */
    getOverlayConfig(overrideConfig) {
        const overlayConfig = this.getDefaultOverlayConfig();
        if (overrideConfig) {
            return new OverlayConfig({ ...overlayConfig, ...overrideConfig });
        }
        return overlayConfig;
    }
    /**
     * Returns the default overlay config for the toast
     *
     * @ignore
     */
    getDefaultOverlayConfig() {
        const positionStrategy = this.overlay.position().global();
        switch (this.toastSettings.alignment) {
            case 'bottomLeft':
                positionStrategy.bottom(`${this.toastSettings.yOffset}px`).left(`${this.toastSettings.xOffset}px`);
                break;
            case 'topLeft':
                positionStrategy.top(`${this.toastSettings.yOffset}px`).left(`${this.toastSettings.xOffset}px`);
                break;
            case 'topRight':
                positionStrategy.top(`${this.toastSettings.yOffset}px`).right(`${this.toastSettings.xOffset}px`);
                break;
            default:
                positionStrategy.bottom(`${this.toastSettings.yOffset}px`).right(`${this.toastSettings.xOffset}px`);
                break;
        }
        return new OverlayConfig({
            hasBackdrop: false,
            panelClass: 'toast-panel',
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            positionStrategy,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToastService, deps: [{ token: i1$4.Overlay }, { token: i0.Injector }, { token: TOAST_SETTINGS }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToastService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Overlay }, { type: i0.Injector }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TOAST_SETTINGS]
                }] }]; } });

/**
 * Returns the next char not empty in the specified value, from the specified index
 */
const getNextCharNotEmpty = (value, fromIndex) => {
    for (let i = fromIndex; i < value.length; i++) {
        if (value.charAt(i) !== ' ') {
            return value.charAt(i);
        }
    }
    return '';
};
/**
 * Returns the previous char not empty in the specified value, from the specified index
 */
const getPreviousCharNotEmpty = (value, fromIndex) => {
    for (let i = fromIndex; i >= 0; i--) {
        if (value.charAt(i) !== ' ') {
            return value.charAt(i);
        }
    }
    return '';
};
/**
 * Trims text on left side only
 */
const trimLeft = (text) => text.replace(/^\s+/, '');
/**
 * Removes specified characters from both sides if exists
 */
const trimWrapperChar = (text, char) => {
    text = text.charAt(0) === char ? text.substring(1) : text;
    text = text.charAt(text.length - 1) === char ? text.substring(0, text.length - 1) : text;
    return text;
};

/**
 * Converts an enum to a map
 */
const enumToMap = (enumObj) => {
    const map = new Map();
    Object.keys(enumObj)
        .filter((k) => isNaN(+k))
        .forEach((key) => {
        map.set(key, enumObj[key]);
    });
    return map;
};

/**
 * pads the specified number with zeros up the specified length
 */
const padWithZeros = (value, length) => {
    const valueLength = `${value != null ? value : ''}`.length;
    const zeroCount = length - valueLength;
    return `${zeroCount > 0 ? '0'.repeat(zeroCount) : ''}${valueLength > 0 ? value : ''}`;
};
/**
 * converts the px value to a number
 * e.g. 100px => 100
 */
const pxToNumber = (pxValue) => {
    if (!pxValue) {
        return 0;
    }
    return Number(pxValue.substring(0, pxValue.length - 2));
};
/**
 * converts the % value to a number
 * e.g. 100% => 100
 */
const percentToNumber = (percentValue) => {
    if (!percentValue) {
        return 0;
    }
    if (typeof percentValue !== 'string') {
        return percentValue;
    }
    return Number(percentValue.substring(0, percentValue.length - 1));
};

/**
 * return the scrollbar width of the specified element
 * if no scrollbar it will return 0
 */
const getScrollbarWidth = (element) => {
    if (!element) {
        return null;
    }
    return element.offsetWidth - element.clientWidth;
};
/**
 * return the scrollbar height (x axis) of the specified element
 * if no scrollbar it will return 0
 */
const getScrollbarHeight = (element) => {
    if (!element) {
        return null;
    }
    return element.offsetHeight - element.clientHeight;
};
/**
 * return all children elements of a node that are of specified type
 */
const getChildrenNodesOfType = (node, type) => {
    const res = [];
    for (let i = 0; i < node.childNodes.length; i++) {
        const childNode = node.childNodes.item(i);
        if (childNode.nodeType === type) {
            res.push(childNode);
        }
    }
    return res;
};

/**
 * Finds a T node by recursively checking all children nodes of same type T
 *
 * @param source  the datasource containing tree structure
 * @param idProp  the id to match
 * @param childrenProp  the property of the datasource object containing the children of same type T
 */
const getNodeById = (source, id, idProp = 'id', childrenProp = 'children') => {
    if (!source) {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < source.length; i++) {
        if (source[i][idProp] === id) {
            return source[i];
        }
        const foundChild = getNodeById(source[i][childrenProp], id);
        if (foundChild) {
            return foundChild;
        }
    }
    return null;
};

/**
 * converts a date to an iso formatted string
 * Excludes the timezone for floating dates
 **/
const dateTimeToString = (date, timezone) => {
    return date.toISO({ includeOffset: timezone !== 'floating' });
};
/**
 * Returns a date time that represents the first day of the week from the provided date
 **/
const getFirstDayOfWeek = (date, firstDayOfWeek) => {
    const isFirstDayOfWeek = date.weekday === firstDayOfWeek;
    if (isFirstDayOfWeek) {
        return date;
    }
    const diffDays = firstDayOfWeek > date.weekday ? date.weekday + 7 - firstDayOfWeek : date.weekday - firstDayOfWeek;
    return date.minus({ day: diffDays });
};
/**
 * converts a string to a date time
 * UTC will be used for floating datetimes (= datetimes with no timezone)
 * @param dateString a string representation of a date
 * @param format the format of the date string (e.g. yyyy-MM-dd). Leave blank for iso dates. See https://github.com/moment/luxon/blob/master/docs/formatting.md
 * @param timezone timezone for the returned date
 */
const stringToDateTime = (dateString, timezone, format = null) => {
    if (!dateString) {
        return null;
    }
    // for floating timezones, remove the timezone before parsing the date
    const timeZoneLength = dateString.endsWith('Z') || dateString.endsWith('z') ? 1 : dateString.substring(dateString.length - 6).match('^[+-]\\d\\d:\\d\\d$')?.[0].length || 0;
    if (timezone === 'floating') {
        if (timeZoneLength > 0) {
            dateString = dateString.substring(0, dateString.length - timeZoneLength);
        }
    }
    // try to parse the text as a date
    let parsedDate;
    // if we have a format, try first to parse the date using it
    if (format) {
        // will use timezone specified in string, or local timezone if none is provided
        parsedDate = DateTime.fromFormat(dateString, format);
    }
    // if not valid just try to parse the date as iso format. Also set the timezone for the returned date
    const resultZone = timezone === 'floating' || timezone === 'utc' ? FixedOffsetZone.utcInstance : timezone === 'local' ? SystemZone.instance : timezone;
    if (!parsedDate?.isValid) {
        parsedDate = DateTime.fromISO(dateString, { zone: resultZone });
    }
    if (!parsedDate.isValid) {
        return null;
    }
    // if the string passed had no timezone, add it
    if (timeZoneLength === 0 && timezone !== 'floating') {
        const isoDateWithoutTimezoneOffset = parsedDate.toISO({ includeOffset: false });
        parsedDate = DateTime.fromISO(isoDateWithoutTimezoneOffset, { zone: resultZone });
    }
    return parsedDate;
};
/**
 * parses the date and applies the specified timezone (uses UTC internally to represents floating dates - no time zone)
 **/
const toZonedDateTime = (date, timezone) => stringToDateTime(dateTimeToString(date, timezone), timezone);
/**
 * Indicates if the specified locale has a 12 hour display format
 * Note. 12 hour time will have a meridiem info
 **/
const is12HourTimeLocale = (locale) => {
    const localeDate = DateTime.now().setLocale(locale);
    const hasMeridiem = localeDate.set({ minute: 1 }).toFormat('t', { locale }).length > 5; // 1:00 PM, 01:00 PM
    return hasMeridiem;
};
/** Provides a static time ago value */
const toRelativeTime = (value, options = { style: 'long' }) => {
    // if no value just return an empty string
    if (!value) {
        return null;
    }
    let dateTime;
    if (value instanceof Date) {
        dateTime = DateTime.fromJSDate(value);
    }
    else if (typeof value === 'string') {
        dateTime = DateTime.fromISO(value);
    }
    else {
        dateTime = value;
    }
    if (!dateTime.isValid) {
        return null;
    }
    // convert 1 day ago to 'yesterday'
    const diffDays = Math.abs(dateTime.diff(DateTime.now(), 'days').days);
    if (diffDays >= 1 && diffDays < 2) {
        return dateTime.toRelativeCalendar({
            ...(options || {}),
            unit: 'days',
        });
    }
    return dateTime.toRelative(options);
};

class LinearLoaderComponent {
    constructor() {
        /**
         * Theme for loader.
         */
        this.theme = ThemeType.PRIMARY;
        /**
         * Specifies whether the load bar should appear or not
         */
        this.show = false;
        /**
         * Specifies the load bar position relative to the datatable
         */
        this.position = 'top';
    }
    /**
     * The classes to apply to the host component
     *
     * @ignore
     */
    get hostClasses() {
        const classes = [];
        if (this.show) {
            classes.push('active');
        }
        classes.push(`position-${this.position}`);
        return classes.join(' ');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LinearLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: LinearLoaderComponent, selector: "avn-linear-loader", inputs: { theme: "theme", show: "show", position: "position" }, host: { properties: { "class": "this.hostClasses" } }, viewQueries: [{ propertyName: "loadbarElement", first: true, predicate: ["loadbarElement"], descendants: true }], ngImport: i0, template: "<div class=\"load-bar\" #loadbarElement [avnTheme]=\"theme\"></div>\n", styles: [":host{position:absolute;width:100%;height:4px;opacity:0;transition:opacity .3s ease-out;z-index:1}:host.active{opacity:1;transition:opacity .2s ease-in}:host.active .load-bar{animation:loading-animation 1.5s linear infinite}:host.active .load-bar.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host.active .load-bar.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host.active .load-bar.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host.active .load-bar.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host.active .load-bar.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host.active .load-bar.theme-info{background-color:var(--info-base);color:var(--info-on)}:host.active .load-bar.theme-success{background-color:var(--success-base);color:var(--success-on)}@keyframes loading-animation{0%{left:0%;width:0%}66.6666%{left:50%;width:50%}to{left:100%;width:0%}}:host:not(.active){display:none}:host.position-top{top:0}:host.position-bottom{bottom:0}:host .load-bar{content:\"\";display:inline;position:absolute;height:100%}\n"], dependencies: [{ kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LinearLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-linear-loader', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"load-bar\" #loadbarElement [avnTheme]=\"theme\"></div>\n", styles: [":host{position:absolute;width:100%;height:4px;opacity:0;transition:opacity .3s ease-out;z-index:1}:host.active{opacity:1;transition:opacity .2s ease-in}:host.active .load-bar{animation:loading-animation 1.5s linear infinite}:host.active .load-bar.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host.active .load-bar.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host.active .load-bar.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host.active .load-bar.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host.active .load-bar.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host.active .load-bar.theme-info{background-color:var(--info-base);color:var(--info-on)}:host.active .load-bar.theme-success{background-color:var(--success-base);color:var(--success-on)}@keyframes loading-animation{0%{left:0%;width:0%}66.6666%{left:50%;width:50%}to{left:100%;width:0%}}:host:not(.active){display:none}:host.position-top{top:0}:host.position-bottom{bottom:0}:host .load-bar{content:\"\";display:inline;position:absolute;height:100%}\n"] }]
        }], propDecorators: { loadbarElement: [{
                type: ViewChild,
                args: ['loadbarElement', { static: false }]
            }], theme: [{
                type: Input
            }], show: [{
                type: Input
            }], position: [{
                type: Input
            }], hostClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * The Loader component displays a spinning loader and blocks the ui with an overlay.
 * - It plays the loading fade in animation when 'isLoading' input is set to true
 * - It only plays the loader fade out animation when 'isLoading' input is set to false and the loader was in loading state
 + - Debounces the loading state to allow the loader fade animation to complete before showing the next one
 */
class LoaderComponent {
    /** @ignore **/
    constructor(animationBuilder, elementRef, _renderer) {
        this.animationBuilder = animationBuilder;
        this.elementRef = elementRef;
        this._renderer = _renderer;
        /** The base duration in milliseconds for each step of the animation */
        this.durationBaseMs = 200;
        /** The icon to be displayed in the loader */
        this.icon = 'hardware:device_hub';
        /** determine if the overlay has the full opacity, which will cover other components */
        this.fullOpacityOverlay = false;
        /**
         * @ignore
         * Subject that emits every time the loader state changes
         */
        this.loadingStateSubject = new BehaviorSubject(false);
        /**
         *@ignore
         * Subject that emits every time an animation is playing
         **/
        this.animationPlayingSubject = new BehaviorSubject(false);
        /**
         * @ignore
         * The bezier for the animation *
         */
        this.BEZIER = 'cubic-bezier(0.4, 0, 0.2, 1)';
        /** @ignore Pattern used to close all subscriptions **/
        this.componentDestroyed$ = new Subject();
        // this.img$ = this.loaderIconRegistryService.loaderImg$;
    }
    /** Specifies the current state of the loader */
    get isLoading() {
        return this.loadingStateSubject.getValue();
    }
    /** Speficies if the loader animation should be displayed or not*/
    set isLoading(val) {
        this.loadingStateSubject.next(!!val);
    }
    /** @ignore **/
    ngAfterViewInit() {
        const loadingStateWhenAnimationCompleted$ = this.animationPlayingSubject.pipe(filter((playing) => !playing), switchMap(() => of(this.loadingStateSubject.value)));
        // ignore unloading states until the loader is show at least once
        const firstRequestToShowLoader$ = this.loadingStateSubject.pipe(filter((loading) => !!loading), take(1));
        // wait until the animation completed before showing the opposite animation
        // Use the latest loading state value received within the time of the animation
        firstRequestToShowLoader$
            .pipe(switchMap(() => this.loadingStateSubject.pipe(distinctUntilChanged(), withLatestFrom(this.animationPlayingSubject.asObservable()), switchMap(([loadingState, isAnimationPlaying]) => (isAnimationPlaying ? loadingStateWhenAnimationCompleted$ : of(loadingState))), distinctUntilChanged(), observeOn(asapScheduler), // Hack to fix a bug where the player 'start' event is not called sometimes
        takeUntil(this.componentDestroyed$))))
            .subscribe((loadingState) => this.playAnimation(loadingState));
    }
    /** Play the animation specified by the loading state **/
    playAnimation(loadingState) {
        // destroy any previous animation
        if (this.player) {
            this.player.destroy();
        }
        // create the animation
        let animationFactory;
        if (loadingState) {
            // Loading animation
            animationFactory = this.animationBuilder.build(animation([
                style({ visibility: 'visible' }),
                query('.logo-container, .loader-container, .spinner, .overlay, p', [style({ visibility: 'hidden' })]),
                group([
                    query('.overlay', [
                        style({ visibility: 'hidden', opacity: 0 }),
                        animate(`${this.durationBaseMs}ms ${this.BEZIER}`, style({
                            visibility: 'visible',
                            opacity: this.fullOpacityOverlay === true ? 1 : 0.2,
                        })),
                    ]),
                    query('.loader-container', [style({ visibility: 'visible' })]),
                    query('.logo-container', [
                        style({
                            visibility: 'hidden',
                            opacity: 0,
                            transform: 'scale(0)',
                        }),
                        animate(`${this.durationBaseMs}ms ${this.BEZIER}`, style({
                            visibility: 'visible',
                            opacity: 1,
                            transform: 'scale(1)',
                        })),
                    ]),
                ]),
                group([
                    query('.spinner:not(.spin)', [
                        style({ visibility: 'hidden', opacity: 0 }),
                        animate(`${this.durationBaseMs * 2}ms ${this.BEZIER}`, style({ visibility: 'visible', opacity: 0.65 })),
                    ]),
                    query('.spinner.spin, p', [
                        style({ visibility: 'hidden', opacity: 0 }),
                        animate(`${this.durationBaseMs * 2}ms ${this.BEZIER}`, style({ visibility: 'visible', opacity: 1 })),
                    ]),
                ]),
            ]));
        }
        else {
            // Unloading animation
            animationFactory = this.animationBuilder.build(animation([
                style({ visibility: 'visible' }),
                query('.spinner, p', [
                    style({ visibility: 'visible', opacity: 1 }),
                    animate(`${this.durationBaseMs * 2}ms ${this.BEZIER}`, style({ visibility: 'hidden', opacity: 0 })),
                ]),
                query('.logo-container', [
                    style({ visibility: 'visible', opacity: 1, transform: 'scale(1)' }),
                    animate(`${this.durationBaseMs}ms ${this.BEZIER}`, style({
                        visibility: 'hidden',
                        opacity: 0,
                        transform: 'scale(0)',
                    })),
                ]),
                query('.loader-container', [style({ visibility: 'hidden' })]),
                query('.overlay', [
                    style({ visibility: 'visible', opacity: 0.2, height: '100%' }),
                    animate(`${this.durationBaseMs}ms ${this.BEZIER}`, style({ visibility: 'hidden', opacity: 0, height: 0 })),
                ]),
                style({ visibility: 'hidden' }),
            ]));
        }
        // create the player, register callback and play the animation
        this.player = animationFactory.create(this.elementRef.nativeElement);
        this.player.onStart(() => {
            this._renderer.removeClass(this.elementRef.nativeElement, 'loader-inactive');
            this.onAnimationStart();
        });
        this.player.onDone(() => {
            this.onAnimationEnd();
            if (!loadingState) {
                this._renderer.addClass(this.elementRef.nativeElement, 'loader-inactive');
            }
        });
        this.player.play();
    }
    /** Called when the loader animation is started **/
    onAnimationStart() {
        this.animationPlayingSubject.next(true);
    }
    /** Called when the loader animation is completed **/
    onAnimationEnd() {
        this.animationPlayingSubject.next(false);
    }
    /** @ignore **/
    ngOnDestroy() {
        // destroy the latest animation, if any
        if (this.player) {
            this.player.destroy();
        }
        // unsubscribe all subscriptions
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderComponent, deps: [{ token: i1$1.AnimationBuilder }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: LoaderComponent, selector: "avn-loader", inputs: { durationBaseMs: "durationBaseMs", displayText: "displayText", icon: "icon", fullOpacityOverlay: "fullOpacityOverlay", isLoading: "isLoading" }, ngImport: i0, template: "<div #loaderContainer class=\"loader-container\">\n  <div #logoContainer class=\"logo-container\">\n    <img *ngIf=\"img$ | async; else elseIcon\" [src]=\"img$ | async\" />\n    <ng-template #elseIcon>\n      <avn-icon [icon]=\"icon\"></avn-icon>\n    </ng-template>\n  </div>\n  <div #spinnerBackground class=\"spinner\"></div>\n  <div #spinner class=\"spinner spin\"></div>\n</div>\n<p #loaderText *ngIf=\"displayText\">{{ displayText }}</p>\n<avn-overlay #overlay class=\"overlay\"></avn-overlay>\n", styles: [":host{position:absolute;width:100%;height:100%;top:0;left:0;z-index:10;display:flex;justify-content:center;align-items:center;flex-direction:column;visibility:hidden}:host.loader-inactive{display:none}:host .loader-container{position:relative;display:block;width:100px;height:100px;overflow:hidden}:host .loader-container .logo-container{position:absolute;left:6px;top:6px;z-index:10;background:white;border-radius:50%;height:88px;width:88px;box-shadow:0 0 5px #00000080;display:flex;justify-content:center;align-items:center}:host .loader-container .logo-container>img{width:70px;height:70px}:host .loader-container .spinner,:host .loader-container .spinner:after{border-radius:50%}:host .loader-container .spinner{font-size:var(--text-sm);position:absolute;text-indent:-9999em;z-index:9;box-shadow:0 0 5px #00000080;height:100px;width:100px;opacity:.65}:host .loader-container .spinner.spin{border:10px solid transparent;border-left:10px solid;opacity:1;z-index:8;animation:load8 .4s infinite linear}:host p{font-size:var(--text-lg);opacity:1;text-shadow:0 0 2px;margin-top:var(--space-md)}:host ::ng-deep avn-overlay{opacity:.2;background:var(--main-background);width:100%;height:100%;z-index:7;display:block;left:0;position:absolute}:host.theme-primary{color:var(--primary-base)}:host.theme-primary .spinner{border:10px solid var(--primary-base)}:host.theme-secondary{color:var(--secondary-base)}:host.theme-secondary .spinner{border:10px solid var(--secondary-base)}:host.theme-highlight{color:var(--highlight-base)}:host.theme-highlight .spinner{border:10px solid var(--highlight-base)}:host.theme-danger{color:var(--danger-base)}:host.theme-danger .spinner{border:10px solid var(--danger-base)}:host.theme-warning{color:var(--warning-base)}:host.theme-warning .spinner{border:10px solid var(--warning-base)}:host.theme-info{color:var(--info-base)}:host.theme-info .spinner{border:10px solid var(--info-base)}:host.theme-success{color:var(--success-base)}:host.theme-success .spinner{border:10px solid var(--success-base)}@keyframes load8{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: OverlayComponent, selector: "avn-overlay", inputs: ["visible", "fullPage"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-loader', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #loaderContainer class=\"loader-container\">\n  <div #logoContainer class=\"logo-container\">\n    <img *ngIf=\"img$ | async; else elseIcon\" [src]=\"img$ | async\" />\n    <ng-template #elseIcon>\n      <avn-icon [icon]=\"icon\"></avn-icon>\n    </ng-template>\n  </div>\n  <div #spinnerBackground class=\"spinner\"></div>\n  <div #spinner class=\"spinner spin\"></div>\n</div>\n<p #loaderText *ngIf=\"displayText\">{{ displayText }}</p>\n<avn-overlay #overlay class=\"overlay\"></avn-overlay>\n", styles: [":host{position:absolute;width:100%;height:100%;top:0;left:0;z-index:10;display:flex;justify-content:center;align-items:center;flex-direction:column;visibility:hidden}:host.loader-inactive{display:none}:host .loader-container{position:relative;display:block;width:100px;height:100px;overflow:hidden}:host .loader-container .logo-container{position:absolute;left:6px;top:6px;z-index:10;background:white;border-radius:50%;height:88px;width:88px;box-shadow:0 0 5px #00000080;display:flex;justify-content:center;align-items:center}:host .loader-container .logo-container>img{width:70px;height:70px}:host .loader-container .spinner,:host .loader-container .spinner:after{border-radius:50%}:host .loader-container .spinner{font-size:var(--text-sm);position:absolute;text-indent:-9999em;z-index:9;box-shadow:0 0 5px #00000080;height:100px;width:100px;opacity:.65}:host .loader-container .spinner.spin{border:10px solid transparent;border-left:10px solid;opacity:1;z-index:8;animation:load8 .4s infinite linear}:host p{font-size:var(--text-lg);opacity:1;text-shadow:0 0 2px;margin-top:var(--space-md)}:host ::ng-deep avn-overlay{opacity:.2;background:var(--main-background);width:100%;height:100%;z-index:7;display:block;left:0;position:absolute}:host.theme-primary{color:var(--primary-base)}:host.theme-primary .spinner{border:10px solid var(--primary-base)}:host.theme-secondary{color:var(--secondary-base)}:host.theme-secondary .spinner{border:10px solid var(--secondary-base)}:host.theme-highlight{color:var(--highlight-base)}:host.theme-highlight .spinner{border:10px solid var(--highlight-base)}:host.theme-danger{color:var(--danger-base)}:host.theme-danger .spinner{border:10px solid var(--danger-base)}:host.theme-warning{color:var(--warning-base)}:host.theme-warning .spinner{border:10px solid var(--warning-base)}:host.theme-info{color:var(--info-base)}:host.theme-info .spinner{border:10px solid var(--info-base)}:host.theme-success{color:var(--success-base)}:host.theme-success .spinner{border:10px solid var(--success-base)}@keyframes load8{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.AnimationBuilder }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { durationBaseMs: [{
                type: Input
            }], displayText: [{
                type: Input
            }], icon: [{
                type: Input
            }], fullOpacityOverlay: [{
                type: Input
            }], isLoading: [{
                type: Input
            }] } });

/**
 * Represents the multiple states of the data load
 * - INIT: The data has not been loaded yet (e.g. no api call was made yet)
 * - LOADING: The data is currently loading (e.g. being fetched from a api endpoint)
 * - LOADED: The data is loaded successfully (e.g. fetched successfully from a api endpoint)
 * **/
var LoadingState;
(function (LoadingState) {
    LoadingState["INIT"] = "INIT";
    LoadingState["LOADING"] = "LOADING";
    LoadingState["LOADED"] = "LOADED";
})(LoadingState || (LoadingState = {}));

/* eslint-disable no-prototype-builtins */
/** Checks the data state to see if there is an error, and returns it if that's the case. **/
const getAsyncDataError = (dataState) => {
    if (dataState?.hasOwnProperty('errorMsg')) {
        return dataState.errorMsg || '';
    }
    return null;
};
/**  Helper function to check if we have an error **/
const hasAsyncDataError = (dataState) => getAsyncDataError(dataState) !== null;
/**  Returns an observable that emits the data every time it is ready state changes (loaded successfully or with errors) **/
const dataWhenReady = (data$, dataState$, takeCount) => {
    const result$ = dataState$.pipe(filter((dataState) => dataState === LoadingState.LOADED || hasAsyncDataError(dataState)), switchMap(() => data$.pipe(take(1))));
    if (takeCount > 0) {
        return result$.pipe(take(takeCount));
    }
    return result$;
};
/**  Returns an observable that emits the data every time it is changing, once loaded at least once successfully or with errors **/
const dataOnceReady = (data$, dataState$, takeCount) => {
    const result$ = dataState$.pipe(filter((dataState) => dataState === LoadingState.LOADED || hasAsyncDataError(dataState)), take(1), switchMap(() => data$));
    if (takeCount > 0) {
        return result$.pipe(take(takeCount));
    }
    return result$;
};
/**  Merge the data states of several requests to determine the actual data state **/
const combineDataStates = (dataStates) => {
    // if all calls are loaded, mark as loaded
    if (dataStates.every((dataState) => dataState === LoadingState.LOADED)) {
        return LoadingState.LOADED;
    }
    // if all calls are init, mark as init
    if (dataStates.every((dataState) => dataState === LoadingState.INIT)) {
        return LoadingState.INIT;
    }
    // if there is one error, then mark as error (concat error messages)
    if (dataStates.some((dataState) => hasAsyncDataError(dataState))) {
        return {
            errorMsg: dataStates
                .filter((dataState) => hasAsyncDataError(dataState))
                .map((dataState) => dataState.errorMsg)
                .join(' - '),
        };
    }
    // otherwise it's loading
    return LoadingState.LOADING;
};

/**
 * Configuration for the async data module
 */
const ASYNC_DATA_CONFIG = new InjectionToken('ASYNC_DATA_CONFIG');
/**
 * Optional configuration for error handling of the async data
 */
const ASYNC_DATA_ERROR_HANDLER = new InjectionToken('ASYNC_DATA_ERROR_HANDLER');
/**
 * Default configuration for async data module
 */
const DEFAULT_ASYNC_DATA_CONFIG = {
    loaderIcon: 'notification:sync',
};

/**
 * This directive allows to manage async data and display a different view (template) when:
 *  - the data is loading
 *  - the data is loaded successfully
 *  - the data is loaded successfully but is empty
 *  - the data is loaded with error
 *
 * Say you have a page with a form to edit a user, and you want to display:
 * - a loader while the user is being fetched in the database
 * - the actual formed filled with user data once the data is loaded
 * - custom error information (if the server returned an error)
 * - a not found message (if the server did not return an error but no user could be found)
 *
 * This directive allows to simplify this particular use case, especially if used in combination with the ngrx loading state helpers (@see state.utils.ts) or
 * with the api request service (@see api-request-state.ts)
 *
 * It allows to display the relevant content based on the current loading state of the data.
 * First you need to pass the data you want to watch.
 * Then you can pass the current data state (loading / loaded / error / empty)
 * If no loaded$ observable is passed, the data will be considered as loaded right away.
 * You can pass a custom template for each state.
 *
 * Also, the directive provides 2 defaults loaders (dynamically loaded) that you can use:
 * - 'icon' : a small loading icon
 * - 'loader' : the regular amp loader
 */
class AsyncDataDirective {
    constructor(_asyncDataConfig, _viewContainerRef, _templateRef, changeDetector, _injector, _renderer) {
        this._asyncDataConfig = _asyncDataConfig;
        this._viewContainerRef = _viewContainerRef;
        this._templateRef = _templateRef;
        this.changeDetector = changeDetector;
        this._injector = _injector;
        this._renderer = _renderer;
        /** If the view should continue to be displayed while in 'loading' state **/
        this.backgroundRefreshEnable = false;
        /** @ignore used in background refresh mode to display loading only the first time */
        this._isFirstLoading = true;
        /** @ignore is the 'loaded' view in the DOM already */
        this._isViewLoaded = false;
    }
    ngOnInit() {
        if (!this.loaderIcon) {
            this.loaderIcon = this._asyncDataConfig?.loaderIcon || DEFAULT_ASYNC_DATA_CONFIG.loaderIcon;
        }
    }
    ngOnChanges({ state }) {
        if (state) {
            if ((state.currentValue === LoadingState.LOADING && !this.backgroundRefreshEnable) ||
                (state.currentValue === LoadingState.LOADING && this.backgroundRefreshEnable && this._isFirstLoading)) {
                this._onLoading();
            }
            else if (state.currentValue === LoadingState.LOADED) {
                this._onLoaded();
            }
            else if (hasAsyncDataError(state.currentValue)) {
                this._onError();
            }
            if (!state.isFirstChange()) {
                // make the content appear
                // only call when not on first change to avoid this issue: https://github.com/angular/angular/issues/38611
                this.changeDetector.detectChanges();
            }
        }
    }
    ngOnDestroy() {
        // destroy any created instance of loader component
        this._loaderRef?.destroy();
        this._linearLoaderRef?.destroy();
        this._iconLoaderRef?.destroy();
    }
    _onLoading() {
        this._isFirstLoading = false;
        this._clearExistingView();
        // show the loading template while the data is loading
        // if no loading template is specified, it will use show the type of loader specified, or nothing if no loader is specified
        if (this.loadingTemplate) {
            this._activeEmbeddedViewRef = this._viewContainerRef.createEmbeddedView(this.loadingTemplate, this.loadingTemplateContext);
        }
        else {
            switch (this.loaderType) {
                case 'loader': {
                    this._loaderRef = this._viewContainerRef.createComponent(LoaderComponent, { injector: this._injector });
                    this._loaderRef.location.nativeElement.classList.add('theme-primary');
                    this._loaderRef.instance.isLoading = true;
                    this._loaderRef.changeDetectorRef.detectChanges();
                    break;
                }
                case 'icon': {
                    this._iconLoaderRef = this._viewContainerRef.createComponent(IconComponent, { injector: this._injector });
                    this._iconLoaderRef.instance.ngOnChanges({ icon: new SimpleChange(null, this.loaderIcon, false) });
                    this._iconLoaderRef.instance.rotate = true;
                    this._iconLoaderRef.changeDetectorRef.detectChanges();
                    this._iconLoaderRef.location.nativeElement.classList.add('default-loader');
                    break;
                }
                case 'linear': {
                    this._linearLoaderRef = this._viewContainerRef.createComponent(LinearLoaderComponent, { injector: this._injector });
                    this._linearLoaderRef.instance.show = true;
                    this._linearLoaderRef.changeDetectorRef.detectChanges();
                    break;
                }
            }
        }
    }
    _onLoaded() {
        if (this.backgroundRefreshEnable && this._isViewLoaded) {
            // this means the view is already loaded in the DOM
            return;
        }
        this._clearExistingView();
        // show the empty template if the data is empty, otherwise show the loaded data template (the directive's template)
        if (!!this.emptyTemplate && this._isDataEmpty(this.data)) {
            this._activeEmbeddedViewRef = this._viewContainerRef.createEmbeddedView(this.emptyTemplate, this.emptyTemplateContext);
        }
        else {
            this._activeEmbeddedViewRef = this._viewContainerRef.createEmbeddedView(this._templateRef);
            this._isViewLoaded = true;
        }
    }
    _onError() {
        this._clearExistingView();
        // show the error template if there was an error loading the data
        // if no error template is specified, nothing will show
        if (this.errorTemplate) {
            this._activeEmbeddedViewRef = this._viewContainerRef.createEmbeddedView(this.errorTemplate, this.errorTemplateContext);
        }
    }
    _isDataEmpty(data) {
        if (this.emptyFn) {
            return this.emptyFn(data);
        }
        if (data === undefined || data === null) {
            return true;
        }
        if (data.constructor.name === 'Array') {
            return data.length === 0;
        }
        return false;
    }
    _clearExistingView() {
        // clear the current view, including loaders
        if (this._loaderRef?.instance.isLoading) {
            // for the regular loader, we cant clear the viewContainerRef because that would clear the loader straight away. But we want to show the unload animation.
            this._loaderRef.instance.isLoading = false;
        }
        else {
            // destroy the existing component instances
            this._iconLoaderRef?.destroy();
            this._linearLoaderRef?.destroy();
            this._viewContainerRef.clear();
        }
        // destroy any previous view
        if (this._activeEmbeddedViewRef) {
            this._activeEmbeddedViewRef.destroy();
            this._isViewLoaded = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataDirective, deps: [{ token: ASYNC_DATA_CONFIG, optional: true }, { token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: AsyncDataDirective, selector: "[avnAsyncData]", inputs: { data: ["avnAsyncData", "data"], state: ["avnAsyncDataState", "state"], loadingTemplate: ["avnAsyncDataLoadingTemplate", "loadingTemplate"], loadingTemplateContext: ["avnAsyncDataLoadingTemplateContext", "loadingTemplateContext"], loaderType: ["avnAsyncDataLoaderType", "loaderType"], loaderIcon: ["avnAsyncDataLoaderIcon", "loaderIcon"], errorTemplate: ["avnAsyncDataErrorTemplate", "errorTemplate"], errorTemplateContext: ["avnAsyncDataErrorTemplateContext", "errorTemplateContext"], emptyTemplate: ["avnAsyncDataEmptyTemplate", "emptyTemplate"], emptyTemplateContext: ["avnAsyncDataEmptyTemplateContext", "emptyTemplateContext"], emptyFn: ["avnAsyncDataEmptyFn", "emptyFn"], backgroundRefreshEnable: ["avnAsyncDataBackgroundRefreshEnable", "backgroundRefreshEnable"] }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnAsyncData]',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ASYNC_DATA_CONFIG]
                }, {
                    type: Optional
                }] }, { type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: i0.Renderer2 }]; }, propDecorators: { data: [{
                type: Input,
                args: ['avnAsyncData']
            }], state: [{
                type: Input,
                args: ['avnAsyncDataState']
            }], loadingTemplate: [{
                type: Input,
                args: ['avnAsyncDataLoadingTemplate']
            }], loadingTemplateContext: [{
                type: Input,
                args: ['avnAsyncDataLoadingTemplateContext']
            }], loaderType: [{
                type: Input,
                args: ['avnAsyncDataLoaderType']
            }], loaderIcon: [{
                type: Input,
                args: ['avnAsyncDataLoaderIcon']
            }], errorTemplate: [{
                type: Input,
                args: ['avnAsyncDataErrorTemplate']
            }], errorTemplateContext: [{
                type: Input,
                args: ['avnAsyncDataErrorTemplateContext']
            }], emptyTemplate: [{
                type: Input,
                args: ['avnAsyncDataEmptyTemplate']
            }], emptyTemplateContext: [{
                type: Input,
                args: ['avnAsyncDataEmptyTemplateContext']
            }], emptyFn: [{
                type: Input,
                args: ['avnAsyncDataEmptyFn']
            }], backgroundRefreshEnable: [{
                type: Input,
                args: ['avnAsyncDataBackgroundRefreshEnable']
            }] } });

class LoaderModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: LoaderModule, declarations: [LoaderComponent, LinearLoaderComponent], imports: [CommonModule, CoreModule, IconModule, OverlayModule, HttpClientModule], exports: [LoaderComponent, LinearLoaderComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderModule, imports: [CommonModule, CoreModule, IconModule, OverlayModule, HttpClientModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, OverlayModule, HttpClientModule],
                    declarations: [LoaderComponent, LinearLoaderComponent],
                    providers: [],
                    exports: [LoaderComponent, LinearLoaderComponent]
                }]
        }] });

class AsyncDataModule {
    static forRoot(config) {
        return {
            ngModule: AsyncDataModule,
            providers: [
                { provide: ASYNC_DATA_CONFIG, useValue: { ...DEFAULT_ASYNC_DATA_CONFIG, ...config } },
                config.errorHandler
                    ? {
                        provide: ASYNC_DATA_ERROR_HANDLER,
                        useFactory: config.errorHandler.useFactory,
                        deps: config.errorHandler.deps,
                    }
                    : [],
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataModule, declarations: [AsyncDataDirective], imports: [IconModule, LoaderModule], exports: [AsyncDataDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataModule, imports: [IconModule, LoaderModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IconModule, LoaderModule],
                    declarations: [AsyncDataDirective],
                    exports: [AsyncDataDirective],
                }]
        }] });

/**
 * Utility class used to manage loading state of api requests.
 * Use in combination with the AsyncData directive
 * **/
class ApiRequestState {
    constructor() {
        this._dataStateSubject = new BehaviorSubject(LoadingState.INIT);
        this.dataState$ = this._dataStateSubject.asObservable();
        this.init$ = this.dataState$.pipe(map((dataState) => dataState === LoadingState.INIT));
        this.loading$ = this.dataState$.pipe(map((dataState) => dataState === LoadingState.LOADING));
        this.loaded$ = this.dataState$.pipe(map((dataState) => dataState === LoadingState.LOADED));
        this.error$ = this.dataState$.pipe(map((dataState) => getAsyncDataError(dataState)));
        this.hasError$ = this.dataState$.pipe(map((dataState) => hasAsyncDataError(dataState)));
    }
    /** Inits the flag and marks the request as pending **/
    init() {
        this._dataStateSubject.next(LoadingState.INIT);
    }
    /** Marks the request as loading **/
    loading() {
        this._dataStateSubject.next(LoadingState.LOADING);
    }
    /** Marks the request as successfully loaded **/
    loadSuccess() {
        this._dataStateSubject.next(LoadingState.LOADED);
    }
    /** Marks the request as unsuccessful and sets the error **/
    loadError(error) {
        this._dataStateSubject.next({ errorMsg: error?.message || error });
    }
}

class AsyncDataService {
    constructor(_errorHandler) {
        this._errorHandler = _errorHandler;
    }
    /**
     * Performs a request and manages the loading state of the request by updating the passed apiRequestState object
     *
     * @param request$ an observable of the request to execute (e.g. a GET api call, a PUT update, etc..)
     * @param apiRequestState the ApiRequestState object that will get updated with the latest loading state
     * @param errorMessageInfo Contains information about the error message to display when an error occurs
     * @param errorReturnValue A default value to return when an error occurs. If specified, no error will be thrown.
     */
    doRequestWithState$(request$, apiRequestState, errorMessageInfo, errorReturnValue) {
        apiRequestState.loading();
        return request$.pipe(tap(() => apiRequestState.loadSuccess()), catchError((err) => {
            apiRequestState.loadError(err.message || err);
            return this._handleError(errorReturnValue, errorMessageInfo, err);
        }));
    }
    /**
     * Performs a request and can automatically manage errors
     *
     * @param request$ an observable of the request to execute (e.g. a GET api call, a PUT update, etc..)
     * @param errorMessageInfo Contains information about the error message to display when an error occurs
     * @param errorReturnValue A default value to return when an error occurs. If specified, no error will be thrown.
     */
    doRequest$(request$, errorMessageInfo, errorReturnValue) {
        return request$.pipe(catchError((err) => this._handleError(errorReturnValue, errorMessageInfo, err)));
    }
    _handleError(defaultReturnValue, errorMessageInfo, err) {
        if (!!this._errorHandler && !!errorMessageInfo) {
            this._errorHandler.handleError(errorMessageInfo);
        }
        if (defaultReturnValue === undefined) {
            return throwError(err);
        }
        return of(defaultReturnValue);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataService, deps: [{ token: ASYNC_DATA_ERROR_HANDLER, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AsyncDataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ASYNC_DATA_ERROR_HANDLER]
                }, {
                    type: Optional
                }] }]; } });

/**
 * A DI Token representing the google analytics configuration
 * Is used in DI to configure the analytics service.
 */
const GOOGLE_ANALYTICS_CONFIGURATION = new InjectionToken('GOOGLE_ANALYTICS_CONFIGURATION');
/**
 * A DI Token representing the google analytics custom dimensions provider
 */
const GOOGLE_ANALYTICS_DIMENSIONS_PROVIDER = new InjectionToken('GOOGLE_ANALYTICS_DIMENSIONS_PROVIDER');
/**
 * A DI Token representing the google analytics custom metrics provider
 */
const GOOGLE_ANALYTICS_METRICS_PROVIDER = new InjectionToken('GOOGLE_ANALYTICS_METRICS_PROVIDER');

/**
 * Provides a default implementation of the Dimensions Provider Service
 * Does not have any dimensions by default.
 */
class DimensionsProviderService {
    get dimensions$() {
        return of(null);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DimensionsProviderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DimensionsProviderService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DimensionsProviderService, decorators: [{
            type: Injectable
        }] });

const getDimensionsByScope = (dimensions, scope) => {
    return (dimensions || []).length > 0 ? dimensions.filter((dimension) => dimension.scope === scope)
        .reduce((res, dim) => {
        return { ...res, [dim.name]: dim.value };
    }, {}) : null;
};

/**
 * Wrapper service for Google Analytics 4
 */
class GoogleAnalyticsService {
    /**
     * @ignore
     */
    constructor(config, _window, document, dimensionsProviderService, metricsProviderService) {
        this.config = config;
        this._window = _window;
        this.document = document;
        this.serviceDestroyed$ = new Subject();
        this.appendTrackingScript();
        // watch dimensions changes
        dimensionsProviderService.dimensions$.pipe(takeUntil$1(this.serviceDestroyed$)).subscribe((dimensions) => {
            this.eventDimensions = getDimensionsByScope(dimensions, 'event');
            this.userDimensions = getDimensionsByScope(dimensions, 'user');
            if (this.userDimensions) {
                this._window['gtag']('set', 'user_properties', this.userDimensions);
            }
        });
        // watch metrics changes
        metricsProviderService.metrics$.pipe(takeUntil$1(this.serviceDestroyed$)).subscribe((metrics) => {
            this.metrics = metrics;
        });
    }
    /** @ignore **/
    ngOnDestroy() {
        this.serviceDestroyed$.next();
        this.serviceDestroyed$.complete();
    }
    /**
     * Sends a pageview hit to Google Analytics
     *
     * @param data  the data describing the page to be sent
     */
    trackPageView(data) {
        // Set the params for GA
        const params = { page_path: data.page };
        // Add dimensions and metrics
        this.addExtraParameters(params, this.eventDimensions);
        this.addExtraParameters(params, this.metrics);
        // Send to GA
        this._window['gtag']('event', 'page_view', params);
    }
    /**
     * Sends a custom event to Google Analytics 4
     *
     * @param data   the data describing the event to be sent
     */
    trackEvent(data) {
        // Set the params for GA
        const params = Object.keys(data).reduce((res, key) => {
            return {
                ...res,
                [snakeCase(key)]: data[key], // Convert to snake case to follow the convention of GA4
            };
        }, {});
        // Add dimensions and metrics
        this.addExtraParameters(params, this.eventDimensions);
        this.addExtraParameters(params, this.metrics);
        // Send to GA. Convert the event name to snake case to follow the convention of GA4
        this._window['gtag']('event', snakeCase(data.eventAction), params);
    }
    /**
     * Sends a custom event of event type exception to Google Analytics 4
     *
     * @param data The data describing the exception/error to be sent
     */
    trackError(data) {
        // Set the params for GA
        const params = {
            description: data.exDescription,
            fatal: data.exFatal,
        };
        // Add dimensions and metrics
        this.addExtraParameters(params, this.eventDimensions);
        this.addExtraParameters(params, this.metrics);
        // Send to GA
        this._window['gtag']('event', 'exception', params);
    }
    /**
     * Appends the scripts for Google Tag Manager and Google Analytics 4 to DOM
     */
    appendTrackingScript() {
        const googleTagScriptElement = this.document.createElement('script');
        googleTagScriptElement.type = 'text/javascript';
        googleTagScriptElement.id = 'googleTag';
        googleTagScriptElement.async = true;
        googleTagScriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${this.config.apiKey}`;
        this.document.head.appendChild(googleTagScriptElement);
        const googleTagConfigElement = this.document.createElement('script');
        googleTagConfigElement.type = 'text/javascript';
        googleTagConfigElement.id = 'googleTagConfigElement';
        googleTagConfigElement.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${this.config.apiKey}');
    `;
        this.document.head.appendChild(googleTagConfigElement);
    }
    /**
     *  Adds extra parameters to the data sent to GA
     *
     *  @ignore
     */
    addExtraParameters(params, data) {
        // metrics
        if (data != null) {
            Object.keys(data).forEach((key) => {
                params[key] = data[key];
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GoogleAnalyticsService, deps: [{ token: GOOGLE_ANALYTICS_CONFIGURATION }, { token: WINDOW }, { token: DOCUMENT }, { token: GOOGLE_ANALYTICS_DIMENSIONS_PROVIDER }, { token: GOOGLE_ANALYTICS_METRICS_PROVIDER }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GoogleAnalyticsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GoogleAnalyticsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [GOOGLE_ANALYTICS_CONFIGURATION]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [GOOGLE_ANALYTICS_DIMENSIONS_PROVIDER]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [GOOGLE_ANALYTICS_METRICS_PROVIDER]
                }] }]; } });

/**
 * This is the main entry point for analytics
 * Any new analytics service can be injected in the constructor
 */
class AnalyticsService {
    /**
     * @ignore
     */
    constructor(googleAnalyticsService) {
        this.googleAnalyticsService = googleAnalyticsService;
    }
    /**
     * Sends a pageview hit to Google Analytics
     *
     * @param data  the data describing the page to be sent
     */
    trackPageView(data) {
        this.googleAnalyticsService.trackPageView(data);
    }
    /**
     * Sends a event hit to Google Analytics
     *
     * @param data   the data describing the event to be sent
     */
    trackEvent(data) {
        this.googleAnalyticsService.trackEvent(data);
    }
    /**
     * Sends a exception hit to Google Analytics
     *
     * @param data 	the data describing the exception/error to be sent
     */
    trackError(data) {
        this.googleAnalyticsService.trackError(data);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsService, deps: [{ token: GoogleAnalyticsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: GoogleAnalyticsService }]; } });

class AnalyticsDirective {
    /**
     * @ignore
     */
    constructor(analyticsService, elementRef) {
        this.analyticsService = analyticsService;
        this.elementRef = elementRef;
        /**
         * The action that will trigger the sending of the event to GA
         */
        this.trigger = 'click';
    }
    /**
     *  called when the component become available
     *
     *  @ignore
     */
    ngAfterViewInit() {
        // subscribe to the event defined in the directive
        this.gaEventListener = fromEvent(this.elementRef.nativeElement, this.trigger).subscribe((_) => {
            this.sendTrackEvent();
        });
    }
    /**
     *  called when the component is destroyed
     *
     *  @ignore
     */
    ngOnDestroy() {
        this.gaEventListener.unsubscribe();
    }
    /**
     * Sends the event to Google Analytics and others...someday
     *
     * @ignore
     */
    sendTrackEvent() {
        // prepare the analytics data
        if (this.category && this.action) {
            const analyticsData = {
                eventAction: this.action,
                eventCategory: this.category,
                eventLabel: this.label,
                eventValue: this.value,
            };
            // call the service
            this.analyticsService.trackEvent(analyticsData);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsDirective, deps: [{ token: AnalyticsService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: AnalyticsDirective, selector: "[avnAnalytics]", inputs: { trigger: "trigger", category: "category", action: "action", label: "label", value: "value" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnAnalytics]',
                }]
        }], ctorParameters: function () { return [{ type: AnalyticsService }, { type: i0.ElementRef }]; }, propDecorators: { trigger: [{
                type: Input
            }], category: [{
                type: Input
            }], action: [{
                type: Input
            }], label: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

/**
 * Provides a default implementation of the Metrics Provider Service
 */
class MetricsProviderService {
    get metrics$() {
        return of(null);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MetricsProviderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MetricsProviderService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MetricsProviderService, decorators: [{
            type: Injectable
        }] });

class AnalyticsModule {
    static forRoot(config) {
        return {
            ngModule: AnalyticsModule,
            providers: [
                {
                    provide: GOOGLE_ANALYTICS_CONFIGURATION,
                    useValue: config.googleAnalyticsConfig,
                },
                {
                    provide: GOOGLE_ANALYTICS_DIMENSIONS_PROVIDER,
                    useClass: config.dimensionsProviderService || DimensionsProviderService,
                },
                {
                    provide: GOOGLE_ANALYTICS_METRICS_PROVIDER,
                    useClass: config.metricsProviderService || MetricsProviderService,
                },
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsModule, declarations: [AnalyticsDirective], imports: [CoreModule], exports: [AnalyticsDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsModule, providers: [DimensionsProviderService, MetricsProviderService], imports: [CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AnalyticsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CoreModule],
                    providers: [DimensionsProviderService, MetricsProviderService],
                    declarations: [AnalyticsDirective],
                    exports: [AnalyticsDirective],
                }]
        }] });

/**
 * This interface represents the data that can be sent to Google analytics
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 */
class IAnalyticsEvent {
}

/**
 * This interface represents the data that can be sent to Google analytics
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
 */
class IAnalyticsPageView {
}

/**
 * This interface represents the data that can be sent to Google analytics
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
 */
class IAnalyticsException {
}

/**
 * Animations used by the dropdown component.
 * the dropdown content needs to be targeted and hidden so it doesn't flikr.
 */
const dropdownAnimations = {
    revealDropdown: trigger('revealDropdown', [
        state('close', style({
            opacity: 0,
            transform: 'scale(0.01, 0.01)',
        })),
        transition('close => enter', sequence([
            query('.avn-dropdown-content', style({ opacity: 0 })),
            animate('100ms linear', style({ opacity: 1, transform: 'scale(1, 0.5)' })),
            group([
                query('.avn-dropdown-content', animate('200ms cubic-bezier(0.55, 0, 0.55, 0.2)', style({ opacity: 1 }))),
                animate('100ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ transform: 'scale(1, 1)' })),
            ]),
        ])),
        transition('enter => close', sequence([
            group([query('.avn-dropdown-content', animate('100ms cubic-bezier(0.55, 0, 0.55, 0.2)', style({ opacity: 0 })))]),
            animate('100ms linear', style({ opacity: 1, transform: 'scale(0.01, 0.01)' })),
        ])),
    ]),
};

var PlacementTypes;
(function (PlacementTypes) {
    PlacementTypes[PlacementTypes["top"] = 'top'] = "top";
    PlacementTypes[PlacementTypes["bottom"] = 'bottom'] = "bottom";
    PlacementTypes[PlacementTypes["left"] = 'left'] = "left";
    PlacementTypes[PlacementTypes["right"] = 'right'] = "right";
})(PlacementTypes || (PlacementTypes = {}));
var TriggerTypes;
(function (TriggerTypes) {
    TriggerTypes["all"] = "all";
    TriggerTypes["click"] = "click";
    TriggerTypes["mouseover"] = "mouseover";
    TriggerTypes["focus"] = "focus";
    TriggerTypes["mouseenter"] = "mouseenter";
})(TriggerTypes || (TriggerTypes = {}));

var ActionBarItemPriority;
(function (ActionBarItemPriority) {
    ActionBarItemPriority[ActionBarItemPriority["PRIMARY"] = 0] = "PRIMARY";
    ActionBarItemPriority[ActionBarItemPriority["SECONDARY"] = 1] = "SECONDARY";
})(ActionBarItemPriority || (ActionBarItemPriority = {}));

/**
 * This animation transforms the select's overlay panel on and off the page.
 */
const panelAnimation = trigger('appearPanel', [
    state('void', style({
        transform: 'scaleY(0.8)',
        opacity: 0.5,
    })),
    state('opened', style({
        opacity: 1,
        transform: 'scaleY(1)',
    })),
    transition('void => opened', animate('120ms cubic-bezier(0, 0, 0.2, 1)')),
]);
/**
 * This component allow to display a projected element (using ng-content) connected to an origin
 * element
 *
 * Note: connected option list should be using this component to avoid duplicating logic (outside
 * click, etc..) However the connected option list was created before and therefore not refactored
 */
class ConnectedElementComponent {
    /** Indicates if the overlay is opened **/
    set opened(opened) {
        this._overlayOpenedSubject.next(opened);
    }
    /** @ignore **/
    constructor(_window, _document, _changeDetectorRef, _overlay) {
        this._window = _window;
        this._document = _document;
        this._changeDetectorRef = _changeDetectorRef;
        this._overlay = _overlay;
        /** Indicates if the options list overlay should be blocking with a backdrop **/
        this.hasOverlayBackdrop = false;
        /** Indicates if the backdrop should be visible **/
        this.hasVisibleBackdrop = false;
        /**
         * Indicates if connected overlay should close when a click is made outside of the overlay or
         * origin element *
         */
        this.closeOnOutsideClick = true;
        /** Whether the connected overlay background should be transparent or use the modal background **/
        this.transparent = false;
        /** Emits when user clicks outside the overlay, it contains current open/close status **/
        this.clickOutside = new EventEmitter();
        /** Emits when the element is opened/closed **/
        this.toggled = new EventEmitter();
        /** @ignore Subject that contain the opened state of the connected overlay **/
        this._overlayOpenedSubject = new BehaviorSubject(false);
        /** @ignore Pattern used to close all subscriptions **/
        this.componentDestroyed$ = new Subject();
        this.overlayOpened$ = this._overlayOpenedSubject.asObservable().pipe(map((opened) => !!this.overlayOrigin && opened), distinctUntilChanged());
        this.overlayOpened$.pipe(takeUntil(this.componentDestroyed$)).subscribe((opened) => {
            this.toggled.emit(opened);
        });
    }
    /** @ignore **/
    ngOnChanges({ overlayOrigin }) {
        if (overlayOrigin && overlayOrigin.currentValue) {
            this.directiveOverlayOrigin = overlayOrigin.currentValue;
        }
    }
    /** @ignore **/
    ngAfterViewInit() {
        this._watchOutsideClick();
        // reposition + recalculate size of the connected element when the window is resized
        fromEvent(this._window, 'resize')
            .pipe(filter(() => !!this.overlayOrigin && !!this._overlayOpenedSubject.value), debounceTime(200), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.updateOverlaySize();
            this.connectedOverlay.overlayRef.updatePosition();
        });
    }
    /** When detached(from ESC key), make sure we have the state as closed*/
    onOverlayDetached() {
        this._overlayOpenedSubject.next(false);
    }
    /** Updates the overlay size (min-width and width) **/
    updateOverlaySize() {
        // if the min width and the width are not set, set the min width to the origin element width
        const originElement = this.overlayOrigin.elementRef.nativeElement;
        let minWidth = this.minWidth;
        let width = this.width;
        if (!minWidth && !width) {
            minWidth = originElement.getBoundingClientRect().width;
            width = originElement.getBoundingClientRect().width;
        }
        if (this.connectedOverlay && this.connectedOverlay.overlayRef) {
            const size = {};
            if (minWidth) {
                size['minWidth'] = minWidth + 'px';
            }
            if (width) {
                if (isNaN(Number(width))) {
                    size['width'] = width;
                }
                else {
                    size['width'] = width + 'px';
                }
            }
            this.connectedOverlay.overlayRef.updateSize(size);
        }
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        // unsubscribe all subscriptions
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /**
     * @ignore
     *  close the overlay on outside click.
     *  *
     */
    _watchOutsideClick() {
        fromEvent(this._document, 'mousedown')
            .pipe(filter(() => !!this.overlayOrigin && !!this._overlayOpenedSubject.value), 
        // make sure the click was outside of the overlay and outside the origin element
        filter((evt) => !this.overlayOrigin.elementRef.nativeElement.contains(evt.target) && !this.connectedOverlay.overlayRef.overlayElement.contains(evt.target)), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            if (this.closeOnOutsideClick) {
                this._overlayOpenedSubject.next(false);
                this._changeDetectorRef.detectChanges();
            }
            this.clickOutside.emit(this._overlayOpenedSubject.value);
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ConnectedElementComponent, deps: [{ token: WINDOW }, { token: DOCUMENT }, { token: i0.ChangeDetectorRef }, { token: i1$4.Overlay }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: { minWidth: "minWidth", width: "width", overlayOrigin: "overlayOrigin", opened: "opened", hasOverlayBackdrop: "hasOverlayBackdrop", hasVisibleBackdrop: "hasVisibleBackdrop", positions: "positions", closeOnOutsideClick: "closeOnOutsideClick", transparent: "transparent" }, outputs: { clickOutside: "clickOutside", toggled: "toggled" }, viewQueries: [{ propertyName: "connectedOverlay", first: true, predicate: CdkConnectedOverlay, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-template\n  cdkConnectedOverlay\n  [cdkConnectedOverlayOrigin]=\"directiveOverlayOrigin\"\n  [cdkConnectedOverlayOpen]=\"overlayOpened$ | async\"\n  [cdkConnectedOverlayHasBackdrop]=\"hasOverlayBackdrop\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayBackdropClass]=\"hasVisibleBackdrop ? 'cdk-overlay-dark-backdrop' : 'cdk-overlay-transparent-backdrop'\"\n  (attach)=\"updateOverlaySize()\"\n  (detach)=\"onOverlayDetached()\"\n>\n  <div class=\"overlay-container\" [@appearPanel]=\"'opened'\" [class.transparent]=\"transparent\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n", styles: [":host{display:contents}.overlay-container{width:100%;transition:height .3s ease-in-out}.overlay-container:not(.transparent){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f!important;background-color:var(--modal-background);color:var(--modal-on)}\n"], dependencies: [{ kind: "directive", type: i1$4.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], animations: [panelAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ConnectedElementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-connected-element', changeDetection: ChangeDetectionStrategy.OnPush, animations: [panelAnimation], template: "<ng-template\n  cdkConnectedOverlay\n  [cdkConnectedOverlayOrigin]=\"directiveOverlayOrigin\"\n  [cdkConnectedOverlayOpen]=\"overlayOpened$ | async\"\n  [cdkConnectedOverlayHasBackdrop]=\"hasOverlayBackdrop\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayBackdropClass]=\"hasVisibleBackdrop ? 'cdk-overlay-dark-backdrop' : 'cdk-overlay-transparent-backdrop'\"\n  (attach)=\"updateOverlaySize()\"\n  (detach)=\"onOverlayDetached()\"\n>\n  <div class=\"overlay-container\" [@appearPanel]=\"'opened'\" [class.transparent]=\"transparent\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n", styles: [":host{display:contents}.overlay-container{width:100%;transition:height .3s ease-in-out}.overlay-container:not(.transparent){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f!important;background-color:var(--modal-background);color:var(--modal-on)}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ChangeDetectorRef }, { type: i1$4.Overlay }]; }, propDecorators: { connectedOverlay: [{
                type: ViewChild,
                args: [CdkConnectedOverlay, { static: false }]
            }], minWidth: [{
                type: Input
            }], width: [{
                type: Input
            }], overlayOrigin: [{
                type: Input
            }], opened: [{
                type: Input
            }], hasOverlayBackdrop: [{
                type: Input
            }], hasVisibleBackdrop: [{
                type: Input
            }], positions: [{
                type: Input
            }], closeOnOutsideClick: [{
                type: Input
            }], transparent: [{
                type: Input
            }], clickOutside: [{
                type: Output
            }], toggled: [{
                type: Output
            }] } });

/** The default height of each option. */
const DEFAULT_OPTION_HEIGHT = 40;
/**
 * A single selectable option inside of a `<avn-option-list>` element.
 */
class OptionComponent {
    /** @ignore **/
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        /** Specifies if the option is selected **/
        this.selected = false;
        /** Specifies if the option is disabled **/
        this.disabled = false;
        /** Specifies the height of the option **/
        this.height = DEFAULT_OPTION_HEIGHT;
        /*** @ignore Pattern used to close all subscriptions */
        this._componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngOnInit() {
        this.refreshOptionHeight();
        // use from event to avoid excessive change detection (HostListener triggers it every time)
        fromEvent(this.elementRef.nativeElement, 'mouseenter')
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            this.renderer.addClass(this.elementRef.nativeElement, 'hovered');
        });
        fromEvent(this.elementRef.nativeElement, 'mouseleave')
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            this.renderer.removeClass(this.elementRef.nativeElement, 'hovered');
        });
    }
    /** @ignore **/
    ngOnChanges({ height, data }) {
        if (height) {
            if (!height.currentValue) {
                this.height = DEFAULT_OPTION_HEIGHT;
            }
            this.refreshOptionHeight();
        }
        if (data && data.currentValue) {
            if (this.data.isGroupOption) {
                this.renderer.addClass(this.elementRef.nativeElement, 'group');
            }
            else {
                this.renderer.removeClass(this.elementRef.nativeElement, 'group');
            }
        }
    }
    /** @ignore Called by the CDK Key Manager when the option is set to active **/
    setActiveStyles() {
        this.renderer.addClass(this.elementRef.nativeElement, 'active');
    }
    /** @ignore Called by the CDK Key Manager when the option is set to not active **/
    setInactiveStyles() {
        this.renderer.removeClass(this.elementRef.nativeElement, 'active');
    }
    /** Refreshes the option height **/
    refreshOptionHeight() {
        this.renderer.setStyle(this.elementRef.nativeElement, 'height', this.height + 'px');
    }
    /** @ignore Adds a value attribute to the element, useful for E2E testing **/
    get value() {
        return this.data ? this.data.value : '';
    }
    /** @ignore **/
    ngOnDestroy() {
        // unsubscribe all subscriptions
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OptionComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: OptionComponent, selector: "avn-option", inputs: { data: "data", selected: "selected", disabled: "disabled", height: "height" }, host: { properties: { "class.selected": "this.selected", "class.disabled": "this.disabled", "attr.value": "this.value" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"content-wrapper\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{border-collapse:collapse;display:flex;align-items:center;justify-content:flex-start;padding:0 var(--space-md);color:var(--selection-component-on);background-color:var(--selection-component-background)}:host:not(.group){cursor:pointer}:host:not(.group).active:not(.disabled),:host:not(.group).hovered:not(.disabled){color:var(--selection-component-hover-on);background-color:var(--selection-component-hover-background)}:host:not(.group).selected:not(.disabled){color:var(--selection-component-selected-on);background-color:var(--selection-component-selected-background)}:host .content-wrapper{white-space:nowrap;width:100%}:host-context(.dmb-aspect) :host{padding:0 5px}:host-context(.dmb-aspect) :host .content-wrapper{display:flex;align-items:center;height:calc(100% - 8px);padding:0 5px;border-radius:2px;transition:all .2s ease}:host-context(.dmb-aspect) :host:not(.group){cursor:pointer}:host-context(.dmb-aspect) :host:not(.group).active:not(.disabled),:host-context(.dmb-aspect) :host:not(.group).hovered:not(.disabled),:host-context(.dmb-aspect) :host:not(.group).selected:not(.disabled){background-color:var(--selection-component-background)}:host-context(.dmb-aspect) :host:not(.group).active:not(.disabled) .content-wrapper,:host-context(.dmb-aspect) :host:not(.group).hovered:not(.disabled) .content-wrapper,:host-context(.dmb-aspect) :host:not(.group).selected:not(.disabled) .content-wrapper{color:var(--topnav-variant-on);background-color:#ffffff1a}:host.disabled{opacity:.3;cursor:not-allowed;-webkit-user-select:none;user-select:none}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-option', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"content-wrapper\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{border-collapse:collapse;display:flex;align-items:center;justify-content:flex-start;padding:0 var(--space-md);color:var(--selection-component-on);background-color:var(--selection-component-background)}:host:not(.group){cursor:pointer}:host:not(.group).active:not(.disabled),:host:not(.group).hovered:not(.disabled){color:var(--selection-component-hover-on);background-color:var(--selection-component-hover-background)}:host:not(.group).selected:not(.disabled){color:var(--selection-component-selected-on);background-color:var(--selection-component-selected-background)}:host .content-wrapper{white-space:nowrap;width:100%}:host-context(.dmb-aspect) :host{padding:0 5px}:host-context(.dmb-aspect) :host .content-wrapper{display:flex;align-items:center;height:calc(100% - 8px);padding:0 5px;border-radius:2px;transition:all .2s ease}:host-context(.dmb-aspect) :host:not(.group){cursor:pointer}:host-context(.dmb-aspect) :host:not(.group).active:not(.disabled),:host-context(.dmb-aspect) :host:not(.group).hovered:not(.disabled),:host-context(.dmb-aspect) :host:not(.group).selected:not(.disabled){background-color:var(--selection-component-background)}:host-context(.dmb-aspect) :host:not(.group).active:not(.disabled) .content-wrapper,:host-context(.dmb-aspect) :host:not(.group).hovered:not(.disabled) .content-wrapper,:host-context(.dmb-aspect) :host:not(.group).selected:not(.disabled) .content-wrapper{color:var(--topnav-variant-on);background-color:#ffffff1a}:host.disabled{opacity:.3;cursor:not-allowed;-webkit-user-select:none;user-select:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { data: [{
                type: Input
            }], selected: [{
                type: HostBinding,
                args: ['class.selected']
            }, {
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: Input
            }], height: [{
                type: Input
            }], value: [{
                type: HostBinding,
                args: ['attr.value']
            }] } });

class CheckboxComponent extends FormControlComponent {
    constructor(renderer, ngControl, changeDetector) {
        super(ngControl, changeDetector);
        this.renderer = renderer;
        /**
         * Emits a simple true/false when a checkbox is checked or unchecked for use in simple scenarios.
         */
        this.cbChange = new EventEmitter();
        /** pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
    }
    /**
     * This method is called when the forms API to write to the view when programmatic (model -> view)
     * changes are requested
     *
     * @ignore
     */
    updateValue(value) {
        this.checked = value;
        if (value === undefined) {
            this.indeterminate = true;
        }
    }
    /**
     * This method is called when Angular (re)sets data-bound input properties.
     *
     * @ignore
     */
    ngOnChanges({ indeterminate }) {
        if (indeterminate && indeterminate.currentValue) {
            // reset the checked value and propagate it
            this.checked = undefined;
            this.propagateChange(this.checked);
            // set the indeterminate attribute on the native element
            const checkboxHtmlElement = this.inputElement.nativeElement;
            checkboxHtmlElement.indeterminate = this.indeterminate;
        }
    }
    /**
     * child components and directives become available from AfterViewInit lifecycle hook
     *
     * @ignore
     */
    ngAfterViewInit() {
        this.subscribeTouch(this.inputElement.nativeElement, 'blur');
    }
    /**
     * Updates the value of our component when the native input value changes
     *
     * @ignore
     */
    onChange($event) {
        this.checked = $event.currentTarget.checked;
        this.indeterminate = false;
        this.propagateChange(this.checked);
        this.cbChange.emit(this.checked);
    }
    /** @ignore **/
    ngOnDestroy() {
        super.ngOnDestroy();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxComponent, deps: [{ token: i0.Renderer2 }, { token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CheckboxComponent, selector: "avn-checkbox", inputs: { label: "label", indeterminate: "indeterminate", checked: "checked" }, outputs: { cbChange: "cbChange" }, host: { properties: { "class.checked": "this.checked" } }, providers: [{ provide: FormControlComponent, useExisting: CheckboxComponent }], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<input type=\"checkbox\" [id]=\"id\" #inputElement [checked]=\"checked\" [disabled]=\"disabled\" (change)=\"onChange($event)\" />\n<div class=\"label-container\" [class.with-label]=\"!!label\">\n  <label [for]=\"id\" class=\"label-svg\" #svgLabel>\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" #svgElement [ngClass]=\"{ checked: checked, unchecked: !checked }\">\n      <ng-container *ngIf=\"checked\">\n        <path class=\"svg-item\" d=\"M0 0h24v24H0z\" fill=\"none\" />\n        <path d=\"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\" />\n      </ng-container>\n      <ng-container *ngIf=\"!checked && !indeterminate\">\n        <path d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\" />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </ng-container>\n      <ng-container *ngIf=\"!checked && indeterminate\">\n        <defs>\n          <path class=\"svg-item\" id=\"a\" d=\"M0 0h24v24H0z\" />\n        </defs>\n        <clipPath id=\"b\">\n          <use xlink:href=\"#a\" overflow=\"visible\" />\n        </clipPath>\n        <path class=\"svg-item\" clip-path=\"url(#b)\" d=\"M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z\" />\n      </ng-container>\n    </svg>\n  </label>\n  <label [for]=\"id\" class=\"label-text\" *ngIf=\"label\">{{ label }}</label>\n</div>\n", styles: [":host{display:block;position:relative}:host svg{fill:var(--checkbox-radio-background)}:host:hover>input[type=checkbox]:not(:disabled)+div.label-container>label>svg{fill:var(--checkbox-radio-hover-background)}:host>input[type=checkbox]{display:none}:host>input[type=checkbox]+div.label-container.with-label{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center}:host>input[type=checkbox]+div.label-container>label{display:inline-block;padding:0;cursor:pointer}:host>input[type=checkbox]+div.label-container>label>svg{width:24px}:host>input[type=checkbox]+div.label-container>label.label-text{margin-left:var(--space-sm)}:host>input[type=checkbox]:disabled+div.label-container{opacity:.3}:host>input[type=checkbox]:disabled+div.label-container>label{cursor:not-allowed}:host label{margin-bottom:0}:host svg.checked{animation:.5s pulse-in}:host svg.unchecked{animation:.5s pulse-out}@keyframes pulse-in{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}@keyframes pulse-out{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-checkbox', providers: [{ provide: FormControlComponent, useExisting: CheckboxComponent }], template: "<input type=\"checkbox\" [id]=\"id\" #inputElement [checked]=\"checked\" [disabled]=\"disabled\" (change)=\"onChange($event)\" />\n<div class=\"label-container\" [class.with-label]=\"!!label\">\n  <label [for]=\"id\" class=\"label-svg\" #svgLabel>\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" #svgElement [ngClass]=\"{ checked: checked, unchecked: !checked }\">\n      <ng-container *ngIf=\"checked\">\n        <path class=\"svg-item\" d=\"M0 0h24v24H0z\" fill=\"none\" />\n        <path d=\"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\" />\n      </ng-container>\n      <ng-container *ngIf=\"!checked && !indeterminate\">\n        <path d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\" />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </ng-container>\n      <ng-container *ngIf=\"!checked && indeterminate\">\n        <defs>\n          <path class=\"svg-item\" id=\"a\" d=\"M0 0h24v24H0z\" />\n        </defs>\n        <clipPath id=\"b\">\n          <use xlink:href=\"#a\" overflow=\"visible\" />\n        </clipPath>\n        <path class=\"svg-item\" clip-path=\"url(#b)\" d=\"M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z\" />\n      </ng-container>\n    </svg>\n  </label>\n  <label [for]=\"id\" class=\"label-text\" *ngIf=\"label\">{{ label }}</label>\n</div>\n", styles: [":host{display:block;position:relative}:host svg{fill:var(--checkbox-radio-background)}:host:hover>input[type=checkbox]:not(:disabled)+div.label-container>label>svg{fill:var(--checkbox-radio-hover-background)}:host>input[type=checkbox]{display:none}:host>input[type=checkbox]+div.label-container.with-label{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center}:host>input[type=checkbox]+div.label-container>label{display:inline-block;padding:0;cursor:pointer}:host>input[type=checkbox]+div.label-container>label>svg{width:24px}:host>input[type=checkbox]+div.label-container>label.label-text{margin-left:var(--space-sm)}:host>input[type=checkbox]:disabled+div.label-container{opacity:.3}:host>input[type=checkbox]:disabled+div.label-container>label{cursor:not-allowed}:host label{margin-bottom:0}:host svg.checked{animation:.5s pulse-in}:host svg.unchecked{animation:.5s pulse-out}@keyframes pulse-in{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}@keyframes pulse-out{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], cbChange: [{
                type: Output
            }], inputElement: [{
                type: ViewChild,
                args: ['inputElement', { static: true }]
            }], checked: [{
                type: HostBinding,
                args: ['class.checked']
            }, {
                type: Input
            }] } });

/**
 *
 * A list of selectable options that provides the following functionalities:
 *
 * Virtualization
 *
 * - Enabled by default, can be disabled if required.
 * - Can also be configured to be enabled only after a certain amount of options are present in the
 * list.
 *
 * Keyboard Navigation
 *
 * - Enabled by default, can be disabled if required.
 * - First option of the list can be automatically set to active if specified
 * - Event is emitted every time an option is made active by navigation
 * - Works with virtual scroll
 *
 * Configurable size
 * - The list can be configured to display a max number of options within its viewport.\
 * - Option height can be configured
 *
 * Option Selection
 * - Option can be selected by clicking on it
 * - When keyboard navigation is enabled, option can be selected by pressing the TAB or ENTER key
 * - Event is emitted every time an option is selected
 *
 * Improvements:
 * Currently the templateCacheSize is set to 0. Setting to another value will cause issues with
 * keyboard navigation with virtual scroll. In order to be able to use the templateCacheSize, more
 * work need to be done in _resetKeyManager method (retrieve CdkVirtualForOf directive via ViewChild
 * to get the templateCacheSize).
 */
class OptionListComponent {
    get selectedOptions() {
        return this._selectedOptions;
    }
    set selectedOptions(value) {
        this._selectedOptions = value ?? [];
    }
    /** @ignore **/
    constructor(elementRef) {
        this.elementRef = elementRef;
        /** Specifies if virtual scroll is enabled **/
        this.virtualization = true;
        /** Specifies if keyboard navigation is enabled **/
        this.keyboardNavigationEnabled = true;
        /**
         * When keyboard navigation is enabled, specifies if the first option should be auto marked as
         * active *
         */
        this.autoActiveFirstOption = false;
        /** Specifies the number of options visible in the list **/
        this.maxOptionsVisibleInViewport = 10;
        /** Specifies the option height **/
        this.optionHeight = DEFAULT_OPTION_HEIGHT;
        /** The selection mode **/
        this.selectionMode = 'single';
        /** Will be taken into consideration only in multiple-selection mode. True to show checkbox for each option item **/
        this.showCheckbox = false;
        /** The selected options in multi-selection mode **/
        this._selectedOptions = [];
        /** Indicates if option grouping is enabled **/
        this.enableGroups = true;
        /** Emits every time an option is clicked (select or de-select) **/
        this.optionClicked = new EventEmitter();
        /** Emits every time an option is marked as active with keyboard navigation **/
        this.optionActivated = new EventEmitter();
        /** Emits every time the selected option(s) is(are) changed **/
        this.selectionsChanged = new EventEmitter();
        /** @ignore **/
        this._viewportChangesSubject = new Subject();
        /** @ignore Pattern used to close all subscriptions **/
        this._componentDestroyed$ = new Subject();
        /** @ignore **/
        this._scrollToSelectedOption = false;
    }
    /** Specifies if the list should be virtualized **/
    get virtualize() {
        if (this.virtualization) {
            return true;
        }
        if (this.autoVirtualizeAfterXOptions) {
            return this._internalOptions && this._internalOptions.length > this.autoVirtualizeAfterXOptions;
        }
        return false;
    }
    /** Returns the viewport height **/
    get optionsViewportHeight() {
        let height = 0;
        if (this._internalOptions) {
            // if there are less options than the maxOptionsVisibleInViewport, return the number of
            // options
            height = Math.min(this._internalOptions.length * this.optionHeight, this.maxOptionsVisibleInViewport * this.optionHeight);
        }
        return height;
    }
    /** @ignore **/
    ngOnChanges({ options, selectedOptions, enableGroups }) {
        if (options) {
            this._internalOptions = this._toInternalOptions(options.currentValue);
            if (this.virtualizedViewport) {
                // we need to reinit the panel after the content changes to a bigger size otherwise it
                // causes display issues if ((options.currentValue || 0) > (options.previousValue || 0)) {
                this.virtualizedViewport.ngOnInit();
                // }
            }
            this._groupCount = this.options.reduce((p, c) => [...p, ...(!!c.group && !p.includes(c.group) ? [c.group] : [])], []).length;
        }
        if (selectedOptions && selectedOptions.isFirstChange()) {
            if (this.selectionMode === 'single') {
                // reposition the scroll to the selected option
                const selectedOptionIndex = this.options.indexOf(this.selectedOptions[0]);
                // position the item as first item in the list so scroll to index + amount of options in
                // panel
                let scrollToIndex = selectedOptionIndex + (this.maxOptionsVisibleInViewport || 0) - 1;
                scrollToIndex = scrollToIndex > this._internalOptions.length - 1 ? this._internalOptions.length - 1 : scrollToIndex;
                // use setTimeout otherwise it won't scroll when there is an animation
                setTimeout(() => {
                    this.scrollToOption(scrollToIndex || 0);
                    if (this.keyboardNavigationEnabled) {
                        if (this.virtualize) {
                            this._scrollToSelectedOption = true;
                        }
                        else {
                            if (!this.keyManager) {
                                this.keyManager = new ActiveDescendantKeyManager(this.optionsList);
                            }
                            // no virtual scroll so just use the index option
                            this.keyManager.setActiveItem(selectedOptionIndex);
                        }
                    }
                });
            }
        }
        if (enableGroups) {
            this._internalOptions = this._toInternalOptions(this.options);
        }
    }
    /** @ignore **/
    ngAfterViewInit() {
        // watch keydown events when keyboard navigation is enabled
        fromEvent(document, 'keydown')
            .pipe(filter(() => this.keyboardNavigationEnabled), takeUntil(this._componentDestroyed$))
            .subscribe((event) => this._onKeydown(event));
        // listen for panel changes (panel changes everytime its opened / closed or virtual scroll mode
        // changes the virtual scroll changes observable emits every time the viewport rendered range is
        // changed...
        this.virtualizedViewportQL.changes
            .pipe(startWith(this.virtualizedViewportQL), filter((pl) => pl.first !== undefined), takeUntil(this._componentDestroyed$))
            .subscribe((pl) => {
            const viewportAlreadyExists = this.virtualizedViewport !== undefined;
            this.virtualizedViewport = pl.first;
            this.regularViewport = undefined;
            if (!viewportAlreadyExists) {
                this._viewportChangesSubject.next();
                if (this.keyboardNavigationEnabled) {
                    // watch options changes until the panel changes again
                    this.optionsList.changes
                        .pipe(startWith(this.optionsList), 
                    // eslint-disable-next-line rxjs/no-unsafe-takeuntil
                    takeUntil(this._viewportChangesSubject.pipe(first())), takeUntil(this._componentDestroyed$))
                        .subscribe((items) => {
                        const renderedRange = this.virtualizedViewport ? this.virtualizedViewport.getRenderedRange() : undefined;
                        const virtualScrollOptionIndexOffset = this.virtualizedViewport.getRenderedRange().start;
                        this._resetKeyManager(this._removeDuplicateItems(items.toArray(), renderedRange), virtualScrollOptionIndexOffset);
                    });
                }
            }
        });
        // regular viewport change
        this.regularViewportQL.changes
            .pipe(startWith(this.regularViewportQL), filter((pl) => pl.first !== undefined), takeUntil(this._componentDestroyed$))
            .subscribe((pl) => {
            this.regularViewport = pl.first;
            this.virtualizedViewport = undefined;
            if (this.regularViewport) {
                this._viewportChangesSubject.next();
                // use the key manager the regular way
                if (this.keyboardNavigationEnabled) {
                    this.keyManager = new ActiveDescendantKeyManager(this.optionsList);
                    // watch options changes until the panel changes again
                    this.optionsList.changes
                        .pipe(startWith(this.optionsList), 
                    // eslint-disable-next-line rxjs/no-unsafe-takeuntil
                    takeUntil(this._viewportChangesSubject.pipe(first())), takeUntil(this._componentDestroyed$))
                        .subscribe(() => {
                        if (this.autoActiveFirstOption) {
                            this._activateFirstItem();
                        }
                        else {
                            this.keyManager.setActiveItem(-1);
                        }
                    });
                }
            }
        });
    }
    /*** @ignore issue with ViewChildren in virtual scroll viewport returning duplicate options **/
    _removeDuplicateItems(items, renderedRange) {
        if (renderedRange) {
            return items.slice(0, renderedRange.end - renderedRange.start);
        }
        if (items.length <= 1) {
            return items;
        }
        const indexOfFirstDuplicate = items.map((i) => i.data.value).lastIndexOf(items[0].data.value);
        if (indexOfFirstDuplicate > 0) {
            return items.slice(0, indexOfFirstDuplicate);
        }
        return items;
    }
    /*** @ignore Resets the key manager (used when virtualization is on) **/
    _resetKeyManager(data, virtualScrollOptionIndexOffset) {
        const autoActivateFirstItem = this.autoActiveFirstOption && virtualScrollOptionIndexOffset === 0;
        let lastActiveItem;
        if (this._scrollToSelectedOption) {
            lastActiveItem = data[data.map((optionComponent) => optionComponent.data).indexOf(this.selectedOptions[0])];
            this._scrollToSelectedOption = false;
        }
        else if (this.keyManager) {
            lastActiveItem = this.keyManager.activeItem;
        }
        const lastActiveItemExists = lastActiveItem && data.indexOf(lastActiveItem) > -1;
        this.keyManager = new ActiveDescendantKeyManager(data);
        if (lastActiveItemExists) {
            this.keyManager.setActiveItem(lastActiveItem);
        }
        else if (autoActivateFirstItem) {
            this._activateFirstItem();
        }
    }
    /*** @ignore Activates the first option (checks for groups) **/
    _activateFirstItem() {
        if (this._internalOptions.length > 0) {
            let indexOfFirstItem = 0;
            if (this._internalOptions[0].isGroupOption) {
                indexOfFirstItem++;
            }
            this.keyManager.setActiveItem(indexOfFirstItem);
            this.optionActivated.emit(this._internalOptions[indexOfFirstItem]);
        }
    }
    /*** @ignore When keyboard key is pressed **/
    _onKeydown(event) {
        if (!this.virtualizedViewport && !this.regularViewport) {
            return;
        }
        if (![DOWN_ARROW, UP_ARROW, ENTER, TAB].includes(event.keyCode)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (event.keyCode === ENTER || event.keyCode === TAB) {
            if (this.keyManager.activeItem) {
                this.onOptionSelected(null, this.keyManager.activeItem.data);
            }
        }
        else if ([DOWN_ARROW, UP_ARROW].includes(event.keyCode)) {
            // get the virtual scroll option index offset
            let virtualScrollOptionIndexOffset = 0;
            if (this.virtualize) {
                virtualScrollOptionIndexOffset = this.virtualizedViewport.getRenderedRange().start;
            }
            // do nothing if we have reached the first or last option
            // make sure to include extra group options in the count
            const optionCount = this.options.length + this._groupCount;
            const hasReachedBoundaries = (this.keyManager.activeItemIndex === 0 && event.keyCode === UP_ARROW) ||
                (this.keyManager.activeItemIndex + virtualScrollOptionIndexOffset === optionCount - 1 && event.keyCode === DOWN_ARROW);
            if (!hasReachedBoundaries) {
                this.keyManager.onKeydown(event);
                // if the next item is a group we go to the next one
                const isGroupOption = this.keyManager.activeItem.data && this.keyManager.activeItem.data.isGroupOption;
                if (isGroupOption) {
                    this.keyManager.onKeydown(event);
                }
                const optionIndex = this.keyManager.activeItemIndex + (this.virtualize ? virtualScrollOptionIndexOffset : 0);
                this.scrollToOption(optionIndex);
                if (this.keyManager.activeItem) {
                    this.optionActivated.emit(this.keyManager.activeItem.data);
                }
            }
        }
    }
    /** Scrolls to the option at the specified index **/
    scrollToOption(optionIndex) {
        const newScrollPosition = this._getOptionScrollPosition(optionIndex, this.optionHeight, this._getViewportScrollTop(), this.optionsViewportHeight);
        this._setScrollTop(newScrollPosition);
    }
    /** @ignore Returns the current scroll position of the option at the specified index **/
    _getOptionScrollPosition(optionIndex, optionHeight, currentScrollPosition, viewportHeight) {
        const optionOffset = optionIndex * optionHeight;
        if (optionOffset < currentScrollPosition) {
            return optionOffset;
        }
        if (optionOffset + optionHeight > currentScrollPosition + viewportHeight) {
            return Math.max(0, optionOffset - viewportHeight + optionHeight);
        }
        return currentScrollPosition;
    }
    /** @ignore Returns the current scrollTop of the viewport **/
    _getViewportScrollTop() {
        if (this.virtualize) {
            return this.virtualizedViewport ? this.virtualizedViewport.elementRef.nativeElement.scrollTop : 0;
        }
        return this.regularViewport ? this.regularViewport.nativeElement.scrollTop : 0;
    }
    /** @ignore Sets the viewport scrollTop **/
    _setScrollTop(scrollTop) {
        if (this.virtualizedViewport) {
            this.virtualizedViewport.elementRef.nativeElement.scrollTop = scrollTop;
        }
        else if (this.regularViewport) {
            this.regularViewport.nativeElement.scrollTop = scrollTop;
        }
    }
    /** When an option is selected by click or keyboard navigation **/
    onOptionSelected(event, selectedOption) {
        if (event) {
            event.stopPropagation();
        }
        // make sure the option is enabled
        if (!selectedOption.disabled && !selectedOption.isGroupOption) {
            const change = {
                added: [],
                removed: [],
                selected: [],
            };
            this.optionClicked.emit(selectedOption);
            if (this.selectionMode === 'single') {
                change.added.push(selectedOption);
                if (this.selectedOptions.length > 0) {
                    change.removed.push(this.selectedOptions[0]);
                }
                this.selectedOptions = [selectedOption];
            }
            else {
                const option = this.selectedOptions.find((opt) => opt.value === selectedOption.value);
                if (option) {
                    change.removed.push(option);
                    this.selectedOptions = this.selectedOptions.filter((opt) => opt.value !== selectedOption.value);
                }
                else {
                    change.added.push(selectedOption);
                    this.selectedOptions = [...this.selectedOptions, selectedOption];
                }
            }
            change.selected = this.selectedOptions;
            this.selectionsChanged.emit(change);
            // mark the selected option as active for keyboard navigation
            if (this.keyboardNavigationEnabled) {
                this.keyManager.setActiveItem(this.optionsList
                    .toArray()
                    .map((opt) => opt.data)
                    .indexOf(selectedOption));
            }
        }
    }
    onClick($event) {
        // The item selection/deselection is handled by the click event on avn-option.
        // Need to prevent the default action of click event on the checkbox or else the
        // onOptionSelected would be called twice.
        $event.preventDefault();
    }
    /** @ignore adds group options to the options list **/
    _toInternalOptions(options) {
        if (!this.enableGroups || !options || options.length === 0 || !options.some((o) => !!o.group)) {
            return options;
        }
        // reorganize the options per group
        const groupedOptionMap = new Map();
        for (const opt of options) {
            const optionGroup = opt.group || '';
            const optionArray = groupedOptionMap.has(optionGroup) ? groupedOptionMap.get(optionGroup) : [];
            optionArray.push(opt);
            groupedOptionMap.set(optionGroup, optionArray);
        }
        const res = [];
        Array.from(groupedOptionMap.keys()).forEach((group) => {
            res.push({ isGroupOption: true, group, disableTemplate: true });
            res.push(...groupedOptionMap.get(group));
        });
        return res;
    }
    /** Returns options with groups added **/
    get internalOptions() {
        return this._internalOptions;
    }
    get hasOptionGroups() {
        return this._groupCount > 0;
    }
    /** track function to avoid recreating options on every change detection cycle **/
    trackByFn(_, option) {
        return option.value;
    }
    /** Check if the provided option is a selected option */
    isSelectedOption(selectedOptions, providedOption) {
        return selectedOptions.some((option) => option === providedOption || option?.value === providedOption?.value);
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        // unsubscribe all subscriptions
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OptionListComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: OptionListComponent, selector: "avn-option-list", inputs: { optionsTemplate: "optionsTemplate", virtualization: "virtualization", autoVirtualizeAfterXOptions: "autoVirtualizeAfterXOptions", keyboardNavigationEnabled: "keyboardNavigationEnabled", autoActiveFirstOption: "autoActiveFirstOption", maxOptionsVisibleInViewport: "maxOptionsVisibleInViewport", optionHeight: "optionHeight", options: "options", selectionMode: "selectionMode", showCheckbox: "showCheckbox", selectedOptions: "selectedOptions", enableGroups: "enableGroups" }, outputs: { optionClicked: "optionClicked", optionActivated: "optionActivated", selectionsChanged: "selectionsChanged" }, viewQueries: [{ propertyName: "virtualizedViewportQL", predicate: ["virtualizedViewport"], descendants: true }, { propertyName: "regularViewportQL", predicate: ["regularViewport"], descendants: true }, { propertyName: "optionsList", predicate: OptionComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"virtualize; else noVirtualization\">\n  <cdk-virtual-scroll-viewport\n    #virtualizedViewport\n    role=\"listbox\"\n    [style.height]=\"optionsViewportHeight + 'px'\"\n    class=\"autocomplete\"\n    [class.has-groups]=\"enableGroups && hasOptionGroups\"\n    [itemSize]=\"optionHeight\"\n    avnScroll\n  >\n    <avn-option\n      *cdkVirtualFor=\"let option of internalOptions; templateCacheSize: 0; trackBy: trackByFn\"\n      (click)=\"onOptionSelected($event, option)\"\n      [selected]=\"selectedOptions | applyFunction: isSelectedOption:[option]\"\n      [disabled]=\"option.disabled\"\n      [data]=\"option\"\n      [height]=\"optionHeight\"\n      [title]=\"option.label || ''\"\n    >\n      <ng-container *ngTemplateOutlet=\"optionItem; context: { option: option }\"></ng-container>\n    </avn-option>\n  </cdk-virtual-scroll-viewport>\n</ng-container>\n<ng-template #noVirtualization>\n  <div\n    #regularViewport\n    *ngIf=\"internalOptions?.length > 0\"\n    role=\"listbox\"\n    [style.height]=\"optionsViewportHeight + 'px'\"\n    class=\"autocomplete\"\n    [class.has-groups]=\"enableGroups && hasOptionGroups\"\n    avnScroll\n  >\n    <div class=\"options-wrapper\">\n      <avn-option\n        *ngFor=\"let option of internalOptions\"\n        (click)=\"onOptionSelected($event, option)\"\n        [selected]=\"selectedOptions | applyFunction: isSelectedOption:[option]\"\n        [disabled]=\"option.disabled\"\n        [data]=\"option\"\n        [height]=\"optionHeight\"\n        [title]=\"option.label || ''\"\n      >\n        <ng-container *ngTemplateOutlet=\"optionItem; context: { option: option }\"></ng-container>\n      </avn-option>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #optionItem let-option=\"option\">\n  <div class=\"item-label\" *ngIf=\"optionsTemplate && !option.disableTemplate; else templateLabel\">\n    <ng-container *ngTemplateOutlet=\"checkboxTemplate\"></ng-container>\n    <ng-container *ngTemplateOutlet=\"optionsTemplate; context: { option: option }\"></ng-container>\n  </div>\n  <ng-template #templateLabel>\n    <div class=\"item-label\">\n      <ng-container *ngTemplateOutlet=\"checkboxTemplate\"></ng-container>\n      {{ option.isGroupOption ? option.group : option.label !== undefined ? option.label : option.value }}\n    </div>\n  </ng-template>\n  <ng-template #checkboxTemplate>\n    <avn-checkbox\n      *ngIf=\"option.isGroupOption !== true && selectionMode === 'multiple' && showCheckbox\"\n      [checked]=\"selectedOptions | applyFunction: isSelectedOption:[option]\"\n      [disabled]=\"option.disabled\"\n      (click)=\"onClick($event)\"\n    >\n    </avn-checkbox>\n  </ng-template>\n</ng-template>\n", styles: [":host{height:100%;width:100%}:host .autocomplete{display:flex;flex-direction:column;z-index:10;overflow-y:auto}:host .autocomplete .item-label{display:flex;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}:host .autocomplete.has-groups avn-option .item-label{padding-left:var(--space-lg)}:host .autocomplete avn-option.group .item-label{text-transform:uppercase;font-size:smaller;opacity:.7;font-weight:bolder;padding-left:0}:host .autocomplete avn-checkbox{align-self:center;margin-right:var(--space-sm)}:host .autocomplete .options-wrapper{background-color:var(--selection-component-background)}:host ::ng-deep .cdk-virtual-scroll-content-wrapper{width:100%}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i2.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i2.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "component", type: CheckboxComponent, selector: "avn-checkbox", inputs: ["label", "indeterminate", "checked"], outputs: ["cbChange"] }, { kind: "component", type: OptionComponent, selector: "avn-option", inputs: ["data", "selected", "disabled", "height"] }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OptionListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-option-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"virtualize; else noVirtualization\">\n  <cdk-virtual-scroll-viewport\n    #virtualizedViewport\n    role=\"listbox\"\n    [style.height]=\"optionsViewportHeight + 'px'\"\n    class=\"autocomplete\"\n    [class.has-groups]=\"enableGroups && hasOptionGroups\"\n    [itemSize]=\"optionHeight\"\n    avnScroll\n  >\n    <avn-option\n      *cdkVirtualFor=\"let option of internalOptions; templateCacheSize: 0; trackBy: trackByFn\"\n      (click)=\"onOptionSelected($event, option)\"\n      [selected]=\"selectedOptions | applyFunction: isSelectedOption:[option]\"\n      [disabled]=\"option.disabled\"\n      [data]=\"option\"\n      [height]=\"optionHeight\"\n      [title]=\"option.label || ''\"\n    >\n      <ng-container *ngTemplateOutlet=\"optionItem; context: { option: option }\"></ng-container>\n    </avn-option>\n  </cdk-virtual-scroll-viewport>\n</ng-container>\n<ng-template #noVirtualization>\n  <div\n    #regularViewport\n    *ngIf=\"internalOptions?.length > 0\"\n    role=\"listbox\"\n    [style.height]=\"optionsViewportHeight + 'px'\"\n    class=\"autocomplete\"\n    [class.has-groups]=\"enableGroups && hasOptionGroups\"\n    avnScroll\n  >\n    <div class=\"options-wrapper\">\n      <avn-option\n        *ngFor=\"let option of internalOptions\"\n        (click)=\"onOptionSelected($event, option)\"\n        [selected]=\"selectedOptions | applyFunction: isSelectedOption:[option]\"\n        [disabled]=\"option.disabled\"\n        [data]=\"option\"\n        [height]=\"optionHeight\"\n        [title]=\"option.label || ''\"\n      >\n        <ng-container *ngTemplateOutlet=\"optionItem; context: { option: option }\"></ng-container>\n      </avn-option>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #optionItem let-option=\"option\">\n  <div class=\"item-label\" *ngIf=\"optionsTemplate && !option.disableTemplate; else templateLabel\">\n    <ng-container *ngTemplateOutlet=\"checkboxTemplate\"></ng-container>\n    <ng-container *ngTemplateOutlet=\"optionsTemplate; context: { option: option }\"></ng-container>\n  </div>\n  <ng-template #templateLabel>\n    <div class=\"item-label\">\n      <ng-container *ngTemplateOutlet=\"checkboxTemplate\"></ng-container>\n      {{ option.isGroupOption ? option.group : option.label !== undefined ? option.label : option.value }}\n    </div>\n  </ng-template>\n  <ng-template #checkboxTemplate>\n    <avn-checkbox\n      *ngIf=\"option.isGroupOption !== true && selectionMode === 'multiple' && showCheckbox\"\n      [checked]=\"selectedOptions | applyFunction: isSelectedOption:[option]\"\n      [disabled]=\"option.disabled\"\n      (click)=\"onClick($event)\"\n    >\n    </avn-checkbox>\n  </ng-template>\n</ng-template>\n", styles: [":host{height:100%;width:100%}:host .autocomplete{display:flex;flex-direction:column;z-index:10;overflow-y:auto}:host .autocomplete .item-label{display:flex;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}:host .autocomplete.has-groups avn-option .item-label{padding-left:var(--space-lg)}:host .autocomplete avn-option.group .item-label{text-transform:uppercase;font-size:smaller;opacity:.7;font-weight:bolder;padding-left:0}:host .autocomplete avn-checkbox{align-self:center;margin-right:var(--space-sm)}:host .autocomplete .options-wrapper{background-color:var(--selection-component-background)}:host ::ng-deep .cdk-virtual-scroll-content-wrapper{width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { virtualizedViewportQL: [{
                type: ViewChildren,
                args: ['virtualizedViewport']
            }], regularViewportQL: [{
                type: ViewChildren,
                args: ['regularViewport']
            }], optionsList: [{
                type: ViewChildren,
                args: [OptionComponent]
            }], optionsTemplate: [{
                type: Input
            }], virtualization: [{
                type: Input
            }], autoVirtualizeAfterXOptions: [{
                type: Input
            }], keyboardNavigationEnabled: [{
                type: Input
            }], autoActiveFirstOption: [{
                type: Input
            }], maxOptionsVisibleInViewport: [{
                type: Input
            }], optionHeight: [{
                type: Input
            }], options: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], showCheckbox: [{
                type: Input
            }], selectedOptions: [{
                type: Input
            }], enableGroups: [{
                type: Input
            }], optionClicked: [{
                type: Output
            }], optionActivated: [{
                type: Output
            }], selectionsChanged: [{
                type: Output
            }] } });

/**
 * This component is used by tooltip directive to create tooptip instance
 * it can also been passed with custom template.
 */
class TooltipComponent {
    constructor(element) {
        this.element = element;
        /**
         * text that represent tooltip title
         */
        this.text = '';
        /**
         * position strategy
         */
        this.position = PlacementTypes.right;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TooltipComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TooltipComponent, selector: "avn-tooltip", inputs: { text: "text", position: "position", template: "template", context: "context", maxWidth: "maxWidth", tooltipTheme: "tooltipTheme", tooltipName: "tooltipName" }, host: { properties: { "class": "this.position" } }, ngImport: i0, template: "<div role=\"tooltip\" aria-hidden=\"false\" [id]=\"tooltipName\" [@fadeIn] [avnTheme]=\"tooltipTheme\">\n  <span class=\"arrow\"></span>\n  <div class=\"content\" [ngStyle]=\"{ 'max-width.px': maxWidth }\">\n    <span>{{ text }}</span>\n    <ng-template [ngTemplateOutlet]=\"template\" [ngTemplateOutletContext]=\"{ model: context }\"> </ng-template>\n  </div>\n</div>\n", styles: [":host>div{background-color:var(--tooltip-background);color:var(--tooltip-on);z-index:1000;border-radius:.25rem}:host>div.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host>div.theme-primary .arrow{border-bottom:5px solid var(--primary-base)}:host>div.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host>div.theme-secondary .arrow{border-bottom:5px solid var(--secondary-base)}:host>div.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host>div.theme-highlight .arrow{border-bottom:5px solid var(--highlight-base)}:host>div.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host>div.theme-danger .arrow{border-bottom:5px solid var(--danger-base)}:host>div.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host>div.theme-warning .arrow{border-bottom:5px solid var(--warning-base)}:host>div.theme-info{background-color:var(--info-base);color:var(--info-on)}:host>div.theme-info .arrow{border-bottom:5px solid var(--info-base)}:host>div.theme-success{background-color:var(--success-base);color:var(--success-on)}:host>div.theme-success .arrow{border-bottom:5px solid var(--success-base)}:host .content{padding:var(--space-sm) var(--space-base);display:flex}:host.right .content{flex-direction:row-reverse}:host .arrow{position:absolute;border-bottom:5px solid var(--tooltip-background);width:0;height:0}:host .icon{font-size:var(--text-md)}:host span{line-height:1.25rem}:host .icon+span{margin-left:var(--space-sm)}:host.right .icon+span{margin-right:var(--space-sm)}:host .arrow{border-left:5px solid transparent;border-right:5px solid transparent}:host.bottom .arrow{top:-5px;left:calc(50% - 5px)}:host.left .arrow{right:-7px;top:calc(50% - 2px);transform:rotate(90deg)}:host.top .arrow{bottom:-5px;left:calc(50% - 5px);transform:rotate(180deg)}:host.right .arrow{left:-7px;top:calc(50% - 2px);transform:rotate(270deg)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }], animations: [
            trigger('fadeIn', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate(500, style({ opacity: 1 }))
                ])
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('fadeIn', [
                            transition(':enter', [
                                style({ opacity: 0 }),
                                animate(500, style({ opacity: 1 }))
                            ])
                        ])
                    ], template: "<div role=\"tooltip\" aria-hidden=\"false\" [id]=\"tooltipName\" [@fadeIn] [avnTheme]=\"tooltipTheme\">\n  <span class=\"arrow\"></span>\n  <div class=\"content\" [ngStyle]=\"{ 'max-width.px': maxWidth }\">\n    <span>{{ text }}</span>\n    <ng-template [ngTemplateOutlet]=\"template\" [ngTemplateOutletContext]=\"{ model: context }\"> </ng-template>\n  </div>\n</div>\n", styles: [":host>div{background-color:var(--tooltip-background);color:var(--tooltip-on);z-index:1000;border-radius:.25rem}:host>div.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host>div.theme-primary .arrow{border-bottom:5px solid var(--primary-base)}:host>div.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host>div.theme-secondary .arrow{border-bottom:5px solid var(--secondary-base)}:host>div.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host>div.theme-highlight .arrow{border-bottom:5px solid var(--highlight-base)}:host>div.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host>div.theme-danger .arrow{border-bottom:5px solid var(--danger-base)}:host>div.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host>div.theme-warning .arrow{border-bottom:5px solid var(--warning-base)}:host>div.theme-info{background-color:var(--info-base);color:var(--info-on)}:host>div.theme-info .arrow{border-bottom:5px solid var(--info-base)}:host>div.theme-success{background-color:var(--success-base);color:var(--success-on)}:host>div.theme-success .arrow{border-bottom:5px solid var(--success-base)}:host .content{padding:var(--space-sm) var(--space-base);display:flex}:host.right .content{flex-direction:row-reverse}:host .arrow{position:absolute;border-bottom:5px solid var(--tooltip-background);width:0;height:0}:host .icon{font-size:var(--text-md)}:host span{line-height:1.25rem}:host .icon+span{margin-left:var(--space-sm)}:host.right .icon+span{margin-right:var(--space-sm)}:host .arrow{border-left:5px solid transparent;border-right:5px solid transparent}:host.bottom .arrow{top:-5px;left:calc(50% - 5px)}:host.left .arrow{right:-7px;top:calc(50% - 2px);transform:rotate(90deg)}:host.top .arrow{bottom:-5px;left:calc(50% - 5px);transform:rotate(180deg)}:host.right .arrow{left:-7px;top:calc(50% - 2px);transform:rotate(270deg)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { text: [{
                type: Input
            }], position: [{
                type: HostBinding,
                args: ['class']
            }, {
                type: Input
            }], template: [{
                type: Input
            }], context: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], tooltipTheme: [{
                type: Input
            }], tooltipName: [{
                type: Input
            }] } });

const CONNECTED_POSITION_RIGHT$1 = {
    name: PlacementTypes.right,
    position: {
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
        offsetX: 5,
    },
};
const CONNECTED_POSITION_LEFT$1 = {
    name: PlacementTypes.left,
    position: {
        originX: 'start',
        originY: 'center',
        overlayX: 'end',
        overlayY: 'center',
        offsetX: -5,
    },
};
const CONNECTED_POSITION_TOP$1 = {
    name: PlacementTypes.top,
    position: {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: -5,
    },
};
const CONNECTED_POSITION_BOTTOM$1 = {
    name: PlacementTypes.bottom,
    position: {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
        offsetY: 5,
    },
};
const findConnectedPositionName$1 = (position) => {
    let name;
    switch (position) {
        case CONNECTED_POSITION_TOP$1.position:
            name = CONNECTED_POSITION_TOP$1.name;
            break;
        case CONNECTED_POSITION_RIGHT$1.position:
            name = CONNECTED_POSITION_RIGHT$1.name;
            break;
        case CONNECTED_POSITION_BOTTOM$1.position:
            name = CONNECTED_POSITION_BOTTOM$1.name;
            break;
        case CONNECTED_POSITION_LEFT$1.position:
            name = CONNECTED_POSITION_LEFT$1.name;
            break;
        default:
            break;
    }
    return name;
};
const findConnectedPosition$1 = (name) => {
    let position;
    switch (name) {
        case PlacementTypes.top:
            position = CONNECTED_POSITION_TOP$1.position;
            break;
        case PlacementTypes.right:
            position = CONNECTED_POSITION_RIGHT$1.position;
            break;
        case PlacementTypes.bottom:
            position = CONNECTED_POSITION_BOTTOM$1.position;
            break;
        case PlacementTypes.left:
            position = CONNECTED_POSITION_LEFT$1.position;
            break;
        default:
            break;
    }
    return position;
};

class TooltipDirective {
    get listensForClick() {
        return this.tooltipTrigger === TriggerTypes.all || this.tooltipTrigger === TriggerTypes.click;
    }
    get listensForHover() {
        return this.tooltipTrigger === TriggerTypes.all || this.tooltipTrigger === TriggerTypes.mouseover;
    }
    constructor(overlay, overlayPositionBuilder, document, elementRef, renderer) {
        this.overlay = overlay;
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.document = document;
        this.elementRef = elementRef;
        this.renderer = renderer;
        /**
         * tooltip text
         */
        this.tooltipTitle = '';
        this.tooltipName = '';
        /**
         * tooltip placement, to be used as the prefered tooltip position,
         * the position will be changed automatically latter if needed to suit
         * the best position when scroll or window resize.
         */
        this.tooltipPlacement = PlacementTypes.right;
        /** set the max width of tooltip */
        this.tooltipMaxWidth = 300;
        /**
         * tooltip disabled, won't be triggered
         */
        this.tooltipDisabled = false;
        /**
         * The type of event that can trigger dispaly of tooltip:
         * it should be "clicks", "mouseover" or all
         */
        this.tooltipTrigger = TriggerTypes.mouseover;
        /**
         * Close tooltip if mouse clicked outside of tooltip
         */
        this.tooltipCloseOnClickOutside = true;
        /**
         * Close tooltip if "mouse leave"
         */
        this.tooltipCloseOnMouseLeave = true;
        /**
         * Time in ms after which the tooltip disappears when the mouse leave the origin element
         */
        this.tooltipMouseLeaveCloseDelay = 100;
        /**
         * delay before the tooltip appears (for trigger type = mouseover)
         */
        this.tooltipMouseEnterOpenDelay = 100;
        /**
         * output event triggered when tooltip is displayed
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.show = new EventEmitter();
        /**
         * output event triggered when tooltip is hide
         */
        this.hide = new EventEmitter();
        this.hoverOutTriggered$ = new Subject();
        this.focusTriggered$ = new Subject();
        /**
         * the available tooltip positions,
         * it will be used dynamically by cdk when window resize
         */
        this.tooltipPositions = [
            CONNECTED_POSITION_TOP$1.position,
            CONNECTED_POSITION_RIGHT$1.position,
            CONNECTED_POSITION_BOTTOM$1.position,
            CONNECTED_POSITION_LEFT$1.position,
        ];
        this.componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.initTooltipPosition();
        // build a flexible, sticky overlay position strategy
        this.positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withGrowAfterOpen(true)
            .withPush(false)
            .withFlexibleDimensions(false)
            .withPositions(this.tooltipPositions);
        this.overlayRef = this.overlay.create({
            positionStrategy: this.positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
        });
        this.componentPortal = new ComponentPortal(TooltipComponent);
        this.positionStrategy.positionChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe((positionChange) => {
            if (this.currerntConnectedPosition !== positionChange.connectionPair) {
                this.tooltipRef.instance.position = findConnectedPositionName$1(positionChange.connectionPair);
                // trigger component instance change detection
                this.tooltipRef.changeDetectorRef.detectChanges();
                this.currerntConnectedPosition = positionChange.connectionPair;
            }
        });
    }
    ngAfterViewInit() {
        this.setAriaDescribedBy();
        this.addListenerToTooltipFocus();
        const openTooltip$ = combineLatest([
            fromEvent(this.elementRef.nativeElement, TriggerTypes.click),
            this.focusTriggered$
        ]);
        openTooltip$.pipe(filter(() => !this.tooltipDisabled && this.listensForClick && this._hasTooltip()), takeUntil(this.componentDestroyed$))
            .subscribe(([clickEvent, focusEvent]) => {
            // prevent default so its not detected by the body click listener
            clickEvent.stopPropagation();
            focusEvent.stopPropagation();
            this.showTooltip();
        });
        fromEvent(this.document, TriggerTypes.click)
            .pipe(filter(() => !this.tooltipDisabled && this.listensForClick && this.tooltipCloseOnClickOutside && this._hasTooltip()), takeUntil(this.componentDestroyed$))
            .subscribe((event) => {
            if (this.tooltipRef && this.tooltipRef.instance && !this.tooltipRef.instance.element.nativeElement.contains(event.target)) {
                this.hideTooltip();
            }
        });
        fromEvent(this.elementRef.nativeElement, TriggerTypes.mouseenter)
            .pipe(delay(this.tooltipMouseEnterOpenDelay), filter(() => !this.tooltipDisabled && this.listensForHover && this._hasTooltip()), 
        // eslint-disable-next-line rxjs/no-unsafe-takeuntil
        takeUntil(this.hoverOutTriggered$), repeat())
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.cancelTimerOfMouseLeaveClosing();
            this.showTooltip();
        });
        this.hoverOutTriggered$.pipe(filter(() => !this.tooltipDisabled && this.listensForHover && this.tooltipCloseOnMouseLeave && this._hasTooltip()), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.setTimerOfMouseLeaveClosing();
        });
    }
    ngOnChanges({ tooltipTemplate, tooltipPlacement, tooltipTitle, tooltipTheme, tooltipMaxWidth, tooltipDisabled }) {
        if (tooltipPlacement && tooltipPlacement.currentValue) {
            this.initTooltipPosition();
        }
        if (this.tooltipRef) {
            if (tooltipTitle && tooltipTitle.currentValue && !!this.tooltipRef) {
                this.tooltipRef.instance.text = this.tooltipTitle;
            }
            if (tooltipTemplate) {
                this.tooltipRef.instance.template = this.tooltipTemplate;
                setTimeout(() => {
                    this.overlayRef.updatePosition();
                }, 10);
            }
            if (tooltipTheme && tooltipTheme.currentValue) {
                this.tooltipRef.instance.tooltipTheme = this.tooltipTheme;
            }
            if (tooltipMaxWidth) {
                this.tooltipRef.instance.maxWidth = this.tooltipMaxWidth;
                this.tooltipRef.changeDetectorRef.detectChanges();
                this.overlayRef.updatePosition();
            }
            if (tooltipDisabled && tooltipDisabled.currentValue === true) {
                this.hideTooltip();
            }
        }
    }
    hideTooltip() {
        if (this.tooltipRef) {
            this.overlayRef.detach();
            this.tooltipRef.destroy();
            this.tooltipRef = undefined;
            this.hide.emit(true);
        }
    }
    _hasTooltip() {
        return !!this.tooltipTemplate || (this.tooltipTitle || '').trim().length > 0;
    }
    showTooltip() {
        if (this.tooltipRef) {
            return;
        }
        this.tooltipRef = this.overlayRef.attach(this.componentPortal);
        this.tooltipRef.instance.text = this.tooltipTitle;
        this.tooltipRef.instance.template = this.tooltipTemplate;
        this.tooltipRef.instance.context = this.templateContext;
        this.tooltipRef.instance.position = this.tooltipPlacement;
        this.tooltipRef.instance.tooltipTheme = this.tooltipTheme;
        this.tooltipRef.instance.maxWidth = this.tooltipMaxWidth;
        this.tooltipRef.instance.tooltipName = this.tooltipName;
        this.tooltipRef.changeDetectorRef.detectChanges();
        this.positionStrategy.withPositions(this.tooltipPositions);
        this.overlayRef.updatePosition();
        this.show.emit(true);
        fromEvent(this.tooltipRef.instance.element.nativeElement, 'mouseenter')
            .pipe(filter(() => !this.tooltipDisabled && this.listensForHover), takeUntil(this.hide))
            .subscribe(() => {
            this.cancelTimerOfMouseLeaveClosing();
        });
        fromEvent(this.tooltipRef.instance.element.nativeElement, 'mouseleave')
            .pipe(filter(() => !this.tooltipDisabled && this.listensForHover && this.tooltipCloseOnMouseLeave), takeUntil(this.hide))
            .subscribe(() => {
            this.setTimerOfMouseLeaveClosing();
        });
    }
    initTooltipPosition() {
        this.defaultConnectedPosition = findConnectedPosition$1(this.tooltipPlacement);
        this.currerntConnectedPosition = this.defaultConnectedPosition;
        this.tooltipPositions = [this.defaultConnectedPosition, ...this.tooltipPositions.filter((position) => position !== this.currerntConnectedPosition)];
        if (!!this.positionStrategy && this.tooltipRef) {
            this.tooltipRef.instance.position = this.tooltipPlacement;
            this.positionStrategy.withPositions(this.tooltipPositions);
            this.overlayRef.updatePosition();
        }
    }
    setTimerOfMouseLeaveClosing() {
        this.timerSub = timer(this.tooltipMouseLeaveCloseDelay).subscribe(() => {
            this.hideTooltip();
        });
    }
    cancelTimerOfMouseLeaveClosing() {
        if (this.timerSub) {
            this.timerSub.unsubscribe();
            this.timerSub = undefined;
        }
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
        this.hoverOutTriggered$.complete();
        this.focusTriggered$.complete();
    }
    setAriaDescribedBy() {
        // eslint-disable-next-line no-prototype-builtins
        this.elementRef.nativeElement.setAttribute('aria-describedby', this.tooltipName);
    }
    addListenerToTooltipFocus() {
        this.renderer.listen(this.elementRef.nativeElement, TriggerTypes.focus, (event) => {
            this.focusTriggered$.next(event);
        });
    }
    onHoverOut(event) {
        this.hoverOutTriggered$.next(event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TooltipDirective, deps: [{ token: i1$4.Overlay }, { token: i1$4.OverlayPositionBuilder }, { token: DOCUMENT }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: TooltipDirective, selector: "[avnTooltip]", inputs: { tooltipTitle: ["avnTooltip", "tooltipTitle"], tooltipName: "tooltipName", tooltipTemplate: "tooltipTemplate", templateContext: "templateContext", tooltipTheme: "tooltipTheme", tooltipPlacement: "tooltipPlacement", tooltipMaxWidth: "tooltipMaxWidth", tooltipDisabled: "tooltipDisabled", tooltipTrigger: "tooltipTrigger", tooltipCloseOnClickOutside: "tooltipCloseOnClickOutside", tooltipCloseOnMouseLeave: "tooltipCloseOnMouseLeave", tooltipMouseLeaveCloseDelay: "tooltipMouseLeaveCloseDelay", tooltipMouseEnterOpenDelay: "tooltipMouseEnterOpenDelay" }, outputs: { show: "show", hide: "hide" }, host: { listeners: { "document:keydown.escape": "onHoverOut($event)", "mouseleave": "onHoverOut($event)" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TooltipDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnTooltip]' }]
        }], ctorParameters: function () { return [{ type: i1$4.Overlay }, { type: i1$4.OverlayPositionBuilder }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { tooltipTitle: [{
                type: Input,
                args: ['avnTooltip']
            }], tooltipName: [{
                type: Input
            }], tooltipTemplate: [{
                type: Input
            }], templateContext: [{
                type: Input
            }], tooltipTheme: [{
                type: Input
            }], tooltipPlacement: [{
                type: Input
            }], tooltipMaxWidth: [{
                type: Input
            }], tooltipDisabled: [{
                type: Input
            }], tooltipTrigger: [{
                type: Input
            }], tooltipCloseOnClickOutside: [{
                type: Input
            }], tooltipCloseOnMouseLeave: [{
                type: Input
            }], tooltipMouseLeaveCloseDelay: [{
                type: Input
            }], tooltipMouseEnterOpenDelay: [{
                type: Input
            }], show: [{
                type: Output
            }], hide: [{
                type: Output
            }], onHoverOut: [{
                type: HostListener,
                args: ['document:keydown.escape', ['$event']]
            }, {
                type: HostListener,
                args: ['mouseleave', ['$event']]
            }] } });

class ActionBarComponent {
    constructor() {
        this._justifyContent = 'flex-start';
        /** Whether the secondary action panel has a backdrop or not*/
        this.hasBackdrop = false;
        /** Whether the secondary action panel backdrop is visible or not when activated */
        this.hasVisibleBackdrop = false;
        /** Placement of the tooltip for the primary actions */
        this.tooltipPlacement = PlacementTypes.bottom;
        /** Event when user click on an action */
        this.actionTriggered = new EventEmitter();
        /** Event when the action bar secondary actions panel is closed */
        this.actionPanelToggled = new EventEmitter();
        /** @ignore State of the menu 'opened/closed' */
        this._optionsListOpened = false;
    }
    /** Icon placement. Possible value are 'start' 'center' or 'end' */
    set iconsPlacement(value) {
        switch (value) {
            case 'start':
                this._justifyContent = 'flex-start';
                break;
            case 'center':
                this._justifyContent = 'center';
                break;
            case 'end':
                this._justifyContent = 'flex-end';
                break;
            default:
                this._justifyContent = 'flex-start';
                break;
        }
    }
    /** List of actions to display */
    get actions() {
        return this._actions;
    }
    set actions(value) {
        this._actions = value;
        this._primaryActions = value.filter((item) => item.priority === ActionBarItemPriority.PRIMARY);
        this._secondaryActions = value
            .filter((item) => item.priority === ActionBarItemPriority.SECONDARY)
            .map((item) => ({
            label: item.name,
            data: item,
        }));
    }
    /** @ignore Emit action when we click on an icon */
    _onClickAction(actionName) {
        this.actionTriggered.emit(actionName);
        this._optionsListOpened = false; // close dropdown if opened
    }
    /** @ignore Emit action when we click on an option in the dropdown */
    _onOptionSelected(value) {
        this._onClickAction(value.data.id);
    }
    /** @ignore When we click on the 'more_vert' icon, we open/close the menu */
    _onMenuClick() {
        this._optionsListOpened = !this._optionsListOpened;
    }
    /** @ignore 2-way binding to keep track of the state of the dropdown menu */
    _onToggleDropdown(opened) {
        this._optionsListOpened = opened;
        this.actionPanelToggled.emit(opened);
    }
    ngOnDestroy() {
        this._optionsListOpened = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ActionBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ActionBarComponent, selector: "avn-action-bar", inputs: { iconsPlacement: "iconsPlacement", actions: "actions", hasBackdrop: "hasBackdrop", hasVisibleBackdrop: "hasVisibleBackdrop", tooltipPlacement: "tooltipPlacement", iconSize: "iconSize" }, outputs: { actionTriggered: "actionTriggered", actionPanelToggled: "actionPanelToggled" }, host: { properties: { "style.justify-content": "this._justifyContent" } }, viewQueries: [{ propertyName: "overlayOrigin", first: true, predicate: ["overlayOrigin"], descendants: true }, { propertyName: "optionsTemplate", first: true, predicate: ["optionsTemplate"], descendants: true }], ngImport: i0, template: "<!-- List of icons -->\n<div\n  [avnTooltip]=\"action.name\"\n  [tooltipPlacement]=\"tooltipPlacement\"\n  [tooltipMouseEnterOpenDelay]=\"0\"\n  [tooltipMouseLeaveCloseDelay]=\"0\"\n  class=\"action-bar-item\"\n  *ngFor=\"let action of _primaryActions\"\n  (click)=\"_onClickAction(action.id)\"\n>\n  <avn-icon [fontSize]=\"iconSize\" [icon]=\"action.icon\" [avnTheme]=\"action.theme\"></avn-icon>\n</div>\n\n<!-- Dropdown -->\n<div *ngIf=\"_secondaryActions?.length\" class=\"action-bar-item\" (click)=\"_onMenuClick()\" cdkOverlayOrigin #overlayOrigin=\"cdkOverlayOrigin\">\n  <avn-icon [fontSize]=\"iconSize\" icon=\"action:more_vert\"></avn-icon>\n</div>\n\n<avn-connected-element\n  *ngIf=\"_secondaryActions?.length\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [hasOverlayBackdrop]=\"hasBackdrop\"\n  [hasVisibleBackdrop]=\"hasVisibleBackdrop\"\n  [opened]=\"_optionsListOpened\"\n  [minWidth]=\"112\"\n  [width]=\"280\"\n  (toggled)=\"_onToggleDropdown($event)\"\n>\n  <!-- Note: ngIf is used so that the list is recreated everytime the overlay is opened (virtual scroll issues otherwise) -->\n  <avn-option-list [options]=\"_secondaryActions\" [optionsTemplate]=\"optionsTemplate\" (optionClicked)=\"_onOptionSelected($event)\"> </avn-option-list>\n</avn-connected-element>\n\n<ng-template #optionsTemplate let-option=\"option\">\n  <div class=\"action-bar-dropdown-option\">\n    <!-- below is a hack to keep the indentation of the text: add an icon but hide it -->\n    <avn-icon [icon]=\"option.data.icon || 'alert:info'\" [style.opacity]=\"option.data.icon ? 1 : 0\" [avnTheme]=\"option.data.theme\"></avn-icon>\n    <span class=\"action-bar-dropdown-option-label\">{{ option.label }}</span>\n  </div>\n</ng-template>\n", styles: [":host{height:100%;width:100%;display:grid;grid-auto-flow:column;grid-gap:var(--space-sm)}:host .action-bar-item{display:flex;margin:var(--space-xs);border-radius:3px;cursor:pointer;-webkit-user-select:none;user-select:none}:host .action-bar-item:hover{background-color:var(--selection-component-hover-background);color:var(--selection-component-hover-on)}:host .action-bar-item avn-icon{margin:auto;padding:var(--space-xs)}avn-option-list{display:block;border-radius:var(--dialog-border-radius);border:1px solid var(--modal-border);overflow:hidden;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.action-bar-dropdown-option{display:grid;align-items:center;align-content:center;justify-content:center;grid-template-columns:max-content 1fr;grid-gap:var(--space-base);cursor:pointer;-webkit-user-select:none;user-select:none}.action-bar-dropdown-option .action-bar-dropdown-option-label{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }, { kind: "component", type: OptionListComponent, selector: "avn-option-list", inputs: ["optionsTemplate", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "options", "selectionMode", "showCheckbox", "selectedOptions", "enableGroups"], outputs: ["optionClicked", "optionActivated", "selectionsChanged"] }, { kind: "directive", type: TooltipDirective, selector: "[avnTooltip]", inputs: ["avnTooltip", "tooltipName", "tooltipTemplate", "templateContext", "tooltipTheme", "tooltipPlacement", "tooltipMaxWidth", "tooltipDisabled", "tooltipTrigger", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipMouseLeaveCloseDelay", "tooltipMouseEnterOpenDelay"], outputs: ["show", "hide"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ActionBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-action-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- List of icons -->\n<div\n  [avnTooltip]=\"action.name\"\n  [tooltipPlacement]=\"tooltipPlacement\"\n  [tooltipMouseEnterOpenDelay]=\"0\"\n  [tooltipMouseLeaveCloseDelay]=\"0\"\n  class=\"action-bar-item\"\n  *ngFor=\"let action of _primaryActions\"\n  (click)=\"_onClickAction(action.id)\"\n>\n  <avn-icon [fontSize]=\"iconSize\" [icon]=\"action.icon\" [avnTheme]=\"action.theme\"></avn-icon>\n</div>\n\n<!-- Dropdown -->\n<div *ngIf=\"_secondaryActions?.length\" class=\"action-bar-item\" (click)=\"_onMenuClick()\" cdkOverlayOrigin #overlayOrigin=\"cdkOverlayOrigin\">\n  <avn-icon [fontSize]=\"iconSize\" icon=\"action:more_vert\"></avn-icon>\n</div>\n\n<avn-connected-element\n  *ngIf=\"_secondaryActions?.length\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [hasOverlayBackdrop]=\"hasBackdrop\"\n  [hasVisibleBackdrop]=\"hasVisibleBackdrop\"\n  [opened]=\"_optionsListOpened\"\n  [minWidth]=\"112\"\n  [width]=\"280\"\n  (toggled)=\"_onToggleDropdown($event)\"\n>\n  <!-- Note: ngIf is used so that the list is recreated everytime the overlay is opened (virtual scroll issues otherwise) -->\n  <avn-option-list [options]=\"_secondaryActions\" [optionsTemplate]=\"optionsTemplate\" (optionClicked)=\"_onOptionSelected($event)\"> </avn-option-list>\n</avn-connected-element>\n\n<ng-template #optionsTemplate let-option=\"option\">\n  <div class=\"action-bar-dropdown-option\">\n    <!-- below is a hack to keep the indentation of the text: add an icon but hide it -->\n    <avn-icon [icon]=\"option.data.icon || 'alert:info'\" [style.opacity]=\"option.data.icon ? 1 : 0\" [avnTheme]=\"option.data.theme\"></avn-icon>\n    <span class=\"action-bar-dropdown-option-label\">{{ option.label }}</span>\n  </div>\n</ng-template>\n", styles: [":host{height:100%;width:100%;display:grid;grid-auto-flow:column;grid-gap:var(--space-sm)}:host .action-bar-item{display:flex;margin:var(--space-xs);border-radius:3px;cursor:pointer;-webkit-user-select:none;user-select:none}:host .action-bar-item:hover{background-color:var(--selection-component-hover-background);color:var(--selection-component-hover-on)}:host .action-bar-item avn-icon{margin:auto;padding:var(--space-xs)}avn-option-list{display:block;border-radius:var(--dialog-border-radius);border:1px solid var(--modal-border);overflow:hidden;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.action-bar-dropdown-option{display:grid;align-items:center;align-content:center;justify-content:center;grid-template-columns:max-content 1fr;grid-gap:var(--space-base);cursor:pointer;-webkit-user-select:none;user-select:none}.action-bar-dropdown-option .action-bar-dropdown-option-label{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}\n"] }]
        }], propDecorators: { overlayOrigin: [{
                type: ViewChild,
                args: ['overlayOrigin', { static: false }]
            }], optionsTemplate: [{
                type: ViewChild,
                args: ['optionsTemplate', { static: false }]
            }], _justifyContent: [{
                type: HostBinding,
                args: ['style.justify-content']
            }], iconsPlacement: [{
                type: Input
            }], actions: [{
                type: Input
            }], hasBackdrop: [{
                type: Input
            }], hasVisibleBackdrop: [{
                type: Input
            }], tooltipPlacement: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], actionTriggered: [{
                type: Output
            }], actionPanelToggled: [{
                type: Output
            }] } });

class ConnectedElementModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ConnectedElementModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ConnectedElementModule, declarations: [ConnectedElementComponent], imports: [CommonModule, OverlayModule$1], exports: [ConnectedElementComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ConnectedElementModule, imports: [CommonModule, OverlayModule$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ConnectedElementModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, OverlayModule$1],
                    declarations: [ConnectedElementComponent],
                    exports: [ConnectedElementComponent],
                }]
        }] });

class CheckboxModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: CheckboxModule, declarations: [CheckboxComponent], imports: [CommonModule], exports: [CheckboxComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CheckboxComponent],
                    exports: [CheckboxComponent],
                }]
        }] });

class OptionModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OptionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: OptionModule, declarations: [OptionComponent, OptionListComponent], imports: [CommonModule, OverlayModule$1, ScrollingModule, CoreModule, CheckboxModule], exports: [OptionComponent, OptionListComponent, OverlayModule$1, ScrollingModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OptionModule, imports: [CommonModule, OverlayModule$1, ScrollingModule, CoreModule, CheckboxModule, OverlayModule$1, ScrollingModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: OptionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, OverlayModule$1, ScrollingModule, CoreModule, CheckboxModule],
                    declarations: [OptionComponent, OptionListComponent],
                    exports: [OptionComponent, OptionListComponent, OverlayModule$1, ScrollingModule],
                }]
        }] });

class TooltipModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TooltipModule, declarations: [TooltipComponent, TooltipDirective], imports: [CommonModule, CoreModule], exports: [TooltipComponent, TooltipDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TooltipModule, imports: [CommonModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TooltipComponent, TooltipDirective],
                    exports: [TooltipComponent, TooltipDirective],
                    imports: [CommonModule, CoreModule]
                }]
        }] });

class ActionBarModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ActionBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ActionBarModule, declarations: [ActionBarComponent], imports: [CommonModule, IconModule, OverlayModule$1, ConnectedElementModule, OptionModule, TooltipModule, CoreModule], exports: [ActionBarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ActionBarModule, imports: [CommonModule, IconModule, OverlayModule$1, ConnectedElementModule, OptionModule, TooltipModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ActionBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, OverlayModule$1, ConnectedElementModule, OptionModule, TooltipModule, CoreModule],
                    declarations: [ActionBarComponent],
                    exports: [ActionBarComponent],
                }]
        }] });

class AvatarComponent {
    constructor() {
        /**
         * a label to display as text on the avatar.
         * i.e. 'initials' if contains for then a word (max 3)
         * or first two letters if a single word, such as a username
         */
        this.label = '';
    }
    get displayLabel() {
        if (this.label && this.label.length > 2) {
            const initials = this.label
                .replace(/[^a-zA-Z- ]/g, '')
                .match(/\b\w/g)
                ?.join('');
            if (initials && initials.length > 1)
                return initials.toUpperCase().substring(0, 3);
            return this.label.substr(0, 2);
        }
        return this.label;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: AvatarComponent, selector: "avn-avatar", inputs: { icon: "icon", label: "label" }, ngImport: i0, template: "<div>\n  <avn-icon *ngIf=\"icon\" [icon]=\"icon\" [fontSize]=\"24\"></avn-icon>\n  <h6 *ngIf=\"!icon\">{{ displayLabel }}</h6>\n</div>\n", styles: [":host{display:inline-block;border-radius:50%;flex-shrink:0;height:40px;width:40px;margin-right:var(--space-md)}:host.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info{background-color:var(--info-base);color:var(--info-on)}:host.theme-success{background-color:var(--success-base);color:var(--success-on)}:host div{height:40px;width:40px;display:flex;flex-wrap:nowrap;justify-content:center;align-content:center;align-items:center}:host div>avn-icon i.fa{font-size:var(--text-lg);display:inline-block;line-height:24px;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-avatar', template: "<div>\n  <avn-icon *ngIf=\"icon\" [icon]=\"icon\" [fontSize]=\"24\"></avn-icon>\n  <h6 *ngIf=\"!icon\">{{ displayLabel }}</h6>\n</div>\n", styles: [":host{display:inline-block;border-radius:50%;flex-shrink:0;height:40px;width:40px;margin-right:var(--space-md)}:host.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info{background-color:var(--info-base);color:var(--info-on)}:host.theme-success{background-color:var(--success-base);color:var(--success-on)}:host div{height:40px;width:40px;display:flex;flex-wrap:nowrap;justify-content:center;align-content:center;align-items:center}:host div>avn-icon i.fa{font-size:var(--text-lg);display:inline-block;line-height:24px;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], label: [{
                type: Input
            }] } });

class AvatarModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: AvatarModule, declarations: [AvatarComponent], imports: [CommonModule, IconModule], exports: [AvatarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AvatarModule, imports: [CommonModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule],
                    declarations: [AvatarComponent],
                    exports: [AvatarComponent],
                }]
        }] });

/* eslint-disable no-prototype-builtins */
/**
 * This animation transforms the select's overlay panel on and off the page.
 */
const loadingIconAnimation = trigger('loadingIconAnimation', [
    transition(':enter', [style({ transform: 'scale(0)', opacity: 0 }), animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'scale(1)', opacity: 1 }))]),
    transition(':leave', [style({ opacity: 1 }), animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 0 }))]),
]);
/**
 * A control to pick a value amongst a connected list of selectable options.
 * Gives the ability to search for the value
 * The autocomplete provides the following functionalities:
 *
 * Configurable datasource
 * - It can be a list of options (sync data) or an async function returning a list of options
 * - Each option holds a value, a label and custom data associated to it
 * - An option can be disabled
 * - A custom rendering template can be specified for use in the option list
 *
 * Virtualization
 *
 * - Enabled by default after N (defaults to 30) options are present in list, can be disabled
 * completely if required.
 *
 * Keyboard Navigation
 *
 * - Enabled by default, can be disabled if required.
 * - First option of the list can be automatically set to active if specified
 * - Event is emitted every time an option is made active by navigation
 * - Works with virtual scroll
 *
 * Configurable size
 * - The list can be configured to display a max number of options within its viewport.
 * - Option height can be configured
 *
 * Configurable width
 * - The list can be configured to match the origin element width or a custom width
 *
 * Option Selection
 * - Option can be selected by clicking on it
 * - Disabled option are not selectable
 * - When keyboard navigation is enabled, option can be selected by pressing the TAB or ENTER key
 * - Event is emitted every time an option is selected
 *
 * Matching Text Highlight
 * - Partially entered text can be highlighted in the resulting option list
 * - First occurrence of matching text only or all occurrences can be highlighted
 *
 * More configurable text search options:
 * - Debounce time between keypress before looking up for matching options
 * - Minimum amount of characters that need to be input before data lookup occurs
 * - Case sensitivity (Sync datasource only)
 * - Match Type (Sync datasource only).
 *    > 'startWith': will return options that starts with the entered text
 *    > 'contains': will return options that contains the entered text
 *
 * Notes:
 *  - As specified above, with an async datasource, the matchType and case sensitivity will not
 * work. Filtering is the responsibility of the async function returning the options. Most likely,
 * the async function will perform an API call. However the current matchType and case sensitivity
 * are passed to the async function so they can be used if necessary.
 *
 *  - When a custom template is used for option display, highlighting of matching text will be
 * disabled.
 *
 *  - When using a async datasource, the initial selected option data must be passed in the
 * selectedOption input. That way we don't need to refetch all the data and wait for the data to be
 * loaded to be able to display the selected option label. Most of the time, when in a form context,
 * the user won't touch the autocomplete field and therefore no data fetch should be performed.
 */
class AutocompleteComponent extends FormControlComponent {
    /**
     * The datasource for the autocomplete.
     * It can be a list of options (sync data) or an async function returning a list of options
     * *
     */
    set datasource(datasource) {
        this._datasource = datasource;
        this.isAsyncDatasource = this.datasource && typeof this.datasource === 'function';
        this.isArrayDatasource = this.datasource && this.datasource.constructor.name === 'Array';
    }
    get datasource() {
        return this._datasource;
    }
    /** @ignore **/
    constructor(ngControl, changeDetector) {
        super(ngControl, changeDetector);
        /** The placeholder for the autocomplete when no value is selected **/
        this.placeholder = '';
        /** The message to display when no options are available for selection **/
        this.emptyPlaceholder = 'No options available';
        /** Specifies if virtual scroll is enabled **/
        this.virtualization = false;
        /**
         * Specifies if virtual scroll should be auto enabled after a specific amount of options in the
         * list *
         */
        this.autoVirtualizeAfterXOptions = 30;
        /** Specifies if keyboard navigation is enabled **/
        this.keyboardNavigationEnabled = true;
        /**
         * When keyboard navigation is enabled, specifies if the first option should be auto marked as
         * active *
         */
        this.autoActiveFirstOption = true;
        /** Specifies the number of options visible in the list **/
        this.maxOptionsVisibleInViewport = 7;
        /** Specifies the option height **/
        this.optionHeight = DEFAULT_OPTION_HEIGHT;
        /** The debounce time for keyboard typing before data is refetched */
        this.debounceTimeMs = 300;
        /** minimum characters that can trigger the search */
        this.minChars = 0;
        /** Specifies how to filter the options list. */
        this.matchType = 'contains';
        /** Specifies if case filtering should apply */
        this.caseSensitive = false;
        /** Specifies if entered text should be highlighted in the option list */
        this.highlightMatchingText = true;
        /** Specifies if first occurrence only of entered text should be highlighted in the option list */
        this.highlightMatchingTextOnlyFirst = true;
        /** Specifies if an 'x' button to clear text input should be shown */
        this.showClearInputIcon = true;
        /**
         * Emits every time the autocomplete value changes. when using allowNonExistingValues items not in the datasource this emits a string.
         * *
         */
        this.valueChanged = new EventEmitter();
        /** Emits every time an option is marked as active with keyboard navigation **/
        this.optionActivated = new EventEmitter();
        /** Emits every time the option list is opened / closed. boolean speficies if opened. **/
        this.optionListToggled = new EventEmitter();
        /** The remaining options after filtering the main datasource */
        this.filteredOptions = [];
        /** Specifies if the options list panel is opened **/
        this.optionsListOpened = false;
        /** Specifies if the autocomplete is loading data */
        this.loading = false;
        this.showClearButton = false;
        /** @ignore pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
        /** @ignore internal tracking of keyboard navigation state **/
        this._keyboardNavigationEnabled = this.keyboardNavigationEnabled;
        /** internal tracking of datasource type **/
        this.isAsyncDatasource = false;
        /** internal tracking of datasource type **/
        this.isArrayDatasource = false;
    }
    /** @ignore */
    ngOnInit() {
        super.ngOnInit();
    }
    /** @ignore **/
    ngAfterViewInit() {
        super.ngOnInit();
        this.watchAutocompleteAction();
        this.watchDocumentAction();
        // if we have a local datasource, we can create the filtered options straight away
        // that will allow us to get the label of the selected option
        if (this.isArrayDatasource) {
            this.filteredOptions = this.datasource;
            this.updateSelectedOption(this.value);
        }
    }
    /** @ignore **/
    ngOnChanges({ keyboardNavigationEnabled, value, selectedOption }) {
        if (keyboardNavigationEnabled && keyboardNavigationEnabled.isFirstChange()) {
            this._keyboardNavigationEnabled = keyboardNavigationEnabled.currentValue;
        }
        if (value) {
            // if we have a local datasource, try finding the option in the array
            // for async data source the selected option must be passed in selectedOption input
            if (this.isArrayDatasource) {
                this.updateSelectedOption(value.currentValue);
            }
        }
        // if we are not in a form context, the initially selected option will be set via the
        // selectedOption input if we are in a form control, we don't set the value fom the selected
        // option as that will be managed by the form
        if (selectedOption) {
            if (!this.formControl) {
                this.value = selectedOption.currentValue ? selectedOption.currentValue.value : '';
            }
            // only update the input value if there is a selected option, otherwise keep the typed in
            // value
            if (selectedOption.currentValue) {
                this.updateInputDisplayValue(this.getDisplayValue(this.selectedOption));
            }
        }
    }
    /**
     * @ignore show the option list when the autocomplete is focused and filter as the user types in
     * *
     */
    watchAutocompleteAction() {
        fromEvent(this.autocompleteInput.nativeElement, 'input')
            .pipe(filter(() => !this.disabled), map((event) => event.target.value), takeUntil(this.componentDestroyed$))
            .subscribe((inputSearchValue) => {
            this.showClearButton = !!inputSearchValue;
            this.changeDetector.detectChanges();
        });
        const keyboardEvent = merge(fromEvent(this.autocompleteInput.nativeElement, 'keyup').pipe(filter(() => !this.disabled), debounceTime(this.debounceTimeMs), filter((event) => ![DOWN_ARROW, UP_ARROW, ENTER, TAB].includes(event.keyCode))), fromEvent(this.autocompleteInput.nativeElement, 'focus').pipe(filter(() => !this.disabled)));
        keyboardEvent
            .pipe(map((event) => event.target.value?.trim()), distinctUntilChanged((prev, curr) => {
            if (isEmpty(curr)) {
                return false;
            }
            else {
                return this.caseSensitive ? prev === curr : prev.toLowerCase() === curr.toLowerCase();
            }
        }), filter((inputSearchValue) => (inputSearchValue || '').length >= this.minChars), switchMap((inputSearchValue) => this.getFilteredOptionsConfig(inputSearchValue)), takeUntil(this.componentDestroyed$))
            .subscribe(({ options }) => this.setFilteredOptionsConfig(options));
        fromEvent(this.autocompleteInput.nativeElement, 'blur')
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            if (!this.autocompleteInput.nativeElement.value && !!this.value) {
                this.selectedOption = undefined;
                this.setValue();
            }
        });
    }
    setFilteredOptionsConfig(options) {
        this.loading = false;
        if (options !== undefined) {
            this.filteredOptions = options ? [...options] : undefined;
            // if no data, add and empty option
            if (!this.filteredOptions || this.filteredOptions.length === 0) {
                this.addEmptyRecord();
                this.optionsListOpened = true;
                this.keyboardNavigationEnabled = false;
            }
            else {
                this.keyboardNavigationEnabled = this._keyboardNavigationEnabled;
                this.optionsListOpened = true;
            }
            this.changeDetector.detectChanges();
        }
    }
    getFilteredOptionsConfig(inputSearchValue) {
        this.filteredOptions = [];
        const searchText = inputSearchValue || '';
        if (searchText.length >= this.minChars) {
            // reset the list and mark the autocomplete as loading
            this.loading = true;
            this.optionsListOpened = true;
            this.changeDetector.detectChanges();
            // check the type of datasource
            const dataSource$ = this.isAsyncDatasource
                ? this.datasource(searchText, this.matchType, this.caseSensitive)
                : of(this.filterAutocompleteOptions(searchText));
            return dataSource$.pipe(first(), catchError(() => of([])), map((options) => ({ options, searchText })));
        }
        this.optionsListOpened = false;
        return of({ options: undefined, searchText });
    }
    /**
     * @ignore
     *  close the option list on outside click. Make sure it applies only when the autocomplete is not
     *  disabled, not loading and when the option list is opened.
     *  *
     */
    watchDocumentAction() {
        this.connectedElement.clickOutside.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
            // if an option was selected but the value in the input field has not changed then its fine.
            // otherwise reset the selected value
            //
            let resetValue = false;
            const selectedOptionDisplayValue = this.getDisplayValue(this.selectedOption);
            if (this.autocompleteInput.nativeElement.value !== selectedOptionDisplayValue) {
                resetValue = true;
            }
            else {
                // if the value is the same let's check if the filtered option has the value
                const isSelectedOptionValid = (this.filteredOptions || []).filter((option) => option.value === this.selectedOption?.value).length > 0;
                resetValue = !isSelectedOptionValid;
            }
            if (resetValue) {
                this.selectedOption = undefined;
                this.setValue();
            }
            else if (this.formControl && !this.formControl.value && this.value) {
                // This happens when value is pre-set at initialization but not yet propagate to the form
                // control
                this.propagateChange(this.value);
            }
        });
    }
    /** @ignore if there are no options then add an empty option and disable keyboard navigation **/
    addEmptyRecord() {
        this.filteredOptions = [
            {
                value: '',
                disabled: true,
                disableTemplate: true,
                label: this.emptyPlaceholder,
            },
        ];
        this.keyboardNavigationEnabled = false;
    }
    /** @ignore filter the options based on the entered value **/
    filterAutocompleteOptions(search = '') {
        const options = this.datasource;
        const applyCase = (value) => (this.caseSensitive ? value : value.toLowerCase());
        const getLabelValue = (option) => applyCase(option.label || '');
        if (this.matchType === 'startsWith') {
            return options.filter((option) => getLabelValue(option).startsWith(applyCase(search)));
        }
        else if (this.matchType === 'contains') {
            return options.filter((option) => getLabelValue(option).indexOf(applyCase(search)) > -1);
        }
        return [];
    }
    /** When an option is selected in the option list **/
    onSelectOption(selectedOption) {
        this.selectedOption = selectedOption;
        this.optionsListOpened = false;
        this.setValue();
    }
    /** When the value is updated by the form api. See FormControl **/
    updateValue(value) {
        if (!value) {
            this.selectedOption = undefined;
            const isIOptionData = this.selectedOption && this.selectedOption.hasOwnProperty('value');
            this.value = isIOptionData ? this.selectedOption.value : this.selectedOption;
            this.updateInputDisplayValue(isIOptionData ? this.getDisplayValue(this.selectedOption) : this.value);
            this.valueChanged.emit(isIOptionData ? { ...this.selectedOption } : this.value);
        }
        else {
            // if we have a local datasource, try finding the option in the array
            // ATTENTION: for async data source the selected option must be passed in selectedOption input
            if (this.isArrayDatasource) {
                this.updateSelectedOption(value);
                const isIOptionData = this.selectedOption && this.selectedOption.hasOwnProperty('value');
                this.value = isIOptionData ? this.selectedOption.value : this.selectedOption;
                this.updateInputDisplayValue(isIOptionData ? this.getDisplayValue(this.selectedOption) : this.value);
                this.valueChanged.emit(isIOptionData ? { ...this.selectedOption } : this.value);
            }
            else {
                this.value = value;
                this.updateInputDisplayValue(this.value);
            }
        }
        this.changeDetector.detectChanges();
    }
    setValue() {
        const isIOptionData = this.selectedOption && this.selectedOption.hasOwnProperty('value');
        this.value = isIOptionData ? this.selectedOption.value : this.selectedOption;
        this.updateInputDisplayValue(isIOptionData ? this.getDisplayValue(this.selectedOption) : this.value);
        this.propagateChange(this.value);
        this.valueChanged.emit(isIOptionData ? { ...this.selectedOption } : this.value);
        this.changeDetector.detectChanges();
    }
    /**
     * *** For ARRAY data source only. ***
     * Sets the selected option from the specified value.
     **/
    updateSelectedOption(value) {
        if (this.datasource && !!value) {
            let optionIndex;
            if (typeof value === 'object') {
                optionIndex = this.datasource.map((o) => JSON.stringify(o.value)).indexOf(JSON.stringify(value));
            }
            else {
                optionIndex = this.datasource.map((o) => (o.value ? o.value.toString() : undefined)).indexOf(value.toString());
            }
            this.selectedOption = optionIndex > -1 ? this.datasource[optionIndex] : undefined;
        }
        else {
            this.selectedOption = undefined;
        }
        this.changeDetector.detectChanges();
    }
    /** When the option list is toggled **/
    onOptionListToggled(opened) {
        this.optionListToggled.emit(opened);
        // when the list is closed, mark the form control as touched
        if (!opened) {
            this.onTouch();
        }
    }
    /** When the option list is activated by keyboard navigation **/
    onOptionActivated(option) {
        this.optionActivated.emit({ ...option });
    }
    /**
     * @ignore override from parent class so we can trigger change detection and run custom code
     * When OnPush strategy is used, inherited Input() change does not trigger ngOnChanges...
     */
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.changeDetector.detectChanges();
    }
    /** @ingore Returns a string representation of the option label (converts object to string) **/
    getDisplayValue(selectedOption) {
        let value = '';
        if (selectedOption) {
            value = selectedOption.label || selectedOption.value;
            if (value && typeof value === 'object') {
                value = JSON.stringify(value);
            }
        }
        return value;
    }
    /** Updates the native input display value **/
    updateInputDisplayValue(value) {
        this.autocompleteInput.nativeElement.value = value || '';
        this.showClearButton = !!value;
    }
    /** Highlights the partially entered text in the option label **/
    replaceItemLabel(option) {
        const partialValue = this.autocompleteInput.nativeElement.value;
        if (!partialValue || !option.label) {
            return option.label;
        }
        const label = option.label;
        const indexes = [];
        let currentIndex = label.toLowerCase().indexOf(partialValue.toLowerCase());
        if (this.highlightMatchingTextOnlyFirst) {
            if (currentIndex !== -1) {
                indexes.push(currentIndex);
            }
        }
        else {
            while (currentIndex !== -1) {
                indexes.push(currentIndex);
                currentIndex = label.toLowerCase().indexOf(partialValue.toLowerCase(), currentIndex + partialValue.length);
            }
        }
        let res = '';
        currentIndex = 0;
        for (const index of indexes) {
            res += label.substring(currentIndex, index) + '<b>' + label.substring(index, index + partialValue.length) + '</b>';
            currentIndex = index + partialValue.length;
        }
        res += label.substring(currentIndex);
        return res;
    }
    clearInput() {
        this.updateInputDisplayValue('');
        this.autocompleteInput.nativeElement.focus();
        this.valueChanged.emit(undefined);
    }
    /** @ignore **/
    ngOnDestroy() {
        super.ngOnDestroy();
        this.optionsListOpened = false;
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AutocompleteComponent, deps: [{ token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: AutocompleteComponent, selector: "avn-autocomplete", inputs: { optionsTemplate: "optionsTemplate", label: "label", datasource: "datasource", placeholder: "placeholder", emptyPlaceholder: "emptyPlaceholder", value: "value", optionsListWidth: "optionsListWidth", virtualization: "virtualization", autoVirtualizeAfterXOptions: "autoVirtualizeAfterXOptions", keyboardNavigationEnabled: "keyboardNavigationEnabled", autoActiveFirstOption: "autoActiveFirstOption", maxOptionsVisibleInViewport: "maxOptionsVisibleInViewport", optionHeight: "optionHeight", debounceTimeMs: "debounceTimeMs", minChars: "minChars", matchType: "matchType", caseSensitive: "caseSensitive", highlightMatchingText: "highlightMatchingText", highlightMatchingTextOnlyFirst: "highlightMatchingTextOnlyFirst", selectedOption: "selectedOption", showClearInputIcon: "showClearInputIcon" }, outputs: { valueChanged: "valueChanged", optionActivated: "optionActivated", optionListToggled: "optionListToggled" }, providers: [{ provide: FormControlComponent, useExisting: AutocompleteComponent }], viewQueries: [{ propertyName: "overlayOrigin", first: true, predicate: ["overlayOrigin"], descendants: true }, { propertyName: "connectedElement", first: true, predicate: ["connectedElement"], descendants: true }, { propertyName: "optionListComponent", first: true, predicate: ["optionList"], descendants: true }, { propertyName: "autocompleteInput", first: true, predicate: ["autocompleteInput"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div class=\"input-container\" [class.disabled]=\"disabled\" #overlayOrigin=\"cdkOverlayOrigin\" cdkOverlayOrigin>\n  <input #autocompleteInput [id]=\"id\" [placeholder]=\"placeholder\" type=\"text\" [disabled]=\"disabled\" [class.loading]=\"loading\" (blur)=\"onTouch()\" />\n  <avn-icon\n    *ngIf=\"showClearInputIcon && showClearButton && !loading\"\n    [fontSize]=\"14\"\n    icon=\"content:clear\"\n    class=\"icon-clear-input\"\n    (click)=\"clearInput()\"\n  >\n  </avn-icon>\n  <avn-icon *ngIf=\"loading\" [fontSize]=\"14\" icon=\"fa:spinner\" class=\"icon-loading\" [rotate]=\"true\"> </avn-icon>\n</div>\n\n<avn-connected-element\n  #connectedElement\n  [minWidth]=\"optionsListWidth\"\n  [width]=\"optionsListWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"!this.loading && optionsListOpened\"\n  (toggled)=\"onOptionListToggled($event)\"\n>\n  <!-- Note: ngIf is used so that the list is recreated everytime the overlay is opened (virtual scroll issues otherwise) -->\n  <avn-option-list\n    *ngIf=\"optionsListOpened\"\n    #optionList\n    [attr.name]=\"formControlName || name\"\n    [virtualization]=\"virtualization\"\n    [autoVirtualizeAfterXOptions]=\"autoVirtualizeAfterXOptions\"\n    [keyboardNavigationEnabled]=\"keyboardNavigationEnabled\"\n    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n    [maxOptionsVisibleInViewport]=\"maxOptionsVisibleInViewport\"\n    [selectedOptions]=\"[selectedOption]\"\n    [options]=\"filteredOptions\"\n    [optionHeight]=\"optionHeight\"\n    (optionClicked)=\"onSelectOption($event)\"\n    [optionsTemplate]=\"optionsTemplate ? optionsTemplate : highlightMatchingText ? highlightTextTemplate : undefined\"\n    (optionActivated)=\"onOptionActivated($event)\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n\n<ng-template #highlightTextTemplate let-option=\"option\">\n  <div class=\"highlighted-text\" [innerHTML]=\"replaceItemLabel(option)\"></div>\n</ng-template>\n", styles: [":host{display:block}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host.validation-theme.ng-valid.ng-touched .input-container,:host.validation-theme.ng-valid.ng-dirty .input-container{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container,:host.validation-theme.ng-invalid.ng-dirty .input-container{border-color:var(--danger-base)!important}:host .input-container{border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);position:relative;display:grid;grid-template-columns:auto min(var(--space-xl));align-items:center}:host .input-container:hover,:host .input-container:focus,:host .input-container.focus{border-color:var(--form-control-hover-border)}:host .input-container:disabled,:host .input-container:disabled:hover,:host .input-container:disabled:focus,:host .input-container.disabled,:host .input-container.disabled:hover,:host .input-container.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-container>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;display:block;width:100%;margin:0;height:calc(2.25rem + 2px);padding:var(--space-sm) var(--space-base);font-size:var(--text-base);font-weight:400;line-height:1.5;background-clip:padding-box;border:none;transition:border-color .15s ease-in-out,background-color .15s ease-in-out;text-overflow:ellipsis}:host .input-container>input::placeholder{color:var(--form-control-placeholder)}:host .input-container>input:disabled,:host .input-container>input:disabled:hover,:host .input-container>input:disabled:focus,:host .input-container>input.disabled,:host .input-container>input.disabled:hover,:host .input-container>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-container>input:after,:host .input-container>input:before{box-sizing:border-box}:host .input-container avn-icon.icon-clear-input{justify-self:end;padding-right:var(--space-md);color:var(--form-control-icon);cursor:pointer}:host .input-container avn-icon.icon-loading{justify-self:end;padding-right:var(--space-md);color:var(--form-control-icon)}.highlighted-text{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: OptionListComponent, selector: "avn-option-list", inputs: ["optionsTemplate", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "options", "selectionMode", "showCheckbox", "selectedOptions", "enableGroups"], outputs: ["optionClicked", "optionActivated", "selectionsChanged"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }], animations: [loadingIconAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-autocomplete', providers: [{ provide: FormControlComponent, useExisting: AutocompleteComponent }], changeDetection: ChangeDetectionStrategy.OnPush, animations: [loadingIconAnimation], template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div class=\"input-container\" [class.disabled]=\"disabled\" #overlayOrigin=\"cdkOverlayOrigin\" cdkOverlayOrigin>\n  <input #autocompleteInput [id]=\"id\" [placeholder]=\"placeholder\" type=\"text\" [disabled]=\"disabled\" [class.loading]=\"loading\" (blur)=\"onTouch()\" />\n  <avn-icon\n    *ngIf=\"showClearInputIcon && showClearButton && !loading\"\n    [fontSize]=\"14\"\n    icon=\"content:clear\"\n    class=\"icon-clear-input\"\n    (click)=\"clearInput()\"\n  >\n  </avn-icon>\n  <avn-icon *ngIf=\"loading\" [fontSize]=\"14\" icon=\"fa:spinner\" class=\"icon-loading\" [rotate]=\"true\"> </avn-icon>\n</div>\n\n<avn-connected-element\n  #connectedElement\n  [minWidth]=\"optionsListWidth\"\n  [width]=\"optionsListWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"!this.loading && optionsListOpened\"\n  (toggled)=\"onOptionListToggled($event)\"\n>\n  <!-- Note: ngIf is used so that the list is recreated everytime the overlay is opened (virtual scroll issues otherwise) -->\n  <avn-option-list\n    *ngIf=\"optionsListOpened\"\n    #optionList\n    [attr.name]=\"formControlName || name\"\n    [virtualization]=\"virtualization\"\n    [autoVirtualizeAfterXOptions]=\"autoVirtualizeAfterXOptions\"\n    [keyboardNavigationEnabled]=\"keyboardNavigationEnabled\"\n    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n    [maxOptionsVisibleInViewport]=\"maxOptionsVisibleInViewport\"\n    [selectedOptions]=\"[selectedOption]\"\n    [options]=\"filteredOptions\"\n    [optionHeight]=\"optionHeight\"\n    (optionClicked)=\"onSelectOption($event)\"\n    [optionsTemplate]=\"optionsTemplate ? optionsTemplate : highlightMatchingText ? highlightTextTemplate : undefined\"\n    (optionActivated)=\"onOptionActivated($event)\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n\n<ng-template #highlightTextTemplate let-option=\"option\">\n  <div class=\"highlighted-text\" [innerHTML]=\"replaceItemLabel(option)\"></div>\n</ng-template>\n", styles: [":host{display:block}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host.validation-theme.ng-valid.ng-touched .input-container,:host.validation-theme.ng-valid.ng-dirty .input-container{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container,:host.validation-theme.ng-invalid.ng-dirty .input-container{border-color:var(--danger-base)!important}:host .input-container{border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);position:relative;display:grid;grid-template-columns:auto min(var(--space-xl));align-items:center}:host .input-container:hover,:host .input-container:focus,:host .input-container.focus{border-color:var(--form-control-hover-border)}:host .input-container:disabled,:host .input-container:disabled:hover,:host .input-container:disabled:focus,:host .input-container.disabled,:host .input-container.disabled:hover,:host .input-container.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-container>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;display:block;width:100%;margin:0;height:calc(2.25rem + 2px);padding:var(--space-sm) var(--space-base);font-size:var(--text-base);font-weight:400;line-height:1.5;background-clip:padding-box;border:none;transition:border-color .15s ease-in-out,background-color .15s ease-in-out;text-overflow:ellipsis}:host .input-container>input::placeholder{color:var(--form-control-placeholder)}:host .input-container>input:disabled,:host .input-container>input:disabled:hover,:host .input-container>input:disabled:focus,:host .input-container>input.disabled,:host .input-container>input.disabled:hover,:host .input-container>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-container>input:after,:host .input-container>input:before{box-sizing:border-box}:host .input-container avn-icon.icon-clear-input{justify-self:end;padding-right:var(--space-md);color:var(--form-control-icon);cursor:pointer}:host .input-container avn-icon.icon-loading{justify-self:end;padding-right:var(--space-md);color:var(--form-control-icon)}.highlighted-text{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { overlayOrigin: [{
                type: ViewChild,
                args: ['overlayOrigin', { static: false }]
            }], connectedElement: [{
                type: ViewChild,
                args: ['connectedElement', { static: false }]
            }], optionListComponent: [{
                type: ViewChild,
                args: ['optionList', { static: false }]
            }], autocompleteInput: [{
                type: ViewChild,
                args: ['autocompleteInput', { static: true }]
            }], optionsTemplate: [{
                type: Input
            }], label: [{
                type: Input
            }], datasource: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], emptyPlaceholder: [{
                type: Input
            }], value: [{
                type: Input
            }], optionsListWidth: [{
                type: Input
            }], virtualization: [{
                type: Input
            }], autoVirtualizeAfterXOptions: [{
                type: Input
            }], keyboardNavigationEnabled: [{
                type: Input
            }], autoActiveFirstOption: [{
                type: Input
            }], maxOptionsVisibleInViewport: [{
                type: Input
            }], optionHeight: [{
                type: Input
            }], debounceTimeMs: [{
                type: Input
            }], minChars: [{
                type: Input
            }], matchType: [{
                type: Input
            }], caseSensitive: [{
                type: Input
            }], highlightMatchingText: [{
                type: Input
            }], highlightMatchingTextOnlyFirst: [{
                type: Input
            }], selectedOption: [{
                type: Input
            }], showClearInputIcon: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }], optionActivated: [{
                type: Output
            }], optionListToggled: [{
                type: Output
            }] } });

class AutocompleteModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: AutocompleteModule, declarations: [AutocompleteComponent], imports: [CommonModule, IconModule, OptionModule, ConnectedElementModule], exports: [AutocompleteComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AutocompleteModule, imports: [CommonModule, IconModule, OptionModule, ConnectedElementModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AutocompleteComponent],
                    exports: [AutocompleteComponent],
                    imports: [CommonModule, IconModule, OptionModule, ConnectedElementModule],
                }]
        }] });

var IBadgeSize;
(function (IBadgeSize) {
    IBadgeSize["EXTRA_SMALL"] = "extraSmall";
    IBadgeSize["SMALL"] = "small";
    IBadgeSize["MEDIUM"] = "medium";
    IBadgeSize["LARGE"] = "large";
    IBadgeSize["EXTRA_LARGE"] = "extraLarge";
    IBadgeSize["DEFAULT"] = "medium";
})(IBadgeSize || (IBadgeSize = {}));

class BadgeComponent {
    constructor() {
        /**
         * badge size : small, medium, large
         */
        this.badgeSize = IBadgeSize.DEFAULT;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: BadgeComponent, selector: "avn-badge", inputs: { label: "label", badgeSize: "badgeSize" }, ngImport: i0, template: "<div\n  [ngClass]=\"{\n    'extra-small': badgeSize === 'extraSmall',\n    small: badgeSize === 'small',\n    medium: badgeSize === 'medium',\n    large: badgeSize === 'large',\n    'extra-large': badgeSize === 'extraLarge'\n  }\"\n>\n  <span class=\"badge\" #badgeElement>{{ label }}</span>\n</div>\n", styles: [":host.theme-primary>div>span.badge{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>div>span.badge{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>div>span.badge{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>div>span.badge{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>div>span.badge{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>div>span.badge{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>div>span.badge{background-color:var(--success-base);color:var(--success-on)}:host>div{display:flex}:host span.badge{background-color:var(--main-variant-background);color:var(--main-variant-on);display:inline-block;padding:var(--space-sm) var(--space-md);font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}:host .extra-small{font-size:var(--text-base)}:host .small{font-size:var(--text-md)}:host .medium{font-size:var(--text-lg)}:host .large{font-size:var(--text-xl)}:host .extra-large{font-size:var(--text-xxl)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-badge', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  [ngClass]=\"{\n    'extra-small': badgeSize === 'extraSmall',\n    small: badgeSize === 'small',\n    medium: badgeSize === 'medium',\n    large: badgeSize === 'large',\n    'extra-large': badgeSize === 'extraLarge'\n  }\"\n>\n  <span class=\"badge\" #badgeElement>{{ label }}</span>\n</div>\n", styles: [":host.theme-primary>div>span.badge{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>div>span.badge{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>div>span.badge{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>div>span.badge{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>div>span.badge{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>div>span.badge{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>div>span.badge{background-color:var(--success-base);color:var(--success-on)}:host>div{display:flex}:host span.badge{background-color:var(--main-variant-background);color:var(--main-variant-on);display:inline-block;padding:var(--space-sm) var(--space-md);font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}:host .extra-small{font-size:var(--text-base)}:host .small{font-size:var(--text-md)}:host .medium{font-size:var(--text-lg)}:host .large{font-size:var(--text-xl)}:host .extra-large{font-size:var(--text-xxl)}\n"] }]
        }], propDecorators: { label: [{
                type: Input
            }], badgeSize: [{
                type: Input
            }] } });

class BadgeModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: BadgeModule, declarations: [BadgeComponent], imports: [CommonModule], exports: [BadgeComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BadgeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [BadgeComponent],
                    exports: [BadgeComponent],
                }]
        }] });

class CardAlternateContentComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardAlternateContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CardAlternateContentComponent, selector: "avn-card-alternate-content", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardAlternateContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-card-alternate-content', template: "<ng-content></ng-content>\n" }]
        }] });

/**
 * place holder component to project content into cards.
 */
class CardContentComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CardContentComponent, selector: "avn-card-content", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-card-content', template: "<ng-content></ng-content>\n" }]
        }] });

const ANIM_SPEED = '200ms';
/**
 * The card component - made with ♥
 *  - inspired by: https://material.io/design/components/cards.html
 *  - see the sandbox for examples of usage.
 *  - supports nesting avn-buttons, avn-icon with caveats:
 *  - will overide the theme and disabled props of the button
 *
 * Alt State / Fullsize
 *  - this is the content that can be shown when the card is fully expanded
 *  - use a @ContentChild with the expand and collapse methods to manipulate the card
 * programatically
 *  - caveat : the parent container should have a css position. If the parent scrolls
 * make sure you set the overflow-y to always show the scroll bar so the animation does not
 * flikr.
 *
 * Expiremental Features
 * 1. Ability to pass the container in which the card should expand full screen.
 *   At the moment, it is difficult to reuse the animation that is bound to the host component.
 *   Also the full screen behaviour should be extracted into a separate directive.
 *   So for that reason and to avoid breaking changes until a refactor is done, the animation state has been
 *   duplicated into 'fullsizeFS' and 'collapsedFS'. This animation is very basic.
 */
class CardComponent {
    get isDisabled() {
        return this.disabled;
    }
    get hasAltContent() {
        return this._hasAlt;
    }
    get collapseAnim() {
        return {
            value: this._animState,
            params: {
                offSetToParent: this._offsetParentTop + 'px',
                offSetToBottom: this._offsetParentBottom + 'px',
            },
        };
    }
    animationDone(event) {
        if (!this.hasAltContent || event.fromState === 'void') {
            return;
        }
        if (event.toState === 'fullsize' || event.toState === 'fullsizeFS') {
            this.renderer.addClass(this.elementRef.nativeElement, 'fullsize');
            this.renderer.addClass(this.footer.nativeElement, 'fullsize');
            this.renderer.addClass(this.header.nativeElement, 'fullsize');
            this.renderer.addClass(this.content.nativeElement, 'fullsize');
            this.renderer.addClass(this.altContent.nativeElement, 'fullsize');
            this.renderer.addClass(this.toggleFullSize.nativeElement, 'fullsize');
            this.renderer.addClass(this.toggleCollapse.nativeElement, 'fullsize');
            if (event.toState === 'fullsizeFS') {
                const rect = this.fullScreenContainer.getBoundingClientRect();
                this.renderer.setStyle(this.fullScreenContainer, 'overflow', `hidden`);
                this.renderer.setStyle(this.elementRef.nativeElement, 'position', `fixed`);
                this.renderer.setStyle(this.elementRef.nativeElement, 'top', `${rect.top}px`);
                this.renderer.setStyle(this.elementRef.nativeElement, 'left', `${rect.left}px`);
                this.renderer.setStyle(this.elementRef.nativeElement, 'width', `${rect.width}px`);
                this.renderer.setStyle(this.elementRef.nativeElement, 'height', `${rect.height}px`);
            }
            this.expanded.emit();
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement, 'fullsize');
            this.renderer.removeClass(this.header.nativeElement, 'fullsize');
            this.renderer.removeClass(this.footer.nativeElement, 'fullsize');
            this.renderer.removeClass(this.content.nativeElement, 'fullsize');
            this.renderer.removeClass(this.altContent.nativeElement, 'fullsize');
            this.renderer.removeClass(this.toggleFullSize.nativeElement, 'fullsize');
            this.renderer.removeClass(this.toggleCollapse.nativeElement, 'fullsize');
            if (event.toState === 'collapsedFS') {
                this.renderer.removeStyle(this.elementRef.nativeElement, 'position');
                this.renderer.removeStyle(this.elementRef.nativeElement, 'top');
                this.renderer.removeStyle(this.elementRef.nativeElement, 'left');
                this.renderer.removeStyle(this.elementRef.nativeElement, 'width');
                this.renderer.removeStyle(this.elementRef.nativeElement, 'height');
                this.renderer.setStyle(this.fullScreenContainer, 'overflow', 'unset');
            }
            this.collapsed.emit();
        }
    }
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        /**
         * to determine if the card should close
         * i.e if the alt content is an invalid form
         */
        this.canClose = true;
        /**
         * Emitted when the component is expanded to show the alt-content.
         * this occurs when the animation is complete.
         */
        this.expanded = new EventEmitter();
        /**
         * Emitted when the component is collapsed back to its initial state.
         * this occurs when the animation is complete.
         */
        this.collapsed = new EventEmitter();
        /**
         * Dispatched when one of the cards actions is clicked.
         */
        this.cardActionClicked = new EventEmitter();
        /**
         * @ignore
         */
        this.buttonComponents = [];
        this._animState = 'collapsed';
        this._offsetParentTop = 0;
        this._offsetParentBottom = 0;
        /**
         * used to resolve if this card has alt-content to activate
         * the collapse / fullsize icons
         *
         * @ignore
         */
        this._hasAlt = false;
    }
    /**
     * expands the component to fullsize.
     */
    expand() {
        if (this.hasAltContent) {
            if (this.fullScreenContainer) {
                this._animState = 'fullsizeFS';
            }
            else {
                this._animState = 'fullsize';
            }
        }
    }
    /**
     * collapse the component to regular size.
     */
    collapse() {
        if (this.canClose) {
            if (this.fullScreenContainer) {
                this._animState = 'collapsedFS';
            }
            else {
                this._animState = 'collapsed';
            }
        }
    }
    ngOnChanges({ disabled, fullScreenContainer }) {
        if (fullScreenContainer) {
            this._animState = fullScreenContainer.currentValue ? 'collapsedFS' : 'collapsed';
        }
        const nDisabled = disabled && disabled.currentValue !== undefined ? disabled.currentValue : false;
        this.refreshButtonStyles(nDisabled);
    }
    ngAfterContentInit() {
        this.buttonComponents = this.buttonComponentQL.toArray();
    }
    ngAfterViewInit() {
        this._hasAlt = this.altContent && this.altContent.nativeElement.children && this.altContent.nativeElement.children.length > 0;
        const hostElem = this.elementRef.nativeElement;
        // todo de-crapify this
        const parentCBR = hostElem.parentNode.getBoundingClientRect();
        const cardCBR = hostElem.getBoundingClientRect();
        this._offsetParentTop = cardCBR.top - parentCBR.top;
        this._offsetParentBottom = parentCBR.bottom - cardCBR.bottom;
    }
    refreshButtonStyles(disabled = false) {
        const btnsModified = this.buttonComponents.map((btn) => {
            const nBtn = Object.assign({}, btn);
            nBtn.disabled = disabled;
            return nBtn;
        });
        this.buttonComponents = btnsModified;
    }
    onCardActionClicked(btn) {
        this.cardActionClicked.emit({
            id: btn.id,
            target: btn,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CardComponent, selector: "avn-card", inputs: { title: "title", subTitle: "subTitle", disabled: "disabled", icon: "icon", fullScreenContainer: "fullScreenContainer", canClose: "canClose" }, outputs: { expanded: "expanded", collapsed: "collapsed", cardActionClicked: "cardActionClicked" }, host: { listeners: { "@collapse.done": "animationDone($event)" }, properties: { "class.disabled": "this.isDisabled", "@collapse": "this.collapseAnim" } }, queries: [{ propertyName: "buttonComponentQL", predicate: ButtonComponent }], viewQueries: [{ propertyName: "header", first: true, predicate: ["cardHeader"], descendants: true }, { propertyName: "footer", first: true, predicate: ["cardFooter"], descendants: true }, { propertyName: "content", first: true, predicate: ["cardContent"], descendants: true }, { propertyName: "altContent", first: true, predicate: ["cardAltContent"], descendants: true }, { propertyName: "toggleFullSize", first: true, predicate: ["toggleFullSize"], descendants: true, read: ElementRef }, { propertyName: "toggleCollapse", first: true, predicate: ["toggleCollapse"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: "<header #cardHeader>\n  <avn-avatar *ngIf=\"icon\" [icon]=\"icon\" [ngClass]=\"{ disabled: disabled }\"></avn-avatar>\n  <div class=\"header-text\">\n    <h6>{{ title }}</h6>\n    <p *ngIf=\"subTitle !== undefined\">{{ subTitle }}</p>\n  </div>\n  <div *ngIf=\"hasAltContent\" class=\"toggle-alt-content\">\n    <avn-icon #toggleFullSize class=\"toggle-fullsize\" (click)=\"expand()\" icon=\"hardware:keyboard_arrow_down\"></avn-icon>\n    <avn-icon #toggleCollapse class=\"toggle-collapse\" [class.no-click]=\"canClose === false\" (click)=\"collapse()\" icon=\"hardware:keyboard_arrow_up\"></avn-icon>\n  </div>\n</header>\n\n<div #cardContent class=\"card-content\" [avnHasChildClass]=\"'avn-card-content'\" avnScroll>\n  <ng-content select=\"avn-card-content\"></ng-content>\n</div>\n\n<div #cardAltContent [avnHasChildClass]=\"'avn-alt-content'\" class=\"alt-content\" avnScroll>\n  <ng-content select=\"avn-card-alternate-content\"></ng-content>\n</div>\n\n<footer #cardFooter class=\"card-actions\" [avnHasChildClass]=\"'avn-card-actions'\">\n  <avn-button\n    *ngFor=\"let btn of buttonComponents\"\n    [id]=\"btn.id\"\n    [label]=\"btn.label\"\n    [disabled]=\"disabled\"\n    [icon]=\"btn.icon\"\n    [size]=\"btn.size\"\n    (click)=\"onCardActionClicked(btn)\"\n  >\n  </avn-button>\n</footer>\n", styles: [":host{display:flex;min-width:220px;position:relative;flex-direction:column;justify-content:flex-start;align-content:flex-start;padding:0;border-radius:.2rem;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);background-color:var(--surface-background);color:var(-surface-on);border:1px solid var(--surface-border)}:host.theme-primary>header>avn-avatar{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>header>avn-avatar{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>header>avn-avatar{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>header>avn-avatar{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>header>avn-avatar{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>header>avn-avatar{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>header>avn-avatar{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--success-base);color:var(--success-on)}:host:hover,:host:focus{box-shadow:0 -1px 0 -2px #00000040,0 2px 2px #0003,0 1px 5px #0000002b!important}:host.disabled{opacity:.3;cursor:no-drop}:host.disabled .avn-card-actions>::ng-deep avn-button>button{cursor:no-drop}:host .alt-content{flex-grow:3;padding:var(--space-sm) var(--space-md);opacity:0;height:0px;border:none}:host .alt-content.fullsize{opacity:1}:host header{display:flex;flex-direction:row;padding:var(--space-sm) var(--space-md)}:host header avn-avatar.disabled{opacity:.3}:host header .header-text{display:flex;flex-grow:2;flex-direction:column;justify-content:center;align-items:flex-start}:host header .header-text h6{text-transform:capitalize}:host header .header-text h6,:host header .header-text p{margin:0}:host header .toggle-alt-content{min-width:40px;display:flex;justify-content:flex-end;align-items:center}:host header .toggle-alt-content avn-icon.toggle-fullsize{opacity:1;display:block;cursor:pointer}:host header .toggle-alt-content avn-icon.toggle-fullsize.fullsize{display:none;opacity:0}:host header .toggle-alt-content avn-icon.toggle-collapse{opacity:0;display:none}:host header .toggle-alt-content avn-icon.toggle-collapse.fullsize{cursor:pointer;display:block;opacity:1}:host header .toggle-alt-content avn-icon.toggle-collapse.fullsize.no-click{opacity:.5;cursor:no-drop}:host header.fullsize{padding:var(--space-sm) var(--space-base)}:host .avn-card-content{flex-grow:1;padding:var(--space-md) var(--space-md) 0 var(--space-md);border-top:1px solid rgba(0,0,0,.2);margin:var(--space-md) 0 0 0}:host .avn-card-content.fullsize{height:0;opacity:0;overflow:hidden;display:none}:host .avn-alt-content{padding:var(--space-md) var(--space-md) 0 var(--space-md);border-top:1px solid rgba(0,0,0,.2);margin-top:var(--space-md);opacity:0;display:none}:host .avn-alt-content.fullsize{display:block}:host .avn-card-actions{padding:var(--space-md);border-top:1px solid rgba(0,0,0,.2)}:host .avn-card-actions>::ng-deep avn-button:not(:last-child){margin-right:var(--space-sm)}:host footer.fullsize{display:none;opacity:0;height:0px}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: HasChildClassDirective, selector: "[avnHasChildClass]", inputs: ["avnHasChildClass"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "component", type: AvatarComponent, selector: "avn-avatar", inputs: ["icon", "label"] }], animations: [
            trigger('collapse', [
                state('fullsize', style({
                    position: 'absolute',
                    top: '0px',
                    bottom: '0px',
                    left: '0px',
                    right: '0px',
                    boxShadow: 'none',
                    zIndex: 100,
                    margin: 0,
                    padding: '5px 0',
                })),
                state('collapsed', style({
                    position: 'relative',
                })),
                state('fullsizeFS', style({
                    position: 'fixed',
                    boxShadow: 'none',
                    zIndex: 100,
                    margin: 0,
                    padding: '5px 0',
                })),
                state('collapsedFS', style({
                    position: 'relative',
                })),
                transition('* => fullsize', sequence([
                    group([
                        query(':self', [
                            style({
                                position: 'absolute',
                                left: '5px',
                                right: '5px',
                                top: '{{offSetToParent}}',
                                bottom: '{{offSetToBottom}}',
                                boxShadow: '*',
                                zIndex: 1,
                                margin: '0',
                                padding: '5px',
                            }),
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                left: '0px',
                                right: '0px',
                                boxShadow: 'none',
                                top: '0px',
                                bottom: '0px',
                            })),
                        ]),
                        query('footer', [
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                opacity: 0,
                                height: '0px',
                            })),
                        ]),
                        query('.card-content', [
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                opacity: 0,
                                height: '0px',
                            })),
                        ], { optional: true }),
                        query('.toggle-fullsize', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(180deg)' }))], { optional: true }),
                    ]),
                ])),
                transition('fullsize => collapsed', sequence([
                    group([
                        query('.toggle-collapse', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(-180deg)' }))], { optional: true }),
                        query('footer', [
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                opacity: 1,
                                height: '*',
                            })),
                        ]),
                        query(':self', [
                            style({
                                left: '0px',
                                right: '0px',
                                boxShadow: 'none',
                                top: '0px',
                                bottom: '0px',
                                position: 'absolute',
                                padding: '5px',
                            }),
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                top: '{{offSetToParent}}',
                                bottom: '{{offSetToBottom}}',
                                boxShadow: '*',
                                left: '5px',
                                right: '5px',
                                padding: '0px',
                            })),
                        ]),
                    ]),
                ])),
                /*** Full screen container state / transitions **/
                transition('* => fullsizeFS', sequence([
                    group([
                        query('footer', [
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                opacity: 0,
                                height: '0px',
                            })),
                        ]),
                        query('.card-content', [
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                opacity: 0,
                                height: '0px',
                            })),
                        ], { optional: true }),
                        query('.toggle-fullsize', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(180deg)' }))], { optional: true }),
                    ]),
                ])),
                transition('fullsizeFS => collapsedFS', sequence([
                    group([
                        query('.toggle-collapse', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(-180deg)' }))], { optional: true }),
                        query('footer', [
                            animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                opacity: 1,
                                height: '*',
                            })),
                        ]),
                    ]),
                ])),
            ]),
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-card', animations: [
                        trigger('collapse', [
                            state('fullsize', style({
                                position: 'absolute',
                                top: '0px',
                                bottom: '0px',
                                left: '0px',
                                right: '0px',
                                boxShadow: 'none',
                                zIndex: 100,
                                margin: 0,
                                padding: '5px 0',
                            })),
                            state('collapsed', style({
                                position: 'relative',
                            })),
                            state('fullsizeFS', style({
                                position: 'fixed',
                                boxShadow: 'none',
                                zIndex: 100,
                                margin: 0,
                                padding: '5px 0',
                            })),
                            state('collapsedFS', style({
                                position: 'relative',
                            })),
                            transition('* => fullsize', sequence([
                                group([
                                    query(':self', [
                                        style({
                                            position: 'absolute',
                                            left: '5px',
                                            right: '5px',
                                            top: '{{offSetToParent}}',
                                            bottom: '{{offSetToBottom}}',
                                            boxShadow: '*',
                                            zIndex: 1,
                                            margin: '0',
                                            padding: '5px',
                                        }),
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            left: '0px',
                                            right: '0px',
                                            boxShadow: 'none',
                                            top: '0px',
                                            bottom: '0px',
                                        })),
                                    ]),
                                    query('footer', [
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            opacity: 0,
                                            height: '0px',
                                        })),
                                    ]),
                                    query('.card-content', [
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            opacity: 0,
                                            height: '0px',
                                        })),
                                    ], { optional: true }),
                                    query('.toggle-fullsize', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(180deg)' }))], { optional: true }),
                                ]),
                            ])),
                            transition('fullsize => collapsed', sequence([
                                group([
                                    query('.toggle-collapse', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(-180deg)' }))], { optional: true }),
                                    query('footer', [
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            opacity: 1,
                                            height: '*',
                                        })),
                                    ]),
                                    query(':self', [
                                        style({
                                            left: '0px',
                                            right: '0px',
                                            boxShadow: 'none',
                                            top: '0px',
                                            bottom: '0px',
                                            position: 'absolute',
                                            padding: '5px',
                                        }),
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            top: '{{offSetToParent}}',
                                            bottom: '{{offSetToBottom}}',
                                            boxShadow: '*',
                                            left: '5px',
                                            right: '5px',
                                            padding: '0px',
                                        })),
                                    ]),
                                ]),
                            ])),
                            /*** Full screen container state / transitions **/
                            transition('* => fullsizeFS', sequence([
                                group([
                                    query('footer', [
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            opacity: 0,
                                            height: '0px',
                                        })),
                                    ]),
                                    query('.card-content', [
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            opacity: 0,
                                            height: '0px',
                                        })),
                                    ], { optional: true }),
                                    query('.toggle-fullsize', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(180deg)' }))], { optional: true }),
                                ]),
                            ])),
                            transition('fullsizeFS => collapsedFS', sequence([
                                group([
                                    query('.toggle-collapse', [animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({ transform: 'rotate(-180deg)' }))], { optional: true }),
                                    query('footer', [
                                        animate(`${ANIM_SPEED} cubic-bezier(0.25, 0.8, 0.25, 1)`, style({
                                            opacity: 1,
                                            height: '*',
                                        })),
                                    ]),
                                ]),
                            ])),
                        ]),
                    ], template: "<header #cardHeader>\n  <avn-avatar *ngIf=\"icon\" [icon]=\"icon\" [ngClass]=\"{ disabled: disabled }\"></avn-avatar>\n  <div class=\"header-text\">\n    <h6>{{ title }}</h6>\n    <p *ngIf=\"subTitle !== undefined\">{{ subTitle }}</p>\n  </div>\n  <div *ngIf=\"hasAltContent\" class=\"toggle-alt-content\">\n    <avn-icon #toggleFullSize class=\"toggle-fullsize\" (click)=\"expand()\" icon=\"hardware:keyboard_arrow_down\"></avn-icon>\n    <avn-icon #toggleCollapse class=\"toggle-collapse\" [class.no-click]=\"canClose === false\" (click)=\"collapse()\" icon=\"hardware:keyboard_arrow_up\"></avn-icon>\n  </div>\n</header>\n\n<div #cardContent class=\"card-content\" [avnHasChildClass]=\"'avn-card-content'\" avnScroll>\n  <ng-content select=\"avn-card-content\"></ng-content>\n</div>\n\n<div #cardAltContent [avnHasChildClass]=\"'avn-alt-content'\" class=\"alt-content\" avnScroll>\n  <ng-content select=\"avn-card-alternate-content\"></ng-content>\n</div>\n\n<footer #cardFooter class=\"card-actions\" [avnHasChildClass]=\"'avn-card-actions'\">\n  <avn-button\n    *ngFor=\"let btn of buttonComponents\"\n    [id]=\"btn.id\"\n    [label]=\"btn.label\"\n    [disabled]=\"disabled\"\n    [icon]=\"btn.icon\"\n    [size]=\"btn.size\"\n    (click)=\"onCardActionClicked(btn)\"\n  >\n  </avn-button>\n</footer>\n", styles: [":host{display:flex;min-width:220px;position:relative;flex-direction:column;justify-content:flex-start;align-content:flex-start;padding:0;border-radius:.2rem;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);background-color:var(--surface-background);color:var(-surface-on);border:1px solid var(--surface-border)}:host.theme-primary>header>avn-avatar{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>header>avn-avatar{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>header>avn-avatar{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>header>avn-avatar{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>header>avn-avatar{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>header>avn-avatar{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>header>avn-avatar{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>.avn-card-actions>::ng-deep avn-button>button{background-color:var(--success-base);color:var(--success-on)}:host:hover,:host:focus{box-shadow:0 -1px 0 -2px #00000040,0 2px 2px #0003,0 1px 5px #0000002b!important}:host.disabled{opacity:.3;cursor:no-drop}:host.disabled .avn-card-actions>::ng-deep avn-button>button{cursor:no-drop}:host .alt-content{flex-grow:3;padding:var(--space-sm) var(--space-md);opacity:0;height:0px;border:none}:host .alt-content.fullsize{opacity:1}:host header{display:flex;flex-direction:row;padding:var(--space-sm) var(--space-md)}:host header avn-avatar.disabled{opacity:.3}:host header .header-text{display:flex;flex-grow:2;flex-direction:column;justify-content:center;align-items:flex-start}:host header .header-text h6{text-transform:capitalize}:host header .header-text h6,:host header .header-text p{margin:0}:host header .toggle-alt-content{min-width:40px;display:flex;justify-content:flex-end;align-items:center}:host header .toggle-alt-content avn-icon.toggle-fullsize{opacity:1;display:block;cursor:pointer}:host header .toggle-alt-content avn-icon.toggle-fullsize.fullsize{display:none;opacity:0}:host header .toggle-alt-content avn-icon.toggle-collapse{opacity:0;display:none}:host header .toggle-alt-content avn-icon.toggle-collapse.fullsize{cursor:pointer;display:block;opacity:1}:host header .toggle-alt-content avn-icon.toggle-collapse.fullsize.no-click{opacity:.5;cursor:no-drop}:host header.fullsize{padding:var(--space-sm) var(--space-base)}:host .avn-card-content{flex-grow:1;padding:var(--space-md) var(--space-md) 0 var(--space-md);border-top:1px solid rgba(0,0,0,.2);margin:var(--space-md) 0 0 0}:host .avn-card-content.fullsize{height:0;opacity:0;overflow:hidden;display:none}:host .avn-alt-content{padding:var(--space-md) var(--space-md) 0 var(--space-md);border-top:1px solid rgba(0,0,0,.2);margin-top:var(--space-md);opacity:0;display:none}:host .avn-alt-content.fullsize{display:block}:host .avn-card-actions{padding:var(--space-md);border-top:1px solid rgba(0,0,0,.2)}:host .avn-card-actions>::ng-deep avn-button:not(:last-child){margin-right:var(--space-sm)}:host footer.fullsize{display:none;opacity:0;height:0px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { title: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], disabled: [{
                type: Input
            }], icon: [{
                type: Input
            }], fullScreenContainer: [{
                type: Input
            }], canClose: [{
                type: Input
            }], expanded: [{
                type: Output
            }], collapsed: [{
                type: Output
            }], cardActionClicked: [{
                type: Output
            }], buttonComponentQL: [{
                type: ContentChildren,
                args: [ButtonComponent]
            }], header: [{
                type: ViewChild,
                args: ['cardHeader', { static: false }]
            }], footer: [{
                type: ViewChild,
                args: ['cardFooter', { static: false }]
            }], content: [{
                type: ViewChild,
                args: ['cardContent', { static: false }]
            }], altContent: [{
                type: ViewChild,
                args: ['cardAltContent', { static: false }]
            }], toggleFullSize: [{
                type: ViewChild,
                args: ['toggleFullSize', { read: ElementRef, static: false }]
            }], toggleCollapse: [{
                type: ViewChild,
                args: ['toggleCollapse', { read: ElementRef, static: false }]
            }], isDisabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }], collapseAnim: [{
                type: HostBinding,
                args: ['@collapse']
            }], animationDone: [{
                type: HostListener,
                args: ['@collapse.done', ['$event']]
            }] } });

class CardModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: CardModule, declarations: [CardComponent, CardContentComponent, CardAlternateContentComponent], imports: [CommonModule, CoreModule, IconModule, ButtonModule, AvatarModule], exports: [CardComponent, CardContentComponent, CardAlternateContentComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardModule, imports: [CommonModule, CoreModule, IconModule, ButtonModule, AvatarModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, ButtonModule, AvatarModule],
                    declarations: [CardComponent, CardContentComponent, CardAlternateContentComponent],
                    exports: [CardComponent, CardContentComponent, CardAlternateContentComponent],
                }]
        }] });

/**
 * The avn-dropdown wraps content that is shown when a avnDropdownTrigger is clicked.
 */
class DropdownComponent {
    constructor(elementRef, _changeDetector, _themeAspect) {
        this.elementRef = elementRef;
        this._changeDetector = _changeDetector;
        this._themeAspect = _themeAspect;
        /**
         * Should the generated drop down be closed when its content is clicked.
         */
        this.closeOnClick = true;
        /**
         * @ignore
         */
        this._xPosition = 'before';
        /**
         * @ignore
         */
        this._yPosition = 'below';
        this._dimensions = {
            bindWidthToTrigger: false,
            minWidth: 200,
        };
        /**
         * @ignore
         */
        this.classList = {};
        /**
         * dispatched when the dropdown is closed.
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        /**
         * Animations
         *
         * @ignore
         */
        this.dropdownAnimState = 'close';
        /**
         * @ignore since this is internal we use subject.
         * used by the trigger directive
         */
        this.animationComplete = new Subject();
    }
    /**
     * The position of the dropdown component relative to the trigger.
     */
    get xPosition() {
        return this._xPosition;
    }
    set xPosition(value) {
        if (value !== 'before' && value !== 'after') {
            throw new Error('invalid value for xPosition should be before or after.');
        }
        this._xPosition = value;
        this.positionDropdown();
    }
    /**
     * The position of the dropdown component relative to the trigger.
     */
    get yPosition() {
        return this._yPosition;
    }
    set yPosition(value) {
        if (value !== 'above' && value !== 'below') {
            throw new Error('invalid value for  yPosition should be above or below.');
        }
        this._yPosition = value;
        this.positionDropdown();
    }
    /**
     * Additional classes to render on the dropdown element when rendered.
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set aditionalClasses(classes) {
        if (classes && classes.length) {
            this.classList = classes.split(' ').reduce((obj, className) => {
                obj[className] = true;
                return obj;
            }, {});
        }
        if (this._themeAspect) {
            this.classList[this._themeAspect] = true;
        }
    }
    /**
     * specifies a width and minWidth on the generated dropdown.
     * minWidth ensures a minimum width should the trigger element not be wide enough.
     * only applies when we bind the width to the trigger element.
     */
    get dimensions() {
        return this._dimensions;
    }
    set dimensions(value) {
        if (!value || typeof value.bindWidthToTrigger !== 'boolean' || typeof value.minWidth !== 'number') {
            throw new Error('dimensions are incorrect. make sure bindWidthToTrigger is a boolean and minWidth is a number.');
        }
        this._dimensions = value;
    }
    positionDropdown(posX = this.xPosition, posY = this.yPosition) {
        const classes = this.classList;
        classes['dropdown-before'] = posX === 'before';
        classes['dropdown-after'] = posX === 'after';
        classes['dropdown-above'] = posY === 'above';
        classes['dropdown-below'] = posY === 'below';
    }
    /**
     * @ignore
     * used internally when animations complete
     */
    onAnimationDone(event) {
        this.animationComplete.next(event);
        this.isAnimating = false;
    }
    startAnimation() {
        this.dropdownAnimState = 'enter';
        this._changeDetector.detectChanges();
    }
    resetAnimation() {
        this.dropdownAnimState = 'close';
        this._changeDetector.detectChanges();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DropdownComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: THEME_ASPECT, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DropdownComponent, selector: "avn-dropdown", inputs: { closeOnClick: "closeOnClick", xPosition: "xPosition", yPosition: "yPosition", aditionalClasses: ["class", "aditionalClasses"], dimensions: "dimensions" }, outputs: { close: "close" }, viewQueries: [{ propertyName: "templateRef", first: true, predicate: ["avnDropdown"], descendants: true }], ngImport: i0, template: "<ng-template #avnDropdown>\n  <div\n    class=\"avn-dropdown-container\"\n    [ngClass]=\"classList\"\n    role=\"menu\"\n    [@revealDropdown]=\"dropdownAnimState\"\n    (@revealDropdown.start)=\"isAnimating = true\"\n    (@revealDropdown.done)=\"onAnimationDone($event)\"\n  >\n    <div class=\"avn-dropdown-content\">\n      <ng-content> </ng-content>\n    </div>\n  </div>\n</ng-template>\n", styles: [".avn-dropdown-container{border-radius:.25rem;min-width:100px;width:100%;max-height:80vh;overflow:auto;box-shadow:0 1px 1px 1px #0003}.avn-dropdown-container:hover{box-shadow:0 1px 1px 1px #0003}.avn-dropdown-container.menu-dropdown{width:100%;border-top-left-radius:0;border-top-right-radius:0;padding:10px 0;box-shadow:0 1px 1px 1px #0003;background-color:var(--topnav-background);color:var(--topnav-on)}.avn-dropdown-container.menu-dropdown.dmb-aspect{padding:var(--space-sm);border-top:1px solid var(--modal-surface-background)}.avn-dropdown-container.menu-dropdown.dmb-aspect ::ng-deep hr{margin:var(--space-xs) 0}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], animations: [dropdownAnimations.revealDropdown], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dropdown', animations: [dropdownAnimations.revealDropdown], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #avnDropdown>\n  <div\n    class=\"avn-dropdown-container\"\n    [ngClass]=\"classList\"\n    role=\"menu\"\n    [@revealDropdown]=\"dropdownAnimState\"\n    (@revealDropdown.start)=\"isAnimating = true\"\n    (@revealDropdown.done)=\"onAnimationDone($event)\"\n  >\n    <div class=\"avn-dropdown-content\">\n      <ng-content> </ng-content>\n    </div>\n  </div>\n</ng-template>\n", styles: [".avn-dropdown-container{border-radius:.25rem;min-width:100px;width:100%;max-height:80vh;overflow:auto;box-shadow:0 1px 1px 1px #0003}.avn-dropdown-container:hover{box-shadow:0 1px 1px 1px #0003}.avn-dropdown-container.menu-dropdown{width:100%;border-top-left-radius:0;border-top-right-radius:0;padding:10px 0;box-shadow:0 1px 1px 1px #0003;background-color:var(--topnav-background);color:var(--topnav-on)}.avn-dropdown-container.menu-dropdown.dmb-aspect{padding:var(--space-sm);border-top:1px solid var(--modal-surface-background)}.avn-dropdown-container.menu-dropdown.dmb-aspect ::ng-deep hr{margin:var(--space-xs) 0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: ThemeAspect, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [THEME_ASPECT]
                }] }]; }, propDecorators: { closeOnClick: [{
                type: Input
            }], templateRef: [{
                type: ViewChild,
                args: ['avnDropdown', { static: false }]
            }], xPosition: [{
                type: Input
            }], yPosition: [{
                type: Input
            }], aditionalClasses: [{
                type: Input,
                args: ['class']
            }], dimensions: [{
                type: Input
            }], close: [{
                type: Output
            }] } });

/**
 * The dropdown trigger converts an element into a toggle that shows a avn-dropdown.
 */
class DropdownTriggerDirective {
    constructor(triggerElement, viewContainerRef, overlay, elementRef, renderer) {
        this.triggerElement = triggerElement;
        this.viewContainerRef = viewContainerRef;
        this.overlay = overlay;
        this.elementRef = elementRef;
        this.renderer = renderer;
        /**
         * enable or disable the dropdown
         */
        this.avnDropdownEnabled = true;
        /**
         * when the dropdown is opened
         */
        this.avnDropdownOpened = new EventEmitter();
        this.overlayRef = null;
        this.dropdownOpen = false;
        this.componentDestroyed$ = new Subject();
    }
    onclick() {
        this.openDropdown();
    }
    openDropdown() {
        if (!this.avnDropdownTrigger) {
            throw new Error('avnDropdownTrigger needs to be specified.');
        }
        if (this.dropdownOpen || !this.avnDropdownEnabled) {
            return;
        }
        const overlayRef = this.createOverlay();
        this.setPosition(overlayRef.getConfig().positionStrategy);
        overlayRef.attach(this.portal);
        this.closeSubscription = this.dropdownClosingStream()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => this.closeMenu());
        this.avnDropdownTrigger.startAnimation();
        this.dropdownOpen = true;
        this.avnDropdownOpened.emit(true);
        this.avnDropdownTrigger.positionDropdown();
    }
    ngAfterContentInit() {
        this.closeSubscription = this.avnDropdownTrigger.close.pipe(takeUntil(this.componentDestroyed$)).subscribe((_) => {
            this.destroyDropdown();
        });
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
        // make sure to destroy the dropdown if its opened when the component is destroyed
        if (this.dropdownOpen) {
            this.onDropdownClosed();
        }
    }
    /**
     * This method builds the configuration object needed to create the overlay, the OverlayState.
     *
     * @ignore
     */
    getOverlayConfig() {
        const cfg = {};
        if (this.avnDropdownTrigger.dimensions.bindWidthToTrigger) {
            cfg['width'] =
                this.elementRef.nativeElement.clientWidth > this.avnDropdownTrigger.dimensions.minWidth
                    ? this.elementRef.nativeElement.clientWidth
                    : this.avnDropdownTrigger.dimensions.minWidth;
        }
        Object.assign(cfg, {
            positionStrategy: this.overlay.position().flexibleConnectedTo(this.triggerElement).withTransformOriginOn('.avn-dropdown-container'),
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            disposeOnNavigation: true,
        });
        return new OverlayConfig(cfg);
    }
    /**
     * @ignore
     * Closes the menu.
     **/
    closeMenu() {
        this.avnDropdownTrigger.close.emit();
    }
    /**
     * @ignore
     */
    destroyDropdown() {
        if (!this.overlayRef || !this.dropdownOpen) {
            return;
        }
        const dDown = this.avnDropdownTrigger;
        dDown.resetAnimation();
        dDown.animationComplete
            .pipe(filter((evt) => evt.toState === 'close'), take(1), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.onDropdownClosed();
        });
    }
    /**
     * @ignore
     * when the dropdown is closed
     */
    onDropdownClosed() {
        this.closeSubscription.unsubscribe();
        this.overlayRef.detach();
        this.dropdownOpen = false;
        this.avnDropdownOpened.emit(false);
    }
    /**
     * @ignore
     * creates a stream of outside clicks or keypresses that should close the menu.
     */
    dropdownClosingStream() {
        const rupertEsc = this.overlayRef.keydownEvents().pipe(
        // todo ignore lint warning until https://github.com/angular/material2/issues/7374 is
        // resolved.
        filter((evt) => evt.keyCode === ESCAPE), map((_) => 'keyboard'));
        const tab = this.overlayRef.keydownEvents().pipe(filter((evt) => evt.keyCode === TAB), map((_) => 'keyboard'));
        const clickOut = this.overlayRef.backdropClick().pipe(map((_) => 'click'));
        const detatch = this.overlayRef.detachments().pipe(map((_) => 'detached'));
        let clickStream = merge(rupertEsc, tab, clickOut, detatch);
        if (this.avnDropdownTrigger.closeOnClick) {
            clickStream = merge(clickStream, fromEvent(this.overlayRef.overlayElement, 'click').pipe(map((_) => 'click')));
        }
        return clickStream;
    }
    /**
     * @ignore
     */
    createOverlay() {
        this.portal = new TemplatePortal(this.avnDropdownTrigger.templateRef, this.viewContainerRef);
        const config = this.getOverlayConfig();
        this.setPositionStreams(config.positionStrategy);
        this.overlayRef = this.overlay.create(config);
        return this.overlayRef;
    }
    /**
     * Listens to changes in the position of the overlay and sets the correct classes
     * on the menu based on the new position. This ensures the animation origin is always
     * correct, even if a fallback position is used for the overlay.
     */
    setPositionStreams(position) {
        position.positionChanges.subscribe((change) => {
            const posX = change.connectionPair.overlayX === 'start' ? 'after' : 'before';
            const posY = change.connectionPair.overlayY === 'top' ? 'below' : 'above';
            this.avnDropdownTrigger.positionDropdown(posX, posY);
        });
    }
    /**
     * @ignore
     */
    setPosition(positionStrategy) {
        const [originX, originFallbackX] = this.avnDropdownTrigger.xPosition === 'before' ? ['end', 'start'] : ['start', 'end'];
        const [overlayY, overlayFallbackY] = this.avnDropdownTrigger.yPosition === 'above' ? ['bottom', 'top'] : ['top', 'bottom'];
        const [originY, originFallbackY] = [overlayY, overlayFallbackY];
        const [overlayX, overlayFallbackX] = [originX, originFallbackX];
        const offsetY = 0 + this.triggerElement.nativeElement.clientHeight;
        positionStrategy.withPositions([
            { originX, originY, overlayX, overlayY, offsetY },
            {
                originX: originFallbackX,
                originY,
                overlayX: overlayFallbackX,
                overlayY,
                offsetY,
            },
            {
                originX,
                originY: originFallbackY,
                overlayX,
                overlayY: overlayFallbackY,
                offsetY: -offsetY,
            },
            {
                originX: originFallbackX,
                originY: originFallbackY,
                overlayX: overlayFallbackX,
                overlayY: overlayFallbackY,
                offsetY: -offsetY,
            },
        ]);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DropdownTriggerDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i1$4.Overlay }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: DropdownTriggerDirective, selector: "[avnDropdownTrigger]", inputs: { avnDropdownTrigger: "avnDropdownTrigger", avnDropdownEnabled: "avnDropdownEnabled" }, outputs: { avnDropdownOpened: "avnDropdownOpened" }, host: { listeners: { "click": "onclick()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DropdownTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnDropdownTrigger]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i1$4.Overlay }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { avnDropdownTrigger: [{
                type: Input
            }], avnDropdownEnabled: [{
                type: Input
            }], avnDropdownOpened: [{
                type: Output
            }], onclick: [{
                type: HostListener,
                args: ['click']
            }] } });

class DropdownModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: DropdownModule, declarations: [DropdownComponent, DropdownTriggerDirective], imports: [CommonModule], exports: [DropdownComponent, DropdownTriggerDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DropdownModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [DropdownComponent, DropdownTriggerDirective],
                    exports: [DropdownComponent, DropdownTriggerDirective],
                }]
        }] });

class FabButtonDirective {
    constructor(button) {
        this.button = button;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabButtonDirective, deps: [{ token: ButtonComponent }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FabButtonDirective, selector: "avn-button[avnFabButton]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'avn-button[avnFabButton]',
                }]
        }], ctorParameters: function () { return [{ type: ButtonComponent }]; } });
class FabToggleDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabToggleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FabToggleDirective, selector: "avn-button[avnFabToggle]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabToggleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'avn-button[avnFabToggle]',
                }]
        }] });
class FabSpeedDialComponent {
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this.opened = false;
        /** Position of the connected overlay containing the buttons, relative to the trigger button */
        this.actionsOverlayPositions = [
            new ConnectionPositionPair({
                originX: 'end',
                originY: 'top',
            }, {
                overlayX: 'end',
                overlayY: 'bottom',
            }, 0, -10),
        ];
        this._componentDestroyed$ = new Subject();
    }
    ngAfterContentInit() {
        this.fabActionButtonsQL.changes
            .pipe(startWith(this.fabActionButtonsQL), switchMap((fabActionButtonsQL) => {
            return merge(...fabActionButtonsQL.toArray().map((directive) => directive.button.actioned));
        }))
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            this.opened = false;
            this._changeDetector.markForCheck();
        });
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabSpeedDialComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: FabSpeedDialComponent, selector: "avn-fab-speed-dial", inputs: { actionsOverlayPositions: "actionsOverlayPositions" }, queries: [{ propertyName: "fabActionButtonsQL", predicate: FabButtonDirective }], ngImport: i0, template: "<div #overlayOriginButton=\"cdkOverlayOrigin\" cdkOverlayOrigin (click)=\"opened = !opened\">\n  <ng-content select=\"avn-button[avnFabToggle]\"></ng-content>\n</div>\n\n<avn-connected-element\n  *ngIf=\"fabActionButtonsQL?.length > 0\"\n  [transparent]=\"true\"\n  [overlayOrigin]=\"overlayOriginButton\"\n  [opened]=\"opened\"\n  [hasOverlayBackdrop]=\"true\"\n  (clickOutside)=\"opened = !opened\"\n  [width]=\"'auto'\"\n  [positions]=\"actionsOverlayPositions\"\n>\n  <div class=\"buttons\" *ngIf=\"opened\"><ng-content select=\"avn-button[avnFabButton]\"></ng-content></div>\n</avn-connected-element>\n", styles: [":host{z-index:999;position:relative;-webkit-user-select:none;user-select:none}:host ::ng-deep avn-button button{overflow:hidden;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f;background-color:revert!important;color:revert!important;border-radius:50px!important}:host ::ng-deep avn-button.icon-only button{width:32px;height:32px}.buttons{display:grid;grid-auto-flow:row;grid-gap:var(--space-md);justify-items:end}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabSpeedDialComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-fab-speed-dial', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #overlayOriginButton=\"cdkOverlayOrigin\" cdkOverlayOrigin (click)=\"opened = !opened\">\n  <ng-content select=\"avn-button[avnFabToggle]\"></ng-content>\n</div>\n\n<avn-connected-element\n  *ngIf=\"fabActionButtonsQL?.length > 0\"\n  [transparent]=\"true\"\n  [overlayOrigin]=\"overlayOriginButton\"\n  [opened]=\"opened\"\n  [hasOverlayBackdrop]=\"true\"\n  (clickOutside)=\"opened = !opened\"\n  [width]=\"'auto'\"\n  [positions]=\"actionsOverlayPositions\"\n>\n  <div class=\"buttons\" *ngIf=\"opened\"><ng-content select=\"avn-button[avnFabButton]\"></ng-content></div>\n</avn-connected-element>\n", styles: [":host{z-index:999;position:relative;-webkit-user-select:none;user-select:none}:host ::ng-deep avn-button button{overflow:hidden;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f;background-color:revert!important;color:revert!important;border-radius:50px!important}:host ::ng-deep avn-button.icon-only button{width:32px;height:32px}.buttons{display:grid;grid-auto-flow:row;grid-gap:var(--space-md);justify-items:end}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { fabActionButtonsQL: [{
                type: ContentChildren,
                args: [FabButtonDirective]
            }], actionsOverlayPositions: [{
                type: Input
            }] } });

class FabSpeedDialModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabSpeedDialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: FabSpeedDialModule, declarations: [FabToggleDirective, FabButtonDirective, FabSpeedDialComponent], imports: [CommonModule, ConnectedElementModule, OverlayModule$1], exports: [FabToggleDirective, FabButtonDirective, FabSpeedDialComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabSpeedDialModule, imports: [CommonModule, ConnectedElementModule, OverlayModule$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FabSpeedDialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ConnectedElementModule, OverlayModule$1],
                    declarations: [FabToggleDirective, FabButtonDirective, FabSpeedDialComponent],
                    exports: [FabToggleDirective, FabButtonDirective, FabSpeedDialComponent],
                }]
        }] });

/**
 * This component can be projected into to the avn-datatable.
 * It consists in an overlay positioned underneath the header that display a clickable notification
 * bar. An event is emitted when the notification is clicked. It can be configured to display a
 * text.
 */
class DataTableNotificationMessageComponent {
    constructor(elementRef, renderer, _changeDetector) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._changeDetector = _changeDetector;
        /** Whether to show the notification message or not */
        this.show = false;
        /** an icon for the action if no action Text is specified */
        this.actionIcon = 'navigation:arrow_upward';
        /** the theme for the action text/action */
        this.actionTheme = ThemeType.INFO;
        /** Emits when the notification message is clicked/actioned */
        this.clicked = new EventEmitter();
        /** Subject that specifies whether the animation is running or not */
        this.animationRunning = new BehaviorSubject(false);
        /** Indicates how the action is triggered (click on the component or the action) */
        this.actionTrigger = 'component';
    }
    /**
     * Default theme for the notification message bar.
     * Add the default theme if none specified via the theming directive
     */
    get shouldApplyDefaultTheme() {
        return (this.elementRef.nativeElement &&
            [...this.elementRef.nativeElement.classList].filter((c) => c.startsWith('theme-') && c !== `theme-${ThemeType.PRIMARY}`).length === 0);
    }
    /** @ignore */
    ngOnInit() {
        if (this.actionTrigger === 'component') {
            this.renderer.addClass(this.elementRef.nativeElement, 'trigger');
        }
        this._updatePosition(this.offsetY);
    }
    /** @ignore */
    ngOnChanges({ offsetY, actionText }) {
        if (offsetY) {
            this._updatePosition(offsetY.currentValue);
        }
        if (actionText) {
            this.actionTrigger = actionText.currentValue ? 'action' : 'component';
        }
    }
    onClick() {
        if (this.actionTrigger === 'component') {
            this.onAction();
        }
    }
    /**
     * Called when the notification message is clicked
     */
    onAction() {
        // only emit the event if the animation is not running (avoid several clicks when notification
        // is disappearing)
        if (!this.animationRunning.getValue()) {
            this.clicked.emit();
        }
    }
    /** @ignore Sets the top position of the component */
    _updatePosition(offsetY) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'top', `${offsetY || 0}px`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableNotificationMessageComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DataTableNotificationMessageComponent, selector: "avn-data-table-notification-message", inputs: { show: "show", text: "text", offsetY: "offsetY", actionText: "actionText", actionIcon: "actionIcon", actionTheme: "actionTheme" }, outputs: { clicked: "clicked" }, host: { listeners: { "click": "onClick()" }, properties: { "class.theme-primary": "this.shouldApplyDefaultTheme", "class.visible": "this.show" } }, viewQueries: [{ propertyName: "notificationContainerElement", first: true, predicate: ["notificationContainerElement"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  #notificationContainerElement\n  class=\"notification-container\"\n  [class.no-action]=\"!actionText && !actionIcon\"\n  [@notificationTrigger]=\"show\"\n  (@notificationTrigger.start)=\"animationRunning.next(true)\"\n  (@notificationTrigger.done)=\"animationRunning.next(false)\"\n>\n  <span class=\"text\" *ngIf=\"text\" [innerHTML]=\"text\"></span>\n  <span class=\"action-text\" *ngIf=\"actionText\" (click)=\"onAction()\" [avnTheme]=\"actionTheme\">{{ actionText }}</span>\n  <avn-icon class=\"action-icon\" *ngIf=\"!actionText && actionIcon\" [icon]=\"actionIcon\" (click)=\"onAction()\" [avnTheme]=\"actionTheme\"></avn-icon>\n</div>\n", styles: [":host{visibility:hidden;position:absolute;display:flex;align-items:center;max-width:80%;min-width:200px;width:-moz-fit-content;width:fit-content;left:50%;transform:translate(-50%);box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f!important}:host.theme-primary>.notification-container{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary>.notification-container:hover{background-color:var(--primary-variant)}:host.theme-secondary>.notification-container{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary>.notification-container:hover{background-color:var(--secondary-variant)}:host.theme-highlight>.notification-container{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight>.notification-container:hover{background-color:var(--highlight-variant)}:host.theme-danger>.notification-container{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger>.notification-container:hover{background-color:var(--danger-variant)}:host.theme-warning>.notification-container{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning>.notification-container:hover{background-color:var(--warning-variant)}:host.theme-info>.notification-container{background-color:var(--info-base);color:var(--info-on)}:host.theme-info>.notification-container:hover{background-color:var(--info-variant)}:host.theme-success>.notification-container{background-color:var(--success-base);color:var(--success-on)}:host.theme-success>.notification-container:hover{background-color:var(--success-variant)}:host.visible{visibility:visible;z-index:5}:host.trigger{cursor:pointer}:host>.notification-container{width:100%;padding:var(--space-md) var(--space-base);font-weight:500;display:flex;align-items:center;justify-content:space-between;border-radius:3px}:host>.notification-container.no-action{justify-content:center}:host>.notification-container>span.action-text{margin-left:var(--space-md);text-transform:uppercase;cursor:pointer}:host>.notification-container>span.action-text.theme-primary{color:var(--primary-base)}:host>.notification-container>span.action-text.theme-secondary{color:var(--secondary-base)}:host>.notification-container>span.action-text.theme-highlight{color:var(--highlight-base)}:host>.notification-container>span.action-text.theme-danger{color:var(--danger-base)}:host>.notification-container>span.action-text.theme-warning{color:var(--warning-base)}:host>.notification-container>span.action-text.theme-info{color:var(--info-base)}:host>.notification-container>span.action-text.theme-success{color:var(--success-base)}:host>.notification-container>avn-icon.action-icon{margin-left:var(--space-md);cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], animations: [
            trigger('notificationTrigger', [
                state('0', style({ opacity: 0, visibility: 'hidden', height: 0 })),
                state('1', style({ opacity: 1, visibility: 'visible', height: '*' })),
                transition('* => 1', [
                    style({ opacity: 0, visibility: 'hidden', height: '0' }),
                    animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, height: '*', visibility: 'visible' })),
                ]),
                transition('1 => 0', [
                    query('span', style({ visibility: 'hidden' })),
                    style({ opacity: 1, transform: 'scale(1)', visibility: 'visible' }),
                    animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 0, transform: 'scale(0.8)', visibility: 'hidden' })),
                ]),
            ]),
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableNotificationMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-data-table-notification-message', animations: [
                        trigger('notificationTrigger', [
                            state('0', style({ opacity: 0, visibility: 'hidden', height: 0 })),
                            state('1', style({ opacity: 1, visibility: 'visible', height: '*' })),
                            transition('* => 1', [
                                style({ opacity: 0, visibility: 'hidden', height: '0' }),
                                animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, height: '*', visibility: 'visible' })),
                            ]),
                            transition('1 => 0', [
                                query('span', style({ visibility: 'hidden' })),
                                style({ opacity: 1, transform: 'scale(1)', visibility: 'visible' }),
                                animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 0, transform: 'scale(0.8)', visibility: 'hidden' })),
                            ]),
                        ]),
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  #notificationContainerElement\n  class=\"notification-container\"\n  [class.no-action]=\"!actionText && !actionIcon\"\n  [@notificationTrigger]=\"show\"\n  (@notificationTrigger.start)=\"animationRunning.next(true)\"\n  (@notificationTrigger.done)=\"animationRunning.next(false)\"\n>\n  <span class=\"text\" *ngIf=\"text\" [innerHTML]=\"text\"></span>\n  <span class=\"action-text\" *ngIf=\"actionText\" (click)=\"onAction()\" [avnTheme]=\"actionTheme\">{{ actionText }}</span>\n  <avn-icon class=\"action-icon\" *ngIf=\"!actionText && actionIcon\" [icon]=\"actionIcon\" (click)=\"onAction()\" [avnTheme]=\"actionTheme\"></avn-icon>\n</div>\n", styles: [":host{visibility:hidden;position:absolute;display:flex;align-items:center;max-width:80%;min-width:200px;width:-moz-fit-content;width:fit-content;left:50%;transform:translate(-50%);box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f!important}:host.theme-primary>.notification-container{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary>.notification-container:hover{background-color:var(--primary-variant)}:host.theme-secondary>.notification-container{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary>.notification-container:hover{background-color:var(--secondary-variant)}:host.theme-highlight>.notification-container{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight>.notification-container:hover{background-color:var(--highlight-variant)}:host.theme-danger>.notification-container{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger>.notification-container:hover{background-color:var(--danger-variant)}:host.theme-warning>.notification-container{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning>.notification-container:hover{background-color:var(--warning-variant)}:host.theme-info>.notification-container{background-color:var(--info-base);color:var(--info-on)}:host.theme-info>.notification-container:hover{background-color:var(--info-variant)}:host.theme-success>.notification-container{background-color:var(--success-base);color:var(--success-on)}:host.theme-success>.notification-container:hover{background-color:var(--success-variant)}:host.visible{visibility:visible;z-index:5}:host.trigger{cursor:pointer}:host>.notification-container{width:100%;padding:var(--space-md) var(--space-base);font-weight:500;display:flex;align-items:center;justify-content:space-between;border-radius:3px}:host>.notification-container.no-action{justify-content:center}:host>.notification-container>span.action-text{margin-left:var(--space-md);text-transform:uppercase;cursor:pointer}:host>.notification-container>span.action-text.theme-primary{color:var(--primary-base)}:host>.notification-container>span.action-text.theme-secondary{color:var(--secondary-base)}:host>.notification-container>span.action-text.theme-highlight{color:var(--highlight-base)}:host>.notification-container>span.action-text.theme-danger{color:var(--danger-base)}:host>.notification-container>span.action-text.theme-warning{color:var(--warning-base)}:host>.notification-container>span.action-text.theme-info{color:var(--info-base)}:host>.notification-container>span.action-text.theme-success{color:var(--success-base)}:host>.notification-container>avn-icon.action-icon{margin-left:var(--space-md);cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { notificationContainerElement: [{
                type: ViewChild,
                args: ['notificationContainerElement', { static: false }]
            }], shouldApplyDefaultTheme: [{
                type: HostBinding,
                args: [`class.theme-${ThemeType.PRIMARY}`]
            }], show: [{
                type: HostBinding,
                args: ['class.visible']
            }, {
                type: Input
            }], text: [{
                type: Input
            }], offsetY: [{
                type: Input
            }], actionText: [{
                type: Input
            }], actionIcon: [{
                type: Input
            }], actionTheme: [{
                type: Input
            }], clicked: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Types of selection modes allowed by the data table
 */
var DataTableSelectionMode;
(function (DataTableSelectionMode) {
    /** Allow selection of multiple rows */
    DataTableSelectionMode["MULTIPLE"] = "multiple";
    /** Allow selection of multiple rows with colors instead of checkbox */
    DataTableSelectionMode["MULTIPLE_COLOR"] = "multiple-color";
    /** Allow selection of a single row */
    DataTableSelectionMode["SINGLE"] = "single";
    /** Allow selection of a single row */
    DataTableSelectionMode["SINGLE_NO_RADIO"] = "single-no-radio";
    /** Do not allow selection of rows */
    DataTableSelectionMode["NONE"] = "none";
})(DataTableSelectionMode || (DataTableSelectionMode = {}));

const MEDIA_BREAKPOINT_INITIAL_STATE = {
    viewportWidthPx: null,
    viewportHeightPx: null,
    breakpoint: null,
};
class MediaBreakpointStore extends ComponentStore {
    get stateSnapshot() {
        return this.get();
    }
    /********************************************************************************************************************
     * EFFECTS
     ********************************************************************************************************************/
    constructor(_breakpointObserver, _mediaBreakpointConfig, _window, zone) {
        super(MEDIA_BREAKPOINT_INITIAL_STATE);
        this._breakpointObserver = _breakpointObserver;
        this._mediaBreakpointConfig = _mediaBreakpointConfig;
        this._window = _window;
        this.zone = zone;
        /********************************************************************************************************************
         * SELECTORS and GETTERS
         ********************************************************************************************************************/
        this.breakpoint$ = this.select((state) => state.breakpoint);
        this.windowSizeChanged$ = this.select(this.select((state) => state.breakpoint), this.select((state) => state.viewportWidthPx), this.select((state) => state.viewportHeightPx), (breakpoint, viewportWidthPx, viewportHeightPx) => ({ breakpoint, viewportWidthPx, viewportHeightPx }));
        /********************************************************************************************************************
         * UPDATERS (aka. reducers)
         ********************************************************************************************************************/
        this.setCurrentBreakpoint = this.updater((state, breakpoint) => ({
            ...state,
            breakpoint,
        }));
        this.setViewportDimensions = this.updater((state, payload) => ({
            ...state,
            ...payload,
        }));
        // make sure the state is ready before calling updaters, otherwise we get a initialisation issue
        const stateReady$ = this.state$.pipe(filterNil(), take(1));
        stateReady$.subscribe(() => this._initResizeListeners());
    }
    _initResizeListeners() {
        // watch the breakpoint changes
        Object.entries(this._mediaBreakpointConfig.breakpoints).forEach(([breakpoint, mediaQuery]) => {
            this._breakpointObserver.observe(mediaQuery).subscribe((state) => {
                if (state.matches) {
                    this.setCurrentBreakpoint(breakpoint);
                    this.setViewportDimensions({ viewportWidthPx: this._window.innerWidth, viewportHeightPx: this._window.innerHeight });
                }
            });
        });
        // listen to window resize for any changes
        this.zone.runOutsideAngular(() => {
            fromEvent(this._window, 'resize')
                .pipe(debounceTime(500), map((evt) => ({
                width: evt.target.innerWidth,
                height: evt.target.innerHeight,
            })), distinctUntilChanged((prev, curr) => prev.width === curr.width && prev.height === curr.height))
                .subscribe(({ width, height }) => {
                this.zone.run(() => {
                    this.setViewportDimensions({ viewportWidthPx: width, viewportHeightPx: height });
                });
            });
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaBreakpointStore, deps: [{ token: i1$7.BreakpointObserver }, { token: MEDIA_BREAKPOINT_CONFIG }, { token: WINDOW }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaBreakpointStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaBreakpointStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$7.BreakpointObserver }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEDIA_BREAKPOINT_CONFIG]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i0.NgZone }]; } });

/** Change event object emitted by RadioComponent and RadioGroupComponent. */
class RadioChangeEvent {
    constructor(
    /** The RadioButton that emits the change event. */
    source, 
    /** The value of the RadioButton. */
    value) {
        this.source = source;
        this.value = value;
    }
}

const RADIO_GROUP_COMPONENT = new InjectionToken('RadioGroupComponent');
// Increasing integer for generating unique ids for radio components.
let nextUniqueId = 0;
class RadioGroupComponent extends FormControlComponent {
    /** Whether the radio group is disabled */
    get disabled() {
        return super.disabled;
    }
    set disabled(value) {
        super.disabled = coerceBooleanProperty(value);
        this.markRadiosForCheck();
    }
    /**
     * Value for the radio-group. Should equal the value of the selected radio button if there is
     * a corresponding radio button with a matching value. If there is not such a corresponding
     * radio button, this value persists to be applied in case a new radio button is added with a
     * matching value.
     */
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (this._value !== newValue) {
            // Set this before proceeding to ensure no circular loop occurs with selection.
            this._value = newValue;
            this.updateSelectedRadioFromValue();
            this.checkSelectedRadioButton();
        }
    }
    /**
     * Name of the radio button group. All radio buttons inside this group will use this name.
     */
    get name() {
        super.name = `avn-radio-group-${nextUniqueId++}`;
        return super.name;
    }
    set name(value) {
        super.name = value;
        this.updateRadioButtonNames();
    }
    /**
     * The currently selected radio button. If set to a new radio button, the radio group value
     * will be updated to match the new selected button.
     */
    get selected() {
        return this._selected;
    }
    set selected(selected) {
        this._selected = selected;
        this.value = selected ? selected.value : null;
        this.checkSelectedRadioButton();
    }
    /**
     * @ignore
     */
    constructor(renderer, ngControl, changeDetector) {
        super(ngControl, changeDetector);
        this.renderer = renderer;
        // /** The HTML name attribute applied to radio buttons in this group. */
        // private _name = `avn-radio-group-${nextUniqueId++}`;
        /** Selected value for the radio group. */
        this._value = null;
        /** The currently selected radio button. Should match value. */
        this._selected = null;
        /** Whether the `value` has been set to its initial value. */
        this._isInitialized = false;
        this.isHorizontal = false;
        /**
         * Event emitted when the group value changes.
         * Change events are only emitted when the value changes due to user interaction with
         * a radio button (the same behavior as `<input type-"radio">`).
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        /** pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
    }
    /**
     * This method is called when the forms API to write to the view when programmatic (model -> view)
     * changes are requested
     *
     * @ignore
     */
    updateValue(value) {
        this.value = value;
        this.changeDetector.markForCheck();
    }
    /**
     * Initialize properties once content children are available.
     * This allows us to propagate relevant attributes to associated buttons.
     *
     * @ignore
     */
    ngAfterContentInit() {
        // Mark this component as initialized in AfterContentInit because the initial value can
        // possibly be set by NgModel on MatRadioGroup, and it is possible that the OnInit of the
        // NgModel occurs *after* the OnInit of the MatRadioGroup.
        this._isInitialized = true;
    }
    /**
     * Updates the children radio buttons names
     *
     * @ignore
     */
    updateRadioButtonNames() {
        if (this.radios) {
            this.radios.forEach((radio) => {
                radio.name = this.name;
            });
        }
    }
    /**
     * Dispatch change event with current selection and group value.
     *
     * @ignore
     */
    emitChangeEvent() {
        if (this._isInitialized) {
            this.change.emit(new RadioChangeEvent(this._selected, this._value));
        }
    }
    /**
     * Updates the `selected` radio button from the internal _value state.
     *
     *  @ignore
     */
    updateSelectedRadioFromValue() {
        if (this.radios) {
            this._selected = null;
            this.radios.forEach((radio) => {
                radio.checked = this.value === radio.value;
                if (radio.checked) {
                    this._selected = radio;
                }
            });
        }
    }
    /**
     * Checks the selected radio button
     *
     *  @ignore
     */
    checkSelectedRadioButton() {
        if (this._selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    }
    /**
     * Marks all radio components for check
     *
     *  @ignore
     */
    markRadiosForCheck() {
        if (this.radios) {
            this.radios.forEach((radio) => radio.markForCheck());
        }
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RadioGroupComponent, deps: [{ token: i0.Renderer2 }, { token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RadioGroupComponent, selector: "avn-radio-group", inputs: { isHorizontal: "isHorizontal", disabled: "disabled", value: "value", name: "name", selected: "selected", label: "label" }, outputs: { change: "change" }, host: { properties: { "attr.value": "this.value", "class.selected": "this.selected" } }, providers: [
            { provide: RADIO_GROUP_COMPONENT, useExisting: RadioGroupComponent },
            {
                provide: FormControlComponent,
                useExisting: RadioGroupComponent,
            },
        ], queries: [{ propertyName: "radios", predicate: i0.forwardRef(function () { return RadioComponent; }), descendants: true }], usesInheritance: true, ngImport: i0, template: "<label *ngIf=\"label\" [ngClass]=\"{ disabled: disabled }\" name=\"radio-group\">{{ label }}</label>\n<div [ngClass]=\"{ row: isHorizontal }\">\n  <ng-content select=\"avn-radio\"></ng-content>\n</div>\n", styles: [":host{display:block;position:relative}:host ::ng-deep avn-radio:not(:last-child){margin-bottom:var(--space-base)}:host .row{width:100%;display:flex;flex-direction:row;justify-content:flex-start;gap:var(--space-md)}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-radio-group', providers: [
                        { provide: RADIO_GROUP_COMPONENT, useExisting: RadioGroupComponent },
                        {
                            provide: FormControlComponent,
                            useExisting: RadioGroupComponent,
                        },
                    ], template: "<label *ngIf=\"label\" [ngClass]=\"{ disabled: disabled }\" name=\"radio-group\">{{ label }}</label>\n<div [ngClass]=\"{ row: isHorizontal }\">\n  <ng-content select=\"avn-radio\"></ng-content>\n</div>\n", styles: [":host{display:block;position:relative}:host ::ng-deep avn-radio:not(:last-child){margin-bottom:var(--space-base)}:host .row{width:100%;display:flex;flex-direction:row;justify-content:flex-start;gap:var(--space-md)}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { radios: [{
                type: ContentChildren,
                args: [forwardRef(() => RadioComponent), { descendants: true }]
            }], isHorizontal: [{
                type: Input
            }], disabled: [{
                type: Input
            }], value: [{
                type: HostBinding,
                args: ['attr.value']
            }, {
                type: Input
            }], name: [{
                type: Input
            }], selected: [{
                type: HostBinding,
                args: ['class.selected']
            }, {
                type: Input
            }], label: [{
                type: Input
            }], change: [{
                type: Output
            }] } });
class RadioComponent {
    /**
     * Whether the radio button is disabled.
     * */
    get disabled() {
        return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
    }
    set disabled(value) {
        const newDisabledState = coerceBooleanProperty(value);
        if (this._disabled !== newDisabledState) {
            this._disabled = newDisabledState;
            this.changeDetector.markForCheck();
        }
    }
    /**
     * Whether this radio button is checked.
     */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        const newCheckedState = coerceBooleanProperty(value);
        if (this._checked !== newCheckedState) {
            this._checked = newCheckedState;
            if (newCheckedState && this.radioGroup && this.radioGroup.value !== this.value) {
                this.radioGroup.selected = this;
            }
            else if (!newCheckedState && this.radioGroup && this.radioGroup.value === this.value) {
                // When unchecking the selected radio button, update the selected radio
                // property on the group.
                this.radioGroup.selected = null;
            }
            if (newCheckedState) {
                // Notify all radio buttons with the same name to un-check.
                this.radioDispatcher.notify(this.uuid, this.name);
            }
            this.changeDetector.markForCheck();
        }
    }
    /**
     * The value of this radio button.
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            if (this.radioGroup !== null) {
                if (!this.checked) {
                    // Update checked when the value changed to match the radio group's value
                    this.checked = this.radioGroup.value === value;
                }
                if (this.checked) {
                    this.radioGroup.selected = this;
                }
            }
        }
    }
    /**
     * radioGroup: The parent radio group. May or may not be present.
     *
     * @ignore
     */
    constructor(radioGroup, changeDetector, radioDispatcher) {
        // // set the theme to the theme defined by the radio group
        // if (this.radioGroup) {
        //   this.theme = this.radioGroup.theme;
        // } else {
        //   this.theme = ThemeType.PRIMARY;
        // }
        this.radioGroup = radioGroup;
        this.changeDetector = changeDetector;
        this.radioDispatcher = radioDispatcher;
        /**
         * id for the radio autogenerate if not provided
         */
        this.id = v4();
        /** Whether this radio is checked. */
        this._checked = false;
        /** Value assigned to this radio. */
        this._value = null;
        /**
         * Generated id for the input field
         */
        this.uuid = v4();
        /**
         * Event emitted when the checked state of this radio button changes.
         * Change events are only emitted when the value changes due to user interaction with
         * the radio button (the same behavior as `<input type-"radio">`).
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        /** Unregister function for _radioDispatcher */
        this.removeUniqueSelectionListener = () => { };
        this.componentDestroyed$ = new Subject();
        // listen to radio selection changes
        this.removeUniqueSelectionListener = radioDispatcher.listen((id, name) => {
            if (id !== this.uuid && name === this.name) {
                this.checked = false;
            }
        });
    }
    /**
     * @ignore
     */
    ngOnInit() {
        if (this.radioGroup) {
            // If the radio is inside a radio group, determine if it should be checked
            this.checked = this.radioGroup.value === this._value;
            // Copy name from parent radio group
            this.name = this.radioGroup.name;
        }
    }
    /**
     * Triggered when the radio button received a click or the input recognized any change.
     * Clicking on a label element, will trigger a change event on the associated input.
     */
    onChange(event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the `change` output.
        event.stopPropagation();
        // has the group value changed? check here before the value gets updated
        const groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
        // make the radio checked
        this.checked = true;
        // emit a change event
        this.emitChangeEvent();
        if (this.radioGroup) {
            // propagate the value change and mark the form control as touched
            this.radioGroup.propagateChange(this.value);
            this.radioGroup.onTouch(event);
            // if the group value has changed, emit a change event
            if (groupValueChanged) {
                this.radioGroup.emitChangeEvent();
            }
        }
    }
    /**
     * Marks the radio button as needing checking for change detection.
     * This method is exposed because the parent radio group will directly
     * update bound properties of the radio button.
     */
    markForCheck() {
        // When group value changes, the button will not be notified. Use `markForCheck` to explicit
        // update radio button's status
        this.changeDetector.markForCheck();
    }
    /**
     *  @ignore
     */
    ngAfterViewInit() {
        // whenever the focus changes for the input element, mark the radio group as touched
        fromEvent(this.inputElement.nativeElement, 'blur').pipe(takeUntil(this.componentDestroyed$)).subscribe((evt) => {
            if (this.radioGroup) {
                this.radioGroup.onTouch(evt);
            }
        });
    }
    /**
     *  remove listeners on destroy
     *
     *  @ignore
     */
    ngOnDestroy() {
        this.removeUniqueSelectionListener();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** Dispatch change event with current value. */
    emitChangeEvent() {
        this.change.emit(new RadioChangeEvent(this, this._value));
    }
    onClick(event) {
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `radio-button` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RadioComponent, deps: [{ token: RADIO_GROUP_COMPONENT, optional: true }, { token: i0.ChangeDetectorRef }, { token: i3.UniqueSelectionDispatcher }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RadioComponent, selector: "avn-radio", inputs: { id: "id", label: "label", name: "name", disabled: "disabled", checked: "checked", value: "value" }, outputs: { change: "change" }, host: { properties: { "attr.value": "this.value" } }, viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true }], ngImport: i0, template: "<input type=\"radio\" [id]=\"id\" [name]=\"name\" #inputElement [checked]=\"checked\" [disabled]=\"disabled\" (change)=\"onChange($event)\" (click)=\"onClick($event)\" />\n<div class=\"label-container\">\n  <label [for]=\"id\" class=\"label-svg\" #svgLabel>\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" #svgElement [ngClass]=\"{ checked: checked, unchecked: !checked }\">\n      <ng-container *ngIf=\"checked\">\n        <path\n          d=\"M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"\n        />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </ng-container>\n      <ng-container *ngIf=\"!checked\">\n        <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\" />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </ng-container>\n    </svg>\n  </label>\n  <label [for]=\"id\" class=\"label-text\" *ngIf=\"label\">{{ label }}</label>\n</div>\n<ng-content></ng-content>\n", styles: [":host{display:block;position:relative}:host svg{fill:var(--checkbox-radio-background)}:host:hover>input[type=radio]:not(:disabled)+div.label-container>label>svg{fill:var(--checkbox-radio-hover-background)}:host>input[type=radio]{display:none}:host>input[type=radio]+div.label-container.with-label{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center}:host>input[type=radio]+div.label-container>label{display:inline-block;padding:0;cursor:pointer}:host>input[type=radio]+div.label-container>label>svg{width:24px}:host>input[type=radio]+div.label-container>label.label-text{margin-left:var(--space-sm)}:host>input[type=radio]:disabled+div.label-container{opacity:.3}:host>input[type=radio]:disabled+div.label-container>label{cursor:not-allowed}:host label{margin-bottom:0}:host svg.checked{animation:.5s pulse-in}:host svg.unchecked{animation:.5s pulse-out}@keyframes pulse-in{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}@keyframes pulse-out{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-radio', template: "<input type=\"radio\" [id]=\"id\" [name]=\"name\" #inputElement [checked]=\"checked\" [disabled]=\"disabled\" (change)=\"onChange($event)\" (click)=\"onClick($event)\" />\n<div class=\"label-container\">\n  <label [for]=\"id\" class=\"label-svg\" #svgLabel>\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" #svgElement [ngClass]=\"{ checked: checked, unchecked: !checked }\">\n      <ng-container *ngIf=\"checked\">\n        <path\n          d=\"M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"\n        />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </ng-container>\n      <ng-container *ngIf=\"!checked\">\n        <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\" />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </ng-container>\n    </svg>\n  </label>\n  <label [for]=\"id\" class=\"label-text\" *ngIf=\"label\">{{ label }}</label>\n</div>\n<ng-content></ng-content>\n", styles: [":host{display:block;position:relative}:host svg{fill:var(--checkbox-radio-background)}:host:hover>input[type=radio]:not(:disabled)+div.label-container>label>svg{fill:var(--checkbox-radio-hover-background)}:host>input[type=radio]{display:none}:host>input[type=radio]+div.label-container.with-label{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center}:host>input[type=radio]+div.label-container>label{display:inline-block;padding:0;cursor:pointer}:host>input[type=radio]+div.label-container>label>svg{width:24px}:host>input[type=radio]+div.label-container>label.label-text{margin-left:var(--space-sm)}:host>input[type=radio]:disabled+div.label-container{opacity:.3}:host>input[type=radio]:disabled+div.label-container>label{cursor:not-allowed}:host label{margin-bottom:0}:host svg.checked{animation:.5s pulse-in}:host svg.unchecked{animation:.5s pulse-out}@keyframes pulse-in{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}@keyframes pulse-out{0%{opacity:0;transform:scale(1.3)}to{opacity:1;transform:scale(1)}}\n"] }]
        }], ctorParameters: function () { return [{ type: RadioGroupComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [RADIO_GROUP_COMPONENT]
                }] }, { type: i0.ChangeDetectorRef }, { type: i3.UniqueSelectionDispatcher }]; }, propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], checked: [{
                type: Input
            }], value: [{
                type: HostBinding,
                args: ['attr.value']
            }, {
                type: Input
            }], change: [{
                type: Output
            }], inputElement: [{
                type: ViewChild,
                args: ['inputElement', { static: false }]
            }] } });

class ToSelectOptionPipe {
    transform(values, valueParam, labelParam) {
        if (values == null && values !== '') {
            return undefined;
        }
        if (values.constructor.name === 'Array') {
            return this.parseMultipleValues(values, valueParam, labelParam);
        }
        return this.parseSingleValue(values, valueParam, labelParam);
    }
    parseMultipleValues(values, valueParam, labelParam) {
        if (values.length === 0) {
            return [];
        }
        if (!valueParam) {
            return values.map((value) => ({ value, label: value }));
        }
        const isFunction = valueParam && typeof valueParam !== 'string';
        if (isFunction) {
            return values.map((value, i) => valueParam(value, i));
        }
        return values.map((value) => ({
            value: value[valueParam],
            label: value[labelParam],
        }));
    }
    parseSingleValue(value, valueParam, labelParam) {
        if (!valueParam) {
            return { value, label: value };
        }
        const isFunction = valueParam && typeof valueParam !== 'string';
        if (isFunction) {
            return valueParam(value, 0);
        }
        return {
            value: value[valueParam],
            label: value[labelParam],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToSelectOptionPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ToSelectOptionPipe, name: "toSelectOption" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ToSelectOptionPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'toSelectOption' }]
        }] });

/**
 * Displays data in a table.
 * Uses a CSS Grid layout for the datatable layout.
 *
 * Provides the following functionalities:
 * - virtual scrolling for large datasets
 * - infinite scrolling with multiple preload strategies
 * - column reordering
 * - column resizing
 * - column sorting
 * - row selection
 * - keyboard navigation
 * - customizable empty message when no data and/or when no columns are configured (for the later, use the avn-empty-data-message with a 'columns' attribute)
 * - customizable header
 * - customizable footer
 * - automatic (fill parent) or fixed height
 * - customizable vertical / horizontal alignment
 *
 * Known issues / hacks:
 * - Firefox issue when last column is sticky to the right
 * (https://stackoverflow.com/questions/60517169/grid-items-overlapping-with-position-sticky)
 */
class DataTableComponent {
    /**
     * Sets the datasource configuration (e.g. allows to specify the id property of the datasource items)
     * When a datasource config id is provided, a trackby function is created and used for better performance
     */
    set dataSourceConfig(dataSourceConfig) {
        this._store.setDataSourceConfig(dataSourceConfig);
        // when a datasource id is provided, create a trackby function using this for better performance
        if (dataSourceConfig.id) {
            this.indexTrackFn = (_, row) => row[dataSourceConfig.id];
        }
    }
    /**
     * The infinite scroll preload mode for loading extra records in the datatable:
     * - page: Load more data after n page of records are left to be scrolled
     * - left: Load more data when n% of current loaded data rows are left to be scrolled
     * - reached: Load more data when n% of current loaded data rows have been scrolled
     */
    set infiniteScrollPreloadStrategy(strategy) {
        this._store.setInfiniteScrollPreloadStrategy(strategy);
    }
    /**
     * The data table scroll mode value
     * - when infiniteScrollPreloadStrategy is 'left': percentage value
     * - when infiniteScrollPreloadStrategy is 'reached': percentage value
     * - when infiniteScrollPreloadStrategy is 'page': number of pages
     */
    set infiniteScrollPreloadValue(value) {
        this._store.setInfiniteScrollPreloadValue(value);
    }
    /** Indicates the quantity of items that will be fetched per data fetch **/
    set pageSize(pageSize) {
        if (pageSize != null) {
            this._store.setPageSize(pageSize);
        }
    }
    /**
     * Indicates whether the sorting should be local or done by the server by re-fetching the data
     * If serverSorting is true but all records have been loaded from the server, then the sorting
     * becomes local
     */
    set serverSorting(enabled) {
        this._store.setServerSorting(enabled);
    }
    /** The sort by criteria for sorting the table data  */
    set sortBy(sortBy) {
        this._store.setSort(sortBy);
    }
    /**
     * Specifies if the datasource of the table is static (no pagination or infinite scrolling data fetch)
     *
     * @deprecated Use infiniteScrollEnabled instead
     */
    set isStaticDataSource(isStaticDatasource) {
        this.infiniteScrollEnabled = !isStaticDatasource;
    }
    /** @ignore */
    constructor(_renderer, elementRef, _cdr, _window, mediaBreakpointStore, _store) {
        this._renderer = _renderer;
        this.elementRef = elementRef;
        this._cdr = _cdr;
        this._window = _window;
        this._store = _store;
        /** The datatable columns definitions/configuration **/
        this.columns = [];
        /** columns configuration for the header columns **/
        this.internalHeaderColumns = [];
        /**
         * columns configuration for the data columns. It will differ from the header columns when header columns are being reordered (cuz of CDK
         * drag & drop) *
         */
        this.internalDataColumns = [];
        /** Indicates if the drag and drop of datatable rows is enabled **/
        this.dragDropRowsEnabled = false;
        /**
         * Specifies the total height of the datatable (including header and footer), it can be:
         * - auto - fits its parent height
         * - a fixed height in px
         **/
        this.tableHeight = 'auto';
        /** Specifies the height of the header in px **/
        this.headerHeight = 50;
        /** Specifies the height of the data rows in px **/
        this.rowHeight = 50;
        /** The vertical alignment of the data within the data row */
        this.dataRowVerticalAlign = 'center';
        /** The mode of selection for a data row. Can be 'none', 'single', 'single-no-radio' or 'multiple' */
        this.selectionMode = DataTableSelectionMode.NONE;
        /**
         *The loading state of the datatable is internally managed by the component. This input allows
         *to force the datatable into a loading state using the regular avn-loader with overlay
         **
         */
        this.forceLoadingState = false;
        /** Theme for the loader */
        this.loaderTheme = ThemeType.PRIMARY;
        /** The horizontal loader position relative to the data table */
        this.horizontalLoaderPosition = 'bottom';
        /** Specifies if keyboard navigation is enabled **/
        this.keyboardNavigationEnabled = true;
        /** Specifies if the datatable header should be visible */
        this.showHeader = true;
        /** Indicates if infinite scroll is enabled. If disabled, you need to provide a fully loaded datasource as no data fetch event will be emitted **/
        this.infiniteScrollEnabled = true;
        /**
         * Specifies the default minimum width px for a column.
         * This only applies to columns with a non fixed width that can vary with table size (widthRatio set)
         */
        this.minColumnWidthPx = 80;
        /**
         * Indicates the strategy for columns resizing:
         * - fixed: When a column is resized, all columns sizes are set to a fixed px width. All columns initially configured to use a ratio of
         * the available free space are now fixed in width.
         * - preserve: When a column is resized, its width its set to a fixed px width. All columns initially configured to use a ratio of the
         * available free space will continue to share the available free space.
         */
        this.columnsResizeStrategy = 'preserve';
        /** Specifies if the columns navigation should show when horizontal scrolling is active */
        this.showHorizontalScrollArrows = true;
        /** To improve rendering performance of virtual scroll, previously rendered rows in viewport are cached. Setting the size of the view cache to 0 disables caching.
         * If your item templates are expensive in terms of memory you may wish to reduce this number to avoid spending too much memory on the cache. **/
        this.templateCacheSize = 20;
        /** Enable the tooltips of columns headings **/
        this.headerTooltipsEnabled = false;
        /**
         * Columns overflow strategy
         * - When set to 'scroll', all columns that do not fit in the available viewport width will be accessible via horizontal scrolling
         * - When set to 'hide-keep-order', all columns that do not fit in the available viewport width will be hidden, in order of which they appear
         * - When set to 'hide-keep-sticky', all columns that do not fit in the available viewport width will be hidden, but sticky columns will be prioritized to fit
         * **/
        this.columnsOverflowStrategy = 'scroll';
        /** Specifies the loader to use for the initial loading state (the page loader blocking the UI or the regular horizontal loader) **/
        this.initialDataLoader = 'block-ui-loader';
        /**
         * Emits when a data fetch is requested
         *
         * offset: this is the start index at which to fetch data
         * amount: this is the amount of data rows to be fetched
         * sort: the sort details of the requested data
         */
        this.fetchData = new EventEmitter();
        /** Emits when a column is sorted */
        this.columnSorted = new EventEmitter();
        /** Emits when a column is reordered */
        this.columnReordered = new EventEmitter();
        /**
         * Emit only when the data table is set to multi-select and Select All option is clicked.
         * Note: Select All CHECKBOX only selects the loaded data. Whereas Select All OPTION indicates that
         *       the user wishes to select everything in the data source. If there are total 500 data and only
         *       300 are loaded, selected items returned from data table would remain 300 even if user clicks
         *       Select All option. Consuming app needs to handle the data that are not yet loaded if user
         *       chooses this option, and display the proper count accordingly on UI.
         */
        this.entireDataSetSelected = new EventEmitter();
        /** Emits when selection has changed (data rows have been selected or unselected) **/
        this.selectionChanged = new EventEmitter();
        /**
         * Emits when a data row is clicked.
         * NOTE: a disabled row would still emit this event. The consuming app should decide whether to handle
         *       this event when a row is disabled. (Because when a table is displayed in master detail view,
         *       the consuming app might still want to show the detail of this row even though it is disabled)
         */
        this.rowClicked = new EventEmitter();
        /**
         * Emits when a data row is double-clicked.
         * NOTE: a disabled row would still emit this event. The consuming app should decide whether to handle
         *       this event when a row is disabled. (Because when a table is displayed in master detail view,
         *       the consuming app might still want to show the detail of this row even though it is disabled)
         */
        this.rowDoubleClicked = new EventEmitter();
        /**
         * Emits when a data rows is made active.
         * NOTE: a disabled row would still emit this event. The consuming app should decide whether to handle
         *       this event when a row is disabled. (Because when a table is displayed in master detail view,
         *       the consuming app might still want to show the detail of this row even though it is disabled)
         */
        this.rowActivated = new EventEmitter();
        /** The notification message underneath the header was clicked */
        this.notificationMessageClicked = new EventEmitter();
        /** Data was loaded (statically or via a data fetch event) */
        this.dataLoaded = new EventEmitter();
        /** Column was resized */
        this.columnResized = new EventEmitter();
        /** Column was navigated horizontally */
        this.columnNavigated = new EventEmitter();
        this.tabindex = 0;
        /**
         * The current width of the body scrollbar
         * When the body has a scrollbar, the header cells need to take that width into account
         * by adding a extra column of the scrollbar width.
         * That way we can easily maintain the header / data columns widths in sync
         */
        this.bodyScrollbarWidth = 0;
        /** Font size (in px) of the arrow icon used to scroll */
        this.arrowIconSize = 48;
        /**
         * Indicates if the header row is currently hovered
         */
        this.headerHovered = false;
        /** Indicates if a column is currently being resized */
        this.resizing = false;
        /** Indicates if there is at least on right sticky column */
        this.hasAtLeastOneStickyRightColumn = false;
        /** Indicates if the horizontal scroll is active */
        this.horizontalScrollActive = false;
        /** model for the component **/
        this.model$ = this._store.model$;
        /** For use in template **/
        this.PlacementTypes = PlacementTypes;
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
        this.isMobileDevice$ = mediaBreakpointStore.breakpoint$.pipe(map((deviceType) => [LayoutDeviceType.HANDSET, LayoutDeviceType.TABLET].includes(deviceType)));
        this.allItemsSelectionEnabled$ = this._store.allItemsSelectionEnabled$;
        this.entireDataSetSelected$ = this._store.entireDataSetSelected$;
        this.entireDataSetSelected$.pipe(tap((entireDataSetSelected) => {
            this.entireDataSetSelected.emit(entireDataSetSelected);
        }), takeUntil(this._componentDestroyed$)).subscribe();
        this.areAllItemsDisabled$ = this._store.areAllItemsDisabled$;
    }
    /** @ignore */
    ngOnInit() {
        // default trackBy function (set default here to avoid ts lint error...)
        this.indexTrackFn = this.indexTrackFn || ((index, _) => index);
        // start listening to events from the store
        // data fetch
        this._store.fetchData$
            .pipe(filter(() => this.infiniteScrollEnabled), takeUntil(this._componentDestroyed$))
            .subscribe((event) => {
            this.fetchData.emit({
                offset: event.offset,
                amount: event.pageSize,
                sort: event.sort,
            });
        });
        // selection change
        this._store.selectionChanged$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this.selectionChanged.emit(event));
    }
    /** @ignore */
    ngAfterViewInit() {
        // init the keyboard navigation
        this._initKeyboardNavigation();
        // init the columns and table dimensions
        this._resetColumns();
        this._refreshTableDimensions();
    }
    /** resets the columns size and dimensions **/
    _resetColumns() {
        this._renderer.setStyle(this.elementRef.nativeElement, '--column-count', `${this.internalHeaderColumns.length}`, RendererStyleFlags2.DashCase);
        this._calcHeaderColumnsSizes();
        this._calcDataColumnsSizes();
    }
    /** @ignore Calculates the columns sizes of the header row */
    _calcHeaderColumnsSizes() {
        let columnSizesCssValue = this._columnsWidthToGridCssWidth(this.internalHeaderColumns);
        // make sure to include the extra column that match the body scrollbar width
        if (this.bodyScrollbarWidth > 0) {
            columnSizesCssValue = `${columnSizesCssValue} ${this.bodyScrollbarWidth}px`;
        }
        this._renderer.setStyle(this.elementRef.nativeElement, '--column-sizes-header', columnSizesCssValue, RendererStyleFlags2.DashCase);
        this._cdr.detectChanges();
    }
    /** @ignore Calculates the columns sizes of a data row */
    _calcDataColumnsSizes() {
        const columnSizesCssValue = this._columnsWidthToGridCssWidth(this.internalDataColumns);
        this._renderer.setStyle(this.elementRef.nativeElement, '--column-sizes-data', columnSizesCssValue, RendererStyleFlags2.DashCase);
    }
    /** @ignore converts the columns width (px or ratio) to the actual grid css size */
    _columnsWidthToGridCssWidth(columnsConfig) {
        const cssGridWidths = columnsConfig.map((c) => (c.widthPx ? `${c.widthPx}px` : `minmax(${this.minColumnWidthPx}px, ${c.widthRatio || 1}fr)`)).join(' ');
        // add an extra 0 px cell at the end to prevent firefox issue (see component desc)
        return `${cssGridWidths} 0px`;
    }
    /** @ignore calculates column widths in px **/
    _calculateColumnsWidthPx() {
        this._columnsWidthPx = this.internalHeaderColumns.map((c) => this._getHeaderColumnWidthPx(c));
        // also create a map of sticky columns only width (useful as a cache)
        this._stickyColumnsLeftWidthPx = this.internalHeaderColumns
            .filter((c) => c.sticky && (!c.stickyPosition || c.stickyPosition === 'left'))
            .reduce((p, c) => {
            const columnIndex = this.internalHeaderColumns.indexOf(c);
            p[columnIndex] = this._columnsWidthPx[columnIndex];
            return p;
        }, {});
        this._stickyColumnsRightWidthPx = this.internalHeaderColumns
            .filter((c) => c.sticky && c.stickyPosition === 'right')
            .reduce((p, c) => {
            const columnIndex = this.internalHeaderColumns.indexOf(c);
            p[columnIndex] = this._columnsWidthPx[columnIndex];
            return p;
        }, {});
        // update the sticky position of each sticky column
        // selection column always sticks
        let currentLeftOffsetPx = 0;
        this.internalHeaderColumns
            .filter((c) => c.sticky && (!c.stickyPosition || c.stickyPosition === 'left'))
            .forEach((columnConfig) => {
            const columnIndex = this.internalHeaderColumns.indexOf(columnConfig);
            this.elementRef.nativeElement.style.setProperty(`--column-sticky-left-${columnIndex}`, `${currentLeftOffsetPx}px`);
            currentLeftOffsetPx += this._columnsWidthPx[columnIndex];
        });
        let currentRightOffsetPx = 0;
        [...this.internalHeaderColumns]
            .reverse()
            .filter((c) => c.sticky && c.stickyPosition === 'right')
            .forEach((columnConfig) => {
            const columnIndex = this.internalHeaderColumns.indexOf(columnConfig);
            // add the st
            this._renderer.setStyle(this.elementRef.nativeElement, `--column-sticky-right-header-${columnIndex}`, `${currentRightOffsetPx + this.bodyScrollbarWidth}px`, RendererStyleFlags2.DashCase);
            this._renderer.setStyle(this.elementRef.nativeElement, `--column-sticky-right-data-${columnIndex}`, `${currentRightOffsetPx}px`, RendererStyleFlags2.DashCase);
            currentRightOffsetPx += this._columnsWidthPx[columnIndex];
        });
    }
    getBodyClassName() {
        let classes = '';
        if (this.dataRowVerticalAlign === 'top') {
            classes += 'valign-top';
        }
        else if (this.dataRowVerticalAlign === 'bottom') {
            classes += 'valign-bottom';
        }
        classes += ' selectionmode-' + this.selectionMode;
        return classes;
    }
    /** Called when a column is being reordered / dragged with drag & drop */
    onColumnReordering(event) {
        this.internalDataColumns = this._moveElementInArray(this.internalDataColumns, event.previousIndex, event.currentIndex);
        this._calcDataColumnsSizes();
    }
    /** Called when a column is reordered / dropped with drag & drop */
    onColumnReordered(event) {
        // do nothing if the column wasn't reordered
        if (event.previousIndex === event.currentIndex) {
            return;
        }
        this.internalHeaderColumns = this._moveElementInArray(this.internalHeaderColumns, event.previousIndex, event.currentIndex);
        this._calcHeaderColumnsSizes();
        // emit event
        this.columnReordered.emit({
            columnId: this.internalHeaderColumns[event.currentIndex].id,
            previousIndex: event.previousIndex,
            currentIndex: event.currentIndex,
            newColumnsIds: this.internalHeaderColumns.map((c) => c.id),
        });
    }
    /** @ignore Moves the array element at specified index to the new index */
    _moveElementInArray(array, elementIndex, newIndex) {
        if (newIndex >= array.length) {
            let k = newIndex - array.length + 1;
            while (k--) {
                array.push(undefined);
            }
        }
        array.splice(newIndex, 0, array.splice(elementIndex, 1)[0]);
        return array;
    }
    /** @ignore Inits the keyboard navigation */
    _initKeyboardNavigation() {
        const keydown$ = fromEvent(this.elementRef.nativeElement, 'keydown');
        // create method to return the next active row
        const getNextActiveRow = (direction, activeRow) => {
            // check boundaries
            if (direction === 'up') {
                if (activeRow.index === 0) {
                    return undefined;
                }
                return {
                    index: activeRow.index - 1,
                    data: this._store.dataSource.data[activeRow.index - 1],
                };
            }
            else {
                if (activeRow.index === this._store.dataSource.data.length - 1) {
                    return undefined;
                }
                return {
                    index: activeRow.index + 1,
                    data: this._store.dataSource.data[activeRow.index + 1],
                };
            }
        };
        // create method to return the scroll offset of the next active row
        const getNextScrollOffset = (nextActiveRow, rowHeight, viewport) => {
            if (!nextActiveRow) {
                return undefined;
            }
            // get the offset of the active row
            const nextActiveRowOffset = nextActiveRow.index * this.rowHeight;
            const viewportHeight = viewport.getViewportSize();
            // update the scroll offset if the next row is offscreen
            const viewportOffsetStart = viewport.elementRef.nativeElement.scrollTop;
            const viewportOffsetEnd = viewportOffsetStart + viewportHeight;
            let nextScrollOffset;
            if (nextActiveRowOffset < viewportOffsetStart) {
                nextScrollOffset = nextActiveRowOffset;
            }
            else if (nextActiveRowOffset >= viewportOffsetEnd) {
                nextScrollOffset = nextActiveRowOffset - viewportHeight + this.rowHeight;
            }
            return nextScrollOffset;
        };
        // listen to to keyboard event
        keydown$
            .pipe(filter(() => this.keyboardNavigationEnabled && !!this.activeRow && !this._store.isPendingData), filter((event) => [DOWN_ARROW, UP_ARROW].includes(event.keyCode)), map((event) => {
            // converts a keydown event into a custom keyboard navigation event
            const direction = event.keyCode === DOWN_ARROW ? 'down' : 'up';
            const nextActiveRow = getNextActiveRow(direction, this.activeRow);
            return {
                direction,
                activeRow: this.activeRow,
                nextActiveRow,
                nextScrollOffset: getNextScrollOffset(nextActiveRow, this.rowHeight, this.virtualizedViewport),
            };
        }), filter((event) => !!event.nextActiveRow), takeUntil(this._componentDestroyed$))
            .subscribe((evt) => {
            if (evt.nextScrollOffset !== undefined) {
                this.virtualizedViewport.scrollToOffset(evt.nextScrollOffset);
            }
            // update the active row
            this._updateActiveRow(evt.nextActiveRow, evt.direction);
            this._cdr.detectChanges();
        });
        // select/deselect the active row when pressing enter key
        keydown$
            .pipe(filter((event) => {
            const result = this.selectionMode !== DataTableSelectionMode.NONE &&
                event.keyCode === SPACE &&
                this.keyboardNavigationEnabled &&
                !!this.activeRow &&
                !this.activeRow.data.datatableRowOptions?.disabled;
            return result;
        }), map(() => this.activeRow.data), takeUntil(this._componentDestroyed$))
            .subscribe((row) => {
            if (this.selectionMode === DataTableSelectionMode.SINGLE || this.selectionMode === DataTableSelectionMode.SINGLE_NO_RADIO) {
                if (this.isRowSelected(row)) {
                    this._store.removeItemFromSelection(row);
                }
                else {
                    this.onSelectSingleRow(this._store.dataSource.data.indexOf(row), row);
                }
            }
            else if (this.selectionMode === DataTableSelectionMode.MULTIPLE) {
                const idProp = this._store.dataSourceConfig?.id;
                const isRowSelected = idProp ? this._store.selectedItemIds.includes(row[idProp]) : this._store.selectedItems.includes(row);
                this.onSelectRow(!isRowSelected, row);
            }
            else if (this.selectionMode === DataTableSelectionMode.MULTIPLE_COLOR) {
                this.onActiveRowSelectionWithoutCheckBox(row);
            }
            this._cdr.markForCheck();
            this._cdr.detectChanges();
        });
    }
    /** @ignore updates the active row */
    _updateActiveRow(activeRow, direction = null, emitActivatedEvent = true) {
        const previousActiveRow = this.activeRow;
        this.activeRow = activeRow;
        // send an event if the active row has changed
        if (emitActivatedEvent && !!activeRow && (!previousActiveRow || activeRow.index !== previousActiveRow.index)) {
            this.rowActivated.emit({
                direction,
                previousActiveRow,
                activeRow,
            });
        }
    }
    /** @ignore */
    ngOnChanges({ columns, tableHeight, dataSource, selectionMode, keyboardNavigationEnabled, footerTemplate, showHeader, columnsOverflowStrategy, selectedItemIds, themeIndicatorWidthPx, }) {
        if (selectionMode) {
            this._selectionColumnConfig = this._getSelectionColumnConfig();
        }
        if (themeIndicatorWidthPx) {
            this._themeIndicatorColumnConfig = this._getThemeIndicatorColumnConfig();
        }
        if (columns || selectionMode || columnsOverflowStrategy) {
            this._applyColumnOverflowStrategy(this.bodyEl?.nativeElement.clientWidth);
            this.hasAtLeastOneStickyRightColumn = this.internalHeaderColumns.some((c) => c.sticky && c.stickyPosition === 'right');
            this._resetColumns();
            this._refreshTableDimensions();
        }
        if (tableHeight || footerTemplate || showHeader) {
            // // recalculate the table dimensions
            this._refreshTableDimensions();
        }
        // when data is received (statically on init or after a dataFetch event)
        if (dataSource) {
            // convert the datasource in the new format (backwards compat)
            let newDataSource;
            const oldFormat = dataSource.currentValue?.hasOwnProperty('rows') || dataSource.currentValue?.hasOwnProperty('totalRowCount');
            if (oldFormat) {
                const oldFormatDataSource = dataSource.currentValue;
                newDataSource = {
                    data: oldFormatDataSource.rows,
                    total: oldFormatDataSource.totalRowCount,
                };
            }
            else {
                newDataSource = dataSource.currentValue;
            }
            // set the initial datasource if the first change
            if (dataSource.isFirstChange()) {
                this._store.setDatasource(newDataSource);
            }
            else {
                this._store.updateDatasource(newDataSource);
                // emit data loaded event
                this.dataLoaded.emit();
                this._refreshTableDimensions();
                // check if we may need to load more data
                if (this.infiniteScrollEnabled && this.virtualizedViewport) {
                    this._store.onMaxRenderedItemIndexChange(this.virtualizedViewport.getRenderedRange().end);
                }
            }
        }
        if (selectionMode && !selectionMode.isFirstChange()) {
            // reset the selected rows
            this.clearSelectedRows();
        }
        if (keyboardNavigationEnabled) {
            // remove active row when keyboard navigation is disabled
            if (!this.keyboardNavigationEnabled && this.activeRow) {
                // update the active row
                this._updateActiveRow(undefined);
            }
        }
        if (selectedItemIds && !isEqual(selectedItemIds.currentValue, selectedItemIds.previousValue)) {
            this._store.setInitialSelectedItemIds(selectedItemIds.currentValue);
        }
    }
    /** Returns the definition of the selection column, depending on the selection mode **/
    _getSelectionColumnConfig() {
        if (this.selectionMode === DataTableSelectionMode.NONE || this.selectionMode === DataTableSelectionMode.SINGLE_NO_RADIO
            || this.selectionMode === DataTableSelectionMode.MULTIPLE_COLOR) {
            return null;
        }
        else {
            return {
                id: null,
                sticky: true,
                stickyPosition: 'left',
                widthPx: 45,
                headerCellTemplate: this.selectionMode === DataTableSelectionMode.MULTIPLE ? this._multiSelectionHeaderTemplate : null,
                dataCellTemplate: this.selectionMode === DataTableSelectionMode.MULTIPLE ? this._multiSelectionDataTemplate : this._singleSelectionDataTemplate,
                name: '',
                resizable: false,
                draggable: false,
                sortable: false,
            };
        }
    }
    _getThemeIndicatorColumnConfig() {
        if (this.themeIndicatorWidthPx) {
            return {
                id: 'theme',
                sticky: true,
                stickyPosition: 'left',
                widthPx: this.themeIndicatorWidthPx,
                headerCellTemplate: this._themeIndicatorTemplate,
                dataCellTemplate: this._themeIndicatorTemplate,
                name: '',
                resizable: false,
                draggable: false,
                sortable: false,
            };
        }
        else {
            return null;
        }
    }
    _getExtraColumns() {
        const columns = [];
        if (this._themeIndicatorColumnConfig) {
            columns.push(this._themeIndicatorColumnConfig);
        }
        if (this._selectionColumnConfig) {
            columns.push(this._selectionColumnConfig);
        }
        return columns;
    }
    /** Updates the internal columns based on the column overflow strategy **/
    _applyColumnOverflowStrategy(viewportAvailableWidth) {
        // when scroll, we always show all columns
        const safeIterableCols = this.columns ? [...this.columns] : [];
        if (this.columnsOverflowStrategy === 'scroll') {
            this.internalHeaderColumns = [...this._getExtraColumns(), ...safeIterableCols];
            this.internalDataColumns = [...this._getExtraColumns(), ...safeIterableCols];
            return;
        }
        // when the viewport is not ready yet, use the current selection (we cannot calculate the columns fitting)
        if (!viewportAvailableWidth) {
            return;
        }
        const hideAll = this.columnsOverflowStrategy === 'hide-keep-order';
        const hideKeepSticky = this.columnsOverflowStrategy === 'hide-keep-sticky';
        viewportAvailableWidth -= this.bodyScrollbarWidth;
        // check if we can fit all columns in the viewport
        const minimumColumnsWidths = [...this._getExtraColumns(), ...this.columns].map((c) => ({
            widthPx: c.widthPx || this.minColumnWidthPx,
            sticky: c.sticky,
        }));
        const minimumSpaceRequiredForAllCols = minimumColumnsWidths.reduce((p, c) => p + c.widthPx, 0);
        const hasEnoughSpaceForAllColumns = minimumSpaceRequiredForAllCols <= viewportAvailableWidth;
        if (hasEnoughSpaceForAllColumns) {
            this.internalHeaderColumns = [...this._getExtraColumns(), ...this.columns];
            this.internalDataColumns = [...this._getExtraColumns(), ...this.columns];
            return;
        }
        const totalStickyWidth = hideAll ? 0 : minimumColumnsWidths.reduce((p, c) => p + (c.sticky ? c.widthPx : 0), 0);
        const availableWidthForNonStickyCols = viewportAvailableWidth - totalStickyWidth;
        const findIndexOfLastVisibleColumn = () => {
            for (let i = 0, total = 0; i < minimumColumnsWidths.length; i++) {
                if (hideKeepSticky && minimumColumnsWidths[i].sticky) {
                    continue;
                }
                total += minimumColumnsWidths[i].widthPx;
                if (total > availableWidthForNonStickyCols) {
                    return i - 1;
                }
            }
            return minimumColumnsWidths.length - 1;
        };
        const extraColumns = this._getExtraColumns();
        const lastVisibleColumnIndex = findIndexOfLastVisibleColumn();
        const indexOfLastFittingCol = lastVisibleColumnIndex - extraColumns.length;
        this.internalHeaderColumns = [
            ...extraColumns,
            ...this.columns.filter((c, i) => i <= indexOfLastFittingCol || (hideKeepSticky ? c.sticky : false)),
        ];
        this.internalDataColumns = [
            ...extraColumns,
            ...this.columns.filter((c, i) => i <= indexOfLastFittingCol || (hideKeepSticky ? c.sticky : false)),
        ];
        this._refreshTableDimensions();
    }
    /** @ignore */
    ngAfterContentInit() {
        // emit an event when the datatable notification message is clicked
        if (this.dataTableNotificationMessageComponent) {
            this.dataTableNotificationMessageComponent.clicked.pipe(takeUntil(this._componentDestroyed$)).subscribe(() => {
                this.notificationMessageClicked.emit();
            });
        }
    }
    /** Called when a column sort icon has been clicked */
    onSortHeaderClick(column) {
        // display sortPanel if sortableFields are set, otherwise use the prop of column directly
        if (column.sortableFields) {
            this.openedSortPanel = column.id;
            this._cdr.detectChanges();
        }
        else {
            this.onColumnSort(column.id, column.prop);
        }
    }
    onSortPanelToggled(columnId, status) {
        if (!status && columnId === this.openedSortPanel) {
            this.openedSortPanel = null;
        }
    }
    /** Determine the active color of sort icon in header */
    isHeaderSortActive(column) {
        return column.sortableFields ? column.sortableFields.some((field) => field.prop === this._store.sort?.prop) : this._store.sort?.id === column.id;
    }
    /** Determine the active color of sort icon inside sort panel */
    isActiveSortProperty(prop, direction) {
        return this._store?.sort?.direction === direction && this._store.sort.prop === prop;
    }
    /** Prepare selected option in sort panel */
    getSortPanelSelectedOptions(list) {
        if (!list) {
            return undefined;
        }
        return list.filter((item) => item.prop === this._store?.sort?.prop).map((item) => ({ value: item.prop, label: item.label }));
    }
    /** Run sort action for datatable*/
    onColumnSort(columnId, prop, direction) {
        if (this.openedSortPanel) {
            this.openedSortPanel = null;
        }
        if (!direction) {
            direction = this._store.sort?.id === columnId && this._store.sort.direction === 'asc' ? 'desc' : 'asc';
        }
        // get the sort property from the column id
        this._store.updateSort({
            id: columnId,
            direction,
            prop,
            isCaseInsensitive: this._store.sort?.isCaseInsensitive
        });
        // emit the sort event
        this.columnSorted.emit({
            serverSorting: this._store.isServerSorting,
            sortBy: {
                id: columnId,
                direction,
                isCaseInsensitive: this._store.sort?.isCaseInsensitive
            },
        });
    }
    onSelectEntireDataSet() {
        this._store.setEntireDataSetSelected(true);
    }
    /** Called when the select all checkbox is ticked */
    onSelectAllRows(checked) {
        this._store.setAllItemsSelectionEnabled(checked);
        if (checked) {
            this._store.selectAllItems();
        }
        else {
            this._store.deselectAllItems();
        }
    }
    /** Called when a row is selected from a multi selection table */
    onSelectRow(checked, row) {
        if (checked) {
            this._store.addItemsToSelection([row]);
        }
        else {
            this._store.removeItemFromSelection(row);
        }
    }
    /** Called when a row is selected from a MULTIPLE_COLOR mode */
    onActiveRowSelectionWithoutCheckBox(row) {
        if (this.isRowSelected(row)) {
            this._store.removeItemFromSelection(row);
        }
        else {
            this._store.addItemsToSelection([row]);
        }
    }
    /** Called when a row is selected from a MULTIPLE_COLOR mode */
    onSingleClickRowSelectionWithoutCheckBox(rowIndex, row) {
        if (this.isRowSelected(row)) {
            this._store.removeItemFromSelection(row);
        }
        else {
            this._store.addItemsToSelection([row]);
        }
        this._updateActiveRow({
            index: rowIndex,
            data: row,
        });
    }
    /** Called when a single row is selected */
    onSelectSingleRow(rowIndex, row) {
        this._store.setSingleSelectedItem(row);
        // remove the active row if its different from the selected one
        if (this.activeRow && this.activeRow.index !== rowIndex) {
            // update the active row
            this._updateActiveRow(undefined);
        }
    }
    /** Specifies if the specified row is selected */
    isRowSelected(row) {
        // compare by id if provided in config, otherwise compare by instance
        const idProp = this._store.dataSourceConfig?.id;
        if (idProp) {
            return this._store.selectedItemIds.includes(row[idProp]);
        }
        return this._store.selectedItems.indexOf(row) > -1;
    }
    /**
     * Disables the single selection radio for:
     * - disabled items
     * - all items if the current selected item is disabled
     * */
    isSingleSelectionRadioDisabled(row) {
        if (row.datatableRowOptions?.disabled) {
            return true;
        }
        const idProp = this._store.dataSourceConfig?.id;
        let isCurrentSelectedItemDisabled;
        if (idProp) {
            isCurrentSelectedItemDisabled =
                this._store.selectedItemIds.length === 1 && this._store.dataSource.data.find((item) => item[idProp] === this._store.selectedItemIds[0])?.datatableRowOptions?.disabled;
        }
        else {
            isCurrentSelectedItemDisabled = this._store.selectedItems.length === 1 && this._store.selectedItems[0].datatableRowOptions?.disabled;
        }
        return isCurrentSelectedItemDisabled;
    }
    /** Indicates if at least one data column exists */
    get hasDataColumns() {
        return !!this.columns?.some((c) => !c.isActionColumn);
    }
    /** Called when a row is clicked */
    onRowClick(rowIndex, row, event) {
        if (!(event.target?.parentElement?.tagName === 'AVN-ICON')) {
            this.rowClicked.emit({
                index: rowIndex,
                data: row,
            });
            // make the row clicked active if keyboard navigation is enabled
            if (this.keyboardNavigationEnabled) {
                // only if its a different row
                if (!this.activeRow || this.activeRow.index !== rowIndex) {
                    // update the active row
                    this._updateActiveRow({
                        index: rowIndex,
                        data: row,
                    });
                }
            }
        }
        if (!row.datatableRowOptions || row.datatableRowOptions.disabled === false) {
            if (this.selectionMode === DataTableSelectionMode.SINGLE_NO_RADIO) {
                this.onSelectSingleRow(rowIndex, row);
            }
            if (this.selectionMode === DataTableSelectionMode.MULTIPLE_COLOR) {
                this.onSingleClickRowSelectionWithoutCheckBox(rowIndex, row);
            }
        }
    }
    /** Called when a row is double clicked */
    onRowDoubleClick(rowIndex, row, event) {
        if (!(event.target?.parentElement?.tagName === 'AVN-ICON')) {
            this.rowDoubleClicked.emit({
                index: rowIndex,
                data: row,
            });
        }
    }
    /** Resets the infinite scroll and sends the initial data fetch **/
    reset() {
        this._store.reset();
    }
    /** clears the active row */
    clearActiveRow() {
        this._updateActiveRow(undefined);
        this._cdr.detectChanges();
    }
    /** clears the selected rows */
    clearSelectedRows() {
        this._store.deselectAllItems();
    }
    /** sets the highlighted row using the specified row index */
    setActiveRow(rowIndex, emitActivatedEvent = true) {
        const data = this._store.dataSource.data[rowIndex];
        if (data) {
            this._updateActiveRow({
                index: rowIndex,
                data,
            }, null, emitActivatedEvent);
        }
    }
    /** Indicates if the height of the datatable is auto (fits its parent height) **/
    get isAutoHeight() {
        return this.tableHeight === 'auto';
    }
    _calcViewportHeight() {
        const hasFooter = !!this.footerTemplate;
        // calculate the viewport height
        const bodyScrollbarHeight = getScrollbarHeight(this.virtualizedViewport?.elementRef.nativeElement);
        switch (this.tableHeight) {
            case 'auto':
                this.tableBodyHeight = `calc(100% - ${(this.showHeader ? this.headerHeight : 0) + (hasFooter ? this.footerHeight : 0)}px)`;
                break;
            case 'fit':
                this.tableMaxBodyHeight = this.tableMaxHeight
                    ? `${this.tableMaxHeight}px`
                    : `calc(100% - ${(this.showHeader ? this.headerHeight : 0) + (hasFooter ? this.footerHeight : 0)}px)`;
                this.tableBodyHeight = `${(this._store.dataSource?.total || 0) * this.rowHeight + bodyScrollbarHeight}px`;
                break;
            default:
                this.tableBodyHeight = `${this.tableHeight - (this.showHeader ? this.headerHeight : 0) - (hasFooter ? this.footerHeight : 0)}px`;
                break;
        }
        // Update the viewport dimensions and re-render
        this.virtualizedViewport?.checkViewportSize();
    }
    /** Called when the table body is resized **/
    onBodyResize(event) {
        if (event.width > 0) {
            this._applyColumnOverflowStrategy(event.width);
            this._resetColumns();
            this._refreshTableDimensions();
        }
    }
    /** Called when the table is resized **/
    _refreshTableDimensions() {
        this._calcViewportHeight();
        /** Note: a bit hackish, but the virtual scroll panel is not updating right away and that causes issues to calculate the scrollbar width, so let delay the computation a little */
        asapScheduler.schedule(() => {
            this._checkScrollbarWidth();
            // calculate the width of each column if we have at least one sticky column
            if (this._hasAtLeastOneStickyColumn()) {
                // refresh the sticky column separators if changed
                // calculate the width of each column if we have at least one sticky column
                this._calculateColumnsWidthPx();
                this._updateStickyInfo();
            }
            if (this.headerEl) {
                this.headerEl.nativeElement.scrollLeft = this.scrolledLeftPx;
            }
        });
    }
    /** @ignore **/
    _checkScrollbarWidth() {
        if (this.headerEl) {
            const hasBodyScrollbar = this.bodyScrollbarWidth > 0;
            this.bodyScrollbarWidth = getScrollbarWidth(this.virtualizedViewport.elementRef.nativeElement);
            const hasScrollbarChanged = (!hasBodyScrollbar && this.bodyScrollbarWidth > 0) || (hasBodyScrollbar && this.bodyScrollbarWidth <= 0);
            // only recalc when the scrollbar width actually changed
            if (hasScrollbarChanged) {
                this._calcHeaderColumnsSizes();
            }
        }
    }
    /** Called when a column has started resizing **/
    onDragStart(column) {
        this.resizing = true;
        this.resizedColumn = column;
        this._resizedColumnDragOffsetLeftPx = 0;
    }
    /** Called when a column has finished resizing by dragging **/
    onDragEnd() {
        // emit the resized event
        this.columnResized.emit({
            columnId: this.resizedColumn.id,
            widthPx: this.resizedColumn.widthPx,
            columnsWidth: this.internalHeaderColumns.map((c) => ({
                columnId: c.id,
                widthPx: c.widthPx,
                widthRatio: c.widthRatio,
            })),
        });
        this.resizing = false;
        this.resizedColumn = null;
    }
    /** Called when a column is being resized **/
    onDragMove(event, column) {
        // ignore vertical mouse moves
        if (event.diffX === 0) {
            return;
        }
        // check if our resized column has already a pixel width
        const internalColumn = this.internalHeaderColumns.find((c) => c.id === column.id);
        // convert the column width
        this._convertColumnWidthToPxUsingResizeStrategy(internalColumn, this.internalDataColumns, this.columnsResizeStrategy);
        // calc the new width of the datatable
        let newWidthPx = internalColumn.widthPx + event.diffX;
        // round to the min width if necessary
        if (newWidthPx < this.minColumnWidthPx && internalColumn.widthPx > this.minColumnWidthPx) {
            newWidthPx = this.minColumnWidthPx;
        }
        const shrinking = event.diffX < 0;
        const hasReachedMinColumnWidth = newWidthPx < this.minColumnWidthPx;
        // if we are expanding the col in min width state, wait for the initial diff X to be greater than 0
        if (shrinking && hasReachedMinColumnWidth) {
            this._resizedColumnDragOffsetLeftPx += event.diffX;
            return;
        }
        else if (!shrinking && this._resizedColumnDragOffsetLeftPx < 0) {
            this._resizedColumnDragOffsetLeftPx += event.diffX;
            return;
        }
        // if we have reach the min column width, do nothing
        if (hasReachedMinColumnWidth) {
            return;
        }
        // actually resize the column and re-render
        this._resizeColumn(internalColumn, newWidthPx);
    }
    /**
     * @ignore converts the specified column to px width.
     * Depending on the resize strategy, it may also convert other columns
     */
    _convertColumnWidthToPxUsingResizeStrategy(column, columns, stragegy) {
        const convertColumnWidthToPx = (c) => {
            const width = this._getHeaderColumnWidthPx(c);
            c.widthRatio = null;
            c.widthPx = width;
        };
        if (stragegy === 'preserve') {
            if (column.widthPx === undefined) {
                // if the width px is not defined, calculate the actual width in px and update the row
                convertColumnWidthToPx(column);
            }
        }
        else if (stragegy === 'fixed') {
            // convert all rows to a fixed width
            const hasColumnsWithRatio = columns.some((c) => !!c.widthRatio);
            if (hasColumnsWithRatio) {
                columns.forEach((c) => {
                    convertColumnWidthToPx(c);
                });
            }
        }
    }
    /** @ignore Return the width of the specified column **/
    _getHeaderColumnWidthPx(c) {
        return this.elementRef.nativeElement.querySelector(`.header-cell.dt-col-${this.internalHeaderColumns.indexOf(c)}`)?.clientWidth;
    }
    /** @ignore Resizes the specified column and re-render **/
    _resizeColumn(column, widthPx) {
        // update the current column with the new width
        column.widthPx = widthPx;
        // make change detection update the column
        this._applyColumnOverflowStrategy(this.bodyEl.nativeElement.clientWidth);
        // re-render the columns
        this._calcHeaderColumnsSizes();
        this._calcDataColumnsSizes();
    }
    /** Called when a column header is double clicked **/
    onColumnHeaderDoubleClicked(column) {
        // remember the current width px of the colum to see if it has actually changed
        const preResizeColumnWidth = column.widthPx;
        this._convertColumnWidthToPxUsingResizeStrategy(column, this.internalHeaderColumns, this.columnsResizeStrategy);
        // selector of the current data cells for the resized column
        const dataCellSelector = `.data-cell.dt-col-${this.internalHeaderColumns.indexOf(column)} > .data-cell-content`;
        // calc the spacing of the data cell
        const dataCellSpacing = ((cell) => {
            // include padding / margin of cell
            const styles = this._window.getComputedStyle(cell);
            const spacing = pxToNumber(styles.paddingLeft) + pxToNumber(styles.paddingRight) + pxToNumber(styles.marginLeft) + pxToNumber(styles.marginRight);
            return spacing;
        })(this.elementRef.nativeElement.querySelector(dataCellSelector));
        // function to calculate a cell width if it was not overflown
        const calcCellFullWidth = (cellEl) => {
            const getDataCellElementToCheck = (cell) => {
                // if no custom template is used, just return the first element as it will be a simple div
                if (!column.dataCellTemplate) {
                    return cell.firstElementChild;
                }
                // if a custom template is used, check if we are able to resize
                // if the sub element is a text directly then use it
                const textNodes = getChildrenNodesOfType(cell, Node.TEXT_NODE);
                if (!cell.firstElementChild && textNodes.length === 1) {
                    return textNodes[0];
                }
                // if no child at all, return
                if (!cell.firstElementChild) {
                    return null;
                }
                // if only ONE sub element with NOT a width of 100% use that element
                const onlyOneChildElement = cell.firstElementChild === cell.lastElementChild;
                const is100PercentWidth = cell.firstElementChild.width === cell.firstElementChild.scrollWidth;
                if (onlyOneChildElement && !is100PercentWidth) {
                    return cell.firstElementChild;
                }
                // otherwise we cant really know how to resize, so we will use the min width...
                return null;
            };
            // get the data cell element to check for size
            const element = getDataCellElementToCheck(cellEl);
            if (!element) {
                return dataCellSpacing;
            }
            // include padding / margin of cell and cell content element (if any)
            const dataCellContentStyle = this._window.getComputedStyle(element);
            let dataCellContentSpacing = pxToNumber(dataCellContentStyle.paddingLeft) +
                pxToNumber(dataCellContentStyle.paddingRight) +
                pxToNumber(dataCellContentStyle.marginLeft) +
                pxToNumber(dataCellContentStyle.marginRight);
            // add 1 px when the text overflow is set to ellipsis otherwise the dots are still showing...
            const extra = dataCellContentStyle.textOverflow === 'ellipsis' ? 1 : 0;
            dataCellContentSpacing += extra;
            return element.scrollWidth + dataCellSpacing + dataCellContentSpacing;
        };
        // get the max width of all visible cells if they would not overflow
        const cellNotOverflownWidths = [...this.elementRef.nativeElement.querySelectorAll(dataCellSelector)].map(calcCellFullWidth);
        const maxChildWidth = cellNotOverflownWidths.reduce((p, c) => (c > p ? c : p), 0);
        // make sure to respect the min width and resize
        const newColumnWidth = maxChildWidth > this.minColumnWidthPx ? maxChildWidth : this.minColumnWidthPx;
        // only re-render and emit event if the width has actually changed
        if (preResizeColumnWidth !== newColumnWidth) {
            this._resizeColumn(column, newColumnWidth);
            // emit the resized event
            this.columnResized.emit({
                columnId: column.id,
                widthPx: column.widthPx,
                columnsWidth: this.internalHeaderColumns.map((c) => ({
                    columnId: c.id,
                    widthPx: c.widthPx,
                    widthRatio: c.widthRatio,
                })),
            });
        }
    }
    /** @ignore Indicates if there is at least one sticky column (left or right) **/
    _hasAtLeastOneStickyColumn() {
        return this.internalHeaderColumns.some((c) => c.sticky);
    }
    /** @ignore Retrieves the left position in px of a column **/
    _getColumnLeftPositionPx(columnIndex) {
        return this._columnsWidthPx.filter((_, k) => k < columnIndex).reduce((p, c) => p + c, 0);
    }
    /** @ignore Retrieves the right position in px of a column **/
    _getColumnRightPositionPx(columnIndex) {
        return this._columnsWidthPx.filter((_, k) => k > columnIndex).reduce((p, c) => p + c, 0);
    }
    /** @ignore Updates he sticky columns separators **/
    _updateStickyInfo() {
        // update the scrolled positions
        this.scrolledLeftPx = this.virtualizedViewport?.measureScrollOffset('left');
        this.scrolledRightPx = this.virtualizedViewport?.measureScrollOffset('right');
        // update the sticky column separators if changed
        let hasChanged = false;
        const hasStickyInfoChanged = (prev, curr) => prev?.lastColumnIndex !== curr?.lastColumnIndex || prev?.totalStickyWidthPx !== curr?.totalStickyWidthPx;
        const leftStickyInfo = this._getLeftStickyInfo();
        if (hasStickyInfoChanged(this.currentLeftStickyInfo, leftStickyInfo)) {
            this.currentLeftStickyInfo = leftStickyInfo;
            hasChanged = true;
        }
        const rightStickyInfo = this._getRightStickyInfo();
        if (hasStickyInfoChanged(this.currentRightStickyInfo, rightStickyInfo)) {
            this.currentRightStickyInfo = rightStickyInfo;
            hasChanged = true;
        }
        const horizontalScrollActive = this.scrolledLeftPx > 0 || this.scrolledRightPx > 0;
        if (!this.horizontalScrollActive && horizontalScrollActive) {
            this.horizontalScrollActive = horizontalScrollActive;
            hasChanged = true;
        }
        if (hasChanged) {
            this._cdr.detectChanges();
        }
    }
    /**
     * @ignore
     * Retrieves info about current sticky columns on the left side
     * Determines which sticky columns should get the left sticky separator depending on the current scroll
     */
    _getLeftStickyInfo() {
        // if the table is not scrolled no need to show the separator
        for (let i = this.internalHeaderColumns.length - 1; i >= 0; i--) {
            const column = this.internalHeaderColumns[i];
            if (column.sticky && (!column.stickyPosition || column.stickyPosition === 'left')) {
                // get the column left position
                const stickyColumnLeftPx = this._getColumnLeftPositionPx(i);
                // withdraw any previous sticky column width from it
                const previousStickyColumnsWidth = Object.keys(this._stickyColumnsLeftWidthPx)
                    .filter((columnIndex) => Number(columnIndex) < i)
                    .reduce((p, c) => p + this._stickyColumnsLeftWidthPx[c], 0);
                // then compare to the scroll left to see if that column should have the separator
                const isLastStickyLeftColumn = this.scrolledLeftPx >= stickyColumnLeftPx - previousStickyColumnsWidth;
                if (isLastStickyLeftColumn) {
                    const totalStickyWidthPx = previousStickyColumnsWidth + this._stickyColumnsLeftWidthPx[i];
                    const viewportWidthPx = this.virtualizedViewport.elementRef.nativeElement.clientWidth;
                    // Calculate the maximum position Left arrow can take. It should be within the viewport of the data-table
                    const maxLeftPosition = viewportWidthPx - this.bodyScrollbarWidth - this.arrowIconSize - 15; // '15' is a margin
                    return {
                        lastColumnIndex: this.scrolledLeftPx === 0 ? null : i,
                        totalStickyWidthPx: Math.min(totalStickyWidthPx, maxLeftPosition),
                    };
                }
            }
        }
        return null;
    }
    /** @ignore Retrieves info about current sticky columns on the right side **/
    _getRightStickyInfo() {
        const scrolledRight = this.scrolledRightPx;
        // for each sticky row (starting with the last one)
        for (let i = 0; i <= this.internalHeaderColumns.length - 1; i++) {
            const column = this.internalHeaderColumns[i];
            if (column.sticky && column.stickyPosition === 'right') {
                // get the column left position
                const stickyColumnRightPx = this._getColumnRightPositionPx(i);
                // withdraw any previous sticky column width from it
                const previousStickyColumnsWidth = Object.keys(this._stickyColumnsRightWidthPx)
                    .filter((columnIndex) => Number(columnIndex) > i)
                    .reduce((p, c) => p + this._stickyColumnsRightWidthPx[c], 0);
                // then compare to the scroll right to see if that column should have the separator
                const isLastStickyRightColumn = scrolledRight >= stickyColumnRightPx - previousStickyColumnsWidth;
                if (isLastStickyRightColumn) {
                    return {
                        lastColumnIndex: scrolledRight > 0 ? i : null,
                        totalStickyWidthPx: previousStickyColumnsWidth + this._stickyColumnsRightWidthPx[i],
                    };
                }
            }
        }
        return null;
    }
    /** Scrolls to the previous column **/
    onNavigateLeft() {
        if (this.scrolledLeftPx <= 0) {
            return;
        }
        const totalStickyWidthPx = this.currentLeftStickyInfo?.totalStickyWidthPx || 0;
        const previousColumn = this._getColumnsPositionInfo().find((columnPosition) => {
            const inVisibleViewport = columnPosition.absoluteLeftPositionEnd >= totalStickyWidthPx;
            if (inVisibleViewport) {
                // if its right next to the last right sticky col (fully visible)
                if (columnPosition.absoluteLeftPositionStart === totalStickyWidthPx) {
                    return columnPosition;
                }
                // if its over the last left sticky col (half visible)
                if (columnPosition.absoluteLeftPositionStart < totalStickyWidthPx) {
                    return columnPosition;
                }
            }
        });
        if (previousColumn) {
            const widthHiddenByStickyColumns = totalStickyWidthPx - previousColumn.absoluteLeftPositionStart;
            const newScrollLeft = this.scrolledLeftPx - widthHiddenByStickyColumns;
            if (this.headerEl) {
                this.headerEl.nativeElement.scrollLeft = newScrollLeft;
            }
            this.virtualizedViewport.scrollTo({ left: newScrollLeft });
            this.columnNavigated.emit(previousColumn.columnIndex);
        }
    }
    /** Scrolls to the next column **/
    onNavigateRight() {
        if (this.scrolledRightPx === 0) {
            return;
        }
        const totalStickyWidthPx = this.currentRightStickyInfo?.totalStickyWidthPx || 0;
        const nextColumn = this._getColumnsPositionInfo().find((columnPosition) => {
            const inVisibleViewport = columnPosition.absoluteRightPositionEnd >= totalStickyWidthPx;
            if (inVisibleViewport) {
                // if its right next to the last right sticky col (fully visible)
                if (columnPosition.absoluteRightPositionEnd === totalStickyWidthPx) {
                    return columnPosition;
                }
                // if its over the last right sticky col (half visible)
                if (columnPosition.absoluteRightPositionStart < totalStickyWidthPx) {
                    return columnPosition;
                }
            }
        });
        if (nextColumn) {
            const widthHiddenByStickyColumns = totalStickyWidthPx - nextColumn.absoluteRightPositionStart;
            const newScrollLeft = this.scrolledLeftPx + widthHiddenByStickyColumns;
            if (this.headerEl) {
                this.headerEl.nativeElement.scrollLeft = newScrollLeft;
            }
            this.virtualizedViewport.scrollTo({ left: newScrollLeft });
            this.columnNavigated.emit(nextColumn.columnIndex);
        }
    }
    /** @ignore Retrieves info about current columns positions **/
    _getColumnsPositionInfo() {
        const totalColumnWidths = this.virtualizedViewport.elementRef.nativeElement.scrollWidth;
        const viewportWidth = this.virtualizedViewport.elementRef.nativeElement.clientWidth;
        return this._columnsWidthPx.map((columnWidth, i) => {
            const leftPosition = this._getColumnLeftPositionPx(i);
            const absoluteLeftPositionStart = leftPosition - this.scrolledLeftPx;
            const absoluteLeftPositionEnd = absoluteLeftPositionStart + columnWidth;
            const absoluteRightPositionEnd = viewportWidth - absoluteLeftPositionStart;
            const absoluteRightPositionStart = absoluteRightPositionEnd - columnWidth;
            return {
                columnIndex: i,
                columnWidth,
                leftPosition,
                rightPosition: totalColumnWidths - leftPosition - columnWidth,
                absoluteLeftPositionStart,
                absoluteLeftPositionEnd,
                absoluteRightPositionStart,
                absoluteRightPositionEnd,
            };
        });
    }
    /** Returns the selected rows **/
    get selectedRows() {
        return this._store.selectedItems;
    }
    /** Indicates when the horizontal loader should show **/
    get showLinearLoader() {
        if (this.showBlockUILoader) {
            return false;
        }
        return (this.initialDataLoader === 'linear-loader' || this._store.hasRecords) && (this.forceLoadingState || this._store.isPendingData);
    }
    /** Indicates when the block UI loader should show **/
    get showBlockUILoader() {
        return this.initialDataLoader === 'block-ui-loader' && !this._store.hasRecords && (this.forceLoadingState || this._store.isPendingData);
    }
    get isLoading() {
        return this.forceLoadingState || this._store.isPendingData;
    }
    /** Indicates if the tooltip is enabled for the specified column **/
    isHeaderTooltipEnabled(column) {
        return this.headerTooltipsEnabled && !!column.description;
    }
    /** Indicates if the column is actionable **/
    isHeaderColumnActionable(column) {
        return column.sortable || column.draggable || column.resizable;
    }
    /** Called when the header is hovered **/
    onHeaderHovered(hovered) {
        this.headerHovered = hovered;
    }
    /** Called when the virtual scroll viewport is scrolled **/
    onVirtualScrollViewportScrolled(event) {
        if (event.direction === 'vertical') {
            this._onViewportVerticalScroll();
        }
        else {
            this._onViewportHorizontalScroll(event.event);
        }
    }
    /** @ignore Called when the virtual scroll viewport is scrolled vertically **/
    _onViewportVerticalScroll() {
        // do nothing for static datasources
        if (!this.infiniteScrollEnabled) {
            return;
        }
        this._store.onMaxRenderedItemIndexChange(this.virtualizedViewport.getRenderedRange().end);
    }
    /** @ignore Called when the virtual scroll viewport is scrolled horizontally **/
    _onViewportHorizontalScroll(event) {
        const scrollLeft = event.target.scrollLeft;
        if (scrollLeft < 0) {
            return;
        }
        // update the scroll positions
        this.scrolledLeftPx = scrollLeft;
        this.scrolledRightPx = this.virtualizedViewport.measureScrollOffset('right');
        if (this.headerEl) {
            this.headerEl.nativeElement.scrollLeft = this.scrolledLeftPx;
        }
        // recalculate the sticky info if needed
        if (this._hasAtLeastOneStickyColumn()) {
            this._updateStickyInfo();
        }
    }
    isChecked(evt) {
        return evt.target.checked;
    }
    /** @ignore */
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: WINDOW }, { token: MediaBreakpointStore }, { token: InfiniteScrollComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DataTableComponent, selector: "avn-data-table", inputs: { customLoaderTemplate: "customLoaderTemplate", columns: "columns", dataSource: "dataSource", dataSourceConfig: "dataSourceConfig", selectedItemIds: "selectedItemIds", dragDropRowsEnabled: "dragDropRowsEnabled", headerCellTemplate: "headerCellTemplate", tableHeight: "tableHeight", tableMaxHeight: "tableMaxHeight", headerHeight: "headerHeight", footerHeight: "footerHeight", footerTemplate: "footerTemplate", rowHeight: "rowHeight", dataRowVerticalAlign: "dataRowVerticalAlign", infiniteScrollPreloadStrategy: "infiniteScrollPreloadStrategy", infiniteScrollPreloadValue: "infiniteScrollPreloadValue", pageSize: "pageSize", serverSorting: "serverSorting", sortBy: "sortBy", selectionMode: "selectionMode", themeIndicatorWidthPx: "themeIndicatorWidthPx", forceLoadingState: "forceLoadingState", loaderTheme: "loaderTheme", horizontalLoaderPosition: "horizontalLoaderPosition", keyboardNavigationEnabled: "keyboardNavigationEnabled", rowClassFn: "rowClassFn", showHeader: "showHeader", isStaticDataSource: "isStaticDataSource", infiniteScrollEnabled: "infiniteScrollEnabled", minColumnWidthPx: "minColumnWidthPx", columnsResizeStrategy: "columnsResizeStrategy", showHorizontalScrollArrows: "showHorizontalScrollArrows", indexTrackFn: "indexTrackFn", templateCacheSize: "templateCacheSize", headerTooltipsEnabled: "headerTooltipsEnabled", columnsOverflowStrategy: "columnsOverflowStrategy", initialDataLoader: "initialDataLoader" }, outputs: { fetchData: "fetchData", columnSorted: "columnSorted", columnReordered: "columnReordered", entireDataSetSelected: "entireDataSetSelected", selectionChanged: "selectionChanged", rowClicked: "rowClicked", rowDoubleClicked: "rowDoubleClicked", rowActivated: "rowActivated", notificationMessageClicked: "notificationMessageClicked", dataLoaded: "dataLoaded", columnResized: "columnResized", columnNavigated: "columnNavigated" }, host: { properties: { "tabindex": "this.tabindex", "class.auto-height": "this.isAutoHeight" } }, providers: [InfiniteScrollComponentStore], queries: [{ propertyName: "dataTableNotificationMessageComponent", first: true, predicate: DataTableNotificationMessageComponent, descendants: true }], viewQueries: [{ propertyName: "_multiSelectionHeaderTemplate", first: true, predicate: ["multiSelectionHeaderTemplate"], descendants: true, static: true }, { propertyName: "_multiSelectionDataTemplate", first: true, predicate: ["multiSelectionDataTemplate"], descendants: true, static: true }, { propertyName: "_singleSelectionDataTemplate", first: true, predicate: ["singleSelectionDataTemplate"], descendants: true, static: true }, { propertyName: "_themeIndicatorTemplate", first: true, predicate: ["themeIndicatorTemplate"], descendants: true, static: true }, { propertyName: "headerEl", first: true, predicate: ["header"], descendants: true }, { propertyName: "bodyEl", first: true, predicate: ["body"], descendants: true }, { propertyName: "virtualizedViewport", first: true, predicate: ["virtualizedViewport"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"model$ | async as vm\">\n  <ng-container *ngIf=\"hasDataColumns\">\n    <div\n      *ngIf=\"showHeader\"\n      #header\n      class=\"header\"\n      [style.height.px]=\"headerHeight\"\n      cdkDropList\n      cdkDropListOrientation=\"horizontal\"\n      (cdkDropListDropped)=\"onColumnReordered($event)\"\n      (cdkDropListSorted)=\"onColumnReordering($event)\"\n      (mouseenter)=\"onHeaderHovered(true)\"\n      (mouseleave)=\"onHeaderHovered(false)\"\n    >\n      <ng-container *ngFor=\"let column of internalHeaderColumns; index as i\">\n        <!-- edge columns should not have the cdkDrag directive. cdkDragDisabled will still allow to have it switched to another col -->\n        <ng-container\n          *ngTemplateOutlet=\"\n            !column.draggable && i === internalHeaderColumns.length - 1 ? headerCellWithNoCdkDrag : headerCellWithCdkDrag;\n            context: { column: column, columnIndex: i }\n          \"\n        >\n        </ng-container>\n        <ng-template #headerCellWithNoCdkDrag let-column=\"column\" let-columnIndex=\"columnIndex\">\n          <div\n            class=\"header-cell\"\n            [ngClass]=\"'dt-col-' + columnIndex\"\n            [class.sort]=\"vm.sort?.id === column.id\"\n            [class.sticky]=\"column.sticky\"\n            [class.theme-indicator]=\"column.id === 'theme'\"\n            [style.left]=\"column.sticky && (!column.stickyPosition || column.stickyPosition === 'left') ? 'var(--column-sticky-left-' + columnIndex + ')' : null\"\n            [style.right]=\"column.sticky && column.stickyPosition === 'right' ? 'var(--column-sticky-right-header-' + columnIndex + ')' : null\"\n            [avnTooltip]=\"column.description?.constructor.name === 'String' ? column.description : (column.description | async)\"\n            [tooltipDisabled]=\"!isHeaderTooltipEnabled(column)\"\n            [tooltipPlacement]=\"PlacementTypes.bottom\"\n            [class.hover-background]=\"isHeaderColumnActionable(column) || isHeaderTooltipEnabled(column)\"\n          >\n            <ng-container *ngTemplateOutlet=\"headerCellTemplateEl; context: { column: column, columnIndex: columnIndex }\"></ng-container>\n          </div>\n        </ng-template>\n        <ng-template #headerCellWithCdkDrag let-column=\"column\" let-columnIndex=\"columnIndex\">\n          <div\n            class=\"header-cell\"\n            [ngClass]=\"'dt-col-' + columnIndex\"\n            cdkDrag\n            [cdkDragDisabled]=\"!column.draggable\"\n            [class.sort]=\"vm.sort?.id === column.id\"\n            [class.sticky]=\"column.sticky\"\n            [class.theme-indicator]=\"column.id === 'theme'\"\n            [style.left]=\"column.sticky && (!column.stickyPosition || column.stickyPosition === 'left') ? 'var(--column-sticky-left-' + columnIndex + ')' : null\"\n            [style.right]=\"column.sticky && column.stickyPosition === 'right' ? 'var(--column-sticky-right-header-' + columnIndex + ')' : null\"\n            [avnTooltip]=\"column.description?.constructor.name === 'String' ? column.description : (column.description | async)\"\n            [tooltipDisabled]=\"!isHeaderTooltipEnabled(column)\"\n            [tooltipPlacement]=\"PlacementTypes.bottom\"\n            [class.with-open-sortpanel]=\"column.sortableFields && openedSortPanel === column.id\"\n            [class.hover-background]=\"isHeaderColumnActionable(column) || isHeaderTooltipEnabled(column)\"\n          >\n            <ng-container *ngTemplateOutlet=\"headerCellTemplateEl; context: { column: column, columnIndex: columnIndex }\"></ng-container>\n          </div>\n        </ng-template>\n        <ng-template #headerCellTemplateEl let-column=\"column\" let-columnIndex=\"columnIndex\">\n          <div class=\"header-cell-content\">\n            <ng-container *ngIf=\"headerCellTemplate || column.headerCellTemplate; else headerCellTextTemplate\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  column.headerCellTemplate || headerCellTemplate;\n                  context: { name: column.name, columnIndex: columnIndex, totalRowCount: vm.dataSource?.total || 0 }\n                \"\n              ></ng-container>\n            </ng-container>\n            <ng-template #headerCellTextTemplate>\n              {{ column.name?.constructor.name === 'String' ? column.name : (column.name | async) }}\n            </ng-template>\n          </div>\n          <ng-container *ngIf=\"column.sortable\">\n            <ng-container *ngIf=\"column.sortableFields; else simpleSortIcon\">\n              <avn-icon\n                class=\"sort-icon\"\n                [class.active]=\"isHeaderSortActive(column)\"\n                [class.desc]=\"isHeaderSortActive(column) && vm.sort?.direction === 'desc'\"\n                icon=\"navigation:arrow_downward\"\n                [fontSize]=\"18\"\n                #overlayOriginIcon=\"cdkOverlayOrigin\"\n                cdkOverlayOrigin\n                (click)=\"onSortHeaderClick(column)\"\n              ></avn-icon>\n              <avn-connected-element\n                #connectedElement\n                [width]=\"250\"\n                [overlayOrigin]=\"overlayOriginIcon\"\n                [opened]=\"openedSortPanel === column.id\"\n                (toggled)=\"onSortPanelToggled(column.id, $event)\"\n                [hasOverlayBackdrop]=\"false\"\n              >\n                <avn-option-list\n                  class=\"sort-field-list\"\n                  [virtualization]=\"false\"\n                  [options]=\"column.sortableFields || [] | toSelectOption: 'prop':'label'\"\n                  [selectedOptions]=\"column.sortableFields | applyFunction: getSortPanelSelectedOptions:[]:this\"\n                  [optionsTemplate]=\"sortColumnTemplate\"\n                  [optionHeight]=\"45\"\n                >\n                </avn-option-list>\n              </avn-connected-element>\n            </ng-container>\n            <ng-template #simpleSortIcon>\n              <avn-icon\n                class=\"sort-icon\"\n                [class.active]=\"isHeaderSortActive(column)\"\n                [class.desc]=\"isHeaderSortActive(column) && vm.sort?.direction === 'desc'\"\n                icon=\"navigation:arrow_downward\"\n                [fontSize]=\"18\"\n                (click)=\"onSortHeaderClick(column)\"\n              ></avn-icon>\n            </ng-template>\n\n            <ng-template #sortColumnTemplate let-option=\"option\">\n              <div class=\"sort-field\">\n                <div>{{ option.label }}</div>\n                <div>\n                  <avn-icon\n                    [class.active]=\"isActiveSortProperty(option.value, 'asc')\"\n                    icon=\"navigation:arrow_downward\"\n                    [fontSize]=\"18\"\n                    (click)=\"onColumnSort(column.id, option.value, 'asc')\"\n                  ></avn-icon>\n                  <avn-icon\n                    [class.active]=\"isActiveSortProperty(option.value, 'desc')\"\n                    icon=\"navigation:arrow_upward\"\n                    [fontSize]=\"18\"\n                    (click)=\"onColumnSort(column.id, option.value, 'desc')\"\n                  ></avn-icon>\n                </div>\n              </div>\n            </ng-template>\n          </ng-container>\n\n          <div\n            [id]=\"column.id\"\n            *ngIf=\"column.resizable || (column.sticky && column.stickyPosition !== 'right')\"\n            class=\"column-separator header right\"\n            [class.resizable]=\"column.resizable\"\n            [class.show]=\"columnIndex === currentLeftStickyInfo?.lastColumnIndex || (column.resizable && !vm.pendingData && (headerHovered || resizing))\"\n            [class.resized]=\"resizedColumn && column.id === resizedColumn.id\"\n            avnDrag\n            (dragStart)=\"onDragStart(column)\"\n            (dragMove)=\"onDragMove($event, column)\"\n            (dragEnd)=\"onDragEnd()\"\n            [debounceTime]=\"0\"\n            (avnMultiClick)=\"onColumnHeaderDoubleClicked(column)\"\n            [clickTime]=\"400\"\n          ></div>\n          <div *ngIf=\"columnIndex === currentRightStickyInfo?.lastColumnIndex\" class=\"column-separator header left\"></div>\n        </ng-template>\n      </ng-container>\n      <div class=\"scroll-offset-column\" *ngIf=\"bodyScrollbarWidth > 0\" [style.width.px]=\"bodyScrollbarWidth\" [class.sticky]=\"hasAtLeastOneStickyRightColumn\"></div>\n      <div class=\"firefox-fix\"></div>\n    </div>\n    <div\n      #body\n      class=\"body\"\n      [ngClass]=\"getBodyClassName()\"\n      [style.height]=\"tableBodyHeight\"\n      [style.maxHeight]=\"tableMaxBodyHeight\"\n      (avnResize)=\"onBodyResize($event)\"\n      [emitInitialEvent]=\"true\"\n      [debounceTime]=\"200\"\n    >\n      <cdk-virtual-scroll-viewport\n        #virtualizedViewport\n        role=\"listbox\"\n        class=\"table-vscroll-viewport\"\n        [itemSize]=\"rowHeight\"\n        avnScroll\n        [avnScrollEmitScrollEvent]=\"true\"\n        (scrolled)=\"onVirtualScrollViewportScrolled($event)\"\n      >\n        <div\n          [attr.data-e2e]=\"'data-row-' + rowIndex\"\n          class=\"data-row\"\n          (click)=\"onRowClick(rowIndex, row, $event)\"\n          (dblclick)=\"onRowDoubleClick(rowIndex, row, $event)\"\n          *cdkVirtualFor=\"let row of vm.dataSource?.data; templateCacheSize: templateCacheSize; trackBy: indexTrackFn; index as rowIndex\"\n          [style.height]=\"rowHeight + 'px'\"\n          [class.odd]=\"(rowIndex + 1) % 2 === 1\"\n          [class.even]=\"(rowIndex + 1) % 2 === 0\"\n          [class.selected]=\"isRowSelected(row)\"\n          [class.active]=\"activeRow?.index === rowIndex\"\n          [class.clickable]=\"rowClicked.observers.length > 0\"\n          [class.disabled]=\"row.datatableRowOptions?.disabled\"\n          [ngClass]=\"rowClassFn ? rowClassFn(row) : undefined\"\n          [avnDragDropElementOrigin]=\"row.datatableRowOptions?.dragOriginId\"\n          [avnDragDropElementOriginData]=\"row\"\n          [avnDragDropElementOriginDisabled]=\"row.datatableRowOptions?.disabled ? true : !dragDropRowsEnabled\"\n        >\n          <div\n            class=\"data-cell\"\n            *ngFor=\"let column of internalDataColumns; index as columnIndex\"\n            [attr.data-e2e]=\"'data-cell-' + columnIndex\"\n            [ngClass]=\"'dt-col-' + columnIndex\"\n            [class.sticky]=\"column.sticky\"\n            [style.left]=\"column.sticky && (!column.stickyPosition || column.stickyPosition === 'left') ? 'var(--column-sticky-left-' + columnIndex + ')' : null\"\n            [style.right]=\"column.sticky && column.stickyPosition === 'right' ? 'var(--column-sticky-right-data-' + columnIndex + ')' : null\"\n            [style.background-color]=\"column.id === 'theme' && row.datatableRowOptions?.theme ? 'var(--' + row.datatableRowOptions.theme + '-base)' : 'inherit'\"\n          >\n            <div\n              class=\"data-cell-content\"\n              [class.center]=\"column.horizontalAlign === 'center'\"\n              [class.right]=\"column.horizontalAlign === 'right'\"\n              [class.theme-indicator]=\"column.id === 'theme'\"\n              [style.padding]=\"column.padding\"\n            >\n              <ng-container *ngIf=\"!column.dataCellTemplate; else dataCellTemplateEl\">\n                <div>\n                  {{ row | nestedProperty: column.prop:column.pipe }}\n                </div>\n              </ng-container>\n              <ng-template #dataCellTemplateEl\n                ><ng-container\n                  *ngTemplateOutlet=\"\n                    column.dataCellTemplate;\n                    context: { row: row, rowIndex: rowIndex, column: column, selectedItems: vm.selectedItems, selectedItemIds: vm.selectedItemIds }\n                  \"\n                ></ng-container\n              ></ng-template>\n            </div>\n            <div\n              *ngIf=\"column.resizable || (column.sticky && column.stickyPosition !== 'right')\"\n              class=\"column-separator data right\"\n              [id]=\"column.id\"\n              [class.resizable]=\"column.resizable\"\n              [class.show]=\"columnIndex === currentLeftStickyInfo?.lastColumnIndex || (column.resizable && !vm.pendingData && (headerHovered || resizing))\"\n              [class.resized]=\"resizedColumn && column.id === resizedColumn.id\"\n            ></div>\n            <div *ngIf=\"columnIndex === currentRightStickyInfo?.lastColumnIndex && vm.dataSource.data?.length > 0\" class=\"column-separator data left\"></div>\n          </div>\n        </div>\n      </cdk-virtual-scroll-viewport>\n      <avn-icon\n        *ngIf=\"showHorizontalScrollArrows\"\n        [fontSize]=\"arrowIconSize\"\n        data-e2e=\"data-table-navigation-arrow-left\"\n        class=\"navigation-arrow left\"\n        icon=\"navigation:chevron_left\"\n        [class.mobile]=\"isMobileDevice$ | async\"\n        [class.visible]=\"scrolledLeftPx > 0 && vm.dataSource?.total > 0\"\n        [style.left.px]=\"currentLeftStickyInfo?.totalStickyWidthPx || 0\"\n        avnLongPress\n        (touchstart)=\"onNavigateLeft()\"\n        (mousedown)=\"onNavigateLeft()\"\n        (longPress)=\"onNavigateLeft()\"\n        [longPressIntervalTimeMs]=\"100\"\n        [longPressActive]=\"scrolledLeftPx > 0\"\n      >\n      </avn-icon>\n      <avn-icon\n        *ngIf=\"showHorizontalScrollArrows\"\n        [fontSize]=\"arrowIconSize\"\n        data-e2e=\"data-table-navigation-arrow-right\"\n        class=\"navigation-arrow right\"\n        icon=\"navigation:chevron_right\"\n        [class.mobile]=\"isMobileDevice$ | async\"\n        [class.visible]=\"scrolledRightPx > 0 && vm.dataSource?.total > 0\"\n        [style.right.px]=\"currentRightStickyInfo?.totalStickyWidthPx || 0\"\n        avnLongPress\n        (touchend)=\"onNavigateRight()\"\n        (mousedown)=\"onNavigateRight()\"\n        (longPress)=\"onNavigateRight()\"\n        [longPressIntervalTimeMs]=\"100\"\n        [longPressActive]=\"scrolledRightPx > 0\"\n      >\n      </avn-icon>\n    </div>\n    <div #footer class=\"footer\" *ngIf=\"!!footerTemplate\" [style.height.px]=\"footerHeight\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          footerTemplate;\n          context: {\n            dataRowCount: vm.dataSource?.data?.length,\n            totalRowCount: vm.dataSource?.total\n          }\n        \"\n      ></ng-container>\n    </div>\n  </ng-container>\n\n  <ng-content select=\"avn-empty-data-message[columns]\" *ngIf=\"!isLoading && !hasDataColumns\"></ng-content>\n  <ng-content select=\"avn-empty-data-message\" *ngIf=\"!isLoading && hasDataColumns && !vm.hasRecords\"></ng-content>\n\n  <!-- Projects custom loader template into datatable -->\n  <ng-container *ngTemplateOutlet=\"customLoaderTemplate\"></ng-container>\n\n  <!-- default loader is applied in case there is no customLoaderTemplate -->\n  <ng-container *ngIf=\"!customLoaderTemplate\">\n    <avn-linear-loader [show]=\"showLinearLoader\" [theme]=\"loaderTheme\" [position]=\"horizontalLoaderPosition\"></avn-linear-loader>\n    <avn-loader [isLoading]=\"showBlockUILoader\" [avnTheme]=\"loaderTheme\"></avn-loader>\n  </ng-container>\n\n  <avn-data-table-notification-message\n    [show]=\"(allItemsSelectionEnabled$ | async) && (entireDataSetSelected$ | async) === false\"\n    [text]=\"vm.selectedItemsCount + ' rows are selected. Select all ' + vm.dataSource?.total + ' rows'\"\n    [actionText]=\"'Select All'\"\n    [offsetY]=\"10\"\n    (clicked)=\"onSelectEntireDataSet()\"\n  >\n  </avn-data-table-notification-message>\n\n  <ng-content select=\"avn-data-table-notification-message\"></ng-content>\n</ng-container>\n\n<ng-template #multiSelectionHeaderTemplate let-totalRowCount=\"totalRowCount\">\n  <avn-checkbox\n    data-e2e=\"select-all\"\n    *ngIf=\"totalRowCount > 0\"\n    (click)=\"$event.stopPropagation()\"\n    (change)=\"onSelectAllRows(isChecked($event))\"\n    [checked]=\"allItemsSelectionEnabled$ | async\"\n    [disabled]=\"areAllItemsDisabled$ | async\"\n  ></avn-checkbox>\n</ng-template>\n<ng-template #multiSelectionDataTemplate let-row=\"row\">\n  <avn-checkbox\n    data-e2e=\"select-row\"\n    (click)=\"$event.stopPropagation()\"\n    (change)=\"onSelectRow(isChecked($event), row)\"\n    [checked]=\"isRowSelected(row)\"\n    [disabled]=\"row.datatableRowOptions?.disabled\"\n  ></avn-checkbox>\n</ng-template>\n<ng-template #singleSelectionDataTemplate let-row=\"row\" let-rowIndex=\"rowIndex\">\n  <avn-radio-group name=\"singleSelectedItem\">\n    <avn-radio\n      data-e2e=\"select-row\"\n      [disabled]=\"isSingleSelectionRadioDisabled(row)\"\n      [checked]=\"isRowSelected(row)\"\n      [value]=\"rowIndex\"\n      (click)=\"$event.stopPropagation()\"\n      (change)=\"onSelectSingleRow(rowIndex, row)\"\n    ></avn-radio>\n  </avn-radio-group>\n</ng-template>\n\n<ng-template #themeIndicatorTemplate let-row=\"row\">\n  <div data-e2e=\"theme-indicator\"></div>\n</ng-template>\n", styles: [".sort-field-list ::ng-deep avn-option:not(.group).selected:not(.disabled){color:var(--selection-component-hover-on);background-color:var(--selection-component-hover-background)}.sort-field-list .active{color:var(--data-table-sort-icon-active)}.sort-field-list .sort-field{display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;width:100%}.sort-field-list .sort-field>div:nth-child(2){display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-column-gap:var(--space-xs)}.sort-field-list .sort-field>div:nth-child(2) avn-icon:hover{color:var(--data-table-sort-icon-active)}:host{--column-count: 0;--column-sizes-header: 0;--column-sizes-data: 0;display:block;position:relative}:host.theme-primary .data-row:hover{color:var(--primary-on)!important;background-color:var(--primary-base)!important}:host.theme-primary .data-row.selected,:host.theme-primary .data-row.active{background-color:var(--primary-variant)!important;color:var(--primary-variant-on)!important}:host.theme-primary .column-separator.show.resized:after{border-color:var(--primary-base)!important}:host.theme-secondary .data-row:hover{color:var(--secondary-on)!important;background-color:var(--secondary-base)!important}:host.theme-secondary .data-row.selected,:host.theme-secondary .data-row.active{background-color:var(--secondary-variant)!important;color:var(--secondary-variant-on)!important}:host.theme-secondary .column-separator.show.resized:after{border-color:var(--secondary-base)!important}:host.theme-highlight .data-row:hover{color:var(--highlight-on)!important;background-color:var(--highlight-base)!important}:host.theme-highlight .data-row.selected,:host.theme-highlight .data-row.active{background-color:var(--highlight-variant)!important;color:var(--highlight-variant-on)!important}:host.theme-highlight .column-separator.show.resized:after{border-color:var(--highlight-base)!important}:host.theme-danger .data-row:hover{color:var(--danger-on)!important;background-color:var(--danger-base)!important}:host.theme-danger .data-row.selected,:host.theme-danger .data-row.active{background-color:var(--danger-variant)!important;color:var(--danger-variant-on)!important}:host.theme-danger .column-separator.show.resized:after{border-color:var(--danger-base)!important}:host.theme-warning .data-row:hover{color:var(--warning-on)!important;background-color:var(--warning-base)!important}:host.theme-warning .data-row.selected,:host.theme-warning .data-row.active{background-color:var(--warning-variant)!important;color:var(--warning-variant-on)!important}:host.theme-warning .column-separator.show.resized:after{border-color:var(--warning-base)!important}:host.theme-info .data-row:hover{color:var(--info-on)!important;background-color:var(--info-base)!important}:host.theme-info .data-row.selected,:host.theme-info .data-row.active{background-color:var(--info-variant)!important;color:var(--info-variant-on)!important}:host.theme-info .column-separator.show.resized:after{border-color:var(--info-base)!important}:host.theme-success .data-row:hover{color:var(--success-on)!important;background-color:var(--success-base)!important}:host.theme-success .data-row.selected,:host.theme-success .data-row.active{background-color:var(--success-variant)!important;color:var(--success-variant-on)!important}:host.theme-success .column-separator.show.resized:after{border-color:var(--success-base)!important}:host-context(.dmb-aspect) :host .header{font-size:18px;font-weight:400;border-bottom:1px solid var(--data-table-row-border);border-top-left-radius:4px;border-top-right-radius:4px}:host-context(.dmb-aspect) :host .body{font-size:14px}:host-context(.dmb-aspect) :host .cdk-virtual-scroll-viewport{border-bottom-left-radius:4px;border-bottom-right-radius:4px}:host-context(.dmb-aspect) :host .header .header-cell:first-child,:host-context(.dmb-aspect) :host .body .header-cell:first-child{padding-left:calc(.5rem + 10px)}:host-context(.dmb-aspect) :host .header .data-row .data-cell:first-child,:host-context(.dmb-aspect) :host .body .data-row .data-cell:first-child{padding-left:10px}:host-context(.dmb-aspect) :host .header .data-row.clickable:not(.disabled),:host-context(.dmb-aspect) :host .body .data-row.clickable:not(.disabled){cursor:default}:host-context(.dmb-aspect) :host .header .data-row.selected,:host-context(.dmb-aspect) :host .body .data-row.selected{color:#000}:host-context(.dmb-aspect) :host .header .data-row.selected .data-cell:first-child:before,:host-context(.dmb-aspect) :host .body .data-row.selected .data-cell:first-child:before{content:\"\";position:absolute;width:6px;height:100%;left:0;top:0;background:var(--data-table-row-selected-on)}:host-context(.dmb-aspect) :host .header .data-row.selected:hover,:host-context(.dmb-aspect) :host .body .data-row.selected:hover{color:var(--data-table-row-selected-on);background-color:var(--data-table-row-selected-background)}:host-context(.dmb-aspect) :host .header .data-row.active:not(.selected).even,:host-context(.dmb-aspect) :host .body .data-row.active:not(.selected).even{background-color:var(--data-table-row-even-background)}:host-context(.dmb-aspect) :host .header .data-row.active:not(.selected).odd,:host-context(.dmb-aspect) :host .body .data-row.active:not(.selected).odd{background-color:var(--data-table-row-odd-background)}:host-context(.dmb-aspect) :host .header .data-row.active:not(.selected):hover,:host-context(.dmb-aspect) :host .body .data-row.active:not(.selected):hover{background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host .header .data-row.active,:host-context(.dmb-aspect) :host .body .data-row.active{font-weight:bolder}:host-context(.dmb-aspect) :host .header .data-row.active:hover:not(.disabled):not(.selected),:host-context(.dmb-aspect) :host .body .data-row.active:hover:not(.disabled):not(.selected){color:var(--data-table-row-hover-on);background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host .body.selectionmode-none .data-row.clickable{cursor:default}:host-context(.dmb-aspect) :host .body.selectionmode-single-no-radio .data-row,:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row{cursor:pointer}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row:not(.disabled){cursor:pointer}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.selected{color:#000}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.selected .data-cell:first-child:before{content:\"\";position:absolute;width:6px;height:100%;left:0;top:0;background:var(--data-table-row-selected-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.selected:hover{color:var(--data-table-row-selected-on);background-color:var(--data-table-row-selected-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:not(.selected).even{background-color:var(--data-table-row-even-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:not(.selected).odd{background-color:var(--data-table-row-odd-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:not(.selected):hover{background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active{font-weight:bolder}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:hover:not(.disabled):not(.selected){color:var(--data-table-row-hover-on);background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host ::ng-deep avn-empty-data-message{padding:18px;border-radius:4px;background:var(--data-table-header-background);color:var(--data-table-header-on)}:host .header{position:relative;display:grid;grid-template-columns:var(--column-sizes-header);grid-gap:0px;background-color:var(--data-table-header-background);color:var(--data-table-header-on);font-weight:500;overflow:hidden}:host .header>.header-cell{padding:var(--space-xs) var(--space-sm);display:flex;align-items:center;white-space:nowrap;position:relative;transition:background-color .2s cubic-bezier(0,0,.2,1)}:host .header>.header-cell.sticky{position:sticky;background-color:inherit;z-index:2}:host .header>.header-cell.theme-indicator{padding:0}:host .header>.header-cell>.header-cell-content{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-user-select:none;user-select:none;position:relative}:host .header>.header-cell.cdk-drag:not(.cdk-drag-disabled){cursor:move}:host .header>.header-cell.cdk-drag-placeholder{border:1px dashed silver;box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .header>.header-cell avn-icon.sort-icon{opacity:0;margin-left:var(--space-sm);cursor:pointer;transition:transform .2s cubic-bezier(0,0,.2,1),opacity .2s cubic-bezier(0,0,.2,1);transform:rotate(360deg)}:host .header>.header-cell avn-icon.sort-icon.desc{transform:rotate(180deg)}:host .header>.header-cell avn-icon.sort-icon:hover,:host .header>.header-cell avn-icon.sort-icon.active{color:var(--data-table-sort-icon-active)}:host .header>.header-cell.sort avn-icon.sort-icon,:host .header>.header-cell:hover avn-icon.sort-icon{opacity:1}:host .header>.header-cell.hover-background:hover{background:var(--data-table-header-hover-background);color:var(--data-table-header-hover-on)}:host .header>.header-cell.with-open-sortpanel{background:var(--data-table-header-hover-background);color:var(--data-table-header-hover-on)}:host .header>.header-cell.with-open-sortpanel avn-icon.sort-icon{opacity:1}:host .header .scroll-offset-column.sticky{position:sticky;right:0;background-color:inherit}:host .body{font-size:var(--text-sm);background-color:var(--data-table-body-background);color:var(--data-table-body-on)}:host .body .data-row{align-items:center;position:relative;display:grid;grid-gap:0px;grid-template-columns:var(--column-sizes-data);box-sizing:border-box}:host .body .data-row:not(:last-child):after{content:\"\";position:absolute;left:0;right:0;bottom:0;z-index:2;border-bottom:1px solid var(--data-table-row-border)}:host .body .data-row.even{background-color:var(--data-table-row-even-background)}:host .body .data-row.odd{background-color:var(--data-table-row-odd-background)}:host .body .data-row.active{color:var(--data-table-row-active-on);background-color:var(--data-table-row-active-background)}:host .body .data-row.active ::ng-deep avn-data-table-actions>avn-icon:not(.theme){color:var(--data-table-action-icon-active)}:host .body .data-row.selected{color:var(--data-table-row-selected-on);background-color:var(--data-table-row-selected-background)}:host .body .data-row.selected ::ng-deep avn-data-table-actions>avn-icon:not(.theme){color:var(--data-table-action-icon-selected)}:host .body .data-row.disabled{opacity:.5;cursor:not-allowed}:host .body .data-row:hover:not(.disabled){color:var(--data-table-row-hover-on);background-color:var(--data-table-row-hover-background)}:host .body .data-row:hover:not(.disabled) ::ng-deep avn-data-table-actions>avn-icon:not(.theme){color:var(--data-table-action-icon)}:host .body .data-row.clickable{cursor:pointer}:host .body .data-row .data-cell{height:100%;display:flex;align-items:center;position:relative;overflow:hidden}:host .body .data-row .data-cell.sticky{position:sticky;background-color:inherit;z-index:2}:host .body .data-row .data-cell>.data-cell-content{width:100%;padding:0px var(--space-sm);position:relative;display:flex;justify-content:flex-start;overflow:hidden}:host .body .data-row .data-cell>.data-cell-content.center{justify-content:center}:host .body .data-row .data-cell>.data-cell-content.right{justify-content:flex-end}:host .body .data-row .data-cell>.data-cell-content.theme-indicator{padding:0}:host .body .data-row .data-cell>.data-cell-content>div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .body.valign-top .data-row>.data-cell{align-items:flex-start}:host .body.valign-bottom .data-row>.data-cell{align-items:flex-end}:host .body .navigation-arrow{position:absolute;top:50%;transform:translateY(-50%);border-radius:50%;background-color:var(--data-table-navigation-icon-background);color:var(--data-table-navigation-icon);transition:opacity .2s cubic-bezier(0,0,.2,1);-webkit-user-select:none;user-select:none;opacity:0;z-index:-1;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f!important}:host .body .navigation-arrow.left{margin-left:var(--space-md)}:host .body .navigation-arrow.right{margin-right:var(--space-base)}:host .body .navigation-arrow.mobile.visible{opacity:.8;cursor:pointer;z-index:10}:host .body .navigation-arrow.mobile.visible:hover{background-color:var(--data-table-navigation-icon-hover-background);color:var(--data-table-navigation-icon-hover);opacity:1}:host .body:hover .navigation-arrow.visible{opacity:.8;cursor:pointer;z-index:10}:host .body:hover .navigation-arrow.visible:hover{background-color:var(--data-table-navigation-icon-hover-background);color:var(--data-table-navigation-icon-hover);opacity:1}:host .footer{background-color:var(--data-table-footer-background);color:var(--data-table-footer-on)}:host .cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}:host .cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host.auto-height{height:100%}:host cdk-virtual-scroll-viewport{height:100%}:host .column-separator{position:absolute;top:0;bottom:0;transform:translate(50%);z-index:1;width:1px;background:transparent}:host .column-separator:after{content:\"\";position:absolute;top:0;left:0;bottom:0;width:0px;transition:border-color .15s ease-in-out}:host .column-separator.resizable{width:8px}:host .column-separator.resizable.header{cursor:col-resize}:host .column-separator.resizable:after{left:calc(50% - 1px)}:host .column-separator.right{right:0}:host .column-separator.right:after{border-right:1px solid transparent}:host .column-separator.left{left:0}:host .column-separator.left:after{left:0;border-right:1px solid var(--data-table-resizer)}:host .column-separator.show:not(.left):after{border-right-color:var(--data-table-resizer)}:host .column-separator.show:not(.left).resized:after{border-right-color:var(--primary-base)}:host .sticky .column-separator{z-index:3}:host avn-linear-loader{z-index:4}:host .grid{width:100%;height:100%;display:grid;padding:var(--space-md);grid-gap:var(--space-md);transition:padding .12s cubic-bezier(0,0,.2,1)}:host .grid>*{height:100%}:host .grid.fullscreen{padding:0;height:100%;overflow:hidden}:host .grid.fullscreen>*{height:100%}:host ::ng-deep avn-empty-data-message{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: DragDirective, selector: "[avnDrag]", inputs: ["debounceTime", "allowOutsideMove", "axis", "cursor", "showDraggingOverlay"], outputs: ["dragStart", "dragMove", "dragEnd"] }, { kind: "directive", type: MultiClickDirective, selector: "[avnMultiClick]", inputs: ["clickCount", "clickTime"], outputs: ["avnMultiClick"] }, { kind: "directive", type: LongPressDirective, selector: "[avnLongPress]", inputs: ["longPressStartTimeMs", "longPressIntervalTimeMs", "longPressActive"], outputs: ["longPress", "longPressEnd"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "directive", type: DragDropElementOriginDirective, selector: "[avnDragDropElementOrigin]", inputs: ["avnDragDropElementOriginCursor", "avnDragDropElementOrigin", "avnDragDropElementOriginData", "avnDragDropElementOriginDisableGhostImage", "avnDragDropElementOriginDisabled", "avnDragDropElementOriginIndex", "avnDragDropElementOriginRef"], outputs: ["dragStart", "dragEnd"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: i2.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i2.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i2.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "directive", type: i4.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "component", type: CheckboxComponent, selector: "avn-checkbox", inputs: ["label", "indeterminate", "checked"], outputs: ["cbChange"] }, { kind: "component", type: RadioComponent, selector: "avn-radio", inputs: ["id", "label", "name", "disabled", "checked", "value"], outputs: ["change"] }, { kind: "component", type: RadioGroupComponent, selector: "avn-radio-group", inputs: ["isHorizontal", "disabled", "value", "name", "selected", "label"], outputs: ["change"] }, { kind: "component", type: LoaderComponent, selector: "avn-loader", inputs: ["durationBaseMs", "displayText", "icon", "fullOpacityOverlay", "isLoading"] }, { kind: "component", type: LinearLoaderComponent, selector: "avn-linear-loader", inputs: ["theme", "show", "position"] }, { kind: "directive", type: TooltipDirective, selector: "[avnTooltip]", inputs: ["avnTooltip", "tooltipName", "tooltipTemplate", "templateContext", "tooltipTheme", "tooltipPlacement", "tooltipMaxWidth", "tooltipDisabled", "tooltipTrigger", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipMouseLeaveCloseDelay", "tooltipMouseEnterOpenDelay"], outputs: ["show", "hide"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }, { kind: "component", type: OptionListComponent, selector: "avn-option-list", inputs: ["optionsTemplate", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "options", "selectionMode", "showCheckbox", "selectedOptions", "enableGroups"], outputs: ["optionClicked", "optionActivated", "selectionsChanged"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: DataTableNotificationMessageComponent, selector: "avn-data-table-notification-message", inputs: ["show", "text", "offsetY", "actionText", "actionIcon", "actionTheme"], outputs: ["clicked"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: NestedPropertyPipe, name: "nestedProperty" }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }, { kind: "pipe", type: ToSelectOptionPipe, name: "toSelectOption" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-data-table', changeDetection: ChangeDetectionStrategy.OnPush, providers: [InfiniteScrollComponentStore], template: "<ng-container *ngIf=\"model$ | async as vm\">\n  <ng-container *ngIf=\"hasDataColumns\">\n    <div\n      *ngIf=\"showHeader\"\n      #header\n      class=\"header\"\n      [style.height.px]=\"headerHeight\"\n      cdkDropList\n      cdkDropListOrientation=\"horizontal\"\n      (cdkDropListDropped)=\"onColumnReordered($event)\"\n      (cdkDropListSorted)=\"onColumnReordering($event)\"\n      (mouseenter)=\"onHeaderHovered(true)\"\n      (mouseleave)=\"onHeaderHovered(false)\"\n    >\n      <ng-container *ngFor=\"let column of internalHeaderColumns; index as i\">\n        <!-- edge columns should not have the cdkDrag directive. cdkDragDisabled will still allow to have it switched to another col -->\n        <ng-container\n          *ngTemplateOutlet=\"\n            !column.draggable && i === internalHeaderColumns.length - 1 ? headerCellWithNoCdkDrag : headerCellWithCdkDrag;\n            context: { column: column, columnIndex: i }\n          \"\n        >\n        </ng-container>\n        <ng-template #headerCellWithNoCdkDrag let-column=\"column\" let-columnIndex=\"columnIndex\">\n          <div\n            class=\"header-cell\"\n            [ngClass]=\"'dt-col-' + columnIndex\"\n            [class.sort]=\"vm.sort?.id === column.id\"\n            [class.sticky]=\"column.sticky\"\n            [class.theme-indicator]=\"column.id === 'theme'\"\n            [style.left]=\"column.sticky && (!column.stickyPosition || column.stickyPosition === 'left') ? 'var(--column-sticky-left-' + columnIndex + ')' : null\"\n            [style.right]=\"column.sticky && column.stickyPosition === 'right' ? 'var(--column-sticky-right-header-' + columnIndex + ')' : null\"\n            [avnTooltip]=\"column.description?.constructor.name === 'String' ? column.description : (column.description | async)\"\n            [tooltipDisabled]=\"!isHeaderTooltipEnabled(column)\"\n            [tooltipPlacement]=\"PlacementTypes.bottom\"\n            [class.hover-background]=\"isHeaderColumnActionable(column) || isHeaderTooltipEnabled(column)\"\n          >\n            <ng-container *ngTemplateOutlet=\"headerCellTemplateEl; context: { column: column, columnIndex: columnIndex }\"></ng-container>\n          </div>\n        </ng-template>\n        <ng-template #headerCellWithCdkDrag let-column=\"column\" let-columnIndex=\"columnIndex\">\n          <div\n            class=\"header-cell\"\n            [ngClass]=\"'dt-col-' + columnIndex\"\n            cdkDrag\n            [cdkDragDisabled]=\"!column.draggable\"\n            [class.sort]=\"vm.sort?.id === column.id\"\n            [class.sticky]=\"column.sticky\"\n            [class.theme-indicator]=\"column.id === 'theme'\"\n            [style.left]=\"column.sticky && (!column.stickyPosition || column.stickyPosition === 'left') ? 'var(--column-sticky-left-' + columnIndex + ')' : null\"\n            [style.right]=\"column.sticky && column.stickyPosition === 'right' ? 'var(--column-sticky-right-header-' + columnIndex + ')' : null\"\n            [avnTooltip]=\"column.description?.constructor.name === 'String' ? column.description : (column.description | async)\"\n            [tooltipDisabled]=\"!isHeaderTooltipEnabled(column)\"\n            [tooltipPlacement]=\"PlacementTypes.bottom\"\n            [class.with-open-sortpanel]=\"column.sortableFields && openedSortPanel === column.id\"\n            [class.hover-background]=\"isHeaderColumnActionable(column) || isHeaderTooltipEnabled(column)\"\n          >\n            <ng-container *ngTemplateOutlet=\"headerCellTemplateEl; context: { column: column, columnIndex: columnIndex }\"></ng-container>\n          </div>\n        </ng-template>\n        <ng-template #headerCellTemplateEl let-column=\"column\" let-columnIndex=\"columnIndex\">\n          <div class=\"header-cell-content\">\n            <ng-container *ngIf=\"headerCellTemplate || column.headerCellTemplate; else headerCellTextTemplate\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  column.headerCellTemplate || headerCellTemplate;\n                  context: { name: column.name, columnIndex: columnIndex, totalRowCount: vm.dataSource?.total || 0 }\n                \"\n              ></ng-container>\n            </ng-container>\n            <ng-template #headerCellTextTemplate>\n              {{ column.name?.constructor.name === 'String' ? column.name : (column.name | async) }}\n            </ng-template>\n          </div>\n          <ng-container *ngIf=\"column.sortable\">\n            <ng-container *ngIf=\"column.sortableFields; else simpleSortIcon\">\n              <avn-icon\n                class=\"sort-icon\"\n                [class.active]=\"isHeaderSortActive(column)\"\n                [class.desc]=\"isHeaderSortActive(column) && vm.sort?.direction === 'desc'\"\n                icon=\"navigation:arrow_downward\"\n                [fontSize]=\"18\"\n                #overlayOriginIcon=\"cdkOverlayOrigin\"\n                cdkOverlayOrigin\n                (click)=\"onSortHeaderClick(column)\"\n              ></avn-icon>\n              <avn-connected-element\n                #connectedElement\n                [width]=\"250\"\n                [overlayOrigin]=\"overlayOriginIcon\"\n                [opened]=\"openedSortPanel === column.id\"\n                (toggled)=\"onSortPanelToggled(column.id, $event)\"\n                [hasOverlayBackdrop]=\"false\"\n              >\n                <avn-option-list\n                  class=\"sort-field-list\"\n                  [virtualization]=\"false\"\n                  [options]=\"column.sortableFields || [] | toSelectOption: 'prop':'label'\"\n                  [selectedOptions]=\"column.sortableFields | applyFunction: getSortPanelSelectedOptions:[]:this\"\n                  [optionsTemplate]=\"sortColumnTemplate\"\n                  [optionHeight]=\"45\"\n                >\n                </avn-option-list>\n              </avn-connected-element>\n            </ng-container>\n            <ng-template #simpleSortIcon>\n              <avn-icon\n                class=\"sort-icon\"\n                [class.active]=\"isHeaderSortActive(column)\"\n                [class.desc]=\"isHeaderSortActive(column) && vm.sort?.direction === 'desc'\"\n                icon=\"navigation:arrow_downward\"\n                [fontSize]=\"18\"\n                (click)=\"onSortHeaderClick(column)\"\n              ></avn-icon>\n            </ng-template>\n\n            <ng-template #sortColumnTemplate let-option=\"option\">\n              <div class=\"sort-field\">\n                <div>{{ option.label }}</div>\n                <div>\n                  <avn-icon\n                    [class.active]=\"isActiveSortProperty(option.value, 'asc')\"\n                    icon=\"navigation:arrow_downward\"\n                    [fontSize]=\"18\"\n                    (click)=\"onColumnSort(column.id, option.value, 'asc')\"\n                  ></avn-icon>\n                  <avn-icon\n                    [class.active]=\"isActiveSortProperty(option.value, 'desc')\"\n                    icon=\"navigation:arrow_upward\"\n                    [fontSize]=\"18\"\n                    (click)=\"onColumnSort(column.id, option.value, 'desc')\"\n                  ></avn-icon>\n                </div>\n              </div>\n            </ng-template>\n          </ng-container>\n\n          <div\n            [id]=\"column.id\"\n            *ngIf=\"column.resizable || (column.sticky && column.stickyPosition !== 'right')\"\n            class=\"column-separator header right\"\n            [class.resizable]=\"column.resizable\"\n            [class.show]=\"columnIndex === currentLeftStickyInfo?.lastColumnIndex || (column.resizable && !vm.pendingData && (headerHovered || resizing))\"\n            [class.resized]=\"resizedColumn && column.id === resizedColumn.id\"\n            avnDrag\n            (dragStart)=\"onDragStart(column)\"\n            (dragMove)=\"onDragMove($event, column)\"\n            (dragEnd)=\"onDragEnd()\"\n            [debounceTime]=\"0\"\n            (avnMultiClick)=\"onColumnHeaderDoubleClicked(column)\"\n            [clickTime]=\"400\"\n          ></div>\n          <div *ngIf=\"columnIndex === currentRightStickyInfo?.lastColumnIndex\" class=\"column-separator header left\"></div>\n        </ng-template>\n      </ng-container>\n      <div class=\"scroll-offset-column\" *ngIf=\"bodyScrollbarWidth > 0\" [style.width.px]=\"bodyScrollbarWidth\" [class.sticky]=\"hasAtLeastOneStickyRightColumn\"></div>\n      <div class=\"firefox-fix\"></div>\n    </div>\n    <div\n      #body\n      class=\"body\"\n      [ngClass]=\"getBodyClassName()\"\n      [style.height]=\"tableBodyHeight\"\n      [style.maxHeight]=\"tableMaxBodyHeight\"\n      (avnResize)=\"onBodyResize($event)\"\n      [emitInitialEvent]=\"true\"\n      [debounceTime]=\"200\"\n    >\n      <cdk-virtual-scroll-viewport\n        #virtualizedViewport\n        role=\"listbox\"\n        class=\"table-vscroll-viewport\"\n        [itemSize]=\"rowHeight\"\n        avnScroll\n        [avnScrollEmitScrollEvent]=\"true\"\n        (scrolled)=\"onVirtualScrollViewportScrolled($event)\"\n      >\n        <div\n          [attr.data-e2e]=\"'data-row-' + rowIndex\"\n          class=\"data-row\"\n          (click)=\"onRowClick(rowIndex, row, $event)\"\n          (dblclick)=\"onRowDoubleClick(rowIndex, row, $event)\"\n          *cdkVirtualFor=\"let row of vm.dataSource?.data; templateCacheSize: templateCacheSize; trackBy: indexTrackFn; index as rowIndex\"\n          [style.height]=\"rowHeight + 'px'\"\n          [class.odd]=\"(rowIndex + 1) % 2 === 1\"\n          [class.even]=\"(rowIndex + 1) % 2 === 0\"\n          [class.selected]=\"isRowSelected(row)\"\n          [class.active]=\"activeRow?.index === rowIndex\"\n          [class.clickable]=\"rowClicked.observers.length > 0\"\n          [class.disabled]=\"row.datatableRowOptions?.disabled\"\n          [ngClass]=\"rowClassFn ? rowClassFn(row) : undefined\"\n          [avnDragDropElementOrigin]=\"row.datatableRowOptions?.dragOriginId\"\n          [avnDragDropElementOriginData]=\"row\"\n          [avnDragDropElementOriginDisabled]=\"row.datatableRowOptions?.disabled ? true : !dragDropRowsEnabled\"\n        >\n          <div\n            class=\"data-cell\"\n            *ngFor=\"let column of internalDataColumns; index as columnIndex\"\n            [attr.data-e2e]=\"'data-cell-' + columnIndex\"\n            [ngClass]=\"'dt-col-' + columnIndex\"\n            [class.sticky]=\"column.sticky\"\n            [style.left]=\"column.sticky && (!column.stickyPosition || column.stickyPosition === 'left') ? 'var(--column-sticky-left-' + columnIndex + ')' : null\"\n            [style.right]=\"column.sticky && column.stickyPosition === 'right' ? 'var(--column-sticky-right-data-' + columnIndex + ')' : null\"\n            [style.background-color]=\"column.id === 'theme' && row.datatableRowOptions?.theme ? 'var(--' + row.datatableRowOptions.theme + '-base)' : 'inherit'\"\n          >\n            <div\n              class=\"data-cell-content\"\n              [class.center]=\"column.horizontalAlign === 'center'\"\n              [class.right]=\"column.horizontalAlign === 'right'\"\n              [class.theme-indicator]=\"column.id === 'theme'\"\n              [style.padding]=\"column.padding\"\n            >\n              <ng-container *ngIf=\"!column.dataCellTemplate; else dataCellTemplateEl\">\n                <div>\n                  {{ row | nestedProperty: column.prop:column.pipe }}\n                </div>\n              </ng-container>\n              <ng-template #dataCellTemplateEl\n                ><ng-container\n                  *ngTemplateOutlet=\"\n                    column.dataCellTemplate;\n                    context: { row: row, rowIndex: rowIndex, column: column, selectedItems: vm.selectedItems, selectedItemIds: vm.selectedItemIds }\n                  \"\n                ></ng-container\n              ></ng-template>\n            </div>\n            <div\n              *ngIf=\"column.resizable || (column.sticky && column.stickyPosition !== 'right')\"\n              class=\"column-separator data right\"\n              [id]=\"column.id\"\n              [class.resizable]=\"column.resizable\"\n              [class.show]=\"columnIndex === currentLeftStickyInfo?.lastColumnIndex || (column.resizable && !vm.pendingData && (headerHovered || resizing))\"\n              [class.resized]=\"resizedColumn && column.id === resizedColumn.id\"\n            ></div>\n            <div *ngIf=\"columnIndex === currentRightStickyInfo?.lastColumnIndex && vm.dataSource.data?.length > 0\" class=\"column-separator data left\"></div>\n          </div>\n        </div>\n      </cdk-virtual-scroll-viewport>\n      <avn-icon\n        *ngIf=\"showHorizontalScrollArrows\"\n        [fontSize]=\"arrowIconSize\"\n        data-e2e=\"data-table-navigation-arrow-left\"\n        class=\"navigation-arrow left\"\n        icon=\"navigation:chevron_left\"\n        [class.mobile]=\"isMobileDevice$ | async\"\n        [class.visible]=\"scrolledLeftPx > 0 && vm.dataSource?.total > 0\"\n        [style.left.px]=\"currentLeftStickyInfo?.totalStickyWidthPx || 0\"\n        avnLongPress\n        (touchstart)=\"onNavigateLeft()\"\n        (mousedown)=\"onNavigateLeft()\"\n        (longPress)=\"onNavigateLeft()\"\n        [longPressIntervalTimeMs]=\"100\"\n        [longPressActive]=\"scrolledLeftPx > 0\"\n      >\n      </avn-icon>\n      <avn-icon\n        *ngIf=\"showHorizontalScrollArrows\"\n        [fontSize]=\"arrowIconSize\"\n        data-e2e=\"data-table-navigation-arrow-right\"\n        class=\"navigation-arrow right\"\n        icon=\"navigation:chevron_right\"\n        [class.mobile]=\"isMobileDevice$ | async\"\n        [class.visible]=\"scrolledRightPx > 0 && vm.dataSource?.total > 0\"\n        [style.right.px]=\"currentRightStickyInfo?.totalStickyWidthPx || 0\"\n        avnLongPress\n        (touchend)=\"onNavigateRight()\"\n        (mousedown)=\"onNavigateRight()\"\n        (longPress)=\"onNavigateRight()\"\n        [longPressIntervalTimeMs]=\"100\"\n        [longPressActive]=\"scrolledRightPx > 0\"\n      >\n      </avn-icon>\n    </div>\n    <div #footer class=\"footer\" *ngIf=\"!!footerTemplate\" [style.height.px]=\"footerHeight\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          footerTemplate;\n          context: {\n            dataRowCount: vm.dataSource?.data?.length,\n            totalRowCount: vm.dataSource?.total\n          }\n        \"\n      ></ng-container>\n    </div>\n  </ng-container>\n\n  <ng-content select=\"avn-empty-data-message[columns]\" *ngIf=\"!isLoading && !hasDataColumns\"></ng-content>\n  <ng-content select=\"avn-empty-data-message\" *ngIf=\"!isLoading && hasDataColumns && !vm.hasRecords\"></ng-content>\n\n  <!-- Projects custom loader template into datatable -->\n  <ng-container *ngTemplateOutlet=\"customLoaderTemplate\"></ng-container>\n\n  <!-- default loader is applied in case there is no customLoaderTemplate -->\n  <ng-container *ngIf=\"!customLoaderTemplate\">\n    <avn-linear-loader [show]=\"showLinearLoader\" [theme]=\"loaderTheme\" [position]=\"horizontalLoaderPosition\"></avn-linear-loader>\n    <avn-loader [isLoading]=\"showBlockUILoader\" [avnTheme]=\"loaderTheme\"></avn-loader>\n  </ng-container>\n\n  <avn-data-table-notification-message\n    [show]=\"(allItemsSelectionEnabled$ | async) && (entireDataSetSelected$ | async) === false\"\n    [text]=\"vm.selectedItemsCount + ' rows are selected. Select all ' + vm.dataSource?.total + ' rows'\"\n    [actionText]=\"'Select All'\"\n    [offsetY]=\"10\"\n    (clicked)=\"onSelectEntireDataSet()\"\n  >\n  </avn-data-table-notification-message>\n\n  <ng-content select=\"avn-data-table-notification-message\"></ng-content>\n</ng-container>\n\n<ng-template #multiSelectionHeaderTemplate let-totalRowCount=\"totalRowCount\">\n  <avn-checkbox\n    data-e2e=\"select-all\"\n    *ngIf=\"totalRowCount > 0\"\n    (click)=\"$event.stopPropagation()\"\n    (change)=\"onSelectAllRows(isChecked($event))\"\n    [checked]=\"allItemsSelectionEnabled$ | async\"\n    [disabled]=\"areAllItemsDisabled$ | async\"\n  ></avn-checkbox>\n</ng-template>\n<ng-template #multiSelectionDataTemplate let-row=\"row\">\n  <avn-checkbox\n    data-e2e=\"select-row\"\n    (click)=\"$event.stopPropagation()\"\n    (change)=\"onSelectRow(isChecked($event), row)\"\n    [checked]=\"isRowSelected(row)\"\n    [disabled]=\"row.datatableRowOptions?.disabled\"\n  ></avn-checkbox>\n</ng-template>\n<ng-template #singleSelectionDataTemplate let-row=\"row\" let-rowIndex=\"rowIndex\">\n  <avn-radio-group name=\"singleSelectedItem\">\n    <avn-radio\n      data-e2e=\"select-row\"\n      [disabled]=\"isSingleSelectionRadioDisabled(row)\"\n      [checked]=\"isRowSelected(row)\"\n      [value]=\"rowIndex\"\n      (click)=\"$event.stopPropagation()\"\n      (change)=\"onSelectSingleRow(rowIndex, row)\"\n    ></avn-radio>\n  </avn-radio-group>\n</ng-template>\n\n<ng-template #themeIndicatorTemplate let-row=\"row\">\n  <div data-e2e=\"theme-indicator\"></div>\n</ng-template>\n", styles: [".sort-field-list ::ng-deep avn-option:not(.group).selected:not(.disabled){color:var(--selection-component-hover-on);background-color:var(--selection-component-hover-background)}.sort-field-list .active{color:var(--data-table-sort-icon-active)}.sort-field-list .sort-field{display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;width:100%}.sort-field-list .sort-field>div:nth-child(2){display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-column-gap:var(--space-xs)}.sort-field-list .sort-field>div:nth-child(2) avn-icon:hover{color:var(--data-table-sort-icon-active)}:host{--column-count: 0;--column-sizes-header: 0;--column-sizes-data: 0;display:block;position:relative}:host.theme-primary .data-row:hover{color:var(--primary-on)!important;background-color:var(--primary-base)!important}:host.theme-primary .data-row.selected,:host.theme-primary .data-row.active{background-color:var(--primary-variant)!important;color:var(--primary-variant-on)!important}:host.theme-primary .column-separator.show.resized:after{border-color:var(--primary-base)!important}:host.theme-secondary .data-row:hover{color:var(--secondary-on)!important;background-color:var(--secondary-base)!important}:host.theme-secondary .data-row.selected,:host.theme-secondary .data-row.active{background-color:var(--secondary-variant)!important;color:var(--secondary-variant-on)!important}:host.theme-secondary .column-separator.show.resized:after{border-color:var(--secondary-base)!important}:host.theme-highlight .data-row:hover{color:var(--highlight-on)!important;background-color:var(--highlight-base)!important}:host.theme-highlight .data-row.selected,:host.theme-highlight .data-row.active{background-color:var(--highlight-variant)!important;color:var(--highlight-variant-on)!important}:host.theme-highlight .column-separator.show.resized:after{border-color:var(--highlight-base)!important}:host.theme-danger .data-row:hover{color:var(--danger-on)!important;background-color:var(--danger-base)!important}:host.theme-danger .data-row.selected,:host.theme-danger .data-row.active{background-color:var(--danger-variant)!important;color:var(--danger-variant-on)!important}:host.theme-danger .column-separator.show.resized:after{border-color:var(--danger-base)!important}:host.theme-warning .data-row:hover{color:var(--warning-on)!important;background-color:var(--warning-base)!important}:host.theme-warning .data-row.selected,:host.theme-warning .data-row.active{background-color:var(--warning-variant)!important;color:var(--warning-variant-on)!important}:host.theme-warning .column-separator.show.resized:after{border-color:var(--warning-base)!important}:host.theme-info .data-row:hover{color:var(--info-on)!important;background-color:var(--info-base)!important}:host.theme-info .data-row.selected,:host.theme-info .data-row.active{background-color:var(--info-variant)!important;color:var(--info-variant-on)!important}:host.theme-info .column-separator.show.resized:after{border-color:var(--info-base)!important}:host.theme-success .data-row:hover{color:var(--success-on)!important;background-color:var(--success-base)!important}:host.theme-success .data-row.selected,:host.theme-success .data-row.active{background-color:var(--success-variant)!important;color:var(--success-variant-on)!important}:host.theme-success .column-separator.show.resized:after{border-color:var(--success-base)!important}:host-context(.dmb-aspect) :host .header{font-size:18px;font-weight:400;border-bottom:1px solid var(--data-table-row-border);border-top-left-radius:4px;border-top-right-radius:4px}:host-context(.dmb-aspect) :host .body{font-size:14px}:host-context(.dmb-aspect) :host .cdk-virtual-scroll-viewport{border-bottom-left-radius:4px;border-bottom-right-radius:4px}:host-context(.dmb-aspect) :host .header .header-cell:first-child,:host-context(.dmb-aspect) :host .body .header-cell:first-child{padding-left:calc(.5rem + 10px)}:host-context(.dmb-aspect) :host .header .data-row .data-cell:first-child,:host-context(.dmb-aspect) :host .body .data-row .data-cell:first-child{padding-left:10px}:host-context(.dmb-aspect) :host .header .data-row.clickable:not(.disabled),:host-context(.dmb-aspect) :host .body .data-row.clickable:not(.disabled){cursor:default}:host-context(.dmb-aspect) :host .header .data-row.selected,:host-context(.dmb-aspect) :host .body .data-row.selected{color:#000}:host-context(.dmb-aspect) :host .header .data-row.selected .data-cell:first-child:before,:host-context(.dmb-aspect) :host .body .data-row.selected .data-cell:first-child:before{content:\"\";position:absolute;width:6px;height:100%;left:0;top:0;background:var(--data-table-row-selected-on)}:host-context(.dmb-aspect) :host .header .data-row.selected:hover,:host-context(.dmb-aspect) :host .body .data-row.selected:hover{color:var(--data-table-row-selected-on);background-color:var(--data-table-row-selected-background)}:host-context(.dmb-aspect) :host .header .data-row.active:not(.selected).even,:host-context(.dmb-aspect) :host .body .data-row.active:not(.selected).even{background-color:var(--data-table-row-even-background)}:host-context(.dmb-aspect) :host .header .data-row.active:not(.selected).odd,:host-context(.dmb-aspect) :host .body .data-row.active:not(.selected).odd{background-color:var(--data-table-row-odd-background)}:host-context(.dmb-aspect) :host .header .data-row.active:not(.selected):hover,:host-context(.dmb-aspect) :host .body .data-row.active:not(.selected):hover{background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host .header .data-row.active,:host-context(.dmb-aspect) :host .body .data-row.active{font-weight:bolder}:host-context(.dmb-aspect) :host .header .data-row.active:hover:not(.disabled):not(.selected),:host-context(.dmb-aspect) :host .body .data-row.active:hover:not(.disabled):not(.selected){color:var(--data-table-row-hover-on);background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host .body.selectionmode-none .data-row.clickable{cursor:default}:host-context(.dmb-aspect) :host .body.selectionmode-single-no-radio .data-row,:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row{cursor:pointer}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row:not(.disabled){cursor:pointer}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.selected{color:#000}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.selected .data-cell:first-child:before{content:\"\";position:absolute;width:6px;height:100%;left:0;top:0;background:var(--data-table-row-selected-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.selected:hover{color:var(--data-table-row-selected-on);background-color:var(--data-table-row-selected-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:not(.selected).even{background-color:var(--data-table-row-even-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:not(.selected).odd{background-color:var(--data-table-row-odd-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:not(.selected):hover{background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active{font-weight:bolder}:host-context(.dmb-aspect) :host .body.selectionmode-multiple-color .data-row.active:hover:not(.disabled):not(.selected){color:var(--data-table-row-hover-on);background-color:var(--data-table-row-hover-background)}:host-context(.dmb-aspect) :host ::ng-deep avn-empty-data-message{padding:18px;border-radius:4px;background:var(--data-table-header-background);color:var(--data-table-header-on)}:host .header{position:relative;display:grid;grid-template-columns:var(--column-sizes-header);grid-gap:0px;background-color:var(--data-table-header-background);color:var(--data-table-header-on);font-weight:500;overflow:hidden}:host .header>.header-cell{padding:var(--space-xs) var(--space-sm);display:flex;align-items:center;white-space:nowrap;position:relative;transition:background-color .2s cubic-bezier(0,0,.2,1)}:host .header>.header-cell.sticky{position:sticky;background-color:inherit;z-index:2}:host .header>.header-cell.theme-indicator{padding:0}:host .header>.header-cell>.header-cell-content{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-user-select:none;user-select:none;position:relative}:host .header>.header-cell.cdk-drag:not(.cdk-drag-disabled){cursor:move}:host .header>.header-cell.cdk-drag-placeholder{border:1px dashed silver;box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .header>.header-cell avn-icon.sort-icon{opacity:0;margin-left:var(--space-sm);cursor:pointer;transition:transform .2s cubic-bezier(0,0,.2,1),opacity .2s cubic-bezier(0,0,.2,1);transform:rotate(360deg)}:host .header>.header-cell avn-icon.sort-icon.desc{transform:rotate(180deg)}:host .header>.header-cell avn-icon.sort-icon:hover,:host .header>.header-cell avn-icon.sort-icon.active{color:var(--data-table-sort-icon-active)}:host .header>.header-cell.sort avn-icon.sort-icon,:host .header>.header-cell:hover avn-icon.sort-icon{opacity:1}:host .header>.header-cell.hover-background:hover{background:var(--data-table-header-hover-background);color:var(--data-table-header-hover-on)}:host .header>.header-cell.with-open-sortpanel{background:var(--data-table-header-hover-background);color:var(--data-table-header-hover-on)}:host .header>.header-cell.with-open-sortpanel avn-icon.sort-icon{opacity:1}:host .header .scroll-offset-column.sticky{position:sticky;right:0;background-color:inherit}:host .body{font-size:var(--text-sm);background-color:var(--data-table-body-background);color:var(--data-table-body-on)}:host .body .data-row{align-items:center;position:relative;display:grid;grid-gap:0px;grid-template-columns:var(--column-sizes-data);box-sizing:border-box}:host .body .data-row:not(:last-child):after{content:\"\";position:absolute;left:0;right:0;bottom:0;z-index:2;border-bottom:1px solid var(--data-table-row-border)}:host .body .data-row.even{background-color:var(--data-table-row-even-background)}:host .body .data-row.odd{background-color:var(--data-table-row-odd-background)}:host .body .data-row.active{color:var(--data-table-row-active-on);background-color:var(--data-table-row-active-background)}:host .body .data-row.active ::ng-deep avn-data-table-actions>avn-icon:not(.theme){color:var(--data-table-action-icon-active)}:host .body .data-row.selected{color:var(--data-table-row-selected-on);background-color:var(--data-table-row-selected-background)}:host .body .data-row.selected ::ng-deep avn-data-table-actions>avn-icon:not(.theme){color:var(--data-table-action-icon-selected)}:host .body .data-row.disabled{opacity:.5;cursor:not-allowed}:host .body .data-row:hover:not(.disabled){color:var(--data-table-row-hover-on);background-color:var(--data-table-row-hover-background)}:host .body .data-row:hover:not(.disabled) ::ng-deep avn-data-table-actions>avn-icon:not(.theme){color:var(--data-table-action-icon)}:host .body .data-row.clickable{cursor:pointer}:host .body .data-row .data-cell{height:100%;display:flex;align-items:center;position:relative;overflow:hidden}:host .body .data-row .data-cell.sticky{position:sticky;background-color:inherit;z-index:2}:host .body .data-row .data-cell>.data-cell-content{width:100%;padding:0px var(--space-sm);position:relative;display:flex;justify-content:flex-start;overflow:hidden}:host .body .data-row .data-cell>.data-cell-content.center{justify-content:center}:host .body .data-row .data-cell>.data-cell-content.right{justify-content:flex-end}:host .body .data-row .data-cell>.data-cell-content.theme-indicator{padding:0}:host .body .data-row .data-cell>.data-cell-content>div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .body.valign-top .data-row>.data-cell{align-items:flex-start}:host .body.valign-bottom .data-row>.data-cell{align-items:flex-end}:host .body .navigation-arrow{position:absolute;top:50%;transform:translateY(-50%);border-radius:50%;background-color:var(--data-table-navigation-icon-background);color:var(--data-table-navigation-icon);transition:opacity .2s cubic-bezier(0,0,.2,1);-webkit-user-select:none;user-select:none;opacity:0;z-index:-1;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f!important}:host .body .navigation-arrow.left{margin-left:var(--space-md)}:host .body .navigation-arrow.right{margin-right:var(--space-base)}:host .body .navigation-arrow.mobile.visible{opacity:.8;cursor:pointer;z-index:10}:host .body .navigation-arrow.mobile.visible:hover{background-color:var(--data-table-navigation-icon-hover-background);color:var(--data-table-navigation-icon-hover);opacity:1}:host .body:hover .navigation-arrow.visible{opacity:.8;cursor:pointer;z-index:10}:host .body:hover .navigation-arrow.visible:hover{background-color:var(--data-table-navigation-icon-hover-background);color:var(--data-table-navigation-icon-hover);opacity:1}:host .footer{background-color:var(--data-table-footer-background);color:var(--data-table-footer-on)}:host .cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}:host .cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host.auto-height{height:100%}:host cdk-virtual-scroll-viewport{height:100%}:host .column-separator{position:absolute;top:0;bottom:0;transform:translate(50%);z-index:1;width:1px;background:transparent}:host .column-separator:after{content:\"\";position:absolute;top:0;left:0;bottom:0;width:0px;transition:border-color .15s ease-in-out}:host .column-separator.resizable{width:8px}:host .column-separator.resizable.header{cursor:col-resize}:host .column-separator.resizable:after{left:calc(50% - 1px)}:host .column-separator.right{right:0}:host .column-separator.right:after{border-right:1px solid transparent}:host .column-separator.left{left:0}:host .column-separator.left:after{left:0;border-right:1px solid var(--data-table-resizer)}:host .column-separator.show:not(.left):after{border-right-color:var(--data-table-resizer)}:host .column-separator.show:not(.left).resized:after{border-right-color:var(--primary-base)}:host .sticky .column-separator{z-index:3}:host avn-linear-loader{z-index:4}:host .grid{width:100%;height:100%;display:grid;padding:var(--space-md);grid-gap:var(--space-md);transition:padding .12s cubic-bezier(0,0,.2,1)}:host .grid>*{height:100%}:host .grid.fullscreen{padding:0;height:100%;overflow:hidden}:host .grid.fullscreen>*{height:100%}:host ::ng-deep avn-empty-data-message{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: MediaBreakpointStore }, { type: InfiniteScrollComponentStore }]; }, propDecorators: { _multiSelectionHeaderTemplate: [{
                type: ViewChild,
                args: ['multiSelectionHeaderTemplate', { static: true }]
            }], _multiSelectionDataTemplate: [{
                type: ViewChild,
                args: ['multiSelectionDataTemplate', { static: true }]
            }], _singleSelectionDataTemplate: [{
                type: ViewChild,
                args: ['singleSelectionDataTemplate', { static: true }]
            }], _themeIndicatorTemplate: [{
                type: ViewChild,
                args: ['themeIndicatorTemplate', { static: true }]
            }], customLoaderTemplate: [{
                type: Input
            }], columns: [{
                type: Input
            }], headerEl: [{
                type: ViewChild,
                args: ['header', { static: false }]
            }], bodyEl: [{
                type: ViewChild,
                args: ['body', { static: false }]
            }], virtualizedViewport: [{
                type: ViewChild,
                args: ['virtualizedViewport', { static: false }]
            }], dataTableNotificationMessageComponent: [{
                type: ContentChild,
                args: [DataTableNotificationMessageComponent, { static: false }]
            }], dataSource: [{
                type: Input
            }], dataSourceConfig: [{
                type: Input
            }], selectedItemIds: [{
                type: Input
            }], dragDropRowsEnabled: [{
                type: Input
            }], headerCellTemplate: [{
                type: Input
            }], tableHeight: [{
                type: Input
            }], tableMaxHeight: [{
                type: Input
            }], headerHeight: [{
                type: Input
            }], footerHeight: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], rowHeight: [{
                type: Input
            }], dataRowVerticalAlign: [{
                type: Input
            }], infiniteScrollPreloadStrategy: [{
                type: Input
            }], infiniteScrollPreloadValue: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], serverSorting: [{
                type: Input
            }], sortBy: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], themeIndicatorWidthPx: [{
                type: Input
            }], forceLoadingState: [{
                type: Input
            }], loaderTheme: [{
                type: Input
            }], horizontalLoaderPosition: [{
                type: Input
            }], keyboardNavigationEnabled: [{
                type: Input
            }], rowClassFn: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], isStaticDataSource: [{
                type: Input
            }], infiniteScrollEnabled: [{
                type: Input
            }], minColumnWidthPx: [{
                type: Input
            }], columnsResizeStrategy: [{
                type: Input
            }], showHorizontalScrollArrows: [{
                type: Input
            }], indexTrackFn: [{
                type: Input
            }], templateCacheSize: [{
                type: Input
            }], headerTooltipsEnabled: [{
                type: Input
            }], columnsOverflowStrategy: [{
                type: Input
            }], initialDataLoader: [{
                type: Input
            }], fetchData: [{
                type: Output
            }], columnSorted: [{
                type: Output
            }], columnReordered: [{
                type: Output
            }], entireDataSetSelected: [{
                type: Output
            }], selectionChanged: [{
                type: Output
            }], rowClicked: [{
                type: Output
            }], rowDoubleClicked: [{
                type: Output
            }], rowActivated: [{
                type: Output
            }], notificationMessageClicked: [{
                type: Output
            }], dataLoaded: [{
                type: Output
            }], columnResized: [{
                type: Output
            }], columnNavigated: [{
                type: Output
            }], tabindex: [{
                type: HostBinding,
                args: ['tabindex']
            }], isAutoHeight: [{
                type: HostBinding,
                args: ['class.auto-height']
            }] } });

var FileDataTableColumns;
(function (FileDataTableColumns) {
    FileDataTableColumns["THUMBNAIL"] = "thumbnail";
    FileDataTableColumns["NAME"] = "name";
    FileDataTableColumns["SIZE"] = "size";
    FileDataTableColumns["TYPE"] = "type";
    FileDataTableColumns["LAST_MODIFIED"] = "lastModified";
    FileDataTableColumns["PROGRESS"] = "progress";
    FileDataTableColumns["ACTIONS"] = "actions";
})(FileDataTableColumns || (FileDataTableColumns = {}));
var FileUploaderTableColumnField;
(function (FileUploaderTableColumnField) {
    FileUploaderTableColumnField["LABEL"] = "label";
    FileUploaderTableColumnField["SORTABLE"] = "sortable";
    FileUploaderTableColumnField["WIDTHPX"] = "widthPx";
})(FileUploaderTableColumnField || (FileUploaderTableColumnField = {}));
const DefaultFileUploaderTableColumnsConfig = {
    [FileDataTableColumns.THUMBNAIL]: {
        [FileUploaderTableColumnField.LABEL]: 'Screen',
        [FileUploaderTableColumnField.SORTABLE]: false,
        [FileUploaderTableColumnField.WIDTHPX]: 60,
    },
    [FileDataTableColumns.NAME]: {
        [FileUploaderTableColumnField.LABEL]: 'Name',
        [FileUploaderTableColumnField.SORTABLE]: true,
        [FileUploaderTableColumnField.WIDTHPX]: 150,
    },
    [FileDataTableColumns.SIZE]: {
        [FileUploaderTableColumnField.LABEL]: 'Size',
        [FileUploaderTableColumnField.SORTABLE]: true,
        [FileUploaderTableColumnField.WIDTHPX]: 100,
    },
    [FileDataTableColumns.TYPE]: {
        [FileUploaderTableColumnField.LABEL]: 'Type',
        [FileUploaderTableColumnField.SORTABLE]: true,
        [FileUploaderTableColumnField.WIDTHPX]: 100,
    },
    [FileDataTableColumns.LAST_MODIFIED]: {
        [FileUploaderTableColumnField.LABEL]: 'Last Modified Date',
        [FileUploaderTableColumnField.SORTABLE]: true,
        [FileUploaderTableColumnField.WIDTHPX]: 200,
    },
    [FileDataTableColumns.PROGRESS]: {
        [FileUploaderTableColumnField.LABEL]: 'Progress',
        [FileUploaderTableColumnField.SORTABLE]: true,
        [FileUploaderTableColumnField.WIDTHPX]: 150,
    },
    [FileDataTableColumns.ACTIONS]: {
        [FileUploaderTableColumnField.LABEL]: '',
        [FileUploaderTableColumnField.SORTABLE]: false,
        [FileUploaderTableColumnField.WIDTHPX]: 150,
    },
};

const getFallbackIcon = (mimeType) => {
    // Reference: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
    if (mimeType?.includes('video')) {
        return 'av:movie';
    }
    else if (mimeType?.includes('image')) {
        return 'image:image';
    }
    else if (mimeType?.includes('audio')) {
        return 'av:music_video';
    }
    else if (mimeType?.includes('text')) {
        return 'action:description';
    }
    else if (mimeType?.includes('font')) {
        return 'av:sort_by_alpha';
    }
    else {
        return 'editor:insert_drive_file';
    }
};
const isFileAllowed = (file, allowedTypes) => {
    let allowed = true;
    if (allowedTypes?.length > 0) {
        const allowedFileTypes = allowedTypes.split(',').map((allowedType) => allowedType.trim());
        allowed = allowedFileTypes.some((allowedType) => {
            // Allowed type is in the format of either image/* or .pdf
            const typeExt = allowedType.split('/');
            if (typeExt.length > 1) {
                // It's e.g. image/*, match with type
                return file.mimeType?.includes(typeExt[0]) || false;
            }
            else {
                // It's e.g. .pdf, match with extension
                return file.file.name.includes(typeExt[0]);
            }
        });
    }
    return allowed;
};
/**
 * Generate thumbnail of a file (image)
 *
 * @param file File has to be an image or videos
 * @param height (Optional) Downscale image based on height
 * @param width (Optional) Downscale image based on width
 * @returns
 */
const generateThumbnail$ = (file, height, width) => {
    const fileType = file.type.split('/')[0];
    const reader = new FileReader();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    switch (fileType) {
        case 'image':
            return from(new Promise((resolve, reject) => {
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        let w; // final width of the image
                        let h; // final height of the image
                        // If both dimension are defined
                        if (width && height) {
                            w = width;
                            h = height;
                        }
                        // scale based on the width
                        else if (width && !height) {
                            w = width;
                            h = (img.height * width) / img.width;
                        }
                        // scale based on the height
                        else if (!width && height) {
                            h = height;
                            w = (img.width * height) / img.height;
                        }
                        // No scale
                        else {
                            w = img.width;
                            h = img.height;
                        }
                        canvas.width = w;
                        canvas.height = h;
                        ctx.drawImage(img, 0, 0, w, h);
                        const thumbnailUrl = canvas.toDataURL(file.type);
                        ctx.clearRect(0, 0, w, h);
                        return resolve(thumbnailUrl);
                    };
                    img.onerror = (e) => reject(e);
                    img.src = event.target.result;
                };
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(file);
            }));
        case 'video_TODO':
            return from(new Promise((resolve) => {
                reader.onload = () => {
                    const blob = new Blob([reader.result], { type: file.type });
                    const url = URL.createObjectURL(blob);
                    const video = document.createElement('video');
                    const addImage = () => {
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        const image = canvas.toDataURL();
                        URL.revokeObjectURL(url);
                        resolve(image);
                    };
                    video.addEventListener('loadeddata', addImage);
                    video.addEventListener('timeupdate', addImage);
                    video.preload = 'metadata';
                    video.src = url;
                    video.muted = true;
                    video.playsInline = true;
                    video.crossOrigin = 'anonymous';
                    video.play();
                };
                reader.readAsArrayBuffer(file);
            }));
        default:
            return of(''); // If file is not an image/video, then return an empty thumbnail
    }
};

var FileStatus;
(function (FileStatus) {
    FileStatus["INIT"] = "init";
    FileStatus["UPLOADING"] = "uploading";
    FileStatus["UPLOADED"] = "uploaded";
    FileStatus["ERROR"] = "error";
    FileStatus["PAUSED"] = "paused";
    FileStatus["CANCELLED"] = "cancelled";
    FileStatus["QUEUED"] = "queued";
})(FileStatus || (FileStatus = {}));
const DEFAULT_FILE_UPLOADER_STATE = {
    files: {},
    chunkSizeInBytes: 10 * 1024 * 1024,
};
/**
 * T = custom initial user data passed to the BEFORE upload process
 * U = Response data returned by any task done BEFORE the actual upload
 * V = Response data returned by the actual upload
 * W = Response data returned by any task done AFTER the actual upload
 */
class FileUploaderStore extends ComponentStore {
    constructor(fileUploadHttp) {
        // initial state
        super(DEFAULT_FILE_UPLOADER_STATE);
        this.fileUploadHttp = fileUploadHttp;
        /** Contains ids of files currently in a cancelled state */
        this.cancelledFileIdsSubject = new BehaviorSubject([]);
        /** Selector */
        this.selectFiles$ = this.select((state) => state.files).pipe(map((files) => Object.values(files)));
        this.selectIsUploading$ = this.select(this.selectFiles$, (files) => files.some((file) => file.status === FileStatus.UPLOADING || file.status === FileStatus.QUEUED));
        this.selectFilesCount$ = this.select(this.selectFiles$, (files) => files.length);
        this.selectHasFile$ = this.select(this.selectFilesCount$, (count) => count > 0);
        this._fileUploadQueueSubject = new Subject();
        this._fileUploadResponseSubject = new Subject();
        this.setChunkSize = this.updater((state, chunkSizeInBytes) => ({
            ...state,
            chunkSizeInBytes,
        }));
        /** Delete a single file in the list based on the name of the file */
        this.deleteFile = this.updater((state, id) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [id]: removed, ...files } = state.files;
            // remove from cancelled files
            this.cancelledFileIdsSubject.next(this.cancelledFileIdsSubject.value.filter((fileId) => fileId !== id));
            return {
                ...state,
                files,
            };
        });
        /** Delete all files in the list */
        this.deleteFiles = this.updater((state) => {
            // clear cancelled files
            this.cancelledFileIdsSubject.next([]);
            return {
                ...state,
                files: {},
            };
        });
        /** Cancel the specified file  */
        this.cancelFileUpload = this.updater((state, id) => {
            const file = state.files[id];
            // can only cancel started but not completed uploads
            const canCancel = [FileStatus.UPLOADING, FileStatus.QUEUED, FileStatus.PAUSED, FileStatus.ERROR].includes(file?.status);
            if (!canCancel) {
                return state;
            }
            this.cancelledFileIdsSubject.next(uniq([...this.cancelledFileIdsSubject.value, id]));
            this.fileUploadHttp.onCancelUpload?.(file.file, file.userData, file.beforeUploadResponseData);
            return {
                ...state,
                files: {
                    ...state.files,
                    [id]: {
                        ...file,
                        status: FileStatus.CANCELLED,
                        progress: 0,
                        resumeByte: 0,
                        error: undefined,
                        userData: undefined,
                        beforeUploadResponseData: undefined,
                        uploadResponseData: undefined,
                        afterUploadResponseData: undefined,
                    },
                },
            };
        });
        /** Change the allowed file types */
        this.changeAllowedFileTypes = this.updater((state, allowedFileTypes) => {
            const files = Object.values(state.files).reduce((acc, file) => (acc[file.id] = { ...file, allowed: isFileAllowed(file, allowedFileTypes) }) && acc, {});
            return {
                ...state,
                files,
            };
        });
        /** Pause upload without cancelling it */
        this.pauseUpload = this.updater((state, id) => {
            const file = state.files[id];
            if (!file || (file.status !== FileStatus.UPLOADING && file.status !== FileStatus.QUEUED)) {
                return state;
            }
            const files = state.files;
            this.cancelledFileIdsSubject.next(uniq([...this.cancelledFileIdsSubject.value, id]));
            return {
                ...state,
                files: {
                    ...files,
                    [id]: { ...file, status: FileStatus.PAUSED },
                },
            };
        });
        /** Pause all uploads without cancelling them */
        this.pauseAllUploads = this.updater((state) => {
            let files = state.files;
            const cancelledFileIds = [];
            // update status to paused
            Object.values(files)
                .filter((file) => file.status === FileStatus.UPLOADING || file.status === FileStatus.QUEUED)
                .forEach((file) => {
                cancelledFileIds.push(file.id);
                files = {
                    ...files,
                    [file.id]: {
                        ...file,
                        status: FileStatus.PAUSED,
                    },
                };
            });
            // cancel all files
            this.cancelledFileIdsSubject.next(uniq([...this.cancelledFileIdsSubject.value, ...cancelledFileIds]));
            return {
                ...state,
                files,
            };
        });
        /** Sets the thumbnail for the specified file */
        this.setFileThumbnail = this.updater((state, payload) => {
            const { fileId, url } = payload;
            const file = state.files[fileId];
            if (!file) {
                return state;
            }
            return {
                ...state,
                files: {
                    ...state.files,
                    [payload.fileId]: {
                        ...file,
                        url,
                    },
                },
            };
        });
        /** Update file with error */
        this.updateErrorFile = this.updater((state, payload) => {
            const files = state.files;
            const file = files[payload.id];
            return {
                ...state,
                files: {
                    ...files,
                    [payload.id]: {
                        ...file,
                        status: FileStatus.ERROR,
                        error: payload.error,
                    },
                },
            };
        });
        /** Update file with uploaded */
        this.markFileAsUploaded = this.updater((state, id) => {
            const files = state.files;
            const file = files[id];
            return {
                ...state,
                files: {
                    ...files,
                    [id]: {
                        ...file,
                        resumeByte: 0,
                        progress: 100,
                        status: FileStatus.UPLOADED,
                    },
                },
            };
        });
        /** Mark file as uploading */
        this.markFileAsUploading = this.updater((state, id) => {
            const files = state.files;
            const file = files[id];
            return {
                ...state,
                files: {
                    ...files,
                    [id]: {
                        ...file,
                        status: FileStatus.UPLOADING,
                    },
                },
            };
        });
        /** Mark file as queued */
        this.markFileAsQueued = this.updater((state, id) => {
            const files = state.files;
            const file = files[id];
            return {
                ...state,
                files: {
                    ...files,
                    [id]: {
                        ...file,
                        status: FileStatus.QUEUED,
                    },
                },
            };
        });
        /** Update file with uploading */
        this.setFileUploadProgress = this.updater((state, payload) => {
            const files = state.files;
            const file = files[payload.id];
            return {
                ...state,
                files: {
                    ...files,
                    [payload.id]: {
                        ...file,
                        ...(payload.progress !== undefined ? { progress: payload.progress } : {}),
                        ...(payload.resumeByte !== undefined ? { resumeByte: payload.resumeByte } : {}),
                    },
                },
            };
        });
        /** Updates the file with data from the 'beforeUpload' hook response */
        this.setBeforeUploadResponseData = this.updater((state, payload) => {
            const files = state.files;
            const file = files[payload.id];
            return {
                ...state,
                files: {
                    ...files,
                    [payload.id]: {
                        ...file,
                        beforeUploadResponseData: payload.beforeUploadResponseData,
                    },
                },
            };
        });
        /** Updates the file with data from the 'upload' hook response */
        this.setUploadResponseData = this.updater((state, payload) => {
            const files = state.files;
            const file = files[payload.id];
            return {
                ...state,
                files: {
                    ...files,
                    [payload.id]: {
                        ...file,
                        uploadResponseData: payload.uploadResponseData,
                    },
                },
            };
        });
        /** Updates the file with data from the 'upload' hook response */
        this.setAfterUploadResponseData = this.updater((state, payload) => {
            const files = state.files;
            const file = files[payload.id];
            return {
                ...state,
                files: {
                    ...files,
                    [payload.id]: {
                        ...file,
                        afterUploadResponseData: payload.afterUploadResponseData,
                    },
                },
            };
        });
        /** Update file with start upload data */
        this.setUserData = this.updater((state, payload) => {
            const files = state.files;
            const file = files[payload.id];
            return {
                ...state,
                files: {
                    ...files,
                    [payload.id]: {
                        ...file,
                        userData: payload.userData,
                    },
                },
            };
        });
        this.createFiles = this.updater((state, files) => ({
            ...state,
            files: { ...state.files, ...files.reduce((acc, file) => (acc[file.id] = file) && acc, {}) },
        }));
        // start listening the upload queue to upload files
        const maxConcurrentUploads = this.fileUploadHttp.getMaxConcurrentUploads?.() || Infinity;
        this._fileUploadQueueSubject
            .pipe(tap((uploadJob) => {
            this.markFileAsQueued(uploadJob.file.id);
        }), mergeMap(({ file, data, resumeByte }) => {
            // this code is ran once the file is taken out of the mergeMap queue
            // make sure the file upload hasn't been cancelled while it was queued
            const isFileCancelled = this.cancelledFileIdsSubject.value.includes(file.id);
            if (isFileCancelled) {
                return EMPTY;
            }
            return this._uploadFile(file, data, resumeByte).pipe(tap((response) => {
                this._fileUploadResponseSubject.next({ id: file.id, response });
            }));
        }, maxConcurrentUploads), takeUntil(this.destroy$))
            .subscribe();
    }
    get chunkSizeInBytes() {
        return this.get().chunkSizeInBytes;
    }
    /** Cancel all files that are uploading, queued, paused or in error  */
    cancelAllFileUploads() {
        Object.keys(this.get().files).forEach((fileId) => this.cancelFileUpload(fileId));
    }
    /** Upload all the files */
    uploadFiles(data) {
        const files = this.get().files;
        const uploadJobs = Object.values(files).reduce((res, file) => {
            switch (file.status) {
                case FileStatus.ERROR:
                case FileStatus.PAUSED:
                    res.push({ file, data, resumeByte: file.resumeByte });
                    break;
                case FileStatus.INIT:
                    res.push({ file, data });
                    break;
            }
            return res;
        }, []);
        const responses$ = merge(...uploadJobs.map((uploadJob) => this._addToUploadQueue$(uploadJob)));
        return responses$;
    }
    /** Resume paused upload (and upload with error if configured) */
    resumeUpload(id, options = { includeErrorStatus: true }) {
        const files = this.get().files;
        const file = files[id];
        // remove from cancelled files
        this.cancelledFileIdsSubject.next(uniq(this.cancelledFileIdsSubject.value.filter((fileId) => fileId !== id)));
        if (file.status === FileStatus.PAUSED || (options?.includeErrorStatus && file.status === FileStatus.ERROR)) {
            return this._addToUploadQueue$({ file, data: file.userData, resumeByte: file.resumeByte }).pipe(map(({ response }) => response));
        }
        return EMPTY;
    }
    /** Resumes all files uploads */
    resumeAllUploads(options = { includeErrorStatus: true }) {
        // get all uploads to resume
        const filesToResume = Object.values(this.get().files)
            .filter((file) => file.status === FileStatus.PAUSED || (options?.includeErrorStatus && file.status === FileStatus.ERROR))
            .map((file) => ({ file, data: file.userData, resumeByte: file.resumeByte }));
        // remove from cancelled files
        const filesToResumeIds = filesToResume.map(({ file }) => file.id);
        this.cancelledFileIdsSubject.next(this.cancelledFileIdsSubject.value.filter((fileId) => !filesToResumeIds.includes(fileId)));
        const responses$ = merge(...filesToResume.map((uploadJob) => this._addToUploadQueue$(uploadJob)));
        return responses$;
    }
    /** start upload for a file at 0% progress */
    startUpload(id, userData) {
        const files = this.get().files;
        const file = files[id];
        // Add data in order to retry upload in case it failed
        this.setUserData({ id: file.id, userData });
        if (file.status === FileStatus.INIT) {
            return this._addToUploadQueue$({ file, data: userData, resumeByte: file.resumeByte }).pipe(map(({ response }) => response));
        }
        return throwError(() => new Error(`File should be in a init state but is in ${file.status}`));
    }
    _addToUploadQueue$({ file, data, resumeByte }) {
        const addToQueue$ = new Observable((subscriber) => {
            this._fileUploadQueueSubject.next({ file, data, resumeByte });
            subscriber.next();
            subscriber.complete();
        });
        const response$ = this._fileUploadResponseSubject.pipe(filter((response) => response.id === file.id));
        return addToQueue$.pipe(switchMapTo(response$));
    }
    addFiles(files, autoGenerateThumbnails = false, thumbnailSize = { height: 100, width: 100 }) {
        const filesItem = this.convertFilesItem(files);
        this.createFiles(filesItem);
        // Load and add thumbnail when loaded
        if (autoGenerateThumbnails) {
            merge(...filesItem.map((file) => {
                const fileDeleted$ = this.select((state) => state.files).pipe(filter((stateFiles) => !Object.keys(stateFiles).includes(file.id)));
                // Generate thumbnail for each file if specified
                return generateThumbnail$(file.file, thumbnailSize.height, thumbnailSize.width).pipe(map((url) => ({ file, url })), catchError(() => of({ file, url: null })), takeUntil(fileDeleted$));
            })).subscribe(({ file, url }) => this.setFileThumbnail({ fileId: file.id, url }));
        }
        return filesItem;
    }
    /** Read the specific file chunk as an observable */
    readFile(file, startByte) {
        return new Observable((observer) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                observer.next(reader.result);
                observer.complete();
            };
            const endByte = startByte + this.chunkSizeInBytes > file.size ? file.size : startByte + this.chunkSizeInBytes;
            reader.readAsArrayBuffer(file.slice.call(file, startByte, endByte));
        });
    }
    /** Upload a single file and determine if we send it by chunk or directly to the server */
    _uploadFile(file, userData, startByte = 0) {
        const chunkCount = Math.ceil(file.file.size / this.chunkSizeInBytes);
        // get the current data
        let uploadRequest$;
        if (startByte || this.fileUploadHttp.shouldUploadByChunk?.(chunkCount, file.file)) {
            uploadRequest$ = this.uploadFileByChunk$(file, userData, startByte);
        }
        else {
            uploadRequest$ = this.directUploadFile$(file, userData);
        }
        // Change file status to uploading
        this.markFileAsUploading(file.id);
        const fileCancelled$ = this.cancelledFileIdsSubject.pipe(filter((cancelledFileIds) => cancelledFileIds.includes(file.id)));
        return uploadRequest$.pipe(tap(() => {
            this.markFileAsUploaded(file.id);
        }), catchError((error) => {
            this.updateErrorFile({ id: file.id, error });
            return throwError(error);
        }), takeUntil(fileCancelled$));
    }
    /** Executes the 'beforeUpload' hook if its provided and caches the response in case of errors / retries **/
    _beforeUpload$(file, userData, chunkCount = null) {
        // No need to call the "beforeUpload" hook if it was previously called for that file (if the upload process failed at the "upload" or "afterUpload" step)
        const beforeUploadHookAlreadyCalled = file.beforeUploadResponseData !== undefined;
        if (beforeUploadHookAlreadyCalled || !this.fileUploadHttp.beforeUpload) {
            return of(file.beforeUploadResponseData);
        }
        return this.fileUploadHttp.beforeUpload(file.file, userData, chunkCount).pipe(
        // Keep the data from the http call
        tap((beforeUploadResponseData) => {
            this.setBeforeUploadResponseData({ id: file.id, beforeUploadResponseData });
        }), catchError((error) => {
            this.fileUploadHttp.onBeforeUploadError?.(error, userData);
            return throwError(error);
        }));
    }
    /** Executes the 'afterUpload' hook if its provided and caches the response in case of errors / retries **/
    _afterUpload$(file, userData, beforeUploadResponseData, uploadResponseData) {
        if (!this.fileUploadHttp.afterUpload) {
            return of(undefined);
        }
        return this.fileUploadHttp.afterUpload(file.file, userData, beforeUploadResponseData, uploadResponseData).pipe(tap((afterUploadResponseData) => {
            this.setAfterUploadResponseData({ id: file.id, afterUploadResponseData });
        }), catchError((error) => {
            this.fileUploadHttp.onAfterUploadError?.(error, userData, beforeUploadResponseData, uploadResponseData);
            return throwError(error);
        }));
    }
    /** Executes the 'upload' hook for a direct file upload (no chunks) **/
    directUploadFile$(file, userData) {
        const uploadFile$ = (beforeUploadResponseData) => {
            // No need to call the "uploadFile" hook if it was previously called for that file (if the upload process failed at the "afterUpload" step)
            const uploadHookAlreadyCalled = file.uploadResponseData !== undefined;
            if (uploadHookAlreadyCalled) {
                return of(file.uploadResponseData);
            }
            return this.fileUploadHttp.uploadFile(file.file, userData, beforeUploadResponseData).pipe(tap((uploadResponseData) => {
                this.setFileUploadProgress({ id: file.id, progress: 100 });
                this.setUploadResponseData({ id: file.id, uploadResponseData });
            }), catchError((error) => {
                this.fileUploadHttp.onUploadError?.(error, userData, beforeUploadResponseData);
                return throwError(error);
            }));
        };
        return this._beforeUpload$(file, userData).pipe(mergeMap((beforeUploadResponseData) => uploadFile$(beforeUploadResponseData).pipe(mergeMap((uploadResponseData) => this._afterUpload$(file, userData, beforeUploadResponseData, uploadResponseData)))));
    }
    /** Executes the 'upload' hook for a file uploaded in chunks (no chunks) **/
    uploadFileByChunk$(file, userData, startByte = 0) {
        const remainingBytes = file.file.size - startByte;
        const startChunkIndex = Math.floor(startByte / this.chunkSizeInBytes);
        const chunkCount = Math.ceil(remainingBytes / this.chunkSizeInBytes);
        const uploadChunksInSequence$ = (beforeUploadResponseData) => {
            const chunkUploadRequests$ = from([...Array(chunkCount).keys()].map((i) => ({ chunkIndex: startChunkIndex + i }))).pipe(concatMap(({ chunkIndex }) => this.readFile(file.file, this.chunkSizeInBytes * chunkIndex).pipe(mergeMap((chunkData) => this.fileUploadHttp.uploadByChunk(file.file, beforeUploadResponseData, chunkData, chunkIndex).pipe(tap((uploadResponseData) => {
                const totalBytesUploaded = chunkIndex * this.chunkSizeInBytes + chunkData.byteLength; // last chunk may not be of full chunk size
                const progress = (totalBytesUploaded / file.file.size) * 100;
                this.setUploadResponseData({ id: file.id, uploadResponseData });
                this.setFileUploadProgress({ id: file.id, progress, resumeByte: totalBytesUploaded });
            }))))), catchError((error) => {
                this.fileUploadHttp.onUploadError?.(error, userData, beforeUploadResponseData);
                return throwError(error);
            }));
            return chunkUploadRequests$;
        };
        return this._beforeUpload$(file, userData, chunkCount).pipe(mergeMap((beforeUploadResponseData) => uploadChunksInSequence$(beforeUploadResponseData).pipe(toArray(), 
        // send the response from the last chunk upload for now
        mergeMap((uploadResponseDataArray) => this._afterUpload$(file, userData, beforeUploadResponseData, uploadResponseDataArray[uploadResponseDataArray.length - 1])))));
    }
    convertFilesItem(files) {
        return files.map((file) => {
            const mimeType = file.type || Mime.getType(file.name);
            return {
                id: v4(),
                filename: file.name,
                progress: 0,
                status: FileStatus.INIT,
                file,
                url: '',
                mimeType,
                allowed: true,
                fallbackIcon: getFallbackIcon(mimeType),
                resumeByte: 0,
            };
        });
    }
    ngOnDestroy() {
        this.cancelAllFileUploads();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderStore, deps: "invalid", target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FileUploaderStore, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderStore, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: undefined }]; } });

class DataTableActionsComponent {
    constructor() {
        /** Action icon was clicked **/
        this.action = new EventEmitter();
        /**
         * @ignore Pattern used to close all subscriptions
         */
        this.componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngAfterContentInit() {
        // watch the icon list changes to register new actions
        this.iconComponents.changes.pipe(startWith(this.iconComponents), takeUntil(this.componentDestroyed$)).subscribe((iconList) => {
            iconList.forEach((icon) => this.registerIconAction(icon));
        });
    }
    /**
     * @ignore listen to the action event of the icon
     */
    registerIconAction(_icon) {
        // make sure that we don't subscribe twice to the same icon component
        // only subscribe to new elements in the list
        // if (icon.click.observers.length === 0) {
        //   icon.click.pipe(takeUntil(this.componentDestroyed$)).subscribe(evt => {
        //     this.action.emit({action: evt.actionId, row: this.dataRow});
        //   });
        // }
    }
    /** @ignore */
    ngOnDestroy() {
        // unsubscribe all subscriptions
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
        // make sure to end all subscriptions to the action output when this component is destroyed
        // especially useful when used in a list with virtual scroll to end subscription as soon as the
        // component is removed from the list, and not wait until the list is destroyed.
        this.action.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DataTableActionsComponent, selector: "avn-data-table-actions", inputs: { dataRow: "dataRow" }, outputs: { action: "action" }, queries: [{ propertyName: "iconComponents", predicate: IconComponent }], ngImport: i0, template: "<ng-content select=\"avn-icon\"></ng-content>\n", styles: [":host{display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;align-items:center;height:100%}::ng-deep avn-data-table-actions>avn-icon{color:var(--data-table-action-icon)}::ng-deep avn-data-table-actions>avn-icon:hover{color:var(--data-table-action-icon-hover)}::ng-deep avn-data-table-actions>avn-icon:not(:last-child){margin-right:var(--space-base)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableActionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-data-table-actions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content select=\"avn-icon\"></ng-content>\n", styles: [":host{display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;align-items:center;height:100%}::ng-deep avn-data-table-actions>avn-icon{color:var(--data-table-action-icon)}::ng-deep avn-data-table-actions>avn-icon:hover{color:var(--data-table-action-icon-hover)}::ng-deep avn-data-table-actions>avn-icon:not(:last-child){margin-right:var(--space-base)}\n"] }]
        }], propDecorators: { dataRow: [{
                type: Input
            }], iconComponents: [{
                type: ContentChildren,
                args: [IconComponent]
            }], action: [{
                type: Output
            }] } });

class DragAndDropDirective {
    constructor(_window, sanitizer) {
        this._window = _window;
        this.sanitizer = sanitizer;
        this.filesDropped = new EventEmitter();
        this.DEFAULT_BACKGROUND = 'var(--topnav-background)';
        this.background = this.DEFAULT_BACKGROUND;
    }
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = this.DEFAULT_BACKGROUND;
    }
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = 'var(--topnav-variant-background)';
    }
    onDrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = this.DEFAULT_BACKGROUND;
        this.processFiles(Array.from(evt.dataTransfer.files));
    }
    processFiles(rawFiles) {
        const files = rawFiles.map((rawFile) => {
            const blob = this._window.URL.createObjectURL(rawFile);
            const file = {
                file: rawFile,
                progress: 0,
                url: this.sanitizer.bypassSecurityTrustUrl(blob),
                mimeType: rawFile.type || Mime.getType(rawFile.name),
            };
            file.allowed = isFileAllowed(file, this.allowedTypes);
            file.fallbackIcon = getFallbackIcon(file.mimeType);
            return file;
        });
        if (files.length > 0) {
            this.filesDropped.emit(files);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragAndDropDirective, deps: [{ token: WINDOW }, { token: i1$8.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: DragAndDropDirective, selector: "[avnDragAndDrop]", inputs: { allowedTypes: "allowedTypes" }, outputs: { filesDropped: "filesDropped" }, host: { listeners: { "dragleave": "onDragLeave($event)", "dragover": "onDragOver($event)", "drop": "onDrop($event)" }, properties: { "style.background": "this.background" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DragAndDropDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnDragAndDrop]',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1$8.DomSanitizer }]; }, propDecorators: { allowedTypes: [{
                type: Input
            }], filesDropped: [{
                type: Output
            }], background: [{
                type: HostBinding,
                args: ['style.background']
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

class FallbackImageDirective {
    constructor(renderer, elementRef, viewContainerRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
    }
    loaded() {
        const element = this.elementRef.nativeElement;
        this.renderer.removeStyle(element, 'display');
        this.viewContainerRef.clear();
    }
    loadFallBackImage() {
        const element = this.elementRef.nativeElement;
        element.style.display = 'none';
        this.viewContainerRef.clear();
        this.viewContainerRef.createEmbeddedView(this.fallbackImageTemplate, { icon: this.fallbackIcon });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FallbackImageDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FallbackImageDirective, selector: "[avnFallbackImage]", inputs: { fallbackImageTemplate: "fallbackImageTemplate", fallbackIcon: "fallbackIcon" }, host: { listeners: { "load": "loaded()", "error": "loadFallBackImage()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FallbackImageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnFallbackImage]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { fallbackImageTemplate: [{
                type: Input
            }], fallbackIcon: [{
                type: Input
            }], loaded: [{
                type: HostListener,
                args: ['load']
            }], loadFallBackImage: [{
                type: HostListener,
                args: ['error']
            }] } });

class FileUploaderComponent {
    constructor(cdr, modalService) {
        this.cdr = cdr;
        this.modalService = modalService;
        /**
         * limit of files allowed to upload together.
         * Set to 1 for single file or use a value greater than 1 for multiple files.
         * Default is 1.
         */
        this.fileLimit = 1;
        this.selectedFiles = new EventEmitter();
        this.disabled = false;
        /**
         * The datatable columns configuration.
         * Column definitions are fixed but labels are not. Pass the translation for
         * the labels in labels input.
         */
        this.columns = [];
        this.FileStatus = FileStatus;
        this.PlacementTypes = PlacementTypes;
        this.themeType = ThemeType;
        this.FileDataTableColumns = FileDataTableColumns;
        this.acknowledge$ = new BehaviorSubject(false);
        /** @ignore pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.files$ = this.fileUploaderStore.selectFiles$;
        this.hasError$ = this.files$.pipe(map((files) => (!!this.fileLimit && files.length > this.fileLimit) || files.some((file) => !file.allowed)));
        this.hasFile$ = this.fileUploaderStore.selectHasFile$;
        this.isUploading$ = this.fileUploaderStore.selectIsUploading$;
        this.showNotification$ = combineLatest([this.hasError$, this.acknowledge$]).pipe(map(([hasError, acknowledge]) => hasError && !acknowledge));
        this.fileDataSource$ = this.files$.pipe(map((files) => ({ rows: files, totalRowCount: files.length })));
    }
    ngOnChanges({ allowedFileTypes, tableColumnsConfig, chunkSize }) {
        if (tableColumnsConfig && !tableColumnsConfig.firstChange) {
            // Call createColumn from ngOnChanges only when it's not first change
            // Initialization of the columns should be called from ngAfterViewInit to
            // have column cell template rendered properly
            this.createColumns();
        }
        if (allowedFileTypes) {
            this.fileUploaderStore.changeAllowedFileTypes(allowedFileTypes.currentValue);
        }
        if (chunkSize?.currentValue) {
            this.fileUploaderStore.setChunkSize(chunkSize.currentValue);
        }
    }
    ngAfterViewInit() {
        this.createColumns();
    }
    /** @ignore */
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    createColumns() {
        this.columns = Object.values(FileDataTableColumns).map((columnField) => ({
            id: columnField,
            name: this.tableColumnsConfig[columnField]?.label || DefaultFileUploaderTableColumnsConfig[columnField].label,
            prop: this.getColumnProperty(columnField),
            sortable: this.getColumnSortable(columnField),
            widthPx: this.tableColumnsConfig[columnField]?.widthPx || DefaultFileUploaderTableColumnsConfig[columnField].widthPx,
            dataCellTemplate: this.getColumnCellTemplate(columnField),
        }));
    }
    acknowledgeError() {
        if (!this.disabled) {
            this.acknowledge$.next(true);
        }
    }
    onFilesDropped($event) {
        if (!this.disabled) {
            this.fileUploaderStore.addFiles($event.map((e) => e.file), true, { height: 100 });
        }
    }
    addFiles($event) {
        this.acknowledge$.next(false);
        const newFiles = $event?.target?.files ? Array.from($event?.target?.files) : [];
        this.fileUploaderStore.addFiles(newFiles, true, { height: 100 });
    }
    deleteFile(id) {
        this.fileUploaderStore.deleteFile(id);
    }
    deleteFiles() {
        this.acknowledge$.next(false);
        this.fileUploaderStore.deleteFiles();
    }
    clearFiles() {
        if (this.labels.clearFilesWarningMsg) {
            const modalRef = this.modalService.openStandardDialog(this.getDialogConfig(this.labels.clearFilesButtonLabel, this.labels.clearFilesWarningMsg));
            modalRef.componentInstance.accepted.pipe(take(1)).subscribe((_) => {
                this.deleteFiles();
            });
        }
        else {
            this.deleteFiles();
        }
    }
    uploadFiles() {
        this.fileUploaderStore.uploadFiles().pipe(takeUntil(this.componentDestroyed$)).subscribe();
    }
    pauseUpload(id) {
        this.fileUploaderStore.pauseUpload(id);
    }
    resumeUpload(id) {
        this.fileUploaderStore.resumeUpload(id).pipe(takeUntil(this.componentDestroyed$)).subscribe();
    }
    startUpload(id) {
        this.fileUploaderStore.startUpload(id).pipe(takeUntil(this.componentDestroyed$)).subscribe();
    }
    abortAllUpload() {
        if (this.labels.abortWarningMsg) {
            const modalRef = this.modalService.openStandardDialog(this.getDialogConfig(this.labels.abortButtonLabel, this.labels.abortWarningMsg));
            modalRef.componentInstance.accepted.pipe(take(1)).subscribe((_) => {
                this.fileUploaderStore.cancelAllFileUploads();
                // Force change detection otherwise abort/upload button status doesn't
                // change Only need to force change detection when modal dialog is used
                this.cdr.detectChanges();
            });
        }
        else {
            this.fileUploaderStore.cancelAllFileUploads();
        }
    }
    abortFile(id) {
        this.fileUploaderStore.cancelFileUpload(id);
    }
    getDialogConfig(title, message) {
        const dialogData = {
            type: ModalDialogType.Confirm,
            theme: ThemeType.WARNING,
            title,
            message,
            closeActionLabel: this.labels.cancelButtonLabel,
            acceptActionLabel: title,
        };
        const dialogConfig = {
            showCloseIcon: true,
            closeOnBackdropClick: true,
            data: dialogData,
        };
        return dialogConfig;
    }
    getColumnProperty(columnField) {
        switch (columnField) {
            case FileDataTableColumns.THUMBNAIL:
                return 'url';
            case FileDataTableColumns.TYPE:
                return 'mimeType';
            case FileDataTableColumns.PROGRESS:
            case FileDataTableColumns.ACTIONS:
                return columnField;
            default:
                return `file.${columnField}`;
        }
    }
    getColumnSortable(columnField) {
        switch (columnField) {
            case FileDataTableColumns.THUMBNAIL:
            case FileDataTableColumns.ACTIONS:
                return false;
            default:
                return this.tableColumnsConfig[columnField]?.sortable != null ? this.tableColumnsConfig[columnField].sortable : DefaultFileUploaderTableColumnsConfig[columnField].sortable;
        }
    }
    getColumnCellTemplate(columnField) {
        switch (columnField) {
            case FileDataTableColumns.THUMBNAIL:
                return this.thumbnailTemplate;
            case FileDataTableColumns.PROGRESS:
                return this.progressTemplate;
            case FileDataTableColumns.SIZE:
                return this.sizeTemplate;
            case FileDataTableColumns.LAST_MODIFIED:
                return this.lastModifiedTemplate;
            case FileDataTableColumns.ACTIONS:
                return this.actionsTemplate;
            default:
                return undefined;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: ModalService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: FileUploaderComponent, selector: "avn-file-uploader", inputs: { fileUploaderStore: "fileUploaderStore", fileLimit: "fileLimit", allowedFileTypes: "allowedFileTypes", labels: "labels", tableColumnsConfig: "tableColumnsConfig", chunkSize: "chunkSize", disabled: "disabled" }, outputs: { selectedFiles: "selectedFiles" }, host: { properties: { "class.disabled": "this.disabled" } }, viewQueries: [{ propertyName: "table", first: true, predicate: ["table"], descendants: true }, { propertyName: "thumbnailTemplate", first: true, predicate: ["thumbnailTemplate"], descendants: true }, { propertyName: "progressTemplate", first: true, predicate: ["progressTemplate"], descendants: true }, { propertyName: "sizeTemplate", first: true, predicate: ["sizeTemplate"], descendants: true }, { propertyName: "lastModifiedTemplate", first: true, predicate: ["lastModifiedTemplate"], descendants: true }, { propertyName: "actionsTemplate", first: true, predicate: ["actionsTemplate"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"content\">\n  <div *ngIf=\"(hasFile$ | async) === false\" class=\"dropzone\" avnDragAndDrop [allowedTypes]=\"allowedFileTypes\" (filesDropped)=\"onFilesDropped($event)\">\n    <avn-icon [fontSize]=\"80\" icon=\"action:backup\"></avn-icon>\n    <div [innerHTML]=\"labels.dropZoneLabel\"></div>\n  </div>\n\n  <div *ngIf=\"hasFile$ | async\" class=\"file-table\">\n    <avn-data-table\n      #table\n      [columns]=\"columns\"\n      [dataSource]=\"fileDataSource$ | async\"\n      [rowHeight]=\"50\"\n      [tableHeight]=\"'auto'\"\n      [showHeader]=\"(fileDataSource$ | async)?.totalRowCount > 0\"\n      [serverSorting]=\"false\"\n      [isStaticDataSource]=\"true\"\n      [forceLoadingState]=\"false\"\n      [keyboardNavigationEnabled]=\"false\"\n    >\n      <avn-data-table-notification-message\n        [offsetY]=\"table.headerHeight + 10\"\n        [text]=\"labels.errorsFoundWarningMsg\"\n        [actionIcon]=\"'content:clear'\"\n        [show]=\"showNotification$ | async\"\n        (clicked)=\"acknowledgeError()\"\n      >\n      </avn-data-table-notification-message>\n    </avn-data-table>\n  </div>\n</div>\n\n<div class=\"actions\">\n  <avn-button [label]=\"labels.addFilesButtonLabel\" [avnTheme]=\"themeType.SECONDARY\" (actioned)=\"uploader.click()\">\n    <input\n      #uploader\n      hidden\n      id=\"add-files\"\n      type=\"file\"\n      [accept]=\"allowedFileTypes\"\n      [multiple]=\"fileLimit !== 1\"\n      [disabled]=\"disabled\"\n      (change)=\"addFiles($event)\"\n      onclick=\"this.value = null\"\n    />\n  </avn-button>\n\n  <avn-button\n    [label]=\"labels.clearFilesButtonLabel\"\n    [avnTheme]=\"themeType.SECONDARY\"\n    [disabled]=\"disabled || (isUploading$ | async) || (hasFile$ | async) === false\"\n    (actioned)=\"clearFiles()\"\n  >\n  </avn-button>\n  <avn-button\n    *ngIf=\"(isUploading$ | async) === false\"\n    [label]=\"labels.uploadButtonLabel\"\n    [avnTheme]=\"themeType.PRIMARY\"\n    [disabled]=\"disabled || (hasFile$ | async) === false || (hasError$ | async)\"\n    (actioned)=\"uploadFiles()\"\n  >\n  </avn-button>\n  <avn-button *ngIf=\"isUploading$ | async\" [label]=\"labels.abortButtonLabel\" [avnTheme]=\"themeType.WARNING\" [disabled]=\"disabled\" (actioned)=\"abortAllUpload()\"></avn-button>\n</div>\n\n<ng-template #fallbackImageTemplate let-icon=\"icon\">\n  <avn-icon [fontSize]=\"50\" [icon]=\"icon\"></avn-icon>\n</ng-template>\n\n<ng-template #thumbnailTemplate let-row=\"row\">\n  <img\n    *ngIf=\"row.url\"\n    [attr.src]=\"row.url\"\n    [style.height.px]=\"table.rowHeight - 10\"\n    [style.width.px]=\"columns && columns[FileDataTableColumns.THUMBNAIL]?.widthPx\"\n    avnFallbackImage\n    [fallbackImageTemplate]=\"fallbackImageTemplate\"\n    [fallbackIcon]=\"row.fallbackIcon\"\n  />\n</ng-template>\n\n<ng-template #progressTemplate let-row=\"row\">\n  <div class=\"progress\">\n    <div class=\"gauge\" [style.width.%]=\"row.progress\" [avnThemify]=\"row.status === FileStatus.ERROR ? themeType.DANGER : themeType.SUCCESS\"></div>\n    <span>{{ row.progress | number: '1.2-2' }}%</span>\n  </div>\n</ng-template>\n\n<ng-template #sizeTemplate let-row=\"row\"> {{ row.file.size | fileSize }} </ng-template>\n\n<ng-template #lastModifiedTemplate let-row=\"row\">{{ row.file.lastModified | date: 'yyyy-MM-dd HH:mm:ss' }} </ng-template>\n\n<ng-template #actionsTemplate let-row=\"row\">\n  <avn-data-table-actions [dataRow]=\"row\">\n    <avn-icon *ngIf=\"row.status === FileStatus.UPLOADED\" class=\"file-upload-success-icon\" icon=\"action:check\"> </avn-icon>\n    <avn-icon *ngIf=\"row.status === FileStatus.ERROR\" class=\"file-upload-error-icon\" icon=\"action:error\" [avnTooltip]=\"row.error?.message\" [tooltipPlacement]=\"PlacementTypes.top\">\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.INIT\"\n      icon=\"action:file_upload\"\n      [avnTooltip]=\"labels.uploadButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      [disabled]=\"disabled || (hasFile$ | async) === false || (hasError$ | async)\"\n      (click)=\"startUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.PAUSED\"\n      icon=\"action:play_arrow\"\n      actionId=\"resume\"\n      [avnTooltip]=\"labels.resumeButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"resumeUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.ERROR\"\n      icon=\"action:refresh\"\n      actionId=\"resume\"\n      [avnTooltip]=\"labels.retryButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"resumeUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status !== FileStatus.QUEUED && row.status !== FileStatus.UPLOADING\"\n      icon=\"action:delete\"\n      actionId=\"delete\"\n      [avnTooltip]=\"labels.deleteFileActionButtonTooltip\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      [disabled]=\"disabled\"\n      (click)=\"deleteFile(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.QUEUED || row.status === FileStatus.UPLOADING\"\n      icon=\"action:pause\"\n      actionId=\"pause\"\n      [avnTooltip]=\"labels.pauseButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"pauseUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.QUEUED || row.status === FileStatus.UPLOADING\"\n      icon=\"action:not_interested\"\n      actionId=\"abort\"\n      [avnTooltip]=\"labels.abortButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"abortFile(row.id)\"\n    >\n    </avn-icon>\n  </avn-data-table-actions>\n</ng-template>\n", styles: [":host{height:inherit;width:inherit;padding:var(--space-md);display:flex;flex-direction:column}:host.disabled{opacity:.5}:host .content{flex-grow:1;height:100%}:host .content .dropzone{height:inherit;border:1px dotted var(--form-control-border);border-radius:3px;display:flex;flex-direction:column;justify-content:center}:host .content .dropzone>avn-icon{flex-grow:1}:host .content .dropzone>div{flex-grow:1;text-align:center}:host .content .file-table{height:inherit}:host .content .file-table .progress{width:inherit;padding:2px 0;position:relative;overflow:hidden;z-index:1;display:flex;align-items:center;justify-content:center;border:1px solid var(--progress-bar-background);border-radius:3px}:host .content .file-table .progress>.gauge{height:100%;z-index:0;position:absolute;top:0;left:0}:host .content .file-table .progress>span{position:relative;z-index:1}:host .actions{margin-top:var(--space-md);display:flex;flex-direction:row;justify-content:center}:host .actions>:not(:last-child){margin-right:var(--space-sm)}:host .actions .add-files{padding:var(--space-sm) var(--space-md);will-change:background-color;will-change:color;will-change:border-color;border:1px solid transparent;border-radius:3px;background-color:var(--button-background);color:var(--button-on)}:host .actions .add-files.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .actions .add-files.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .actions .add-files.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .actions .add-files.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .actions .add-files.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .actions .add-files.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .actions .add-files.theme-success{background-color:var(--success-base);color:var(--success-on)}:host .actions .add-files.theme-primary>label:hover,:host .actions .add-files.theme-primary:hover{background-color:var(--primary-base);color:var(--primary-on)}:host .actions .add-files.theme-primary>label:hover,:host .actions .add-files.theme-primary:hover:hover{background-color:var(--primary-variant)}:host .actions .add-files.theme-secondary>label:hover,:host .actions .add-files.theme-secondary:hover{background-color:var(--secondary-base);color:var(--secondary-on)}:host .actions .add-files.theme-secondary>label:hover,:host .actions .add-files.theme-secondary:hover:hover{background-color:var(--secondary-variant)}:host .actions .add-files.theme-highlight>label:hover,:host .actions .add-files.theme-highlight:hover{background-color:var(--highlight-base);color:var(--highlight-on)}:host .actions .add-files.theme-highlight>label:hover,:host .actions .add-files.theme-highlight:hover:hover{background-color:var(--highlight-variant)}:host .actions .add-files.theme-danger>label:hover,:host .actions .add-files.theme-danger:hover{background-color:var(--danger-base);color:var(--danger-on)}:host .actions .add-files.theme-danger>label:hover,:host .actions .add-files.theme-danger:hover:hover{background-color:var(--danger-variant)}:host .actions .add-files.theme-warning>label:hover,:host .actions .add-files.theme-warning:hover{background-color:var(--warning-base);color:var(--warning-on)}:host .actions .add-files.theme-warning>label:hover,:host .actions .add-files.theme-warning:hover:hover{background-color:var(--warning-variant)}:host .actions .add-files.theme-info>label:hover,:host .actions .add-files.theme-info:hover{background-color:var(--info-base);color:var(--info-on)}:host .actions .add-files.theme-info>label:hover,:host .actions .add-files.theme-info:hover:hover{background-color:var(--info-variant)}:host .actions .add-files.theme-success>label:hover,:host .actions .add-files.theme-success:hover{background-color:var(--success-base);color:var(--success-on)}:host .actions .add-files.theme-success>label:hover,:host .actions .add-files.theme-success:hover:hover{background-color:var(--success-variant)}:host .actions .add-files:hover{cursor:pointer}:host .actions .add-files>label{margin-bottom:0}:host .actions .add-files>label:hover{cursor:pointer}:host .file-upload-error-icon{color:var(--danger-base)!important}:host .file-upload-success-icon{color:var(--success-base)!important}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ThemifyDirective, selector: "[avnThemify]", inputs: ["avnThemify"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "component", type: DataTableComponent, selector: "avn-data-table", inputs: ["customLoaderTemplate", "columns", "dataSource", "dataSourceConfig", "selectedItemIds", "dragDropRowsEnabled", "headerCellTemplate", "tableHeight", "tableMaxHeight", "headerHeight", "footerHeight", "footerTemplate", "rowHeight", "dataRowVerticalAlign", "infiniteScrollPreloadStrategy", "infiniteScrollPreloadValue", "pageSize", "serverSorting", "sortBy", "selectionMode", "themeIndicatorWidthPx", "forceLoadingState", "loaderTheme", "horizontalLoaderPosition", "keyboardNavigationEnabled", "rowClassFn", "showHeader", "isStaticDataSource", "infiniteScrollEnabled", "minColumnWidthPx", "columnsResizeStrategy", "showHorizontalScrollArrows", "indexTrackFn", "templateCacheSize", "headerTooltipsEnabled", "columnsOverflowStrategy", "initialDataLoader"], outputs: ["fetchData", "columnSorted", "columnReordered", "entireDataSetSelected", "selectionChanged", "rowClicked", "rowDoubleClicked", "rowActivated", "notificationMessageClicked", "dataLoaded", "columnResized", "columnNavigated"] }, { kind: "component", type: DataTableActionsComponent, selector: "avn-data-table-actions", inputs: ["dataRow"], outputs: ["action"] }, { kind: "component", type: DataTableNotificationMessageComponent, selector: "avn-data-table-notification-message", inputs: ["show", "text", "offsetY", "actionText", "actionIcon", "actionTheme"], outputs: ["clicked"] }, { kind: "directive", type: TooltipDirective, selector: "[avnTooltip]", inputs: ["avnTooltip", "tooltipName", "tooltipTemplate", "templateContext", "tooltipTheme", "tooltipPlacement", "tooltipMaxWidth", "tooltipDisabled", "tooltipTrigger", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipMouseLeaveCloseDelay", "tooltipMouseEnterOpenDelay"], outputs: ["show", "hide"] }, { kind: "directive", type: DragAndDropDirective, selector: "[avnDragAndDrop]", inputs: ["allowedTypes"], outputs: ["filesDropped"] }, { kind: "directive", type: FallbackImageDirective, selector: "[avnFallbackImage]", inputs: ["fallbackImageTemplate", "fallbackIcon"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$2.DecimalPipe, name: "number" }, { kind: "pipe", type: i1$2.DatePipe, name: "date" }, { kind: "pipe", type: FileSizePipe, name: "fileSize" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-file-uploader', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"content\">\n  <div *ngIf=\"(hasFile$ | async) === false\" class=\"dropzone\" avnDragAndDrop [allowedTypes]=\"allowedFileTypes\" (filesDropped)=\"onFilesDropped($event)\">\n    <avn-icon [fontSize]=\"80\" icon=\"action:backup\"></avn-icon>\n    <div [innerHTML]=\"labels.dropZoneLabel\"></div>\n  </div>\n\n  <div *ngIf=\"hasFile$ | async\" class=\"file-table\">\n    <avn-data-table\n      #table\n      [columns]=\"columns\"\n      [dataSource]=\"fileDataSource$ | async\"\n      [rowHeight]=\"50\"\n      [tableHeight]=\"'auto'\"\n      [showHeader]=\"(fileDataSource$ | async)?.totalRowCount > 0\"\n      [serverSorting]=\"false\"\n      [isStaticDataSource]=\"true\"\n      [forceLoadingState]=\"false\"\n      [keyboardNavigationEnabled]=\"false\"\n    >\n      <avn-data-table-notification-message\n        [offsetY]=\"table.headerHeight + 10\"\n        [text]=\"labels.errorsFoundWarningMsg\"\n        [actionIcon]=\"'content:clear'\"\n        [show]=\"showNotification$ | async\"\n        (clicked)=\"acknowledgeError()\"\n      >\n      </avn-data-table-notification-message>\n    </avn-data-table>\n  </div>\n</div>\n\n<div class=\"actions\">\n  <avn-button [label]=\"labels.addFilesButtonLabel\" [avnTheme]=\"themeType.SECONDARY\" (actioned)=\"uploader.click()\">\n    <input\n      #uploader\n      hidden\n      id=\"add-files\"\n      type=\"file\"\n      [accept]=\"allowedFileTypes\"\n      [multiple]=\"fileLimit !== 1\"\n      [disabled]=\"disabled\"\n      (change)=\"addFiles($event)\"\n      onclick=\"this.value = null\"\n    />\n  </avn-button>\n\n  <avn-button\n    [label]=\"labels.clearFilesButtonLabel\"\n    [avnTheme]=\"themeType.SECONDARY\"\n    [disabled]=\"disabled || (isUploading$ | async) || (hasFile$ | async) === false\"\n    (actioned)=\"clearFiles()\"\n  >\n  </avn-button>\n  <avn-button\n    *ngIf=\"(isUploading$ | async) === false\"\n    [label]=\"labels.uploadButtonLabel\"\n    [avnTheme]=\"themeType.PRIMARY\"\n    [disabled]=\"disabled || (hasFile$ | async) === false || (hasError$ | async)\"\n    (actioned)=\"uploadFiles()\"\n  >\n  </avn-button>\n  <avn-button *ngIf=\"isUploading$ | async\" [label]=\"labels.abortButtonLabel\" [avnTheme]=\"themeType.WARNING\" [disabled]=\"disabled\" (actioned)=\"abortAllUpload()\"></avn-button>\n</div>\n\n<ng-template #fallbackImageTemplate let-icon=\"icon\">\n  <avn-icon [fontSize]=\"50\" [icon]=\"icon\"></avn-icon>\n</ng-template>\n\n<ng-template #thumbnailTemplate let-row=\"row\">\n  <img\n    *ngIf=\"row.url\"\n    [attr.src]=\"row.url\"\n    [style.height.px]=\"table.rowHeight - 10\"\n    [style.width.px]=\"columns && columns[FileDataTableColumns.THUMBNAIL]?.widthPx\"\n    avnFallbackImage\n    [fallbackImageTemplate]=\"fallbackImageTemplate\"\n    [fallbackIcon]=\"row.fallbackIcon\"\n  />\n</ng-template>\n\n<ng-template #progressTemplate let-row=\"row\">\n  <div class=\"progress\">\n    <div class=\"gauge\" [style.width.%]=\"row.progress\" [avnThemify]=\"row.status === FileStatus.ERROR ? themeType.DANGER : themeType.SUCCESS\"></div>\n    <span>{{ row.progress | number: '1.2-2' }}%</span>\n  </div>\n</ng-template>\n\n<ng-template #sizeTemplate let-row=\"row\"> {{ row.file.size | fileSize }} </ng-template>\n\n<ng-template #lastModifiedTemplate let-row=\"row\">{{ row.file.lastModified | date: 'yyyy-MM-dd HH:mm:ss' }} </ng-template>\n\n<ng-template #actionsTemplate let-row=\"row\">\n  <avn-data-table-actions [dataRow]=\"row\">\n    <avn-icon *ngIf=\"row.status === FileStatus.UPLOADED\" class=\"file-upload-success-icon\" icon=\"action:check\"> </avn-icon>\n    <avn-icon *ngIf=\"row.status === FileStatus.ERROR\" class=\"file-upload-error-icon\" icon=\"action:error\" [avnTooltip]=\"row.error?.message\" [tooltipPlacement]=\"PlacementTypes.top\">\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.INIT\"\n      icon=\"action:file_upload\"\n      [avnTooltip]=\"labels.uploadButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      [disabled]=\"disabled || (hasFile$ | async) === false || (hasError$ | async)\"\n      (click)=\"startUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.PAUSED\"\n      icon=\"action:play_arrow\"\n      actionId=\"resume\"\n      [avnTooltip]=\"labels.resumeButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"resumeUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.ERROR\"\n      icon=\"action:refresh\"\n      actionId=\"resume\"\n      [avnTooltip]=\"labels.retryButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"resumeUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status !== FileStatus.QUEUED && row.status !== FileStatus.UPLOADING\"\n      icon=\"action:delete\"\n      actionId=\"delete\"\n      [avnTooltip]=\"labels.deleteFileActionButtonTooltip\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      [disabled]=\"disabled\"\n      (click)=\"deleteFile(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.QUEUED || row.status === FileStatus.UPLOADING\"\n      icon=\"action:pause\"\n      actionId=\"pause\"\n      [avnTooltip]=\"labels.pauseButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"pauseUpload(row.id)\"\n    >\n    </avn-icon>\n\n    <avn-icon\n      *ngIf=\"row.status === FileStatus.QUEUED || row.status === FileStatus.UPLOADING\"\n      icon=\"action:not_interested\"\n      actionId=\"abort\"\n      [avnTooltip]=\"labels.abortButtonLabel\"\n      [tooltipPlacement]=\"PlacementTypes.top\"\n      (click)=\"abortFile(row.id)\"\n    >\n    </avn-icon>\n  </avn-data-table-actions>\n</ng-template>\n", styles: [":host{height:inherit;width:inherit;padding:var(--space-md);display:flex;flex-direction:column}:host.disabled{opacity:.5}:host .content{flex-grow:1;height:100%}:host .content .dropzone{height:inherit;border:1px dotted var(--form-control-border);border-radius:3px;display:flex;flex-direction:column;justify-content:center}:host .content .dropzone>avn-icon{flex-grow:1}:host .content .dropzone>div{flex-grow:1;text-align:center}:host .content .file-table{height:inherit}:host .content .file-table .progress{width:inherit;padding:2px 0;position:relative;overflow:hidden;z-index:1;display:flex;align-items:center;justify-content:center;border:1px solid var(--progress-bar-background);border-radius:3px}:host .content .file-table .progress>.gauge{height:100%;z-index:0;position:absolute;top:0;left:0}:host .content .file-table .progress>span{position:relative;z-index:1}:host .actions{margin-top:var(--space-md);display:flex;flex-direction:row;justify-content:center}:host .actions>:not(:last-child){margin-right:var(--space-sm)}:host .actions .add-files{padding:var(--space-sm) var(--space-md);will-change:background-color;will-change:color;will-change:border-color;border:1px solid transparent;border-radius:3px;background-color:var(--button-background);color:var(--button-on)}:host .actions .add-files.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .actions .add-files.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .actions .add-files.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .actions .add-files.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .actions .add-files.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .actions .add-files.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .actions .add-files.theme-success{background-color:var(--success-base);color:var(--success-on)}:host .actions .add-files.theme-primary>label:hover,:host .actions .add-files.theme-primary:hover{background-color:var(--primary-base);color:var(--primary-on)}:host .actions .add-files.theme-primary>label:hover,:host .actions .add-files.theme-primary:hover:hover{background-color:var(--primary-variant)}:host .actions .add-files.theme-secondary>label:hover,:host .actions .add-files.theme-secondary:hover{background-color:var(--secondary-base);color:var(--secondary-on)}:host .actions .add-files.theme-secondary>label:hover,:host .actions .add-files.theme-secondary:hover:hover{background-color:var(--secondary-variant)}:host .actions .add-files.theme-highlight>label:hover,:host .actions .add-files.theme-highlight:hover{background-color:var(--highlight-base);color:var(--highlight-on)}:host .actions .add-files.theme-highlight>label:hover,:host .actions .add-files.theme-highlight:hover:hover{background-color:var(--highlight-variant)}:host .actions .add-files.theme-danger>label:hover,:host .actions .add-files.theme-danger:hover{background-color:var(--danger-base);color:var(--danger-on)}:host .actions .add-files.theme-danger>label:hover,:host .actions .add-files.theme-danger:hover:hover{background-color:var(--danger-variant)}:host .actions .add-files.theme-warning>label:hover,:host .actions .add-files.theme-warning:hover{background-color:var(--warning-base);color:var(--warning-on)}:host .actions .add-files.theme-warning>label:hover,:host .actions .add-files.theme-warning:hover:hover{background-color:var(--warning-variant)}:host .actions .add-files.theme-info>label:hover,:host .actions .add-files.theme-info:hover{background-color:var(--info-base);color:var(--info-on)}:host .actions .add-files.theme-info>label:hover,:host .actions .add-files.theme-info:hover:hover{background-color:var(--info-variant)}:host .actions .add-files.theme-success>label:hover,:host .actions .add-files.theme-success:hover{background-color:var(--success-base);color:var(--success-on)}:host .actions .add-files.theme-success>label:hover,:host .actions .add-files.theme-success:hover:hover{background-color:var(--success-variant)}:host .actions .add-files:hover{cursor:pointer}:host .actions .add-files>label{margin-bottom:0}:host .actions .add-files>label:hover{cursor:pointer}:host .file-upload-error-icon{color:var(--danger-base)!important}:host .file-upload-success-icon{color:var(--success-base)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: ModalService }]; }, propDecorators: { table: [{
                type: ViewChild,
                args: ['table', { static: false }]
            }], thumbnailTemplate: [{
                type: ViewChild,
                args: ['thumbnailTemplate', { static: false }]
            }], progressTemplate: [{
                type: ViewChild,
                args: ['progressTemplate', { static: false }]
            }], sizeTemplate: [{
                type: ViewChild,
                args: ['sizeTemplate', { static: false }]
            }], lastModifiedTemplate: [{
                type: ViewChild,
                args: ['lastModifiedTemplate', { static: false }]
            }], actionsTemplate: [{
                type: ViewChild,
                args: ['actionsTemplate', { static: false }]
            }], fileUploaderStore: [{
                type: Input
            }], fileLimit: [{
                type: Input
            }], allowedFileTypes: [{
                type: Input
            }], labels: [{
                type: Input
            }], tableColumnsConfig: [{
                type: Input
            }], chunkSize: [{
                type: Input
            }], selectedFiles: [{
                type: Output
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: Input
            }] } });

/**
 * This component can be projected into to the avn-datatable.
 * It is a placeholder displayed when the datatable does not contain any data.
 * It can be configured to have a icon, a main text and a sub text
 */
class EmptyDataMessageComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: EmptyDataMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: EmptyDataMessageComponent, selector: "avn-empty-data-message", inputs: { icon: "icon", text: "text", subText: "subText" }, ngImport: i0, template: "<avn-icon [fontSize]=\"100\" *ngIf=\"icon\" [icon]=\"icon\"></avn-icon>\n<span class=\"text\" *ngIf=\"text\" [innerHTML]=\"text\"></span>\n<span class=\"sub-text\" *ngIf=\"subText\" [innerHTML]=\"subText\"></span>\n<ng-content></ng-content>\n", styles: [":host{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;padding-left:var(--space-xxl);padding-right:var(--space-xxl);z-index:1;text-align:center}:host>avn-icon{margin-bottom:var(--space-md)}:host>.text{font-size:var(--text-md);margin-bottom:var(--space-sm)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: EmptyDataMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-empty-data-message', changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-icon [fontSize]=\"100\" *ngIf=\"icon\" [icon]=\"icon\"></avn-icon>\n<span class=\"text\" *ngIf=\"text\" [innerHTML]=\"text\"></span>\n<span class=\"sub-text\" *ngIf=\"subText\" [innerHTML]=\"subText\"></span>\n<ng-content></ng-content>\n", styles: [":host{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;padding-left:var(--space-xxl);padding-right:var(--space-xxl);z-index:1;text-align:center}:host>avn-icon{margin-bottom:var(--space-md)}:host>.text{font-size:var(--text-md);margin-bottom:var(--space-sm)}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], text: [{
                type: Input
            }], subText: [{
                type: Input
            }] } });

class EmptyDataMessageModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: EmptyDataMessageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: EmptyDataMessageModule, declarations: [EmptyDataMessageComponent], imports: [CommonModule, IconModule], exports: [EmptyDataMessageComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: EmptyDataMessageModule, imports: [CommonModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: EmptyDataMessageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule],
                    declarations: [EmptyDataMessageComponent],
                    exports: [EmptyDataMessageComponent],
                }]
        }] });

class RadioModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: RadioModule, declarations: [RadioComponent, RadioGroupComponent], imports: [CommonModule], exports: [RadioComponent, RadioGroupComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RadioModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RadioModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [RadioComponent, RadioGroupComponent],
                    exports: [RadioComponent, RadioGroupComponent],
                }]
        }] });

/**
 * A control to pick a value amongst a connected list of selectable options
 * The select provides the following functionalities:
 *
 * Configurable options
 * - An option holds a value, a label and custom data associated to it
 * - An option can be disabled
 * - A custom rendering template can be specified for use in the option list
 * - A custom rendering template can be specified for the selected option
 *
 * Virtualization
 *
 * - Enabled by default after N (defaults to 30) options are present in list, can be disabled
 * completely if required.
 *
 * Keyboard Navigation
 *
 * - Enabled by default, can be disabled if required.
 * - First option of the list can be automatically set to active if specified
 * - Event is emitted every time an option is made active by navigation
 * - Works with virtual scroll
 *
 * Configurable size
 * - The list can be configured to display a max number of options within its viewport.
 * - Option height can be configured
 *
 * Configurable width
 * - The list can be configured to match the origin element width or a custom width
 *
 * Option Selection
 * - Option can be selected by clicking on it
 * - Disabled option are not selectable
 * - When keyboard navigation is enabled, option can be selected by pressing the TAB or ENTER key
 * - Event is emitted every time an option is selected
 */
class SelectComponent extends FormControlComponent {
    /** @ignore **/
    constructor(document, ngControl, changeDetector) {
        super(ngControl, changeDetector);
        this.document = document;
        /** The placeholder for the select when no value is selected **/
        this.placeholder = '';
        this.iconSize = 15;
        /** The message to display when no options are available for selection **/
        this.emptyPlaceholder = 'No options available';
        /** Specifies if virtual scroll is enabled **/
        this.virtualization = false;
        /**
         * Specifies if virtual scroll should be auto enabled after a specific amount of options in the
         * list
         */
        this.autoVirtualizeAfterXOptions = 30;
        /** Specifies if keyboard navigation is enabled **/
        this.keyboardNavigationEnabled = true;
        /**
         * When keyboard navigation is enabled, specifies if the first option should be auto marked as
         * active
         */
        this.autoActiveFirstOption = true;
        /** Specifies the number of options visible in the list **/
        this.maxOptionsVisibleInViewport = 7;
        /** Indicates if option grouping is enabled **/
        this.enableGroups = true;
        /** Specifies the option height **/
        this.optionHeight = DEFAULT_OPTION_HEIGHT;
        /** Indicates if the select option list has dark backdrop when it is displayed (an extra click is needed to close the select)   **/
        this.backdropEnabled = false;
        /**
         * Emits every time the selected value(s) changes.
         * One item in single-select mode. An array of items in multi-select mode.
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        /** Emits every time an option is marked as active with keyboard navigation **/
        this.optionActivated = new EventEmitter();
        /** Emits every time the option list is toggled **/
        this.optionListToggled = new EventEmitter();
        /**
         * The selected options.
         * In single-select mode, first item would be used.
         * In multi-select mode, all items would be used.
         */
        this.selectedOptions = [];
        /** Used in multi-select mode. The number of the hidden selected options in the "input" area. */
        this.hiddenSelectedOptionsCount = 0;
        /** @ignore pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
        /** @ignore internal tracking of keyboard navigation state **/
        this._keyboardNavigationEnabled = this.keyboardNavigationEnabled;
        /** @ignore Subject that contain the opened state of the option list panel **/
        this._optionsListOpenedSubject = new BehaviorSubject(false);
        this.optionsListOpened$ = this._optionsListOpenedSubject.asObservable().pipe(distinctUntilChanged());
    }
    /** @ignore **/
    ngAfterViewInit() {
        this._initToggleOptionsPanelListeners();
        this.visibleItems.changes
            .pipe(map((visibleItems) => visibleItems.toArray()), startWith(this.visibleItems.toArray()), filter((visibleItems) => visibleItems.length > 0 && this.isMultipleSelect), takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            this.detectDisplayValueOverflow();
        });
    }
    /** @ignore **/
    ngOnInit() {
        super.ngOnInit();
        this.updateSelectedOption(this.value);
    }
    /** @ignore **/
    ngOnChanges({ keyboardNavigationEnabled, options, value }) {
        if (keyboardNavigationEnabled && keyboardNavigationEnabled.isFirstChange()) {
            this._keyboardNavigationEnabled = keyboardNavigationEnabled.currentValue;
        }
        if (options) {
            // if there are no options then add an empty option and disable keyboard navigation
            if (!this.options || this.options.length === 0) {
                this.options = [
                    {
                        value: '',
                        disabled: true,
                        disableTemplate: true,
                        label: this.emptyPlaceholder,
                    },
                ];
                this.keyboardNavigationEnabled = false;
            }
            else {
                this.keyboardNavigationEnabled = this._keyboardNavigationEnabled;
                this.updateSelectedOption(this.value);
            }
            this.changeDetector.detectChanges();
        }
        if (value && !value.isFirstChange()) {
            // when the value changes, update the selected option
            this.updateSelectedOption(value.currentValue);
        }
    }
    /** @ignore **/
    ngOnDestroy() {
        super.ngOnDestroy();
        this._optionsListOpenedSubject.next(false);
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** Delete one single option from delete icon in multi-selection mode **/
    deleteSelection(selectedOption) {
        this.onSelectionsChanged(this.selectedOptions.filter((x) => x.value !== selectedOption.value));
    }
    /** Process the latest selected values **/
    onSelectionsChanged(selectedOptions) {
        this._optionsListOpenedSubject.next(this.isMultipleSelect);
        this.selectedOptions = selectedOptions;
        this.value = this.isMultipleSelect ? this.selectedOptions.map((x) => x.value) : this.selectedOptions[0]?.value;
        // update the value and propagate the change
        this.propagateChange(this.value);
        this.change.emit(this.isMultipleSelect ? this.selectedOptions : { ...this.selectedOptions[0] });
        this.changeDetector.detectChanges();
        this.detectDisplayValueOverflow();
    }
    /** When the value is updated by the form api. See FormControl **/
    updateValue(value) {
        this.value = value;
        this.updateSelectedOption(value);
    }
    /** Sets the selected option(s) from the specified value **/
    updateSelectedOption(value) {
        if (this.options && value !== undefined && value !== null) {
            if (value.constructor.name === 'Array') {
                const strValues = value.map((val) => val.toString());
                this.selectedOptions = this.options.filter((option) => strValues.includes(option.value.toString()));
            }
            else {
                let optionIndex;
                if (typeof value === 'object') {
                    optionIndex = this.options.map((o) => JSON.stringify(o.value)).indexOf(JSON.stringify(value));
                }
                else {
                    optionIndex = this.options.map((o) => (o.value ? o.value.toString() : undefined)).indexOf(value.toString());
                }
                this.selectedOptions = optionIndex > -1 ? [this.options[optionIndex]] : [];
            }
        }
        else {
            this.selectedOptions = [];
        }
        this.changeDetector.detectChanges();
        this.detectDisplayValueOverflow();
    }
    detectDisplayValueOverflow() {
        if (this.isMultipleSelect && this.visibleItemsContainer?.nativeElement) {
            const inputRightPosition = this.visibleItemsContainer.nativeElement.getBoundingClientRect().right;
            let count = -1;
            for (let i = 0; i < this.visibleItemsContainer.nativeElement.children.length; i++) {
                const nodeRightPosition = this.visibleItemsContainer.nativeElement.children[i].getBoundingClientRect().right;
                if (nodeRightPosition > inputRightPosition /* || this.visibleItemsContainer.nativeElement.children[i].className.includes('hidden-count')*/) {
                    count = i;
                    break;
                }
            }
            this.visibleSelectedOptionsCount = count > -1 ? count : this.selectedOptions.length;
            this.hiddenSelectedOptionsCount = this.selectedOptions.length - this.visibleSelectedOptionsCount;
            this.changeDetector.detectChanges();
        }
    }
    /** When the option list is toggled **/
    onOptionListToggled(opened) {
        // when the list is closed, mark the form control as touched
        if (!opened) {
            this.onTouch();
        }
        this.optionListToggled.emit(opened);
    }
    /** When the option list is activated by keyboard navigation **/
    onOptionActivated(option) {
        this.optionActivated.emit({ ...option });
    }
    /**
     * @ignore override from parent class so we can trigger change detection and run custom code
     * When OnPush strategy is used, inherited Input() change does not trigger ngOnChanges...
     */
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.changeDetector.detectChanges();
    }
    /**
     * Useful for e2e.
     * Returns the currently selected value. If multiple select, return all selected values delimited by comma.
     */
    get selectedValue() {
        return this.value ? this.value : this.selectedOptions ? this.selectedOptions.map((val) => val.value).join(',') : '';
    }
    /** track function to avoid recreating options on every change detection cycle **/
    trackByFn(_, option) {
        return option.value;
    }
    /** Inits the event listeners to toggle the visibility of the options panel **/
    _initToggleOptionsPanelListeners() {
        const selectClicked$ = fromEvent(this.overlayOrigin.elementRef.nativeElement, 'click').pipe(mapTo('select'));
        const documentClicked$ = fromEvent(this.document, 'click').pipe(mapTo('document'));
        race(selectClicked$, documentClicked$)
            .pipe(filter(() => !this.disabled), 
        // prevent the repeat operator to catch event bubbling from select to document. Do not stop event propagation to the document otherwise other select components wont close properly.
        observeOn(asyncScheduler), take(1), repeat(), takeUntil(this.componentDestroyed$))
            .subscribe((elementClicked) => {
            if (elementClicked === 'select') {
                this._optionsListOpenedSubject.next(!this._optionsListOpenedSubject.value);
            }
            else if (elementClicked === 'document') {
                this._optionsListOpenedSubject.next(false);
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SelectComponent, deps: [{ token: DOCUMENT }, { token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SelectComponent, selector: "avn-select", inputs: { optionsTemplate: "optionsTemplate", selectedOptionTemplate: "selectedOptionTemplate", label: "label", options: "options", placeholder: "placeholder", icon: "icon", iconSize: "iconSize", emptyPlaceholder: "emptyPlaceholder", value: "value", optionsListWidth: "optionsListWidth", virtualization: "virtualization", autoVirtualizeAfterXOptions: "autoVirtualizeAfterXOptions", keyboardNavigationEnabled: "keyboardNavigationEnabled", autoActiveFirstOption: "autoActiveFirstOption", maxOptionsVisibleInViewport: "maxOptionsVisibleInViewport", enableGroups: "enableGroups", optionHeight: "optionHeight", isMultipleSelect: "isMultipleSelect", backdropEnabled: "backdropEnabled" }, outputs: { change: "change", optionActivated: "optionActivated", optionListToggled: "optionListToggled" }, host: { properties: { "attr.value": "this.selectedValue" } }, providers: [{ provide: FormControlComponent, useExisting: SelectComponent }], viewQueries: [{ propertyName: "overlayOrigin", first: true, predicate: ["overlayOrigin"], descendants: true }, { propertyName: "connectedElement", first: true, predicate: ["connectedElement"], descendants: true }, { propertyName: "optionListComponent", first: true, predicate: ["optionList"], descendants: true }, { propertyName: "selectInput", first: true, predicate: ["selectInput"], descendants: true }, { propertyName: "visibleItemsContainer", first: true, predicate: ["visibleItemsContainer"], descendants: true }, { propertyName: "visibleItems", predicate: ["visibleItem"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div\n  [id]=\"id\"\n  class=\"select-container\"\n  [class.selected-option-template]=\"!!selectedOptionTemplate\"\n  [class.disabled]=\"disabled\"\n  tabindex=\"0\"\n  #overlayOrigin=\"cdkOverlayOrigin\"\n  cdkOverlayOrigin\n>\n  <div *ngIf=\"icon\" class=\"select-icon\">\n    <avn-icon [icon]=\"icon\" [fontSize]=\"iconSize\"></avn-icon>\n  </div>\n  <div class=\"selected-value-input\" *ngIf=\"!selectedOptionTemplate\">\n    <ng-template #multipleSelect>\n      <div *ngIf=\"value?.length; else noValueMultiple\" class=\"multiple-select\">\n        <div #visibleItemsContainer class=\"visible-items\">\n          <ng-container *ngFor=\"let item of selectedOptions; let idx = index; trackBy: trackByFn\">\n            <div #visibleItem *ngIf=\"idx < visibleSelectedOptionsCount\" class=\"multiple-select-item\">\n              <span> {{ item.label }} </span>\n              <avn-icon [disabled]=\"disabled\" (click)=\"deleteSelection(item)\" fontSize=\"14\" icon=\"content:clear\"></avn-icon>\n            </div>\n          </ng-container>\n        </div>\n\n        <div class=\"hidden-count\" [class.hidden]=\"hiddenSelectedOptionsCount < 1\">\n          <span>(+{{ hiddenSelectedOptionsCount }})</span>\n        </div>\n      </div>\n      <ng-template #noValueMultiple>\n        <div class=\"placeholder\" *ngIf=\"placeholder\">{{ placeholder }}</div>\n      </ng-template>\n    </ng-template>\n    <input\n      *ngIf=\"!isMultipleSelect; else multipleSelect\"\n      #selectInput\n      type=\"text\"\n      readonly\n      class=\"select-input\"\n      [placeholder]=\"placeholder\"\n      [value]=\"selectedOptions[0]?.label || selectedOptions[0]?.value || ''\"\n      [disabled]=\"disabled\"\n    />\n  </div>\n  <div class=\"selected-value-custom\" avnTheme=\"primary\" *ngIf=\"!!selectedOptionTemplate\">\n    <div class=\"selected-value-template-container\">\n      <ng-container *ngIf=\"value; else noValue\">\n        <ng-container *ngTemplateOutlet=\"selectedOptionTemplate; context: { option: isMultipleSelect ? selectedOptions : selectedOptions[0] }\"></ng-container>\n      </ng-container>\n      <ng-template #noValue>\n        <div class=\"placeholder\" *ngIf=\"placeholder\">{{ placeholder }}</div>\n      </ng-template>\n    </div>\n  </div>\n  <avn-icon [fontSize]=\"18\" class=\"select-caret\" icon=\"hardware:keyboard_arrow_down\" [class.rotate]=\"optionsListOpened$ | async\"></avn-icon>\n</div>\n\n<avn-connected-element\n  #connectedElement\n  [minWidth]=\"optionsListWidth\"\n  [width]=\"optionsListWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"optionsListOpened$ | async\"\n  [hasVisibleBackdrop]=\"backdropEnabled\"\n  [hasOverlayBackdrop]=\"backdropEnabled\"\n  (toggled)=\"onOptionListToggled($event)\"\n>\n  <!-- Note: ngIf is used so that the list is recreated everytime the overlay is opened (virtual scroll issues otherwise) -->\n  <avn-option-list\n    *ngIf=\"optionsListOpened$ | async\"\n    #optionList\n    [attr.name]=\"formControlName || name\"\n    [virtualization]=\"virtualization\"\n    [autoVirtualizeAfterXOptions]=\"autoVirtualizeAfterXOptions\"\n    [keyboardNavigationEnabled]=\"keyboardNavigationEnabled\"\n    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n    [maxOptionsVisibleInViewport]=\"maxOptionsVisibleInViewport\"\n    [enableGroups]=\"enableGroups\"\n    [selectionMode]=\"isMultipleSelect ? 'multiple' : 'single'\"\n    [showCheckbox]=\"isMultipleSelect\"\n    [options]=\"options\"\n    [optionHeight]=\"optionHeight\"\n    [selectedOptions]=\"selectedOptions\"\n    [optionsTemplate]=\"optionsTemplate\"\n    (selectionsChanged)=\"onSelectionsChanged($event.selected)\"\n    (optionActivated)=\"onOptionActivated($event)\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n\n<ng-template #customOptionsTemplate let-option=\"option\">\n  <span>Checkbox Here</span>\n  <ng-container *ngTemplateOutlet=\"optionsTemplate; context: { option: option }\"></ng-container>\n</ng-template>\n\n<ng-template #plainCustomTemplate let-option=\"option\">\n  <span>Checkbox Here</span>\n  <div class=\"item-label\">\n    {{ option.isGroupOption ? option.group : option.label !== undefined ? option.label : option.value }}\n  </div>\n</ng-template>\n", styles: [":host{display:block}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host.validation-theme.ng-valid.ng-touched .select-container,:host.validation-theme.ng-valid.ng-dirty .select-container{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .select-container,:host.validation-theme.ng-invalid.ng-dirty .select-container{border-color:var(--danger-base)!important}:host .select-container{border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;width:100%;padding:var(--space-sm) var(--space-base);line-height:1.3;cursor:pointer;outline:0}:host .select-container:hover,:host .select-container:focus,:host .select-container.focus{border-color:var(--form-control-hover-border)}:host .select-container:disabled,:host .select-container:disabled:hover,:host .select-container:disabled:focus,:host .select-container.disabled,:host .select-container.disabled:hover,:host .select-container.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .select-container>div>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;cursor:pointer;width:100%;border:0;outline:0}:host .select-container>div>input::placeholder{color:var(--form-control-placeholder)}:host .select-container>div>input:disabled,:host .select-container>div>input:disabled:hover,:host .select-container>div>input:disabled:focus,:host .select-container>div>input.disabled,:host .select-container>div>input.disabled:hover,:host .select-container>div>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .select-container .select-icon{padding-right:var(--space-sm)}:host .select-container:not(.selected-option-template){background:var(--form-control-background)}:host .select-container .selected-value-input,:host .select-container .selected-value-custom{width:100%}:host .select-container .selected-value-input{display:grid;align-items:center}:host .select-container avn-icon.select-caret{-webkit-user-select:none;user-select:none;padding-left:var(--space-md)}:host .select-container avn-icon.select-caret>::ng-deep i{color:var(--form-control-icon);transition:transform .12s ease-in-out}:host .select-container avn-icon.select-caret.rotate>::ng-deep i{transform:rotate(180deg)}:host .placeholder{color:var(--form-control-placeholder)}:host .multiple-select{display:flex;overflow:hidden;white-space:nowrap;align-items:center}:host .multiple-select .visible-items{width:inherit;flex-grow:1;display:flex;overflow:hidden;white-space:nowrap}:host .multiple-select .visible-items .multiple-select-item{display:flex;border:solid 1px var(--form-control-placeholder);border-radius:1rem;align-items:center;padding:var(--space-xs) var(--space-sm);background:var(--form-control-placeholder);margin-right:var(--space-xs)}:host .multiple-select .visible-items .multiple-select-item avn-icon{margin-left:var(--space-sm);background:var(--selection-component-hover-background);border-radius:1rem;padding:calc(var(--space-xs) / 2)}:host .multiple-select .hidden-count{visibility:visible}:host .multiple-select .hidden-count.hidden{visibility:hidden}:host-context(.dmb-aspect) :host .select-container{width:100%}:host-context(.dmb-aspect) :host .select-container .select-icon{flex:0 0 30px}:host-context(.dmb-aspect) :host .select-container .selected-value-input,:host-context(.dmb-aspect) :host .select-container .selected-value-custom{flex:1 1 auto}:host-context(.dmb-aspect) :host .select-container avn-icon.select-caret{flex:0 0 auto}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: OptionListComponent, selector: "avn-option-list", inputs: ["optionsTemplate", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "options", "selectionMode", "showCheckbox", "selectedOptions", "enableGroups"], outputs: ["optionClicked", "optionActivated", "selectionsChanged"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-select', providers: [{ provide: FormControlComponent, useExisting: SelectComponent }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div\n  [id]=\"id\"\n  class=\"select-container\"\n  [class.selected-option-template]=\"!!selectedOptionTemplate\"\n  [class.disabled]=\"disabled\"\n  tabindex=\"0\"\n  #overlayOrigin=\"cdkOverlayOrigin\"\n  cdkOverlayOrigin\n>\n  <div *ngIf=\"icon\" class=\"select-icon\">\n    <avn-icon [icon]=\"icon\" [fontSize]=\"iconSize\"></avn-icon>\n  </div>\n  <div class=\"selected-value-input\" *ngIf=\"!selectedOptionTemplate\">\n    <ng-template #multipleSelect>\n      <div *ngIf=\"value?.length; else noValueMultiple\" class=\"multiple-select\">\n        <div #visibleItemsContainer class=\"visible-items\">\n          <ng-container *ngFor=\"let item of selectedOptions; let idx = index; trackBy: trackByFn\">\n            <div #visibleItem *ngIf=\"idx < visibleSelectedOptionsCount\" class=\"multiple-select-item\">\n              <span> {{ item.label }} </span>\n              <avn-icon [disabled]=\"disabled\" (click)=\"deleteSelection(item)\" fontSize=\"14\" icon=\"content:clear\"></avn-icon>\n            </div>\n          </ng-container>\n        </div>\n\n        <div class=\"hidden-count\" [class.hidden]=\"hiddenSelectedOptionsCount < 1\">\n          <span>(+{{ hiddenSelectedOptionsCount }})</span>\n        </div>\n      </div>\n      <ng-template #noValueMultiple>\n        <div class=\"placeholder\" *ngIf=\"placeholder\">{{ placeholder }}</div>\n      </ng-template>\n    </ng-template>\n    <input\n      *ngIf=\"!isMultipleSelect; else multipleSelect\"\n      #selectInput\n      type=\"text\"\n      readonly\n      class=\"select-input\"\n      [placeholder]=\"placeholder\"\n      [value]=\"selectedOptions[0]?.label || selectedOptions[0]?.value || ''\"\n      [disabled]=\"disabled\"\n    />\n  </div>\n  <div class=\"selected-value-custom\" avnTheme=\"primary\" *ngIf=\"!!selectedOptionTemplate\">\n    <div class=\"selected-value-template-container\">\n      <ng-container *ngIf=\"value; else noValue\">\n        <ng-container *ngTemplateOutlet=\"selectedOptionTemplate; context: { option: isMultipleSelect ? selectedOptions : selectedOptions[0] }\"></ng-container>\n      </ng-container>\n      <ng-template #noValue>\n        <div class=\"placeholder\" *ngIf=\"placeholder\">{{ placeholder }}</div>\n      </ng-template>\n    </div>\n  </div>\n  <avn-icon [fontSize]=\"18\" class=\"select-caret\" icon=\"hardware:keyboard_arrow_down\" [class.rotate]=\"optionsListOpened$ | async\"></avn-icon>\n</div>\n\n<avn-connected-element\n  #connectedElement\n  [minWidth]=\"optionsListWidth\"\n  [width]=\"optionsListWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"optionsListOpened$ | async\"\n  [hasVisibleBackdrop]=\"backdropEnabled\"\n  [hasOverlayBackdrop]=\"backdropEnabled\"\n  (toggled)=\"onOptionListToggled($event)\"\n>\n  <!-- Note: ngIf is used so that the list is recreated everytime the overlay is opened (virtual scroll issues otherwise) -->\n  <avn-option-list\n    *ngIf=\"optionsListOpened$ | async\"\n    #optionList\n    [attr.name]=\"formControlName || name\"\n    [virtualization]=\"virtualization\"\n    [autoVirtualizeAfterXOptions]=\"autoVirtualizeAfterXOptions\"\n    [keyboardNavigationEnabled]=\"keyboardNavigationEnabled\"\n    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n    [maxOptionsVisibleInViewport]=\"maxOptionsVisibleInViewport\"\n    [enableGroups]=\"enableGroups\"\n    [selectionMode]=\"isMultipleSelect ? 'multiple' : 'single'\"\n    [showCheckbox]=\"isMultipleSelect\"\n    [options]=\"options\"\n    [optionHeight]=\"optionHeight\"\n    [selectedOptions]=\"selectedOptions\"\n    [optionsTemplate]=\"optionsTemplate\"\n    (selectionsChanged)=\"onSelectionsChanged($event.selected)\"\n    (optionActivated)=\"onOptionActivated($event)\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n\n<ng-template #customOptionsTemplate let-option=\"option\">\n  <span>Checkbox Here</span>\n  <ng-container *ngTemplateOutlet=\"optionsTemplate; context: { option: option }\"></ng-container>\n</ng-template>\n\n<ng-template #plainCustomTemplate let-option=\"option\">\n  <span>Checkbox Here</span>\n  <div class=\"item-label\">\n    {{ option.isGroupOption ? option.group : option.label !== undefined ? option.label : option.value }}\n  </div>\n</ng-template>\n", styles: [":host{display:block}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host.validation-theme.ng-valid.ng-touched .select-container,:host.validation-theme.ng-valid.ng-dirty .select-container{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .select-container,:host.validation-theme.ng-invalid.ng-dirty .select-container{border-color:var(--danger-base)!important}:host .select-container{border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;width:100%;padding:var(--space-sm) var(--space-base);line-height:1.3;cursor:pointer;outline:0}:host .select-container:hover,:host .select-container:focus,:host .select-container.focus{border-color:var(--form-control-hover-border)}:host .select-container:disabled,:host .select-container:disabled:hover,:host .select-container:disabled:focus,:host .select-container.disabled,:host .select-container.disabled:hover,:host .select-container.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .select-container>div>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;cursor:pointer;width:100%;border:0;outline:0}:host .select-container>div>input::placeholder{color:var(--form-control-placeholder)}:host .select-container>div>input:disabled,:host .select-container>div>input:disabled:hover,:host .select-container>div>input:disabled:focus,:host .select-container>div>input.disabled,:host .select-container>div>input.disabled:hover,:host .select-container>div>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .select-container .select-icon{padding-right:var(--space-sm)}:host .select-container:not(.selected-option-template){background:var(--form-control-background)}:host .select-container .selected-value-input,:host .select-container .selected-value-custom{width:100%}:host .select-container .selected-value-input{display:grid;align-items:center}:host .select-container avn-icon.select-caret{-webkit-user-select:none;user-select:none;padding-left:var(--space-md)}:host .select-container avn-icon.select-caret>::ng-deep i{color:var(--form-control-icon);transition:transform .12s ease-in-out}:host .select-container avn-icon.select-caret.rotate>::ng-deep i{transform:rotate(180deg)}:host .placeholder{color:var(--form-control-placeholder)}:host .multiple-select{display:flex;overflow:hidden;white-space:nowrap;align-items:center}:host .multiple-select .visible-items{width:inherit;flex-grow:1;display:flex;overflow:hidden;white-space:nowrap}:host .multiple-select .visible-items .multiple-select-item{display:flex;border:solid 1px var(--form-control-placeholder);border-radius:1rem;align-items:center;padding:var(--space-xs) var(--space-sm);background:var(--form-control-placeholder);margin-right:var(--space-xs)}:host .multiple-select .visible-items .multiple-select-item avn-icon{margin-left:var(--space-sm);background:var(--selection-component-hover-background);border-radius:1rem;padding:calc(var(--space-xs) / 2)}:host .multiple-select .hidden-count{visibility:visible}:host .multiple-select .hidden-count.hidden{visibility:hidden}:host-context(.dmb-aspect) :host .select-container{width:100%}:host-context(.dmb-aspect) :host .select-container .select-icon{flex:0 0 30px}:host-context(.dmb-aspect) :host .select-container .selected-value-input,:host-context(.dmb-aspect) :host .select-container .selected-value-custom{flex:1 1 auto}:host-context(.dmb-aspect) :host .select-container avn-icon.select-caret{flex:0 0 auto}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { overlayOrigin: [{
                type: ViewChild,
                args: ['overlayOrigin', { static: false }]
            }], connectedElement: [{
                type: ViewChild,
                args: ['connectedElement', { static: false }]
            }], optionListComponent: [{
                type: ViewChild,
                args: ['optionList', { static: false }]
            }], selectInput: [{
                type: ViewChild,
                args: ['selectInput', { static: false }]
            }], visibleItemsContainer: [{
                type: ViewChild,
                args: ['visibleItemsContainer', { static: false }]
            }], visibleItems: [{
                type: ViewChildren,
                args: ['visibleItem']
            }], optionsTemplate: [{
                type: Input
            }], selectedOptionTemplate: [{
                type: Input
            }], label: [{
                type: Input
            }], options: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], emptyPlaceholder: [{
                type: Input
            }], value: [{
                type: Input
            }], optionsListWidth: [{
                type: Input
            }], virtualization: [{
                type: Input
            }], autoVirtualizeAfterXOptions: [{
                type: Input
            }], keyboardNavigationEnabled: [{
                type: Input
            }], autoActiveFirstOption: [{
                type: Input
            }], maxOptionsVisibleInViewport: [{
                type: Input
            }], enableGroups: [{
                type: Input
            }], optionHeight: [{
                type: Input
            }], isMultipleSelect: [{
                type: Input
            }], backdropEnabled: [{
                type: Input
            }], change: [{
                type: Output
            }], optionActivated: [{
                type: Output
            }], optionListToggled: [{
                type: Output
            }], selectedValue: [{
                type: HostBinding,
                args: ['attr.value']
            }] } });

class SelectModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SelectModule, declarations: [SelectComponent, ToSelectOptionPipe], imports: [CommonModule, IconModule, OptionModule, ConnectedElementModule], exports: [SelectComponent, ToSelectOptionPipe, OptionModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SelectModule, imports: [CommonModule, IconModule, OptionModule, ConnectedElementModule, OptionModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SelectComponent, ToSelectOptionPipe],
                    exports: [SelectComponent, ToSelectOptionPipe, OptionModule],
                    imports: [CommonModule, IconModule, OptionModule, ConnectedElementModule],
                }]
        }] });

class DataTableModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: DataTableModule, declarations: [DataTableComponent, DataTableActionsComponent, DataTableNotificationMessageComponent], imports: [CommonModule,
            CoreModule,
            IconModule,
            ScrollingModule,
            DragDropModule,
            CheckboxModule,
            RadioModule,
            LoaderModule,
            EmptyDataMessageModule,
            TooltipModule,
            ConnectedElementModule,
            OptionModule,
            SelectModule], exports: [DataTableComponent, DataTableActionsComponent, DataTableNotificationMessageComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableModule, imports: [CommonModule,
            CoreModule,
            IconModule,
            ScrollingModule,
            DragDropModule,
            CheckboxModule,
            RadioModule,
            LoaderModule,
            EmptyDataMessageModule,
            TooltipModule,
            ConnectedElementModule,
            OptionModule,
            SelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DataTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CoreModule,
                        IconModule,
                        ScrollingModule,
                        DragDropModule,
                        CheckboxModule,
                        RadioModule,
                        LoaderModule,
                        EmptyDataMessageModule,
                        TooltipModule,
                        ConnectedElementModule,
                        OptionModule,
                        SelectModule,
                    ],
                    providers: [],
                    declarations: [DataTableComponent, DataTableActionsComponent, DataTableNotificationMessageComponent],
                    exports: [DataTableComponent, DataTableActionsComponent, DataTableNotificationMessageComponent],
                }]
        }] });

class FilePickerDirective {
    /** Prevent dragover event so drop events register */
    onDragOver(evt) {
        if (this.triggerMode === 'dragDrop') {
            evt.preventDefault();
            evt.stopPropagation();
            this.background = 'var(--topnav-variant-background)';
        }
    }
    onDragLeave(evt) {
        if (this.triggerMode === 'dragDrop') {
            evt.preventDefault();
            evt.stopPropagation();
            this.background = this.DEFAULT_BACKGROUND;
        }
    }
    /** Set files on drop and emit selected files */
    onDrop(evt) {
        if (this.triggerMode === 'dragDrop') {
            evt.preventDefault();
            evt.stopPropagation();
            this.background = this.DEFAULT_BACKGROUND;
            this._inputElement.files = evt.dataTransfer.files;
            this._onFilesChanged();
        }
    }
    /** Invoke click event on input element to browse files */
    onClick(event) {
        if (this.triggerMode === 'click') {
            event.preventDefault();
            this._inputElement.click();
        }
    }
    get inputElement() {
        return this._inputElement;
    }
    constructor(_document, element) {
        this._document = _document;
        this.element = element;
        /**
         * Specify whether the file picker allows multiple file selection. Defaults to true.
         * Note: this input takes effect only when the trigger mode is click. In DnD mode it's
         * always multiple.
         */
        this.multipleSelection = true;
        /**
         * Accepted mime types. Default to accept every type.
         * Note: this input takes effect only when the trigger mode is click. In DnD mode it
         * always accepts all types of files.
         */
        this.mimeTypesAccepted = [];
        /** Mode to trigger file selection. Support click or drag and drop. Default to click. */
        this.triggerMode = 'click';
        /** Emit selected files */
        this.filesChanged = new EventEmitter();
        this.DEFAULT_BACKGROUND = 'var(--topnav-background)';
        this._onFilesChanged = () => {
            this.filesChanged.emit(Array.from(this._inputElement.files));
            this._form.reset();
        };
        this._form = this._document.createElement('form');
        this._inputElement = this._document.createElement('input');
        this._inputElement.type = 'file';
        this._inputElement.multiple = this.multipleSelection;
        this._inputElement.accept = (this.mimeTypesAccepted ?? []).length > 0 ? this.mimeTypesAccepted.join(',') : '*/*';
        this._inputElement.addEventListener('change', this._onFilesChanged);
        this._form.appendChild(this._inputElement);
    }
    ngOnChanges({ multipleSelection, mimeTypesAccepted, triggerMode }) {
        if (multipleSelection) {
            this._inputElement.multiple = this.multipleSelection;
        }
        if (mimeTypesAccepted) {
            this._inputElement.accept = (this.mimeTypesAccepted ?? []).length > 0 ? this.mimeTypesAccepted.join(',') : '*/*';
        }
        if (triggerMode) {
            if (this.triggerMode === 'dragDrop') {
                this.background = this.DEFAULT_BACKGROUND;
            }
        }
    }
    ngOnDestroy() {
        this._inputElement.removeEventListener('change', this._onFilesChanged);
        this._inputElement.remove();
        this._form.remove();
    }
    /** Clear the selected files and reset the hidden form. */
    clear() {
        this._form.reset();
        this.filesChanged.emit([]);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FilePickerDirective, deps: [{ token: DOCUMENT }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: FilePickerDirective, selector: "[avnFilePicker]", inputs: { multipleSelection: "multipleSelection", mimeTypesAccepted: "mimeTypesAccepted", triggerMode: "triggerMode" }, outputs: { filesChanged: "filesChanged" }, host: { listeners: { "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)", "drop": "onDrop($event)", "click": "onClick($event)" }, properties: { "style.background": "this.background" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FilePickerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnFilePicker]'
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }]; }, propDecorators: { multipleSelection: [{
                type: Input
            }], mimeTypesAccepted: [{
                type: Input
            }], triggerMode: [{
                type: Input
            }], filesChanged: [{
                type: Output
            }], background: [{
                type: HostBinding,
                args: ['style.background']
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class FileUploaderModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderModule, declarations: [FileUploaderComponent, DragAndDropDirective, FallbackImageDirective, FilePickerDirective], imports: [CommonModule, CoreModule, IconModule, InputModule, ButtonModule, DataTableModule, ModalModule, TooltipModule], exports: [FileUploaderComponent, FilePickerDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderModule, imports: [CommonModule, CoreModule, IconModule, InputModule, ButtonModule, DataTableModule, ModalModule, TooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: FileUploaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FileUploaderComponent, DragAndDropDirective, FallbackImageDirective, FilePickerDirective],
                    imports: [CommonModule, CoreModule, IconModule, InputModule, ButtonModule, DataTableModule, ModalModule, TooltipModule],
                    exports: [FileUploaderComponent, FilePickerDirective],
                }]
        }] });

class MultiInputComponent extends FormControlComponent {
    /** Custom regex Validation on input */
    set validators(validators) {
        this.setValidators(validators);
    }
    get validators() {
        return this._validators;
    }
    constructor(ngControl, changeDetector) {
        super(ngControl, changeDetector);
        /**
         * The type for the input field (text, number, date)
         */
        this.type = 'text';
        /**
         * The placeholder to display in input field
         */
        this.placeholder = '';
        /** Default values  */
        this.value = [];
        /** Set to true to show arrow buttons in the input field for number type input. Default to false */
        this.showSpinButtonsForNumberInput = false;
        /**
         * Emits everytime the component value changes
         */
        this.changed = new EventEmitter();
        /** Form group used for the input to do validation */
        this.internalFormControl = new FormControl();
        this.themeType = ThemeType;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    /** When the value is updated by the form api. See FormControl **/
    updateValue(value) {
        if (value && Array.isArray(value)) {
            this.value = value?.filter((item) => item?.toString()?.length > 0);
        }
        else {
            this.value = [];
        }
    }
    /** When the value is submitted in the internal avn-input, add value to array if valid */
    onInputSubmitValue() {
        const newValue = this.type === 'number' ? +this.internalFormControl.value : this.internalFormControl.value;
        // Check if validators passes
        if (this.internalFormControl.valid && newValue) {
            this.internalFormControl.reset(); // empty input after submitting value
            this.value.push(newValue);
            this.propagateChange(this.value);
            this.changed.emit(this.value);
        }
    }
    onDeleteMultipleOptions(value) {
        this.value = this.value.filter((e) => e !== value);
        this.propagateTouched();
        this.propagateChange(this.value);
        this.changed.emit(this.value);
        this.resetDuplicateValidator(this.internalFormControl.value);
    }
    /** When control is disabled, we need to disable internal control too */
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        if (isDisabled) {
            this.internalFormControl?.disable();
        }
        else {
            this.internalFormControl?.enable();
        }
    }
    duplicateValueValidator(currentValue, type, prevValue) {
        return () => {
            if (!prevValue?.length || !currentValue) {
                return null;
            }
            // Normalize for input type 'number'
            const isNumeric = ['number', 'integer'].includes(type);
            const newValue = isNumeric ? +currentValue : currentValue;
            const oldValues = isNumeric ? prevValue.map(Number) : prevValue;
            const isDuplicate = oldValues.includes(newValue);
            if (isDuplicate) {
                return { duplicate: { value: isDuplicate } };
            }
            return null;
        };
    }
    onMultiInputChanged(controlValue) {
        // Propagate touch for formControl
        this.propagateTouched();
        this.resetDuplicateValidator(controlValue);
    }
    /** @ignore **/
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    resetDuplicateValidator(controlValue) {
        const validators = this.validators && Object.values(this.validators).length > 0 ? [...this.validators] : [];
        const validator = {
            validator: this.duplicateValueValidator(controlValue, this.type, this.value),
            errorKey: 'duplicate',
            errorMessage: 'Duplicate value',
        };
        const index = validators.findIndex((item) => item.errorKey === 'duplicate');
        if (index !== -1) {
            validators.splice(index, 1, validator);
        }
        else {
            validators.push(validator);
        }
        this.setValidators(validators);
    }
    setValidators(validators) {
        this._validators = validators;
        this.internalFormControl.setValidators(validators?.length ? validators.map((e) => e.validator) : []);
        this.internalFormControl.updateValueAndValidity();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MultiInputComponent, deps: [{ token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: MultiInputComponent, selector: "avn-multi-input", inputs: { label: "label", debounceTime: "debounceTime", type: "type", placeholder: "placeholder", validators: "validators", value: "value", min: "min", max: "max", showSpinButtonsForNumberInput: "showSpinButtonsForNumberInput" }, outputs: { changed: "changed" }, providers: [{ provide: FormControlComponent, useExisting: MultiInputComponent }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"value?.length\" class=\"multiple-select\" [ngClass]=\"{ disabled: disabled }\">\n  <div *ngFor=\"let val of value\" class=\"multiple-select-item\">\n    <span class=\"multi-input-item-no-select\"> {{ val }} </span>\n    <avn-icon class=\"multi-input-item-no-select\" (click)=\"onDeleteMultipleOptions(val)\" fontSize=\"14\" icon=\"content:clear\"></avn-icon>\n  </div>\n</div>\n<avn-form-field>\n  <div class=\"multi-input-form-field\">\n    <avn-input\n      autocomplete=\"off\"\n      class=\"multi-input-form-input\"\n      [formControl]=\"internalFormControl\"\n      [avnTheme]=\"themeType?.PRIMARY\"\n      [label]=\"label\"\n      [debounceTime]=\"debounceTime\"\n      [type]=\"type\"\n      [placeholder]=\"placeholder || ''\"\n      [min]=\"min\"\n      [max]=\"max\"\n      [showSpinButtonsForNumberInput]=\"showSpinButtonsForNumberInput\"\n      [emitDistinctValueChange]=\"false\"\n      (changed)=\"onMultiInputChanged($event)\"\n      (submitted)=\"onInputSubmitValue()\"\n    ></avn-input>\n    <avn-icon [disabled]=\"!internalFormControl.valid || disabled\" class=\"multi-input-add-icon\" icon=\"action:add_circle_outline\" (click)=\"onInputSubmitValue()\"></avn-icon>\n  </div>\n  <avn-form-field-error *ngFor=\"let validator of validators\" [key]=\"validator.errorKey\" [message]=\"validator.errorMessage\"></avn-form-field-error>\n</avn-form-field>\n", styles: [":host .multiple-select{display:flex;flex-wrap:wrap}:host .multiple-select:disabled,:host .multiple-select:disabled:hover,:host .multiple-select:disabled:focus,:host .multiple-select.disabled,:host .multiple-select.disabled:hover,:host .multiple-select.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .multiple-select .multiple-select-item{display:flex;border:solid 1px var(--form-control-placeholder);border-radius:1rem;align-items:center;padding:var(--space-xs) var(--space-sm);background:var(--form-control-placeholder);margin:var(--space-xs);color:var(--form-control-on)}:host .multiple-select .multiple-select-item .multi-input-item-no-select{-webkit-user-select:none;user-select:none}:host .multiple-select .multiple-select-item avn-icon{margin-left:var(--space-sm);background:var(--selection-component-hover-background);border-radius:1rem;padding:calc(var(--space-xs) / 2)}:host .multi-input-form-field{display:flex}:host .multi-input-form-field .multi-input-add-icon{margin-top:auto;margin-left:var(--space-sm);margin-bottom:5px;-webkit-user-select:none;user-select:none}:host .multi-input-form-field .multi-input-form-input{flex:1}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: InputComponent, selector: "avn-input", inputs: ["label", "debounceTime", "type", "showSpinButtonsForNumberInput", "min", "max", "placeholder", "value", "emitDistinctValueChange"], outputs: ["changed", "submitted"] }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FormFieldComponent, selector: "avn-form-field", inputs: ["enableValidTheme", "enableInvalidTheme", "disabled"] }, { kind: "component", type: FormFieldErrorComponent, selector: "avn-form-field-error", inputs: ["key", "message", "fixedHeight"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MultiInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-multi-input', providers: [{ provide: FormControlComponent, useExisting: MultiInputComponent }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"value?.length\" class=\"multiple-select\" [ngClass]=\"{ disabled: disabled }\">\n  <div *ngFor=\"let val of value\" class=\"multiple-select-item\">\n    <span class=\"multi-input-item-no-select\"> {{ val }} </span>\n    <avn-icon class=\"multi-input-item-no-select\" (click)=\"onDeleteMultipleOptions(val)\" fontSize=\"14\" icon=\"content:clear\"></avn-icon>\n  </div>\n</div>\n<avn-form-field>\n  <div class=\"multi-input-form-field\">\n    <avn-input\n      autocomplete=\"off\"\n      class=\"multi-input-form-input\"\n      [formControl]=\"internalFormControl\"\n      [avnTheme]=\"themeType?.PRIMARY\"\n      [label]=\"label\"\n      [debounceTime]=\"debounceTime\"\n      [type]=\"type\"\n      [placeholder]=\"placeholder || ''\"\n      [min]=\"min\"\n      [max]=\"max\"\n      [showSpinButtonsForNumberInput]=\"showSpinButtonsForNumberInput\"\n      [emitDistinctValueChange]=\"false\"\n      (changed)=\"onMultiInputChanged($event)\"\n      (submitted)=\"onInputSubmitValue()\"\n    ></avn-input>\n    <avn-icon [disabled]=\"!internalFormControl.valid || disabled\" class=\"multi-input-add-icon\" icon=\"action:add_circle_outline\" (click)=\"onInputSubmitValue()\"></avn-icon>\n  </div>\n  <avn-form-field-error *ngFor=\"let validator of validators\" [key]=\"validator.errorKey\" [message]=\"validator.errorMessage\"></avn-form-field-error>\n</avn-form-field>\n", styles: [":host .multiple-select{display:flex;flex-wrap:wrap}:host .multiple-select:disabled,:host .multiple-select:disabled:hover,:host .multiple-select:disabled:focus,:host .multiple-select.disabled,:host .multiple-select.disabled:hover,:host .multiple-select.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .multiple-select .multiple-select-item{display:flex;border:solid 1px var(--form-control-placeholder);border-radius:1rem;align-items:center;padding:var(--space-xs) var(--space-sm);background:var(--form-control-placeholder);margin:var(--space-xs);color:var(--form-control-on)}:host .multiple-select .multiple-select-item .multi-input-item-no-select{-webkit-user-select:none;user-select:none}:host .multiple-select .multiple-select-item avn-icon{margin-left:var(--space-sm);background:var(--selection-component-hover-background);border-radius:1rem;padding:calc(var(--space-xs) / 2)}:host .multi-input-form-field{display:flex}:host .multi-input-form-field .multi-input-add-icon{margin-top:auto;margin-left:var(--space-sm);margin-bottom:5px;-webkit-user-select:none;user-select:none}:host .multi-input-form-field .multi-input-form-input{flex:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], type: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], validators: [{
                type: Input
            }], value: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], showSpinButtonsForNumberInput: [{
                type: Input
            }], changed: [{
                type: Output
            }] } });

class MultiInputModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MultiInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: MultiInputModule, declarations: [MultiInputComponent], imports: [CommonModule, CoreModule, IconModule, InputModule, FormsModule, ReactiveFormsModule, FormFieldModule], exports: [MultiInputComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MultiInputModule, imports: [CommonModule, CoreModule, IconModule, InputModule, FormsModule, ReactiveFormsModule, FormFieldModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MultiInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, InputModule, FormsModule, ReactiveFormsModule, FormFieldModule],
                    declarations: [MultiInputComponent],
                    exports: [MultiInputComponent],
                }]
        }] });

class TextareaComponent extends FormControlComponent {
    /**
     * @ignore
     */
    constructor(ngControl, changeDetector) {
        super(ngControl, changeDetector);
        /**
         * The placeholder to display in textarea field
         */
        this.placeholder = '';
        /**
         * The value for the textarea field
         */
        this.value = '';
        /**
         * Emits everytime the component value changes
         */
        this.changed = new EventEmitter();
        /**
         * @ignore
         */
        this.componentDestroyed$ = new Subject();
    }
    /**
     * This method is called when the forms API to write to the view when programmatic (model -> view)
     * changes are requested
     *
     * @ignore
     */
    updateValue(value) {
        this.value = value;
        this.indentJsonObject(value);
    }
    /**
     * child components and directives become available from AfterViewInit lifecycle hook
     *
     * @ignore
     */
    ngAfterViewInit() {
        this.subscribeTouch(this.inputElement.nativeElement, 'blur');
        this.indentJsonObject(this.inputElement.nativeElement.value);
    }
    /**
     * Updates the value of our component when the native textarea value changes
     *
     * @ignore
     */
    onChange($event) {
        $event.stopPropagation();
        // set the value from the textarea value
        this.value = $event.currentTarget.value;
        // propagate the change
        this.propagateChange(this.value);
        this.changed.emit(this.value);
        this.indentJsonObject(this.value);
    }
    indentJsonObject(value) {
        if (this.indentObject && (value || '').length > 0 && this.inputElement) {
            try {
                const formattedObject = JSON.stringify(JSON.parse(value), undefined, 4);
                this.inputElement.nativeElement.value = formattedObject;
            }
            catch (e) {
                // Fail to indent
            }
        }
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TextareaComponent, deps: [{ token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TextareaComponent, selector: "avn-textarea", inputs: { label: "label", placeholder: "placeholder", rows: "rows", columns: "columns", value: "value", indentObject: "indentObject" }, outputs: { changed: "changed" }, providers: [{ provide: FormControlComponent, useExisting: TextareaComponent }], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<textarea avnScroll #inputElement [value]=\"value\" [id]=\"id\" [rows]=\"rows\" [cols]=\"columns\" [disabled]=\"disabled\" [placeholder]=\"placeholder\" (change)=\"onChange($event)\"></textarea>\n", styles: [":host{display:flex;flex-direction:column;height:100%}:host.validation-theme.ng-valid.ng-touched>textarea,:host.validation-theme.ng-valid.ng-dirty>textarea{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched>textarea,:host.validation-theme.ng-invalid.ng-dirty>textarea{border-color:var(--danger-base)!important}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host>textarea{outline-style:none;outline-offset:-2px;color:inherit;background:none;border:1px solid var(--form-control-border);color:var(--form-control-on);background:var(--form-control-background);flex-grow:1;margin:0;padding:var(--space-sm) var(--space-base);font-size:var(--text-base);font-weight:400;line-height:1.5;background-clip:padding-box;border-width:1px;border-radius:.25rem;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}:host>textarea::placeholder{color:var(--form-control-placeholder)}:host>textarea:hover,:host>textarea:focus,:host>textarea.focus{border-color:var(--form-control-hover-border)}:host>textarea:disabled,:host>textarea:disabled:hover,:host>textarea:disabled:focus,:host>textarea.disabled,:host>textarea.disabled:hover,:host>textarea.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host>textarea:after,:host>textarea:before{box-sizing:border-box}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TextareaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-textarea', providers: [{ provide: FormControlComponent, useExisting: TextareaComponent }], template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<textarea avnScroll #inputElement [value]=\"value\" [id]=\"id\" [rows]=\"rows\" [cols]=\"columns\" [disabled]=\"disabled\" [placeholder]=\"placeholder\" (change)=\"onChange($event)\"></textarea>\n", styles: [":host{display:flex;flex-direction:column;height:100%}:host.validation-theme.ng-valid.ng-touched>textarea,:host.validation-theme.ng-valid.ng-dirty>textarea{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched>textarea,:host.validation-theme.ng-invalid.ng-dirty>textarea{border-color:var(--danger-base)!important}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host>textarea{outline-style:none;outline-offset:-2px;color:inherit;background:none;border:1px solid var(--form-control-border);color:var(--form-control-on);background:var(--form-control-background);flex-grow:1;margin:0;padding:var(--space-sm) var(--space-base);font-size:var(--text-base);font-weight:400;line-height:1.5;background-clip:padding-box;border-width:1px;border-radius:.25rem;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}:host>textarea::placeholder{color:var(--form-control-placeholder)}:host>textarea:hover,:host>textarea:focus,:host>textarea.focus{border-color:var(--form-control-hover-border)}:host>textarea:disabled,:host>textarea:disabled:hover,:host>textarea:disabled:focus,:host>textarea.disabled,:host>textarea.disabled:hover,:host>textarea.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host>textarea:after,:host>textarea:before{box-sizing:border-box}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], rows: [{
                type: Input
            }], columns: [{
                type: Input
            }], inputElement: [{
                type: ViewChild,
                args: ['inputElement', { static: false }]
            }], value: [{
                type: Input
            }], indentObject: [{
                type: Input
            }], changed: [{
                type: Output
            }] } });

class TextareaModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TextareaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TextareaModule, declarations: [TextareaComponent], imports: [CommonModule, FormsModule, CoreModule], exports: [TextareaComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TextareaModule, imports: [CommonModule, FormsModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TextareaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, CoreModule],
                    declarations: [TextareaComponent],
                    exports: [TextareaComponent],
                }]
        }] });

/**
 * This service loads a provided icon 'png' to display on the loader in your application.
 */
class LoaderIconRegistryService {
    /**
     * @ignore
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
        /**
         * @ignore
         */
        this._imgReplayStorage = new ReplaySubject();
    }
    /**
     * returns an observable of the loaded loader branding image.
     */
    get loaderImg$() {
        return this._imgReplayStorage.asObservable();
    }
    /**
     * Loads an icon from the path. i.e './assets/img.png'
     */
    loadIconFromAsset(source) {
        this.httpClient
            .get(source, { responseType: 'blob' })
            .pipe(switchMap((blob) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(blob);
            return new Observable((observer) => {
                fileReader.onload = (ev) => {
                    observer.next(ev.target.result);
                    observer.complete();
                };
                fileReader.onerror = (error) => {
                    observer.error(error);
                };
            });
        }))
            .subscribe((img) => {
            this._imgReplayStorage.next(img);
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderIconRegistryService, deps: [{ token: i1$9.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderIconRegistryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LoaderIconRegistryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$9.HttpClient }]; } });

class PanelComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: PanelComponent, selector: "avn-panel", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:flex;flex-direction:column;height:100%}:host avn-panel-body{flex:1}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-panel', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: [":host{display:flex;flex-direction:column;height:100%}:host avn-panel-body{flex:1}\n"] }]
        }] });

class PanelHeaderComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: PanelHeaderComponent, selector: "avn-panel-header", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:grid;grid-auto-flow:column;grid-auto-columns:auto;grid-template-rows:auto;grid-column-gap:var(--space-xl);max-width:100%;align-items:center;justify-content:space-between;margin:var(--space-sm)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-panel-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: [":host{display:grid;grid-auto-flow:column;grid-auto-columns:auto;grid-template-rows:auto;grid-column-gap:var(--space-xl);max-width:100%;align-items:center;justify-content:space-between;margin:var(--space-sm)}\n"] }]
        }] });

class PanelBodyComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: PanelBodyComponent, selector: "avn-panel-body", ngImport: i0, template: "<div class=\"panel-body-content\" avnScroll><ng-content></ng-content></div>\n", styles: [":host{display:block;flex:1;margin:var(--space-sm);overflow:auto}:host .panel-body-content{height:100%}\n"], dependencies: [{ kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-panel-body', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"panel-body-content\" avnScroll><ng-content></ng-content></div>\n", styles: [":host{display:block;flex:1;margin:var(--space-sm);overflow:auto}:host .panel-body-content{height:100%}\n"] }]
        }] });

class PanelFooterComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: PanelFooterComponent, selector: "avn-panel-footer", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:grid;grid-auto-flow:column;grid-auto-columns:auto;grid-template-rows:auto;grid-column-gap:var(--space-xl);max-width:100%;align-items:center;justify-content:space-between;margin:var(--space-sm)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-panel-footer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: [":host{display:grid;grid-auto-flow:column;grid-auto-columns:auto;grid-template-rows:auto;grid-column-gap:var(--space-xl);max-width:100%;align-items:center;justify-content:space-between;margin:var(--space-sm)}\n"] }]
        }] });

class SlotDirective {
    constructor(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
    }
    ngOnInit() {
        // auto add text overflow for text elements
        const isTextElement = this._elementRef.nativeElement.tagName.toLowerCase() === 'span';
        if (isTextElement) {
            this._renderer.setStyle(this._elementRef.nativeElement, 'text-overflow', 'ellipsis');
            this._renderer.setStyle(this._elementRef.nativeElement, 'white-space', 'nowrap');
            this._renderer.setStyle(this._elementRef.nativeElement, 'overflow', 'hidden');
        }
    }
    ngOnChanges({ position }) {
        if (position) {
            const positionValue = position.currentValue;
            const order = positionValue === 'left' ? 0 : positionValue === 'center' ? 1 : positionValue === 'right' ? 2 : 0;
            this._renderer.setStyle(this._elementRef.nativeElement, 'order', order);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SlotDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: SlotDirective, selector: "[avnSlot]", inputs: { position: ["avnSlot", "position"] }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SlotDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnSlot]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { position: [{
                type: Input,
                args: ['avnSlot']
            }] } });

class PanelModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: PanelModule, declarations: [PanelComponent, PanelHeaderComponent, PanelBodyComponent, PanelFooterComponent, SlotDirective], imports: [CommonModule, CoreModule], exports: [PanelComponent, PanelHeaderComponent, PanelBodyComponent, PanelFooterComponent, SlotDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelModule, imports: [CommonModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PanelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule],
                    declarations: [PanelComponent, PanelHeaderComponent, PanelBodyComponent, PanelFooterComponent, SlotDirective],
                    exports: [PanelComponent, PanelHeaderComponent, PanelBodyComponent, PanelFooterComponent, SlotDirective],
                }]
        }] });

class ProgressSegmentComponent {
    constructor(template) {
        this.template = template;
        /**
         * value to be displayed in the progressbar. Should be smaller or equal to "max" value.
         */
        this.percentage = 0;
        /**
         * A flag indicating if the current percentage value should be shown.
         */
        this.showValue = false;
        this.valueChanged = new EventEmitter();
    }
    ngOnChanges({ value }) {
        if (value) {
            this.valueChanged.emit(this.value);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ProgressSegmentComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ProgressSegmentComponent, selector: "avn-progress-segment", inputs: { value: "value" }, outputs: { valueChanged: "valueChanged" }, usesOnChanges: true, ngImport: i0, template: "<div\n  #segment\n  class=\"progress-bar{{ striped ? ' progress-bar-striped' : '' }}\"\n  role=\"progressbar\"\n  [attr.aria-valuenow]=\"percentage\"\n  aria-valuemin=\"0\"\n  [attr.aria-valuemax]=\"max\"\n>\n  <span *ngIf=\"showValue\">{{ label }}</span>\n</div>\n", styles: [":host{transition:width .15s cubic-bezier(0,0,.2,1)}:host.theme-primary>div{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>div{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>div{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>div{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>div{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>div{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>div{background-color:var(--success-base);color:var(--success-on)}:host .progress-bar-striped{background-image:linear-gradient(45deg,var(--main-on) 25%,transparent 26%,transparent 50%,var(--main-on) 50%,var(--main-on) 75%,transparent 75%,transparent);background-size:1rem 1rem}:host div{height:100%;text-align:center}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ProgressSegmentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-progress-segment', template: "<div\n  #segment\n  class=\"progress-bar{{ striped ? ' progress-bar-striped' : '' }}\"\n  role=\"progressbar\"\n  [attr.aria-valuenow]=\"percentage\"\n  aria-valuemin=\"0\"\n  [attr.aria-valuemax]=\"max\"\n>\n  <span *ngIf=\"showValue\">{{ label }}</span>\n</div>\n", styles: [":host{transition:width .15s cubic-bezier(0,0,.2,1)}:host.theme-primary>div{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>div{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>div{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>div{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>div{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>div{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>div{background-color:var(--success-base);color:var(--success-on)}:host .progress-bar-striped{background-image:linear-gradient(45deg,var(--main-on) 25%,transparent 26%,transparent 50%,var(--main-on) 50%,var(--main-on) 75%,transparent 75%,transparent);background-size:1rem 1rem}:host div{height:100%;text-align:center}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { value: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }] } });

class ProgressbarComponent {
    constructor(renderer, _changeDetector) {
        this.renderer = renderer;
        this._changeDetector = _changeDetector;
        /**
         * Maximal value to be displayed in the progressbar.
         * this will help calculate the percentage by value / max;
         */
        this.max = 100;
        /**
         * display Icon under progress bar
         */
        this.showIcon = true;
        /**
         * If the progress is finished
         */
        this.finished = false;
        /** Pattern used to close all subscriptions **/
        this.componentDestroyed$ = new Subject();
        this.hashedProgressSegment = {};
    }
    ngAfterContentInit() {
        if (this.segments) {
            this.initAndDrawSegment(this.segments);
            this.recreateSubscriptions();
            this.segments.changes.pipe(takeUntil(this.componentDestroyed$)).subscribe((segmentList) => {
                this.resetSubscriptions();
                this.hashedProgressSegment = {};
                this.initAndDrawSegment(segmentList);
                this.recreateSubscriptions();
            });
        }
    }
    getSmallerInRange(value, max) {
        return Math.max(Math.min(value, max), 0);
    }
    getPercentValue(value) {
        return (100 * this.getSmallerInRange(value, this.max)) / this.max;
    }
    getDisplayValue(value) {
        return Math.floor((100 * this.getSmallerInRange(value, this.max)) / this.max);
    }
    ngOnDestroy() {
        this.resetSubscriptions();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    createItemSubscription(item) {
        const subscription = item.valueChanged.subscribe((_) => {
            this.drawSegment(item);
        });
        return subscription;
    }
    drawSegment(segment) {
        segment.showValue = this.showValue;
        segment.max = this.max;
        segment.striped = this.striped;
        segment.percentage = this.getPercentValue(segment.value);
        segment.label = this.maxIsValid(this.max) ? this.getDisplayValue(segment.value) + '%' : '';
        this.renderer.setStyle(segment.template.nativeElement, 'width', this.getPercentValue(segment.value) + '%');
        this._changeDetector.markForCheck();
    }
    initAndDrawSegment(segments) {
        setTimeout(() => {
            segments.forEach((segment) => {
                this.drawSegment(segment);
            });
        });
    }
    resetSubscriptions() {
        Object.keys(this.hashedProgressSegment).forEach((k) => {
            if (this.hashedProgressSegment[k].subscription) {
                this.hashedProgressSegment[k].subscription.unsubscribe();
            }
        });
    }
    recreateSubscriptions() {
        // register the change detection
        this.segments.toArray().forEach((segment) => {
            const subscription = this.createItemSubscription(segment);
            segment.key = v4();
            this.hashedProgressSegment[segment.key] = { subscription };
        });
    }
    ngOnChanges({ max, striped, showValue }) {
        if ((max && !max.firstChange) || (striped && !striped.firstChange) || (showValue && !showValue.firstChange)) {
            this.initAndDrawSegment(this.segments);
        }
    }
    maxIsValid(max) {
        return max > 0;
    }
    /**
     * dynamically create a background div, due to a browser css rendering issue for border-radius:
     * https://stackoverflow.com/questions/30337954/border-radius-overflow-hidden-inner-element-progress-bar-makes-jagged-edge
     */
    shouldShowBackGround() {
        return this.max > this.segments.reduce((sum, item) => sum + Number(item.value), 0);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ProgressbarComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ProgressbarComponent, selector: "avn-progressbar", inputs: { max: "max", striped: "striped", showValue: "showValue", showIcon: "showIcon", height: "height", finished: "finished" }, queries: [{ propertyName: "segments", predicate: ProgressSegmentComponent }], usesOnChanges: true, ngImport: i0, template: "<div class=\"progress\" [style.height]=\"height\" #progressContainer>\n  <ng-content></ng-content>\n  <div *ngIf=\"shouldShowBackGround()\" class=\"background\"></div>\n</div>\n<ng-container *ngIf=\"showIcon && segments.length > 0\">\n  <avn-icon *ngIf=\"finished; else unfinish\" class=\"icon\" [icon]=\"'navigation:check'\"></avn-icon>\n  <ng-template #unfinish>\n    <avn-icon class=\"icon\" [icon]=\"'action:autorenew'\" [rotate]=\"true\"></avn-icon>\n  </ng-template>\n</ng-container>\n", styles: [":host{display:block;width:100%}:host.theme-primary div.progress>.background{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary div.progress>.background{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight div.progress>.background{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger div.progress>.background{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning div.progress>.background{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info div.progress>.background{background-color:var(--info-base);color:var(--info-on)}:host.theme-success div.progress>.background{background-color:var(--success-base);color:var(--success-on)}:host .progress{display:flex;height:1rem;overflow:hidden;font-size:var(--text-sm);border-radius:.25rem}:host .progress .background{background:var(--progress-bar-background);flex-grow:1}:host .icon{float:right}:host avn-icon{width:1rem;height:1rem}:host avn-icon ::ng-deep i{font-size:var(--text-base)!important;font-weight:700}:host .avn-spin{animation:avn-spin 2s infinite linear}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ProgressbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-progressbar', template: "<div class=\"progress\" [style.height]=\"height\" #progressContainer>\n  <ng-content></ng-content>\n  <div *ngIf=\"shouldShowBackGround()\" class=\"background\"></div>\n</div>\n<ng-container *ngIf=\"showIcon && segments.length > 0\">\n  <avn-icon *ngIf=\"finished; else unfinish\" class=\"icon\" [icon]=\"'navigation:check'\"></avn-icon>\n  <ng-template #unfinish>\n    <avn-icon class=\"icon\" [icon]=\"'action:autorenew'\" [rotate]=\"true\"></avn-icon>\n  </ng-template>\n</ng-container>\n", styles: [":host{display:block;width:100%}:host.theme-primary div.progress>.background{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary div.progress>.background{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight div.progress>.background{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger div.progress>.background{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning div.progress>.background{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info div.progress>.background{background-color:var(--info-base);color:var(--info-on)}:host.theme-success div.progress>.background{background-color:var(--success-base);color:var(--success-on)}:host .progress{display:flex;height:1rem;overflow:hidden;font-size:var(--text-sm);border-radius:.25rem}:host .progress .background{background:var(--progress-bar-background);flex-grow:1}:host .icon{float:right}:host avn-icon{width:1rem;height:1rem}:host avn-icon ::ng-deep i{font-size:var(--text-base)!important;font-weight:700}:host .avn-spin{animation:avn-spin 2s infinite linear}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { max: [{
                type: Input
            }], striped: [{
                type: Input
            }], showValue: [{
                type: Input
            }], showIcon: [{
                type: Input
            }], height: [{
                type: Input
            }], finished: [{
                type: Input
            }], segments: [{
                type: ContentChildren,
                args: [ProgressSegmentComponent]
            }] } });

class ProgressbarModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ProgressbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ProgressbarModule, declarations: [ProgressbarComponent, ProgressSegmentComponent], imports: [CommonModule, CoreModule, IconModule], exports: [ProgressbarComponent, ProgressSegmentComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ProgressbarModule, imports: [CommonModule, CoreModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ProgressbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule],
                    declarations: [ProgressbarComponent, ProgressSegmentComponent],
                    exports: [ProgressbarComponent, ProgressSegmentComponent],
                }]
        }] });

/** Decorates the `ng-template` tags and reads out the template from it. */
class SideTabLazyLoadingDirective {
    constructor(template) {
        this.template = template;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabLazyLoadingDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: SideTabLazyLoadingDirective, selector: "[avnLazyLoading]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabLazyLoadingDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnLazyLoading]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class SideTabComponent {
    get content() {
        return this._contentPortal;
    }
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        /** Label to appear on this tab  */
        this.label = '';
        /** Disable the tab */
        this.disabled = false;
        /** active tab */
        this.active = false;
        /** Portal that will be the hosted content of the tab */
        this._contentPortal = null;
    }
    ngOnInit() {
        this._contentPortal = new TemplatePortal(this._explicitContent || this._content, this._viewContainerRef);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabComponent, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SideTabComponent, selector: "avn-side-tab", inputs: { icon: "icon", label: "label", disabled: "disabled" }, queries: [{ propertyName: "_explicitContent", first: true, predicate: SideTabLazyLoadingDirective, descendants: true, read: TemplateRef, static: true }], viewQueries: [{ propertyName: "_content", first: true, predicate: TemplateRef, descendants: true, static: true }], ngImport: i0, template: "<!-- Represent the HTML content inside a <avn-side-tab> -->\n<ng-template><ng-content></ng-content></ng-template>\n", styles: [":host{display:block}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-side-tab', template: "<!-- Represent the HTML content inside a <avn-side-tab> -->\n<ng-template><ng-content></ng-content></ng-template>\n", styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { _content: [{
                type: ViewChild,
                args: [TemplateRef, { static: true }]
            }], _explicitContent: [{
                type: ContentChild,
                args: [SideTabLazyLoadingDirective, { read: TemplateRef, static: true }]
            }], icon: [{
                type: Input
            }], label: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class SideTabBodyComponent {
    constructor() {
        /** If tab is currently active or not */
        this.active = false;
        /** Tell if this is the first time we draw the content */
        this.firstTime = true;
    }
    ngOnChanges() {
        this.render();
    }
    /** Render the content the first time the tab is active */
    render() {
        if (this.active && this.firstTime) {
            this.drawContent = this.content;
            this.firstTime = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SideTabBodyComponent, selector: "avn-side-tab-body", inputs: { content: "content", active: "active" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"side-tab-body-content\" avnScroll>\n  <ng-template [cdkPortalOutlet]=\"drawContent\"></ng-template>\n</div>\n", styles: [":host{display:block;position:relative;height:100%}:host .side-tab-body-content{position:relative;height:100%;overflow:auto}\n"], dependencies: [{ kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: i2$1.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-side-tab-body', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"side-tab-body-content\" avnScroll>\n  <ng-template [cdkPortalOutlet]=\"drawContent\"></ng-template>\n</div>\n", styles: [":host{display:block;position:relative;height:100%}:host .side-tab-body-content{position:relative;height:100%;overflow:auto}\n"] }]
        }], propDecorators: { content: [{
                type: Input
            }], active: [{
                type: Input
            }] } });

class SideTabGroupComponent {
    constructor() {
        /** Event emitted when the selected tab change */
        this.selectedTabChanged = new EventEmitter();
        /** Output to enable support for two-way binding on `[(selectedIndex)]` */
        this.selectedIndexChange = new EventEmitter();
    }
    ngAfterContentInit() {
        // Select the first tab by default if none are selected
        if (this.tabs && this.tabs.length) {
            this.selectTab(this.tabs.get(this.selectedIndex) || this.tabs.first);
        }
    }
    ngOnChanges({ selectedIndex }) {
        let currValue = selectedIndex.currentValue;
        if (Number.isInteger(currValue) && currValue !== selectedIndex.previousValue && this.tabs) {
            // if selected index is out of range then clamp the selected index to the size of the number of tabs
            currValue = currValue < 0 ? 0 : currValue;
            currValue = currValue >= this.tabs.length ? this.tabs.length - 1 : currValue;
            const tab = this.tabs.get(currValue);
            if (!tab.active) {
                this.selectTab(tab);
            }
        }
    }
    /** Active a tab and unactive all others */
    selectTab(tab) {
        if (!tab?.disabled) {
            this.tabs.forEach((item, index) => {
                item.active = item === tab; // set active state for each tab
                if (item.active) {
                    this.selectedIndex = index;
                }
            });
            // Emit after change detection has run to fix ExpressionChangedAfterItHasBeenCheckedError
            Promise.resolve().then(() => {
                // 2-way binding
                this.selectedIndexChange.emit(this.selectedIndex);
            });
            this.selectedTabChanged.emit({
                index: this.selectedIndex,
                tab,
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SideTabGroupComponent, selector: "avn-side-tab-group", inputs: { selectedIndex: "selectedIndex" }, outputs: { selectedTabChanged: "selectedTabChanged", selectedIndexChange: "selectedIndexChange" }, queries: [{ propertyName: "tabs", predicate: SideTabComponent }], usesOnChanges: true, ngImport: i0, template: "<div class=\"side-tab-headers\" avnScroll>\n  <div class=\"side-tab-header\" [ngClass]=\"{ active: !!tab.active, disabled: tab.disabled }\" *ngFor=\"let tab of tabs\" (click)=\"selectTab(tab)\">\n    <div class=\"side-tab-header-label\">{{ tab.label }}</div>\n    <avn-icon class=\"side-tab-header-icon\" *ngIf=\"tab.icon\" [icon]=\"tab.icon\"></avn-icon>\n  </div>\n</div>\n\n<div class=\"side-tab-content\">\n  <avn-side-tab-body role=\"tabpanel\" *ngFor=\"let tab of tabs; let i = index\" [content]=\"tab.content\" [active]=\"tab.active\" [hidden]=\"!tab.active\">\n  </avn-side-tab-body>\n</div>\n", styles: [":host{--side-tab-divider-color: rgba(0, 0, 0, .5);display:flex}:host.theme-primary .side-tab-header.active{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary .side-tab-header.active{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight .side-tab-header.active{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger .side-tab-header.active{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning .side-tab-header.active{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info .side-tab-header.active{background-color:var(--info-base);color:var(--info-on)}:host.theme-success .side-tab-header.active{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary .side-tab-headers .side-tab-header:hover,:host.theme-primary .side-tab-headers .side-tab-header:focus{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary .side-tab-headers .side-tab-header:hover,:host.theme-primary .side-tab-headers .side-tab-header:focus:hover{background-color:var(--primary-variant)}:host.theme-secondary .side-tab-headers .side-tab-header:hover,:host.theme-secondary .side-tab-headers .side-tab-header:focus{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary .side-tab-headers .side-tab-header:hover,:host.theme-secondary .side-tab-headers .side-tab-header:focus:hover{background-color:var(--secondary-variant)}:host.theme-highlight .side-tab-headers .side-tab-header:hover,:host.theme-highlight .side-tab-headers .side-tab-header:focus{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight .side-tab-headers .side-tab-header:hover,:host.theme-highlight .side-tab-headers .side-tab-header:focus:hover{background-color:var(--highlight-variant)}:host.theme-danger .side-tab-headers .side-tab-header:hover,:host.theme-danger .side-tab-headers .side-tab-header:focus{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger .side-tab-headers .side-tab-header:hover,:host.theme-danger .side-tab-headers .side-tab-header:focus:hover{background-color:var(--danger-variant)}:host.theme-warning .side-tab-headers .side-tab-header:hover,:host.theme-warning .side-tab-headers .side-tab-header:focus{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning .side-tab-headers .side-tab-header:hover,:host.theme-warning .side-tab-headers .side-tab-header:focus:hover{background-color:var(--warning-variant)}:host.theme-info .side-tab-headers .side-tab-header:hover,:host.theme-info .side-tab-headers .side-tab-header:focus{background-color:var(--info-base);color:var(--info-on)}:host.theme-info .side-tab-headers .side-tab-header:hover,:host.theme-info .side-tab-headers .side-tab-header:focus:hover{background-color:var(--info-variant)}:host.theme-success .side-tab-headers .side-tab-header:hover,:host.theme-success .side-tab-headers .side-tab-header:focus{background-color:var(--success-base);color:var(--success-on)}:host.theme-success .side-tab-headers .side-tab-header:hover,:host.theme-success .side-tab-headers .side-tab-header:focus:hover{background-color:var(--success-variant)}:host .side-tab-headers{border-right:1px solid var(--side-tab-divider-color, black)}:host .side-tab-headers .side-tab-header{-webkit-user-select:none;user-select:none;padding:var(--space-base) var(--space-sm);cursor:pointer}:host .side-tab-headers .side-tab-header .side-tab-header-label{writing-mode:tb-rl;transform:rotate(180deg);margin:auto}:host .side-tab-headers .side-tab-header .side-tab-header-icon{margin-top:var(--space-sm)}:host .side-tab-headers .side-tab-header.disabled{opacity:.3;cursor:not-allowed}:host .side-tab-content{flex:1}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: SideTabBodyComponent, selector: "avn-side-tab-body", inputs: ["content", "active"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-side-tab-group', template: "<div class=\"side-tab-headers\" avnScroll>\n  <div class=\"side-tab-header\" [ngClass]=\"{ active: !!tab.active, disabled: tab.disabled }\" *ngFor=\"let tab of tabs\" (click)=\"selectTab(tab)\">\n    <div class=\"side-tab-header-label\">{{ tab.label }}</div>\n    <avn-icon class=\"side-tab-header-icon\" *ngIf=\"tab.icon\" [icon]=\"tab.icon\"></avn-icon>\n  </div>\n</div>\n\n<div class=\"side-tab-content\">\n  <avn-side-tab-body role=\"tabpanel\" *ngFor=\"let tab of tabs; let i = index\" [content]=\"tab.content\" [active]=\"tab.active\" [hidden]=\"!tab.active\">\n  </avn-side-tab-body>\n</div>\n", styles: [":host{--side-tab-divider-color: rgba(0, 0, 0, .5);display:flex}:host.theme-primary .side-tab-header.active{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary .side-tab-header.active{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight .side-tab-header.active{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger .side-tab-header.active{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning .side-tab-header.active{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info .side-tab-header.active{background-color:var(--info-base);color:var(--info-on)}:host.theme-success .side-tab-header.active{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary .side-tab-headers .side-tab-header:hover,:host.theme-primary .side-tab-headers .side-tab-header:focus{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary .side-tab-headers .side-tab-header:hover,:host.theme-primary .side-tab-headers .side-tab-header:focus:hover{background-color:var(--primary-variant)}:host.theme-secondary .side-tab-headers .side-tab-header:hover,:host.theme-secondary .side-tab-headers .side-tab-header:focus{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary .side-tab-headers .side-tab-header:hover,:host.theme-secondary .side-tab-headers .side-tab-header:focus:hover{background-color:var(--secondary-variant)}:host.theme-highlight .side-tab-headers .side-tab-header:hover,:host.theme-highlight .side-tab-headers .side-tab-header:focus{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight .side-tab-headers .side-tab-header:hover,:host.theme-highlight .side-tab-headers .side-tab-header:focus:hover{background-color:var(--highlight-variant)}:host.theme-danger .side-tab-headers .side-tab-header:hover,:host.theme-danger .side-tab-headers .side-tab-header:focus{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger .side-tab-headers .side-tab-header:hover,:host.theme-danger .side-tab-headers .side-tab-header:focus:hover{background-color:var(--danger-variant)}:host.theme-warning .side-tab-headers .side-tab-header:hover,:host.theme-warning .side-tab-headers .side-tab-header:focus{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning .side-tab-headers .side-tab-header:hover,:host.theme-warning .side-tab-headers .side-tab-header:focus:hover{background-color:var(--warning-variant)}:host.theme-info .side-tab-headers .side-tab-header:hover,:host.theme-info .side-tab-headers .side-tab-header:focus{background-color:var(--info-base);color:var(--info-on)}:host.theme-info .side-tab-headers .side-tab-header:hover,:host.theme-info .side-tab-headers .side-tab-header:focus:hover{background-color:var(--info-variant)}:host.theme-success .side-tab-headers .side-tab-header:hover,:host.theme-success .side-tab-headers .side-tab-header:focus{background-color:var(--success-base);color:var(--success-on)}:host.theme-success .side-tab-headers .side-tab-header:hover,:host.theme-success .side-tab-headers .side-tab-header:focus:hover{background-color:var(--success-variant)}:host .side-tab-headers{border-right:1px solid var(--side-tab-divider-color, black)}:host .side-tab-headers .side-tab-header{-webkit-user-select:none;user-select:none;padding:var(--space-base) var(--space-sm);cursor:pointer}:host .side-tab-headers .side-tab-header .side-tab-header-label{writing-mode:tb-rl;transform:rotate(180deg);margin:auto}:host .side-tab-headers .side-tab-header .side-tab-header-icon{margin-top:var(--space-sm)}:host .side-tab-headers .side-tab-header.disabled{opacity:.3;cursor:not-allowed}:host .side-tab-content{flex:1}\n"] }]
        }], propDecorators: { selectedIndex: [{
                type: Input
            }], selectedTabChanged: [{
                type: Output
            }], selectedIndexChange: [{
                type: Output
            }], tabs: [{
                type: ContentChildren,
                args: [SideTabComponent]
            }] } });

class SideTabModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SideTabModule, declarations: [SideTabComponent, SideTabGroupComponent, SideTabBodyComponent, SideTabLazyLoadingDirective], imports: [CommonModule, CoreModule, IconModule, PortalModule], exports: [SideTabComponent, SideTabGroupComponent, SideTabLazyLoadingDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabModule, imports: [CommonModule, CoreModule, IconModule, PortalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SideTabModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, PortalModule],
                    exports: [SideTabComponent, SideTabGroupComponent, SideTabLazyLoadingDirective],
                    declarations: [SideTabComponent, SideTabGroupComponent, SideTabBodyComponent, SideTabLazyLoadingDirective],
                    providers: [],
                }]
        }] });

class SwitchComponent extends FormControlComponent {
    /**
     * The initial value of the switch
     */
    set value(val) {
        this.updateValue(val);
    }
    get disabled() {
        return super.disabled;
    }
    set disabled(value) {
        super.disabled = value;
    }
    /**
     * @ignore
     */
    constructor(renderer, ngControl, changeDetector) {
        super(ngControl, changeDetector);
        this.renderer = renderer;
        /**
         * label position to switch button: could be 'before' or 'after',
         * by default, it's 'before'
         */
        this.labelPosition = 'before';
        /**
         * The status of switch, true of false
         */
        this.status = false;
        /**
         * @deprecated Emit event when status is changed
         */
        this.statusChanged = new EventEmitter();
        /**
         * Emit event when status is changed
         */
        this.changed = new EventEmitter();
        /** pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
    }
    /**
     * child components and directives become available from AfterViewInit lifecycle hook
     *
     * @ignore
     */
    ngAfterViewInit() {
        this.subscribeTouch(this.inputElement.nativeElement, 'blur');
    }
    /**
     * Updates the value of our component when the native input value changes
     *
     * @ignore
     */
    onChange($event) {
        this.status = $event.currentTarget.checked;
        this.propagateChange(this.status);
        this.onTouch();
        this.statusChanged.emit({ status: this.status });
        this.changed.emit(this.status);
    }
    updateValue(value) {
        this.status = !!value;
    }
    getLabelPositionClass() {
        if (this.labelPosition === 'after') {
            return this.labelPosition;
        }
        else {
            return 'before';
        }
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SwitchComponent, deps: [{ token: i0.Renderer2 }, { token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SwitchComponent, selector: "avn-switch", inputs: { label: "label", labelPosition: "labelPosition", value: "value", status: "status" }, outputs: { statusChanged: "statusChanged", changed: "changed" }, host: { properties: { "class.active": "this.status", "class.disabled": "this.disabled" } }, providers: [{ provide: FormControlComponent, useExisting: SwitchComponent }], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<label #labelElement class=\"switch-container\" [for]=\"id\" [ngClass]=\"getLabelPositionClass()\">\n  <span class=\"avn-switch-label\">{{ label }}</span>\n  <div class=\"ui-switch is-animated\" [class.on]=\"status\">\n    <input type=\"checkbox\" class=\"ui-checkbox\" [id]=\"id\" [disabled]=\"disabled\" (change)=\"onChange($event)\" [checked]=\"status\" #inputElement />\n    <span class=\"ui-button\"></span>\n  </div>\n</label>\n", styles: [":host{display:block;max-width:100%}:host.theme-primary>.switch-container>.ui-switch.on:before{border:1px solid var(--primary-base);background-color:var(--primary-base)}:host.theme-primary>.switch-container>.ui-switch.on>span{background-color:var(--primary-base)}:host.theme-secondary>.switch-container>.ui-switch.on:before{border:1px solid var(--secondary-base);background-color:var(--secondary-base)}:host.theme-secondary>.switch-container>.ui-switch.on>span{background-color:var(--secondary-base)}:host.theme-highlight>.switch-container>.ui-switch.on:before{border:1px solid var(--highlight-base);background-color:var(--highlight-base)}:host.theme-highlight>.switch-container>.ui-switch.on>span{background-color:var(--highlight-base)}:host.theme-danger>.switch-container>.ui-switch.on:before{border:1px solid var(--danger-base);background-color:var(--danger-base)}:host.theme-danger>.switch-container>.ui-switch.on>span{background-color:var(--danger-base)}:host.theme-warning>.switch-container>.ui-switch.on:before{border:1px solid var(--warning-base);background-color:var(--warning-base)}:host.theme-warning>.switch-container>.ui-switch.on>span{background-color:var(--warning-base)}:host.theme-info>.switch-container>.ui-switch.on:before{border:1px solid var(--info-base);background-color:var(--info-base)}:host.theme-info>.switch-container>.ui-switch.on>span{background-color:var(--info-base)}:host.theme-success>.switch-container>.ui-switch.on:before{border:1px solid var(--success-base);background-color:var(--success-base)}:host.theme-success>.switch-container>.ui-switch.on>span{background-color:var(--success-base)}:host label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host label.disabled{opacity:.3}:host.disabled label{opacity:.3}:host .switch-container{display:flex;height:inherit;cursor:pointer}:host .switch-container>.avn-switch-label{margin:auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .switch-container .ui-switch{display:inline-block;position:relative;border-radius:20px;min-width:51px;margin:5.5px;line-height:1.55rem}:host .switch-container .ui-switch.on:before{border:1px solid var(--switch-on-background);background-color:var(--switch-on-background)}:host .switch-container .ui-switch.on>span{background-color:var(--switch-on-background)}:host .switch-container .ui-switch:before{content:\"\";display:inline-block;border-radius:20px;width:100%;height:100%;position:absolute;left:0;line-height:1.55rem;opacity:.5;border:1px solid var(--switch-off-background);background-color:var(--switch-off-background)}:host .switch-container .ui-switch input:disabled{cursor:not-allowed}:host .switch-container .is-animated .ui-button{transition:margin ease-out .2s}:host .switch-container .ui-checkbox{opacity:0;display:block;position:absolute;top:0;width:100%;height:100%;margin:0}:host .switch-container .ui-button{display:block;width:19px;height:19px;margin:1px;background-color:var(--switch-off-background);border-radius:11px;transform:scale(1.5);box-shadow:0 0 1px 1px #0000004d}:host .switch-container .ui-checkbox:checked+.ui-button{margin-left:29px}:host .before .avn-switch-label{order:0;margin-right:var(--space-sm)}:host .after .avn-switch-label{order:1;margin-left:var(--space-sm)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-switch', providers: [{ provide: FormControlComponent, useExisting: SwitchComponent }], template: "<label #labelElement class=\"switch-container\" [for]=\"id\" [ngClass]=\"getLabelPositionClass()\">\n  <span class=\"avn-switch-label\">{{ label }}</span>\n  <div class=\"ui-switch is-animated\" [class.on]=\"status\">\n    <input type=\"checkbox\" class=\"ui-checkbox\" [id]=\"id\" [disabled]=\"disabled\" (change)=\"onChange($event)\" [checked]=\"status\" #inputElement />\n    <span class=\"ui-button\"></span>\n  </div>\n</label>\n", styles: [":host{display:block;max-width:100%}:host.theme-primary>.switch-container>.ui-switch.on:before{border:1px solid var(--primary-base);background-color:var(--primary-base)}:host.theme-primary>.switch-container>.ui-switch.on>span{background-color:var(--primary-base)}:host.theme-secondary>.switch-container>.ui-switch.on:before{border:1px solid var(--secondary-base);background-color:var(--secondary-base)}:host.theme-secondary>.switch-container>.ui-switch.on>span{background-color:var(--secondary-base)}:host.theme-highlight>.switch-container>.ui-switch.on:before{border:1px solid var(--highlight-base);background-color:var(--highlight-base)}:host.theme-highlight>.switch-container>.ui-switch.on>span{background-color:var(--highlight-base)}:host.theme-danger>.switch-container>.ui-switch.on:before{border:1px solid var(--danger-base);background-color:var(--danger-base)}:host.theme-danger>.switch-container>.ui-switch.on>span{background-color:var(--danger-base)}:host.theme-warning>.switch-container>.ui-switch.on:before{border:1px solid var(--warning-base);background-color:var(--warning-base)}:host.theme-warning>.switch-container>.ui-switch.on>span{background-color:var(--warning-base)}:host.theme-info>.switch-container>.ui-switch.on:before{border:1px solid var(--info-base);background-color:var(--info-base)}:host.theme-info>.switch-container>.ui-switch.on>span{background-color:var(--info-base)}:host.theme-success>.switch-container>.ui-switch.on:before{border:1px solid var(--success-base);background-color:var(--success-base)}:host.theme-success>.switch-container>.ui-switch.on>span{background-color:var(--success-base)}:host label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host label.disabled{opacity:.3}:host.disabled label{opacity:.3}:host .switch-container{display:flex;height:inherit;cursor:pointer}:host .switch-container>.avn-switch-label{margin:auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .switch-container .ui-switch{display:inline-block;position:relative;border-radius:20px;min-width:51px;margin:5.5px;line-height:1.55rem}:host .switch-container .ui-switch.on:before{border:1px solid var(--switch-on-background);background-color:var(--switch-on-background)}:host .switch-container .ui-switch.on>span{background-color:var(--switch-on-background)}:host .switch-container .ui-switch:before{content:\"\";display:inline-block;border-radius:20px;width:100%;height:100%;position:absolute;left:0;line-height:1.55rem;opacity:.5;border:1px solid var(--switch-off-background);background-color:var(--switch-off-background)}:host .switch-container .ui-switch input:disabled{cursor:not-allowed}:host .switch-container .is-animated .ui-button{transition:margin ease-out .2s}:host .switch-container .ui-checkbox{opacity:0;display:block;position:absolute;top:0;width:100%;height:100%;margin:0}:host .switch-container .ui-button{display:block;width:19px;height:19px;margin:1px;background-color:var(--switch-off-background);border-radius:11px;transform:scale(1.5);box-shadow:0 0 1px 1px #0000004d}:host .switch-container .ui-checkbox:checked+.ui-button{margin-left:29px}:host .before .avn-switch-label{order:0;margin-right:var(--space-sm)}:host .after .avn-switch-label{order:1;margin-left:var(--space-sm)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], value: [{
                type: Input
            }], status: [{
                type: HostBinding,
                args: ['class.active']
            }, {
                type: Input
            }], statusChanged: [{
                type: Output
            }], changed: [{
                type: Output
            }], inputElement: [{
                type: ViewChild,
                args: ['inputElement', { static: false }]
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }] } });

class SwitchModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SwitchModule, declarations: [SwitchComponent], imports: [CommonModule, IconModule], exports: [SwitchComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SwitchModule, imports: [CommonModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule],
                    declarations: [SwitchComponent],
                    exports: [SwitchComponent],
                }]
        }] });

/**
 * Injection token for use in the tabs container and custom tabs that allows to inject the tabs
 * config.
 */
const TABS_CONFIG = new InjectionToken('TABS_CONFIG');
const DEFAULT_TABS_CONFIG = {
    tabOverflow: 'scroll',
};

/** Decorates the `ng-template` tags and reads out the template from it. */
class LazyLoadingDirective {
    constructor(template) {
        this.template = template;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyLoadingDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: LazyLoadingDirective, selector: "[avnLazyLoading]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyLoadingDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnLazyLoading]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class TabComponent {
    constructor() {
        /**
         * id of tab
         */
        this.id = v4();
        /**
         * Indicates if the tab is active
         */
        this.active = false;
        /**
         * disabled, if true this tab will be disabled
         */
        this.disabled = false;
        /** Emit the tab ID when the tab is dynamically set to be active in the code, e.g. by route change */
        this.activeChangeSub = new Subject();
        this.activeChange$ = this.activeChangeSub.asObservable();
    }
    get content() {
        return this._contentPortal;
    }
    ngOnInit() {
        this._contentPortal = this._explicitContent || this._content;
    }
    ngOnChanges({ active }) {
        if (active?.currentValue && !active.firstChange) {
            this.activeChangeSub.next(this.id);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TabComponent, selector: "avn-tab", inputs: { id: "id", label: "label", active: "active", disabled: "disabled", headerTemplate: "headerTemplate" }, queries: [{ propertyName: "_explicitContent", first: true, predicate: LazyLoadingDirective, descendants: true, read: TemplateRef, static: true }], viewQueries: [{ propertyName: "_content", first: true, predicate: TemplateRef, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<!-- Represent the HTML content inside a <avn-tab> -->\n<ng-template><ng-content></ng-content></ng-template>\n", styles: [":host{display:block}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tab', template: "<!-- Represent the HTML content inside a <avn-tab> -->\n<ng-template><ng-content></ng-content></ng-template>\n", styles: [":host{display:block}\n"] }]
        }], propDecorators: { _content: [{
                type: ViewChild,
                args: [TemplateRef, { static: true }]
            }], _explicitContent: [{
                type: ContentChild,
                args: [LazyLoadingDirective, { read: TemplateRef, static: true }]
            }], id: [{
                type: Input
            }], label: [{
                type: Input
            }], active: [{
                type: Input
            }], disabled: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }] } });

class TabsService {
    constructor() {
        this._tabsSubject = new Subject();
        this._tabsResizedSubject = new Subject();
    }
    get tabsContent$() {
        return this._tabsSubject.asObservable();
    }
    get tabsResized$() {
        return this._tabsResizedSubject.asObservable();
    }
    activateTabOverflow(lastTabHeaderOffsetLeft, lastTabHeaderOffsetWidth, firstTabHeaderOffsetLeft, tabsContainerOffsetWidth) {
        return lastTabHeaderOffsetLeft + lastTabHeaderOffsetWidth - firstTabHeaderOffsetLeft > tabsContainerOffsetWidth ? true : false;
    }
    setTabs(tabs) {
        this._tabsSubject.next(tabs);
    }
    setTabsResized(event) {
        this._tabsResizedSubject.next(event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsService, decorators: [{
            type: Injectable
        }] });

class TabsHeaderComponent {
    constructor(_tabsService) {
        this._tabsService = _tabsService;
        /**
         * Type of navigation to be used for tabs. Can be one of Bootstrap defined types ('tabs' or
         * 'pills').
         */
        this.type = 'tabs';
        /**
         * Add justify style to host
         */
        this.justifyClass = 'start';
        /**
         * List of the tabs
         */
        this.tabDatas = [];
        this.tabsSelectedEmit = new EventEmitter();
        this.componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        // Update tab when add/remove tab
        this.tabListItems.changes.pipe(takeUntil(this.componentDestroyed$)).subscribe((tab) => {
            this._tabsService.setTabs(tab.toArray());
        });
        const activeTab = this.tabDatas.find((tab) => tab.active);
        if (this.tabDatas.length > 0 && !this.tabDatas[0].disabled && !activeTab) {
            this.selectTab(this.tabDatas[0]);
        }
    }
    selectTab(selectedTab) {
        if (selectedTab && !selectedTab.disabled) {
            this.tabDatas.forEach((element) => {
                element.active = false;
            });
            this.tabDatas = [...this.tabDatas];
            selectedTab.active = true;
            this.tabsSelectedEmit.emit(selectedTab);
        }
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    get paddingButton() {
        return this.type === 'tabs' ? '0' : '2px';
    }
    getTabsClass() {
        const justifyContent = this.justifyClass === 'fill' || this.justifyClass === 'justified' ? `nav-${this.justifyClass}` : `justify-content-${this.justifyClass}`;
        return 'nav nav-' + this.type + ' ' + justifyContent;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsHeaderComponent, deps: [{ token: TabsService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TabsHeaderComponent, selector: "avn-tabs-header", inputs: { type: "type", justifyClass: "justifyClass", tabDatas: "tabDatas" }, outputs: { tabsSelectedEmit: "tabsSelectedEmit" }, host: { properties: { "style.paddingBottom": "this.paddingButton" } }, viewQueries: [{ propertyName: "tabContainer", first: true, predicate: ["tabContainer"], descendants: true, static: true }, { propertyName: "tabListItems", predicate: ["tabListItem"], descendants: true }], ngImport: i0, template: "<ul #tabContainer [ngClass]=\"getTabsClass()\" role=\"tablist\">\n  <li #tabListItem class=\"nav-item\" *ngFor=\"let tab of tabDatas\" (click)=\"selectTab(tab)\" [class.active]=\"tab.active\" [attr.data-e2e]=\"tab.id\">\n    <div class=\"nav-link\" [class.disabled]=\"tab.disabled\" role=\"tab\">\n      <ng-container *ngIf=\"tab.headerTemplate === undefined; else customTemplate\">{{ tab.label }}</ng-container>\n      <ng-template #customTemplate><ng-container *ngTemplateOutlet=\"tab.headerTemplate\"></ng-container></ng-template>\n    </div>\n  </li>\n</ul>\n", styles: [":host{display:flex;width:100%;z-index:1}:host.theme-primary ul>li.active>div.nav-link{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary ul>li.active>div.nav-link{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight ul>li.active>div.nav-link{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger ul>li.active>div.nav-link{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning ul>li.active>div.nav-link{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info ul>li.active>div.nav-link{background-color:var(--info-base);color:var(--info-on)}:host.theme-success ul>li.active>div.nav-link{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-primary .nav-tabs .nav-link:focus{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-primary .nav-tabs .nav-link:focus:hover{background-color:var(--primary-variant)}:host.theme-secondary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-secondary .nav-tabs .nav-link:focus{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-secondary .nav-tabs .nav-link:focus:hover{background-color:var(--secondary-variant)}:host.theme-highlight .nav-tabs .nav-link:hover:not(.disabled),:host.theme-highlight .nav-tabs .nav-link:focus{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight .nav-tabs .nav-link:hover:not(.disabled),:host.theme-highlight .nav-tabs .nav-link:focus:hover{background-color:var(--highlight-variant)}:host.theme-danger .nav-tabs .nav-link:hover:not(.disabled),:host.theme-danger .nav-tabs .nav-link:focus{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger .nav-tabs .nav-link:hover:not(.disabled),:host.theme-danger .nav-tabs .nav-link:focus:hover{background-color:var(--danger-variant)}:host.theme-warning .nav-tabs .nav-link:hover:not(.disabled),:host.theme-warning .nav-tabs .nav-link:focus{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning .nav-tabs .nav-link:hover:not(.disabled),:host.theme-warning .nav-tabs .nav-link:focus:hover{background-color:var(--warning-variant)}:host.theme-info .nav-tabs .nav-link:hover:not(.disabled),:host.theme-info .nav-tabs .nav-link:focus{background-color:var(--info-base);color:var(--info-on)}:host.theme-info .nav-tabs .nav-link:hover:not(.disabled),:host.theme-info .nav-tabs .nav-link:focus:hover{background-color:var(--info-variant)}:host.theme-success .nav-tabs .nav-link:hover:not(.disabled),:host.theme-success .nav-tabs .nav-link:focus{background-color:var(--success-base);color:var(--success-on)}:host.theme-success .nav-tabs .nav-link:hover:not(.disabled),:host.theme-success .nav-tabs .nav-link:focus:hover{background-color:var(--success-variant)}:host.theme-primary .nav-pills .nav-link:hover,:host.theme-primary .nav-tabs .nav-link:focus{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary .nav-pills .nav-link:hover,:host.theme-primary .nav-tabs .nav-link:focus:hover{background-color:var(--primary-variant)}:host.theme-secondary .nav-pills .nav-link:hover,:host.theme-secondary .nav-tabs .nav-link:focus{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary .nav-pills .nav-link:hover,:host.theme-secondary .nav-tabs .nav-link:focus:hover{background-color:var(--secondary-variant)}:host.theme-highlight .nav-pills .nav-link:hover,:host.theme-highlight .nav-tabs .nav-link:focus{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight .nav-pills .nav-link:hover,:host.theme-highlight .nav-tabs .nav-link:focus:hover{background-color:var(--highlight-variant)}:host.theme-danger .nav-pills .nav-link:hover,:host.theme-danger .nav-tabs .nav-link:focus{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger .nav-pills .nav-link:hover,:host.theme-danger .nav-tabs .nav-link:focus:hover{background-color:var(--danger-variant)}:host.theme-warning .nav-pills .nav-link:hover,:host.theme-warning .nav-tabs .nav-link:focus{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning .nav-pills .nav-link:hover,:host.theme-warning .nav-tabs .nav-link:focus:hover{background-color:var(--warning-variant)}:host.theme-info .nav-pills .nav-link:hover,:host.theme-info .nav-tabs .nav-link:focus{background-color:var(--info-base);color:var(--info-on)}:host.theme-info .nav-pills .nav-link:hover,:host.theme-info .nav-tabs .nav-link:focus:hover{background-color:var(--info-variant)}:host.theme-success .nav-pills .nav-link:hover,:host.theme-success .nav-tabs .nav-link:focus{background-color:var(--success-base);color:var(--success-on)}:host.theme-success .nav-pills .nav-link:hover,:host.theme-success .nav-tabs .nav-link:focus:hover{background-color:var(--success-variant)}:host.tabs-header-hiding{position:absolute;top:0;left:0;visibility:hidden;z-index:0}:host .nav-fill .nav-item{flex:1 1 auto;text-align:center}:host .nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}:host .nav-fill li>div,:host .nav-justified li>div{width:100%}:host .justify-content-start{justify-content:flex-start}:host .justify-content-end{justify-content:flex-end}:host .justify-content-center{justify-content:center}:host .nav-item{margin-bottom:-1px;white-space:nowrap;height:100%}:host .nav-item.active .nav-link{font-weight:bolder}:host .nav-link{display:block;padding:var(--space-sm) var(--space-base)}:host .nav-link:focus{text-decoration:none}:host .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem;height:100%;cursor:pointer}:host .nav-link.active:hover,:host .nav-link.active:focus{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}:host .nav-link.disabled{opacity:.3;cursor:not-allowed;border-color:transparent}:host .nav-link.disabled:hover{color:inherit}:host .nav{display:flex;padding-left:0;margin-bottom:0;list-style:none;height:100%;width:100%}:host .nav-pills .nav-link{border-radius:.25rem}:host .nav-tabs li.nav-item.active .nav-link{border-bottom:2px solid var(--main-on)}:host .nav-tabs li.nav-item.active .nav-link,:host .nav-tabs li.nav-item .nav-link:hover{background-color:initial}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tabs-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul #tabContainer [ngClass]=\"getTabsClass()\" role=\"tablist\">\n  <li #tabListItem class=\"nav-item\" *ngFor=\"let tab of tabDatas\" (click)=\"selectTab(tab)\" [class.active]=\"tab.active\" [attr.data-e2e]=\"tab.id\">\n    <div class=\"nav-link\" [class.disabled]=\"tab.disabled\" role=\"tab\">\n      <ng-container *ngIf=\"tab.headerTemplate === undefined; else customTemplate\">{{ tab.label }}</ng-container>\n      <ng-template #customTemplate><ng-container *ngTemplateOutlet=\"tab.headerTemplate\"></ng-container></ng-template>\n    </div>\n  </li>\n</ul>\n", styles: [":host{display:flex;width:100%;z-index:1}:host.theme-primary ul>li.active>div.nav-link{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary ul>li.active>div.nav-link{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight ul>li.active>div.nav-link{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger ul>li.active>div.nav-link{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning ul>li.active>div.nav-link{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info ul>li.active>div.nav-link{background-color:var(--info-base);color:var(--info-on)}:host.theme-success ul>li.active>div.nav-link{background-color:var(--success-base);color:var(--success-on)}:host.theme-primary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-primary .nav-tabs .nav-link:focus{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-primary .nav-tabs .nav-link:focus:hover{background-color:var(--primary-variant)}:host.theme-secondary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-secondary .nav-tabs .nav-link:focus{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary .nav-tabs .nav-link:hover:not(.disabled),:host.theme-secondary .nav-tabs .nav-link:focus:hover{background-color:var(--secondary-variant)}:host.theme-highlight .nav-tabs .nav-link:hover:not(.disabled),:host.theme-highlight .nav-tabs .nav-link:focus{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight .nav-tabs .nav-link:hover:not(.disabled),:host.theme-highlight .nav-tabs .nav-link:focus:hover{background-color:var(--highlight-variant)}:host.theme-danger .nav-tabs .nav-link:hover:not(.disabled),:host.theme-danger .nav-tabs .nav-link:focus{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger .nav-tabs .nav-link:hover:not(.disabled),:host.theme-danger .nav-tabs .nav-link:focus:hover{background-color:var(--danger-variant)}:host.theme-warning .nav-tabs .nav-link:hover:not(.disabled),:host.theme-warning .nav-tabs .nav-link:focus{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning .nav-tabs .nav-link:hover:not(.disabled),:host.theme-warning .nav-tabs .nav-link:focus:hover{background-color:var(--warning-variant)}:host.theme-info .nav-tabs .nav-link:hover:not(.disabled),:host.theme-info .nav-tabs .nav-link:focus{background-color:var(--info-base);color:var(--info-on)}:host.theme-info .nav-tabs .nav-link:hover:not(.disabled),:host.theme-info .nav-tabs .nav-link:focus:hover{background-color:var(--info-variant)}:host.theme-success .nav-tabs .nav-link:hover:not(.disabled),:host.theme-success .nav-tabs .nav-link:focus{background-color:var(--success-base);color:var(--success-on)}:host.theme-success .nav-tabs .nav-link:hover:not(.disabled),:host.theme-success .nav-tabs .nav-link:focus:hover{background-color:var(--success-variant)}:host.theme-primary .nav-pills .nav-link:hover,:host.theme-primary .nav-tabs .nav-link:focus{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-primary .nav-pills .nav-link:hover,:host.theme-primary .nav-tabs .nav-link:focus:hover{background-color:var(--primary-variant)}:host.theme-secondary .nav-pills .nav-link:hover,:host.theme-secondary .nav-tabs .nav-link:focus{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-secondary .nav-pills .nav-link:hover,:host.theme-secondary .nav-tabs .nav-link:focus:hover{background-color:var(--secondary-variant)}:host.theme-highlight .nav-pills .nav-link:hover,:host.theme-highlight .nav-tabs .nav-link:focus{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-highlight .nav-pills .nav-link:hover,:host.theme-highlight .nav-tabs .nav-link:focus:hover{background-color:var(--highlight-variant)}:host.theme-danger .nav-pills .nav-link:hover,:host.theme-danger .nav-tabs .nav-link:focus{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-danger .nav-pills .nav-link:hover,:host.theme-danger .nav-tabs .nav-link:focus:hover{background-color:var(--danger-variant)}:host.theme-warning .nav-pills .nav-link:hover,:host.theme-warning .nav-tabs .nav-link:focus{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-warning .nav-pills .nav-link:hover,:host.theme-warning .nav-tabs .nav-link:focus:hover{background-color:var(--warning-variant)}:host.theme-info .nav-pills .nav-link:hover,:host.theme-info .nav-tabs .nav-link:focus{background-color:var(--info-base);color:var(--info-on)}:host.theme-info .nav-pills .nav-link:hover,:host.theme-info .nav-tabs .nav-link:focus:hover{background-color:var(--info-variant)}:host.theme-success .nav-pills .nav-link:hover,:host.theme-success .nav-tabs .nav-link:focus{background-color:var(--success-base);color:var(--success-on)}:host.theme-success .nav-pills .nav-link:hover,:host.theme-success .nav-tabs .nav-link:focus:hover{background-color:var(--success-variant)}:host.tabs-header-hiding{position:absolute;top:0;left:0;visibility:hidden;z-index:0}:host .nav-fill .nav-item{flex:1 1 auto;text-align:center}:host .nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}:host .nav-fill li>div,:host .nav-justified li>div{width:100%}:host .justify-content-start{justify-content:flex-start}:host .justify-content-end{justify-content:flex-end}:host .justify-content-center{justify-content:center}:host .nav-item{margin-bottom:-1px;white-space:nowrap;height:100%}:host .nav-item.active .nav-link{font-weight:bolder}:host .nav-link{display:block;padding:var(--space-sm) var(--space-base)}:host .nav-link:focus{text-decoration:none}:host .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem;height:100%;cursor:pointer}:host .nav-link.active:hover,:host .nav-link.active:focus{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}:host .nav-link.disabled{opacity:.3;cursor:not-allowed;border-color:transparent}:host .nav-link.disabled:hover{color:inherit}:host .nav{display:flex;padding-left:0;margin-bottom:0;list-style:none;height:100%;width:100%}:host .nav-pills .nav-link{border-radius:.25rem}:host .nav-tabs li.nav-item.active .nav-link{border-bottom:2px solid var(--main-on)}:host .nav-tabs li.nav-item.active .nav-link,:host .nav-tabs li.nav-item .nav-link:hover{background-color:initial}\n"] }]
        }], ctorParameters: function () { return [{ type: TabsService }]; }, propDecorators: { tabContainer: [{
                type: ViewChild,
                args: ['tabContainer', { static: true }]
            }], tabListItems: [{
                type: ViewChildren,
                args: ['tabListItem']
            }], type: [{
                type: Input
            }], justifyClass: [{
                type: Input
            }], tabDatas: [{
                type: Input
            }], tabsSelectedEmit: [{
                type: Output
            }], paddingButton: [{
                type: HostBinding,
                args: ['style.paddingBottom']
            }] } });

class TabsScrollComponent {
    constructor(_cdr, _tabsService) {
        this._cdr = _cdr;
        this._tabsService = _tabsService;
        /**
         * Disable the left arrow
         */
        this.disableTabLeftArrow = false;
        /**
         * Disable the right arrow
         */
        this.disableTabRightArrow = false;
        /**
         * scrollLeft of container
         */
        this._containerScrollLeft = 0;
        this.componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        // init tabScroll when add/remove/update tab in header
        merge(this._tabsService.tabsContent$, this._tabsService.tabsResized$)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            if (this.tabHeader.tabListItems.length) {
                this.initTabScroll();
            }
        });
        this.initTabScroll();
    }
    // init of tabsScroll
    initTabScroll() {
        // active scroll icon
        this.showScrollIcons = this._tabsService.activateTabOverflow(this.tabHeader.tabListItems.last.nativeElement.offsetLeft, this.tabHeader.tabListItems.last.nativeElement.offsetWidth, this.tabHeader.tabListItems.first.nativeElement.offsetLeft, this.tabsContainer.nativeElement.offsetWidth);
        // run the change detection so the scroll icons
        this._cdr.detectChanges();
        const tabsContainerOffsetWidth = this.tabsContainer.nativeElement.offsetWidth;
        const tabsContainerOffsetLeft = this.tabsContainer.nativeElement.offsetLeft;
        const indexOfActiveTab = this.tabHeader.tabDatas.findIndex((x) => x.active);
        const activeTabs = this.tabHeader.tabListItems.toArray()[indexOfActiveTab]?.nativeElement;
        if (activeTabs) {
            const tabActiveOffsetLeft = activeTabs.offsetLeft;
            const tabActiveOffsetWidth = activeTabs.offsetWidth;
            // position active tab only if available
            this.tabsContainer.nativeElement.scrollLeft =
                this.repositionActiveTab(tabsContainerOffsetLeft, tabsContainerOffsetWidth, tabActiveOffsetLeft, tabActiveOffsetWidth) || this._containerScrollLeft;
            this.onScroll(this.tabsContainer.nativeElement);
        }
    }
    // reposition active tab, to make it visible on load and on tab selected
    repositionActiveTab(tabsContainerOffsetLeft, tabsContainerOffsetWidth, tabActiveOffsetLeft, tabActiveOffsetWidth) {
        // reposition active tab in case of overflow to the right
        if (tabsContainerOffsetWidth + this._containerScrollLeft < tabActiveOffsetLeft + tabActiveOffsetWidth) {
            const activeTabSetup = tabActiveOffsetLeft + tabActiveOffsetWidth;
            const tabsContainerSetup = tabsContainerOffsetLeft + tabsContainerOffsetWidth;
            return activeTabSetup - tabsContainerSetup;
            // reposition active tab in case of overflow to the left
        }
        else if (this._containerScrollLeft > tabActiveOffsetLeft - tabsContainerOffsetLeft) {
            return tabActiveOffsetLeft - tabsContainerOffsetLeft === 0 ? -this.scrollIconWidth : tabActiveOffsetLeft - tabsContainerOffsetLeft;
        }
    }
    // scroll tabContainer, depending on the side of the scroll icon
    navigateTabs(tabsContainer, direction) {
        if (!this.disableTabRightArrow && direction === 'forward') {
            tabsContainer.scrollBy({
                top: 0,
                left: this.tabsContainer.nativeElement.offsetWidth / 2,
                behavior: 'smooth',
            });
        }
        else if (!this.disableTabLeftArrow && direction === 'backward') {
            this.tabsContainer.nativeElement.scrollBy({
                top: 0,
                left: -this.tabsContainer.nativeElement.offsetWidth / 2,
                behavior: 'smooth',
            });
        }
    }
    // after scroll, display or not the icon arrow
    onScroll(element) {
        this._containerScrollLeft = element.scrollLeft;
        this.disableTabRightArrow = element.scrollLeft + element.offsetWidth >= element.scrollWidth;
        this.disableTabLeftArrow = element.scrollLeft === 0;
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsScrollComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: TabsService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TabsScrollComponent, selector: "avn-tabs-scroll", inputs: { scrollIconWidth: "scrollIconWidth", tabDatas: "tabDatas" }, queries: [{ propertyName: "tabHeader", first: true, predicate: TabsHeaderComponent, descendants: true }], viewQueries: [{ propertyName: "tabsContainer", first: true, predicate: ["tabsContainer"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"tabs-scroll-container\">\n  <avn-icon\n    *ngIf=\"showScrollIcons\"\n    icon=\"hardware:keyboard_arrow_left\"\n    class=\"tabs-arrow-left\"\n    [fontSize]=\"scrollIconWidth\"\n    [disabled]=\"disableTabLeftArrow\"\n    (click)=\"navigateTabs(tabsContainer, 'backward')\"\n  ></avn-icon>\n  <div class=\"tabs-container\" #tabsContainer (scroll)=\"onScroll($event.target)\">\n    <ng-content select=\"avn-tabs-header\"></ng-content>\n  </div>\n  <avn-icon\n    *ngIf=\"showScrollIcons\"\n    icon=\"hardware:keyboard_arrow_right\"\n    class=\"tabs-arrow-right\"\n    [fontSize]=\"scrollIconWidth\"\n    [disabled]=\"disableTabRightArrow\"\n    (click)=\"navigateTabs(tabsContainer, 'forward')\"\n  ></avn-icon>\n</div>\n", styles: ["html{scroll-behavior:smooth}:host{display:block;width:100%}:host.type-tabs .tabs-scroll-container:after{content:\"\";border-bottom:solid var(--main-on);border-bottom-width:2px;background-color:unset;opacity:.2;width:100%;height:100%;position:absolute;left:0}:host .tabs-scroll-container{display:flex;position:relative}:host avn-icon{-webkit-user-select:none;user-select:none}:host .tabs-container{display:flex;width:100%;overflow:scroll;scrollbar-width:none}:host ::-webkit-scrollbar{display:none}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsScrollComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tabs-scroll', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"tabs-scroll-container\">\n  <avn-icon\n    *ngIf=\"showScrollIcons\"\n    icon=\"hardware:keyboard_arrow_left\"\n    class=\"tabs-arrow-left\"\n    [fontSize]=\"scrollIconWidth\"\n    [disabled]=\"disableTabLeftArrow\"\n    (click)=\"navigateTabs(tabsContainer, 'backward')\"\n  ></avn-icon>\n  <div class=\"tabs-container\" #tabsContainer (scroll)=\"onScroll($event.target)\">\n    <ng-content select=\"avn-tabs-header\"></ng-content>\n  </div>\n  <avn-icon\n    *ngIf=\"showScrollIcons\"\n    icon=\"hardware:keyboard_arrow_right\"\n    class=\"tabs-arrow-right\"\n    [fontSize]=\"scrollIconWidth\"\n    [disabled]=\"disableTabRightArrow\"\n    (click)=\"navigateTabs(tabsContainer, 'forward')\"\n  ></avn-icon>\n</div>\n", styles: ["html{scroll-behavior:smooth}:host{display:block;width:100%}:host.type-tabs .tabs-scroll-container:after{content:\"\";border-bottom:solid var(--main-on);border-bottom-width:2px;background-color:unset;opacity:.2;width:100%;height:100%;position:absolute;left:0}:host .tabs-scroll-container{display:flex;position:relative}:host avn-icon{-webkit-user-select:none;user-select:none}:host .tabs-container{display:flex;width:100%;overflow:scroll;scrollbar-width:none}:host ::-webkit-scrollbar{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: TabsService }]; }, propDecorators: { tabHeader: [{
                type: ContentChild,
                args: [TabsHeaderComponent]
            }], tabsContainer: [{
                type: ViewChild,
                args: ['tabsContainer', { static: true }]
            }], scrollIconWidth: [{
                type: Input
            }], tabDatas: [{
                type: Input
            }] } });

class TabsDropdownComponent {
    constructor(_cdr, _tabsService) {
        this._cdr = _cdr;
        this._tabsService = _tabsService;
        /**
         * Emit tab selected
         */
        this.tabsSelectedEmit = new EventEmitter();
        this.componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        // init tabScroll when add/remove/update tab in header
        merge(this._tabsService.tabsContent$, this._tabsService.tabsResized$)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            if (this.tabHeader.tabListItems.length) {
                this.updateDropDown();
            }
        });
        this.updateDropDown();
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    selectTab(selectedTab) {
        if (selectedTab && !selectedTab.disabled) {
            const activeTab = this.tabDatas.find((tab) => tab.id === selectedTab.id);
            this.tabsSelectedEmit.emit(activeTab);
            this.tabDatas.forEach((element) => {
                element.active = false;
            });
            activeTab.active = true;
        }
    }
    updateDropDown() {
        const lastTabHeaderOffsetLeft = this.tabHeader.tabListItems.last.nativeElement.offsetLeft;
        const lastTabHeaderOffsetWidth = this.tabHeader.tabListItems.last.nativeElement.offsetWidth;
        const firstTabHeaderOffsetLeft = this.tabHeader.tabListItems.first.nativeElement.offsetLeft;
        const tabsContainerOffsetWidth = this.tabsContainer.nativeElement.offsetWidth;
        this.tabsHeaderOptions = this.tabDatas.map((tabs) => ({
            id: tabs.id,
            label: tabs.label,
            value: tabs.label,
            disabled: tabs.disabled,
        }));
        this.tabsActive = this.tabDatas.find((tab) => tab.active);
        this.showDropdown = this._tabsService.activateTabOverflow(lastTabHeaderOffsetLeft, lastTabHeaderOffsetWidth, firstTabHeaderOffsetLeft, tabsContainerOffsetWidth);
        this._cdr.detectChanges();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsDropdownComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: TabsService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TabsDropdownComponent, selector: "avn-tabs-dropdown", inputs: { tabDatas: "tabDatas" }, outputs: { tabsSelectedEmit: "tabsSelectedEmit" }, queries: [{ propertyName: "tabHeader", first: true, predicate: TabsHeaderComponent, descendants: true }], viewQueries: [{ propertyName: "tabsContainer", first: true, predicate: ["tabsContainer"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"\" [ngClass]=\"['tabs-dropdown-container', showDropdown ? 'show-dropdown' : 'hide-dropdown']\">\n  <avn-select [value]=\"tabsActive?.label\" (change)=\"selectTab($event)\" [options]=\"tabsHeaderOptions\"> </avn-select>\n  <div class=\"tabs-container\" #tabsContainer>\n    <ng-content select=\"avn-tabs-header\"></ng-content>\n  </div>\n</div>\n", styles: [":host{display:block}:host.type-tabs .hide-dropdown:after{content:\"\";border-bottom:solid var(--main-on);border-bottom-width:2px;background-color:unset;opacity:.2;width:100%;height:100%;position:absolute;left:0}:host .tabs-dropdown-container{position:relative;width:100%;height:38px}:host avn-select{width:100%;position:absolute;top:-999999px;opacity:0;transition:opacity .2s ease-in-out}:host .tabs-container{display:flex;width:100%;overflow:auto;position:absolute;top:0;opacity:1;transition:opacity .2s ease-in-out}:host .show-dropdown avn-select{top:0;opacity:1}:host .show-dropdown .tabs-container{top:-999999px;opacity:0;position:absolute}:host ::-webkit-scrollbar{display:none}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: SelectComponent, selector: "avn-select", inputs: ["optionsTemplate", "selectedOptionTemplate", "label", "options", "placeholder", "icon", "iconSize", "emptyPlaceholder", "value", "optionsListWidth", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "enableGroups", "optionHeight", "isMultipleSelect", "backdropEnabled"], outputs: ["change", "optionActivated", "optionListToggled"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tabs-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"\" [ngClass]=\"['tabs-dropdown-container', showDropdown ? 'show-dropdown' : 'hide-dropdown']\">\n  <avn-select [value]=\"tabsActive?.label\" (change)=\"selectTab($event)\" [options]=\"tabsHeaderOptions\"> </avn-select>\n  <div class=\"tabs-container\" #tabsContainer>\n    <ng-content select=\"avn-tabs-header\"></ng-content>\n  </div>\n</div>\n", styles: [":host{display:block}:host.type-tabs .hide-dropdown:after{content:\"\";border-bottom:solid var(--main-on);border-bottom-width:2px;background-color:unset;opacity:.2;width:100%;height:100%;position:absolute;left:0}:host .tabs-dropdown-container{position:relative;width:100%;height:38px}:host avn-select{width:100%;position:absolute;top:-999999px;opacity:0;transition:opacity .2s ease-in-out}:host .tabs-container{display:flex;width:100%;overflow:auto;position:absolute;top:0;opacity:1;transition:opacity .2s ease-in-out}:host .show-dropdown avn-select{top:0;opacity:1}:host .show-dropdown .tabs-container{top:-999999px;opacity:0;position:absolute}:host ::-webkit-scrollbar{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: TabsService }]; }, propDecorators: { tabHeader: [{
                type: ContentChild,
                args: [TabsHeaderComponent]
            }], tabsContainer: [{
                type: ViewChild,
                args: ['tabsContainer', { static: true }]
            }], tabDatas: [{
                type: Input
            }], tabsSelectedEmit: [{
                type: Output
            }] } });

class TabsHybridComponent {
    constructor(_tabsService, _cdr) {
        this._tabsService = _tabsService;
        this._cdr = _cdr;
        /**
         * Add justify style to host
         */
        this.justifyClass = 'start';
        /** Emits every time the select value changes **/
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.tabsSelectedEmit = new EventEmitter();
        /**
         * When keyboard navigation is enabled, specifies if the first option should be auto marked as
         * active *
         */
        this.autoActiveFirstOption = true;
        /** Specifies the option height **/
        this.optionHeight = 50;
        /** Specifies if the options list panel is opened **/
        this.optionsListOpened = false;
        this.visibleTab = [];
        this.hiddenTab = [];
        /** @ignore pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        merge(this._tabsService.tabsContent$, this._tabsService.tabsResized$)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            this.updateHybrid(this.tabsContainer.nativeElement.offsetWidth);
        });
        this.updateHybrid(this.tabsContainer.nativeElement.offsetWidth);
    }
    /** @ignore **/
    ngOnDestroy() {
        this.optionsListOpened = false;
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** When an option is selected in the option list **/
    onSelectOption(selectedOption) {
        if (selectedOption && !selectedOption.disabled) {
            this.selectedOption = selectedOption;
            this.optionsListOpened = false;
            this.tabsSelectedEmit.emit(this.tabHeader.tabDatas.find((tab) => tab.id === selectedOption.id));
        }
    }
    expandHiddenTab() {
        this.optionsListOpened = !this.optionsListOpened;
    }
    clickOutside() {
        this.optionsListOpened = false;
    }
    updateHybrid(tabsContainerOffsetWidth) {
        this.visibleTab = [];
        this.hiddenTab = [];
        this.tabHeader.tabListItems.toArray().forEach((tab, index) => {
            if (tabsContainerOffsetWidth - tab.nativeElement.offsetWidth >= 0 && this.hiddenTab.length === 0) {
                tabsContainerOffsetWidth -= tab.nativeElement.offsetWidth;
                this.visibleTab.push(this.tabHeader.tabDatas[index]);
                this.forceJustifyFill = false;
            }
            else if (this.tabHeader.tabDatas[index]) {
                this.hiddenTab.push(this.tabHeader.tabDatas[index]);
                this.forceJustifyFill = true;
            }
        });
        this.selectedOption = this.hiddenTab.find((option) => option.id === this.tabHeader.tabDatas.find((tab) => tab.active)?.id);
        this._cdr.detectChanges();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsHybridComponent, deps: [{ token: TabsService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TabsHybridComponent, selector: "avn-tabs-hybrid", inputs: { tabDatas: "tabDatas", avnTheme: "avnTheme", justifyClass: "justifyClass" }, outputs: { tabsSelectedEmit: "tabsSelectedEmit" }, queries: [{ propertyName: "tabHeader", first: true, predicate: TabsHeaderComponent, descendants: true }], viewQueries: [{ propertyName: "tabsContainer", first: true, predicate: ["tabsContainer"], descendants: true, static: true }, { propertyName: "hybridHeaderTabs", first: true, predicate: ["hybridHeaderTabs"], descendants: true, static: true }, { propertyName: "overlayOrigin", first: true, predicate: ["overlayOrigin"], descendants: true }], ngImport: i0, template: "<div #tabsContainer class=\"tabs-container\">\n  <avn-tabs-header\n    #hybridHeaderTabs\n    [avnTheme]=\"avnTheme\"\n    [tabDatas]=\"visibleTab\"\n    [justifyClass]=\"forceJustifyFill ? 'fill' : justifyClass\"\n    (tabsSelectedEmit)=\"onSelectOption($event)\"\n  ></avn-tabs-header>\n  <ng-content select=\"avn-tabs-header\"></ng-content>\n</div>\n<avn-icon\n  *ngIf=\"hiddenTab.length\"\n  class=\"hybrid-icon\"\n  icon=\"navigation:more_vert\"\n  [fontSize]=\"25\"\n  (click)=\"expandHiddenTab()\"\n  #overlayOrigin=\"cdkOverlayOrigin\"\n  cdkOverlayOrigin\n></avn-icon>\n\n<avn-connected-element\n  #connectedElement\n  [minWidth]=\"200\"\n  [width]=\"optionsListWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"optionsListOpened\"\n  (clickOutside)=\"clickOutside()\"\n>\n  <avn-option-list\n    *ngIf=\"optionsListOpened\"\n    #optionList\n    [options]=\"hiddenTab\"\n    [optionHeight]=\"optionHeight\"\n    [selectedOptions]=\"[selectedOption]\"\n    (optionClicked)=\"onSelectOption($event)\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n", styles: [":host{width:100%;display:flex;position:relative}:host.type-tabs:after{content:\"\";border-bottom:solid var(--main-on);border-bottom-width:2px;background-color:unset;opacity:.2;width:100%;height:100%;position:absolute;left:0}:host avn-icon{-webkit-user-select:none;user-select:none;cursor:pointer}:host avn-icon.hideIcon{display:none}:host .tabs-container{display:flex;width:100%;overflow:auto;position:relative;flex-direction:column}:host .tabs-container .nav-item{width:100%}:host .hybrid-icon-container{display:flex;align-items:center}:host avn-icon{display:flex;align-items:center;padding:0 var(--space-sm)}:host ::-webkit-scrollbar{display:none}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: OptionListComponent, selector: "avn-option-list", inputs: ["optionsTemplate", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "options", "selectionMode", "showCheckbox", "selectedOptions", "enableGroups"], outputs: ["optionClicked", "optionActivated", "selectionsChanged"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }, { kind: "component", type: TabsHeaderComponent, selector: "avn-tabs-header", inputs: ["type", "justifyClass", "tabDatas"], outputs: ["tabsSelectedEmit"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsHybridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tabs-hybrid', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #tabsContainer class=\"tabs-container\">\n  <avn-tabs-header\n    #hybridHeaderTabs\n    [avnTheme]=\"avnTheme\"\n    [tabDatas]=\"visibleTab\"\n    [justifyClass]=\"forceJustifyFill ? 'fill' : justifyClass\"\n    (tabsSelectedEmit)=\"onSelectOption($event)\"\n  ></avn-tabs-header>\n  <ng-content select=\"avn-tabs-header\"></ng-content>\n</div>\n<avn-icon\n  *ngIf=\"hiddenTab.length\"\n  class=\"hybrid-icon\"\n  icon=\"navigation:more_vert\"\n  [fontSize]=\"25\"\n  (click)=\"expandHiddenTab()\"\n  #overlayOrigin=\"cdkOverlayOrigin\"\n  cdkOverlayOrigin\n></avn-icon>\n\n<avn-connected-element\n  #connectedElement\n  [minWidth]=\"200\"\n  [width]=\"optionsListWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"optionsListOpened\"\n  (clickOutside)=\"clickOutside()\"\n>\n  <avn-option-list\n    *ngIf=\"optionsListOpened\"\n    #optionList\n    [options]=\"hiddenTab\"\n    [optionHeight]=\"optionHeight\"\n    [selectedOptions]=\"[selectedOption]\"\n    (optionClicked)=\"onSelectOption($event)\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n", styles: [":host{width:100%;display:flex;position:relative}:host.type-tabs:after{content:\"\";border-bottom:solid var(--main-on);border-bottom-width:2px;background-color:unset;opacity:.2;width:100%;height:100%;position:absolute;left:0}:host avn-icon{-webkit-user-select:none;user-select:none;cursor:pointer}:host avn-icon.hideIcon{display:none}:host .tabs-container{display:flex;width:100%;overflow:auto;position:relative;flex-direction:column}:host .tabs-container .nav-item{width:100%}:host .hybrid-icon-container{display:flex;align-items:center}:host avn-icon{display:flex;align-items:center;padding:0 var(--space-sm)}:host ::-webkit-scrollbar{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: TabsService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { tabHeader: [{
                type: ContentChild,
                args: [TabsHeaderComponent]
            }], tabsContainer: [{
                type: ViewChild,
                args: ['tabsContainer', { static: true }]
            }], hybridHeaderTabs: [{
                type: ViewChild,
                args: ['hybridHeaderTabs', { static: true }]
            }], overlayOrigin: [{
                type: ViewChild,
                args: ['overlayOrigin', { static: false }]
            }], tabDatas: [{
                type: Input
            }], avnTheme: [{
                type: Input
            }], justifyClass: [{
                type: Input
            }], tabsSelectedEmit: [{
                type: Output
            }] } });

class TabBodyComponent {
    constructor() {
        /** If tab is currently active or not */
        this.active = false;
        /** Tell if this is the first time we draw the content */
        this.firstTime = true;
    }
    get activeClass() {
        return this.active;
    }
    ngOnChanges() {
        this.render();
    }
    /** Render the content the first time the tab is active */
    render() {
        if (this.active && this.firstTime) {
            this.drawContent = this.content;
            this.firstTime = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TabBodyComponent, selector: "avn-tab-body", inputs: { content: "content", active: "active" }, host: { properties: { "class.active": "this.activeClass" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"pane\">\n  <ng-container *ngTemplateOutlet=\"drawContent\"></ng-container>\n</div>\n", styles: [":host{display:none;height:100%}:host .pane{height:100%}:host.active{display:block}\n"], dependencies: [{ kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tab-body', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pane\">\n  <ng-container *ngTemplateOutlet=\"drawContent\"></ng-container>\n</div>\n", styles: [":host{display:none;height:100%}:host .pane{height:100%}:host.active{display:block}\n"] }]
        }], propDecorators: { content: [{
                type: Input
            }], active: [{
                type: Input
            }], activeClass: [{
                type: HostBinding,
                args: ['class.active']
            }] } });

class TabsComponent {
    constructor(tabsConfig, _cdr, _tabsService) {
        this.tabsConfig = tabsConfig;
        this._cdr = _cdr;
        this._tabsService = _tabsService;
        /**
         * Type of navigation to be used for tabs. Can be one of Bootstrap defined types ('tabs' or
         * 'pills').
         */
        this.type = 'tabs';
        /**
         * Size of the scoll icon
         */
        this.scrollIconWidth = 35;
        /**
         * enables routing navigation
         */
        this.navigation = false;
        /**
         * send event when active tab has been changed
         */
        this.tabChange = new EventEmitter();
        this.componentDestroyed$ = new Subject();
        this.tabsConfig = this.tabsConfig || DEFAULT_TABS_CONFIG;
    }
    ngAfterContentInit() {
        this.initTabs();
        this.tabs.changes.pipe(takeUntil(this.componentDestroyed$)).subscribe((_) => {
            this.initTabs();
        });
        // Watch if any tab is set to be active dynamically (e.g. by route change)
        this.tabs.changes.pipe(startWith$1(this.tabs), map$1((tabs) => tabs.toArray()), tap$1((tabs) => {
            tabs.forEach((tab) => {
                tab.activeChange$.pipe(tap$1((activeTabId) => {
                    this.resetTabs(activeTabId);
                }), takeUntil(this.componentDestroyed$)).subscribe();
            });
        }), takeUntil(this.componentDestroyed$)).subscribe();
    }
    initTabs() {
        this.resetTabs();
    }
    /** Update active tab after user clicks a tab */
    selectedTab(selectedTab) {
        if (selectedTab && !selectedTab.disabled) {
            this.tabSelected = selectedTab;
            const selectedTabList = this.tabs.find((tab) => tab.id === selectedTab.id);
            this.tabChange.emit({ activeTab: selectedTabList });
            // deactivate all tabs
            this.tabs.toArray().forEach((eachTab) => {
                const istabActive = selectedTabList.id === eachTab.id;
                eachTab.active = istabActive;
            });
            this.tabDatas = this.tabs.toArray();
            this._tabsService.setTabs(this.tabs.toArray());
        }
    }
    /** Initialize tabs or reset tabs after a tab is set to be active dynamically */
    resetTabs(tabId) {
        this.tabSelected = this.tabs.find((tab) => tab.id === tabId || tab.active);
        const tabs = this.tabs.toArray();
        if (tabId) {
            tabs.forEach((tab) => {
                tab.active = tabId === tab.id;
            });
        }
        this.tabDatas = tabs;
        this._tabsService.setTabs(this.tabDatas);
    }
    resizeTabs(event) {
        this._tabsService.setTabsResized(event);
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsComponent, deps: [{ token: TABS_CONFIG, optional: true }, { token: i0.ChangeDetectorRef }, { token: TabsService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TabsComponent, selector: "avn-tabs", inputs: { justify: "justify", type: "type", scrollIconWidth: "scrollIconWidth", avnTheme: "avnTheme", navigation: "navigation" }, outputs: { tabChange: "tabChange" }, providers: [TabsService], queries: [{ propertyName: "tabs", predicate: TabComponent }], ngImport: i0, template: "<div *ngIf=\"tabDatas\" avnScroll>\n  <avn-tabs-scroll *ngIf=\"tabsConfig.tabOverflow === 'scroll'\" [class.type-tabs]=\"type === 'tabs'\" [scrollIconWidth]=\"scrollIconWidth\">\n    <avn-tabs-header\n      [avnTheme]=\"avnTheme\"\n      [type]=\"type\"\n      [justifyClass]=\"justify\"\n      [tabDatas]=\"tabDatas\"\n      (tabsSelectedEmit)=\"selectedTab($event)\"\n    ></avn-tabs-header>\n  </avn-tabs-scroll>\n\n  <avn-tabs-dropdown\n    *ngIf=\"tabsConfig.tabOverflow === 'dropdown'\"\n    [class.type-tabs]=\"type === 'tabs'\"\n    [tabDatas]=\"tabDatas\"\n    (tabsSelectedEmit)=\"selectedTab($event)\"\n  >\n    <avn-tabs-header\n      [avnTheme]=\"avnTheme\"\n      [type]=\"type\"\n      [justifyClass]=\"justify\"\n      [tabDatas]=\"tabDatas\"\n      (tabsSelectedEmit)=\"selectedTab($event)\"\n    ></avn-tabs-header>\n  </avn-tabs-dropdown>\n\n  <avn-tabs-hybrid\n    *ngIf=\"tabsConfig.tabOverflow === 'hybrid'\"\n    [class.type-tabs]=\"type === 'tabs'\"\n    [avnTheme]=\"avnTheme\"\n    [justifyClass]=\"justify\"\n    (tabsSelectedEmit)=\"selectedTab($event)\"\n  >\n    <avn-tabs-header\n      class=\"tabs-header-hiding\"\n      [avnTheme]=\"avnTheme\"\n      [type]=\"type\"\n      [tabDatas]=\"tabDatas\"\n      (tabsSelectedEmit)=\"selectedTab($event)\"\n    ></avn-tabs-header>\n  </avn-tabs-hybrid>\n</div>\n\n<div *ngIf=\"!navigation\" class=\"tab-content\" (avnResize)=\"resizeTabs($event)\" [debounceTime]=\"0\" avnScroll>\n  <avn-tab-body role=\"tabpanel\" *ngFor=\"let tab of tabs\" [content]=\"tab.content\" [active]=\"tab.active\" [hidden]=\"!tab.active\"></avn-tab-body>\n</div>\n", styles: [":host{height:100%;display:grid;grid-template-rows:min-content 1fr}:host .tab-content{display:block}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: TabsScrollComponent, selector: "avn-tabs-scroll", inputs: ["scrollIconWidth", "tabDatas"] }, { kind: "component", type: TabsHeaderComponent, selector: "avn-tabs-header", inputs: ["type", "justifyClass", "tabDatas"], outputs: ["tabsSelectedEmit"] }, { kind: "component", type: TabsDropdownComponent, selector: "avn-tabs-dropdown", inputs: ["tabDatas"], outputs: ["tabsSelectedEmit"] }, { kind: "component", type: TabsHybridComponent, selector: "avn-tabs-hybrid", inputs: ["tabDatas", "avnTheme", "justifyClass"], outputs: ["tabsSelectedEmit"] }, { kind: "component", type: TabBodyComponent, selector: "avn-tab-body", inputs: ["content", "active"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tabs', providers: [TabsService], template: "<div *ngIf=\"tabDatas\" avnScroll>\n  <avn-tabs-scroll *ngIf=\"tabsConfig.tabOverflow === 'scroll'\" [class.type-tabs]=\"type === 'tabs'\" [scrollIconWidth]=\"scrollIconWidth\">\n    <avn-tabs-header\n      [avnTheme]=\"avnTheme\"\n      [type]=\"type\"\n      [justifyClass]=\"justify\"\n      [tabDatas]=\"tabDatas\"\n      (tabsSelectedEmit)=\"selectedTab($event)\"\n    ></avn-tabs-header>\n  </avn-tabs-scroll>\n\n  <avn-tabs-dropdown\n    *ngIf=\"tabsConfig.tabOverflow === 'dropdown'\"\n    [class.type-tabs]=\"type === 'tabs'\"\n    [tabDatas]=\"tabDatas\"\n    (tabsSelectedEmit)=\"selectedTab($event)\"\n  >\n    <avn-tabs-header\n      [avnTheme]=\"avnTheme\"\n      [type]=\"type\"\n      [justifyClass]=\"justify\"\n      [tabDatas]=\"tabDatas\"\n      (tabsSelectedEmit)=\"selectedTab($event)\"\n    ></avn-tabs-header>\n  </avn-tabs-dropdown>\n\n  <avn-tabs-hybrid\n    *ngIf=\"tabsConfig.tabOverflow === 'hybrid'\"\n    [class.type-tabs]=\"type === 'tabs'\"\n    [avnTheme]=\"avnTheme\"\n    [justifyClass]=\"justify\"\n    (tabsSelectedEmit)=\"selectedTab($event)\"\n  >\n    <avn-tabs-header\n      class=\"tabs-header-hiding\"\n      [avnTheme]=\"avnTheme\"\n      [type]=\"type\"\n      [tabDatas]=\"tabDatas\"\n      (tabsSelectedEmit)=\"selectedTab($event)\"\n    ></avn-tabs-header>\n  </avn-tabs-hybrid>\n</div>\n\n<div *ngIf=\"!navigation\" class=\"tab-content\" (avnResize)=\"resizeTabs($event)\" [debounceTime]=\"0\" avnScroll>\n  <avn-tab-body role=\"tabpanel\" *ngFor=\"let tab of tabs\" [content]=\"tab.content\" [active]=\"tab.active\" [hidden]=\"!tab.active\"></avn-tab-body>\n</div>\n", styles: [":host{height:100%;display:grid;grid-template-rows:min-content 1fr}:host .tab-content{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TABS_CONFIG]
                }, {
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }, { type: TabsService }]; }, propDecorators: { tabs: [{
                type: ContentChildren,
                args: [TabComponent]
            }], justify: [{
                type: Input
            }], type: [{
                type: Input
            }], scrollIconWidth: [{
                type: Input
            }], avnTheme: [{
                type: Input
            }], navigation: [{
                type: Input
            }], tabChange: [{
                type: Output
            }] } });

class TabsModule {
    static forRoot(cfg) {
        return {
            ngModule: TabsModule,
            providers: [
                {
                    provide: TABS_CONFIG,
                    useValue: cfg ? { ...DEFAULT_TABS_CONFIG, ...cfg } : DEFAULT_TABS_CONFIG,
                },
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TabsModule, declarations: [TabsComponent,
            TabComponent,
            TabsScrollComponent,
            TabsHeaderComponent,
            TabsDropdownComponent,
            TabsHybridComponent,
            TabBodyComponent,
            LazyLoadingDirective], imports: [CommonModule, CoreModule, ScrollingModule, IconModule, SelectModule, ConnectedElementModule], exports: [TabsComponent, TabComponent, LazyLoadingDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsModule, imports: [CommonModule, CoreModule, ScrollingModule, IconModule, SelectModule, ConnectedElementModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, ScrollingModule, IconModule, SelectModule, ConnectedElementModule],
                    declarations: [
                        TabsComponent,
                        TabComponent,
                        TabsScrollComponent,
                        TabsHeaderComponent,
                        TabsDropdownComponent,
                        TabsHybridComponent,
                        TabBodyComponent,
                        LazyLoadingDirective,
                    ],
                    exports: [TabsComponent, TabComponent, LazyLoadingDirective],
                }]
        }] });

class BreadcrumbComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
    onclick() {
        this.clicked.emit();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BreadcrumbComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: BreadcrumbComponent, selector: "avn-breadcrumb", inputs: { label: "label", icon: "icon" }, outputs: { clicked: "clicked" }, host: { listeners: { "click": "onclick()" } }, ngImport: i0, template: "<div class=\"left-triangle\"></div>\n\n<div class=\"content\">\n  <avn-icon *ngIf=\"icon\" class=\"breadcrumb-icon\" [icon]=\"icon\" [fontSize]=\"10\"></avn-icon>\n  <label *ngIf=\"label\">{{ label | uppercase }}</label>\n</div>\n\n<div class=\"right-triangle\"></div>\n", styles: [":host{display:flex;flex-direction:row;align-items:center;cursor:pointer}:host>.left-triangle{width:0;height:0;border-top:10px solid transparent;border-left:5px solid transparent;border-bottom:10px solid transparent;border-top-color:var(--ribbon-breadcrumb-background);border-bottom-color:var(--ribbon-breadcrumb-background)}:host>.content{height:20px;display:flex;flex-direction:row;align-items:center;padding:0 var(--space-sm);background-color:var(--ribbon-breadcrumb-background);color:var(--ribbon-breadcrumb-on)}:host>.content avn-icon{margin-left:var(--space-xs)}:host>.content>label{margin:0;cursor:pointer;font-size:var(--text-xs);margin-left:var(--space-xs);line-height:var(--text-xs)}:host>.right-triangle{width:0;height:0;border-top:10px solid transparent;border-left:5px solid transparent;border-bottom:10px solid transparent;border-left-color:var(--ribbon-breadcrumb-background)}:host:hover .left-triangle{border-top-color:var(--ribbon-breadcrumb-variant-background);border-bottom-color:var(--ribbon-breadcrumb-variant-background)}:host:hover .right-triangle{border-left-color:var(--ribbon-breadcrumb-variant-background)}:host:hover .content{background-color:var(--ribbon-breadcrumb-variant-background);color:var(--ribbon-breadcrumb-variant-on)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "pipe", type: i1$2.UpperCasePipe, name: "uppercase" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-breadcrumb', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"left-triangle\"></div>\n\n<div class=\"content\">\n  <avn-icon *ngIf=\"icon\" class=\"breadcrumb-icon\" [icon]=\"icon\" [fontSize]=\"10\"></avn-icon>\n  <label *ngIf=\"label\">{{ label | uppercase }}</label>\n</div>\n\n<div class=\"right-triangle\"></div>\n", styles: [":host{display:flex;flex-direction:row;align-items:center;cursor:pointer}:host>.left-triangle{width:0;height:0;border-top:10px solid transparent;border-left:5px solid transparent;border-bottom:10px solid transparent;border-top-color:var(--ribbon-breadcrumb-background);border-bottom-color:var(--ribbon-breadcrumb-background)}:host>.content{height:20px;display:flex;flex-direction:row;align-items:center;padding:0 var(--space-sm);background-color:var(--ribbon-breadcrumb-background);color:var(--ribbon-breadcrumb-on)}:host>.content avn-icon{margin-left:var(--space-xs)}:host>.content>label{margin:0;cursor:pointer;font-size:var(--text-xs);margin-left:var(--space-xs);line-height:var(--text-xs)}:host>.right-triangle{width:0;height:0;border-top:10px solid transparent;border-left:5px solid transparent;border-bottom:10px solid transparent;border-left-color:var(--ribbon-breadcrumb-background)}:host:hover .left-triangle{border-top-color:var(--ribbon-breadcrumb-variant-background);border-bottom-color:var(--ribbon-breadcrumb-variant-background)}:host:hover .right-triangle{border-left-color:var(--ribbon-breadcrumb-variant-background)}:host:hover .content{background-color:var(--ribbon-breadcrumb-variant-background);color:var(--ribbon-breadcrumb-variant-on)}\n"] }]
        }], propDecorators: { label: [{
                type: Input
            }], icon: [{
                type: Input
            }], clicked: [{
                type: Output
            }], onclick: [{
                type: HostListener,
                args: ['click']
            }] } });

class BreadcrumbsComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BreadcrumbsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: BreadcrumbsComponent, selector: "avn-breadcrumbs", ngImport: i0, template: "<div #breadcrumbList class=\"breadcrumb-list\">\n  <ng-content select=\"avn-breadcrumb\"></ng-content>\n</div>\n", styles: [":host .breadcrumb-list{display:flex;flex-direction:row}:host .breadcrumb-list>::ng-deep avn-breadcrumb:first-child .left-triangle{border-top-color:transparent!important;border-bottom-color:transparent!important}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: BreadcrumbsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-breadcrumbs', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #breadcrumbList class=\"breadcrumb-list\">\n  <ng-content select=\"avn-breadcrumb\"></ng-content>\n</div>\n", styles: [":host .breadcrumb-list{display:flex;flex-direction:row}:host .breadcrumb-list>::ng-deep avn-breadcrumb:first-child .left-triangle{border-top-color:transparent!important;border-bottom-color:transparent!important}\n"] }]
        }] });

/**
 * @whatItDoes Conditionally excludes an HTML element if the current device
 * is included in the device list passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *avnHideForDevices="'handset'">...</some-element>
 *
 *     <some-element *avnHideForDevices="['tablet', 'web',
 * 'handset']">...</some-element>
 * ```
 */
class HideForDevicesDirective {
    constructor(_mediaBreakpointStore, templateRef, viewContainerRef) {
        this._mediaBreakpointStore = _mediaBreakpointStore;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.componentDestroyed$ = new Subject();
    }
    set avnHideForDevices(value) {
        const valAsArray = typeof value === 'string' ? [value] : value;
        this.devices = valAsArray;
        let exists = false;
        valAsArray.forEach((dt) => {
            if (Object.values(LayoutDeviceType).indexOf(dt) !== -1) {
                exists = true;
            }
        });
        if (!exists) {
            throw new Error(`Device Type not supported ${value}. Only ${Object.values(LayoutDeviceType).join(', ')} are supported.`);
        }
        this.updateView();
    }
    ngOnInit() {
        this._mediaBreakpointStore.breakpoint$.pipe(takeUntil(this.componentDestroyed$)).subscribe((deviceType) => {
            this.deviceType = deviceType;
            this.updateView();
        });
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    updateView() {
        if (!this.currentDeviceIsInList()) {
            if (!this.viewContainerRef.length) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            }
        }
        else {
            this.viewContainerRef.clear();
        }
    }
    currentDeviceIsInList() {
        if (!this.deviceType) {
            return true;
        }
        for (const device of this.devices) {
            if (this.deviceType === device) {
                return true;
            }
        }
        return false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: HideForDevicesDirective, deps: [{ token: MediaBreakpointStore }, { token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: HideForDevicesDirective, selector: "[avnHideForDevices]", inputs: { avnHideForDevices: "avnHideForDevices" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: HideForDevicesDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnHideForDevices]',
                }]
        }], ctorParameters: function () { return [{ type: MediaBreakpointStore }, { type: i0.TemplateRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { avnHideForDevices: [{
                type: Input
            }] } });

class NavContentDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: NavContentDirective, selector: "avnNavContent, avnNavElements, avnNavItems, avnNavHeader", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'avnNavContent, avnNavElements, avnNavItems, avnNavHeader',
                }]
        }] });

/**
 * @whatItDoes Adds a class of the current media breakpoint to the current element.
 *
 * @howToUse
 * ```
 *     <some-element avnResponsiveElement>...</some-element>
 *
 *     <some-element avnResponsiveElement="prefix-">...</some-element>
 * ```
 */
class ResponsiveElementDirective {
    /** @ignore **/
    constructor(renderer, elementRef, _mediaBreakpointStore) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this._mediaBreakpointStore = _mediaBreakpointStore;
        /** Specifies an optional prefix for the class name. **/
        this.avnResponsiveElement = '';
        /** @ignore Pattern used to close all subscriptions */
        this.componentDestroyed$ = new Subject();
    }
    /** @ignore **/
    ngOnInit() {
        this._mediaBreakpointStore.breakpoint$.pipe(takeUntil(this.componentDestroyed$)).subscribe((deviceType) => {
            if (this.currentClass) {
                this.renderer.removeClass(this.elementRef.nativeElement, this.currentClass);
            }
            this.currentClass = [this.avnResponsiveElement, 'mb-', deviceType].filter((e) => !!e).join('');
            this.renderer.addClass(this.elementRef.nativeElement, this.currentClass);
        });
    }
    /** @ignore **/
    ngOnDestroy() {
        // unsubscribe all subscriptions
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResponsiveElementDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: MediaBreakpointStore }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ResponsiveElementDirective, selector: "[avnResponsiveElement]", inputs: { avnResponsiveElement: "avnResponsiveElement" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResponsiveElementDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnResponsiveElement]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: MediaBreakpointStore }]; }, propDecorators: { avnResponsiveElement: [{
                type: Input
            }] } });

/**
 * @whatItDoes Conditionally includes an HTML element if the current device
 * is included in the device list passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *avnShowForDevices="'handset'">...</some-element>
 *
 *     <some-element *avnShowForDevices="['tablet', 'web', 'handset']">...</some-element>
 * ```
 */
class ShowForDevicesDirective {
    constructor(_mediaBreakpointStore, templateRef, viewContainerRef) {
        this._mediaBreakpointStore = _mediaBreakpointStore;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.componentDestroyed$ = new Subject();
    }
    set avnShowForDevices(value) {
        this.devices = typeof value === 'string' ? [value] : value;
        this.updateView();
    }
    ngOnInit() {
        this._mediaBreakpointStore.breakpoint$.pipe(takeUntil(this.componentDestroyed$)).subscribe((deviceType) => {
            this.deviceType = deviceType;
            this.updateView();
        });
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    updateView() {
        if (this.currentDeviceIsInList()) {
            if (!this.viewContainerRef.length) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            }
        }
        else {
            this.viewContainerRef.clear();
        }
    }
    currentDeviceIsInList() {
        for (const device of this.devices) {
            if (device === this.deviceType) {
                return true;
            }
        }
        return false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ShowForDevicesDirective, deps: [{ token: MediaBreakpointStore }, { token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ShowForDevicesDirective, selector: "[avnShowForDevices]", inputs: { avnShowForDevices: "avnShowForDevices" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ShowForDevicesDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnShowForDevices]',
                }]
        }], ctorParameters: function () { return [{ type: MediaBreakpointStore }, { type: i0.TemplateRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { avnShowForDevices: [{
                type: Input
            }] } });

/**
 * The [avnGridElement] directive uses grid-row-end and grid-column-end
 * to place content within avn-grid.
 *
 * for other usages not covered by avn-grid you can use the css-grid api.
 *
 * to use the gridElement in responsive mode and vary layouts accross different devices
 * you can define your inputs in terms of [key]: value where the key is one of the breakpoints
 * defined in LayoutDeviceType.
 *
 * when using the responsive breakpoints any omitted value will be filled by the WEB
 * WEB is required
 */
class GridElementDirective {
    constructor(elementRef, renderer, _mediaBreakpointStore) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._mediaBreakpointStore = _mediaBreakpointStore;
        /**
         * number of rows to span in the grid.
         */
        this.rowSpan = 1;
        /**
         * number of columns to span in the grid.
         */
        this.columnSpan = 1;
        this.componentDestroyed$ = new Subject();
        this.spans$ = new ReplaySubject(1);
    }
    ngOnChanges({ rowSpan, columnSpan }) {
        if (rowSpan && rowSpan.currentValue) {
            const rows = this.parseSpan(rowSpan.currentValue, 'rowSpan');
            const spans = {
                rows,
                cols: this.parseSpan(this.columnSpan),
            };
            this.spans$.next(spans);
        }
        else if (columnSpan && columnSpan.currentValue) {
            const cols = this.parseSpan(columnSpan.currentValue);
            const spans = {
                rows: this.parseSpan(this.rowSpan, 'rowSpan'),
                cols,
            };
            this.spans$.next(spans);
        }
    }
    ngAfterViewInit() {
        combineLatest([this._mediaBreakpointStore.breakpoint$, this.spans$])
            .pipe(mergeMap(([deviceType, rInfo]) => of({
            cSpan: rInfo.cols[deviceType],
            rSpan: rInfo.rows[deviceType],
        })), takeUntil(this.componentDestroyed$))
            .subscribe(({ cSpan, rSpan }) => {
            this.renderer.setStyle(this.elementRef.nativeElement, 'grid-column-end', `span ${cSpan}`);
            this.renderer.setStyle(this.elementRef.nativeElement, 'grid-row-end', `span ${rSpan}`);
        });
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    parseSpan(spanSettings, prop = 'columnSpan') {
        const resCols = {};
        if (spanSettings && typeof spanSettings === 'object') {
            // means I want to change cols in different modes
            // start with web work down.w
            if (!spanSettings[LayoutDeviceType.WEB]) {
                throw new Error(`Missing required value for ${LayoutDeviceType.WEB} in ${prop}`);
            }
            const webDefault = +spanSettings[LayoutDeviceType.WEB];
            Object.values(LayoutDeviceType).forEach((lt) => {
                resCols[lt] = spanSettings[lt] ? +spanSettings[lt] : webDefault;
            });
            return resCols;
        }
        else if (spanSettings && typeof +spanSettings === 'number') {
            const colParsedToNum = Number(spanSettings);
            Object.values(LayoutDeviceType).forEach((lBreakpoint) => {
                resCols[lBreakpoint] = colParsedToNum;
            });
            return resCols;
        }
        return undefined;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridElementDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: MediaBreakpointStore }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: GridElementDirective, selector: "[avnGridElement]", inputs: { rowSpan: "rowSpan", columnSpan: "columnSpan" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridElementDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnGridElement]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: MediaBreakpointStore }]; }, propDecorators: { rowSpan: [{
                type: Input
            }], columnSpan: [{
                type: Input
            }] } });

/**
 * the avn-grid component helps you create a grid css layout on the fly based on
 * layout breakpoints.
 *
 * to use the grid in responsive mode and vary layouts accross different devices
 * you can define your inputs in terms of [key]: value where the key is one of the breakpoints
 * defined in LayoutDeviceType.
 *
 * the grid facilitates the rendering of columns for different devices (LayoutDeviceType) and can be
 * customized by providing additional css to your avn-grid instance other than grid-gap and
 * grid-template-columns.
 *
 * the grid assumes an equal row height and column width.
 */
class GridComponent {
    constructor(_mediaBreakpointStore, renderer, elementRef) {
        this._mediaBreakpointStore = _mediaBreakpointStore;
        this.renderer = renderer;
        this.elementRef = elementRef;
        /**
         * gap between grid items.
         * Applied in px.
         * NO change detection as should be static.
         */
        this.gap = 10;
        /**
         * columns in the grid.
         */
        this.cols = 3;
        /**
         * emits when the column size changes
         */
        this.columnChanged = new EventEmitter();
        this.componentDestroyed$ = new Subject();
        this.viewInfoChanges$ = new ReplaySubject(1);
        this.cols$ = new ReplaySubject(1);
    }
    ngOnChanges({ cols, gap, gridRowHeight }) {
        if (cols && cols.currentValue) {
            const rCols = this.parseCol(cols.currentValue);
            if (rCols) {
                rCols.gap = this.gap;
                rCols.gridRowHeight = +this.gridRowHeight;
                this.cols$.next(rCols);
            }
        }
        if (gap && gap.currentValue) {
            const rCols = this.parseCol(this.cols);
            if (rCols) {
                rCols.gap = +gap.currentValue;
                rCols.gridRowHeight = +this.gridRowHeight;
                this.cols$.next(rCols);
            }
        }
        if (gridRowHeight && gridRowHeight.currentValue) {
            const rCols = this.parseCol(this.cols);
            if (rCols) {
                rCols.gap = this.gap;
                rCols.gridRowHeight = +gridRowHeight.currentValue;
                this.cols$.next(rCols);
            }
        }
    }
    ngOnInit() {
        combineLatest([this.viewInfoChanges$, this._mediaBreakpointStore.breakpoint$, this.cols$])
            .pipe(filter(([vc]) => vc.isInit), mergeMap(([vInfo, deviceType, colInfo]) => of({
            availWidth: vInfo.clientW,
            gapInfo: colInfo.gap,
            rMH: colInfo.gridRowHeight,
            cols: colInfo[deviceType],
        })), takeUntil(this.componentDestroyed$))
            .subscribe((cInfo) => {
            this.renderGridGap(cInfo.gapInfo);
            this.renderCols(cInfo);
        });
    }
    ngAfterViewInit() {
        this.resizeObserver = new ResizeObserver$1((mutations) => {
            mutations.forEach((mutation) => {
                this.viewInfoChanges$.next({
                    isInit: true,
                    clientH: mutation.contentRect.height,
                    clientW: mutation.contentRect.width,
                });
            });
        });
        this.resizeObserver.observe(this.elementRef.nativeElement);
        this.parseCol(this.cols);
        this.renderGridGap(this.gap);
        // this.gridElementsQL
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
        this.resizeObserver.disconnect();
    }
    renderCols(cInfo) {
        const inputCols = cInfo.cols;
        const computedColWidth = (cInfo.availWidth - (inputCols - 1) * Number(this.gap)) / inputCols;
        this.renderer.setStyle(this.elementRef.nativeElement, 'grid-template-columns', `repeat(${cInfo.cols}, 1fr)`);
        const gridRowMinH = cInfo.rMH ? cInfo.rMH : computedColWidth;
        this.renderer.addClass(this.elementRef.nativeElement, `cols-${inputCols}`);
        this.renderer.setStyle(this.elementRef.nativeElement, 'grid-auto-rows', `minmax(${gridRowMinH}px, auto)`);
    }
    /**
     * parse cols into a dictionary
     * adjusts to the input type of col definitions.
     */
    parseCol(colSettings) {
        const resCols = {};
        if (colSettings && typeof colSettings === 'object' && Object.keys(colSettings).length > 0) {
            // means I want to change cols in different modes
            // start with web work down.
            if (!colSettings[LayoutDeviceType.WEB]) {
                throw new Error(`Missing required value for ${LayoutDeviceType.WEB} in cols.`);
            }
            const webDefault = +colSettings[LayoutDeviceType.WEB];
            Object.values(LayoutDeviceType).forEach((lt) => {
                resCols[lt] = colSettings[lt] ? +colSettings[lt] : webDefault;
            });
            return resCols;
        }
        else if (colSettings && typeof +colSettings === 'number') {
            const colParsedToNum = Number(colSettings);
            Object.values(LayoutDeviceType).forEach((lBreakpoint) => {
                resCols[lBreakpoint] = colParsedToNum;
            });
            return resCols;
        }
        return undefined;
    }
    renderGridGap(gap) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'grid-gap', `${gap}px`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridComponent, deps: [{ token: MediaBreakpointStore }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: GridComponent, selector: "avn-grid", inputs: { gap: "gap", cols: "cols", gridRowHeight: "gridRowHeight" }, outputs: { columnChanged: "columnChanged" }, queries: [{ propertyName: "gridElementsQL", predicate: GridElementDirective }], usesOnChanges: true, ngImport: i0, template: "<ng-content> </ng-content>\n", styles: [":host{display:grid;grid-auto-flow:dense}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-grid', template: "<ng-content> </ng-content>\n", styles: [":host{display:grid;grid-auto-flow:dense}\n"] }]
        }], ctorParameters: function () { return [{ type: MediaBreakpointStore }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { gap: [{
                type: Input
            }], cols: [{
                type: Input
            }], gridRowHeight: [{
                type: Input
            }], columnChanged: [{
                type: Output
            }], gridElementsQL: [{
                type: ContentChildren,
                args: [GridElementDirective]
            }] } });

/**
 * Enum that describes all sources to trigger the opening of the menu
 */
const TriggerSourceType = {
    HAMBURGER: 'hamburger',
    SIDENAV: 'sidenav',
    RIBBON: 'ribbon',
    MAIN: 'main',
    ROUTER: 'router',
};

/**
 * the different available layout modes for the sidenav
 */
var SideNavMode;
(function (SideNavMode) {
    /**
     * Side nav is hidden off the canvas
     */
    SideNavMode["OFF_CANVAS"] = "offCanvas";
    /**
     * Side nav is collapsed and toggles to full size
     * Only available on WEB desktop devices.
     * Tablets and Handsets get off canvas mode.
     */
    SideNavMode["COLLAPSIBLE"] = "collapsible";
    /**
     * Side nav is always open with a min width
     * Only available on WEB desktop devices.
     */
    SideNavMode["STATIC"] = "static";
})(SideNavMode || (SideNavMode = {}));

/**
 * Injection token to set the settings for toasts.
 */
const LAYOUT_SETTINGS = new InjectionToken('LAYOUT_SETTINGS');
/**
 * defaults for the layout settings.
 */
const DEFAULT_LAYOUT_SETTINGS = {
    topNavSettings: {
        heightPx: 50,
    },
    ribbonSettings: {
        heightPx: 75,
        mobileRibbonSelectedFacetPlaceholder$: of('Select a facet...'),
        ribbonContentMobileDisplayMode: 'top',
        ribbonContentAlignment: 'centered',
    },
    sideNavSettings: {
        mode: SideNavMode.COLLAPSIBLE,
        autoExpandDelayMs: 500,
        autoExpandCloseDelayMs: 300,
        widthPx: 200,
        collapsedWidthPx: 50,
        openSideNavOnLoad: false,
        autoCloseOnRouteChange: true,
        stickyFooter: false,
    },
    navTabBarSettings: {
        heightPx: 50,
    },
};

/**
 * Calculates the actual layout mode to apply, based on the original layout mode requested and the current breakpoint
 */
const getLayoutModeForBreakpoint = (defaultMode, device) => {
    if (defaultMode === SideNavMode.COLLAPSIBLE &&
        [LayoutDeviceType.TABLET, LayoutDeviceType.WEB, LayoutDeviceType.HUGE, LayoutDeviceType.YUGE, LayoutDeviceType.GIGANTIC].indexOf(device) > -1) {
        return SideNavMode.COLLAPSIBLE;
    }
    if (defaultMode === SideNavMode.STATIC && [LayoutDeviceType.WEB, LayoutDeviceType.HUGE, LayoutDeviceType.YUGE, LayoutDeviceType.GIGANTIC].indexOf(device) > -1) {
        return SideNavMode.STATIC;
    }
    return SideNavMode.OFF_CANVAS;
};
/**
 * Returns the sidenav width depending on the menu state and layout mode
 */
const getVisibleSideNavWidthPx = (sideNavWidthPx, collapsedSideNavWidthPx, sidenavOpened, isTopNavDetailView, sideNavMode) => {
    if (isTopNavDetailView) {
        return 0;
    }
    if (sidenavOpened) {
        return sideNavWidthPx;
    }
    if (sideNavMode === SideNavMode.COLLAPSIBLE) {
        return collapsedSideNavWidthPx;
    }
    return 0;
};
/**
 * Returns the initial side nav offset, based on the side nav settings and layout mode requested
 */
const getInitialSideNavVisibleWidthPx = (sideNavSettings, isTopNavDetailView, sideNavMode) => {
    return getVisibleSideNavWidthPx(sideNavSettings.widthPx, sideNavSettings.collapsedWidthPx, sideNavMode !== SideNavMode.OFF_CANVAS && sideNavSettings.openSideNavOnLoad, isTopNavDetailView, sideNavMode);
};
/**
 * Returns the grid css columns and rows for the layout based on the layout components that have been provided
 */
const getLayoutGridDimensions = (sideNavMode, topNavExists, topNavDetailTitle, sideNavExists, navTabBarExists, navTabBarPosition, settings) => {
    const topNavHeight = topNavExists ? (settings.topNavSettings.heightPx ? `${settings.topNavSettings.heightPx}px` : 'max-content') : null;
    const mainHeight = '1fr';
    // topNavDetail mode, cover bottom
    const bottomTabBarHeight = topNavDetailTitle ? null : navTabBarExists && navTabBarPosition === 'bottom' ? `${settings.navTabBarSettings.heightPx}px` : null;
    const gridTemplateRows = [topNavHeight, mainHeight, bottomTabBarHeight].filter(Boolean).join(' ');
    const gridTemplateColumns = !sideNavExists ? '100%' : `${settings.sideNavSettings.widthPx}px 1fr`;
    return {
        gridTemplateRows,
        gridTemplateColumns,
    };
};
const getAvailableSpace = (topNavExists, topRibbonExists, mobileRibbonState, sideNavVisibleWidthPx, topNavDetailTitle, navTabBarExists, navTabBarPosition, settings) => {
    let top = topNavExists ? settings.topNavSettings.heightPx : 0;
    top = topRibbonExists ? top + settings.ribbonSettings.heightPx : top;
    // topnav detail mode, cover navTabBar
    let bottom = topNavDetailTitle ? 0 : navTabBarExists && navTabBarPosition === 'bottom' ? settings.navTabBarSettings.heightPx : 0;
    bottom = mobileRibbonState?.exist ? bottom + mobileRibbonState.heightPx : bottom;
    return { top, bottom, left: sideNavVisibleWidthPx || 0, right: 0 };
};
/**
 * Returns the grid css columns and rows for the layout based on the layout components that have been provided
 */
const getPageGridDimensions = (ribbonExists, mobileRibbonExists, settings) => {
    const ribbonHeight = settings.ribbonSettings.heightPx ? settings.ribbonSettings.heightPx + 'px' : 'max-content';
    const mobileRibbonHeight = mobileRibbonExists ? 'max-content' : null;
    const gridTemplateRows = !ribbonExists ? '100%' : [ribbonHeight, '1fr', mobileRibbonHeight].join(' ');
    return {
        gridTemplateRows,
        gridTemplateColumns: '100%',
    };
};

/**
 * Returns the initial layout settings, combining the layout settings passed with the default settings (some settings are optional)
 */
const getInitialLayoutSettings = (layoutSettings) => {
    return {
        ...DEFAULT_LAYOUT_SETTINGS,
        ...layoutSettings,
        topNavSettings: {
            ...DEFAULT_LAYOUT_SETTINGS.topNavSettings,
            ...(layoutSettings.topNavSettings || {}),
        },
        sideNavSettings: {
            ...DEFAULT_LAYOUT_SETTINGS.sideNavSettings,
            ...(layoutSettings.sideNavSettings || {}),
        },
        ribbonSettings: {
            ...DEFAULT_LAYOUT_SETTINGS.ribbonSettings,
            ...(layoutSettings.ribbonSettings || {}),
        },
        navTabBarSettings: {
            ...DEFAULT_LAYOUT_SETTINGS.navTabBarSettings,
            ...(layoutSettings.navTabBarSettings || {}),
        },
    };
};

const LAYOUT_INITIAL_STATE = {
    settings: DEFAULT_LAYOUT_SETTINGS,
    sideNavLayoutMode: DEFAULT_LAYOUT_SETTINGS.sideNavSettings.mode,
    topNavExists: false,
    sideNavExists: false,
    navTabBarExists: false,
    sideNavToggleVisible: false,
    sideNavOpened: false,
    sideNavOpenedTrigger: null,
    sideNavOverlayVisible: false,
    sideNavVisibleWidthPx: 0,
    currentRoute: null,
    topNavDetailTitle: null,
    topNavDetailBackIcon: true,
    topNavDetailBackRoute: null,
    navTabBarPosition: 'original',
    topRibbonExists: false,
    mobileRibbonState: { exist: false, heightPx: undefined },
};
class LayoutStore extends ComponentStore {
    get stateSnapshot() {
        return this.get();
    }
    constructor(_layoutSettings, _mediaBreakpointStore) {
        super({
            ...LAYOUT_INITIAL_STATE,
            sideNavLayoutMode: _layoutSettings.sideNavSettings?.mode,
            settings: getInitialLayoutSettings(_layoutSettings),
            sideNavVisibleWidthPx: getInitialSideNavVisibleWidthPx({
                ...DEFAULT_LAYOUT_SETTINGS.sideNavSettings,
                ...(_layoutSettings.sideNavSettings || {}),
            }, false, _layoutSettings.sideNavSettings?.mode),
        });
        this._layoutSettings = _layoutSettings;
        this._mediaBreakpointStore = _mediaBreakpointStore;
        this.fabActionClicked = new Subject();
        this.navigateToRoot = new EventEmitter();
        this.navigateToUrl = new EventEmitter();
        /********************************************************************************************************************
         * SELECTORS and GETTERS
         ********************************************************************************************************************/
        this.mode$ = this.select((state) => state.sideNavLayoutMode).pipe(distinctUntilChanged());
        this.sideNavOpened$ = this.select((state) => state.sideNavOpened);
        this.currentRoute$ = this.select((state) => state.currentRoute);
        this.layoutDimensions$ = this.select(this.select((state) => state.sideNavLayoutMode), this.select((state) => state.topNavExists), this.select((state) => state.topNavDetailTitle), this.select((state) => state.sideNavExists), this.select((state) => state.navTabBarExists), this.select((state) => state.navTabBarPosition), this.select((state) => state.settings), getLayoutGridDimensions);
        /** Get available space under layout */
        this.availableSpace$ = combineLatest([
            this.select(this.select((state) => state.topNavExists), this.select((state) => state.topRibbonExists), this.select((state) => state.mobileRibbonState), this.select((state) => state.sideNavVisibleWidthPx), this.select((state) => state.topNavDetailTitle), this.select((state) => state.navTabBarExists), this.select((state) => state.navTabBarPosition), this.select((state) => state.settings), getAvailableSpace).pipe(distinctUntilChanged((p, c) => p.top === c.top && p.bottom === c.bottom && p.left === c.left && p.right === c.right), debounceTime(200)),
            this._mediaBreakpointStore.windowSizeChanged$,
        ]).pipe(map(([position, viewPort]) => ({
            ...position,
            width: viewPort.viewportWidthPx - position.left - position.right,
            height: viewPort.viewportHeightPx - position.top - position.bottom,
        })));
        /********************************************************************************************************************
         * UPDATERS (aka. reducers)
         ********************************************************************************************************************/
        this.setTopNavExists = this.updater((state, topNavExists) => ({
            ...state,
            topNavExists,
        }));
        this.setSideNavExists = this.updater((state, sideNavExists) => ({
            ...state,
            sideNavExists,
        }));
        this.setSideNavOpened = this.updater((state, payload) => ({
            ...state,
            sideNavOpened: payload.opened,
            sideNavOpenedTrigger: payload.source,
        }));
        this.setNavTabBarExists = this.updater((state, navTabBarExists) => ({
            ...state,
            navTabBarExists,
        }));
        this.setTopRibbonExists = this.updater((state, topRibbonExists) => ({
            ...state,
            topRibbonExists,
        }));
        this.setMobileRibbonState = this.updater((state, mobileRibbonState) => ({
            ...state,
            mobileRibbonState: {
                ...mobileRibbonState,
            },
        }));
        this.setCurrentRoute = this.updater((state, { url, topNavDetailTitle, topNavDetailBackIcon }) => {
            const isDetailRouteOpened = !!topNavDetailTitle;
            const isDetailRouteAlreadyOpened = !!state.topNavDetailTitle;
            const previousRoute = state.currentRoute;
            return {
                ...state,
                currentRoute: url,
                topNavDetailTitle,
                topNavDetailBackIcon: topNavDetailBackIcon === false ? false : true,
                topNavDetailBackRoute: !isDetailRouteOpened ? null : isDetailRouteAlreadyOpened ? state.topNavDetailBackRoute : previousRoute,
            };
        });
        this.reset = this.updater((state, layoutSettings) => ({
            ...state,
            sideNavLayoutMode: layoutSettings.sideNavSettings.mode,
            settings: getInitialLayoutSettings(layoutSettings),
            sideNavOpened: layoutSettings.sideNavSettings.mode === SideNavMode.STATIC || layoutSettings.sideNavSettings?.openSideNavOnLoad,
        }));
        /********************************************************************************************************************
         * EFFECTS
         ********************************************************************************************************************/
        /** Auto update the layout mode when the media breakpoint changes **/
        this.autoUpdateLayoutMode$ = this.effect(() => 
        // make sure the state is ready since we rely on a external observable, otherwise we get a initialisation issue
        this.state$.pipe(filterNil(), take(1)).pipe(switchMap(() => this._mediaBreakpointStore.windowSizeChanged$.pipe(tap(({ breakpoint }) => {
            const state = this.get();
            const { widthPx, collapsedWidthPx } = state.settings.sideNavSettings;
            const { sideNavOpened, sideNavExists } = state;
            const adjustedLayoutMode = getLayoutModeForBreakpoint(state.settings.sideNavSettings.mode, breakpoint);
            const isTopNavDetailView = !!state.topNavDetailTitle;
            this.patchState({
                sideNavLayoutMode: adjustedLayoutMode,
                sideNavToggleVisible: adjustedLayoutMode !== SideNavMode.STATIC,
                sideNavVisibleWidthPx: sideNavExists ? getVisibleSideNavWidthPx(widthPx, collapsedWidthPx, sideNavOpened, isTopNavDetailView, adjustedLayoutMode) : 0,
            });
        })))));
        /** Auto update the visibility of the sidenav **/
        this.autoUpdateSideNavVisibility$ = this.effect(() => this.select(this.select((state) => state.sideNavExists), this.select((state) => state.sideNavOpened), this.select((state) => state.sideNavLayoutMode), this.select((state) => state.topNavDetailTitle), (sideNavExists, sideNavOpened, mode, topNavDetailTitle) => ({ sideNavExists, sideNavOpened, mode, topNavDetailTitle })).pipe(tap(({ sideNavExists, sideNavOpened, mode, topNavDetailTitle }) => {
            const sideNavOverlayVisible = sideNavExists && sideNavOpened && mode === SideNavMode.OFF_CANVAS;
            const { widthPx, collapsedWidthPx } = this.get().settings.sideNavSettings;
            const isTopNavDetailView = !!topNavDetailTitle;
            const sideNavVisibleWidthPx = sideNavExists ? getVisibleSideNavWidthPx(widthPx, collapsedWidthPx, sideNavOpened, isTopNavDetailView, mode) : null;
            this.patchState({
                sideNavOverlayVisible,
                sideNavVisibleWidthPx,
            });
        })));
        /** Auto close the menu on route change if configured **/
        this.autoCloseOnRouteChange$ = this.effect(() => this.currentRoute$.pipe(filter((route) => !!route && this.get().sideNavLayoutMode !== SideNavMode.STATIC && this.get().settings.sideNavSettings?.autoCloseOnRouteChange), tap(() => {
            this.setSideNavOpened({ opened: false, source: null });
        })));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutStore, deps: [{ token: LAYOUT_SETTINGS }, { token: MediaBreakpointStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LAYOUT_SETTINGS]
                }] }, { type: MediaBreakpointStore }]; } });

/**
 * The delicious hamburger component.
 * This is the component that lives in the layout module that is used to toggle the sidebar menu.
 * configure this component through the topnav component.
 * current implementation coupled to the menu. (pun intended)
 */
class HamburgerComponent {
    constructor(_layoutStore, _changeDetector) {
        this._layoutStore = _layoutStore;
        this._changeDetector = _changeDetector;
        this.componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this._layoutStore
            .select(this._layoutStore.select((layoutState) => layoutState.sideNavOpened), (sideNavOpened) => ({
            sideNavOpened,
        }))
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    onClick() {
        this._layoutStore.setSideNavOpened({ opened: !this.model.sideNavOpened, source: TriggerSourceType.HAMBURGER });
    }
    get opened() {
        return this.model.sideNavOpened;
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: HamburgerComponent, deps: [{ token: LayoutStore }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: HamburgerComponent, selector: "avn-hamburger", host: { listeners: { "click": "onClick()" }, properties: { "class.opened": "this.opened" } }, ngImport: i0, template: "<span #topBun></span>\n<span #cheese></span>\n<span class=\"meat\" #meat></span>\n<span #bottomBun></span>\n", styles: [":host{display:block;margin:var(--space-sm);cursor:pointer;height:40px;width:40px;min-width:40px;padding:var(--space-md) var(--space-sm);position:relative;transform:rotate(0);border-radius:25px;color:var(--topnav-on);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host:hover{background-color:var(--topnav-variant-background)}:host span{display:block;position:absolute;height:2px;width:20px;border-radius:1px;opacity:1;left:10px;background-color:var(--topnav-on);transform:rotate(0);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host span:nth-child(1){top:14px}:host span:nth-child(2),:host span:nth-child(3){top:19px}:host span:nth-child(4){top:24px}:host.opened span:nth-child(1),:host.opened span:nth-child(4){top:24px;width:0%;left:50%}:host.opened span:nth-child(2){transform:rotate(45deg)}:host.opened span:nth-child(3){transform:rotate(-45deg)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: HamburgerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-hamburger', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span #topBun></span>\n<span #cheese></span>\n<span class=\"meat\" #meat></span>\n<span #bottomBun></span>\n", styles: [":host{display:block;margin:var(--space-sm);cursor:pointer;height:40px;width:40px;min-width:40px;padding:var(--space-md) var(--space-sm);position:relative;transform:rotate(0);border-radius:25px;color:var(--topnav-on);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host:hover{background-color:var(--topnav-variant-background)}:host span{display:block;position:absolute;height:2px;width:20px;border-radius:1px;opacity:1;left:10px;background-color:var(--topnav-on);transform:rotate(0);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host span:nth-child(1){top:14px}:host span:nth-child(2),:host span:nth-child(3){top:19px}:host span:nth-child(4){top:24px}:host.opened span:nth-child(1),:host.opened span:nth-child(4){top:24px;width:0%;left:50%}:host.opened span:nth-child(2){transform:rotate(45deg)}:host.opened span:nth-child(3){transform:rotate(-45deg)}\n"] }]
        }], ctorParameters: function () { return [{ type: LayoutStore }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }], opened: [{
                type: HostBinding,
                args: ['class.opened']
            }] } });

class MainComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MainComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: MainComponent, selector: "avn-main", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{width:100%;height:100%;display:block;background-color:var(--main-background);color:var(--main-on);overflow:auto;transition:all .25s cubic-bezier(.2,1,.3,1) 0ms;position:relative}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MainComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-main', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: [":host{width:100%;height:100%;display:block;background-color:var(--main-background);color:var(--main-on);overflow:auto;transition:all .25s cubic-bezier(.2,1,.3,1) 0ms;position:relative}\n"] }]
        }] });

/**
 * The nav item component - made with ♥
 * Represents a clickable item in navigation components.
 */
class NavItemComponent {
    constructor() {
        /**
         * the type for the nav. the 'link' type is clickable and adds a background color.
         * the 'title' is text only without interaction.
         */
        this.type = 'link';
        /**
         * @ignore
         */
        this.componentDestroyed$ = new Subject();
    }
    get hasTitleClass() {
        return this.type === 'title';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: NavItemComponent, selector: "avn-nav-item", inputs: { title: "title", icon: "icon", type: "type" }, host: { properties: { "class.title": "this.hasTitleClass" } }, ngImport: i0, template: "<avn-icon *ngIf=\"icon\" [icon]=\"icon\"></avn-icon>\n<p>{{ title }}</p>\n", styles: [":host{cursor:pointer;outline:none;display:flex;padding:0 var(--space-lg);justify-content:flex-start;align-items:center;min-height:25px;background-color:var(--topnav-background);color:var(--topnav-on)}:host:focus,:host:hover{outline:none}:host:hover{background-color:var(--topnav-variant-background);color:var(--topnav-variant-on)}:host p{margin-bottom:0}:host ::ng-deep avn-icon{height:16px;width:16px;margin-right:var(--space-sm)}:host ::ng-deep avn-icon>.material-icons,:host ::ng-deep avn-icon>.fa{font-size:var(--text-md)}:host.title{cursor:auto}:host.title p{font-size:var(--text-sm);font-weight:600}:host-context(.dmb-aspect) :host{padding:var(--space-md) var(--space-sm);transition:all .2s ease;border-radius:4px;margin:0}:host-context(.dmb-aspect) :host ::ng-deep avn-icon{height:auto;width:30px;margin-right:10px}:host-context(.dmb-aspect) :host:hover{color:var(--topnav-variant-on);background-color:#ffffff19}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-nav-item', template: "<avn-icon *ngIf=\"icon\" [icon]=\"icon\"></avn-icon>\n<p>{{ title }}</p>\n", styles: [":host{cursor:pointer;outline:none;display:flex;padding:0 var(--space-lg);justify-content:flex-start;align-items:center;min-height:25px;background-color:var(--topnav-background);color:var(--topnav-on)}:host:focus,:host:hover{outline:none}:host:hover{background-color:var(--topnav-variant-background);color:var(--topnav-variant-on)}:host p{margin-bottom:0}:host ::ng-deep avn-icon{height:16px;width:16px;margin-right:var(--space-sm)}:host ::ng-deep avn-icon>.material-icons,:host ::ng-deep avn-icon>.fa{font-size:var(--text-md)}:host.title{cursor:auto}:host.title p{font-size:var(--text-sm);font-weight:600}:host-context(.dmb-aspect) :host{padding:var(--space-md) var(--space-sm);transition:all .2s ease;border-radius:4px;margin:0}:host-context(.dmb-aspect) :host ::ng-deep avn-icon{height:auto;width:30px;margin-right:10px}:host-context(.dmb-aspect) :host:hover{color:var(--topnav-variant-on);background-color:#ffffff19}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], icon: [{
                type: Input
            }], type: [{
                type: Input
            }], hasTitleClass: [{
                type: HostBinding,
                args: ['class.title']
            }] } });

class NavComponent {
    constructor(renderer, changeDetector) {
        this.renderer = renderer;
        this.changeDetector = changeDetector;
        /**
         * The minimum width of the underlying dropdown menu.
         */
        this.minWidth = 150;
        /**
         * @ignore
         */
        this.hasDropdown = false;
        /**
         * @ignore
         */
        this.isOpen = false;
        /**
         * @ignore
         */
        this.componentDestroyed$ = new Subject();
    }
    /**
     * @ignore
     */
    ngAfterViewInit() {
        if (this.nativeDomElForChildCount.nativeElement.children && this.nativeDomElForChildCount.nativeElement.children.length > 0) {
            this.hasDropdown = true;
            this.changeDetector.detectChanges();
            this.renderer.setStyle(this.nativeDomElForChildCount.nativeElement, 'minWidth', this.navTrigger.nativeElement.clientWidth);
        }
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    onDropdownToggled(opened) {
        this.isOpen = opened;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: NavComponent, selector: "avn-nav", inputs: { icon: "icon", title: "title", subTitle: "subTitle", minWidth: "minWidth" }, queries: [{ propertyName: "iconComponent", first: true, predicate: IconComponent, descendants: true }, { propertyName: "iconCountComponent", first: true, predicate: CountIconComponent, descendants: true }, { propertyName: "navItems", predicate: NavItemComponent }], viewQueries: [{ propertyName: "menuDropdown", first: true, predicate: ["navDropDown"], descendants: true, read: ElementRef }, { propertyName: "navTrigger", first: true, predicate: ["navTrigger"], descendants: true, read: ElementRef }, { propertyName: "nativeDomElForChildCount", first: true, predicate: ["nativeDomElForChildCount"], descendants: true, read: ElementRef }], ngImport: i0, template: "<div\n  #navTrigger\n  class=\"trigger\"\n  [class.menu-trigger]=\"hasDropdown\"\n  [class.is-open]=\"isOpen\"\n  [class.has-title]=\"!!title\"\n  [avnDropdownTrigger]=\"navDropDown\"\n  [avnDropdownEnabled]=\"hasDropdown\"\n  (avnDropdownOpened)=\"onDropdownToggled($event)\"\n>\n  <ng-content select=\"avn-icon\"></ng-content>\n  <ng-content select=\"avn-count-icon\"></ng-content>\n  <ng-content select=\"[avnNavHeader]\"></ng-content>\n  <div *ngIf=\"title\">\n    <p *ngIf=\"subTitle\" class=\"sub-title\">{{ subTitle }}</p>\n    <p *ngIf=\"title\" class=\"title\">{{ title }}</p>\n  </div>\n</div>\n<!-- todo add a setting for min menu width -->\n<avn-dropdown [dimensions]=\"{ bindWidthToTrigger: true, minWidth: minWidth }\" #navDropDown class=\"menu-dropdown\">\n  <div #nativeDomElForChildCount>\n    <ng-content select=\"[avnNavItems]\"></ng-content>\n  </div>\n</avn-dropdown>\n", styles: [":host{height:100%;display:flex;background-color:var(--topnav-background);color:var(--topnav-on)}:host>div{display:flex;align-items:center;padding:0 var(--space-sm);cursor:pointer;min-width:40px;justify-content:center}:host>div:hover{background-color:var(--topnav-variant-background);color:var(--topnav-variant-on)}:host>div.menu-trigger{padding:0 var(--space-base)}:host>div>div{display:flex;flex-direction:column}:host>div>div>p{margin:0}:host>div>div>p.sub-title{font-size:var(--text-sm);line-height:10px}:host>div>div>p.title{line-height:12px;font-weight:500}:host>div>p{margin:0;font-size:var(--text-base)}:host>div.has-title ::ng-deep avn-count-icon>avn-icon{margin-right:0}:host>div.has-title ::ng-deep avn-icon,:host>div.has-title avn-count-icon{margin-right:var(--space-sm)}:host-context(.dmb-aspect) :host>div{background-color:unset!important;color:unset!important}:host-context(.dmb-aspect) :host>div.menu-trigger{padding:var(--space-xs)}:host-context(.dmb-aspect) :host>div.is-open ::ng-deep avn-icon{color:var(--nav-tab-bar-selected-color)}:host-context(.dmb-aspect) :host ::ng-deep avn-icon{align-items:center;border-radius:100%;background-color:var(--topnav-variant-background);line-height:1em;width:38px;height:38px}:host-context(.dmb-aspect) :host ::ng-deep avn-icon:hover{color:var(--nav-tab-bar-selected-color)}:host-context(.dmb-aspect) :host ::ng-deep avn-count-icon>.count{margin-top:0;margin-left:calc(-1 * var(--space-xs));padding:0 2px;height:unset}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DropdownComponent, selector: "avn-dropdown", inputs: ["closeOnClick", "xPosition", "yPosition", "class", "dimensions"], outputs: ["close"] }, { kind: "directive", type: DropdownTriggerDirective, selector: "[avnDropdownTrigger]", inputs: ["avnDropdownTrigger", "avnDropdownEnabled"], outputs: ["avnDropdownOpened"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-nav', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  #navTrigger\n  class=\"trigger\"\n  [class.menu-trigger]=\"hasDropdown\"\n  [class.is-open]=\"isOpen\"\n  [class.has-title]=\"!!title\"\n  [avnDropdownTrigger]=\"navDropDown\"\n  [avnDropdownEnabled]=\"hasDropdown\"\n  (avnDropdownOpened)=\"onDropdownToggled($event)\"\n>\n  <ng-content select=\"avn-icon\"></ng-content>\n  <ng-content select=\"avn-count-icon\"></ng-content>\n  <ng-content select=\"[avnNavHeader]\"></ng-content>\n  <div *ngIf=\"title\">\n    <p *ngIf=\"subTitle\" class=\"sub-title\">{{ subTitle }}</p>\n    <p *ngIf=\"title\" class=\"title\">{{ title }}</p>\n  </div>\n</div>\n<!-- todo add a setting for min menu width -->\n<avn-dropdown [dimensions]=\"{ bindWidthToTrigger: true, minWidth: minWidth }\" #navDropDown class=\"menu-dropdown\">\n  <div #nativeDomElForChildCount>\n    <ng-content select=\"[avnNavItems]\"></ng-content>\n  </div>\n</avn-dropdown>\n", styles: [":host{height:100%;display:flex;background-color:var(--topnav-background);color:var(--topnav-on)}:host>div{display:flex;align-items:center;padding:0 var(--space-sm);cursor:pointer;min-width:40px;justify-content:center}:host>div:hover{background-color:var(--topnav-variant-background);color:var(--topnav-variant-on)}:host>div.menu-trigger{padding:0 var(--space-base)}:host>div>div{display:flex;flex-direction:column}:host>div>div>p{margin:0}:host>div>div>p.sub-title{font-size:var(--text-sm);line-height:10px}:host>div>div>p.title{line-height:12px;font-weight:500}:host>div>p{margin:0;font-size:var(--text-base)}:host>div.has-title ::ng-deep avn-count-icon>avn-icon{margin-right:0}:host>div.has-title ::ng-deep avn-icon,:host>div.has-title avn-count-icon{margin-right:var(--space-sm)}:host-context(.dmb-aspect) :host>div{background-color:unset!important;color:unset!important}:host-context(.dmb-aspect) :host>div.menu-trigger{padding:var(--space-xs)}:host-context(.dmb-aspect) :host>div.is-open ::ng-deep avn-icon{color:var(--nav-tab-bar-selected-color)}:host-context(.dmb-aspect) :host ::ng-deep avn-icon{align-items:center;border-radius:100%;background-color:var(--topnav-variant-background);line-height:1em;width:38px;height:38px}:host-context(.dmb-aspect) :host ::ng-deep avn-icon:hover{color:var(--nav-tab-bar-selected-color)}:host-context(.dmb-aspect) :host ::ng-deep avn-count-icon>.count{margin-top:0;margin-left:calc(-1 * var(--space-xs));padding:0 2px;height:unset}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { icon: [{
                type: Input
            }], title: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], minWidth: [{
                type: Input
            }], iconComponent: [{
                type: ContentChild,
                args: [IconComponent, { static: false }]
            }], iconCountComponent: [{
                type: ContentChild,
                args: [CountIconComponent, { static: false }]
            }], navItems: [{
                type: ContentChildren,
                args: [NavItemComponent]
            }], menuDropdown: [{
                type: ViewChild,
                args: ['navDropDown', { read: ElementRef, static: false }]
            }], navTrigger: [{
                type: ViewChild,
                args: ['navTrigger', { read: ElementRef, static: false }]
            }], nativeDomElForChildCount: [{
                type: ViewChild,
                args: ['nativeDomElForChildCount', { read: ElementRef, static: false }]
            }] } });

const RIBBON_INITIAL_STATE = {
    showAlternateContent: false,
    alternateContentIsEmpty: true,
    facets: [],
    actions: [],
    selectedFacet: null,
    ribbonContentPortal: null,
    isMobileBreakpoint: false,
    mobileRibbonExists: false,
    parentPageComponentExists: false,
    ribbonContentMobileDisplayMode: 'top',
};
class RibbonStore extends ComponentStore {
    constructor(_layoutSettings, _mediaBreakpointStore, _layoutStore) {
        super({ ...RIBBON_INITIAL_STATE, ribbonContentMobileDisplayMode: _layoutSettings?.ribbonSettings?.ribbonContentMobileDisplayMode });
        this._layoutSettings = _layoutSettings;
        this._mediaBreakpointStore = _mediaBreakpointStore;
        this._layoutStore = _layoutStore;
        /********************************************************************************************************************
         * SELECTORS and GETTERS
         ********************************************************************************************************************/
        this.mobileRibbonExists$ = this.select((state) => state.mobileRibbonExists);
        /********************************************************************************************************************
         * UPDATERS (aka. reducers)
         ********************************************************************************************************************/
        this.setShowAlternateContent = this.updater((state, showAlternateContent) => ({
            ...state,
            showAlternateContent,
        }));
        this.setAlternateContentIsEmpty = this.updater((state, alternateContentIsEmpty) => ({
            ...state,
            alternateContentIsEmpty,
        }));
        this.registerFacets = this.updater((state, facets) => ({
            ...state,
            facets,
        }));
        this.registerActions = this.updater((state, actions) => ({
            ...state,
            actions,
        }));
        this.registerRibbonContentPortal = this.updater((state, ribbonContentPortal) => ({
            ...state,
            ribbonContentPortal,
        }));
        this.setParentPageComponentExists = this.updater((state, parentPageComponentExists) => ({
            ...state,
            parentPageComponentExists,
        }));
        /********************************************************************************************************************
         * EFFECTS
         ********************************************************************************************************************/
        /** Auto update the layout mode when the media breakpoint changes **/
        this.autoUpdateMobileRibbon$ = this.effect(() => 
        // make sure the state is ready since we rely on a external observable, otherwise we get a initialisation issue
        this.state$.pipe(filterNil(), take(1)).pipe(switchMap(() => combineLatest([
            this._mediaBreakpointStore.breakpoint$,
            this.select((state) => state.ribbonContentPortal),
            this.select((state) => state.ribbonContentMobileDisplayMode),
            this.select((state) => state.facets),
            this.select((state) => state.actions),
            this.select((state) => state.parentPageComponentExists),
        ]).pipe(tap(([breakpoint, ribbonContentPortal, ribbonContentMobileDisplayMode, facets, actions, isWrappedInPage]) => {
            const hasContentToShow = (ribbonContentMobileDisplayMode === 'bottom' && ribbonContentPortal !== null) || facets.length > 0 || actions.length > 0;
            const isMobileBreakpoint = [LayoutDeviceType.HANDSET, LayoutDeviceType.TABLET].includes(breakpoint);
            this.patchState({
                mobileRibbonExists: isMobileBreakpoint && hasContentToShow && isWrappedInPage,
                isMobileBreakpoint,
            });
        })))));
        /** Auto update the selected ribbon facet when the facets changes **/
        this.autoUpdateSelectedFacet$ = this.effect(() => this.select((state) => state.facets).pipe(switchMap((facets) => {
            // watch active facet change
            const selectedFacet$ = combineLatest(facets.map((facet) => facet.active.pipe(map((toggled) => ({ facet, toggled })), startWith({ facet, toggled: facet.toggled })))).pipe(map((facetsToggled) => facetsToggled.find(({ toggled }) => !!toggled)?.facet));
            return selectedFacet$;
        }), tap((facet) => {
            this.patchState({
                selectedFacet: facet,
            });
        })));
        this._layoutStore.setTopRibbonExists(true);
    }
    get stateSnapshot() {
        return this.get();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this._layoutStore.setTopRibbonExists(false);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonStore, deps: [{ token: LAYOUT_SETTINGS }, { token: MediaBreakpointStore }, { token: LayoutStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LAYOUT_SETTINGS]
                }] }, { type: MediaBreakpointStore }, { type: LayoutStore }]; } });

class RibbonContentComponent {
    constructor(_ribbonStore) {
        this._ribbonStore = _ribbonStore;
    }
    ngOnInit() {
        this._ribbonStore.registerRibbonContentPortal(new DomPortal(this.domPortalContent));
    }
    /** @ignore */
    ngOnDestroy() {
        this._ribbonStore.registerRibbonContentPortal(null);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonContentComponent, deps: [{ token: RibbonStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonContentComponent, selector: "avn-ribbon-content", viewQueries: [{ propertyName: "domPortalContent", first: true, predicate: ["domPortalContent"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"portal-content\" #domPortalContent>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{display:contents}:host .portal-content{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;width:100%;height:100%}:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container{background-color:var(--form-control-on);color:var(--ribbon-on);border-color:#000}:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:not(.selected-option-template){background:var(--form-control-on)}:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:hover,:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:active,:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:focus{color:#fff;border-color:#000}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon-content', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"portal-content\" #domPortalContent>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{display:contents}:host .portal-content{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;width:100%;height:100%}:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container{background-color:var(--form-control-on);color:var(--ribbon-on);border-color:#000}:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:not(.selected-option-template){background:var(--form-control-on)}:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:hover,:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:active,:host-context(.dmb-aspect) :host ::ng-deep avn-select>.select-container:focus{color:#fff;border-color:#000}\n"] }]
        }], ctorParameters: function () { return [{ type: RibbonStore }]; }, propDecorators: { domPortalContent: [{
                type: ViewChild,
                args: ['domPortalContent', { static: true }]
            }] } });

/**
 * The ribbon component controls various aspects in a given page
 * - facets: actions that can slice or limit a list that a user is looking at
 *  i.e filters, search or quick filters
 * - actions: actions that can be applied to the current context
 *  i.e delete all, create new, import / export
 *  actions can be global or based on a selected subset of the data. In the later
 *  case we use the alternate-actions
 * - context: an indicator of what the user is currently looking at
 *  i.e devices filtered by group
 *  the context can also be used to project a dropdown to allow changing the context
 * - configuration: any configuration that can be done and persisted that affects the display of the
 * page. i.e turn select the displayed items on the dashboard
 */
class RibbonComponent {
    /**
     * Shows the alternate content
     */
    set showAlternateContent(showAlternateContent) {
        this.ribbonStore.setShowAlternateContent(showAlternateContent);
    }
    constructor(_layoutSettings, ribbonStore, _changeDetector, _renderer, _elementRef, _layoutStore) {
        this._layoutSettings = _layoutSettings;
        this.ribbonStore = ribbonStore;
        this._changeDetector = _changeDetector;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._layoutStore = _layoutStore;
        /**
         * Specifies if the fab icon should be disabled
         */
        this.fabIconDisabled = false;
        /**
         * to hide the breadcrumbs on device types.
         */
        this.breadCrumbsHideForDevices = [LayoutDeviceType.HANDSET];
        /**
         * Whether the back button should show next to the ribbon title
         */
        this.showBackButton = false;
        /**
         * Back button icon
         */
        this.backButtonIcon = 'navigation:arrow_back';
        /**
         * dispatched when the fab button is clicked.
         */
        this.fabActionClicked = new EventEmitter();
        /**
         * dispatched when the title nav item is clicked.
         */
        this.titleNavItemClicked = new EventEmitter();
        /**
         * dispatched when the back button is clicked.
         */
        this.backButtonClicked = new EventEmitter();
        this._hasTitleSubject = new BehaviorSubject(false);
        this._showBackButtonSubject = new BehaviorSubject(false);
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this.ribbonStore
            .select(this.ribbonStore.select((ribbonState) => ribbonState.showAlternateContent), this.ribbonStore.select((ribbonState) => ribbonState.alternateContentIsEmpty), this.ribbonStore.select((ribbonState) => ribbonState.facets), this.ribbonStore.select((ribbonState) => ribbonState.actions), this.ribbonStore.select((ribbonState) => ribbonState.ribbonContentPortal), this.ribbonStore.select((ribbonState) => ribbonState.isMobileBreakpoint), this.ribbonStore.select((ribbonState) => ribbonState.mobileRibbonExists), this.ribbonStore.select((ribbonState) => ribbonState.ribbonContentMobileDisplayMode), this._hasTitleSubject.asObservable(), this._showBackButtonSubject.asObservable(), (showAlternateContent, alternateContentIsEmpty, facets, actions, ribbonContentPortal, isMobileBreakpoint, mobileRibbonExists, ribbonContentMobileDisplayMode, hasTitle, showBackButton) => {
            const hasFacets = facets.length > 0;
            const hasActions = actions.length > 0;
            const hasRibbonContent = !!ribbonContentPortal;
            const showRibbonContentSeparator = !mobileRibbonExists && hasTitle && hasRibbonContent;
            const showRibbonActionsSeparator = !mobileRibbonExists && hasFacets && hasActions;
            const showRibbonFacetsSeparator = !mobileRibbonExists && hasRibbonContent && hasFacets;
            return {
                showAlternateContent,
                alternateContentIsEmpty,
                isMobileBreakpoint,
                mobileRibbonExists,
                hasFacets,
                hasActions,
                alternateContentAnimationState: showAlternateContent ? 'alternate' : 'global',
                showRibbonContentSeparator,
                showRibbonActionsSeparator,
                showRibbonFacetsSeparator,
                hasRibbonContent,
                ribbonContentMobileDisplayMode,
                showBackButton,
                hasTitle,
            };
        })
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            const noTitleToShow = !model.showBackButton && !model.hasTitle;
            const noRibbonContentToShow = !model.hasRibbonContent || (model.isMobileBreakpoint && model.ribbonContentMobileDisplayMode !== 'top');
            const noFacetsActionsToShow = model.isMobileBreakpoint || (!model.hasFacets && !model.hasActions);
            const hideTopRibbon = (!model.showAlternateContent && noTitleToShow && noRibbonContentToShow && noFacetsActionsToShow) || (model.showAlternateContent && model.alternateContentIsEmpty);
            if (hideTopRibbon) {
                this._renderer.addClass(this._elementRef.nativeElement, 'hide');
                this._layoutStore.setTopRibbonExists(false);
            }
            else {
                this._renderer.removeClass(this._elementRef.nativeElement, 'hide');
                this._layoutStore.setTopRibbonExists(true);
            }
            this._changeDetector.markForCheck();
        });
    }
    ngOnChanges({ titleNavItems, title, showBackButton }) {
        if (showBackButton) {
            this._showBackButtonSubject.next(showBackButton.currentValue);
        }
        if (titleNavItems || title) {
            const hasTitle = title?.currentValue || titleNavItems?.currentValue?.length > 0;
            this._hasTitleSubject.next(hasTitle);
            this.titleNavMenuOptions =
                this.titleNavItems?.length > 0
                    ? [
                        { value: this.title, label: this.title },
                        ...this.titleNavItems.map((e) => ({
                            value: e.id,
                            label: e.title,
                        })),
                    ].sort((a, b) => (a.label < b.label ? -1 : 1))
                    : null;
        }
    }
    get hasMobileRibbon() {
        return this.model.mobileRibbonExists;
    }
    get ribbonHeight() {
        return this._layoutSettings?.ribbonSettings?.heightPx;
    }
    getRibbonContentAlignment() {
        return this._layoutSettings.ribbonSettings.ribbonContentAlignment;
    }
    onFabClick() {
        this.fabButtonTrigger.nativeButton.nativeElement.blur();
        this.fabActionClicked.emit();
    }
    onTitleNavItemClicked(option) {
        // make sure we havent clicked on the current title
        if (option.value !== this.title) {
            this.titleNavItemClicked.emit(option.value);
        }
    }
    /** @ignore */
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonComponent, deps: [{ token: LAYOUT_SETTINGS }, { token: RibbonStore }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: LayoutStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonComponent, selector: "avn-ribbon", inputs: { title: "title", context: "context", fabIcons: "fabIcons", fabIconDisabled: "fabIconDisabled", showAlternateContent: "showAlternateContent", breadCrumbsHideForDevices: "breadCrumbsHideForDevices", titleNavItems: "titleNavItems", showBackButton: "showBackButton", backButtonIcon: "backButtonIcon" }, outputs: { fabActionClicked: "fabActionClicked", titleNavItemClicked: "titleNavItemClicked", backButtonClicked: "backButtonClicked" }, host: { properties: { "class.mobile": "this.hasMobileRibbon", "style.height.px": "this.ribbonHeight" } }, providers: [RibbonStore], queries: [{ propertyName: "ribbonContent", first: true, predicate: RibbonContentComponent, descendants: true }], viewQueries: [{ propertyName: "fabButtonTrigger", first: true, predicate: ["fabButtonToggle"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"content\">\n  <avn-icon *ngIf=\"showBackButton\" class=\"back-button\" [icon]=\"backButtonIcon\" (click)=\"backButtonClicked.emit()\"></avn-icon>\n\n  <!-- Context -->\n  <div class=\"title-area\">\n    <!-- Breadcrumbs -->\n    <ng-content *avnHideForDevices=\"breadCrumbsHideForDevices\" select=\"avn-breadcrumbs\"></ng-content>\n\n    <div class=\"context\" *ngIf=\"title || titleNavItems?.length > 0\">\n      <ng-container *ngIf=\"titleNavItems?.length > 0; else regularTitle\">\n        <avn-select\n          id=\"ribbon-title-select\"\n          [options]=\"titleNavMenuOptions\"\n          [optionsTemplate]=\"titleOptionsTemplate\"\n          [selectedOptionTemplate]=\"titleOptionsTemplate\"\n          [value]=\"title\"\n          [optionsListWidth]=\"200\"\n          [maxOptionsVisibleInViewport]=\"7\"\n          [backdropEnabled]=\"true\"\n          (change)=\"onTitleNavItemClicked($event)\"\n        >\n          <ng-template let-option=\"option\" #titleOptionsTemplate>\n            <h4 class=\"title\">{{ option?.label }}</h4>\n          </ng-template>\n        </avn-select>\n      </ng-container>\n\n      <ng-template #regularTitle>\n        <h4 class=\"title\">{{ title }}</h4>\n      </ng-template>\n    </div>\n  </div>\n\n  <div class=\"middle-content\" [class]=\"getRibbonContentAlignment()\">\n    <div class=\"separator\" *ngIf=\"model.showRibbonContentSeparator\"></div>\n    <div class=\"content\" *ngIf=\"!(model.isMobileBreakpoint && model.ribbonContentMobileDisplayMode === 'none')\">\n      <ng-content select=\"avn-ribbon-content\"></ng-content>\n    </div>\n  </div>\n\n  <!-- Actions & Facets -->\n  <ng-container *ngIf=\"!model.mobileRibbonExists\">\n    <div class=\"facets-actions\" [@standardList]=\"model.hasActions || model.hasFacets\" [style.padding-right]=\"fabIcons && (model.hasActions || model.hasFacets) ? '32px' : '0'\">\n      <ng-container *ngIf=\"model.hasActions || model.hasFacets\">\n        <div class=\"separator\" *ngIf=\"model.showRibbonFacetsSeparator\"></div>\n\n        <div class=\"facets\">\n          <ng-container *ngTemplateOutlet=\"ribbonFacetsList\"></ng-container>\n        </div>\n\n        <div class=\"separator\" *ngIf=\"model.showRibbonActionsSeparator\"></div>\n\n        <ng-container *ngTemplateOutlet=\"ribbonActionsList\" class=\"actions\"></ng-container>\n      </ng-container>\n    </div>\n  </ng-container>\n\n  <!-- Alternate Content -->\n  <div class=\"alternate\" [@alternateState]=\"model.alternateContentAnimationState\">\n    <ng-content select=\"avn-ribbon-alternate-content\"></ng-content>\n  </div>\n</div>\n\n<!-- Templates -->\n\n<ng-template #ribbonFacetsList>\n  <ng-content select=\"avn-ribbon-facets\"></ng-content>\n</ng-template>\n\n<ng-template #ribbonActionsList>\n  <ng-content select=\"avn-ribbon-actions\"></ng-content>\n</ng-template>\n\n<!-- Fab Button -->\n<avn-fab-speed-dial *ngIf=\"fabIcons && !model.showAlternateContent\" direction=\"left\">\n  <avn-button #fabButtonToggle avnFabToggle [icon]=\"fabIcons\" [disabled]=\"fabIconDisabled\" (click)=\"onFabClick()\"></avn-button>\n</avn-fab-speed-dial>\n", styles: [":host{z-index:999;display:grid;position:relative;padding-right:var(--space-md);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms;background-color:var(--ribbon-background);color:var(--ribbon-on);border-bottom:1px solid var(--ribbon-border)}:host.hide{display:none}:host>.content{width:100%;height:inherit;overflow:hidden;display:flex;justify-content:flex-start;align-items:center;position:relative}:host>.content avn-icon.back-button{padding:0 0 0 var(--space-base)}:host>.content div.title-area:not(:empty){display:flex;flex-direction:column;align-items:flex-start;justify-content:center;color:inherit;padding:0 0 0 var(--space-base);transition:padding-left .6s cubic-bezier(.25,.8,.25,1)}:host>.content div.title-area:not(:empty)>div:first-child{align-items:center}:host>.content div.title-area:not(:empty)>div:nth-child(2){margin-top:var(--space-xs)}:host>.content div.title-area:not(:empty) h4{margin:0 0 0 var(--space-sm);font-size:var(--text-lg);font-weight:400}:host>.content div.context{display:flex;flex-direction:row;justify-content:flex-start;flex-grow:inherit}:host>.content div.context ::ng-deep #ribbon-title-select{border:0;background:none;padding:0}:host>.content div.middle-content{display:flex;height:100%;justify-content:space-between;align-items:center;position:relative}:host>.content div.middle-content.centered{flex-grow:2}:host>.content div.middle-content>.content{display:flex;flex-grow:1;margin:0 var(--space-md)}:host>.content div.facets-actions{height:100%;display:flex;justify-content:flex-start;align-items:center;position:relative}:host>.content div.facets-actions div.facets{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;height:100%;color:inherit;overflow:hidden}:host>.content div.facets-actions .dropdown{height:100%;padding:var(--space-sm)}:host>.content .separator{height:50%;border-right:1px solid;border-right-color:var(--ribbon-on);margin:0 var(--space-base)}:host>.content .alternate{position:absolute;inset:0;z-index:1000}:host avn-fab-speed-dial{position:absolute;display:block;bottom:-15px;right:20px}h4.title{white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: FabToggleDirective, selector: "avn-button[avnFabToggle]" }, { kind: "component", type: FabSpeedDialComponent, selector: "avn-fab-speed-dial", inputs: ["actionsOverlayPositions"] }, { kind: "component", type: SelectComponent, selector: "avn-select", inputs: ["optionsTemplate", "selectedOptionTemplate", "label", "options", "placeholder", "icon", "iconSize", "emptyPlaceholder", "value", "optionsListWidth", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "enableGroups", "optionHeight", "isMultipleSelect", "backdropEnabled"], outputs: ["change", "optionActivated", "optionListToggled"] }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "directive", type: HideForDevicesDirective, selector: "[avnHideForDevices]", inputs: ["avnHideForDevices"] }], animations: [
            trigger('alternateState', [
                state('global', style({
                    display: 'none',
                    opacity: 0,
                })),
                state('alternate', style({
                    display: 'block',
                    opacity: 1,
                })),
                transition('global => alternate', animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
                transition('alternate => global', animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
            ]),
            trigger('standardList', [
                transition('* <=> *', [
                    query(':enter', [
                        style({ opacity: 0, transform: 'translateY(-15px)' }),
                        stagger('100ms', animate('300ms cubic-bezier(.8,-0.6,0.2,1.5)', style({ opacity: 1, transform: 'translateY(0px)' }))),
                    ], { optional: true }),
                    query(':leave', animate('300ms cubic-bezier(.8,-0.1,0.2,1.5)', style({ transform: 'scale(0)' })), { optional: true }),
                ]),
            ]),
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon', changeDetection: ChangeDetectionStrategy.OnPush, providers: [RibbonStore], animations: [
                        trigger('alternateState', [
                            state('global', style({
                                display: 'none',
                                opacity: 0,
                            })),
                            state('alternate', style({
                                display: 'block',
                                opacity: 1,
                            })),
                            transition('global => alternate', animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
                            transition('alternate => global', animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
                        ]),
                        trigger('standardList', [
                            transition('* <=> *', [
                                query(':enter', [
                                    style({ opacity: 0, transform: 'translateY(-15px)' }),
                                    stagger('100ms', animate('300ms cubic-bezier(.8,-0.6,0.2,1.5)', style({ opacity: 1, transform: 'translateY(0px)' }))),
                                ], { optional: true }),
                                query(':leave', animate('300ms cubic-bezier(.8,-0.1,0.2,1.5)', style({ transform: 'scale(0)' })), { optional: true }),
                            ]),
                        ]),
                    ], template: "<div class=\"content\">\n  <avn-icon *ngIf=\"showBackButton\" class=\"back-button\" [icon]=\"backButtonIcon\" (click)=\"backButtonClicked.emit()\"></avn-icon>\n\n  <!-- Context -->\n  <div class=\"title-area\">\n    <!-- Breadcrumbs -->\n    <ng-content *avnHideForDevices=\"breadCrumbsHideForDevices\" select=\"avn-breadcrumbs\"></ng-content>\n\n    <div class=\"context\" *ngIf=\"title || titleNavItems?.length > 0\">\n      <ng-container *ngIf=\"titleNavItems?.length > 0; else regularTitle\">\n        <avn-select\n          id=\"ribbon-title-select\"\n          [options]=\"titleNavMenuOptions\"\n          [optionsTemplate]=\"titleOptionsTemplate\"\n          [selectedOptionTemplate]=\"titleOptionsTemplate\"\n          [value]=\"title\"\n          [optionsListWidth]=\"200\"\n          [maxOptionsVisibleInViewport]=\"7\"\n          [backdropEnabled]=\"true\"\n          (change)=\"onTitleNavItemClicked($event)\"\n        >\n          <ng-template let-option=\"option\" #titleOptionsTemplate>\n            <h4 class=\"title\">{{ option?.label }}</h4>\n          </ng-template>\n        </avn-select>\n      </ng-container>\n\n      <ng-template #regularTitle>\n        <h4 class=\"title\">{{ title }}</h4>\n      </ng-template>\n    </div>\n  </div>\n\n  <div class=\"middle-content\" [class]=\"getRibbonContentAlignment()\">\n    <div class=\"separator\" *ngIf=\"model.showRibbonContentSeparator\"></div>\n    <div class=\"content\" *ngIf=\"!(model.isMobileBreakpoint && model.ribbonContentMobileDisplayMode === 'none')\">\n      <ng-content select=\"avn-ribbon-content\"></ng-content>\n    </div>\n  </div>\n\n  <!-- Actions & Facets -->\n  <ng-container *ngIf=\"!model.mobileRibbonExists\">\n    <div class=\"facets-actions\" [@standardList]=\"model.hasActions || model.hasFacets\" [style.padding-right]=\"fabIcons && (model.hasActions || model.hasFacets) ? '32px' : '0'\">\n      <ng-container *ngIf=\"model.hasActions || model.hasFacets\">\n        <div class=\"separator\" *ngIf=\"model.showRibbonFacetsSeparator\"></div>\n\n        <div class=\"facets\">\n          <ng-container *ngTemplateOutlet=\"ribbonFacetsList\"></ng-container>\n        </div>\n\n        <div class=\"separator\" *ngIf=\"model.showRibbonActionsSeparator\"></div>\n\n        <ng-container *ngTemplateOutlet=\"ribbonActionsList\" class=\"actions\"></ng-container>\n      </ng-container>\n    </div>\n  </ng-container>\n\n  <!-- Alternate Content -->\n  <div class=\"alternate\" [@alternateState]=\"model.alternateContentAnimationState\">\n    <ng-content select=\"avn-ribbon-alternate-content\"></ng-content>\n  </div>\n</div>\n\n<!-- Templates -->\n\n<ng-template #ribbonFacetsList>\n  <ng-content select=\"avn-ribbon-facets\"></ng-content>\n</ng-template>\n\n<ng-template #ribbonActionsList>\n  <ng-content select=\"avn-ribbon-actions\"></ng-content>\n</ng-template>\n\n<!-- Fab Button -->\n<avn-fab-speed-dial *ngIf=\"fabIcons && !model.showAlternateContent\" direction=\"left\">\n  <avn-button #fabButtonToggle avnFabToggle [icon]=\"fabIcons\" [disabled]=\"fabIconDisabled\" (click)=\"onFabClick()\"></avn-button>\n</avn-fab-speed-dial>\n", styles: [":host{z-index:999;display:grid;position:relative;padding-right:var(--space-md);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms;background-color:var(--ribbon-background);color:var(--ribbon-on);border-bottom:1px solid var(--ribbon-border)}:host.hide{display:none}:host>.content{width:100%;height:inherit;overflow:hidden;display:flex;justify-content:flex-start;align-items:center;position:relative}:host>.content avn-icon.back-button{padding:0 0 0 var(--space-base)}:host>.content div.title-area:not(:empty){display:flex;flex-direction:column;align-items:flex-start;justify-content:center;color:inherit;padding:0 0 0 var(--space-base);transition:padding-left .6s cubic-bezier(.25,.8,.25,1)}:host>.content div.title-area:not(:empty)>div:first-child{align-items:center}:host>.content div.title-area:not(:empty)>div:nth-child(2){margin-top:var(--space-xs)}:host>.content div.title-area:not(:empty) h4{margin:0 0 0 var(--space-sm);font-size:var(--text-lg);font-weight:400}:host>.content div.context{display:flex;flex-direction:row;justify-content:flex-start;flex-grow:inherit}:host>.content div.context ::ng-deep #ribbon-title-select{border:0;background:none;padding:0}:host>.content div.middle-content{display:flex;height:100%;justify-content:space-between;align-items:center;position:relative}:host>.content div.middle-content.centered{flex-grow:2}:host>.content div.middle-content>.content{display:flex;flex-grow:1;margin:0 var(--space-md)}:host>.content div.facets-actions{height:100%;display:flex;justify-content:flex-start;align-items:center;position:relative}:host>.content div.facets-actions div.facets{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;height:100%;color:inherit;overflow:hidden}:host>.content div.facets-actions .dropdown{height:100%;padding:var(--space-sm)}:host>.content .separator{height:50%;border-right:1px solid;border-right-color:var(--ribbon-on);margin:0 var(--space-base)}:host>.content .alternate{position:absolute;inset:0;z-index:1000}:host avn-fab-speed-dial{position:absolute;display:block;bottom:-15px;right:20px}h4.title{white-space:nowrap}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LAYOUT_SETTINGS]
                }] }, { type: RibbonStore }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: LayoutStore }]; }, propDecorators: { fabButtonTrigger: [{
                type: ViewChild,
                args: ['fabButtonToggle', { static: false }]
            }], title: [{
                type: Input
            }], context: [{
                type: Input
            }], fabIcons: [{
                type: Input
            }], fabIconDisabled: [{
                type: Input
            }], showAlternateContent: [{
                type: Input
            }], breadCrumbsHideForDevices: [{
                type: Input
            }], titleNavItems: [{
                type: Input
            }], showBackButton: [{
                type: Input
            }], backButtonIcon: [{
                type: Input
            }], fabActionClicked: [{
                type: Output
            }], titleNavItemClicked: [{
                type: Output
            }], backButtonClicked: [{
                type: Output
            }], ribbonContent: [{
                type: ContentChild,
                args: [RibbonContentComponent, { descendants: true }]
            }], hasMobileRibbon: [{
                type: HostBinding,
                args: ['class.mobile']
            }], ribbonHeight: [{
                type: HostBinding,
                args: ['style.height.px']
            }] } });

class RibbonFacetsBottomSheetComponent {
    constructor(dialogRef, dialogConfig) {
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this.actioned = new EventEmitter();
        this.cancelled = new EventEmitter();
    }
    ngOnInit() {
        this.facetsOptions = this.dialogConfig.data.facets.map((facet) => ({
            value: facet.id || facet.title,
            label: facet.title,
            data: facet,
        }));
        this.dialogConfig.data.mobileRibbonExists$
            .pipe(filter((v) => !v), take(1), takeUntil(this.dialogRef.afterClosed))
            .subscribe(() => {
            this.onCancel();
        });
    }
    canClose() {
        return true;
    }
    onCancel() {
        this.cancelled.emit();
        this.dialogRef.close();
    }
    onAction(facet) {
        this.actioned.emit(facet);
        this.dialogRef.close();
    }
    selectedCard(facetsOptions) {
        return facetsOptions.filter((facet) => facet.data.toggled);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonFacetsBottomSheetComponent, deps: [{ token: ModalRef }, { token: MODAL_CONFIG }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonFacetsBottomSheetComponent, selector: "avn-ribbon-facets-bottom-sheet", ngImport: i0, template: "<avn-bottom-sheet-container (closed)=\"onCancel()\">\n  <avn-option-list\n    [virtualization]=\"false\"\n    [optionsTemplate]=\"optionsTemplate\"\n    [options]=\"facetsOptions\"\n    (optionClicked)=\"onAction($event.data)\"\n    [selectedOptions]=\"facetsOptions | applyFunction: selectedCard\"\n  >\n    <ng-template #optionsTemplate let-option=\"option\">\n      <div class=\"facet-option\" *ngIf=\"option?.data\">\n        <avn-icon *ngIf=\"option.data.icon\" [icon]=\"option.data.icon\"></avn-icon>\n        <span class=\"title\">{{ option.data.title }}</span>\n        <ng-container *ngIf=\"option.data?.count as count\">\n          <span class=\"badge-count\" [avnBackground]=\"{ cssProp: '--' + option.data?.countTheme + '-base', shade: 500 }\">{{ count }}</span>\n        </ng-container>\n      </div>\n    </ng-template>\n  </avn-option-list>\n</avn-bottom-sheet-container>\n", styles: [":host avn-option-list{--selection-component-background: transparent;--selection-component-on: var(--modal-on)}.facet-option{display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-base);align-items:center}.facet-option .badge-count{padding:0 var(--space-sm);font-size:var(--text-sm);border-radius:3px}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: BackgroundDirective, selector: "[avnBackground]", inputs: ["avnBackground"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: BottomSheetContainerComponent, selector: "avn-bottom-sheet-container", outputs: ["closed"] }, { kind: "component", type: OptionListComponent, selector: "avn-option-list", inputs: ["optionsTemplate", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "options", "selectionMode", "showCheckbox", "selectedOptions", "enableGroups"], outputs: ["optionClicked", "optionActivated", "selectionsChanged"] }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonFacetsBottomSheetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon-facets-bottom-sheet', changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-bottom-sheet-container (closed)=\"onCancel()\">\n  <avn-option-list\n    [virtualization]=\"false\"\n    [optionsTemplate]=\"optionsTemplate\"\n    [options]=\"facetsOptions\"\n    (optionClicked)=\"onAction($event.data)\"\n    [selectedOptions]=\"facetsOptions | applyFunction: selectedCard\"\n  >\n    <ng-template #optionsTemplate let-option=\"option\">\n      <div class=\"facet-option\" *ngIf=\"option?.data\">\n        <avn-icon *ngIf=\"option.data.icon\" [icon]=\"option.data.icon\"></avn-icon>\n        <span class=\"title\">{{ option.data.title }}</span>\n        <ng-container *ngIf=\"option.data?.count as count\">\n          <span class=\"badge-count\" [avnBackground]=\"{ cssProp: '--' + option.data?.countTheme + '-base', shade: 500 }\">{{ count }}</span>\n        </ng-container>\n      </div>\n    </ng-template>\n  </avn-option-list>\n</avn-bottom-sheet-container>\n", styles: [":host avn-option-list{--selection-component-background: transparent;--selection-component-on: var(--modal-on)}.facet-option{display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-base);align-items:center}.facet-option .badge-count{padding:0 var(--space-sm);font-size:var(--text-sm);border-radius:3px}\n"] }]
        }], ctorParameters: function () { return [{ type: ModalRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONFIG]
                }] }]; } });

class RibbonMobileComponent {
    constructor(_layoutSettings, _changeDetector, _modalService, _elementRef, layoutStore) {
        this._layoutSettings = _layoutSettings;
        this._changeDetector = _changeDetector;
        this._modalService = _modalService;
        this._elementRef = _elementRef;
        this.layoutStore = layoutStore;
        this._componentDestroyed$ = new Subject();
        this.selectedFacetPlaceholder$ =
            this._layoutSettings.ribbonSettings?.mobileRibbonSelectedFacetPlaceholder$ || DEFAULT_LAYOUT_SETTINGS.ribbonSettings.mobileRibbonSelectedFacetPlaceholder$;
    }
    ngOnInit() {
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        if (this.ribbonStore) {
            this.ribbonStore
                .select(this.ribbonStore.select((ribbonState) => ribbonState.showAlternateContent), this.ribbonStore.select((ribbonState) => ribbonState.facets), this.ribbonStore.select((ribbonState) => ribbonState.selectedFacet), this.ribbonStore.select((ribbonState) => ribbonState.actions), this.ribbonStore.select((ribbonState) => ribbonState.ribbonContentPortal), this.ribbonStore.select((ribbonState) => ribbonState.ribbonContentMobileDisplayMode), (showAlternateContent, facets, selectedFacet, actions, ribbonContentPortal, ribbonContentMobileDisplayMode) => ({
                showAlternateContent,
                facets,
                hasFacets: facets.length > 0,
                selectedFacet,
                actions,
                ribbonContentPortal,
                ribbonContentMobileDisplayMode,
                hasActions: actions.length > 0,
                alternateContentAnimationState: showAlternateContent ? 'alternate' : 'global',
            }))
                .pipe(takeUntil(this._componentDestroyed$))
                .subscribe((model) => {
                this.model = model;
                this._changeDetector.markForCheck();
            });
        }
        this.layoutStore.setMobileRibbonState({ exist: true, heightPx: 0 });
    }
    ngAfterViewInit() {
        const heightPx = this._elementRef.nativeElement.offsetHeight;
        this.layoutStore.setMobileRibbonState({ exist: true, heightPx });
    }
    toSelectOptionFn(facet) {
        return {
            value: facet.id || facet.title,
            label: facet.title,
            data: facet,
        };
    }
    selectedCard(cards) {
        const selectedCard = cards.find((card) => card.toggled);
        return selectedCard ? [selectedCard] : [];
    }
    onCardClick(card) {
        card.dispatchClick();
    }
    openFacetsBottomSheet() {
        const dialogConfig = {
            showCloseIcon: true,
            closeOnBackdropClick: true,
            data: {
                facets: this.ribbonStore.stateSnapshot.facets,
                mobileRibbonExists$: this.ribbonStore.mobileRibbonExists$,
            },
        };
        const modalRef = this._modalService.openBottomSheet(RibbonFacetsBottomSheetComponent, dialogConfig);
        modalRef.componentInstance.actioned.pipe(takeUntil(modalRef.afterClosed)).subscribe((card) => {
            this.onCardClick(card);
            this._changeDetector.markForCheck();
        });
    }
    /** @ignore */
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
        this.layoutStore.setMobileRibbonState({ exist: false, heightPx: undefined });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonMobileComponent, deps: [{ token: LAYOUT_SETTINGS }, { token: i0.ChangeDetectorRef }, { token: ModalService }, { token: i0.ElementRef }, { token: LayoutStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonMobileComponent, selector: "avn-ribbon-mobile", inputs: { ribbonStore: "ribbonStore" }, ngImport: i0, template: "<ng-container *ngIf=\"model\">\n  <div class=\"ribbon-content-wrapper\" *ngIf=\"model.ribbonContentPortal && model.ribbonContentMobileDisplayMode === 'bottom'\">\n    <div [cdkPortalOutlet]=\"model.ribbonContentPortal\"></div>\n  </div>\n\n  <div class=\"facet-actions-wrapper\" *ngIf=\"model.hasFacets || model.hasActions\">\n    <!--  Facets-->\n    <ng-container *ngIf=\"model.hasFacets; else noFacets\">\n      <div class=\"facet-toggle-button\" role=\"button\" (click)=\"openFacetsBottomSheet()\" [avnBackground]=\"{ cssProp: '--ribbon-variant-background', shade: 500, hoverShade: 700 }\">\n        <ng-container *ngIf=\"model.selectedFacet as selectedFacet\">\n          <avn-icon *ngIf=\"selectedFacet.icon\" [icon]=\"selectedFacet.icon\"></avn-icon>\n          <span>{{ selectedFacet.title }}</span>\n          <span *ngIf=\"selectedFacet.count as count\" class=\"badge-count\" [avnBackground]=\"{ cssProp: '--' + selectedFacet?.countTheme + '-base', shade: 500 }\">{{ count }}</span>\n        </ng-container>\n        <span *ngIf=\"!model.selectedFacet\" style=\"opacity: 0.7\">{{ selectedFacetPlaceholder$ | async }}</span>\n\n        <avn-icon class=\"toggle\" [icon]=\"'navigation:expand_less'\" [fontSize]=\"18\"></avn-icon>\n      </div>\n    </ng-container>\n\n    <ng-template #noFacets>\n      <div></div>\n    </ng-template>\n\n    <!--  Actions -->\n    <avn-fab-speed-dial #fabSpeedDial direction=\"left\" *ngIf=\"model.hasActions\">\n      <avn-button avnFabToggle *ngIf=\"fabSpeedDial.opened\" class=\"close-actions opened\" [icon]=\"'content:add'\"></avn-button>\n      <avn-button avnFabToggle *ngIf=\"!fabSpeedDial.opened\" class=\"close-actions closed\" [icon]=\"'navigation:more_horiz'\"></avn-button>\n      <!--  <avn-button avnFabToggle *ngIf=\"!fabSpeedDial.opened\" class=\"close-actions closed\" [icon]=\"'navigation:expand_less'\"></avn-button>-->\n      <avn-button\n        *ngFor=\"let action of model.actions\"\n        avnFabButton\n        class=\"fab-button\"\n        [icon]=\"action.icon\"\n        [label]=\"action.title\"\n        [iconTheme]=\"action.iconTheme\"\n        (click)=\"onCardClick(action)\"\n      ></avn-button>\n    </avn-fab-speed-dial>\n  </div>\n</ng-container>\n", styles: [":host{display:flex;flex-direction:column}:host .ribbon-content-wrapper{background-color:var(--ribbon-mobile-background);color:var(--ribbon-on);padding:var(--space-sm) var(--space-base);border-top:1px solid var(--ribbon-mobile-border);width:100%;height:auto}:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container{background-color:var(--form-control-on);color:var(--ribbon-on);border-color:#000}:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:not(.selected-option-template){background:var(--form-control-on)}:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:hover,:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:active,:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:focus{color:#fff;border-color:#000}:host .facet-actions-wrapper{background-color:var(--ribbon-mobile-background);color:var(--ribbon-on);padding:var(--space-sm) var(--space-base);border-top:1px solid var(--ribbon-mobile-border);width:100%;height:auto;display:flex;justify-content:space-between;align-items:center;-webkit-user-select:none;user-select:none;transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host .facet-actions-wrapper .facet-toggle-button{padding:var(--space-md);display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-base);align-items:center;border-radius:3px;cursor:pointer}:host .facet-actions-wrapper .facet-toggle-button .badge-count{padding:0 var(--space-sm);font-size:var(--text-sm);border-radius:3px}:host .facet-actions-wrapper .facet-toggle-button avn-icon.toggle{opacity:.6}:host .facet-actions-wrapper ::ng-deep .close-actions.opened avn-icon i{animation:rotate-right .3s cubic-bezier(0,0,.2,1);transform:rotate(45deg)}:host .facet-actions-wrapper ::ng-deep .close-actions.closed avn-icon i{animation:rotate-left .3s cubic-bezier(0,0,.2,1)}@keyframes rotate-right{0%{transform:rotate(0)}to{transform:rotate(45deg)}}@keyframes rotate-left{0%{transform:rotate(45deg)}to{transform:rotate(0)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: BackgroundDirective, selector: "[avnBackground]", inputs: ["avnBackground"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: FabToggleDirective, selector: "avn-button[avnFabToggle]" }, { kind: "directive", type: FabButtonDirective, selector: "avn-button[avnFabButton]" }, { kind: "component", type: FabSpeedDialComponent, selector: "avn-fab-speed-dial", inputs: ["actionsOverlayPositions"] }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "directive", type: i2$1.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonMobileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon-mobile', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"model\">\n  <div class=\"ribbon-content-wrapper\" *ngIf=\"model.ribbonContentPortal && model.ribbonContentMobileDisplayMode === 'bottom'\">\n    <div [cdkPortalOutlet]=\"model.ribbonContentPortal\"></div>\n  </div>\n\n  <div class=\"facet-actions-wrapper\" *ngIf=\"model.hasFacets || model.hasActions\">\n    <!--  Facets-->\n    <ng-container *ngIf=\"model.hasFacets; else noFacets\">\n      <div class=\"facet-toggle-button\" role=\"button\" (click)=\"openFacetsBottomSheet()\" [avnBackground]=\"{ cssProp: '--ribbon-variant-background', shade: 500, hoverShade: 700 }\">\n        <ng-container *ngIf=\"model.selectedFacet as selectedFacet\">\n          <avn-icon *ngIf=\"selectedFacet.icon\" [icon]=\"selectedFacet.icon\"></avn-icon>\n          <span>{{ selectedFacet.title }}</span>\n          <span *ngIf=\"selectedFacet.count as count\" class=\"badge-count\" [avnBackground]=\"{ cssProp: '--' + selectedFacet?.countTheme + '-base', shade: 500 }\">{{ count }}</span>\n        </ng-container>\n        <span *ngIf=\"!model.selectedFacet\" style=\"opacity: 0.7\">{{ selectedFacetPlaceholder$ | async }}</span>\n\n        <avn-icon class=\"toggle\" [icon]=\"'navigation:expand_less'\" [fontSize]=\"18\"></avn-icon>\n      </div>\n    </ng-container>\n\n    <ng-template #noFacets>\n      <div></div>\n    </ng-template>\n\n    <!--  Actions -->\n    <avn-fab-speed-dial #fabSpeedDial direction=\"left\" *ngIf=\"model.hasActions\">\n      <avn-button avnFabToggle *ngIf=\"fabSpeedDial.opened\" class=\"close-actions opened\" [icon]=\"'content:add'\"></avn-button>\n      <avn-button avnFabToggle *ngIf=\"!fabSpeedDial.opened\" class=\"close-actions closed\" [icon]=\"'navigation:more_horiz'\"></avn-button>\n      <!--  <avn-button avnFabToggle *ngIf=\"!fabSpeedDial.opened\" class=\"close-actions closed\" [icon]=\"'navigation:expand_less'\"></avn-button>-->\n      <avn-button\n        *ngFor=\"let action of model.actions\"\n        avnFabButton\n        class=\"fab-button\"\n        [icon]=\"action.icon\"\n        [label]=\"action.title\"\n        [iconTheme]=\"action.iconTheme\"\n        (click)=\"onCardClick(action)\"\n      ></avn-button>\n    </avn-fab-speed-dial>\n  </div>\n</ng-container>\n", styles: [":host{display:flex;flex-direction:column}:host .ribbon-content-wrapper{background-color:var(--ribbon-mobile-background);color:var(--ribbon-on);padding:var(--space-sm) var(--space-base);border-top:1px solid var(--ribbon-mobile-border);width:100%;height:auto}:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container{background-color:var(--form-control-on);color:var(--ribbon-on);border-color:#000}:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:not(.selected-option-template){background:var(--form-control-on)}:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:hover,:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:active,:host-context(.dmb-aspect) :host .ribbon-content-wrapper ::ng-deep avn-select>.select-container:focus{color:#fff;border-color:#000}:host .facet-actions-wrapper{background-color:var(--ribbon-mobile-background);color:var(--ribbon-on);padding:var(--space-sm) var(--space-base);border-top:1px solid var(--ribbon-mobile-border);width:100%;height:auto;display:flex;justify-content:space-between;align-items:center;-webkit-user-select:none;user-select:none;transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host .facet-actions-wrapper .facet-toggle-button{padding:var(--space-md);display:grid;grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-base);align-items:center;border-radius:3px;cursor:pointer}:host .facet-actions-wrapper .facet-toggle-button .badge-count{padding:0 var(--space-sm);font-size:var(--text-sm);border-radius:3px}:host .facet-actions-wrapper .facet-toggle-button avn-icon.toggle{opacity:.6}:host .facet-actions-wrapper ::ng-deep .close-actions.opened avn-icon i{animation:rotate-right .3s cubic-bezier(0,0,.2,1);transform:rotate(45deg)}:host .facet-actions-wrapper ::ng-deep .close-actions.closed avn-icon i{animation:rotate-left .3s cubic-bezier(0,0,.2,1)}@keyframes rotate-right{0%{transform:rotate(0)}to{transform:rotate(45deg)}}@keyframes rotate-left{0%{transform:rotate(45deg)}to{transform:rotate(0)}}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LAYOUT_SETTINGS]
                }] }, { type: i0.ChangeDetectorRef }, { type: ModalService }, { type: i0.ElementRef }, { type: LayoutStore }]; }, propDecorators: { ribbonStore: [{
                type: Input
            }] } });

class PageComponent {
    constructor() {
        /** Indicates if the mobile version of the ribbon is present (located at the bottom of the page) **/
        this.mobileRibbonExists$ = of(false);
    }
    set ribbon(ribbon) {
        // Determine if the mobile ribbon should show by checking the main ribbon state
        if (ribbon) {
            this.ribbonStore = ribbon.ribbonStore;
            this.ribbonStore.setParentPageComponentExists(true);
            this.mobileRibbonExists$ = this.ribbonStore.mobileRibbonExists$;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: PageComponent, selector: "avn-page", queries: [{ propertyName: "ribbon", first: true, predicate: RibbonComponent, descendants: true }], ngImport: i0, template: "<ng-content select=\"avn-ribbon\"></ng-content>\n<div class=\"main\" avnScroll>\n  <ng-content select=\"avn-main\"></ng-content>\n</div>\n<ng-container *ngIf=\"mobileRibbonExists$ | async\">\n  <avn-ribbon-mobile [ribbonStore]=\"ribbonStore\"></avn-ribbon-mobile>\n</ng-container>\n<ng-content></ng-content>\n", styles: [":host{width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column}:host .main{flex-grow:2}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "component", type: RibbonMobileComponent, selector: "avn-ribbon-mobile", inputs: ["ribbonStore"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-page', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content select=\"avn-ribbon\"></ng-content>\n<div class=\"main\" avnScroll>\n  <ng-content select=\"avn-main\"></ng-content>\n</div>\n<ng-container *ngIf=\"mobileRibbonExists$ | async\">\n  <avn-ribbon-mobile [ribbonStore]=\"ribbonStore\"></avn-ribbon-mobile>\n</ng-container>\n<ng-content></ng-content>\n", styles: [":host{width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column}:host .main{flex-grow:2}\n"] }]
        }], propDecorators: { ribbon: [{
                type: ContentChild,
                args: [RibbonComponent, { static: false, descendants: true }]
            }] } });

/**
 * Any html element tagged with this directive will be able to be displayed as facets, actions in ribbon.
 * avn-ribbon-card is a customized implementation of it.
 */
class RibbonDisplayItemDirective {
    get itemOpacity() {
        return this.disabled ? 0.3 : 1;
    }
    get toggled() {
        return this._toggled;
    }
    set toggled(val) {
        this._toggled = val ? val : false;
        this.active.emit(this._toggled);
    }
    onMouseEnter() {
        this._renderer.setStyle(this._elementRef.nativeElement, 'color', 'var(--ribbon-variant-on)');
    }
    onMouseLeave() {
        this._renderRibbonLinkActive();
    }
    constructor(_elementRef, _renderer, routerLinkActive) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.routerLinkActive = routerLinkActive;
        /** Disabled item won't react to click */
        this.disabled = false;
        this._toggled = false;
        this._isActiveRouterLink = false;
        /**
         * Emits every time the card is activated (toggled becomes true).
         */
        this.active = new EventEmitter();
        /**
         * Emits every time the item is actioned (clicked). Item must be enabled.
         */
        this.actioned = new EventEmitter();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        // initial styles
        const ribbonDirectiveStyles = {
            paddingRight: 'var(--space-lg)',
            marginRight: 'var(--space-lg)',
            letterSpacing: '0.4px',
            willChange: 'color',
            transition: 'color .15s ease-in-out',
            color: 'var(--ribbon-on)',
        };
        Object.keys(ribbonDirectiveStyles).forEach((styleProp) => {
            this._renderer.setStyle(this._elementRef.nativeElement, `${styleProp}`, `${ribbonDirectiveStyles[styleProp]}`);
        });
        fromEvent(this._elementRef.nativeElement, 'click')
            .pipe(filter(() => !this.disabled), takeUntil(this._componentDestroyed$))
            .subscribe(() => this.actioned.emit());
        if (this.routerLinkActive?.isActiveChange) {
            this.routerLinkActive.isActiveChange.pipe(takeUntil(this._componentDestroyed$)).subscribe((r) => {
                this._isActiveRouterLink = r;
                this._renderRibbonLinkActive();
            });
        }
    }
    _renderRibbonLinkActive() {
        if (this._isActiveRouterLink) {
            this._renderer.addClass(this._elementRef.nativeElement, this.avnRibbonDisplayItem);
            this._renderer.setStyle(this._elementRef.nativeElement, 'fontFamily', 'var(--font-family-headers)');
            this._renderer.setStyle(this._elementRef.nativeElement, 'color', 'var(--ribbon-variant-on)');
        }
        else {
            this._renderer.removeClass(this._elementRef.nativeElement, this.avnRibbonDisplayItem);
            this._renderer.removeStyle(this._elementRef.nativeElement, 'fontFamily');
            this._renderer.setStyle(this._elementRef.nativeElement, 'color', 'var(--ribbon-on)');
        }
    }
    /** item clicked when in mobile mode(either from option list of facade, or button in fab-icon) */
    dispatchClick() {
        this._elementRef.nativeElement.dispatchEvent(new MouseEvent('click'));
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonDisplayItemDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1$a.RouterLinkActive, host: true, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: RibbonDisplayItemDirective, selector: "[avnRibbonDisplayItem]", inputs: { avnRibbonDisplayItem: "avnRibbonDisplayItem", id: "id", disabled: "disabled", title: "title", icon: "icon", toggled: "toggled" }, outputs: { active: "active", actioned: "actioned" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" }, properties: { "style.opacity": "this.itemOpacity" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonDisplayItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnRibbonDisplayItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$a.RouterLinkActive, decorators: [{
                    type: Optional
                }, {
                    type: Host
                }] }]; }, propDecorators: { avnRibbonDisplayItem: [{
                type: Input
            }], id: [{
                type: Input
            }], disabled: [{
                type: Input
            }], title: [{
                type: Input
            }], icon: [{
                type: Input
            }], itemOpacity: [{
                type: HostBinding,
                args: ['style.opacity']
            }], toggled: [{
                type: Input
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }], active: [{
                type: Output
            }], actioned: [{
                type: Output
            }] } });

class RibbonActionsComponent {
    set actionsQLInRibbonBar(actions) {
        this._ribbonStore.registerActions(actions.toArray());
    }
    constructor(_ribbonStore) {
        this._ribbonStore = _ribbonStore;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonActionsComponent, deps: [{ token: RibbonStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonActionsComponent, selector: "avn-ribbon-actions", queries: [{ propertyName: "actionsQLInRibbonBar", predicate: RibbonDisplayItemDirective, emitDistinctChangesOnly: false, descendants: true }], ngImport: i0, template: "<div class=\"web-mode\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{height:100%;display:block}:host>div.web-mode{display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;align-items:center;align-content:center;padding:var(--space-xs);height:100%}:host>div.web-mode ::ng-deep avn-ribbon-card{align-self:end}:host a{margin-left:20px}:host a:not([href]):not([tabindex]){display:inline-block;padding:0 25px 0 0;letter-spacing:.4px;text-align:center;transition:color .15s ease-in-out}:host a:not([href]):not([tabindex]).active{font-family:var(--font-family-headers);color:var(--main-variant-on)}:host a:not([href]):not([tabindex]):hover,:host a:not([href]):not([tabindex]):focus{color:var(--main-variant-on)}:host a:not([href]):not([tabindex]):before{content:attr(title);display:block;height:1px;margin-top:-1px;overflow:hidden;font-family:var(--font-family-headers);opacity:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonActionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon-actions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"web-mode\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{height:100%;display:block}:host>div.web-mode{display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;align-items:center;align-content:center;padding:var(--space-xs);height:100%}:host>div.web-mode ::ng-deep avn-ribbon-card{align-self:end}:host a{margin-left:20px}:host a:not([href]):not([tabindex]){display:inline-block;padding:0 25px 0 0;letter-spacing:.4px;text-align:center;transition:color .15s ease-in-out}:host a:not([href]):not([tabindex]).active{font-family:var(--font-family-headers);color:var(--main-variant-on)}:host a:not([href]):not([tabindex]):hover,:host a:not([href]):not([tabindex]):focus{color:var(--main-variant-on)}:host a:not([href]):not([tabindex]):before{content:attr(title);display:block;height:1px;margin-top:-1px;overflow:hidden;font-family:var(--font-family-headers);opacity:0}\n"] }]
        }], ctorParameters: function () { return [{ type: RibbonStore }]; }, propDecorators: { actionsQLInRibbonBar: [{
                type: ContentChildren,
                args: [RibbonDisplayItemDirective, { descendants: true, emitDistinctChangesOnly: false }]
            }] } });

class RibbonAlternateContentComponent {
    constructor(_ribbonStore, _changeDetector) {
        this._ribbonStore = _ribbonStore;
        this._changeDetector = _changeDetector;
        /**
         * @ignore
         */
        this.altActions = [];
        this.optionListOpened = false;
        // private isAlt = false;
        this.componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this._ribbonStore
            .select(this._ribbonStore.select((ribbonState) => ribbonState.showAlternateContent), (showAlternateContent) => ({
            showAlternateContent,
        }))
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    ngAfterContentInit() {
        this.altActions = this.altActionCardQL.toArray();
        this.updateAlternateContentState();
        this.altActionCardQL.changes.pipe(takeUntil(this.componentDestroyed$)).subscribe((actions) => {
            this.altActions = actions.toArray();
            this.updateAlternateContentState();
        });
    }
    updateAlternateContentState() {
        if (this.title == undefined && this.altActions.length === 0) {
            this._ribbonStore.setAlternateContentIsEmpty(true);
        }
        else {
            this._ribbonStore.setAlternateContentIsEmpty(false);
        }
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    toggleOptionList() {
        this.optionListOpened = !this.optionListOpened;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonAlternateContentComponent, deps: [{ token: RibbonStore }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonAlternateContentComponent, selector: "avn-ribbon-alternate-content", inputs: { title: "title", showSeparator: "showSeparator" }, queries: [{ propertyName: "altActionCardQL", predicate: RibbonDisplayItemDirective }], ngImport: i0, template: "<div class=\"alternate\">\n  <!-- Alternate Action Title -->\n  <h4 *ngIf=\"title\">{{ title }}</h4>\n  <ng-content select=\".content-title\"></ng-content>\n\n  <!-- Separator -->\n  <div *ngIf=\"showSeparator || altActions?.length > 0\" class=\"separator\"></div>\n\n  <!-- Action Buttons -->\n  <div class=\"actions\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host .alternate{background-color:var(--ribbon-background);color:var(--ribbon-on);display:flex;justify-content:flex-start;align-items:center;position:relative;height:100%}:host .alternate h4{margin:0;padding-left:var(--space-base);display:block}:host .alternate .separator{height:50%;border-right:1px solid;border-right-color:var(--ribbon-on);margin:0 var(--space-base)}:host .alternate .actions{display:flex;flex-grow:2;margin-right:var(--space-base);padding:var(--space-xs);height:100%}:host .alternate .actions .dropdown{height:100%}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [
            trigger('altActionList', [
                transition('* => *', [
                    query('.card-item', stagger('-300ms', [
                        animate('300ms cubic-bezier(.8,-0.6,0.2,1.5)', style({
                            transform: 'scale(0)',
                            opacity: 0,
                        })),
                    ]), {
                        optional: true,
                    }),
                    query('.card-item', stagger('300ms', [
                        animate('300ms cubic-bezier(.8,-0.6,0.2,1.5)', style({
                            transform: 'scale(1)',
                            opacity: 1,
                        })),
                    ]), {
                        optional: true,
                    }),
                ]),
            ]),
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonAlternateContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon-alternate-content', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('altActionList', [
                            transition('* => *', [
                                query('.card-item', stagger('-300ms', [
                                    animate('300ms cubic-bezier(.8,-0.6,0.2,1.5)', style({
                                        transform: 'scale(0)',
                                        opacity: 0,
                                    })),
                                ]), {
                                    optional: true,
                                }),
                                query('.card-item', stagger('300ms', [
                                    animate('300ms cubic-bezier(.8,-0.6,0.2,1.5)', style({
                                        transform: 'scale(1)',
                                        opacity: 1,
                                    })),
                                ]), {
                                    optional: true,
                                }),
                            ]),
                        ]),
                    ], template: "<div class=\"alternate\">\n  <!-- Alternate Action Title -->\n  <h4 *ngIf=\"title\">{{ title }}</h4>\n  <ng-content select=\".content-title\"></ng-content>\n\n  <!-- Separator -->\n  <div *ngIf=\"showSeparator || altActions?.length > 0\" class=\"separator\"></div>\n\n  <!-- Action Buttons -->\n  <div class=\"actions\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host .alternate{background-color:var(--ribbon-background);color:var(--ribbon-on);display:flex;justify-content:flex-start;align-items:center;position:relative;height:100%}:host .alternate h4{margin:0;padding-left:var(--space-base);display:block}:host .alternate .separator{height:50%;border-right:1px solid;border-right-color:var(--ribbon-on);margin:0 var(--space-base)}:host .alternate .actions{display:flex;flex-grow:2;margin-right:var(--space-base);padding:var(--space-xs);height:100%}:host .alternate .actions .dropdown{height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: RibbonStore }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { title: [{
                type: Input
            }], showSeparator: [{
                type: Input
            }], altActionCardQL: [{
                type: ContentChildren,
                args: [RibbonDisplayItemDirective]
            }] } });

/**
 * This is a richer implementation of RibbonDisplayItem
 */
class RibbonCardComponent {
    get toggled() {
        return this._toggled;
    }
    set toggled(val) {
        this._toggled = val ? val : false;
        this.active.emit(this._toggled);
    }
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        /**
         * display count 0 if true
         */
        this.displayZeroCount = false;
        /**
         * Theming for the count badge.
         */
        this.countTheme = ThemeType.PRIMARY;
        /**
         * toggled. adds a darker bg to reflect toggled.
         * this is tracked externaly and a 1 way input.
         */
        this._toggled = false;
        /**
         * Emits every time the card is actioned (clicked). Card must be enabled.
         */
        this.actioned = new EventEmitter();
        /**
         * Emits every time the card is activated (toggled becomes true).
         */
        this.active = new EventEmitter();
    }
    /**
     * @ignore
     */
    get displayCount() {
        if (!this.count) {
            return this.displayZeroCount && this.count === 0 ? this.count.toString() : '';
        }
        else if (this.count && +this.count > 999) {
            return '+';
        }
        return this.count.toString();
    }
    get isToggled() {
        return this._toggled;
    }
    onClick() {
        if (!this.disabled) {
            this.actioned.emit();
        }
    }
    dispatchClick() {
        this._elementRef.nativeElement.dispatchEvent(new MouseEvent('click'));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonCardComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonCardComponent, selector: "avn-ribbon-card", inputs: { id: "id", title: "title", icon: "icon", displayZeroCount: "displayZeroCount", count: "count", countTheme: "countTheme", iconTheme: "iconTheme", priority: "priority", disabled: "disabled", toggled: "toggled" }, outputs: { actioned: "actioned", active: "active" }, host: { listeners: { "click": "onClick()" }, properties: { "class.has-icon": "this.icon", "class.disabled": "this.disabled", "class.toggled": "this.isToggled" } }, providers: [{ provide: RibbonDisplayItemDirective, useExisting: RibbonCardComponent }], ngImport: i0, template: "<div *ngIf=\"displayZeroCount ? count !== undefined && count !== null : !!count\" class=\"count\" [avnTheme]=\"count === 0 ? 'warning' : countTheme\">\n  {{ displayCount }}\n</div>\n<avn-icon *ngIf=\"icon\" [icon]=\"icon\" [avnTheme]=\"iconTheme\"></avn-icon>\n<span>{{ title }}</span>\n", styles: [":host{display:flex;height:100%;position:relative;flex-direction:column;margin-right:var(--space-md);background-color:var(--ribbon-background);color:var(--ribbon-on);cursor:pointer;-webkit-user-select:none;user-select:none;border-radius:3px;padding:var(--space-sm) var(--space-md)}:host.has-icon{width:75px;padding:var(--space-md) var(--space-md) 0}:host.disabled{opacity:.3;cursor:not-allowed}:host:hover:not(.disabled),:host.toggled{background-color:var(--ribbon-variant-background);color:var(--ribbon-variant-on)}:host.no-border{border:none}:host .count{position:absolute;top:-3px;right:-5px;border-radius:2px;padding:0 var(--space-sm);font-size:var(--text-sm);height:19px;max-width:60px;text-overflow:ellipsis;overflow:hidden}:host .count.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .count.theme-primary :hover{background-color:var(--primary-variant)}:host .count.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .count.theme-secondary :hover{background-color:var(--secondary-variant)}:host .count.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .count.theme-highlight :hover{background-color:var(--highlight-variant)}:host .count.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .count.theme-danger :hover{background-color:var(--danger-variant)}:host .count.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .count.theme-warning :hover{background-color:var(--warning-variant)}:host .count.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .count.theme-info :hover{background-color:var(--info-variant)}:host .count.theme-success{background-color:var(--success-base);color:var(--success-on)}:host .count.theme-success :hover{background-color:var(--success-variant)}:host.has-icon avn-icon{display:flex;position:relative;flex-direction:row;justify-content:center}:host.has-icon span{font-size:var(--text-xs);text-transform:uppercase;display:flex;font-weight:400;text-align:center;justify-content:center;align-items:center;height:100%}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon-card', providers: [{ provide: RibbonDisplayItemDirective, useExisting: RibbonCardComponent }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"displayZeroCount ? count !== undefined && count !== null : !!count\" class=\"count\" [avnTheme]=\"count === 0 ? 'warning' : countTheme\">\n  {{ displayCount }}\n</div>\n<avn-icon *ngIf=\"icon\" [icon]=\"icon\" [avnTheme]=\"iconTheme\"></avn-icon>\n<span>{{ title }}</span>\n", styles: [":host{display:flex;height:100%;position:relative;flex-direction:column;margin-right:var(--space-md);background-color:var(--ribbon-background);color:var(--ribbon-on);cursor:pointer;-webkit-user-select:none;user-select:none;border-radius:3px;padding:var(--space-sm) var(--space-md)}:host.has-icon{width:75px;padding:var(--space-md) var(--space-md) 0}:host.disabled{opacity:.3;cursor:not-allowed}:host:hover:not(.disabled),:host.toggled{background-color:var(--ribbon-variant-background);color:var(--ribbon-variant-on)}:host.no-border{border:none}:host .count{position:absolute;top:-3px;right:-5px;border-radius:2px;padding:0 var(--space-sm);font-size:var(--text-sm);height:19px;max-width:60px;text-overflow:ellipsis;overflow:hidden}:host .count.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host .count.theme-primary :hover{background-color:var(--primary-variant)}:host .count.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host .count.theme-secondary :hover{background-color:var(--secondary-variant)}:host .count.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host .count.theme-highlight :hover{background-color:var(--highlight-variant)}:host .count.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host .count.theme-danger :hover{background-color:var(--danger-variant)}:host .count.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host .count.theme-warning :hover{background-color:var(--warning-variant)}:host .count.theme-info{background-color:var(--info-base);color:var(--info-on)}:host .count.theme-info :hover{background-color:var(--info-variant)}:host .count.theme-success{background-color:var(--success-base);color:var(--success-on)}:host .count.theme-success :hover{background-color:var(--success-variant)}:host.has-icon avn-icon{display:flex;position:relative;flex-direction:row;justify-content:center}:host.has-icon span{font-size:var(--text-xs);text-transform:uppercase;display:flex;font-weight:400;text-align:center;justify-content:center;align-items:center;height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { id: [{
                type: Input
            }], title: [{
                type: Input
            }], icon: [{
                type: HostBinding,
                args: ['class.has-icon']
            }, {
                type: Input
            }], displayZeroCount: [{
                type: Input
            }], count: [{
                type: Input
            }], countTheme: [{
                type: Input
            }], iconTheme: [{
                type: Input
            }], priority: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: Input
            }], toggled: [{
                type: Input
            }], actioned: [{
                type: Output
            }], active: [{
                type: Output
            }], isToggled: [{
                type: HostBinding,
                args: ['class.toggled']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class RibbonFacetsComponent {
    set facetsQLInRibbonBar(facets) {
        this._ribbonStore.registerFacets(facets.toArray());
    }
    constructor(_ribbonStore) {
        this._ribbonStore = _ribbonStore;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonFacetsComponent, deps: [{ token: RibbonStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: RibbonFacetsComponent, selector: "avn-ribbon-facets", queries: [{ propertyName: "facetsQLInRibbonBar", predicate: RibbonDisplayItemDirective, descendants: true }], ngImport: i0, template: "<div class=\"web-mode\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{height:100%;display:block}:host>div.web-mode{display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;align-items:center;align-content:center;padding:var(--space-xs);height:100%;padding-right:var(--space-md)}:host>div.web-mode ::ng-deep avn-ribbon-card{align-self:end}:host>div.web-mode>a:not(:first-child){margin-left:20px}:host>div.web-mode>a:not([href]):not([tabindex]){display:inline-block;padding:0 25px 0 0;letter-spacing:.4px;text-align:center;transition:color .15s ease-in-out}:host>div.web-mode>a:not([href]):not([tabindex]).active{font-family:var(--font-family-headers);color:var(--main-variant-on)}:host>div.web-mode>a:not([href]):not([tabindex]):hover,:host>div.web-mode>a:not([href]):not([tabindex]):focus{color:var(--main-variant-on)}:host>div.web-mode>a:not([href]):not([tabindex]):before{content:attr(title);display:block;height:1px;margin-top:-1px;overflow:hidden;font-family:var(--font-family-headers);opacity:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: RibbonFacetsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-ribbon-facets', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"web-mode\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{height:100%;display:block}:host>div.web-mode{display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;align-items:center;align-content:center;padding:var(--space-xs);height:100%;padding-right:var(--space-md)}:host>div.web-mode ::ng-deep avn-ribbon-card{align-self:end}:host>div.web-mode>a:not(:first-child){margin-left:20px}:host>div.web-mode>a:not([href]):not([tabindex]){display:inline-block;padding:0 25px 0 0;letter-spacing:.4px;text-align:center;transition:color .15s ease-in-out}:host>div.web-mode>a:not([href]):not([tabindex]).active{font-family:var(--font-family-headers);color:var(--main-variant-on)}:host>div.web-mode>a:not([href]):not([tabindex]):hover,:host>div.web-mode>a:not([href]):not([tabindex]):focus{color:var(--main-variant-on)}:host>div.web-mode>a:not([href]):not([tabindex]):before{content:attr(title);display:block;height:1px;margin-top:-1px;overflow:hidden;font-family:var(--font-family-headers);opacity:0}\n"] }]
        }], ctorParameters: function () { return [{ type: RibbonStore }]; }, propDecorators: { facetsQLInRibbonBar: [{
                type: ContentChildren,
                args: [RibbonDisplayItemDirective, { descendants: true }]
            }] } });

/**
 * Animation for the sub item panel
 */
const itemsAppearAnimation = trigger('itemsAppearAnimation', [
    state('0', style({
        // transform: 'translateY(-100%)',
        opacity: 0,
        height: '0px',
    })),
    state('void', style({
        // transform: 'translateY(-100%)',
        opacity: 0,
        height: '0px',
    })),
    state('1', style({
        opacity: 1,
        height: '*',
        // transform: 'translateY(0)',
    })),
    transition('* => *', animate('250ms cubic-bezier(0, 0, 0.2, 1)')),
]);
/** Default icon size when null or not specified **/
const DEFAULT_ICON_SIZE_PX = 24;
/**
 * This component represents a sidebar item
 * It can contain children sidebar items set by projection
 */
class SidebarItemComponent {
    /** Indicates if the sub items panel is currently opened **/
    set opened(opened) {
        this._opened = opened;
        this._changeDetector.detectChanges();
    }
    get opened() {
        return this._opened;
    }
    /** @ignore **/
    constructor(elementRef, _renderer, _changeDetector, _layoutStore) {
        this.elementRef = elementRef;
        this._renderer = _renderer;
        this._changeDetector = _changeDetector;
        this._layoutStore = _layoutStore;
        /** size of the item icon **/
        this.iconSize = DEFAULT_ICON_SIZE_PX;
        /** Emits when the item is clicked **/
        this.clicked = new EventEmitter();
        /** Emits when the sub items panel is toggled (if any sub-items) **/
        this.toggled = new EventEmitter();
        /** Indicates if the item is currently active (active link) **/
        this.active = false;
        this._opened = false;
        /** @ignore **/
        this._itemsPanelAnimationRunning = false;
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.hovered$ = merge(fromEvent(this.itemEl.nativeElement, 'mouseenter').pipe(map(() => true)), fromEvent(this.itemEl.nativeElement, 'mouseleave').pipe(map(() => false))).pipe(startWith(false));
    }
    ngOnChanges({ iconSize }) {
        if (iconSize && !iconSize.currentValue) {
            this.iconSize = DEFAULT_ICON_SIZE_PX;
        }
    }
    ngAfterViewInit() {
        this._layoutStore
            .select((layoutState) => layoutState.settings.sideNavSettings.collapsedWidthPx)
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((collapsedSideNavWidthPx) => {
            if (this._iconContainerEl) {
                this._renderer.setStyle(this._iconContainerEl.nativeElement, 'width', `${collapsedSideNavWidthPx + 1}px`);
                this._renderer.setStyle(this._iconContainerEl.nativeElement, 'min-width', `${collapsedSideNavWidthPx + 1}px`);
            }
        });
    }
    /** Called when an item is toggled **/
    onItemToggled() {
        this.toggled.emit({ item: this, opened: !this._opened });
    }
    /** Called when an item is clicked **/
    onItemClicked(event) {
        // when the item is clicked, stop the click propagation when href is clicked to avoid opening the menu when not necessary
        if (this._itemsPanelAnimationRunning) {
            event.stopPropagation();
            return;
        }
        if (this.href) {
            event.stopPropagation();
            this.clicked.emit(this);
        }
        else {
            this.onItemToggled();
        }
    }
    onItemsPanelAnimationStart() {
        this._itemsPanelAnimationRunning = true;
    }
    onItemsPanelAnimationEnd() {
        this._itemsPanelAnimationRunning = false;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /**  Indicates if this item has children */
    get hasChildren() {
        // Need to filter the current item
        // https://github.com/angular/angular/issues/10098
        return this.childrenItemsQL.toArray().filter((child) => child !== this).length > 0;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SidebarItemComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: LayoutStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SidebarItemComponent, selector: "avn-sidebar-item", inputs: { title: "title", icon: "icon", iconSize: "iconSize", href: "href" }, outputs: { clicked: "clicked", toggled: "toggled" }, host: { properties: { "class.active": "this.active" } }, queries: [{ propertyName: "childrenItemsQL", predicate: i0.forwardRef(function () { return SidebarItemComponent; }) }], viewQueries: [{ propertyName: "itemEl", first: true, predicate: ["item"], descendants: true, static: true }, { propertyName: "_iconContainerEl", first: true, predicate: ["iconContainer"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #item class=\"item\" [class.opened]=\"opened\" (click)=\"onItemClicked($event)\" [class.toggle-item]=\"!href && hasChildren\">\n  <div #iconContainer class=\"icon-container\" *ngIf=\"icon\">\n    <avn-icon [icon]=\"icon\" [fontSize]=\"iconSize\"></avn-icon>\n  </div>\n  <span class=\"title\">{{ title }}</span>\n  <div class=\"icon-toggle-container\" *ngIf=\"hasChildren\">\n    <div class=\"icon-toggle-wrapper\" (click)=\"$event.stopPropagation(); onItemToggled()\">\n      <avn-icon icon=\"navigation:chevron_left\" [fontSize]=\"14\"></avn-icon>\n    </div>\n  </div>\n</div>\n<div\n  class=\"items\"\n  *ngIf=\"hasChildren && opened\"\n  [@itemsAppearAnimation]=\"true\"\n  (@itemsAppearAnimation.start)=\"onItemsPanelAnimationStart()\"\n  (@itemsAppearAnimation.done)=\"onItemsPanelAnimationEnd()\"\n>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{cursor:pointer;display:block}:host .item{display:flex;flex-flow:row nowrap;align-items:center;width:100%;padding:var(--space-xs) 0px;min-height:48px;transition:background-color .15s cubic-bezier(0,0,.2,1),color .15s cubic-bezier(0,0,.2,1)}:host .item span.title{opacity:.7;margin-left:var(--space-base)}:host .item .icon-container{opacity:.7;display:flex;align-items:center;justify-content:center}:host .item .icon-container>avn-icon{-webkit-user-select:none;user-select:none}:host .item .icon-container+span.title{margin-left:0}:host .item .icon-toggle-container{opacity:.7;justify-self:flex-end;flex-grow:1;display:flex;justify-content:flex-end;margin-right:var(--space-xs)}:host .item .icon-toggle-container .icon-toggle-wrapper{padding:var(--space-xs) 4px;border-radius:50%;transition:background-color .15s cubic-bezier(0,0,.2,1)}:host .item .icon-toggle-container .icon-toggle-wrapper:hover{background-color:#ffffff1a}:host .item .icon-toggle-container .icon-toggle-wrapper avn-icon{-webkit-user-select:none;user-select:none}:host .item .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i{transition:transform .15s cubic-bezier(0,0,.2,1)}:host .item.opened .icon-toggle-container .icon-toggle-wrapper{background-color:#ffffff1a}:host .item.opened .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i{transform:rotate(-90deg)}:host .item.toggle-item:hover .icon-toggle-container .icon-toggle-wrapper{background-color:#ffffff1a}:host .item:hover{background-color:var(--sidenav-variant-background);color:var(--sidenav-variant-on)}:host .item:hover>span.title{opacity:1}:host .item:hover .icon-container{opacity:1}:host .item:hover.toggle-item .icon-toggle-container{opacity:1}:host .item>span.title{-webkit-user-select:none;user-select:none}:host .items{padding-left:var(--space-base);background-color:var(--sidenav-open-background);color:var(--sidenav-open-on);position:relative;overflow-y:hidden}:host.active>.item{background-color:var(--sidenav-variant-background);color:var(--highlight-base)}:host.active>.item>span.title{opacity:1}:host.active>.item .icon-container{opacity:1}:host.active>.item.toggle-item .icon-toggle-container{opacity:1}:host.active>.item>.icon-container>avn-icon{color:var(--highlight-base)}:host.active>.item>.icon-toggle-container{opacity:1}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], animations: [itemsAppearAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SidebarItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-sidebar-item', changeDetection: ChangeDetectionStrategy.OnPush, animations: [itemsAppearAnimation], template: "<div #item class=\"item\" [class.opened]=\"opened\" (click)=\"onItemClicked($event)\" [class.toggle-item]=\"!href && hasChildren\">\n  <div #iconContainer class=\"icon-container\" *ngIf=\"icon\">\n    <avn-icon [icon]=\"icon\" [fontSize]=\"iconSize\"></avn-icon>\n  </div>\n  <span class=\"title\">{{ title }}</span>\n  <div class=\"icon-toggle-container\" *ngIf=\"hasChildren\">\n    <div class=\"icon-toggle-wrapper\" (click)=\"$event.stopPropagation(); onItemToggled()\">\n      <avn-icon icon=\"navigation:chevron_left\" [fontSize]=\"14\"></avn-icon>\n    </div>\n  </div>\n</div>\n<div\n  class=\"items\"\n  *ngIf=\"hasChildren && opened\"\n  [@itemsAppearAnimation]=\"true\"\n  (@itemsAppearAnimation.start)=\"onItemsPanelAnimationStart()\"\n  (@itemsAppearAnimation.done)=\"onItemsPanelAnimationEnd()\"\n>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{cursor:pointer;display:block}:host .item{display:flex;flex-flow:row nowrap;align-items:center;width:100%;padding:var(--space-xs) 0px;min-height:48px;transition:background-color .15s cubic-bezier(0,0,.2,1),color .15s cubic-bezier(0,0,.2,1)}:host .item span.title{opacity:.7;margin-left:var(--space-base)}:host .item .icon-container{opacity:.7;display:flex;align-items:center;justify-content:center}:host .item .icon-container>avn-icon{-webkit-user-select:none;user-select:none}:host .item .icon-container+span.title{margin-left:0}:host .item .icon-toggle-container{opacity:.7;justify-self:flex-end;flex-grow:1;display:flex;justify-content:flex-end;margin-right:var(--space-xs)}:host .item .icon-toggle-container .icon-toggle-wrapper{padding:var(--space-xs) 4px;border-radius:50%;transition:background-color .15s cubic-bezier(0,0,.2,1)}:host .item .icon-toggle-container .icon-toggle-wrapper:hover{background-color:#ffffff1a}:host .item .icon-toggle-container .icon-toggle-wrapper avn-icon{-webkit-user-select:none;user-select:none}:host .item .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i{transition:transform .15s cubic-bezier(0,0,.2,1)}:host .item.opened .icon-toggle-container .icon-toggle-wrapper{background-color:#ffffff1a}:host .item.opened .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i{transform:rotate(-90deg)}:host .item.toggle-item:hover .icon-toggle-container .icon-toggle-wrapper{background-color:#ffffff1a}:host .item:hover{background-color:var(--sidenav-variant-background);color:var(--sidenav-variant-on)}:host .item:hover>span.title{opacity:1}:host .item:hover .icon-container{opacity:1}:host .item:hover.toggle-item .icon-toggle-container{opacity:1}:host .item>span.title{-webkit-user-select:none;user-select:none}:host .items{padding-left:var(--space-base);background-color:var(--sidenav-open-background);color:var(--sidenav-open-on);position:relative;overflow-y:hidden}:host.active>.item{background-color:var(--sidenav-variant-background);color:var(--highlight-base)}:host.active>.item>span.title{opacity:1}:host.active>.item .icon-container{opacity:1}:host.active>.item.toggle-item .icon-toggle-container{opacity:1}:host.active>.item>.icon-container>avn-icon{color:var(--highlight-base)}:host.active>.item>.icon-toggle-container{opacity:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: LayoutStore }]; }, propDecorators: { childrenItemsQL: [{
                type: ContentChildren,
                args: [forwardRef(() => SidebarItemComponent), { descendants: false }]
            }], itemEl: [{
                type: ViewChild,
                args: ['item', { static: true }]
            }], _iconContainerEl: [{
                type: ViewChild,
                args: ['iconContainer', { static: false }]
            }], title: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], href: [{
                type: Input
            }], clicked: [{
                type: Output
            }], toggled: [{
                type: Output
            }], active: [{
                type: HostBinding,
                args: ['class.active']
            }] } });

/** Converts the item string href into a different format **/
const urlStringToInternalFormat = (url) => {
    const split = url.split(/\?|;|&/);
    return {
        url: split[0].startsWith('/') ? split[0].substring(1) : split[0],
        params: split.slice(1).reduce((p, c) => {
            const splitParam = c.split('=');
            p[splitParam[0]] = splitParam[1];
            return p;
        }, {}),
    };
};
/** Converts the item href into our internal format **/
const urlToInternalFormat = (href) => {
    if (href === undefined || href === null) {
        return href;
    }
    if (href.constructor.name === 'String') {
        return urlStringToInternalFormat(href);
    }
    if (href.constructor.name === 'Array') {
        // treat like a routerLink with params
        const url = href.filter((e) => e && e.constructor.name === 'String').join('/');
        const params = href.filter((e) => e && e.constructor.name === 'Object')[0] || {};
        return { url, params };
    }
    return null;
};

const appearAnimation = trigger('appearAnimation', [
    transition('* => *', [
        // each time the binding value changes
        query(':enter', [
            style({ opacity: 0 }),
            stagger(120, [
                animate('750ms cubic-bezier(0.25, 0.8, 0.25, 1)', keyframes([style({ opacity: 0, transform: 'translateX(-100%)' }), style({ opacity: 1, transform: 'translateX(0)' })])),
            ]),
        ], { optional: true }),
    ]),
]);
class TreeSidebarComponent {
    /** @ignore **/
    constructor(_elementRef, _layoutStore, _changeDetector, _renderer) {
        this._elementRef = _elementRef;
        this._layoutStore = _layoutStore;
        this._changeDetector = _changeDetector;
        this._renderer = _renderer;
        /**
         *  Unique query params that allows to differentiate identical url paths leading to different components
         *  e.g. a legacy component that displays an iframe could use a query param 'module' to set the actual page to display
         *  however the path will always be /app/legacy?module=xxx
         * *
         */
        this.uniqueParams = [];
        /** Indicates if all nodes opened should auto close when another node is opened **/
        this.autoClose = true;
        /** Indicates if the top level node should be opened automatically when hovered and when sidenav is closed **/
        this.autoExpandFirstLevelItem = true;
        /** Emits the href of the nav item clicked **/
        this.itemClicked = new EventEmitter();
        /** @ignore list of all sidebar items of all levels, with ancestor info for each of them **/
        this._itemsWithAncestors = [];
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
        this.sidenavToggled$ = this._layoutStore.sideNavOpened$;
    }
    /** @ignore **/
    ngAfterContentInit() {
        this.childrenItemsQL.changes.pipe(startWith(this.childrenItemsQL), takeUntil(this._componentDestroyed$)).subscribe((itemsQL) => {
            this._itemsWithAncestors = this._getAllItems(itemsQL.toArray());
            // when an item is toggled, open it and close all other items if needed
            merge(...this._itemsWithAncestors.map((item) => item.item.toggled))
                .pipe(takeUntil(merge(this.childrenItemsQL.changes, this._componentDestroyed$)))
                .subscribe((item) => {
                if (this.autoClose) {
                    this.closeAllItems(item.item);
                }
                item.item.opened = item.opened;
            });
            // when an item is clicked, emit its href
            merge(...this._itemsWithAncestors.map((item) => item.item.clicked))
                .pipe(takeUntil(merge(this.childrenItemsQL.changes, this._componentDestroyed$)))
                .subscribe((item) => this.itemClicked.emit(item.href));
        });
        this.hoveredItem$ = combineLatest([...this._itemsWithAncestors.map((item) => item.item.hovered$.pipe(map((hovered) => (hovered ? item.item : null))))]).pipe(map((itemsHovered) => itemsHovered.find((item) => !!item)));
    }
    /** @ignore **/
    ngAfterViewInit() {
        // update the active item every time the route changes
        this._layoutStore.currentRoute$
            .pipe(filter((currentUrl) => !!currentUrl), takeUntil(this._componentDestroyed$))
            .subscribe((currentUrl) => {
            // remove any leading slash
            const formattedUrl = urlStringToInternalFormat(currentUrl);
            this._updateActiveItem(formattedUrl);
        });
        // auto open the hovered item when sidenav is being opened
        // auto open active item when sidenav is being opened and no hovered item (opened via hamburger)
        // close all items when menu is closed
        this.sidenavToggled$.pipe(withLatestFrom(this.hoveredItem$), takeUntil(this._componentDestroyed$)).subscribe(([opened, hoveredItem]) => {
            // sets the opened class
            if (opened) {
                this._renderer.addClass(this._elementRef.nativeElement, 'opened');
            }
            else {
                this._renderer.removeClass(this._elementRef.nativeElement, 'opened');
            }
            if (!opened) {
                this.closeAllItems();
            }
            else if (this.autoExpandFirstLevelItem) {
                // open the hovered item
                if (hoveredItem) {
                    hoveredItem.opened = true;
                    // open any active sub item too
                    if (hoveredItem.active) {
                        this._openAllActiveItems();
                    }
                }
                else {
                    this._openAllActiveItems();
                }
            }
        });
    }
    /** @ignore Opens all active item nodes **/
    _openAllActiveItems() {
        // open all active items
        this._itemsWithAncestors.forEach((item) => {
            if (item.item.active) {
                item.item.opened = true;
            }
        });
    }
    /** @ignore update the active item based on the current url **/
    _updateActiveItem(currentUrl) {
        const currentUrlParamsMatching = Object.keys(currentUrl.params).filter((name) => this.uniqueParams?.includes(name));
        this._itemsWithAncestors.forEach((item) => (item.item.active = false));
        const activeItems = this._itemsWithAncestors.filter((item) => {
            if (item.item.href) {
                const formattedUrl = urlToInternalFormat(item.item.href);
                if (currentUrl.url.startsWith(formattedUrl.url)) {
                    if (currentUrlParamsMatching.length === 0) {
                        return true;
                    }
                    return currentUrlParamsMatching.every((paramName) => currentUrl.params[paramName] === formattedUrl.params[paramName]);
                }
            }
            return false;
        });
        if (activeItems.length > 0) {
            // update all active items
            const allActiveItems = activeItems.reduce((p, c) => {
                const activeItemWithAncestors = [c.item, ...c.ancestors];
                return [...p, ...activeItemWithAncestors.filter((item) => !p.includes(item))];
            }, []);
            allActiveItems.forEach((item) => (item.active = true));
        }
    }
    /** @ignore create a list of all sidebar items and their ancestors **/
    _getAllItems(items, ancestors = [], level = 0) {
        const res = [];
        items.forEach((item) => {
            res.push({ item, level, ancestors });
            res.push(...this._getAllItems(item.childrenItemsQL.toArray().filter((instance) => instance !== item), [...ancestors, item], level + 1));
        });
        return res;
    }
    /**
     * Closes all menu items
     * If an item to exclude is specified, this item and all its ancestors will remain opened
     *
     * @param itemToExclude
     */
    closeAllItems(itemToExclude = null) {
        const ancestors = itemToExclude ? this._itemsWithAncestors.find((item) => item.item === itemToExclude)?.ancestors || [] : [];
        this._itemsWithAncestors.forEach((item) => {
            if (itemToExclude !== item.item && !ancestors.includes(item.item)) {
                item.item.opened = false;
            }
        });
    }
    get toggleAnimationState() {
        return true;
    }
    animationStart() {
        this._renderer.addClass(this._elementRef.nativeElement, 'animated');
    }
    animationDone() {
        this._renderer.removeClass(this._elementRef.nativeElement, 'animated');
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TreeSidebarComponent, deps: [{ token: i0.ElementRef }, { token: LayoutStore }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TreeSidebarComponent, selector: "avn-tree-sidebar", inputs: { uniqueParams: "uniqueParams", autoClose: "autoClose", autoExpandFirstLevelItem: "autoExpandFirstLevelItem" }, outputs: { itemClicked: "itemClicked" }, host: { listeners: { "@appearAnimation.start": "animationStart()", "@appearAnimation.done": "animationDone()" }, properties: { "@appearAnimation": "this.toggleAnimationState" } }, queries: [{ propertyName: "childrenItemsQL", predicate: SidebarItemComponent }], ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:block}:host ::ng-deep avn-sidebar-item{border-top:1px solid rgba(255,255,255,.06)}:host ::ng-deep>avn-sidebar-item{background-color:var(--sidenav-background);color:var(--sidenav-background-on)}:host ::ng-deep>avn-sidebar-item:first-child{border-top:none}:host.animated:not(.opened) ::ng-deep>avn-sidebar-item span.title,:host.animated:not(.opened) ::ng-deep>avn-sidebar-item .icon-toggle-container{visibility:hidden}\n"], animations: [appearAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TreeSidebarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-tree-sidebar', changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearAnimation], template: "<ng-content></ng-content>\n", styles: [":host{display:block}:host ::ng-deep avn-sidebar-item{border-top:1px solid rgba(255,255,255,.06)}:host ::ng-deep>avn-sidebar-item{background-color:var(--sidenav-background);color:var(--sidenav-background-on)}:host ::ng-deep>avn-sidebar-item:first-child{border-top:none}:host.animated:not(.opened) ::ng-deep>avn-sidebar-item span.title,:host.animated:not(.opened) ::ng-deep>avn-sidebar-item .icon-toggle-container{visibility:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: LayoutStore }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { childrenItemsQL: [{
                type: ContentChildren,
                args: [SidebarItemComponent, { descendants: false }]
            }], uniqueParams: [{
                type: Input
            }], autoClose: [{
                type: Input
            }], autoExpandFirstLevelItem: [{
                type: Input
            }], itemClicked: [{
                type: Output
            }], toggleAnimationState: [{
                type: HostBinding,
                args: ['@appearAnimation']
            }], animationStart: [{
                type: HostListener,
                args: ['@appearAnimation.start']
            }], animationDone: [{
                type: HostListener,
                args: ['@appearAnimation.done']
            }] } });

class SidenavComponent {
    constructor(_layoutStore, _renderer, _elementRef, _document, layoutSettings, _changeDetector) {
        this._layoutStore = _layoutStore;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._document = _document;
        this.layoutSettings = layoutSettings;
        this._changeDetector = _changeDetector;
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this._layoutStore
            .select(this._layoutStore.select((state) => state.topNavExists), this._layoutStore.select((state) => state.settings.sideNavSettings.widthPx), this._layoutStore.select((state) => state.settings.sideNavSettings.collapsedWidthPx), this._layoutStore.select((state) => state.settings.sideNavSettings.stickyFooter), this._layoutStore.select((state) => state.settings.topNavSettings.heightPx), (topNavExists, widthPx, collapsedWidthPx, stickyFooter, topNavHeightPx) => ({
            widthPx,
            collapsedWidthPx,
            stickyFooter,
            sideNavTopPx: widthPx || 0,
            sideNavHeight: `calc(100vh - ${topNavHeightPx || 0}px)`,
            gridRow: `${topNavExists ? 2 : 1} / span 1`,
        }))
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    ngOnInit() {
        this._initSideNavStateChangeListeners();
        this._layoutStore.sideNavOpened$.pipe(withLatestFrom(this._layoutStore.mode$), takeUntil(this._componentDestroyed$)).subscribe(([sideNavOpened, mode]) => {
            if (sideNavOpened && mode === SideNavMode.OFF_CANVAS) {
                this._renderer.setStyle(this._document.body, 'overflow', 'hidden');
            }
            else if (!sideNavOpened || mode === SideNavMode.COLLAPSIBLE || mode === SideNavMode.STATIC) {
                this._renderer.removeStyle(this._document.body, 'overflow');
            }
        });
    }
    _initSideNavStateChangeListeners() {
        const mouseenter$ = fromEvent(this._elementRef.nativeElement, 'mouseenter');
        const mouseleave$ = fromEvent(this._elementRef.nativeElement, 'mouseleave');
        const clicked$ = fromEvent(this._elementRef.nativeElement, 'click');
        // wait before opening / closing the side nav
        const hoverInTrigger$ = mouseenter$.pipe(switchMap(() => timer(this._layoutStore.stateSnapshot.settings.sideNavSettings.autoExpandDelayMs).pipe(takeUntil(merge(mouseleave$)))));
        const hoverOutTrigger$ = mouseleave$.pipe(switchMap(() => timer(this._layoutStore.stateSnapshot.settings.sideNavSettings.autoExpandCloseDelayMs).pipe(takeUntil(mouseenter$))));
        // open menu after auto expand delay has passed or click on the sidenav
        merge(clicked$, hoverInTrigger$)
            .pipe(withLatestFrom(this._layoutStore.state$), filter(([_, { sideNavOpened, sideNavLayoutMode }]) => sideNavLayoutMode === SideNavMode.COLLAPSIBLE && !sideNavOpened), takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            this._layoutStore.setSideNavOpened({ opened: true, source: TriggerSourceType.SIDENAV });
        });
        hoverOutTrigger$
            .pipe(withLatestFrom(this._layoutStore.state$), filter(([_, { sideNavOpened, sideNavOpenedTrigger, sideNavLayoutMode }]) => sideNavLayoutMode === SideNavMode.COLLAPSIBLE && sideNavOpened && sideNavOpenedTrigger === TriggerSourceType.SIDENAV), takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            this._layoutStore.setSideNavOpened({ opened: false, source: TriggerSourceType.SIDENAV });
        });
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SidenavComponent, deps: [{ token: LayoutStore }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: DOCUMENT }, { token: LAYOUT_SETTINGS }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SidenavComponent, selector: "avn-sidenav", ngImport: i0, template: "<div class=\"wrapper\" avnScroll [style.grid-row]=\"model.gridRow\">\n  <div class=\"header\">\n    <ng-content select=\"[avnNavHeader]\"></ng-content>\n  </div>\n  <div class=\"body\" avnScroll>\n    <ng-content select=\"[avnNavElements]\"></ng-content>\n    <ng-container *ngIf=\"!model.stickyFooter\"><ng-container *ngTemplateOutlet=\"navContent\"></ng-container></ng-container>\n  </div>\n  <div class=\"footer\">\n    <ng-container *ngIf=\"model.stickyFooter\">\n      <ng-container *ngTemplateOutlet=\"navContent\"></ng-container>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #navContent>\n  <ng-content select=\"[avnNavContent]\"></ng-content>\n</ng-template>\n", styles: [":host{display:contents}:host>.wrapper{display:grid;grid-auto-flow:row;grid-template-rows:max-content 1fr max-content;grid-template-columns:100%;height:100%;max-height:100%;background-color:var(--sidenav-background);border-right:1px solid var(--sidenav-border);color:var(--sidenav-on);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host>.wrapper ::ng-deep *[avnNavHeader]{width:100%;display:flex;min-height:50px;align-items:center;justify-content:center;margin:var(--space-md) 0 var(--space-lg)}:host>.wrapper ::ng-deep *[avnNavHeader]>*{display:block}:host>.wrapper ::ng-deep *[avnNavHeader] h1,:host>.wrapper ::ng-deep *[avnNavHeader] h2,:host>.wrapper ::ng-deep *[avnNavHeader] h3,:host>.wrapper ::ng-deep *[avnNavHeader] h4,:host>.wrapper ::ng-deep *[avnNavHeader] h5,:host>.wrapper ::ng-deep *[avnNavHeader] h6,:host>.wrapper ::ng-deep *[avnNavHeader] p{font-size:var(--text-md);font-weight:700}:host>.wrapper ::ng-deep *[avnNavElements]{width:100%}:host>.wrapper ::ng-deep *[avnNavContent]{width:100%}:host>.wrapper .body{display:flex;flex-direction:column;justify-content:space-between}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-sidenav', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"wrapper\" avnScroll [style.grid-row]=\"model.gridRow\">\n  <div class=\"header\">\n    <ng-content select=\"[avnNavHeader]\"></ng-content>\n  </div>\n  <div class=\"body\" avnScroll>\n    <ng-content select=\"[avnNavElements]\"></ng-content>\n    <ng-container *ngIf=\"!model.stickyFooter\"><ng-container *ngTemplateOutlet=\"navContent\"></ng-container></ng-container>\n  </div>\n  <div class=\"footer\">\n    <ng-container *ngIf=\"model.stickyFooter\">\n      <ng-container *ngTemplateOutlet=\"navContent\"></ng-container>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #navContent>\n  <ng-content select=\"[avnNavContent]\"></ng-content>\n</ng-template>\n", styles: [":host{display:contents}:host>.wrapper{display:grid;grid-auto-flow:row;grid-template-rows:max-content 1fr max-content;grid-template-columns:100%;height:100%;max-height:100%;background-color:var(--sidenav-background);border-right:1px solid var(--sidenav-border);color:var(--sidenav-on);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host>.wrapper ::ng-deep *[avnNavHeader]{width:100%;display:flex;min-height:50px;align-items:center;justify-content:center;margin:var(--space-md) 0 var(--space-lg)}:host>.wrapper ::ng-deep *[avnNavHeader]>*{display:block}:host>.wrapper ::ng-deep *[avnNavHeader] h1,:host>.wrapper ::ng-deep *[avnNavHeader] h2,:host>.wrapper ::ng-deep *[avnNavHeader] h3,:host>.wrapper ::ng-deep *[avnNavHeader] h4,:host>.wrapper ::ng-deep *[avnNavHeader] h5,:host>.wrapper ::ng-deep *[avnNavHeader] h6,:host>.wrapper ::ng-deep *[avnNavHeader] p{font-size:var(--text-md);font-weight:700}:host>.wrapper ::ng-deep *[avnNavElements]{width:100%}:host>.wrapper ::ng-deep *[avnNavContent]{width:100%}:host>.wrapper .body{display:flex;flex-direction:column;justify-content:space-between}\n"] }]
        }], ctorParameters: function () { return [{ type: LayoutStore }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LAYOUT_SETTINGS]
                }] }, { type: i0.ChangeDetectorRef }]; } });

class TopnavTitleComponent {
    constructor(_layoutStore, _changeDetector) {
        this._layoutStore = _layoutStore;
        this._changeDetector = _changeDetector;
        this.clicked = new EventEmitter();
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this._layoutStore
            .select(this._layoutStore.select((state) => state.settings.sideNavSettings.widthPx), (widthPx) => ({
            widthPx,
        }))
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    get widthPx() {
        return this.model.widthPx;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TopnavTitleComponent, deps: [{ token: LayoutStore }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TopnavTitleComponent, selector: "avn-topnav-title", inputs: { title: "title", iconURL: "iconURL", link: "link" }, outputs: { clicked: "clicked" }, host: { properties: { "style.width.px": "this.widthPx" } }, ngImport: i0, template: "<ng-container *ngIf=\"link; else noLink\">\n  <span class=\"title-link\" (click)=\"clicked.emit(link)\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </span>\n</ng-container>\n\n<ng-template #noLink>\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</ng-template>\n\n<ng-template #content>\n  <img *ngIf=\"iconURL\" [alt]=\"title || ''\" [title]=\"title || ''\" [src]=\"iconURL\" />\n  <h5 *ngIf=\"!iconURL && title\">{{ title }}</h5>\n</ng-template>\n", styles: [":host{height:100%;display:flex;background-color:var(--topnav-title-background);color:var(--topnav-title-on);align-items:center}:host h5{margin-bottom:0;margin-top:0;margin-left:var(--space-base)}:host span.title-link{cursor:pointer;outline:none}:host img,:host span.title-link img{width:200px;height:50px;object-fit:scale-down}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TopnavTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-topnav-title', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"link; else noLink\">\n  <span class=\"title-link\" (click)=\"clicked.emit(link)\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </span>\n</ng-container>\n\n<ng-template #noLink>\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</ng-template>\n\n<ng-template #content>\n  <img *ngIf=\"iconURL\" [alt]=\"title || ''\" [title]=\"title || ''\" [src]=\"iconURL\" />\n  <h5 *ngIf=\"!iconURL && title\">{{ title }}</h5>\n</ng-template>\n", styles: [":host{height:100%;display:flex;background-color:var(--topnav-title-background);color:var(--topnav-title-on);align-items:center}:host h5{margin-bottom:0;margin-top:0;margin-left:var(--space-base)}:host span.title-link{cursor:pointer;outline:none}:host img,:host span.title-link img{width:200px;height:50px;object-fit:scale-down}\n"] }]
        }], ctorParameters: function () { return [{ type: LayoutStore }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { title: [{
                type: Input
            }], iconURL: [{
                type: Input
            }], link: [{
                type: Input
            }], clicked: [{
                type: Output
            }], widthPx: [{
                type: HostBinding,
                args: ['style.width.px']
            }] } });

class TopnavComponent {
    constructor(_layoutStore, _changeDetector) {
        this._layoutStore = _layoutStore;
        this._changeDetector = _changeDetector;
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this._layoutStore
            .select(this._layoutStore.select((state) => state.sideNavExists), this._layoutStore.select((state) => state.sideNavToggleVisible), this._layoutStore.select((state) => state.topNavDetailTitle), this._layoutStore.select((state) => state.topNavDetailBackIcon), (sideNavExists, sideNavToggleVisible, topNavDetailTitle, topNavDetailBackIcon) => ({
            showSideNavToggle: sideNavExists && sideNavToggleVisible,
            gridColumn: `span ${sideNavExists ? 2 : 1}`,
            topNavDetailTitle,
            topNavDetailBackIcon,
        }))
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    get gridColumn() {
        return this.model.gridColumn;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    navigateBack() {
        // Navigate to the last page that was not a detail page. If none exists, navigate to root
        const { topNavDetailBackRoute } = this._layoutStore.stateSnapshot;
        const shouldNavigateToRoot = !topNavDetailBackRoute;
        if (shouldNavigateToRoot) {
            this._layoutStore.navigateToRoot.emit();
        }
        else {
            this._layoutStore.navigateToUrl.emit(topNavDetailBackRoute);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TopnavComponent, deps: [{ token: LayoutStore }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TopnavComponent, selector: "avn-topnav", host: { properties: { "style.grid-column": "this.gridColumn" } }, ngImport: i0, template: "<div class=\"detail-top-nav\" [class.visible]=\"model.topNavDetailTitle\">\n  <div style=\"display: grid; grid-auto-flow: column; grid-auto-columns: max-content; grid-column-gap: var(--space-base); align-items: center; padding: var(--space-base)\">\n    <avn-icon *ngIf=\"model.topNavDetailBackIcon\" class=\"back-button\" [icon]=\"'navigation:arrow_back'\" (click)=\"navigateBack()\"></avn-icon>\n    <h4 class=\"detail-title\">{{ model.topNavDetailTitle }}</h4>\n  </div>\n</div>\n\n<div class=\"regular-top-nav\" [class.visible]=\"!model.topNavDetailTitle\">\n  <!-- Topnav title / logo area -->\n  <div class=\"area-wrapper\">\n    <ng-content select=\"[avnNavHeader]\"></ng-content>\n  </div>\n\n  <!-- Hamburger menu -->\n  <div class=\"area-wrapper\">\n    <avn-hamburger *ngIf=\"model.showSideNavToggle\"></avn-hamburger>\n  </div>\n\n  <!-- projection center menu items i.e search or other -->\n  <div class=\"area-wrapper\">\n    <ng-content select=\"[avnNavContent]\"></ng-content>\n  </div>\n\n  <!-- projection right -->\n  <div class=\"area-wrapper\">\n    <ng-content select=\"[avnNavElements]\"></ng-content>\n  </div>\n</div>\n", styles: [":host{z-index:999;box-shadow:0 3px 5px -1px #0003,0 6px 10px #0000000a,0 1px 4px #0000001a;height:100%;width:100%;position:relative;overflow:hidden;padding:0;display:grid;grid-template-columns:100%;grid-template-rows:100%;align-items:center}:host .detail-top-nav{position:absolute;inset:0;opacity:0;background-color:var(--topnav-background);color:var(--topnav-on);display:flex;align-items:center;pointer-events:none;transform:translate(-100%) scale(0);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host .detail-top-nav.visible{opacity:1;pointer-events:auto;transform:translate(0) scale(1)}:host .detail-top-nav .back-button{background:var(--topnav-variant-background);border-radius:50%;padding:var(--space-xs)}:host .detail-top-nav .detail-title{margin:0}:host .regular-top-nav{height:100%;width:100%;padding:0;display:grid;grid-template-columns:max-content max-content 1fr max-content;grid-template-rows:100%;align-items:center;background-color:var(--topnav-background);color:var(--topnav-on);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms;opacity:1}:host .regular-top-nav:not(.visible){opacity:0;transform:translate(100%)}:host .regular-top-nav .area-wrapper{height:100%;width:100%;display:flex;align-items:center;justify-content:center}:host .regular-top-nav:hover{box-shadow:0 3px 5px -1px #0003,0 6px 10px #0000000a,0 1px 4px #0000001a!important}:host .regular-top-nav .sidenav-toggle{display:block}:host .regular-top-nav ::ng-deep *[avnNavContent]{display:flex;justify-content:center;overflow:hidden}:host .regular-top-nav ::ng-deep *[avnNavElements]{height:100%;display:flex;justify-content:flex-end;align-items:center}:host .regular-top-nav ::ng-deep *[avnNavElements]:last-child{margin-right:var(--space-lg)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: HamburgerComponent, selector: "avn-hamburger" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TopnavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-topnav', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"detail-top-nav\" [class.visible]=\"model.topNavDetailTitle\">\n  <div style=\"display: grid; grid-auto-flow: column; grid-auto-columns: max-content; grid-column-gap: var(--space-base); align-items: center; padding: var(--space-base)\">\n    <avn-icon *ngIf=\"model.topNavDetailBackIcon\" class=\"back-button\" [icon]=\"'navigation:arrow_back'\" (click)=\"navigateBack()\"></avn-icon>\n    <h4 class=\"detail-title\">{{ model.topNavDetailTitle }}</h4>\n  </div>\n</div>\n\n<div class=\"regular-top-nav\" [class.visible]=\"!model.topNavDetailTitle\">\n  <!-- Topnav title / logo area -->\n  <div class=\"area-wrapper\">\n    <ng-content select=\"[avnNavHeader]\"></ng-content>\n  </div>\n\n  <!-- Hamburger menu -->\n  <div class=\"area-wrapper\">\n    <avn-hamburger *ngIf=\"model.showSideNavToggle\"></avn-hamburger>\n  </div>\n\n  <!-- projection center menu items i.e search or other -->\n  <div class=\"area-wrapper\">\n    <ng-content select=\"[avnNavContent]\"></ng-content>\n  </div>\n\n  <!-- projection right -->\n  <div class=\"area-wrapper\">\n    <ng-content select=\"[avnNavElements]\"></ng-content>\n  </div>\n</div>\n", styles: [":host{z-index:999;box-shadow:0 3px 5px -1px #0003,0 6px 10px #0000000a,0 1px 4px #0000001a;height:100%;width:100%;position:relative;overflow:hidden;padding:0;display:grid;grid-template-columns:100%;grid-template-rows:100%;align-items:center}:host .detail-top-nav{position:absolute;inset:0;opacity:0;background-color:var(--topnav-background);color:var(--topnav-on);display:flex;align-items:center;pointer-events:none;transform:translate(-100%) scale(0);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host .detail-top-nav.visible{opacity:1;pointer-events:auto;transform:translate(0) scale(1)}:host .detail-top-nav .back-button{background:var(--topnav-variant-background);border-radius:50%;padding:var(--space-xs)}:host .detail-top-nav .detail-title{margin:0}:host .regular-top-nav{height:100%;width:100%;padding:0;display:grid;grid-template-columns:max-content max-content 1fr max-content;grid-template-rows:100%;align-items:center;background-color:var(--topnav-background);color:var(--topnav-on);transition:all .25s cubic-bezier(.2,1,.3,1) 0ms;opacity:1}:host .regular-top-nav:not(.visible){opacity:0;transform:translate(100%)}:host .regular-top-nav .area-wrapper{height:100%;width:100%;display:flex;align-items:center;justify-content:center}:host .regular-top-nav:hover{box-shadow:0 3px 5px -1px #0003,0 6px 10px #0000000a,0 1px 4px #0000001a!important}:host .regular-top-nav .sidenav-toggle{display:block}:host .regular-top-nav ::ng-deep *[avnNavContent]{display:flex;justify-content:center;overflow:hidden}:host .regular-top-nav ::ng-deep *[avnNavElements]{height:100%;display:flex;justify-content:flex-end;align-items:center}:host .regular-top-nav ::ng-deep *[avnNavElements]:last-child{margin-right:var(--space-lg)}\n"] }]
        }], ctorParameters: function () { return [{ type: LayoutStore }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { gridColumn: [{
                type: HostBinding,
                args: ['style.grid-column']
            }] } });

/**
 * Wrapper of all layout components.
 * Will compute the css grid layout based on available layout components.
 */
class LayoutComponent {
    set topNav(topNav) {
        this.layoutStore.setTopNavExists(!!topNav);
    }
    set sideNav(sideNav) {
        this.layoutStore.setSideNavExists(!!sideNav);
    }
    constructor(layoutStore, _changeDetector, 
    // inject the theme service so theme variables are auto generated when using the main layout
    themeService) {
        this.layoutStore = layoutStore;
        this._changeDetector = _changeDetector;
        this.themeService = themeService;
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this.layoutStore
            .select(this.layoutStore.select((layoutState) => layoutState.sideNavLayoutMode), this.layoutStore.select((layoutState) => layoutState.sideNavExists), this.layoutStore.select((layoutState) => layoutState.sideNavOpened), this.layoutStore.select((layoutState) => layoutState.sideNavVisibleWidthPx), this.layoutStore.select((layoutState) => layoutState.sideNavOverlayVisible), this.layoutStore.select((layoutState) => layoutState.settings.sideNavSettings.widthPx), this.layoutStore.layoutDimensions$, (sideNavMode, sideNavExists, sideNavOpened, sideNavVisibleWidthPx, sideNavOverlayVisible, sideNavWidthPx, { gridTemplateRows, gridTemplateColumns }) => {
            const ribbonOffsetPx = !sideNavExists ? 0 : sideNavWidthPx - sideNavVisibleWidthPx;
            const widthOffsetPx = sideNavMode === SideNavMode.OFF_CANVAS && sideNavOpened ? sideNavVisibleWidthPx : ribbonOffsetPx;
            return {
                gridTemplateRows,
                gridTemplateColumns,
                leftPx: -ribbonOffsetPx,
                width: `calc(100% + ${widthOffsetPx}px)`,
                sideNavOverlayVisible,
            };
        })
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    get gridTemplateRows() {
        return this.model.gridTemplateRows;
    }
    get gridTemplateColumns() {
        return this.model.gridTemplateColumns;
    }
    closeSideNav() {
        this.layoutStore.setSideNavOpened({ opened: false, source: TriggerSourceType.MAIN });
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutComponent, deps: [{ token: LayoutStore }, { token: i0.ChangeDetectorRef }, { token: ThemeService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: LayoutComponent, selector: "avn-layout", host: { properties: { "style.grid-template-rows": "this.gridTemplateRows", "style.grid-template-columns": "this.gridTemplateColumns" } }, providers: [LayoutStore], queries: [{ propertyName: "topNav", first: true, predicate: TopnavComponent, descendants: true }, { propertyName: "sideNav", first: true, predicate: SidenavComponent, descendants: true }], ngImport: i0, template: "<ng-content select=\"avn-topnav\"></ng-content>\n<ng-content select=\"avn-sidenav\"></ng-content>\n<div class=\"page-wrapper\" [style.left.px]=\"model.leftPx\" [style.width]=\"model.width\">\n  <ng-content select=\"avn-page\"> </ng-content>\n  <avn-overlay [fullPage]=\"false\" [visible]=\"model.sideNavOverlayVisible\" (click)=\"closeSideNav()\"></avn-overlay>\n  <!-- allow projection of any content in case of lazy loading with router outlet -->\n  <ng-content></ng-content>\n</div>\n", styles: [":host{width:100%;height:100%;display:grid;background-color:var(--main-background)}:host .page-wrapper{position:relative;overflow:hidden;transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host .page-wrapper ::ng-deep>*{height:100%}\n"], dependencies: [{ kind: "component", type: OverlayComponent, selector: "avn-overlay", inputs: ["visible", "fullPage"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-layout', changeDetection: ChangeDetectionStrategy.OnPush, providers: [LayoutStore], template: "<ng-content select=\"avn-topnav\"></ng-content>\n<ng-content select=\"avn-sidenav\"></ng-content>\n<div class=\"page-wrapper\" [style.left.px]=\"model.leftPx\" [style.width]=\"model.width\">\n  <ng-content select=\"avn-page\"> </ng-content>\n  <avn-overlay [fullPage]=\"false\" [visible]=\"model.sideNavOverlayVisible\" (click)=\"closeSideNav()\"></avn-overlay>\n  <!-- allow projection of any content in case of lazy loading with router outlet -->\n  <ng-content></ng-content>\n</div>\n", styles: [":host{width:100%;height:100%;display:grid;background-color:var(--main-background)}:host .page-wrapper{position:relative;overflow:hidden;transition:all .25s cubic-bezier(.2,1,.3,1) 0ms}:host .page-wrapper ::ng-deep>*{height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: LayoutStore }, { type: i0.ChangeDetectorRef }, { type: ThemeService }]; }, propDecorators: { topNav: [{
                type: ContentChild,
                args: [TopnavComponent, { static: false }]
            }], sideNav: [{
                type: ContentChild,
                args: [SidenavComponent, { static: false }]
            }], gridTemplateRows: [{
                type: HostBinding,
                args: ['style.grid-template-rows']
            }], gridTemplateColumns: [{
                type: HostBinding,
                args: ['style.grid-template-columns']
            }] } });

const NAV_TAB_BAR_INITIAL_STATE = {
    selectedItemId: null,
    itemWidthPx: 100,
    iconSizePx: 32,
    itemIds: [],
    itemHrefs: {},
    position: 'original',
    routeQueryParams: [],
};
class NavTabBarStore extends ComponentStore {
    constructor(_layoutStore) {
        super(NAV_TAB_BAR_INITIAL_STATE);
        this._layoutStore = _layoutStore;
        this.itemClicked = new EventEmitter();
        /********************************************************************************************************************
         * SELECTORS and GETTERS
         ********************************************************************************************************************/
        this.navTabBarPosition$ = this._layoutStore.select((state) => state.navTabBarPosition);
        this.navTabBarHeightPx$ = this._layoutStore.select((state) => state.settings.navTabBarSettings.heightPx);
        /********************************************************************************************************************
         * UPDATERS (aka. reducers)
         ********************************************************************************************************************/
        this.setSelectedItem = this.updater((state, selectedItemId) => ({
            ...state,
            selectedItemId,
        }));
        this.setItemWidthPx = this.updater((state, itemWidthPx) => ({
            ...state,
            itemWidthPx,
        }));
        this.setIconSizePx = this.updater((state, iconSizePx) => ({
            ...state,
            iconSizePx,
        }));
        this.registerItem = this.updater((state, itemId) => ({
            ...state,
            itemIds: Array.from(new Set([...state.itemIds, itemId])),
        }));
        this.registerItemHref = this.updater((state, payload) => ({
            ...state,
            itemHrefs: {
                ...state.itemHrefs,
                [payload.itemId]: payload.href,
            },
        }));
        this.setRouteQueryParams = this.updater((state, routeQueryParams) => ({
            ...state,
            routeQueryParams,
        }));
        this.setComputedHeightPx = this.updater((state, computedHeightPx) => ({
            ...state,
            computedHeightPx,
        }));
        /********************************************************************************************************************
         * EFFECTS
         ********************************************************************************************************************/
        /** Auto update the active item every time the route changes **/
        this.updateSelectedItemOnRouteChange = this.effect(() => this.select(this.select((state) => state.itemHrefs), this._layoutStore.currentRoute$.pipe(filter((currentUrl) => !!currentUrl)), (itemHrefs, currentUrl) => ({ itemHrefs, currentUrl })).pipe(tap(({ itemHrefs, currentUrl }) => {
            // remove any leading slash
            const { routeQueryParams } = this.get();
            const formattedUrl = urlStringToInternalFormat(currentUrl);
            const selectedItemId = this.getActiveItemId(formattedUrl, itemHrefs, routeQueryParams);
            this.patchState({ selectedItemId });
        })));
        /** Called when an item is clicked **/
        this.onItemClicked = this.effect((itemId$) => itemId$.pipe(tap((itemId) => {
            const itemHref = this.get().itemHrefs[itemId];
            this.itemClicked.emit({
                id: itemId,
                href: itemHref,
            });
        })));
        this._layoutStore.setNavTabBarExists(true);
    }
    /** @ignore get the item whose href matches the current url **/
    getActiveItemId(currentUrl, itemHrefs, routeQueryParams) {
        const currentUrlParamsMatching = Object.keys(currentUrl.params).filter((name) => routeQueryParams.includes(name));
        const activeItem = Object.entries(itemHrefs).find(([_, itemHref]) => {
            if (itemHref) {
                const formattedUrl = urlToInternalFormat(itemHref);
                if (currentUrl.url.startsWith(formattedUrl.url)) {
                    if (currentUrlParamsMatching.length === 0) {
                        return true;
                    }
                    return currentUrlParamsMatching.every((paramName) => currentUrl.params[paramName] === formattedUrl.params[paramName]);
                }
            }
            return false;
        });
        return activeItem?.[0] || null;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this._layoutStore.setNavTabBarExists(false);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarStore, deps: [{ token: LayoutStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: LayoutStore }]; } });

class NavTabBarComponent {
    /**
     *  Unique query params that allows to differentiate identical url paths leading to different components
     *  e.g. a legacy component that displays an iframe could use a query param 'module' to set the actual page to display
     *  however the path will always be /app/legacy?module=xxx
     * *
     */
    set routeQueryParams(routeQueryParams) {
        this._navTabBarStore.setRouteQueryParams(routeQueryParams);
    }
    /** Sets the selected item. Use this when route binding is not used to set the initially selected item **/
    set selectedItem(selectedItem) {
        this._navTabBarStore.setSelectedItem(selectedItem);
    }
    constructor(_navTabBarStore, _changeDetector) {
        this._navTabBarStore = _navTabBarStore;
        this._changeDetector = _changeDetector;
        /** When true, the nav tab bar will always be centered in the top nav, ignoring other top nav elements on the left and right sides **/
        this.keepCenteredInTopNav = true;
        /** Emits the href of the nav item clicked **/
        this.itemClicked = this._navTabBarStore.itemClicked;
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this._navTabBarStore
            .select(this._navTabBarStore.navTabBarPosition$, this._navTabBarStore.navTabBarHeightPx$, (position, heightPx) => ({
            position,
            heightPx,
        }))
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    /** Sets the width in px of the nav items **/
    set itemWidthPx(itemWidthPx) {
        this._navTabBarStore.setItemWidthPx(itemWidthPx);
    }
    /** Sets the width in px of the nav items **/
    set iconSizePx(iconSizePx) {
        this._navTabBarStore.setIconSizePx(iconSizePx);
    }
    get gridTemplateRows() {
        return this.model.heightPx;
    }
    get getClass() {
        return this.model.position;
    }
    get topNavCentered() {
        return this.keepCenteredInTopNav && this.model.position === 'original';
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarComponent, deps: [{ token: NavTabBarStore }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: NavTabBarComponent, selector: "avn-nav-tab-bar", inputs: { routeQueryParams: "routeQueryParams", keepCenteredInTopNav: "keepCenteredInTopNav", selectedItem: "selectedItem", itemWidthPx: "itemWidthPx", iconSizePx: "iconSizePx" }, outputs: { itemClicked: "itemClicked" }, host: { properties: { "style.height.px": "this.gridTemplateRows", "class": "this.getClass", "class.top-nav-centered": "this.topNavCentered" } }, providers: [NavTabBarStore], ngImport: i0, template: "<ng-content select=\"a, avn-nav-tab-bar-item\"></ng-content>\n", styles: [":host{padding-top:var(--space-sm);height:100%;display:grid;grid-auto-flow:column;-webkit-user-select:none;user-select:none;background-color:var(--topnav-background)}:host.bottom{padding-top:0;position:fixed;bottom:0;left:0;right:0;border-top:1px solid var(--ribbon-background)}:host.hidden{display:none}:host.top-nav-centered{position:absolute;top:0;left:50%;transform:translate(-50%)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-nav-tab-bar', changeDetection: ChangeDetectionStrategy.OnPush, providers: [NavTabBarStore], template: "<ng-content select=\"a, avn-nav-tab-bar-item\"></ng-content>\n", styles: [":host{padding-top:var(--space-sm);height:100%;display:grid;grid-auto-flow:column;-webkit-user-select:none;user-select:none;background-color:var(--topnav-background)}:host.bottom{padding-top:0;position:fixed;bottom:0;left:0;right:0;border-top:1px solid var(--ribbon-background)}:host.hidden{display:none}:host.top-nav-centered{position:absolute;top:0;left:50%;transform:translate(-50%)}\n"] }]
        }], ctorParameters: function () { return [{ type: NavTabBarStore }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { routeQueryParams: [{
                type: Input
            }], keepCenteredInTopNav: [{
                type: Input
            }], selectedItem: [{
                type: Input
            }], itemClicked: [{
                type: Output
            }], itemWidthPx: [{
                type: Input
            }], iconSizePx: [{
                type: Input
            }], gridTemplateRows: [{
                type: HostBinding,
                args: ['style.height.px']
            }], getClass: [{
                type: HostBinding,
                args: ['class']
            }], topNavCentered: [{
                type: HostBinding,
                args: ['class.top-nav-centered']
            }] } });

class NavTabBarItemComponent {
    /** href for the item (could be any data), but usually will be similar to what routerLink directive data **/
    set href(href) {
        this._navTabBarStore.registerItemHref({ itemId: this.id, href });
    }
    constructor(_navTabBarStore, _changeDetector) {
        this._navTabBarStore = _navTabBarStore;
        this._changeDetector = _changeDetector;
        /** Unique id for the item **/
        this.id = v4();
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this._navTabBarStore
            .select(this._navTabBarStore.select((tabBarState) => tabBarState.itemWidthPx), this._navTabBarStore.select((tabBarState) => tabBarState.iconSizePx), this._navTabBarStore.select((tabBarState) => tabBarState.selectedItemId), this._navTabBarStore.navTabBarPosition$, this._navTabBarStore.select((tabBarState) => tabBarState.itemIds), (itemWidthPx, iconSizePx, selectedItemId, position, _) => ({
            itemWidthPx: position === 'bottom' ? null : itemWidthPx,
            iconSizePx: this.customIconSizePx ? this.customIconSizePx : iconSizePx,
            selected: selectedItemId === this.id,
            position,
        }))
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((model) => {
            this.model = model;
            this._changeDetector.markForCheck();
        });
    }
    ngOnInit() {
        // register the item to the store
        this._navTabBarStore.registerItem(this.id);
    }
    selectItem(id) {
        this._navTabBarStore.setSelectedItem(id);
        this._navTabBarStore.onItemClicked(id);
    }
    get selected() {
        return this.model.selected;
    }
    get getClass() {
        return this.model.position;
    }
    get itemWidthPx() {
        return this.model.itemWidthPx;
    }
    onClick() {
        this.selectItem(this.id);
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarItemComponent, deps: [{ token: NavTabBarStore }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: NavTabBarItemComponent, selector: "avn-nav-tab-bar-item", inputs: { icon: "icon", label: "label", customIconSizePx: "customIconSizePx", href: "href", id: "id" }, host: { listeners: { "click": "onClick()" }, properties: { "class.selected": "this.selected", "class": "this.getClass", "style.width.px": "this.itemWidthPx" } }, ngImport: i0, template: "<avn-icon *ngIf=\"icon\" [icon]=\"icon\" [fontSize]=\"model.iconSizePx\"> </avn-icon>\n<span *ngIf=\"label\">\n  {{ label }}\n</span>\n<div class=\"line\"></div>\n", styles: [":host{height:100%;display:grid;grid-auto-flow:row;grid-row-gap:var(--space-xs);grid-template-rows:1fr min-content;cursor:pointer}:host avn-icon{align-items:center;transition:color .15s cubic-bezier(0,0,.2,1);color:var(--nav-tab-bar-color)}:host .line{height:4px;border-top-left-radius:3px;border-top-right-radius:3px;transition:background-color .15s cubic-bezier(0,0,.2,1)}:host.bottom{grid-template-rows:min-content 1fr}:host.bottom avn-icon{order:2}:host.bottom .line{order:1;border-radius:0 0 3px 3px/0px 0px 3px 3px}:host.selected avn-icon{color:var(--nav-tab-bar-selected-color)}:host.selected .line{background-color:var(--nav-tab-bar-selected-color)}:host:hover avn-icon{color:var(--nav-tab-bar-selected-color)}:host-context(.active) avn-icon{color:var(--nav-tab-bar-selected-color)!important}:host-context(.active) .line{background-color:var(--nav-tab-bar-selected-color)}:host-context(.dmb-aspect) avn-icon{max-height:35px}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-nav-tab-bar-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-icon *ngIf=\"icon\" [icon]=\"icon\" [fontSize]=\"model.iconSizePx\"> </avn-icon>\n<span *ngIf=\"label\">\n  {{ label }}\n</span>\n<div class=\"line\"></div>\n", styles: [":host{height:100%;display:grid;grid-auto-flow:row;grid-row-gap:var(--space-xs);grid-template-rows:1fr min-content;cursor:pointer}:host avn-icon{align-items:center;transition:color .15s cubic-bezier(0,0,.2,1);color:var(--nav-tab-bar-color)}:host .line{height:4px;border-top-left-radius:3px;border-top-right-radius:3px;transition:background-color .15s cubic-bezier(0,0,.2,1)}:host.bottom{grid-template-rows:min-content 1fr}:host.bottom avn-icon{order:2}:host.bottom .line{order:1;border-radius:0 0 3px 3px/0px 0px 3px 3px}:host.selected avn-icon{color:var(--nav-tab-bar-selected-color)}:host.selected .line{background-color:var(--nav-tab-bar-selected-color)}:host:hover avn-icon{color:var(--nav-tab-bar-selected-color)}:host-context(.active) avn-icon{color:var(--nav-tab-bar-selected-color)!important}:host-context(.active) .line{background-color:var(--nav-tab-bar-selected-color)}:host-context(.dmb-aspect) avn-icon{max-height:35px}\n"] }]
        }], ctorParameters: function () { return [{ type: NavTabBarStore }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { icon: [{
                type: Input
            }], label: [{
                type: Input
            }], customIconSizePx: [{
                type: Input
            }], href: [{
                type: Input
            }], id: [{
                type: Input
            }], selected: [{
                type: HostBinding,
                args: ['class.selected']
            }], getClass: [{
                type: HostBinding,
                args: ['class']
            }], itemWidthPx: [{
                type: HostBinding,
                args: ['style.width.px']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Apply this directive on a nav tab bar component to make it responsive.
 * It will show the nav as a bottom navigation bar for handsets and tablets
 */
class NavTabBarResponsiveDirective {
    constructor(_elementRef, _layoutStore, _mediaBreakpointStore) {
        this._elementRef = _elementRef;
        this._layoutStore = _layoutStore;
        this._mediaBreakpointStore = _mediaBreakpointStore;
        this._componentDestroyed$ = new Subject();
        // hide the tab bar to avoid a flicker for the initial position, the time the available space is calculated
        this._layoutStore.patchState({ navTabBarPosition: 'hidden' });
        this._mediaBreakpointStore.breakpoint$.subscribe((breakpoint) => {
            const navTabBarPosition = [LayoutDeviceType.HANDSET, LayoutDeviceType.TABLET].includes(breakpoint) ? 'bottom' : 'original';
            this._layoutStore.patchState({ navTabBarPosition });
        });
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarResponsiveDirective, deps: [{ token: i0.ElementRef }, { token: LayoutStore }, { token: MediaBreakpointStore }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: NavTabBarResponsiveDirective, selector: "avn-nav-tab-bar[avnNavTabBarResponsive]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NavTabBarResponsiveDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'avn-nav-tab-bar[avnNavTabBarResponsive]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: LayoutStore }, { type: MediaBreakpointStore }]; } });

class LayoutModule {
    static forRoot(settings) {
        return {
            ngModule: LayoutModule,
            providers: [
                {
                    provide: LAYOUT_SETTINGS,
                    useValue: !settings ? DEFAULT_LAYOUT_SETTINGS : getInitialLayoutSettings(settings),
                },
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: LayoutModule, declarations: [TopnavComponent,
            SidenavComponent,
            HamburgerComponent,
            MainComponent,
            RibbonComponent,
            RibbonActionsComponent,
            RibbonFacetsComponent,
            RibbonCardComponent,
            RibbonAlternateContentComponent,
            RibbonContentComponent,
            NavContentDirective,
            NavComponent,
            NavItemComponent,
            ShowForDevicesDirective,
            HideForDevicesDirective,
            ResponsiveElementDirective,
            TopnavTitleComponent,
            GridComponent,
            GridElementDirective,
            BreadcrumbsComponent,
            BreadcrumbComponent,
            TreeSidebarComponent,
            SidebarItemComponent,
            PageComponent,
            LayoutComponent,
            NavTabBarComponent,
            NavTabBarItemComponent,
            NavTabBarResponsiveDirective,
            RibbonMobileComponent,
            RibbonFacetsBottomSheetComponent,
            RibbonDisplayItemDirective], imports: [CommonModule,
            CoreModule,
            IconModule,
            ModalModule,
            TooltipModule,
            FabSpeedDialModule,
            DropdownModule,
            OptionModule,
            SelectModule,
            ButtonModule,
            ConnectedElementModule,
            OverlayModule$1,
            OverlayModule,
            BadgeModule,
            PortalModule], exports: [TopnavComponent,
            SidenavComponent,
            HamburgerComponent,
            MainComponent,
            RibbonComponent,
            RibbonActionsComponent,
            RibbonFacetsComponent,
            RibbonCardComponent,
            RibbonAlternateContentComponent,
            RibbonContentComponent,
            NavContentDirective,
            NavComponent,
            NavItemComponent,
            ShowForDevicesDirective,
            HideForDevicesDirective,
            ResponsiveElementDirective,
            TopnavTitleComponent,
            GridComponent,
            GridElementDirective,
            BreadcrumbsComponent,
            BreadcrumbComponent,
            SidebarItemComponent,
            TreeSidebarComponent,
            PageComponent,
            LayoutComponent,
            NavTabBarComponent,
            NavTabBarItemComponent,
            NavTabBarResponsiveDirective,
            RibbonDisplayItemDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutModule, imports: [CommonModule,
            CoreModule,
            IconModule,
            ModalModule,
            TooltipModule,
            FabSpeedDialModule,
            DropdownModule,
            OptionModule,
            SelectModule,
            ButtonModule,
            ConnectedElementModule,
            OverlayModule$1,
            OverlayModule,
            BadgeModule,
            PortalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CoreModule,
                        IconModule,
                        ModalModule,
                        TooltipModule,
                        FabSpeedDialModule,
                        DropdownModule,
                        OptionModule,
                        SelectModule,
                        ButtonModule,
                        ConnectedElementModule,
                        OverlayModule$1,
                        OverlayModule,
                        BadgeModule,
                        PortalModule,
                    ],
                    declarations: [
                        TopnavComponent,
                        SidenavComponent,
                        HamburgerComponent,
                        MainComponent,
                        RibbonComponent,
                        RibbonActionsComponent,
                        RibbonFacetsComponent,
                        RibbonCardComponent,
                        RibbonAlternateContentComponent,
                        RibbonContentComponent,
                        NavContentDirective,
                        NavComponent,
                        NavItemComponent,
                        ShowForDevicesDirective,
                        HideForDevicesDirective,
                        ResponsiveElementDirective,
                        TopnavTitleComponent,
                        GridComponent,
                        GridElementDirective,
                        BreadcrumbsComponent,
                        BreadcrumbComponent,
                        TreeSidebarComponent,
                        SidebarItemComponent,
                        PageComponent,
                        LayoutComponent,
                        NavTabBarComponent,
                        NavTabBarItemComponent,
                        NavTabBarResponsiveDirective,
                        RibbonMobileComponent,
                        RibbonFacetsBottomSheetComponent,
                        RibbonDisplayItemDirective,
                    ],
                    exports: [
                        TopnavComponent,
                        SidenavComponent,
                        HamburgerComponent,
                        MainComponent,
                        RibbonComponent,
                        RibbonActionsComponent,
                        RibbonFacetsComponent,
                        RibbonCardComponent,
                        RibbonAlternateContentComponent,
                        RibbonContentComponent,
                        NavContentDirective,
                        NavComponent,
                        NavItemComponent,
                        ShowForDevicesDirective,
                        HideForDevicesDirective,
                        ResponsiveElementDirective,
                        TopnavTitleComponent,
                        GridComponent,
                        GridElementDirective,
                        BreadcrumbsComponent,
                        BreadcrumbComponent,
                        SidebarItemComponent,
                        TreeSidebarComponent,
                        PageComponent,
                        LayoutComponent,
                        NavTabBarComponent,
                        NavTabBarItemComponent,
                        NavTabBarResponsiveDirective,
                        RibbonDisplayItemDirective,
                    ],
                }]
        }] });

/** Top nav height in pixel */
const TOP_NAV_HEIGHT = 50;
/** Ribbon height in pixel */
const RIBBON_HEIGHT = 75;

class StepperModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: StepperModule, declarations: [StepperComponent,
            StepperStepComponent,
            StepperStepLabelDirective,
            StepperButtonNextDirective,
            StepperButtonPreviousDirective,
            StepperButtonCompleteDirective,
            StepperButtonCancelDirective,
            StepperStepHeaderComponent], imports: [CommonModule, IconModule, CdkStepperModule], exports: [StepperComponent,
            StepperStepComponent,
            StepperStepLabelDirective,
            StepperButtonNextDirective,
            StepperButtonPreviousDirective,
            StepperButtonCompleteDirective,
            StepperButtonCancelDirective,
            StepperStepHeaderComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperModule, imports: [CommonModule, IconModule, CdkStepperModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: StepperModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, CdkStepperModule],
                    exports: [
                        StepperComponent,
                        StepperStepComponent,
                        StepperStepLabelDirective,
                        StepperButtonNextDirective,
                        StepperButtonPreviousDirective,
                        StepperButtonCompleteDirective,
                        StepperButtonCancelDirective,
                        StepperStepHeaderComponent,
                    ],
                    declarations: [
                        StepperComponent,
                        StepperStepComponent,
                        StepperStepLabelDirective,
                        StepperButtonNextDirective,
                        StepperButtonPreviousDirective,
                        StepperButtonCompleteDirective,
                        StepperButtonCancelDirective,
                        StepperStepHeaderComponent,
                    ],
                    providers: [],
                }]
        }] });

/**
 * This event is emitted when a stepper is cancelled
 */
class IStepperCancelledEvent {
}

/**
 * This event is emitted when a stepper is completed
 */
class IStepperCompletedEvent {
}

/**
 * This event is emitted when a step in the stepper changes
 */
class IStepperStepChangedEvent {
}

class SlideDialogModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SlideDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SlideDialogModule, declarations: [SlideDialogComponent], imports: [CommonModule, CoreModule, StepperModule, ButtonModule, IconModule, ModalModule], exports: [SlideDialogComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SlideDialogModule, imports: [CommonModule, CoreModule, StepperModule, ButtonModule, IconModule, ModalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SlideDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, StepperModule, ButtonModule, IconModule, ModalModule],
                    declarations: [SlideDialogComponent],
                    exports: [SlideDialogComponent]
                }]
        }] });

var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength["WEAK"] = "weak";
    PasswordStrength["MEDIUM"] = "medium";
    PasswordStrength["MAX"] = "max";
})(PasswordStrength || (PasswordStrength = {}));

var PasswordValidationItem;
(function (PasswordValidationItem) {
    PasswordValidationItem["LENGTH"] = "length";
    PasswordValidationItem["NUMBER"] = "number";
    PasswordValidationItem["LOWER_CASE"] = "lowerCase";
    PasswordValidationItem["UPPER_CASE"] = "upperCase";
    PasswordValidationItem["SPECIAL_CHAR"] = "specialChar";
    PasswordValidationItem["SOME_REQUIRED"] = "someRequired";
})(PasswordValidationItem || (PasswordValidationItem = {}));

class PasswordIndicatorComponent {
    constructor() {
        /** password messages */
        this.messages = [];
        /** password messages*/
        this.passwordRowState = {};
        this.themeType = ThemeType;
    }
    showOptionIcon(message) {
        return this.noValue() || (this.secondLevelMessage(message) && this.passwordRowState[PasswordValidationItem.SOME_REQUIRED]);
    }
    showSuccessIcon(message) {
        return this.passwordRowState[message.type];
    }
    noValue() {
        return !this.value;
    }
    secondLevelMessage(message) {
        return message.nestedLevel === 'second';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PasswordIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: PasswordIndicatorComponent, selector: "avn-password-indicator", inputs: { strengthLevel: "strengthLevel", value: "value", messages: "messages", passwordRowState: "passwordRowState" }, ngImport: i0, template: "<div>\n  <div *ngFor=\"let message of messages\">\n    <div class=\"password-row\" [ngClass]=\"{ 'second-level': message.nestedLevel === 'second' }\" *ngIf=\"message.value\">\n      <ng-container *ngIf=\"showSuccessIcon(message); else showStateIcon\">\n        <avn-icon icon=\"action:check_circle\" fontSize=\"14\" [avnTheme]=\"themeType.SUCCESS\"></avn-icon>\n      </ng-container>\n      <ng-template #showStateIcon>\n        <ng-container *ngIf=\"showOptionIcon(message); else showErrorIcon\">\n          <avn-icon icon=\"content:remove\" fontSize=\"14\"></avn-icon>\n        </ng-container>\n        <ng-template #showErrorIcon>\n          <avn-icon icon=\"alert:error\" [fontSize]=\"14\" [avnTheme]=\"themeType.DANGER\"></avn-icon>\n        </ng-template>\n      </ng-template>\n      <span>{{ message.value }}</span>\n    </div>\n  </div>\n</div>\n", styles: [":host>div{background-color:var(--selection-component-background);color:var(--selection-component-on)}:host>div>div{height:40px;border-collapse:collapse;display:flex;align-items:center;justify-content:flex-start;padding:0 var(--space-md)}:host>div>div .password-row{display:flex;flex-flow:row nowrap;align-items:center;flex-grow:1;padding:var(--space-sm) 0}:host>div>div .password-row.second-level{margin-left:var(--space-lg)}:host>div>div .password-row>span{margin-left:var(--space-sm)}:host>div>div .qualified{color:var(--success-base)}:host>div>div .un-qualified{color:var(--danger-base)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PasswordIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-password-indicator', template: "<div>\n  <div *ngFor=\"let message of messages\">\n    <div class=\"password-row\" [ngClass]=\"{ 'second-level': message.nestedLevel === 'second' }\" *ngIf=\"message.value\">\n      <ng-container *ngIf=\"showSuccessIcon(message); else showStateIcon\">\n        <avn-icon icon=\"action:check_circle\" fontSize=\"14\" [avnTheme]=\"themeType.SUCCESS\"></avn-icon>\n      </ng-container>\n      <ng-template #showStateIcon>\n        <ng-container *ngIf=\"showOptionIcon(message); else showErrorIcon\">\n          <avn-icon icon=\"content:remove\" fontSize=\"14\"></avn-icon>\n        </ng-container>\n        <ng-template #showErrorIcon>\n          <avn-icon icon=\"alert:error\" [fontSize]=\"14\" [avnTheme]=\"themeType.DANGER\"></avn-icon>\n        </ng-template>\n      </ng-template>\n      <span>{{ message.value }}</span>\n    </div>\n  </div>\n</div>\n", styles: [":host>div{background-color:var(--selection-component-background);color:var(--selection-component-on)}:host>div>div{height:40px;border-collapse:collapse;display:flex;align-items:center;justify-content:flex-start;padding:0 var(--space-md)}:host>div>div .password-row{display:flex;flex-flow:row nowrap;align-items:center;flex-grow:1;padding:var(--space-sm) 0}:host>div>div .password-row.second-level{margin-left:var(--space-lg)}:host>div>div .password-row>span{margin-left:var(--space-sm)}:host>div>div .qualified{color:var(--success-base)}:host>div>div .un-qualified{color:var(--danger-base)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { strengthLevel: [{
                type: Input
            }], value: [{
                type: Input
            }], messages: [{
                type: Input
            }], passwordRowState: [{
                type: Input
            }] } });

class PasswordInputComponent extends FormControlComponent {
    get isDisabled() {
        return this.disabled;
    }
    constructor(ngControl, changeDetector) {
        super(ngControl, changeDetector);
        /** debounce time for password input to trigger validation when value changes*/
        this.debounceTimeMs = 100;
        /** input value */
        this.value = '';
        /** strength 1 to 5 map to 5 indicator bar*/
        this.passStrength = 0;
        /** each indicator's state */
        this.passwordRowState = {};
        this.valid = false;
        this.componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        this.measurePasswordStrengthOnKeyUp();
        this.initializeTouchOnBlur();
        if (this.strengthSpec && this.value) {
            this.passStrength = this.measureStrength(this.value);
        }
    }
    ngOnChanges({ value, strengthSpec }) {
        if (value?.currentValue || value?.currentValue === '') {
            this.passStrength = this.measureStrength(value.currentValue);
        }
        if (strengthSpec && this.value) {
            this.passStrength = this.measureStrength(this.value);
        }
    }
    updateValue(value) {
        this.value = value;
    }
    propagate($event) {
        if ($event) {
            this.valid = true;
        }
        else {
            this.valid = false;
        }
        // do not propargate when it's just initialized, to avoid form validation at initial stage.
        if (!(this.formControl && this.formControl.pristine && this.formControl.untouched)) {
            setTimeout(() => {
                if ($event) {
                    this.propagateChange(this.value);
                }
                else {
                    this.propagateChange(undefined);
                }
            }, 1);
        }
    }
    get isPasswordWeak() {
        return !this.valid && this.value;
    }
    get isWeakForPasswordStrengthGreaterThanOne() {
        return this.isPasswordWeak && this.passStrength > 1;
    }
    get isWeakForPasswordStrengthThree() {
        return this.isPasswordWeak && this.passStrength === 3;
    }
    get isValidForPasswordStrengthGreaterThanOne() {
        return this.valid && this.passStrength > 1;
    }
    get isValidForPasswordStrengthTwoOrThree() {
        return this.valid && this.passStrength < 4 && this.passStrength > 1;
    }
    get isValidForPasswordStrengthThree() {
        return this.valid && this.passStrength === 3;
    }
    get isValidForPasswordStrengthGreaterThanThree() {
        return this.valid && this.passStrength > 3;
    }
    get isValidForPasswordStrengthGreaterThanFour() {
        return this.valid && this.passStrength > 4;
    }
    get isValidForPasswordStrengthLessThanFour() {
        return this.valid && this.passStrength < 4;
    }
    get passwordStrengthCategoryMessage() {
        return this.passStrength > 3
            ? this.messages.labelIndicator.max
            : this.passStrength > 2
                ? this.messages.labelIndicator.medium
                : this.value && this.valid
                    ? this.messages.labelIndicator.weak
                    : !this.value
                        ? ''
                        : this.messages.labelIndicator.error;
    }
    measureStrength(pass) {
        this.passwordRowState = {};
        if (pass === '' || pass === undefined) {
            this.propagateChange(undefined);
            this.valid = false;
            return undefined;
        }
        this.updatePasswordIndicator(PasswordValidationItem.LENGTH, null, pass.length);
        let count = 0;
        if (/\d/.test(pass)) {
            count++;
            this.updatePasswordIndicator(PasswordValidationItem.NUMBER);
        }
        if (/[a-z]/.test(pass)) {
            count++;
            this.updatePasswordIndicator(PasswordValidationItem.LOWER_CASE);
        }
        if (/[A-Z]/.test(pass)) {
            count++;
            this.updatePasswordIndicator(PasswordValidationItem.UPPER_CASE);
        }
        if (RegExp(`[${this.strengthSpec.specialCharAllowed}]`).test(pass)) {
            count++;
            this.updatePasswordIndicator(PasswordValidationItem.SPECIAL_CHAR);
        }
        this.updatePasswordIndicator(PasswordValidationItem.SOME_REQUIRED, count);
        this.validate(pass.length, count);
        if (!this.passwordRowState[PasswordValidationItem.LENGTH]) {
            return 1;
        }
        else {
            if (count < this.strengthSpec.weakTypeLimit) {
                return 1;
            }
            else if (this.strengthSpec.weakTypeLimit <= count && count < this.strengthSpec.mediumTypeLimit) {
                return 2;
            }
            else if (count === this.strengthSpec.mediumTypeLimit) {
                return 3;
            }
            else if (this.strengthSpec.mediumTypeLimit < count && count <= this.strengthSpec.maxTypeLimit) {
                return 4;
            }
            else {
                return 5;
            }
        }
    }
    validate(length, count) {
        switch (this.strengthSpec.level) {
            case PasswordStrength.WEAK: {
                if (length >= this.strengthSpec.weakLengthLimit && length <= this.strengthSpec.maxLength && count >= this.strengthSpec.weakTypeLimit) {
                    this.propagate(true);
                }
                else {
                    this.propagate(false);
                }
                break;
            }
            case PasswordStrength.MEDIUM: {
                if (length >= this.strengthSpec.mediumLengthLimit && length <= this.strengthSpec.maxLength && count >= this.strengthSpec.mediumTypeLimit) {
                    this.propagate(true);
                }
                else {
                    this.propagate(false);
                }
                break;
            }
            case PasswordStrength.MAX: {
                if (length >= this.strengthSpec.maxLengthLimit && length <= this.strengthSpec.maxLength && count >= this.strengthSpec.maxTypeLimit) {
                    this.propagate(true);
                }
                else {
                    this.propagate(false);
                }
                break;
            }
            default:
                break;
        }
    }
    updatePasswordIndicator(key, count, length) {
        switch (key) {
            case PasswordValidationItem.LENGTH: {
                switch (this.strengthSpec.level) {
                    case PasswordStrength.WEAK: {
                        if (length >= this.strengthSpec.weakLengthLimit && length <= this.strengthSpec.maxLength) {
                            this.passwordRowState[PasswordValidationItem.LENGTH] = true;
                        }
                        break;
                    }
                    case PasswordStrength.MEDIUM: {
                        if (length >= this.strengthSpec.mediumLengthLimit && length <= this.strengthSpec.maxLength) {
                            this.passwordRowState[PasswordValidationItem.LENGTH] = true;
                        }
                        break;
                    }
                    case PasswordStrength.MAX: {
                        if (length >= this.strengthSpec.maxLengthLimit && length <= this.strengthSpec.maxLength) {
                            this.passwordRowState[PasswordValidationItem.LENGTH] = true;
                        }
                        break;
                    }
                }
                break;
            }
            case PasswordValidationItem.NUMBER: {
                this.passwordRowState[PasswordValidationItem.NUMBER] = true;
                break;
            }
            case PasswordValidationItem.LOWER_CASE: {
                this.passwordRowState[PasswordValidationItem.LOWER_CASE] = true;
                break;
            }
            case PasswordValidationItem.UPPER_CASE: {
                this.passwordRowState[PasswordValidationItem.UPPER_CASE] = true;
                break;
            }
            case PasswordValidationItem.SPECIAL_CHAR: {
                this.passwordRowState[PasswordValidationItem.SPECIAL_CHAR] = true;
                break;
            }
            case PasswordValidationItem.SOME_REQUIRED: {
                if (this.strengthSpec.level === PasswordStrength.WEAK) {
                    this.passwordRowState[PasswordValidationItem.SOME_REQUIRED] = true;
                }
                if (this.strengthSpec.level === PasswordStrength.MEDIUM) {
                    this.passwordRowState[PasswordValidationItem.SOME_REQUIRED] = count >= this.strengthSpec.mediumTypeLimit ? true : false;
                }
                if (this.strengthSpec.level === PasswordStrength.MAX) {
                    this.passwordRowState[PasswordValidationItem.SOME_REQUIRED] = count >= this.strengthSpec.maxTypeLimit ? true : false;
                }
                break;
            }
            default:
                break;
        }
    }
    measurePasswordStrengthOnKeyUp() {
        fromEvent(this.inputComponent.inputElement.nativeElement, 'keyup')
            .pipe(debounceTime(this.debounceTimeMs), takeUntil(this.componentDestroyed$))
            .subscribe((val) => {
            if (this.formControl && this.formControl.untouched) {
                this.onTouch();
            }
            this.value = val.target.value;
            this.passStrength = this.measureStrength(this.value);
            this.changeDetector.detectChanges();
        });
    }
    initializeTouchOnBlur() {
        // ng forms touch callback when blurred
        fromEvent(this.inputComponent.inputElement.nativeElement, 'blur')
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            this.onTouch();
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PasswordInputComponent, deps: [{ token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: PasswordInputComponent, selector: "avn-password-input", inputs: { label: "label", strengthSpec: "strengthSpec", debounceTimeMs: "debounceTimeMs", value: "value", messages: "messages" }, host: { properties: { "class.disabled": "this.isDisabled" } }, providers: [{ provide: FormControlComponent, useExisting: PasswordInputComponent }], viewQueries: [{ propertyName: "inputComponent", first: true, predicate: InputComponent, descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [avnDropdownTrigger]=\"dropdown\" [avnDropdownEnabled]=\"true\">\n  <avn-input type=\"password\" [label]=\"label\" [disabled]=\"disabled\" [value]=\"value\"> </avn-input>\n</div>\n<div id=\"strength\" #strength class=\"strength\">\n  <ul id=\"strengthBar\">\n    <li\n      class=\"point\"\n      [ngClass]=\"{\n        weak: isPasswordWeak,\n        medium: isValidForPasswordStrengthLessThanFour,\n        max: isValidForPasswordStrengthGreaterThanThree\n      }\"\n    ></li>\n    <li\n      class=\"point\"\n      [ngClass]=\"{\n        weak: isWeakForPasswordStrengthGreaterThanOne,\n        medium: isValidForPasswordStrengthTwoOrThree,\n        max: isValidForPasswordStrengthGreaterThanThree\n      }\"\n    ></li>\n    <li\n      class=\"point\"\n      [ngClass]=\"{\n        weak: isWeakForPasswordStrengthThree,\n        medium: isValidForPasswordStrengthThree,\n        max: isValidForPasswordStrengthGreaterThanThree\n      }\"\n    ></li>\n    <li class=\"point\" [ngClass]=\"{ max: isValidForPasswordStrengthGreaterThanThree }\"></li>\n    <li class=\"point\" [ngClass]=\"{ max: isValidForPasswordStrengthGreaterThanFour }\"></li>\n  </ul>\n  <span\n    [ngClass]=\"{\n      weak: isPasswordWeak,\n      medium: isValidForPasswordStrengthGreaterThanOne,\n      max: isValidForPasswordStrengthGreaterThanThree\n    }\"\n  >\n    {{passwordStrengthCategoryMessage}}</span>\n</div>\n<avn-dropdown #dropdown [dimensions]=\"{ bindWidthToTrigger: true, minWidth: 40 }\">\n  <avn-password-indicator\n          [value]=\"value\"\n          [strengthLevel]=\"strengthSpec.level\"\n          [messages]=\"messages.msgList\"\n          [passwordRowState]=\"passwordRowState\">\n  </avn-password-indicator>\n</avn-dropdown>\n", styles: [":host{width:80px}:host.disabled>.strength,:host:disabled>.strength{opacity:0}:host>label.disabled{opacity:.3}:host ::ng-deep avn-input input{min-width:220px}:host .strength{display:flex;justify-content:space-between;align-items:center;line-height:1rem;min-width:220px}:host .strength div{display:flex}:host .strength>span{height:14px;font-size:var(--text-sm);font-weight:400}:host .strength>.weak{color:var(--danger-base)}:host .strength>.medium{color:var(--warning-base)}:host .strength>.max{color:var(--success-base)}:host ul#strengthBar{display:flex;flex-direction:row;align-items:center;list-style:none;margin:0 var(--space-sm) 0 0;padding:0}:host ul#strengthBar>.weak{background-color:var(--danger-base)}:host ul#strengthBar>.medium{background-color:var(--warning-base)}:host ul#strengthBar>.max{background-color:var(--success-base)}:host .point:last{margin:0!important}:host .point{background:var(--main-on);border-radius:2px;display:inline-block;height:3px;margin-right:1px;width:28px}:host ::ng-deep avn-icon{align-items:center;width:15px;height:15px!important}:host.validation-theme.ng-valid.ng-touched avn-input ::ng-deep>input,:host.validation-theme.ng-valid.ng-dirty avn-input ::ng-deep>input{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched avn-input ::ng-deep>input,:host.validation-theme.ng-invalid.ng-dirty avn-input ::ng-deep>input{border-color:var(--danger-base)!important}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: InputComponent, selector: "avn-input", inputs: ["label", "debounceTime", "type", "showSpinButtonsForNumberInput", "min", "max", "placeholder", "value", "emitDistinctValueChange"], outputs: ["changed", "submitted"] }, { kind: "component", type: DropdownComponent, selector: "avn-dropdown", inputs: ["closeOnClick", "xPosition", "yPosition", "class", "dimensions"], outputs: ["close"] }, { kind: "directive", type: DropdownTriggerDirective, selector: "[avnDropdownTrigger]", inputs: ["avnDropdownTrigger", "avnDropdownEnabled"], outputs: ["avnDropdownOpened"] }, { kind: "component", type: PasswordIndicatorComponent, selector: "avn-password-indicator", inputs: ["strengthLevel", "value", "messages", "passwordRowState"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PasswordInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-password-input', providers: [{ provide: FormControlComponent, useExisting: PasswordInputComponent }], template: "<div [avnDropdownTrigger]=\"dropdown\" [avnDropdownEnabled]=\"true\">\n  <avn-input type=\"password\" [label]=\"label\" [disabled]=\"disabled\" [value]=\"value\"> </avn-input>\n</div>\n<div id=\"strength\" #strength class=\"strength\">\n  <ul id=\"strengthBar\">\n    <li\n      class=\"point\"\n      [ngClass]=\"{\n        weak: isPasswordWeak,\n        medium: isValidForPasswordStrengthLessThanFour,\n        max: isValidForPasswordStrengthGreaterThanThree\n      }\"\n    ></li>\n    <li\n      class=\"point\"\n      [ngClass]=\"{\n        weak: isWeakForPasswordStrengthGreaterThanOne,\n        medium: isValidForPasswordStrengthTwoOrThree,\n        max: isValidForPasswordStrengthGreaterThanThree\n      }\"\n    ></li>\n    <li\n      class=\"point\"\n      [ngClass]=\"{\n        weak: isWeakForPasswordStrengthThree,\n        medium: isValidForPasswordStrengthThree,\n        max: isValidForPasswordStrengthGreaterThanThree\n      }\"\n    ></li>\n    <li class=\"point\" [ngClass]=\"{ max: isValidForPasswordStrengthGreaterThanThree }\"></li>\n    <li class=\"point\" [ngClass]=\"{ max: isValidForPasswordStrengthGreaterThanFour }\"></li>\n  </ul>\n  <span\n    [ngClass]=\"{\n      weak: isPasswordWeak,\n      medium: isValidForPasswordStrengthGreaterThanOne,\n      max: isValidForPasswordStrengthGreaterThanThree\n    }\"\n  >\n    {{passwordStrengthCategoryMessage}}</span>\n</div>\n<avn-dropdown #dropdown [dimensions]=\"{ bindWidthToTrigger: true, minWidth: 40 }\">\n  <avn-password-indicator\n          [value]=\"value\"\n          [strengthLevel]=\"strengthSpec.level\"\n          [messages]=\"messages.msgList\"\n          [passwordRowState]=\"passwordRowState\">\n  </avn-password-indicator>\n</avn-dropdown>\n", styles: [":host{width:80px}:host.disabled>.strength,:host:disabled>.strength{opacity:0}:host>label.disabled{opacity:.3}:host ::ng-deep avn-input input{min-width:220px}:host .strength{display:flex;justify-content:space-between;align-items:center;line-height:1rem;min-width:220px}:host .strength div{display:flex}:host .strength>span{height:14px;font-size:var(--text-sm);font-weight:400}:host .strength>.weak{color:var(--danger-base)}:host .strength>.medium{color:var(--warning-base)}:host .strength>.max{color:var(--success-base)}:host ul#strengthBar{display:flex;flex-direction:row;align-items:center;list-style:none;margin:0 var(--space-sm) 0 0;padding:0}:host ul#strengthBar>.weak{background-color:var(--danger-base)}:host ul#strengthBar>.medium{background-color:var(--warning-base)}:host ul#strengthBar>.max{background-color:var(--success-base)}:host .point:last{margin:0!important}:host .point{background:var(--main-on);border-radius:2px;display:inline-block;height:3px;margin-right:1px;width:28px}:host ::ng-deep avn-icon{align-items:center;width:15px;height:15px!important}:host.validation-theme.ng-valid.ng-touched avn-input ::ng-deep>input,:host.validation-theme.ng-valid.ng-dirty avn-input ::ng-deep>input{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched avn-input ::ng-deep>input,:host.validation-theme.ng-invalid.ng-dirty avn-input ::ng-deep>input{border-color:var(--danger-base)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], strengthSpec: [{
                type: Input
            }], debounceTimeMs: [{
                type: Input
            }], inputComponent: [{
                type: ViewChild,
                args: [InputComponent, { static: false }]
            }], value: [{
                type: Input
            }], messages: [{
                type: Input
            }], isDisabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }] } });

class PassswordInputModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PassswordInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: PassswordInputModule, declarations: [PasswordInputComponent, PasswordIndicatorComponent], imports: [CommonModule, CoreModule, IconModule, TooltipModule, InputModule, DropdownModule], exports: [PasswordInputComponent, PasswordIndicatorComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PassswordInputModule, imports: [CommonModule, CoreModule, IconModule, TooltipModule, InputModule, DropdownModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: PassswordInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, TooltipModule, InputModule, DropdownModule],
                    declarations: [PasswordInputComponent, PasswordIndicatorComponent],
                    exports: [PasswordInputComponent, PasswordIndicatorComponent],
                }]
        }] });

/** nested password message level */
var PasswordMessageLevel;
(function (PasswordMessageLevel) {
    PasswordMessageLevel["FIRST"] = "first";
    PasswordMessageLevel["SECOND"] = "second";
    PasswordMessageLevel["THIRD"] = "third";
})(PasswordMessageLevel || (PasswordMessageLevel = {}));

/**
 * This directive is to be used with the master/detail component
 * It represents a view to be injected inside of the master panel.
 */
class MasterViewDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MasterViewDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: MasterViewDirective, selector: "[avnMasterView]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MasterViewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnMasterView]',
                }]
        }] });

/**
 * This directive is to be used with the master/detail component
 * It represents a view to be injected inside of the detail panel.
 */
class DetailViewDirective {
    /** @ignore **/
    constructor(templateRef, viewContainerRef, builder, renderer) {
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.builder = builder;
        this.renderer = renderer;
        /** Specifies an id for the detail view **/
        this.viewId = '';
        /** @ignore indicates if the content of the directive is currently visible */
        this._visible = false;
    }
    /**
     * Show / Hide the content of the directive
     *
     * @param visible Specifies if the content should be visible or not
     * @param playAnimation Specifies if the transition animation should be played
     */
    setVisible(visible, playAnimation, animationDurationMs, backwardsAnimation, animationAxis) {
        // do nothing if the visiblity has not changed
        if (!!this._visible === !!visible) {
            return;
        }
        this._visible = visible;
        // destroy any previous player
        if (this._player && playAnimation) {
            this._player.destroy();
            this._player = undefined;
        }
        if (visible) {
            this.viewContainerRef.clear();
            this._embeddedViewRef = this.viewContainerRef.createEmbeddedView(this.templateRef);
            // make sure the root node is ready for the next step by calling changed detection on the newly created view
            this._embeddedViewRef.detectChanges();
            // get the element inside our detail view
            const detailElement = this.detailElement;
            if (detailElement) {
                // make the detail content fit the panel container
                this.renderer.setStyle(detailElement, 'height', '100%');
                this.renderer.setStyle(detailElement, 'width', '100%');
                if (playAnimation) {
                    const parentDimensions = detailElement.parentElement.getBoundingClientRect();
                    const factory = this.builder.build(this.fadeIn(parentDimensions, animationDurationMs, backwardsAnimation, animationAxis));
                    this._player = factory.create(detailElement);
                    this._player.play();
                }
            }
        }
        else {
            const detailElement = this.detailElement;
            if (playAnimation) {
                // if we need to play the animation, only clear the container once the animation is
                // completed
                if (detailElement) {
                    const parentDimensions = detailElement.parentElement.getBoundingClientRect();
                    const factory = this.builder.build(this.fadeOut(parentDimensions, animationDurationMs, backwardsAnimation, animationAxis));
                    this._player = factory.create(detailElement);
                    this._player.onDone(() => {
                        // make sure the visible state has not changed while the animation was playing
                        if (!this._visible) {
                            this.viewContainerRef.clear();
                        }
                    });
                    this._player.play();
                }
            }
            else {
                // clear the container
                this.viewContainerRef.clear();
            }
        }
    }
    /** Indidcates if the directive content is currently visible **/
    get isVisible() {
        return this._visible;
    }
    /** Returns the element contained in the directive **/
    get detailElement() {
        return this._embeddedViewRef?.rootNodes.find((node) => node.nodeType === Node.ELEMENT_NODE);
    }
    /** @ignore Returns the animation metadata for the fade in **/
    fadeIn(parentDimensions, animationDurationMs, backwardsAnimation, animationAxis) {
        const verticalAxis = animationAxis === 'vertical';
        const parentSize = verticalAxis ? parentDimensions.height : parentDimensions.width;
        const translate = verticalAxis ? 'translateY' : 'translateX';
        const minus = verticalAxis ? (backwardsAnimation ? '' : '-') : backwardsAnimation ? '-' : '';
        const transform = `${translate}(${minus}${parentSize}px)`;
        return [
            style({ transform: `${transform}`, opacity: 0 }),
            animate(`${animationDurationMs}ms cubic-bezier(.86, 0, .07, 1)`, style({ transform: 'none', opacity: 1 })),
        ];
    }
    /** @ignore Returns the animation metadata for the fade out **/
    fadeOut(parentDimensions, animationDurationMs, backwardsAnimation, animationAxis) {
        const verticalAxis = animationAxis === 'vertical';
        const parentSize = verticalAxis ? parentDimensions.height : parentDimensions.width;
        const translate = verticalAxis ? 'translateY' : 'translateX';
        const minus = verticalAxis ? (backwardsAnimation ? '-' : '') : backwardsAnimation ? '' : '-';
        const transform = `${translate}(${minus}${parentSize}px)`;
        return [
            style({ transform: 'none', opacity: 1 }),
            animate(`${animationDurationMs}ms cubic-bezier(.86, 0, .07, 1)`, style({ transform: `${transform}`, opacity: 0 })),
        ];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailViewDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: i1$1.AnimationBuilder }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: DetailViewDirective, selector: "[avnDetailView]", inputs: { viewId: ["avnDetailView", "viewId"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailViewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnDetailView]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i1$1.AnimationBuilder }, { type: i0.Renderer2 }]; }, propDecorators: { viewId: [{
                type: Input,
                args: ['avnDetailView']
            }] } });

class MasterDetailComponent {
    /**  @ignore */
    constructor(renderer, elementRef, cdr, _document) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.cdr = cdr;
        this._document = _document;
        /** Indicates if the detail panel is resizable */
        this.resizable = true;
        /** The width of the resizer panel in px */
        this.resizerWidthPx = 4;
        /** The width of the detail panel (in px or percent) */
        this.detailWidth = '30%';
        /** The min width of the detail panel (when resizable) */
        this.detailResizeMinWidth = '20%';
        /** The max width of the detail panel */
        this.detailResizeMaxWidth = '40%';
        /**
         * Specifies if the detail should take all component space.
         * This is used to override when the detail can go full screen. e.g. if the master contains a datatable, we may
         * want to make the detail full screen when there is not enough space left in the master container to display the datatable
         * without a horizontal scrollbar.
         * */
        this.forceDetailFullScreen = false;
        /** Enable transition animation between views */
        this.enableViewTransition = true;
        /** Duration of the transition animation */
        this.transitionDurationMs = 300;
        /** Axis of the transition animation */
        this.transitionAxis = 'vertical';
        /** Specifies if the transition animation should be played backwards */
        this.transitionPlayBackwards = false;
        /** Emits when the detail view is toggled */
        this.detailToggled = new EventEmitter();
        /** Emits when the view inside of the detail view changes */
        this.detailViewChanged = new EventEmitter();
        /** Emits when the detail panel is resized */
        this.detailResized = new EventEmitter();
        /** Indicates if the detail view is opened */
        this.isDetailViewOpened = false;
        /** Indicates if the detail should show full screen once opened */
        this.showDetailFullScreen = false;
        /** @ignore Indicates if the user is currently resizing the detail panel */
        this._draggingActive = false;
        /** @ignore Indicates if a view exists for the current view id */
        this._activeDetailViewExists = false;
        /** @ignore Emits whenever the resizable feature is deactivated */
        this._notResizableSubject = new Subject();
        /** @ignore */
        this._componentDestroyed$ = new Subject();
        /** @ignore indicates if the detail width is specified in pixels (if not, it is in percent) **/
        this._isDetailWidthPx = false;
        /** @ignore */
        this._resizeObserverSubject$ = new Subject();
    }
    /** @ignore */
    ngOnChanges({ activeDetailView, resizable, resizerWidth, detailWidth }) {
        if (activeDetailView && !activeDetailView.isFirstChange()) {
            // update the active view if its different from the previous one, or if the panel is not
            // opened
            const previousView = activeDetailView.previousValue ? activeDetailView.previousValue.id : undefined;
            const currentView = activeDetailView.currentValue ? activeDetailView.currentValue.id : undefined;
            if (previousView !== currentView || !this.isDetailViewOpened) {
                this._updateActiveDetailView(currentView);
            }
        }
        if (resizable && !resizable.isFirstChange()) {
            if (resizable.currentValue) {
                this._initResizableListeners();
            }
            else {
                this._notResizableSubject.next();
            }
        }
        if (resizerWidth && !resizerWidth.isFirstChange()) {
            this._updateDimensions();
        }
        if (detailWidth) {
            const newDetailWidth = detailWidth.currentValue || '0px';
            this._isDetailWidthPx = typeof newDetailWidth === 'string' && newDetailWidth.endsWith('px');
            if (!detailWidth.isFirstChange()) {
                this._updateDimensions(newDetailWidth);
            }
        }
    }
    /** @ignore */
    ngAfterViewInit() {
        if (this.activeDetailView) {
            this._updateActiveDetailView(this.activeDetailView.id);
        }
        // update the dimensions of the component
        this._updateDimensions(this.detailWidth);
        if (this.resizable) {
            this._initResizableListeners();
        }
        // everytime the container of the component is resized, recalculate the dimensions
        // use a combination of resize observer and add a debounce time
        this._resizeObserverSubject$.pipe(debounceTime(100), takeUntil(this._componentDestroyed$)).subscribe(() => {
            this._updateDimensions();
        });
        this._resizeObserver = new ResizeObserver$1((mutations) => {
            mutations.forEach(() => {
                this._resizeObserverSubject$.next();
            });
        });
        this._resizeObserver.observe(this.elementRef.nativeElement.parentElement);
    }
    /**
     * Inits the listeners for the resizable functionnality
     *
     * @ignore
     */
    _initResizableListeners() {
        const isNotResizableAnymore$ = merge(this._notResizableSubject.asObservable(), this._componentDestroyed$).pipe(first());
        merge(fromEvent(this.resizerElement.nativeElement, 'mousedown'), fromEvent(this.resizerElement.nativeElement, 'touchstart'))
            .pipe(filter(() => !this._draggingActive), takeUntil(isNotResizableAnymore$))
            .subscribe((event) => {
            if (event.cancelable) {
                event.preventDefault();
            }
            this._currentXPosition = this._getClientXPosition(event);
            this._draggingActive = !!this._currentXPosition;
            this._previousDetailWidth = this.currentDimensions.detail;
        });
        merge(fromEvent(this._document, 'mouseup'), fromEvent(this._document, 'touchend'))
            .pipe(filter(() => this._draggingActive), takeUntil(isNotResizableAnymore$))
            .subscribe((_) => {
            this._draggingActive = false;
            // emit the width changed if it has changed
            if (this._previousDetailWidth !== this.currentDimensions.detail) {
                this.detailResized.emit(this.currentDimensions.detail);
            }
        });
        merge(fromEvent(this._document, 'mousemove'), fromEvent(this._document, 'touchmove'))
            .pipe(filter(() => this._draggingActive), takeUntil(isNotResizableAnymore$))
            .subscribe((event) => {
            // check by how many px we have moved
            const xPosition = this._getClientXPosition(event);
            const diff = this._currentXPosition - xPosition;
            this._currentXPosition = xPosition;
            // then calculate the new detail width and use it to update the dimensions
            if (this._isDetailWidthPx) {
                const newDetailWidth = pxToNumber(this.currentDimensions.detail) + diff;
                this._updateDimensions(`${newDetailWidth}px`);
            }
            else {
                // if the width is specified in percent, compare percent values
                const parentWidth = this.elementRef.nativeElement.parentElement.clientWidth;
                const percentAdded = (diff * 100) / parentWidth;
                const newWidthPercent = percentToNumber(this.currentDimensions.detail) + percentAdded;
                this._updateDimensions(`${newWidthPercent}%`);
            }
        });
    }
    /**
     * Returns the cursor / finger x position depending on the event fired
     *
     * @ignore
     */
    _getClientXPosition(event) {
        return event instanceof TouchEvent ? event.touches[0].clientX : event.clientX;
    }
    /**
     * Calculates the dimensions of each of the items of the component (master / resizer / detail)
     * based on the current detail width and parent container width
     * Also updates the detail transition width parameters
     * Min / Max limits allowed for manual resize are also checked
     *
     * @ignore
     */
    _updateDimensions(newDetailWidth) {
        newDetailWidth = newDetailWidth ? newDetailWidth : this.currentDimensions ? this.currentDimensions.detail : this.detailWidth || '0px';
        // make sure we are within limits
        if (this._isDetailWidthPx) {
            const newDetailWidthPx = pxToNumber(newDetailWidth);
            if (this.resizable) {
                const minLimit = pxToNumber(this.detailResizeMinWidth);
                const maxLimit = pxToNumber(this.detailResizeMaxWidth);
                // check if we have reached the resize limit
                const minLimitReached = newDetailWidthPx < minLimit;
                const maxLimitReached = newDetailWidthPx > maxLimit;
                // if we have already reached the limit previous (current value equals the limit), then just return
                const hasAlreadyReachedMinLimit = minLimitReached && !!this.currentDimensions && minLimit === pxToNumber(this.currentDimensions.detail);
                const hasAlreadyReachedMaxLimit = maxLimitReached && !!this.currentDimensions && maxLimit === pxToNumber(this.currentDimensions.detail);
                if (hasAlreadyReachedMinLimit || hasAlreadyReachedMaxLimit) {
                    return;
                }
                // if we have past the boundaries set it the to boundary value (mousemove can skip some values)
                if (minLimitReached) {
                    newDetailWidth = this.detailResizeMinWidth;
                }
                else if (maxLimitReached) {
                    newDetailWidth = this.detailResizeMaxWidth;
                }
            }
            // calculate the master width
            const parentWidthPx = this.elementRef.nativeElement.parentElement.clientWidth;
            const newMasterWidthPx = parentWidthPx - this.resizerWidthPx - newDetailWidthPx;
            this.currentDimensions = {
                master: `${newMasterWidthPx}px`,
                resizer: this.resizerWidthPx,
                detail: newDetailWidth,
            };
            this.currentPxDimensions = {
                master: newMasterWidthPx,
                resizer: this.resizerWidthPx,
                detail: newDetailWidthPx,
            };
        }
        else {
            // if the width is specified in percent, compare percent values
            const newDetailWidthPercent = percentToNumber(newDetailWidth);
            if (this.resizable) {
                const minLimit = percentToNumber(this.detailResizeMinWidth);
                const maxLimit = percentToNumber(this.detailResizeMaxWidth);
                // check if we have reached the resize limit
                const minLimitReached = newDetailWidthPercent < minLimit;
                const maxLimitReached = newDetailWidthPercent > maxLimit;
                // if we have already reached the limit previous (current value equals the limit), then just return
                const hasAlreadyReachedMinLimit = minLimitReached && !!this.currentDimensions && minLimit === percentToNumber(this.currentDimensions.detail);
                const hasAlreadyReachedMaxLimit = maxLimitReached && !!this.currentDimensions && maxLimit === percentToNumber(this.currentDimensions.detail);
                if (hasAlreadyReachedMinLimit || hasAlreadyReachedMaxLimit) {
                    return;
                }
                // if we have past the boundaries set it the to boundary value (mousemove can skip some values)
                if (minLimitReached) {
                    newDetailWidth = this.detailResizeMinWidth;
                }
                else if (maxLimitReached) {
                    newDetailWidth = this.detailResizeMaxWidth;
                }
            }
            const parentWidthPx = this.elementRef.nativeElement.parentElement.clientWidth;
            const newMasterWidthCalc = `calc(100% - ${this.resizerWidthPx}px - ${newDetailWidth})`;
            const newDetailWidthPx = (parentWidthPx * newDetailWidthPercent) / 100;
            const newMasterWidthPx = parentWidthPx - this.resizerWidthPx - newDetailWidthPx;
            this.currentDimensions = {
                master: newMasterWidthCalc,
                resizer: this.resizerWidthPx,
                detail: newDetailWidth,
            };
            this.currentPxDimensions = {
                master: newMasterWidthPx,
                resizer: this.resizerWidthPx,
                detail: newDetailWidthPx,
            };
        }
        // set the elements dimensions
        this.elementRef.nativeElement.style.setProperty('--master-width', this.currentDimensions.master);
        this.elementRef.nativeElement.style.setProperty('--resizer-width', `${this.currentDimensions.resizer}px`);
        this.elementRef.nativeElement.style.setProperty('--detail-width', this.currentDimensions.detail);
        // now check if the detail should go full screen
        const masterMinLimitReached = this.currentPxDimensions.master < (this.masterMinWidthPx || 0);
        const detailMinLimitReached = this.currentPxDimensions.detail < (this.detailMinWidthPx || 0);
        this.showDetailFullScreen = masterMinLimitReached || detailMinLimitReached;
        // set the detail transition params
        const transformValue = this.forceDetailFullScreen || this.showDetailFullScreen ? '100%' : `${this.currentPxDimensions.detail}px`;
        this.elementRef.nativeElement.style.setProperty('--detail-width-transition-px', transformValue);
        this.cdr.detectChanges();
    }
    /**
     * Updates the view of the detail panel
     *
     * @ignore
     */
    _updateActiveDetailView(viewId) {
        if (this.detailViewList) {
            this._activeDetailViewExists = false;
            this.detailViewList.toArray().forEach((detailView) => {
                detailView.setVisible(detailView.viewId === viewId, this.enableViewTransition && this.isDetailViewOpened, this.transitionDurationMs, this.transitionPlayBackwards, this.transitionAxis);
                this._activeDetailViewExists = this._activeDetailViewExists || detailView.viewId === viewId;
            });
            if (this._activeDetailViewExists) {
                this.detailViewChanged.emit(viewId);
            }
            if (this._activeDetailViewExists && !this.isDetailViewOpened) {
                this._setDetailViewOpened(true);
                // this._updateMasterWidth();
            }
            else if (!this._activeDetailViewExists && this.isDetailViewOpened) {
                this._setDetailViewOpened(false);
            }
        }
    }
    /**
     * Opens or closes the detail view
     *
     * @ignore
     */
    _setDetailViewOpened(opened) {
        this.isDetailViewOpened = opened;
        this.detailToggled.emit(opened);
        this.cdr.detectChanges();
    }
    /**
     * Closes the detail panel
     */
    closeDetail() {
        this.isDetailViewOpened = false;
        this.detailToggled.emit(false);
        this.cdr.detectChanges();
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MasterDetailComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: MasterDetailComponent, selector: "avn-master-detail", inputs: { resizable: "resizable", resizerWidthPx: "resizerWidthPx", detailWidth: "detailWidth", detailResizeMinWidth: "detailResizeMinWidth", detailResizeMaxWidth: "detailResizeMaxWidth", detailMinWidthPx: "detailMinWidthPx", masterMinWidthPx: "masterMinWidthPx", forceDetailFullScreen: "forceDetailFullScreen", enableViewTransition: "enableViewTransition", transitionDurationMs: "transitionDurationMs", transitionAxis: "transitionAxis", transitionPlayBackwards: "transitionPlayBackwards", activeDetailView: "activeDetailView" }, outputs: { detailToggled: "detailToggled", detailViewChanged: "detailViewChanged", detailResized: "detailResized" }, queries: [{ propertyName: "detailViewList", predicate: DetailViewDirective }], viewQueries: [{ propertyName: "masterContainer", first: true, predicate: ["masterContainer"], descendants: true, read: ElementRef }, { propertyName: "detailContainer", first: true, predicate: ["detailContainer"], descendants: true, read: ElementRef }, { propertyName: "resizerElement", first: true, predicate: ["resizerElement"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: "<div class=\"grid\" [class.show-detail]=\"isDetailViewOpened\" [class.fullscreen]=\"showDetailFullScreen || forceDetailFullScreen\">\n  <div class=\"master-container\" #masterContainer avnScroll>\n    <ng-content select=\"[avnMasterView]\"></ng-content>\n  </div>\n  <div class=\"resizer\" #resizerElement [class.resizable]=\"resizable\" [style.display]=\"isDetailViewOpened ? undefined : 'none'\"></div>\n  <div class=\"detail-container\" #detailContainer avnScroll [style.display]=\"isDetailViewOpened ? undefined : 'none'\">\n    <ng-content select=\"ng-template[avnDetailView]\"></ng-content>\n  </div>\n</div>\n", styles: [":host{display:block;width:100%;height:100%;--master-width: $default-master-width;--resizer-width: $default-resizer-width;--detail-width: $default-detail-width;--detail-width-transition-px: $default-detail-width}.grid{width:100%;height:100%;overflow-x:hidden;display:grid;grid-template-columns:1fr;grid-template-rows:1fr;grid-template-areas:\"master resizer detail\"}.grid.show-detail{grid-template-columns:auto 8px 400px;grid-template-columns:var(--master-width) var(--resizer-width) var(--detail-width)}.grid.show-detail.fullscreen{grid-template-columns:0px 0px auto}.grid .master-container{grid-area:master;overflow-y:auto}.grid .resizer{background-color:var(--master-detail-resizer);grid-area:resizer}.grid .resizer.resizable{cursor:col-resize}.grid .detail-container{position:relative;grid-area:detail;overflow-y:hidden;animation:.3s enter cubic-bezier(.86,0,.07,1);overflow-x:hidden}.grid .detail-container ::ng-deep>*{position:absolute;top:0;left:0;overflow:hidden}@keyframes enter{0%{transform:translate(var(--detail-width-transition-px))}to{transform:none}}\n"], dependencies: [{ kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MasterDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-master-detail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"grid\" [class.show-detail]=\"isDetailViewOpened\" [class.fullscreen]=\"showDetailFullScreen || forceDetailFullScreen\">\n  <div class=\"master-container\" #masterContainer avnScroll>\n    <ng-content select=\"[avnMasterView]\"></ng-content>\n  </div>\n  <div class=\"resizer\" #resizerElement [class.resizable]=\"resizable\" [style.display]=\"isDetailViewOpened ? undefined : 'none'\"></div>\n  <div class=\"detail-container\" #detailContainer avnScroll [style.display]=\"isDetailViewOpened ? undefined : 'none'\">\n    <ng-content select=\"ng-template[avnDetailView]\"></ng-content>\n  </div>\n</div>\n", styles: [":host{display:block;width:100%;height:100%;--master-width: $default-master-width;--resizer-width: $default-resizer-width;--detail-width: $default-detail-width;--detail-width-transition-px: $default-detail-width}.grid{width:100%;height:100%;overflow-x:hidden;display:grid;grid-template-columns:1fr;grid-template-rows:1fr;grid-template-areas:\"master resizer detail\"}.grid.show-detail{grid-template-columns:auto 8px 400px;grid-template-columns:var(--master-width) var(--resizer-width) var(--detail-width)}.grid.show-detail.fullscreen{grid-template-columns:0px 0px auto}.grid .master-container{grid-area:master;overflow-y:auto}.grid .resizer{background-color:var(--master-detail-resizer);grid-area:resizer}.grid .resizer.resizable{cursor:col-resize}.grid .detail-container{position:relative;grid-area:detail;overflow-y:hidden;animation:.3s enter cubic-bezier(.86,0,.07,1);overflow-x:hidden}.grid .detail-container ::ng-deep>*{position:absolute;top:0;left:0;overflow:hidden}@keyframes enter{0%{transform:translate(var(--detail-width-transition-px))}to{transform:none}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { detailViewList: [{
                type: ContentChildren,
                args: [DetailViewDirective]
            }], masterContainer: [{
                type: ViewChild,
                args: ['masterContainer', { read: ElementRef, static: false }]
            }], detailContainer: [{
                type: ViewChild,
                args: ['detailContainer', { read: ElementRef, static: false }]
            }], resizerElement: [{
                type: ViewChild,
                args: ['resizerElement', { read: ElementRef, static: false }]
            }], resizable: [{
                type: Input
            }], resizerWidthPx: [{
                type: Input
            }], detailWidth: [{
                type: Input
            }], detailResizeMinWidth: [{
                type: Input
            }], detailResizeMaxWidth: [{
                type: Input
            }], detailMinWidthPx: [{
                type: Input
            }], masterMinWidthPx: [{
                type: Input
            }], forceDetailFullScreen: [{
                type: Input
            }], enableViewTransition: [{
                type: Input
            }], transitionDurationMs: [{
                type: Input
            }], transitionAxis: [{
                type: Input
            }], transitionPlayBackwards: [{
                type: Input
            }], activeDetailView: [{
                type: Input
            }], detailToggled: [{
                type: Output
            }], detailViewChanged: [{
                type: Output
            }], detailResized: [{
                type: Output
            }] } });

class DetailContentComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DetailContentComponent, selector: "avn-detail-content", ngImport: i0, template: "<div class=\"detail-content-container\" avnScroll>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{overflow-y:auto;display:block}:host>.detail-content-container{overflow-y:auto;padding:calc(var(--space-md) * 2) var(--space-md);display:flex;flex-direction:column}\n"], dependencies: [{ kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-detail-content', template: "<div class=\"detail-content-container\" avnScroll>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{overflow-y:auto;display:block}:host>.detail-content-container{overflow-y:auto;padding:calc(var(--space-md) * 2) var(--space-md);display:flex;flex-direction:column}\n"] }]
        }] });

class DetailFooterComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DetailFooterComponent, selector: "avn-detail-footer", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{padding:var(--space-md);overflow:hidden;display:flex;flex-direction:row;align-items:flex-start}:host ::ng-deep>avn-button{display:block}:host ::ng-deep>avn-button:not(:last-child){margin-right:var(--space-md)}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-detail-footer', template: "<ng-content></ng-content>\n", styles: [":host{padding:var(--space-md);overflow:hidden;display:flex;flex-direction:row;align-items:flex-start}:host ::ng-deep>avn-button{display:block}:host ::ng-deep>avn-button:not(:last-child){margin-right:var(--space-md)}\n"] }]
        }] });

class DetailHeaderComponent {
    constructor() {
        /** Specifies if the close icon should be displayed */
        this.showCloseIcon = true;
        /** the icon to use as the close icon */
        this.closeIcon = 'action:close';
        /** dispatched when the close icon is clicked */
        this.closed = new EventEmitter();
    }
    /** When the closed icon is clicked **/
    onClose() {
        this.closed.emit();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DetailHeaderComponent, selector: "avn-detail-header", inputs: { title: "title", template: "template", showCloseIcon: "showCloseIcon", closeIcon: "closeIcon" }, outputs: { closed: "closed" }, ngImport: i0, template: "<ng-container *ngIf=\"!!template; else defaultTitle\">\n  <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n</ng-container>\n<ng-template #defaultTitle>\n  <h5>{{ title }}</h5>\n</ng-template>\n<avn-icon *ngIf=\"showCloseIcon\" [icon]=\"closeIcon\" (click)=\"onClose()\"></avn-icon>\n", styles: [":host{display:flex;flex-direction:row;justify-content:space-between;padding:var(--space-md);align-items:center}:host>h5{margin:0}:host>avn-icon{align-self:flex-start}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-detail-header', template: "<ng-container *ngIf=\"!!template; else defaultTitle\">\n  <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n</ng-container>\n<ng-template #defaultTitle>\n  <h5>{{ title }}</h5>\n</ng-template>\n<avn-icon *ngIf=\"showCloseIcon\" [icon]=\"closeIcon\" (click)=\"onClose()\"></avn-icon>\n", styles: [":host{display:flex;flex-direction:row;justify-content:space-between;padding:var(--space-md);align-items:center}:host>h5{margin:0}:host>avn-icon{align-self:flex-start}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], template: [{
                type: Input
            }], showCloseIcon: [{
                type: Input
            }], closeIcon: [{
                type: Input
            }], closed: [{
                type: Output
            }] } });

class DetailLayoutComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DetailLayoutComponent, selector: "avn-detail-layout", ngImport: i0, template: "<ng-content select=\"avn-detail-header\"> </ng-content>\n<ng-content select=\"avn-detail-content\"> </ng-content>\n<ng-content select=\"avn-detail-footer\"> </ng-content>\n", styles: [":host{display:grid;height:100%;grid-template-rows:max-content auto max-content}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DetailLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-detail-layout', template: "<ng-content select=\"avn-detail-header\"> </ng-content>\n<ng-content select=\"avn-detail-content\"> </ng-content>\n<ng-content select=\"avn-detail-footer\"> </ng-content>\n", styles: [":host{display:grid;height:100%;grid-template-rows:max-content auto max-content}\n"] }]
        }] });

class MasterDetailModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MasterDetailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: MasterDetailModule, declarations: [MasterDetailComponent,
            MasterViewDirective,
            DetailViewDirective,
            DetailLayoutComponent,
            DetailHeaderComponent,
            DetailFooterComponent,
            DetailContentComponent], imports: [CommonModule, CoreModule, IconModule, ScrollingModule, LayoutModule], exports: [MasterDetailComponent,
            MasterViewDirective,
            DetailViewDirective,
            DetailLayoutComponent,
            DetailHeaderComponent,
            DetailFooterComponent,
            DetailContentComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MasterDetailModule, imports: [CommonModule, CoreModule, IconModule, ScrollingModule, LayoutModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MasterDetailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, ScrollingModule, LayoutModule],
                    declarations: [
                        MasterDetailComponent,
                        MasterViewDirective,
                        DetailViewDirective,
                        DetailLayoutComponent,
                        DetailHeaderComponent,
                        DetailFooterComponent,
                        DetailContentComponent,
                    ],
                    exports: [
                        MasterDetailComponent,
                        MasterViewDirective,
                        DetailViewDirective,
                        DetailLayoutComponent,
                        DetailHeaderComponent,
                        DetailFooterComponent,
                        DetailContentComponent,
                    ],
                }]
        }] });

class WidgetFooterComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: WidgetFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: WidgetFooterComponent, selector: "avn-widget-footer", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: WidgetFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-widget-footer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n" }]
        }] });

class WidgetComponent {
    /** @ignore*/
    constructor(_elementRef, _renderer, _document, _window) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._document = _document;
        this._window = _window;
        /** if display close button */
        this.showCloseButton = true;
        /** if the widgets can be fullscreened */
        this.enableFullScreen = false;
        /** The size of the heading title*/
        this.headingSize = 17;
        /** Emitted when the widget is closed*/
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        /** Emitted when full screen is toggled  */
        this.fullScreenToggled = new EventEmitter();
        /** Indicated if the widget is fullscreen  */
        this.isFullScreen = false;
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
    }
    /**  Called when the widget close button is clicked*/
    closeWidget(e) {
        this.close.emit(e);
    }
    /**  Called when the widget fullscreen button is clicked */
    toggleFullScreen(forceValue) {
        this.isFullScreen = forceValue !== undefined ? forceValue : !this.isFullScreen;
        this.fullScreenToggled.emit(this.isFullScreen);
        if (this.isFullScreen) {
            this._updateWidgetDimensions();
        }
        else {
            this._renderer.removeStyle(this._elementRef.nativeElement, 'top');
            this._renderer.removeStyle(this._elementRef.nativeElement, 'left');
            this._renderer.removeStyle(this._elementRef.nativeElement, 'width');
            this._renderer.removeStyle(this._elementRef.nativeElement, 'height');
            this._renderer.setStyle(this.fullScreenContainer, 'overflow', this._originalFullScreenContainerOverflow);
        }
    }
    /** @ignore*/
    ngOnInit() {
        if (this.enableFullScreen) {
            this._originalFullScreenContainerOverflow = this._window.getComputedStyle(this.fullScreenContainer).overflow;
            // resize the widget in full screen mode when its parent container size changes
            this._resizeObserver = new ResizeObserver$1((mutations) => {
                mutations.forEach(() => {
                    if (this.isFullScreen) {
                        this._updateWidgetDimensions();
                    }
                });
            });
            this._resizeObserver.observe(this.fullScreenContainer);
            // close full screen mode on ESCAPE keypress
            fromEvent(this._document, 'keydown')
                .pipe(filter((event) => event.keyCode === ESCAPE), takeUntil(this._componentDestroyed$))
                .subscribe(() => this.toggleFullScreen(false));
        }
    }
    /** @ignore Updates the widget dimensions to fill the full screen container */
    _updateWidgetDimensions() {
        const rect = this.fullScreenContainer.getBoundingClientRect();
        this._renderer.setStyle(this.fullScreenContainer, 'overflow', `hidden`);
        this._renderer.setStyle(this._elementRef.nativeElement, 'top', `${rect.top}px`);
        this._renderer.setStyle(this._elementRef.nativeElement, 'left', `${rect.left}px`);
        this._renderer.setStyle(this._elementRef.nativeElement, 'width', `${rect.width}px`);
        this._renderer.setStyle(this._elementRef.nativeElement, 'height', `${rect.height}px`);
    }
    /** @ignore*/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: WidgetComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: DOCUMENT }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: WidgetComponent, selector: "avn-widget", inputs: { name: "name", showCloseButton: "showCloseButton", enableFullScreen: "enableFullScreen", fullScreenContainer: "fullScreenContainer", fullScreenTooltipText: "fullScreenTooltipText", headingTitle: "headingTitle", headingSize: "headingSize", headerTemplate: "headerTemplate", headerTemplateContext: "headerTemplateContext" }, outputs: { close: "close", fullScreenToggled: "fullScreenToggled" }, host: { properties: { "class.fullscreen": "this.isFullScreen" } }, queries: [{ propertyName: "footerComponent", first: true, predicate: WidgetFooterComponent, descendants: true }], ngImport: i0, template: "<header [class.use-template]=\"headerTemplate\">\n  <ng-container *ngIf=\"!headerTemplate; else header\">\n    <h5 [ngStyle]=\"{ 'font-size.px': headingSize }\">{{ headingTitle }}</h5>\n  </ng-container>\n  <div class=\"widget-actions\">\n    <ng-content select=\"avn-icon.action\"></ng-content>\n    <avn-icon\n      *ngIf=\"enableFullScreen\"\n      [icon]=\"isFullScreen ? 'action:close_fullscreen' : 'action:open_in_full'\"\n      (click)=\"toggleFullScreen()\"\n      [avnTooltip]=\"fullScreenTooltipText\"\n      [tooltipDisabled]=\"!fullScreenTooltipText\"\n      tooltipPlacement=\"top\"\n    ></avn-icon>\n    <avn-icon *ngIf=\"showCloseButton && !isFullScreen\" icon=\"action:close\" (click)=\"closeWidget($event)\"></avn-icon>\n  </div>\n</header>\n\n<div class=\"widget-body\">\n  <ng-content></ng-content>\n</div>\n\n<footer *ngIf=\"footerComponent\">\n  <ng-content select=\"avn-widget-footer\"></ng-content>\n</footer>\n\n<ng-template #header>\n  <ng-container *ngTemplateOutlet=\"headerTemplate; context: headerTemplateContext\"></ng-container>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;position:relative;background:var(--surface-background);color:var(--surface-on);border:1px solid var(--surface-border);border-radius:.2rem;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;transition:box-shadow .28s cubic-bezier(.4,0,.2,1)}:host:hover,:host:focus{box-shadow:0 -1px 0 -2px #00000040,0 2px 2px #0003,0 1px 5px #0000002b!important}:host>header{padding:var(--space-md);display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between}:host>header.use-template{border-bottom:1px solid rgba(0,0,0,.2)}:host>header>h5{margin-bottom:0}:host>header .widget-actions{display:flex;flex-flow:row nowrap;align-self:flex-start;opacity:0;transition:opacity .15s cubic-bezier(0,0,.2,1)}:host>header .widget-actions ::ng-deep avn-icon:not(:last-child){margin-right:var(--space-md)}:host>header .widget-actions ::ng-deep avn-icon>i{color:var(--surface-on)}:host>header>div{font-weight:600}:host>.widget-body{padding:var(--space-md);overflow:hidden;flex-grow:1}:host>footer{padding:var(--space-md);border-top:1px solid rgba(0,0,0,.2)}:host:hover .widget-controls-hover{opacity:1}:host:hover header .widget-actions{opacity:1}:host:not(.fullscreen){width:100%;height:100%}:host.fullscreen{position:fixed;animation:zoomIn .15s cubic-bezier(0,0,.2,1);z-index:500}@keyframes zoomIn{0%{opacity:.8;transform:scale(.9)}to{opacity:1;transform:scale(1)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: TooltipDirective, selector: "[avnTooltip]", inputs: ["avnTooltip", "tooltipName", "tooltipTemplate", "templateContext", "tooltipTheme", "tooltipPlacement", "tooltipMaxWidth", "tooltipDisabled", "tooltipTrigger", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipMouseLeaveCloseDelay", "tooltipMouseEnterOpenDelay"], outputs: ["show", "hide"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: WidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-widget', template: "<header [class.use-template]=\"headerTemplate\">\n  <ng-container *ngIf=\"!headerTemplate; else header\">\n    <h5 [ngStyle]=\"{ 'font-size.px': headingSize }\">{{ headingTitle }}</h5>\n  </ng-container>\n  <div class=\"widget-actions\">\n    <ng-content select=\"avn-icon.action\"></ng-content>\n    <avn-icon\n      *ngIf=\"enableFullScreen\"\n      [icon]=\"isFullScreen ? 'action:close_fullscreen' : 'action:open_in_full'\"\n      (click)=\"toggleFullScreen()\"\n      [avnTooltip]=\"fullScreenTooltipText\"\n      [tooltipDisabled]=\"!fullScreenTooltipText\"\n      tooltipPlacement=\"top\"\n    ></avn-icon>\n    <avn-icon *ngIf=\"showCloseButton && !isFullScreen\" icon=\"action:close\" (click)=\"closeWidget($event)\"></avn-icon>\n  </div>\n</header>\n\n<div class=\"widget-body\">\n  <ng-content></ng-content>\n</div>\n\n<footer *ngIf=\"footerComponent\">\n  <ng-content select=\"avn-widget-footer\"></ng-content>\n</footer>\n\n<ng-template #header>\n  <ng-container *ngTemplateOutlet=\"headerTemplate; context: headerTemplateContext\"></ng-container>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;position:relative;background:var(--surface-background);color:var(--surface-on);border:1px solid var(--surface-border);border-radius:.2rem;box-shadow:0 -1px 0 -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;transition:box-shadow .28s cubic-bezier(.4,0,.2,1)}:host:hover,:host:focus{box-shadow:0 -1px 0 -2px #00000040,0 2px 2px #0003,0 1px 5px #0000002b!important}:host>header{padding:var(--space-md);display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between}:host>header.use-template{border-bottom:1px solid rgba(0,0,0,.2)}:host>header>h5{margin-bottom:0}:host>header .widget-actions{display:flex;flex-flow:row nowrap;align-self:flex-start;opacity:0;transition:opacity .15s cubic-bezier(0,0,.2,1)}:host>header .widget-actions ::ng-deep avn-icon:not(:last-child){margin-right:var(--space-md)}:host>header .widget-actions ::ng-deep avn-icon>i{color:var(--surface-on)}:host>header>div{font-weight:600}:host>.widget-body{padding:var(--space-md);overflow:hidden;flex-grow:1}:host>footer{padding:var(--space-md);border-top:1px solid rgba(0,0,0,.2)}:host:hover .widget-controls-hover{opacity:1}:host:hover header .widget-actions{opacity:1}:host:not(.fullscreen){width:100%;height:100%}:host.fullscreen{position:fixed;animation:zoomIn .15s cubic-bezier(0,0,.2,1);z-index:500}@keyframes zoomIn{0%{opacity:.8;transform:scale(.9)}to{opacity:1;transform:scale(1)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; }, propDecorators: { footerComponent: [{
                type: ContentChild,
                args: [WidgetFooterComponent, { static: false }]
            }], name: [{
                type: Input
            }], showCloseButton: [{
                type: Input
            }], enableFullScreen: [{
                type: Input
            }], fullScreenContainer: [{
                type: Input
            }], fullScreenTooltipText: [{
                type: Input
            }], headingTitle: [{
                type: Input
            }], headingSize: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }], headerTemplateContext: [{
                type: Input
            }], close: [{
                type: Output
            }], fullScreenToggled: [{
                type: Output
            }], isFullScreen: [{
                type: HostBinding,
                args: ['class.fullscreen']
            }] } });

class WidgetModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: WidgetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: WidgetModule, declarations: [WidgetComponent, WidgetFooterComponent], imports: [CommonModule, TooltipModule, IconModule], exports: [WidgetComponent, WidgetFooterComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: WidgetModule, imports: [CommonModule, TooltipModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: WidgetModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TooltipModule, IconModule],
                    declarations: [WidgetComponent, WidgetFooterComponent],
                    exports: [WidgetComponent, WidgetFooterComponent],
                }]
        }] });

/**
 * This enum defines the item types
 */
var TimelineItemType;
(function (TimelineItemType) {
    TimelineItemType["IMAGE"] = "image";
    TimelineItemType["VIDEO"] = "video";
    TimelineItemType["TEXT"] = "text";
})(TimelineItemType || (TimelineItemType = {}));
/**
 * This enum defines timeline playlist sync type
 */
var TimelineSyncType;
(function (TimelineSyncType) {
    TimelineSyncType[TimelineSyncType["MASTER"] = 0] = "MASTER";
    TimelineSyncType[TimelineSyncType["REPEAT"] = 1] = "REPEAT";
    TimelineSyncType[TimelineSyncType["REPEAT_ONCE"] = 2] = "REPEAT_ONCE";
    TimelineSyncType[TimelineSyncType["NO_SYNC"] = 3] = "NO_SYNC";
})(TimelineSyncType || (TimelineSyncType = {}));

/**
 * Convert milliseconds to a time object (hours, minutes, seconds and milliseconds)
 */
const msToTime$1 = (duration) => {
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const seconds = Math.floor((duration / 1000) % 60);
    const milliseconds = duration % 1000;
    return { hours, minutes, seconds, milliseconds };
};
/**
 * Convert time object (hours, minutes, seconds and milliseconds) to milliseconds
 */
const timeToMs$1 = (value) => {
    const timeParts = value.split(':');
    const hoursMs = parseInt(timeParts[0], 10) * 60 * 60 * 1000 || 0;
    const minutesMs = parseInt(timeParts[1], 10) * 60 * 1000 || 0;
    const secondesMs = parseInt(timeParts[2], 10) * 1000 || 0;
    const ms = parseInt(timeParts[3], 10) || 0;
    return hoursMs + minutesMs + secondesMs + ms;
};
/**
 * Return a formatted time object (hours, minutes, seconds and milliseconds) from a milliseconds
 * value
 */
const displayTimeWithMS$1 = (num) => {
    if (num === undefined) {
        return '----';
    }
    const t = msToTime$1(num);
    return t.hours + ':' + t.minutes + ':' + t.seconds + ':' + padEndWithZero$1(t.milliseconds, 3);
};
/**
 * Return a new zero padded string from a number until the resulting string reaches the given
 * length. The padding is applied from the start (left) of the current value.
 */
const padStartWithZero$1 = (num, length) => num.toString().padStart(length, '0');
/**
 * Return a new zero padded string from a number until the resulting string reaches the given
 * length. The padding is applied from the end (right) of the current string.
 */
const padEndWithZero$1 = (num, length) => num.toString().padEnd(length, '0');
/**
 * Convert a string enumeration to an Array of object with key value pair
 */
const convertStringEnumToObjArray$1 = (enumObj) => {
    const itemType = [];
    let index = 0;
    for (const type in enumObj) {
        if (typeof enumObj[type] === 'string') {
            itemType.push({ id: index, key: type, value: enumObj[type] });
            index++;
        }
    }
    return itemType;
};

// eslint-disable-next-line @angular-eslint/component-class-suffix
class TimelineScrubberComponentV1 {
    constructor() {
        this.themeType = ThemeType;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineScrubberComponentV1, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineScrubberComponentV1, selector: "avn-timeline-scrubber-v1", ngImport: i0, template: "<div class=\"time-indicator\">\n  <avn-icon icon=\"action:label\" [avnTheme]=\"themeType.SECONDARY\"></avn-icon>\n</div>\n", styles: [":host{height:100%;position:absolute;padding-top:var(--space-lg);z-index:10}:host .time-indicator{height:100%;width:1px;background-color:red}:host .time-indicator ::ng-deep avn-icon{transform:rotate(90deg);cursor:grab;height:25px;width:25px;left:-12px}:host .time-indicator ::ng-deep avn-icon i{font-size:var(--text-xl)}\n"], dependencies: [{ kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineScrubberComponentV1, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline-scrubber-v1', template: "<div class=\"time-indicator\">\n  <avn-icon icon=\"action:label\" [avnTheme]=\"themeType.SECONDARY\"></avn-icon>\n</div>\n", styles: [":host{height:100%;position:absolute;padding-top:var(--space-lg);z-index:10}:host .time-indicator{height:100%;width:1px;background-color:red}:host .time-indicator ::ng-deep avn-icon{transform:rotate(90deg);cursor:grab;height:25px;width:25px;left:-12px}:host .time-indicator ::ng-deep avn-icon i{font-size:var(--text-xl)}\n"] }]
        }] });

class TimelineItemComponent {
    /**
     * if provided, add the custom class to the host element
     * TODO: issue here as it will bind class custom-class and not the input classes..
     */
    get hostClasses() {
        return this.class;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineItemComponent, selector: "avn-timeline-item", inputs: { class: "class" }, host: { properties: { "class.custom-class": "this.hostClasses" } }, ngImport: i0, template: "<!-- projection main content -->\n<ng-content select=\".main-content\"></ng-content>\n\n<!-- projection left resizer -->\n<ng-content select=\".resizer.left\"></ng-content>\n\n<!-- projection right resizer -->\n<ng-content select=\".resizer.right\"></ng-content>\n\n<!-- projection top resizer -->\n<ng-content select=\".resizer.top\"></ng-content>\n\n<!-- projection bottom resizer -->\n<ng-content select=\".resizer.bottom\"></ng-content>\n", styles: ["@charset \"UTF-8\";::ng-deep .resizable .resizer{position:absolute;height:100%;width:10px}::ng-deep .resizable .resizer.left{left:0}::ng-deep .resizable .resizer.left:hover{cursor:w-resize}::ng-deep .resizable .resizer.left:after{content:\"\\2022\\2022\\2022\";position:absolute;left:10px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-xs);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.right{right:0}::ng-deep .resizable .resizer.right:hover{cursor:e-resize}::ng-deep .resizable .resizer.right:after{content:\"\\2022\\2022\\2022\";position:absolute;left:3px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-xs);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.top{height:10px;width:100%;top:0;background-color:#0003}::ng-deep .resizable .resizer.top:hover{cursor:n-resize}::ng-deep .resizable .resizer.bottom{height:10px;width:100%;bottom:0;background-color:#0003}::ng-deep .resizable .resizer.bottom:hover{cursor:s-resize}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline-item', template: "<!-- projection main content -->\n<ng-content select=\".main-content\"></ng-content>\n\n<!-- projection left resizer -->\n<ng-content select=\".resizer.left\"></ng-content>\n\n<!-- projection right resizer -->\n<ng-content select=\".resizer.right\"></ng-content>\n\n<!-- projection top resizer -->\n<ng-content select=\".resizer.top\"></ng-content>\n\n<!-- projection bottom resizer -->\n<ng-content select=\".resizer.bottom\"></ng-content>\n", styles: ["@charset \"UTF-8\";::ng-deep .resizable .resizer{position:absolute;height:100%;width:10px}::ng-deep .resizable .resizer.left{left:0}::ng-deep .resizable .resizer.left:hover{cursor:w-resize}::ng-deep .resizable .resizer.left:after{content:\"\\2022\\2022\\2022\";position:absolute;left:10px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-xs);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.right{right:0}::ng-deep .resizable .resizer.right:hover{cursor:e-resize}::ng-deep .resizable .resizer.right:after{content:\"\\2022\\2022\\2022\";position:absolute;left:3px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-xs);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.top{height:10px;width:100%;top:0;background-color:#0003}::ng-deep .resizable .resizer.top:hover{cursor:n-resize}::ng-deep .resizable .resizer.bottom{height:10px;width:100%;bottom:0;background-color:#0003}::ng-deep .resizable .resizer.bottom:hover{cursor:s-resize}\n"] }]
        }], propDecorators: { class: [{
                type: Input
            }], hostClasses: [{
                type: HostBinding,
                args: ['class.custom-class']
            }] } });

class TimelineComponent {
    /**
     * Return the timeline main section element
     */
    get mainSection() {
        return this.elRef.nativeElement.querySelector('.main-section');
    }
    /**
     * @ignore Return the dragged item floating status
     */
    _isFloatingItem() {
        let floatProp;
        if (this._lastDraggedItem && this._lastDraggedItem.item) {
            floatProp = this._lastDraggedItem.item.floating ? this._lastDraggedItem.item.floating : false;
        }
        else {
            floatProp = false;
        }
        return floatProp;
    }
    /**
     * Return the item background color based on the "color" property, the "type" property or the
     * global theme
     */
    getItemColor(item, hover) {
        const selected = !this.disabledSelectionPreview ? item.selected : false;
        const defaultColorBaseScheme = this._colorScheme[0].base;
        if (item.color) {
            // By provided color
            const newColor = new Color(item.color);
            return selected ? newColor.darken(0.3).string() : hover ? newColor.lighten(0.2).string() : newColor.string();
        }
        else if (item.type) {
            // By item type
            const types = convertStringEnumToObjArray$1(TimelineItemType);
            const type = types.find((t) => t.value === item.type);
            const typeId = type.id;
            return selected
                ? this._colorScheme[typeId].base.darken(0.3).string()
                : hover
                    ? this._colorScheme[typeId].base.lighten(0.2).string()
                    : this._colorScheme[typeId].base.string();
        }
        else {
            return selected ? defaultColorBaseScheme.darken(0.3).string() : hover ? defaultColorBaseScheme.lighten(0.2).string() : defaultColorBaseScheme.string();
        }
    }
    /**
     * Return the item color based on the background color "on" calculation
     */
    getItemOnColor(item) {
        if (item.color) {
            // By provided color
            const newColor = new Color(item.color);
            return this._resolveForegroundColor(newColor);
        }
        else if (item.type) {
            // By item type
            const types = convertStringEnumToObjArray$1(TimelineItemType);
            const type = types.find((t) => t.value === item.type);
            return this._colorScheme[type.id].on;
        }
        else {
            return this._colorScheme[0].on;
        }
    }
    /**
     * @ignore
     */
    constructor(renderer, colorSetsService, _window, _document, elRef) {
        this.renderer = renderer;
        this.colorSetsService = colorSetsService;
        this._window = _window;
        this._document = _document;
        this.elRef = elRef;
        /**
         * The datasource containing the rows/columns to display in the timeline
         */
        this.dataSource = [];
        /**
         * Display the current time indicator (scrubber)
         */
        this.displayCurrentTimeIndicator = true;
        /**
         * Display the resizer handles
         */
        this.displayResizer = true;
        /**
         * Width of the leftmost column (px)
         */
        this.leftSectionWidth = 100;
        /**
         * Size of the height or width of the timeline element (px)
         */
        this.timelineSmallerDimension = 50;
        /**
         * Theme for items
         */
        this.theme = ThemeType.PRIMARY;
        /**
         * disables resize, drag & drop operations.
         */
        this.disabled = false;
        /** The minimum media item duration value (ms) */
        this.mediaMinDurationMs = 1000;
        /** Specifies the duration of an interval, i.e the duration precision for an item */
        this.intervalDurationMs = 50;
        /**
         * disable the darker overlay selection preview
         */
        this.disabledSelectionPreview = false;
        /**
         * Emits when an item is selected
         */
        this.itemSelected = new EventEmitter();
        /**
         * Emits when the dataSource is modified (move, drag & drop, resize, delete)
         */
        this.dataSourceChanged = new EventEmitter();
        /**
         * Emits when the current time indicator changes
         */
        this.currentTimeScrubberChanged = new EventEmitter();
        /**
         * Allows adding a custom css class to the ruler ( axisTemplate )
         */
        this.rulerClasses = '';
        /** current scrubber left position (relative to the start of the ruler canvas) **/
        this.scrubberLeftPx = 0;
        /** @ignore available durations for a step, corresponds to the zoom levels **/
        this._availableStepDurationMs = [300, 500, 1000, 3000, 5000, 10000];
        /** @ignore Used to define the ruler step distance (px) */
        this._stepWidthPx = 100;
        /** @ignore Current time model object, used to track current time scrubber */
        this._currentTime = {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
        };
        /** @ignore Current time position in millisecond, used to position the scrubber on timeline */
        this._currentTimePos = 0;
        /** @ignore The minimum timeline container width value (px) */
        this._timelineMinWidth = 1500;
        /** @ignore The buffer size for keeping a gap after the last item (px) */
        this._timelineBufferWidth = 2000;
        /** @ignore pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
        /**
         * @ignore
         * Used to keep track of a dragover event and container reference
         */
        this.dragOverSubject = new Subject();
        /**
         * @ignore
         * Used to throttle down dragover value emitted for performance reasons
         */
        this.dragOverObservable = this.dragOverSubject.asObservable().pipe(throttleTime(250));
    }
    /**
     * @ignore
     */
    ngOnChanges({ dataSource, zoomLevel, changeItemPosition, changeItemDuration, theme, timelineMaxTimeMs, intervalDurationMs }) {
        if (zoomLevel && zoomLevel.currentValue !== undefined) {
            if (zoomLevel.currentValue > this._availableStepDurationMs.length) {
                this.zoomLevel = this._availableStepDurationMs.length;
            }
            if (zoomLevel.currentValue < 1) {
                this.zoomLevel = 1;
            }
            this._refreshZoomLevelInfo();
            this._drawCanvasRuler();
        }
        if (changeItemPosition && changeItemPosition.currentValue !== undefined) {
            this.updateTimelineItemPosition(changeItemPosition.currentValue.uuid, changeItemPosition.currentValue.pos);
        }
        if (changeItemDuration && changeItemDuration.currentValue !== undefined) {
            this.updateTimelineItemDuration(changeItemDuration.currentValue.uuid, changeItemDuration.currentValue.dur);
        }
        if (dataSource && dataSource.currentValue) {
            this._initObjectUUID(cloneDeep(dataSource.currentValue));
        }
        if (theme && theme.currentValue) {
            this._setColorSchemeFromTheme(theme.currentValue);
        }
        if (timelineMaxTimeMs) {
            this._maxScrubberPositionPx = timelineMaxTimeMs.currentValue ? this.convertDurationMsToPx(timelineMaxTimeMs.currentValue) : null;
            this._drawCanvasRuler();
        }
        if (intervalDurationMs && intervalDurationMs.currentValue) {
            this._refreshZoomLevelInfo();
            this._drawCanvasRuler();
        }
    }
    /**
     * Create a color scheme list used on the item elements
     */
    _setColorSchemeFromTheme(theme) {
        const newTheme = this.colorSetsService.defaultThemes.find((t) => t.name === theme);
        this._colorScheme = [];
        if (newTheme) {
            for (let i = 0; i < 6; i++) {
                const color = new Color(newTheme.domain[i]);
                this._colorScheme.push({
                    base: color,
                    on: this._resolveForegroundColor(color),
                });
            }
        }
    }
    /**
     * Return black or white based on the rgb background color contrast
     * https://en.wikipedia.org/wiki/YIQ
     */
    _resolveForegroundColor(color) {
        const r = color.color[0];
        const g = color.color[1];
        const b = color.color[2];
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? '#000' : '#FFF';
    }
    /**
     * @ignore
     */
    ngOnInit() {
        if (!this.zoomLevel) {
            this.zoomLevel = 2;
            this._refreshZoomLevelInfo();
        }
        if (this.theme) {
            this._setColorSchemeFromTheme(this.theme);
        }
        this.dragOverObservable.subscribe((data) => {
            this._moveItemsOnDragOver(data.evt, data.timelineId);
        });
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /**
     * @ignore
     */
    ngAfterViewInit() {
        this._drawCanvasRuler();
        fromEvent(this._document, 'keydown')
            .pipe(filter((event) => (event.keyCode === DELETE || event.keyCode === BACKSPACE) && !this.disabled), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.deleteSelectedItems();
        });
        // listen scroll event on timeline-wrapper div element
        const leftSection = this.timelineLeftSection.nativeElement;
        const leftSectionPos = leftSection.getBoundingClientRect().left;
        fromEvent(this.timelineWrapper.nativeElement, 'scroll')
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            const leftPos = this.timelineContainer.nativeElement.getBoundingClientRect().left;
            if (leftPos < leftSectionPos) {
                leftSection.classList.add('on-top');
            }
            else {
                leftSection.classList.remove('on-top');
            }
        });
    }
    /**
     * Generate UUIDs on timeline rows and items
     * will not regenerate uuids if they already exists
     */
    _initObjectUUID(dataSource) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < dataSource.length; i++) {
            dataSource[i].uuid = dataSource[i].uuid || v4();
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let j = 0; j < dataSource[i].items.length; j++) {
                dataSource[i].items[j].uuid = dataSource[i].items[j].uuid || v4();
            }
        }
        this.dataSource = [...dataSource];
    }
    /**
     * Set default based on the layout mode
     */
    _refreshZoomLevelInfo() {
        this._lastDraggedItem = undefined;
        this._currentStepDurationMs = this._availableStepDurationMs[this._availableStepDurationMs.length - this.zoomLevel];
        this._totalSnappableIntervalsInStep = this._currentStepDurationMs / this.intervalDurationMs;
        this._snappableIntervalPx = this._stepWidthPx / this._totalSnappableIntervalsInStep;
        // reset the scrubber at the same time position (dont emit the time change event tho)
        this._setScrubberAtXPosition(this.convertDurationMsToPx(this._currentTimePos), null);
        // adjust the timeline width
        if (this.timelineMaxTimeMs) {
            this._maxScrubberPositionPx = this.convertDurationMsToPx(this.timelineMaxTimeMs);
        }
    }
    /**
     * Set container width
     */
    _setContainerWidth() {
        // check the max length of the timeline if any
        if (this.timelineMaxTimeMs) {
            const widthPx = this.convertDurationMsToPx(this.timelineMaxTimeMs);
            this.timelineRightSection.nativeElement.style.width = widthPx + this._stepWidthPx + 'px';
            this.timelineMainSection.nativeElement.style.width = widthPx + 'px';
            this.timelineCanvasRuler.nativeElement.width = widthPx + this._stepWidthPx;
            this.timelineContainer.nativeElement.style.removeProperty('width');
            return;
        }
        else {
            const timelineContainerEl = this.timelineContainer.nativeElement;
            timelineContainerEl.style.width = this._getContainerWidth() + 'px';
        }
        const canvas = this.timelineCanvasRuler.nativeElement;
        const parentWidth = canvas.parentElement.offsetWidth;
        canvas.width = parentWidth;
    }
    /**
     * Get container width
     */
    _getContainerWidth() {
        const positions = [];
        let containerWidth;
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.dataSource.length; i++) {
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let j = 0; j < this.dataSource[i].items.length; j++) {
                positions.push(this.convertDurationMsToPx(this.dataSource[i].items[j].pos + this.dataSource[i].items[j].dur));
            }
        }
        containerWidth = Math.round(Math.max(...positions) + this._timelineBufferWidth);
        if (containerWidth < this._timelineMinWidth) {
            containerWidth = this._timelineMinWidth;
        }
        return containerWidth;
    }
    /**
     * Draws a ruler
     */
    _drawCanvasRuler() {
        this._setContainerWidth();
        const canvas = this.timelineCanvasRuler.nativeElement;
        const ctx = canvas.getContext('2d');
        ctx.strokeStyle = 'rgb(230, 230, 230)';
        ctx.fillStyle = 'rgb(230, 230, 230)';
        ctx.textAlign = 'left';
        ctx.font = '12px sans-serif';
        ctx.lineWidth = 0.75;
        ctx.beginPath();
        // get the amount of px for an interval indicator (with a max of 20 indicators per step)
        const intervalPx = this._stepWidthPx / Math.min(this._totalSnappableIntervalsInStep, 20);
        // since the division is no always an integer, keep the modulo to determine when to draw the interval
        const modulo = this._stepWidthPx % Math.min(this._totalSnappableIntervalsInStep, 20);
        let lastStepIndex = 0;
        for (let i = 0; i < canvas.width; i++) {
            // check if we have reached a step
            const drawStep = i % this._stepWidthPx === 0;
            const drawStepInterval = !drawStep && i % intervalPx < 1 && i > lastStepIndex + modulo;
            if (!drawStep && !drawStepInterval) {
                continue;
            }
            if (drawStep) {
                lastStepIndex = i;
            }
            const currentStepMs = (i / this._stepWidthPx) * this._currentStepDurationMs;
            const timeObj = msToTime$1(currentStepMs);
            if (drawStep) {
                ctx.fillText(timeObj.hours + ':' + timeObj.minutes + ':' + timeObj.seconds + ':' + timeObj.milliseconds, i, 16);
                if (i === 0) {
                    ctx.textAlign = 'center';
                }
            }
            ctx.moveTo(i, drawStep ? 20 : 28);
            ctx.lineTo(i, 40);
        }
        ctx.stroke();
    }
    /**
     * Emits an event with the selected item when you click on it
     */
    onToggleSelect(evt, item) {
        const originalState = item.selected;
        if (!evt.shiftKey && !evt.ctrlKey) {
            this.deselectAllItems();
        }
        item.selected = !originalState;
        const data = {
            data: {
                item: cloneDeep(item),
                list: cloneDeep(this.getTimelineOfItem(item.uuid)),
            },
        };
        this.itemSelected.emit(cloneDeep(data));
    }
    /**
     * Deselects all selected items
     */
    deselectAllItems() {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.dataSource.length; i++) {
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let j = 0; j < this.dataSource[i].items.length; j++) {
                this.dataSource[i].items[j].selected = false;
            }
        }
    }
    /**
     * Delete all selected items
     */
    deleteSelectedItems() {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.dataSource.length; i++) {
            this.dataSource[i].items = this.dataSource[i].items.filter((item) => !item.selected);
        }
    }
    /**
     * Move all items to the right when dragover is detected
     */
    _moveItemsOnDragOver(evt, timelineId) {
        if (!this._lastDraggedItem) {
            return;
        }
        const targetId = evt.target.id;
        const targetIsDraggable = evt.target.getAttribute('draggable');
        const dragItem = this.getItem(this._lastDraggedItem.item.uuid);
        const timelineIndex = this.getTimelineIndex(timelineId);
        if (targetIsDraggable && timelineId !== this._lastOveredContainer && timelineId !== targetId && dragItem.uuid !== targetId) {
            // do a draggable container backup
            if (!this._timelineItemsBackup || timelineId !== this._timelineItemsBackup.uuid) {
                this._timelineItemsBackup = Object.assign({}, this.dataSource[timelineIndex]);
            }
            if (targetId) {
                const items = this._getNextItems(targetId);
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < items.length; i++) {
                    const itemIndex = this.getItemIndex(items[i].uuid);
                    this.updateTimelineItemPosition(this.dataSource[timelineIndex].items[itemIndex].uuid, items[i].pos + dragItem.dur);
                    this._lastOveredContainer = timelineId;
                }
            }
        }
        else if (this._timelineItemsBackup && targetIsDraggable && dragItem.uuid === targetId) {
            if (this._timelineItemsBackup) {
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < this._timelineItemsBackup.items.length; i++) {
                    this.updateTimelineItemPosition(this._timelineItemsBackup.items[i].uuid, this._timelineItemsBackup.items[i].pos);
                }
            }
        }
    }
    /**
     * Specifies what data to be dragged by setting a custom data object
     */
    onTimelineItemDragStart(evt, item) {
        const data = {
            item,
            offsetX: evt.offsetX,
            offsetY: evt.offsetY,
            pageX: evt.pageX,
            pageY: evt.pageY,
        };
        const elementRef = JSON.stringify(data);
        this._lastDraggedItem = data;
        evt.dataTransfer.setData('ref', elementRef);
    }
    /**
     * Cast new dragover event value
     */
    onTimelineDragOver(evt, timelineId) {
        evt.preventDefault();
        if (!this._isFloatingItem()) {
            this.dragOverSubject.next({ evt, timelineId });
        }
    }
    /**
     * Append or move the dragged item into the container by changing its position and duration.
     * Features:
     *  1-snap position on time grid effect
     *  2-resize item if no space
     *  3-snap on before and after limits
     */
    onTimelineDrop(evt) {
        evt.preventDefault();
        const data = JSON.parse(evt.dataTransfer.getData('ref'));
        const item = data.item;
        let itemId = item.uuid;
        const timelineSourceId = this.getTimelineUuidOfItem(itemId);
        const timelineDestId = evt.target.id;
        const distance = this.convertPxToDurationMs(evt.pageX - data.pageX);
        const offsetMargin = this.mainSection.getBoundingClientRect().left;
        let finalPos = item.pos !== undefined
            ? this._snapOnTimeValue(item.pos + distance)
            : this._snapOnTimeValue(this.convertPxToDurationMs(evt.pageX - data.offsetX - offsetMargin));
        // timeline limit validation
        if (finalPos < 0) {
            finalPos = 0;
        }
        if (timelineSourceId !== timelineDestId && evt.target.classList.contains('timeline-row')) {
            if (item.pos !== undefined) {
                this._moveItemToTimeline(itemId, timelineSourceId, timelineDestId);
            }
            else {
                itemId = this._addItemToTimeline(item, timelineDestId).uuid;
            }
            this.sortTimelineItems(timelineDestId);
        }
        this.updateTimelineItemPosition(itemId, finalPos);
        // media limits validation
        const elements = {
            prev: this._getPreviousTimelineItem(itemId),
            next: this._getNextTimelineItem(itemId),
        };
        const afterLimit = this.convertPxToDurationMs(this._getContainerWidth());
        const limits = {
            before: elements.prev ? elements.prev.pos + elements.prev.dur : 0,
            after: elements.next ? elements.next.pos : afterLimit,
        };
        if (!this._isFloatingItem()) {
            if (finalPos + item.dur > limits.after) {
                finalPos = limits.after - item.dur;
            }
            if (finalPos < limits.before) {
                finalPos = limits.before;
            }
        }
        this.updateTimelineItemPosition(itemId, finalPos);
        // resize if there is no space
        if (limits.after - limits.before < item.dur && !this._isFloatingItem()) {
            this.updateTimelineItemDuration(itemId, limits.after - limits.before);
        }
        this._lastDraggedItem = undefined;
        this._lastOveredContainer = undefined;
        this.dataSourceChanged.emit(this.dataSource);
        this._drawCanvasRuler();
    }
    /** Called when the resize handle of a timeline item starts being resized **/
    onItemResizeStart(event, item) {
        this._originalItemResized = cloneDeep(item);
    }
    /** Called when a timeline item is being resized **/
    onItemResizeMove(evt, item, resizeHandle) {
        // cannot resize past the first sibling non floating element
        if (resizeHandle === 'left') {
            const prevItem = this._getPreviousTimelineItem(item.uuid, false);
            // can only expand item up to the timeline edge (0ms) or the previous non floating item end
            const maxExpandTimeMs = !prevItem ? 0 : prevItem.pos + prevItem.dur;
            const maxExpandDurationMs = this._originalItemResized.pos - maxExpandTimeMs;
            const maxPxResizeLeft = this.convertDurationMsToPx(maxExpandDurationMs);
            // can only shrink item up to the minimum media duration
            const maxShrinkDurationMs = this._originalItemResized.dur - this.mediaMinDurationMs;
            const maxPxResizeRight = this.convertDurationMsToPx(maxShrinkDurationMs);
            const isAboveLeftThreshold = evt.initialDiffX < 0 && Math.abs(evt.initialDiffX) > maxPxResizeLeft;
            const isAboveRightThreshold = evt.initialDiffX > 0 && Math.abs(evt.initialDiffX) > maxPxResizeRight;
            if (isAboveLeftThreshold) {
                const newPositionMs = prevItem ? prevItem.pos + prevItem.dur : 0;
                const newDurationMs = this._originalItemResized.dur + this._originalItemResized.pos - (prevItem ? prevItem.pos + prevItem.dur : 0);
                this.updateTimelineItemDuration(item.uuid, newDurationMs);
                this.updateTimelineItemPosition(item.uuid, newPositionMs);
            }
            else if (isAboveRightThreshold) {
                this.updateTimelineItemDuration(item.uuid, this._originalItemResized.pos + this._originalItemResized.dur - this.mediaMinDurationMs);
                this.updateTimelineItemPosition(item.uuid, this.mediaMinDurationMs);
            }
            else {
                const diffPx = evt.initialDiffX;
                const durationMsToAdd = this._snapOnTimeValue(this.convertPxToDurationMs(diffPx));
                this.updateTimelineItemDuration(item.uuid, this._originalItemResized.dur - durationMsToAdd);
                this.updateTimelineItemPosition(item.uuid, this._originalItemResized.pos + durationMsToAdd);
            }
        }
        else {
            const nextItem = this._getNextTimelineItem(item.uuid, false);
            const limitToTimelineMax = !nextItem && this.timelineMaxTimeMs;
            // can only shrink item up to the minimum media duration
            const maxShrinkDurationMs = this._originalItemResized.dur - this.mediaMinDurationMs;
            const maxPxResizeLeft = this.convertDurationMsToPx(maxShrinkDurationMs);
            // can only expand item to either the start of the next non floating item, or the max timeline length
            const maxExpandTimeMs = nextItem ? nextItem.pos : limitToTimelineMax ? this.timelineMaxTimeMs : null;
            const maxExpandDurationMs = maxExpandTimeMs ? maxExpandTimeMs - (this._originalItemResized.pos + this._originalItemResized.dur) : null;
            const maxPxResizeRight = maxExpandDurationMs !== null ? this.convertDurationMsToPx(maxExpandDurationMs) : null;
            const isAboveLeftThreshold = evt.initialDiffX < 0 && Math.abs(evt.initialDiffX) > maxPxResizeLeft;
            const isAboveRightThreshold = maxPxResizeRight !== null && evt.initialDiffX > 0 && Math.abs(evt.initialDiffX) > maxPxResizeRight;
            if (isAboveLeftThreshold) {
                const newDurationMs = this.mediaMinDurationMs;
                this.updateTimelineItemDuration(item.uuid, newDurationMs);
            }
            else if (isAboveRightThreshold) {
                const newDurationMs = maxExpandTimeMs - this._originalItemResized.pos;
                this.updateTimelineItemDuration(item.uuid, newDurationMs);
            }
            else {
                const diffPx = Math.abs(evt.initialDiffX);
                const durationMsToAdd = this._snapOnTimeValue(this.convertPxToDurationMs(diffPx));
                this.updateTimelineItemDuration(item.uuid, evt.initialDiffX < 0 ? this._originalItemResized.dur - durationMsToAdd : this._originalItemResized.dur + durationMsToAdd);
            }
        }
    }
    /** Called when the resize handle of a timeline item starts being resized **/
    onResizeItemEnd(event, item) {
        const hasChanged = item.pos !== this._originalItemResized.pos || item.dur !== this._originalItemResized.dur;
        if (hasChanged) {
            this.dataSourceChanged.emit(this.dataSource);
        }
        this._originalItemResized = null;
    }
    /**
     * Resize item on double click by changing its position and/or duration.
     * Features:
     *  1-snap on before and after limits
     *  2-use left and right handles in horizontal mode
     *  3-use top and bottom handles in vertical mode
     */
    onTimelineItemResizerDblClick(evt, pos, id) {
        const el = evt.target;
        const originalWidth = evt.target.parentNode.getBoundingClientRect().right - evt.target.parentNode.getBoundingClientRect().left;
        const originalHeight = evt.target.parentNode.getBoundingClientRect().bottom - evt.target.parentNode.getBoundingClientRect().top;
        const elements = {
            prev: this._getPreviousTimelineItem(id),
            next: this._getNextTimelineItem(id),
        };
        const afterLimit = this._getContainerWidth();
        const limits = {
            before: elements.prev ? elements.prev.pos + elements.prev.dur : 0,
            after: elements.next ? elements.next.pos : this.convertPxToDurationMs(afterLimit),
        };
        let newDur;
        if (el.classList.contains('left')) {
            // Resize Left
            newDur = Math.round(this.convertPxToDurationMs(originalWidth) + pos - limits.before);
            this.updateTimelineItemDuration(id, newDur);
            this.updateTimelineItemPosition(id, limits.before);
        }
        else if (el.classList.contains('right')) {
            // Resize Right
            newDur = limits.after - pos;
            this.updateTimelineItemDuration(id, newDur);
        }
        else if (el.classList.contains('top')) {
            // Resize Top
            newDur = Math.round(this.convertPxToDurationMs(originalHeight) + pos - limits.before);
            this.updateTimelineItemDuration(id, newDur);
            this.updateTimelineItemPosition(id, limits.before);
        }
        else {
            // Resize Bottom
            newDur = limits.after - pos;
            this.updateTimelineItemDuration(id, newDur);
        }
        this.dataSourceChanged.emit(this.dataSource);
    }
    /**
     * Return a rounded value based on snap distance calculation
     */
    _snapOnTimeValue(value) {
        return value - (value % this.intervalDurationMs);
    }
    /**
     * Stop propagation on resizer click
     */
    onTimelineItemResizerClick(evt) {
        evt.stopPropagation();
    }
    /**
     * Change the position of an item
     */
    updateTimelineItemPosition(itemUuid, newPosition) {
        const item = this.getItem(itemUuid);
        if (item) {
            item.pos = newPosition;
        }
    }
    /**
     * Change the duration of an item
     */
    updateTimelineItemDuration(itemUuid, newDuration) {
        const item = this.getItem(itemUuid);
        if (item) {
            item.dur = newDuration;
        }
    }
    /**
     * Get the previous item based on the reference one
     */
    _getPreviousTimelineItem(itemUuid, includeFloatingItems = true) {
        const timelineIndex = this.getTimelineIndexOfItem(itemUuid);
        const timeline = this.getTimelineOfItem(itemUuid);
        this.sortTimelineItems(this.dataSource[timelineIndex].uuid);
        const itemIndex = this.getItemIndex(itemUuid);
        let nextItem;
        for (let i = itemIndex - 1; i >= 0; i--) {
            if (includeFloatingItems || !timeline.items[i].floating) {
                nextItem = timeline.items[i];
                break;
            }
        }
        return nextItem;
    }
    /**
     * Get the next item based on the reference one
     */
    _getNextTimelineItem(itemUuid, includeFloatingItems = true) {
        const timelineIndex = this.getTimelineIndexOfItem(itemUuid);
        const timeline = this.getTimelineOfItem(itemUuid);
        this.sortTimelineItems(this.getTimelineAtIndex(timelineIndex));
        const itemIndex = this.getItemIndex(itemUuid);
        let nextItem;
        for (let i = itemIndex + 1; i < timeline.items.length; i++) {
            if (includeFloatingItems || !timeline.items[i].floating) {
                nextItem = timeline.items[i];
                break;
            }
        }
        return nextItem;
    }
    /**
     * Return next items list based on the reference one (reference is included)
     */
    _getNextItems(id) {
        const timelineIndex = this.getTimelineIndexOfItem(id);
        const elIndex = this.getItemIndex(id);
        const timelineItems = this.dataSource[timelineIndex].items;
        return timelineItems.slice(elIndex, this.dataSource[timelineIndex].items.length);
    }
    /**
     * Return the container index based on an item
     */
    getTimelineIndexOfItem(itemUuid) {
        return this.dataSource.findIndex((timeline) => timeline.items.some((item) => item.uuid === itemUuid));
    }
    /**
     * Returns the item's parent timeline uuid
     */
    getTimelineUuidOfItem(itemUuid) {
        return this.dataSource.find((timeline) => timeline.items.some((item) => item.uuid === itemUuid))?.uuid;
    }
    /**
     * Returns the item's parent timeline
     */
    getTimelineOfItem(itemUuid) {
        return this.dataSource.find((timeline) => timeline.items.some((item) => item.uuid === itemUuid));
    }
    /**
     * Return the container index based on a container id
     */
    getTimelineIndex(timelineUuid) {
        return this.dataSource.findIndex((timeline) => timeline.uuid === timelineUuid);
    }
    /**
     * Return the container id based on a container index
     */
    getTimelineAtIndex(index) {
        return this.dataSource[index].uuid;
    }
    /**
     * Create mouseMove event listener on scrubber move action
     */
    onScrubberMouseMove(evt) {
        const scrubberLeft = this.timelineCanvasRuler.nativeElement.getBoundingClientRect().left;
        const movedX = evt.clientX - scrubberLeft;
        this._setScrubberAtXPosition(movedX, 'scrubber');
    }
    /**
     * @ignore
     */
    _setScrubberAtXPosition(xPos, trigger) {
        if (xPos < 0) {
            xPos = 0;
        }
        else if (this._maxScrubberPositionPx && xPos > this._maxScrubberPositionPx) {
            xPos = this._maxScrubberPositionPx;
        }
        // calculate the current
        const intervalIndex = Math.floor(xPos / this._snappableIntervalPx);
        const timeOfInterval = intervalIndex * this.intervalDurationMs;
        this._currentTimePos = timeOfInterval;
        this._currentTime = msToTime$1(timeOfInterval);
        this.scrubberLeftPx = intervalIndex * this._snappableIntervalPx;
        // if a trigger was specified, then send an event
        if (trigger) {
            this.currentTimeScrubberChanged.emit({
                time: this._currentTime,
                timeMs: this._currentTimePos,
                trigger,
            });
        }
    }
    /**
     * Change the scrubber position on ruler click
     */
    onCanvasClick(evt) {
        evt.preventDefault();
        if (this.displayCurrentTimeIndicator) {
            const scrubberLeft = this.timelineCanvasRuler.nativeElement.getBoundingClientRect().left;
            const newScrubberXPosition = evt.clientX - scrubberLeft;
            this._setScrubberAtXPosition(newScrubberXPosition, 'scrubber');
        }
    }
    /**
     * Returns the item corresponding to its UUID
     */
    getItem(itemUuid) {
        const timelineIndex = this.getTimelineIndexOfItem(itemUuid);
        let element;
        if (timelineIndex !== -1) {
            element = this.dataSource[timelineIndex].items.find((item) => item.uuid === itemUuid);
        }
        return element ? element : undefined;
    }
    /**
     * Returns the item index corresponding to its UUID
     */
    getItemIndex(itemUuid) {
        const timeline = this.getTimelineOfItem(itemUuid);
        if (!timeline) {
            return -1;
        }
        return timeline.items.findIndex((item) => item.uuid === itemUuid);
    }
    /**
     * Sort by position on an item list
     */
    sortTimelineItems(timelineUuid) {
        const timelineToSort = this.dataSource.find((timeline) => timeline.uuid === timelineUuid);
        timelineToSort.items.sort((a, b) => a.pos - b.pos);
    }
    /**
     * Move an item from one timeline to another
     */
    _moveItemToTimeline(itemUuid, sourceTimelineUuid, destinationTimelineUuid) {
        const item = this.getItem(itemUuid);
        const itemIndex = this.getItemIndex(itemUuid);
        this.dataSource[this.getTimelineIndex(sourceTimelineUuid)].items.splice(itemIndex, 1);
        this.dataSource[this.getTimelineIndex(destinationTimelineUuid)].items.push(item);
    }
    /**
     * Add an item to a container
     */
    _addItemToTimeline(item, destinationTimelineUuid) {
        item.uuid = v4();
        this.dataSource[this.getTimelineIndex(destinationTimelineUuid)].items.push(item);
        return item;
    }
    /**
     * Convert a time duration in milliseconds to a pixel value
     */
    convertDurationMsToPx(timeMs) {
        // calc the px amount of 1ms
        const pxFor1ms = this._stepWidthPx / this._currentStepDurationMs;
        return timeMs * pxFor1ms;
    }
    /**
     * Convert a pixel based value to time duration in milliseconds
     */
    convertPxToDurationMs(pixelCount) {
        const pxFor1ms = this._stepWidthPx / this._currentStepDurationMs;
        return pixelCount / pxFor1ms;
    }
    /** returns the current time of the component / indicated by scrubber */
    get currentTime() {
        return this._currentTime;
    }
    /** Sets the current time of the component / indicated by scrubber */
    updateTimePosition(timeMs) {
        // must be within allowed time limits
        if (timeMs < 0 || (this.timelineMaxTimeMs && timeMs > this.timelineMaxTimeMs)) {
            return;
        }
        this._setScrubberAtXPosition(this.convertDurationMsToPx(timeMs), 'app');
    }
    /** returns the current time in milliseconds of the component / indicated by scrubber */
    get currentTimePositionMs() {
        return this._currentTimePos;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineComponent, deps: [{ token: i0.Renderer2 }, { token: ColorSetsService }, { token: WINDOW }, { token: DOCUMENT }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineComponent, selector: "avn-timeline", inputs: { dataSource: "dataSource", displayCurrentTimeIndicator: "displayCurrentTimeIndicator", displayResizer: "displayResizer", zoomLevel: "zoomLevel", changeItemPosition: "changeItemPosition", changeItemDuration: "changeItemDuration", itemTemplate: "itemTemplate", axisTemplate: "axisTemplate", leftSectionWidth: "leftSectionWidth", timelineSmallerDimension: "timelineSmallerDimension", theme: "theme", disabled: "disabled", timelineMaxTimeMs: "timelineMaxTimeMs", mediaMinDurationMs: "mediaMinDurationMs", intervalDurationMs: "intervalDurationMs", disabledSelectionPreview: "disabledSelectionPreview", rulerClasses: "rulerClasses" }, outputs: { itemSelected: "itemSelected", dataSourceChanged: "dataSourceChanged", currentTimeScrubberChanged: "currentTimeScrubberChanged" }, viewQueries: [{ propertyName: "timelineWrapper", first: true, predicate: ["timelineWrapper"], descendants: true, static: true }, { propertyName: "timelineContainer", first: true, predicate: ["timelineContainer"], descendants: true, static: true }, { propertyName: "timelineLeftSection", first: true, predicate: ["leftSection"], descendants: true }, { propertyName: "timelineRightSection", first: true, predicate: ["rightSection"], descendants: true }, { propertyName: "timelineMainSection", first: true, predicate: ["mainSection"], descendants: true }, { propertyName: "timelineCanvasRuler", first: true, predicate: ["canvasRuler"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div #timelineWrapper class=\"timeline-wrapper\" avnScroll>\n  <div #timelineContainer class=\"timeline-container\">\n    <div class=\"left-section sticky\" #leftSection [style.minWidth.px]=\"leftSectionWidth\">\n      <div class=\"axis-section top\">\n        <span *ngIf=\"displayCurrentTimeIndicator\"\n          >{{ currentTime.hours }}:{{ currentTime.minutes }}:{{ currentTime.seconds }}:{{ currentTime.milliseconds }}</span\n        >\n      </div>\n      <div class=\"axis-section\" *ngFor=\"let source of dataSource\" [style.height.px]=\"source.size ? source.size : timelineSmallerDimension\">\n        <ng-template #defaultAxisTemplate>\n          <div>{{ source.name }}</div>\n        </ng-template>\n        <ng-container [ngTemplateOutlet]=\"axisTemplate ? axisTemplate : defaultAxisTemplate\" [ngTemplateOutletContext]=\"{ $implicit: source }\"> </ng-container>\n      </div>\n    </div>\n    <div class=\"right-section\" #rightSection>\n      <avn-timeline-scrubber-v1\n        *ngIf=\"displayCurrentTimeIndicator\"\n        avnDrag\n        [showDraggingOverlay]=\"false\"\n        [allowOutsideMove]=\"true\"\n        [debounceTime]=\"0\"\n        [cursor]=\"'grab'\"\n        [axis]=\"'x'\"\n        (dragMove)=\"onScrubberMouseMove($event)\"\n        [style.transform]=\"'translateX(' + scrubberLeftPx + 'px)'\"\n      ></avn-timeline-scrubber-v1>\n      <div class=\"top-section\">\n        <div [ngClass]=\"rulerClasses\" class=\"canvas-wrapper\">\n          <canvas #canvasRuler class=\"canvas-ruler\" height=\"40\" (click)=\"onCanvasClick($event)\"></canvas>\n        </div>\n      </div>\n      <div class=\"main-section\" #mainSection>\n        <div\n          [id]=\"timeline.uuid\"\n          class=\"timeline-row\"\n          *ngFor=\"let timeline of dataSource\"\n          [style.height.px]=\"timeline.size ? timeline.size : timelineSmallerDimension\"\n          [class.disabled]=\"disabled\"\n          (drop)=\"!disabled && onTimelineDrop($event)\"\n          (dragover)=\"!disabled && onTimelineDragOver($event, timeline.uuid)\"\n        >\n          <avn-timeline-item\n            *ngFor=\"let item of timeline.items\"\n            draggable=\"true\"\n            [id]=\"item.uuid\"\n            class=\"timeline-item\"\n            [ngClass]=\"item.class ? item.class : ''\"\n            [class.floating]=\"item.floating\"\n            [class.selected]=\"item.selected\"\n            [class.resizable]=\"item.resizable\"\n            [style.width.px]=\"convertDurationMsToPx(item.dur)\"\n            [style.height.px]=\"timeline.size ? timeline.size : timelineSmallerDimension\"\n            [style.transform]=\"'translateX(' + convertDurationMsToPx(item.pos) + 'px)'\"\n            [style.backgroundColor]=\"getItemColor(item, item.hover)\"\n            [style.color]=\"getItemOnColor(item)\"\n            [style.cursor]=\"!disabled ? 'grab' : 'inherit'\"\n            (mouseenter)=\"item.hover = true\"\n            (mouseleave)=\"item.hover = undefined\"\n            (click)=\"onToggleSelect($event, item)\"\n            (dragstart)=\"!disabled && onTimelineItemDragStart($event, item)\"\n          >\n            <div class=\"main-content\">\n              <ng-template #defaultItemTemplate>\n                <div>{{ item.name }}</div>\n              </ng-template>\n              <ng-container\n                [ngTemplateOutlet]=\"itemTemplate ? itemTemplate : defaultItemTemplate\"\n                [ngTemplateOutletContext]=\"{\n                  $implicit: item,\n                  size: convertDurationMsToPx(item.dur)\n                }\"\n              >\n              </ng-container>\n            </div>\n            <div\n              *ngIf=\"displayResizer && !disabled\"\n              class=\"resizer left\"\n              (click)=\"onTimelineItemResizerClick($event)\"\n              (dblclick)=\"onTimelineItemResizerDblClick($event, item.pos, item.uuid)\"\n              avnDrag\n              [showDraggingOverlay]=\"false\"\n              [allowOutsideMove]=\"true\"\n              [debounceTime]=\"0\"\n              [cursor]=\"'w-resize'\"\n              [axis]=\"'x'\"\n              (dragStart)=\"onItemResizeStart($event, item)\"\n              (dragMove)=\"onItemResizeMove($event, item, 'left')\"\n              (dragEnd)=\"onResizeItemEnd($event, item)\"\n            ></div>\n            <div\n              *ngIf=\"displayResizer && !disabled\"\n              class=\"resizer right\"\n              (click)=\"onTimelineItemResizerClick($event)\"\n              (dblclick)=\"onTimelineItemResizerDblClick($event, item.pos, item.uuid)\"\n              avnDrag\n              [showDraggingOverlay]=\"false\"\n              [allowOutsideMove]=\"true\"\n              [debounceTime]=\"0\"\n              [cursor]=\"'w-resize'\"\n              [axis]=\"'x'\"\n              (dragStart)=\"onItemResizeStart($event, item)\"\n              (dragMove)=\"onItemResizeMove($event, item, 'right')\"\n              (dragEnd)=\"onResizeItemEnd($event, item)\"\n            ></div>\n          </avn-timeline-item>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}:host .header-section{display:flex;padding-bottom:var(--space-base);align-items:flex-end}:host .header-section avn-input,:host .header-section avn-button{padding-left:var(--space-base)}:host .header-section avn-button:first-child{padding-left:0}:host .timeline-wrapper{overflow:auto}:host .timeline-container{position:relative;display:flex;background-color:var(--main-background);color:var(--main-on)}:host .left-section{background-color:var(--main-background);color:var(--main-on);align-items:center;margin-right:1px;z-index:1}:host .left-section.sticky{position:sticky;left:0;z-index:10}:host .left-section.on-top{z-index:11}:host .right-section{width:100%}:host .top-section{height:40px;vertical-align:middle;display:flex;align-items:center}:host .axis-section{display:flex;align-items:center;justify-content:center;margin-top:1px;vertical-align:middle;font-size:var(--text-sm)}:host .axis-section.top{height:40px;margin:0;color:var(--secondary-base);font-weight:700;font-size:var(--text-sm)}:host .timeline-row{width:100%;background-color:#ffffff1a;margin-top:1px}:host .timeline-item{position:absolute;display:flex;border-radius:2px;z-index:1;box-sizing:border-box;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:box-shadow .2s cubic-bezier(0,0,.2,1);transition:background-color .2s;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host .timeline-item.floating{pointer-events:auto;opacity:.9;z-index:2}:host .timeline-item:active{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .canvas-wrapper{position:relative;width:100%;height:40px}:host .canvas-ruler{position:absolute;height:40px;top:0;left:0}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: DragDirective, selector: "[avnDrag]", inputs: ["debounceTime", "allowOutsideMove", "axis", "cursor", "showDraggingOverlay"], outputs: ["dragStart", "dragMove", "dragEnd"] }, { kind: "component", type: TimelineScrubberComponentV1, selector: "avn-timeline-scrubber-v1" }, { kind: "component", type: TimelineItemComponent, selector: "avn-timeline-item", inputs: ["class"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline', template: "<div #timelineWrapper class=\"timeline-wrapper\" avnScroll>\n  <div #timelineContainer class=\"timeline-container\">\n    <div class=\"left-section sticky\" #leftSection [style.minWidth.px]=\"leftSectionWidth\">\n      <div class=\"axis-section top\">\n        <span *ngIf=\"displayCurrentTimeIndicator\"\n          >{{ currentTime.hours }}:{{ currentTime.minutes }}:{{ currentTime.seconds }}:{{ currentTime.milliseconds }}</span\n        >\n      </div>\n      <div class=\"axis-section\" *ngFor=\"let source of dataSource\" [style.height.px]=\"source.size ? source.size : timelineSmallerDimension\">\n        <ng-template #defaultAxisTemplate>\n          <div>{{ source.name }}</div>\n        </ng-template>\n        <ng-container [ngTemplateOutlet]=\"axisTemplate ? axisTemplate : defaultAxisTemplate\" [ngTemplateOutletContext]=\"{ $implicit: source }\"> </ng-container>\n      </div>\n    </div>\n    <div class=\"right-section\" #rightSection>\n      <avn-timeline-scrubber-v1\n        *ngIf=\"displayCurrentTimeIndicator\"\n        avnDrag\n        [showDraggingOverlay]=\"false\"\n        [allowOutsideMove]=\"true\"\n        [debounceTime]=\"0\"\n        [cursor]=\"'grab'\"\n        [axis]=\"'x'\"\n        (dragMove)=\"onScrubberMouseMove($event)\"\n        [style.transform]=\"'translateX(' + scrubberLeftPx + 'px)'\"\n      ></avn-timeline-scrubber-v1>\n      <div class=\"top-section\">\n        <div [ngClass]=\"rulerClasses\" class=\"canvas-wrapper\">\n          <canvas #canvasRuler class=\"canvas-ruler\" height=\"40\" (click)=\"onCanvasClick($event)\"></canvas>\n        </div>\n      </div>\n      <div class=\"main-section\" #mainSection>\n        <div\n          [id]=\"timeline.uuid\"\n          class=\"timeline-row\"\n          *ngFor=\"let timeline of dataSource\"\n          [style.height.px]=\"timeline.size ? timeline.size : timelineSmallerDimension\"\n          [class.disabled]=\"disabled\"\n          (drop)=\"!disabled && onTimelineDrop($event)\"\n          (dragover)=\"!disabled && onTimelineDragOver($event, timeline.uuid)\"\n        >\n          <avn-timeline-item\n            *ngFor=\"let item of timeline.items\"\n            draggable=\"true\"\n            [id]=\"item.uuid\"\n            class=\"timeline-item\"\n            [ngClass]=\"item.class ? item.class : ''\"\n            [class.floating]=\"item.floating\"\n            [class.selected]=\"item.selected\"\n            [class.resizable]=\"item.resizable\"\n            [style.width.px]=\"convertDurationMsToPx(item.dur)\"\n            [style.height.px]=\"timeline.size ? timeline.size : timelineSmallerDimension\"\n            [style.transform]=\"'translateX(' + convertDurationMsToPx(item.pos) + 'px)'\"\n            [style.backgroundColor]=\"getItemColor(item, item.hover)\"\n            [style.color]=\"getItemOnColor(item)\"\n            [style.cursor]=\"!disabled ? 'grab' : 'inherit'\"\n            (mouseenter)=\"item.hover = true\"\n            (mouseleave)=\"item.hover = undefined\"\n            (click)=\"onToggleSelect($event, item)\"\n            (dragstart)=\"!disabled && onTimelineItemDragStart($event, item)\"\n          >\n            <div class=\"main-content\">\n              <ng-template #defaultItemTemplate>\n                <div>{{ item.name }}</div>\n              </ng-template>\n              <ng-container\n                [ngTemplateOutlet]=\"itemTemplate ? itemTemplate : defaultItemTemplate\"\n                [ngTemplateOutletContext]=\"{\n                  $implicit: item,\n                  size: convertDurationMsToPx(item.dur)\n                }\"\n              >\n              </ng-container>\n            </div>\n            <div\n              *ngIf=\"displayResizer && !disabled\"\n              class=\"resizer left\"\n              (click)=\"onTimelineItemResizerClick($event)\"\n              (dblclick)=\"onTimelineItemResizerDblClick($event, item.pos, item.uuid)\"\n              avnDrag\n              [showDraggingOverlay]=\"false\"\n              [allowOutsideMove]=\"true\"\n              [debounceTime]=\"0\"\n              [cursor]=\"'w-resize'\"\n              [axis]=\"'x'\"\n              (dragStart)=\"onItemResizeStart($event, item)\"\n              (dragMove)=\"onItemResizeMove($event, item, 'left')\"\n              (dragEnd)=\"onResizeItemEnd($event, item)\"\n            ></div>\n            <div\n              *ngIf=\"displayResizer && !disabled\"\n              class=\"resizer right\"\n              (click)=\"onTimelineItemResizerClick($event)\"\n              (dblclick)=\"onTimelineItemResizerDblClick($event, item.pos, item.uuid)\"\n              avnDrag\n              [showDraggingOverlay]=\"false\"\n              [allowOutsideMove]=\"true\"\n              [debounceTime]=\"0\"\n              [cursor]=\"'w-resize'\"\n              [axis]=\"'x'\"\n              (dragStart)=\"onItemResizeStart($event, item)\"\n              (dragMove)=\"onItemResizeMove($event, item, 'right')\"\n              (dragEnd)=\"onResizeItemEnd($event, item)\"\n            ></div>\n          </avn-timeline-item>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}:host .header-section{display:flex;padding-bottom:var(--space-base);align-items:flex-end}:host .header-section avn-input,:host .header-section avn-button{padding-left:var(--space-base)}:host .header-section avn-button:first-child{padding-left:0}:host .timeline-wrapper{overflow:auto}:host .timeline-container{position:relative;display:flex;background-color:var(--main-background);color:var(--main-on)}:host .left-section{background-color:var(--main-background);color:var(--main-on);align-items:center;margin-right:1px;z-index:1}:host .left-section.sticky{position:sticky;left:0;z-index:10}:host .left-section.on-top{z-index:11}:host .right-section{width:100%}:host .top-section{height:40px;vertical-align:middle;display:flex;align-items:center}:host .axis-section{display:flex;align-items:center;justify-content:center;margin-top:1px;vertical-align:middle;font-size:var(--text-sm)}:host .axis-section.top{height:40px;margin:0;color:var(--secondary-base);font-weight:700;font-size:var(--text-sm)}:host .timeline-row{width:100%;background-color:#ffffff1a;margin-top:1px}:host .timeline-item{position:absolute;display:flex;border-radius:2px;z-index:1;box-sizing:border-box;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:box-shadow .2s cubic-bezier(0,0,.2,1);transition:background-color .2s;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host .timeline-item.floating{pointer-events:auto;opacity:.9;z-index:2}:host .timeline-item:active{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .canvas-wrapper{position:relative;width:100%;height:40px}:host .canvas-ruler{position:absolute;height:40px;top:0;left:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: ColorSetsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }]; }, propDecorators: { dataSource: [{
                type: Input
            }], displayCurrentTimeIndicator: [{
                type: Input
            }], displayResizer: [{
                type: Input
            }], zoomLevel: [{
                type: Input
            }], changeItemPosition: [{
                type: Input
            }], changeItemDuration: [{
                type: Input
            }], itemTemplate: [{
                type: Input
            }], axisTemplate: [{
                type: Input
            }], leftSectionWidth: [{
                type: Input
            }], timelineSmallerDimension: [{
                type: Input
            }], theme: [{
                type: Input
            }], disabled: [{
                type: Input
            }], timelineMaxTimeMs: [{
                type: Input
            }], mediaMinDurationMs: [{
                type: Input
            }], intervalDurationMs: [{
                type: Input
            }], disabledSelectionPreview: [{
                type: Input
            }], itemSelected: [{
                type: Output
            }], dataSourceChanged: [{
                type: Output
            }], currentTimeScrubberChanged: [{
                type: Output
            }], rulerClasses: [{
                type: Input
            }], timelineWrapper: [{
                type: ViewChild,
                args: ['timelineWrapper', { static: true }]
            }], timelineContainer: [{
                type: ViewChild,
                args: ['timelineContainer', { static: true }]
            }], timelineLeftSection: [{
                type: ViewChild,
                args: ['leftSection']
            }], timelineRightSection: [{
                type: ViewChild,
                args: ['rightSection']
            }], timelineMainSection: [{
                type: ViewChild,
                args: ['mainSection']
            }], timelineCanvasRuler: [{
                type: ViewChild,
                args: ['canvasRuler', { static: true }]
            }] } });

class TimelineModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TimelineModule, declarations: [TimelineComponent, TimelineScrubberComponentV1, TimelineItemComponent], imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule], exports: [TimelineComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineModule, imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TimelineComponent, TimelineScrubberComponentV1, TimelineItemComponent],
                    exports: [TimelineComponent],
                    imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule],
                    providers: [],
                }]
        }] });

var TimelineLayoutMode;
(function (TimelineLayoutMode) {
    TimelineLayoutMode[TimelineLayoutMode["HORIZONTAL"] = 0] = "HORIZONTAL";
    TimelineLayoutMode[TimelineLayoutMode["VERTICAL"] = 1] = "VERTICAL";
})(TimelineLayoutMode || (TimelineLayoutMode = {}));

/**
 * Convert milliseconds to a time object (hours, minutes, seconds and milliseconds)
 */
const timeMsToTime = (duration) => {
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const seconds = Math.floor((duration / 1000) % 60);
    const milliseconds = duration % 1000;
    return { hours, minutes, seconds, milliseconds };
};
/**
 * Returns a formatted time object (hours, minutes, seconds and milliseconds) from a milliseconds value and based on a config
 */
const getTimelineDisplayTime = (timeMs, timeConfig) => {
    const { showHours, showMinutes, showSeconds, showMilliseconds } = timeConfig;
    let timeStr = '';
    if (showHours) {
        timeStr += `${padWithZeros(timeMs.hours, 2)}`;
    }
    if (showMinutes) {
        timeStr += `${timeStr.length === 0 ? '' : ':'}`;
        timeStr += `${padWithZeros(timeMs.minutes, 2)}`;
    }
    if (showSeconds) {
        timeStr += `${timeStr.length === 0 ? '' : ':'}`;
        timeStr += `${padWithZeros(timeMs.seconds, 2)}`;
    }
    if (showMilliseconds) {
        timeStr += `${timeStr.length === 0 ? '' : '.'}`;
        timeStr += `${padWithZeros(timeMs.milliseconds, 3)}`;
    }
    return timeStr;
};

/** Computes the grid css template rows value for the timeline based on the number of tracks and other's element dimensions/positions **/
const getTimelineTemplateRows = (trackCount, timelineHeaderHeightPx, trackHeightPx) => `${timelineHeaderHeightPx}px repeat(${trackCount}, ${trackHeightPx}px)`;
/** Computes the height of the time scrubber (positionned absolutely) based on the number of tracks and other's element dimensions/positions **/
const getScrubberHeightPx = (tracksCount, rulerHeightPx, trackHeightPx, scrubberTopPx) => rulerHeightPx + trackHeightPx * tracksCount - scrubberTopPx;
/** Computes and returns ruler specific metrics that changes based on the specified zoom level **/
const getZoomLevelInfo = (zoomLevel, stepDurationMsPerZoomLevel, stepWidthPx, intervalDurationMs) => {
    // make sure the zoom level is valid
    zoomLevel = zoomLevel > stepDurationMsPerZoomLevel.length ? stepDurationMsPerZoomLevel.length : zoomLevel < 1 ? 1 : zoomLevel;
    const stepDurationMs = stepDurationMsPerZoomLevel[stepDurationMsPerZoomLevel.length - zoomLevel];
    const totalSnappableIntervalsInStep = stepDurationMs / intervalDurationMs;
    const snappableIntervalWidthPx = stepWidthPx / totalSnappableIntervalsInStep;
    return {
        level: zoomLevel,
        stepDurationMs,
        totalSnappableIntervalsInStep,
        snappableIntervalWidthPx,
    };
};
/** Calculates the width in px of a track based on all track's existing items and other contrains (min track width, max timeline duration) **/
const getTrackWidthPx = (tracks, stepWidthPx, stepDurationMs, timelineBufferWidthPx, currentTimeMs, timelineMaxDurationMs) => {
    const itemsEndTimePositions = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < tracks.length; i++) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let j = 0; j < tracks[i].items.length; j++) {
            itemsEndTimePositions.push(tracks[i].items[j].positionMs + tracks[i].items[j].durationMs);
        }
    }
    const trackItemMaxEndTimePositionMs = Math.max(...itemsEndTimePositions, currentTimeMs);
    const timelineMaxPx = durationMsToPx(timelineMaxDurationMs, stepWidthPx, stepDurationMs);
    const trackWidthPx = Math.min(durationMsToPx(trackItemMaxEndTimePositionMs, stepWidthPx, stepDurationMs) + timelineBufferWidthPx, timelineMaxPx);
    return trackWidthPx;
};
/**
 * Convert a time duration in milliseconds to a pixel value
 */
const durationMsToPx = (timeMs, stepWidthPx, stepDurationMs) => {
    // calc the px amount of 1ms
    const pxFor1ms = stepWidthPx / stepDurationMs;
    return timeMs * pxFor1ms;
};
/**
 * Convert a pixel based value to time duration in milliseconds
 */
const pxToDurationMs = (px, stepWidthPx, stepDurationMs) => {
    // calc the px amount of 1ms
    const pxFor1ms = stepWidthPx / stepDurationMs;
    return px / pxFor1ms;
};
/**
 * Returns the adjusted time and x position of for the time scrubber, snapped to the nearest available time interval
 */
const getTimeScrubberSnappedInfo = (leftPx, timeScrubberMaxLeftPx, snappableIntervalWidthPx, rulerIntervalDurationMs) => {
    if (leftPx < 0) {
        leftPx = 0;
    }
    else if (timeScrubberMaxLeftPx ?? false) {
        if (leftPx > timeScrubberMaxLeftPx) {
            leftPx = timeScrubberMaxLeftPx;
        }
    }
    // Snap to the nearest interval
    const intervalIndex = Math.round(leftPx / snappableIntervalWidthPx);
    const intervalTimeMs = intervalIndex * rulerIntervalDurationMs;
    return {
        leftPx: intervalIndex * snappableIntervalWidthPx,
        timeMs: intervalTimeMs,
    };
};
/**
 * adds unique internal id to the track items
 */
const addTracksInternalUuids = (tracks) => tracks.map((track) => ({
    uuid: v4(),
    ...track,
    items: track.items.map((item) => ({ ...item, uuid: v4() })),
}));
/**
 * Converts the original tracks to display tracks, by replacing the destination track items with the items from current item dragging info
 * **/
const getDisplayTracks = (originalTracks, destinationTrackIndex, draggingItems) => [
    ...originalTracks.slice(0, destinationTrackIndex),
    {
        ...originalTracks[destinationTrackIndex],
        items: draggingItems,
    },
    ...originalTracks.slice(destinationTrackIndex + 1),
];
/**
 * Returns the tracks updated with the specified item data, if the item could be found on one of the tracks
 * **/
const getTracksWithUpdatedItem = (tracks, itemUuid, itemTrackIndex, updateData) => {
    // get the track index of the item to update
    const trackIndex = itemTrackIndex ?? getItemTrackIndex(tracks, itemUuid);
    if ((trackIndex ?? -1) === -1) {
        return tracks;
    }
    const items = tracks[trackIndex].items.map((it) => (it.uuid === itemUuid ? { ...it, ...updateData } : it));
    return [
        ...tracks.slice(0, trackIndex),
        {
            ...tracks[trackIndex],
            items,
        },
        ...tracks.slice(trackIndex + 1),
    ];
};
/**
 * Returns the tracks without the specified item
 * An optional function to match on specific items properties can be passed
 * **/
const getTracksWithoutItem = (tracks, itemUuid, itemTrackIndex, resignItemUUid = false, extraItemMatchFn) => {
    extraItemMatchFn = extraItemMatchFn || ((_) => true);
    // get the track index of the item to remove
    const trackIndex = itemTrackIndex ?? tracks.findIndex((track) => track.items.some((it) => it.uuid === itemUuid && extraItemMatchFn(it)));
    if ((trackIndex ?? -1) === -1) {
        return tracks;
    }
    let items = tracks[trackIndex].items.filter((it) => !(it.uuid === itemUuid && extraItemMatchFn(it)));
    // drag items in same track require reset uuid, to avoid forloop confusion
    if (resignItemUUid) {
        items = items.map((item) => ({
            ...item,
            uuid: v4(),
        }));
    }
    return [
        ...tracks.slice(0, trackIndex),
        {
            ...tracks[trackIndex],
            items,
        },
        ...tracks.slice(trackIndex + 1),
    ];
};
/**
 * Returns the track index of the specified item
 * **/
const getItemTrackIndex = (tracks, itemUuid) => tracks.findIndex((track) => track.items.some((it) => it.uuid === itemUuid));

/**
 * A default fallback type for items whose type was not specified
 */
const DEFAULT_TIMELINE_ITEM_TYPE = {
    type: 'unknown',
    backgroundColor: 'var(--primary-base)',
    textColor: 'var(--primary-on)',
};

const TIMELINE_DEFAULT_DISPLAY_TIME_CONFIG = {
    showHours: false,
    showMinutes: true,
    showSeconds: true,
    showMilliseconds: true,
};
const TIMELINE_INITIAL_STATE = {
    types: [],
    tracks: [],
    displayTracks: [],
    currentTimeMs: 0,
    displayTimeConfig: TIMELINE_DEFAULT_DISPLAY_TIME_CONFIG,
    timeScrubberTrigger: 'app',
    trackMinWidthPx: 1500,
    trackBufferWidthPx: 1920,
    rulerHeightPx: 50,
    trackHeightPx: 50,
    timeScrubberTopPx: 28,
    rulerStepWidthPx: 100,
    rulerIntervalDurationMs: 50,
    stepDurationMsPerZoomLevel: [300, 500, 1000, 3000, 5000, 10000],
    timelineMaxDurationMs: Infinity,
    zoomLevelInfo: getZoomLevelInfo(1, [300, 500, 1000, 3000, 5000, 10000], 100, 50),
    trackItemMinDurationMs: 1000,
    itemDraggingActive: false,
    trackWidthPx: 1500,
    timeScrubberLeftPx: 0,
    timeScrubberMaxLeftPx: null,
    enableAutoAlign: true,
    alignmentIndicator: null,
};
/**
 * Holds the state for the timeline
 */
class TimelineStore extends ComponentStore {
    get stateSnapshot() {
        return this.get();
    }
    constructor() {
        super(TIMELINE_INITIAL_STATE);
        /** Selectors */
        /**
         * Info about the current zoom level. Contains zoom-specific metrics mostly used to convert pixels to durations in ms.
         * **/
        this.zoomLevelInfo$ = this.select((state) => state.zoomLevelInfo);
        /**
         * Emits when the scrubber time position changes
         * **/
        this.timeChanged$ = this.select(this.select((state) => state.currentTimeMs), this.select((state) => state.timeScrubberTrigger), (currentTimeMs, timeScrubberTrigger) => ({ timeMs: currentTimeMs, time: timeMsToTime(currentTimeMs), trigger: timeScrubberTrigger }), { debounce: true });
        /**
         * Returns the grid template rows layout for the timeline [header - track1 - track2 - etc..]
         * **/
        this.timelineTemplateRows$ = this.select(this.select((state) => state.tracks), this.select((state) => state.rulerHeightPx), this.select((state) => state.trackHeightPx), (tracks, rulerHeightPx, trackHeightPx) => getTimelineTemplateRows(tracks.length, rulerHeightPx, trackHeightPx));
        /**
         * Returns the height in px of the time scrubber.
         * (A trade-off in order to have the top ruler stick to the top when scrolling is that the time scrubber has an absolute position within the ruler container.
         * Therefore its height needs to get computed based on number of tracks and other metrics
         * **/
        this.scrubberHeightPx$ = this.select(this.select((state) => state.tracks.length), this.select((state) => state.rulerHeightPx), this.select((state) => state.trackHeightPx), this.select((state) => state.timeScrubberTopPx), (tracksCount, rulerHeightPx, trackHeightPx, scrubberTopPx) => getScrubberHeightPx(tracksCount, rulerHeightPx, trackHeightPx, scrubberTopPx));
        this.alignmentIndicator$ = this.select((state) => state.alignmentIndicator);
        /** Updaters */
        /** Sets the content of the timeline: the tracks with their items. Adds internal uuids for indexing. **/
        this.setTracks = this.updater((state, tracks) => {
            const tracksWithUuids = addTracksInternalUuids(tracks);
            return {
                ...state,
                tracks: tracksWithUuids,
                displayTracks: tracksWithUuids,
            };
        });
        /** Sets the type definitions of the item included in the timeline **/
        this.setTypes = this.updater((state, types) => ({
            ...state,
            types: types.map((type) => ({
                ...type,
                backgroundColor: type.backgroundColor ?? DEFAULT_TIMELINE_ITEM_TYPE.backgroundColor,
                textColor: type.textColor ?? DEFAULT_TIMELINE_ITEM_TYPE.textColor,
            })),
        }));
        /** Sets the height in px of a track **/
        this.setTrackHeightPx = this.updater((state, trackHeightPx) => ({
            ...state,
            trackHeightPx,
        }));
        /** Sets the zoom level **/
        this.setZoomLevel = this.updater((state, zoomLevel) => {
            const zoomLevelInfo = getZoomLevelInfo(zoomLevel, state.stepDurationMsPerZoomLevel, state.rulerStepWidthPx, state.rulerIntervalDurationMs);
            // do nothing if the zoom level hasn't changed
            if (zoomLevelInfo.level === state.zoomLevelInfo.level) {
                return state;
            }
            const currentTimeInPx = durationMsToPx(state.currentTimeMs, state.rulerStepWidthPx, zoomLevelInfo.stepDurationMs);
            return {
                ...state,
                zoomLevel,
                zoomLevelInfo,
                timeScrubberLeftPx: currentTimeInPx,
            };
        });
        /** Sets the display time format of the timeline (ruler) **/
        this.setDisplayTimeConfig = this.updater((state, timeConfig) => ({
            ...state,
            displayTimeConfig: {
                ...TIMELINE_DEFAULT_DISPLAY_TIME_CONFIG,
                ...timeConfig,
            },
        }));
        /** Sets the left position in px of the time scrubber. This will be converted into a duration and snapped to the nearest interval. **/
        this.setTimeScrubberLeftPx = this.updater((state, payload) => {
            const adjustedPositionInfo = getTimeScrubberSnappedInfo(payload.timeScrubberLeftPx, state.timeScrubberMaxLeftPx, state.zoomLevelInfo.snappableIntervalWidthPx, state.rulerIntervalDurationMs);
            return {
                ...state,
                timeScrubberLeftPx: adjustedPositionInfo.leftPx,
                currentTimeMs: adjustedPositionInfo.timeMs,
                timeScrubberTrigger: payload.trigger,
            };
        });
        /** Sets a max duration for the timeline. Defaults to infinity **/
        this.setTimelineMaxDurationMs = this.updater((state, timelineMaxDurationMs) => ({
            ...state,
            timelineMaxDurationMs: timelineMaxDurationMs ?? Infinity,
            timeScrubberMaxLeftPx: durationMsToPx(timelineMaxDurationMs ?? Infinity, state.rulerStepWidthPx, state.zoomLevelInfo.stepDurationMs),
        }));
        /** Sets the minimum duration of a timeline item **/
        this.setTrackItemMinDurationMs = this.updater((state, trackItemMinDurationMs) => ({
            ...state,
            trackItemMinDurationMs,
        }));
        this.setAlignmentIndicator = this.updater((state, activeMagnetSlot) => ({
            ...state,
            alignmentIndicator: activeMagnetSlot
                ? {
                    topPx: state.rulerHeightPx,
                    leftPx: durationMsToPx(activeMagnetSlot, state.rulerStepWidthPx, state.zoomLevelInfo.stepDurationMs),
                    heightPx: state.tracks.length * state.trackHeightPx,
                }
                : null,
        }));
        /** Sets the duration of an interval of the ruler. Items durations can only be a multiple of this value. **/
        this.setRulerIntervalDurationMs = this.updater((state, rulerIntervalDurationMs) => ({
            ...state,
            rulerIntervalDurationMs,
        }));
        /** Indicate if we want magnetic behavior */
        this.setAutoAlign = this.updater((state, enableAutoAlign) => ({
            ...state,
            enableAutoAlign,
        }));
        /** Sets the width of the buffer that allows keeping a gap after the last item. **/
        this.setTrackBufferWidthPx = this.updater((state, trackBufferWidthPx) => ({
            ...state,
            trackBufferWidthPx,
        }));
        /** Cancel the current item being dragged (it could be a new item dragged from outside the timeline or an existing item being moved) */
        this.cancelItemDragging = this.updater((state, payload) => {
            const { draggedItemUuid, originTrackIndex, isDraggingStillActive } = payload;
            if (!draggedItemUuid) {
                return state;
            }
            const isExistingItemBeingDragged = originTrackIndex !== null;
            // check if we need to reset the moved item flag back to false
            const shouldResetMovedItemFlag = isExistingItemBeingDragged && !isDraggingStillActive;
            if (!shouldResetMovedItemFlag) {
                return {
                    ...state,
                    displayTracks: state.tracks,
                };
            }
            const newTracks = getTracksWithUpdatedItem(state.tracks, draggedItemUuid, originTrackIndex, { moved: false });
            return {
                ...state,
                tracks: newTracks,
                displayTracks: newTracks,
            };
        });
        /** Saves the current item being dragged (it could be a new item dragged from outside the timeline or an existing item being moved) */
        this.saveItemDragging = this.updater((state, draggingInfo) => {
            const { draggedItemUuid, originTrackIndex, destinationTrackIndex } = draggingInfo;
            const isExistingItemBeingDragged = originTrackIndex !== null;
            // first reset the dragged flag on the dragged item
            let newTracks = getTracksWithUpdatedItem(state.displayTracks, draggedItemUuid, destinationTrackIndex, { dragged: false });
            // then if an existing item was dragged, remove it from its original location
            if (isExistingItemBeingDragged) {
                newTracks = getTracksWithoutItem(newTracks, draggedItemUuid, originTrackIndex, originTrackIndex === destinationTrackIndex, (item) => item.moved);
            }
            return {
                ...state,
                tracks: newTracks,
                displayTracks: newTracks,
            };
        });
        /** Updates the item dragging state of the timeline (is an item being dragged or not?) */
        this.setItemDraggingActive = this.updater((state, itemDraggingActive) => ({
            ...state,
            itemDraggingActive,
        }));
        /** Updates the specified item with the provided data */
        this.updateTrackItem = this.updater((state, payload) => {
            const { itemUuid, itemTrackIndex, updateData, preserveOriginalTracks } = payload;
            const newTracks = getTracksWithUpdatedItem(state.displayTracks, itemUuid, itemTrackIndex, updateData);
            if (newTracks === state.tracks) {
                return state;
            }
            return {
                ...state,
                tracks: preserveOriginalTracks ? state.tracks : newTracks,
                displayTracks: newTracks,
            };
        });
        /** Updates the tracks with the display tracks */
        this.saveDisplayTracks = this.updater((state) => ({
            ...state,
            tracks: state.displayTracks,
        }));
        /** Updates the display tracks (what's currently visible in the timeline) with the current item being dragged info.
         * Original tracks are not updated in order to easily perform a rollback.
         * */
        this.updateDisplayTracksWithDraggingInfo = this.updater((state, payload) => {
            const { destinationTrackIndex, draggingItems } = payload;
            return {
                ...state,
                displayTracks: getDisplayTracks(state.tracks, destinationTrackIndex, draggingItems),
            };
        });
        /**
         * Deletes an item from the timeline
         * */
        this.deleteItem = this.updater((state, payload) => {
            const { itemUuid, trackIndex } = payload;
            const newTracks = getTracksWithoutItem(state.tracks, itemUuid, trackIndex);
            return {
                ...state,
                tracks: newTracks,
                displayTracks: newTracks,
            };
        });
        /** Automatically recalculate the track width when the tracks content changes **/
        this.recalculateTrackWidthPx = this.effect(() => this.select(this.select((state) => state.tracks), 
        // this.select((state) => state.displayTracks),
        this.select((state) => state.rulerStepWidthPx), this.select((state) => state.trackBufferWidthPx), this.select((state) => state.currentTimeMs).pipe(debounceTime(500)), // avoid recreating the canvas when the scrubber is moved fast
        this.select((state) => state.timelineMaxDurationMs), this.select((state) => state.zoomLevelInfo.stepDurationMs), (tracks, rulerStepWidthPx, trackBufferWidthPx, currentTimeMs, timelineMaxDurationMs, stepDurationMs) => ({
            tracks,
            rulerStepWidthPx,
            trackBufferWidthPx,
            currentTimeMs,
            timelineMaxDurationMs,
            stepDurationMs,
        })).pipe(tap(({ tracks, rulerStepWidthPx, trackBufferWidthPx, currentTimeMs, timelineMaxDurationMs, stepDurationMs }) => {
            const trackWidthPx = getTrackWidthPx(tracks, rulerStepWidthPx, stepDurationMs, trackBufferWidthPx, currentTimeMs, timelineMaxDurationMs);
            this.patchState({
                trackWidthPx,
            });
        })));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * Returns the left scroll position in px that will center the timeline on specified time position
 * If the time position is already visible within the timeline visible area, it will return null
 */
const getLeftScollPxOfTimePosition = (trackHeaderWidth, trackWidthPx, trackVisibleWidthPx, durationMsPerPx, currentScrollLeftPx, currentScrollRightPx, timePositionMs) => {
    const trackDurationMs = trackWidthPx * durationMsPerPx;
    // calculate min and max times visible in visible area
    const minTimeMs = currentScrollLeftPx * durationMsPerPx;
    const durationNotVisibleMs = currentScrollRightPx * durationMsPerPx;
    const maxTimeMs = trackDurationMs - durationNotVisibleMs;
    const isCurrentTimeInVisibleArea = timePositionMs >= minTimeMs && timePositionMs <= maxTimeMs;
    if (isCurrentTimeInVisibleArea) {
        return null;
    }
    return timePositionMs / durationMsPerPx - (maxTimeMs - minTimeMs) / 2 / durationMsPerPx;
};

/**
 * Snaps the time value to the nearest available time interval
 */
const getNearestIntervalPositionMs = (positionMs, intervalDurationMs) => {
    const modulo = positionMs % intervalDurationMs;
    const middle = intervalDurationMs / 2;
    const shouldSnapNextInterval = modulo > middle;
    if (shouldSnapNextInterval) {
        return positionMs + (intervalDurationMs - modulo);
    }
    else {
        return positionMs - modulo;
    }
};

/** Returns the index of the track being hovered by the current item drag **/
const getTimelineHoveredTrackIndex = (event, firstTrackTopPx, trackHeightPx, trackCount) => {
    const isCursorBeforeFirstTrack = event.clientY < firstTrackTopPx;
    if (isCursorBeforeFirstTrack) {
        return null;
    }
    const isCursorAfterLastTrack = event.clientY >= firstTrackTopPx + trackHeightPx * trackCount;
    if (isCursorAfterLastTrack) {
        return null;
    }
    const topPositionPx = event.clientY - firstTrackTopPx;
    const trackIndex = Math.floor(topPositionPx / trackHeightPx);
    return trackIndex;
};
/**
 * Updates the specified list of items of the target track to include the dragged item at the current drag position.
 * Note that some items may get automatically pushed to allow inserting the dragged item.
 * - alignment to control item dragged from left or right, which will determine which side of item will detect magnetic snap
 * **/
const getTrackWithDraggedItem = (beforeDragItems, dragXTimePositionMs, draggedItem, draggedItemType, timelineMaxDurationMs, trackItemMinDurationMs, rulerIntervalDurationMs, magneticForce, magneticSlots, alignment) => {
    const movedItemIndex = beforeDragItems.findIndex((item) => item.moved);
    const itemsWithoutMovedItem = beforeDragItems.filter((_, index) => index !== movedItemIndex);
    const { resizeByMultiple, defaultDurationMs } = draggedItemType;
    const insertSlots = getTrackInsertSlots(itemsWithoutMovedItem, timelineMaxDurationMs, movedItemIndex);
    let insertSlotHovered = insertSlots.find(({ startMs, endMs }) => dragXTimePositionMs >= startMs && dragXTimePositionMs <= endMs);
    const nearestMagneticInsertSlot = findNearestSlot(dragXTimePositionMs, insertSlots, magneticForce, timelineMaxDurationMs);
    const nearestMagneticSlot = findNearestSlot(dragXTimePositionMs, magneticSlots, magneticForce, timelineMaxDurationMs);
    insertSlotHovered = nearestMagneticInsertSlot || insertSlotHovered;
    if (!insertSlotHovered) {
        return beforeDragItems;
    }
    const insertSlotDurationMs = insertSlotHovered.endMs - insertSlotHovered.startMs;
    const shouldPushItems = insertSlotDurationMs < trackItemMinDurationMs || ((draggedItem.originalDurationMs ?? false) && !!resizeByMultiple && insertSlotDurationMs < draggedItem.originalDurationMs);
    let draggedItemInserted;
    if (shouldPushItems) {
        const pushDurationMs = Math.max(defaultDurationMs || trackItemMinDurationMs, draggedItem.originalDurationMs - insertSlotDurationMs);
        draggedItemInserted = {
            ...draggedItem,
            dragged: true,
            positionMs: insertSlotHovered.startMs,
            durationMs: draggedItem.originalDurationMs ??
                Math.max(Math.max(insertSlotHovered.endMs - insertSlotHovered.startMs, trackItemMinDurationMs), defaultDurationMs || trackItemMinDurationMs || 5000),
        };
        if (insertSlotHovered.nextItemIndex === -1) {
            return [...beforeDragItems, draggedItemInserted];
        }
        return [
            ...beforeDragItems.slice(0, insertSlotHovered.nextItemIndex),
            draggedItemInserted,
            ...beforeDragItems.slice(insertSlotHovered.nextItemIndex).map((item) => ({ ...item, positionMs: item.positionMs + pushDurationMs })),
        ];
    }
    const draggedItemDurationMs = (() => {
        const hasExistingDurationMs = (draggedItem.durationMs ?? -1) >= 0;
        if (hasExistingDurationMs) {
            return Math.min(insertSlotHovered.endMs - insertSlotHovered.startMs, draggedItem.durationMs);
        }
        const hasOriginalDurationMs = (draggedItem.originalDurationMs ?? -1) >= 0;
        if (hasOriginalDurationMs) {
            return draggedItem.originalDurationMs;
        }
        return Math.min(insertSlotHovered.endMs - insertSlotHovered.startMs, defaultDurationMs || 5000);
    })();
    let draggedItemPositionMs = (() => {
        const shouldInsertAtSlotEnd = alignment === 'left' ? dragXTimePositionMs + draggedItemDurationMs > insertSlotHovered.endMs : false;
        if (shouldInsertAtSlotEnd) {
            return insertSlotHovered.endMs - draggedItemDurationMs;
        }
        const shouldInsertAtSlotStart = alignment === 'left' ? dragXTimePositionMs < insertSlotHovered.startMs : dragXTimePositionMs < insertSlotHovered.startMs + draggedItem.durationMs;
        if (shouldInsertAtSlotStart) {
            return insertSlotHovered.startMs;
        }
        const hasNearestMagneticSlot = !!nearestMagneticSlot;
        if (hasNearestMagneticSlot) {
            return alignment === 'left'
                ? nearestMagneticSlot.endMs - magneticForce
                : Math.max(draggedItem.positionMs, nearestMagneticSlot.endMs - magneticForce - draggedItem.durationMs);
        }
        if (nearestMagneticInsertSlot) {
            return dragXTimePositionMs < nearestMagneticInsertSlot.startMs
                ? nearestMagneticInsertSlot.startMs
                : dragXTimePositionMs > nearestMagneticInsertSlot.endMs
                    ? nearestMagneticInsertSlot.endMs - draggedItem.durationMs
                    : Math.min(dragXTimePositionMs, nearestMagneticInsertSlot.endMs - draggedItem.durationMs);
        }
        return alignment === 'left' ? dragXTimePositionMs : Math.max(0, dragXTimePositionMs - draggedItem.durationMs);
    })();
    // snap on nearest available interval
    draggedItemPositionMs = getNearestIntervalPositionMs(draggedItemPositionMs, rulerIntervalDurationMs);
    draggedItemInserted = {
        ...draggedItem,
        uuid: `${draggedItem.uuid}`,
        dragged: true,
        positionMs: draggedItemPositionMs,
        durationMs: draggedItemDurationMs,
    };
    if (insertSlotHovered.nextItemIndex === -1) {
        return [...beforeDragItems, draggedItemInserted];
    }
    return [...beforeDragItems.slice(0, insertSlotHovered.nextItemIndex), draggedItemInserted, ...beforeDragItems.slice(insertSlotHovered.nextItemIndex)];
};
/** Returns all the possible insert slots on a track **/
const getTrackInsertSlots = (items, timelineMaxTimeMs, movedItemIndex) => {
    if (items.length === 0) {
        return [
            {
                startMs: 0,
                endMs: timelineMaxTimeMs || Infinity,
                nextItemIndex: -1,
            },
        ];
    }
    const result = [];
    items.forEach((item, i) => {
        const isFirstItem = i === 0;
        const isLastItem = i === items.length - 1;
        if (isFirstItem) {
            result.push({ startMs: 0, endMs: item.positionMs, nextItemIndex: 0 });
        }
        else {
            const previousItem = items[i - 1];
            const nextItemOffset = movedItemIndex === -1 || movedItemIndex >= i ? 0 : -1;
            result.push({ startMs: previousItem.positionMs + previousItem.durationMs, endMs: item.positionMs, nextItemIndex: i - nextItemOffset });
        }
        if (isLastItem) {
            result.push({ startMs: item.positionMs + item.durationMs, endMs: timelineMaxTimeMs || Infinity, nextItemIndex: -1 });
        }
    });
    return result;
};
/** Returns all the possible magnetic slots of the timeline **/
const getMagneticSlots = (tracks, magneticForce, timelineMaxDurationMs, scrubberPositionMs, itemUuidToExclude) => {
    const result = [];
    const keys = [];
    const addMagneticSlot = (startMs, endMs) => {
        const key = `${startMs}-${endMs}`;
        if (keys.includes(key)) {
            return;
        }
        keys.push(key);
        result.push({
            startMs,
            endMs,
        });
    };
    // add scrubber position
    addMagneticSlot(Math.max(0, scrubberPositionMs - magneticForce), Math.min(timelineMaxDurationMs, scrubberPositionMs + magneticForce));
    tracks.forEach((track) => {
        track.items
            .filter((item) => item.uuid !== itemUuidToExclude)
            .forEach((item) => {
            // left side
            let startMs = Math.max(0, item.positionMs - magneticForce);
            let endMs = Math.min(timelineMaxDurationMs, item.positionMs + magneticForce);
            addMagneticSlot(startMs, endMs);
            // right side
            startMs = Math.max(0, item.positionMs + item.durationMs - magneticForce);
            endMs = Math.min(timelineMaxDurationMs, item.positionMs + item.durationMs + magneticForce);
            addMagneticSlot(startMs, endMs);
        });
    });
    return result;
};
/** Finds the nearest insert slot from current cursor position and within reach of the magnetic force **/
const findNearestSlot = (dragXTimePositionMs, slots, magneticForce, timelineMaxDurationMs) => slots.find((slot) => {
    const minDragXTimePositionMs = Math.max(0, slot.startMs - magneticForce);
    const isWithinMagneticDistanceLeft = dragXTimePositionMs >= minDragXTimePositionMs && dragXTimePositionMs <= slot.startMs + magneticForce;
    if (isWithinMagneticDistanceLeft) {
        return true;
    }
    const maxDragXTimePositionMs = Math.min(slot.endMs + magneticForce, timelineMaxDurationMs);
    const isWithinMagneticDistanceRight = dragXTimePositionMs <= maxDragXTimePositionMs && dragXTimePositionMs >= slot.endMs - magneticForce;
    if (isWithinMagneticDistanceRight) {
        return true;
    }
    return false;
});

class TimelineScrubberComponent {
    constructor() {
        this.scrubberTheme = ThemeType.SECONDARY;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineScrubberComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineScrubberComponent, selector: "avn-timeline-scrubber", ngImport: i0, template: "<div class=\"time-indicator\">\n  <avn-icon icon=\"action:label\" [avnTheme]=\"scrubberTheme\"></avn-icon>\n</div>\n", styles: [":host .time-indicator{height:100%;width:1px;background-color:red}:host .time-indicator avn-icon{transform:translate(-50%) rotate(90deg);cursor:grab}:host .time-indicator avn-icon i{font-size:var(--text-xl)}\n"], dependencies: [{ kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineScrubberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline-scrubber', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"time-indicator\">\n  <avn-icon icon=\"action:label\" [avnTheme]=\"scrubberTheme\"></avn-icon>\n</div>\n", styles: [":host .time-indicator{height:100%;width:1px;background-color:red}:host .time-indicator avn-icon{transform:translate(-50%) rotate(90deg);cursor:grab}:host .time-indicator avn-icon i{font-size:var(--text-xl)}\n"] }]
        }] });

/**
 *  Get the previous item in the timeline track from the specified one
 */
const getPreviousTrackItem = (trackItems, itemUuid) => {
    const itemIndex = trackItems.findIndex((item) => item.uuid === itemUuid) ?? -1;
    if (itemIndex <= 0) {
        return null;
    }
    const previousItem = trackItems[itemIndex - 1];
    return previousItem;
};
/**
 *  Get the next item in the timeline track from the specified one
 */
const getNextTrackItem = (trackItems, itemUuid) => {
    const itemIndex = trackItems.findIndex((item) => item.uuid === itemUuid) ?? -1;
    const isLastItem = itemIndex === trackItems.length - 1;
    if (itemIndex === -1 || isLastItem) {
        return null;
    }
    const nextItem = trackItems[itemIndex + 1];
    return nextItem;
};

/** Returns the new position and duration for the currently resized item based on the mouse cursor position and preceding item
 *  magnetic slots are also considered
 **/
const getLeftHandleDraggingInfo = (previousItem, resizingInfo, dragXTimePositionMs) => {
    const { initialPositionMs, initialDurationMs, trackItemMinDurationMs, rulerIntervalDurationMs, resizeByMultiple, originalDurationMs, magneticForce, magneticSlots } = resizingInfo;
    // can only expand item up to the timeline edge (0ms) or the previous item end
    let maxExpandPositionMs = !previousItem ? 0 : previousItem.positionMs + previousItem.durationMs;
    let maxExpandDurationMs = initialPositionMs - maxExpandPositionMs;
    maxExpandDurationMs = resizeByMultiple ? Math.floor(maxExpandDurationMs / originalDurationMs) * originalDurationMs : maxExpandDurationMs;
    maxExpandPositionMs = resizeByMultiple ? initialPositionMs - maxExpandDurationMs : maxExpandPositionMs;
    const isAboveMaxResizeLeftPosition = dragXTimePositionMs < maxExpandPositionMs;
    if (isAboveMaxResizeLeftPosition) {
        return {
            positionMs: maxExpandPositionMs,
            durationMs: initialDurationMs + maxExpandDurationMs,
        };
    }
    // can only shrink item up to the minimum item duration
    const minDurationMs = resizeByMultiple ? originalDurationMs : trackItemMinDurationMs;
    const maxShrinkableDurationMs = Math.max(0, initialDurationMs - minDurationMs);
    const isAboveMaxResizeRightPosition = dragXTimePositionMs > initialPositionMs + maxShrinkableDurationMs;
    if (isAboveMaxResizeRightPosition) {
        return {
            positionMs: initialPositionMs + initialDurationMs - minDurationMs,
            durationMs: minDurationMs,
        };
    }
    if (!resizeByMultiple) {
        const nearestMagneticSlot = findNearestSlot(dragXTimePositionMs, magneticSlots, magneticForce, initialPositionMs + initialDurationMs);
        if (nearestMagneticSlot) {
            dragXTimePositionMs = nearestMagneticSlot.startMs + magneticForce;
        }
    }
    const intervalDurationMs = resizeByMultiple ? originalDurationMs : rulerIntervalDurationMs;
    const modulizedDelta = getNearestIntervalPositionMs(initialPositionMs - dragXTimePositionMs, intervalDurationMs);
    const xPosition = initialPositionMs - modulizedDelta;
    return {
        positionMs: xPosition,
        durationMs: initialDurationMs + initialPositionMs - xPosition,
    };
};
const getRightHandleDraggingInfo = (nextItem, resizingInfo, dragXTimePositionMs) => {
    const { initialPositionMs, initialDurationMs, originalDurationMs, trackItemMinDurationMs, timelineMaxDurationMs, rulerIntervalDurationMs, resizeByMultiple, magneticForce, magneticSlots, } = resizingInfo;
    // can only shrink item up to the minimum media duration
    const minDurationMs = resizeByMultiple ? originalDurationMs : trackItemMinDurationMs;
    const maxShrinkableDurationMs = Math.max(0, initialDurationMs - minDurationMs);
    const isAboveMaxResizeLeftPosition = dragXTimePositionMs < initialPositionMs + initialDurationMs - maxShrinkableDurationMs;
    if (isAboveMaxResizeLeftPosition) {
        return {
            positionMs: initialPositionMs,
            durationMs: minDurationMs,
        };
    }
    // can only expand item up to the max timeline duration or start of next item
    const maxExpandPositionMs = nextItem ? nextItem.positionMs : timelineMaxDurationMs ?? Infinity;
    let maxExpandDurationMs = maxExpandPositionMs - (initialPositionMs + initialDurationMs);
    maxExpandDurationMs = resizeByMultiple ? Math.floor(maxExpandDurationMs / originalDurationMs) * originalDurationMs : maxExpandDurationMs;
    // const remainingExpandDurationMs = maxExpandDurationMs ? maxExpandDurationMs - (item.durationMs - initialDurationMs) : null;
    const isAboveMaxResizeRightPosition = dragXTimePositionMs > initialPositionMs + initialDurationMs + maxExpandDurationMs;
    if (isAboveMaxResizeRightPosition) {
        return {
            positionMs: initialPositionMs,
            durationMs: initialDurationMs + maxExpandDurationMs,
        };
    }
    if (!resizeByMultiple) {
        const nearestMagneticSlot = findNearestSlot(dragXTimePositionMs, magneticSlots, magneticForce, maxExpandPositionMs);
        if (nearestMagneticSlot) {
            dragXTimePositionMs = nearestMagneticSlot.startMs + magneticForce;
        }
    }
    const intervalDurationMs = resizeByMultiple ? originalDurationMs : rulerIntervalDurationMs;
    const modulizedDelta = getNearestIntervalPositionMs(dragXTimePositionMs - initialPositionMs, intervalDurationMs);
    const xPosition = initialPositionMs + modulizedDelta;
    return {
        positionMs: initialPositionMs,
        durationMs: xPosition - initialPositionMs,
    };
};

class TimelineTrackItemComponent {
    set item(item) {
        this._itemSubject.next(item);
    }
    get item() {
        return this._itemSubject.value;
    }
    constructor(_store) {
        this._store = _store;
        /** the timeline track item to display **/
        this._itemSubject = new BehaviorSubject(null);
        /** Whether the item is selected or not **/
        this.selected = false;
        /** Whether the item should react to events or not (i.e. disabled when dragging occurs) **/
        this.enablePointerEvents = true;
        /** Emits when the item has been resized **/
        this.itemResized = new EventEmitter();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this.model$ = this._store.select(this._store.select((state) => state.types), 
        // this._store.select((state) => state.tracks.find((track) => track.id === this.itemTrack.id).items.find((item) => item.id === this.item.id)),
        this._itemSubject.asObservable(), this._store.select((state) => state.rulerStepWidthPx), this._store.select((state) => state.zoomLevelInfo), (types, item, rulerStepWidthPx, zoomLevelInfo) => ({
            itemType: types.find(({ type }) => type === item.type) || DEFAULT_TIMELINE_ITEM_TYPE,
            rulerStepWidthPx,
            stepDurationMs: zoomLevelInfo.stepDurationMs,
            itemWidthPx: durationMsToPx(item.durationMs, rulerStepWidthPx, zoomLevelInfo.stepDurationMs),
            itemTranslateX: this.getItemTranslateX(durationMsToPx(item.positionMs, rulerStepWidthPx, zoomLevelInfo.stepDurationMs)),
        }));
    }
    getItemTranslateX(itemLeftPx) {
        if (itemLeftPx <= 0) {
            return null;
        }
        return `translateX(${itemLeftPx}px)`;
    }
    /** Called when the resize handle of a timeline item starts being resized **/
    onItemResizeStart() {
        const { item } = this;
        const { stateSnapshot } = this._store;
        // get all magnetic slots for the current timeline
        const msFor1Px = (1 / stateSnapshot.rulerStepWidthPx) * stateSnapshot.zoomLevelInfo.stepDurationMs;
        const magneticForce = 10 * msFor1Px;
        const magneticSlots = this._store.stateSnapshot.enableAutoAlign
            ? getMagneticSlots(stateSnapshot.tracks, magneticForce, stateSnapshot.timelineMaxDurationMs, stateSnapshot.currentTimeMs, item.uuid)
            : [];
        this.resizingInfo = {
            originalDurationMs: item.originalDurationMs,
            initialPositionMs: item.positionMs,
            initialDurationMs: item.durationMs,
            resizeByMultiple: stateSnapshot.types.find(({ type }) => type === item.type).resizeByMultiple,
            trackItemMinDurationMs: stateSnapshot.trackItemMinDurationMs,
            timelineMaxDurationMs: stateSnapshot.timelineMaxDurationMs,
            rulerStepWidthPx: stateSnapshot.rulerStepWidthPx,
            rulerIntervalDurationMs: stateSnapshot.rulerIntervalDurationMs,
            stepDurationMs: stateSnapshot.zoomLevelInfo.stepDurationMs,
            magneticForce,
            magneticSlots,
        };
    }
    /** Called when a timeline item is being resized **/
    onItemResize(evt, resizeHandle) {
        const { item, itemTrack, itemTrackIndex, resizingInfo } = this;
        let updatedItemInfo;
        const resizeBeginMs = resizeHandle === 'left' ? resizingInfo.initialPositionMs : resizingInfo.initialPositionMs + resizingInfo.initialDurationMs;
        const dragXTimePositionMs = resizeBeginMs + pxToDurationMs(evt.initialDiffX, resizingInfo.rulerStepWidthPx, resizingInfo.stepDurationMs);
        if (!resizingInfo.resizeByMultiple) {
            const nearestMagneticSlot = findNearestSlot(dragXTimePositionMs, resizingInfo.magneticSlots, resizingInfo.magneticForce, resizingInfo.initialPositionMs + resizingInfo.initialDurationMs + resizingInfo.magneticForce);
            this._store.setAlignmentIndicator(nearestMagneticSlot && nearestMagneticSlot.startMs ? nearestMagneticSlot.startMs + resizingInfo.magneticForce : null);
        }
        if (resizeHandle === 'left') {
            const previousItem = getPreviousTrackItem(itemTrack.items, item.uuid);
            updatedItemInfo = getLeftHandleDraggingInfo(previousItem, resizingInfo, dragXTimePositionMs);
        }
        else if (resizeHandle === 'right') {
            const nextItem = getNextTrackItem(itemTrack.items, item.uuid);
            updatedItemInfo = getRightHandleDraggingInfo(nextItem, resizingInfo, dragXTimePositionMs);
        }
        const hasItemChanged = updatedItemInfo.positionMs !== item.positionMs || updatedItemInfo.durationMs !== item.durationMs;
        if (hasItemChanged) {
            this._store.updateTrackItem({ itemUuid: item.uuid, itemTrackIndex, updateData: updatedItemInfo, preserveOriginalTracks: true });
        }
    }
    /** Called when the resize handle of a timeline item starts being resized **/
    onResizeItemEnd() {
        this._store.setAlignmentIndicator(null);
        const { item, itemTrack, resizingInfo } = this;
        const hasChanged = item.positionMs !== resizingInfo.initialPositionMs || item.durationMs !== resizingInfo.initialDurationMs;
        if (hasChanged) {
            this._store.saveDisplayTracks();
            this.itemResized.emit({
                resizedItem: item,
                previousPositionMs: resizingInfo.initialPositionMs,
                previousDurationMs: resizingInfo.initialDurationMs,
                track: itemTrack,
            });
        }
        this.resizingInfo = null;
    }
    /** Returns the padding for the item. Depending on the zoom level, the padding cannpt be > than the total item width itself otherwise it results in a glitch **/
    getItemPadding(item, rulerStepWidthPx, stepDurationMs) {
        const itemSizePx = durationMsToPx(item.durationMs, rulerStepWidthPx, stepDurationMs);
        const defaultPaddingPx = 14;
        if (itemSizePx > defaultPaddingPx * 2) {
            return `0 ${defaultPaddingPx}px`;
        }
        return `0 ${itemSizePx / 2}px`;
    }
    get moved() {
        return this.item.moved;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineTrackItemComponent, deps: [{ token: TimelineStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineTrackItemComponent, selector: "avn-timeline-track-item", inputs: { item: "item", itemTrack: "itemTrack", itemTrackIndex: "itemTrackIndex", itemTemplate: "itemTemplate", selected: "selected", enablePointerEvents: "enablePointerEvents" }, outputs: { itemResized: "itemResized" }, host: { properties: { "class.enable-pointer-events": "this.enablePointerEvents", "class.moved": "this.moved" } }, ngImport: i0, template: "<ng-container *ngIf=\"model$ | async as model\">\n  <div\n    class=\"item-wrapper\"\n    [style.background]=\"model.itemType.backgroundColor\"\n    [style.color]=\"model.itemType.textColor\"\n    [style.width.px]=\"model.itemWidthPx\"\n    [style.transform]=\"model.itemTranslateX\"\n    [style.padding]=\"item | applyFunction: getItemPadding:[model.rulerStepWidthPx, model.stepDurationMs]\"\n    [class.selected]=\"selected\"\n  >\n    <ng-container *ngIf=\"!!itemTemplate; else noItemTemplate\">\n      <ng-container *ngTemplateOutlet=\"itemTemplate; context: { item: item }\"></ng-container>\n    </ng-container>\n    <ng-template #noItemTemplate>\n      <span class=\"title\" [title]=\"item.name\">{{ item.name }}</span>\n    </ng-template>\n    <ng-container *ngIf=\"item.resizable\">\n      <div\n        class=\"resizer left\"\n        avnDrag\n        [showDraggingOverlay]=\"false\"\n        [allowOutsideMove]=\"true\"\n        [debounceTime]=\"0\"\n        [cursor]=\"'w-resize'\"\n        [axis]=\"'x'\"\n        (dragStart)=\"onItemResizeStart()\"\n        (dragMove)=\"onItemResize($event, 'left')\"\n        (dragEnd)=\"onResizeItemEnd()\"\n      ></div>\n      <div\n        class=\"resizer right\"\n        avnDrag\n        [showDraggingOverlay]=\"false\"\n        [allowOutsideMove]=\"true\"\n        [debounceTime]=\"0\"\n        [cursor]=\"'w-resize'\"\n        [axis]=\"'x'\"\n        (dragStart)=\"onItemResizeStart()\"\n        (dragMove)=\"onItemResize($event, 'right')\"\n        (dragEnd)=\"onResizeItemEnd()\"\n      ></div>\n    </ng-container>\n    <div class=\"background-overlay\"></div>\n  </div>\n</ng-container>\n", styles: ["@charset \"UTF-8\";:host{display:inline-block;height:100%;position:relative;z-index:1;pointer-events:none;transition:opacity .15s cubic-bezier(0,0,.2,1)}:host.enable-pointer-events{pointer-events:auto!important}:host.moved{opacity:.2}:host .item-wrapper{position:absolute;top:0;bottom:0;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:2px;display:flex;align-items:center;justify-content:center;padding:0 14px;overflow:hidden}:host .item-wrapper .background-overlay{position:absolute;inset:0;pointer-events:none;background-color:transparent;transition:all .15s cubic-bezier(0,0,.2,1);opacity:0;z-index:1}:host .item-wrapper.selected .background-overlay{opacity:.3;background-color:var(--highlight-base)}:host .item-wrapper:not(.selected):hover .background-overlay{opacity:.1;background-color:#fff}:host .item-wrapper.selected,:host .item-wrapper:hover{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .item-wrapper .title{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}:host .item-wrapper .resizer{position:absolute;top:0;bottom:0;width:10px;display:flex;align-items:center;justify-content:center}:host .item-wrapper .resizer:after{content:\"\\2022\\2022\\2022\";position:absolute;top:50%;color:#0000004d;font-size:var(--text-xs);letter-spacing:2px}:host .item-wrapper .resizer.left{left:0}:host .item-wrapper .resizer.left:after{transform:translate(-50%,-50%) rotate(90deg);left:8px}:host .item-wrapper .resizer.right{right:0}:host .item-wrapper .resizer.right:after{transform:translate(50%,-50%) rotate(90deg);right:8px}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: DragDirective, selector: "[avnDrag]", inputs: ["debounceTime", "allowOutsideMove", "axis", "cursor", "showDraggingOverlay"], outputs: ["dragStart", "dragMove", "dragEnd"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineTrackItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline-track-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"model$ | async as model\">\n  <div\n    class=\"item-wrapper\"\n    [style.background]=\"model.itemType.backgroundColor\"\n    [style.color]=\"model.itemType.textColor\"\n    [style.width.px]=\"model.itemWidthPx\"\n    [style.transform]=\"model.itemTranslateX\"\n    [style.padding]=\"item | applyFunction: getItemPadding:[model.rulerStepWidthPx, model.stepDurationMs]\"\n    [class.selected]=\"selected\"\n  >\n    <ng-container *ngIf=\"!!itemTemplate; else noItemTemplate\">\n      <ng-container *ngTemplateOutlet=\"itemTemplate; context: { item: item }\"></ng-container>\n    </ng-container>\n    <ng-template #noItemTemplate>\n      <span class=\"title\" [title]=\"item.name\">{{ item.name }}</span>\n    </ng-template>\n    <ng-container *ngIf=\"item.resizable\">\n      <div\n        class=\"resizer left\"\n        avnDrag\n        [showDraggingOverlay]=\"false\"\n        [allowOutsideMove]=\"true\"\n        [debounceTime]=\"0\"\n        [cursor]=\"'w-resize'\"\n        [axis]=\"'x'\"\n        (dragStart)=\"onItemResizeStart()\"\n        (dragMove)=\"onItemResize($event, 'left')\"\n        (dragEnd)=\"onResizeItemEnd()\"\n      ></div>\n      <div\n        class=\"resizer right\"\n        avnDrag\n        [showDraggingOverlay]=\"false\"\n        [allowOutsideMove]=\"true\"\n        [debounceTime]=\"0\"\n        [cursor]=\"'w-resize'\"\n        [axis]=\"'x'\"\n        (dragStart)=\"onItemResizeStart()\"\n        (dragMove)=\"onItemResize($event, 'right')\"\n        (dragEnd)=\"onResizeItemEnd()\"\n      ></div>\n    </ng-container>\n    <div class=\"background-overlay\"></div>\n  </div>\n</ng-container>\n", styles: ["@charset \"UTF-8\";:host{display:inline-block;height:100%;position:relative;z-index:1;pointer-events:none;transition:opacity .15s cubic-bezier(0,0,.2,1)}:host.enable-pointer-events{pointer-events:auto!important}:host.moved{opacity:.2}:host .item-wrapper{position:absolute;top:0;bottom:0;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:2px;display:flex;align-items:center;justify-content:center;padding:0 14px;overflow:hidden}:host .item-wrapper .background-overlay{position:absolute;inset:0;pointer-events:none;background-color:transparent;transition:all .15s cubic-bezier(0,0,.2,1);opacity:0;z-index:1}:host .item-wrapper.selected .background-overlay{opacity:.3;background-color:var(--highlight-base)}:host .item-wrapper:not(.selected):hover .background-overlay{opacity:.1;background-color:#fff}:host .item-wrapper.selected,:host .item-wrapper:hover{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .item-wrapper .title{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}:host .item-wrapper .resizer{position:absolute;top:0;bottom:0;width:10px;display:flex;align-items:center;justify-content:center}:host .item-wrapper .resizer:after{content:\"\\2022\\2022\\2022\";position:absolute;top:50%;color:#0000004d;font-size:var(--text-xs);letter-spacing:2px}:host .item-wrapper .resizer.left{left:0}:host .item-wrapper .resizer.left:after{transform:translate(-50%,-50%) rotate(90deg);left:8px}:host .item-wrapper .resizer.right{right:0}:host .item-wrapper .resizer.right:after{transform:translate(50%,-50%) rotate(90deg);right:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: TimelineStore }]; }, propDecorators: { item: [{
                type: Input
            }], itemTrack: [{
                type: Input
            }], itemTrackIndex: [{
                type: Input
            }], itemTemplate: [{
                type: Input
            }], selected: [{
                type: Input
            }], enablePointerEvents: [{
                type: HostBinding,
                args: ['class.enable-pointer-events']
            }, {
                type: Input
            }], itemResized: [{
                type: Output
            }], moved: [{
                type: HostBinding,
                args: ['class.moved']
            }] } });

class TimelineRulerComponent {
    constructor(_store) {
        this._store = _store;
        this._componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this.model$ = this._store.select(this._store.select((state) => state.rulerHeightPx), this._store.select((state) => state.trackWidthPx), (rulerHeightPx, trackWidthPx) => ({ rulerHeightPx: rulerHeightPx - 1, trackWidthPx }) // -1 for the bottom border
        );
    }
    ngAfterViewInit() {
        this._store
            .select(this._store.select((state) => state.rulerHeightPx), this._store.select((state) => state.rulerStepWidthPx), this._store.select((state) => state.trackWidthPx), this._store.select((state) => state.zoomLevelInfo), this._store.select((state) => state.displayTimeConfig), (rulerHeightPx, rulerStepWidthPx, trackWidthPx, zoomLevelInfo, displayTimeConfig) => ({ rulerHeightPx, rulerStepWidthPx, trackWidthPx, zoomLevelInfo, displayTimeConfig }))
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe(({ rulerHeightPx, rulerStepWidthPx, trackWidthPx, zoomLevelInfo, displayTimeConfig }) => {
            setTimeout(() => this._drawCanvasRuler(rulerHeightPx, rulerStepWidthPx, trackWidthPx, zoomLevelInfo, displayTimeConfig));
        });
    }
    _drawCanvasRuler(rulerHeightPx, rulerStepWidthPx, trackWidthPx, zoomLevelInfo, displayTimeConfig) {
        const canvas = this._canvasElement.nativeElement;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, trackWidthPx, rulerHeightPx);
        ctx.strokeStyle = 'rgb(230, 230, 230)';
        ctx.fillStyle = 'rgb(230, 230, 230)';
        ctx.textAlign = 'left';
        ctx.font = '12px sans-serif';
        ctx.lineWidth = 0.75;
        ctx.beginPath();
        // get the amount of px for an interval indicator (with a max of 10 indicators per step)
        const intervalPx = rulerStepWidthPx / Math.min(zoomLevelInfo.totalSnappableIntervalsInStep, 10);
        // since the division is no always an integer, keep the modulo to determine when to draw the interval
        const modulo = rulerStepWidthPx % Math.min(zoomLevelInfo.totalSnappableIntervalsInStep, 10);
        let lastStepIndex = 0;
        for (let i = 0; i < trackWidthPx; i++) {
            // check if we have reached a step
            const drawStep = i % rulerStepWidthPx === 0;
            const drawStepInterval = !drawStep && i % intervalPx < 1 && i > lastStepIndex + modulo;
            if (!drawStep && !drawStepInterval) {
                continue;
            }
            if (drawStep) {
                lastStepIndex = i;
            }
            const currentStepMs = (i / rulerStepWidthPx) * zoomLevelInfo.stepDurationMs;
            const timeObj = timeMsToTime(currentStepMs);
            if (drawStep) {
                ctx.fillText(getTimelineDisplayTime(timeObj, displayTimeConfig), i, rulerHeightPx - 35);
                if (i === 0) {
                    ctx.textAlign = 'center';
                }
            }
            ctx.moveTo(i, drawStep ? rulerHeightPx - 25 : rulerHeightPx - 15);
            ctx.lineTo(i, rulerHeightPx);
        }
        ctx.stroke();
    }
    /**
     * Change the scrubber position on ruler click
     */
    onCanvasClick(evt, canvasLeftPosition) {
        const newScrubberXPosition = evt.clientX - canvasLeftPosition;
        this._store.setTimeScrubberLeftPx({ timeScrubberLeftPx: newScrubberXPosition, trigger: 'scrubber' });
    }
    get canvasLeftPosition() {
        return this._canvasElement.nativeElement.getBoundingClientRect().left;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineRulerComponent, deps: [{ token: TimelineStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineRulerComponent, selector: "avn-timeline-ruler", viewQueries: [{ propertyName: "_canvasElement", first: true, predicate: ["canvas"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"model$ | async as model\">\n  <canvas #canvas (click)=\"onCanvasClick($event, canvasLeftPosition)\" [height]=\"model.rulerHeightPx\" [width]=\"model.trackWidthPx\"></canvas>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineRulerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline-ruler', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"model$ | async as model\">\n  <canvas #canvas (click)=\"onCanvasClick($event, canvasLeftPosition)\" [height]=\"model.rulerHeightPx\" [width]=\"model.trackWidthPx\"></canvas>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: TimelineStore }]; }, propDecorators: { _canvasElement: [{
                type: ViewChild,
                args: ['canvas', { static: false }]
            }] } });

const DEFAULT_LABELS = {
    'track-add': 'Add New Track',
    'zoom-in': 'Zoom In',
    'zoom-out': 'Zoom Out',
    'recenter-on-scrubber': 'Recenter on Scrubber',
};
class TimelineSettingsComponent {
    constructor() {
        this.showTrackAddButton = false;
        this._actionLabels = DEFAULT_LABELS;
        /** Emits when an action button is clicked */
        this.action = new EventEmitter();
        this.tooltipMouseEnterOpenDelay = 500;
        this.tooltipPosition = PlacementTypes.top;
    }
    set actionLabels(labels) {
        this._actionLabels = labels || DEFAULT_LABELS;
    }
    get actionLabels() {
        return this._actionLabels;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineSettingsComponent, selector: "avn-timeline-settings", inputs: { showTrackAddButton: "showTrackAddButton", actionLabels: "actionLabels" }, outputs: { action: "action" }, ngImport: i0, template: "<div class=\"settings\">\n  <div class=\"content\">\n    <avn-icon\n      [icon]=\"'action:zoom_out'\"\n      [fontSize]=\"21\"\n      (click)=\"action.emit('zoom-out')\"\n      [avnTooltip]=\"actionLabels['zoom-out']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n    <avn-icon\n      [icon]=\"'action:zoom_in'\"\n      [fontSize]=\"21\"\n      (click)=\"action.emit('zoom-in')\"\n      [avnTooltip]=\"actionLabels['zoom-in']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n    <div class=\"separator\"></div>\n    <avn-icon\n      *ngIf=\"showTrackAddButton\"\n      [icon]=\"'content:add'\"\n      [fontSize]=\"21\"\n      (click)=\"action.emit('track-add')\"\n      [avnTooltip]=\"actionLabels['track-add']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n    <avn-icon\n      [icon]=\"'action:label'\"\n      [style.transform]=\"'rotate(90deg)'\"\n      [fontSize]=\"18\"\n      (click)=\"action.emit('recenter-on-scrubber')\"\n      [avnTooltip]=\"actionLabels['recenter-on-scrubber']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n  </div>\n</div>\n", styles: [":host .settings{padding:0 var(--space-md)}:host .settings .content{height:100%;display:grid;margin:0px var(--space-md);grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-sm)}:host .settings .content .separator{background-color:var(--surface-background);width:1px;height:100%;margin:0 2px}:host .settings .content avn-icon{opacity:.7}:host .settings .content avn-icon:hover,:host .settings .content avn-icon.active{cursor:pointer;opacity:1}:host .settings .content avn-icon.active{color:var(--info-base)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: TooltipDirective, selector: "[avnTooltip]", inputs: ["avnTooltip", "tooltipName", "tooltipTemplate", "templateContext", "tooltipTheme", "tooltipPlacement", "tooltipMaxWidth", "tooltipDisabled", "tooltipTrigger", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipMouseLeaveCloseDelay", "tooltipMouseEnterOpenDelay"], outputs: ["show", "hide"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineSettingsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline-settings', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"settings\">\n  <div class=\"content\">\n    <avn-icon\n      [icon]=\"'action:zoom_out'\"\n      [fontSize]=\"21\"\n      (click)=\"action.emit('zoom-out')\"\n      [avnTooltip]=\"actionLabels['zoom-out']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n    <avn-icon\n      [icon]=\"'action:zoom_in'\"\n      [fontSize]=\"21\"\n      (click)=\"action.emit('zoom-in')\"\n      [avnTooltip]=\"actionLabels['zoom-in']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n    <div class=\"separator\"></div>\n    <avn-icon\n      *ngIf=\"showTrackAddButton\"\n      [icon]=\"'content:add'\"\n      [fontSize]=\"21\"\n      (click)=\"action.emit('track-add')\"\n      [avnTooltip]=\"actionLabels['track-add']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n    <avn-icon\n      [icon]=\"'action:label'\"\n      [style.transform]=\"'rotate(90deg)'\"\n      [fontSize]=\"18\"\n      (click)=\"action.emit('recenter-on-scrubber')\"\n      [avnTooltip]=\"actionLabels['recenter-on-scrubber']\"\n      [tooltipPlacement]=\"tooltipPosition\"\n      [tooltipMouseEnterOpenDelay]=\"tooltipMouseEnterOpenDelay\"\n    ></avn-icon>\n  </div>\n</div>\n", styles: [":host .settings{padding:0 var(--space-md)}:host .settings .content{height:100%;display:grid;margin:0px var(--space-md);grid-auto-flow:column;grid-auto-columns:max-content;grid-gap:var(--space-sm)}:host .settings .content .separator{background-color:var(--surface-background);width:1px;height:100%;margin:0 2px}:host .settings .content avn-icon{opacity:.7}:host .settings .content avn-icon:hover,:host .settings .content avn-icon.active{cursor:pointer;opacity:1}:host .settings .content avn-icon.active{color:var(--info-base)}\n"] }]
        }], propDecorators: { showTrackAddButton: [{
                type: Input
            }], actionLabels: [{
                type: Input
            }], action: [{
                type: Output
            }] } });

class TimelineV2Component {
    /** All tracks with their items to display in the timeline **/
    set tracks(tracks) {
        this._store.setTracks(tracks);
    }
    /** Sets the type definitions of the item included in the timeline **/
    set types(types) {
        this._store.setTypes(types);
    }
    /** Height in px of a track **/
    set trackHeightPx(trackHeightPx) {
        this._store.setTrackHeightPx(trackHeightPx);
    }
    /** Current zoom level. Available Zoom Levels (1 - 6). Zoom level 1 is the most zoomed out zoom level available */
    set zoomLevel(zoomLevel) {
        this.updateZoom(zoomLevel);
    }
    /** Maximum duration of the timeline in ms */
    set timelineMaxDurationMs(timelineMaxDurationMs) {
        this._store.setTimelineMaxDurationMs(timelineMaxDurationMs);
    }
    /** Minimum duration of the track items in ms **/
    set trackItemMinDurationMs(trackItemMinDuration) {
        // we dont allow < 100ms because its causes issues with rendering
        this._store.setTrackItemMinDurationMs(Math.max(100, trackItemMinDuration));
    }
    /** Duration of a time interval in the ruler in ms. Items durations can only be a multiple of this value */
    set rulerIntervalDurationMs(rulerIntervalDurationMs) {
        this._store.setRulerIntervalDurationMs(rulerIntervalDurationMs);
    }
    /** Sets the width of the buffer that allows keeping a gap after the last item. **/
    set trackBufferWidthPx(trackBufferWidthPx) {
        this._store.setTrackBufferWidthPx(trackBufferWidthPx);
    }
    /** Sets the display time format of the timeline (ruler) **/
    set displayTimeConfig(displayTimeConfig) {
        this._store.setDisplayTimeConfig(displayTimeConfig);
    }
    /** If true, will enable magnetic behavior, and show alignment indicator when dragging or resizing item */
    set enableAutoAlign(autoAlign) {
        this._store.setAutoAlign(autoAlign);
    }
    constructor(_store, _scrollDispatcher, _changeDetectorRef) {
        this._store = _store;
        this._scrollDispatcher = _scrollDispatcher;
        this._changeDetectorRef = _changeDetectorRef;
        /** Emits when the current time indicator changes */
        this.currentTimeChanged = new EventEmitter();
        /** Emits when the add track button is clicked. The add button will appear only when this event is subscribed to */
        this.trackAdd = new EventEmitter();
        /** Emits when a track item is resized **/
        this.itemResized = new EventEmitter();
        /** Emits when a track item is selected **/
        this.itemSelected = new EventEmitter();
        /** Emits when a track item is moved **/
        this.itemMoved = new EventEmitter();
        /** Emits when a track item is added **/
        this.itemAdded = new EventEmitter();
        /** Emits when a track item is added **/
        this.itemDeleted = new EventEmitter();
        /** Whether the timeline has scrolled horizontall or not */
        this.isTimelineScrolledHorizontally = false;
        this.trackByTrack = (_, track) => track.uuid;
        this.trackByTrackItem = (_, item) => `${item.uuid}-${!!item.dragged}`;
        this.timeMsToTime = timeMsToTime;
        this.getTimelineDisplayTime = getTimelineDisplayTime;
        this.componentDestroyed$ = new Subject();
        // Build the model for the view (any time any of the properties changes, the view will be updated)
        this.model$ = this._store.select(this._store.select((state) => state.tracks), this._store.select((state) => state.displayTracks), this._store.zoomLevelInfo$, this._store.select((state) => state.timeScrubberTopPx), this._store.select((state) => state.trackHeightPx), this._store.select((state) => state.trackWidthPx), this._store.select((state) => state.timeScrubberLeftPx), this._store.select((state) => state.currentTimeMs), this._store.select((state) => state.itemDraggingActive), this._store.select((state) => state.displayTimeConfig), this._store.select((state) => state.alignmentIndicator), (tracks, displayTracks, zoomLevelInfo, timeScrubberTopPx, trackHeightPx, trackWidthPx, timeScrubberLeftPx, currentTimeMs, itemDraggingActive, displayTimeConfig, alignmentIndicator) => ({
            tracks,
            displayTracks,
            zoomLevelInfo,
            timeScrubberTopPx,
            trackHeightPx,
            trackWidthPx,
            timeScrubberLeftPx,
            currentTimeMs,
            itemDraggingActive,
            displayTimeConfig,
            alignmentIndicator,
        }));
        this.timelineTemplateRows$ = this._store.timelineTemplateRows$;
        this.scrubberHeightPx$ = this._store.scrubberHeightPx$;
    }
    ngAfterViewInit() {
        this._initScrollListeners();
        this._initZoomListeners();
        this._updateScrollPositions();
        this._initEvents();
    }
    onScrubberDragStart(timeScrubberLeftPx) {
        this._initialScrubberLeftPx = timeScrubberLeftPx;
    }
    onScrubberDragMove(evt) {
        this._store.setTimeScrubberLeftPx({ timeScrubberLeftPx: this._initialScrubberLeftPx + evt.initialDiffX, trigger: 'scrubber' });
    }
    updateZoom(zoomLevel) {
        this._store.setZoomLevel(zoomLevel);
    }
    recenterOnScrubber() {
        const trackHeaderWidthPx = this._trackHeaderElement?.nativeElement.clientWidth || 0;
        const trackWidthPx = this._store.stateSnapshot.trackWidthPx;
        const durationMsPerPx = this._store.stateSnapshot.zoomLevelInfo.stepDurationMs / this._store.stateSnapshot.rulerStepWidthPx;
        const scrollLeftPx = this.currentTimelineScrolledPx.scrollLeft;
        const scrollRightPx = this.currentTimelineScrolledPx.scrollRight;
        const currentTimeMs = this._store.stateSnapshot.currentTimeMs;
        const trackVisibleWidthPx = this._timelineElement.nativeElement.clientWidth;
        const newScrollLeftPx = getLeftScollPxOfTimePosition(trackHeaderWidthPx, trackWidthPx, trackVisibleWidthPx, durationMsPerPx, scrollLeftPx, scrollRightPx, currentTimeMs);
        this._timelineScrollableElement.scrollTo({ left: newScrollLeftPx });
    }
    resizeTrack(event, trackHeightPx) {
        // track height min 30px and max 70px
        const newTrackHeightPx = Math.min(70, Math.max(30, trackHeightPx + event.diffY));
        this._store.setTrackHeightPx(newTrackHeightPx);
    }
    selectItem(item, track) {
        this.selectedItemUuid = item.uuid;
        this.itemSelected.emit({
            item,
            track,
        });
    }
    deleteItem(item, track, trackIndex) {
        this._store.deleteItem({ itemUuid: item.uuid, trackIndex });
        this.itemDeleted.emit({
            id: item.id,
            trackId: track.id,
            trackIndex,
            data: item.data,
            tracks: [...this._store.stateSnapshot.tracks],
        });
    }
    deselectItems() {
        this.selectedItemUuid = null;
        this._changeDetectorRef.detectChanges();
    }
    get showTrackAddButton() {
        return this.trackAdd.observers.length > 0;
    }
    onTimelineSettingsAction(action, currentZoomLevel) {
        if (action === 'recenter-on-scrubber') {
            this.recenterOnScrubber();
        }
        else if (action === 'zoom-in') {
            this.updateZoom(currentZoomLevel + 1);
        }
        else if (action === 'zoom-out') {
            this.updateZoom(currentZoomLevel - 1);
        }
        else if (action === 'track-add') {
            this.trackAdd.emit();
        }
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    _initScrollListeners() {
        this._scrollDispatcher
            .scrolled(0)
            .pipe(filter((evt) => evt.getElementRef()?.nativeElement === this._timelineElement.nativeElement), takeUntil(this.componentDestroyed$))
            .subscribe((evt) => {
            this.currentTimelineScrolledPx = {
                scrollLeft: evt.measureScrollOffset('left'),
                scrollRight: evt.measureScrollOffset('right'),
            };
            this.isTimelineScrolledHorizontally = evt.measureScrollOffset('left') > 0;
            // wont update the view immediately when using an observable - need to detect changes right away
            this._changeDetectorRef.detectChanges();
        });
    }
    _initZoomListeners() {
        this._store.zoomLevelInfo$.pipe(skip(1), observeOn(asyncScheduler), takeUntil(this.componentDestroyed$)).subscribe(() => {
            this._updateScrollPositions();
            this.recenterOnScrubber();
        });
    }
    _initEvents() {
        this._store.timeChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe((evt) => this.currentTimeChanged.emit(evt));
    }
    _updateScrollPositions() {
        this.currentTimelineScrolledPx = {
            scrollLeft: this._timelineScrollableElement.measureScrollOffset('left'),
            scrollRight: this._timelineScrollableElement.measureScrollOffset('right'),
        };
    }
    // When an item starts being dragged (from within or outside of the timeline)
    onItemDragStart($event, tracks) {
        this._store.setItemDraggingActive(true);
        // get the dragged item
        let draggedItem = $event.source.draggableData.originData;
        const draggedItemType = this._store.stateSnapshot.types.find(({ type }) => type === draggedItem.type) || DEFAULT_TIMELINE_ITEM_TYPE;
        const isNewItem = !draggedItem.uuid;
        // add a uuid for new items and make sure it has a duration otherwise use the default from the item type
        if (isNewItem) {
            draggedItem = {
                ...draggedItem,
                uuid: v4(),
                durationMs: draggedItem.durationMs ?? draggedItem.originalDurationMs ?? draggedItemType.defaultDurationMs ?? this._store.stateSnapshot.trackItemMinDurationMs ?? 1000,
            };
        }
        // get the track index if its not a new item
        let draggedItemTrackIndex = null;
        if (!isNewItem) {
            draggedItemTrackIndex = getItemTrackIndex(tracks, draggedItem.uuid);
            this._store.updateTrackItem({ itemUuid: draggedItem.uuid, itemTrackIndex: draggedItemTrackIndex, updateData: { moved: true } });
        }
        const firstTrackRect = this._trackElementQL.toArray()[0].nativeElement.getBoundingClientRect();
        // get all magnetic slots for the current timeline
        const msFor1Px = (1 / this._store.stateSnapshot.rulerStepWidthPx) * this._store.stateSnapshot.zoomLevelInfo.stepDurationMs;
        const magneticForce = 10 * msFor1Px;
        const magneticSlots = this._store.stateSnapshot.enableAutoAlign
            ? getMagneticSlots(tracks, magneticForce, this._store.stateSnapshot.timelineMaxDurationMs, this._store.stateSnapshot.currentTimeMs, draggedItem.uuid)
            : [];
        // Init the drag info with data that is not going to changed during the drag process
        this.dragInfo = {
            draggedItem,
            draggedItemTrackIndex,
            isNewItem,
            firstTrackPosition: { left: firstTrackRect.left, top: firstTrackRect.y },
            trackHeightPx: this._store.stateSnapshot.trackHeightPx,
            trackItemMinDurationMs: this._store.stateSnapshot.trackItemMinDurationMs,
            timelineMaxDurationMs: this._store.stateSnapshot.timelineMaxDurationMs,
            rulerStepWidthPx: this._store.stateSnapshot.rulerStepWidthPx,
            rulerIntervalDurationMs: this._store.stateSnapshot.rulerIntervalDurationMs,
            stepDurationMs: this._store.stateSnapshot.zoomLevelInfo.stepDurationMs,
            draggedItemType,
            magneticForce,
            magneticSlots,
            hoveredTrackIndex: null,
            timePositionMs: null,
            draggingItems: null,
        };
    }
    /**
     * When an item is moved on the timeline
     */
    onTimelineDragItemMove($event, tracks) {
        const { draggedItem, draggedItemTrackIndex, firstTrackPosition, trackHeightPx, rulerStepWidthPx, rulerIntervalDurationMs, stepDurationMs, draggedItemType, timelineMaxDurationMs, trackItemMinDurationMs, magneticForce, magneticSlots, } = this.dragInfo;
        const previousHoveredTrackIndex = this.dragInfo.hoveredTrackIndex;
        const previousTimePositionMs = this.dragInfo.timePositionMs;
        const hoveredTrackIndex = getTimelineHoveredTrackIndex($event.event, firstTrackPosition.top, trackHeightPx, tracks.length);
        if (hoveredTrackIndex === null) {
            this._store.cancelItemDragging({ isDraggingStillActive: true, draggedItemUuid: draggedItem.uuid, originTrackIndex: draggedItemTrackIndex });
            return;
        }
        const beforeDragHoveredTrack = tracks[hoveredTrackIndex];
        if (!beforeDragHoveredTrack) {
            this._store.cancelItemDragging({ isDraggingStillActive: true, draggedItemUuid: draggedItem.uuid, originTrackIndex: draggedItemTrackIndex });
            return;
        }
        // get the time position of the cursor on the track
        const xPosWithinTrack = $event.event.clientX - firstTrackPosition.left;
        const dragXTimePositionMs = pxToDurationMs(xPosWithinTrack, rulerStepWidthPx, stepDurationMs);
        const hasTrackChanged = previousHoveredTrackIndex !== hoveredTrackIndex;
        const hasTimePositionChanged = previousTimePositionMs !== dragXTimePositionMs;
        // drag on the left / right side
        const dragSide = dragXTimePositionMs - (draggedItem.positionMs + draggedItem.durationMs / 2);
        let draggingItems;
        if (hasTrackChanged || hasTimePositionChanged) {
            const nearestMagneticSlot = findNearestSlot(dragXTimePositionMs, magneticSlots, magneticForce, timelineMaxDurationMs);
            this._store.setAlignmentIndicator(nearestMagneticSlot && nearestMagneticSlot.startMs ? nearestMagneticSlot.startMs + magneticForce : null);
            // get the items of the destination track, updated with the dragged item (it may push other items of the track)
            draggingItems = getTrackWithDraggedItem(beforeDragHoveredTrack.items, dragXTimePositionMs, draggedItem, draggedItemType, timelineMaxDurationMs, trackItemMinDurationMs, rulerIntervalDurationMs, magneticForce, magneticSlots, dragSide > 0 ? 'right' : 'left');
            this._store.updateDisplayTracksWithDraggingInfo({
                destinationTrackIndex: hoveredTrackIndex,
                draggingItems,
            });
        }
        // update the drag info
        this.dragInfo = {
            ...this.dragInfo,
            hoveredTrackIndex,
            timePositionMs: dragXTimePositionMs,
            ...(draggingItems ? { draggingItems } : {}), // only update the dragging items if they have changed
        };
    }
    /**
     * When an item stops being dragged (with a drop in the timeline or not)
     */
    onItemDragEnd($event, displayTracks) {
        this._store.setAlignmentIndicator(null);
        const { draggedItem, draggedItemTrackIndex, isNewItem, firstTrackPosition, trackHeightPx, draggingItems } = this.dragInfo;
        this._store.setItemDraggingActive(false);
        const hoveredTrackIndex = getTimelineHoveredTrackIndex($event.event, firstTrackPosition.top, trackHeightPx, displayTracks.length);
        if (hoveredTrackIndex === null) {
            this._store.cancelItemDragging({ isDraggingStillActive: false, draggedItemUuid: draggedItem.uuid, originTrackIndex: draggedItemTrackIndex });
            return;
        }
        const isItemAdded = displayTracks.some((track) => track.items.some((item) => item.uuid === draggedItem.uuid && !item.moved));
        if (!isItemAdded) {
            this._store.cancelItemDragging({ isDraggingStillActive: false, draggedItemUuid: draggedItem.uuid, originTrackIndex: draggedItemTrackIndex });
            return;
        }
        // item was successfully moved/added - save the new items
        const finalDraggedItem = draggingItems.find((item) => item.uuid === draggedItem.uuid && item.dragged);
        this._store.saveItemDragging({ draggedItemUuid: draggedItem.uuid, originTrackIndex: draggedItemTrackIndex, destinationTrackIndex: hoveredTrackIndex });
        // emit the events
        if (isNewItem) {
            this.itemAdded.emit({
                destinationTrackId: displayTracks[hoveredTrackIndex].id,
                destinationTrackIndex: hoveredTrackIndex,
                positionMs: finalDraggedItem.positionMs,
                durationMs: finalDraggedItem.durationMs,
                tracks: [...this._store.stateSnapshot.tracks],
                draggedItem: $event.source.draggableData.targetData,
            });
        }
        else {
            this.itemMoved.emit({
                originTrackId: displayTracks[draggedItemTrackIndex].id,
                originTrackIndex: draggedItemTrackIndex,
                destinationTrackId: displayTracks[hoveredTrackIndex].id,
                destinationTrackIndex: hoveredTrackIndex,
                previousPositionMs: draggedItem.positionMs,
                previousDurationMs: draggedItem.durationMs,
                positionMs: finalDraggedItem.positionMs,
                durationMs: finalDraggedItem.durationMs,
                tracks: [...this._store.stateSnapshot.tracks],
                draggedItem: $event.source.draggableData.targetData,
            });
        }
        this.dragInfo = null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineV2Component, deps: [{ token: TimelineStore }, { token: i1$4.ScrollDispatcher }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimelineV2Component, selector: "avn-timeline-v2", inputs: { tracks: "tracks", types: "types", trackHeightPx: "trackHeightPx", zoomLevel: "zoomLevel", timelineMaxDurationMs: "timelineMaxDurationMs", trackItemMinDurationMs: "trackItemMinDurationMs", rulerIntervalDurationMs: "rulerIntervalDurationMs", trackBufferWidthPx: "trackBufferWidthPx", displayTimeConfig: "displayTimeConfig", enableAutoAlign: "enableAutoAlign", trackHeaderTemplate: "trackHeaderTemplate", trackItemTemplate: "trackItemTemplate", actionLabels: "actionLabels" }, outputs: { currentTimeChanged: "currentTimeChanged", trackAdd: "trackAdd", itemResized: "itemResized", itemSelected: "itemSelected", itemMoved: "itemMoved", itemAdded: "itemAdded", itemDeleted: "itemDeleted" }, providers: [TimelineStore], viewQueries: [{ propertyName: "_timelineElement", first: true, predicate: ["timeline"], descendants: true }, { propertyName: "_timelineScrollableElement", first: true, predicate: ScrollDirective, descendants: true }, { propertyName: "_trackHeaderElement", first: true, predicate: ["trackHeader"], descendants: true }, { propertyName: "_trackElementQL", predicate: ["trackEl"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"model$ | async as model\">\n  <div\n    #timeline\n    class=\"timeline\"\n    avnScroll\n    [class.x-scrolled]=\"isTimelineScrolledHorizontally\"\n    [avnDragDropElementTarget]=\"['timeline-item']\"\n    [avnDragDropElementTargetShowOnDragOnly]=\"false\"\n    [avnDragDropElementTargetShowOnHoverOnly]=\"false\"\n    [avnDragDropElementTargetEmitAllDragMoveEvents]=\"true\"\n    (draggedOver)=\"model.tracks.length > 0 && onTimelineDragItemMove($event, model.tracks)\"\n    (dragStart)=\"model.tracks.length > 0 && onItemDragStart($event, model.tracks)\"\n    (dragEnd)=\"model.tracks.length > 0 && onItemDragEnd($event, model.displayTracks)\"\n  >\n    <div class=\"content\" [style.grid-template-rows]=\"timelineTemplateRows$ | async\">\n      <div class=\"time-settings-container\">\n        <avn-timeline-settings\n          [showTrackAddButton]=\"showTrackAddButton\"\n          (action)=\"onTimelineSettingsAction($event, model.zoomLevelInfo.level)\"\n          [actionLabels]=\"actionLabels\"\n        ></avn-timeline-settings>\n        <div class=\"current-time\">{{ model.currentTimeMs | applyFunction: timeMsToTime | applyFunction: getTimelineDisplayTime:[model.displayTimeConfig] }}</div>\n      </div>\n      <div class=\"ruler-container\" [style.width.px]=\"model.trackWidthPx\">\n        <avn-timeline-ruler></avn-timeline-ruler>\n        <avn-timeline-scrubber\n          [style.height.px]=\"scrubberHeightPx$ | async\"\n          [style.left.px]=\"model.timeScrubberLeftPx\"\n          [style.top.px]=\"model.timeScrubberTopPx\"\n          avnDrag\n          [showDraggingOverlay]=\"false\"\n          [allowOutsideMove]=\"true\"\n          [debounceTime]=\"0\"\n          [cursor]=\"'grabbing'\"\n          [axis]=\"'x'\"\n          (dragStart)=\"onScrubberDragStart(model.timeScrubberLeftPx)\"\n          (dragMove)=\"onScrubberDragMove($event)\"\n        ></avn-timeline-scrubber>\n        <div\n          class=\"alignment-indicator\"\n          *ngIf=\"model.alignmentIndicator\"\n          [style.height.px]=\"model.alignmentIndicator.heightPx\"\n          [style.left.px]=\"model.alignmentIndicator.leftPx\"\n          [style.top.px]=\"model.alignmentIndicator.topPx\"\n        ></div>\n      </div>\n      <ng-container *ngFor=\"let track of model.displayTracks; trackBy: trackByTrack; index as trackIndex; last as lastTrack\">\n        <div class=\"track-header\" #trackHeader>\n          <ng-container *ngIf=\"!!trackHeaderTemplate; else noHeaderTemplate\">\n            <ng-container *ngTemplateOutlet=\"trackHeaderTemplate; context: { track: track }\"></ng-container>\n          </ng-container>\n          <ng-template #noHeaderTemplate>\n            <span class=\"title\">{{ track.name }}</span>\n          </ng-template>\n        </div>\n        <div #trackEl class=\"track\" [style.height.px]=\"model.trackHeightPx\" [style.width.px]=\"model.trackWidthPx\">\n          <ng-container *ngFor=\"let item of track.items; trackBy: trackByTrackItem\">\n            <avn-timeline-track-item\n              [tabIndex]=\"0\"\n              [avnDragDropElementOrigin]=\"'timeline-item'\"\n              [avnDragDropElementOriginData]=\"item\"\n              [avnDragDropElementOriginCursor]=\"'grab'\"\n              [avnDragDropElementOriginDisableGhostImage]=\"true\"\n              [itemTemplate]=\"trackItemTemplate\"\n              [itemTrack]=\"track\"\n              [itemTrackIndex]=\"trackIndex\"\n              [item]=\"item\"\n              [selected]=\"selectedItemUuid === item.uuid\"\n              [enablePointerEvents]=\"!model.itemDraggingActive || item.moved\"\n              (itemResized)=\"itemResized.emit($event)\"\n              (focus)=\"selectItem(item, track)\"\n              (blur)=\"deselectItems()\"\n              (keydown.delete)=\"deleteItem(item, track, trackIndex)\"\n            ></avn-timeline-track-item>\n          </ng-container>\n          <ng-container *ngIf=\"!lastTrack\">\n            <div\n              class=\"track-resizer\"\n              avnDrag\n              [showDraggingOverlay]=\"false\"\n              [cursor]=\"'n-resize'\"\n              [debounceTime]=\"0\"\n              (dragMove)=\"resizeTrack($event, model.trackHeightPx)\"\n              [class.disabled]=\"model.itemDraggingActive\"\n            ></div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</ng-container>\n", styles: [":host{--timeline-background: var(--main-background);height:100%;-webkit-user-select:none;user-select:none;display:block}:host .timeline{width:100%;height:100%;overflow:auto;position:relative}:host .timeline .content{position:relative;display:grid;grid-template-columns:max-content auto;width:max-content;overflow:clip}:host .timeline .content .alignment-indicator{position:absolute;height:100%;width:1px;border-left:1px dashed red}:host .timeline .content .time-settings-container{position:sticky;top:0;left:0;width:100%;min-width:100px;background-color:var(--timeline-background);border-bottom:1px solid var(--surface-background);z-index:5;display:grid}:host .timeline .content .time-settings-container .current-time{color:var(--secondary-base);font-size:var(--text-sm);font-weight:bolder;display:flex;align-items:center;justify-content:center}:host .timeline .content .ruler-container{background-color:var(--timeline-background);border-bottom:1px solid var(--timeline-background);position:sticky;top:0;z-index:6}:host .timeline .content .ruler-container avn-timeline-scrubber{position:absolute;z-index:1000;left:0}:host .timeline .content .track-header{box-sizing:border-box;padding:2px;position:sticky;background-color:var(--timeline-background);left:0;width:100%;z-index:4;border-bottom:1px solid var(--surface-background);display:flex;align-items:center;justify-content:center;padding:var(--space-sm)}:host .timeline .content .track-header>.title{font-size:var(--text-sm)}:host .timeline .content .track{position:relative;background:var(--surface-background);border-bottom:1px solid var(--timeline-background);overflow:hidden}:host .timeline .content .track>.track-resizer{position:absolute;left:0;right:0;bottom:-4px;height:8px}:host .timeline .content .track>.track-resizer.disabled{pointer-events:none}:host .timeline.x-scrolled .content .time-settings-container{z-index:7}:host .timeline.x-scrolled .content .track-header{z-index:6}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: DragDirective, selector: "[avnDrag]", inputs: ["debounceTime", "allowOutsideMove", "axis", "cursor", "showDraggingOverlay"], outputs: ["dragStart", "dragMove", "dragEnd"] }, { kind: "directive", type: DragDropElementOriginDirective, selector: "[avnDragDropElementOrigin]", inputs: ["avnDragDropElementOriginCursor", "avnDragDropElementOrigin", "avnDragDropElementOriginData", "avnDragDropElementOriginDisableGhostImage", "avnDragDropElementOriginDisabled", "avnDragDropElementOriginIndex", "avnDragDropElementOriginRef"], outputs: ["dragStart", "dragEnd"] }, { kind: "directive", type: DragDropElementTargetDirective, selector: "[avnDragDropElementTarget]", inputs: ["avnDragDropElementTarget", "avnDragDropElementTargetShowOnHoverOnly", "avnDragDropElementTargetShowOnDragOnly", "avnDragDropElementTargetDisabled", "avnDragDropElementTargetOpacity", "avnDragDropElementTargetBorder", "avnDragDropElementTargetData", "avnDragDropElementTargetIndex", "avnDragDropElementTargetEmitAllDragMoveEvents"], outputs: ["draggedOver", "dragStart", "dragEnd", "dragEnter", "dragLeave", "elementDropped"] }, { kind: "component", type: TimelineScrubberComponent, selector: "avn-timeline-scrubber" }, { kind: "component", type: TimelineTrackItemComponent, selector: "avn-timeline-track-item", inputs: ["item", "itemTrack", "itemTrackIndex", "itemTemplate", "selected", "enablePointerEvents"], outputs: ["itemResized"] }, { kind: "component", type: TimelineRulerComponent, selector: "avn-timeline-ruler" }, { kind: "component", type: TimelineSettingsComponent, selector: "avn-timeline-settings", inputs: ["showTrackAddButton", "actionLabels"], outputs: ["action"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineV2Component, decorators: [{
            type: Component,
            args: [{ selector: 'avn-timeline-v2', providers: [TimelineStore], template: "<ng-container *ngIf=\"model$ | async as model\">\n  <div\n    #timeline\n    class=\"timeline\"\n    avnScroll\n    [class.x-scrolled]=\"isTimelineScrolledHorizontally\"\n    [avnDragDropElementTarget]=\"['timeline-item']\"\n    [avnDragDropElementTargetShowOnDragOnly]=\"false\"\n    [avnDragDropElementTargetShowOnHoverOnly]=\"false\"\n    [avnDragDropElementTargetEmitAllDragMoveEvents]=\"true\"\n    (draggedOver)=\"model.tracks.length > 0 && onTimelineDragItemMove($event, model.tracks)\"\n    (dragStart)=\"model.tracks.length > 0 && onItemDragStart($event, model.tracks)\"\n    (dragEnd)=\"model.tracks.length > 0 && onItemDragEnd($event, model.displayTracks)\"\n  >\n    <div class=\"content\" [style.grid-template-rows]=\"timelineTemplateRows$ | async\">\n      <div class=\"time-settings-container\">\n        <avn-timeline-settings\n          [showTrackAddButton]=\"showTrackAddButton\"\n          (action)=\"onTimelineSettingsAction($event, model.zoomLevelInfo.level)\"\n          [actionLabels]=\"actionLabels\"\n        ></avn-timeline-settings>\n        <div class=\"current-time\">{{ model.currentTimeMs | applyFunction: timeMsToTime | applyFunction: getTimelineDisplayTime:[model.displayTimeConfig] }}</div>\n      </div>\n      <div class=\"ruler-container\" [style.width.px]=\"model.trackWidthPx\">\n        <avn-timeline-ruler></avn-timeline-ruler>\n        <avn-timeline-scrubber\n          [style.height.px]=\"scrubberHeightPx$ | async\"\n          [style.left.px]=\"model.timeScrubberLeftPx\"\n          [style.top.px]=\"model.timeScrubberTopPx\"\n          avnDrag\n          [showDraggingOverlay]=\"false\"\n          [allowOutsideMove]=\"true\"\n          [debounceTime]=\"0\"\n          [cursor]=\"'grabbing'\"\n          [axis]=\"'x'\"\n          (dragStart)=\"onScrubberDragStart(model.timeScrubberLeftPx)\"\n          (dragMove)=\"onScrubberDragMove($event)\"\n        ></avn-timeline-scrubber>\n        <div\n          class=\"alignment-indicator\"\n          *ngIf=\"model.alignmentIndicator\"\n          [style.height.px]=\"model.alignmentIndicator.heightPx\"\n          [style.left.px]=\"model.alignmentIndicator.leftPx\"\n          [style.top.px]=\"model.alignmentIndicator.topPx\"\n        ></div>\n      </div>\n      <ng-container *ngFor=\"let track of model.displayTracks; trackBy: trackByTrack; index as trackIndex; last as lastTrack\">\n        <div class=\"track-header\" #trackHeader>\n          <ng-container *ngIf=\"!!trackHeaderTemplate; else noHeaderTemplate\">\n            <ng-container *ngTemplateOutlet=\"trackHeaderTemplate; context: { track: track }\"></ng-container>\n          </ng-container>\n          <ng-template #noHeaderTemplate>\n            <span class=\"title\">{{ track.name }}</span>\n          </ng-template>\n        </div>\n        <div #trackEl class=\"track\" [style.height.px]=\"model.trackHeightPx\" [style.width.px]=\"model.trackWidthPx\">\n          <ng-container *ngFor=\"let item of track.items; trackBy: trackByTrackItem\">\n            <avn-timeline-track-item\n              [tabIndex]=\"0\"\n              [avnDragDropElementOrigin]=\"'timeline-item'\"\n              [avnDragDropElementOriginData]=\"item\"\n              [avnDragDropElementOriginCursor]=\"'grab'\"\n              [avnDragDropElementOriginDisableGhostImage]=\"true\"\n              [itemTemplate]=\"trackItemTemplate\"\n              [itemTrack]=\"track\"\n              [itemTrackIndex]=\"trackIndex\"\n              [item]=\"item\"\n              [selected]=\"selectedItemUuid === item.uuid\"\n              [enablePointerEvents]=\"!model.itemDraggingActive || item.moved\"\n              (itemResized)=\"itemResized.emit($event)\"\n              (focus)=\"selectItem(item, track)\"\n              (blur)=\"deselectItems()\"\n              (keydown.delete)=\"deleteItem(item, track, trackIndex)\"\n            ></avn-timeline-track-item>\n          </ng-container>\n          <ng-container *ngIf=\"!lastTrack\">\n            <div\n              class=\"track-resizer\"\n              avnDrag\n              [showDraggingOverlay]=\"false\"\n              [cursor]=\"'n-resize'\"\n              [debounceTime]=\"0\"\n              (dragMove)=\"resizeTrack($event, model.trackHeightPx)\"\n              [class.disabled]=\"model.itemDraggingActive\"\n            ></div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</ng-container>\n", styles: [":host{--timeline-background: var(--main-background);height:100%;-webkit-user-select:none;user-select:none;display:block}:host .timeline{width:100%;height:100%;overflow:auto;position:relative}:host .timeline .content{position:relative;display:grid;grid-template-columns:max-content auto;width:max-content;overflow:clip}:host .timeline .content .alignment-indicator{position:absolute;height:100%;width:1px;border-left:1px dashed red}:host .timeline .content .time-settings-container{position:sticky;top:0;left:0;width:100%;min-width:100px;background-color:var(--timeline-background);border-bottom:1px solid var(--surface-background);z-index:5;display:grid}:host .timeline .content .time-settings-container .current-time{color:var(--secondary-base);font-size:var(--text-sm);font-weight:bolder;display:flex;align-items:center;justify-content:center}:host .timeline .content .ruler-container{background-color:var(--timeline-background);border-bottom:1px solid var(--timeline-background);position:sticky;top:0;z-index:6}:host .timeline .content .ruler-container avn-timeline-scrubber{position:absolute;z-index:1000;left:0}:host .timeline .content .track-header{box-sizing:border-box;padding:2px;position:sticky;background-color:var(--timeline-background);left:0;width:100%;z-index:4;border-bottom:1px solid var(--surface-background);display:flex;align-items:center;justify-content:center;padding:var(--space-sm)}:host .timeline .content .track-header>.title{font-size:var(--text-sm)}:host .timeline .content .track{position:relative;background:var(--surface-background);border-bottom:1px solid var(--timeline-background);overflow:hidden}:host .timeline .content .track>.track-resizer{position:absolute;left:0;right:0;bottom:-4px;height:8px}:host .timeline .content .track>.track-resizer.disabled{pointer-events:none}:host .timeline.x-scrolled .content .time-settings-container{z-index:7}:host .timeline.x-scrolled .content .track-header{z-index:6}\n"] }]
        }], ctorParameters: function () { return [{ type: TimelineStore }, { type: i1$4.ScrollDispatcher }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { _timelineElement: [{
                type: ViewChild,
                args: ['timeline', { static: false }]
            }], _timelineScrollableElement: [{
                type: ViewChild,
                args: [ScrollDirective, { static: false }]
            }], _trackHeaderElement: [{
                type: ViewChild,
                args: ['trackHeader', { static: false }]
            }], _trackElementQL: [{
                type: ViewChildren,
                args: ['trackEl']
            }], tracks: [{
                type: Input
            }], types: [{
                type: Input
            }], trackHeightPx: [{
                type: Input
            }], zoomLevel: [{
                type: Input
            }], timelineMaxDurationMs: [{
                type: Input
            }], trackItemMinDurationMs: [{
                type: Input
            }], rulerIntervalDurationMs: [{
                type: Input
            }], trackBufferWidthPx: [{
                type: Input
            }], displayTimeConfig: [{
                type: Input
            }], enableAutoAlign: [{
                type: Input
            }], trackHeaderTemplate: [{
                type: Input
            }], trackItemTemplate: [{
                type: Input
            }], actionLabels: [{
                type: Input
            }], currentTimeChanged: [{
                type: Output
            }], trackAdd: [{
                type: Output
            }], itemResized: [{
                type: Output
            }], itemSelected: [{
                type: Output
            }], itemMoved: [{
                type: Output
            }], itemAdded: [{
                type: Output
            }], itemDeleted: [{
                type: Output
            }] } });

class TimelineV2Module {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineV2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TimelineV2Module, declarations: [TimelineV2Component, TimelineScrubberComponent, TimelineTrackItemComponent, TimelineRulerComponent, TimelineTrackItemComponent, TimelineSettingsComponent], imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule, TooltipModule], exports: [TimelineV2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineV2Module, imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule, TooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimelineV2Module, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TimelineV2Component, TimelineScrubberComponent, TimelineTrackItemComponent, TimelineRulerComponent, TimelineTrackItemComponent, TimelineSettingsComponent],
                    exports: [TimelineV2Component],
                    imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule, TooltipModule],
                    providers: [],
                }]
        }] });

/**
 * This enum defines the item types
 */
var SchedulerItemType;
(function (SchedulerItemType) {
    SchedulerItemType["IMAGE"] = "image";
    SchedulerItemType["VIDEO"] = "video";
    SchedulerItemType["TEXT"] = "text";
    SchedulerItemType["SCHEDULE_BREAKFAST"] = "breakfast";
    SchedulerItemType["SCHEDULE_LUNCH"] = "lunch";
    SchedulerItemType["SCHEDULE_DINNER"] = "dinner";
    SchedulerItemType["SCHEDULE_OFF"] = "off";
})(SchedulerItemType || (SchedulerItemType = {}));
/**
 * This enum defines scheduler playlist sync type
 */
var SchedulerSyncType;
(function (SchedulerSyncType) {
    SchedulerSyncType[SchedulerSyncType["MASTER"] = 0] = "MASTER";
    SchedulerSyncType[SchedulerSyncType["REPEAT"] = 1] = "REPEAT";
    SchedulerSyncType[SchedulerSyncType["REPEAT_ONCE"] = 2] = "REPEAT_ONCE";
    SchedulerSyncType[SchedulerSyncType["NO_SYNC"] = 3] = "NO_SYNC";
})(SchedulerSyncType || (SchedulerSyncType = {}));

/**
 * Convert milliseconds to a time object (hours, minutes, seconds and milliseconds)
 */
const msToTime = (duration) => {
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const seconds = Math.floor((duration / 1000) % 60);
    const milliseconds = duration % 1000;
    return { hours, minutes, seconds, milliseconds };
};
/**
 * Convert time object (hours, minutes, seconds and milliseconds) to milliseconds
 */
const timeToMs = (value) => {
    const timeParts = value.split(':');
    const hoursMs = parseInt(timeParts[0], 10) * 60 * 60 * 1000 || 0;
    const minutesMs = parseInt(timeParts[1], 10) * 60 * 1000 || 0;
    const secondesMs = parseInt(timeParts[2], 10) * 1000 || 0;
    const ms = parseInt(timeParts[3], 10) || 0;
    return hoursMs + minutesMs + secondesMs + ms;
};
/**
 * Return a formatted time object (hours, minutes, seconds and milliseconds) from a milliseconds
 * value
 */
const displayTimeWithMS = (num) => {
    if (num === undefined) {
        return '----';
    }
    const t = msToTime(num);
    return t.hours + ':' + t.minutes + ':' + t.seconds + ':' + padEndWithZero(t.milliseconds, 3);
};
/**
 * Return a new zero padded string from a number until the resulting string reaches the given
 * length. The padding is applied from the start (left) of the current value.
 */
const padStartWithZero = (num, length) => num.toString().padStart(length, '0');
/**
 * Return a new zero padded string from a number until the resulting string reaches the given
 * length. The padding is applied from the end (right) of the current string.
 */
const padEndWithZero = (num, length) => num.toString().padEnd(length, '0');
/**
 * Convert a string enumeration to an Array of object with key value pair
 */
const convertStringEnumToObjArray = (enumObj) => {
    const itemType = [];
    let index = 0;
    for (const type in enumObj) {
        if (typeof enumObj[type] === 'string') {
            itemType.push({ id: index, key: type, value: enumObj[type] });
            index++;
        }
    }
    return itemType;
};

class SchedulerItemComponent {
    /**
     * if provided, add the custom class to the host element
     */
    get hostClasses() {
        return this.class;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SchedulerItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SchedulerItemComponent, selector: "avn-scheduler-item", inputs: { class: "class" }, host: { properties: { "class.custom-class": "this.hostClasses" } }, ngImport: i0, template: "<!-- projection main content -->\n<ng-content select=\".main-content\"></ng-content>\n\n<!-- projection left resizer -->\n<ng-content select=\".resizer.left\"></ng-content>\n\n<!-- projection right resizer -->\n<ng-content select=\".resizer.right\"></ng-content>\n\n<!-- projection top resizer -->\n<ng-content select=\".resizer.top\"></ng-content>\n\n<!-- projection bottom resizer -->\n<ng-content select=\".resizer.bottom\"></ng-content>\n", styles: ["@charset \"UTF-8\";::ng-deep .resizable .resizer{position:absolute;height:100%;width:10px}::ng-deep .resizable .resizer.left{left:0}::ng-deep .resizable .resizer.left:hover{cursor:w-resize}::ng-deep .resizable .resizer.left:after{content:\"\\2022\\2022\\2022\";position:absolute;left:10px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-lg);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.right{right:0}::ng-deep .resizable .resizer.right:hover{cursor:e-resize}::ng-deep .resizable .resizer.right:after{content:\"\\2022\\2022\\2022\";position:absolute;left:3px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-lg);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.top{height:10px;width:100%;top:0;background-color:#0003}::ng-deep .resizable .resizer.top:hover{cursor:n-resize}::ng-deep .resizable .resizer.bottom{height:10px;width:100%;bottom:0;background-color:#0003}::ng-deep .resizable .resizer.bottom:hover{cursor:s-resize}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SchedulerItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-scheduler-item', template: "<!-- projection main content -->\n<ng-content select=\".main-content\"></ng-content>\n\n<!-- projection left resizer -->\n<ng-content select=\".resizer.left\"></ng-content>\n\n<!-- projection right resizer -->\n<ng-content select=\".resizer.right\"></ng-content>\n\n<!-- projection top resizer -->\n<ng-content select=\".resizer.top\"></ng-content>\n\n<!-- projection bottom resizer -->\n<ng-content select=\".resizer.bottom\"></ng-content>\n", styles: ["@charset \"UTF-8\";::ng-deep .resizable .resizer{position:absolute;height:100%;width:10px}::ng-deep .resizable .resizer.left{left:0}::ng-deep .resizable .resizer.left:hover{cursor:w-resize}::ng-deep .resizable .resizer.left:after{content:\"\\2022\\2022\\2022\";position:absolute;left:10px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-lg);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.right{right:0}::ng-deep .resizable .resizer.right:hover{cursor:e-resize}::ng-deep .resizable .resizer.right:after{content:\"\\2022\\2022\\2022\";position:absolute;left:3px;top:50%;color:#0000004d;transform:translate(-50%,-50%) rotate(90deg);font-size:var(--text-lg);letter-spacing:2px;margin-top:var(--space-xs)}::ng-deep .resizable .resizer.top{height:10px;width:100%;top:0;background-color:#0003}::ng-deep .resizable .resizer.top:hover{cursor:n-resize}::ng-deep .resizable .resizer.bottom{height:10px;width:100%;bottom:0;background-color:#0003}::ng-deep .resizable .resizer.bottom:hover{cursor:s-resize}\n"] }]
        }], propDecorators: { class: [{
                type: Input
            }], hostClasses: [{
                type: HostBinding,
                args: ['class.custom-class']
            }] } });

/* eslint-disable @typescript-eslint/prefer-for-of */
class SchedulerComponent {
    /**
     * Return the scheduler main section element
     */
    get mainSection() {
        return this.elRef.nativeElement.querySelector('.main-section');
    }
    /**
     * Return the dragged item floating status
     */
    isFloatingItem() {
        let floatProp;
        if (this.lastDraggedItem && this.lastDraggedItem.item) {
            floatProp = this.lastDraggedItem.item.floating ? this.lastDraggedItem.item.floating : false;
        }
        else {
            floatProp = false;
        }
        return floatProp;
    }
    /**
     * Return the item background color based on the "color" property, the "type" property or the
     * global theme
     */
    getItemColor(item, hover) {
        const selected = !this.disabledSelectionPreview ? item.selected : false;
        const defaultColorBaseScheme = this.colorScheme[0].base;
        if (item.color) {
            // By provided color
            const newColor = new Color(item.color);
            return selected ? newColor.darken(0.3).string() : hover ? newColor.lighten(0.2).string() : newColor.string();
        }
        else if (item.type) {
            // By item type
            const types = convertStringEnumToObjArray(SchedulerItemType);
            const type = types.find((t) => t.value === item.type);
            const typeId = type.id;
            return selected
                ? this.colorScheme[typeId].base.darken(0.3).string()
                : hover
                    ? this.colorScheme[typeId].base.lighten(0.2).string()
                    : this.colorScheme[typeId].base.string();
        }
        else {
            return selected ? defaultColorBaseScheme.darken(0.3).string() : hover ? defaultColorBaseScheme.lighten(0.2).string() : defaultColorBaseScheme.string();
        }
    }
    /**
     * Return the item color based on the background color "on" calculation
     */
    getItemOnColor(item) {
        if (item.color) {
            // By provided color
            const newColor = new Color(item.color);
            return this.resolveForegroundColor(newColor);
        }
        else if (item.type) {
            // By item type
            const types = convertStringEnumToObjArray(SchedulerItemType);
            const type = types.find((t) => t.value === item.type);
            return this.colorScheme[type.id].on;
        }
        else {
            return this.colorScheme[0].on;
        }
    }
    /**
     * @ignore
     */
    constructor(renderer, colorSetsService, _window, _document, elRef) {
        this.renderer = renderer;
        this.colorSetsService = colorSetsService;
        this._window = _window;
        this._document = _document;
        this.elRef = elRef;
        /**
         * The datasource containing the rows/columns to display in the scheduler
         */
        this.dataSource = [];
        /**
         * Display the resizer handles
         */
        this.displayResizer = true;
        /**
         * Available Zoom Levels (0..4)
         * Zoom level 0 is the most zoomed out zoom level available
         */
        this.zoomLevel = 1;
        /**
         * Width of the leftmost column (px)
         */
        this.leftSectionWidth = 100;
        /**
         * Size of the height or width of the scheduler element (px)
         */
        this.schedulerSmallerDimension = 50;
        /**
         * Theme for items
         */
        this.theme = ThemeType.PRIMARY;
        /**
         * disables resize, drag & drop operations.
         */
        this.disabled = false;
        /**
         * disable the darker overlay selection preview
         */
        this.disabledSelectionPreview = false;
        /**
         * Emits when an item is selected
         */
        this.itemSelected = new EventEmitter();
        /**
         * Emits when the dataSource is modified (move, drag & drop, resize, delete)
         */
        this.dataSourceChanged = new EventEmitter();
        /**
         * Emits when the current time indicator changes
         */
        this.currentTimeScrubberChanged = new EventEmitter();
        /**
         * Allows adding a custom css class to the ruler ( axisTemplate )
         */
        this.rulerClasses = '';
        /** @ignore Mousemove event listener instance, used to destroy existing listener on mouseUp */
        this.globalInstance = null;
        /** @ignore Used to track the last resized item */
        this.lastResizedItem = undefined;
        /** @ignore Used to track the last dragged item */
        this.lastDraggedItem = undefined;
        /** @ignore Used to track the last overred scheduler container */
        this.lastOveredContainer = undefined;
        /** @ignore Used when you toggle selection on an item */
        this.selectedItem = undefined;
        /** @ignore The minimum media item duration value (ms) */
        this.mediaMinDuration = 1000;
        /** @ignore Backup of items used to track positions on dragover functionality */
        this.containerItemsBackup = undefined;
        /** @ignore The ruler top margin */
        this.rulerTopMargin = 40;
        /** @ignore The ruler bottom margin */
        this.rulerBottomMargin = 10;
        /** @ignore pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
        /**
         * @ignore
         * Used to keep track of a dragover event and container reference
         */
        this.dragOverSubject = new Subject();
        /**
         * @ignore
         * Used to throttle down dragover value emitted for performance reasons
         */
        this.dragOverObservable = this.dragOverSubject.asObservable().pipe(throttleTime(250));
        this.setDefault();
    }
    /**
     * @ignore
     */
    ngOnChanges({ dataSource, mode, zoomLevel, changeItemPosition, changeItemDuration, theme, tickIntervalDivision }) {
        if (zoomLevel && zoomLevel.currentValue !== undefined) {
            if (zoomLevel.currentValue > 4) {
                this.zoomLevel = 4;
            }
            if (zoomLevel.currentValue < 0) {
                this.zoomLevel = 0;
            }
            this.setDefault();
        }
        if ((zoomLevel && !zoomLevel.firstChange) || (tickIntervalDivision && !tickIntervalDivision.firstChange)) {
            this.drawCanvasRuler();
        }
        if (mode && mode.currentValue !== undefined) {
            this.setDefault();
        }
        if (changeItemPosition && changeItemPosition.currentValue !== undefined) {
            this.changePos(changeItemPosition.currentValue.uuid, changeItemPosition.currentValue.pos);
        }
        if (changeItemDuration && changeItemDuration.currentValue !== undefined) {
            this.changeDur(changeItemDuration.currentValue.uuid, changeItemDuration.currentValue.dur);
        }
        if (dataSource && dataSource.currentValue) {
            this.initObjectUUID(cloneDeep(dataSource.currentValue));
            this.drawCanvasRuler();
        }
        if (theme && theme.currentValue) {
            this.setColorSchemeFromTheme(theme.currentValue);
        }
    }
    /**
     * Create a color scheme list used on the item elements
     */
    setColorSchemeFromTheme(theme) {
        const newTheme = this.colorSetsService.defaultThemes.find((t) => t.name === theme);
        this.colorScheme = [];
        if (newTheme) {
            for (let i = 0; i < 6; i++) {
                const color = new Color(newTheme.domain[i]);
                this.colorScheme.push({
                    base: color,
                    on: this.resolveForegroundColor(color),
                });
            }
        }
    }
    /**
     * Return black or white based on the rgb background color contrast
     * https://en.wikipedia.org/wiki/YIQ
     */
    resolveForegroundColor(color) {
        const r = color.color[0];
        const g = color.color[1];
        const b = color.color[2];
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? '#000' : '#FFF';
    }
    /**
     * @ignore
     */
    ngOnInit() {
        if (this.theme) {
            this.setColorSchemeFromTheme(this.theme);
        }
        this.dragOverObservable.subscribe((data) => {
            this.moveItemsOnDragOver(data.evt, data.draggableContainerId);
        });
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /**
     * @ignore
     */
    ngAfterViewInit() {
        this.drawCanvasRuler();
        fromEvent(this._document, 'keydown')
            .pipe(filter((event) => event.keyCode === DELETE && !this.disabled), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.deleteSelectedItems();
        });
        // when mouseup is done outside the window
        fromEvent(this._window, 'mouseup')
            .pipe(filter((event) => {
            const el = event.target;
            return el.tagName === 'HTML';
        }), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.onMouseUp();
        });
        // when mouseup is done inside the window
        fromEvent(this._document, 'mouseup')
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            this.onMouseUp();
        });
    }
    /**
     * Generate UUIDs on scheduler rows and items
     */
    initObjectUUID(dataSource) {
        for (let i = 0; i < dataSource.length; i++) {
            dataSource[i].uuid = v4();
            for (let j = 0; j < dataSource[i].items.length; j++) {
                dataSource[i].items[j].uuid = v4();
            }
        }
        this.dataSource = [...dataSource];
    }
    /**
     * Set default based on the layout mode
     */
    setDefault() {
        this.scales = [0.25, 0.5, 1, 2, 4];
        this.scale = this.scales[this.scales.length - this.zoomLevel - 1];
        this.step = 50; // px
        this.scaleFactor = 72000;
        this.snapDistance = 225000; // ms
        this.lastDraggedItem = undefined;
        this.lastResizedItem = undefined;
    }
    /**
     * Set container parent height
     */
    setContainerParentHeight() {
        const canvas = this.schedulerCanvasRuler.nativeElement;
        const parentElement = canvas.parentElement;
        const totalHeight = (this.step / this.scale) * 24 + this.rulerTopMargin + this.rulerBottomMargin;
        canvas.height = totalHeight;
        parentElement.style.height = totalHeight + 'px';
    }
    /**
     * Get container offset height
     */
    getContainerHeight() {
        const schedulerContainerEl = this.schedulerContainer.nativeElement;
        return schedulerContainerEl.offsetHeight;
    }
    /**
     * Draw a vertical ruler for the left section using an HTML canvas element
     */
    drawCanvasRuler() {
        this.setContainerParentHeight();
        const canvas = this.schedulerCanvasRuler.nativeElement;
        const ctx = canvas.getContext('2d');
        ctx.strokeStyle = 'rgb(230, 230, 230)';
        ctx.fillStyle = 'rgb(230, 230, 230)';
        ctx.textAlign = 'right';
        ctx.font = '12px sans-serif';
        ctx.lineWidth = 0.75;
        ctx.beginPath();
        const interval = this.tickIntervalDivision ? this.tickIntervalDivision : 4;
        const lowTickDist = this.step / interval;
        for (let i = 0; i < canvas.height; i += this.step) {
            const x = i / this.step === Math.floor(i / this.step) ? 0 : 8;
            const { hours, seconds, minutes, milliseconds } = msToTime(this.convertPxToTimeScale(i));
            const timeLocale = DateTime.fromObject({ hour: hours, second: seconds, minute: minutes, millisecond: milliseconds }).toFormat('t');
            if (!x) {
                if (this.amLabel && hours === 0 && minutes === 0) {
                    ctx.fillText(this.amLabel, 65, i + 4 + this.rulerTopMargin);
                }
                else if (this.pmLabel && hours === 12 && minutes === 0) {
                    ctx.fillText(this.pmLabel, 65, i + 4 + this.rulerTopMargin);
                }
                else {
                    ctx.fillText(timeLocale, 65, i + 4 + this.rulerTopMargin);
                }
            }
            ctx.moveTo(75, i + this.rulerTopMargin);
            ctx.lineTo(95, i + this.rulerTopMargin);
            // Draw sub ticks
            for (let j = interval - 1; j > 0; j--) {
                ctx.moveTo(80, lowTickDist * j + i + this.rulerTopMargin);
                ctx.lineTo(95, lowTickDist * j + i + this.rulerTopMargin);
            }
        }
        ctx.stroke();
    }
    /**
     * Tick interval value used to display horizontal ruler
     */
    calculateIntervalDivision() {
        const secondeInterval = this.scale / 10;
        const maxSubDivision = 5;
        for (let i = maxSubDivision; i > 0; i--) {
            if ((secondeInterval / i) % 1 === 0) {
                return i;
            }
        }
        return 0;
    }
    /**
     * Emits an event with the selected item when you click on it
     */
    onToggleSelect(evt, id) {
        const draggableContainerIndex = this.getDraggableContainerIndexFromItemId(id);
        const item = this.dataSource[draggableContainerIndex].items.find((el) => el.uuid === id);
        const originalState = item.selected;
        if (!evt.shiftKey && !evt.ctrlKey) {
            this.deselectedAllItems();
        }
        item.selected = !originalState;
        const data = {
            data: {
                item: cloneDeep(item),
                list: cloneDeep(this.getDraggableContainerFromItemId(item.uuid)),
            },
        };
        this.itemSelected.emit(cloneDeep(data));
    }
    /**
     * Deselect all selected items
     */
    deselectedAllItems() {
        for (let i = 0; i < this.dataSource.length; i++) {
            for (let j = 0; j < this.dataSource[i].items.length; j++) {
                this.dataSource[i].items[j].selected = false;
            }
        }
    }
    /**
     * Delete all selected items
     */
    deleteSelectedItems() {
        for (let i = 0; i < this.dataSource.length; i++) {
            this.dataSource[i].items = this.dataSource[i].items.filter((item) => !item.selected);
        }
        this.selectedItem = undefined;
    }
    /**
     * Move all items to the right when dragover is detected
     */
    moveItemsOnDragOver(evt, draggableContainerId) {
        if (!this.lastDraggedItem) {
            return;
        }
        const targetId = evt.target.id;
        const targetIsDraggable = evt.target.getAttribute('draggable');
        const dragItem = this.getItem(this.lastDraggedItem.item.uuid);
        const draggableContainerIndex = this.getDraggableContainerIndexFromContainerId(draggableContainerId);
        if (targetIsDraggable && draggableContainerId !== this.lastOveredContainer && draggableContainerId !== targetId && dragItem.uuid !== targetId) {
            // do a draggable container backup
            if (!this.containerItemsBackup || draggableContainerId !== this.containerItemsBackup.uuid) {
                this.containerItemsBackup = Object.assign({}, this.dataSource[draggableContainerIndex]);
            }
            if (targetId) {
                const items = this.getNextItems(targetId);
                for (let i = 0; i < items.length; i++) {
                    const itemIndex = this.getItemIndex(items[i].uuid);
                    this.changePos(this.dataSource[draggableContainerIndex].items[itemIndex].uuid, items[i].pos + dragItem.dur);
                    this.lastOveredContainer = draggableContainerId;
                }
            }
        }
        else if (this.containerItemsBackup && targetIsDraggable && dragItem.uuid === targetId) {
            if (this.containerItemsBackup) {
                for (let i = 0; i < this.containerItemsBackup.items.length; i++) {
                    this.changePos(this.containerItemsBackup.items[i].uuid, this.containerItemsBackup.items[i].pos);
                }
            }
        }
    }
    /**
     * Specifies what data to be dragged by setting a custom data object
     */
    drag(evt, item) {
        const data = {
            item,
            offsetX: evt.offsetX,
            offsetY: evt.offsetY,
            pageX: evt.pageX,
            pageY: evt.pageY,
        };
        const elementRef = JSON.stringify(data);
        this.lastDraggedItem = data;
        evt.dataTransfer.setData('ref', elementRef);
    }
    /**
     * Cast new dragover event value
     */
    dragOver(evt, draggableContainerId) {
        evt.preventDefault();
        if (!this.isFloatingItem()) {
            this.dragOverSubject.next({ evt, draggableContainerId });
        }
    }
    /**
     * Append or move the dragged item into the container by changing its position and duration.
     * Features:
     *  1-snap position on time grid effect
     *  2-resize item if no space
     *  3-snap on before and after limits
     */
    drop(evt) {
        evt.preventDefault();
        const data = JSON.parse(evt.dataTransfer.getData('ref'));
        const item = data.item;
        let itemId = item.uuid;
        const draggableContainerSourceId = this.getDraggableContainerIdFromItemId(itemId);
        const draggableContainerDestId = evt.target.id;
        const distance = this.convertPxToTimeScale(evt.pageY - data.pageY);
        const offsetMargin = this.mainSection.getBoundingClientRect().top;
        let finalPos = item.pos !== undefined
            ? this.snapOnTimeValue(item.pos + distance)
            : this.snapOnTimeValue(this.convertPxToTimeScale(evt.pageY - data.offsetY - offsetMargin));
        // scheduler limit validation
        if (finalPos < 0) {
            finalPos = 0;
        }
        if (draggableContainerSourceId !== draggableContainerDestId && evt.target.classList.contains('scheduler-column')) {
            if (item.pos !== undefined) {
                this.moveElement(itemId, draggableContainerSourceId, draggableContainerDestId);
            }
            else {
                itemId = this.addElement(item, draggableContainerDestId).uuid;
            }
            this.sortElements(draggableContainerDestId);
        }
        this.changePos(itemId, finalPos);
        // media limits validation
        const elements = {
            prev: this.getPrevItem(itemId),
            next: this.getNextItem(itemId),
        };
        const margin = this.rulerTopMargin + this.rulerBottomMargin;
        const afterLimit = this.convertPxToTimeScale(this.getContainerHeight() - margin);
        const limits = {
            before: elements.prev ? elements.prev.pos + elements.prev.dur : 0,
            after: elements.next ? elements.next.pos : afterLimit,
        };
        if (!this.isFloatingItem()) {
            if (finalPos + item.dur > limits.after) {
                finalPos = limits.after - item.dur;
            }
            if (finalPos < limits.before) {
                finalPos = limits.before;
            }
        }
        this.changePos(itemId, finalPos);
        // resize if there is no space
        if (limits.after - limits.before < item.dur && !this.isFloatingItem()) {
            this.changeDur(itemId, limits.after - limits.before);
        }
        this.lastDraggedItem = undefined;
        this.lastOveredContainer = undefined;
        this.dataSourceChanged.emit(Object.assign({}, this.dataSource));
        this.drawCanvasRuler();
    }
    /**
     * Change item duration and position on resize action with snap on time effect
     */
    onMouseUp() {
        // Destroy mousemove listener
        if (this.globalInstance) {
            this.globalInstance();
        }
        // Snap effect on resize (for all type except video)
        if (this.lastResizedItem) {
            const item = this.getItem(this.lastResizedItem.id);
            if (item && item.type !== SchedulerItemType.VIDEO) {
                if (this.lastResizedItem.resizer === 1) {
                    item.dur = this.snapOnTimeValue(item.dur);
                }
                else {
                    item.dur = this.snapOnTimeValue(item.dur);
                    item.pos = this.snapOnTimeValue(item.pos);
                }
            }
            if (this.lastResizedItem.pos !== item.pos || this.lastResizedItem.dur !== item.dur) {
                this.dataSourceChanged.emit(Object.assign({}, this.dataSource));
            }
        }
        this.lastResizedItem = undefined;
        this.drawCanvasRuler();
    }
    /**
     * Create mouseMove event listener on mouseDown action
     */
    onMouseDown(evt, pos, id) {
        evt.preventDefault();
        const originalWidth = evt.target.parentNode.getBoundingClientRect().right - evt.target.parentNode.getBoundingClientRect().left;
        const originalHeight = evt.target.parentNode.getBoundingClientRect().bottom - evt.target.parentNode.getBoundingClientRect().top;
        const originalX = evt.target.parentNode.getBoundingClientRect().left;
        const originalY = evt.target.parentNode.getBoundingClientRect().top;
        const originalEl = {
            height: originalHeight,
            width: originalWidth,
            pos: this.convertTimeScaleToPx(pos),
            x: originalX,
            y: originalY,
        };
        this.globalInstance = this.renderer.listen(this.schedulerContainer.nativeElement, 'mousemove', (evtParent) => {
            this.resize(evt, evtParent, originalEl, id);
        });
    }
    /**
     * Resize item on mouseMove by changing its position and/or duration.
     * Features:
     *  1-snap position on time grid effect
     *  2-snap on before and after limits
     *  3-use top and bottom handles
     */
    resize(evt, evtParent, originalEl, id) {
        const el = evt.target;
        const originalPos = this.convertPxToTimeScale(originalEl.pos);
        const originalDur = this.roundValue(this.convertPxToTimeScale(originalEl['height']));
        const elements = {
            prev: this.getPrevItem(id),
            next: this.getNextItem(id),
        };
        const margin = this.rulerTopMargin + this.rulerBottomMargin;
        const afterLimit = this.getContainerHeight() - margin;
        const limits = {
            before: elements.prev ? elements.prev.pos + elements.prev.dur : 0,
            after: elements.next ? elements.next.pos : this.convertPxToTimeScale(afterLimit),
        };
        const distance = evtParent.pageY - originalEl.y;
        if (el.classList.contains('top') || el.classList.contains('left')) {
            // Resize Top & Left
            let newPos = this.roundValue(this.convertPxToTimeScale(originalEl.pos + distance - 4));
            if (newPos < 0) {
                newPos = 0;
            }
            if (newPos < limits.before) {
                newPos = limits.before;
            }
            const newDur = originalDur - (newPos - originalPos);
            if (newDur >= this.mediaMinDuration) {
                if (newPos >= 0) {
                    this.lastResizedItem = {
                        id,
                        resizer: 0,
                        pos: originalPos,
                        dur: originalDur,
                    };
                    this.changeDur(id, newDur);
                    this.changePos(id, newPos);
                }
            }
        }
        else {
            // Resize Bottom & Right
            const posStart = this.roundValue(originalPos);
            let posEnd = this.roundValue(this.convertPxToTimeScale(originalEl.pos + distance + 4));
            if (posEnd > limits.after) {
                posEnd = limits.after;
            }
            const newDur = posEnd - posStart;
            if (newDur >= this.mediaMinDuration && posEnd <= limits.after) {
                this.changeDur(id, newDur);
                this.lastResizedItem = {
                    id,
                    resizer: 1,
                    pos: originalPos,
                    dur: originalDur,
                };
            }
        }
    }
    /**
     * Resize item on double click by changing its position and/or duration.
     * Features:
     *  1-snap on before and after limits
     *  2-use left and right handles in horizontal mode
     *  3-use top and bottom handles in vertical mode
     */
    onDblClick(evt, pos, id) {
        const el = evt.target;
        const originalWidth = evt.target.parentNode.getBoundingClientRect().right - evt.target.parentNode.getBoundingClientRect().left;
        const originalHeight = evt.target.parentNode.getBoundingClientRect().bottom - evt.target.parentNode.getBoundingClientRect().top;
        const elements = {
            prev: this.getPrevItem(id),
            next: this.getNextItem(id),
        };
        const margin = this.rulerTopMargin + this.rulerBottomMargin;
        const afterLimit = this.getContainerHeight() - margin;
        const limits = {
            before: elements.prev ? elements.prev.pos + elements.prev.dur : 0,
            after: elements.next ? elements.next.pos : this.convertPxToTimeScale(afterLimit),
        };
        let newDur;
        if (el.classList.contains('left')) {
            // Resize Left
            newDur = this.roundValue(this.convertPxToTimeScale(originalWidth) + pos - limits.before);
            this.changeDur(id, newDur);
            this.changePos(id, limits.before);
        }
        else if (el.classList.contains('right')) {
            // Resize Right
            newDur = limits.after - pos;
            this.changeDur(id, newDur);
        }
        else if (el.classList.contains('top')) {
            // Resize Top
            newDur = this.roundValue(this.convertPxToTimeScale(originalHeight) + pos - limits.before);
            this.changeDur(id, newDur);
            this.changePos(id, limits.before);
        }
        else {
            // Resize Bottom
            newDur = limits.after - pos;
            this.changeDur(id, newDur);
        }
        this.dataSourceChanged.emit(Object.assign({}, this.dataSource));
    }
    /**
     * Return a rounded value based on snap distance calculation
     */
    snapOnTimeValue(value) {
        const inv = 0.25 / this.snapDistance;
        return Math.round(value * inv) / inv;
    }
    /**
     * Return a rounded value
     */
    roundValue(x) {
        return Math.round(x);
    }
    /**
     * Stop propagation on resizer click
     */
    onClickResizer(evt) {
        evt.stopPropagation();
    }
    /**
     * Change de position of an item
     */
    changePos(id, newPos) {
        const item = this.getItem(id);
        if (item) {
            item.pos = newPos;
        }
    }
    /**
     * Change de duration of an item
     */
    changeDur(id, newDur) {
        const item = this.getItem(id);
        if (item) {
            item.dur = newDur;
        }
    }
    /**
     * Get the previous item based on the reference one
     */
    getPrevItem(id) {
        const draggableContainerIndex = this.getDraggableContainerIndexFromItemId(id);
        this.sortElements(this.getContainerIdFromContainerIndex(draggableContainerIndex));
        const itemIndex = this.getItemIndex(id);
        return itemIndex === 0 ? undefined : this.dataSource[draggableContainerIndex].items[itemIndex - 1];
    }
    /**
     * Get the next item based on the reference one
     */
    getNextItem(id) {
        const draggableContainerIndex = this.getDraggableContainerIndexFromItemId(id);
        this.sortElements(this.getContainerIdFromContainerIndex(draggableContainerIndex));
        const itemIndex = this.getItemIndex(id);
        if (itemIndex === this.dataSource[draggableContainerIndex].items.length - 1) {
            return undefined;
        }
        else {
            return this.dataSource[draggableContainerIndex].items[itemIndex + 1];
        }
    }
    /**
     * Return next items list based on the reference one (reference is included)
     */
    getNextItems(id) {
        const draggableContainerIndex = this.getDraggableContainerIndexFromItemId(id);
        const elIndex = this.getItemIndex(id);
        const items = this.dataSource[draggableContainerIndex].items;
        return items.slice(elIndex, this.dataSource[draggableContainerIndex].items.length);
    }
    /**
     * Return the container index based on an item
     */
    getDraggableContainerIndexFromItemId(id) {
        for (let i = 0; i < this.dataSource.length; i++) {
            const element = this.dataSource[i].items.find((item) => item.uuid === id);
            if (element) {
                return i;
            }
        }
    }
    /**
     * Return the container uuid based on an item
     */
    getDraggableContainerIdFromItemId(id) {
        for (let i = 0; i < this.dataSource.length; i++) {
            const element = this.dataSource[i].items.find((item) => item.uuid === id);
            if (element) {
                return this.dataSource[i].uuid;
            }
        }
    }
    /**
     * Return the container object based on an item
     */
    getDraggableContainerFromItemId(id) {
        for (let i = 0; i < this.dataSource.length; i++) {
            const element = this.dataSource[i].items.find((item) => item.uuid === id);
            if (element) {
                return this.dataSource[i];
            }
        }
    }
    /**
     * Return the container index based on a container id
     */
    getDraggableContainerIndexFromContainerId(id) {
        const container = this.dataSource.find((item) => item.uuid === id);
        if (container) {
            return this.dataSource.indexOf(container);
        }
    }
    /**
     * Return the container id based on a container index
     */
    getContainerIdFromContainerIndex(id) {
        return this.dataSource[id].uuid;
    }
    /**
     * Returns the item corresponding to its UUID
     */
    getItem(id) {
        const draggableContainerIndex = this.getDraggableContainerIndexFromItemId(id);
        let element;
        if (draggableContainerIndex !== undefined) {
            element = this.dataSource[draggableContainerIndex].items.find((item) => item.uuid === id);
        }
        return element ? element : undefined;
    }
    /**
     * Returns the item index corresponding to its UUID
     */
    getItemIndex(id) {
        const draggableContainerIndex = this.getDraggableContainerIndexFromItemId(id);
        let element;
        if (draggableContainerIndex !== undefined) {
            element = this.dataSource[draggableContainerIndex].items.find((item) => item.uuid === id);
        }
        return element ? this.dataSource[draggableContainerIndex].items.indexOf(element) : -1;
    }
    /**
     * Sort by position on an item list
     */
    sortElements(id) {
        const draggableContainerIndex = this.getDraggableContainerIndexFromContainerId(id);
        this.dataSource[draggableContainerIndex].items.sort((a, b) => a.pos - b.pos);
    }
    /**
     * Move an item from one container to another
     */
    moveElement(id, fromContainer, toContainer) {
        const item = this.getItem(id);
        const itemIndex = this.getItemIndex(id);
        this.dataSource[this.getDraggableContainerIndexFromContainerId(fromContainer)].items.splice(itemIndex, 1);
        this.dataSource[this.getDraggableContainerIndexFromContainerId(toContainer)].items.push(item);
    }
    /**
     * Add an item to a container
     */
    addElement(item, toContainer) {
        item.uuid = v4();
        this.dataSource[this.getDraggableContainerIndexFromContainerId(toContainer)].items.push(item);
        return item;
    }
    /**
     * Convert a time based value to pixel value
     */
    convertTimeScaleToPx(val) {
        return val / this.scale / this.scaleFactor;
    }
    /**
     * Convert a pixel based value to time scale value
     */
    convertPxToTimeScale(val) {
        return val * this.scale * this.scaleFactor;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SchedulerComponent, deps: [{ token: i0.Renderer2 }, { token: ColorSetsService }, { token: WINDOW }, { token: DOCUMENT }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SchedulerComponent, selector: "avn-scheduler", inputs: { dataSource: "dataSource", displayResizer: "displayResizer", zoomLevel: "zoomLevel", changeItemPosition: "changeItemPosition", changeItemDuration: "changeItemDuration", itemTemplate: "itemTemplate", axisTemplate: "axisTemplate", leftSectionWidth: "leftSectionWidth", schedulerSmallerDimension: "schedulerSmallerDimension", theme: "theme", disabled: "disabled", tickIntervalDivision: "tickIntervalDivision", amLabel: "amLabel", pmLabel: "pmLabel", disabledSelectionPreview: "disabledSelectionPreview", rulerClasses: "rulerClasses" }, outputs: { itemSelected: "itemSelected", dataSourceChanged: "dataSourceChanged", currentTimeScrubberChanged: "currentTimeScrubberChanged" }, viewQueries: [{ propertyName: "schedulerWrapper", first: true, predicate: ["schedulerWrapper"], descendants: true, static: true }, { propertyName: "schedulerContainer", first: true, predicate: ["schedulerContainer"], descendants: true, static: true }, { propertyName: "schedulerLeftSection", first: true, predicate: ["leftSection"], descendants: true, static: true }, { propertyName: "schedulerRightSection", first: true, predicate: ["rightSection"], descendants: true, static: true }, { propertyName: "schedulerCanvasRuler", first: true, predicate: ["canvasRuler"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div #schedulerWrapper class=\"scheduler-wrapper\" avnScroll>\n  <div #schedulerContainer class=\"scheduler-container\">\n    <div class=\"left-section\" #leftSection>\n      <div [ngClass]=\"rulerClasses\" class=\"canvas-wrapper\" [ngStyle]=\"{ 'min-width.px': leftSectionWidth }\">\n        <canvas #canvasRuler class=\"canvas-ruler\" width=\"100\"></canvas>\n      </div>\n    </div>\n    <div class=\"right-section\" #rightSection>\n      <div class=\"top-section\">\n        <div\n          class=\"axis-section\"\n          *ngFor=\"let source of dataSource\"\n          [ngStyle]=\"{\n            'width.px': source.size ? source.size : schedulerSmallerDimension\n          }\"\n        >\n          <ng-template #defaultAxisTemplate>\n            <div>{{ source.name }}</div>\n          </ng-template>\n          <ng-container [ngTemplateOutlet]=\"axisTemplate ? axisTemplate : defaultAxisTemplate\" [ngTemplateOutletContext]=\"{ $implicit: source }\">\n          </ng-container>\n        </div>\n      </div>\n      <div class=\"main-section\">\n        <div\n          [id]=\"source.uuid\"\n          class=\"scheduler-column\"\n          *ngFor=\"let source of dataSource\"\n          [style.width.px]=\"source.size || schedulerSmallerDimension\"\n          [class.disabled]=\"disabled\"\n          (drop)=\"!disabled && drop($event)\"\n          (dragover)=\"!disabled && dragOver($event, source.uuid)\"\n        >\n          <avn-scheduler-item\n            *ngFor=\"let item of source.items\"\n            draggable=\"true\"\n            [id]=\"item.uuid\"\n            class=\"scheduler-item vertical\"\n            [ngClass]=\"item.class ? item.class : ''\"\n            [class.floating]=\"item.floating\"\n            [class.selected]=\"item.selected\"\n            [class.resizable]=\"item.resizable\"\n            [style.height.px]=\"convertTimeScaleToPx(item.dur)\"\n            [style.width.px]=\"source.size || schedulerSmallerDimension\"\n            [style.transform]=\"'translate(0, ' + convertTimeScaleToPx(item.pos) + 'px)'\"\n            [style.backgroundColor]=\"getItemColor(item, item.hover)\"\n            [style.color]=\"getItemOnColor(item)\"\n            [style.cursor]=\"!disabled ? 'grab' : 'inherit'\"\n            (mouseenter)=\"item.hover = true\"\n            (mouseleave)=\"item.hover = undefined\"\n            (click)=\"onToggleSelect($event, item.uuid)\"\n            (dragstart)=\"!disabled && drag($event, item)\"\n          >\n            <div class=\"main-content\">\n              <ng-template #defaultItemTemplate>\n                <div>{{ item.name }}</div>\n              </ng-template>\n              <ng-container\n                [ngTemplateOutlet]=\"itemTemplate ? itemTemplate : defaultItemTemplate\"\n                [ngTemplateOutletContext]=\"{\n                  $implicit: item,\n                  size: convertTimeScaleToPx(item.dur)\n                }\"\n              >\n              </ng-container>\n            </div>\n            <div\n              *ngIf=\"displayResizer\"\n              class=\"resizer top\"\n              (click)=\"onClickResizer($event)\"\n              (dblclick)=\"onDblClick($event, item.pos, item.uuid)\"\n              (mousedown)=\"onMouseDown($event, item.pos, item.uuid)\"\n            ></div>\n            <div\n              *ngIf=\"displayResizer\"\n              class=\"resizer bottom\"\n              (click)=\"onClickResizer($event)\"\n              (dblclick)=\"onDblClick($event, item.pos, item.uuid)\"\n              (mousedown)=\"onMouseDown($event, item.pos, item.uuid)\"\n            ></div>\n          </avn-scheduler-item>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}:host .header-section{display:flex;padding-bottom:var(--space-base);align-items:flex-end}:host .header-section avn-input,:host .header-section avn-button{padding-left:var(--space-base)}:host .header-section avn-button:first-child{padding-left:0}:host .scheduler-wrapper{overflow:auto}:host .scheduler-container{position:relative;display:flex;background-color:var(--main-background);color:var(--main-on);width:100%}:host .main-section{display:flex;height:calc(100% - 40px)}:host .left-section{background-color:var(--main-background);color:var(--main-on);align-items:center;margin-right:0}:host .left-section.sticky{position:sticky;left:0;z-index:10}:host .right-section{width:100%;width:initial}:host .top-section{height:40px;vertical-align:middle;display:flex;align-items:center;background-color:initial}:host .axis-section{display:flex;align-items:center;justify-content:center;margin-top:1px;vertical-align:middle;font-size:var(--text-base);font-weight:400;height:40px;margin-left:var(--space-sm)}:host .scheduler-column{width:100%;height:100%;margin-top:0;margin-left:var(--space-sm);background-color:initial}:host .scheduler-item{position:absolute;display:flex;z-index:1;box-sizing:border-box;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:background-color .2s;border-radius:1px;height:100%}:host .scheduler-item>.main-content{height:100%;width:100%}:host .scheduler-item.floating{pointer-events:auto;opacity:.9;z-index:2}:host .scheduler-item:active{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .canvas-wrapper{position:relative;height:100%}:host .canvas-ruler{position:absolute;top:0;right:0}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "component", type: SchedulerItemComponent, selector: "avn-scheduler-item", inputs: ["class"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SchedulerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-scheduler', template: "<div #schedulerWrapper class=\"scheduler-wrapper\" avnScroll>\n  <div #schedulerContainer class=\"scheduler-container\">\n    <div class=\"left-section\" #leftSection>\n      <div [ngClass]=\"rulerClasses\" class=\"canvas-wrapper\" [ngStyle]=\"{ 'min-width.px': leftSectionWidth }\">\n        <canvas #canvasRuler class=\"canvas-ruler\" width=\"100\"></canvas>\n      </div>\n    </div>\n    <div class=\"right-section\" #rightSection>\n      <div class=\"top-section\">\n        <div\n          class=\"axis-section\"\n          *ngFor=\"let source of dataSource\"\n          [ngStyle]=\"{\n            'width.px': source.size ? source.size : schedulerSmallerDimension\n          }\"\n        >\n          <ng-template #defaultAxisTemplate>\n            <div>{{ source.name }}</div>\n          </ng-template>\n          <ng-container [ngTemplateOutlet]=\"axisTemplate ? axisTemplate : defaultAxisTemplate\" [ngTemplateOutletContext]=\"{ $implicit: source }\">\n          </ng-container>\n        </div>\n      </div>\n      <div class=\"main-section\">\n        <div\n          [id]=\"source.uuid\"\n          class=\"scheduler-column\"\n          *ngFor=\"let source of dataSource\"\n          [style.width.px]=\"source.size || schedulerSmallerDimension\"\n          [class.disabled]=\"disabled\"\n          (drop)=\"!disabled && drop($event)\"\n          (dragover)=\"!disabled && dragOver($event, source.uuid)\"\n        >\n          <avn-scheduler-item\n            *ngFor=\"let item of source.items\"\n            draggable=\"true\"\n            [id]=\"item.uuid\"\n            class=\"scheduler-item vertical\"\n            [ngClass]=\"item.class ? item.class : ''\"\n            [class.floating]=\"item.floating\"\n            [class.selected]=\"item.selected\"\n            [class.resizable]=\"item.resizable\"\n            [style.height.px]=\"convertTimeScaleToPx(item.dur)\"\n            [style.width.px]=\"source.size || schedulerSmallerDimension\"\n            [style.transform]=\"'translate(0, ' + convertTimeScaleToPx(item.pos) + 'px)'\"\n            [style.backgroundColor]=\"getItemColor(item, item.hover)\"\n            [style.color]=\"getItemOnColor(item)\"\n            [style.cursor]=\"!disabled ? 'grab' : 'inherit'\"\n            (mouseenter)=\"item.hover = true\"\n            (mouseleave)=\"item.hover = undefined\"\n            (click)=\"onToggleSelect($event, item.uuid)\"\n            (dragstart)=\"!disabled && drag($event, item)\"\n          >\n            <div class=\"main-content\">\n              <ng-template #defaultItemTemplate>\n                <div>{{ item.name }}</div>\n              </ng-template>\n              <ng-container\n                [ngTemplateOutlet]=\"itemTemplate ? itemTemplate : defaultItemTemplate\"\n                [ngTemplateOutletContext]=\"{\n                  $implicit: item,\n                  size: convertTimeScaleToPx(item.dur)\n                }\"\n              >\n              </ng-container>\n            </div>\n            <div\n              *ngIf=\"displayResizer\"\n              class=\"resizer top\"\n              (click)=\"onClickResizer($event)\"\n              (dblclick)=\"onDblClick($event, item.pos, item.uuid)\"\n              (mousedown)=\"onMouseDown($event, item.pos, item.uuid)\"\n            ></div>\n            <div\n              *ngIf=\"displayResizer\"\n              class=\"resizer bottom\"\n              (click)=\"onClickResizer($event)\"\n              (dblclick)=\"onDblClick($event, item.pos, item.uuid)\"\n              (mousedown)=\"onMouseDown($event, item.pos, item.uuid)\"\n            ></div>\n          </avn-scheduler-item>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}:host .header-section{display:flex;padding-bottom:var(--space-base);align-items:flex-end}:host .header-section avn-input,:host .header-section avn-button{padding-left:var(--space-base)}:host .header-section avn-button:first-child{padding-left:0}:host .scheduler-wrapper{overflow:auto}:host .scheduler-container{position:relative;display:flex;background-color:var(--main-background);color:var(--main-on);width:100%}:host .main-section{display:flex;height:calc(100% - 40px)}:host .left-section{background-color:var(--main-background);color:var(--main-on);align-items:center;margin-right:0}:host .left-section.sticky{position:sticky;left:0;z-index:10}:host .right-section{width:100%;width:initial}:host .top-section{height:40px;vertical-align:middle;display:flex;align-items:center;background-color:initial}:host .axis-section{display:flex;align-items:center;justify-content:center;margin-top:1px;vertical-align:middle;font-size:var(--text-base);font-weight:400;height:40px;margin-left:var(--space-sm)}:host .scheduler-column{width:100%;height:100%;margin-top:0;margin-left:var(--space-sm);background-color:initial}:host .scheduler-item{position:absolute;display:flex;z-index:1;box-sizing:border-box;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:background-color .2s;border-radius:1px;height:100%}:host .scheduler-item>.main-content{height:100%;width:100%}:host .scheduler-item.floating{pointer-events:auto;opacity:.9;z-index:2}:host .scheduler-item:active{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}:host .canvas-wrapper{position:relative;height:100%}:host .canvas-ruler{position:absolute;top:0;right:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: ColorSetsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }]; }, propDecorators: { dataSource: [{
                type: Input
            }], displayResizer: [{
                type: Input
            }], zoomLevel: [{
                type: Input
            }], changeItemPosition: [{
                type: Input
            }], changeItemDuration: [{
                type: Input
            }], itemTemplate: [{
                type: Input
            }], axisTemplate: [{
                type: Input
            }], leftSectionWidth: [{
                type: Input
            }], schedulerSmallerDimension: [{
                type: Input
            }], theme: [{
                type: Input
            }], disabled: [{
                type: Input
            }], tickIntervalDivision: [{
                type: Input
            }], amLabel: [{
                type: Input
            }], pmLabel: [{
                type: Input
            }], disabledSelectionPreview: [{
                type: Input
            }], itemSelected: [{
                type: Output
            }], dataSourceChanged: [{
                type: Output
            }], currentTimeScrubberChanged: [{
                type: Output
            }], rulerClasses: [{
                type: Input
            }], schedulerWrapper: [{
                type: ViewChild,
                args: ['schedulerWrapper', { static: true }]
            }], schedulerContainer: [{
                type: ViewChild,
                args: ['schedulerContainer', { static: true }]
            }], schedulerLeftSection: [{
                type: ViewChild,
                args: ['leftSection', { static: true }]
            }], schedulerRightSection: [{
                type: ViewChild,
                args: ['rightSection', { static: true }]
            }], schedulerCanvasRuler: [{
                type: ViewChild,
                args: ['canvasRuler', { static: true }]
            }] } });

class SchedulerModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SchedulerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SchedulerModule, declarations: [SchedulerComponent, SchedulerItemComponent], imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule], exports: [SchedulerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SchedulerModule, imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SchedulerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SchedulerComponent, SchedulerItemComponent],
                    exports: [SchedulerComponent],
                    imports: [CommonModule, CoreModule, IconModule, OptionModule, SelectModule, InputModule],
                    providers: [],
                }]
        }] });

/**
 * Slider Handler Index
 */
var SliderHandlerEnum;
(function (SliderHandlerEnum) {
    SliderHandlerEnum[SliderHandlerEnum["left"] = 0] = "left";
    SliderHandlerEnum[SliderHandlerEnum["right"] = 1] = "right";
})(SliderHandlerEnum || (SliderHandlerEnum = {}));
/**
 * Selected value display mode options
 */
var SelectedValueDisplayMode;
(function (SelectedValueDisplayMode) {
    SelectedValueDisplayMode["hide"] = "hide";
    SelectedValueDisplayMode["show"] = "show";
    SelectedValueDisplayMode["always"] = "always";
})(SelectedValueDisplayMode || (SelectedValueDisplayMode = {}));

/**
 * Utilities class helper for the slider component
 */
class Utilities {
    /**
     * Checks if value is empty, undefined or null
     */
    isNullOrEmpty(obj) {
        return obj === undefined || obj === null || obj === '';
    }
    /**
     * Return a valid available step value
     */
    findNextValidStepValue(n, step) {
        const divisorsSet1 = [];
        const divisorsSet2 = [];
        const sqrtNum = Math.sqrt(n);
        let newStep = -1;
        for (let i = 0; i < sqrtNum; i++) {
            if (n % i === 0) {
                divisorsSet1.push(i);
                divisorsSet2.push(n / i);
            }
        }
        // Picking newStep by checking large set of divisors first
        for (const divisorSet2 of divisorsSet2) {
            if (step > divisorSet2) {
                newStep = divisorSet2;
                break;
            }
        }
        // checking set of small divisors if newStep didn't find out till.
        if (newStep === -1) {
            for (let i = divisorsSet1.length - 1; i >= 0; i--) {
                if (step > divisorsSet1[i]) {
                    newStep = divisorsSet1[i];
                    break;
                }
            }
        }
        return newStep === -1 ? 1 : newStep;
    }
}

/**
 * the slider component made with ♡.
 *
 * caveat: when showing tooltips the implementation must account for overflow based on the label size which
 * will grow to fit the values used in the label template. Allow some extra space so labels can be fully shown. i.e the
 * slider's parent container should account for the anticipated max label size.
 */
class SliderComponent extends Utilities {
    /** return true if the selectedValue display mode is "show" */
    get isSelectedValueDisplayed() {
        return this.selectedValueDisplayMode === SelectedValueDisplayMode.show;
    }
    /** return true if the selectedValue display mode is "always" */
    get isSelectedValueAlwaysDisplayed() {
        return this.selectedValueDisplayMode === SelectedValueDisplayMode.always;
    }
    /**
     * @ignore
     */
    constructor(el, _changeDetector, document) {
        super();
        this.el = el;
        this._changeDetector = _changeDetector;
        this.document = document;
        /** @ignore width of slider bar element **/
        this.sliderWidth = 0;
        /** @ignore total difference between max and min values **/
        this.totalDiff = 0;
        /** @ignore initial event position of the dragged handle (x coordinate of event) **/
        this.startClientX = 0;
        /** @ignore initial position of the dragged handle (in slider model format) **/
        this.startPosition = 0;
        /** @ignore slider init state value **/
        this.sliderInitiated = false;
        /** @ignore pattern for destroy all subscriptions **/
        this.componentDestroyed$ = new Subject();
        /**
         * @ignore
         * Contains the offsets from each respective edge
         * eg. if min/max = [1000, 5000] and selected values = [2000, 4000] then slider model = [1000, 3000]
         */
        this.sliderModel = [0, 0];
        /** the size in px of the handlers **/
        this.handleSize = 22;
        /** Indicates if the slider handler is currently being dragged **/
        this.isHandlerActive = false;
        /** handle index value **/
        this.currentHandler = SliderHandlerEnum.left;
        /** indicator position list (px) **/
        this.stepIndicatorPositions = [];
        /** ref to SliderHandlerEnum for template purpose **/
        this.SliderHandler = SliderHandlerEnum;
        /** display or not the step indicator ticks **/
        this.showStepIndicator = false;
        /** display or not the dual handles for a range selection **/
        this.multiRange = false;
        /** show a tooltip instead of a label **/
        this.showTooltip = true;
        /** tooltip display mode (show, hide and always show) **/
        this.selectedValueDisplayMode = SelectedValueDisplayMode.show;
        /** hide the min and max value **/
        this.hideValues = false;
        /** specifies whether the component is disabled or not. **/
        this.disabled = false;
        /** the height of the slider main bar */
        this.barHeight = 8;
        /** Emits every time the selected value(s) changes **/
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        /** Emits the slider value everytime the user has finished sliding **/
        this.released = new EventEmitter();
    }
    ngOnInit() {
        merge(fromEvent(this.document, 'mouseup'), fromEvent(this.document, 'touchend'))
            .pipe(filter(() => !this.disabled && this.isHandlerActive), takeUntil(this.componentDestroyed$))
            .subscribe(() => {
            if (this.isHandlerActive) {
                this.released.emit(this.multiRange ? [this.minSelected, this.maxSelected] : this.minSelected);
            }
            this.isHandlerActive = false;
        });
        merge(fromEvent(this.document, 'mousemove').pipe(map((event) => event.clientX)), fromEvent(this.document, 'touchmove').pipe(map((event) => event.touches[0].clientX)))
            .pipe(filter(() => !this.disabled && this.isHandlerActive), map((clientX) => {
            let movedX = Math.round(((clientX - this.startClientX) / this.sliderWidth) * this.totalDiff);
            movedX = this.snapValueOnStep(movedX);
            return this.startPosition + movedX;
        }), takeUntil(this.componentDestroyed$))
            .subscribe((nextPosition) => {
            this.handlerSliding(nextPosition);
            this._changeDetector.detectChanges();
        });
    }
    ngAfterViewInit() {
        this.initializeSlider();
    }
    /**
     * called when the component is destroyed
     *
     * @ignore
     */
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /**
     * called when Angular (re)sets data-bound input properties.
     *
     * @ignore
     */
    ngOnChanges({ min, max, minLowLimit, minHighLimit, maxLowLimit, maxHighLimit, minSelected, maxSelected, barHeight, showStepIndicator }) {
        // whenever one the values has changed and is not blank, recalculate the model
        const check = (v) => v && !this.isNullOrEmpty(v.currentValue) && v.currentValue !== v.previousValue;
        const recalculateModel = check(min) ||
            check(max) ||
            check(minLowLimit) ||
            check(minHighLimit) ||
            check(maxLowLimit) ||
            check(maxHighLimit) ||
            check(minSelected) ||
            check(maxSelected);
        if (this.sliderInitiated && recalculateModel) {
            this.resetModel();
        }
        if (barHeight && barHeight.currentValue) {
            this.handleSize = this.setHandleHeight(barHeight.currentValue);
        }
        if (showStepIndicator) {
            this.initializeStepIndicator();
        }
    }
    /**
     * return a calculated handle height based on the bar height
     */
    setHandleHeight(barHeight) {
        let handleSize = barHeight * 2 + 6;
        if (handleSize < 16) {
            handleSize = 16;
        }
        return handleSize;
    }
    sizeChange(e) {
        if (e.width > 0) {
            this.initializeSlider();
        }
    }
    /**
     * Method to initailize entire Slider
     */
    initializeSlider() {
        // get the width of the slider bar (div.bar)
        this.sliderWidth = this._sliderBarEl.nativeElement.offsetWidth;
        this.resetModel();
        this.sliderInitiated = true;
    }
    /**
     * Method to initialize variables and model values
     */
    resetModel() {
        this.validateSliderValues();
        // Setting the model values
        this.sliderModel = [this.toSliderModelPosition(this.minSelected), this.toSliderModelPosition(this.maxSelected)];
        this.totalDiff = this.max - this.min;
        // Validation for slider step
        if (this.totalDiff % this.step !== 0) {
            const newStep = this.findNextValidStepValue(this.totalDiff, this.step);
            this.step = newStep;
        }
        this.initializeStepIndicator();
        this.setHandlerPosition();
        // run change detection because we have modified some local variables (sliderModel, minSelected, etc..)
        this._changeDetector.detectChanges();
    }
    /**
     * Method to do validation of init and selected range values
     */
    validateSliderValues() {
        // if invalid / no min-max are passed in just init with 0
        const isInvalidData = this.isNullOrEmpty(this.min) || this.isNullOrEmpty(this.max) || this.min > this.max;
        if (isInvalidData) {
            this.min = 0;
            this.max = 0;
            this.updateCurrentValue(0, 0, true);
        }
        else {
            // Validation for Selected range values
            let newMinSelected;
            let newMaxSelected;
            newMinSelected = this.isNullOrEmpty(this.minSelected) ? 0 : this.minSelected;
            newMaxSelected = this.isNullOrEmpty(this.maxSelected) ? 0 : this.maxSelected;
            if (newMinSelected < this.min || newMinSelected > this.max) {
                newMinSelected = this.min;
            }
            if (newMaxSelected < this.min || newMaxSelected > this.max) {
                newMaxSelected = this.max;
            }
            if (newMinSelected > newMaxSelected) {
                newMinSelected = this.min;
                newMaxSelected = this.max;
            }
            this.updateCurrentValue(newMinSelected, newMaxSelected, true);
        }
    }
    // Method to add step indicator to slider
    initializeStepIndicator() {
        if (this.showStepIndicator) {
            this.stepIndicatorPositions.length = 0;
            const numOfStepIndicators = this.totalDiff / this.step;
            if (this.sliderWidth / numOfStepIndicators >= 10) {
                const increment = this.sliderWidth / numOfStepIndicators;
                let leftPosition = increment;
                while (this.stepIndicatorPositions.length < numOfStepIndicators - 1) {
                    this.stepIndicatorPositions.push(+leftPosition.toFixed(2));
                    leftPosition += increment;
                }
            }
            else {
                console.warn(`As 'step' value is too small compared to min & max value difference and slider width,
          Step Indicator can't be displayed!. Provide slight large value for 'step'`);
            }
        }
        else {
            this.stepIndicatorPositions.length = 0;
        }
    }
    // Method to set current selected values
    updateCurrentValue(newMinSelected, newMaxSelected, privateChange = false) {
        // make sure the value has changed
        const hasChanged = this.minSelected !== newMinSelected || this.maxSelected !== newMaxSelected;
        if (!hasChanged) {
            return;
        }
        // update the selected values with the new values
        this.minSelected = newMinSelected;
        this.maxSelected = newMaxSelected;
        // Emit change event only it was triggered by a user slide
        if (!privateChange) {
            this.change.emit(this.multiRange ? [this.minSelected, this.maxSelected] : this.minSelected);
        }
    }
    /**
     * Method to set handler position
     */
    setHandlerPosition() {
        // Updating selected values : current values
        const newMinSelected = this.min + this.sliderModel[SliderHandlerEnum.left];
        const newMaxSelected = this.min + this.sliderModel[SliderHandlerEnum.right];
        this.updateCurrentValue(newMinSelected, newMaxSelected);
    }
    /**
     * Method to set model array values
     */
    setModelValue(sliderHandler, value) {
        this.sliderModel[sliderHandler] = value;
    }
    /**
     * Method to detect start draging handler
     * Execute on events: mousedown
     */
    setHandlerActive(event, handler) {
        if (event.cancelable) {
            event.preventDefault();
        }
        if (!this.disabled) {
            this.startClientX = event instanceof TouchEvent ? event.touches[0].clientX : event.clientX;
            this.currentHandler = handler;
            this.startPosition = this.sliderModel[handler];
            this.isHandlerActive = true;
        }
    }
    /**
     * Method to calculate a snap effect value based on the step
     */
    snapValueOnStep(value) {
        if (this.step > 1) {
            value = Math.round(value / this.step) * this.step;
        }
        return value;
    }
    /**
     * Method to calculate slider handler movement
     * Execute on events: mousemove
     */
    handlerSliding(nextPosition) {
        // calculate the min and max positions of the handle based on the min/max values and min/max limit constraints
        let positionMinLimit;
        let positionMaxLimit;
        if (this.currentHandler === SliderHandlerEnum.left) {
            positionMinLimit = Math.max(...[this.toSliderModelPosition(this.minLowLimit), this.toSliderModelPosition(this.min)].filter((v) => v != null));
            positionMaxLimit = Math.min(...[this.toSliderModelPosition(this.minHighLimit), this.toSliderModelPosition(this.max), this.sliderModel[SliderHandlerEnum.right]].filter((v) => v != null));
        }
        else if (this.currentHandler === SliderHandlerEnum.right) {
            positionMinLimit = Math.max(...[this.toSliderModelPosition(this.maxLowLimit), this.toSliderModelPosition(this.min), this.sliderModel[SliderHandlerEnum.left]].filter((v) => v != null));
            positionMaxLimit = Math.min(...[this.toSliderModelPosition(this.maxHighLimit), this.toSliderModelPosition(this.max)].filter((v) => v != null));
        }
        // if we have passed the position, make sure to set the position to the limit, sometimes by mousemoving too fast
        // it will skip the actual last valid position so we need to readjust
        if (nextPosition < positionMinLimit) {
            nextPosition = positionMinLimit;
        }
        else if (nextPosition > positionMaxLimit) {
            nextPosition = positionMaxLimit;
        }
        this.setModelValue(this.currentHandler, nextPosition);
        this.setHandlerPosition();
    }
    /** converts the actual position to the slider model position **/
    toSliderModelPosition(position) {
        if (position == null) {
            return position;
        }
        return position - this.min;
    }
    /** converts a slider model value to a percentage used to position the handle correctly **/
    toPercentPosition(position) {
        return (position / this.totalDiff) * 100;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SliderComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SliderComponent, selector: "avn-slider", inputs: { min: "min", max: "max", minLowLimit: "minLowLimit", minHighLimit: "minHighLimit", maxLowLimit: "maxLowLimit", maxHighLimit: "maxHighLimit", minSelected: "minSelected", maxSelected: "maxSelected", step: "step", showStepIndicator: "showStepIndicator", multiRange: "multiRange", showTooltip: "showTooltip", selectedValueDisplayMode: "selectedValueDisplayMode", hideValues: "hideValues", disabled: "disabled", barHeight: "barHeight", barSelectedColor: "barSelectedColor", barUnselectedColor: "barUnselectedColor", valuesTemplate: "valuesTemplate", tooltipsTemplate: "tooltipsTemplate" }, outputs: { change: "change", released: "released" }, viewQueries: [{ propertyName: "_sliderBarEl", first: true, predicate: ["sliderBar"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"slider\" [class.disabled]=\"disabled\">\n  <div\n    (avnResize)=\"sizeChange($event)\"\n    #sliderBar\n    class=\"bar\"\n    [ngStyle]=\"{\n      'background-color': barUnselectedColor ? barUnselectedColor : null,\n      height: barHeight + 'px'\n    }\"\n  >\n    <span\n      class=\"left-handle\"\n      [ngClass]=\"{\n        active: isHandlerActive && currentHandler === SliderHandler.left,\n        'last-active': currentHandler === SliderHandler.left\n      }\"\n      [ngStyle]=\"{\n        transform: 'translate(0, calc(-50% + ' + barHeight / 2 + 'px))',\n        left: toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n        'margin-left': -handleSize / 2 + 'px',\n        width: handleSize + 'px',\n        height: handleSize + 'px'\n      }\"\n      (mousedown)=\"setHandlerActive($event, SliderHandler.left)\"\n      (touchstart)=\"setHandlerActive($event, SliderHandler.left)\"\n    >\n      <span\n        *ngIf=\"isSelectedValueDisplayed || isSelectedValueAlwaysDisplayed\"\n        class=\"selected-value\"\n        [ngStyle]=\"{\n          transform: 'translate(calc(-100% + ' + handleSize / 2 + 'px), ' + (-handleSize - 8) + 'px)'\n        }\"\n        [ngClass]=\"{\n          'avn-tooltip': showTooltip,\n          'tooltip-min': showTooltip,\n          'always-show': isSelectedValueAlwaysDisplayed\n        }\"\n      >\n        <ng-container [ngTemplateOutlet]=\"tooltipsTemplate ? tooltipsTemplate : defaultTooltipsTemplate\" [ngTemplateOutletContext]=\"{ value: minSelected }\">\n        </ng-container>\n      </span>\n    </span>\n    <div class=\"filler\">\n      <div class=\"step-indicators\">\n        <span *ngFor=\"let stepPos of stepIndicatorPositions\" [ngStyle]=\"{ left: stepPos + 'px', height: barHeight + 'px' }\"></span>\n      </div>\n      <span\n        *ngIf=\"multiRange\"\n        [ngStyle]=\"{\n          left: toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n          width: toPercentPosition(sliderModel[SliderHandler.right]) - toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n          'background-color': barSelectedColor ? barSelectedColor : null\n        }\"\n      ></span>\n      <span\n        *ngIf=\"!multiRange\"\n        [ngStyle]=\"{\n          left: '0',\n          width: toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n          'background-color': barSelectedColor ? barSelectedColor : null\n        }\"\n      ></span>\n    </div>\n    <span\n      *ngIf=\"multiRange\"\n      class=\"right-handle\"\n      [ngClass]=\"{\n        active: isHandlerActive && currentHandler === SliderHandler.right,\n        'last-active': currentHandler === SliderHandler.right\n      }\"\n      [ngStyle]=\"{\n        transform: 'translate(0, calc(-50% + ' + barHeight / 2 + 'px))',\n        left: toPercentPosition(sliderModel[SliderHandler.right]) + '%',\n        'margin-left': -handleSize / 2 + 'px',\n        width: handleSize + 'px',\n        height: handleSize + 'px'\n      }\"\n      (mousedown)=\"setHandlerActive($event, SliderHandler.right)\"\n      (touchstart)=\"setHandlerActive($event, SliderHandler.right)\"\n    >\n      <span\n        *ngIf=\"isSelectedValueDisplayed || isSelectedValueAlwaysDisplayed\"\n        class=\"selected-value\"\n        [ngStyle]=\"{\n          transform: 'translate(' + handleSize / 2 + 'px, ' + (-handleSize - 8) + 'px)'\n        }\"\n        [ngClass]=\"{\n          'avn-tooltip': showTooltip,\n          'tooltip-max': showTooltip,\n          'always-show': isSelectedValueAlwaysDisplayed\n        }\"\n      >\n        <ng-container [ngTemplateOutlet]=\"tooltipsTemplate ? tooltipsTemplate : defaultTooltipsTemplate\" [ngTemplateOutletContext]=\"{ value: maxSelected }\">\n        </ng-container>\n      </span>\n    </span>\n  </div>\n  <div class=\"values\" *ngIf=\"!hideValues\">\n    <span>\n      <ng-container [ngTemplateOutlet]=\"valuesTemplate ? valuesTemplate : defaultValuesTemplate\" [ngTemplateOutletContext]=\"{ value: min }\"> </ng-container>\n    </span>\n    <span>\n      <ng-container [ngTemplateOutlet]=\"valuesTemplate ? valuesTemplate : defaultValuesTemplate\" [ngTemplateOutletContext]=\"{ value: max }\"> </ng-container>\n    </span>\n  </div>\n  <ng-template #defaultValuesTemplate let-value=\"value\">{{ value }}</ng-template>\n  <ng-template #defaultTooltipsTemplate let-value=\"value\">{{ value }}</ng-template>\n</div>\n", styles: [":host.theme-primary>.slider .bar>span.left-handle,:host.theme-primary>.slider .bar>span.right-handle{background-color:var(--primary-base)}:host.theme-primary>.slider .bar div.filler>span{background-color:var(--primary-base)}:host.theme-secondary>.slider .bar>span.left-handle,:host.theme-secondary>.slider .bar>span.right-handle{background-color:var(--secondary-base)}:host.theme-secondary>.slider .bar div.filler>span{background-color:var(--secondary-base)}:host.theme-highlight>.slider .bar>span.left-handle,:host.theme-highlight>.slider .bar>span.right-handle{background-color:var(--highlight-base)}:host.theme-highlight>.slider .bar div.filler>span{background-color:var(--highlight-base)}:host.theme-danger>.slider .bar>span.left-handle,:host.theme-danger>.slider .bar>span.right-handle{background-color:var(--danger-base)}:host.theme-danger>.slider .bar div.filler>span{background-color:var(--danger-base)}:host.theme-warning>.slider .bar>span.left-handle,:host.theme-warning>.slider .bar>span.right-handle{background-color:var(--warning-base)}:host.theme-warning>.slider .bar div.filler>span{background-color:var(--warning-base)}:host.theme-info>.slider .bar>span.left-handle,:host.theme-info>.slider .bar>span.right-handle{background-color:var(--info-base)}:host.theme-info>.slider .bar div.filler>span{background-color:var(--info-base)}:host.theme-success>.slider .bar>span.left-handle,:host.theme-success>.slider .bar>span.right-handle{background-color:var(--success-base)}:host.theme-success>.slider .bar div.filler>span{background-color:var(--success-base)}:host .slider,:host .slider *{box-sizing:border-box}:host .slider{display:block;width:100%;padding:var(--space-md) 0;cursor:default;font-size:var(--text-sm)}:host .slider .bar{width:100%;position:relative;border-radius:5px;background-color:var(--slider-bar)}:host .slider .bar>span.left-handle,:host .slider .bar>span.right-handle{background-color:var(--slider-handle);display:inline-block;box-shadow:0 0 8px -2px #00000091;border-radius:50%;position:absolute;top:0;z-index:1;cursor:pointer}:host .slider .bar>span.left-handle.last-active,:host .slider .bar>span.right-handle.last-active{z-index:2}:host .slider .bar>span.left-handle .selected-value,:host .slider .bar>span.right-handle .selected-value{display:block;position:absolute;bottom:-6px;left:0;white-space:nowrap;text-align:center;font-weight:500;transition:opacity .2s ease;opacity:0}:host .slider .bar>span.left-handle .selected-value.always-show,:host .slider .bar>span.right-handle .selected-value.always-show{opacity:1}:host .slider .bar>span.left-handle .avn-tooltip,:host .slider .bar>span.right-handle .avn-tooltip{background-color:var(--tooltip-background);color:var(--tooltip-on);border-radius:4px;padding:var(--space-xs) var(--space-sm);bottom:0;min-width:20px}:host .slider .bar>span.left-handle .avn-tooltip:after,:host .slider .bar>span.right-handle .avn-tooltip:after{content:\"\";position:absolute;top:100%;left:calc(50% - 5px);border-top-color:var(--tooltip-background)}:host .slider .bar>span.left-handle .tooltip-min,:host .slider .bar>span.right-handle .tooltip-min{border-radius:2px 2px 0}:host .slider .bar>span.left-handle .tooltip-min:after,:host .slider .bar>span.right-handle .tooltip-min:after{left:calc(100% - 5px);border-top:5px solid var(--tooltip-background);border-left:5px solid transparent}:host .slider .bar>span.left-handle .tooltip-max,:host .slider .bar>span.right-handle .tooltip-max{border-radius:2px 2px 2px 0}:host .slider .bar>span.left-handle .tooltip-max:after,:host .slider .bar>span.right-handle .tooltip-max:after{left:calc(0% + -0px);border-top:5px solid var(--tooltip-background);border-right:5px solid transparent}:host .slider .bar>span.left-handle:hover>.selected-value,:host .slider .bar>span.left-handle.active>.selected-value,:host .slider .bar>span.right-handle:hover>.selected-value,:host .slider .bar>span.right-handle.active>.selected-value{opacity:1}:host .slider .bar>span.left-handle:hover,:host .slider .bar>span.right-handle:hover{box-shadow:0 0 8px -2px #000!important}:host .slider .bar div.filler{display:block;width:100%;height:100%;position:relative;overflow:hidden;border-radius:5px}:host .slider .bar div.filler>span{background-color:var(--slider-bar-selected);display:inline-block;height:100%;position:absolute;top:0}:host .slider .bar div.filler>div.step-indicators{width:100%;height:100%;position:relative}:host .slider .bar div.filler>div.step-indicators>span{background-color:var(--slider-bar);width:1px;display:inline-block;opacity:.5;position:absolute;left:0}:host .slider .values{color:inherit;display:block;font-weight:500;margin-top:var(--space-sm)}:host .slider .values span:first-child{float:left;transform:translate(-50%)}:host .slider .values span:last-child{float:right;transform:translate(50%)}:host .slider.disabled{opacity:.4}:host .slider.disabled .bar>span.left-handle,:host .slider.disabled .bar>span.right-handle{cursor:not-allowed}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-slider', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"slider\" [class.disabled]=\"disabled\">\n  <div\n    (avnResize)=\"sizeChange($event)\"\n    #sliderBar\n    class=\"bar\"\n    [ngStyle]=\"{\n      'background-color': barUnselectedColor ? barUnselectedColor : null,\n      height: barHeight + 'px'\n    }\"\n  >\n    <span\n      class=\"left-handle\"\n      [ngClass]=\"{\n        active: isHandlerActive && currentHandler === SliderHandler.left,\n        'last-active': currentHandler === SliderHandler.left\n      }\"\n      [ngStyle]=\"{\n        transform: 'translate(0, calc(-50% + ' + barHeight / 2 + 'px))',\n        left: toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n        'margin-left': -handleSize / 2 + 'px',\n        width: handleSize + 'px',\n        height: handleSize + 'px'\n      }\"\n      (mousedown)=\"setHandlerActive($event, SliderHandler.left)\"\n      (touchstart)=\"setHandlerActive($event, SliderHandler.left)\"\n    >\n      <span\n        *ngIf=\"isSelectedValueDisplayed || isSelectedValueAlwaysDisplayed\"\n        class=\"selected-value\"\n        [ngStyle]=\"{\n          transform: 'translate(calc(-100% + ' + handleSize / 2 + 'px), ' + (-handleSize - 8) + 'px)'\n        }\"\n        [ngClass]=\"{\n          'avn-tooltip': showTooltip,\n          'tooltip-min': showTooltip,\n          'always-show': isSelectedValueAlwaysDisplayed\n        }\"\n      >\n        <ng-container [ngTemplateOutlet]=\"tooltipsTemplate ? tooltipsTemplate : defaultTooltipsTemplate\" [ngTemplateOutletContext]=\"{ value: minSelected }\">\n        </ng-container>\n      </span>\n    </span>\n    <div class=\"filler\">\n      <div class=\"step-indicators\">\n        <span *ngFor=\"let stepPos of stepIndicatorPositions\" [ngStyle]=\"{ left: stepPos + 'px', height: barHeight + 'px' }\"></span>\n      </div>\n      <span\n        *ngIf=\"multiRange\"\n        [ngStyle]=\"{\n          left: toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n          width: toPercentPosition(sliderModel[SliderHandler.right]) - toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n          'background-color': barSelectedColor ? barSelectedColor : null\n        }\"\n      ></span>\n      <span\n        *ngIf=\"!multiRange\"\n        [ngStyle]=\"{\n          left: '0',\n          width: toPercentPosition(sliderModel[SliderHandler.left]) + '%',\n          'background-color': barSelectedColor ? barSelectedColor : null\n        }\"\n      ></span>\n    </div>\n    <span\n      *ngIf=\"multiRange\"\n      class=\"right-handle\"\n      [ngClass]=\"{\n        active: isHandlerActive && currentHandler === SliderHandler.right,\n        'last-active': currentHandler === SliderHandler.right\n      }\"\n      [ngStyle]=\"{\n        transform: 'translate(0, calc(-50% + ' + barHeight / 2 + 'px))',\n        left: toPercentPosition(sliderModel[SliderHandler.right]) + '%',\n        'margin-left': -handleSize / 2 + 'px',\n        width: handleSize + 'px',\n        height: handleSize + 'px'\n      }\"\n      (mousedown)=\"setHandlerActive($event, SliderHandler.right)\"\n      (touchstart)=\"setHandlerActive($event, SliderHandler.right)\"\n    >\n      <span\n        *ngIf=\"isSelectedValueDisplayed || isSelectedValueAlwaysDisplayed\"\n        class=\"selected-value\"\n        [ngStyle]=\"{\n          transform: 'translate(' + handleSize / 2 + 'px, ' + (-handleSize - 8) + 'px)'\n        }\"\n        [ngClass]=\"{\n          'avn-tooltip': showTooltip,\n          'tooltip-max': showTooltip,\n          'always-show': isSelectedValueAlwaysDisplayed\n        }\"\n      >\n        <ng-container [ngTemplateOutlet]=\"tooltipsTemplate ? tooltipsTemplate : defaultTooltipsTemplate\" [ngTemplateOutletContext]=\"{ value: maxSelected }\">\n        </ng-container>\n      </span>\n    </span>\n  </div>\n  <div class=\"values\" *ngIf=\"!hideValues\">\n    <span>\n      <ng-container [ngTemplateOutlet]=\"valuesTemplate ? valuesTemplate : defaultValuesTemplate\" [ngTemplateOutletContext]=\"{ value: min }\"> </ng-container>\n    </span>\n    <span>\n      <ng-container [ngTemplateOutlet]=\"valuesTemplate ? valuesTemplate : defaultValuesTemplate\" [ngTemplateOutletContext]=\"{ value: max }\"> </ng-container>\n    </span>\n  </div>\n  <ng-template #defaultValuesTemplate let-value=\"value\">{{ value }}</ng-template>\n  <ng-template #defaultTooltipsTemplate let-value=\"value\">{{ value }}</ng-template>\n</div>\n", styles: [":host.theme-primary>.slider .bar>span.left-handle,:host.theme-primary>.slider .bar>span.right-handle{background-color:var(--primary-base)}:host.theme-primary>.slider .bar div.filler>span{background-color:var(--primary-base)}:host.theme-secondary>.slider .bar>span.left-handle,:host.theme-secondary>.slider .bar>span.right-handle{background-color:var(--secondary-base)}:host.theme-secondary>.slider .bar div.filler>span{background-color:var(--secondary-base)}:host.theme-highlight>.slider .bar>span.left-handle,:host.theme-highlight>.slider .bar>span.right-handle{background-color:var(--highlight-base)}:host.theme-highlight>.slider .bar div.filler>span{background-color:var(--highlight-base)}:host.theme-danger>.slider .bar>span.left-handle,:host.theme-danger>.slider .bar>span.right-handle{background-color:var(--danger-base)}:host.theme-danger>.slider .bar div.filler>span{background-color:var(--danger-base)}:host.theme-warning>.slider .bar>span.left-handle,:host.theme-warning>.slider .bar>span.right-handle{background-color:var(--warning-base)}:host.theme-warning>.slider .bar div.filler>span{background-color:var(--warning-base)}:host.theme-info>.slider .bar>span.left-handle,:host.theme-info>.slider .bar>span.right-handle{background-color:var(--info-base)}:host.theme-info>.slider .bar div.filler>span{background-color:var(--info-base)}:host.theme-success>.slider .bar>span.left-handle,:host.theme-success>.slider .bar>span.right-handle{background-color:var(--success-base)}:host.theme-success>.slider .bar div.filler>span{background-color:var(--success-base)}:host .slider,:host .slider *{box-sizing:border-box}:host .slider{display:block;width:100%;padding:var(--space-md) 0;cursor:default;font-size:var(--text-sm)}:host .slider .bar{width:100%;position:relative;border-radius:5px;background-color:var(--slider-bar)}:host .slider .bar>span.left-handle,:host .slider .bar>span.right-handle{background-color:var(--slider-handle);display:inline-block;box-shadow:0 0 8px -2px #00000091;border-radius:50%;position:absolute;top:0;z-index:1;cursor:pointer}:host .slider .bar>span.left-handle.last-active,:host .slider .bar>span.right-handle.last-active{z-index:2}:host .slider .bar>span.left-handle .selected-value,:host .slider .bar>span.right-handle .selected-value{display:block;position:absolute;bottom:-6px;left:0;white-space:nowrap;text-align:center;font-weight:500;transition:opacity .2s ease;opacity:0}:host .slider .bar>span.left-handle .selected-value.always-show,:host .slider .bar>span.right-handle .selected-value.always-show{opacity:1}:host .slider .bar>span.left-handle .avn-tooltip,:host .slider .bar>span.right-handle .avn-tooltip{background-color:var(--tooltip-background);color:var(--tooltip-on);border-radius:4px;padding:var(--space-xs) var(--space-sm);bottom:0;min-width:20px}:host .slider .bar>span.left-handle .avn-tooltip:after,:host .slider .bar>span.right-handle .avn-tooltip:after{content:\"\";position:absolute;top:100%;left:calc(50% - 5px);border-top-color:var(--tooltip-background)}:host .slider .bar>span.left-handle .tooltip-min,:host .slider .bar>span.right-handle .tooltip-min{border-radius:2px 2px 0}:host .slider .bar>span.left-handle .tooltip-min:after,:host .slider .bar>span.right-handle .tooltip-min:after{left:calc(100% - 5px);border-top:5px solid var(--tooltip-background);border-left:5px solid transparent}:host .slider .bar>span.left-handle .tooltip-max,:host .slider .bar>span.right-handle .tooltip-max{border-radius:2px 2px 2px 0}:host .slider .bar>span.left-handle .tooltip-max:after,:host .slider .bar>span.right-handle .tooltip-max:after{left:calc(0% + -0px);border-top:5px solid var(--tooltip-background);border-right:5px solid transparent}:host .slider .bar>span.left-handle:hover>.selected-value,:host .slider .bar>span.left-handle.active>.selected-value,:host .slider .bar>span.right-handle:hover>.selected-value,:host .slider .bar>span.right-handle.active>.selected-value{opacity:1}:host .slider .bar>span.left-handle:hover,:host .slider .bar>span.right-handle:hover{box-shadow:0 0 8px -2px #000!important}:host .slider .bar div.filler{display:block;width:100%;height:100%;position:relative;overflow:hidden;border-radius:5px}:host .slider .bar div.filler>span{background-color:var(--slider-bar-selected);display:inline-block;height:100%;position:absolute;top:0}:host .slider .bar div.filler>div.step-indicators{width:100%;height:100%;position:relative}:host .slider .bar div.filler>div.step-indicators>span{background-color:var(--slider-bar);width:1px;display:inline-block;opacity:.5;position:absolute;left:0}:host .slider .values{color:inherit;display:block;font-weight:500;margin-top:var(--space-sm)}:host .slider .values span:first-child{float:left;transform:translate(-50%)}:host .slider .values span:last-child{float:right;transform:translate(50%)}:host .slider.disabled{opacity:.4}:host .slider.disabled .bar>span.left-handle,:host .slider.disabled .bar>span.right-handle{cursor:not-allowed}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { _sliderBarEl: [{
                type: ViewChild,
                args: ['sliderBar', { static: true }]
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], minLowLimit: [{
                type: Input
            }], minHighLimit: [{
                type: Input
            }], maxLowLimit: [{
                type: Input
            }], maxHighLimit: [{
                type: Input
            }], minSelected: [{
                type: Input
            }], maxSelected: [{
                type: Input
            }], step: [{
                type: Input
            }], showStepIndicator: [{
                type: Input
            }], multiRange: [{
                type: Input
            }], showTooltip: [{
                type: Input
            }], selectedValueDisplayMode: [{
                type: Input
            }], hideValues: [{
                type: Input
            }], disabled: [{
                type: Input
            }], barHeight: [{
                type: Input
            }], barSelectedColor: [{
                type: Input
            }], barUnselectedColor: [{
                type: Input
            }], valuesTemplate: [{
                type: Input
            }], tooltipsTemplate: [{
                type: Input
            }], change: [{
                type: Output
            }], released: [{
                type: Output
            }] } });

class SliderModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SliderModule, declarations: [SliderComponent], imports: [CommonModule, CoreModule], exports: [SliderComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SliderModule, imports: [CommonModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SliderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SliderComponent],
                    exports: [SliderComponent],
                    imports: [CommonModule, CoreModule],
                }]
        }] });

class CarouselItemDirective {
    constructor(template) {
        this.template = template;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CarouselItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: CarouselItemDirective, selector: "[avnCarouselItem]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CarouselItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnCarouselItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

var CarouselType;
(function (CarouselType) {
    CarouselType["FIXED"] = "fixed";
    CarouselType["RESPONSIVE"] = "responsive";
})(CarouselType || (CarouselType = {}));

/**
 * avn-carousel used a structural directive avnCarouselItem to inject the template
 * to each item of a for-loop.
 *
 * Example to use avn-carousel
 *
 <avn-carousel
  [itemPerSlideConfig]="itemPerSlideConfig"
  [pointVisible]="pointVisible"
  [buttonVisible]="buttonVisible"
  [autoLoop]="autoSlide"
  [withAnimation]="withAnimation"
  (slided)="onSlided($event)"
>
  <ng-container *ngFor="let item of carouselTileItems$ | async; let i = index">
    <ng-container *avnCarouselItem>
      <avn-card class="card" [title]="i" [icon]="'social:person'">
        <avn-card-content>
          <div class="tile" [style.background]="'url(' + item + ')'"></div>
        </avn-card-content>
      </avn-card>
    </ng-container>
  </ng-container>
</avn-carousel>
 */
class CarouselComponent {
    constructor(el, renderer, _mediaBreakpointStore, document, cdr) {
        this.el = el;
        this.renderer = renderer;
        this._mediaBreakpointStore = _mediaBreakpointStore;
        this.document = document;
        this.cdr = cdr;
        /**
         * the config for item per slide, for each according device size: [handset, tablet, web, all].
         *
         * If all is set with value, will be treated as each carousel item's fix width in px,
         *  and the carousel will not be reponsive, but with fixed width.
         */
        this.itemPerSlideConfig = {
            handset: 1,
            tablet: 1,
            web: 1,
            huge: 1,
            yuge: 1,
            gigantic: 1,
        };
        /** carousel animation speed */
        this.speed = 300;
        /** the minimal space between two items */
        this.minSpace = 30;
        /** auto loop time interval, the time between each auto loop */
        this.autoLoopInterval = 3500;
        /** show or hide the points indicator */
        this.pointVisible = true;
        /** show or hide the button indicator when needed: pages > 1 */
        this.buttonVisible = true;
        /** wheather the carousel will auto loop */
        this.autoLoop = false;
        /** wheather apply animation or not */
        this.withAnimation = true;
        /** Keyboard navigation */
        this.keyboardNavigationEnabled = true;
        /** the easing animation */
        this.easing = 'cubic-bezier(0, 0, 0.2, 1)';
        /**keep the current viewing item position, when data source change
         * it will slide to first item, when set to false and datasource changes
         */
        this.keepPositionOnSourceChange = true;
        /** output event when carousel slide a view */
        this.slided = new EventEmitter();
        /** indicate how many pages of slides */
        this.pages = [];
        this.type = CarouselType.FIXED;
        /** the unique id of the carousel */
        this.token = '';
        /** items in one slide */
        this.slideItems = 0;
        /** carousel width, used to calculate each item's width */
        this.carouselWidth = undefined;
        /** resize event width*/
        this.resizeEventWidth = undefined;
        /** item margin: will be calculated */
        this.itemMargin = 0;
        /** item padding: will be calculated */
        this.itemPadding = 0;
        /** default button width */
        this.buttonＷidth = 35;
        /** the current beginning index of several items that is been displayed in carousel */
        this.currentItemIndex = 0;
        /** if it's the first carousel item, used to check if we need disable left arrow */
        this.isFirst = true;
        /** if it's the last carousel item, used to check if we need disable right arrow */
        this.isLast = false;
        /** @ignore Pattern used to close all subscriptions */
        this.componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.itemsContainerResized$ = this.resizeDirective.avnResize.pipe(debounce(() => timer(100)), filter((event) => event.width !== 0), withLatestFrom(this._mediaBreakpointStore.breakpoint$), map(([deviceResizeEvent, deviceType]) => ({
            deviceType,
            width: deviceResizeEvent.width,
        })), takeUntil(this.componentDestroyed$));
        this.deviceInfo$ = this._mediaBreakpointStore.windowSizeChanged$.pipe(map(({ breakpoint, viewportWidthPx }) => ({
            deviceType: breakpoint,
            width: this.resizeEventWidth !== undefined ? this.resizeEventWidth : viewportWidthPx,
        })), takeUntil(this.componentDestroyed$));
        // left right key clicked on carousel
        this.keyDown$ = fromEvent(this.carouselBody.nativeElement, 'keydown').pipe(filter(() => !!this.keyboardNavigationEnabled), filter((event) => [LEFT_ARROW, RIGHT_ARROW].includes(event.keyCode)));
    }
    ngAfterViewInit() {
        this.carouselItemCssNode = this.createStyleElem();
        this.carouselCssNode = this.createStyleElem();
        this.token = 'carousel' + v4();
        this.renderer.addClass(this.el.nativeElement, this.token);
        const container = this.carouselMain.nativeElement;
        this.play$ = fromEvent(container, 'mouseleave').pipe(mapTo(1));
        this.pause$ = fromEvent(container, 'mouseenter').pipe(mapTo(0));
        this.interval$ = interval(this.autoLoopInterval).pipe(mapTo(1));
        merge(this.itemsContainerResized$, this.deviceInfo$)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((evt) => {
            this.deviceType = evt.deviceType;
            this.adjustCarouselWidth(evt.width);
            this.adjustCarouselItemStyle();
            this.initCarouselPoint();
        });
        this.setupAutoSlide();
        this.keyDown$.pipe(takeUntil(this.componentDestroyed$)).subscribe((event) => {
            event.preventDefault();
            event.stopPropagation();
            if (event.keyCode === LEFT_ARROW) {
                this.navigateCarousel('backward');
            }
            else {
                this.navigateCarousel('forward');
            }
        });
    }
    ngAfterContentInit() {
        this.carouselItems.changes.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
            this.adjustCarouselWidth(this.resizeEventWidth);
            this.adjustCarouselItemStyle();
            this.initCarouselPoint(this.keepPositionOnSourceChange);
        });
    }
    ngOnChanges({ itemPerSlideConfig, autoLoop, buttonVisible, minSpace, viewingItemIndex }) {
        if (autoLoop) {
            this.setupAutoSlide();
        }
        if (viewingItemIndex) {
            try {
                this.currentItemIndex = Number(viewingItemIndex.currentValue);
            }
            catch {
                throw new Error(`the viewing index passed ${viewingItemIndex} is not valid, it must be an number!`);
            }
            if (!viewingItemIndex.firstChange) {
                this.initCarouselPoint();
            }
        }
        if (itemPerSlideConfig) {
            this.type = this.itemPerSlideConfig.all ? CarouselType.FIXED : CarouselType.RESPONSIVE;
        }
        if (itemPerSlideConfig && this.carouselItemCssNode) {
            this.adjustCarouselWidth(this.resizeEventWidth);
            this.adjustCarouselItemStyle();
            this.initCarouselPoint();
        }
        if ((buttonVisible || minSpace) && this.carouselCssNode) {
            this.adjustCarouselWidth(this.resizeEventWidth);
            this.adjustCarouselItemStyle();
            this.initCarouselPoint();
        }
    }
    adjustCarouselWidth(width) {
        this.resizeEventWidth = width;
        let _slideItems = 0;
        if (this.type === CarouselType.RESPONSIVE) {
            _slideItems = this.itemPerSlideConfig[this.deviceType];
        }
        else {
            _slideItems = Math.trunc(width / (this.itemPerSlideConfig.all + this.minSpace));
        }
        this.carouselWidth = Math.ceil(this.carouselItems.length / _slideItems) > 1 && this.buttonVisible ? width - this.buttonＷidth - this.buttonＷidth : width;
    }
    /** set the style of the carousel based the inputs data */
    adjustCarouselItemStyle() {
        if (this.type === CarouselType.RESPONSIVE) {
            this.slideItems = this.itemPerSlideConfig[this.deviceType];
        }
        else {
            if (Math.trunc(this.carouselWidth / (this.itemPerSlideConfig.all + this.minSpace)) === 0) {
                console.warn(`Carousl config error! you have set carousel item width to a fix number, through itemPerSlideConfig.all,
          current space available for items: ${this.carouselWidth}px, is smaller than the configed width: ${this.itemPerSlideConfig.all} plus min space: ${this.minSpace}`);
            }
            else {
                this.slideItems = Math.trunc(this.carouselWidth / (this.itemPerSlideConfig.all + this.minSpace));
            }
        }
        this.styleid = `.${this.token} > div > .carousel > div > .carousel-items`;
        let itemStyle = '';
        if (this.type === CarouselType.RESPONSIVE) {
            const animation = `${this.styleid} > .item {flex: 0 0 ${this.carouselWidth / this.itemPerSlideConfig[this.deviceType]}px; max-width: ${this.carouselWidth / this.itemPerSlideConfig[this.deviceType]}px; transition: transform 0.6s ease;}`;
            itemStyle = `@media (max-width:${LayoutDeviceBreakpoint.HANDSET - 1}px){${animation}}
                   @media (min-width:${LayoutDeviceBreakpoint.HANDSET}px) and (max-width: ${LayoutDeviceBreakpoint.TABLET - 1}px){${animation}}
                   @media (min-width:${LayoutDeviceBreakpoint.TABLET}px) and (max-width: ${LayoutDeviceBreakpoint.WEB - 1}px){${animation}}
                   @media (min-width:${LayoutDeviceBreakpoint.WEB}px) and (max-width: ${LayoutDeviceBreakpoint.HUGE - 1}px){${animation}}
                   @media (min-width:${LayoutDeviceBreakpoint.HUGE}px) and (max-width: ${LayoutDeviceBreakpoint.YUGE - 1}px){${animation}}
                   @media (min-width:${LayoutDeviceBreakpoint.YUGE}px){${animation}}`;
        }
        else {
            itemStyle = `${this.styleid} .item {flex: 0 0 ${this.itemPerSlideConfig.all}px; width: ${this.itemPerSlideConfig.all}px; max-width: ${this.itemPerSlideConfig.all}px;}`;
        }
        this.carouselItemCssNode.innerHTML = itemStyle;
        this.itemMargin = this.getMargin();
        this.itemPadding = this.getPadding();
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        // unsubscribe all subscriptions
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
        if (this.carouselIntervalSubscription) {
            this.carouselIntervalSubscription.unsubscribe();
        }
        this.slided.complete();
    }
    /** Init carousel point */
    initCarouselPoint(keepPosition = true) {
        this.pointCount = Math.ceil(this.carouselItems.length / this.slideItems);
        const pointers = [];
        if (this.pointCount > 1) {
            for (let i = 0; i < this.pointCount; i++) {
                pointers.push(i);
            }
        }
        this.pages = pointers;
        if (!keepPosition) {
            this.currentItemIndex = this.viewingItemIndex ? this.viewingItemIndex : 0;
            this.activePoint = 0;
        }
        if (this.pointCount <= 1) {
            this.updateButtonStatus(1, 1);
        }
        else {
            if (this.currentItemIndex <= 0 && !this.autoLoop) {
                this.updateButtonStatus(1, 0);
            }
            else if (this.currentItemIndex + this.slideItems >= this.carouselItems.length && !this.autoLoop) {
                this.updateButtonStatus(0, 1);
            }
            else {
                this.updateButtonStatus(0, 0);
            }
        }
        if (this.currentItemIndex + this.slideItems > this.carouselItems.length) {
            this.goToSlideAndUpdateActivePoint(this.carouselItems.length - this.slideItems, this.speed, undefined, false);
        }
        else {
            this.goToSlideAndUpdateActivePoint(this.currentItemIndex, this.speed, undefined, false);
        }
        this.cdr.detectChanges();
    }
    getPadding() {
        return this.minSpace / 2;
    }
    getMargin() {
        const leftOver = this.carouselWidth % (this.itemPerSlideConfig.all + this.minSpace);
        const newSpace = this.minSpace + leftOver / this.slideItems;
        return newSpace / 2;
    }
    /** this function is used to scoll the carousel when point is clicked */
    moveTo(slide, withAnimation = this.withAnimation) {
        if (this.activePoint !== slide && slide < this.pointCount) {
            let slideremains;
            switch (slide) {
                case 0:
                    this.updateButtonStatus(1, 0);
                    slideremains = slide * this.slideItems;
                    break;
                case this.pointCount - 1:
                    this.updateButtonStatus(0, 1);
                    slideremains = this.carouselItems.length - this.slideItems;
                    break;
                default:
                    this.updateButtonStatus(0, 0);
                    slideremains = slide * this.slideItems;
            }
            this.goToSlideAndUpdateActivePoint(slideremains, this.speed, undefined, withAnimation);
        }
    }
    /** logic to scroll the carousel step 1 */
    navigateCarousel(direction) {
        let itemSpeed = this.speed;
        let currentItemIndex = 0;
        this.renderer.setStyle(this.itemsContainer.nativeElement, 'transform', '');
        if (this.pointCount === 1) {
            return;
        }
        else if (direction === 'backward' && ((!this.autoLoop && !this.isFirst) || this.autoLoop)) {
            const currentItemIndexD = this.currentItemIndex - this.slideItems;
            const MoveSlide = currentItemIndexD + this.slideItems;
            this.updateButtonStatus(0, 1);
            if (this.currentItemIndex === 0) {
                currentItemIndex = this.carouselItems.length - this.slideItems;
                itemSpeed = 400;
                this.updateButtonStatus(0, 1);
            }
            else if (this.slideItems >= MoveSlide) {
                currentItemIndex = 0;
                this.updateButtonStatus(1, 0);
            }
            else {
                this.updateButtonStatus(0, 0);
                currentItemIndex = this.currentItemIndex - this.slideItems;
            }
            this.goToSlideAndUpdateActivePoint(currentItemIndex, itemSpeed, direction);
        }
        else if (direction === 'forward' && ((!this.autoLoop && !this.isLast) || this.autoLoop)) {
            if (this.carouselItems.length <= this.currentItemIndex + this.slideItems + this.slideItems && !this.isLast) {
                currentItemIndex = this.carouselItems.length - this.slideItems;
                this.updateButtonStatus(0, 1);
            }
            else if (this.isLast) {
                currentItemIndex = 0;
                itemSpeed = 400;
                this.updateButtonStatus(1, 0);
            }
            else {
                this.updateButtonStatus(0, 0);
                currentItemIndex = this.currentItemIndex + this.slideItems;
            }
            this.goToSlideAndUpdateActivePoint(currentItemIndex, itemSpeed, direction);
        }
    }
    /** logic to scroll the carousel step 2 */
    goToSlideAndUpdateActivePoint(currentItemIndex, itemSpeed, direction, withAnimation = this.withAnimation) {
        if (withAnimation) {
            this.renderer.setStyle(this.itemsContainer.nativeElement, 'transition', `transform ${itemSpeed}ms ${this.easing}`);
        }
        else {
            this.renderer.setStyle(this.itemsContainer.nativeElement, 'transition', ``);
        }
        if (!direction) {
            direction = currentItemIndex < this.currentItemIndex ? 'backward' : currentItemIndex > this.currentItemIndex ? 'forward' : null;
        }
        this.transformStyle(currentItemIndex);
        this.currentItemIndex = currentItemIndex;
        this.slided.emit({
            direction,
            firstVisibleItemIndex: currentItemIndex,
        });
        this.activePoint = Math.ceil(this.currentItemIndex / this.slideItems);
        this.cdr.detectChanges();
    }
    /** boolean function for making isFirst and isLast */
    updateButtonStatus(first, last) {
        this.isFirst = !!first;
        this.isLast = !!last;
        this.cdr.detectChanges();
    }
    transformString(deviceType, slide) {
        return `${this.styleid} { transform: translate3d(-${(slide / this.itemPerSlideConfig[deviceType]) * 100}%, 0, 0); }`;
    }
    /** set the transform style to scroll the carousel  */
    transformStyle(slide) {
        let slideCss = '';
        if (this.type === CarouselType.RESPONSIVE) {
            slideCss = `
      @media (max-width: ${LayoutDeviceBreakpoint.HANDSET - 1}px) {${this.transformString('handset', slide)}}
      @media (min-width: ${LayoutDeviceBreakpoint.HANDSET}px) and (max-width: ${LayoutDeviceBreakpoint.TABLET - 1}px) {${this.transformString('tablet', slide)} }
      @media (min-width: ${LayoutDeviceBreakpoint.TABLET}px) and (max-width: ${LayoutDeviceBreakpoint.WEB - 1}px) {${this.transformString('web', slide)} }
      @media (min-width: ${LayoutDeviceBreakpoint.WEB}px) and (max-width: ${LayoutDeviceBreakpoint.HUGE - 1}px) {${this.transformString('huge', slide)} }
      @media (min-width: ${LayoutDeviceBreakpoint.HUGE}px) and (max-width: ${LayoutDeviceBreakpoint.YUGE - 1}px) {${this.transformString('yuge', slide)} }
      @media (min-width: ${LayoutDeviceBreakpoint.YUGE}px) {${this.transformString('gigantic', slide)} }
      `;
        }
        else {
            slideCss = `${this.styleid} { transform: translate3d(-${(slide / this.slideItems) * 100}%, 0, 0); }`;
        }
        this.carouselCssNode.innerHTML = slideCss;
    }
    /** handle the auto slide */
    setupAutoSlide() {
        if (this.autoLoopInterval && this.autoLoop) {
            this.carouselIntervalSubscription = merge(this.play$, this.pause$)
                .pipe(startWith(1), switchMap((val) => (val ? this.interval$ : EMPTY)))
                .subscribe((_) => {
                this.navigateCarousel('forward');
            });
        }
        else {
            if (this.carouselIntervalSubscription) {
                this.carouselIntervalSubscription.unsubscribe();
            }
        }
    }
    /** For generating style tag */
    createStyleElem() {
        const styleItem = this.renderer.createElement('style');
        this.renderer.appendChild(this.el.nativeElement, styleItem);
        return styleItem;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CarouselComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: MediaBreakpointStore }, { token: DOCUMENT }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CarouselComponent, selector: "avn-carousel", inputs: { itemPerSlideConfig: "itemPerSlideConfig", speed: "speed", minSpace: "minSpace", autoLoopInterval: "autoLoopInterval", pointVisible: "pointVisible", buttonVisible: "buttonVisible", autoLoop: "autoLoop", withAnimation: "withAnimation", keyboardNavigationEnabled: "keyboardNavigationEnabled", easing: "easing", keepPositionOnSourceChange: "keepPositionOnSourceChange", viewingItemIndex: "viewingItemIndex" }, outputs: { slided: "slided" }, queries: [{ propertyName: "carouselItems", predicate: CarouselItemDirective }], viewQueries: [{ propertyName: "carouselBody", first: true, predicate: ["carousel"], descendants: true, read: ElementRef, static: true }, { propertyName: "carouselMain", first: true, predicate: ["carouselMain"], descendants: true, read: ElementRef, static: true }, { propertyName: "resizeDirective", first: true, predicate: ResizeDirective, descendants: true, static: true }, { propertyName: "itemsContainer", first: true, predicate: ["itemsContainer"], descendants: true, read: ElementRef, static: true }], usesOnChanges: true, ngImport: i0, template: "<div #carousel avnResize cdkTrapFocus tabindex=\"0\">\n  <avn-icon\n    *ngIf=\"buttonVisible && pages.length > 0\"\n    [style.opacity]=\"isFirst ? 0.3 : 1\"\n    icon=\"hardware:keyboard_arrow_left\"\n    fontSize=\"35\"\n    (click)=\"navigateCarousel('backward')\"\n  ></avn-icon>\n\n  <div #carouselMain class=\"carousel\">\n    <div>\n      <div #itemsContainer class=\"carousel-items\" [ngClass]=\"{ 'center-items': pages.length === 0 }\">\n        <ng-container *ngFor=\"let item of carouselItems; let i = index\">\n          <div\n            class=\"item\"\n            [ngStyle]=\"{\n              'margin-left.px': type === 'fixed' ? itemMargin : 0,\n              'margin-right.px': type === 'fixed' ? itemMargin : 0,\n              'padding-left.px': type === 'responsive' ? itemPadding : 0,\n              'padding-right.px': type === 'responsive' ? itemPadding : 0\n            }\"\n          >\n            <ng-container [ngTemplateOutlet]=\"item.template\"></ng-container>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n\n  <avn-icon\n    *ngIf=\"buttonVisible && pages.length > 0\"\n    [style.opacity]=\"isLast ? 0.3 : 1\"\n    icon=\"hardware:keyboard_arrow_right\"\n    fontSize=\"35\"\n    (click)=\"navigateCarousel('forward')\"\n  ></avn-icon>\n</div>\n<ul class=\"carousel-point\" *ngIf=\"pointVisible && pages.length > 1\">\n  <li *ngFor=\"let page of pages; let i = index\" [class.active]=\"i === activePoint\" (click)=\"moveTo(i)\"></li>\n</ul>\n", styles: [":host>div{display:flex;position:relative}:host ::ng-deep avn-icon{align-items:center}:host .carousel{position:relative;overflow:hidden;height:100%;width:100%}:host .carousel .carousel-items{position:relative;display:flex;height:100%}:host .carousel .carousel-items .item{box-sizing:border-box;display:flex;justify-content:center}:host .carousel .center-items{justify-content:center}:host .carousel-point{list-style-type:none;text-align:center;padding:var(--space-md);margin:0;white-space:nowrap;overflow:auto;box-sizing:border-box}:host .carousel-point li{display:inline-block;border-radius:50%;background:var(--main-on);opacity:.25;padding:var(--space-xs);margin:0 var(--space-xs);transition-timing-function:cubic-bezier(.17,.67,.83,.67);transition:.4s}:host .carousel-point li.active{opacity:1;transform:scale(1.2)}:host .carousel-point li:hover{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: i1$5.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-carousel', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #carousel avnResize cdkTrapFocus tabindex=\"0\">\n  <avn-icon\n    *ngIf=\"buttonVisible && pages.length > 0\"\n    [style.opacity]=\"isFirst ? 0.3 : 1\"\n    icon=\"hardware:keyboard_arrow_left\"\n    fontSize=\"35\"\n    (click)=\"navigateCarousel('backward')\"\n  ></avn-icon>\n\n  <div #carouselMain class=\"carousel\">\n    <div>\n      <div #itemsContainer class=\"carousel-items\" [ngClass]=\"{ 'center-items': pages.length === 0 }\">\n        <ng-container *ngFor=\"let item of carouselItems; let i = index\">\n          <div\n            class=\"item\"\n            [ngStyle]=\"{\n              'margin-left.px': type === 'fixed' ? itemMargin : 0,\n              'margin-right.px': type === 'fixed' ? itemMargin : 0,\n              'padding-left.px': type === 'responsive' ? itemPadding : 0,\n              'padding-right.px': type === 'responsive' ? itemPadding : 0\n            }\"\n          >\n            <ng-container [ngTemplateOutlet]=\"item.template\"></ng-container>\n          </div>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n\n  <avn-icon\n    *ngIf=\"buttonVisible && pages.length > 0\"\n    [style.opacity]=\"isLast ? 0.3 : 1\"\n    icon=\"hardware:keyboard_arrow_right\"\n    fontSize=\"35\"\n    (click)=\"navigateCarousel('forward')\"\n  ></avn-icon>\n</div>\n<ul class=\"carousel-point\" *ngIf=\"pointVisible && pages.length > 1\">\n  <li *ngFor=\"let page of pages; let i = index\" [class.active]=\"i === activePoint\" (click)=\"moveTo(i)\"></li>\n</ul>\n", styles: [":host>div{display:flex;position:relative}:host ::ng-deep avn-icon{align-items:center}:host .carousel{position:relative;overflow:hidden;height:100%;width:100%}:host .carousel .carousel-items{position:relative;display:flex;height:100%}:host .carousel .carousel-items .item{box-sizing:border-box;display:flex;justify-content:center}:host .carousel .center-items{justify-content:center}:host .carousel-point{list-style-type:none;text-align:center;padding:var(--space-md);margin:0;white-space:nowrap;overflow:auto;box-sizing:border-box}:host .carousel-point li{display:inline-block;border-radius:50%;background:var(--main-on);opacity:.25;padding:var(--space-xs);margin:0 var(--space-xs);transition-timing-function:cubic-bezier(.17,.67,.83,.67);transition:.4s}:host .carousel-point li.active{opacity:1;transform:scale(1.2)}:host .carousel-point li:hover{cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: MediaBreakpointStore }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { itemPerSlideConfig: [{
                type: Input
            }], speed: [{
                type: Input
            }], minSpace: [{
                type: Input
            }], autoLoopInterval: [{
                type: Input
            }], pointVisible: [{
                type: Input
            }], buttonVisible: [{
                type: Input
            }], autoLoop: [{
                type: Input
            }], withAnimation: [{
                type: Input
            }], keyboardNavigationEnabled: [{
                type: Input
            }], easing: [{
                type: Input
            }], keepPositionOnSourceChange: [{
                type: Input
            }], viewingItemIndex: [{
                type: Input
            }], slided: [{
                type: Output
            }], carouselItems: [{
                type: ContentChildren,
                args: [CarouselItemDirective]
            }], carouselBody: [{
                type: ViewChild,
                args: ['carousel', { read: ElementRef, static: true }]
            }], carouselMain: [{
                type: ViewChild,
                args: ['carouselMain', { read: ElementRef, static: true }]
            }], resizeDirective: [{
                type: ViewChild,
                args: [ResizeDirective, { static: true }]
            }], itemsContainer: [{
                type: ViewChild,
                args: ['itemsContainer', { read: ElementRef, static: true }]
            }] } });

class CarouselModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: CarouselModule, declarations: [CarouselComponent, CarouselItemDirective], imports: [CommonModule, CoreModule, IconModule, A11yModule], exports: [CarouselComponent, CarouselItemDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CarouselModule, imports: [CommonModule, CoreModule, IconModule, A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, A11yModule],
                    exports: [CarouselComponent, CarouselItemDirective],
                    declarations: [CarouselComponent, CarouselItemDirective],
                }]
        }] });

/**
 * contains the various media asset types
 * see: https://confluence.stratacache.com/display/CM/CMS+Data+Model#CMSDataModel-Contentobject
 */
var MediaAssetType;
(function (MediaAssetType) {
    MediaAssetType["AUDIO"] = "Audio";
    MediaAssetType["IMAGE"] = "Image";
    MediaAssetType["SMILE"] = "Smile";
    MediaAssetType["VIDEO"] = "Video";
})(MediaAssetType || (MediaAssetType = {}));
var ImageFitStrategy;
(function (ImageFitStrategy) {
    ImageFitStrategy["CONTAIN"] = "contain";
    ImageFitStrategy["COVER"] = "cover";
})(ImageFitStrategy || (ImageFitStrategy = {}));

class MediaCardComponent {
    constructor(cdr) {
        this.cdr = cdr;
        /***
         * Image Width
         */
        this.imageWidth = 250;
        /**
         * Image Height
         */
        this.imageHeight = 250;
        /**
         *  by default CONTAIN is used, so the image will use its acutual imageWidth and imageHeight
         *  if COVER is used, image will be used to cover the image area
         */
        this.imageFitStrategy = ImageFitStrategy.CONTAIN;
        /**
         * overlay placement: 'Over' or 'Under'
         */
        this.footerPlacement = 'Under';
        /**
         * boolean that allow to use a custom gif loader
         */
        this.isDefaultLoader = true;
        /** Size of the icon image */
        this.iconImageFontSize = 70;
        /** Indicates if the media card can be selected */
        this.selectionEnabled = false;
        /** Indicates if the media card has the selection indicator turned on */
        this.selected = false;
        /** Indicates the position of the media card selection indicator */
        this.selectionIndicatorPosition = 'top-left';
        /** icon font Size */
        this.iconFontSize = 30;
        /**
         * The background image loading policy.
         * If this component is being used inside an iframe or with other front-end frameworks, be careful with lazy mode.
         */
        this.imgLoadingPolicy = 'eager';
        /**
         * dispatched when the component is clicked
         *
         * @todo DMB-3257 when the component is clicked we output this event.
         * we need an evt object with a discriminant that tells us:
         * - icon overlay button is clicked
         * also need to have an object output that will be passed back with the event emitted.
         */
        this.mediaCardEmitter = new EventEmitter();
        /**
         * Emit when an action icon is clicked.
         */
        this.mediaCardActioned = new EventEmitter();
        /**
         * map of icons to display per MediaAssetType
         */
        this.mediaIcons = {};
        /**
         * gives the state of the Icon, if it should be the icon or the spinner
         */
        this.isBackgroundImageLoaded$ = new BehaviorSubject(false);
        // generate a map of icons
        this.mediaIcons[MediaAssetType.AUDIO] = 'image:audiotrack';
        this.mediaIcons[MediaAssetType.IMAGE] = 'image:photo';
        this.mediaIcons[MediaAssetType.SMILE] = 'image:tag_faces';
        this.mediaIcons[MediaAssetType.VIDEO] = 'av:play_arrow';
    }
    ngOnChanges({ imageUrl, footerPlacement, imageHeight, refreshTriggered }) {
        if (imageUrl) {
            this.isBackgroundImageLoaded$.next(false);
        }
        if (imageUrl || footerPlacement || imageHeight) {
            this.updateCardHeight();
        }
        if (refreshTriggered) {
            if (this.refreshTriggeredSub !== undefined) {
                this.refreshTriggeredSub.unsubscribe();
                this.refreshTriggeredSub = undefined;
            }
            this.refreshTriggeredSub = refreshTriggered.currentValue.subscribe(() => {
                this.isBackgroundImageLoaded$.next(false);
            });
        }
    }
    ngAfterViewInit() {
        this.footerHeight = this.footer.nativeElement.clientHeight;
        this.updateCardHeight();
        this.cdr.detectChanges();
    }
    mediaCardClick(event, elementClicked) {
        event.preventDefault();
        this.mediaCardEmitter.emit({
            event,
            htmlSource: elementClicked,
            mediaAssetType: this.mediaAssetType,
            imageUrl: this.imageUrl,
            isLoaded: this.isBackgroundImageLoaded$.value,
        });
    }
    mediaCardActionClick(event, elementClicked) {
        event.preventDefault();
        this.mediaCardActioned.emit({
            event,
            htmlSource: elementClicked,
            mediaAssetType: this.mediaAssetType,
            imageUrl: this.imageUrl,
            isLoaded: this.isBackgroundImageLoaded$.value,
        });
    }
    imageLoaded() {
        this.isBackgroundImageLoaded$.next(true);
    }
    updateCardHeight() {
        if (this.footerPlacement === 'Under') {
            this.imageContainerHeight = this.imageHeight + Number(this.footerHeight);
        }
        else {
            this.imageContainerHeight = this.imageHeight;
        }
    }
    ngOnDestroy() {
        if (this.refreshTriggeredSub !== undefined) {
            this.refreshTriggeredSub.unsubscribe();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaCardComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: MediaCardComponent, selector: "avn-media-card", inputs: { imageWidth: "imageWidth", imageHeight: "imageHeight", imageFitStrategy: "imageFitStrategy", mediaAssetType: "mediaAssetType", imageUrl: "imageUrl", footerPlacement: "footerPlacement", customLoader: "customLoader", isDefaultLoader: "isDefaultLoader", iconImage: "iconImage", iconImageFontSize: "iconImageFontSize", selectionEnabled: "selectionEnabled", selected: "selected", refreshTriggered: "refreshTriggered", selectionIndicatorPosition: "selectionIndicatorPosition", mediaIconClass: "mediaIconClass", iconFontSize: "iconFontSize", customIcon: "customIcon", actionIcons: "actionIcons", imgLoadingPolicy: "imgLoadingPolicy" }, outputs: { mediaCardEmitter: "mediaCardEmitter", mediaCardActioned: "mediaCardActioned" }, viewQueries: [{ propertyName: "icon", first: true, predicate: ["mediaTypeIcon"], descendants: true }, { propertyName: "footer", first: true, predicate: ["footer"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<!-- Media Icon -->\n<ng-container *ngIf=\"!iconImage\">\n  <ng-container *ngIf=\"(isBackgroundImageLoaded$ | async) && (mediaAssetType || customIcon || actionIcons)\">\n    <div class=\"action-icons\">\n      <avn-icon\n        *ngFor=\"let actionIcon of actionIcons\"\n        [class]=\"'custom-icon action-icon card-icon' + (mediaIconClass ? ' ' + mediaIconClass : '')\"\n        [icon]=\"actionIcon.icon\"\n        [fontSize]=\"iconFontSize\"\n        (click)=\"mediaCardActionClick($event, actionIcon.id)\"\n      ></avn-icon>\n      <!-- Media Icon (will show Custom Icon if customIcon is provided) -->\n      <avn-icon\n        #mediaTypeIcon\n        [class]=\"'card-icon' + (mediaIconClass ? ' ' + mediaIconClass : '')\"\n        [class.custom-icon]=\"!!customIcon\"\n        [icon]=\"customIcon || mediaIcons[mediaAssetType]\"\n        [fontSize]=\"iconFontSize\"\n        (click)=\"mediaCardClick($event, 'icon')\"\n      ></avn-icon>\n    </div>\n  </ng-container>\n  <!-- Spinner Icon -->\n  <avn-icon\n    #mediaTypeIcon\n    [class]=\"'card-icon' + (mediaIconClass ? ' ' + mediaIconClass : '')\"\n    [rotate]=\"true\"\n    *ngIf=\"(isBackgroundImageLoaded$ | async) === false && isDefaultLoader\"\n    [icon]=\"'action:autorenew'\"\n    [fontSize]=\"iconFontSize\"\n  ></avn-icon>\n  <!-- Custom loader icon-->\n  <img class=\"customLoader\" [src]=\"customLoader\" *ngIf=\"(isBackgroundImageLoaded$ | async) === false && !isDefaultLoader\" />\n</ng-container>\n\n<!-- Image Container\n     The imageContainer is to allow the footer to be 'Over or 'Under' -->\n<div (click)=\"mediaCardClick($event, 'image')\" class=\"imgContainer\" [ngStyle]=\"{ height: imageContainerHeight + 'px' }\">\n  <div\n    class=\"icon-container\"\n    *ngIf=\"iconImage; else image\"\n    [style.width.px]=\"imageWidth\"\n    [style.height.px]=\"imageHeight\"\n    [style.maxHeight.px]=\"imageContainerHeight\"\n    [style.maxWidth.px]=\"imageWidth\"\n  >\n    <avn-icon [icon]=\"iconImage\" [fontSize]=\"iconImageFontSize\"></avn-icon>\n  </div>\n  <ng-template #image>\n    <div\n      class=\"image-container\"\n      [ngClass]=\"{\n        'image-contain': imageFitStrategy === 'contain',\n        'image-cover': imageFitStrategy === 'cover',\n        'footer-under': footerPlacement === 'Under'\n      }\"\n      [ngStyle]=\"{\n        'background-image': (isBackgroundImageLoaded$ | async) === true ? 'url(\\'' + imageUrl + '\\')' : 'none',\n        height: imageHeight + 'px',\n        width: imageWidth + 'px'\n      }\"\n    >\n      <!-- loading the same image using the DOM / a hidden image and bind to the load event on it\n      --- This is so that we know when the image is loaded -->\n      <img style=\"display: none\" (load)=\"imageLoaded()\" [src]=\"imageUrl\" [attr.loading]=\"imgLoadingPolicy\" />\n    </div>\n  </ng-template>\n</div>\n\n<footer (click)=\"mediaCardClick($event, 'footer')\" #footer [ngClass]=\"{ over: footerPlacement === 'Over' }\">\n  <!-- Projected footer content: title, dates description -->\n  <ng-content></ng-content>\n</footer>\n\n<avn-icon\n  *ngIf=\"selectionEnabled\"\n  class=\"selection-indicator\"\n  [class.selected]=\"selected\"\n  [class.top-left]=\"selectionIndicatorPosition === 'top-left'\"\n  [class.top-right]=\"selectionIndicatorPosition === 'top-right'\"\n  [class.bottom-left]=\"selectionIndicatorPosition === 'bottom-left'\"\n  [class.bottom-right]=\"selectionIndicatorPosition === 'bottom-right'\"\n  icon=\"action:check_circle\"\n  [avnTheme]=\"selected ? 'success' : null\"\n></avn-icon>\n", styles: [":host{width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;display:flex;flex-direction:column;position:relative}:host.theme-primary footer{background-color:var(--primary-base)}:host.theme-secondary footer{background-color:var(--secondary-base)}:host.theme-highlight footer{background-color:var(--highlight-base)}:host.theme-danger footer{background-color:var(--danger-base)}:host.theme-warning footer{background-color:var(--warning-base)}:host.theme-info footer{background-color:var(--info-base)}:host.theme-success footer{background-color:var(--success-base)}:host>.action-icons{position:absolute;z-index:1;top:var(--space-sm);right:var(--space-sm);display:flex}:host>.action-icons>avn-icon.card-icon{border-radius:50%;background-color:#000;color:#fff;opacity:.75}:host>.action-icons>avn-icon.card-icon:not(:first-child){margin-left:var(--space-sm)}:host>.action-icons>avn-icon.card-icon:hover{opacity:1;cursor:pointer}:host>.action-icons>avn-icon.card-icon ::ng-deep .material-icons{padding:var(--space-md)}:host>.action-icons>avn-icon.custom-icon{opacity:0}:host:hover>.action-icons>avn-icon.custom-icon{opacity:.8}:host:hover>.action-icons>avn-icon.custom-icon:hover{opacity:1}:host .customLoader{position:absolute;top:15px;height:48px;right:15px}:host .imgContainer{border-radius:5px;background-color:#000;background-position:center;background-repeat:no-repeat;transition:width 1s,height 1s}:host .imgContainer .image-container{background-repeat:no-repeat;background-position:inherit;max-width:100%;max-height:100%;margin:auto;border-radius:5px}:host .imgContainer .image-container.image-contain{background-size:contain}:host .imgContainer .image-container.image-cover{background-size:cover}:host .imgContainer .image-container.footer-under{border-bottom-left-radius:unset;border-bottom-right-radius:unset}:host .imgContainer .icon-container{height:100%;width:100%;display:flex;align-items:center;justify-content:center}:host .loading{margin:0 auto;position:inherit;background:transparent}:host footer{bottom:0;position:absolute;padding:var(--space-sm);border-radius:0 0 5px 5px;overflow:hidden;left:0;right:0}:host footer.over{background-color:#000000bf}:host footer:empty{padding:unset!important}:host .selection-indicator{opacity:0;position:absolute;transition:opacity .15s ease-in-out}:host .selection-indicator.selected{opacity:1;border-radius:50px;background:white}:host .selection-indicator.top-left{top:10px;left:10px}:host .selection-indicator.top-right{top:10px;right:10px}:host .selection-indicator.bottom-left{bottom:10px;left:10px}:host .selection-indicator.bottom-right{bottom:10px;right:10px}:host:hover .selection-indicator{opacity:1}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-media-card', template: "<!-- Media Icon -->\n<ng-container *ngIf=\"!iconImage\">\n  <ng-container *ngIf=\"(isBackgroundImageLoaded$ | async) && (mediaAssetType || customIcon || actionIcons)\">\n    <div class=\"action-icons\">\n      <avn-icon\n        *ngFor=\"let actionIcon of actionIcons\"\n        [class]=\"'custom-icon action-icon card-icon' + (mediaIconClass ? ' ' + mediaIconClass : '')\"\n        [icon]=\"actionIcon.icon\"\n        [fontSize]=\"iconFontSize\"\n        (click)=\"mediaCardActionClick($event, actionIcon.id)\"\n      ></avn-icon>\n      <!-- Media Icon (will show Custom Icon if customIcon is provided) -->\n      <avn-icon\n        #mediaTypeIcon\n        [class]=\"'card-icon' + (mediaIconClass ? ' ' + mediaIconClass : '')\"\n        [class.custom-icon]=\"!!customIcon\"\n        [icon]=\"customIcon || mediaIcons[mediaAssetType]\"\n        [fontSize]=\"iconFontSize\"\n        (click)=\"mediaCardClick($event, 'icon')\"\n      ></avn-icon>\n    </div>\n  </ng-container>\n  <!-- Spinner Icon -->\n  <avn-icon\n    #mediaTypeIcon\n    [class]=\"'card-icon' + (mediaIconClass ? ' ' + mediaIconClass : '')\"\n    [rotate]=\"true\"\n    *ngIf=\"(isBackgroundImageLoaded$ | async) === false && isDefaultLoader\"\n    [icon]=\"'action:autorenew'\"\n    [fontSize]=\"iconFontSize\"\n  ></avn-icon>\n  <!-- Custom loader icon-->\n  <img class=\"customLoader\" [src]=\"customLoader\" *ngIf=\"(isBackgroundImageLoaded$ | async) === false && !isDefaultLoader\" />\n</ng-container>\n\n<!-- Image Container\n     The imageContainer is to allow the footer to be 'Over or 'Under' -->\n<div (click)=\"mediaCardClick($event, 'image')\" class=\"imgContainer\" [ngStyle]=\"{ height: imageContainerHeight + 'px' }\">\n  <div\n    class=\"icon-container\"\n    *ngIf=\"iconImage; else image\"\n    [style.width.px]=\"imageWidth\"\n    [style.height.px]=\"imageHeight\"\n    [style.maxHeight.px]=\"imageContainerHeight\"\n    [style.maxWidth.px]=\"imageWidth\"\n  >\n    <avn-icon [icon]=\"iconImage\" [fontSize]=\"iconImageFontSize\"></avn-icon>\n  </div>\n  <ng-template #image>\n    <div\n      class=\"image-container\"\n      [ngClass]=\"{\n        'image-contain': imageFitStrategy === 'contain',\n        'image-cover': imageFitStrategy === 'cover',\n        'footer-under': footerPlacement === 'Under'\n      }\"\n      [ngStyle]=\"{\n        'background-image': (isBackgroundImageLoaded$ | async) === true ? 'url(\\'' + imageUrl + '\\')' : 'none',\n        height: imageHeight + 'px',\n        width: imageWidth + 'px'\n      }\"\n    >\n      <!-- loading the same image using the DOM / a hidden image and bind to the load event on it\n      --- This is so that we know when the image is loaded -->\n      <img style=\"display: none\" (load)=\"imageLoaded()\" [src]=\"imageUrl\" [attr.loading]=\"imgLoadingPolicy\" />\n    </div>\n  </ng-template>\n</div>\n\n<footer (click)=\"mediaCardClick($event, 'footer')\" #footer [ngClass]=\"{ over: footerPlacement === 'Over' }\">\n  <!-- Projected footer content: title, dates description -->\n  <ng-content></ng-content>\n</footer>\n\n<avn-icon\n  *ngIf=\"selectionEnabled\"\n  class=\"selection-indicator\"\n  [class.selected]=\"selected\"\n  [class.top-left]=\"selectionIndicatorPosition === 'top-left'\"\n  [class.top-right]=\"selectionIndicatorPosition === 'top-right'\"\n  [class.bottom-left]=\"selectionIndicatorPosition === 'bottom-left'\"\n  [class.bottom-right]=\"selectionIndicatorPosition === 'bottom-right'\"\n  icon=\"action:check_circle\"\n  [avnTheme]=\"selected ? 'success' : null\"\n></avn-icon>\n", styles: [":host{width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;display:flex;flex-direction:column;position:relative}:host.theme-primary footer{background-color:var(--primary-base)}:host.theme-secondary footer{background-color:var(--secondary-base)}:host.theme-highlight footer{background-color:var(--highlight-base)}:host.theme-danger footer{background-color:var(--danger-base)}:host.theme-warning footer{background-color:var(--warning-base)}:host.theme-info footer{background-color:var(--info-base)}:host.theme-success footer{background-color:var(--success-base)}:host>.action-icons{position:absolute;z-index:1;top:var(--space-sm);right:var(--space-sm);display:flex}:host>.action-icons>avn-icon.card-icon{border-radius:50%;background-color:#000;color:#fff;opacity:.75}:host>.action-icons>avn-icon.card-icon:not(:first-child){margin-left:var(--space-sm)}:host>.action-icons>avn-icon.card-icon:hover{opacity:1;cursor:pointer}:host>.action-icons>avn-icon.card-icon ::ng-deep .material-icons{padding:var(--space-md)}:host>.action-icons>avn-icon.custom-icon{opacity:0}:host:hover>.action-icons>avn-icon.custom-icon{opacity:.8}:host:hover>.action-icons>avn-icon.custom-icon:hover{opacity:1}:host .customLoader{position:absolute;top:15px;height:48px;right:15px}:host .imgContainer{border-radius:5px;background-color:#000;background-position:center;background-repeat:no-repeat;transition:width 1s,height 1s}:host .imgContainer .image-container{background-repeat:no-repeat;background-position:inherit;max-width:100%;max-height:100%;margin:auto;border-radius:5px}:host .imgContainer .image-container.image-contain{background-size:contain}:host .imgContainer .image-container.image-cover{background-size:cover}:host .imgContainer .image-container.footer-under{border-bottom-left-radius:unset;border-bottom-right-radius:unset}:host .imgContainer .icon-container{height:100%;width:100%;display:flex;align-items:center;justify-content:center}:host .loading{margin:0 auto;position:inherit;background:transparent}:host footer{bottom:0;position:absolute;padding:var(--space-sm);border-radius:0 0 5px 5px;overflow:hidden;left:0;right:0}:host footer.over{background-color:#000000bf}:host footer:empty{padding:unset!important}:host .selection-indicator{opacity:0;position:absolute;transition:opacity .15s ease-in-out}:host .selection-indicator.selected{opacity:1;border-radius:50px;background:white}:host .selection-indicator.top-left{top:10px;left:10px}:host .selection-indicator.top-right{top:10px;right:10px}:host .selection-indicator.bottom-left{bottom:10px;left:10px}:host .selection-indicator.bottom-right{bottom:10px;right:10px}:host:hover .selection-indicator{opacity:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { imageWidth: [{
                type: Input
            }], imageHeight: [{
                type: Input
            }], imageFitStrategy: [{
                type: Input
            }], mediaAssetType: [{
                type: Input
            }], imageUrl: [{
                type: Input
            }], footerPlacement: [{
                type: Input
            }], customLoader: [{
                type: Input
            }], isDefaultLoader: [{
                type: Input
            }], iconImage: [{
                type: Input
            }], iconImageFontSize: [{
                type: Input
            }], selectionEnabled: [{
                type: Input
            }], selected: [{
                type: Input
            }], refreshTriggered: [{
                type: Input
            }], selectionIndicatorPosition: [{
                type: Input
            }], mediaIconClass: [{
                type: Input
            }], iconFontSize: [{
                type: Input
            }], customIcon: [{
                type: Input
            }], actionIcons: [{
                type: Input
            }], imgLoadingPolicy: [{
                type: Input
            }], mediaCardEmitter: [{
                type: Output
            }], mediaCardActioned: [{
                type: Output
            }], icon: [{
                type: ViewChild,
                args: ['mediaTypeIcon', { static: false }]
            }], footer: [{
                type: ViewChild,
                args: ['footer', { static: true }]
            }] } });

class MediaCardModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: MediaCardModule, declarations: [MediaCardComponent], imports: [CommonModule, CoreModule, IconModule], exports: [MediaCardComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaCardModule, imports: [CommonModule, CoreModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MediaCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MediaCardComponent],
                    exports: [MediaCardComponent],
                    imports: [CommonModule, CoreModule, IconModule],
                }]
        }] });

class MenuCardComponent {
    constructor() {
        /** Height of the menu-card. Accepts any valid CSS height values, ex. '2rem'. Default value = '300px' */
        this.height = '300px';
        /** Width of the menu-card. Accepts any valid CSS height values, ex. '2rem'. Default value = '250px' */
        this.width = '250px';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MenuCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: MenuCardComponent, selector: "avn-menu-card", inputs: { title: "title", subTitle: "subTitle", height: "height", width: "width", backgroundColor: "backgroundColor", color: "color" }, ngImport: i0, template: "<div class=\"menu-card-main\" [style.height]=\"height\" [style.width]=\"width\">\n  <span class=\"menu-card-details\" [style.backgroundColor]=\"backgroundColor\" [style.color]=\"color\">\n    <span class=\"menu-card-title\">{{ title }}</span>\n    <span class=\"menu-card-subtitle\">{{ subTitle }}</span>\n    <div #subtext class=\"menu-card-bottom-content\">\n      <ng-content select=\"span\"></ng-content>\n      <ng-content></ng-content>\n    </div>\n  </span>\n</div>\n", styles: [":host{display:block}:host.theme-primary>.menu-card-main>.menu-card-details{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>.menu-card-main>.menu-card-details{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>.menu-card-main>.menu-card-details{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>.menu-card-main>.menu-card-details{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>.menu-card-main>.menu-card-details{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>.menu-card-main>.menu-card-details{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>.menu-card-main>.menu-card-details{background-color:var(--success-base);color:var(--success-on)}:host .menu-card-main{box-shadow:0 2px 30px #00000080;position:relative;-webkit-user-select:none;user-select:none;border-radius:10px;white-space:nowrap;overflow:hidden;display:inline-block;transition:all .2s ease-out;transform:scale(1)}:host .menu-card-main:hover{transform:scale(1.02)}:host .menu-card-main .menu-card-details{height:100%;width:100%;padding:1rem;white-space:initial;float:left;font-size:2.5rem;font-weight:600}:host .menu-card-main .menu-card-details .menu-card-title{font-weight:900;display:inline-block;width:100%;font-size:20px}:host .menu-card-main .menu-card-details .menu-card-subtitle{font-weight:100;line-height:1rem}:host .menu-card-main .menu-card-details .menu-card-bottom-content{font-size:1.1rem;position:absolute;bottom:0;left:0;padding:1.25rem 1rem;width:100%;white-space:initial;letter-spacing:0;font-weight:400}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MenuCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-menu-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"menu-card-main\" [style.height]=\"height\" [style.width]=\"width\">\n  <span class=\"menu-card-details\" [style.backgroundColor]=\"backgroundColor\" [style.color]=\"color\">\n    <span class=\"menu-card-title\">{{ title }}</span>\n    <span class=\"menu-card-subtitle\">{{ subTitle }}</span>\n    <div #subtext class=\"menu-card-bottom-content\">\n      <ng-content select=\"span\"></ng-content>\n      <ng-content></ng-content>\n    </div>\n  </span>\n</div>\n", styles: [":host{display:block}:host.theme-primary>.menu-card-main>.menu-card-details{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>.menu-card-main>.menu-card-details{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>.menu-card-main>.menu-card-details{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>.menu-card-main>.menu-card-details{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>.menu-card-main>.menu-card-details{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>.menu-card-main>.menu-card-details{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>.menu-card-main>.menu-card-details{background-color:var(--success-base);color:var(--success-on)}:host .menu-card-main{box-shadow:0 2px 30px #00000080;position:relative;-webkit-user-select:none;user-select:none;border-radius:10px;white-space:nowrap;overflow:hidden;display:inline-block;transition:all .2s ease-out;transform:scale(1)}:host .menu-card-main:hover{transform:scale(1.02)}:host .menu-card-main .menu-card-details{height:100%;width:100%;padding:1rem;white-space:initial;float:left;font-size:2.5rem;font-weight:600}:host .menu-card-main .menu-card-details .menu-card-title{font-weight:900;display:inline-block;width:100%;font-size:20px}:host .menu-card-main .menu-card-details .menu-card-subtitle{font-weight:100;line-height:1rem}:host .menu-card-main .menu-card-details .menu-card-bottom-content{font-size:1.1rem;position:absolute;bottom:0;left:0;padding:1.25rem 1rem;width:100%;white-space:initial;letter-spacing:0;font-weight:400}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { title: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class MenuCardModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MenuCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: MenuCardModule, declarations: [MenuCardComponent], imports: [CommonModule, CoreModule], exports: [MenuCardComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MenuCardModule, imports: [CommonModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MenuCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MenuCardComponent],
                    exports: [MenuCardComponent],
                    imports: [CommonModule, CoreModule],
                }]
        }] });

class SummaryCardComponent {
    constructor() {
        /**
         * Height of the card. Accepts any valid CSS height values, ex. '2rem'.
         * Default value = '300px'
         */
        this.height = '300px';
        /**
         * Width of the card. Accepts any valid CSS height values, ex. '2rem'.
         * Default value = '250px'
         */
        this.width = '250px';
        this.isTextOverflow = false;
    }
    sizeChanged() {
        // resize icon of the card
        this.iconSize =
            this.mainContainer.nativeElement.clientWidth > this.mainContainer.nativeElement.clientHeight
                ? this.mainContainer.nativeElement.clientHeight
                : this.mainContainer.nativeElement.clientWidth;
        this.isTextOverflow = this.mainContainer.nativeElement.scrollHeight > this.mainContainer.nativeElement.clientHeight;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SummaryCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SummaryCardComponent, selector: "avn-summary-card", inputs: { header: "header", footer: "footer", height: "height", width: "width", icon: "icon" }, host: { properties: { "style.height": "this.height", "style.width": "this.width" } }, viewQueries: [{ propertyName: "mainContainer", first: true, predicate: ["mainContainer"], descendants: true, static: true }, { propertyName: "content", first: true, predicate: ["content"], descendants: true, static: true }], ngImport: i0, template: "<div #mainContainer class=\"card-main\" (avnResize)=\"sizeChanged()\">\n  <div class=\"card-details\">\n    <avn-icon *ngIf=\"icon\" [icon]=\"icon\" [fontSize]=\"iconSize / 1.5\"></avn-icon>\n\n    <div class=\"header\">{{ header }}</div>\n\n    <div #content class=\"content\" [class.overflow-text]=\"isTextOverflow\">\n      <ng-content select=\"span\"></ng-content>\n      <ng-content></ng-content>\n    </div>\n\n    <div class=\"footer\">{{ footer }}</div>\n  </div>\n</div>\n", styles: [":host{display:block}:host.theme-primary>.card-main>.card-details{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>.card-main>.card-details{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>.card-main>.card-details{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>.card-main>.card-details{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>.card-main>.card-details{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>.card-main>.card-details{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>.card-main>.card-details{background-color:var(--success-base);color:var(--success-on)}:host .card-main{width:100%;height:100%;background:black;box-shadow:0 2px 30px #00000080;position:relative;-webkit-user-select:none;user-select:none;border-radius:3px;white-space:nowrap;overflow:hidden;display:inline-block;transition:all .2s ease-out;transform:scale(1)}:host .card-main:hover{transform:scale(1.02)}:host .card-main .card-details{display:flex;justify-content:space-between;flex-direction:column;height:100%;width:100%;padding:var(--space-base);white-space:initial;float:left;font-size:2.5rem;font-weight:600}:host .card-main .card-details .header{font-weight:900;display:inline-block;width:100%;font-size:20px}:host .card-main .card-details .content{font-size:1.1rem;white-space:initial;letter-spacing:0;font-weight:400}:host .card-main .card-details .content.overflow-text{min-height:0}:host .card-main .card-details .content.overflow-text ::ng-deep *{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .card-main .card-details .footer{font-size:1.1rem;font-weight:400}:host avn-icon{position:absolute;top:-25%;right:-25%;opacity:.2;z-index:0}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SummaryCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-summary-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #mainContainer class=\"card-main\" (avnResize)=\"sizeChanged()\">\n  <div class=\"card-details\">\n    <avn-icon *ngIf=\"icon\" [icon]=\"icon\" [fontSize]=\"iconSize / 1.5\"></avn-icon>\n\n    <div class=\"header\">{{ header }}</div>\n\n    <div #content class=\"content\" [class.overflow-text]=\"isTextOverflow\">\n      <ng-content select=\"span\"></ng-content>\n      <ng-content></ng-content>\n    </div>\n\n    <div class=\"footer\">{{ footer }}</div>\n  </div>\n</div>\n", styles: [":host{display:block}:host.theme-primary>.card-main>.card-details{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>.card-main>.card-details{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>.card-main>.card-details{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>.card-main>.card-details{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>.card-main>.card-details{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>.card-main>.card-details{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>.card-main>.card-details{background-color:var(--success-base);color:var(--success-on)}:host .card-main{width:100%;height:100%;background:black;box-shadow:0 2px 30px #00000080;position:relative;-webkit-user-select:none;user-select:none;border-radius:3px;white-space:nowrap;overflow:hidden;display:inline-block;transition:all .2s ease-out;transform:scale(1)}:host .card-main:hover{transform:scale(1.02)}:host .card-main .card-details{display:flex;justify-content:space-between;flex-direction:column;height:100%;width:100%;padding:var(--space-base);white-space:initial;float:left;font-size:2.5rem;font-weight:600}:host .card-main .card-details .header{font-weight:900;display:inline-block;width:100%;font-size:20px}:host .card-main .card-details .content{font-size:1.1rem;white-space:initial;letter-spacing:0;font-weight:400}:host .card-main .card-details .content.overflow-text{min-height:0}:host .card-main .card-details .content.overflow-text ::ng-deep *{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .card-main .card-details .footer{font-size:1.1rem;font-weight:400}:host avn-icon{position:absolute;top:-25%;right:-25%;opacity:.2;z-index:0}\n"] }]
        }], propDecorators: { mainContainer: [{
                type: ViewChild,
                args: ['mainContainer', { static: true }]
            }], content: [{
                type: ViewChild,
                args: ['content', { static: true }]
            }], header: [{
                type: Input
            }], footer: [{
                type: Input
            }], height: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.height']
            }], width: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.width']
            }], icon: [{
                type: Input
            }] } });

class SummaryCardModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SummaryCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SummaryCardModule, declarations: [SummaryCardComponent], imports: [CommonModule, CoreModule, IconModule], exports: [SummaryCardComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SummaryCardModule, imports: [CommonModule, CoreModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SummaryCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SummaryCardComponent],
                    imports: [CommonModule, CoreModule, IconModule],
                    exports: [SummaryCardComponent]
                }]
        }] });

/**
 * A control that parses and validates Natural Language expressions (NLP).
 */
class CheckboxGroupComponent extends FormControlComponent {
    /** @ignore **/
    constructor(ngControl, changeDetector, _renderer) {
        super(ngControl, changeDetector);
        this._renderer = _renderer;
        /** layout direction of the checkboxes within the component */
        this.direction = 'vertical';
        /** The items to create the checkboxes */
        this.items = [];
        /** The minimum width for an item (horizontal mode only) **/
        this.horizontalItemMinWidth = 200;
        /** Emits every time the component value changes **/
        this.changed = new EventEmitter();
        /** @ignore indicates if the items have loaded **/
        this._itemsLoaded = false;
    }
    /** @ignore **/
    ngOnInit() {
        super.ngOnInit();
    }
    /** @ignore **/
    ngOnChanges({ value, items, direction, horizontalItemMinWidth }) {
        if (value) {
            this._internalValue = value.currentValue;
            this._checkValidValues();
        }
        if (items && items.currentValue) {
            this._itemsLoaded = this._itemsLoaded || items.currentValue !== undefined;
            // when the items changed, make sure the value exists in the items
            this._checkValidValues();
        }
        if (direction || horizontalItemMinWidth) {
            if (this.direction === 'horizontal') {
                const width = this.horizontalItemMinWidth || 200;
                this._renderer.setStyle(this._checkboxContainer.nativeElement, 'grid-template-columns', `repeat(auto-fill, minmax(${width}px, auto)`);
            }
            else {
                this._renderer.removeStyle(this._checkboxContainer.nativeElement, 'grid-template-columns');
            }
        }
    }
    /** When the value is updated by the form api. See FormControl **/
    updateValue(value) {
        this._internalValue = value ? [...value] : [];
        this.value = [...this._internalValue];
        // we only validate the  value if the items have been loaded (to avoid changing the value to
        // empty). when items will be received that will be checked anyway
        if (this._itemsLoaded) {
            this._checkValidValues();
        }
    }
    _checkValidValues() {
        // make sure the value exists in the items
        const newItemsValues = this.items ? this.items.map((it) => it.value) : [];
        const newValue = [];
        for (const val of this._internalValue || []) {
            if (newItemsValues.includes(val)) {
                newValue.push(val);
            }
        }
        if (newValue.join('-') !== (this.value || []).join('-')) {
            this.value = newValue;
            this.propagateChange(newValue);
            this.changed.emit(newValue);
        }
    }
    /**
     * @ignore override from parent class so we can trigger change detection and run custom code
     * When OnPush strategy is used, inherited Input() change does not trigger ngOnChanges...
     */
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.changeDetector.detectChanges();
    }
    /** @ignore **/
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /** Called when an item is toggled **/
    onItemToggled(itemValue, checked) {
        this.value = this.value || [];
        if (checked) {
            this.value.push(itemValue);
        }
        else {
            this.value = this.value.filter((v) => v !== itemValue);
        }
        this._internalValue = this.value;
        this.propagateChange(this.value);
        this.changed.emit(this.value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxGroupComponent, deps: [{ token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CheckboxGroupComponent, selector: "avn-checkbox-group", inputs: { label: "label", direction: "direction", items: "items", horizontalItemMinWidth: "horizontalItemMinWidth", value: "value" }, outputs: { changed: "changed" }, providers: [{ provide: FormControlComponent, useExisting: CheckboxGroupComponent }], viewQueries: [{ propertyName: "_checkboxContainer", first: true, predicate: ["checkboxContainer"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div #checkboxContainer class=\"checkboxes-container\" [class.vertical]=\"direction === 'vertical'\" [class.horizontal]=\"direction === 'horizontal'\">\n  <avn-checkbox\n    *ngFor=\"let item of items || []\"\n    [attr.value]=\"item.value\"\n    [disabled]=\"disabled\"\n    [checked]=\"(value || []).includes(item.value)\"\n    [label]=\"item.label ? (item.label.constructor.name === 'String' ? item.label : (item.label | async)) : null\"\n    (change)=\"onItemToggled(item.value, $event.target.checked)\"\n  ></avn-checkbox>\n</div>\n", styles: [":host{display:block}:host .checkboxes-container.horizontal{display:grid}:host .checkboxes-container.vertical{display:flex;flex-direction:column}:host .checkboxes-container>avn-checkbox ::ng-deep label{white-space:nowrap}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CheckboxComponent, selector: "avn-checkbox", inputs: ["label", "indeterminate", "checked"], outputs: ["cbChange"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-checkbox-group', providers: [{ provide: FormControlComponent, useExisting: CheckboxGroupComponent }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div #checkboxContainer class=\"checkboxes-container\" [class.vertical]=\"direction === 'vertical'\" [class.horizontal]=\"direction === 'horizontal'\">\n  <avn-checkbox\n    *ngFor=\"let item of items || []\"\n    [attr.value]=\"item.value\"\n    [disabled]=\"disabled\"\n    [checked]=\"(value || []).includes(item.value)\"\n    [label]=\"item.label ? (item.label.constructor.name === 'String' ? item.label : (item.label | async)) : null\"\n    (change)=\"onItemToggled(item.value, $event.target.checked)\"\n  ></avn-checkbox>\n</div>\n", styles: [":host{display:block}:host .checkboxes-container.horizontal{display:grid}:host .checkboxes-container.vertical{display:flex;flex-direction:column}:host .checkboxes-container>avn-checkbox ::ng-deep label{white-space:nowrap}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { _checkboxContainer: [{
                type: ViewChild,
                args: ['checkboxContainer', { static: true }]
            }], label: [{
                type: Input
            }], direction: [{
                type: Input
            }], items: [{
                type: Input
            }], horizontalItemMinWidth: [{
                type: Input
            }], value: [{
                type: Input
            }], changed: [{
                type: Output
            }] } });

class CheckboxGroupModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: CheckboxGroupModule, declarations: [CheckboxGroupComponent], imports: [CommonModule, CheckboxModule], exports: [CheckboxGroupComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxGroupModule, imports: [CommonModule, CheckboxModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CheckboxGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CheckboxModule],
                    declarations: [CheckboxGroupComponent],
                    exports: [CheckboxGroupComponent],
                }]
        }] });

/**
 * The parser for device filters
 */
/* eslint-disable no-useless-escape */
class NlpExpressionParser extends CstParser {
    /** @ignore **/
    constructor(tokens, _useDisplayLanguage = false) {
        super(tokens, { recoveryEnabled: true });
        /**
         * Indicates if the native language is used when updating the expression.
         * This will be automatically set to true when the user adds translations for the tokens
         **/
        this._useDisplayLanguage = false;
        /**
         * A map for the token that can have a display value different from their token native pattern
         * value *
         */
        this._tokenI18nValuesMap = new Map();
        /**
         *Stores the i18n key/value pairs for each token for which the value is picked from an enum.
         * We need to display the translated value for display, but native expression need to use the
         *original enum value
         **/
        this._enumI18nValues = [];
        /** A map for the i18n code labels back to the token pattern **/
        this._labelToPatternMap = new Map();
        this.lexer = new Lexer(tokens);
        this.tokens = tokens;
        this._useDisplayLanguage = _useDisplayLanguage;
    }
    /**
     * Updates the parser with the specified nativeExpression.
     * Depending on whether the nativeExpression passed needs is in native grammar or not, the
     * nativeExpression may need to be 'de-translated' into the grammar tokens
     *
     * @param expression the expression to parse (could be in display or native language depedning on
     *     the _useDisplayLanguage flag)
     */
    updateExpression(expression) {
        this.nativeExpressionInfo = this.onBeforeTokenizeExpression(expression);
        // also init the display expression with the expression passed
        if (this._useDisplayLanguage) {
            this.displayExpressionInfo = {
                expression,
            };
        }
        // tokenize the nativeExpression
        this.lexResult = this.lexer.tokenize(this.nativeExpressionInfo.expression);
        this.nativeExpressionInfo.tokens = this.lexResult.tokens;
        // onAfterTokenizeExpression (typically combine tokens)
        this.nativeExpressionInfo = this.onAfterTokenizeExpression(this.nativeExpressionInfo, this.lexResult);
        // keep a copy of the initial native tokens with display enum values
        const initialNativeTokens = cloneDeep(this.nativeExpressionInfo.tokens);
        // extra process before validating the expression (e.g. translate enum values)
        this.nativeExpressionInfo = this.onBeforeValidateExpression(this.nativeExpressionInfo);
        // set the input tokens for the parser
        this.input = this.nativeExpressionInfo.tokens;
        // Validate and retrieve info about the parsed expression (that depends on the grammar and
        // therefore is done in inheriting classes)
        const cst = this.validateExpression();
        // extra process once expression is validated and cst created (e.g.
        this.nativeExpressionInfo = this.onAfterValidateExpression(this.nativeExpressionInfo, cst);
        // create the display expression info from the native expression
        if (this._useDisplayLanguage) {
            const updatedDisplayTokens = this._getDisplayExpressionTokens(initialNativeTokens);
            this.displayExpressionInfo = {
                ...this.displayExpressionInfo,
                tokens: updatedDisplayTokens,
            };
        }
        // return the parsed expression information
        return {
            native: this.nativeExpressionInfo,
            display: this.displayExpressionInfo,
            cst,
            errors: {
                parse: this.errors,
                lex: this.lexResult.errors,
            },
        };
    }
    /**
     * @ignore
     * Create the display expression info from the native expression info.
     * create a display token for each native token and:
     *  - update the native value with the display value.
     *  - update the offsets of the text within the expression.
     *  Note. the native tokens passed must contain the non-native enum values (i.e. display values)
     */
    _getDisplayExpressionTokens(nativeTokens) {
        // update each token
        const displayTokens = [];
        let offsetAdd = 0;
        for (const token of nativeTokens) {
            const displayToken = { ...token };
            // if there is a i18n label (therefore there is a string pattern), replace and update the
            // offset otherwise we keep the current value (just update the token value offsets)
            let tokenOffset = 0;
            if ((token.tokenType.LABEL || '').length > 0 && this._tokenI18nValuesMap.has(token.tokenType.LABEL)) {
                const i18nLabel = this._tokenI18nValuesMap.get(token.tokenType.LABEL);
                const nativeValue = `${token.tokenType.PATTERN}`;
                tokenOffset = i18nLabel.length - nativeValue.length;
                displayToken.image = i18nLabel;
            }
            displayToken.startOffset += offsetAdd;
            displayToken.startColumn += offsetAdd;
            displayToken.endOffset += offsetAdd + tokenOffset;
            displayToken.endColumn += offsetAdd;
            offsetAdd += tokenOffset;
            displayTokens.push(displayToken);
        }
        return displayTokens;
    }
    /** Creates a token suggestion for the specified field */
    createTokenSuggestion(tokenType, autoAppendAfter, isNextToken, group = null) {
        // if the pattern is a string, use that string
        // if there is a label but its blank, don't suggest anything for that field
        let value;
        switch (tokenType.PATTERN.constructor.name) {
            case 'RegExp':
                value = tokenType.PATTERN.source;
                break;
            case 'String':
                value = tokenType.PATTERN;
                break;
            default:
                value = tokenType.PATTERN;
        }
        const label = this._getTokenI18nValue(tokenType.LABEL) || value;
        return {
            value: !this._useDisplayLanguage ? value : label,
            label,
            showSuggestion: tokenType.LABEL !== '',
            autoAppendAfter,
            isNextToken,
            group,
        };
    }
    /** Adds a suggestion to the list of suggestion and make sure no duplicates are added */
    addToSuggestions(finalSuggestions, filterSuggestion) {
        // we could have duplication because each suggestion also includes a Path, and the same Token
        // may appear in multiple suggested paths.
        if (!finalSuggestions.map((s) => s.value).includes(filterSuggestion.value)) {
            finalSuggestions.push(filterSuggestion);
        }
    }
    /** Checks if a token is of type of the specified token */
    isTokenTypeOf(token, type) {
        if (token.tokenTypeIdx === type.tokenTypeIdx) {
            return true;
        }
        return type.categoryMatches.includes(token.tokenTypeIdx);
    }
    /**
     * Recursively retrieves all categories of a token
     */
    getAllCategories(token) {
        const res = [token];
        for (const category of token.CATEGORIES) {
            res.push(...this.getAllCategories(category));
        }
        return res;
    }
    /** gets the i18n display value of a token from its label key. */
    _getTokenI18nValue(label) {
        if (label && this._tokenI18nValuesMap.has(label)) {
            return this._tokenI18nValuesMap.get(label);
        }
        return label;
    }
    /**
     * Returns the map of tokens with translated i18n labels
     **/
    getTokenI18nValuesMap() {
        return this._tokenI18nValuesMap;
    }
    /**
     * Returns a list of the fields that can have a display value different from the native one.
     * This is the case for tokens that have a well defined string pattern and where a label key is
     *defined. We can only translate fields that have a string pattern and where the label is defined.
     **/
    getTokensI18nKeys() {
        const res = [];
        for (const token of this.tokens) {
            const hasStringPattern = token.PATTERN.constructor.name === 'String';
            if (hasStringPattern && token.LABEL) {
                res.push(token.LABEL);
            }
        }
        return res;
    }
    /**
     * Set the i18n display value for a particular token.
     * Use this if you want the display expression to be more readable than the native expression.
     **/
    addTokenI18nValue(tokenLabel, displayValue) {
        this._tokenI18nValuesMap.set(tokenLabel, displayValue);
        // also map the token label back to the original pattern
        const token = this.tokens.filter((t) => t.LABEL === tokenLabel && t.PATTERN.constructor.name === 'String')[0];
        if (token) {
            this._labelToPatternMap.set(tokenLabel, token.PATTERN.toString());
        }
    }
    /**
     * Set the i18n display value for a enum value of a token
     * Use this if you want the display expression to be more readable than the native expression.
     * eg. HealthStatus = 1 to HealthStatus = "OK"
     **/
    addI18nEnumValue(fieldToken, nativeValueToken, displayValueToken, enumValue, enumDisplayValue) {
        if (this._enumI18nValues.some((v) => v.fieldToken === fieldToken && v.enumValue === enumValue)) {
            throw Error(`The enum value has already been added [tokenName=${fieldToken.name}, enumValue=${enumValue}]`);
        }
        this._enumI18nValues.push({
            fieldToken,
            nativeValueTokenType: nativeValueToken,
            displayValueTokenType: displayValueToken,
            enumValue,
            enumI18nValue: enumDisplayValue,
        });
    }
    /**
     * clears the parser
     **/
    clear() {
        this._tokenI18nValuesMap.clear();
        this._labelToPatternMap.clear();
        this._enumI18nValues.length = 0;
        this.nativeExpressionInfo = undefined;
        this.displayExpressionInfo = undefined;
    }
    /**
     * Indicates if a text matches one of the languages reserved keywords (pattern or display value)
     **/
    isGrammarKeyword(text) {
        return this.tokens.some((t) => t.PATTERN === text) || Array.from(this._tokenI18nValuesMap.values()).some((label) => label === text);
    }
    /**
     * Converts a display expression into a native expression
     **/
    displayToNativeExpression(expression) {
        if ((expression || '').length === 0) {
            return expression;
        }
        const sortFn = (a, b) => 
        // sort by field size, if equal by alphabet
        a[1].length !== b[1].length ? b[1].length - a[1].length : -a[1].localeCompare(b[1]);
        // sort the display values by length (longer to smaller). We need to start replacing the longest
        // values first.
        const sortedEntries = Array.from(this._tokenI18nValuesMap.entries()).sort(sortFn);
        // create a regex with all the keywords
        let regex = '';
        for (const entry of sortedEntries) {
            regex += regex.length > 0 ? '|' : '';
            regex += this._escapeRegExp(entry[1]);
        }
        const regexText = new RegExp(regex, 'g');
        const wrapperCharList = this._getValueWrapperChars() || [];
        // replace all keywords with display values
        const res = expression.replace(regexText, (match, index) => {
            const precedingChar = getPreviousCharNotEmpty(expression, index - 1);
            const followingChar = getNextCharNotEmpty(expression, index + match.length);
            // dont replace keywords in values
            if (wrapperCharList.includes(precedingChar) && wrapperCharList.includes(followingChar) && precedingChar === followingChar) {
                return match;
            }
            for (const entry of sortedEntries) {
                if (entry[1] === match) {
                    return this._labelToPatternMap.get(entry[0]) || match;
                }
            }
            return match;
        });
        return res;
    }
    /** @ignore escapes a string into a regular expression **/
    _escapeRegExp(str) {
        return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // $& means the whole matched string
    }
    /** Returns the list of wrapper chars **/
    _getValueWrapperChars() {
        return Array.from(this.getValueWrapperCharMap().values());
    }
}

/**
 * This service is scoped to the NLP Input Component (provided in component)
 * It ensures the communication between the nlp input and the custom overlays for autocompletion:
 * - Every time the edited expression changes in the input, the current suggestion result will be
 * updated
 * - Overlays will use the service to listen to those changes and update their display / values
 * - When the user updates a value through an NLP overlay, the value will be updated in the service
 * and the NLP input will listen to those changes
 */
class NlpOverlayService {
    constructor() {
        /** @ignore  Emits every time a value is updated from a NLP overlay  **/
        this._valueSelectedSubject = new Subject();
        /** @ignore Indicates if an outside click can close the connected overlay of the nlp input  **/
        this._allowCloseOnOutsideClickSubject = new BehaviorSubject(true);
        /** @ignore Emits every time the suggestions for the nlp expression changes **/
        this._expressionSuggestionsResultSubject = new BehaviorSubject(null);
    }
    /**
     * Sets the i18n map for tokens that can have a display value different from their token native
     * pattern value *
     */
    setTokenI18nValuesMap(map) {
        this._tokenI18nValuesMap = map;
    }
    /**
     * Gets the map for the token that can have a display value different from their token native
     * pattern value *
     */
    getTokenI18nValuesMap() {
        return this._tokenI18nValuesMap;
    }
    /**
     * Gets the value selected from a NLP overlay
     **/
    get valueSelected$() {
        return this._valueSelectedSubject.asObservable();
    }
    /**
     * Sets the value selected from a NLP overlay
     *
     * @param value the updated value
     * @param cursorOffset the offset of cursor repositioning. Sometimes we may want to reposition the
     *cursor not exactely after the selected value but just before last char to trigger more actions
     * in the same overlay (e.g. for a date time picker, show time selection overlay once the date has
     *been picked with a different overlay
     **/
    setValueSelected(value, cursorOffset = 0, keepOverlayOpened = false) {
        this._valueSelectedSubject.next({
            value,
            cursorOffset,
            keepOverlayOpened,
        });
    }
    /** Sets the current suggestions for the nlp expression **/
    setExpressionSuggestionsResult(res) {
        this._expressionSuggestionsResultSubject.next(res);
    }
    /** Observable of the current suggestions for the nlp expression **/
    get expressionSuggestionsResult$() {
        return this._expressionSuggestionsResultSubject.asObservable();
    }
    /**
     * Observable that indicates if an outside click can close the connected overlay of the nlp input
     * For instance when an overlay contains a select component and the select is opened, clicking on
     *an option of that select would trigger the closing of the nlp overlay because its considered as
     *an 'outside click'. So the trick here would be to listen to the select options being toggled and
     *disable the outside click closing while its opened.
     **/
    get allowCloseOnOutsideClick$() {
        return this._allowCloseOnOutsideClickSubject.asObservable();
    }
    /**
     * Specify if an outside click can close the connected overlay of the nlp input
     **/
    setAllowCloseOnOutsideClick(value) {
        this._allowCloseOnOutsideClickSubject.next(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpOverlayService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpOverlayService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpOverlayService, decorators: [{
            type: Injectable
        }] });

/**
 * Directive to apply on components / elements to be displayed in the NLP connected overlay.
 * The directive takes in a Token Type as input. Whenever the current field expression being entered
 * matches this token type and the value for that field expression needs to be entered (usually
 * after the operator), then the overlay will display.
 */
class NlpSuggestionOverlayDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        /**
         * An array of possible values tokens for the token type
         * e.g for a DateField the value could be a duration (NumericValue + TimeUnit) or a date (DateValue)
         * so we would pass [[NumericValue, TimeUnit], [DateValue]]
         *
         */
        this.valueTypes = [];
    }
    /**
     * Indicates if the current value entered in the partial expression is complete.
     * Some field values are composed of multiple tokens (e.g. duration = NumericValue + TimeUnit)
     * full expression value is used in the case of cursor repositioning
     * *
     */
    isValueCompleted(partialValueTokens, fullValueTokens) {
        if (!partialValueTokens || partialValueTokens.length === 0) {
            return false;
        }
        if (!fullValueTokens || fullValueTokens.length === 0) {
            return false;
        }
        // if the full expression has more values than the partial expression, then its not complete
        if (fullValueTokens.length > partialValueTokens.length) {
            return false;
        }
        // if the full expression has the same amount of values as the partial expression, check the
        // value itself
        if (partialValueTokens[partialValueTokens.length - 1].image !== fullValueTokens[fullValueTokens.length - 1].image) {
            return false;
        }
        // we have reached the point where the partial/full expression have the exact same values
        // we now need to determine if the value is complete or if only part of it has been entered so
        // far get all value types that starts with the same types of values. e.g. if values =
        // [NumericValue] and valueTypes = [[NumericValue, TimeUnit], [DateValue], [NumericValue, XXX,
        // XXX]] then return
        // [[NumericValue, TimeUnit], [NumericValue, XXX, XXX]]
        const matchingValueTypes = this.valueTypes.filter((vt) => partialValueTokens.every((val, i) => tokenMatcher(val, vt[i])));
        // if none was matched, that means that not all values have been entered
        if (matchingValueTypes.length === 0) {
            return false;
        }
        // keep only the longest
        const valueTypeToCompare = matchingValueTypes.reduce((prev, curr) => (curr.length > prev.length ? curr : prev), []);
        // if the amount of value fields has not been entered, its not completed
        if (valueTypeToCompare.length > partialValueTokens.length) {
            return false;
        }
        // all good, its completed :D
        return true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpSuggestionOverlayDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: NlpSuggestionOverlayDirective, selector: "[avnNlpSuggestionOverlay]", inputs: { tokenType: ["avnNlpSuggestionOverlay", "tokenType"], valueTypes: ["avnNlpSuggestionOverlayValueTypes", "valueTypes"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpSuggestionOverlayDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnNlpSuggestionOverlay]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { tokenType: [{
                type: Input,
                args: ['avnNlpSuggestionOverlay']
            }], valueTypes: [{
                type: Input,
                args: ['avnNlpSuggestionOverlayValueTypes']
            }] } });

/**
 * A control that parses and validates Natural Language expressions (NLP).
 * The component provides the following functionalities:
 *
 * Datasource function
 * - Pass in a function taking in the results of the nativeExpression parsing and returns an
 * observable of autocompletion options
 *
 * Virtualization
 *
 * - Enabled by default after N (defaults to 30) options are present in list.
 *
 * Keyboard Navigation
 *
 * - First option of the list is automatically set to active
 * - Works with virtual scroll
 *
 * Configurable size
 * - The list can be configured to display a max number of options within its viewport.
 *
 * Configurable width
 * - The list can be configured to match the origin element width or a custom width
 *
 * Option Selection
 * - Option can be selected by clicking on it
 * - When keyboard navigation is enabled, option can be selected by pressing the TAB or ENTER key
 *
 * Matching Text Highlight
 * - First occurrence of partially entered text is highlighted in the resulting option list
 *
 * More configurable text search options:
 * - Debounce time between keypress before looking up for matching options
 */
class NlpExpressionInputComponent extends FormControlComponent {
    /** @ignore **/
    constructor(_element, _renderer, _document, ngControl, changeDetector, _nlpOverlayService) {
        super(ngControl, changeDetector);
        this._element = _element;
        this._renderer = _renderer;
        this._document = _document;
        this._nlpOverlayService = _nlpOverlayService;
        /** disable NLP, i.e. make the component a regular search component **/
        this.disableNlpFunctionality = false;
        /** Enable the regular search, ie. search with a single word **/
        this.enableRegularSearch = false;
        /** The icon to display in the input component */
        this.icon = 'content:filter_list';
        /** The icon to display in the input component */
        this.buttonPosition = 'right';
        /** Specifies if the seach button should be displayed */
        this.showSearchButton = true;
        /** The icon to display in the input component */
        this.enableInfoTooltip = false;
        /** The placeholder for the autocomplete when no value is selected **/
        this.placeholder = '';
        /** Specifies the number of options visible in the list **/
        this.maxOptionsVisibleInViewport = 7;
        /** The debounce time for keyboard typing before data is refetched */
        this.debounceTimeMs = 300;
        /** Indicates if the nlp expression can wrap to a new line */
        this.multiline = false;
        /** Emits every time the expression has changed. Sends back the parsing result **/
        this.expressionChanged = new EventEmitter();
        /** Emits every time the search button is clicked. Emits the current nativeExpression **/
        this.search = new EventEmitter();
        /** The remaining options after filtering the main datasource */
        this.filteredOptions = [];
        /** Specifies if the connected element is opened **/
        this.connectedElementOpened = false;
        /** Specifies if first occurrence only of entered text should be highlighted in the option list */
        this.highlightMatchingTextOnlyFirst = true;
        /**
         * When keyboard navigation is enabled, specifies if the first option should be auto marked as
         * active *
         */
        this.autoActiveFirstOption = false;
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
        /** @ignore used to manually trigger the recheck of the nativeExpression **/
        this._recheckExpressionSubject = new Subject();
        /** @ignore specifies if the component (input or button) is currently hovered **/
        this._hovered = false;
        /** @ignore specifies if the component (input or button) is currently focused **/
        this._focused = false;
        /**
         * @ignore used to prevent ENTER key to emit search when pressing ENTER to select an autocomplete
         * option *
         */
        this._canSearchWithEnterKey = new BehaviorSubject(true);
        /**
         * @ignore when we debounce the input text and the last char entered is ENTER (or TAB etc.., see the list below),
         * the expression wont get re-parsed. so we need to know if any text has been entered during the debounce.
         */
        this._inputKeypressReparseExpressionSubject = new BehaviorSubject(false);
        /** @ignore Indicates if the component is in a loading state (fetching autocompletion data) **/
        this._loadingSubject = new BehaviorSubject(false);
        this.allowCloseOnOutsideClick$ = this._nlpOverlayService.allowCloseOnOutsideClick$;
    }
    /** @ignore **/
    ngOnInit() {
        super.ngOnInit();
    }
    /** @ignore **/
    ngAfterViewInit() {
        if (!this.disableNlpFunctionality) {
            this._watchAutocompleteAction();
            // add validator when field is used within a form context
            if (this.formControl) {
                // we need to add the required validator if it was added at form creation
                // there should never be any other validator than required as validation is done in this
                // component
                const validators = [];
                if (this._hasRequiredValidator()) {
                    validators.push(Validators.required);
                }
                validators.push(this.validate.bind(this));
                this.formControl.setValidators(validators);
            }
        }
        // when in regular search mode, update the value when the input value changes
        fromEvent(this.inputNativeElement, 'input')
            .pipe(filter(() => !this.disabled && this._isRegularSearchMode()), takeUntil(this._componentDestroyed$))
            .subscribe(() => {
            if (this.connectedElementOpened) {
                this.connectedElementOpened = false;
            }
            this.value = this.inputNativeElement.value;
            this.propagateChange(this.value);
        });
        // submit on enter
        // dont submit if enter key was pressed to select an option from the list
        fromEvent(this.filterInput.nativeElement, 'keyup')
            .pipe(filter(() => !this.disabled && !this.hasErrors && this._canSearchWithEnterKey.getValue()), filter((event) => event.keyCode === ENTER), 
        // if enter key is pressed, make sure to wait until keypress debounce is completed
        switchMap(() => this._inputKeypressReparseExpressionSubject.pipe(filter((shouldReparse) => !shouldReparse), take(1))), switchMap(() => this._loadingSubject.pipe(filter((loading) => !loading), take(1))), takeUntil(this._componentDestroyed$))
            .subscribe(() => this.onSearch());
        // watch input and button events in order to set this component hovered and focus state
        merge(fromEvent(this._element.nativeElement, 'mouseenter'), fromEvent(this._element.nativeElement, 'mouseleave'))
            .pipe(map((evt) => evt.type === 'mouseenter'), takeUntil(this._componentDestroyed$))
            .subscribe((hovered) => {
            this._hovered = hovered;
            this.changeDetector.markForCheck();
        });
        merge(fromEvent(this.inputNativeElement, 'focus'), fromEvent(this.inputNativeElement, 'blur'))
            .pipe(map((evt) => evt.type === 'focus'), takeUntil(this._componentDestroyed$))
            .subscribe((focused) => {
            this._focused = focused;
            this.changeDetector.markForCheck();
        });
        // This is a hack to prevent the ENTER key to submit the search when a option is selected from
        // the list. The issue is that the input listens to ENTER key press to submit the search.
        // Therefore when selecting an option from the list with the ENTER key (the input is still
        // focused), it triggers a search, that we want to avoid. The hack here is to add a small delay
        // before activating the ENTER key search submission once an option has been selected.
        this.optionList.optionActivated
            .pipe(filter(() => this._canSearchWithEnterKey.getValue()), tap(() => this._canSearchWithEnterKey.next(false)), 
        // wait until an option is selected or the option panel is closed to allow searching
        // again
        switchMap(() => race(this.optionList.optionClicked, this.connectedElement.toggled.pipe(filter((opened) => !opened))).pipe(take(1))), delay(100), takeUntil(this._componentDestroyed$))
            .subscribe(() => this._canSearchWithEnterKey.next(true));
        // when a value is selected from one of the custom overlays, update the expression
        this._nlpOverlayService.valueSelected$.pipe(takeUntil(this._componentDestroyed$)).subscribe((value) => {
            const hasValue = this.expressionSuggestionsResult.currentFullFieldExpression &&
                this.expressionSuggestionsResult.currentFullFieldExpression.values &&
                this.expressionSuggestionsResult.currentFullFieldExpression.values.length > 0;
            this._updateFieldExpressionValue(value.value, '', !hasValue, value.cursorOffset, value.keepOverlayOpened);
        });
    }
    /** @ignore **/
    ngOnChanges({ value, nlpParser }) {
        if (value) {
            if (this.nlpParser) {
                const newValue = (this.value || '').trim();
                this.errors = [];
                if (!this.disableNlpFunctionality && newValue.length > 0) {
                    // we need to convert the native expression into the display expression first
                    const displayExpression = this.nlpParser.nativeToDisplayExpression(newValue);
                    this._parseExpression(displayExpression);
                    this.displayValue = displayExpression;
                    if (this.filterInput) {
                        this.filterInput.nativeElement.value = displayExpression;
                    }
                }
                else {
                    this.displayValue = newValue;
                    if (this.filterInput) {
                        this.filterInput.nativeElement.value = newValue;
                    }
                }
            }
        }
        // the form api may set the form value before the parser is initiated
        // so recalc the display expression when the parser changes
        if (nlpParser && nlpParser.currentValue) {
            const displayExpression = this.nlpParser.nativeToDisplayExpression(this.value) || '';
            this.displayValue = displayExpression;
            if (this.filterInput) {
                this.filterInput.nativeElement.value = displayExpression;
            }
            // Provide nlp i18n values to the overlay service
            this._nlpOverlayService.setTokenI18nValuesMap(this.nlpParser.getTokenI18nValuesMap());
        }
    }
    /** @ignore shows the option list when the input is focused or the user types in **/
    _watchAutocompleteAction() {
        // create some listeners
        const keyup$ = fromEvent(this.filterInput.nativeElement, 'keyup').pipe(
        // if text is entered, make sure to remember to reparse the expression (in case the last event is a non text char like ENTER)
        tap((event) => this._inputKeypressReparseExpressionSubject.next(this._inputKeypressReparseExpressionSubject.value || ![DOWN_ARROW, UP_ARROW, ENTER, TAB, ESCAPE].includes(event.keyCode))), debounceTime(this.debounceTimeMs));
        const mousedown$ = fromEvent(this.filterInput.nativeElement, 'mousedown');
        const mouseup$ = fromEvent(this.filterInput.nativeElement, 'mouseup');
        const documentMouseup$ = fromEvent(this._document, 'mouseup');
        // record when the mouse is being pressed while focus is in the input text
        const mousePressedSubject$ = new BehaviorSubject(false);
        mousedown$.pipe(takeUntil(this._componentDestroyed$)).subscribe(() => mousePressedSubject$.next(true));
        documentMouseup$
            .pipe(takeUntil(this._componentDestroyed$))
            .pipe(filter(() => mousePressedSubject$.getValue()))
            .subscribe(() => mousePressedSubject$.next(false));
        // only listen to focus when the mouse is not being pressed (avoid double focus event processing
        // when focused via mouse click)
        const focus$ = fromEvent(this.filterInput.nativeElement, 'focus').pipe(filter(() => !mousePressedSubject$.getValue()), 
        // there is a bug where focus event does not hold the cursor position
        // (https://bugs.chromium.org/p/chromium/issues/detail?id=526516) so add
        // a tiny delay
        delay(1));
        merge(this._recheckExpressionSubject.asObservable().pipe(delay(1)), keyup$.pipe(filter(() => !this.disabled), filter((event) => !!this._inputKeypressReparseExpressionSubject.value || ![DOWN_ARROW, UP_ARROW, ENTER, TAB, ESCAPE].includes(event.keyCode)), map((event) => event.target.value), map((expression) => ({ expression }))), focus$.pipe(filter(() => !this.disabled), map((event) => event.target.value), map((expression) => ({ expression }))), mouseup$.pipe(filter(() => !this.disabled && this._focused), map((event) => event.target.value), map((expression) => ({ expression }))))
            .pipe(
        // debounce needed to avoid double once focused programmatically
        debounceTime(10), 
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        switchMap(({ expression, keepOverlayOpened }) => {
            // reset the list and mark the component as loading
            this.filteredOptions = [];
            this._loadingSubject.next(true);
            this.changeDetector.detectChanges();
            // sometimes we dont want to close an overlay until we are sure that will change
            // for example the time picker should stay opened when a time unit (minute) is selected
            if (!keepOverlayOpened) {
                this.connectedElementOpened = false;
                this.overlayTemplate = null;
                this.changeDetector.detectChanges();
            }
            // parse the expression
            this._parseExpression(expression);
            // get the suggestions
            // now get the token suggestion for the expression up to the current cursor position
            try {
                return this.nlpParser.getFilterSuggestions(this.fullExpressionInfo, this.partialExpressionInfo).pipe(first(), catchError((err) => {
                    console.warn('Error getting suggestions', err);
                    return of([]);
                }));
            }
            catch (err) {
                console.warn('Error getting suggestions', err);
                return of([]);
            }
        }), takeUntil(this._componentDestroyed$))
            .subscribe((suggestionsResult) => {
            this.expressionSuggestionsResult = suggestionsResult;
            // provide the new suggestions result to the overlay service
            this._nlpOverlayService.setExpressionSuggestionsResult(suggestionsResult);
            const currentField = suggestionsResult.currentFieldExpression ? suggestionsResult.currentFieldExpression.field : null;
            const currentOperator = suggestionsResult.currentFieldExpression ? suggestionsResult.currentFieldExpression.operator : null;
            const currentValues = suggestionsResult.currentFieldExpression ? suggestionsResult.currentFieldExpression.values : null;
            // find exact match first
            let directive = currentField ? this.overlayDirectiveQL.toArray().find((d) => currentField.tokenType.name === d.tokenType.name) : null;
            if (!directive) {
                directive = currentField ? this.overlayDirectiveQL.toArray().find((d) => tokenMatcher(currentField, d.tokenType)) : null;
            }
            const currentFullValues = suggestionsResult.currentFullFieldExpression ? suggestionsResult.currentFullFieldExpression.values : null;
            const currentValueCompleted = directive && directive.isValueCompleted(currentValues, currentFullValues);
            const isExpressionValueEdited = !!currentField && !!currentOperator && !currentValueCompleted;
            this.overlayTemplate = directive && isExpressionValueEdited ? directive.templateRef : null;
            // if there is an overlay template for the current field, use it
            if (this.overlayTemplate) {
                this.connectedElementOpened = true;
            }
            else {
                // otherwise use the regular option list to display the suggestions
                const options = suggestionsResult.tokenSuggestions.map((s) => ({
                    value: s.value,
                    label: s.label,
                    group: s.group,
                    data: {
                        value: s.value,
                        label: s.label,
                        showSuggestion: s.showSuggestion,
                        autoAppendAfter: s.autoAppendAfter,
                        isNextToken: s.isNextToken,
                        icon: s.icon,
                    },
                }));
                this.filteredOptions = options ? options.filter((o) => o.data.showSuggestion) : [];
                // if there are options, open the option list
                const filteredOptionLength = this.filteredOptions ? this.filteredOptions.length : 0;
                if (filteredOptionLength > 0) {
                    this.connectedElementOpened = true;
                    // make the first option active if a partially entered value was entered
                    this.autoActiveFirstOption = this.expressionSuggestionsResult.autocompleteSuggestionFiltered;
                }
            }
            this._inputKeypressReparseExpressionSubject.next(false);
            this._loadingSubject.next(false);
            this.changeDetector.detectChanges();
        });
    }
    /** @ignore Parses/checks the display expression entered **/
    _parseExpression(expression) {
        // if the native input is null its because its not initialized yet
        const cursorPosition = !this.inputNativeElement ? expression.length : this.inputNativeElement.selectionEnd < 0 ? expression.length : this.inputNativeElement.selectionEnd;
        if (expression === this._previousExpression && cursorPosition === this._previousCursorPosition) {
            return;
        }
        // first parse the full expression
        this.fullExpressionInfo = this.nlpParser.updateExpression(expression);
        // then parse the partial expression (if cursor not at end)
        if (this.hasPartialExpression) {
            this.partialExpressionInfo = this.nlpParser.updateExpression(expression.substring(0, cursorPosition));
        }
        else {
            this.partialExpressionInfo = null;
        }
        const lexErrors = [];
        const parseErrors = [];
        // process any error
        // lex errors
        this.fullExpressionInfo.errors.lex.forEach((e) => {
            lexErrors.push(JSON.stringify(e.message).replace(new RegExp('\\\\n', 'g'), '<br>'));
        });
        // parse errors
        this.fullExpressionInfo.errors.parse.forEach((e) => {
            parseErrors.push(JSON.stringify(e.message).replace(new RegExp('\\\\n', 'g'), '<br>'));
        });
        this.errors = [...lexErrors, ...parseErrors];
        this._previousExpression = expression;
        this._previousCursorPosition = cursorPosition;
        // update the component value
        this.value = this.fullExpressionInfo.native.apiExpression;
        this.displayValue = expression;
        this.propagateChange(this.fullExpressionInfo.native.apiExpression);
        // emit the nativeExpression change
        this.expressionChanged.emit({
            valid: !this.hasErrors,
            nativeExpression: this.fullExpressionInfo.native.apiExpression,
            displayExpression: expression,
        });
    }
    /** When an option is selected in the option list **/
    onSelectOption(selectedOption) {
        const suggestion = selectedOption.data;
        this._updateFieldExpressionValue(suggestion.value, suggestion.autoAppendAfter, suggestion.isNextToken);
    }
    /** @ignore Called when the value of the current field expression is updated **/
    _updateFieldExpressionValue(value, autoAppendAfter, isNextToken, cursorRepositionOffset = 0, keepOverlayOpened = false) {
        const cursorPosition = this._previousCursorPosition;
        const hasMoreTextAfterCursor = this.inputNativeElement.value.substring(cursorPosition).trim().length > 0;
        const replaceIndexOffset = isNextToken ? 1 : 0;
        const tokenReplaceIndexes = this.nlpParser.getIndexesOfTokensToReplace(this.fullExpressionInfo, this.partialExpressionInfo, this.expressionSuggestionsResult);
        // rebuild the expression from the tokens
        const rebuildTokens = this.fullExpressionInfo.display ? this.fullExpressionInfo.display.tokens : this.fullExpressionInfo.native.tokens;
        let newExpression = '';
        const appendAfter = !hasMoreTextAfterCursor ? autoAppendAfter || '' : '';
        let newCursorPosition;
        let suggestionAppended = false;
        for (let i = 0; i < rebuildTokens.length; i++) {
            const token = rebuildTokens[i];
            if (!isNextToken && tokenReplaceIndexes.includes(i - replaceIndexOffset)) {
                if (!suggestionAppended) {
                    newExpression += (i > 0 ? ' ' : '') + value + (appendAfter ? ' ' + appendAfter : '') + (!hasMoreTextAfterCursor ? ' ' : '');
                    newCursorPosition = token.startOffset + value.length;
                    suggestionAppended = true;
                }
            }
            else {
                newExpression += (i > 0 ? ' ' : '') + token.image;
            }
        }
        if (!suggestionAppended) {
            // append at the cursor position
            const textBeforeCursor = newExpression.substring(0, cursorPosition);
            const textAfterCursor = newExpression.substring(cursorPosition);
            const leadingSpace = textBeforeCursor.trim().length > 0 ? ' ' : '';
            // dont auto append space after if we there is a cursor reposition offset
            const textToAppend = leadingSpace + value + (appendAfter ? ' ' + appendAfter : '') + (cursorRepositionOffset === 0 ? ' ' : '');
            // we also want to reposition the caret at the center of the auto appended value so calculate
            // the offset
            const appendAfterOffset = appendAfter.trim().length > 0 ? Math.floor(appendAfter.length / 2) + 1 : 0;
            newExpression = textBeforeCursor.trim() + textToAppend + trimLeft(textAfterCursor);
            newCursorPosition = (textBeforeCursor.trim() + textToAppend).length - appendAfterOffset;
        }
        // add the cursor position offset (this is usually set by the custom overlay to be able to
        // reposition at the end of the value token so that more overlays can be displayed to complete
        // the value rather than the next token suggestion e.g. Time picker once a date was selected
        newCursorPosition += cursorRepositionOffset;
        // update the value of the input
        this.inputNativeElement.value = newExpression;
        // if the option was selected from the list by clicking, refocus the input (focus was lost by
        // clicking on the list) to trigger the recheck of nativeExpression. If it already focused (auto
        // appened or TAB from the list, then manually trigger the recheck of the nativeExpression
        const isFocused = this._document.activeElement === this.inputNativeElement;
        if (isFocused) {
            this._recheckExpressionSubject.next({
                expression: newExpression,
                keepOverlayOpened,
            });
        }
        else {
            this.inputNativeElement.focus();
            this._recheckExpressionSubject.next({
                expression: newExpression,
                keepOverlayOpened,
            });
        }
        // update the cursor position
        this._setCursorPosition(newCursorPosition);
    }
    /** Updates the cursor position within the input component **/
    _setCursorPosition(index) {
        this.inputNativeElement.selectionStart = index;
        this.inputNativeElement.selectionEnd = index;
    }
    /** When the value is updated by the form api. See FormControl **/
    updateValue(value) {
        this.value = value;
        // the nlp parser may not be initialised yet, we take care of that in ngOnChanges
        if (this.nlpParser) {
            this.displayValue = this.nlpParser.nativeToDisplayExpression(value);
            if (this.filterInput) {
                this.filterInput.nativeElement.value = this.displayValue;
            }
        }
        this.changeDetector.detectChanges();
    }
    /**
     * @ignore override from parent class so we can trigger change detection and run custom code
     * When OnPush strategy is used, inherited Input() change does not trigger ngOnChanges...
     */
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.changeDetector.detectChanges();
    }
    /** Highlights the partially entered text in the option label **/
    replaceItemLabel(option) {
        const partialValue = this.expressionSuggestionsResult.partialValueInfo.partialValue;
        if (!partialValue || !option.label || option.data.isNextToken) {
            return option.label;
        }
        const label = option.label;
        const indexes = [];
        let currentIndex = label.toLowerCase().indexOf(partialValue.toLowerCase());
        if (this.highlightMatchingTextOnlyFirst) {
            if (currentIndex !== -1) {
                indexes.push(currentIndex);
            }
        }
        else {
            while (currentIndex !== -1) {
                indexes.push(currentIndex);
                currentIndex = label.toLowerCase().indexOf(partialValue.toLowerCase(), currentIndex + partialValue.length);
            }
        }
        let res = '';
        currentIndex = 0;
        for (const index of indexes) {
            res += label.substring(currentIndex, index) + '<b>' + label.substring(index, index + partialValue.length) + '</b>';
            currentIndex = index + partialValue.length;
        }
        res += label.substring(currentIndex);
        return res;
    }
    /** return the default icon to display **/
    get filterIcon() {
        if (this.loading) {
            return 'fa:spinner';
        }
        if (!this._isExpressionParsed()) {
            return this.icon;
        }
        // do not set the error icon if the expression is blank and field marked as not required
        if (this.formControl && !this.value && !this._hasRequiredValidator()) {
            return this.icon;
        }
        return this.hasErrors ? 'alert:error' : 'action:done';
    }
    /** @ignore Indicates if the component has a required validator applied to it **/
    _hasRequiredValidator() {
        if (this.formControl.validator) {
            const validator = this.formControl.validator({});
            return validator && validator.required;
        }
        return false;
    }
    /** returns the theme for the icon **/
    get filterIconTheme() {
        if (this.loading || !this._isExpressionParsed()) {
            return null;
        }
        // do not set the theme if the expression is blank and field marked as not required
        if (this.formControl && !this.value && !this._hasRequiredValidator()) {
            return null;
        }
        return this.hasErrors ? ThemeType.DANGER : ThemeType.SUCCESS;
    }
    /** Specifies whether the info tooltip should be displayed when hovering the icon **/
    get showTooltip() {
        return this.enableInfoTooltip && this._isExpressionParsed();
    }
    /** Specifies if the nativeExpression has been parsed **/
    _isExpressionParsed() {
        if (this._isRegularSearchMode()) {
            return false;
        }
        if (this.formControl) {
            return this.formControl.dirty || this.formControl.touched;
        }
        return (this.displayValue || '').length > 0;
    }
    /** Resets the component and nativeExpression **/
    resetExpression() {
        this.updateValue('');
        this._previousExpression = undefined;
        this.errors = undefined;
        if (this.formControl) {
            this.formControl.reset();
        }
        this.changeDetector.detectChanges();
    }
    /** Specifies if the nativeExpression has errors **/
    get hasErrors() {
        if (this._isRegularSearchMode()) {
            return false;
        }
        return this.errors && this.errors.length > 0;
    }
    /** Specifies if component is in the regular seach mode (not using expression - 1 word max) **/
    _isRegularSearchMode() {
        return this.disableNlpFunctionality || (this.enableRegularSearch && this.inputNativeElement && this.inputNativeElement.value.trim().split(' ').length <= 1);
    }
    /** Returns the text to display in the tooltip  **/
    get tooltipText() {
        if (!this.hasErrors) {
            return 'The entered expression is valid';
        }
        return this.errors.join('<br>');
    }
    /** Returns the native input element containing the nativeExpression  **/
    get inputNativeElement() {
        return this.filterInput ? this.filterInput.nativeElement : null;
    }
    /**
     * This is a validator function that will be trigger when the component is used in a form context.
     * It will set the component in an error state if the nativeExpression is not valid
     *
     * @param control
     */
    validate(control) {
        // the control seems to be not ready sometimes so just use the class control (same)
        if (!control || Object.keys(control).length === 0) {
            control = this.formControl;
        }
        if ((this.value || '').length === 0) {
            control.setErrors(null);
            return null;
        }
        let err = null;
        if (this.hasErrors) {
            err = {
                expressionError: {
                    errors: this.errors,
                },
            };
            // custom error message if an custom error function was provided
            if (this.customErrorFn && this.fullExpressionInfo.errors.parse) {
                const expressionInfo = this.fullExpressionInfo.display ? this.fullExpressionInfo.display : this.fullExpressionInfo.native;
                // get the display token for the token in error
                this.fullExpressionInfo.errors.parse.forEach((ex) => {
                    // In the exception returned, we want to set the native token if the native value was entered,
                    // or the display token if the display value was entered
                    // find the index of the token that has an error
                    const index = this.fullExpressionInfo.native.tokens.indexOf(ex.token);
                    // check if we have a matching display token
                    const tokenDisplay = expressionInfo.tokens[index];
                    if (tokenDisplay) {
                        // if we do, compare the actual value entered by the user to determine which token to set in the exception
                        const displayValue = expressionInfo.expression.substring(tokenDisplay.startOffset, tokenDisplay.endOffset + 1);
                        if (displayValue !== ex.token.image) {
                            ex.token = tokenDisplay;
                        }
                    }
                });
                const customErrorMessage = this.customErrorFn(this.fullExpressionInfo.errors.parse, this.expressionSuggestionsResult ? expressionInfo.currentExpressionField : null);
                if (customErrorMessage) {
                    err = {
                        customError: customErrorMessage,
                        ...err,
                    };
                }
            }
        }
        control.setErrors(err);
        return err;
    }
    /** Returns a boolean indicating if the search button can be clicked **/
    get canSearch() {
        if (this.disabled) {
            return false;
        }
        if (this.formControl) {
            return this.formControl.valid;
        }
        return !this.loading && !this.hasErrors;
    }
    /** When the search button is clicked **/
    onSearch() {
        if (this.canSearch) {
            const expression = this._isRegularSearchMode() ? this.value : this.fullExpressionInfo ? this.fullExpressionInfo.native.apiExpression : null;
            this.search.emit({
                expression: expression || '',
                regularSearch: this._isRegularSearchMode(),
            });
        }
    }
    /** Specifies if the component is currently active (hovered or focused) */
    get active() {
        return this._hovered || this._focused;
    }
    /** Specifies if the component is currently active (hovered or focused) */
    get isDisabled() {
        return this.disabled;
    }
    /** Resize the text area to fit the content */
    get hasPartialExpression() {
        if (!this.inputNativeElement) {
            return true;
        }
        return this.inputNativeElement.selectionEnd < this.inputNativeElement.value.length;
    }
    /** Indicates if the component is loading autocomplete data */
    get loading() {
        return this._loadingSubject.value;
    }
    /** @ignore **/
    ngOnDestroy() {
        super.ngOnDestroy();
        this.connectedElementOpened = false;
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpExpressionInputComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: DOCUMENT }, { token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }, { token: NlpOverlayService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: NlpExpressionInputComponent, selector: "avn-nlp-expression-input", inputs: { disableNlpFunctionality: "disableNlpFunctionality", enableRegularSearch: "enableRegularSearch", nlpParser: "nlpParser", label: "label", icon: "icon", buttonPosition: "buttonPosition", showSearchButton: "showSearchButton", enableInfoTooltip: "enableInfoTooltip", placeholder: "placeholder", value: "value", displayValue: "displayValue", connectedOverlayMinWidth: "connectedOverlayMinWidth", connectedOverlayWidth: "connectedOverlayWidth", maxOptionsVisibleInViewport: "maxOptionsVisibleInViewport", debounceTimeMs: "debounceTimeMs", multiline: "multiline", customErrorFn: "customErrorFn" }, outputs: { expressionChanged: "expressionChanged", search: "search" }, host: { properties: { "class.active": "this.active", "class.disabled": "this.isDisabled" } }, providers: [{ provide: FormControlComponent, useExisting: NlpExpressionInputComponent }, NlpOverlayService], queries: [{ propertyName: "overlayDirectiveQL", predicate: NlpSuggestionOverlayDirective }], viewQueries: [{ propertyName: "overlayOrigin", first: true, predicate: ["overlayOrigin"], descendants: true }, { propertyName: "connectedElement", first: true, predicate: ConnectedElementComponent, descendants: true, static: true }, { propertyName: "optionList", first: true, predicate: OptionListComponent, descendants: true }, { propertyName: "filterInput", first: true, predicate: ["filterInput"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div class=\"wrapper\" [class.show-search-btn]=\"showSearchButton\" [class.btn-left]=\"buttonPosition === 'left'\" [class.btn-right]=\"buttonPosition === 'right'\">\n  <div class=\"input-container\" [class.success]=\"!hasErrors\" [class.danger]=\"hasErrors\">\n    <input\n      *ngIf=\"!multiline\"\n      #filterInput\n      [placeholder]=\"placeholder || ''\"\n      type=\"text\"\n      [value]=\"displayValue || ''\"\n      [class.loading]=\"loading\"\n      #overlayOrigin=\"cdkOverlayOrigin\"\n      cdkOverlayOrigin\n      [disabled]=\"disabled\"\n    />\n    <textarea\n      cdkTextareaAutosize\n      cdkAutosizeMinRows=\"1\"\n      cdkAutosizeMaxRows=\"25\"\n      *ngIf=\"multiline\"\n      #filterInput\n      [placeholder]=\"placeholder || ''\"\n      [value]=\"\"\n      [class.loading]=\"loading\"\n      #overlayOrigin=\"cdkOverlayOrigin\"\n      cdkOverlayOrigin\n      [disabled]=\"disabled\"\n      >{{ displayValue || '' }}</textarea\n    >\n    <avn-icon\n      [icon]=\"filterIcon\"\n      [class.has-custom-theme]=\"!!filterIconTheme\"\n      [avnTheme]=\"filterIconTheme\"\n      [rotate]=\"loading\"\n      [avnTooltip]=\"tooltipText\"\n      tooltipPlacement=\"top\"\n      [tooltipDisabled]=\"!showTooltip\"\n    ></avn-icon>\n  </div>\n  <avn-button *ngIf=\"showSearchButton\" [disabled]=\"!canSearch\" [class.disabled]=\"!canSearch\" icon=\"action:search\" (click)=\"onSearch()\"></avn-button>\n</div>\n\n<avn-connected-element\n  [minWidth]=\"connectedOverlayMinWidth\"\n  [width]=\"connectedOverlayWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"connectedElementOpened\"\n  [closeOnOutsideClick]=\"allowCloseOnOutsideClick$ | async\"\n  (clickOutside)=\"connectedElementOpened = $event\"\n>\n  <!-- Note: Putting <ng-content> directly in there does not work... this is a hack with a ng-container to make it work -->\n  <ng-container *ngIf=\"!!overlayTemplate\">\n    <ng-container *ngTemplateOutlet=\"overlayTemplate\"></ng-container>\n  </ng-container>\n\n  <avn-option-list\n    #optionList\n    *ngIf=\"!overlayTemplate\"\n    [virtualization]=\"false\"\n    [autoVirtualizeAfterXOptions]=\"30\"\n    [keyboardNavigationEnabled]=\"connectedElementOpened\"\n    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n    [maxOptionsVisibleInViewport]=\"maxOptionsVisibleInViewport\"\n    [options]=\"filteredOptions\"\n    (optionClicked)=\"onSelectOption($event)\"\n    [optionsTemplate]=\"highlightTextTemplate\"\n    name=\"input\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n\n<!--<ng-template #contentContainer><ng-content></ng-content></ng-template>-->\n\n<ng-template #highlightTextTemplate let-option=\"option\">\n  <div class=\"option-container\">\n    <span [innerHTML]=\"replaceItemLabel(option)\"></span>\n    <avn-icon *ngIf=\"option.data?.icon\" [icon]=\"option.data.icon\" [fontSize]=\"20\"></avn-icon>\n  </div>\n</ng-template>\n", styles: [":host{display:block}:host textarea.cdk-textarea-autosize-measuring-firefox,:host textarea.cdk-textarea-autosize-measuring{height:auto!important;overflow:hidden!important;padding:calc(var(--space-sm) + 3px) var(--space-sm) calc(var(--space-sm) + 3px) var(--space-xxl)!important;box-sizing:content-box!important}:host .wrapper{display:flex;align-items:stretch}:host .wrapper .input-container{display:flex;flex-grow:1;position:relative}:host .wrapper .input-container>input,:host .wrapper .input-container>textarea{outline-style:none;outline-offset:-2px;color:inherit;background:none;border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);display:block;width:100%;margin:0;font-size:var(--text-base);font-weight:400;padding:var(--space-sm) var(--space-sm) var(--space-sm) var(--space-xxl);background-clip:padding-box;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}:host .wrapper .input-container>input::placeholder,:host .wrapper .input-container>textarea::placeholder{color:var(--form-control-placeholder)}:host .wrapper .input-container>input:hover,:host .wrapper .input-container>input:focus,:host .wrapper .input-container>input.focus,:host .wrapper .input-container>textarea:hover,:host .wrapper .input-container>textarea:focus,:host .wrapper .input-container>textarea.focus{border-color:var(--form-control-hover-border)}:host .wrapper .input-container>input:after,:host .wrapper .input-container>input:before,:host .wrapper .input-container>textarea:after,:host .wrapper .input-container>textarea:before{box-sizing:border-box}:host .wrapper .input-container>input.loading,:host .wrapper .input-container>textarea.loading{padding-right:var(--space-xxl)}:host .wrapper .input-container>input{line-height:1.5}:host .wrapper .input-container>textarea{resize:none}:host .wrapper .input-container avn-icon{position:absolute;top:5px;left:.5rem;right:initial}:host .wrapper .input-container avn-icon:not(.has-custom-theme){color:var(--form-control-icon)}:host .wrapper.show-search-btn .input-container input,:host .wrapper.show-search-btn .input-container textarea{border-right-color:transparent!important}:host .wrapper.show-search-btn>avn-button{display:flex}:host .wrapper.show-search-btn>avn-button ::ng-deep button{border-color:var(--form-control-border);opacity:1!important;border-left:none!important}:host .wrapper.show-search-btn>avn-button ::ng-deep button:not(:disabled){background-color:var(--form-control-background)}:host .wrapper.show-search-btn>avn-button ::ng-deep avn-icon{color:var(--form-control-icon);font-size:var(--text-lg)!important}:host .wrapper.show-search-btn.btn-left .input-container{order:2}:host .wrapper.show-search-btn.btn-left .input-container>input,:host .wrapper.show-search-btn.btn-left .input-container>textarea{border-left:0px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important;padding:var(--space-sm) var(--space-xxl) var(--space-sm) var(--space-base)}:host .wrapper.show-search-btn.btn-left .input-container>avn-icon{left:initial;right:.5rem}:host .wrapper.show-search-btn.btn-left>avn-button{order:1}:host .wrapper.show-search-btn.btn-left>avn-button ::ng-deep button{border-top-right-radius:0!important;border-bottom-right-radius:0!important}:host .wrapper.show-search-btn.btn-right .input-container{order:1}:host .wrapper.show-search-btn.btn-right .input-container>input,:host .wrapper.show-search-btn.btn-right .input-container>textarea{border-right:0px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important;line-height:1.3}:host .wrapper.show-search-btn.btn-right>avn-button{order:2}:host .wrapper.show-search-btn.btn-right>avn-button ::ng-deep button{border-top-left-radius:0!important;border-bottom-left-radius:0!important;padding:var(--space-xs) var(--space-md)}:host.disabled input,:host.disabled textarea{border-color:var(--form-control-border)!important}:host:disabled,:host:disabled:hover,:host:disabled:focus,:host.disabled,:host.disabled:hover,:host.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-left-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-left-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-right-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-right-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-top-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-top-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-bottom-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-bottom-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-left-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-left-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-right-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-right-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-top-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-top-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-bottom-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-bottom-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .show-search-btn ::ng-deep button,:host.validation-theme.ng-valid.ng-dirty .show-search-btn ::ng-deep button{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .show-search-btn ::ng-deep button,:host.validation-theme.ng-invalid.ng-dirty .show-search-btn ::ng-deep button{border-color:var(--danger-base)!important}:host.active:not(.disabled) .wrapper .input-container input,:host.active:not(.disabled) .wrapper .input-container textarea{border-color:var(--form-control-hover-border)}:host.active:not(.disabled) .wrapper.show-search-btn>avn-button:not(.disabled) ::ng-deep button{background-color:var(--form-control-hover-border);border-top-color:var(--form-control-hover-border);border-bottom-color:var(--form-control-hover-border);border-left-color:transparent!important}:host.active:not(.disabled) .wrapper.show-search-btn>avn-button:not(.disabled) ::ng-deep avn-icon{color:var(--form-control-hover-icon)}:host label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host label.disabled{opacity:.3}.option-container{display:flex;align-items:center;justify-content:space-between;width:100%}.option-container>span{overflow:hidden;text-overflow:ellipsis}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "component", type: OptionListComponent, selector: "avn-option-list", inputs: ["optionsTemplate", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "options", "selectionMode", "showCheckbox", "selectedOptions", "enableGroups"], outputs: ["optionClicked", "optionActivated", "selectionsChanged"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "directive", type: TooltipDirective, selector: "[avnTooltip]", inputs: ["avnTooltip", "tooltipName", "tooltipTemplate", "templateContext", "tooltipTheme", "tooltipPlacement", "tooltipMaxWidth", "tooltipDisabled", "tooltipTrigger", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipMouseLeaveCloseDelay", "tooltipMouseEnterOpenDelay"], outputs: ["show", "hide"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }, { kind: "directive", type: i11.CdkTextareaAutosize, selector: "textarea[cdkTextareaAutosize]", inputs: ["cdkAutosizeMinRows", "cdkAutosizeMaxRows", "cdkTextareaAutosize", "placeholder"], exportAs: ["cdkTextareaAutosize"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpExpressionInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-nlp-expression-input', providers: [{ provide: FormControlComponent, useExisting: NlpExpressionInputComponent }, NlpOverlayService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div class=\"wrapper\" [class.show-search-btn]=\"showSearchButton\" [class.btn-left]=\"buttonPosition === 'left'\" [class.btn-right]=\"buttonPosition === 'right'\">\n  <div class=\"input-container\" [class.success]=\"!hasErrors\" [class.danger]=\"hasErrors\">\n    <input\n      *ngIf=\"!multiline\"\n      #filterInput\n      [placeholder]=\"placeholder || ''\"\n      type=\"text\"\n      [value]=\"displayValue || ''\"\n      [class.loading]=\"loading\"\n      #overlayOrigin=\"cdkOverlayOrigin\"\n      cdkOverlayOrigin\n      [disabled]=\"disabled\"\n    />\n    <textarea\n      cdkTextareaAutosize\n      cdkAutosizeMinRows=\"1\"\n      cdkAutosizeMaxRows=\"25\"\n      *ngIf=\"multiline\"\n      #filterInput\n      [placeholder]=\"placeholder || ''\"\n      [value]=\"\"\n      [class.loading]=\"loading\"\n      #overlayOrigin=\"cdkOverlayOrigin\"\n      cdkOverlayOrigin\n      [disabled]=\"disabled\"\n      >{{ displayValue || '' }}</textarea\n    >\n    <avn-icon\n      [icon]=\"filterIcon\"\n      [class.has-custom-theme]=\"!!filterIconTheme\"\n      [avnTheme]=\"filterIconTheme\"\n      [rotate]=\"loading\"\n      [avnTooltip]=\"tooltipText\"\n      tooltipPlacement=\"top\"\n      [tooltipDisabled]=\"!showTooltip\"\n    ></avn-icon>\n  </div>\n  <avn-button *ngIf=\"showSearchButton\" [disabled]=\"!canSearch\" [class.disabled]=\"!canSearch\" icon=\"action:search\" (click)=\"onSearch()\"></avn-button>\n</div>\n\n<avn-connected-element\n  [minWidth]=\"connectedOverlayMinWidth\"\n  [width]=\"connectedOverlayWidth\"\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"connectedElementOpened\"\n  [closeOnOutsideClick]=\"allowCloseOnOutsideClick$ | async\"\n  (clickOutside)=\"connectedElementOpened = $event\"\n>\n  <!-- Note: Putting <ng-content> directly in there does not work... this is a hack with a ng-container to make it work -->\n  <ng-container *ngIf=\"!!overlayTemplate\">\n    <ng-container *ngTemplateOutlet=\"overlayTemplate\"></ng-container>\n  </ng-container>\n\n  <avn-option-list\n    #optionList\n    *ngIf=\"!overlayTemplate\"\n    [virtualization]=\"false\"\n    [autoVirtualizeAfterXOptions]=\"30\"\n    [keyboardNavigationEnabled]=\"connectedElementOpened\"\n    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n    [maxOptionsVisibleInViewport]=\"maxOptionsVisibleInViewport\"\n    [options]=\"filteredOptions\"\n    (optionClicked)=\"onSelectOption($event)\"\n    [optionsTemplate]=\"highlightTextTemplate\"\n    name=\"input\"\n  >\n  </avn-option-list>\n</avn-connected-element>\n\n<!--<ng-template #contentContainer><ng-content></ng-content></ng-template>-->\n\n<ng-template #highlightTextTemplate let-option=\"option\">\n  <div class=\"option-container\">\n    <span [innerHTML]=\"replaceItemLabel(option)\"></span>\n    <avn-icon *ngIf=\"option.data?.icon\" [icon]=\"option.data.icon\" [fontSize]=\"20\"></avn-icon>\n  </div>\n</ng-template>\n", styles: [":host{display:block}:host textarea.cdk-textarea-autosize-measuring-firefox,:host textarea.cdk-textarea-autosize-measuring{height:auto!important;overflow:hidden!important;padding:calc(var(--space-sm) + 3px) var(--space-sm) calc(var(--space-sm) + 3px) var(--space-xxl)!important;box-sizing:content-box!important}:host .wrapper{display:flex;align-items:stretch}:host .wrapper .input-container{display:flex;flex-grow:1;position:relative}:host .wrapper .input-container>input,:host .wrapper .input-container>textarea{outline-style:none;outline-offset:-2px;color:inherit;background:none;border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);display:block;width:100%;margin:0;font-size:var(--text-base);font-weight:400;padding:var(--space-sm) var(--space-sm) var(--space-sm) var(--space-xxl);background-clip:padding-box;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}:host .wrapper .input-container>input::placeholder,:host .wrapper .input-container>textarea::placeholder{color:var(--form-control-placeholder)}:host .wrapper .input-container>input:hover,:host .wrapper .input-container>input:focus,:host .wrapper .input-container>input.focus,:host .wrapper .input-container>textarea:hover,:host .wrapper .input-container>textarea:focus,:host .wrapper .input-container>textarea.focus{border-color:var(--form-control-hover-border)}:host .wrapper .input-container>input:after,:host .wrapper .input-container>input:before,:host .wrapper .input-container>textarea:after,:host .wrapper .input-container>textarea:before{box-sizing:border-box}:host .wrapper .input-container>input.loading,:host .wrapper .input-container>textarea.loading{padding-right:var(--space-xxl)}:host .wrapper .input-container>input{line-height:1.5}:host .wrapper .input-container>textarea{resize:none}:host .wrapper .input-container avn-icon{position:absolute;top:5px;left:.5rem;right:initial}:host .wrapper .input-container avn-icon:not(.has-custom-theme){color:var(--form-control-icon)}:host .wrapper.show-search-btn .input-container input,:host .wrapper.show-search-btn .input-container textarea{border-right-color:transparent!important}:host .wrapper.show-search-btn>avn-button{display:flex}:host .wrapper.show-search-btn>avn-button ::ng-deep button{border-color:var(--form-control-border);opacity:1!important;border-left:none!important}:host .wrapper.show-search-btn>avn-button ::ng-deep button:not(:disabled){background-color:var(--form-control-background)}:host .wrapper.show-search-btn>avn-button ::ng-deep avn-icon{color:var(--form-control-icon);font-size:var(--text-lg)!important}:host .wrapper.show-search-btn.btn-left .input-container{order:2}:host .wrapper.show-search-btn.btn-left .input-container>input,:host .wrapper.show-search-btn.btn-left .input-container>textarea{border-left:0px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important;padding:var(--space-sm) var(--space-xxl) var(--space-sm) var(--space-base)}:host .wrapper.show-search-btn.btn-left .input-container>avn-icon{left:initial;right:.5rem}:host .wrapper.show-search-btn.btn-left>avn-button{order:1}:host .wrapper.show-search-btn.btn-left>avn-button ::ng-deep button{border-top-right-radius:0!important;border-bottom-right-radius:0!important}:host .wrapper.show-search-btn.btn-right .input-container{order:1}:host .wrapper.show-search-btn.btn-right .input-container>input,:host .wrapper.show-search-btn.btn-right .input-container>textarea{border-right:0px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important;line-height:1.3}:host .wrapper.show-search-btn.btn-right>avn-button{order:2}:host .wrapper.show-search-btn.btn-right>avn-button ::ng-deep button{border-top-left-radius:0!important;border-bottom-left-radius:0!important;padding:var(--space-xs) var(--space-md)}:host.disabled input,:host.disabled textarea{border-color:var(--form-control-border)!important}:host:disabled,:host:disabled:hover,:host:disabled:focus,:host.disabled,:host.disabled:hover,:host.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-left-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-left-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-right-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-right-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-top-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-top-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>input,:host.validation-theme.ng-valid.ng-dirty .input-container>input{border-bottom-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>input,:host.validation-theme.ng-invalid.ng-dirty .input-container>input{border-bottom-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-left-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-left-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-right-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-right-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-top-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-top-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .input-container>textarea,:host.validation-theme.ng-valid.ng-dirty .input-container>textarea{border-bottom-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-container>textarea,:host.validation-theme.ng-invalid.ng-dirty .input-container>textarea{border-bottom-color:var(--danger-base)!important}:host.validation-theme.ng-valid.ng-touched .show-search-btn ::ng-deep button,:host.validation-theme.ng-valid.ng-dirty .show-search-btn ::ng-deep button{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .show-search-btn ::ng-deep button,:host.validation-theme.ng-invalid.ng-dirty .show-search-btn ::ng-deep button{border-color:var(--danger-base)!important}:host.active:not(.disabled) .wrapper .input-container input,:host.active:not(.disabled) .wrapper .input-container textarea{border-color:var(--form-control-hover-border)}:host.active:not(.disabled) .wrapper.show-search-btn>avn-button:not(.disabled) ::ng-deep button{background-color:var(--form-control-hover-border);border-top-color:var(--form-control-hover-border);border-bottom-color:var(--form-control-hover-border);border-left-color:transparent!important}:host.active:not(.disabled) .wrapper.show-search-btn>avn-button:not(.disabled) ::ng-deep avn-icon{color:var(--form-control-hover-icon)}:host label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host label.disabled{opacity:.3}.option-container{display:flex;align-items:center;justify-content:space-between;width:100%}.option-container>span{overflow:hidden;text-overflow:ellipsis}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }, { type: NlpOverlayService }]; }, propDecorators: { overlayDirectiveQL: [{
                type: ContentChildren,
                args: [NlpSuggestionOverlayDirective]
            }], overlayOrigin: [{
                type: ViewChild,
                args: ['overlayOrigin', { static: false }]
            }], connectedElement: [{
                type: ViewChild,
                args: [ConnectedElementComponent, { static: true }]
            }], optionList: [{
                type: ViewChild,
                args: [OptionListComponent, { static: false }]
            }], filterInput: [{
                type: ViewChild,
                args: ['filterInput', { static: false }]
            }], disableNlpFunctionality: [{
                type: Input
            }], enableRegularSearch: [{
                type: Input
            }], nlpParser: [{
                type: Input
            }], label: [{
                type: Input
            }], icon: [{
                type: Input
            }], buttonPosition: [{
                type: Input
            }], showSearchButton: [{
                type: Input
            }], enableInfoTooltip: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], displayValue: [{
                type: Input
            }], connectedOverlayMinWidth: [{
                type: Input
            }], connectedOverlayWidth: [{
                type: Input
            }], maxOptionsVisibleInViewport: [{
                type: Input
            }], debounceTimeMs: [{
                type: Input
            }], multiline: [{
                type: Input
            }], customErrorFn: [{
                type: Input
            }], expressionChanged: [{
                type: Output
            }], search: [{
                type: Output
            }], active: [{
                type: HostBinding,
                args: ['class.active']
            }], isDisabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }] } });

class NlpExpressionInputModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpExpressionInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: NlpExpressionInputModule, declarations: [NlpExpressionInputComponent, NlpSuggestionOverlayDirective], imports: [CommonModule, CoreModule, IconModule, ButtonModule, OptionModule, TooltipModule, ConnectedElementModule, TextFieldModule], exports: [NlpExpressionInputComponent, NlpSuggestionOverlayDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpExpressionInputModule, imports: [CommonModule, CoreModule, IconModule, ButtonModule, OptionModule, TooltipModule, ConnectedElementModule, TextFieldModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpExpressionInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule, ButtonModule, OptionModule, TooltipModule, ConnectedElementModule, TextFieldModule],
                    declarations: [NlpExpressionInputComponent, NlpSuggestionOverlayDirective],
                    exports: [NlpExpressionInputComponent, NlpSuggestionOverlayDirective],
                }]
        }] });

/**
 * Base class for NLP overlay components
 */
class NlpOverlayComponent {
    /** @ignore **/
    constructor(nlpOverlayService) {
        // only emit the new value to the overlay when its field token matches
        this.activated$ = nlpOverlayService.expressionSuggestionsResult$.pipe(filter((res) => res.currentFieldExpression &&
            res.currentFieldExpression.field &&
            res.currentFieldExpression.operator &&
            tokenMatcher(res.currentFieldExpression.field, this.tokenType)), tap((res) => (this.value = this.parseValue(res))));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpOverlayComponent, deps: [{ token: NlpOverlayService }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: NlpOverlayComponent, inputs: { tokenType: "tokenType" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: NlpOverlayComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: NlpOverlayService }]; }, propDecorators: { tokenType: [{
                type: Input
            }] } });

/**
 * The treeview component
 */
class TreeviewComponent {
    /**
     * The dataSource for the component.
     * elements need to implement the ITreeNodeItem interface.
     */
    set dataSource(datasource) {
        if (datasource) {
            this._internalDatasource = this._toInternalDatasource(datasource);
            this._originalDatasource = cloneDeep(datasource);
        }
    }
    /**
     * Those are the selected nodes aka the value of this form control component.
     * This will be updated via reactive forms when used in reactive form context.
     * Otherwise it can be used to directly set the selected values in a non reactive form context.
     */
    set selectedNodeIds(selectedNodeIds) {
        this._updateSelectedNodes(selectedNodeIds);
    }
    get disable() {
        return this.disabled;
    }
    /** Returns an observable of the datasource used for display **/
    get displayDatasource$() {
        return this._displayDatasourceSubject.asObservable();
    }
    get bufferInPx() {
        // Add 100px more to reduce the checkbox rendering flicker when user scroll down
        return this.elementRef.nativeElement.clientHeight + 100;
    }
    constructor(elementRef, renderer, cdr) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdr = cdr;
        /**
         * The text that is displayed in the search box to prompt the user to search
         */
        this.searchPlaceholder = '';
        /**
         * Default height of the entire treeview component in px.
         */
        this.componentHeightInPx = 400;
        /**
         * text to show when there is no data or the search results are empty
         */
        this.emptyListLabel = '';
        /**
         * Enables the selection of multiple items.
         */
        this.multipleSelection = true;
        /**
         * Maximum levels shown in the component
         * important for async usage with a call back implementation since
         * the asyncCallBack is not invoked after this level is reached
         */
        this.maxLevel = 10;
        /**
         * Enables the search box in the treeview.
         * Note: this field is automatically set to false when asyncCallBack is used
         */
        this.showSearch = true;
        /**
         * The first level that is selectable in the treeview.
         * If not provided everything is selectable. Set to 0 to disable
         * selection
         */
        this.firstSelectableLevel = 1;
        /**
         * Enables the checkbox to show only the selected items.
         */
        this.showSelected = false;
        /**
         * Show selected item count at each parent level if there is selection under a parent.
         * If there is no selection under a parent, the count will not be shown even though this field
         * is set to true.
         */
        this.showSelectionCount = false;
        /**
         * Height (in px) of the search input
         */
        this.searchInputHeightInPx = 50;
        /**
         * Height (in px) of the search input
         */
        this.selectedFilterHeightInPx = 50;
        /**
         * Height (in px) of each item in the treeview list
         */
        this.listItemHeightInPx = 50;
        /**
         * Expand icon position. Possible value are 'left' and 'right'. By default, expand icon will appear on the right
         */
        this.expandIconPosition = 'right';
        /** Indicates if parent nodes can be selected.
         * For single selection mode it will allow to actually select the parent node.
         * For multi selection mode it will include the parent node in the selection event nodes
         * **/
        this.enableParentNodeSelection = false;
        // Allow the treeview to be disabled, and when it is make it somewhat transparent.
        this.disabled = false;
        /**
         * Event emitted when an item is selected or unselected.
         * only available on selectable nodes. see firstSelectableLevel input.
         */
        this.selectionChanged = new EventEmitter();
        /**
         * Event emitted when an item is expanded.
         */
        this.itemOpened = new EventEmitter();
        /**
         * Event emitted when an item is collapsed.
         */
        this.itemClosed = new EventEmitter();
        /** The current search text **/
        this.searchText = '';
        /** Indicates if only selected items should be shown **/
        this.showOnlySelectedItems = false;
        /** Indicates if the search box is focused **/
        this.searchBoxFocused = false;
        /** Subject to handle debounce in search text field **/
        this._displayDatasourceSubject = new BehaviorSubject([]);
        /** Subject to handle debounce in search text field **/
        this._searchedSubject = new Subject();
        /** Keeps track of the expanded nodes to be reapplied when filter are cleared **/
        this._expandedNodeIds = [];
        this.componentDestroyed$ = new Subject();
        /** Keeps track of the selected nodes **/
        this._selectedNodes = [];
        /** A function allowing to track the nodes by id for performance **/
        this.idTrackFn = (index, node) => node.id;
        /**
         * Function to call when the selection changes.
         */
        this.propagateChange = (_) => { };
        /**
         * Function to call when the treeview is touched.
         */
        this.propagateTouched = () => { };
    }
    ngOnInit() {
        this.setUpSearchListener();
    }
    ngAfterViewInit() {
        this.resetHeight();
    }
    ngOnChanges({ componentHeightInPx, showSearch, showSelected, asyncCallBack, dataSource }) {
        if (componentHeightInPx && componentHeightInPx.currentValue) {
            this.componentHeightInPx = componentHeightInPx.currentValue;
            this.resetHeight();
        }
        if (showSearch) {
            this.showSearch = this.asyncCallBack && typeof this.asyncCallBack === 'function' ? false : showSearch.currentValue;
            this.resetHeight();
        }
        if (showSelected) {
            this.resetHeight();
        }
        if (asyncCallBack && asyncCallBack.currentValue) {
            this.showSearch = false;
        }
        if (dataSource) {
            this._updateInternalDataSource(this._internalDatasource, this.showOnlySelectedItems, this.searchText);
            this._refreshDisplayDatasource();
            // also reselect all previously selected items
            if (dataSource.currentValue?.length > 0 && this._initialSelectedNodesIds?.length > 0) {
                this._updateSelectedNodes(this._initialSelectedNodesIds);
                this._initialSelectedNodesIds = [];
            }
        }
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    setUpSearchListener() {
        this._searchedSubject.pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.componentDestroyed$)).subscribe((searchText) => {
            this.searchText = searchText;
            this._updateInternalDataSource(this._internalDatasource, this.showOnlySelectedItems, this.searchText);
            this._refreshDisplayDatasource();
        });
    }
    resetHeight() {
        this.renderer.setStyle(this.elementRef.nativeElement, 'height', this.componentHeightInPx === 'auto' ? '100%' : `${this.componentHeightInPx}px`);
    }
    get virtualScrollViewportHeight() {
        let subtract = 0;
        if (this.showSearch) {
            subtract += this.searchInputHeightInPx;
        }
        if (this.showSelected) {
            subtract += this.selectedFilterHeightInPx;
        }
        if (this.componentHeightInPx === 'auto') {
            return `calc(100% - ${subtract}px)`;
        }
        return `${this.componentHeightInPx - subtract}px`;
    }
    /** @ignore Called when a node is clicked **/
    onNodeClicked(event, node) {
        event.preventDefault();
        event.stopPropagation();
        if (this.disabled || node.disabled || !this.isSelectable(node)) {
            return;
        }
        this._toggleNodeSelection(node);
        // refresh the display datasource
        this._refreshDisplayDatasource();
    }
    /** @ignore Called when a node is selected / deselected **/
    _toggleNodeSelection(toggledNode, emitSelection = true) {
        const isParentNode = this.hasChildren(toggledNode);
        if (!this.multipleSelection && !this.enableParentNodeSelection && isParentNode) {
            return;
        }
        // indeterminate is considered as as sub-state of selected
        // toggle the current item selected state
        const newSelectionState = toggledNode.nextSelectionState;
        const nextSelectionState = !toggledNode.nextSelectionState;
        let toggledLeafNodes;
        if (this.multipleSelection) {
            toggledNode.selected = newSelectionState;
            // update the node and propagate the selection state and counts up and down
            toggledLeafNodes = this._propagateNodeSelection(toggledNode, newSelectionState);
        }
        else {
            // deselect all selected leaf nodes
            this._selectedNodes.forEach((selectedNode) => {
                selectedNode.selected = false;
                selectedNode.nextSelectionState = true;
            });
            toggledLeafNodes = [toggledNode];
            toggledNode.selected = newSelectionState;
        }
        // also update the next selection state
        toggledNode.nextSelectionState = nextSelectionState;
        // update selected nodes
        this._selectedNodes = this._internalDatasource.filter((n) => n.selected && (this.enableParentNodeSelection ? true : n.children.length === 0));
        // propagate the form value change + emit selection change if specified
        if (emitSelection) {
            this.propagateChange(this._selectedNodes.map((node) => node.id));
            this.selectionChanged.emit({
                triggerNode: this._toSelectedItem(toggledNode),
                toggledNodes: toggledLeafNodes.map(this._toSelectedItem),
                selectedNodes: this._selectedNodes.map(this._toSelectedItem),
            });
        }
    }
    /**
     * @ignore
     * propagate the selection state of the current node up and down. Also updates the counts
     * Returns the list of the leaf node that were selected/deselected
     * *
     */
    _propagateNodeSelection(rootNode, selected) {
        const toggledLeafNodes = [];
        // update the counts of all children nodes
        // update the selection state of all parents
        // update the counts of all parent nodes
        // make sure to only update filtered items
        // get all flattened children of the toggled node and reverse it (let's start processing by the last tree leaf and up)
        const nodeFlattenedChildren = this._internalDatasource.slice(rootNode.startIndex, rootNode.endIndex + 1).reverse();
        const childrenCountMap = new Map();
        for (const node of nodeFlattenedChildren) {
            const isParentNode = node.children?.length > 0;
            if (isParentNode) {
                // if we have reached a parent node, we have the total count of its children
                node.selectedChildrenCount = childrenCountMap.get(node.id) || 0;
                // make the node indeterminate if its children contains at least one selected or indeterminate, AND are not all selected
                // indeterminate
                const atLeastOneChildSelected = node.children.some((child) => child.selected);
                const allChildFullySelected = node.children.every((child) => child.selected && !child.indeterminate);
                node.selected = atLeastOneChildSelected;
                node.indeterminate = atLeastOneChildSelected && !allChildFullySelected;
                node.nextSelectionState = !node.selected;
            }
            else {
                if (!node.disabled && this._isNodeMatchingFilter(node, this.showOnlySelectedItems, this.searchText)) {
                    const selectionToggled = node.selected !== selected;
                    node.selected = selected;
                    node.nextSelectionState = !node.selected;
                    if (node === rootNode || selectionToggled) {
                        toggledLeafNodes.push(node);
                    }
                }
            }
            // increase the count of items for each parent of 1 (only for leaf nodes)
            if (!isParentNode && node.selected) {
                node.parents?.forEach((parent) => childrenCountMap.set(parent.id, (childrenCountMap.get(parent.id) || 0) + 1));
            }
        }
        [...rootNode.parents].reverse().forEach((parent) => {
            // make the node indeterminate if its children contains at least one selected or indeterminate
            const atLeastOneChildSelected = parent.children.some((child) => child.selected);
            const allChildFullySelected = parent.children.every((child) => child.selected && !child.indeterminate);
            parent.selected = atLeastOneChildSelected;
            parent.indeterminate = atLeastOneChildSelected && !allChildFullySelected;
            parent.nextSelectionState = !parent.selected;
            // update the parent count by summing all of its selecting leaf children + non leaf children selected count
            parent.selectedChildrenCount = parent.children.reduce((p, child) => {
                if (child.children.length === 0) {
                    return p + (child.selected ? 1 : 0);
                }
                return p + (child.selectedChildrenCount || 0);
            }, 0);
        });
        // return the leaf nodes that were toggled (reset in correct order)
        return toggledLeafNodes.reverse();
    }
    expandNode(id) {
        let item = this._internalDatasource.find((node) => node.id === id);
        if (!item || item.expanded) {
            // If item is already expanded, don't do anything
            return;
        }
        this.expandNode(item.parentId);
        // Add node and all its parents into the expandNode list (and remove duplicate)
        this._expandedNodeIds = [...new Set([...this._expandedNodeIds, item.id, ...item.parentIds])];
        item.expanded = true;
        const onChildrenLoaded = (node) => {
            // refresh the display datasource
            this._markAllChildrenAsVisible(item);
            this._refreshDisplayDatasource();
            this.itemOpened.emit({ id: node.id, data: node.data });
        };
        const shouldAsyncLoad = item.hasAsyncChildren && !!this.asyncCallBack;
        if (shouldAsyncLoad) {
            item.loading = true;
            this._refreshDisplayDatasource();
            this.cdr.detectChanges();
            this.asyncCallBack(item)
                .pipe(take(1), tap((childrenNodes) => {
                // update the node in the original data source and recreate our internal datasource
                const node = getNodeById(this._originalDatasource, item.id);
                node.children = childrenNodes;
                node.hasAsyncChildren = false;
                node.expanded = true;
                this._internalDatasource = this._toInternalDatasource(this._originalDatasource);
                // reset the item and continue updating
                item = this._internalDatasource.find((n) => n.id === item.id);
                item.loading = false;
                onChildrenLoaded(item);
                // reselect all previously selected items
                this._updateSelectedNodes(this._selectedNodes.map((n) => n.id));
                this.cdr.detectChanges();
            }), takeUntil(this.componentDestroyed$))
                .subscribe();
        }
        else {
            // no async load required, just expand all items and complete process
            onChildrenLoaded(item);
        }
    }
    /** Collapse a specific node */
    collapseNode(id) {
        const item = this._internalDatasource.find((node) => node.id === id);
        if (!item || !item.expanded) {
            // if item is already collapse, don't do anything
            return;
        }
        this._expandedNodeIds = this._expandedNodeIds.filter((expandedNodeId) => expandedNodeId !== item.id);
        item.expanded = false;
        // if the node was closed, also close all its children
        if (item.children?.length > 0) {
            this._collapseAllChildren(item.children);
        }
        // refresh the display datasource
        this._refreshDisplayDatasource();
        this.itemClosed.emit({ id: item.id, data: item.data });
    }
    /** Called when a node is expanded **/
    toggleNodeExpanded(event, item) {
        // stop propagation of the click to the wrapping item
        event.stopPropagation();
        if (item.expanded) {
            this.collapseNode(item.id);
        }
        else {
            this.expandNode(item.id);
        }
    }
    /** @ignore marks all children that match filter as visible **/
    _markAllChildrenAsVisible(node) {
        node.children.filter((child) => this._isNodeMatchingFilter(child, this.showOnlySelectedItems, this.searchText)).forEach((child) => (child.visible = true));
    }
    /** @ignore Collapses a node and all its children **/
    _collapseAllChildren(children) {
        children.forEach((n) => {
            n.visible = false;
            n.expanded = false;
            this._expandedNodeIds = this._expandedNodeIds.filter((expandedNodeId) => expandedNodeId !== n.id);
            if (n.children?.length > 0) {
                this._collapseAllChildren(n.children);
            }
        });
    }
    onSearchClear() {
        this._searchedSubject.next('');
        this._updateInternalDataSource(this._internalDatasource, this.showOnlySelectedItems, this.searchText);
        this._refreshDisplayDatasource();
    }
    toggleShowOnlySelected() {
        this.showOnlySelectedItems = !this.showOnlySelectedItems;
        this._updateInternalDataSource(this._internalDatasource, this.showOnlySelectedItems, this.searchText);
        this._refreshDisplayDatasource();
    }
    hasFilters() {
        return this.showOnlySelectedItems || this.searchText.length > 0;
    }
    hasChildren(item) {
        return item.children?.length > 0 || (item.hasAsyncChildren && !!this.asyncCallBack);
    }
    isSelectable(item) {
        return this.firstSelectableLevel > 0 && item.level >= this.firstSelectableLevel;
    }
    /**
     * Allows Angular to update the model (selection).
     * Update the model and changes needed for the view here.
     */
    writeValue(selectedNodeIds) {
        this._updateSelectedNodes(selectedNodeIds);
    }
    /**  @ignore updates the selected nodes with the specified ids */
    _updateSelectedNodes(selectedNodeIds) {
        this._initialSelectedNodesIds = selectedNodeIds;
        // if our datasource is empty, do nothing (keep the selected node ids, so they are still available when the async datasource is ready)
        if (this._internalDatasource.length === 0) {
            return;
        }
        selectedNodeIds = selectedNodeIds || [];
        this._selectedNodes = [];
        // deselect all nodes
        this._internalDatasource.forEach((node) => {
            node.selected = false;
            node.nextSelectionState = true;
            node.selectedChildrenCount = 0;
        });
        // find selected nodes
        selectedNodeIds.forEach((nodeId) => {
            const item = this._internalDatasource.find((node) => node.id === nodeId);
            if (item) {
                this._selectedNodes.push(item);
                this._toggleNodeSelection(item, false);
            }
        });
        // we can reset our initial selected nodes ids because the datasource was ready
        this._initialSelectedNodesIds = [];
        // refresh the display datasource
        this._refreshDisplayDatasource();
    }
    /**
     * Allows Angular to register a function to call when the model (selection) changes.
     * Save the function as a property to call later here.
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * Allows Angular to register a function to call when the treeview has been touched.
     * Save the function as a property to call later here.
     */
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
    /**
     * Allows Angular to disable the whole component.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @ignore
     * creates a flattened datasource for internal use.
     * Adds extra information like parent info and indexes to improve performance when applying filters and toggling nodes
     * *
     */
    _toInternalDatasource(dataSource) {
        // Calculate delta changes between datasource and previous datasource
        let previousDatasource = [];
        let currentDatasource = [];
        let addedNode = [];
        let deletedNode = [];
        if (dataSource !== this._originalDatasource) {
            previousDatasource = this._flattenTree(this._originalDatasource).map((e) => e.id);
            currentDatasource = this._flattenTree(dataSource).map((e) => e.id);
            // Check all added node in the new datasource
            addedNode = currentDatasource.filter((item) => !previousDatasource.includes(item));
            deletedNode = previousDatasource.filter((item) => !currentDatasource.includes(item));
            // Remove all the node that has been deleted
            this._expandedNodeIds = this._expandedNodeIds.filter((item) => !deletedNode.includes(item));
        }
        const flattened = [];
        const processItem = (item, level, parents = []) => {
            const itemUuid = item.id ?? v4();
            const res = {
                ...item,
                id: itemUuid,
                level,
                parentId: parents?.length > 0 ? parents[parents.length - 1].id : null,
                parents,
                parentIds: parents.map((p) => p.id),
                data: cloneDeep(item.data),
                loading: false,
                selected: false,
                indeterminate: false,
                nextSelectionState: true,
                children: [],
                startIndex: flattened.length,
                endIndex: null,
                visible: parents.length === 0 || parents[parents.length - 1].expanded || this._expandedNodeIds.includes(parents[parents.length - 1].id),
                // Keep expanded item between 2 changes of the datasource
                expanded: addedNode.find((id) => id === itemUuid) ? item.expanded : this._expandedNodeIds.includes(item.id),
            };
            // If item has been added and is expanded
            if (item.expanded && addedNode.find((id) => id === itemUuid)) {
                this._expandedNodeIds.push(item.id);
            }
            flattened.push(res);
            res.children = item.children?.map((child) => processItem(child, level + 1, [...parents, res])) || [];
            res.endIndex = flattened.length - 1;
            return res;
        };
        dataSource.map((item) => processItem(item, 1));
        return flattened;
    }
    /** @ignore Flatten the tree so all nodes in the tree are in the same array */
    _flattenTree(dataSource = []) {
        const result = [];
        dataSource.forEach((item) => {
            result.push(item);
            // Add children recursively
            if (item.children?.length) {
                result.push(...this._flattenTree(item.children));
            }
        });
        return result;
    }
    /** @ignore Updates the internal datasource with the specified filters **/
    _updateInternalDataSource(datasource, showSelectedOnly, searchFilter) {
        const isFiltered = showSelectedOnly || searchFilter;
        if (!isFiltered) {
            datasource.forEach((node) => {
                const isParentNode = node.parents.length > 0;
                // first level items are always visible
                node.visible = node.parents.length === 0 || !!node.parents[node.parents.length - 1].expanded;
                if (isParentNode) {
                    node.expanded = this._expandedNodeIds.includes(node.id);
                }
            });
            return;
        }
        // reset all nodes to not visible
        datasource.forEach((node) => {
            node.visible = false;
        });
        // only make visible those matching the filter
        // take all leaves selected (exclude parents as they will be automatically included later on)
        const datasourceSubset = datasource.filter((node) => node.children.length === 0 && this._isNodeMatchingFilter(node, showSelectedOnly, searchFilter));
        datasourceSubset.forEach((visibleNode) => {
            // make the node and all its parent visible
            visibleNode.visible = true;
            visibleNode.parents.forEach((parent) => (parent.visible = true));
        });
    }
    /** @ignore refreshes the display datasource from the current internal datasource **/
    _refreshDisplayDatasource() {
        // update the display datasource with only the visible nodes
        this._displayDatasourceSubject.next(this._internalDatasource.filter((node) => node.visible));
    }
    /** @ignore Indicates if the node is matching the specified filters **/
    _isNodeMatchingFilter(node, showSelectedOnly, searchFilter) {
        if (showSelectedOnly && !node.selected) {
            return false;
        }
        if (searchFilter && node.label.toLowerCase().indexOf(searchFilter.toLowerCase()) === -1) {
            return false;
        }
        return true;
    }
    /** Called when the search text changes **/
    onSearchTextInput(event) {
        this._searchedSubject.next(event.target.value || '');
    }
    /** Called when the search box focus changes **/
    onSearchBoxFocused(focused) {
        this.searchBoxFocused = focused;
    }
    /** @ignore **/
    _toSelectedItem(node) {
        return { id: node.id, selected: node.selected, data: cloneDeep(node.data) };
    }
    /** returns the currently selected nodes **/
    get selectedNodes() {
        return this._selectedNodes.map(this._toSelectedItem);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TreeviewComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TreeviewComponent, selector: "avn-treeview", inputs: { searchPlaceholder: "searchPlaceholder", dataSource: "dataSource", componentHeightInPx: "componentHeightInPx", emptyListLabel: "emptyListLabel", multipleSelection: "multipleSelection", maxLevel: "maxLevel", showSearch: "showSearch", firstSelectableLevel: "firstSelectableLevel", asyncCallBack: "asyncCallBack", showSelected: "showSelected", showOnlySelectedItemsLabel: "showOnlySelectedItemsLabel", showSelectionCount: "showSelectionCount", customTemplate: "customTemplate", searchInputHeightInPx: "searchInputHeightInPx", selectedFilterHeightInPx: "selectedFilterHeightInPx", listItemHeightInPx: "listItemHeightInPx", selectedNodeIds: "selectedNodeIds", expandIconPosition: "expandIconPosition", enableParentNodeSelection: "enableParentNodeSelection" }, outputs: { selectionChanged: "selectionChanged", itemOpened: "itemOpened", itemClosed: "itemClosed" }, host: { properties: { "class.disabled": "this.disable" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef((() => TreeviewComponent)),
                multi: true,
            },
        ], viewQueries: [{ propertyName: "searchBox", first: true, predicate: ["searchBox"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  *ngIf=\"showSearch\"\n  class=\"search-item\"\n  [class.focused]=\"searchBoxFocused\"\n  [class.active]=\"!!searchText\"\n  #searchBox\n  [ngStyle]=\"{\n    'height.px': searchInputHeightInPx,\n    'min-height.px': searchInputHeightInPx\n  }\"\n  aria-label=\"search-item\"\n>\n  <avn-icon icon=\"action:search\" class=\"search-icon\"></avn-icon>\n  <input\n    [(ngModel)]=\"searchText\"\n    type=\"text\"\n    [readonly]=\"disabled\"\n    class=\"search-input\"\n    placeholder=\"{{ searchPlaceholder }}\"\n    aria-label=\"search-name\"\n    (keyup)=\"onSearchTextInput($event)\"\n    (focus)=\"onSearchBoxFocused(true)\"\n    (blur)=\"onSearchBoxFocused(false)\"\n  />\n  <avn-icon *ngIf=\"searchText\" class=\"clear-icon\" icon=\"content:clear\" (click)=\"onSearchClear()\"></avn-icon>\n</div>\n\n<div class=\"filters\" *ngIf=\"showSelected\">\n  <avn-checkbox [label]=\"showOnlySelectedItemsLabel\" [checked]=\"showOnlySelectedItems\" (change)=\"!disable && toggleShowOnlySelected()\"></avn-checkbox>\n</div>\n\n<cdk-virtual-scroll-viewport avnScroll [itemSize]=\"listItemHeightInPx\" [minBufferPx]=\"bufferInPx\" [maxBufferPx]=\"bufferInPx\" [style.height]=\"virtualScrollViewportHeight\">\n  <div\n    class=\"vscroll-list-item level{{ item.level }}\"\n    [ngStyle]=\"{ 'height.px': listItemHeightInPx }\"\n    (click)=\"onNodeClicked($event, item)\"\n    [ngClass]=\"{\n      disabled: item.disabled,\n      selected: !multipleSelection && item.selected,\n      'has-children': hasChildren(item)\n    }\"\n    *cdkVirtualFor=\"let item of displayDatasource$ | async; templateCacheSize: 0; trackBy: idTrackFn\"\n  >\n    <div class=\"icon-toggle-container\" [class.expanded]=\"item.expanded\" [class.toggle-left]=\"expandIconPosition === 'left'\">\n      <div\n        *ngIf=\"hasChildren(item) && !this.hasFilters() && item.level < maxLevel && !item.disabled\"\n        class=\"icon-toggle-wrapper\"\n        (click)=\"!disabled && !item.disabled && toggleNodeExpanded($event, item)\"\n      >\n        <avn-icon [icon]=\"item.loading ? 'action:cached' : 'navigation:chevron_right'\" fontSize=\"24\" [rotate]=\"item.loading\"></avn-icon>\n      </div>\n    </div>\n    <avn-checkbox\n      *ngIf=\"multipleSelection && isSelectable(item)\"\n      [attr.data-e2e]=\"item.id\"\n      [checked]=\"item.selected && !item.indeterminate\"\n      [indeterminate]=\"item.indeterminate\"\n      [disabled]=\"item.disabled\"\n      (click)=\"onNodeClicked($event, item)\"\n    >\n    </avn-checkbox>\n    <div class=\"item-wrapper\" [ngClass]=\"{ 'no-cb': !multipleSelection || !isSelectable(item) }\">\n      <ng-container [ngTemplateOutlet]=\"customTemplate ? customTemplate : defaultTemplate\" [ngTemplateOutletContext]=\"{ $implicit: item }\"> </ng-container>\n      <ng-template #defaultTemplate>{{ item.label }}</ng-template>\n      <span class=\"selected-count\" *ngIf=\"showSelectionCount && item.selectedChildrenCount > 0\">&nbsp;({{ item.selectedChildrenCount }})</span>\n    </div>\n  </div>\n</cdk-virtual-scroll-viewport>\n\n<div *ngIf=\"(displayDatasource$ | async).length === 0\" class=\"empty-list-section\" [ngStyle]=\"{ 'top.px': searchInputHeightInPx + 40 }\">\n  <p>\n    {{ emptyListLabel }}\n  </p>\n</div>\n", styles: ["avn-treeview,:host{--selected-background: rgba(0, 0, 0, .25);--selected-color: inherit;width:100%;display:block;position:relative}avn-treeview.disabled,:host.disabled{opacity:.3}avn-treeview.disabled:after,:host.disabled:after{content:\"\";display:block;position:absolute;inset:0;cursor:not-allowed}avn-treeview.theme-primary ::ng-deep avn-checkbox>div>label>svg,:host.theme-primary ::ng-deep avn-checkbox>div>label>svg{fill:var(--primary-base)!important}avn-treeview.theme-secondary ::ng-deep avn-checkbox>div>label>svg,:host.theme-secondary ::ng-deep avn-checkbox>div>label>svg{fill:var(--secondary-base)!important}avn-treeview.theme-highlight ::ng-deep avn-checkbox>div>label>svg,:host.theme-highlight ::ng-deep avn-checkbox>div>label>svg{fill:var(--highlight-base)!important}avn-treeview.theme-danger ::ng-deep avn-checkbox>div>label>svg,:host.theme-danger ::ng-deep avn-checkbox>div>label>svg{fill:var(--danger-base)!important}avn-treeview.theme-warning ::ng-deep avn-checkbox>div>label>svg,:host.theme-warning ::ng-deep avn-checkbox>div>label>svg{fill:var(--warning-base)!important}avn-treeview.theme-info ::ng-deep avn-checkbox>div>label>svg,:host.theme-info ::ng-deep avn-checkbox>div>label>svg{fill:var(--info-base)!important}avn-treeview.theme-success ::ng-deep avn-checkbox>div>label>svg,:host.theme-success ::ng-deep avn-checkbox>div>label>svg{fill:var(--success-base)!important}avn-treeview .filters,:host .filters{display:flex;align-items:center;height:50px;width:100%}avn-treeview .filters:hover,:host .filters:hover{background-color:#0000001a}avn-treeview .filters>::ng-deep avn-checkbox,:host .filters>::ng-deep avn-checkbox{margin-left:var(--space-md)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-primary ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-primary ::ng-deep avn-checkbox>div>label>svg{fill:var(--primary-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-secondary ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-secondary ::ng-deep avn-checkbox>div>label>svg{fill:var(--secondary-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-highlight ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-highlight ::ng-deep avn-checkbox>div>label>svg{fill:var(--highlight-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-danger ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-danger ::ng-deep avn-checkbox>div>label>svg{fill:var(--danger-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-warning ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-warning ::ng-deep avn-checkbox>div>label>svg{fill:var(--warning-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-info ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-info ::ng-deep avn-checkbox>div>label>svg{fill:var(--info-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-success ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-success ::ng-deep avn-checkbox>div>label>svg{fill:var(--success-base)!important}avn-treeview .filters>::ng-deep avn-checkbox>div label.label-text,:host .filters>::ng-deep avn-checkbox>div label.label-text{margin-left:var(--space-sm)!important;padding-top:var(--space-xs)!important}avn-treeview input.search-input::placeholder,:host input.search-input::placeholder{color:var(--form-control-placeholder)}avn-treeview .cdk-virtual-scroll-content-wrapper,:host .cdk-virtual-scroll-content-wrapper{bottom:0}avn-treeview cdk-virtual-scroll-viewport,:host cdk-virtual-scroll-viewport{height:100%;width:100%;display:block;position:relative}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item,:host cdk-virtual-scroll-viewport .vscroll-list-item{display:flex;padding-right:var(--space-md);position:relative;justify-content:flex-start;align-items:center;border-bottom:1px solid rgba(0,0,0,.12);z-index:1}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container{opacity:.7;display:flex;justify-content:flex-end;margin-right:var(--space-xs);width:calc(var(--space-xs) * 2 + 24px);order:3}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.toggle-left,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.toggle-left{order:0}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper{padding:var(--space-xs);border-radius:50%;transition:background-color .15s cubic-bezier(0,0,.2,1)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon{position:relative;z-index:2;-webkit-user-select:none;user-select:none}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i{transition:transform .15s cubic-bezier(0,0,.2,1)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded{opacity:1}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper{background-color:#ffffff0d}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper avn-icon>::ng-deep i,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper avn-icon>::ng-deep i{transform:rotate(90deg)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container:hover .icon-toggle-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container:hover .icon-toggle-wrapper{background-color:#ffffff1a}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper{height:100%;position:relative;z-index:2;flex:1 1 auto;margin:0;padding:0;text-overflow:ellipsis;flex-grow:2;white-space:nowrap;display:flex;align-items:center}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper.no-cb,:host cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper.no-cb{padding-left:var(--space-base)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:first-child,:host cdk-virtual-scroll-viewport .vscroll-list-item:first-child{border-top:1px solid rgba(0,0,0,.12);border-bottom:1px solid rgba(0,0,0,.12)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item>::ng-deep avn-checkbox,:host cdk-virtual-scroll-viewport .vscroll-list-item>::ng-deep avn-checkbox{position:relative;z-index:2;height:24px;margin:0 var(--space-sm) 0 var(--space-md);cursor:pointer;line-height:1rem}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled):before,:host cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled):before{content:\"\";display:block;position:absolute;inset:0;background-color:var(--selected-background);color:var(--selected-color);z-index:0}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled),:host cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled){cursor:pointer}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled) ::ng-deep avn-checkbox>div>input[type=checkbox]:before,:host cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled) ::ng-deep avn-checkbox>div>input[type=checkbox]:before{border-color:inherit}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.selected,:host cdk-virtual-scroll-viewport .vscroll-list-item.selected{background-color:var(--selected-background);color:var(--selected-color)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.disabled>p,:host cdk-virtual-scroll-viewport .vscroll-list-item.disabled>p{opacity:.3}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox],:host cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox]{cursor:no-drop}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox]:not(:checked):before,:host cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox]:not(:checked):before{border-color:#f2f2f2}avn-treeview cdk-virtual-scroll-viewport .level1,:host cdk-virtual-scroll-viewport .level1{padding-left:0}avn-treeview cdk-virtual-scroll-viewport .level2,:host cdk-virtual-scroll-viewport .level2{padding-left:var(--space-lg)}avn-treeview cdk-virtual-scroll-viewport .level3,:host cdk-virtual-scroll-viewport .level3{padding-left:calc(var(--space-lg) * 2)}avn-treeview cdk-virtual-scroll-viewport .level4,:host cdk-virtual-scroll-viewport .level4{padding-left:calc(var(--space-lg) * 3)}avn-treeview cdk-virtual-scroll-viewport .level5,:host cdk-virtual-scroll-viewport .level5{padding-left:calc(var(--space-lg) * 4)}avn-treeview cdk-virtual-scroll-viewport .level6,:host cdk-virtual-scroll-viewport .level6{padding-left:calc(var(--space-lg) * 5)}avn-treeview cdk-virtual-scroll-viewport .level7,:host cdk-virtual-scroll-viewport .level7{padding-left:calc(var(--space-lg) * 6)}avn-treeview cdk-virtual-scroll-viewport .level8,:host cdk-virtual-scroll-viewport .level8{padding-left:calc(var(--space-lg) * 7)}avn-treeview cdk-virtual-scroll-viewport .level9,:host cdk-virtual-scroll-viewport .level9{padding-left:calc(var(--space-lg) * 8)}avn-treeview cdk-virtual-scroll-viewport .level10,:host cdk-virtual-scroll-viewport .level10{padding-left:calc(var(--space-lg) * 9)}avn-treeview .empty-list-section,:host .empty-list-section{left:0;bottom:0;right:0;display:flex;justify-content:center;align-content:flex-start;align-items:flex-start;position:absolute}avn-treeview .search-item,:host .search-item{position:relative;padding:0;display:flex;align-items:center}avn-treeview .search-item .search-icon,:host .search-item .search-icon{margin-left:var(--space-md)}avn-treeview .search-item avn-icon,:host .search-item avn-icon{opacity:.7}avn-treeview .search-item avn-icon.clear-icon,:host .search-item avn-icon.clear-icon{justify-self:end;margin-right:var(--space-md);cursor:pointer}avn-treeview .search-item input.search-input,:host .search-item input.search-input{background-color:transparent;color:inherit;width:100%;border-style:none;padding-left:var(--space-sm)}avn-treeview .search-item:hover,avn-treeview .search-item.focused,avn-treeview .search-item.active,:host .search-item:hover,:host .search-item.focused,:host .search-item.active{background-color:#0000001a}avn-treeview .search-item:hover avn-icon,avn-treeview .search-item.focused avn-icon,avn-treeview .search-item.active avn-icon,:host .search-item:hover avn-icon,:host .search-item.focused avn-icon,:host .search-item.active avn-icon{opacity:1}avn-treeview .icon-spacer,:host .icon-spacer{height:24px;width:24px}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "component", type: CheckboxComponent, selector: "avn-checkbox", inputs: ["label", "indeterminate", "checked"], outputs: ["cbChange"] }, { kind: "directive", type: i2.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i2.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i2.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TreeviewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-treeview', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => TreeviewComponent)),
                            multi: true,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  *ngIf=\"showSearch\"\n  class=\"search-item\"\n  [class.focused]=\"searchBoxFocused\"\n  [class.active]=\"!!searchText\"\n  #searchBox\n  [ngStyle]=\"{\n    'height.px': searchInputHeightInPx,\n    'min-height.px': searchInputHeightInPx\n  }\"\n  aria-label=\"search-item\"\n>\n  <avn-icon icon=\"action:search\" class=\"search-icon\"></avn-icon>\n  <input\n    [(ngModel)]=\"searchText\"\n    type=\"text\"\n    [readonly]=\"disabled\"\n    class=\"search-input\"\n    placeholder=\"{{ searchPlaceholder }}\"\n    aria-label=\"search-name\"\n    (keyup)=\"onSearchTextInput($event)\"\n    (focus)=\"onSearchBoxFocused(true)\"\n    (blur)=\"onSearchBoxFocused(false)\"\n  />\n  <avn-icon *ngIf=\"searchText\" class=\"clear-icon\" icon=\"content:clear\" (click)=\"onSearchClear()\"></avn-icon>\n</div>\n\n<div class=\"filters\" *ngIf=\"showSelected\">\n  <avn-checkbox [label]=\"showOnlySelectedItemsLabel\" [checked]=\"showOnlySelectedItems\" (change)=\"!disable && toggleShowOnlySelected()\"></avn-checkbox>\n</div>\n\n<cdk-virtual-scroll-viewport avnScroll [itemSize]=\"listItemHeightInPx\" [minBufferPx]=\"bufferInPx\" [maxBufferPx]=\"bufferInPx\" [style.height]=\"virtualScrollViewportHeight\">\n  <div\n    class=\"vscroll-list-item level{{ item.level }}\"\n    [ngStyle]=\"{ 'height.px': listItemHeightInPx }\"\n    (click)=\"onNodeClicked($event, item)\"\n    [ngClass]=\"{\n      disabled: item.disabled,\n      selected: !multipleSelection && item.selected,\n      'has-children': hasChildren(item)\n    }\"\n    *cdkVirtualFor=\"let item of displayDatasource$ | async; templateCacheSize: 0; trackBy: idTrackFn\"\n  >\n    <div class=\"icon-toggle-container\" [class.expanded]=\"item.expanded\" [class.toggle-left]=\"expandIconPosition === 'left'\">\n      <div\n        *ngIf=\"hasChildren(item) && !this.hasFilters() && item.level < maxLevel && !item.disabled\"\n        class=\"icon-toggle-wrapper\"\n        (click)=\"!disabled && !item.disabled && toggleNodeExpanded($event, item)\"\n      >\n        <avn-icon [icon]=\"item.loading ? 'action:cached' : 'navigation:chevron_right'\" fontSize=\"24\" [rotate]=\"item.loading\"></avn-icon>\n      </div>\n    </div>\n    <avn-checkbox\n      *ngIf=\"multipleSelection && isSelectable(item)\"\n      [attr.data-e2e]=\"item.id\"\n      [checked]=\"item.selected && !item.indeterminate\"\n      [indeterminate]=\"item.indeterminate\"\n      [disabled]=\"item.disabled\"\n      (click)=\"onNodeClicked($event, item)\"\n    >\n    </avn-checkbox>\n    <div class=\"item-wrapper\" [ngClass]=\"{ 'no-cb': !multipleSelection || !isSelectable(item) }\">\n      <ng-container [ngTemplateOutlet]=\"customTemplate ? customTemplate : defaultTemplate\" [ngTemplateOutletContext]=\"{ $implicit: item }\"> </ng-container>\n      <ng-template #defaultTemplate>{{ item.label }}</ng-template>\n      <span class=\"selected-count\" *ngIf=\"showSelectionCount && item.selectedChildrenCount > 0\">&nbsp;({{ item.selectedChildrenCount }})</span>\n    </div>\n  </div>\n</cdk-virtual-scroll-viewport>\n\n<div *ngIf=\"(displayDatasource$ | async).length === 0\" class=\"empty-list-section\" [ngStyle]=\"{ 'top.px': searchInputHeightInPx + 40 }\">\n  <p>\n    {{ emptyListLabel }}\n  </p>\n</div>\n", styles: ["avn-treeview,:host{--selected-background: rgba(0, 0, 0, .25);--selected-color: inherit;width:100%;display:block;position:relative}avn-treeview.disabled,:host.disabled{opacity:.3}avn-treeview.disabled:after,:host.disabled:after{content:\"\";display:block;position:absolute;inset:0;cursor:not-allowed}avn-treeview.theme-primary ::ng-deep avn-checkbox>div>label>svg,:host.theme-primary ::ng-deep avn-checkbox>div>label>svg{fill:var(--primary-base)!important}avn-treeview.theme-secondary ::ng-deep avn-checkbox>div>label>svg,:host.theme-secondary ::ng-deep avn-checkbox>div>label>svg{fill:var(--secondary-base)!important}avn-treeview.theme-highlight ::ng-deep avn-checkbox>div>label>svg,:host.theme-highlight ::ng-deep avn-checkbox>div>label>svg{fill:var(--highlight-base)!important}avn-treeview.theme-danger ::ng-deep avn-checkbox>div>label>svg,:host.theme-danger ::ng-deep avn-checkbox>div>label>svg{fill:var(--danger-base)!important}avn-treeview.theme-warning ::ng-deep avn-checkbox>div>label>svg,:host.theme-warning ::ng-deep avn-checkbox>div>label>svg{fill:var(--warning-base)!important}avn-treeview.theme-info ::ng-deep avn-checkbox>div>label>svg,:host.theme-info ::ng-deep avn-checkbox>div>label>svg{fill:var(--info-base)!important}avn-treeview.theme-success ::ng-deep avn-checkbox>div>label>svg,:host.theme-success ::ng-deep avn-checkbox>div>label>svg{fill:var(--success-base)!important}avn-treeview .filters,:host .filters{display:flex;align-items:center;height:50px;width:100%}avn-treeview .filters:hover,:host .filters:hover{background-color:#0000001a}avn-treeview .filters>::ng-deep avn-checkbox,:host .filters>::ng-deep avn-checkbox{margin-left:var(--space-md)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-primary ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-primary ::ng-deep avn-checkbox>div>label>svg{fill:var(--primary-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-secondary ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-secondary ::ng-deep avn-checkbox>div>label>svg{fill:var(--secondary-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-highlight ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-highlight ::ng-deep avn-checkbox>div>label>svg{fill:var(--highlight-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-danger ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-danger ::ng-deep avn-checkbox>div>label>svg{fill:var(--danger-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-warning ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-warning ::ng-deep avn-checkbox>div>label>svg{fill:var(--warning-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-info ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-info ::ng-deep avn-checkbox>div>label>svg{fill:var(--info-base)!important}avn-treeview .filters>::ng-deep avn-checkbox.theme-success ::ng-deep avn-checkbox>div>label>svg,:host .filters>::ng-deep avn-checkbox.theme-success ::ng-deep avn-checkbox>div>label>svg{fill:var(--success-base)!important}avn-treeview .filters>::ng-deep avn-checkbox>div label.label-text,:host .filters>::ng-deep avn-checkbox>div label.label-text{margin-left:var(--space-sm)!important;padding-top:var(--space-xs)!important}avn-treeview input.search-input::placeholder,:host input.search-input::placeholder{color:var(--form-control-placeholder)}avn-treeview .cdk-virtual-scroll-content-wrapper,:host .cdk-virtual-scroll-content-wrapper{bottom:0}avn-treeview cdk-virtual-scroll-viewport,:host cdk-virtual-scroll-viewport{height:100%;width:100%;display:block;position:relative}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item,:host cdk-virtual-scroll-viewport .vscroll-list-item{display:flex;padding-right:var(--space-md);position:relative;justify-content:flex-start;align-items:center;border-bottom:1px solid rgba(0,0,0,.12);z-index:1}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container{opacity:.7;display:flex;justify-content:flex-end;margin-right:var(--space-xs);width:calc(var(--space-xs) * 2 + 24px);order:3}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.toggle-left,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.toggle-left{order:0}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper{padding:var(--space-xs);border-radius:50%;transition:background-color .15s cubic-bezier(0,0,.2,1)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon{position:relative;z-index:2;-webkit-user-select:none;user-select:none}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container .icon-toggle-wrapper avn-icon>::ng-deep i{transition:transform .15s cubic-bezier(0,0,.2,1)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded{opacity:1}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper{background-color:#ffffff0d}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper avn-icon>::ng-deep i,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container.expanded .icon-toggle-wrapper avn-icon>::ng-deep i{transform:rotate(90deg)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container:hover .icon-toggle-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item .icon-toggle-container:hover .icon-toggle-wrapper{background-color:#ffffff1a}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper,:host cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper{height:100%;position:relative;z-index:2;flex:1 1 auto;margin:0;padding:0;text-overflow:ellipsis;flex-grow:2;white-space:nowrap;display:flex;align-items:center}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper.no-cb,:host cdk-virtual-scroll-viewport .vscroll-list-item>.item-wrapper.no-cb{padding-left:var(--space-base)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:first-child,:host cdk-virtual-scroll-viewport .vscroll-list-item:first-child{border-top:1px solid rgba(0,0,0,.12);border-bottom:1px solid rgba(0,0,0,.12)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item>::ng-deep avn-checkbox,:host cdk-virtual-scroll-viewport .vscroll-list-item>::ng-deep avn-checkbox{position:relative;z-index:2;height:24px;margin:0 var(--space-sm) 0 var(--space-md);cursor:pointer;line-height:1rem}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled):before,:host cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled):before{content:\"\";display:block;position:absolute;inset:0;background-color:var(--selected-background);color:var(--selected-color);z-index:0}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled),:host cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled){cursor:pointer}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled) ::ng-deep avn-checkbox>div>input[type=checkbox]:before,:host cdk-virtual-scroll-viewport .vscroll-list-item:hover:not(.disabled) ::ng-deep avn-checkbox>div>input[type=checkbox]:before{border-color:inherit}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.selected,:host cdk-virtual-scroll-viewport .vscroll-list-item.selected{background-color:var(--selected-background);color:var(--selected-color)}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.disabled>p,:host cdk-virtual-scroll-viewport .vscroll-list-item.disabled>p{opacity:.3}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox],:host cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox]{cursor:no-drop}avn-treeview cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox]:not(:checked):before,:host cdk-virtual-scroll-viewport .vscroll-list-item.disabled:hover>input[type=checkbox]:not(:checked):before{border-color:#f2f2f2}avn-treeview cdk-virtual-scroll-viewport .level1,:host cdk-virtual-scroll-viewport .level1{padding-left:0}avn-treeview cdk-virtual-scroll-viewport .level2,:host cdk-virtual-scroll-viewport .level2{padding-left:var(--space-lg)}avn-treeview cdk-virtual-scroll-viewport .level3,:host cdk-virtual-scroll-viewport .level3{padding-left:calc(var(--space-lg) * 2)}avn-treeview cdk-virtual-scroll-viewport .level4,:host cdk-virtual-scroll-viewport .level4{padding-left:calc(var(--space-lg) * 3)}avn-treeview cdk-virtual-scroll-viewport .level5,:host cdk-virtual-scroll-viewport .level5{padding-left:calc(var(--space-lg) * 4)}avn-treeview cdk-virtual-scroll-viewport .level6,:host cdk-virtual-scroll-viewport .level6{padding-left:calc(var(--space-lg) * 5)}avn-treeview cdk-virtual-scroll-viewport .level7,:host cdk-virtual-scroll-viewport .level7{padding-left:calc(var(--space-lg) * 6)}avn-treeview cdk-virtual-scroll-viewport .level8,:host cdk-virtual-scroll-viewport .level8{padding-left:calc(var(--space-lg) * 7)}avn-treeview cdk-virtual-scroll-viewport .level9,:host cdk-virtual-scroll-viewport .level9{padding-left:calc(var(--space-lg) * 8)}avn-treeview cdk-virtual-scroll-viewport .level10,:host cdk-virtual-scroll-viewport .level10{padding-left:calc(var(--space-lg) * 9)}avn-treeview .empty-list-section,:host .empty-list-section{left:0;bottom:0;right:0;display:flex;justify-content:center;align-content:flex-start;align-items:flex-start;position:absolute}avn-treeview .search-item,:host .search-item{position:relative;padding:0;display:flex;align-items:center}avn-treeview .search-item .search-icon,:host .search-item .search-icon{margin-left:var(--space-md)}avn-treeview .search-item avn-icon,:host .search-item avn-icon{opacity:.7}avn-treeview .search-item avn-icon.clear-icon,:host .search-item avn-icon.clear-icon{justify-self:end;margin-right:var(--space-md);cursor:pointer}avn-treeview .search-item input.search-input,:host .search-item input.search-input{background-color:transparent;color:inherit;width:100%;border-style:none;padding-left:var(--space-sm)}avn-treeview .search-item:hover,avn-treeview .search-item.focused,avn-treeview .search-item.active,:host .search-item:hover,:host .search-item.focused,:host .search-item.active{background-color:#0000001a}avn-treeview .search-item:hover avn-icon,avn-treeview .search-item.focused avn-icon,avn-treeview .search-item.active avn-icon,:host .search-item:hover avn-icon,:host .search-item.focused avn-icon,:host .search-item.active avn-icon{opacity:1}avn-treeview .icon-spacer,:host .icon-spacer{height:24px;width:24px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { searchBox: [{
                type: ViewChild,
                args: ['searchBox', { static: false }]
            }], searchPlaceholder: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], componentHeightInPx: [{
                type: Input
            }], emptyListLabel: [{
                type: Input
            }], multipleSelection: [{
                type: Input
            }], maxLevel: [{
                type: Input
            }], showSearch: [{
                type: Input
            }], firstSelectableLevel: [{
                type: Input
            }], asyncCallBack: [{
                type: Input
            }], showSelected: [{
                type: Input
            }], showOnlySelectedItemsLabel: [{
                type: Input
            }], showSelectionCount: [{
                type: Input
            }], customTemplate: [{
                type: Input
            }], searchInputHeightInPx: [{
                type: Input
            }], selectedFilterHeightInPx: [{
                type: Input
            }], listItemHeightInPx: [{
                type: Input
            }], selectedNodeIds: [{
                type: Input
            }], expandIconPosition: [{
                type: Input
            }], enableParentNodeSelection: [{
                type: Input
            }], disable: [{
                type: HostBinding,
                args: ['class.disabled']
            }], selectionChanged: [{
                type: Output
            }], itemOpened: [{
                type: Output
            }], itemClosed: [{
                type: Output
            }] } });

class TreeviewModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TreeviewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TreeviewModule, declarations: [TreeviewComponent], imports: [CommonModule, CoreModule, CheckboxModule, ScrollingModule, FormsModule, IconModule], exports: [TreeviewComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TreeviewModule, imports: [CommonModule, CoreModule, CheckboxModule, ScrollingModule, FormsModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TreeviewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, CheckboxModule, ScrollingModule, FormsModule, IconModule],
                    declarations: [TreeviewComponent],
                    exports: [TreeviewComponent],
                }]
        }] });

var ContextMenuPlacementTypes;
(function (ContextMenuPlacementTypes) {
    ContextMenuPlacementTypes["top"] = "top";
    ContextMenuPlacementTypes["bottom"] = "bottom";
    ContextMenuPlacementTypes["left"] = "left";
    ContextMenuPlacementTypes["right"] = "right";
    ContextMenuPlacementTypes["center"] = "center";
    ContextMenuPlacementTypes["mouseTop"] = "mouseTop";
    ContextMenuPlacementTypes["mouseBottom"] = "mouseBottom";
    ContextMenuPlacementTypes["mouseLeft"] = "mouseLeft";
    ContextMenuPlacementTypes["mouseRight"] = "mouseRight";
})(ContextMenuPlacementTypes || (ContextMenuPlacementTypes = {}));
var ContextMenuTriggerTypes;
(function (ContextMenuTriggerTypes) {
    ContextMenuTriggerTypes["all"] = "all";
    ContextMenuTriggerTypes["click"] = "click";
    ContextMenuTriggerTypes["contextmenu"] = "contextmenu";
})(ContextMenuTriggerTypes || (ContextMenuTriggerTypes = {}));

/**
 * This component is used by context-menu directive to create a context-menu instance
 * it can also been passed with custom template.
 */
class ContextMenuComponent {
    constructor(element) {
        this.element = element;
        /**
         * text that represent context-menu header
         */
        this.header = '';
        /**
         * position strategy
         */
        this.position = ContextMenuPlacementTypes.right;
        /**
         * the theme to apply to the context-menu background
         * Defaults to Primary theme when none specified
         */
        this.contextMenuTheme = ThemeType.PRIMARY;
        /**
         * emit selected item
         */
        this.selectedOption = new EventEmitter();
    }
    onMenuItemClick(item) {
        this.selectedOption.emit(item);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ContextMenuComponent, selector: "avn-context-menu", inputs: { header: "header", position: "position", headerTemplate: "headerTemplate", context: "context", maxWidth: "maxWidth", contextMenuTheme: "contextMenuTheme", dataSource: "dataSource", dataSourceTemplate: "dataSourceTemplate" }, outputs: { selectedOption: "selectedOption" }, host: { properties: { "class": "this.position" } }, ngImport: i0, template: "<div [avnTheme]=\"contextMenuTheme\">\n  <span class=\"arrow\"></span>\n  <div class=\"content\" [ngStyle]=\"{ 'max-width.px': maxWidth }\" [class.with-header]=\"!!headerTemplate || header\">\n    <span *ngIf=\"!headerTemplate && !!header\">{{ header }}</span>\n    <ng-template [ngTemplateOutlet]=\"headerTemplate\" [ngTemplateOutletContext]=\"{ model: context }\"> </ng-template>\n    <ng-container *ngIf=\"!dataSourceTemplate\">\n      <div *ngIf=\"dataSource && dataSource.length > 0\" class=\"list-item\">\n        <div *ngFor=\"let item of dataSource\" [class.disabled]=\"item.disabled\" (click)=\"!item.disabled && onMenuItemClick(item)\">\n          <avn-icon *ngIf=\"item.icon\" icon=\"{{ item.icon }}\" class=\"icon\" [disabled]=\"item.disabled\"></avn-icon>{{ item.label }}\n        </div>\n      </div>\n    </ng-container>\n    <ng-template [ngTemplateOutlet]=\"dataSourceTemplate\"></ng-template>\n  </div>\n</div>\n", styles: [":host>div{background-color:var(--modal-background);color:var(--modal-on);border:1px solid var(--modal-border);z-index:1000;border-radius:.25rem;box-shadow:0 0 11px 2px #0003}:host>div.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host>div.theme-primary .arrow{border-bottom-color:var(--primary-base)}:host>div.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host>div.theme-secondary .arrow{border-bottom-color:var(--secondary-base)}:host>div.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host>div.theme-highlight .arrow{border-bottom-color:var(--highlight-base)}:host>div.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host>div.theme-danger .arrow{border-bottom-color:var(--danger-base)}:host>div.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host>div.theme-warning .arrow{border-bottom-color:var(--warning-base)}:host>div.theme-info{background-color:var(--info-base);color:var(--info-on)}:host>div.theme-info .arrow{border-bottom-color:var(--info-base)}:host>div.theme-success{background-color:var(--success-base);color:var(--success-on)}:host>div.theme-success .arrow{border-bottom-color:var(--success-base)}:host .content{padding:var(--space-sm) var(--space-md);display:flex;flex-direction:column}:host .content div.list-item{font-size:var(--text-sm);font-weight:500}:host .content div.list-item>div{display:flex;padding:var(--space-sm) var(--space-xs);border-radius:3px}:host .content div.list-item>div.disabled{opacity:.5;cursor:not-allowed}:host .content div.list-item>div:not(.disabled):hover{background-color:var(--selection-component-hover-background);color:var(--selection-component-hover-on);cursor:pointer}:host .content div.list-item>div>avn-icon{font-size:var(--text-md)!important;padding-right:var(--space-sm)}:host .content.with-header .list-item{padding-top:var(--space-sm)}:host .arrow{position:absolute;width:0;height:0;border-bottom:5px solid;border-bottom-color:var(--modal-background)}:host .icon{font-size:var(--text-md)}:host span{line-height:1.25rem}:host .icon+span{margin-left:var(--space-sm)}:host.right .icon+span{margin-right:var(--space-sm)}:host .arrow{border-left:5px solid transparent;border-right:5px solid transparent}:host.bottom .arrow{top:-5px;left:calc(50% - 5px)}:host.left .arrow{right:-7px;top:calc(50% - 2px);transform:rotate(90deg)}:host.top .arrow{bottom:-5px;left:calc(50% - 5px);transform:rotate(180deg)}:host.right .arrow{left:-7px;top:calc(50% - 2px);transform:rotate(270deg)}:host.center .arrow{bottom:-4.9px;left:calc(50% - 5px);transform:rotate(180deg)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-context-menu', template: "<div [avnTheme]=\"contextMenuTheme\">\n  <span class=\"arrow\"></span>\n  <div class=\"content\" [ngStyle]=\"{ 'max-width.px': maxWidth }\" [class.with-header]=\"!!headerTemplate || header\">\n    <span *ngIf=\"!headerTemplate && !!header\">{{ header }}</span>\n    <ng-template [ngTemplateOutlet]=\"headerTemplate\" [ngTemplateOutletContext]=\"{ model: context }\"> </ng-template>\n    <ng-container *ngIf=\"!dataSourceTemplate\">\n      <div *ngIf=\"dataSource && dataSource.length > 0\" class=\"list-item\">\n        <div *ngFor=\"let item of dataSource\" [class.disabled]=\"item.disabled\" (click)=\"!item.disabled && onMenuItemClick(item)\">\n          <avn-icon *ngIf=\"item.icon\" icon=\"{{ item.icon }}\" class=\"icon\" [disabled]=\"item.disabled\"></avn-icon>{{ item.label }}\n        </div>\n      </div>\n    </ng-container>\n    <ng-template [ngTemplateOutlet]=\"dataSourceTemplate\"></ng-template>\n  </div>\n</div>\n", styles: [":host>div{background-color:var(--modal-background);color:var(--modal-on);border:1px solid var(--modal-border);z-index:1000;border-radius:.25rem;box-shadow:0 0 11px 2px #0003}:host>div.theme-primary{background-color:var(--primary-base);color:var(--primary-on)}:host>div.theme-primary .arrow{border-bottom-color:var(--primary-base)}:host>div.theme-secondary{background-color:var(--secondary-base);color:var(--secondary-on)}:host>div.theme-secondary .arrow{border-bottom-color:var(--secondary-base)}:host>div.theme-highlight{background-color:var(--highlight-base);color:var(--highlight-on)}:host>div.theme-highlight .arrow{border-bottom-color:var(--highlight-base)}:host>div.theme-danger{background-color:var(--danger-base);color:var(--danger-on)}:host>div.theme-danger .arrow{border-bottom-color:var(--danger-base)}:host>div.theme-warning{background-color:var(--warning-base);color:var(--warning-on)}:host>div.theme-warning .arrow{border-bottom-color:var(--warning-base)}:host>div.theme-info{background-color:var(--info-base);color:var(--info-on)}:host>div.theme-info .arrow{border-bottom-color:var(--info-base)}:host>div.theme-success{background-color:var(--success-base);color:var(--success-on)}:host>div.theme-success .arrow{border-bottom-color:var(--success-base)}:host .content{padding:var(--space-sm) var(--space-md);display:flex;flex-direction:column}:host .content div.list-item{font-size:var(--text-sm);font-weight:500}:host .content div.list-item>div{display:flex;padding:var(--space-sm) var(--space-xs);border-radius:3px}:host .content div.list-item>div.disabled{opacity:.5;cursor:not-allowed}:host .content div.list-item>div:not(.disabled):hover{background-color:var(--selection-component-hover-background);color:var(--selection-component-hover-on);cursor:pointer}:host .content div.list-item>div>avn-icon{font-size:var(--text-md)!important;padding-right:var(--space-sm)}:host .content.with-header .list-item{padding-top:var(--space-sm)}:host .arrow{position:absolute;width:0;height:0;border-bottom:5px solid;border-bottom-color:var(--modal-background)}:host .icon{font-size:var(--text-md)}:host span{line-height:1.25rem}:host .icon+span{margin-left:var(--space-sm)}:host.right .icon+span{margin-right:var(--space-sm)}:host .arrow{border-left:5px solid transparent;border-right:5px solid transparent}:host.bottom .arrow{top:-5px;left:calc(50% - 5px)}:host.left .arrow{right:-7px;top:calc(50% - 2px);transform:rotate(90deg)}:host.top .arrow{bottom:-5px;left:calc(50% - 5px);transform:rotate(180deg)}:host.right .arrow{left:-7px;top:calc(50% - 2px);transform:rotate(270deg)}:host.center .arrow{bottom:-4.9px;left:calc(50% - 5px);transform:rotate(180deg)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { header: [{
                type: Input
            }], position: [{
                type: HostBinding,
                args: ['class']
            }, {
                type: Input
            }], headerTemplate: [{
                type: Input
            }], context: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], contextMenuTheme: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], dataSourceTemplate: [{
                type: Input
            }], selectedOption: [{
                type: Output
            }] } });

const CONNECTED_POSITION_RIGHT = {
    name: ContextMenuPlacementTypes.right,
    position: {
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
        offsetX: 5,
    },
};
const CONNECTED_POSITION_LEFT = {
    name: ContextMenuPlacementTypes.left,
    position: {
        originX: 'start',
        originY: 'center',
        overlayX: 'end',
        overlayY: 'center',
        offsetX: -5,
    },
};
const CONNECTED_POSITION_TOP = {
    name: ContextMenuPlacementTypes.top,
    position: {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: -5,
    },
};
const CONNECTED_POSITION_BOTTOM = {
    name: ContextMenuPlacementTypes.bottom,
    position: {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
        offsetY: 5,
    },
};
const CONNECTED_POSITION_CENTER = {
    name: ContextMenuPlacementTypes.center,
    position: {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
    },
};
const CONNECTED_POSITION_MOUSE_RIGHT = {
    name: ContextMenuPlacementTypes.right,
    position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'center',
    },
};
const CONNECTED_POSITION_MOUSE_LEFT = {
    name: ContextMenuPlacementTypes.left,
    position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'center',
    },
};
const CONNECTED_POSITION_MOUSE_TOP = {
    name: ContextMenuPlacementTypes.top,
    position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
    },
};
const CONNECTED_POSITION_MOUSE_BOTTOM = {
    name: ContextMenuPlacementTypes.bottom,
    position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'top',
    },
};
const findConnectedPositionName = (position) => {
    let name;
    switch (position) {
        case CONNECTED_POSITION_TOP.position:
            name = CONNECTED_POSITION_TOP.name;
            break;
        case CONNECTED_POSITION_RIGHT.position:
            name = CONNECTED_POSITION_RIGHT.name;
            break;
        case CONNECTED_POSITION_BOTTOM.position:
            name = CONNECTED_POSITION_BOTTOM.name;
            break;
        case CONNECTED_POSITION_LEFT.position:
            name = CONNECTED_POSITION_LEFT.name;
            break;
        case CONNECTED_POSITION_CENTER.position:
            name = CONNECTED_POSITION_CENTER.name;
            break;
        case CONNECTED_POSITION_MOUSE_TOP.position:
            name = CONNECTED_POSITION_MOUSE_TOP.name;
            break;
        case CONNECTED_POSITION_MOUSE_RIGHT.position:
            name = CONNECTED_POSITION_MOUSE_RIGHT.name;
            break;
        case CONNECTED_POSITION_MOUSE_LEFT.position:
            name = CONNECTED_POSITION_MOUSE_LEFT.name;
            break;
        case CONNECTED_POSITION_MOUSE_BOTTOM.position:
            name = CONNECTED_POSITION_MOUSE_BOTTOM.name;
            break;
        default:
            break;
    }
    return name;
};
const findConnectedPosition = (name) => {
    let position;
    switch (name) {
        case ContextMenuPlacementTypes.top:
            position = CONNECTED_POSITION_TOP.position;
            break;
        case ContextMenuPlacementTypes.right:
            position = CONNECTED_POSITION_RIGHT.position;
            break;
        case ContextMenuPlacementTypes.bottom:
            position = CONNECTED_POSITION_BOTTOM.position;
            break;
        case ContextMenuPlacementTypes.left:
            position = CONNECTED_POSITION_LEFT.position;
            break;
        case ContextMenuPlacementTypes.center:
            position = CONNECTED_POSITION_CENTER.position;
            break;
        case ContextMenuPlacementTypes.mouseBottom:
            position = CONNECTED_POSITION_MOUSE_BOTTOM.position;
            break;
        case ContextMenuPlacementTypes.mouseLeft:
            position = CONNECTED_POSITION_MOUSE_LEFT.position;
            break;
        case ContextMenuPlacementTypes.mouseRight:
            position = CONNECTED_POSITION_MOUSE_RIGHT.position;
            break;
        case ContextMenuPlacementTypes.mouseTop:
            position = CONNECTED_POSITION_MOUSE_TOP.position;
            break;
        default:
            break;
    }
    return position;
};

class ContextMenuService {
    constructor() {
        this.attachedContextMenus = [];
    }
    getContextMenuDir() {
        return this.attachedContextMenus;
    }
    setContextMenuDir(contextMenuDir) {
        this.attachedContextMenus.push(contextMenuDir);
    }
    hideAllContextMenus() {
        if (this.attachedContextMenus.length > 0) {
            this.attachedContextMenus.forEach((contextMenuDir) => {
                contextMenuDir.hideContextMenu();
            });
            this.attachedContextMenus = [];
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuService, decorators: [{
            type: Injectable
        }] });

class ContextMenuDirective {
    get listensForClick() {
        return this.contextMenuTrigger === ContextMenuTriggerTypes.all || this.contextMenuTrigger === ContextMenuTriggerTypes.click;
    }
    get listensForRightClick() {
        return this.contextMenuTrigger === ContextMenuTriggerTypes.all || this.contextMenuTrigger === ContextMenuTriggerTypes.contextmenu;
    }
    get isMouseRelativePlacement() {
        return [
            ContextMenuPlacementTypes.mouseTop,
            ContextMenuPlacementTypes.mouseBottom,
            ContextMenuPlacementTypes.mouseLeft,
            ContextMenuPlacementTypes.mouseRight,
        ].some((item) => item === this.contextMenuPlacement);
    }
    constructor(contextMenuService, overlay, overlayPositionBuilder, document, elementRef) {
        this.contextMenuService = contextMenuService;
        this.overlay = overlay;
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.document = document;
        this.elementRef = elementRef;
        /**
         * contextMenu header text
         */
        this.contextMenuHeader = '';
        /**
         * menu item dataSource
         */
        this.contextMenuDataSource = [];
        /**
         * contextMenu placement, to be used as the prefered contextMenu position,
         * the position will be changed automatically latter if needed to suit
         * the best position when scroll or window resize.
         */
        this.contextMenuPlacement = ContextMenuPlacementTypes.right;
        /** set the max width of contextMenu */
        this.contextMenuMaxWidth = 300;
        /**
         * contextMenu disabled, won't be triggered
         */
        this.contextMenuDisabled = false;
        /**
         * The type of event that can trigger display of contextMenu:
         * it should be "clicks", "contextmenu" or all
         */
        this.contextMenuTrigger = ContextMenuTriggerTypes.click;
        /**
         * Close contextMenu if mouse clicked outside of contextMenu
         */
        this.contextMenuCloseOnClickOutside = true;
        /** Indicates if the context menu should auto close when an item is selected **/
        this.contextMenuCloseOnItemSelected = false;
        /**
         * output event triggered when contextMenu is displayed
         */
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.show = new EventEmitter();
        /**
         * output event triggered when contextMenu is hide
         */
        this.hide = new EventEmitter();
        /**
         * output selected option (action)
         */
        this.contextMenuSelectedOption = new EventEmitter();
        /**
         * the available contextMenu positions,
         * it will be used dynamically by cdk when window resize
         */
        this.connectedPositions = [
            CONNECTED_POSITION_TOP.position,
            CONNECTED_POSITION_RIGHT.position,
            CONNECTED_POSITION_BOTTOM.position,
            CONNECTED_POSITION_LEFT.position,
            CONNECTED_POSITION_CENTER.position,
        ];
        /**
         * the available contextMenu positions that is mouse relative,
         * it will be used dynamically by cdk when window resize
         */
        this.mouseRelativePositions = [
            CONNECTED_POSITION_MOUSE_TOP.position,
            CONNECTED_POSITION_MOUSE_BOTTOM.position,
            CONNECTED_POSITION_MOUSE_LEFT.position,
            CONNECTED_POSITION_MOUSE_RIGHT.position,
        ];
        this.componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.initContextMenuPosition();
        // build a flexible, sticky overlay position strategy
        this.positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withGrowAfterOpen(true)
            .withPush(false)
            .withFlexibleDimensions(false)
            .withPositions(this.contextMenuPositions);
        this.overlayRef = this.overlay.create({
            positionStrategy: this.positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
        });
        this.componentPortal = new ComponentPortal(ContextMenuComponent);
        this.positionStrategy.positionChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe((positionChange) => {
            if (this.currentConnectedPosition !== positionChange.connectionPair) {
                this.contextMenuRef.instance.position = findConnectedPositionName(positionChange.connectionPair);
                // trigger component instance change detection
                this.contextMenuRef.changeDetectorRef.detectChanges();
                this.currentConnectedPosition = positionChange.connectionPair;
            }
        });
    }
    ngAfterViewInit() {
        // Define offsetY position from the center of the element
        CONNECTED_POSITION_CENTER.position.offsetY = Math.round(this.elementRef.nativeElement.offsetHeight / 2);
        fromEvent(this.elementRef.nativeElement, 'click')
            .pipe(filter(() => !this.contextMenuDisabled && this.listensForClick), takeUntil(this.componentDestroyed$))
            .subscribe((event) => {
            // prevent propagation so its not detected by the body click listener
            event.stopPropagation();
            this.showContextMenu(event);
        });
        fromEvent(this.elementRef.nativeElement, 'contextmenu')
            .pipe(filter(() => !this.contextMenuDisabled && this.listensForRightClick), takeUntil(this.componentDestroyed$))
            .subscribe((event) => {
            // prevent default so its not displaying chrome, firefox context menu
            event.preventDefault();
            // prevent propagation so its not detected by the body right click listener
            event.stopPropagation();
            this.showContextMenu(event);
        });
        fromEvent(this.document, 'click')
            .pipe(filter(() => !this.contextMenuDisabled && (this.listensForClick || this.listensForRightClick) && this.contextMenuCloseOnClickOutside), takeUntil(this.componentDestroyed$))
            .subscribe((event) => {
            if (this.contextMenuRef && this.contextMenuRef.instance && !this.contextMenuRef.instance.element.nativeElement.contains(event.target)) {
                this.hideContextMenu();
                // todo UIC-481 improve to avoid clicks on headers.
            }
            else if (this.contextMenuRef &&
                this.contextMenuRef.instance &&
                this.contextMenuRef.instance.element.nativeElement.contains(event.target) &&
                this.contextMenuCloseOnItemSelected &&
                this.contextMenuDataSourceTemplate) {
                this.hideContextMenu();
            }
        });
    }
    ngOnChanges({ contextMenuDataSource, contextMenuHeaderTemplate, contextMenuDataSourceTemplate, contextMenuPlacement, contextMenuHeader, contextMenuTheme, contextMenuMaxWidth, }) {
        if (contextMenuPlacement && contextMenuPlacement.currentValue) {
            this.initContextMenuPosition();
        }
        if (this.contextMenuRef) {
            if (contextMenuDataSource && contextMenuDataSource.currentValue) {
                this.contextMenuRef.instance.dataSource = contextMenuDataSource.currentValue;
            }
            if (contextMenuHeader && contextMenuHeader.currentValue && !!this.contextMenuRef) {
                this.contextMenuRef.instance.header = this.contextMenuHeader;
            }
            if (contextMenuHeaderTemplate) {
                this.contextMenuRef.instance.headerTemplate = this.contextMenuHeaderTemplate;
                setTimeout(() => {
                    this.overlayRef.updatePosition();
                }, 10);
            }
            if (contextMenuDataSourceTemplate) {
                this.contextMenuRef.instance.dataSourceTemplate = this.contextMenuDataSourceTemplate;
                setTimeout(() => {
                    this.overlayRef.updatePosition();
                }, 10);
            }
            if (contextMenuTheme && contextMenuTheme.currentValue) {
                this.contextMenuRef.instance.contextMenuTheme = this.contextMenuTheme;
            }
            if (contextMenuMaxWidth) {
                this.contextMenuRef.instance.maxWidth = this.contextMenuMaxWidth;
                this.contextMenuRef.changeDetectorRef.detectChanges();
                this.overlayRef.updatePosition();
            }
        }
    }
    hideContextMenu() {
        if (this.contextMenuRef) {
            this.overlayRef.detach();
            this.contextMenuRef.destroy();
            this.contextMenuRef = undefined;
            this.hide.emit(true);
        }
    }
    showContextMenu(event) {
        if (this.contextMenuRef) {
            return;
        }
        this.contextMenuService.hideAllContextMenus();
        this.contextMenuRef = this.overlayRef.attach(this.componentPortal);
        this.contextMenuRef.instance.dataSource = this.contextMenuDataSource;
        this.contextMenuRef.instance.dataSourceTemplate = this.contextMenuDataSourceTemplate;
        this.contextMenuRef.instance.header = this.contextMenuHeader;
        this.contextMenuRef.instance.headerTemplate = this.contextMenuHeaderTemplate;
        this.contextMenuRef.instance.context = this.contextMenuTemplateContext;
        this.contextMenuRef.instance.contextMenuTheme = this.contextMenuTheme;
        this.contextMenuRef.instance.maxWidth = this.contextMenuMaxWidth;
        this.contextMenuRef.instance.position = findConnectedPositionName(this.currentConnectedPosition);
        this.positionStrategy.withPositions(this.contextMenuPositions);
        this.positionStrategy.withDefaultOffsetX(this.isMouseRelativePlacement ? event.offsetX : 0);
        this.positionStrategy.withDefaultOffsetY(this.isMouseRelativePlacement ? event.offsetY : 0);
        setTimeout(() => {
            this.overlayRef.updatePosition();
        }, 100);
        this.show.emit(true);
        // Emit selected option on component instance selection
        this.contextMenuRef.instance.selectedOption.pipe(takeUntil(this.hide)).subscribe((evt) => {
            this.contextMenuSelectedOption.emit(evt);
            if (this.contextMenuCloseOnItemSelected) {
                this.hideContextMenu();
            }
        });
        // track the context menu reference (directive)
        this.contextMenuService.setContextMenuDir(this);
    }
    initContextMenuPosition() {
        this.defaultConnectedPosition = findConnectedPosition(this.contextMenuPlacement);
        this.currentConnectedPosition = this.defaultConnectedPosition;
        if (!this.isMouseRelativePlacement) {
            this.contextMenuPositions = [this.defaultConnectedPosition, ...this.connectedPositions.filter((position) => position !== this.currentConnectedPosition)];
        }
        else {
            this.contextMenuPositions = [
                this.defaultConnectedPosition,
                ...this.mouseRelativePositions.filter((position) => position !== this.currentConnectedPosition),
            ];
        }
        if (!!this.positionStrategy && this.contextMenuRef) {
            this.contextMenuRef.instance.position = findConnectedPositionName(this.currentConnectedPosition);
            this.positionStrategy.withPositions(this.contextMenuPositions);
            this.overlayRef.updatePosition();
        }
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuDirective, deps: [{ token: ContextMenuService }, { token: i1$4.Overlay }, { token: i1$4.OverlayPositionBuilder }, { token: DOCUMENT }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ContextMenuDirective, selector: "[avnContextMenu]", inputs: { contextMenuHeader: ["avnContextMenu", "contextMenuHeader"], contextMenuHeaderTemplate: "contextMenuHeaderTemplate", contextMenuTemplateContext: "contextMenuTemplateContext", contextMenuTheme: "contextMenuTheme", contextMenuDataSource: "contextMenuDataSource", contextMenuDataSourceTemplate: "contextMenuDataSourceTemplate", contextMenuPlacement: "contextMenuPlacement", contextMenuMaxWidth: "contextMenuMaxWidth", contextMenuDisabled: "contextMenuDisabled", contextMenuTrigger: "contextMenuTrigger", contextMenuCloseOnClickOutside: "contextMenuCloseOnClickOutside", contextMenuCloseOnItemSelected: "contextMenuCloseOnItemSelected" }, outputs: { show: "show", hide: "hide", contextMenuSelectedOption: "contextMenuSelectedOption" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[avnContextMenu]' }]
        }], ctorParameters: function () { return [{ type: ContextMenuService }, { type: i1$4.Overlay }, { type: i1$4.OverlayPositionBuilder }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }]; }, propDecorators: { contextMenuHeader: [{
                type: Input,
                args: ['avnContextMenu']
            }], contextMenuHeaderTemplate: [{
                type: Input
            }], contextMenuTemplateContext: [{
                type: Input
            }], contextMenuTheme: [{
                type: Input
            }], contextMenuDataSource: [{
                type: Input
            }], contextMenuDataSourceTemplate: [{
                type: Input
            }], contextMenuPlacement: [{
                type: Input
            }], contextMenuMaxWidth: [{
                type: Input
            }], contextMenuDisabled: [{
                type: Input
            }], contextMenuTrigger: [{
                type: Input
            }], contextMenuCloseOnClickOutside: [{
                type: Input
            }], contextMenuCloseOnItemSelected: [{
                type: Input
            }], show: [{
                type: Output
            }], hide: [{
                type: Output
            }], contextMenuSelectedOption: [{
                type: Output
            }] } });

class ContextMenuModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuModule, declarations: [ContextMenuComponent, ContextMenuDirective], imports: [CommonModule, CoreModule, IconModule], exports: [ContextMenuComponent, ContextMenuDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuModule, providers: [ContextMenuService], imports: [CommonModule, CoreModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ContextMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ContextMenuComponent, ContextMenuDirective],
                    exports: [ContextMenuComponent, ContextMenuDirective],
                    imports: [CommonModule, CoreModule, IconModule],
                    // This service should probably be provided for each directive created
                    providers: [ContextMenuService]
                }]
        }] });

const CALENDAR_CONFIG = new InjectionToken('CALENDAR_CONFIG');
const DEFAULT_CALENDAR_CONFIG = {
    daysSizePx: 40,
    autoFillIncompleteWeeks: true,
    fixedHeight: false,
    firstDayOfWeekPerLocale: { en: 'sun' },
};

/**
 * The calendar component comes with the following features:
 - Can be configured to be either a date, a month or a year picker
 - ability to specify a minimum and maximum selectable date
 - autofill incomplete starting / ending weeks with previous and next month days
 - configure all calendars globally at the app level with the CALENDAR_SETTINGS injection token
 - i18n compatible (labels, first day of week...) - a language observable can be provided via TOKEN injection to have all calendars updated
 when the app language changes (also overridable per calendar)
 - easily configurable theme (days dimensions, background hover colors, active/inactive days backgrounds etc..)
 */
class CalendarComponent {
    get selectedDateIsoString() {
        return this.selectedDateInternal ? dateTimeToString(this.selectedDateInternal, this.timezone) : null;
    }
    /** @ignore **/
    constructor(_elementRef, _calendarConfig, _dateTimeOptions, _changeDetector, _renderer, _dateLocaleService) {
        this._elementRef = _elementRef;
        this._calendarConfig = _calendarConfig;
        this._dateTimeOptions = _dateTimeOptions;
        this._changeDetector = _changeDetector;
        this._renderer = _renderer;
        this._dateLocaleService = _dateLocaleService;
        /** Indicates if days from previous/next months should display to fill the incomplete start/end weeks **/
        this.autoFillIncompleteWeeks = false;
        /** Indicates if the date picker should have a fixed height across all months / views **/
        this.fixedHeight = false;
        /** Specifies the selection mode of the calendar **/
        this.selectionMode = 'day';
        /** Emits when a date is selected **/
        this.selected = new EventEmitter();
        /*** @ignore Pattern used to close all subscriptions */
        this._componentDestroyed$ = new Subject();
        this._dateTimeOptions = {
            ...DEFAULT_DATE_TIME_OPTIONS,
            ...(this._dateTimeOptions || {}),
        };
        this._calendarConfig = {
            ...DEFAULT_CALENDAR_CONFIG,
            ...(this._calendarConfig || {}),
        };
        this.autoFillIncompleteWeeks = this._calendarConfig.autoFillIncompleteWeeks;
        this.fixedHeight = this._calendarConfig.fixedHeight;
        this.timezone = this._dateTimeOptions.timezone;
    }
    /** @ignore **/
    ngOnInit() {
        // set display to today if not set
        this.displayDate = this.displayDate || toZonedDateTime(DateTime.now(), this.timezone).setLocale(this.locale || 'en');
        // set the view mode
        this.view = this.selectionMode || 'day';
        this._elementRef.nativeElement.style.setProperty('--day-size-px', `${this._calendarConfig.daysSizePx}px`);
        // calculate years
        const firstOfYear = this.displayDate.startOf('year');
        this._updateYearRange(firstOfYear);
    }
    /** @ignore **/
    ngAfterViewInit() {
        if (this.fixedHeight) {
            this._renderer.setStyle(this._elementRef.nativeElement, 'height', `${this._elementRef.nativeElement.getBoundingClientRect().height}px`);
        }
        // if no locale was specified, use the locale observable from the global config
        if (!this.locale) {
            this._dateLocaleService.locale$.pipe(takeUntil(this._componentDestroyed$)).subscribe((locale) => {
                this.locale = locale;
                this._updateDays(this.displayDate.month, this.displayDate.year);
                this._changeDetector.detectChanges();
            });
        }
    }
    /** @ignore **/
    ngOnChanges({ selectedDate, locale, minSelectableDate, maxSelectableDate }) {
        // init the display date here because we need the timezone to be available
        this.displayDate = this.displayDate || toZonedDateTime(DateTime.now(), this.timezone).setLocale(this.locale || 'en');
        if (locale) {
            this._updateDays(this.displayDate.month, this.displayDate.year);
        }
        if (selectedDate) {
            this.selectedDateInternal = stringToDateTime(selectedDate.currentValue, this.timezone);
            if (this.selectedDateInternal) {
                this.selectedDateInternal = this.selectedDateInternal.setLocale(this.locale || 'en');
                this.displayDate = this.selectedDateInternal;
            }
            else {
                this.displayDate = this.today;
            }
            this._updateDays(this.displayDate.month, this.displayDate.year);
        }
        if (minSelectableDate) {
            this.minSelectableDateInternal = stringToDateTime(minSelectableDate.currentValue, this.timezone);
        }
        if (maxSelectableDate) {
            this.maxSelectableDateInternal = stringToDateTime(maxSelectableDate.currentValue, this.timezone);
        }
    }
    /**
     * @ignore
     * Updates the display days to the specified month / year
     * *
     */
    _updateDays(month, year) {
        const selectedDate = this.selectedDateInternal || toZonedDateTime(DateTime.now(), this.timezone).setLocale(this.locale || 'en');
        const firstDayOfMonth = selectedDate.set({ year, month }).startOf('month');
        // headings
        this.daysLabels = [];
        // Luxon has no support to determine if the first day of week is sunday or monday. Use the config for now
        // https://github.com/moment/luxon/issues/373#:~:text=While%20most%20countries%20in%20the,start%20of%20week%20as%20Monday..
        // const firstDayOfWeek = firstDayOfMonth.startOf('week'); // not working: always returns monday
        const firstDayOfWeekStr = this._calendarConfig.firstDayOfWeekPerLocale?.[this.locale] || 'mon';
        const firstDayOfWeekAsNumber = (['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].findIndex((d) => d === firstDayOfWeekStr) + 1);
        const firstDayOfWeek = getFirstDayOfWeek(firstDayOfMonth, firstDayOfWeekAsNumber);
        for (let i = 0; i < 7; i++) {
            this.daysLabels.push(firstDayOfWeek.plus({ days: i }).toLocaleString({ weekday: 'short' }));
        }
        // the number of day's rows may vary depending on the month
        const previousMonthDaysCount = firstDayOfMonth.diff(firstDayOfWeek, 'days').days;
        const totalWeeksInMonth = this.fixedHeight ? 6 : Math.ceil((firstDayOfMonth.daysInMonth + previousMonthDaysCount) / 7);
        this._elementRef.nativeElement.style.setProperty('--weeks-count', `${totalWeeksInMonth}`);
        this.days = [];
        const max = totalWeeksInMonth * 7;
        for (let i = 0; i < max; i++) {
            const itemDate = firstDayOfWeek.plus({ day: i });
            this.days.push(itemDate);
        }
        // also update the months
        const firstOfYear = firstDayOfMonth.startOf('year');
        this.months = Array.from(Array(12)).map((_, i) => firstOfYear.plus({ month: i }));
        this.displayDate = firstDayOfMonth;
    }
    /**
     * @ignore
     * Updates the display years from the specified year
     * *
     */
    _updateYearRange(startYear) {
        this.years = Array.from(Array(20)).map((_, i) => startYear.plus({ year: i }));
    }
    // Check if today button is visible
    todayButtonIsVisible() {
        let withinDate = true;
        withinDate =
            (this.minSelectableDateInternal <= this.today || !this.minSelectableDateInternal) && (this.today <= this.maxSelectableDateInternal || !this.maxSelectableDateInternal);
        return withinDate && this.view === 'day';
    }
    /** Returns today's date formatted with timezone **/
    get today() {
        return toZonedDateTime(DateTime.now(), this.timezone).setLocale(this.locale || 'en');
    }
    /** Returns today button's label/text */
    get todayLabel() {
        return new Intl.RelativeTimeFormat(this.locale || 'en', { numeric: 'auto' }).format(0, 'day');
    }
    /** Navigates to the current day/today**/
    showToday() {
        this._updateDays(this.today.month, this.today.year);
        this.onSelectDay(this.today);
    }
    /** Navigates to the previous month **/
    showPreviousMonth() {
        const month = this.displayDate.month - 1 < 0 ? 11 : this.displayDate.month - 1;
        const year = this.displayDate.month - 1 < 0 ? this.displayDate.year - 1 : this.displayDate.year;
        this._updateDays(month, year);
    }
    /** Navigates to the next month **/
    showNextMonth() {
        const month = (this.displayDate.month + 1) % 12;
        const year = this.displayDate.month + 1 >= 12 ? this.displayDate.year + 1 : this.displayDate.year;
        this._updateDays(month, year);
    }
    /** Navigates to the previous year **/
    showPreviousYear() {
        this._updateDays(this.displayDate.month, this.displayDate.year - 1);
    }
    /** Navigates to the next year **/
    showNextYear() {
        this._updateDays(this.displayDate.month, this.displayDate.year + 1);
    }
    /** Navigates to the previous year range **/
    showPreviousYearRange() {
        this._updateYearRange(this.years[0].minus({ year: this.years.length }));
    }
    /** Navigates to the previous year range **/
    showNextYearRange() {
        this._updateYearRange(this.years[this.years.length - 1].plus({ year: 1 }));
    }
    /** Called when a day is picked **/
    onSelectDay(date) {
        this._updateDateSelection(date);
    }
    /** @ignore updates and emits the selected date **/
    _updateDateSelection(date) {
        this.displayDate = date;
        this.selectedDateInternal = date;
        this.selected.emit(dateTimeToString(date, this.timezone));
    }
    /** Returns the month i18n display text **/
    getDisplayMonth(date, format) {
        if (format === 'long') {
            return date.setLocale(this.locale).toLocaleString({ month: 'long' });
        }
        return date.setLocale(this.locale).toLocaleString({ month: 'short' });
    }
    /** Updates the view to the specified view **/
    updateView(view) {
        this.view = view;
    }
    /** Called when the previous navigation arrow is pressed **/
    onNavigatePrevious(view) {
        if (view === 'day') {
            this.showPreviousMonth();
        }
        else if (view === 'month') {
            this.showPreviousYear();
        }
        else if (view === 'year') {
            this.showPreviousYearRange();
        }
    }
    /** Called when the today button is clicked **/
    onNavigateToday() {
        this.showToday();
    }
    /** Called when the next navigation arrow is pressed **/
    onNavigateNext(view) {
        if (view === 'day') {
            this.showNextMonth();
        }
        else if (view === 'month') {
            this.showNextYear();
        }
        else if (view === 'year') {
            this.showNextYearRange();
        }
    }
    /** Called when a month is picked **/
    onSelectMonth(month) {
        this._updateDays(month.month, this.displayDate.year);
        if (this.selectionMode === 'month') {
            this._updateDateSelection(month);
        }
        else {
            this.view = 'day';
        }
    }
    /** Called when a month is picked **/
    onSelectYear(year) {
        this._updateDays(this.displayDate.month, year.year);
        if (this.selectionMode === 'year') {
            this._updateDateSelection(year);
        }
        else {
            this.view = this.selectionMode;
        }
    }
    /** Indicates if the specified date can be selected **/
    isSelectableDate(date, granularity) {
        if (this.minSelectableDateInternal && date.startOf(granularity) < this.minSelectableDateInternal.startOf(granularity)) {
            return false;
        }
        if (this.maxSelectableDateInternal && date.startOf(granularity) > this.maxSelectableDateInternal.startOf(granularity)) {
            return false;
        }
        return true;
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CalendarComponent, deps: [{ token: i0.ElementRef }, { token: CALENDAR_CONFIG, optional: true }, { token: DATE_TIME_OPTIONS }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: DateLocaleService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: CalendarComponent, selector: "avn-calendar", inputs: { selectedDate: "selectedDate", locale: "locale", autoFillIncompleteWeeks: "autoFillIncompleteWeeks", fixedHeight: "fixedHeight", minSelectableDate: "minSelectableDate", maxSelectableDate: "maxSelectableDate", selectionMode: "selectionMode", timezone: "timezone" }, outputs: { selected: "selected" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"header\">\n  <div class=\"current-date\">\n    <span class=\"month highlight\" *ngIf=\"view === 'day'\" (click)=\"updateView('month')\">{{ getDisplayMonth(displayDate, 'long') }}</span>\n    <span class=\"year\" *ngIf=\"view !== 'year'\" [class.highlight]=\"view === 'month'\" (click)=\"updateView('year')\">{{ displayDate.year }}</span>\n    <span class=\"year-range highlight\" *ngIf=\"view === 'year'\">{{ years[0].year }} - {{ years[years.length - 1].year }}</span>\n  </div>\n\n  <div class=\"navigation-today\" *ngIf=\"todayButtonIsVisible()\"><avn-button (click)=\"onNavigateToday()\" [label]=\"todayLabel\" class=\"today-button\"></avn-button></div>\n  <div class=\"navigation\">\n    <avn-icon\n      icon=\"navigation:chevron_left\"\n      [fontSize]=\"32\"\n      avnLongPress\n      (touchstart)=\"onNavigatePrevious(view)\"\n      (mousedown)=\"onNavigatePrevious(view)\"\n      (longPress)=\"onNavigatePrevious(view)\"\n      [longPressIntervalTimeMs]=\"100\"\n    ></avn-icon>\n    <avn-icon\n      icon=\"navigation:chevron_right\"\n      [fontSize]=\"32\"\n      avnLongPress\n      (touchstart)=\"onNavigateNext(view)\"\n      (mousedown)=\"onNavigateNext(view)\"\n      (longPress)=\"onNavigateNext(view)\"\n      [longPressIntervalTimeMs]=\"100\"\n    ></avn-icon>\n  </div>\n</div>\n<div class=\"body\">\n  <ng-container [ngSwitch]=\"view\">\n    <ng-container *ngSwitchCase=\"'day'\">\n      <div class=\"days-heading\">\n        <span *ngFor=\"let heading of daysLabels\">{{ heading }}</span>\n      </div>\n      <div class=\"days-separator\"></div>\n      <div class=\"days\">\n        <div\n          class=\"calendar-item day\"\n          role=\"button\"\n          *ngFor=\"let day of days\"\n          [class.active-month]=\"day.month === displayDate.month\"\n          [class.selectable]=\"isSelectableDate(day, 'day')\"\n          [class.show]=\"autoFillIncompleteWeeks\"\n          [class.today]=\"day.year === today.year && day.ordinal === today.ordinal\"\n          [class.selected]=\"day.year === selectedDateInternal?.year && day.ordinal === selectedDateInternal?.ordinal\"\n          (click)=\"isSelectableDate(day, 'day') && onSelectDay(day)\"\n        >\n          <div class=\"item-wrapper\">\n            <span>{{ day.day }}</span>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'month'\">\n      <div class=\"months\">\n        <div\n          class=\"calendar-item month\"\n          role=\"button\"\n          *ngFor=\"let month of months\"\n          [class.today]=\"month.month === today.month && month.year === today?.year\"\n          [class.selectable]=\"isSelectableDate(month, 'month')\"\n          [class.selected]=\"\n            month.month === (selectionMode === 'month' ? selectedDateInternal : displayDate)?.month &&\n            month.year === (selectionMode === 'month' ? selectedDateInternal : displayDate)?.year\n          \"\n          (click)=\"isSelectableDate(month, 'month') && onSelectMonth(month)\"\n        >\n          <div class=\"item-wrapper\">\n            <span>{{ getDisplayMonth(month, 'short') }}</span>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'year'\">\n      <div class=\"years\">\n        <div\n          class=\"calendar-item year\"\n          role=\"button\"\n          *ngFor=\"let year of years\"\n          [class.today]=\"year.year === today.year\"\n          [class.selectable]=\"this.isSelectableDate(year, 'year')\"\n          [class.selected]=\"year.year === (selectionMode === 'year' ? selectedDateInternal : displayDate)?.year\"\n          (click)=\"this.isSelectableDate(year, 'year') && onSelectYear(year)\"\n        >\n          <div class=\"item-wrapper\">\n            <span>{{ year.year }}</span>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [":host{--weeks-count: 6;--day-size-px: 50px;display:inline-flex;flex-direction:column;background-color:var(--calendar-background);color:var(--calendar-on);border-radius:4px;padding:var(--space-base);transition:height .15s cubic-bezier(0,0,.2,1);width:calc(var(--space-base) * 2 + 7 * var(--day-size-px) + 6px)}:host .header{padding:0px var(--space-sm);display:flex;align-items:flex-start}:host .header>div{flex:1}:host .header>.navigation-today{display:flex;justify-content:center}:host .header>.navigation-today avn-button.today-button ::ng-deep span{text-transform:capitalize}:host .header>.current-date{display:flex;flex-direction:column}:host .header>.current-date span{transition:color .15s cubic-bezier(0,0,.2,1)}:host .header>.current-date span:not(.year-range){cursor:pointer}:host .header>.current-date span:hover:not(.year-range){color:var(--primary-base)}:host .header>.current-date span.month{border-radius:4px}:host .header>.current-date span.year{border-radius:4px}:host .header>.current-date span.highlight{font-size:var(--text-lg)}:host .header>.navigation{display:flex;justify-content:right}:host .header>.navigation avn-icon{cursor:pointer;-webkit-user-select:none;user-select:none;transition:color .15s cubic-bezier(0,0,.2,1)}:host .header>.navigation avn-icon:hover{color:var(--primary-base)}:host .days-separator{border-bottom:1px solid var(--calendar-divider);margin-left:calc(var(--space-base) * -1);margin-right:calc(var(--space-base) * -1)}:host .body{display:flex;flex-direction:column;margin-top:var(--space-lg)}:host .body>.days-heading{display:grid;grid-gap:1px;grid-template-columns:repeat(7,var(--day-size-px));grid-template-rows:var(--day-size-px)}:host .body>.days-heading>span{display:flex;align-items:center;justify-content:center}:host .body .calendar-item{width:100%;display:flex;align-items:center;justify-content:center;padding:var(--space-xs);cursor:default}:host .body .calendar-item:hover.selectable>.item-wrapper{background-color:var(--calendar-hover-background);color:var(--calendar-hover-on)}:host .body .calendar-item>.item-wrapper{height:100%;width:100%;display:flex;align-items:center;justify-content:center;border-radius:50px;transition:background-color .15s cubic-bezier(0,0,.2,1);line-height:var(--day-size-px);padding:0px var(--space-sm)}:host .body .calendar-item.today>.item-wrapper{line-height:calc(var(--day-size-px) - 2px)}:host .body .calendar-item.today:not(.selected)>.item-wrapper{border:1px solid}:host .body .calendar-item.selected>.item-wrapper{background-color:var(--calendar-selected-background)!important;color:var(--calendar-selected-on)!important}:host .body .calendar-item.selectable{cursor:pointer}:host .body .calendar-item:not(.selectable) span{opacity:.5!important}:host .body>.days{margin-top:var(--space-base);display:grid;grid-gap:1px;grid-template-columns:repeat(7,var(--day-size-px));grid-template-rows:repeat(var(--weeks-count),var(--day-size-px))}:host .body>.days>.day.active-month{background-color:var(--calendar-active-month-background);color:var(--calendar-active-month-color)}:host .body>.days>.day:not(.active-month){background-color:var(--calendar-inactive-month-background);color:var(--calendar-inactive-month-color)}:host .body>.days>.day:not(.active-month):not(.today) span{opacity:.5}:host .body>.days>.day:not(.active-month):not(.show){visibility:hidden}:host .body>.months{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:32px 16px;justify-items:center}:host .body>.years{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:8px;justify-items:center}:host .body>.years>.item-wrapper{border-radius:50px 0}:host-context(.dmb-aspect) :host .header>.current-date span:hover:not(.year-range){color:var(--primary-on)}:host-context(.dmb-aspect) :host .header>.navigation avn-icon:hover{color:var(--primary-on)}:host-context(.dmb-aspect) :host .body{margin-top:var(--space-md);border:1px solid rgb(13,13,14)}:host-context(.dmb-aspect) :host .body .days-heading{background:#3a4147}:host-context(.dmb-aspect) :host .body .calendar-item:hover.selectable>.item-wrapper{color:var(--primary-on)}:host-context(.dmb-aspect) :host .body .days-separator{margin-left:0;margin-right:0;border-color:#3a4147}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: LongPressDirective, selector: "[avnLongPress]", inputs: ["longPressStartTimeMs", "longPressIntervalTimeMs", "longPressActive"], outputs: ["longPress", "longPressEnd"] }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CalendarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-calendar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"header\">\n  <div class=\"current-date\">\n    <span class=\"month highlight\" *ngIf=\"view === 'day'\" (click)=\"updateView('month')\">{{ getDisplayMonth(displayDate, 'long') }}</span>\n    <span class=\"year\" *ngIf=\"view !== 'year'\" [class.highlight]=\"view === 'month'\" (click)=\"updateView('year')\">{{ displayDate.year }}</span>\n    <span class=\"year-range highlight\" *ngIf=\"view === 'year'\">{{ years[0].year }} - {{ years[years.length - 1].year }}</span>\n  </div>\n\n  <div class=\"navigation-today\" *ngIf=\"todayButtonIsVisible()\"><avn-button (click)=\"onNavigateToday()\" [label]=\"todayLabel\" class=\"today-button\"></avn-button></div>\n  <div class=\"navigation\">\n    <avn-icon\n      icon=\"navigation:chevron_left\"\n      [fontSize]=\"32\"\n      avnLongPress\n      (touchstart)=\"onNavigatePrevious(view)\"\n      (mousedown)=\"onNavigatePrevious(view)\"\n      (longPress)=\"onNavigatePrevious(view)\"\n      [longPressIntervalTimeMs]=\"100\"\n    ></avn-icon>\n    <avn-icon\n      icon=\"navigation:chevron_right\"\n      [fontSize]=\"32\"\n      avnLongPress\n      (touchstart)=\"onNavigateNext(view)\"\n      (mousedown)=\"onNavigateNext(view)\"\n      (longPress)=\"onNavigateNext(view)\"\n      [longPressIntervalTimeMs]=\"100\"\n    ></avn-icon>\n  </div>\n</div>\n<div class=\"body\">\n  <ng-container [ngSwitch]=\"view\">\n    <ng-container *ngSwitchCase=\"'day'\">\n      <div class=\"days-heading\">\n        <span *ngFor=\"let heading of daysLabels\">{{ heading }}</span>\n      </div>\n      <div class=\"days-separator\"></div>\n      <div class=\"days\">\n        <div\n          class=\"calendar-item day\"\n          role=\"button\"\n          *ngFor=\"let day of days\"\n          [class.active-month]=\"day.month === displayDate.month\"\n          [class.selectable]=\"isSelectableDate(day, 'day')\"\n          [class.show]=\"autoFillIncompleteWeeks\"\n          [class.today]=\"day.year === today.year && day.ordinal === today.ordinal\"\n          [class.selected]=\"day.year === selectedDateInternal?.year && day.ordinal === selectedDateInternal?.ordinal\"\n          (click)=\"isSelectableDate(day, 'day') && onSelectDay(day)\"\n        >\n          <div class=\"item-wrapper\">\n            <span>{{ day.day }}</span>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'month'\">\n      <div class=\"months\">\n        <div\n          class=\"calendar-item month\"\n          role=\"button\"\n          *ngFor=\"let month of months\"\n          [class.today]=\"month.month === today.month && month.year === today?.year\"\n          [class.selectable]=\"isSelectableDate(month, 'month')\"\n          [class.selected]=\"\n            month.month === (selectionMode === 'month' ? selectedDateInternal : displayDate)?.month &&\n            month.year === (selectionMode === 'month' ? selectedDateInternal : displayDate)?.year\n          \"\n          (click)=\"isSelectableDate(month, 'month') && onSelectMonth(month)\"\n        >\n          <div class=\"item-wrapper\">\n            <span>{{ getDisplayMonth(month, 'short') }}</span>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'year'\">\n      <div class=\"years\">\n        <div\n          class=\"calendar-item year\"\n          role=\"button\"\n          *ngFor=\"let year of years\"\n          [class.today]=\"year.year === today.year\"\n          [class.selectable]=\"this.isSelectableDate(year, 'year')\"\n          [class.selected]=\"year.year === (selectionMode === 'year' ? selectedDateInternal : displayDate)?.year\"\n          (click)=\"this.isSelectableDate(year, 'year') && onSelectYear(year)\"\n        >\n          <div class=\"item-wrapper\">\n            <span>{{ year.year }}</span>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [":host{--weeks-count: 6;--day-size-px: 50px;display:inline-flex;flex-direction:column;background-color:var(--calendar-background);color:var(--calendar-on);border-radius:4px;padding:var(--space-base);transition:height .15s cubic-bezier(0,0,.2,1);width:calc(var(--space-base) * 2 + 7 * var(--day-size-px) + 6px)}:host .header{padding:0px var(--space-sm);display:flex;align-items:flex-start}:host .header>div{flex:1}:host .header>.navigation-today{display:flex;justify-content:center}:host .header>.navigation-today avn-button.today-button ::ng-deep span{text-transform:capitalize}:host .header>.current-date{display:flex;flex-direction:column}:host .header>.current-date span{transition:color .15s cubic-bezier(0,0,.2,1)}:host .header>.current-date span:not(.year-range){cursor:pointer}:host .header>.current-date span:hover:not(.year-range){color:var(--primary-base)}:host .header>.current-date span.month{border-radius:4px}:host .header>.current-date span.year{border-radius:4px}:host .header>.current-date span.highlight{font-size:var(--text-lg)}:host .header>.navigation{display:flex;justify-content:right}:host .header>.navigation avn-icon{cursor:pointer;-webkit-user-select:none;user-select:none;transition:color .15s cubic-bezier(0,0,.2,1)}:host .header>.navigation avn-icon:hover{color:var(--primary-base)}:host .days-separator{border-bottom:1px solid var(--calendar-divider);margin-left:calc(var(--space-base) * -1);margin-right:calc(var(--space-base) * -1)}:host .body{display:flex;flex-direction:column;margin-top:var(--space-lg)}:host .body>.days-heading{display:grid;grid-gap:1px;grid-template-columns:repeat(7,var(--day-size-px));grid-template-rows:var(--day-size-px)}:host .body>.days-heading>span{display:flex;align-items:center;justify-content:center}:host .body .calendar-item{width:100%;display:flex;align-items:center;justify-content:center;padding:var(--space-xs);cursor:default}:host .body .calendar-item:hover.selectable>.item-wrapper{background-color:var(--calendar-hover-background);color:var(--calendar-hover-on)}:host .body .calendar-item>.item-wrapper{height:100%;width:100%;display:flex;align-items:center;justify-content:center;border-radius:50px;transition:background-color .15s cubic-bezier(0,0,.2,1);line-height:var(--day-size-px);padding:0px var(--space-sm)}:host .body .calendar-item.today>.item-wrapper{line-height:calc(var(--day-size-px) - 2px)}:host .body .calendar-item.today:not(.selected)>.item-wrapper{border:1px solid}:host .body .calendar-item.selected>.item-wrapper{background-color:var(--calendar-selected-background)!important;color:var(--calendar-selected-on)!important}:host .body .calendar-item.selectable{cursor:pointer}:host .body .calendar-item:not(.selectable) span{opacity:.5!important}:host .body>.days{margin-top:var(--space-base);display:grid;grid-gap:1px;grid-template-columns:repeat(7,var(--day-size-px));grid-template-rows:repeat(var(--weeks-count),var(--day-size-px))}:host .body>.days>.day.active-month{background-color:var(--calendar-active-month-background);color:var(--calendar-active-month-color)}:host .body>.days>.day:not(.active-month){background-color:var(--calendar-inactive-month-background);color:var(--calendar-inactive-month-color)}:host .body>.days>.day:not(.active-month):not(.today) span{opacity:.5}:host .body>.days>.day:not(.active-month):not(.show){visibility:hidden}:host .body>.months{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:32px 16px;justify-items:center}:host .body>.years{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:8px;justify-items:center}:host .body>.years>.item-wrapper{border-radius:50px 0}:host-context(.dmb-aspect) :host .header>.current-date span:hover:not(.year-range){color:var(--primary-on)}:host-context(.dmb-aspect) :host .header>.navigation avn-icon:hover{color:var(--primary-on)}:host-context(.dmb-aspect) :host .body{margin-top:var(--space-md);border:1px solid rgb(13,13,14)}:host-context(.dmb-aspect) :host .body .days-heading{background:#3a4147}:host-context(.dmb-aspect) :host .body .calendar-item:hover.selectable>.item-wrapper{color:var(--primary-on)}:host-context(.dmb-aspect) :host .body .days-separator{margin-left:0;margin-right:0;border-color:#3a4147}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CALENDAR_CONFIG]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DATE_TIME_OPTIONS]
                }] }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: DateLocaleService }]; }, propDecorators: { selectedDate: [{
                type: Input
            }], locale: [{
                type: Input
            }], autoFillIncompleteWeeks: [{
                type: Input
            }], fixedHeight: [{
                type: Input
            }], minSelectableDate: [{
                type: Input
            }], maxSelectableDate: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], timezone: [{
                type: Input
            }], selected: [{
                type: Output
            }] } });

class CalendarModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CalendarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: CalendarModule, declarations: [CalendarComponent], imports: [CommonModule, IconModule, CoreModule, ButtonModule], exports: [CalendarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CalendarModule, imports: [CommonModule, IconModule, CoreModule, ButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: CalendarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CalendarComponent],
                    imports: [CommonModule, IconModule, CoreModule, ButtonModule],
                    exports: [CalendarComponent],
                }]
        }] });

/**
 * The time picker component comes with the following features:
 * - Select time in 12h or 24h format
 * - Select hours, minutes and optional seconds
 * - Optional keypad for quick time selection
 *
 * Caveats:
 * - input type is set to number in order to trigger digit keypad on mobile. This prevents
 *   input cursor position to be manipulated
 */
class TimePickerComponent {
    get selectedTimeIsoString() {
        return this.selectedTimeInternal ? dateTimeToString(this.selectedTimeInternal, this.timezone) : null;
    }
    /** @ignore **/
    constructor(_changeDetector, _dateTimeOptions, _dateLocaleService) {
        this._changeDetector = _changeDetector;
        this._dateTimeOptions = _dateTimeOptions;
        this._dateLocaleService = _dateLocaleService;
        /** Indicates the min time that can be selected **/
        this.showSeconds = false;
        /**
         * When true, the selected time value will be only emitted once the user releases the up/down arrows. If false, it will emit each value
         * *
         */
        this.debounceSelectedTime = true;
        /** Indicates if time auto increases after a time unit resest (e.g. add 1 mimute when seconds > 60)**/
        this.autoIncreaseTime = false;
        /** Sets the active time unit **/
        this.activeTimeUnit = 'hour';
        /** Emits when a time is selected **/
        this.selected = new EventEmitter();
        /** The currently active time field **/
        this.activeTimeUnitField = 'hour';
        /** @ignore  Eits the selected value **/
        this._selectedValueSubject = new Subject();
        /*** @ignore Pattern used to close all subscriptions */
        this._componentDestroyed$ = new Subject();
        this._dateTimeOptions = {
            ...DEFAULT_DATE_TIME_OPTIONS,
            ...(this._dateTimeOptions || {}),
        };
        this._digitsHour12HourFormat = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '12am', '0', '12pm'];
        this._digitsHour24HourFormat = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '00', '0', '12'];
        this._digitsMinuteSecond = ['1', '2', '3', '4', '5', '6', '7', '8', '9', ':00', '0', ':30'];
        this.timezone = this._dateTimeOptions.timezone;
    }
    /** @ignore **/
    ngOnInit() {
        // init the initial time here because we need the timezone
        this.selectedTimeInternal = this.selectedTimeInternal || toZonedDateTime(DateTime.now(), this.timezone).setLocale(this.locale || 'en');
        // use global config value if not set
        this.showKeypad = this.showKeypad ?? this._dateTimeOptions.showTimeKeypad;
        // emit the selected time value only after the user stops pressing the up/down arrows
        this._selectedValueSubject.pipe(debounceTime(this.debounceSelectedTime ? 250 : 0), takeUntil(this._componentDestroyed$)).subscribe((value) => this.selected.emit(value));
    }
    /** @ignore **/
    ngAfterViewInit() {
        this.setActiveField('hour');
        this._changeDetector.detectChanges();
        // if no locale was specified, use the locale observable from the global config
        if (!this.locale) {
            this._dateLocaleService.locale$.pipe(startWith(Settings.defaultLocale), takeUntil(this._componentDestroyed$)).subscribe((locale) => {
                this.locale = locale;
                this._refreshLocaleData(locale);
                this._changeDetector.detectChanges();
            });
        }
        if (this.activeTimeUnit) {
            this.setActiveField(this.activeTimeUnit, false);
            this._changeDetector.detectChanges();
        }
    }
    /** @ignore **/
    ngOnChanges({ selectedTime, use24HourFormat, locale, activeTimeUnit }) {
        // init the initial time here because we need the timezone
        this.selectedTimeInternal = this.selectedTimeInternal || toZonedDateTime(DateTime.now(), this.timezone).setLocale(this.locale || 'en');
        if (selectedTime) {
            this.selectedTimeInternal = stringToDateTime(selectedTime.currentValue, this.timezone);
            if (this.selectedTimeInternal) {
                this.selectedTimeInternal.setLocale(this.locale || 'en');
            }
            else {
                // set to today
                this.selectedTimeInternal = toZonedDateTime(DateTime.now(), this.timezone).setLocale(this.locale || 'en');
            }
        }
        if (use24HourFormat) {
            this._originalUse24HourFormat = use24HourFormat.currentValue;
            this._refreshLocaleData(this.locale || 'en');
        }
        if (locale) {
            this._refreshLocaleData(locale.currentValue || 'en');
        }
        // as the 'second' field is optional, it wont be ready on first change
        if (activeTimeUnit && activeTimeUnit.currentValue && !activeTimeUnit.isFirstChange()) {
            this.setActiveField(activeTimeUnit.currentValue, false);
        }
    }
    /**
     * @ignore refreshes elements that rely on locale
     */
    _refreshLocaleData(locale) {
        this.use24HourFormat = this._originalUse24HourFormat ?? !is12HourTimeLocale(locale);
        this.selectedTimeInternal = this.selectedTimeInternal.setLocale(locale);
        if (this.activeTimeUnitField) {
            this._updateKeypad(this.activeTimeUnitField);
        }
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** Adds the specified amount of hours (can be negative to withdraw) **/
    addHour(amount) {
        if (this.autoIncreaseTime) {
            this.selectedTimeInternal = this.selectedTimeInternal.plus({ hour: amount });
        }
        else {
            const newHour = this.selectedTimeInternal.hour + amount;
            this.selectedTimeInternal = this.selectedTimeInternal.set({ hour: newHour > 23 ? 0 : newHour < 0 ? 23 : newHour });
        }
        this._selectedValueSubject.next(dateTimeToString(this.selectedTimeInternal, this.timezone));
    }
    /** Adds the specified amount of minutes (can be negative to withdraw) **/
    addMinute(amount) {
        if (this.autoIncreaseTime) {
            this.selectedTimeInternal = this.selectedTimeInternal.plus({ minute: amount });
        }
        else {
            const newMinute = this.selectedTimeInternal.minute + amount;
            this.selectedTimeInternal = this.selectedTimeInternal.set({ minute: newMinute > 59 ? 0 : newMinute < 0 ? 59 : newMinute });
        }
        this._selectedValueSubject.next(dateTimeToString(this.selectedTimeInternal, this.timezone));
    }
    /** Adds the specified amount of seconds (can be negative to withdraw) **/
    addSecond(amount) {
        if (this.autoIncreaseTime) {
            this.selectedTimeInternal = this.selectedTimeInternal.plus({ second: amount });
        }
        else {
            const newSecond = this.selectedTimeInternal.second + amount;
            this.selectedTimeInternal = this.selectedTimeInternal.set({ second: newSecond > 59 ? 0 : newSecond < 0 ? 59 : newSecond });
        }
        this._selectedValueSubject.next(dateTimeToString(this.selectedTimeInternal, this.timezone));
    }
    /** Sets the active time unit field **/
    setActiveField(field, setFocus = true) {
        this.activeTimeUnitField = field;
        const activeInput = this._getActiveInput();
        if (setFocus) {
            activeInput.focus();
        }
        if (this.showKeypad) {
            this._updateKeypad(field);
        }
    }
    /** Sets the meridiem **/
    setMeridiem(value, emitEvent = true) {
        if (this.meridiem === value) {
            return;
        }
        if (this.meridiem === 'am' && value === 'pm') {
            this.selectedTimeInternal = this.selectedTimeInternal.set({ hour: this.hour + 12 });
        }
        else if (this.meridiem === 'pm' && value === 'am') {
            this.selectedTimeInternal = this.selectedTimeInternal.set({ hour: this.hour - 12 });
        }
        if (emitEvent) {
            this.selected.emit(dateTimeToString(this.selectedTimeInternal, this.timezone));
        }
    }
    /** Sets the hour (in 24h format) **/
    _setHour(value) {
        this.selectedTimeInternal = this.selectedTimeInternal.set({ hour: value });
        this.selected.emit(dateTimeToString(this.selectedTimeInternal, this.timezone));
    }
    /** Sets the minute **/
    _setMinute(value) {
        this.selectedTimeInternal = this.selectedTimeInternal.set({ minute: value });
        this.selected.emit(dateTimeToString(this.selectedTimeInternal, this.timezone));
    }
    /** Sets the second **/
    _setSecond(value) {
        this.selectedTimeInternal = this.selectedTimeInternal.set({ second: value });
        this.selected.emit(dateTimeToString(this.selectedTimeInternal, this.timezone));
    }
    /** Gets the current hour **/
    get hour() {
        return this.selectedTimeInternal.hour;
    }
    /** Gets the current minute **/
    get minute() {
        return this.selectedTimeInternal.minute;
    }
    /** Gets the current second **/
    get second() {
        return this.selectedTimeInternal.second;
    }
    /** Gets the current meridiem **/
    get meridiem() {
        return this.selectedTimeInternal.hour < 12 ? 'am' : 'pm';
    }
    /** Gets the current hour formatted with 12h or 24h display **/
    get i18nHour() {
        return this.use24HourFormat ? this.hour : this.hour % 12 || 12;
    }
    /** @ignore Updates the time unit value of the current active time unit field. Hour should be passed in 24h format**/
    _updateTimeUnitValue(value) {
        if (this.activeTimeUnitField === 'hour') {
            // this.setHour(!this.use24HourFormat && this.meridiem === 'pm' ? value + 12 : value);
            this._setHour(value);
        }
        else if (this.activeTimeUnitField === 'minute') {
            this._setMinute(value);
        }
        else if (this.activeTimeUnitField === 'second') {
            this._setSecond(value);
        }
        this.partialValue = null;
        this._updateKeypad(this.activeTimeUnitField);
    }
    /** Called when the keypad is clicked / digit entered manually. Includes special digits like ':00' or '12am' **/
    onDigitInput(selected) {
        // check if a preset value was selected
        const isPresetValue = selected.length > 1;
        if (isPresetValue) {
            if (selected === '12am') {
                this.setMeridiem('am', false);
                this._updateTimeUnitValue(0);
            }
            else if (selected === '12pm') {
                this.setMeridiem('pm', false);
                this._updateTimeUnitValue(12);
            }
            else if (selected.startsWith(':')) {
                this._updateTimeUnitValue(Number(selected.substring(1)));
            }
            else {
                this._updateTimeUnitValue(this._convertTo24HourFormat(Number(selected)));
            }
            this._focusNextField();
            return;
        }
        // a previous digit was already selected
        const alreadyEnteredDigit = this.partialValue;
        if (alreadyEnteredDigit) {
            this._updateTimeUnitValue(this._convertTo24HourFormat(Number(`${alreadyEnteredDigit}${selected}`)));
            this._focusNextField();
            return;
        }
        // no previous digit was selected
        const selectedDigit = Number(selected);
        const canInputMoreDigits = this.activeTimeUnitField !== 'hour' || this.use24HourFormat || selectedDigit === 1;
        if (!canInputMoreDigits) {
            this._updateTimeUnitValue(this._convertTo24HourFormat(selectedDigit));
            this._focusNextField();
            return;
        }
        this.partialValue = selected;
        this._updateKeypad(this.activeTimeUnitField);
    }
    /** @ignore checks the time unit value and make sure to adjust to 24h format **/
    _convertTo24HourFormat(value) {
        if (this.activeTimeUnitField === 'hour' && !this.use24HourFormat) {
            return this.meridiem === 'pm' ? value + 12 : value;
        }
        return value;
    }
    /** @ignore focus on the next time unit field available and returns a boolean indicating if there was one **/
    _focusNextField() {
        const units = ['hour', 'minute', ...(this.showSeconds ? ['second'] : [])];
        const nextTimeUnit = units[units.indexOf(this.activeTimeUnitField) + 1];
        if (nextTimeUnit) {
            this.setActiveField(nextTimeUnit);
            return true;
        }
        return false;
    }
    /**
     * @ignore updates the keypad by enabling only digits that can be entered next
     */
    _updateKeypad(field) {
        if (field === 'hour') {
            this.digits = this.use24HourFormat ? this._digitsHour24HourFormat : this._digitsHour12HourFormat;
            if (this.partialValue) {
                const allowedSecondDigit = this.use24HourFormat ? (Number(this.partialValue) === 1 ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] : [0, 1, 2, 3]) : [0, 1, 2];
                this.digitEnabled = this.digits.map((digit) => digit.length > 1 || allowedSecondDigit.includes(Number(digit)));
            }
            else {
                const allowedFirstDigit = this.use24HourFormat ? [0, 1, 2] : [1, 2, 3, 4, 5, 6, 7, 8, 9];
                this.digitEnabled = this.digits.map((digit) => digit.length > 1 || allowedFirstDigit.includes(Number(digit)));
            }
        }
        else if (field === 'minute' || field === 'second') {
            this.digits = this._digitsMinuteSecond;
            if (this.partialValue) {
                this.digitEnabled = this.digits.map(() => true);
            }
            else {
                this.digitEnabled = this.digits.map((digit) => digit.length > 1 || [1, 2, 3, 4, 5].includes(Number(digit)));
            }
        }
    }
    /**
     * @ignore returns the currently active input
     */
    _getActiveInput() {
        if (this.activeTimeUnitField === 'hour') {
            return this._inputHourElement.nativeElement;
        }
        if (this.activeTimeUnitField === 'minute') {
            return this._inputMinuteElement.nativeElement;
        }
        if (this.activeTimeUnitField === 'second') {
            return this._inputSecondElement.nativeElement;
        }
        return null;
    }
    /**
     * Called when a value is manually typed into any of the time input fields
     */
    onManualInput(value) {
        if (value.length > 0) {
            // take the last digit that was entered
            this.onDigitInput(value.substring(value.length - 1));
        }
    }
    /**
     * Called when a time unit is focused
     */
    onInputFocus(field) {
        if (this.partialValue) {
            this._updateTimeUnitValue(this._convertTo24HourFormat(Number(this.partialValue)));
        }
        this.setActiveField(field);
    }
    /**
     * formats the time unit with leading zeros
     */
    formatTimeUnit(field, value) {
        return padWithZeros(value, field === 'hour' && !this.use24HourFormat ? 1 : 2);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimePickerComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: DATE_TIME_OPTIONS }, { token: DateLocaleService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TimePickerComponent, selector: "avn-time-picker", inputs: { selectedTime: "selectedTime", showSeconds: "showSeconds", showKeypad: "showKeypad", use24HourFormat: "use24HourFormat", locale: "locale", debounceSelectedTime: "debounceSelectedTime", timezone: "timezone", autoIncreaseTime: "autoIncreaseTime", activeTimeUnit: "activeTimeUnit" }, outputs: { selected: "selected" }, viewQueries: [{ propertyName: "_inputHourElement", first: true, predicate: ["inputHour"], descendants: true, static: true }, { propertyName: "_inputMinuteElement", first: true, predicate: ["inputMinute"], descendants: true, static: true }, { propertyName: "_inputSecondElement", first: true, predicate: ["inputSecond"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"time\">\n  <div class=\"item\" data-e2e=\"hours\">\n    <avn-icon\n      icon=\"navigation:arrow_drop_up\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      (touchstart)=\"setActiveField('hour'); addHour(1)\"\n      (mousedown)=\"setActiveField('hour'); addHour(1)\"\n      avnLongPress\n      (longPress)=\"setActiveField('hour'); addHour(1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n    <input\n      #inputHour\n      [class.active]=\"activeTimeUnitField === 'hour'\"\n      type=\"number\"\n      maxlength=\"2\"\n      [value]=\"activeTimeUnitField === 'hour' && partialValue ? partialValue : formatTimeUnit('hour', i18nHour)\"\n      [lastValidValue]=\"activeTimeUnitField === 'hour' && partialValue ? partialValue : formatTimeUnit('hour', i18nHour)\"\n      [avnInputRegex]=\"use24HourFormat ? '^[01]\\\\[0-9]?|2[0-4]?$' : '^([1-9]|1[012])$'\"\n      (focus)=\"onInputFocus('hour')\"\n      (inputChange)=\"onManualInput($event)\"\n      (keydown.arrowUp)=\"$event.preventDefault(); setActiveField('hour'); addHour(1)\"\n      (keydown.arrowDown)=\"$event.preventDefault(); setActiveField('hour'); addHour(-1)\"\n    />\n    <avn-icon\n      icon=\"navigation:arrow_drop_down\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      (touchstart)=\"setActiveField('hour'); addHour(-1)\"\n      (mousedown)=\"setActiveField('hour'); addHour(-1)\"\n      avnLongPress\n      (longPress)=\"setActiveField('hour'); addHour(-1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n  </div>\n  <div class=\"separator\">:</div>\n  <div class=\"item\" data-e2e=\"minutes\">\n    <avn-icon\n      icon=\"navigation:arrow_drop_up\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      (touchstart)=\"setActiveField('minute'); addMinute(1)\"\n      (mousedown)=\"setActiveField('minute'); addMinute(1)\"\n      avnLongPress\n      (longPress)=\"setActiveField('minute'); addMinute(1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n    <input\n      #inputMinute\n      [class.active]=\"activeTimeUnitField === 'minute'\"\n      type=\"number\"\n      maxlength=\"2\"\n      [value]=\"activeTimeUnitField === 'minute' && partialValue ? partialValue : formatTimeUnit('minute', minute)\"\n      [lastValidValue]=\"activeTimeUnitField === 'minute' && partialValue ? partialValue : formatTimeUnit('minute', minute)\"\n      [avnInputRegex]=\"'^[0-5]{1}[0-9]{0,1}$'\"\n      (focus)=\"onInputFocus('minute')\"\n      (inputChange)=\"onManualInput($event)\"\n      (keydown.arrowUp)=\"$event.preventDefault(); setActiveField('minute'); addMinute(1)\"\n      (keydown.arrowDown)=\"$event.preventDefault(); setActiveField('minute'); addMinute(-1)\"\n    />\n    <avn-icon\n      icon=\"navigation:arrow_drop_down\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      avnLongPress\n      (touchstart)=\"setActiveField('minute'); addMinute(-1)\"\n      (mousedown)=\"setActiveField('minute'); addMinute(-1)\"\n      (longPress)=\"setActiveField('minute'); addMinute(-1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n  </div>\n  <div class=\"separator\" *ngIf=\"showSeconds\">:</div>\n  <div class=\"item\" data-e2e=\"seconds\" *ngIf=\"showSeconds\">\n    <avn-icon\n      icon=\"navigation:arrow_drop_up\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      avnLongPress\n      (touchstart)=\"setActiveField('second'); addSecond(1)\"\n      (mousedown)=\"setActiveField('second'); addSecond(1)\"\n      (longPress)=\"setActiveField('second'); addSecond(1)\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n    <input\n      #inputSecond\n      [class.active]=\"activeTimeUnitField === 'second'\"\n      type=\"number\"\n      maxlength=\"2\"\n      [avnInputRegex]=\"'^[0-5]{1}[0-9]{0,1}$'\"\n      [value]=\"activeTimeUnitField === 'second' && partialValue ? partialValue : formatTimeUnit('second', second)\"\n      [lastValidValue]=\"activeTimeUnitField === 'second' && partialValue ? partialValue : formatTimeUnit('second', second)\"\n      (focus)=\"onInputFocus('second')\"\n      (inputChange)=\"onManualInput($event)\"\n      (keydown.arrowUp)=\"$event.preventDefault(); setActiveField('second'); addSecond(1)\"\n      (keydown.arrowDown)=\"$event.preventDefault(); setActiveField('second'); addSecond(-1)\"\n    />\n    <avn-icon\n      icon=\"navigation:arrow_drop_down\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      avnLongPress\n      (touchstart)=\"setActiveField('second'); addSecond(-1)\"\n      (mousedown)=\"setActiveField('second'); addSecond(-1)\"\n      (longPress)=\"setActiveField('second'); addSecond(-1)\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n  </div>\n  <div class=\"separator hidden\" *ngIf=\"!use24HourFormat\">:</div>\n  <div class=\"meridiem\" *ngIf=\"!use24HourFormat\">\n    <span role=\"button\" [class.active]=\"meridiem === 'am'\" (click)=\"setMeridiem('am')\">AM</span>\n    <span role=\"button\" [class.active]=\"meridiem === 'pm'\" (click)=\"setMeridiem('pm')\">PM</span>\n  </div>\n</div>\n<div class=\"keypad\" *ngIf=\"showKeypad\">\n  <div\n    class=\"keypad-item\"\n    [class.enabled]=\"digitEnabled[i]\"\n    [class.quick-select]=\"digit.length > 1\"\n    *ngFor=\"let digit of digits; index as i\"\n    (click)=\"digitEnabled[i] && onDigitInput(digit)\"\n  >\n    {{ digit }}\n  </div>\n</div>\n", styles: [":host{background-color:var(--modal-background);color:var(--modal-on);min-width:250px;display:flex;flex-direction:column}:host>.time{padding:var(--space-base);display:flex;flex-flow:row nowrap;justify-content:center}:host>.time>div{display:flex;flex-direction:column;align-items:center;justify-content:center}:host>.time>div:not(:first-child){margin-left:var(--space-base)}:host>.time>div.item,:host>.time>div.separator{font-size:var(--text-xl);line-height:2rem;-webkit-user-select:none;user-select:none}:host>.time>div.item avn-icon{-webkit-user-select:none;user-select:none;opacity:.5;cursor:pointer}:host>.time>div.item avn-icon:hover{opacity:1}:host>.time>div.item>input{box-sizing:content-box;padding:var(--space-sm) var(--space-base);border:0px;width:2.5ch;text-align:center;border-radius:4px;background-color:var(--time-picker-time-unit-background);color:var(--time-picker-time-unit-on);color:inherit;transition:all .15s cubic-bezier(0,0,.2,1);-moz-appearance:textfield}:host>.time>div.item>input::-webkit-outer-spin-button,:host>.time>div.item>input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}:host>.time>div.item>input.active{background-color:var(--primary-base);color:var(--primary-on)}:host>.time>div.separator.hidden{visibility:hidden}:host>.time>div.meridiem{display:flex;flex-direction:column;align-items:center;justify-content:center}:host>.time>div.meridiem>span{cursor:pointer;border-radius:4px;padding:var(--space-sm) var(--space-base);-webkit-user-select:none;user-select:none;transition:all .15s cubic-bezier(0,0,.2,1);opacity:.5}:host>.time>div.meridiem>span:first-child{margin-bottom:var(--space-xs)}:host>.time>div.meridiem>span.active,:host>.time>div.meridiem>span:hover{opacity:1;background-color:var(--time-picker-time-unit-background);color:var(--time-picker-time-unit-on)}:host .keypad{padding:var(--space-base);display:grid;grid-template-columns:1fr 1fr 1fr;grid-auto-rows:1fr;align-items:center;justify-items:center;background-color:var(--time-picker-keypad-background);color:var(--time-picker-keypad-on)}:host .keypad:before{content:\"\";width:0;padding-bottom:65%;grid-row:1/1;grid-column:1/1}:host .keypad>.keypad-item{font-size:var(--text-lg);opacity:.5;transition:all .15s cubic-bezier(0,0,.2,1);width:100%;height:100%;display:flex;align-items:center;justify-content:center;border-radius:4px;-webkit-user-select:none;user-select:none}:host .keypad>.keypad-item.enabled{cursor:pointer}:host .keypad>.keypad-item.enabled:hover{opacity:1;background-color:var(--time-picker-keypad-hover-background);color:var(--time-picker-keypad-hover-on)}:host .keypad>.keypad-item:not(.enabled){opacity:.2;cursor:not-allowed}:host .keypad>.keypad-item:first-child{grid-row:1/1;grid-column:1/1}:host .keypad>.keypad-item.quick-select{font-size:var(--text-md)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "directive", type: LongPressDirective, selector: "[avnLongPress]", inputs: ["longPressStartTimeMs", "longPressIntervalTimeMs", "longPressActive"], outputs: ["longPress", "longPressEnd"] }, { kind: "directive", type: InputRegexDirective, selector: "input[avnInputRegex]", inputs: ["avnInputRegex", "lastValidValue"], outputs: ["inputChange", "inputInvalid"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-time-picker', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"time\">\n  <div class=\"item\" data-e2e=\"hours\">\n    <avn-icon\n      icon=\"navigation:arrow_drop_up\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      (touchstart)=\"setActiveField('hour'); addHour(1)\"\n      (mousedown)=\"setActiveField('hour'); addHour(1)\"\n      avnLongPress\n      (longPress)=\"setActiveField('hour'); addHour(1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n    <input\n      #inputHour\n      [class.active]=\"activeTimeUnitField === 'hour'\"\n      type=\"number\"\n      maxlength=\"2\"\n      [value]=\"activeTimeUnitField === 'hour' && partialValue ? partialValue : formatTimeUnit('hour', i18nHour)\"\n      [lastValidValue]=\"activeTimeUnitField === 'hour' && partialValue ? partialValue : formatTimeUnit('hour', i18nHour)\"\n      [avnInputRegex]=\"use24HourFormat ? '^[01]\\\\[0-9]?|2[0-4]?$' : '^([1-9]|1[012])$'\"\n      (focus)=\"onInputFocus('hour')\"\n      (inputChange)=\"onManualInput($event)\"\n      (keydown.arrowUp)=\"$event.preventDefault(); setActiveField('hour'); addHour(1)\"\n      (keydown.arrowDown)=\"$event.preventDefault(); setActiveField('hour'); addHour(-1)\"\n    />\n    <avn-icon\n      icon=\"navigation:arrow_drop_down\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      (touchstart)=\"setActiveField('hour'); addHour(-1)\"\n      (mousedown)=\"setActiveField('hour'); addHour(-1)\"\n      avnLongPress\n      (longPress)=\"setActiveField('hour'); addHour(-1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n  </div>\n  <div class=\"separator\">:</div>\n  <div class=\"item\" data-e2e=\"minutes\">\n    <avn-icon\n      icon=\"navigation:arrow_drop_up\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      (touchstart)=\"setActiveField('minute'); addMinute(1)\"\n      (mousedown)=\"setActiveField('minute'); addMinute(1)\"\n      avnLongPress\n      (longPress)=\"setActiveField('minute'); addMinute(1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n    <input\n      #inputMinute\n      [class.active]=\"activeTimeUnitField === 'minute'\"\n      type=\"number\"\n      maxlength=\"2\"\n      [value]=\"activeTimeUnitField === 'minute' && partialValue ? partialValue : formatTimeUnit('minute', minute)\"\n      [lastValidValue]=\"activeTimeUnitField === 'minute' && partialValue ? partialValue : formatTimeUnit('minute', minute)\"\n      [avnInputRegex]=\"'^[0-5]{1}[0-9]{0,1}$'\"\n      (focus)=\"onInputFocus('minute')\"\n      (inputChange)=\"onManualInput($event)\"\n      (keydown.arrowUp)=\"$event.preventDefault(); setActiveField('minute'); addMinute(1)\"\n      (keydown.arrowDown)=\"$event.preventDefault(); setActiveField('minute'); addMinute(-1)\"\n    />\n    <avn-icon\n      icon=\"navigation:arrow_drop_down\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      avnLongPress\n      (touchstart)=\"setActiveField('minute'); addMinute(-1)\"\n      (mousedown)=\"setActiveField('minute'); addMinute(-1)\"\n      (longPress)=\"setActiveField('minute'); addMinute(-1)\"\n      [longPressStartTimeMs]=\"200\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n  </div>\n  <div class=\"separator\" *ngIf=\"showSeconds\">:</div>\n  <div class=\"item\" data-e2e=\"seconds\" *ngIf=\"showSeconds\">\n    <avn-icon\n      icon=\"navigation:arrow_drop_up\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      avnLongPress\n      (touchstart)=\"setActiveField('second'); addSecond(1)\"\n      (mousedown)=\"setActiveField('second'); addSecond(1)\"\n      (longPress)=\"setActiveField('second'); addSecond(1)\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n    <input\n      #inputSecond\n      [class.active]=\"activeTimeUnitField === 'second'\"\n      type=\"number\"\n      maxlength=\"2\"\n      [avnInputRegex]=\"'^[0-5]{1}[0-9]{0,1}$'\"\n      [value]=\"activeTimeUnitField === 'second' && partialValue ? partialValue : formatTimeUnit('second', second)\"\n      [lastValidValue]=\"activeTimeUnitField === 'second' && partialValue ? partialValue : formatTimeUnit('second', second)\"\n      (focus)=\"onInputFocus('second')\"\n      (inputChange)=\"onManualInput($event)\"\n      (keydown.arrowUp)=\"$event.preventDefault(); setActiveField('second'); addSecond(1)\"\n      (keydown.arrowDown)=\"$event.preventDefault(); setActiveField('second'); addSecond(-1)\"\n    />\n    <avn-icon\n      icon=\"navigation:arrow_drop_down\"\n      [fontSize]=\"32\"\n      role=\"button\"\n      avnLongPress\n      (touchstart)=\"setActiveField('second'); addSecond(-1)\"\n      (mousedown)=\"setActiveField('second'); addSecond(-1)\"\n      (longPress)=\"setActiveField('second'); addSecond(-1)\"\n      [longPressIntervalTimeMs]=\"50\"\n    ></avn-icon>\n  </div>\n  <div class=\"separator hidden\" *ngIf=\"!use24HourFormat\">:</div>\n  <div class=\"meridiem\" *ngIf=\"!use24HourFormat\">\n    <span role=\"button\" [class.active]=\"meridiem === 'am'\" (click)=\"setMeridiem('am')\">AM</span>\n    <span role=\"button\" [class.active]=\"meridiem === 'pm'\" (click)=\"setMeridiem('pm')\">PM</span>\n  </div>\n</div>\n<div class=\"keypad\" *ngIf=\"showKeypad\">\n  <div\n    class=\"keypad-item\"\n    [class.enabled]=\"digitEnabled[i]\"\n    [class.quick-select]=\"digit.length > 1\"\n    *ngFor=\"let digit of digits; index as i\"\n    (click)=\"digitEnabled[i] && onDigitInput(digit)\"\n  >\n    {{ digit }}\n  </div>\n</div>\n", styles: [":host{background-color:var(--modal-background);color:var(--modal-on);min-width:250px;display:flex;flex-direction:column}:host>.time{padding:var(--space-base);display:flex;flex-flow:row nowrap;justify-content:center}:host>.time>div{display:flex;flex-direction:column;align-items:center;justify-content:center}:host>.time>div:not(:first-child){margin-left:var(--space-base)}:host>.time>div.item,:host>.time>div.separator{font-size:var(--text-xl);line-height:2rem;-webkit-user-select:none;user-select:none}:host>.time>div.item avn-icon{-webkit-user-select:none;user-select:none;opacity:.5;cursor:pointer}:host>.time>div.item avn-icon:hover{opacity:1}:host>.time>div.item>input{box-sizing:content-box;padding:var(--space-sm) var(--space-base);border:0px;width:2.5ch;text-align:center;border-radius:4px;background-color:var(--time-picker-time-unit-background);color:var(--time-picker-time-unit-on);color:inherit;transition:all .15s cubic-bezier(0,0,.2,1);-moz-appearance:textfield}:host>.time>div.item>input::-webkit-outer-spin-button,:host>.time>div.item>input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}:host>.time>div.item>input.active{background-color:var(--primary-base);color:var(--primary-on)}:host>.time>div.separator.hidden{visibility:hidden}:host>.time>div.meridiem{display:flex;flex-direction:column;align-items:center;justify-content:center}:host>.time>div.meridiem>span{cursor:pointer;border-radius:4px;padding:var(--space-sm) var(--space-base);-webkit-user-select:none;user-select:none;transition:all .15s cubic-bezier(0,0,.2,1);opacity:.5}:host>.time>div.meridiem>span:first-child{margin-bottom:var(--space-xs)}:host>.time>div.meridiem>span.active,:host>.time>div.meridiem>span:hover{opacity:1;background-color:var(--time-picker-time-unit-background);color:var(--time-picker-time-unit-on)}:host .keypad{padding:var(--space-base);display:grid;grid-template-columns:1fr 1fr 1fr;grid-auto-rows:1fr;align-items:center;justify-items:center;background-color:var(--time-picker-keypad-background);color:var(--time-picker-keypad-on)}:host .keypad:before{content:\"\";width:0;padding-bottom:65%;grid-row:1/1;grid-column:1/1}:host .keypad>.keypad-item{font-size:var(--text-lg);opacity:.5;transition:all .15s cubic-bezier(0,0,.2,1);width:100%;height:100%;display:flex;align-items:center;justify-content:center;border-radius:4px;-webkit-user-select:none;user-select:none}:host .keypad>.keypad-item.enabled{cursor:pointer}:host .keypad>.keypad-item.enabled:hover{opacity:1;background-color:var(--time-picker-keypad-hover-background);color:var(--time-picker-keypad-hover-on)}:host .keypad>.keypad-item:not(.enabled){opacity:.2;cursor:not-allowed}:host .keypad>.keypad-item:first-child{grid-row:1/1;grid-column:1/1}:host .keypad>.keypad-item.quick-select{font-size:var(--text-md)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DATE_TIME_OPTIONS]
                }] }, { type: DateLocaleService }]; }, propDecorators: { _inputHourElement: [{
                type: ViewChild,
                args: ['inputHour', { static: true }]
            }], _inputMinuteElement: [{
                type: ViewChild,
                args: ['inputMinute', { static: true }]
            }], _inputSecondElement: [{
                type: ViewChild,
                args: ['inputSecond', { static: false }]
            }], selectedTime: [{
                type: Input
            }], showSeconds: [{
                type: Input
            }], showKeypad: [{
                type: Input
            }], use24HourFormat: [{
                type: Input
            }], locale: [{
                type: Input
            }], debounceSelectedTime: [{
                type: Input
            }], timezone: [{
                type: Input
            }], autoIncreaseTime: [{
                type: Input
            }], activeTimeUnit: [{
                type: Input
            }], selected: [{
                type: Output
            }] } });

class TimePickerModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: TimePickerModule, declarations: [TimePickerComponent], imports: [CommonModule, IconModule, CoreModule, InputModule], exports: [TimePickerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimePickerModule, imports: [CommonModule, IconModule, CoreModule, InputModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TimePickerComponent],
                    imports: [CommonModule, IconModule, CoreModule, InputModule],
                    exports: [TimePickerComponent],
                }]
        }] });

class InputDateTimePickerComponent extends FormControlComponent {
    /** @ignore */
    constructor(renderer, ngControl, changeDetector, _dateTimeOptions, _dateLocaleService) {
        super(ngControl, changeDetector);
        this.renderer = renderer;
        this._dateTimeOptions = _dateTimeOptions;
        this._dateLocaleService = _dateLocaleService;
        /** The date time units to include */
        this.datePickerMode = 'day';
        /** The date time units to include */
        this.timePickerMode = 'minute';
        /** The type of picker */
        this.type = 'date';
        /** Emits every time the component value changes */
        this.changed = new EventEmitter();
        /** Indicates if the connected overlay is opened **/
        this.overlayOpened = false;
        /** @ignore The partial value to display when an invalid date is entered */
        this._partialValue = '';
        /** All time units included in the current date/time format */
        this._dateFormatTimeUnits = [];
        /** Indicates if the user should select the time once the date has been picked (date and time overlay will show successively) **/
        this._showTimePickerOnDateSelected = false;
        /** @ignore */
        this._componentDestroyed$ = new Subject();
        /** list of regex per time unit **/
        this._timeUnitRegex = {
            dd: '([0d]([1-9]|d)|[12d][\\dd]|[3d][01d])',
            yyyy: '([12y][\\dy]{1,3})',
            MM: '((0|M)([1-9]|M)|[1M][012M])',
            HH: '([01H][\\dH]|[2H]([0-3]|H))',
            mm: '(([0-5]|m)([0-9]|m))',
            ss: '(([0-5]|s)([0-9]|s))',
            SSS: '(([0-9]|S){3})',
            hh: '([0h]([1-9]|h)|([1h][012h]))',
            A: '([aAP][aM])',
            a: '([aAP][aM])',
        };
        this._dateTimeOptions = {
            ...DEFAULT_DATE_TIME_OPTIONS,
            ...(this._dateTimeOptions || {}),
        };
        this.showTimeKeypad = !!_dateTimeOptions.showTimeKeypad;
        this.timezone = this._dateTimeOptions.timezone;
    }
    /** This method is called when the value is set to the component via the angular forms */
    updateValue(value) {
        this.value = value;
        this.selectedDateInternal = stringToDateTime(value, this.timezone);
    }
    /** @ignore */
    ngOnInit() {
        super.ngOnInit();
        this.dateTimeFormat = this.dateTimeFormat || this._getDisplayDateFormat(this.type, this.locale || 'en', this.datePickerMode, this.timePickerMode);
        this.dateTimeRegex = this._dateFormatToRegex(this.dateTimeFormat);
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        // Angular change detection doesn't detect changes when base attributes _disabled is changed so we have to trigger it manually
        this.changeDetector.markForCheck();
    }
    /** @ignore Called when the locale changes */
    _onLocaleChange() {
        this.dateTimeFormat = this._getDisplayDateFormat(this.type, this.locale || 'en', this.datePickerMode, this.timePickerMode);
        this.dateTimeRegex = this._dateFormatToRegex(this.dateTimeFormat);
    }
    /** @ignore */
    ngOnChanges({ value, locale, dateTimeFormat, timezone }) {
        if (locale && locale.currentValue) {
            this._onLocaleChange();
        }
        if (dateTimeFormat) {
            this.dateTimeRegex = this._dateFormatToRegex(dateTimeFormat.currentValue);
        }
        if (timezone) {
            this.selectedDateInternal = stringToDateTime(this.value, timezone.currentValue);
        }
        if (value) {
            this.selectedDateInternal = stringToDateTime(value.currentValue, this.timezone);
        }
    }
    /** @ignore */
    ngAfterViewInit() {
        this.subscribeTouch(this._inputElement.nativeElement, 'blur');
        // if no locale was specified, use the locale observable from the global config
        if (!this.locale) {
            this._dateLocaleService.locale$.pipe(startWith(Settings.defaultLocale), takeUntil(this._componentDestroyed$)).subscribe((locale) => {
                this.locale = locale;
                this._onLocaleChange();
                this.changeDetector.detectChanges();
            });
        }
    }
    /** @ignore Updates the value of our component when the native input value changes */
    onInputValueChange(value) {
        // each date pattern (DD MM etc..) need be completed
        const isValueCompleted = value.length > 0 &&
            this._dateFormatTimeUnits.reduce((allPatternsCompleted, unit) => {
                const patternCompleted = !value.substring(unit.index, unit.index + unit.pattern.length).includes(unit.pattern.charAt(0));
                return allPatternsCompleted && patternCompleted;
            }, true);
        if (isValueCompleted) {
            const parsedDate = stringToDateTime(value, this.timezone, this.dateTimeFormat);
            this._updateEmitValue(dateTimeToString(parsedDate, this.timezone));
        }
        else {
            // value not completed, set the partial value and reset the date value
            this._partialValue = value || this.dateTimeFormat;
            if (this.value) {
                this._updateEmitValue(null);
            }
        }
        this.selectDateInputChar();
        this.onCursorPositionChange();
    }
    /** Called when a date is selected on the calendar */
    onDateSelected(date) {
        this._updateEmitValue(date);
        if (this._showTimePickerOnDateSelected) {
            this._openOverlay('time');
        }
        else {
            this.overlayOpened = false;
        }
    }
    /** Called when a time is selected on the time picker */
    onTimeSelected(date) {
        this._updateEmitValue(date);
    }
    /** Called when the date/time icon is clicked */
    onIconClick() {
        if (this.overlayOpened) {
            this.overlayOpened = false;
        }
        else {
            // focus the input
            this._inputElement.nativeElement.focus();
            this._inputElement.nativeElement.setSelectionRange(0, 0);
            // show the overlay
            this._openOverlay(this.type === 'time' ? 'time' : 'date', this.type === 'datetime');
        }
    }
    /** Called when the overlay is toggled */
    onOverlayToggled(opened) {
        this.overlayOpened = opened;
    }
    /**
     * Called when the cursor position changes. Will update the overlay if needed
     */
    onCursorPositionChange() {
        // find the index start/end positions of the date / time patterns
        const format = this.dateTimeFormat;
        const dateStartIndex = Math.min(...[format.indexOf('y'), format.indexOf('M'), format.indexOf('d')].filter((i) => i !== -1));
        const dateEndIndex = Math.max(...[format.lastIndexOf('y'), format.lastIndexOf('M'), format.lastIndexOf('d')].filter((i) => i !== -1));
        const timeStartIndex = Math.min(...[Math.max(format.indexOf('H'), format.indexOf('h')), format.indexOf('M'), format.indexOf('s'), format.indexOf('a')].filter((i) => i !== -1));
        const timeEndIndex = Math.max(...[Math.max(format.lastIndexOf('H'), format.lastIndexOf('h')), format.lastIndexOf('m'), format.lastIndexOf('s'), format.lastIndexOf('a')].filter((i) => i !== -1));
        const cursorPosition = this._inputElement.nativeElement.selectionStart;
        if (this.type === 'date' || (this.type === 'datetime' && cursorPosition >= dateStartIndex && cursorPosition <= dateEndIndex)) {
            this._openOverlay('date');
        }
        else if (this.type === 'time' || (this.type === 'datetime' && cursorPosition >= timeStartIndex && cursorPosition <= timeEndIndex)) {
            // get the time unit selected
            const timeUnitChar = this.dateTimeFormat.charAt(this._inputElement.nativeElement.selectionStart);
            this.activeTimeUnit = timeUnitChar === 's' ? 'second' : timeUnitChar === 'm' ? 'minute' : 'hour';
            this._openOverlay('time');
        }
        else {
            this.overlayOpened = false;
        }
    }
    /** @ignore Selects the first date character to input from the current cursor position  */
    selectDateInputChar(direction = null) {
        // build an array with all time unit chars used in the current date format (Y, M, D, etc..)
        const patternChars = this._dateFormatTimeUnits.reduce((p, c) => [...p, c.pattern.charAt(0)], []);
        let newCursorPosition;
        if (direction === 'left') {
            newCursorPosition = this._inputElement.nativeElement.selectionStart - 1;
            // if the prev char does not match any char the user has to input, then go back one char more
            while (!patternChars.includes(this.dateTimeFormat.charAt(newCursorPosition)) && newCursorPosition > 0) {
                newCursorPosition--;
            }
        }
        else if (direction === 'right') {
            newCursorPosition = this._inputElement.nativeElement.selectionStart + 1;
            // if the prev char does not match any char the user has to input, then go back one char more
            while (!patternChars.includes(this.dateTimeFormat.charAt(newCursorPosition)) && newCursorPosition < this.dateTimeFormat.length) {
                newCursorPosition++;
            }
        }
        else {
            newCursorPosition = this._inputElement.nativeElement.selectionStart;
            // if the prev char does not match any char the user has to input, then go back one char more
            while (!patternChars.includes(this.dateTimeFormat.charAt(newCursorPosition)) && newCursorPosition < this.dateTimeFormat.length) {
                newCursorPosition++;
            }
        }
        // user can put the cursor after last char so take care of that
        if (newCursorPosition >= this.dateTimeFormat.length) {
            newCursorPosition = this.dateTimeFormat.length - 1;
        }
        else if (newCursorPosition < 0) {
            newCursorPosition = 0;
        }
        this._inputElement.nativeElement.setSelectionRange(newCursorPosition, newCursorPosition + 1);
    }
    /** @ignore Opens the overlay */
    _openOverlay(overlay, showTimePickerOnDateSelected = false) {
        this._showTimePickerOnDateSelected = showTimePickerOnDateSelected;
        if (this.overlayOpened && this.activeOverlay === overlay) {
            return;
        }
        // make sure to close/open to re-trigger animation
        this.overlayOpened = false;
        this.changeDetector.detectChanges();
        this.activeOverlay = overlay;
        this.overlayOpened = true;
        this.changeDetector.detectChanges();
    }
    /** @ignore return the display date format based on the requested picker mode **/
    _getDisplayDateFormat(type, locale, datePickerMode, timePickerMode) {
        const isDatePicked = type === 'date' || type === 'datetime';
        const isTimePicked = type === 'time' || type === 'datetime';
        const hasYear = isDatePicked;
        const hasMonth = isDatePicked && (datePickerMode === 'day' || datePickerMode === 'month');
        const hasDay = isDatePicked && datePickerMode === 'day';
        const hasHour = isTimePicked;
        const hasMinute = isTimePicked;
        const hasSecond = isTimePicked && (timePickerMode === 'second' || timePickerMode === 'millisecond');
        const hasMillisecond = isTimePicked && timePickerMode === 'millisecond';
        const dateTimeFormatOptions = {
            ...(hasYear ? { year: 'numeric' } : {}),
            ...(hasMonth ? { month: '2-digit' } : {}),
            ...(hasDay ? { day: '2-digit' } : {}),
            ...(hasHour ? { hour: 'numeric' } : {}),
            ...(hasMinute ? { minute: '2-digit' } : {}),
            ...(hasSecond ? { second: '2-digit' } : {}),
            ...(hasMillisecond ? { millisecond: '2-digit' } : {}),
        };
        const getDateFormatPattern = () => {
            const is12HourLocale = is12HourTimeLocale(locale);
            const getPatternForPart = (part) => {
                switch (part.type) {
                    case 'day':
                        return 'dd';
                    case 'month':
                        return 'MM';
                    case 'year':
                        return 'yyyy';
                    case 'minute':
                        return 'mm';
                    case 'hour':
                        return is12HourLocale ? 'hh' : 'HH';
                    case 'second':
                        return 'ss';
                    case 'literal':
                        return part.value === ', ' ? ' ' : part.value;
                    default:
                        return '';
                }
            };
            // create the display format using a localized date split into date / time parts
            let displayFormat = new Intl.DateTimeFormat(locale, dateTimeFormatOptions)
                .formatToParts(DateTime.fromJSDate(new Date()).endOf('year').startOf('day').toJSDate())
                .map(getPatternForPart)
                .join('')
                .trim();
            // add the milliseconds as its not supported by format parts
            if (hasMillisecond) {
                displayFormat += '.SSS';
            }
            if (isTimePicked && is12HourLocale) {
                displayFormat += ' a';
            }
            return displayFormat;
        };
        return getDateFormatPattern();
    }
    /** @ignore converts the date format into regex used to filter whats being typed in the input **/
    _dateFormatToRegex(dateFormat) {
        const timeUnits = Object.keys(this._timeUnitRegex);
        this._dateFormatTimeUnits = timeUnits
            .reduce((res, timeUnit) => {
            const index = dateFormat.indexOf(timeUnit);
            if (index > -1) {
                return [...res, { index, pattern: timeUnit }];
            }
            return res;
        }, [])
            .sort((a, b) => (a.index < b.index ? -1 : 1));
        const formatRegex = this._dateFormatTimeUnits.reduce((regex, timeUnit, i) => {
            const timeUnitEndOffset = timeUnit.index + timeUnit.pattern.length;
            const timeUnitRegex = this._timeUnitRegex[timeUnit.pattern];
            const separator = dateFormat.substring(timeUnitEndOffset, this._dateFormatTimeUnits[i + 1]?.index || timeUnitEndOffset);
            return `${regex}${timeUnitRegex}${separator}`;
        }, '');
        return `^${formatRegex}$`;
    }
    /** returns the data to display in the input field. **/
    get displayValue() {
        // either a valid date formatted or a partial value
        return this.selectedDateInternal ? this.selectedDateInternal.toFormat(this.dateTimeFormat) : this._partialValue;
    }
    /** called when text is pasted into the input field **/
    onInputPaste(value) {
        // try to parse the pasted text as a date
        const parsedDate = stringToDateTime(value, this.timezone, this.dateTimeFormat);
        if (parsedDate?.isValid) {
            this._updateEmitValue(dateTimeToString(parsedDate, this.timezone));
        }
    }
    /** called when the input is clicked **/
    onInputClick() {
        // if the value is blank, set the pattern
        if (!this._inputElement.nativeElement.value) {
            this._partialValue = this.dateTimeFormat;
            this.changeDetector.detectChanges();
            this._inputElement.nativeElement.setSelectionRange(0, 0);
        }
        // select the char at the cursor location
        this.selectDateInputChar();
        this.onCursorPositionChange();
    }
    /** called when an invalid input is entered **/
    onInvalidInput(event) {
        // reselect the invalid char on invalid input
        this._inputElement.nativeElement.setSelectionRange(event.cursorPosition - 1, event.cursorPosition);
    }
    /** called when the delete / backspace keys are pressed to delete a char on the input **/
    onDeleteInputText(event, keepCursorPosition) {
        event.preventDefault();
        event.stopPropagation();
        const firstDeleteCharPosition = this._inputElement.nativeElement.selectionStart;
        const lastDeleteCharPosition = this._inputElement.nativeElement.selectionEnd - 1;
        const currentValue = this._inputElement.nativeElement.value;
        const newValue = `${currentValue.substring(0, firstDeleteCharPosition)}${this.dateTimeFormat.substring(firstDeleteCharPosition, lastDeleteCharPosition + 1)}${currentValue.substring(lastDeleteCharPosition + 1)}`;
        // the value is not valid anymore as we deleted a char
        this._partialValue = newValue;
        this._updateEmitValue(null);
        // reset the cursor selection
        this.changeDetector.detectChanges();
        this._inputElement.nativeElement.selectionStart = firstDeleteCharPosition;
        this._inputElement.nativeElement.selectionEnd = firstDeleteCharPosition;
        this.selectDateInputChar(keepCursorPosition ? null : 'left');
        this.onCursorPositionChange();
    }
    /** called when input loses focus **/
    onInputBlur() {
        this.focused = false;
        // reset to blank if no data was entered
        if (this._partialValue === this.dateTimeFormat) {
            this._partialValue = '';
        }
    }
    /** called when input is focused **/
    onInputFocus() {
        this.focused = true;
    }
    /** @ignore once a valid date is parsed, update the value and emit the change. Checks if its in the min/max range **/
    _updateEmitValue(value) {
        // if we dont have a value no need to parse the date
        if (!value) {
            this.value = null;
            this.selectedDateInternal = null;
            this.propagateChange(null);
            this.changed.emit(null);
            return;
        }
        // unset all the time units not in used (e.g. 2020-04-01T00:00:00.000 for month selection only - set first day of month and zero the
        // hours mins etc..)
        const unsetTimeUnitNotUsed = (dd) => {
            dd = dd.set({ millisecond: this.type === 'date' || this.timePickerMode === 'minute' || this.timePickerMode === 'second' ? 0 : dd.millisecond });
            dd = dd.set({ second: this.type === 'date' || this.timePickerMode === 'minute' ? 0 : dd.second });
            dd = dd.set({ minute: this.type === 'date' ? 0 : dd.minute });
            dd = dd.set({ hour: this.type === 'date' ? 0 : dd.hour });
            dd = dd.set({ month: this.type === 'datetime' && this.datePickerMode === 'year' ? 1 : dd.month });
            dd = dd.set({ day: this.type === 'datetime' && this.datePickerMode === 'month' ? 1 : dd.day });
            return dd;
        };
        this.selectedDateInternal = unsetTimeUnitNotUsed(stringToDateTime(value, this.timezone));
        this.value = dateTimeToString(this.selectedDateInternal, this.timezone);
        this.propagateChange(this.value);
        this.changed.emit(this.value);
    }
    /** @ignore */
    ngOnDestroy() {
        super.ngOnDestroy();
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputDateTimePickerComponent, deps: [{ token: i0.Renderer2 }, { token: i1$3.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }, { token: DATE_TIME_OPTIONS }, { token: DateLocaleService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: InputDateTimePickerComponent, selector: "avn-input-date-time-picker", inputs: { label: "label", datePickerMode: "datePickerMode", timePickerMode: "timePickerMode", locale: "locale", timezone: "timezone", type: "type", value: "value", minSelectableDate: "minSelectableDate", maxSelectableDate: "maxSelectableDate" }, outputs: { changed: "changed" }, providers: [
            {
                provide: FormControlComponent,
                useExisting: InputDateTimePickerComponent,
            },
        ], viewQueries: [{ propertyName: "_inputElement", first: true, predicate: ["inputElement"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div class=\"input-wrapper\" [class.disabled]=\"disabled\" [class.focus]=\"focused\" #overlayOrigin=\"cdkOverlayOrigin\" cdkOverlayOrigin>\n  <input\n    #inputElement\n    [id]=\"id\"\n    autocomplete=\"new-password\"\n    [disabled]=\"disabled\"\n    [placeholder]=\"dateTimeFormat\"\n    [value]=\"displayValue\"\n    (inputChange)=\"onInputValueChange($event)\"\n    (inputInvalid)=\"onInvalidInput($event)\"\n    (paste)=\"$event.preventDefault(); $event.stopPropagation(); onInputPaste($event.clipboardData.getData('text'))\"\n    (change)=\"$event.preventDefault(); $event.stopPropagation()\"\n    (click)=\"onInputClick()\"\n    (focus)=\"onInputFocus()\"\n    (blur)=\"onInputBlur()\"\n    [avnInputRegex]=\"dateTimeRegex\"\n    [lastValidValue]=\"displayValue\"\n    (keydown.arrowLeft)=\"$event.preventDefault(); selectDateInputChar('left'); onCursorPositionChange()\"\n    (keydown.arrowRight)=\"$event.preventDefault(); selectDateInputChar('right'); onCursorPositionChange()\"\n    (keydown.arrowUp)=\"$event.preventDefault()\"\n    (keydown.arrowDown)=\"$event.preventDefault()\"\n    (keydown.backspace)=\"onDeleteInputText($event, false)\"\n    (keydown.delete)=\"onDeleteInputText($event, true)\"\n  />\n  <avn-icon\n    class=\"input-icon\"\n    [icon]=\"type === 'date' || type === 'datetime' ? 'action:date_range' : 'device:access_time'\"\n    (click)=\"!this.disabled && onIconClick()\"\n  ></avn-icon>\n</div>\n<avn-connected-element\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"overlayOpened\"\n  (toggled)=\"onOverlayToggled($event)\"\n  [width]=\"'auto'\"\n  [closeOnOutsideClick]=\"true\"\n>\n  <avn-calendar\n    *ngIf=\"activeOverlay === 'date'\"\n    [locale]=\"locale\"\n    [timezone]=\"timezone\"\n    [selectedDate]=\"value\"\n    [selectionMode]=\"datePickerMode\"\n    [minSelectableDate]=\"minSelectableDate\"\n    [maxSelectableDate]=\"maxSelectableDate\"\n    (selected)=\"onDateSelected($event)\"\n  ></avn-calendar>\n  <avn-time-picker\n    *ngIf=\"activeOverlay === 'time'\"\n    [locale]=\"locale\"\n    [timezone]=\"timezone\"\n    [showKeypad]=\"showTimeKeypad\"\n    [selectedTime]=\"value\"\n    [showSeconds]=\"timePickerMode === 'second' || timePickerMode === 'millisecond'\"\n    [activeTimeUnit]=\"activeTimeUnit\"\n    (selected)=\"onTimeSelected($event)\"\n  ></avn-time-picker>\n</avn-connected-element>\n", styles: [":host{display:block}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host.validation-theme.ng-valid.ng-touched .input-wrapper,:host.validation-theme.ng-valid.ng-dirty .input-wrapper{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-wrapper,:host.validation-theme.ng-invalid.ng-dirty .input-wrapper{border-color:var(--danger-base)!important}:host .input-wrapper{position:relative;border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;width:100%;padding:var(--space-sm) var(--space-base);outline:0}:host .input-wrapper:hover,:host .input-wrapper:focus,:host .input-wrapper.focus{border-color:var(--form-control-hover-border)}:host .input-wrapper:disabled,:host .input-wrapper:disabled:hover,:host .input-wrapper:disabled:focus,:host .input-wrapper.disabled,:host .input-wrapper.disabled:hover,:host .input-wrapper.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-wrapper>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;width:100%;border:0;outline:0;padding:0}:host .input-wrapper>input::placeholder{color:var(--form-control-placeholder)}:host .input-wrapper>input:disabled,:host .input-wrapper>input:disabled:hover,:host .input-wrapper>input:disabled:focus,:host .input-wrapper>input.disabled,:host .input-wrapper>input.disabled:hover,:host .input-wrapper>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-wrapper>input:focus:not(:disabled){border-color:var(--form-control-hover-border)}:host .input-wrapper>input:focus:not(:disabled)+.input-icon{color:inherit}:host .input-wrapper avn-icon.input-icon{color:var(--form-control-icon);-webkit-user-select:none;user-select:none;margin-left:var(--space-base)}:host .input-wrapper:not(.disabled){cursor:pointer}:host .input-wrapper:not(.disabled):hover avn-icon.input-icon{color:var(--form-control-on)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: ConnectedElementComponent, selector: "avn-connected-element", inputs: ["minWidth", "width", "overlayOrigin", "opened", "hasOverlayBackdrop", "hasVisibleBackdrop", "positions", "closeOnOutsideClick", "transparent"], outputs: ["clickOutside", "toggled"] }, { kind: "directive", type: i1$4.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: CalendarComponent, selector: "avn-calendar", inputs: ["selectedDate", "locale", "autoFillIncompleteWeeks", "fixedHeight", "minSelectableDate", "maxSelectableDate", "selectionMode", "timezone"], outputs: ["selected"] }, { kind: "component", type: TimePickerComponent, selector: "avn-time-picker", inputs: ["selectedTime", "showSeconds", "showKeypad", "use24HourFormat", "locale", "debounceSelectedTime", "timezone", "autoIncreaseTime", "activeTimeUnit"], outputs: ["selected"] }, { kind: "directive", type: InputRegexDirective, selector: "input[avnInputRegex]", inputs: ["avnInputRegex", "lastValidValue"], outputs: ["inputChange", "inputInvalid"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputDateTimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-input-date-time-picker', providers: [
                        {
                            provide: FormControlComponent,
                            useExisting: InputDateTimePickerComponent,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<label *ngIf=\"label\" [for]=\"id\" [ngClass]=\"{ disabled: disabled }\">{{ label }}</label>\n<div class=\"input-wrapper\" [class.disabled]=\"disabled\" [class.focus]=\"focused\" #overlayOrigin=\"cdkOverlayOrigin\" cdkOverlayOrigin>\n  <input\n    #inputElement\n    [id]=\"id\"\n    autocomplete=\"new-password\"\n    [disabled]=\"disabled\"\n    [placeholder]=\"dateTimeFormat\"\n    [value]=\"displayValue\"\n    (inputChange)=\"onInputValueChange($event)\"\n    (inputInvalid)=\"onInvalidInput($event)\"\n    (paste)=\"$event.preventDefault(); $event.stopPropagation(); onInputPaste($event.clipboardData.getData('text'))\"\n    (change)=\"$event.preventDefault(); $event.stopPropagation()\"\n    (click)=\"onInputClick()\"\n    (focus)=\"onInputFocus()\"\n    (blur)=\"onInputBlur()\"\n    [avnInputRegex]=\"dateTimeRegex\"\n    [lastValidValue]=\"displayValue\"\n    (keydown.arrowLeft)=\"$event.preventDefault(); selectDateInputChar('left'); onCursorPositionChange()\"\n    (keydown.arrowRight)=\"$event.preventDefault(); selectDateInputChar('right'); onCursorPositionChange()\"\n    (keydown.arrowUp)=\"$event.preventDefault()\"\n    (keydown.arrowDown)=\"$event.preventDefault()\"\n    (keydown.backspace)=\"onDeleteInputText($event, false)\"\n    (keydown.delete)=\"onDeleteInputText($event, true)\"\n  />\n  <avn-icon\n    class=\"input-icon\"\n    [icon]=\"type === 'date' || type === 'datetime' ? 'action:date_range' : 'device:access_time'\"\n    (click)=\"!this.disabled && onIconClick()\"\n  ></avn-icon>\n</div>\n<avn-connected-element\n  [overlayOrigin]=\"overlayOrigin\"\n  [opened]=\"overlayOpened\"\n  (toggled)=\"onOverlayToggled($event)\"\n  [width]=\"'auto'\"\n  [closeOnOutsideClick]=\"true\"\n>\n  <avn-calendar\n    *ngIf=\"activeOverlay === 'date'\"\n    [locale]=\"locale\"\n    [timezone]=\"timezone\"\n    [selectedDate]=\"value\"\n    [selectionMode]=\"datePickerMode\"\n    [minSelectableDate]=\"minSelectableDate\"\n    [maxSelectableDate]=\"maxSelectableDate\"\n    (selected)=\"onDateSelected($event)\"\n  ></avn-calendar>\n  <avn-time-picker\n    *ngIf=\"activeOverlay === 'time'\"\n    [locale]=\"locale\"\n    [timezone]=\"timezone\"\n    [showKeypad]=\"showTimeKeypad\"\n    [selectedTime]=\"value\"\n    [showSeconds]=\"timePickerMode === 'second' || timePickerMode === 'millisecond'\"\n    [activeTimeUnit]=\"activeTimeUnit\"\n    (selected)=\"onTimeSelected($event)\"\n  ></avn-time-picker>\n</avn-connected-element>\n", styles: [":host{display:block}:host>label{color:var(--form-control-label);text-transform:var(--form-control-label-case);font-size:var(--form-control-label-size);letter-spacing:var(--form-control-label-letter-spacing)}:host>label.disabled{opacity:.3}:host.validation-theme.ng-valid.ng-touched .input-wrapper,:host.validation-theme.ng-valid.ng-dirty .input-wrapper{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched .input-wrapper,:host.validation-theme.ng-invalid.ng-dirty .input-wrapper{border-color:var(--danger-base)!important}:host .input-wrapper{position:relative;border:1px solid var(--form-control-border);border-radius:.25rem;color:var(--form-control-on);background:var(--form-control-background);display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;width:100%;padding:var(--space-sm) var(--space-base);outline:0}:host .input-wrapper:hover,:host .input-wrapper:focus,:host .input-wrapper.focus{border-color:var(--form-control-hover-border)}:host .input-wrapper:disabled,:host .input-wrapper:disabled:hover,:host .input-wrapper:disabled:focus,:host .input-wrapper.disabled,:host .input-wrapper.disabled:hover,:host .input-wrapper.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-wrapper>input{outline-style:none;outline-offset:-2px;color:inherit;background:none;width:100%;border:0;outline:0;padding:0}:host .input-wrapper>input::placeholder{color:var(--form-control-placeholder)}:host .input-wrapper>input:disabled,:host .input-wrapper>input:disabled:hover,:host .input-wrapper>input:disabled:focus,:host .input-wrapper>input.disabled,:host .input-wrapper>input.disabled:hover,:host .input-wrapper>input.disabled:focus{border-color:var(--form-control-border);cursor:not-allowed;opacity:.3}:host .input-wrapper>input:focus:not(:disabled){border-color:var(--form-control-hover-border)}:host .input-wrapper>input:focus:not(:disabled)+.input-icon{color:inherit}:host .input-wrapper avn-icon.input-icon{color:var(--form-control-icon);-webkit-user-select:none;user-select:none;margin-left:var(--space-base)}:host .input-wrapper:not(.disabled){cursor:pointer}:host .input-wrapper:not(.disabled):hover avn-icon.input-icon{color:var(--form-control-on)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DATE_TIME_OPTIONS]
                }] }, { type: DateLocaleService }]; }, propDecorators: { _inputElement: [{
                type: ViewChild,
                args: ['inputElement', { static: true }]
            }], label: [{
                type: Input
            }], datePickerMode: [{
                type: Input
            }], timePickerMode: [{
                type: Input
            }], locale: [{
                type: Input
            }], timezone: [{
                type: Input
            }], type: [{
                type: Input
            }], value: [{
                type: Input
            }], minSelectableDate: [{
                type: Input
            }], maxSelectableDate: [{
                type: Input
            }], changed: [{
                type: Output
            }] } });

class InputDateTimePickerModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputDateTimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: InputDateTimePickerModule, declarations: [InputDateTimePickerComponent], imports: [CommonModule, FormsModule, IconModule, ConnectedElementModule, OverlayModule$1, CalendarModule, TimePickerModule, CoreModule], exports: [InputDateTimePickerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputDateTimePickerModule, imports: [CommonModule, FormsModule, IconModule, ConnectedElementModule, OverlayModule$1, CalendarModule, TimePickerModule, CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: InputDateTimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, IconModule, ConnectedElementModule, OverlayModule$1, CalendarModule, TimePickerModule, CoreModule],
                    declarations: [InputDateTimePickerComponent],
                    exports: [InputDateTimePickerComponent],
                }]
        }] });

const TestingWindowProvider = {
    provide: WINDOW,
    useFactory: windowFactory,
    deps: [WindowRef, PLATFORM_ID],
};
const TestingWindowProviders = [
    { provide: WindowRef, useClass: BrowserWindowRef },
    {
        provide: WINDOW,
        useFactory: windowFactory,
        deps: [WindowRef, PLATFORM_ID],
    },
];
//
// export const TestingToastSettingsProvider: Provider = [
//   {provide: TOAST_SETTINGS, useValue: DEFAULT_TOAST_SETTINGS}
// ];
const TestingFormControlValidationProvider = [
    {
        provide: FORM_CONTROL_VALIDATION_OPTIONS,
        useValue: {
            enableValidTheme: true,
            enableInvalidTheme: true,
        },
    },
];
const TestingScrollConfigProvider = {
    provide: SCROLL_OPTIONS,
    useValue: DEFAULT_SCROLL_OPTIONS,
};
/**
 * for OnPush components, fixture.detectChanges will only work once.
 So use fixture.detectChanges() for the initial change detection (to call ngOnInit,
 ngAfterViewInit etc..) and get the change detector to use it for any subsequent change
 detection https://github.com/angular/angular/issues/12313
 */
const detectChanges = (fixture) => {
    const changeDetector = fixture.debugElement.injector.get(ChangeDetectorRef);
    changeDetector.detectChanges();
};

const EMPLOYEE_TEST_DATA = [
    {
        name: 'Ethel Price',
        gender: 'female',
        company: 'Johnson, Johnson and Partners, LLC avnP DDC',
        age: 22,
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Ethel Price',
        gender: 'female',
        company: 'Johnson, Johnson and Partners, LLC avnP DDC',
        age: 22,
        address: {
            post: '1234h',
            addr: '9230 rue found 1',
        },
    },
    {
        name: 'Ethel A',
        gender: 'female',
        company: 'Johnson, Johnson and Partners, LLC avnP DDC',
        age: 22,
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Ethel C',
        gender: 'female',
        company: 'Johnson, Johnson and Partners, LLC avnP DDC',
        age: 22,
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Ethel C',
        gender: 'female',
        company: 'Johnson, Johnson and Partners, LLC avnP DDC',
        age: 22,
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Claudine Neal',
        gender: 'female',
        company: 'Sealoud',
        age: 55,
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Beryl Rice',
        gender: 'female',
        company: 'Velity',
        age: 67,
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Wilder Gonzales',
        gender: 'male',
        company: 'Geekko',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Georgina Schultz',
        gender: 'female',
        company: 'Suretech',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Carroll Buchanan',
        gender: 'male',
        company: 'Ecosys',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Valarie Atkinson',
        gender: 'female',
        company: 'Hopeli',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Schroeder Mathews',
        gender: 'male',
        company: 'Polarium',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Lynda Mendoza',
        gender: 'female',
        company: 'Dogspa',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Sarah Massey',
        gender: 'female',
        company: 'Bisba',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Robles Boyle',
        gender: 'male',
        company: 'Comtract',
    },
    {
        name: 'Evans Hickman',
        gender: 'male',
        company: 'Parleynet',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Dawson Barber',
        gender: 'male',
        company: 'Dymi',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Bruce Strong',
        gender: 'male',
        company: 'Xyqag',
    },
    {
        name: 'Nellie Whitfield',
        gender: 'female',
        company: 'Exospace',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Jackson Macias',
        gender: 'male',
        company: 'Aquamate',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Pena Pena',
        gender: 'male',
        company: 'Quarx',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Lelia Gates',
        gender: 'female',
        company: 'Proxsoft',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Letitia Vasquez',
        gender: 'female',
        company: 'Slumberia',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Trevino Moreno',
        gender: 'male',
        company: 'Conjurica',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Barr Page',
        gender: 'male',
        company: 'Apex',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Kirkland Merrill',
        gender: 'male',
        company: 'Utara',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Blanche Conley',
        gender: 'female',
        company: 'Imkan',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Atkins Dunlap',
        gender: 'male',
        company: 'Comveyor',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Everett Foreman',
        gender: 'male',
        company: 'Maineland',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Gould Randolph',
        gender: 'male',
        company: 'Intergeek',
        address: {
            post: '1234',
            addr: '9230 rue found',
        },
    },
    {
        name: 'Kelli Leon',
        gender: 'female',
        company: 'Verbus',
    },
    {
        name: 'Freda Mason',
        gender: 'female',
        company: 'Accidency',
    },
    {
        name: 'Tucker Maxwell',
        gender: 'male',
        company: 'Lumbrex',
    },
    {
        name: 'Yvonne Parsons',
        gender: 'female',
        company: 'Zolar',
    },
    {
        name: 'Woods Key',
        gender: 'male',
        company: 'Bedder',
    },
    {
        name: 'Stephens Reilly',
        gender: 'male',
        company: 'Acusage',
    },
    {
        name: 'Mcfarland Sparks',
        gender: 'male',
        company: 'Comvey',
    },
    {
        name: 'Jocelyn Sawyer',
        gender: 'female',
        company: 'Fortean',
    },
    {
        name: 'Renee Barr',
        gender: 'female',
        company: 'Kiggle',
    },
    {
        name: 'Gaines Beck',
        gender: 'male',
        company: 'Sequitur',
    },
    {
        name: 'Luisa Farrell',
        gender: 'female',
        company: 'Cinesanct',
    },
    {
        name: 'Robyn Strickland',
        gender: 'female',
        company: 'Obones',
    },
    {
        name: 'Roseann Jarvis',
        gender: 'female',
        company: 'Aquazure',
    },
    {
        name: 'Johnston Park',
        gender: 'male',
        company: 'Netur',
    },
    {
        name: 'Wong Craft',
        gender: 'male',
        company: 'Opticall',
    },
    {
        name: 'Merritt Cole',
        gender: 'male',
        company: 'Techtrix',
    },
    {
        name: 'Dale Byrd',
        gender: 'female',
        company: 'Kneedles',
    },
    {
        name: 'Sara Delgado',
        gender: 'female',
        company: 'Netagy',
    },
    {
        name: 'Alisha Myers',
        gender: 'female',
        company: 'Intradisk',
    },
    {
        name: 'Felecia Smith',
        gender: 'female',
        company: 'Futurity',
    },
    {
        name: 'Neal Harvey',
        gender: 'male',
        company: 'Pyramax',
    },
    {
        name: 'Nola Miles',
        gender: 'female',
        company: 'Sonique',
    },
    {
        name: 'Herring Pierce',
        gender: 'male',
        company: 'Geeketron',
    },
    {
        name: 'Shelley Rodriquez',
        gender: 'female',
        company: 'Bostonic',
    },
    {
        name: 'Cora Chase',
        gender: 'female',
        company: 'Isonus',
    },
    {
        name: 'Mckay Santos',
        gender: 'male',
        company: 'Amtas',
    },
    {
        name: 'Hilda Crane',
        gender: 'female',
        company: 'Jumpstack',
    },
    {
        name: 'Jeanne Lindsay',
        gender: 'female',
        company: 'Genesynk',
    },
    {
        name: 'Frye Sharpe',
        gender: 'male',
        company: 'Eplode',
    },
    {
        name: 'Velma Fry',
        gender: 'female',
        company: 'Ronelon',
    },
    {
        name: 'Reyna Espinoza',
        gender: 'female',
        company: 'Prismatic',
    },
    {
        name: 'Spencer Sloan',
        gender: 'male',
        company: 'Comverges',
    },
    {
        name: 'Graham Marsh',
        gender: 'male',
        company: 'Medifax',
    },
    {
        name: 'Hale Boone',
        gender: 'male',
        company: 'Digial',
    },
    {
        name: 'Wiley Hubbard',
        gender: 'male',
        company: 'Zensus',
    },
    {
        name: 'Blackburn Drake',
        gender: 'male',
        company: 'Frenex',
    },
    {
        name: 'Franco Hunter',
        gender: 'male',
        company: 'Rockabye',
    },
    {
        name: 'Barnett Case',
        gender: 'male',
        company: 'Norali',
    },
    {
        name: 'Alexander Foley',
        gender: 'male',
        company: 'Geekosis',
    },
    {
        name: 'Lynette Stein',
        gender: 'female',
        company: 'Macronaut',
    },
    {
        name: 'Anthony Joyner',
        gender: 'male',
        company: 'Senmei',
    },
    {
        name: 'Garrett Brennan',
        gender: 'male',
        company: 'Bluegrain',
    },
    {
        name: 'Betsy Horton',
        gender: 'female',
        company: 'Zilla',
    },
    {
        name: 'Patton Small',
        gender: 'male',
        company: 'Genmex',
    },
    {
        name: 'Lakisha Huber',
        gender: 'female',
        company: 'Insource',
    },
    {
        name: 'Lindsay Avery',
        gender: 'female',
        company: 'Unq',
    },
    {
        name: 'Ayers Hood',
        gender: 'male',
        company: 'Accuprint',
    },
    {
        name: 'Torres Durham',
        gender: 'male',
        company: 'Uplinx',
    },
    {
        name: 'Vincent Hernandez',
        gender: 'male',
        company: 'Talendula',
    },
    {
        name: 'Baird Ryan',
        gender: 'male',
        company: 'Aquasseur',
    },
    {
        name: 'Georgia Mercer',
        gender: 'female',
        company: 'Skyplex',
    },
    {
        name: 'Francesca Elliott',
        gender: 'female',
        company: 'Nspire',
    },
    {
        name: 'Lyons Peters',
        gender: 'male',
        company: 'Quinex',
    },
    {
        name: 'Kristi Brewer',
        gender: 'female',
        company: 'Oronoko',
    },
    {
        name: 'Tonya Bray',
        gender: 'female',
        company: 'Insuron',
    },
    {
        name: 'Valenzuela Huff',
        gender: 'male',
        company: 'Applideck',
    },
    {
        name: 'Tiffany Anderson',
        gender: 'female',
        company: 'Zanymax',
    },
    {
        name: 'Jerri King',
        gender: 'female',
        company: 'Eventex',
    },
    {
        name: 'Rocha Meadows',
        gender: 'male',
        company: 'Goko',
    },
    {
        name: 'Marcy Green',
        gender: 'female',
        company: 'Pharmex',
    },
    {
        name: 'Kirk Cross',
        gender: 'male',
        company: 'Portico',
    },
    {
        name: 'Hattie Mullen',
        gender: 'female',
        company: 'Zilencio',
    },
    {
        name: 'Deann Bridges',
        gender: 'female',
        company: 'Equitox',
    },
    {
        name: 'Chaney Roach',
        gender: 'male',
        company: 'Qualitern',
    },
    {
        name: 'Consuelo Dickson',
        gender: 'female',
        company: 'Poshome',
    },
    {
        name: 'Billie Rowe',
        gender: 'female',
        company: 'Cemention',
    },
    {
        name: 'Bean Donovan',
        gender: 'male',
        company: 'Mantro',
    },
    {
        name: 'Lancaster Patel',
        gender: 'male',
        company: 'Krog',
    },
    {
        name: 'Rosa Dyer',
        gender: 'female',
        company: 'Netility',
    },
    {
        name: 'Christine Compton',
        gender: 'female',
        company: 'Bleeko',
    },
    {
        name: 'Milagros Finch',
        gender: 'female',
        company: 'Handshake',
    },
    {
        name: 'Ericka Alvarado',
        gender: 'female',
        company: 'Lyrichord',
    },
    {
        name: 'Sylvia Sosa',
        gender: 'female',
        company: 'Circum',
    },
    {
        name: 'a Sosa',
        gender: 'female',
        company: 'Circum',
    },
    {
        name: 'b Sosa',
        gender: 'female',
        company: 'Circum',
    },
    {
        name: 'c Sosa',
        gender: 'female',
        company: 'Circum',
    },
    {
        name: 'd Sosa',
        gender: 'female',
        company: 'Circum',
    },
    {
        name: 'e Sosa',
        gender: 'female',
        company: 'Circum',
    },
    {
        name: 'Humphrey Curtis',
        gender: 'male',
        company: 'Corepan',
    },
];
const EMPLOYEE_TEST_DATA_EXTRA = [
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
    ...EMPLOYEE_TEST_DATA,
];

/**
 * A server used to mock a paged data result from a server
 */
class MockServerResultsService {
    constructor(data) {
        // map when the id is different from the prop
        this.idPropMap = new Map([
            ['address', 'address.addr'],
            ['killedBy', 'killedBy.characterName'],
        ]);
        if (data) {
            this.data = data;
        }
        else {
            this.data = EMPLOYEE_TEST_DATA;
        }
    }
    getResultsCount() {
        return this.data.length;
    }
    getEmployeeNames() {
        return EMPLOYEE_TEST_DATA.map((employee) => ({
            label: employee.name,
            value: employee.name,
        }));
    }
    getResults(offset, limit, sort, delayMs = 1000) {
        const idPropMap = this.idPropMap;
        const sortData = (data, s) => {
            if (!s) {
                return data;
            }
            data.sort((a, b) => {
                const prop = s.prop || idPropMap.get(s.id) || s.id;
                return (a[prop] || '').toString().localeCompare((b[prop] || '').toString()) * (sort.direction === 'desc' || sort.dir === 'desc' ? -1 : 1);
            });
            return data;
        };
        const dataObservable = of(sortData(this.data, sort).slice(offset, offset + limit));
        if (delayMs > 0) {
            return dataObservable.pipe(delay(delayMs));
        }
        return dataObservable;
    }
    searchResults(searchText, prop, matchType, caseSensitive) {
        searchText = searchText || '';
        const dataArray = [...this.data].map((data) => data[prop]);
        const result = dataArray.filter((data) => {
            data = data === 'string' ? data : JSON.stringify(data);
            data = caseSensitive ? data : data.toLowerCase();
            searchText = caseSensitive ? searchText : searchText.toLowerCase();
            if (matchType === 'contains') {
                return data.includes(searchText.toLowerCase());
            }
            else if (matchType === 'startsWith') {
                return data.toLowerCase().startsWith(searchText.toLowerCase());
            }
            return false;
        });
        return result ? result : [];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MockServerResultsService, deps: [{ token: 'MOCK_DATA', optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MockServerResultsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: MockServerResultsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['MOCK_DATA']
                }] }]; } });

const TestTheme = {
    themeName: 'test-theme',
    themeType: 'dark',
    primaryBase: 'rgb(0, 105, 171)',
    secondaryBase: 'rgb(27, 162, 247)',
    highlightBase: 'rgb(252, 201, 15)',
    dangerBase: 'rgb(245, 28, 49)',
    warningBase: 'rgb(247, 113, 41)',
    successBase: 'rgb(1, 175, 22)',
    infoBase: 'rgb(104, 230, 248)',
    mainBackground: 'rgb(39, 43, 48)',
};
/**
 * returns the default config for theming
 */
const DEFAULT_THEME_CONFIG = {
    defaultTheme: TestTheme.themeName,
    availableThemes: [TestTheme],
};
const DEFAULT_THEME_PROVIDERS = [
    { provide: DEFAULT_THEME, useValue: TestTheme.themeName },
    { provide: AVAILABLE_THEMES, useValue: [TestTheme] },
];

/**
 * Token to inject the map of lazy non routable modules for each of the lazy components
 */
const LAZY_COMPONENT_MODULES_MAP = new InjectionToken('LAZY_MODULES_MAP');
/**
 * Some lazy components may require permissions to be loaded. Use this token to inject a permission provider.
 */
const LAZY_MODULES_PERMISSIONS_PROVIDER = new InjectionToken('LAZY_MODULES_PERMISSIONS_PROVIDER');
/**
 * Some lazy components may require permissions to be loaded. Use this token to inject a permission provider.
 */
const LAZY_COMPONENT_DATA = new InjectionToken('LAZY_COMPONENT_DATA');

/**
 * Service to cache lazy loaded module references
 */
class LazyModuleCacheService {
    constructor() {
        this.cache = new Map();
    }
    getModuleInfo(lazyComponentKey) {
        return this.cache.get(lazyComponentKey);
    }
    setModuleInfo(lazyComponentKey, moduleInfo) {
        this.cache.set(lazyComponentKey, moduleInfo);
    }
    destroy(lazyComponentKey) {
        if (this.cache.has(lazyComponentKey)) {
            this.cache.get(lazyComponentKey).moduleRef.destroy();
            this.cache.delete(lazyComponentKey);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyModuleCacheService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyModuleCacheService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyModuleCacheService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class LazyComponentDirective {
    constructor(_viewContainerRef, _injector, _compiler, _loadModuleService, lazyComponentModulesMap, permissionsProvider) {
        this._viewContainerRef = _viewContainerRef;
        this._injector = _injector;
        this._compiler = _compiler;
        this._loadModuleService = _loadModuleService;
        this.lazyComponentModulesMap = lazyComponentModulesMap;
        this.permissionsProvider = permissionsProvider;
        /** Minimum loading time before the component appears (useful to avoid flickers when loading the component is very fast) **/
        // eslint-disable-next-line @angular-eslint/no-input-rename
        this.minLoadingTimeMs = 500;
        /** Emits a reference of the created component when loaded successfully. Emits null if not loaded successfully **/
        // eslint-disable-next-line @angular-eslint/no-output-rename
        this.loaded = new EventEmitter();
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.permissionsProvider
            .canLoad(this.lazyComponentKey)
            .pipe(take(1), mergeMap((canLoad) => {
            if (!canLoad) {
                this.loaded.emit(null);
                return EMPTY;
            }
            // check if a module to load for that component was provided
            const moduleCallback = this.lazyComponentModulesMap[this.lazyComponentKey];
            if (!moduleCallback) {
                console.warn(`Please provide a module and component to be loaded for the identifier "${this.lazyComponentKey}".
              It needs to be included in the LoadModuleModule.forRoot configuration.`);
                this.loaded.emit(null);
                return EMPTY;
            }
            // Now while the module/component is loading, display a loader
            // either use the loading template provided or default to a simple icon loader
            if (this.loadingTemplate) {
                this._viewContainerRef.createEmbeddedView(this.loadingTemplate);
            }
            else {
                const ref = this._viewContainerRef.createComponent(IconComponent, { index: 0, injector: this._injector });
                ref.instance.ngOnChanges({ icon: new SimpleChange(null, 'notification:sync', false) });
                ref.instance.rotate = true;
                ref.changeDetectorRef.detectChanges();
                ref.location.nativeElement.classList.add('default-loader');
            }
            // get the module ref in cache (if it was already loaded)
            const moduleRef = this._loadModuleService.getModuleInfo(this.lazyComponentKey);
            if (moduleRef) {
                return of(moduleRef);
            }
            const getModuleFactory$ = this._getModuleFactory(moduleCallback, this._compiler).pipe(map((lazyComponentInfo) => {
                // store the module info (ref + factory) in the module cache
                const moduleInfo = {
                    moduleRef: lazyComponentInfo.moduleFactory.create(this._injector),
                    moduleFactory: lazyComponentInfo.moduleFactory,
                    component: lazyComponentInfo.component,
                };
                this._loadModuleService.setModuleInfo(this.lazyComponentKey, moduleInfo);
                return moduleInfo;
            }));
            // if dont have a minimal loading time, just load immediately
            if ((this.minLoadingTimeMs || 0) <= 0) {
                return getModuleFactory$;
            }
            // otherwise wait for at least the min loading time
            return combineLatest([timer(this.minLoadingTimeMs), getModuleFactory$]).pipe(map(([_, moduleFactory]) => moduleFactory));
        }), catchError((err) => {
            console.warn(`There was an error loading lazy component "${this.lazyComponentKey}": ${err}`);
            this.loaded.emit(null);
            return EMPTY;
        }), takeUntil(this._componentDestroyed$))
            .subscribe((moduleInfo) => {
            // now that the module is loaded
            // clear the loader and insert the component
            this._viewContainerRef.clear();
            // pass the components data to the created component via injection
            const injector = Injector.create({
                providers: [{ provide: LAZY_COMPONENT_DATA, useValue: this.data }],
                parent: this._injector,
            });
            const componentRef = this._viewContainerRef.createComponent(moduleInfo.component, { index: 0, injector });
            componentRef.changeDetectorRef.detectChanges();
            this.loaded.emit(componentRef);
        });
    }
    /** @ignore **/
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    _getModuleFactory(callback, compiler) {
        // callback will return either a promise or the module factory (if previously loaded)
        const loadModuleComponentCallback = callback();
        const compileModule = (info) => compiler.compileModuleAsync(info.module).then((moduleFactory) => ({
            moduleFactory,
            component: info.component,
        }));
        if (loadModuleComponentCallback instanceof Promise) {
            return from(loadModuleComponentCallback.then(compileModule));
        }
        return from(Promise.resolve(loadModuleComponentCallback).then(compileModule));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyComponentDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.Injector }, { token: i0.Compiler }, { token: LazyModuleCacheService }, { token: LAZY_COMPONENT_MODULES_MAP }, { token: LAZY_MODULES_PERMISSIONS_PROVIDER }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: LazyComponentDirective, selector: "ng-container[avnLazyComponent]", inputs: { lazyComponentKey: ["avnLazyComponent", "lazyComponentKey"], loadingTemplate: ["avnLazyComponentLoadingTemplate", "loadingTemplate"], minLoadingTimeMs: ["avnLazyComponentMinLoadingTimeMs", "minLoadingTimeMs"], data: ["avnLazyComponentData", "data"] }, outputs: { loaded: "avnLazyComponentLoaded" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyComponentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-container[avnLazyComponent]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.Injector }, { type: i0.Compiler }, { type: LazyModuleCacheService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LAZY_COMPONENT_MODULES_MAP]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LAZY_MODULES_PERMISSIONS_PROVIDER]
                }] }]; }, propDecorators: { lazyComponentKey: [{
                type: Input,
                args: ['avnLazyComponent']
            }], loadingTemplate: [{
                type: Input,
                args: ['avnLazyComponentLoadingTemplate']
            }], minLoadingTimeMs: [{
                type: Input,
                args: ['avnLazyComponentMinLoadingTimeMs']
            }], loaded: [{
                type: Output,
                args: ['avnLazyComponentLoaded']
            }], data: [{
                type: Input,
                args: ['avnLazyComponentData']
            }] } });

class LazyComponentModule {
    static forRoot(config) {
        return {
            ngModule: LazyComponentModule,
            providers: [
                { provide: LAZY_COMPONENT_MODULES_MAP, useValue: config.lazyComponents },
                config.permissionsProvider || {
                    provide: LAZY_MODULES_PERMISSIONS_PROVIDER,
                    useFactory: () => ({ canLoad: () => of(true) }), // if not provided, user has access to all lazy components
                },
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: LazyComponentModule, declarations: [LazyComponentDirective], imports: [IconModule], exports: [LazyComponentDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyComponentModule, imports: [IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: LazyComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IconModule],
                    declarations: [LazyComponentDirective],
                    exports: [LazyComponentDirective]
                }]
        }] });

var SkeletonBoneType;
(function (SkeletonBoneType) {
    /** rectangle bone*/
    SkeletonBoneType["Rect"] = "RECT";
    /** circle bone*/
    SkeletonBoneType["Circle"] = "CIRCLE";
    /** an svg bone */
    SkeletonBoneType["Svg"] = "SVG";
})(SkeletonBoneType || (SkeletonBoneType = {}));
/** basic element type */
var SkeletonType;
(function (SkeletonType) {
    /** blank */
    SkeletonType["Blank"] = "BLANK";
    /** bar chart*/
    SkeletonType["BarChart"] = "BAR_CHART";
    /** donut chart */
    SkeletonType["DonutChart"] = "DONUT_CHART";
    /** screenshot */
    SkeletonType["ScreenShot"] = "SCREEN_SHOT";
    /** card */
    SkeletonType["Card"] = "CARD";
    /** svg */
    SkeletonType["CustomSvg"] = "CUSTOM_SVG";
    /** general layout */
    SkeletonType["Layout"] = "LAYOUT";
    /** paragraph */
    SkeletonType["Paragraph"] = "PARAGRAPH";
    /** tree view */
    SkeletonType["TreeView"] = "TREEVIEW";
    /** List */
    SkeletonType["List"] = "LIST";
    /** DataTable */
    SkeletonType["DataTable"] = "DATATABLE";
    /** Form */
    SkeletonType["Form"] = "FORM";
})(SkeletonType || (SkeletonType = {}));
/** element display type */
var SkeletonBoneDimensionType;
(function (SkeletonBoneDimensionType) {
    /** in pixel */
    SkeletonBoneDimensionType["PX"] = "PX";
    /** in percentage */
    SkeletonBoneDimensionType["Percentage"] = "PERCENTAGE";
})(SkeletonBoneDimensionType || (SkeletonBoneDimensionType = {}));
var SkeletonAnimateDirection;
(function (SkeletonAnimateDirection) {
    /** animate from left to right */
    SkeletonAnimateDirection["Horizontal"] = "HORIZONTAL";
    /** animate from top to bottom */
    SkeletonAnimateDirection["Vertical"] = "VERTICAL";
})(SkeletonAnimateDirection || (SkeletonAnimateDirection = {}));

class SkeletonBoneComponent {
    constructor(_render, _elementRef, _cdr) {
        this._render = _render;
        this._elementRef = _elementRef;
        this._cdr = _cdr;
        /** border radius of element, applied to none circle element */
        this.borderRadiusInPx = 4;
    }
    ngOnInit() {
        if (this.boneType === SkeletonBoneType.Circle) {
            this._render.setStyle(this._elementRef.nativeElement, 'border-radius', '50%');
        }
        else {
            this._render.setStyle(this._elementRef.nativeElement, 'border-radius', this.borderRadiusInPx + 'px');
        }
    }
    ngAfterContentInit() {
        const svgs = this._elementRef.nativeElement.querySelectorAll('svg');
        if (svgs?.length === 0 && this.boneType === SkeletonBoneType.Svg) {
            throw new Error('Please provide custom svg for skeleton element that has boneType: SVG');
        }
    }
    ngOnChanges({ width, height, borderRadiusInPx }) {
        if (width && width.currentValue) {
            switch (this.width.type) {
                case SkeletonBoneDimensionType.PX:
                    this._render.setStyle(this._elementRef.nativeElement, 'width', this.width.value + 'px');
                    break;
                case SkeletonBoneDimensionType.Percentage:
                    this._render.setStyle(this._elementRef.nativeElement, 'width', this.width.value + '%');
                    break;
                default:
                    break;
            }
        }
        if (height && height.currentValue) {
            switch (this.height.type) {
                case SkeletonBoneDimensionType.PX:
                    this._render.setStyle(this._elementRef.nativeElement, 'height', this.height.value + 'px');
                    break;
                case SkeletonBoneDimensionType.Percentage:
                    this._render.setStyle(this._elementRef.nativeElement, 'height', this.height.value + '%');
                    break;
                default:
                    break;
            }
        }
        if (borderRadiusInPx && borderRadiusInPx.currentValue && !borderRadiusInPx.isFirstChange) {
            if (this.boneType !== SkeletonBoneType.Circle) {
                this._render.setStyle(this._elementRef.nativeElement, 'border-radius', this.borderRadiusInPx + 'px');
            }
        }
        this._cdr.detectChanges();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SkeletonBoneComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SkeletonBoneComponent, selector: "avn-skeleton-bone", inputs: { boneType: "boneType", width: "width", height: "height", borderRadiusInPx: "borderRadiusInPx" }, host: { properties: { "class.animatey": "this.animateY", "class.animatex": "this.animateX" } }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"boneType === 'SVG'\">\n  <ng-content></ng-content>\n</ng-container>\n", styles: [":host{display:flex;height:100%;width:100%;background:var(--skeleton-background);position:relative;overflow:hidden}:host ::ng-deep svg{height:100%;width:100%;fill:var(--skeleton-fill)}:host:after{content:\"\";position:absolute;width:100%;height:100%}:host.animatex:after{background:linear-gradient(90deg,transparent,var(--skeleton-animation-color),transparent);transform:translate(-100%);animation:wavex 3s infinite}:host.animatey:after{background:linear-gradient(0deg,transparent,var(--skeleton-animation-color),transparent);transform:translateY(-100%);animation:wavey 3s infinite}@keyframes wavex{to{transform:translate(100%)}}@keyframes wavey{to{transform:translateY(100%)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SkeletonBoneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-skeleton-bone', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"boneType === 'SVG'\">\n  <ng-content></ng-content>\n</ng-container>\n", styles: [":host{display:flex;height:100%;width:100%;background:var(--skeleton-background);position:relative;overflow:hidden}:host ::ng-deep svg{height:100%;width:100%;fill:var(--skeleton-fill)}:host:after{content:\"\";position:absolute;width:100%;height:100%}:host.animatex:after{background:linear-gradient(90deg,transparent,var(--skeleton-animation-color),transparent);transform:translate(-100%);animation:wavex 3s infinite}:host.animatey:after{background:linear-gradient(0deg,transparent,var(--skeleton-animation-color),transparent);transform:translateY(-100%);animation:wavey 3s infinite}@keyframes wavex{to{transform:translate(100%)}}@keyframes wavey{to{transform:translateY(100%)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { boneType: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], borderRadiusInPx: [{
                type: Input
            }], animateY: [{
                type: HostBinding,
                args: ['class.animatey']
            }], animateX: [{
                type: HostBinding,
                args: ['class.animatex']
            }] } });

/**
 * Injection token to set template
 */
const SKELETON_TEMPLATE_CONFIG = new InjectionToken('SKELETON_TEMPLATE_CONFIG');
/**
 * defaults value
 */
const DEFAULT_SKELETON_TEMPLATE_CONFIG = {
    /** bar chart unit, used to determine how many bars to render for a given space */
    barChartUnitWidth: 15,
    /** circle size */
    paragraphCircleSize: 55,
    treeViewCircleSize: 20,
    listCircleSize: 20,
    formCircleSize: 20,
    /** graph line height */
    paragraphLineHeight: 15,
    treeViewLineHeight: 5,
    listLineHeight: 5,
};

class SkeletonComponent {
    constructor(_cdr, templateConfig) {
        this._cdr = _cdr;
        this.templateConfig = templateConfig;
        /** animation direction */
        this.animateDirection = SkeletonAnimateDirection.Horizontal;
        /** animate indicator */
        this.animate = true;
        /** define the level for the treeView */
        this.treeViewLevel = 6;
        /** define the level for the treeView */
        this.listLevel = 4;
        this.SkeletonType = SkeletonType;
        this.SkeletonBoneType = SkeletonBoneType;
        this.SkeletonBoneDimensionType = SkeletonBoneDimensionType;
        this.barChartCount = [];
        this.treeViewCount = [];
        this.listCount = [];
        /** define the orientation of the menuBoard */
        this.menuBoardOrientation = SkeletonAnimateDirection.Horizontal;
        this._componentDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.resizeDirective.avnResize
            .pipe(debounceTime(200), filter(() => this.skeletonType === SkeletonType.BarChart), filter((event) => event.width !== 0), map((resize) => [resize.width, resize.height]), takeUntil(this._componentDestroyed$))
            .subscribe(([width]) => {
            const count = Math.floor(width / (this.templateConfig.barChartUnitWidth * 2));
            const newBar = Array.from(Array(count).keys()).map(() => {
                const random = Math.floor(Math.random() * 100);
                return random > 0 ? random : 1;
            });
            // avoid bar chart complete change
            if (this.barChartCount.length >= newBar.length) {
                this.barChartCount = this.barChartCount.slice(0, newBar.length);
            }
            else {
                this.barChartCount.push(...newBar.slice(0, newBar.length - this.barChartCount.length));
            }
            this._cdr.detectChanges();
        });
    }
    ngAfterViewInit() {
        this.childrenSkeletonBones.changes.subscribe(() => {
            this._updateChildrenAnimation();
        });
        this._updateChildrenAnimation();
    }
    ngAfterContentInit() {
        this._updateChildrenAnimation();
    }
    ngOnChanges({ animateDirection, animate, treeViewLevel, listLevel }) {
        if (animate && (this.childrenSkeletonBones || this.contentSkeletonBones)) {
            this._updateChildrenAnimation();
        }
        if (animateDirection && (this.childrenSkeletonBones || this.contentSkeletonBones)) {
            this._updateChildrenAnimation();
        }
        if (this.skeletonType === SkeletonType.List && listLevel) {
            this.listCount = Array.from(Array(Number(listLevel.currentValue)).keys()).map(() => 1);
        }
        if (this.skeletonType === SkeletonType.TreeView) {
            let initCount = 1;
            this.treeViewCount = Array.from(Array(Number(treeViewLevel.currentValue)).keys()).map(() => {
                let level = initCount;
                const randomFive = Math.floor(Math.random() * 3);
                if (randomFive > 1) {
                    level = initCount++;
                }
                else if (randomFive < 1 && initCount > 1) {
                    level = initCount--;
                }
                return level;
            });
        }
    }
    _updateChildrenAnimation() {
        switch (this.animateDirection) {
            case SkeletonAnimateDirection.Horizontal:
                this.childrenSkeletonBones?.forEach((element) => {
                    element.animateY = undefined;
                    element.animateX = this.animate;
                });
                this.contentSkeletonBones?.forEach((element) => {
                    element.animateY = undefined;
                    element.animateX = this.animate;
                });
                break;
            case SkeletonAnimateDirection.Vertical:
                this.childrenSkeletonBones?.forEach((element) => {
                    element.animateX = undefined;
                    element.animateY = this.animate;
                });
                this.contentSkeletonBones?.forEach((element) => {
                    element.animateX = undefined;
                    element.animateY = this.animate;
                });
                break;
            default:
                break;
        }
        this._cdr.detectChanges();
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** determine the orientation of the skeleton (landscape or portrait) */
    skeletonOrientation(width, height) {
        return width > height ? SkeletonAnimateDirection.Horizontal : SkeletonAnimateDirection.Vertical;
    }
    gridRowColumnStart(index, value, type) {
        return type === 'cercle' ? `${index === 0 ? 1 : index + 1}/${index === 0 ? 1 : value}` : `${index === 0 ? 1 : index + 1}/${index === 0 ? 2 : value + 1}`;
    }
    arrayOfNumber(number) {
        return Array.from(Array(number).keys());
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SkeletonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: SKELETON_TEMPLATE_CONFIG }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SkeletonComponent, selector: "avn-skeleton", inputs: { text: "text", subText: "subText", skeletonType: "skeletonType", animateDirection: "animateDirection", animate: "animate", treeViewLevel: "treeViewLevel", listLevel: "listLevel" }, queries: [{ propertyName: "contentSkeletonBones", predicate: SkeletonBoneComponent }], viewQueries: [{ propertyName: "resizeDirective", first: true, predicate: ResizeDirective, descendants: true, static: true }, { propertyName: "childrenSkeletonBones", predicate: SkeletonBoneComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-content select=\"avn-skeleton-bone\"></ng-content>\n<div\n  [ngClass]=\"{\n    'bar-chart': skeletonType === SkeletonType.BarChart,\n    'donut-chart': skeletonType === SkeletonType.DonutChart,\n    card: skeletonType === SkeletonType.Card,\n    paragraph: skeletonType === SkeletonType.Paragraph,\n    layout: skeletonType === SkeletonType.Layout,\n    treeview: skeletonType === SkeletonType.TreeView,\n    list: skeletonType === SkeletonType.List,\n    dataTable: skeletonType === SkeletonType.DataTable,\n    form: skeletonType === SkeletonType.Form\n  }\"\n  [ngStyle]=\"{ gridTemplateRows: skeletonType === SkeletonType.TreeView ? 'repeat(' + treeViewLevel + ', auto)' : '' }\"\n  avnResize\n>\n  <ng-container [ngSwitch]=\"skeletonType\">\n    <ng-container *ngSwitchCase=\"SkeletonType.BarChart\">\n      <ng-container *ngTemplateOutlet=\"barChart\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.CustomSvg\">\n      <ng-container *ngTemplateOutlet=\"svg\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.ScreenShot\">\n      <ng-container *ngTemplateOutlet=\"screenshot\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Card\">\n      <ng-container *ngTemplateOutlet=\"card\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Blank\">\n      <ng-container *ngTemplateOutlet=\"blank\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.DonutChart\">\n      <ng-container *ngTemplateOutlet=\"donutChart\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Paragraph\">\n      <ng-container *ngTemplateOutlet=\"paragraph\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Layout\">\n      <ng-container *ngTemplateOutlet=\"layout\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.TreeView\">\n      <ng-container *ngTemplateOutlet=\"treeView\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.List\">\n      <ng-container *ngTemplateOutlet=\"list\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.DataTable\">\n      <ng-container *ngTemplateOutlet=\"dataTable\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Form\">\n      <ng-container *ngTemplateOutlet=\"form\"></ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n<avn-empty-data-message [text]=\"text\" [subText]=\"subText\"></avn-empty-data-message>\n<ng-template #barChart>\n  <avn-skeleton-bone\n    *ngFor=\"let item of barChartCount\"\n    [boneType]=\"SkeletonBoneType.Rect\"\n    [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.barChartUnitWidth }\"\n    [height]=\"{ type: SkeletonBoneDimensionType.Percentage, value: item }\"\n  >\n  </avn-skeleton-bone>\n</ng-template>\n\n<ng-template #donutChart>\n  <avn-skeleton-bone class=\"donut-svg\" [boneType]=\"SkeletonBoneType.Svg\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n      <path\n        d=\"M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z\"\n      />\n    </svg>\n  </avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #screenshot>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Svg\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <circle cx=\"12\" cy=\"12\" r=\"3.2\" />\n      <path d=\"M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z\" />\n    </svg>\n  </avn-skeleton-bone>\n</ng-template>\n\n<ng-template #svg>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Svg\">\n    <ng-content select=\"svg\"></ng-content>\n  </avn-skeleton-bone>\n</ng-template>\n\n<ng-template #card>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #blank>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #paragraph>\n  <avn-skeleton-bone\n    [boneType]=\"SkeletonBoneType.Circle\"\n    [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphCircleSize }\"\n    [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphCircleSize }\"\n  ></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #layout>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n\n\n<ng-template #treeView>\n  <ng-container *ngFor=\"let value of treeViewCount; let i = index\">\n    <avn-skeleton-bone\n      class=\"cercle\"\n      [boneType]=\"SkeletonBoneType.Circle\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'cercle') + ' / span 3 / auto' }\"\n      [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewCircleSize }\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewCircleSize }\"\n    ></avn-skeleton-bone>\n    <avn-skeleton-bone\n      class=\"line\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'line') + ' / span 3 / fit-content' }\"\n      [boneType]=\"SkeletonBoneType.Rect\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewLineHeight }\"\n    ></avn-skeleton-bone>\n  </ng-container>\n</ng-template>\n\n<ng-template #list>\n  <ng-container *ngFor=\"let value of listCount; let i = index\">\n    <avn-skeleton-bone\n      class=\"cercle\"\n      [boneType]=\"SkeletonBoneType.Circle\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'cercle') + ' / span 3 / auto' }\"\n      [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.listCircleSize }\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.listCircleSize }\"\n    ></avn-skeleton-bone>\n    <avn-skeleton-bone\n      class=\"line\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'line') + ' / span 3 / fit-content' }\"\n      [boneType]=\"SkeletonBoneType.Rect\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewLineHeight }\"\n    ></avn-skeleton-bone>\n  </ng-container>\n</ng-template>\n\n<ng-template #dataTable>\n  <avn-skeleton-bone class=\"header\" [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <ng-container *ngFor=\"let index of arrayOfNumber(9)\">\n    <avn-skeleton-bone [ngClass]=\"'bone-' + index\" [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  </ng-container>\n</ng-template>\n\n<ng-template #form>\n  <ng-container *ngFor=\"let index of arrayOfNumber(2)\">\n    <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n    <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  </ng-container>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <ng-container *ngFor=\"let index of arrayOfNumber(3)\">\n    <avn-skeleton-bone\n      [boneType]=\"SkeletonBoneType.Circle\"\n      [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.formCircleSize }\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.formCircleSize }\"\n    ></avn-skeleton-bone>\n    <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  </ng-container>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n", styles: [":host{display:flex;width:100%;height:100%;position:relative}:host>div{width:100%;height:100%}:host .bar-chart{display:flex;width:100%;height:100%;justify-content:center;align-items:flex-end}:host .bar-chart>avn-skeleton-bone{margin-right:var(--space-md)}:host .donut-chart{display:grid;grid-template-columns:repeat(6,1fr);grid-template-rows:repeat(8,1fr);gap:var(--space-md)}:host .donut-chart>.donut-svg{grid-row:1/span 6;grid-column:1/span 6}:host .donut-chart>.donut-svg>svg{width:100%;height:100%}:host .donut-chart>avn-skeleton-bone:nth-child(2){grid-row:7/span 1;grid-column:1/span 2}:host .donut-chart>avn-skeleton-bone:nth-child(3){grid-row:7/span 1;grid-column:3/span 4}:host .donut-chart>avn-skeleton-bone:nth-child(4){grid-row:8/span 1;grid-column:1/span 2}:host .donut-chart>avn-skeleton-bone:nth-child(5){grid-row:8;grid-column:3/span 4}:host .card{display:grid;grid-template-columns:repeat(6,1fr);grid-template-rows:repeat(8,1fr);gap:var(--space-md)}:host .card>avn-skeleton-bone:nth-child(1){grid-row:1/span 6;grid-column:1/span 6}:host .card>avn-skeleton-bone:nth-child(2){grid-row:7/span 1;grid-column:1/span 6}:host .card>avn-skeleton-bone:nth-child(3){grid-row:8/span 1;grid-column:1/span 6}:host .blank{display:block}:host .paragraph{display:grid;grid-template-columns:1fr 3fr;grid-template-rows:repeat(4,1fr);justify-items:center;align-items:center}:host .paragraph>avn-skeleton-bone:first-child{grid-row:1/span 2}:host .paragraph>avn-skeleton-bone:nth-child(2){grid-row:1/span 1}:host .paragraph>avn-skeleton-bone:nth-child(3){grid-row:2/span 1}:host .paragraph>avn-skeleton-bone:nth-child(4){grid-column:1/span 2}:host .paragraph>avn-skeleton-bone:nth-child(5){grid-column:1/span 2}:host .layout{display:grid;grid-template-columns:1fr 2fr;grid-template-rows:repeat(7,1fr);justify-items:center;align-items:center;gap:var(--space-md)}:host .layout>avn-skeleton-bone:first-child{grid-row:1/span 2}:host .layout>avn-skeleton-bone:nth-child(2){grid-row:1/span 1}:host .layout>avn-skeleton-bone:nth-child(3){grid-row:2/span 1}:host .layout>avn-skeleton-bone:nth-child(4){grid-row:3/span 5;grid-column:1/span 1}:host .layout>avn-skeleton-bone:nth-child(5){grid-row:3/span 5;grid-column:2/span 1}:host avn-empty-data-message{color:var(--skeleton-text-color);position:absolute}:host avn-empty-data-message ::ng-deep .sub-text{font-style:italic}:host .menu-board-svg path{fill:var(--skeleton-fill)}:host .treeview{display:grid;grid-template-columns:repeat(20,auto);justify-items:center;align-items:center}:host .list{display:grid;grid-template-columns:repeat(20,auto);justify-items:center;align-items:center}:host .dataTable{display:grid;grid-template-columns:repeat(10,auto);grid-template-rows:repeat(12,auto);justify-items:center;align-items:center}:host .dataTable .header{grid-row:1/span 2;grid-column:1/content-fit}:host .dataTable .bone-0{grid-row:4/span 2;grid-column:1/span 3}:host .dataTable .bone-1{grid-row:4/span 2;grid-column:5/span 3}:host .dataTable .bone-2{grid-row:4/span 2;grid-column:9/span 3}:host .dataTable .bone-3{grid-row:7/span 2;grid-column:1/span 3}:host .dataTable .bone-4{grid-row:7/span 2;grid-column:5/span 3}:host .dataTable .bone-5{grid-row:7/span 2;grid-column:9/span 3}:host .dataTable .bone-6{grid-row:10/span 2;grid-column:1/span 3}:host .dataTable .bone-7{grid-row:10/span 2;grid-column:5/span 3}:host .dataTable .bone-8{grid-row:10/span 2;grid-column:9/span 3}:host .form{display:grid;grid-template-columns:repeat(32,auto);grid-template-rows:repeat(23,auto);justify-items:center;align-items:center}:host .form avn-skeleton-bone:first-child{grid-row:1;grid-column:1/span 7}:host .form avn-skeleton-bone:nth-child(2){grid-row:3/span 2;grid-column:1/content-fit}:host .form avn-skeleton-bone:nth-child(3){grid-row:7;grid-column:1/span 7}:host .form avn-skeleton-bone:nth-child(4){grid-row:9/span 2;grid-column:1/content-fit}:host .form avn-skeleton-bone:nth-child(6){grid-row:15/span 3;grid-column:1/span 2}:host .form avn-skeleton-bone:nth-child(7){grid-row:16;grid-column:3/span 9}:host .form avn-skeleton-bone:nth-child(8){grid-row:15/span 3;grid-column:12/span 2}:host .form avn-skeleton-bone:nth-child(9){grid-row:16;grid-column:14/span 9}:host .form avn-skeleton-bone:nth-child(10){grid-row:15/span 3;grid-column:23/span 2}:host .form avn-skeleton-bone:nth-child(11){grid-row:16;grid-column:25/span 9}:host .form avn-skeleton-bone:nth-child(5){grid-row:13;grid-column:1/span 7}:host .form avn-skeleton-bone:nth-child(12){grid-row:19;grid-column:1/content-fit}:host .form avn-skeleton-bone:last-child{grid-row:22/span 3;grid-column:26/span 8}\n"], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1$2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "component", type: EmptyDataMessageComponent, selector: "avn-empty-data-message", inputs: ["icon", "text", "subText"] }, { kind: "component", type: SkeletonBoneComponent, selector: "avn-skeleton-bone", inputs: ["boneType", "width", "height", "borderRadiusInPx"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SkeletonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-skeleton', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content select=\"avn-skeleton-bone\"></ng-content>\n<div\n  [ngClass]=\"{\n    'bar-chart': skeletonType === SkeletonType.BarChart,\n    'donut-chart': skeletonType === SkeletonType.DonutChart,\n    card: skeletonType === SkeletonType.Card,\n    paragraph: skeletonType === SkeletonType.Paragraph,\n    layout: skeletonType === SkeletonType.Layout,\n    treeview: skeletonType === SkeletonType.TreeView,\n    list: skeletonType === SkeletonType.List,\n    dataTable: skeletonType === SkeletonType.DataTable,\n    form: skeletonType === SkeletonType.Form\n  }\"\n  [ngStyle]=\"{ gridTemplateRows: skeletonType === SkeletonType.TreeView ? 'repeat(' + treeViewLevel + ', auto)' : '' }\"\n  avnResize\n>\n  <ng-container [ngSwitch]=\"skeletonType\">\n    <ng-container *ngSwitchCase=\"SkeletonType.BarChart\">\n      <ng-container *ngTemplateOutlet=\"barChart\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.CustomSvg\">\n      <ng-container *ngTemplateOutlet=\"svg\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.ScreenShot\">\n      <ng-container *ngTemplateOutlet=\"screenshot\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Card\">\n      <ng-container *ngTemplateOutlet=\"card\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Blank\">\n      <ng-container *ngTemplateOutlet=\"blank\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.DonutChart\">\n      <ng-container *ngTemplateOutlet=\"donutChart\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Paragraph\">\n      <ng-container *ngTemplateOutlet=\"paragraph\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Layout\">\n      <ng-container *ngTemplateOutlet=\"layout\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.TreeView\">\n      <ng-container *ngTemplateOutlet=\"treeView\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.List\">\n      <ng-container *ngTemplateOutlet=\"list\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.DataTable\">\n      <ng-container *ngTemplateOutlet=\"dataTable\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"SkeletonType.Form\">\n      <ng-container *ngTemplateOutlet=\"form\"></ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n<avn-empty-data-message [text]=\"text\" [subText]=\"subText\"></avn-empty-data-message>\n<ng-template #barChart>\n  <avn-skeleton-bone\n    *ngFor=\"let item of barChartCount\"\n    [boneType]=\"SkeletonBoneType.Rect\"\n    [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.barChartUnitWidth }\"\n    [height]=\"{ type: SkeletonBoneDimensionType.Percentage, value: item }\"\n  >\n  </avn-skeleton-bone>\n</ng-template>\n\n<ng-template #donutChart>\n  <avn-skeleton-bone class=\"donut-svg\" [boneType]=\"SkeletonBoneType.Svg\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n      <path\n        d=\"M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z\"\n      />\n    </svg>\n  </avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #screenshot>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Svg\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <circle cx=\"12\" cy=\"12\" r=\"3.2\" />\n      <path d=\"M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z\" />\n    </svg>\n  </avn-skeleton-bone>\n</ng-template>\n\n<ng-template #svg>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Svg\">\n    <ng-content select=\"svg\"></ng-content>\n  </avn-skeleton-bone>\n</ng-template>\n\n<ng-template #card>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #blank>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #paragraph>\n  <avn-skeleton-bone\n    [boneType]=\"SkeletonBoneType.Circle\"\n    [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphCircleSize }\"\n    [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphCircleSize }\"\n  ></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\" [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.paragraphLineHeight }\"></avn-skeleton-bone>\n</ng-template>\n\n<ng-template #layout>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n\n\n\n<ng-template #treeView>\n  <ng-container *ngFor=\"let value of treeViewCount; let i = index\">\n    <avn-skeleton-bone\n      class=\"cercle\"\n      [boneType]=\"SkeletonBoneType.Circle\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'cercle') + ' / span 3 / auto' }\"\n      [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewCircleSize }\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewCircleSize }\"\n    ></avn-skeleton-bone>\n    <avn-skeleton-bone\n      class=\"line\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'line') + ' / span 3 / fit-content' }\"\n      [boneType]=\"SkeletonBoneType.Rect\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewLineHeight }\"\n    ></avn-skeleton-bone>\n  </ng-container>\n</ng-template>\n\n<ng-template #list>\n  <ng-container *ngFor=\"let value of listCount; let i = index\">\n    <avn-skeleton-bone\n      class=\"cercle\"\n      [boneType]=\"SkeletonBoneType.Circle\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'cercle') + ' / span 3 / auto' }\"\n      [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.listCircleSize }\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.listCircleSize }\"\n    ></avn-skeleton-bone>\n    <avn-skeleton-bone\n      class=\"line\"\n      [ngStyle]=\"{ 'grid-area': gridRowColumnStart(i, value, 'line') + ' / span 3 / fit-content' }\"\n      [boneType]=\"SkeletonBoneType.Rect\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.treeViewLineHeight }\"\n    ></avn-skeleton-bone>\n  </ng-container>\n</ng-template>\n\n<ng-template #dataTable>\n  <avn-skeleton-bone class=\"header\" [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <ng-container *ngFor=\"let index of arrayOfNumber(9)\">\n    <avn-skeleton-bone [ngClass]=\"'bone-' + index\" [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  </ng-container>\n</ng-template>\n\n<ng-template #form>\n  <ng-container *ngFor=\"let index of arrayOfNumber(2)\">\n    <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n    <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  </ng-container>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  <ng-container *ngFor=\"let index of arrayOfNumber(3)\">\n    <avn-skeleton-bone\n      [boneType]=\"SkeletonBoneType.Circle\"\n      [width]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.formCircleSize }\"\n      [height]=\"{ type: SkeletonBoneDimensionType.PX, value: templateConfig.formCircleSize }\"\n    ></avn-skeleton-bone>\n    <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n  </ng-container>\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n\n  <avn-skeleton-bone [boneType]=\"SkeletonBoneType.Rect\"></avn-skeleton-bone>\n</ng-template>\n", styles: [":host{display:flex;width:100%;height:100%;position:relative}:host>div{width:100%;height:100%}:host .bar-chart{display:flex;width:100%;height:100%;justify-content:center;align-items:flex-end}:host .bar-chart>avn-skeleton-bone{margin-right:var(--space-md)}:host .donut-chart{display:grid;grid-template-columns:repeat(6,1fr);grid-template-rows:repeat(8,1fr);gap:var(--space-md)}:host .donut-chart>.donut-svg{grid-row:1/span 6;grid-column:1/span 6}:host .donut-chart>.donut-svg>svg{width:100%;height:100%}:host .donut-chart>avn-skeleton-bone:nth-child(2){grid-row:7/span 1;grid-column:1/span 2}:host .donut-chart>avn-skeleton-bone:nth-child(3){grid-row:7/span 1;grid-column:3/span 4}:host .donut-chart>avn-skeleton-bone:nth-child(4){grid-row:8/span 1;grid-column:1/span 2}:host .donut-chart>avn-skeleton-bone:nth-child(5){grid-row:8;grid-column:3/span 4}:host .card{display:grid;grid-template-columns:repeat(6,1fr);grid-template-rows:repeat(8,1fr);gap:var(--space-md)}:host .card>avn-skeleton-bone:nth-child(1){grid-row:1/span 6;grid-column:1/span 6}:host .card>avn-skeleton-bone:nth-child(2){grid-row:7/span 1;grid-column:1/span 6}:host .card>avn-skeleton-bone:nth-child(3){grid-row:8/span 1;grid-column:1/span 6}:host .blank{display:block}:host .paragraph{display:grid;grid-template-columns:1fr 3fr;grid-template-rows:repeat(4,1fr);justify-items:center;align-items:center}:host .paragraph>avn-skeleton-bone:first-child{grid-row:1/span 2}:host .paragraph>avn-skeleton-bone:nth-child(2){grid-row:1/span 1}:host .paragraph>avn-skeleton-bone:nth-child(3){grid-row:2/span 1}:host .paragraph>avn-skeleton-bone:nth-child(4){grid-column:1/span 2}:host .paragraph>avn-skeleton-bone:nth-child(5){grid-column:1/span 2}:host .layout{display:grid;grid-template-columns:1fr 2fr;grid-template-rows:repeat(7,1fr);justify-items:center;align-items:center;gap:var(--space-md)}:host .layout>avn-skeleton-bone:first-child{grid-row:1/span 2}:host .layout>avn-skeleton-bone:nth-child(2){grid-row:1/span 1}:host .layout>avn-skeleton-bone:nth-child(3){grid-row:2/span 1}:host .layout>avn-skeleton-bone:nth-child(4){grid-row:3/span 5;grid-column:1/span 1}:host .layout>avn-skeleton-bone:nth-child(5){grid-row:3/span 5;grid-column:2/span 1}:host avn-empty-data-message{color:var(--skeleton-text-color);position:absolute}:host avn-empty-data-message ::ng-deep .sub-text{font-style:italic}:host .menu-board-svg path{fill:var(--skeleton-fill)}:host .treeview{display:grid;grid-template-columns:repeat(20,auto);justify-items:center;align-items:center}:host .list{display:grid;grid-template-columns:repeat(20,auto);justify-items:center;align-items:center}:host .dataTable{display:grid;grid-template-columns:repeat(10,auto);grid-template-rows:repeat(12,auto);justify-items:center;align-items:center}:host .dataTable .header{grid-row:1/span 2;grid-column:1/content-fit}:host .dataTable .bone-0{grid-row:4/span 2;grid-column:1/span 3}:host .dataTable .bone-1{grid-row:4/span 2;grid-column:5/span 3}:host .dataTable .bone-2{grid-row:4/span 2;grid-column:9/span 3}:host .dataTable .bone-3{grid-row:7/span 2;grid-column:1/span 3}:host .dataTable .bone-4{grid-row:7/span 2;grid-column:5/span 3}:host .dataTable .bone-5{grid-row:7/span 2;grid-column:9/span 3}:host .dataTable .bone-6{grid-row:10/span 2;grid-column:1/span 3}:host .dataTable .bone-7{grid-row:10/span 2;grid-column:5/span 3}:host .dataTable .bone-8{grid-row:10/span 2;grid-column:9/span 3}:host .form{display:grid;grid-template-columns:repeat(32,auto);grid-template-rows:repeat(23,auto);justify-items:center;align-items:center}:host .form avn-skeleton-bone:first-child{grid-row:1;grid-column:1/span 7}:host .form avn-skeleton-bone:nth-child(2){grid-row:3/span 2;grid-column:1/content-fit}:host .form avn-skeleton-bone:nth-child(3){grid-row:7;grid-column:1/span 7}:host .form avn-skeleton-bone:nth-child(4){grid-row:9/span 2;grid-column:1/content-fit}:host .form avn-skeleton-bone:nth-child(6){grid-row:15/span 3;grid-column:1/span 2}:host .form avn-skeleton-bone:nth-child(7){grid-row:16;grid-column:3/span 9}:host .form avn-skeleton-bone:nth-child(8){grid-row:15/span 3;grid-column:12/span 2}:host .form avn-skeleton-bone:nth-child(9){grid-row:16;grid-column:14/span 9}:host .form avn-skeleton-bone:nth-child(10){grid-row:15/span 3;grid-column:23/span 2}:host .form avn-skeleton-bone:nth-child(11){grid-row:16;grid-column:25/span 9}:host .form avn-skeleton-bone:nth-child(5){grid-row:13;grid-column:1/span 7}:host .form avn-skeleton-bone:nth-child(12){grid-row:19;grid-column:1/content-fit}:host .form avn-skeleton-bone:last-child{grid-row:22/span 3;grid-column:26/span 8}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SKELETON_TEMPLATE_CONFIG]
                }] }]; }, propDecorators: { text: [{
                type: Input
            }], subText: [{
                type: Input
            }], skeletonType: [{
                type: Input
            }], animateDirection: [{
                type: Input
            }], animate: [{
                type: Input
            }], treeViewLevel: [{
                type: Input
            }], listLevel: [{
                type: Input
            }], childrenSkeletonBones: [{
                type: ViewChildren,
                args: [SkeletonBoneComponent]
            }], contentSkeletonBones: [{
                type: ContentChildren,
                args: [SkeletonBoneComponent]
            }], resizeDirective: [{
                type: ViewChild,
                args: [ResizeDirective, { static: true }]
            }] } });

class SkeletonModule {
    static forRoot(cfg) {
        return {
            ngModule: SkeletonModule,
            providers: [
                {
                    provide: SKELETON_TEMPLATE_CONFIG,
                    useValue: !cfg ? DEFAULT_SKELETON_TEMPLATE_CONFIG : { ...DEFAULT_SKELETON_TEMPLATE_CONFIG, ...cfg },
                },
            ],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SkeletonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: SkeletonModule, declarations: [SkeletonComponent, SkeletonBoneComponent], imports: [CommonModule, CoreModule, EmptyDataMessageModule], exports: [SkeletonComponent, SkeletonBoneComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SkeletonModule, imports: [CommonModule, CoreModule, EmptyDataMessageModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SkeletonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkeletonComponent, SkeletonBoneComponent],
                    imports: [CommonModule, CoreModule, EmptyDataMessageModule],
                    exports: [SkeletonComponent, SkeletonBoneComponent],
                }]
        }] });

class GridListHeaderTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListHeaderTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: GridListHeaderTemplateDirective, selector: "ng-template[avnGridListHeaderTemplate]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListHeaderTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[avnGridListHeaderTemplate]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class GridListItemTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListItemTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: GridListItemTemplateDirective, selector: "ng-template[avnGridListItemTemplate]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListItemTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[avnGridListItemTemplate]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

/**
 * Known issues:
 * - When autosize of items is enabled, when an item is selected, scroll repositioning is disabled (not working with cdk autosize)
 */
class GridListComponent {
    /** Sets the datasource configuration (e.g. allows to specify the id property of the datasource items) **/
    set dataSourceConfig(dataSourceConfig) {
        this._store.setDataSourceConfig(dataSourceConfig);
    }
    /**
     * The infinite scroll preload mode for loading extra records in the datatable:
     * - page: Load more data after n page of records are left to be scrolled
     * - left: Load more data when n% of current loaded data rows are left to be scrolled
     * - reached: Load more data when n% of current loaded data rows have been scrolled
     */
    set infiniteScrollPreloadStrategy(strategy) {
        this._store.setInfiniteScrollPreloadStrategy(strategy);
    }
    /**
     * The data table scroll mode value
     * - when infiniteScrollPreloadStrategy is 'left': percentage value
     * - when infiniteScrollPreloadStrategy is 'reached': percentage value
     * - when infiniteScrollPreloadStrategy is 'page': number of pages
     */
    set infiniteScrollPreloadValue(value) {
        this._store.setInfiniteScrollPreloadValue(value);
    }
    /** Indicates the quantity of items that will be fetched per data fetch **/
    set pageSize(pageSize) {
        this._store.setPageSize(pageSize);
    }
    /** indicates how items are sorted **/
    set sortBy(sortBy) {
        this._store.setSort(sortBy);
    }
    /**
     * Indicates whether the sorting should be local or done by the server by re-fetching the data
     * If serverSorting is true but all records have been loaded from the server, then the sorting
     * becomes local
     */
    set serverSorting(enabled) {
        this._store.setServerSorting(enabled);
    }
    constructor(_elementRef, _renderer, _store) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._store = _store;
        /** width of the grid items **/
        this.gridItemWidth = 200;
        /** height of the grid items **/
        this.gridItemHeight = 200;
        /** When enabled, items will auto fill the available space and gridItemWidth and gridItemHeight will be used as the minimum dimensions **/
        this.autoSizeItemsEnabled = false;
        /**
         * Applies to items of the last row
         *  When enabled, all items will keep the same width
         *  When disabled, items of will span the available space on the last row
         * **/
        this.autoSizeItemsEqualWidth = true;
        /** minimum gap in px between the items **/
        this.minGridGap = 16;
        /** To improve rendering performance of virtual scroll, previously rendered rows in viewport are cached. Setting the size of the view cache to 0 disables caching.
         * If your item templates are expensive in terms of memory you may wish to reduce this number to avoid spending too much memory on the cache. **/
        this.rowCacheSize = 20;
        /** Indicates if infinite scroll is enabled. If disabled, you need to provide a fully loaded datasource as no data fetch event will be emitted **/
        this.infiniteScrollEnabled = true;
        /** The mode of selection for the items. Can be 'none', 'single' or 'multiple' */
        this.selectionMode = 'none';
        /** Horizontal alignment of content in each grid item */
        this.horizontalAlignment = 'start';
        /** Vertical alignment of content in each grid item */
        this.verticalAlignment = 'start';
        /** Specifies the loader to use for the initial loading state (the page loader blocking the UI or the regular horizontal loader) **/
        this.initialDataLoader = 'block-ui-loader';
        /** Emits when a data fetch is requested **/
        this.fetchData = new EventEmitter();
        /** Emits when item selection has changed **/
        this.selectionChanged = new EventEmitter();
        /** model for the component **/
        this.model$ = this._store.model$;
        /** the items chunked into rows **/
        this.dataRows$ = of([]);
        /** Tab index allows the grid to be focusable **/
        this.tabindex = 0;
        this.themeType = ThemeType;
        this._componentDestroyed$ = new Subject();
        this._itemsPerRowSubject = new BehaviorSubject(0);
    }
    get itemsPerRow() {
        return this._itemsPerRowSubject.value;
    }
    get selectionEnabled() {
        return this.selectionMode !== 'none';
    }
    ngOnInit() {
        // chunk the datasource into rows until cdk supports multi-column virtual scroll
        this.dataRows$ = combineLatest([this._store.dataSource$, this._itemsPerRowSubject.asObservable()]).pipe(map(([dataSource, itemsPerRow]) => chunk(dataSource?.data || [], itemsPerRow)));
        // start listening to  events from the store
        // data fetch
        this._store.fetchData$
            .pipe(filter(() => this.infiniteScrollEnabled), takeUntil(this._componentDestroyed$))
            .subscribe((event) => {
            this.fetchData.emit(event);
        });
        // selection change
        this._store.selectionChanged$.pipe(takeUntil(this._componentDestroyed$)).subscribe((event) => this.selectionChanged.emit(event));
        // when autosize is enabled
        if (this.autoSizeItemsEnabled) {
            this.dataRows$.pipe(takeUntil(this._componentDestroyed$)).subscribe((dataRows) => {
                const hasOneRow = dataRows.length === 1;
                const autoFit = this.autoSizeItemsEnabled && (!this.autoSizeItemsEqualWidth || hasOneRow);
                if (autoFit) {
                    this._renderer.setStyle(this._elementRef.nativeElement, '--grid-item-auto-sizing', `auto-fit`, RendererStyleFlags2.DashCase);
                }
                else {
                    this._renderer.setStyle(this._elementRef.nativeElement, '--grid-item-auto-sizing', `auto-fill`, RendererStyleFlags2.DashCase);
                }
                // refresh the virtual scroll viewport every time the rows change
                asyncScheduler.schedule(() => this.virtualizedViewport?.checkViewportSize());
            });
        }
    }
    ngOnChanges({ dataSource, gridItemWidth, gridItemHeight, minGridGap }) {
        if (dataSource) {
            if (dataSource.isFirstChange()) {
                this._store.setDatasource(dataSource.currentValue);
            }
            else {
                this._store.updateDatasource(dataSource.currentValue);
                // check if we may need to load more data
                if (this.infiniteScrollEnabled && this.virtualizedViewport) {
                    this.onScroll(this.virtualizedViewport.getRenderedRange().end);
                }
            }
        }
        if (gridItemWidth) {
            this._renderer.setStyle(this._elementRef.nativeElement, '--grid-item-min-width', `${this.gridItemMinWidth}px`, RendererStyleFlags2.DashCase);
            this.checkForItemsSizeChange(this.virtualizedViewport?.elementRef.nativeElement.clientWidth);
        }
        if (gridItemHeight) {
            this._renderer.setStyle(this._elementRef.nativeElement, '--grid-item-min-height', `${this.autoSizeItemsEnabled ? 'auto' : this.gridItemMinHeight}px`, RendererStyleFlags2.DashCase);
        }
        if (minGridGap) {
            this._renderer.setStyle(this._elementRef.nativeElement, '--grid-item-min-width', `${this.gridItemMinWidth}px`, RendererStyleFlags2.DashCase);
            this._renderer.setStyle(this._elementRef.nativeElement, '--grid-item-min-height', `${this.autoSizeItemsEnabled ? 'auto' : this.gridItemMinHeight}px`, RendererStyleFlags2.DashCase);
            this.checkForItemsSizeChange(this.virtualizedViewport?.elementRef.nativeElement.clientWidth);
        }
    }
    ngAfterViewInit() {
        this._initKeyboardNavigation();
        this._initFocusScroll();
    }
    /** Used to cache the item's row wrappers already rendered when datasource is updated **/
    trackByFn(index) {
        return index;
    }
    checkForItemsSizeChange(viewportWidth) {
        // check if the number of items per row has changed
        if (viewportWidth) {
            const newItemsPerRow = this._getItemsPerRow(viewportWidth);
            if (this.itemsPerRow !== newItemsPerRow) {
                this._itemsPerRowSubject.next(newItemsPerRow);
                if (this.infiniteScrollEnabled) {
                    this.onScroll(this.virtualizedViewport.getRenderedRange().end);
                }
            }
        }
    }
    onScroll(lastRenderedRowIndex) {
        const lastRenderedItemIndex = lastRenderedRowIndex * this.itemsPerRow;
        this._store.onMaxRenderedItemIndexChange(lastRenderedItemIndex);
    }
    /** Resets the infinite scroll and sends the initial data fetch **/
    reset() {
        this._store.reset();
    }
    /** Deselect all the items **/
    deselectAllItems() {
        this._store.deselectAllItems();
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    onItemClick(selectedItem, selectedItemIndex, event) {
        if (this.selectionEnabled) {
            this.focusHost();
            event.stopPropagation();
            const multiSelectionEnabled = this.selectionMode === 'multiple';
            if (!multiSelectionEnabled) {
                this._updateSingleSelection(selectedItem, selectedItemIndex);
            }
            else if (event.ctrlKey && event.shiftKey) {
                this._updateCtrlShiftSelection(selectedItem, selectedItemIndex);
            }
            else if (event.ctrlKey) {
                this._updateCtrlSelection(selectedItem, selectedItemIndex);
            }
            else if (event.shiftKey) {
                this._updateShiftSelection(selectedItem, selectedItemIndex);
            }
            else {
                this._updateSingleSelection(selectedItem, selectedItemIndex);
            }
        }
    }
    focusHost() {
        this._elementRef.nativeElement.focus();
    }
    onHostClick() {
        if (this.selectionEnabled) {
            this.deselectAllItems();
            this._store.setFocusedItemIndex(null);
        }
    }
    /** Specifies if the specified item is selected */
    isItemSelected(item) {
        // compare by id if provided in config, otherwise compare by instance
        const idProp = this._store.dataSourceConfig?.id;
        if (idProp) {
            return this._store.selectedItemIds.includes(item[idProp]);
        }
        return this._store.selectedItems.indexOf(item) > -1;
    }
    /**
     * Returns the actual index of the item in the datasource.
     * Note. Not using datasource.data.findIndex for performance reasons. Can be removed when multi column is supported by cdk.
     * **/
    getItemIndex(rowIndex, itemIndexInRow) {
        return rowIndex * this.itemsPerRow + itemIndexInRow;
    }
    /** @ignore returns the min width of a grid item including the gap required between items **/
    get gridItemMinWidth() {
        const width = this.gridItemWidth ?? 200;
        const gap = this.minGridGap ?? 8;
        return width + gap / 2;
    }
    /** returns the min height of a grid item including the gap required between items **/
    get gridItemMinHeight() {
        const height = this.gridItemHeight ?? 200;
        const gap = this.minGridGap ?? 8;
        return height + gap / 2;
    }
    /** returns the item width when auto fill items is enabled **/
    getAutoFillItemsWidth() {
        return `calc(100% - ${this.minGridGap / 2}px)`;
    }
    get blockUILoaderEnabled() {
        return this.initialDataLoader === 'block-ui-loader';
    }
    /** Updates the selection when an item is clicked **/
    _updateSingleSelection(selectedItem, selectedItemIndex) {
        this._store.deselectAllItems();
        this._store.addItemsToSelection([selectedItem]);
        this._store.setFocusedItemIndex(selectedItemIndex);
    }
    /** Updates the selection when an item is clicked with CTRL key pressed **/
    _updateCtrlSelection(selectedItem, selectedItemIndex) {
        const isItemAlreadySelected = this.isItemSelected(selectedItem);
        if (isItemAlreadySelected) {
            this._store.removeItemFromSelection(selectedItem);
        }
        else {
            this._store.addItemsToSelection([selectedItem]);
        }
        this._store.setFocusedItemIndex(selectedItemIndex);
    }
    /** Updates the selection when an item is clicked with SHIFT key pressed **/
    _updateShiftSelection(selectedItem, selectedItemIndex) {
        const focusedItemIndex = this._store.focusedItemIndex;
        const isSingleItemSelected = focusedItemIndex === null || focusedItemIndex === selectedItemIndex;
        const isItemAlreadySelected = this.isItemSelected(selectedItem);
        if (isSingleItemSelected && isItemAlreadySelected) {
            return;
        }
        this._store.deselectAllItems();
        if (isSingleItemSelected) {
            this._store.addItemsToSelection([selectedItem]);
            this._store.setFocusedItemIndex(selectedItemIndex);
            return;
        }
        const fromIndex = Math.min(focusedItemIndex, selectedItemIndex);
        const toIndex = Math.max(focusedItemIndex, selectedItemIndex);
        const newSelectedItems = [];
        for (let i = fromIndex; i <= toIndex; i++) {
            const item = this._store.dataSource.data[i];
            if (!this.isItemSelected(item)) {
                newSelectedItems.push(item);
            }
        }
        this._store.addItemsToSelection(newSelectedItems);
    }
    /** Updates the selection when an item is clicked with CTRL + SHIFT key pressed **/
    _updateCtrlShiftSelection(selectedItem, selectedItemIndex) {
        const focusedItemIndex = this._store.focusedItemIndex;
        const isSingleItemSelected = focusedItemIndex === null;
        const isItemAlreadySelected = this.isItemSelected(selectedItem);
        if (isSingleItemSelected && isItemAlreadySelected) {
            this._store.removeItemFromSelection(selectedItem);
            return;
        }
        if (isSingleItemSelected) {
            this._store.addItemsToSelection([selectedItem]);
            return;
        }
        const fromIndex = Math.min(focusedItemIndex, selectedItemIndex);
        const toIndex = Math.max(focusedItemIndex, selectedItemIndex);
        const newSelectedItems = [];
        for (let i = fromIndex; i <= toIndex; i++) {
            const item = this._store.dataSource.data[i];
            if (!this.isItemSelected(item)) {
                newSelectedItems.push(item);
            }
        }
        this._store.addItemsToSelection(newSelectedItems);
    }
    _getItemsPerRow(viewportWidth) {
        return Math.floor(viewportWidth / this.gridItemMinWidth);
    }
    /** @ignore Inits the keyboard navigation */
    _initKeyboardNavigation() {
        const keydown$ = fromEvent(this._elementRef.nativeElement, 'keydown').pipe(withLatestFrom(this._store.hasRecords$), filter(([_, hasRecords]) => hasRecords), map(([event, _]) => event));
        const onRightArrow$ = keydown$.pipe(filter((event) => event.keyCode === RIGHT_ARROW), filter(() => this._store.focusedItemIndex < this._store.dataSource.data.length - 1), map(() => this._store.focusedItemIndex + 1));
        const onLeftArrow$ = keydown$.pipe(filter((event) => event.keyCode === LEFT_ARROW), filter(() => this._store.focusedItemIndex > 0), map(() => this._store.focusedItemIndex - 1));
        const onUpArrow$ = keydown$.pipe(filter((event) => event.keyCode === UP_ARROW), filter(() => this._store.focusedItemIndex - this.itemsPerRow >= 0), map(() => this._store.focusedItemIndex - this.itemsPerRow));
        const onDownArrow$ = keydown$.pipe(filter((event) => event.keyCode === DOWN_ARROW), filter(() => this._store.focusedItemIndex + this.itemsPerRow <= this._store.dataSource.data.length - 1), map(() => this._store.focusedItemIndex + this.itemsPerRow));
        merge(onLeftArrow$, onRightArrow$, onUpArrow$, onDownArrow$)
            .pipe(takeUntil(this._componentDestroyed$))
            .subscribe((index) => {
            this._store.setFocusedItemIndex(index);
            this._store.deselectAllItems();
            this._store.addItemsToSelection([this._store.dataSource.data[index]]);
        });
    }
    /** @ingore Adjusts the viewport scroll to make sure the focused item fits in the viewport **/
    _initFocusScroll() {
        this._store.focusedItemIndex$
            .pipe(skip(1), filter(() => !!this.virtualizedViewport && !this.autoSizeItemsEnabled), takeUntil(this._componentDestroyed$))
            .subscribe((currentIndex) => {
            // reposition the scroll if the item is not fully visible in viewport
            const viewportHeight = this.virtualizedViewport.elementRef.nativeElement.clientHeight;
            const viewportYStart = this.virtualizedViewport.elementRef.nativeElement.scrollTop;
            const viewportYEnd = this.virtualizedViewport.elementRef.nativeElement.scrollTop + viewportHeight;
            const gridItemHeight = this.gridItemMinHeight;
            const itemRowNumber = Math.floor(currentIndex / this.itemsPerRow);
            const gridItemYStart = itemRowNumber * gridItemHeight;
            const gridItemYEnd = itemRowNumber * gridItemHeight + gridItemHeight;
            const itemYStart = gridItemYStart + this.minGridGap / 2;
            const itemYEnd = gridItemYEnd - this.minGridGap / 2;
            const isCroppedOnTop = itemYStart < viewportYStart;
            const isCroppedOnBottom = itemYEnd > viewportYEnd;
            const atLeastOneItemFitInViewport = viewportHeight >= gridItemYEnd - gridItemYStart;
            if (!isCroppedOnTop && !isCroppedOnBottom) {
                return;
            }
            if (isCroppedOnTop || !atLeastOneItemFitInViewport) {
                this.virtualizedViewport.scrollToOffset(gridItemYStart);
            }
            else {
                this.virtualizedViewport.scrollToOffset(this.virtualizedViewport.elementRef.nativeElement.scrollTop + (gridItemYEnd - viewportYEnd));
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: InfiniteScrollComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: GridListComponent, selector: "avn-grid-list", inputs: { gridItemWidth: "gridItemWidth", gridItemHeight: "gridItemHeight", autoSizeItemsEnabled: "autoSizeItemsEnabled", autoSizeItemsEqualWidth: "autoSizeItemsEqualWidth", minGridGap: "minGridGap", rowCacheSize: "rowCacheSize", infiniteScrollEnabled: "infiniteScrollEnabled", selectionMode: "selectionMode", horizontalAlignment: "horizontalAlignment", verticalAlignment: "verticalAlignment", dataSource: "dataSource", dataSourceConfig: "dataSourceConfig", initialDataLoader: "initialDataLoader", infiniteScrollPreloadStrategy: "infiniteScrollPreloadStrategy", infiniteScrollPreloadValue: "infiniteScrollPreloadValue", pageSize: "pageSize", sortBy: "sortBy", serverSorting: "serverSorting" }, outputs: { fetchData: "fetchData", selectionChanged: "selectionChanged" }, host: { listeners: { "click": "onHostClick()" }, properties: { "tabindex": "this.tabindex", "class.selectable": "this.selectionEnabled" } }, providers: [InfiniteScrollComponentStore], queries: [{ propertyName: "itemTemplateDirective", first: true, predicate: GridListItemTemplateDirective, descendants: true }, { propertyName: "headerTemplateDirective", first: true, predicate: GridListHeaderTemplateDirective, descendants: true }], viewQueries: [{ propertyName: "virtualizedViewport", first: true, predicate: CdkVirtualScrollViewport, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"wrapper\" *ngIf=\"model$ | async as vm\" [class.has-header]=\"!!headerTemplateDirective && vm.hasRecords\">\n  <ng-container *ngIf=\"!!headerTemplateDirective && vm.hasRecords\">\n    <ng-container *ngTemplateOutlet=\"headerTemplateDirective.templateRef; context: { dataCount: vm.dataSource.data.length, totalCount: vm.dataSource.total }\"></ng-container>\n  </ng-container>\n\n  <ng-container *ngIf=\"autoSizeItemsEnabled\">\n    <cdk-virtual-scroll-viewport\n      #virtualizedViewport\n      role=\"listbox\"\n      autosize\n      avnScroll\n      [avnScrollEmitScrollEvent]=\"true\"\n      (avnResize)=\"checkForItemsSizeChange($event.width)\"\n      (scrolled)=\"infiniteScrollEnabled && onScroll(virtualizedViewport.getRenderedRange().end)\"\n      [debounceTime]=\"0\"\n    >\n      <div\n        class=\"row\"\n        [style.padding-bottom.px]=\"minGridGap / 2\"\n        *cdkVirtualFor=\"let row of dataRows$ | async; index as rowIndex; templateCacheSize: rowCacheSize; trackBy: trackByFn\"\n        [style.align-items]=\"horizontalAlignment\"\n        [style.justify-items]=\"verticalAlignment\"\n        (click)=\"focusHost()\"\n      >\n        <ng-container *ngFor=\"let item of row; index as itemIndexInRow\">\n          <div class=\"grid-item\" [style.width]=\"'100%'\" [style.height]=\"'100%'\">\n            <div\n              class=\"item-wrapper\"\n              [style.width]=\"getAutoFillItemsWidth()\"\n              [style.height]=\"'100%'\"\n              [style.min-width.px]=\"gridItemWidth\"\n              [style.min-height.px]=\"gridItemHeight\"\n              (click)=\"onItemClick(item, getItemIndex(rowIndex, itemIndexInRow), $event)\"\n              [class.selected]=\"isItemSelected(item)\"\n              [class.focused]=\"vm.focusedItemIndex === getItemIndex(rowIndex, itemIndexInRow)\"\n            >\n              <ng-container *ngIf=\"itemTemplateDirective?.templateRef\">\n                <ng-container *ngTemplateOutlet=\"itemTemplateDirective.templateRef; context: { item: item, index: getItemIndex(rowIndex, itemIndexInRow) }\"> </ng-container>\n              </ng-container>\n              <div class=\"selection-wrapper\"></div>\n            </div>\n          </div>\n        </ng-container>\n      </div>\n    </cdk-virtual-scroll-viewport>\n  </ng-container>\n\n  <ng-container *ngIf=\"!autoSizeItemsEnabled\">\n    <cdk-virtual-scroll-viewport\n      #virtualizedViewport\n      role=\"listbox\"\n      [itemSize]=\"gridItemMinHeight\"\n      avnScroll\n      (avnResize)=\"checkForItemsSizeChange($event.width)\"\n      (scrolledIndexChange)=\"infiniteScrollEnabled && onScroll(virtualizedViewport.getRenderedRange().end)\"\n      [debounceTime]=\"0\"\n    >\n      <ng-container *cdkVirtualFor=\"let row of dataRows$ | async; index as rowIndex; templateCacheSize: rowCacheSize; trackBy: trackByFn\">\n        <div class=\"row\" [style.align-items]=\"horizontalAlignment\" [style.justify-items]=\"verticalAlignment\" (click)=\"focusHost()\">\n          <ng-container *ngFor=\"let item of row; index as itemIndexInRow\">\n            <div class=\"grid-item\">\n              <div\n                class=\"item-wrapper\"\n                [style.max-width.px]=\"gridItemWidth\"\n                [style.max-height.px]=\"gridItemHeight\"\n                (click)=\"onItemClick(item, getItemIndex(rowIndex, itemIndexInRow), $event)\"\n                [class.selected]=\"isItemSelected(item)\"\n                [class.focused]=\"vm.focusedItemIndex === getItemIndex(rowIndex, itemIndexInRow)\"\n              >\n                <ng-container *ngIf=\"itemTemplateDirective?.templateRef\">\n                  <ng-container *ngTemplateOutlet=\"itemTemplateDirective.templateRef; context: { item: item, index: getItemIndex(rowIndex, itemIndexInRow) }\"> </ng-container>\n                </ng-container>\n                <div class=\"selection-wrapper\"></div>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </cdk-virtual-scroll-viewport>\n  </ng-container>\n\n  <avn-linear-loader [show]=\"(!blockUILoaderEnabled || vm.hasRecords) && vm.pendingData\" [theme]=\"'primary'\" [position]=\"'bottom'\"></avn-linear-loader>\n  <avn-loader [isLoading]=\"blockUILoaderEnabled && !vm.hasRecords && vm.pendingData\" [avnTheme]=\"themeType.PRIMARY\"></avn-loader>\n  <ng-content select=\"avn-empty-data-message\" *ngIf=\"!vm.pendingData && !vm.hasRecords\"></ng-content>\n</div>\n", styles: [":host{display:block;width:100%;height:100%;position:relative;-webkit-user-select:none;user-select:none;--grid-item-min-width: 216px;--grid-item-min-height: 216px;--grid-item-auto-sizing: auto-fill}:host .wrapper{display:block;width:100%;height:100%}:host .wrapper.has-header{display:grid;grid-template-rows:min-content auto;grid-gap:var(--space-sm)}:host .wrapper cdk-virtual-scroll-viewport{width:100%;height:100%}:host .row{display:grid;grid-template-columns:repeat(var(--grid-item-auto-sizing),minmax(var(--grid-item-min-width),1fr));grid-template-rows:var(--grid-item-min-height)}:host .row .grid-item .item-wrapper{display:inline-flex;box-shadow:unset;position:relative;overflow:hidden}:host .row .grid-item .item-wrapper .selection-wrapper{position:absolute;height:100%;width:100%;pointer-events:none}:host ::ng-deep avn-empty-data-message{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host-context(.selectable) .wrapper .grid-item .item-wrapper:hover .selection-wrapper{box-shadow:inset 0 0 0 1px var(--selection-component-background)}:host-context(.selectable) .wrapper .grid-item .item-wrapper.selected .selection-wrapper{box-shadow:inset 0 0 0 1px var(--highlight-base)}:host-context(.selectable) .wrapper .grid-item .item-wrapper.selected .selection-wrapper:after{content:\"\";width:100%;height:100%;pointer-events:none;background:var(--highlight-base);display:block;position:absolute;opacity:.1}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "directive", type: i2.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i2.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i2.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "directive", type: i7.CdkAutoSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[autosize]", inputs: ["minBufferPx", "maxBufferPx"] }, { kind: "component", type: LoaderComponent, selector: "avn-loader", inputs: ["durationBaseMs", "displayText", "icon", "fullOpacityOverlay", "isLoading"] }, { kind: "component", type: LinearLoaderComponent, selector: "avn-linear-loader", inputs: ["theme", "show", "position"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-grid-list', changeDetection: ChangeDetectionStrategy.OnPush, providers: [InfiniteScrollComponentStore], template: "<div class=\"wrapper\" *ngIf=\"model$ | async as vm\" [class.has-header]=\"!!headerTemplateDirective && vm.hasRecords\">\n  <ng-container *ngIf=\"!!headerTemplateDirective && vm.hasRecords\">\n    <ng-container *ngTemplateOutlet=\"headerTemplateDirective.templateRef; context: { dataCount: vm.dataSource.data.length, totalCount: vm.dataSource.total }\"></ng-container>\n  </ng-container>\n\n  <ng-container *ngIf=\"autoSizeItemsEnabled\">\n    <cdk-virtual-scroll-viewport\n      #virtualizedViewport\n      role=\"listbox\"\n      autosize\n      avnScroll\n      [avnScrollEmitScrollEvent]=\"true\"\n      (avnResize)=\"checkForItemsSizeChange($event.width)\"\n      (scrolled)=\"infiniteScrollEnabled && onScroll(virtualizedViewport.getRenderedRange().end)\"\n      [debounceTime]=\"0\"\n    >\n      <div\n        class=\"row\"\n        [style.padding-bottom.px]=\"minGridGap / 2\"\n        *cdkVirtualFor=\"let row of dataRows$ | async; index as rowIndex; templateCacheSize: rowCacheSize; trackBy: trackByFn\"\n        [style.align-items]=\"horizontalAlignment\"\n        [style.justify-items]=\"verticalAlignment\"\n        (click)=\"focusHost()\"\n      >\n        <ng-container *ngFor=\"let item of row; index as itemIndexInRow\">\n          <div class=\"grid-item\" [style.width]=\"'100%'\" [style.height]=\"'100%'\">\n            <div\n              class=\"item-wrapper\"\n              [style.width]=\"getAutoFillItemsWidth()\"\n              [style.height]=\"'100%'\"\n              [style.min-width.px]=\"gridItemWidth\"\n              [style.min-height.px]=\"gridItemHeight\"\n              (click)=\"onItemClick(item, getItemIndex(rowIndex, itemIndexInRow), $event)\"\n              [class.selected]=\"isItemSelected(item)\"\n              [class.focused]=\"vm.focusedItemIndex === getItemIndex(rowIndex, itemIndexInRow)\"\n            >\n              <ng-container *ngIf=\"itemTemplateDirective?.templateRef\">\n                <ng-container *ngTemplateOutlet=\"itemTemplateDirective.templateRef; context: { item: item, index: getItemIndex(rowIndex, itemIndexInRow) }\"> </ng-container>\n              </ng-container>\n              <div class=\"selection-wrapper\"></div>\n            </div>\n          </div>\n        </ng-container>\n      </div>\n    </cdk-virtual-scroll-viewport>\n  </ng-container>\n\n  <ng-container *ngIf=\"!autoSizeItemsEnabled\">\n    <cdk-virtual-scroll-viewport\n      #virtualizedViewport\n      role=\"listbox\"\n      [itemSize]=\"gridItemMinHeight\"\n      avnScroll\n      (avnResize)=\"checkForItemsSizeChange($event.width)\"\n      (scrolledIndexChange)=\"infiniteScrollEnabled && onScroll(virtualizedViewport.getRenderedRange().end)\"\n      [debounceTime]=\"0\"\n    >\n      <ng-container *cdkVirtualFor=\"let row of dataRows$ | async; index as rowIndex; templateCacheSize: rowCacheSize; trackBy: trackByFn\">\n        <div class=\"row\" [style.align-items]=\"horizontalAlignment\" [style.justify-items]=\"verticalAlignment\" (click)=\"focusHost()\">\n          <ng-container *ngFor=\"let item of row; index as itemIndexInRow\">\n            <div class=\"grid-item\">\n              <div\n                class=\"item-wrapper\"\n                [style.max-width.px]=\"gridItemWidth\"\n                [style.max-height.px]=\"gridItemHeight\"\n                (click)=\"onItemClick(item, getItemIndex(rowIndex, itemIndexInRow), $event)\"\n                [class.selected]=\"isItemSelected(item)\"\n                [class.focused]=\"vm.focusedItemIndex === getItemIndex(rowIndex, itemIndexInRow)\"\n              >\n                <ng-container *ngIf=\"itemTemplateDirective?.templateRef\">\n                  <ng-container *ngTemplateOutlet=\"itemTemplateDirective.templateRef; context: { item: item, index: getItemIndex(rowIndex, itemIndexInRow) }\"> </ng-container>\n                </ng-container>\n                <div class=\"selection-wrapper\"></div>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </cdk-virtual-scroll-viewport>\n  </ng-container>\n\n  <avn-linear-loader [show]=\"(!blockUILoaderEnabled || vm.hasRecords) && vm.pendingData\" [theme]=\"'primary'\" [position]=\"'bottom'\"></avn-linear-loader>\n  <avn-loader [isLoading]=\"blockUILoaderEnabled && !vm.hasRecords && vm.pendingData\" [avnTheme]=\"themeType.PRIMARY\"></avn-loader>\n  <ng-content select=\"avn-empty-data-message\" *ngIf=\"!vm.pendingData && !vm.hasRecords\"></ng-content>\n</div>\n", styles: [":host{display:block;width:100%;height:100%;position:relative;-webkit-user-select:none;user-select:none;--grid-item-min-width: 216px;--grid-item-min-height: 216px;--grid-item-auto-sizing: auto-fill}:host .wrapper{display:block;width:100%;height:100%}:host .wrapper.has-header{display:grid;grid-template-rows:min-content auto;grid-gap:var(--space-sm)}:host .wrapper cdk-virtual-scroll-viewport{width:100%;height:100%}:host .row{display:grid;grid-template-columns:repeat(var(--grid-item-auto-sizing),minmax(var(--grid-item-min-width),1fr));grid-template-rows:var(--grid-item-min-height)}:host .row .grid-item .item-wrapper{display:inline-flex;box-shadow:unset;position:relative;overflow:hidden}:host .row .grid-item .item-wrapper .selection-wrapper{position:absolute;height:100%;width:100%;pointer-events:none}:host ::ng-deep avn-empty-data-message{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host-context(.selectable) .wrapper .grid-item .item-wrapper:hover .selection-wrapper{box-shadow:inset 0 0 0 1px var(--selection-component-background)}:host-context(.selectable) .wrapper .grid-item .item-wrapper.selected .selection-wrapper{box-shadow:inset 0 0 0 1px var(--highlight-base)}:host-context(.selectable) .wrapper .grid-item .item-wrapper.selected .selection-wrapper:after{content:\"\";width:100%;height:100%;pointer-events:none;background:var(--highlight-base);display:block;position:absolute;opacity:.1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: InfiniteScrollComponentStore }]; }, propDecorators: { virtualizedViewport: [{
                type: ViewChild,
                args: [CdkVirtualScrollViewport, { static: false }]
            }], itemTemplateDirective: [{
                type: ContentChild,
                args: [GridListItemTemplateDirective]
            }], headerTemplateDirective: [{
                type: ContentChild,
                args: [GridListHeaderTemplateDirective]
            }], gridItemWidth: [{
                type: Input
            }], gridItemHeight: [{
                type: Input
            }], autoSizeItemsEnabled: [{
                type: Input
            }], autoSizeItemsEqualWidth: [{
                type: Input
            }], minGridGap: [{
                type: Input
            }], rowCacheSize: [{
                type: Input
            }], infiniteScrollEnabled: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], horizontalAlignment: [{
                type: Input
            }], verticalAlignment: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], dataSourceConfig: [{
                type: Input
            }], initialDataLoader: [{
                type: Input
            }], infiniteScrollPreloadStrategy: [{
                type: Input
            }], infiniteScrollPreloadValue: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], sortBy: [{
                type: Input
            }], serverSorting: [{
                type: Input
            }], fetchData: [{
                type: Output
            }], selectionChanged: [{
                type: Output
            }], tabindex: [{
                type: HostBinding,
                args: ['tabindex']
            }], selectionEnabled: [{
                type: HostBinding,
                args: ['class.selectable']
            }], onHostClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class GridListHeaderCountTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListHeaderCountTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: GridListHeaderCountTemplateDirective, selector: "ng-template[avnGridListHeaderCountTemplate]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListHeaderCountTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[avnGridListHeaderCountTemplate]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class GridListHeaderComponent {
    /** The list of sort options **/
    set sortableFields(sortableFields) {
        this.sortOptions = sortableFields.map((field) => ({
            value: field.id,
            label: field.desc,
            data: field,
        }));
    }
    /** Inject the store of the parent grid component **/
    constructor(_store) {
        this._store = _store;
        /** Placeholder for the sort by select **/
        this.sortByPlaceholder = 'Sort By';
        this.selectOptionValue$ = this._store.sort$.pipe(filter((sort) => !!sort), map((sort) => sort.id));
        this.hasRecords$ = this._store.hasRecords$;
    }
    sortData(sort) {
        this._store.updateSort(sort);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListHeaderComponent, deps: [{ token: InfiniteScrollComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: GridListHeaderComponent, selector: "avn-grid-list-header", inputs: { sortByPlaceholder: "sortByPlaceholder", sortableFields: "sortableFields" }, queries: [{ propertyName: "gridListHeaderCountTemplate", first: true, predicate: GridListHeaderCountTemplateDirective, descendants: true }], ngImport: i0, template: "<div class=\"header\" *ngIf=\"hasRecords$ | async\">\n  <div class=\"sort-container\">\n    <avn-select\n      *ngIf=\"sortOptions?.length > 0\"\n      [placeholder]=\"sortByPlaceholder\"\n      [options]=\"sortOptions\"\n      [value]=\"selectOptionValue$ | async\"\n      (change)=\"sortData($event.data)\"\n      [selectedOptionTemplate]=\"selectedOptionTemplate\"\n    >\n      <ng-template let-option=\"option\" #selectedOptionTemplate>\n        <div class=\"option-template\">\n          <avn-icon [icon]=\"'content:sort'\" [avnTheme]=\"\"></avn-icon>\n          <span>{{ option.label }}</span>\n        </div>\n      </ng-template>\n    </avn-select>\n  </div>\n  <div class=\"count-container\">\n    <ng-container *ngIf=\"!!gridListHeaderCountTemplate\">\n      <ng-container *ngTemplateOutlet=\"gridListHeaderCountTemplate.templateRef\"></ng-container>\n    </ng-container>\n  </div>\n</div>\n", styles: [":host .header{display:grid;width:100%;grid-template-columns:auto 1fr;align-items:center}:host .option-template{display:grid;grid-template-columns:auto auto;grid-gap:var(--space-sm);align-items:center}:host .count-container{justify-self:end}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }, { kind: "component", type: SelectComponent, selector: "avn-select", inputs: ["optionsTemplate", "selectedOptionTemplate", "label", "options", "placeholder", "icon", "iconSize", "emptyPlaceholder", "value", "optionsListWidth", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "enableGroups", "optionHeight", "isMultipleSelect", "backdropEnabled"], outputs: ["change", "optionActivated", "optionListToggled"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-grid-list-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"header\" *ngIf=\"hasRecords$ | async\">\n  <div class=\"sort-container\">\n    <avn-select\n      *ngIf=\"sortOptions?.length > 0\"\n      [placeholder]=\"sortByPlaceholder\"\n      [options]=\"sortOptions\"\n      [value]=\"selectOptionValue$ | async\"\n      (change)=\"sortData($event.data)\"\n      [selectedOptionTemplate]=\"selectedOptionTemplate\"\n    >\n      <ng-template let-option=\"option\" #selectedOptionTemplate>\n        <div class=\"option-template\">\n          <avn-icon [icon]=\"'content:sort'\" [avnTheme]=\"\"></avn-icon>\n          <span>{{ option.label }}</span>\n        </div>\n      </ng-template>\n    </avn-select>\n  </div>\n  <div class=\"count-container\">\n    <ng-container *ngIf=\"!!gridListHeaderCountTemplate\">\n      <ng-container *ngTemplateOutlet=\"gridListHeaderCountTemplate.templateRef\"></ng-container>\n    </ng-container>\n  </div>\n</div>\n", styles: [":host .header{display:grid;width:100%;grid-template-columns:auto 1fr;align-items:center}:host .option-template{display:grid;grid-template-columns:auto auto;grid-gap:var(--space-sm);align-items:center}:host .count-container{justify-self:end}\n"] }]
        }], ctorParameters: function () { return [{ type: InfiniteScrollComponentStore }]; }, propDecorators: { gridListHeaderCountTemplate: [{
                type: ContentChild,
                args: [GridListHeaderCountTemplateDirective]
            }], sortByPlaceholder: [{
                type: Input
            }], sortableFields: [{
                type: Input
            }] } });

class GridListModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: GridListModule, declarations: [GridListComponent,
            GridListItemTemplateDirective,
            GridListHeaderTemplateDirective,
            GridListHeaderComponent,
            GridListHeaderCountTemplateDirective], imports: [CommonModule, CoreModule, ScrollingModule, ScrollingModule$1, LoaderModule, SelectModule, IconModule], exports: [GridListComponent, GridListItemTemplateDirective, GridListHeaderTemplateDirective, GridListHeaderComponent, GridListHeaderCountTemplateDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListModule, imports: [CommonModule, CoreModule, ScrollingModule, ScrollingModule$1, LoaderModule, SelectModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GridListComponent,
                        GridListItemTemplateDirective,
                        GridListHeaderTemplateDirective,
                        GridListHeaderComponent,
                        GridListHeaderCountTemplateDirective,
                    ],
                    imports: [CommonModule, CoreModule, ScrollingModule, ScrollingModule$1, LoaderModule, SelectModule, IconModule],
                    exports: [GridListComponent, GridListItemTemplateDirective, GridListHeaderTemplateDirective, GridListHeaderComponent, GridListHeaderCountTemplateDirective],
                }]
        }] });

/**
 * Directive to place on sections of the resizeable layout
 */
class ResizeableLayoutSectionDirective {
    /** @ignore **/
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutSectionDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.4", type: ResizeableLayoutSectionDirective, selector: "[avnResizeableLayoutSection]", inputs: { id: ["avnResizeableLayoutSection", "id"], collapsedLabel: ["avnResizeableLayoutSectionCollapsedLabel", "collapsedLabel"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutSectionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[avnResizeableLayoutSection]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { id: [{
                type: Input,
                args: ['avnResizeableLayoutSection']
            }], collapsedLabel: [{
                type: Input,
                args: ['avnResizeableLayoutSectionCollapsedLabel']
            }] } });

class ResizeableLayoutSectionComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    get width() {
        return this._elementRef.nativeElement.clientWidth;
    }
    get height() {
        return this._elementRef.nativeElement.clientHeight;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutSectionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ResizeableLayoutSectionComponent, selector: "avn-resizeable-layout-section", inputs: { name: "name" }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:block;height:100%;width:100%;background-color:var(--surface-background);border-radius:3px;overflow:hidden}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-resizeable-layout-section', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: [":host{display:block;height:100%;width:100%;background-color:var(--surface-background);border-radius:3px;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { name: [{
                type: Input
            }] } });

const rotateMatrix = (matrix, angle) => {
    if (!matrix || matrix.length === 0) {
        return matrix;
    }
    const rotationCount = Math.abs((360 + angle) % 360) / 90;
    return Array.from(Array(rotationCount)).reduce((res) => res[0].map((val, index) => res.map((row) => row[index]).reverse()), matrix);
};
const isResizer = (sectionId) => sectionId?.startsWith('resizer-');
const isRowResizer = (sectionId) => sectionId?.startsWith('resizer-row-');
const isColumnResizer = (sectionId) => sectionId?.startsWith('resizer-column-');

/**
 * The datasource initial state
 */
const INITIAL_RESIZEABLE_LAYOUT_STATE = {
    originalLayout: { layout: [], cols: [], rows: [], minMax: {} },
    calculatedLayout: { layout: [], cols: [], rows: [] },
    collapsedLayout: { layout: [], cols: [], rows: [] },
    resizerSizePx: 8,
    xAxisResizeOffsets: {},
    yAxisResizeOffsets: {},
    componentDimensionsPx: null,
    resizeInfo: null,
    collapsedSections: [],
    resizerAffectedSections: {},
};
/**
 * This is a store that can be used for components that want to implement infinite scroll in a list
 *
 */
class ResizeableLayoutStore extends ComponentStore {
    constructor() {
        super(INITIAL_RESIZEABLE_LAYOUT_STATE);
        /** Selectors */
        this.calculatedLayout$ = this.select((state) => state.calculatedLayout);
        this.xAxisResizeOffsets$ = this.select((state) => state.xAxisResizeOffsets);
        this.yAxisResizeOffsets$ = this.select((state) => state.yAxisResizeOffsets);
        this.resizerSizePx$ = this.select((state) => state.resizerSizePx);
        this.componentDimensionsPx$ = this.select((state) => state.componentDimensionsPx).pipe(map((val) => val || { width: 0, height: 0 }));
        this.collapsedSections$ = this.select((state) => state.collapsedSections);
        this.collapsibleSections$ = this.select((state) => state.originalLayout.collapsibleSections);
        this.gridTemplateAreas$ = this.select(this.calculatedLayout$, (layout) => calculateGridTemplateAreas(layout.layout));
        this.gridTemplateColumns$ = this.select(this.calculatedLayout$, this.resizerSizePx$, this.xAxisResizeOffsets$, this.componentDimensionsPx$, (calculatedLayout, resizerSizePx, xAxisResizeOffsets, componentDimensionsPx) => calculateGridTemplateDimensions(calculatedLayout.cols, resizerSizePx, xAxisResizeOffsets, componentDimensionsPx.width, calculatedLayout.cols.length - this.get().collapsedLayout.layout[0]?.length || 0), { debounce: true });
        this.gridTemplateRows$ = this.select(this.calculatedLayout$, this.resizerSizePx$, this.yAxisResizeOffsets$, this.componentDimensionsPx$, (calculatedLayout, resizerSizePx, yAxisResizeOffsets, componentDimensionsPx) => calculateGridTemplateDimensions(calculatedLayout.rows, resizerSizePx, yAxisResizeOffsets, componentDimensionsPx.height, calculatedLayout.rows.length - this.get().collapsedLayout.layout.length || 0), { debounce: true });
        this.resizerAffectedSections$ = this.select(this.calculatedLayout$, this.collapsibleSections$, this.collapsedSections$, (collapsedLayout, collapsibleSections, collapsedSections) => toResizerAffectedSectionsInfo(collapsedLayout.layout, collapsibleSections, collapsedSections));
        this.model$ = this.select(this.calculatedLayout$, this.resizerSizePx$, this.gridTemplateAreas$, this.gridTemplateColumns$, this.gridTemplateRows$, this.collapsedSections$, this.collapsibleSections$, this.resizerAffectedSections$, (calculatedLayout, resizerSizePx, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, collapsedSections, collapsibleSections, resizerAffectedSections) => ({
            distinctSectionIds: uniq(flattenDeep(calculatedLayout.layout)),
            resizerSizePx,
            gridTemplateAreas,
            gridTemplateColumns,
            gridTemplateRows,
            collapsedSections,
            hasCollapsedSections: collapsedSections.length > 0,
            layout: calculatedLayout.layout,
            rows: calculatedLayout.rows,
            cols: calculatedLayout.cols,
            resizerAffectedSections,
            collapsibleSections,
        }));
        /** Updaters **/
        this.setOriginalLayout = this.updater((state, layoutDefinition) => ({
            ...state,
            originalLayout: {
                ...layoutDefinition,
                collapsibleSections: layoutDefinition.collapsibleSections || [],
                minMax: layoutDefinition.minMax || {},
            },
            xAxisResizeOffsets: {},
            yAxisResizeOffsets: {},
            collapsedSections: [],
        }));
        this.setResizeSizePx = this.updater((state, resizerSizePx) => ({
            ...state,
            resizerSizePx,
        }));
        this.setResizeInfo = this.updater((state, resizeInfo) => ({
            ...state,
            resizeInfo,
        }));
        this.setComponentDimensionsPx = this.updater((state, componentDimensionsPx) => ({
            ...state,
            componentDimensionsPx,
        }));
        this.initResize = this.updater((state, payload) => {
            const minMax = state.originalLayout.minMax;
            const { resizerIndex, affectedSectionBeforeSizes, affectedSectionAfterSizes, axis } = payload;
            const axisResizeOffsetsProp = axis === 'x' ? 'xAxisResizeOffsets' : 'yAxisResizeOffsets';
            const minMaxProperty = axis === 'x' ? 'width' : 'height';
            // for each section, calc the max amount of pixels that it can be shrinked or expanded
            const sectionsMinMax = Object.keys({ ...affectedSectionBeforeSizes, ...affectedSectionAfterSizes }).reduce((res, sectionId) => {
                const sectionMinPx = (minMax[sectionId] || {})[minMaxProperty]?.min || 0;
                const sectionMaxPx = minMax[sectionId] && minMax[sectionId][minMaxProperty] && minMax[sectionId][minMaxProperty].max ? minMax[sectionId][minMaxProperty].max : Infinity;
                return {
                    ...res,
                    [sectionId]: {
                        minPx: sectionMinPx,
                        maxPx: sectionMaxPx,
                    },
                };
            }, {});
            // calculate the max amount of px to resize on the left + right, based on min & max dimensions for each section
            // when resizing to the left / top,  mins of before sections + maxs of after sections should be preserved
            let remainingResizePxBefore = Object.entries(affectedSectionBeforeSizes)
                .map(([sectionId, sectionSize]) => sectionSize - sectionsMinMax[sectionId].minPx)
                .reduce((res, remainingResizePx) => Math.min(res, remainingResizePx), Infinity);
            let remainingResizePxAfter = Object.entries(affectedSectionAfterSizes)
                .map(([sectionId, sectionSize]) => sectionsMinMax[sectionId].maxPx - sectionSize)
                .reduce((res, remainingResizePx) => Math.min(res, remainingResizePx), Infinity);
            const maxResizePxBefore = Math.min(remainingResizePxBefore, remainingResizePxAfter);
            // when resizing to the right / bottom,  maxs of before sections + mins of after sections should be preserved
            remainingResizePxBefore = Object.entries(affectedSectionBeforeSizes)
                .map(([sectionId, sectionSize]) => sectionsMinMax[sectionId].maxPx - sectionSize)
                .reduce((res, remainingResizePx) => Math.min(res, remainingResizePx), Infinity);
            remainingResizePxAfter = Object.entries(affectedSectionAfterSizes)
                .map(([sectionId, sectionSize]) => sectionSize - sectionsMinMax[sectionId].minPx)
                .reduce((res, remainingResizePx) => Math.min(res, remainingResizePx), Infinity);
            const maxResizePxAfter = Math.min(remainingResizePxBefore, remainingResizePxAfter);
            return {
                ...state,
                resizeInfo: {
                    resizerIndex,
                    maxResizePxBefore,
                    maxResizePxAfter,
                    remainingResizePxBefore: maxResizePxBefore,
                    remainingResizePxAfter: maxResizePxAfter,
                    initialDiffPx: 0,
                    initialAxisOffset: state[axisResizeOffsetsProp][resizerIndex] || 0,
                },
            };
        });
        this.doResize = this.updater((state, payload) => {
            const { resizeInfo } = state;
            const { event, axis } = payload;
            const initialDiffPx = axis === 'x' ? event.initialDiffX : event.initialDiffY;
            const diffPx = axis === 'x' ? event.diffX : event.diffY;
            const axisResizeOffsetsProp = axis === 'x' ? 'xAxisResizeOffsets' : 'yAxisResizeOffsets';
            const canResizeLeft = -initialDiffPx <= resizeInfo.maxResizePxBefore;
            const canResizeRight = initialDiffPx <= resizeInfo.maxResizePxAfter;
            const isResizingBefore = diffPx < 0;
            const isResizingAfter = diffPx > 0;
            const shouldSpanToBeforeEdge = isResizingBefore && !canResizeLeft && resizeInfo.remainingResizePxBefore > 0;
            const shouldSpanToAfterEdge = isResizingAfter && !canResizeRight && resizeInfo.remainingResizePxAfter > 0;
            const shouldUpdateResizerOffset = (canResizeLeft && canResizeRight) || shouldSpanToBeforeEdge || shouldSpanToAfterEdge;
            if (!shouldUpdateResizerOffset) {
                return state;
            }
            let newResizerOffsetPx;
            let remainingResizePxBefore;
            let remainingResizePxAfter;
            if (canResizeLeft && canResizeRight) {
                newResizerOffsetPx = resizeInfo.initialAxisOffset + initialDiffPx;
                remainingResizePxBefore = resizeInfo.maxResizePxBefore + initialDiffPx;
                remainingResizePxAfter = resizeInfo.maxResizePxAfter - initialDiffPx;
            }
            else if (shouldSpanToBeforeEdge) {
                newResizerOffsetPx = (state[axisResizeOffsetsProp][resizeInfo.resizerIndex] || 0) - resizeInfo.remainingResizePxBefore;
                remainingResizePxAfter = resizeInfo.maxResizePxAfter - initialDiffPx + resizeInfo.remainingResizePxBefore;
                remainingResizePxBefore = 0;
            }
            else if (shouldSpanToAfterEdge) {
                newResizerOffsetPx = (state[axisResizeOffsetsProp][resizeInfo.resizerIndex] || 0) + resizeInfo.remainingResizePxAfter;
                remainingResizePxBefore = resizeInfo.maxResizePxBefore + initialDiffPx + resizeInfo.remainingResizePxAfter;
                remainingResizePxAfter = 0;
            }
            return {
                ...state,
                [axisResizeOffsetsProp]: {
                    ...state[axisResizeOffsetsProp],
                    [state.resizeInfo.resizerIndex]: newResizerOffsetPx,
                },
                resizeInfo: {
                    ...resizeInfo,
                    initialDiffPx,
                    remainingResizePxBefore,
                    remainingResizePxAfter,
                },
            };
        });
        this.scaleResizeOffset = this.updater((state, payload) => {
            const { widthRatio, heightRatio } = payload;
            const xAxisResizeOffsets = Object.entries(state.xAxisResizeOffsets).reduce((res, [section, width]) => ({
                ...res,
                [section]: width * widthRatio,
            }), {});
            const yAxisResizeOffsets = Object.entries(state.yAxisResizeOffsets).reduce((res, [section, height]) => ({
                ...res,
                [section]: height * heightRatio,
            }), {});
            return {
                ...state,
                xAxisResizeOffsets,
                yAxisResizeOffsets,
            };
        });
        this.hideSection = this.updater((state, section) => ({ ...state, collapsedSections: [...state.collapsedSections, section] }));
        this.showSection = this.updater((state, section) => ({ ...state, collapsedSections: state.collapsedSections.filter((s) => s !== section) }));
        /** Automatically recalculate the layout when sections are collapsed **/
        this.recalculateLayout = this.effect(() => this.select(this.select((state) => state.collapsedLayout), this.resizerSizePx$, (collapsedLayout, resizerSizePx) => ({
            collapsedLayout,
            resizerSizePx,
        })).pipe(tap(({ collapsedLayout, resizerSizePx }) => {
            const calculatedLayout = addAllResizers(collapsedLayout, resizerSizePx);
            this.patchState({
                calculatedLayout,
            });
        })));
        /** Automatically recalculate the layout when the collapsed layout changes **/
        this.recalculateCollapsedLayout = this.effect(() => this.collapsedSections$.pipe(tap((collapsedSections) => {
            if (collapsedSections.length === 0) {
                this.patchState({
                    collapsedLayout: this.get().originalLayout,
                });
                return;
            }
            const collapsedLayout = cloneDeep(this.get().originalLayout);
            for (const collapsedSection of collapsedSections) {
                collapsedLayout.layout = createLayoutWithoutSection(collapsedLayout.layout, collapsedSection);
            }
            this.patchState({
                collapsedLayout,
                xAxisResizeOffsets: {},
                yAxisResizeOffsets: {},
            });
        })));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });
const calculateGridTemplateAreas = (layout) => layout.map((layoutRow) => `"${layoutRow.join(' ')}"`).join(` `);
const calculateGridTemplateDimensions = (cells, resizerSizePx, axisResizeOffsets, componentSizePx, axisResizerCount) => {
    const resizerRatioPx = axisResizerCount === 0 ? 0 : (resizerSizePx * axisResizerCount) / (axisResizerCount + 1);
    return cells
        .map((dimension, i) => {
        const resizeOffsetBefore = axisResizeOffsets[i - 1];
        const resizeOffsetAfter = axisResizeOffsets[i + 1];
        if (!resizeOffsetBefore && !resizeOffsetAfter) {
            return typeof dimension === 'string' ? dimension : `calc(${dimension * 100}% - ${resizerRatioPx}px)`;
        }
        const resizeOffsetPx = (resizeOffsetBefore || 0) - (resizeOffsetAfter || 0);
        const resizeOffsetPercent = (resizeOffsetPx / componentSizePx) * 100;
        if (typeof dimension === 'string') {
            return `calc(${dimension} - ${resizeOffsetPercent}% - ${resizerRatioPx}px)`;
        }
        return `calc(${dimension * 100}% - ${resizeOffsetPercent}% - ${resizerRatioPx}px)`;
    })
        .join(' ');
};
const createLayoutWithoutSection = (layout, sectionToRemove) => {
    // if the section spans a whole row just remove it
    let rowIndex = layout.findIndex((row) => row.every((col) => col === sectionToRemove));
    if (rowIndex !== -1) {
        return [...layout.slice(0, rowIndex), layout[rowIndex - 1] || layout[rowIndex + 1], ...layout.slice(rowIndex + 1)];
    }
    // same if it spans a whole column
    const rotated = rotateMatrix(layout, 90);
    rowIndex = rotated.findIndex((row) => row.every((col) => col === sectionToRemove));
    if (rowIndex !== -1) {
        return rotateMatrix([...rotated.slice(0, rowIndex), rotated[rowIndex - 1] || rotated[rowIndex + 1], ...rotated.slice(rowIndex + 1)], -90);
    }
    const colIndexes = layout.reduce((res, row) => {
        row.forEach((col, i) => {
            if (col === sectionToRemove) {
                res.push(i);
            }
        });
        return res;
    }, []);
    const rowIndexes = rotateMatrix(layout, -90).reduce((res, row) => {
        row.forEach((col, i) => {
            if (col === sectionToRemove) {
                res.push(i);
            }
        });
        return res;
    }, []);
    const isSingleSection = colIndexes.length === 1 && rowIndexes.length === 1;
    if (isSingleSection) {
        const newLayout = cloneDeep(layout);
        newLayout[rowIndexes[0]][colIndexes[0]] = layout[rowIndexes[0]][colIndexes[0] + 1] || layout[rowIndexes[0]][colIndexes[0] - 1];
        return newLayout;
    }
    // Not supported for more complex use cases
    return layout;
};
const addAllResizers = (layout, resizerSizePx) => {
    // add vertical columns resizers
    let newRows = addResizer(layout.layout, 'resizer-column');
    // add horizontal rows resizers (flip the grid matrix to apply the same process as for columns)
    newRows = rotateMatrix(newRows, 90);
    newRows = addResizer(newRows, 'resizer-row');
    newRows = rotateMatrix(newRows, -90);
    // calc new rows
    let index = 0;
    const rows = newRows.reduce((res, row) => {
        res.push(row.some((section) => isRowResizer(section)) ? `${resizerSizePx}px` : layout.rows[index++]);
        return res;
    }, []);
    // calc new cols
    index = 0;
    const cols = rotateMatrix(newRows, 90).reduce((res, row) => {
        res.push(row.some((section) => isColumnResizer(section)) ? `${resizerSizePx}px` : layout.cols[index++]);
        return res;
    }, []);
    return {
        layout: newRows,
        cols,
        rows,
    };
};
const addResizer = (layout, type) => {
    let index = 0;
    // first loop through each row to find out the col index where a resizer is needed
    const colIndexForResizers = layout
        .reduce((colIndexes, row) => {
        row.forEach((section, colIndex) => {
            const isLastHorizontalSection = colIndex === row.length - 1;
            const isSameNextHorizontalSection = !isLastHorizontalSection && row[colIndex + 1] === section;
            if (!isLastHorizontalSection && !isSameNextHorizontalSection && !colIndexes.includes(colIndex)) {
                colIndexes.push(colIndex);
            }
        });
        return colIndexes;
    }, [])
        .sort();
    // now insert the resizers, and duplicate sections as needed to match added resizers, in order to keep the grid ratio
    let newLayout = layout.map((row) => row.reduce((newRow, rowSection, colIndex) => {
        newRow.push(rowSection);
        if (colIndexForResizers.includes(colIndex)) {
            const isSameNextHorizontalSection = row[colIndex + 1] === rowSection;
            if (isSameNextHorizontalSection) {
                newRow.push(rowSection);
            }
            else {
                newRow.push(type);
            }
        }
        return newRow;
    }, []));
    // now we need to group the resizers across multiple rows. Rotating the grid makes it easier
    newLayout = rotateMatrix(newLayout, 90).map((row) => row.reduce((newRow, rowSection, colIndex) => {
        if (rowSection !== type) {
            return [...newRow, rowSection];
        }
        const hasPreviousResizer = row[colIndex - 1] === `${type}`;
        return [...newRow, `${type}-${hasPreviousResizer ? index : ++index}`];
    }, []));
    // rotate it back and return
    return rotateMatrix(newLayout, -90);
};
/**
 * Returns each before and after section that will be affected by each resizer
 */
const toResizerAffectedSectionsInfo = (layout, collapsibleSections, collapsedSections) => {
    const remainingCollapsibleSections = collapsibleSections.filter((section) => !collapsedSections.includes(section));
    const res = {};
    // columns resizers
    layout.forEach((row, rowIndex) => {
        row.forEach((col, colIndex) => {
            if (remainingCollapsibleSections.includes(col)) {
                // find the first column resizer
                let colResizerId = layout[rowIndex].slice(colIndex + 1).find((section) => isColumnResizer(section));
                if (colResizerId) {
                    res[colResizerId] = { ...res[colResizerId], before: col };
                    return res;
                }
                colResizerId = layout[rowIndex]
                    .slice(0, colIndex)
                    .reverse()
                    .find((section) => isColumnResizer(section));
                if (colResizerId) {
                    res[colResizerId] = { ...res[colResizerId], after: col };
                    return res;
                }
            }
        });
    });
    // row resizers
    const rotatedLayout = rotateMatrix(layout, 90);
    rotatedLayout.forEach((row, rowIndex) => {
        row.forEach((col, colIndex) => {
            if (remainingCollapsibleSections.includes(col)) {
                // find the first row resizer
                let rowResizerId = rotatedLayout[rowIndex].slice(colIndex + 1).find((section) => isRowResizer(section));
                if (rowResizerId) {
                    res[rowResizerId] = { ...res[rowResizerId], after: col };
                    return res;
                }
                rowResizerId = rotatedLayout[rowIndex]
                    .slice(0, colIndex)
                    .reverse()
                    .find((section) => isColumnResizer(section));
                if (rowResizerId) {
                    res[rowResizerId] = { ...res[rowResizerId], before: col };
                    return res;
                }
            }
        });
    });
    return res;
};

/**
 * This component allows to create dynamic resizable layouts.
 * It uses grid css under the hood and a component store to manage its reactive data.
 */
class ResizeableLayoutComponent {
    /** state of the collapse section icon, null when not visible **/
    set layout(layout) {
        this._store.setOriginalLayout(layout);
        this._hideCollapseSectionIconSubject.next();
    }
    set resizerSizePx(resizerSizePx) {
        this._resizerSizePx = resizerSizePx;
        this._store.setResizeSizePx(resizerSizePx);
    }
    get resizerSizePx() {
        return this._resizerSizePx;
    }
    set collapseIconTrigger(triggerType) {
        this._collapseIconTrigger = triggerType || 'hover';
        this._collapseSectionIconTriggerSubject.next(this._collapseIconTrigger);
    }
    get collapseIconTrigger() {
        return this._collapseIconTrigger;
    }
    constructor(_store) {
        this._store = _store;
        /** Position of the sidebar containing collapsed sections **/
        this.sidebarPosition = 'right';
        /**
         * Collapse button trigger type.
         * Set to hover to show the collapse button when hovering the resizer
         * Set to sticky to always show the collapse button
         */
        this._collapseIconTrigger = 'hover';
        /** Emits when a section is toggled (opened / collapsed) **/
        this.sectionToggled = new EventEmitter();
        this.model$ = this._store.model$;
        this.trackBySection = (_, sectionId) => sectionId;
        this.isRowResizer = isRowResizer;
        this.isColumnResizer = isColumnResizer;
        this.isResizer = isResizer;
        /** @ignore couple of subjects to manage the visibility and position of the collapse section icon **/
        this._resizerEnterSubject = new Subject();
        this._resizerLeaveSubject = new Subject();
        this._resizerMoveSubject = new Subject();
        this._hideCollapseSectionIconSubject = new Subject();
        this._collapseSectionIconHoveredSubject = new Subject();
        this._collapseSectionIconTriggerSubject = new BehaviorSubject(this._collapseIconTrigger);
        this._componentDestroyed$ = new Subject();
        const hoveredCollapseSectionIcon$ = merge(this._resizerEnterSubject, this._resizerMoveSubject)
            .pipe(takeUntil(this._collapseSectionIconTriggerSubject.pipe(filter((trigger) => trigger !== 'hover'))))
            .pipe(debounceTime(600), takeUntil(merge(this._resizerLeaveSubject.pipe(delay(300), takeUntil(this._collapseSectionIconHoveredSubject.pipe(isTruthy()))), this._collapseSectionIconHoveredSubject.pipe(isFalsy(), delay(300)), this._hideCollapseSectionIconSubject)))
            .pipe(endWith(null), repeat())
            .pipe(distinctUntilChanged(), withLatestFrom(this._store.resizerSizePx$), map(([evt, resizerSizePx]) => {
            if (!evt) {
                return null;
            }
            const { event, resizerId, axis } = evt;
            const { offsetX, offsetY, clientX, clientY } = event;
            const x = axis === 'x' ? clientX - offsetX + resizerSizePx : clientX;
            const y = axis === 'y' ? clientY - offsetY + resizerSizePx : clientY;
            return { resizerId, x, y };
        }));
        this.collapseSectionIcon$ = this._collapseSectionIconTriggerSubject.pipe(filter((triggerType) => triggerType === 'hover'), switchMap((_triggerType) => hoveredCollapseSectionIcon$));
        // emit a toggled event every time the collapsed sections change
        this._store.collapsedSections$
            .pipe(pairwise(), switchMap(([prev, curr]) => {
            const diff = xor(prev, curr);
            const toggledSection = diff[0];
            if (!toggledSection) {
                return EMPTY;
            }
            return of({
                toggledSection,
                opened: !curr.includes(toggledSection),
                collapsedSections: curr,
            });
        }), takeUntil(this._componentDestroyed$))
            .subscribe((event) => {
            this.sectionToggled.emit(event);
        });
    }
    getTemplate(section, resizeableSectionsDirectiveQL) {
        return (resizeableSectionsDirectiveQL?.toArray() || []).find((item) => item.id === section)?.templateRef;
    }
    onHorizontalResizeStart(resizerId, layout) {
        // create a map of all sections affected by the resizing on the left/right of the resizer, with their current widths
        const resizerIndex = this._getResizerColIndex(resizerId, layout);
        const layoutSectionsAffectedByResize = this._getLayoutSectionsAffectedByResize(resizerIndex, resizerId, layout);
        const affectedSectionBeforeSizes = Array.from(layoutSectionsAffectedByResize.before.values()).reduce((res, section) => ({ ...res, [section]: this.resizeableSectionsComponentQL.toArray().find((s) => s.name === section).width }), {});
        const affectedSectionAfterSizes = Array.from(layoutSectionsAffectedByResize.after.values()).reduce((res, section) => ({ ...res, [section]: this.resizeableSectionsComponentQL.toArray().find((s) => s.name === section).width }), {});
        this._store.initResize({ resizerIndex, affectedSectionBeforeSizes, affectedSectionAfterSizes, axis: 'x' });
        if (this._collapseIconTrigger === 'hover') {
            this._hideCollapseSectionIconSubject.next();
        }
    }
    onHorizontalResizeMove(event) {
        this._store.doResize({ event, axis: 'x' });
    }
    onHorizontalResizeEnd() {
        this._store.setResizeInfo(null);
    }
    onVerticalResizeStart(resizerId, layout) {
        layout = rotateMatrix(layout, -90);
        // create a map of all sections affected by the resizing on the left/right of the resizer, with their current widths
        const resizerIndex = this._getResizerColIndex(resizerId, layout);
        const layoutSectionsAffectedByResize = this._getLayoutSectionsAffectedByResize(resizerIndex, resizerId, layout);
        const affectedSectionBeforeSizes = Array.from(layoutSectionsAffectedByResize.before.values()).reduce((res, section) => ({ ...res, [section]: this.resizeableSectionsComponentQL.toArray().find((s) => s.name === section).height }), {});
        const affectedSectionAfterSizes = Array.from(layoutSectionsAffectedByResize.after.values()).reduce((res, section) => ({ ...res, [section]: this.resizeableSectionsComponentQL.toArray().find((s) => s.name === section).height }), {});
        this._store.initResize({ resizerIndex, affectedSectionBeforeSizes, affectedSectionAfterSizes, axis: 'y' });
        if (this._collapseIconTrigger === 'hover') {
            this._hideCollapseSectionIconSubject.next();
        }
    }
    onVerticalResizeMove(event) {
        this._store.doResize({ event, axis: 'y' });
    }
    onVerticalResizeEnd() {
        this._store.setResizeInfo(null);
    }
    onResize($event) {
        // we need to adjust the resizing to the new dimensions
        this._store.setComponentDimensionsPx({ width: $event.width, height: $event.height });
        const widthRatio = $event.width / $event.previousWidth;
        const heightRatio = $event.height / $event.previousHeight;
        this._store.scaleResizeOffset({ widthRatio, heightRatio });
    }
    hideSection(sectionId) {
        this._hideCollapseSectionIconSubject.next();
        this._collapseSectionIconHoveredSubject.next(false);
        this._store.hideSection(sectionId);
    }
    showSection(sectionId) {
        this._store.showSection(sectionId);
    }
    onResizeMouseEnter(event, resizerId, axis) {
        this._resizerEnterSubject.next({ event, resizerId, axis });
    }
    onResizeMouseMove(event, resizerId, axis) {
        this._resizerMoveSubject.next({ event, resizerId, axis });
    }
    onResizeMouseLeave(event, resizerId, axis) {
        this._resizerLeaveSubject.next({ event, resizerId, axis });
    }
    onCollapseSectionIconMouseEnter() {
        this._collapseSectionIconHoveredSubject.next(true);
    }
    onCollapseSectionIconMouseLeave() {
        this._collapseSectionIconHoveredSubject.next(false);
    }
    getCollapsedSectionLabel(section, list) {
        return list?.toArray().find((s) => s.id === section)?.collapsedLabel || section;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    _getResizerColIndex(resizerId, layout) {
        // find the col index of the resizer (go through all rows as it many be on any row)
        return flattenDeep(layout).findIndex((s) => s === resizerId) % layout[0].length;
    }
    _getLayoutSectionsAffectedByResize(resizerIndex, resizerId, layout) {
        // find the col index of the resizer (go through all rows as it many be on any row)
        return layout
            .filter((row) => row.includes(resizerId))
            .reduce((res, row) => {
            const sectionBefore = row[resizerIndex - 1];
            const sectionAfter = row[resizerIndex + 1];
            if (!isResizer(sectionBefore)) {
                res.before.add(sectionBefore);
            }
            if (!isResizer(sectionAfter)) {
                res.after.add(sectionAfter);
            }
            return res;
        }, { before: new Set(), after: new Set() });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutComponent, deps: [{ token: ResizeableLayoutStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: ResizeableLayoutComponent, selector: "avn-resizeable-layout", inputs: { layout: "layout", resizerSizePx: "resizerSizePx", sidebarPosition: "sidebarPosition", collapseIconTrigger: "collapseIconTrigger" }, outputs: { sectionToggled: "sectionToggled" }, providers: [ResizeableLayoutStore], queries: [{ propertyName: "resizeableSectionsDirectiveQL", predicate: ResizeableLayoutSectionDirective }], viewQueries: [{ propertyName: "resizeableSectionsComponentQL", predicate: ResizeableLayoutSectionComponent, descendants: true }], ngImport: i0, template: "<div\n  [class]=\"['wrapper', sidebarPosition]\"\n  [class.has-sidebar]=\"(model$ | async)?.hasCollapsedSections\"\n  (avnResize)=\"onResize($event)\"\n  [debounceTime]=\"0\"\n  [emitInitialEvent]=\"true\"\n>\n  <ng-container *ngIf=\"model$ | async as model\">\n    <div\n      class=\"grid\"\n      [style.--resizer-size]=\"model.resizerSizePx + 'px'\"\n      [style.grid-template-areas]=\"model.gridTemplateAreas\"\n      [style.grid-template-rows]=\"model.gridTemplateRows\"\n      [style.grid-template-columns]=\"model.gridTemplateColumns\"\n    >\n      <ng-container *ngFor=\"let section of model.distinctSectionIds; trackBy: trackBySection\">\n        <ng-container *ngIf=\"isColumnResizer(section)\">\n          <!-- vertical resizer -->\n          <div\n            [style.grid-area]=\"section\"\n            class=\"resizer\"\n            avnDrag\n            [axis]=\"'x'\"\n            [cursor]=\"'col-resize'\"\n            [debounceTime]=\"0\"\n            (dragStart)=\"onHorizontalResizeStart(section, model.layout)\"\n            (dragMove)=\"onHorizontalResizeMove($event)\"\n            (dragEnd)=\"onHorizontalResizeEnd()\"\n            (mouseenter)=\"onResizeMouseEnter($event, section, 'x')\"\n            (mousemove)=\"onResizeMouseMove($event, section, 'x')\"\n            (mouseleave)=\"onResizeMouseLeave($event, section, 'x')\"\n            (avnMultiClick)=\"model.resizerAffectedSections[section] && hideSection(model.resizerAffectedSections[section].after || model.resizerAffectedSections[section].before)\"\n          >\n            <ng-container *ngIf=\"collapseIconTrigger === 'sticky'\">\n              <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n                <ng-container *ngIf=\"toggles.before\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'left', sectionToHide: toggles.before }\"></ng-container>\n                </ng-container>\n                <ng-container *ngIf=\"toggles.after\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'right', sectionToHide: toggles.after }\"></ng-container>\n                </ng-container>\n              </ng-container>\n            </ng-container>\n          </div>\n          <!-- vertical resizer collapse icons -->\n          <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n            <ng-container *ngIf=\"collapseSectionIcon$ | async as collapseSectionIcon\">\n              <ng-container *ngIf=\"toggles.before && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'left',\n                      sectionToHide: toggles.before,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n              <ng-container *ngIf=\"toggles.after && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'right',\n                      sectionToHide: toggles.after,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"isRowResizer(section)\">\n          <!-- horizontal resizer -->\n          <div\n            [style.grid-area]=\"section\"\n            class=\"resizer\"\n            avnDrag\n            [cursor]=\"'row-resize'\"\n            [axis]=\"'y'\"\n            [debounceTime]=\"0\"\n            (dragStart)=\"onVerticalResizeStart(section, model.layout)\"\n            (dragMove)=\"onVerticalResizeMove($event)\"\n            (dragEnd)=\"onVerticalResizeEnd()\"\n            (mouseenter)=\"onResizeMouseEnter($event, section, 'y')\"\n            (mousemove)=\"onResizeMouseMove($event, section, 'y')\"\n            (mouseleave)=\"onResizeMouseLeave($event, section, 'y')\"\n            (avnMultiClick)=\"model.resizerAffectedSections[section] && hideSection(model.resizerAffectedSections[section].after || model.resizerAffectedSections[section].before)\"\n          >\n            <ng-container *ngIf=\"collapseIconTrigger === 'sticky'\">\n              <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n                <ng-container *ngIf=\"toggles.before\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'top', sectionToHide: toggles.before }\"></ng-container>\n                </ng-container>\n                <ng-container *ngIf=\"toggles.after\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'bottom', sectionToHide: toggles.after }\"></ng-container>\n                </ng-container>\n              </ng-container>\n            </ng-container>\n          </div>\n          <!-- vertical resizer collapse icons -->\n          <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n            <ng-container *ngIf=\"collapseSectionIcon$ | async as collapseSectionIcon\">\n              <ng-container *ngIf=\"toggles.before && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'top',\n                      sectionToHide: toggles.before,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n              <ng-container *ngIf=\"toggles.after && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'bottom',\n                      sectionToHide: toggles.after,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"!isResizer(section)\">\n          <avn-resizeable-layout-section [name]=\"section\" [style.grid-area]=\"section\">\n            <ng-container *ngTemplateOutlet=\"section | applyFunction:getTemplate:[resizeableSectionsDirectiveQL]\"></ng-container>\n          </avn-resizeable-layout-section>\n        </ng-container>\n      </ng-container>\n    </div>\n    <div [class]=\"['sidebar', sidebarPosition]\" *ngIf=\"model.hasCollapsedSections\">\n      <ng-container *ngFor=\"let collapsedSection of model.collapsedSections; trackBy: trackBySection\">\n        <div class=\"sidebar-section\" (click)=\"showSection(collapsedSection)\">{{ collapsedSection | applyFunction: getCollapsedSectionLabel:[resizeableSectionsDirectiveQL] }}</div>\n      </ng-container>\n    </div>\n  </ng-container>\n</div>\n\n<ng-template #hoveredToggleSectionIcon let-position=\"position\" let-sectionToHide=\"sectionToHide\" let-collapseSectionIcon=\"collapseSectionIcon\">\n  <div\n    [class]=\"'hovered icon ' + position\"\n    [style.left.px]=\"collapseSectionIcon.x\"\n    [style.top.px]=\"collapseSectionIcon.y\"\n    (click)=\"hideSection(sectionToHide)\"\n    (mouseenter)=\"onCollapseSectionIconMouseEnter()\"\n    (mouseleave)=\"onCollapseSectionIconMouseLeave()\"\n  >\n    <avn-icon [icon]=\"'navigation:double_arrow'\"></avn-icon>\n  </div>\n</ng-template>\n\n<ng-template #stickyToggleSectionIcon let-position=\"position\" let-sectionToHide=\"sectionToHide\">\n  <div\n    [class]=\"'sticky icon ' + position\"\n    (click)=\"hideSection(sectionToHide)\">\n      <avn-icon [icon]=\"'navigation:double_arrow'\" [fontSize]=\"18\"></avn-icon>\n  </div>\n</ng-template>\n", styles: [":host{display:block;height:100%;width:100%}:host .wrapper{display:grid;height:100%;width:100%;grid-template-columns:1fr}:host .wrapper.has-sidebar.right{grid-template-columns:1fr min-content}:host .wrapper.has-sidebar.bottom{grid-template-rows:1fr min-content}:host .wrapper.has-sidebar.left{grid-template-columns:min-content 1fr}:host .wrapper.has-sidebar.left>.grid{order:2}:host .wrapper.has-sidebar.left>.sidebar{order:1}:host .wrapper.has-sidebar.top{grid-template-rows:min-content 1fr}:host .wrapper.has-sidebar.top>.grid{order:2}:host .wrapper.has-sidebar.top>.sidebar{order:1}:host .wrapper .grid{display:grid;height:100%;width:100%;overflow:hidden}:host .wrapper .grid>div.resizer{-webkit-user-select:none;user-select:none;box-sizing:content-box;background-color:var(--master-detail-resizer);position:relative;z-index:1}:host .wrapper .grid avn-resizeable-layout-section{position:relative}:host .wrapper .grid avn-resizeable-layout-section .toggled-container{position:absolute;inset:0;background-color:var(--master-detail-resizer);z-index:1}:host .wrapper .sidebar{-webkit-user-select:none;user-select:none;background-color:var(--main-background);display:grid;grid-gap:var(--space-md);padding:var(--space-xs)}:host .wrapper .sidebar .sidebar-section{background-color:var(--surface-background);border-radius:3px;cursor:pointer}:host .wrapper .sidebar .sidebar-section:hover{background-color:var(--primary-base);color:var(--primary-on)}:host .wrapper .sidebar.left,:host .wrapper .sidebar.right{grid-auto-flow:row;grid-auto-rows:max-content;justify-content:center;align-items:start}:host .wrapper .sidebar.left .sidebar-section,:host .wrapper .sidebar.right .sidebar-section{padding:var(--space-md) var(--space-xs);text-orientation:mixed;writing-mode:vertical-rl}:host .wrapper .sidebar.top,:host .wrapper .sidebar.bottom{grid-auto-flow:column;grid-auto-columns:max-content;justify-content:start;align-items:center}:host .wrapper .sidebar.top .sidebar-section,:host .wrapper .sidebar.bottom .sidebar-section{padding:var(--space-xs) var(--space-md)}:host .wrapper .icon{cursor:pointer;background-color:var(--master-detail-resizer);position:fixed;--resizer-size: 6px}:host .wrapper .icon.hovered{--section-icon-opacity: .7;top:0;z-index:2;-webkit-user-select:none;user-select:none;animation:pulse-in .3s cubic-bezier(0,0,.2,1)}:host .wrapper .icon.hovered.right{padding:var(--space-md) var(--space-sm);transform:translate(1px,-50%)}:host .wrapper .icon.hovered.left{padding:var(--space-md) var(--space-sm);transform:translate(calc(-100% - var(--resizer-size) - 1px),-50%)}:host .wrapper .icon.hovered.top{padding:var(--space-sm) var(--space-md);transform:translate(-50%,calc(-100% - var(--resizer-size) - 1px))}:host .wrapper .icon.hovered.bottom{padding:var(--space-sm) var(--space-md);transform:translate(-50%,1px)}:host .wrapper .icon.hovered>avn-icon{opacity:var(--section-icon-opacity)}:host .wrapper .icon.hovered>avn-icon:hover{opacity:1}:host .wrapper .icon.sticky{--section-icon-opacity: .5;padding:var(--space-sm)}:host .wrapper .icon.sticky.left{transform:translate(calc(-100% - var(--resizer-size) + 10px))}:host .wrapper .icon.sticky.top{transform:translate(-50%,calc(-100% - var(--resizer-size) - 1px))}:host .wrapper .icon.sticky>avn-icon{opacity:var(--section-icon-opacity)}:host .wrapper .icon.sticky>avn-icon:hover{opacity:1}:host .wrapper .icon.left>avn-icon{transform:rotate(-180deg)}:host .wrapper .icon.top>avn-icon{transform:rotate(-90deg)}:host .wrapper .icon.bottom>avn-icon{transform:rotate(90deg)}@keyframes pulse-in{0%{opacity:0}to{opacity:var(--section-icon-opacity)}}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }, { kind: "directive", type: DragDirective, selector: "[avnDrag]", inputs: ["debounceTime", "allowOutsideMove", "axis", "cursor", "showDraggingOverlay"], outputs: ["dragStart", "dragMove", "dragEnd"] }, { kind: "directive", type: MultiClickDirective, selector: "[avnMultiClick]", inputs: ["clickCount", "clickTime"], outputs: ["avnMultiClick"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "component", type: ResizeableLayoutSectionComponent, selector: "avn-resizeable-layout-section", inputs: ["name"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-resizeable-layout', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ResizeableLayoutStore], template: "<div\n  [class]=\"['wrapper', sidebarPosition]\"\n  [class.has-sidebar]=\"(model$ | async)?.hasCollapsedSections\"\n  (avnResize)=\"onResize($event)\"\n  [debounceTime]=\"0\"\n  [emitInitialEvent]=\"true\"\n>\n  <ng-container *ngIf=\"model$ | async as model\">\n    <div\n      class=\"grid\"\n      [style.--resizer-size]=\"model.resizerSizePx + 'px'\"\n      [style.grid-template-areas]=\"model.gridTemplateAreas\"\n      [style.grid-template-rows]=\"model.gridTemplateRows\"\n      [style.grid-template-columns]=\"model.gridTemplateColumns\"\n    >\n      <ng-container *ngFor=\"let section of model.distinctSectionIds; trackBy: trackBySection\">\n        <ng-container *ngIf=\"isColumnResizer(section)\">\n          <!-- vertical resizer -->\n          <div\n            [style.grid-area]=\"section\"\n            class=\"resizer\"\n            avnDrag\n            [axis]=\"'x'\"\n            [cursor]=\"'col-resize'\"\n            [debounceTime]=\"0\"\n            (dragStart)=\"onHorizontalResizeStart(section, model.layout)\"\n            (dragMove)=\"onHorizontalResizeMove($event)\"\n            (dragEnd)=\"onHorizontalResizeEnd()\"\n            (mouseenter)=\"onResizeMouseEnter($event, section, 'x')\"\n            (mousemove)=\"onResizeMouseMove($event, section, 'x')\"\n            (mouseleave)=\"onResizeMouseLeave($event, section, 'x')\"\n            (avnMultiClick)=\"model.resizerAffectedSections[section] && hideSection(model.resizerAffectedSections[section].after || model.resizerAffectedSections[section].before)\"\n          >\n            <ng-container *ngIf=\"collapseIconTrigger === 'sticky'\">\n              <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n                <ng-container *ngIf=\"toggles.before\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'left', sectionToHide: toggles.before }\"></ng-container>\n                </ng-container>\n                <ng-container *ngIf=\"toggles.after\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'right', sectionToHide: toggles.after }\"></ng-container>\n                </ng-container>\n              </ng-container>\n            </ng-container>\n          </div>\n          <!-- vertical resizer collapse icons -->\n          <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n            <ng-container *ngIf=\"collapseSectionIcon$ | async as collapseSectionIcon\">\n              <ng-container *ngIf=\"toggles.before && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'left',\n                      sectionToHide: toggles.before,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n              <ng-container *ngIf=\"toggles.after && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'right',\n                      sectionToHide: toggles.after,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"isRowResizer(section)\">\n          <!-- horizontal resizer -->\n          <div\n            [style.grid-area]=\"section\"\n            class=\"resizer\"\n            avnDrag\n            [cursor]=\"'row-resize'\"\n            [axis]=\"'y'\"\n            [debounceTime]=\"0\"\n            (dragStart)=\"onVerticalResizeStart(section, model.layout)\"\n            (dragMove)=\"onVerticalResizeMove($event)\"\n            (dragEnd)=\"onVerticalResizeEnd()\"\n            (mouseenter)=\"onResizeMouseEnter($event, section, 'y')\"\n            (mousemove)=\"onResizeMouseMove($event, section, 'y')\"\n            (mouseleave)=\"onResizeMouseLeave($event, section, 'y')\"\n            (avnMultiClick)=\"model.resizerAffectedSections[section] && hideSection(model.resizerAffectedSections[section].after || model.resizerAffectedSections[section].before)\"\n          >\n            <ng-container *ngIf=\"collapseIconTrigger === 'sticky'\">\n              <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n                <ng-container *ngIf=\"toggles.before\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'top', sectionToHide: toggles.before }\"></ng-container>\n                </ng-container>\n                <ng-container *ngIf=\"toggles.after\">\n                  <ng-container *ngTemplateOutlet=\"stickyToggleSectionIcon; context: { position: 'bottom', sectionToHide: toggles.after }\"></ng-container>\n                </ng-container>\n              </ng-container>\n            </ng-container>\n          </div>\n          <!-- vertical resizer collapse icons -->\n          <ng-container *ngIf=\"model.resizerAffectedSections[section] as toggles\">\n            <ng-container *ngIf=\"collapseSectionIcon$ | async as collapseSectionIcon\">\n              <ng-container *ngIf=\"toggles.before && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'top',\n                      sectionToHide: toggles.before,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n              <ng-container *ngIf=\"toggles.after && collapseSectionIcon.resizerId === section\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    hoveredToggleSectionIcon;\n                    context: {\n                      position: 'bottom',\n                      sectionToHide: toggles.after,\n                      resizerSizePx: model.resizerSizePx,\n                      collapseSectionIcon: collapseSectionIcon\n                    }\n                  \"\n                ></ng-container>\n              </ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"!isResizer(section)\">\n          <avn-resizeable-layout-section [name]=\"section\" [style.grid-area]=\"section\">\n            <ng-container *ngTemplateOutlet=\"section | applyFunction:getTemplate:[resizeableSectionsDirectiveQL]\"></ng-container>\n          </avn-resizeable-layout-section>\n        </ng-container>\n      </ng-container>\n    </div>\n    <div [class]=\"['sidebar', sidebarPosition]\" *ngIf=\"model.hasCollapsedSections\">\n      <ng-container *ngFor=\"let collapsedSection of model.collapsedSections; trackBy: trackBySection\">\n        <div class=\"sidebar-section\" (click)=\"showSection(collapsedSection)\">{{ collapsedSection | applyFunction: getCollapsedSectionLabel:[resizeableSectionsDirectiveQL] }}</div>\n      </ng-container>\n    </div>\n  </ng-container>\n</div>\n\n<ng-template #hoveredToggleSectionIcon let-position=\"position\" let-sectionToHide=\"sectionToHide\" let-collapseSectionIcon=\"collapseSectionIcon\">\n  <div\n    [class]=\"'hovered icon ' + position\"\n    [style.left.px]=\"collapseSectionIcon.x\"\n    [style.top.px]=\"collapseSectionIcon.y\"\n    (click)=\"hideSection(sectionToHide)\"\n    (mouseenter)=\"onCollapseSectionIconMouseEnter()\"\n    (mouseleave)=\"onCollapseSectionIconMouseLeave()\"\n  >\n    <avn-icon [icon]=\"'navigation:double_arrow'\"></avn-icon>\n  </div>\n</ng-template>\n\n<ng-template #stickyToggleSectionIcon let-position=\"position\" let-sectionToHide=\"sectionToHide\">\n  <div\n    [class]=\"'sticky icon ' + position\"\n    (click)=\"hideSection(sectionToHide)\">\n      <avn-icon [icon]=\"'navigation:double_arrow'\" [fontSize]=\"18\"></avn-icon>\n  </div>\n</ng-template>\n", styles: [":host{display:block;height:100%;width:100%}:host .wrapper{display:grid;height:100%;width:100%;grid-template-columns:1fr}:host .wrapper.has-sidebar.right{grid-template-columns:1fr min-content}:host .wrapper.has-sidebar.bottom{grid-template-rows:1fr min-content}:host .wrapper.has-sidebar.left{grid-template-columns:min-content 1fr}:host .wrapper.has-sidebar.left>.grid{order:2}:host .wrapper.has-sidebar.left>.sidebar{order:1}:host .wrapper.has-sidebar.top{grid-template-rows:min-content 1fr}:host .wrapper.has-sidebar.top>.grid{order:2}:host .wrapper.has-sidebar.top>.sidebar{order:1}:host .wrapper .grid{display:grid;height:100%;width:100%;overflow:hidden}:host .wrapper .grid>div.resizer{-webkit-user-select:none;user-select:none;box-sizing:content-box;background-color:var(--master-detail-resizer);position:relative;z-index:1}:host .wrapper .grid avn-resizeable-layout-section{position:relative}:host .wrapper .grid avn-resizeable-layout-section .toggled-container{position:absolute;inset:0;background-color:var(--master-detail-resizer);z-index:1}:host .wrapper .sidebar{-webkit-user-select:none;user-select:none;background-color:var(--main-background);display:grid;grid-gap:var(--space-md);padding:var(--space-xs)}:host .wrapper .sidebar .sidebar-section{background-color:var(--surface-background);border-radius:3px;cursor:pointer}:host .wrapper .sidebar .sidebar-section:hover{background-color:var(--primary-base);color:var(--primary-on)}:host .wrapper .sidebar.left,:host .wrapper .sidebar.right{grid-auto-flow:row;grid-auto-rows:max-content;justify-content:center;align-items:start}:host .wrapper .sidebar.left .sidebar-section,:host .wrapper .sidebar.right .sidebar-section{padding:var(--space-md) var(--space-xs);text-orientation:mixed;writing-mode:vertical-rl}:host .wrapper .sidebar.top,:host .wrapper .sidebar.bottom{grid-auto-flow:column;grid-auto-columns:max-content;justify-content:start;align-items:center}:host .wrapper .sidebar.top .sidebar-section,:host .wrapper .sidebar.bottom .sidebar-section{padding:var(--space-xs) var(--space-md)}:host .wrapper .icon{cursor:pointer;background-color:var(--master-detail-resizer);position:fixed;--resizer-size: 6px}:host .wrapper .icon.hovered{--section-icon-opacity: .7;top:0;z-index:2;-webkit-user-select:none;user-select:none;animation:pulse-in .3s cubic-bezier(0,0,.2,1)}:host .wrapper .icon.hovered.right{padding:var(--space-md) var(--space-sm);transform:translate(1px,-50%)}:host .wrapper .icon.hovered.left{padding:var(--space-md) var(--space-sm);transform:translate(calc(-100% - var(--resizer-size) - 1px),-50%)}:host .wrapper .icon.hovered.top{padding:var(--space-sm) var(--space-md);transform:translate(-50%,calc(-100% - var(--resizer-size) - 1px))}:host .wrapper .icon.hovered.bottom{padding:var(--space-sm) var(--space-md);transform:translate(-50%,1px)}:host .wrapper .icon.hovered>avn-icon{opacity:var(--section-icon-opacity)}:host .wrapper .icon.hovered>avn-icon:hover{opacity:1}:host .wrapper .icon.sticky{--section-icon-opacity: .5;padding:var(--space-sm)}:host .wrapper .icon.sticky.left{transform:translate(calc(-100% - var(--resizer-size) + 10px))}:host .wrapper .icon.sticky.top{transform:translate(-50%,calc(-100% - var(--resizer-size) - 1px))}:host .wrapper .icon.sticky>avn-icon{opacity:var(--section-icon-opacity)}:host .wrapper .icon.sticky>avn-icon:hover{opacity:1}:host .wrapper .icon.left>avn-icon{transform:rotate(-180deg)}:host .wrapper .icon.top>avn-icon{transform:rotate(-90deg)}:host .wrapper .icon.bottom>avn-icon{transform:rotate(90deg)}@keyframes pulse-in{0%{opacity:0}to{opacity:var(--section-icon-opacity)}}\n"] }]
        }], ctorParameters: function () { return [{ type: ResizeableLayoutStore }]; }, propDecorators: { resizeableSectionsComponentQL: [{
                type: ViewChildren,
                args: [ResizeableLayoutSectionComponent]
            }], resizeableSectionsDirectiveQL: [{
                type: ContentChildren,
                args: [ResizeableLayoutSectionDirective]
            }], layout: [{
                type: Input
            }], resizerSizePx: [{
                type: Input
            }], sidebarPosition: [{
                type: Input
            }], collapseIconTrigger: [{
                type: Input
            }], sectionToggled: [{
                type: Output
            }] } });

class ResizeableLayoutModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutModule, declarations: [ResizeableLayoutComponent, ResizeableLayoutSectionComponent, ResizeableLayoutSectionDirective], imports: [CommonModule, CoreModule, IconModule], exports: [ResizeableLayoutComponent, ResizeableLayoutSectionDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutModule, imports: [CommonModule, CoreModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: ResizeableLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule, IconModule],
                    declarations: [ResizeableLayoutComponent, ResizeableLayoutSectionComponent, ResizeableLayoutSectionDirective],
                    exports: [ResizeableLayoutComponent, ResizeableLayoutSectionDirective],
                }]
        }] });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Time and timing curve for expansion panel animations. */
const EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';
/**
 * Animations used by the expansion panel.
 *
 * A bug in angular animation's `state` when ViewContainers are moved using ViewContainerRef.move()
 * causes the animation state of moved components to become `void` upon exit, and not update again
 * upon reentry into the DOM.  This can lead a to situation for the expansion panel where the state
 * of the panel is `expanded` or `collapsed` but the animation state is `void`.
 *
 * To correctly handle animating to the next state, we animate between `void` and `collapsed` which
 * are defined to have the same styles. Since angular animates from the current styles to the
 * destination state's style definition, in situations where we are moving from `void`'s styles to
 * `collapsed` this acts a noop since no style values change.
 *
 * In the case where angular's animation state is out of sync with the expansion panel's state, the
 * expansion panel being `expanded` and angular animations being `void`, the animation from the
 * `expanded`'s effective styles (though in a `void` animation state) to the collapsed state will
 * occur as expected.
 *
 * Angular Bug: https://github.com/angular/angular/issues/18847
 *
 * @docs-private
 */
const accordionExpansionAnimations = {
    /** Animation that rotates the indicator arrow. */
    indicatorRotate: trigger('indicatorRotate', [
        state('collapsed, void', style({ transform: 'rotate(0deg)' })),
        state('expanded', style({ transform: 'rotate(180deg)' })),
        transition('expanded <=> collapsed, void => collapsed', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
    ]),
    /** Animation that expands and collapses the panel content. */
    bodyExpansion: trigger('bodyExpansion', [
        state('collapsed, void', style({ height: '0px', visibility: 'hidden' })),
        state('expanded', style({ height: '*', visibility: 'visible' })),
        transition('expanded <=> collapsed, void => collapsed', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
    ]),
};

class AccordionPanelComponent extends CdkAccordionItem {
    constructor() {
        super(...arguments);
        /** Position of the toggle icon within the header. Set to 'none' to disable it **/
        this.toggleIconPosition = 'right';
        /** Emits when the panel is toggled **/
        this.toggled = new EventEmitter();
        /** Unique identifier for the accordion item **/
        this.id = v4();
    }
    /** Sets the expanded state of the panel **/
    set expand(value) {
        if (value) {
            this.open();
        }
        else {
            this.close();
        }
    }
    /** Animation state based on the expanded state **/
    getExpandedState() {
        return this.expanded ? 'expanded' : 'collapsed';
    }
    /** Called when the panel is toggled **/
    togglePanel() {
        if (!this.disableExpansion) {
            this.toggle();
            this.toggled.emit({ id: this.id, opened: this.expanded });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AccordionPanelComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: AccordionPanelComponent, selector: "avn-accordion-panel", inputs: { headerTitle: "headerTitle", headerTemplate: "headerTemplate", headerTemplateContext: "headerTemplateContext", toggleIconPosition: "toggleIconPosition", disableExpansion: "disableExpansion", expand: "expand" }, outputs: { toggled: "toggled" }, usesInheritance: true, ngImport: i0, template: "<header (click)=\"togglePanel()\" [class]=\"[toggleIconPosition]\" [class.expansion-enabled]=\"!disableExpansion\" [class.has-template]=\"!!headerTemplate\">\n  <ng-container *ngIf=\"toggleIconPosition === 'left'\">\n    <ng-container *ngTemplateOutlet=\"expandButton\"></ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"!headerTemplate; else header\">\n    <h5 class=\"title\">{{ headerTitle }}</h5>\n  </ng-container>\n  <ng-container *ngIf=\"toggleIconPosition === 'right'\">\n    <ng-container *ngTemplateOutlet=\"expandButton\"></ng-container>\n  </ng-container>\n</header>\n\n<div class=\"widgetBody\" [class.expanded]=\"expandedChange | async\" [@bodyExpansion]=\"getExpandedState()\">\n  <ng-content></ng-content>\n</div>\n\n<ng-template #header>\n  <ng-container *ngTemplateOutlet=\"headerTemplate; context: headerTemplateContext\"></ng-container>\n</ng-template>\n\n<ng-template #expandButton>\n  <avn-icon class=\"expandButton\" [disabled]=\"disableExpansion\" [@indicatorRotate]=\"getExpandedState()\" icon=\"hardware:keyboard_arrow_down\"></avn-icon>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column}:host header{display:grid;align-items:center;grid-gap:var(--space-md);background-color:var(--accordion-header-background, unset);-webkit-user-select:none;user-select:none;padding:var(--accordion-header-padding, 0)}:host header.expansion-enabled{cursor:pointer}:host header.left{grid-template-columns:max-content 1fr}:host header.right{grid-template-columns:1fr max-content;justify-content:space-between}:host header .title{margin:0}:host header:not(.has-template){padding:var(--accordion-header-padding, var(--space-md))}:host .widgetBody{overflow:hidden;background-color:var(--accordion-body-background, unset);flex-grow:1}:host .widgetBody.expanded{margin:0}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], animations: [accordionExpansionAnimations.bodyExpansion, accordionExpansionAnimations.indicatorRotate], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AccordionPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-accordion-panel', animations: [accordionExpansionAnimations.bodyExpansion, accordionExpansionAnimations.indicatorRotate], changeDetection: ChangeDetectionStrategy.OnPush, template: "<header (click)=\"togglePanel()\" [class]=\"[toggleIconPosition]\" [class.expansion-enabled]=\"!disableExpansion\" [class.has-template]=\"!!headerTemplate\">\n  <ng-container *ngIf=\"toggleIconPosition === 'left'\">\n    <ng-container *ngTemplateOutlet=\"expandButton\"></ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"!headerTemplate; else header\">\n    <h5 class=\"title\">{{ headerTitle }}</h5>\n  </ng-container>\n  <ng-container *ngIf=\"toggleIconPosition === 'right'\">\n    <ng-container *ngTemplateOutlet=\"expandButton\"></ng-container>\n  </ng-container>\n</header>\n\n<div class=\"widgetBody\" [class.expanded]=\"expandedChange | async\" [@bodyExpansion]=\"getExpandedState()\">\n  <ng-content></ng-content>\n</div>\n\n<ng-template #header>\n  <ng-container *ngTemplateOutlet=\"headerTemplate; context: headerTemplateContext\"></ng-container>\n</ng-template>\n\n<ng-template #expandButton>\n  <avn-icon class=\"expandButton\" [disabled]=\"disableExpansion\" [@indicatorRotate]=\"getExpandedState()\" icon=\"hardware:keyboard_arrow_down\"></avn-icon>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column}:host header{display:grid;align-items:center;grid-gap:var(--space-md);background-color:var(--accordion-header-background, unset);-webkit-user-select:none;user-select:none;padding:var(--accordion-header-padding, 0)}:host header.expansion-enabled{cursor:pointer}:host header.left{grid-template-columns:max-content 1fr}:host header.right{grid-template-columns:1fr max-content;justify-content:space-between}:host header .title{margin:0}:host header:not(.has-template){padding:var(--accordion-header-padding, var(--space-md))}:host .widgetBody{overflow:hidden;background-color:var(--accordion-body-background, unset);flex-grow:1}:host .widgetBody.expanded{margin:0}\n"] }]
        }], propDecorators: { headerTitle: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }], headerTemplateContext: [{
                type: Input
            }], toggleIconPosition: [{
                type: Input
            }], disableExpansion: [{
                type: Input
            }], expand: [{
                type: Input
            }], toggled: [{
                type: Output
            }] } });

/***
 * Basic wrapper around CdkAccordionItem. Uses basic animations from material/expansion.
 * Supports custom header template with context
 * Supports multiple exclusive panel
 */
class AccordionComponent {
    constructor(_renderer) {
        this._renderer = _renderer;
        /** Indicates if several accordion items can be opened at the same time **/
        this.multiExpansionEnabled = false;
        this._gridTemplateRowsSubject = new BehaviorSubject(null);
        /** @ignore pattern for destroy all subscriptions **/
        this._componentDestroyed$ = new Subject();
        this.gridTemplateRows$ = this._gridTemplateRowsSubject.asObservable();
    }
    ngAfterContentInit() {
        this.accordionPanelQL.changes
            .pipe(startWith(this.accordionPanelQL), switchMap((accordionPanelQL) => merge(...accordionPanelQL.toArray().map((panel) => panel.toggled))), takeUntil(this._componentDestroyed$))
            .subscribe(({ id, opened }) => {
            if (!this.multiExpansionEnabled) {
                if (opened) {
                    // when an accordion item is opened, automatically close all other items
                    this.accordionPanelQL
                        .toArray()
                        .filter((panel) => panel.id !== id)
                        .forEach((panel) => panel.close());
                }
            }
            // everytime a panel is toggled, recalculate the layout
            if (this.fullHeightPanelRatios) {
                this._recalculateLayout();
            }
        });
        if (this.fullHeightPanelRatios) {
            this._recalculateLayout();
        }
    }
    _recalculateLayout() {
        const getGridTemplateRows = () => {
            const allOpened = this.accordionPanelQL.toArray().every((panel) => panel.expanded);
            if (allOpened) {
                return this.fullHeightPanelRatios.map((ratio) => `${ratio}fr`).join(' ');
            }
            return this.accordionPanelQL
                .toArray()
                .map((accordionPanel, i) => {
                return accordionPanel.expanded ? `${this.fullHeightPanelRatios[i] || 1}fr` : 'max-content';
            })
                .join(' ');
        };
        this._gridTemplateRowsSubject.next(getGridTemplateRows());
    }
    /** @ignore */
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AccordionComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: AccordionComponent, selector: "avn-accordion", inputs: { multiExpansionEnabled: "multiExpansionEnabled", fullHeightPanelRatios: "fullHeightPanelRatios" }, host: { properties: { "class.auto-height": "this.fullHeightPanelRatios" } }, queries: [{ propertyName: "accordionPanelQL", predicate: AccordionPanelComponent }], ngImport: i0, template: "<div class=\"wrapper\" [style.grid-template-rows]=\"gridTemplateRows$ | async\">\n  <ng-content select=\"avn-accordion-panel\"></ng-content>\n</div>\n", styles: [":host{display:contents}:host .wrapper{display:contents}:host.auto-height{display:block;height:100%;width:100%}:host.auto-height .wrapper{display:grid;height:100%;width:100%}:host.auto-height ::ng-deep avn-accordion-panel{background-color:var(--accordion-body-background, unset)}\n"], dependencies: [{ kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-accordion', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"wrapper\" [style.grid-template-rows]=\"gridTemplateRows$ | async\">\n  <ng-content select=\"avn-accordion-panel\"></ng-content>\n</div>\n", styles: [":host{display:contents}:host .wrapper{display:contents}:host.auto-height{display:block;height:100%;width:100%}:host.auto-height .wrapper{display:grid;height:100%;width:100%}:host.auto-height ::ng-deep avn-accordion-panel{background-color:var(--accordion-body-background, unset)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { accordionPanelQL: [{
                type: ContentChildren,
                args: [AccordionPanelComponent]
            }], multiExpansionEnabled: [{
                type: Input
            }], fullHeightPanelRatios: [{
                type: HostBinding,
                args: ['class.auto-height']
            }, {
                type: Input
            }] } });

class AccordionModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: AccordionModule, declarations: [AccordionComponent, AccordionPanelComponent], imports: [CommonModule, IconModule, CdkAccordionModule], exports: [AccordionComponent, AccordionPanelComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AccordionModule, imports: [CommonModule, IconModule, CdkAccordionModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: AccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IconModule, CdkAccordionModule],
                    declarations: [AccordionComponent, AccordionPanelComponent],
                    exports: [AccordionComponent, AccordionPanelComponent],
                }]
        }] });

/**
 * **IMPORTANT**: This component requires to have avnTheme to set color.
 *
 * Simple use case:
 * <avn-grid-size-selector
 *   [avnTheme]="'primary'"
 *   [minGridSize]="{ row: 2, column: 3 }"
 *   [maxGridSize]="{ row: 6, column: 12 }"
 *   [selectedGridSize]="{ row: 3, column: 3 }"
 *   [minSelectedGridSize]="{ row: 3, column: 3 }"
 *   (gridItemClicked)="setSelectedGridSize($event)">
 * </avn-grid-size-selector>
 *
 * The above code will show a grid size selector with
 * - min grid size is 3 (columns) x 2 (rows), the grid will not shrink to smaller size than this
 * - max grid size is 12 (columns) x 6 (rows), the grid will not expand to bigger size than this
 * - selected grid size is 3 (columns) x 3 (rows)
 * - min selection requirement is 3 (columns) x 3 (rows), if user moves mouse to a grid item
 *   smaller than this and click on it, e.g. the grid item at 2 x 2, the 3 x 3 would still be
 *   emitted (hence force user to select this minimum size). But if user clicks on a grid item
 *   which only one side is smaller than the min requirement, e.g. if user clicks on the grid item
 *   at 2 x 4, 3 x 4 will be emitted by gridItemClicked.
 */
class GridSizeSelectorComponent {
    constructor() {
        /** Default values for view, min, max and selected sizes */
        this.VIEW_SIZE = { row: 5, column: 5 };
        this.MIN_SIZE = { row: 3, column: 3 };
        this.MAX_SIZE = { row: 30, column: 50 };
        this.SELECTED_SIZE = { row: 0, column: 0 };
        /**
         * The default grid size when grid size selector is shown. Default to 5 x 5.
         * If any value is set to less than 1, default value would be used.
         * The final view size will be determined by the selected size as well. If the selected size is
         * greater than the view size, the selected size would be used.
         * E.g. If view size is 6 (columns) x 4 (rows), and the selected size is 8 (columns) x 2 (rows),
         * the view size would be 8 (columns) x 4 (rows).
         */
        this._viewSize = this.VIEW_SIZE;
        /**
         * The minimum grid display size. Default to 1 x 1.
         * If any value is set to less than 1, default value would be used.
         */
        this._minGridSize = this.MIN_SIZE;
        /**
         * The maximum grid display size. Default to 50 (columns) x 30 (rows).
         * If any value is not set or set to less than 1, default value would be used.
         */
        this._maxGridSize = this.MAX_SIZE;
        /** Selected grid size */
        this._selectedGridSize = this.SELECTED_SIZE;
        /**
         * Minimum selected grid size required.
         * If user moves to an item that is smaller than this size, this value would be used.
         * e.g. If user moves to 3 col x 4 rows and min selected size is 4 col x 3 rows,
         * 4 col (from min selected size) x 4 rows (selected by user) would be emitted.
         */
        this._minSelectedGridSize = this.SELECTED_SIZE;
        /** Emit when the selected grid size changes. Emit as user moves mouse over a grid item. */
        this.gridSizeChanged = new EventEmitter();
        /**
         * Emit the current selected grid size when a grid item is clicked.
         * Emit column/row size from minSelectedGridSize if minSelectedGridSize is set and the selection does not
         * meet the minimum requirement.
         * Since the selected grid size changes as user moves mouse over a grid item, it might be hard to tell which
         * size user wants. If this component is opened in an overlay, this event emitter can be used to detect
         * the final selection and closes the overlay when this emitter emits a value.
         */
        this.gridItemClicked = new EventEmitter();
        /** Currently selected grid size */
        this.currSelectedGridSize = this.SELECTED_SIZE;
        /** Current grid display size */
        this.currGridSizeSub = new BehaviorSubject(this.viewSize);
        this.rows$ = this.currGridSizeSub.pipe(map(size => Array.from(Array(size.row).keys())));
        this.columns$ = this.currGridSizeSub.pipe(map(size => Array.from(Array(size.column).keys())));
        this.ThemeType = ThemeType;
        this.ThemeShades = ThemeShade;
    }
    get viewSize() {
        return this._viewSize;
    }
    set viewSize(value) {
        this._viewSize = this._getDefault(value, this.VIEW_SIZE);
    }
    get minGridSize() {
        return this._minGridSize;
    }
    set minGridSize(value) {
        this._minGridSize = this._getDefault(value, this.MIN_SIZE);
    }
    get maxGridSize() {
        return this._maxGridSize;
    }
    set maxGridSize(value) {
        this._maxGridSize = this._getDefault(value, this.MAX_SIZE);
    }
    get selectedGridSize() {
        return this._selectedGridSize;
    }
    set selectedGridSize(value) {
        this._selectedGridSize = this._getDefault(value, this.SELECTED_SIZE);
    }
    get minSelectedGridSize() {
        return this._minSelectedGridSize;
    }
    set minSelectedGridSize(value) {
        this._minSelectedGridSize = this._getDefault(value, this.SELECTED_SIZE);
    }
    ngOnInit() {
        this._selectedSizeChanged();
    }
    ngOnChanges({ selectedGridSize }) {
        if (selectedGridSize?.currentValue) {
            this.currSelectedGridSize = selectedGridSize.currentValue;
            if (!selectedGridSize.firstChange) {
                this._selectedSizeChanged();
            }
        }
    }
    onMouseEnter(row, column) {
        const size = {
            row: row < this.minSelectedGridSize.row ? this.minSelectedGridSize.row : row,
            column: column < this.minSelectedGridSize.column ? this.minSelectedGridSize.column : column,
        };
        this.currSelectedGridSize = size;
        this.gridSizeChanged.emit(this.currSelectedGridSize);
        this.currGridSizeSub.next({ row: this._getCurrCount(row, 'row'), column: this._getCurrCount(column, 'column') });
    }
    onClick() {
        if (this.currSelectedGridSize.row >= this.minSelectedGridSize.row && this.currSelectedGridSize.column >= this.minSelectedGridSize.column) {
            this.gridItemClicked.emit(this.currSelectedGridSize);
        }
    }
    /** Use the default value if the new value is not properly set */
    _getDefault(value, defaultSize) {
        return {
            row: value?.row && value.row > 0 ? value.row : defaultSize.row,
            column: value?.column && value.column > 0 ? value.column : defaultSize.column,
        };
    }
    /** Get the new display row/column size */
    _getCurrCount(size, field) {
        let newSize = size;
        if (size >= this.currGridSizeSub.value[field]) { // Check max limit, row goes beyond the current row
            newSize = size >= this.maxGridSize[field] ? this.maxGridSize[field] : size + 1;
        }
        else if (size <= this.currGridSizeSub.value[field] - 1) { // Check min limit, row goes below the current row
            newSize = size < this.minGridSize[field] - 1 ? this.minGridSize[field] : size + 1;
        }
        return newSize;
    }
    _selectedSizeChanged() {
        const displaySize = { ...this.viewSize };
        if (this.selectedGridSize) {
            displaySize.row = this.selectedGridSize.row >= this.maxGridSize.row ? this.selectedGridSize.row :
                (this.selectedGridSize.row < this.minGridSize.row ? this.minGridSize.row : this.selectedGridSize.row + 1);
            displaySize.column = this.selectedGridSize.column >= this.maxGridSize.column ? this.selectedGridSize.column :
                (this.selectedGridSize.column < this.minGridSize.column ? this.minGridSize.column : this.selectedGridSize.column + 1);
        }
        this.currGridSizeSub.next(displaySize);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridSizeSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: GridSizeSelectorComponent, selector: "avn-grid-size-selector", inputs: { viewSize: "viewSize", minGridSize: "minGridSize", maxGridSize: "maxGridSize", _selectedGridSize: "_selectedGridSize", selectedGridSize: "selectedGridSize", minSelectedGridSize: "minSelectedGridSize" }, outputs: { gridSizeChanged: "gridSizeChanged", gridItemClicked: "gridItemClicked" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"grid-row\" *ngFor=\"let rowIdx of rows$ | async\">\n  <div class=\"grid-column\" *ngFor=\"let columnIdx of columns$ | async\" (mouseenter)=\"onMouseEnter(rowIdx + 1, columnIdx + 1)\" (click)=\"onClick()\">\n    <div class=\"grid-item\" [class.selected]=\"rowIdx < currSelectedGridSize.row && columnIdx < currSelectedGridSize.column\"></div>\n  </div>\n</div>\n<div class=\"grid-label\">\n  <span>{{ currSelectedGridSize.column }} x {{ currSelectedGridSize.row }}</span>\n</div>\n", styles: [":host{width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;padding:var(--space-sm);display:flex;flex-direction:column;background-color:inherit;color:inherit}:host.theme-primary>div.grid-row>div.grid-column>div.grid-item{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>div.grid-row>div.grid-column>div.grid-item{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>div.grid-row>div.grid-column>div.grid-item{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>div.grid-row>div.grid-column>div.grid-item{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>div.grid-row>div.grid-column>div.grid-item{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>div.grid-row>div.grid-column>div.grid-item{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>div.grid-row>div.grid-column>div.grid-item{background-color:var(--success-base);color:var(--success-on)}:host .grid-row{display:flex;flex-direction:row}:host .grid-row:not(:last-child){margin-bottom:var(--space-xs)}:host .grid-row .grid-column:not(:last-child){margin-right:var(--space-xs)}:host .grid-row .grid-column .grid-item{width:var(--space-md);height:var(--space-md);padding:var(--space-sm);opacity:.5}:host .grid-row .grid-column .grid-item.selected{opacity:1}:host .grid-label{align-self:center}:host .grid-label>span{color:var(--main-on)}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridSizeSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-grid-size-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"grid-row\" *ngFor=\"let rowIdx of rows$ | async\">\n  <div class=\"grid-column\" *ngFor=\"let columnIdx of columns$ | async\" (mouseenter)=\"onMouseEnter(rowIdx + 1, columnIdx + 1)\" (click)=\"onClick()\">\n    <div class=\"grid-item\" [class.selected]=\"rowIdx < currSelectedGridSize.row && columnIdx < currSelectedGridSize.column\"></div>\n  </div>\n</div>\n<div class=\"grid-label\">\n  <span>{{ currSelectedGridSize.column }} x {{ currSelectedGridSize.row }}</span>\n</div>\n", styles: [":host{width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;padding:var(--space-sm);display:flex;flex-direction:column;background-color:inherit;color:inherit}:host.theme-primary>div.grid-row>div.grid-column>div.grid-item{background-color:var(--primary-base);color:var(--primary-on)}:host.theme-secondary>div.grid-row>div.grid-column>div.grid-item{background-color:var(--secondary-base);color:var(--secondary-on)}:host.theme-highlight>div.grid-row>div.grid-column>div.grid-item{background-color:var(--highlight-base);color:var(--highlight-on)}:host.theme-danger>div.grid-row>div.grid-column>div.grid-item{background-color:var(--danger-base);color:var(--danger-on)}:host.theme-warning>div.grid-row>div.grid-column>div.grid-item{background-color:var(--warning-base);color:var(--warning-on)}:host.theme-info>div.grid-row>div.grid-column>div.grid-item{background-color:var(--info-base);color:var(--info-on)}:host.theme-success>div.grid-row>div.grid-column>div.grid-item{background-color:var(--success-base);color:var(--success-on)}:host .grid-row{display:flex;flex-direction:row}:host .grid-row:not(:last-child){margin-bottom:var(--space-xs)}:host .grid-row .grid-column:not(:last-child){margin-right:var(--space-xs)}:host .grid-row .grid-column .grid-item{width:var(--space-md);height:var(--space-md);padding:var(--space-sm);opacity:.5}:host .grid-row .grid-column .grid-item.selected{opacity:1}:host .grid-label{align-self:center}:host .grid-label>span{color:var(--main-on)}\n"] }]
        }], propDecorators: { viewSize: [{
                type: Input
            }], minGridSize: [{
                type: Input
            }], maxGridSize: [{
                type: Input
            }], _selectedGridSize: [{
                type: Input
            }], selectedGridSize: [{
                type: Input
            }], minSelectedGridSize: [{
                type: Input
            }], gridSizeChanged: [{
                type: Output
            }], gridItemClicked: [{
                type: Output
            }] } });

class GridSizeSelectorModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridSizeSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.4", ngImport: i0, type: GridSizeSelectorModule, declarations: [GridSizeSelectorComponent], imports: [CommonModule,
            CoreModule], exports: [GridSizeSelectorComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridSizeSelectorModule, imports: [CommonModule,
            CoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: GridSizeSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GridSizeSelectorComponent
                    ],
                    imports: [
                        CommonModule,
                        CoreModule,
                    ],
                    exports: [
                        GridSizeSelectorComponent
                    ]
                }]
        }] });

class SectionBreadcrumbComponent {
    constructor() {
        /** Css style attribute for breadcrumb (Default: 40px) */
        this.height = '40px';
        /** Event when click on a section of the breadcrumb */
        this.clicked = new EventEmitter();
    }
    onClick(section) {
        this.clicked.emit(section);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SectionBreadcrumbComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: SectionBreadcrumbComponent, isStandalone: true, selector: "avn-section-breadcrumb", inputs: { sections: "sections", height: "height" }, outputs: { clicked: "clicked" }, ngImport: i0, template: "<div class=\"section-title\" *ngIf=\"sections?.length\">\n  <div\n    class=\"breadcrumb\"\n    [style.height]=\"height\"\n    (click)=\"onClick(section)\"\n    *ngFor=\"let section of sections; let idx = index\"\n    [avnBackground]=\"{ cssProp: '--ribbon-breadcrumb-background', shade: 100 + ((idx * 200) % 900) }\"\n  >\n    <div class=\"content\">\n      <div class=\"section-breadcrumb-title\">{{ section.title }}</div>\n      <div class=\"section-breadcrumb-value\">{{ section.value }}</div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}:host .section-title{display:flex;align-items:center}:host .section-title .breadcrumb{display:flex;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none}:host .section-title .breadcrumb .content{display:flex;flex-direction:column;width:100%;min-width:80px;height:100%;padding:0 var(--space-md);background-color:inherit;color:var(--ribbon-breadcrumb-on);position:relative}:host .section-title .breadcrumb .content .section-breadcrumb-title{font-size:10px;opacity:.5;margin-top:var(--space-xs)}:host .section-title .breadcrumb .content .section-breadcrumb-value{margin:auto 0}:host .section-title .breadcrumb .content:after{content:\"\";display:block;position:absolute;bottom:0;top:0;left:100%;clip-path:polygon(50% 50%,-50% -50%,0 100%);width:1em;z-index:1;background-color:inherit}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: CoreModule }, { kind: "directive", type: BackgroundDirective, selector: "[avnBackground]", inputs: ["avnBackground"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: SectionBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'avn-section-breadcrumb', imports: [CommonModule, CoreModule], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"section-title\" *ngIf=\"sections?.length\">\n  <div\n    class=\"breadcrumb\"\n    [style.height]=\"height\"\n    (click)=\"onClick(section)\"\n    *ngFor=\"let section of sections; let idx = index\"\n    [avnBackground]=\"{ cssProp: '--ribbon-breadcrumb-background', shade: 100 + ((idx * 200) % 900) }\"\n  >\n    <div class=\"content\">\n      <div class=\"section-breadcrumb-title\">{{ section.title }}</div>\n      <div class=\"section-breadcrumb-value\">{{ section.value }}</div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}:host .section-title{display:flex;align-items:center}:host .section-title .breadcrumb{display:flex;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none}:host .section-title .breadcrumb .content{display:flex;flex-direction:column;width:100%;min-width:80px;height:100%;padding:0 var(--space-md);background-color:inherit;color:var(--ribbon-breadcrumb-on);position:relative}:host .section-title .breadcrumb .content .section-breadcrumb-title{font-size:10px;opacity:.5;margin-top:var(--space-xs)}:host .section-title .breadcrumb .content .section-breadcrumb-value{margin:auto 0}:host .section-title .breadcrumb .content:after{content:\"\";display:block;position:absolute;bottom:0;top:0;left:100%;clip-path:polygon(50% 50%,-50% -50%,0 100%);width:1em;z-index:1;background-color:inherit}\n"] }]
        }], propDecorators: { sections: [{
                type: Input
            }], height: [{
                type: Input
            }], clicked: [{
                type: Output
            }] } });

var AnchorNames;
(function (AnchorNames) {
    AnchorNames["top"] = "top";
    AnchorNames["left"] = "left";
    AnchorNames["right"] = "right";
    AnchorNames["bottom"] = "bottom";
    AnchorNames["topright"] = "topright";
    AnchorNames["topleft"] = "topleft";
    AnchorNames["bottomright"] = "bottomright";
    AnchorNames["bottomleft"] = "bottomleft";
})(AnchorNames || (AnchorNames = {}));
var AnchorLocks;
(function (AnchorLocks) {
    AnchorLocks["top"] = "y";
    AnchorLocks["left"] = "x";
    AnchorLocks["right"] = "x";
    AnchorLocks["bottom"] = "y";
    AnchorLocks["topright"] = "";
    AnchorLocks["topleft"] = "";
    AnchorLocks["bottomright"] = "";
    AnchorLocks["bottomleft"] = "";
})(AnchorLocks || (AnchorLocks = {}));
var AlignmentFixtures;
(function (AlignmentFixtures) {
    AlignmentFixtures["top"] = "top";
    AlignmentFixtures["left"] = "left";
    AlignmentFixtures["right"] = "right";
    AlignmentFixtures["bottom"] = "bottom";
    AlignmentFixtures["vertmid"] = "vertmid";
    AlignmentFixtures["horizmid"] = "horizmid";
})(AlignmentFixtures || (AlignmentFixtures = {}));
var FitFixtures;
(function (FitFixtures) {
    FitFixtures["width"] = "width";
    FitFixtures["height"] = "height";
    FitFixtures["all"] = "all";
})(FitFixtures || (FitFixtures = {}));

/**
 * Toolbar for <transformable-element-stage>. Binds it's state to the state
 * of the current edited or locked elements. Sends events on click to
 * the registered stage.
 */
class TransformableElementToolbarComponent {
    constructor() {
        this.elementNameText = 'element';
        /**
         * Undo event emitted on click of undo button
         */
        this.undone = new Subject();
        /**
         * Redo event emitted on click of redo button
         */
        this.redone = new Subject();
        /**
         * Restore event emitted on click of cancel button
         */
        this.restored = new Subject();
        /**
         * Editing element, true enables Cancel/Done and Add Region buttons
         */
        this.editing$ = new BehaviorSubject(false);
        /**
         * Editing element enabled, true enables alignment and fit operations
         */
        this.editingElement$ = new Observable();
        this._componentDestroyed$ = new Subject();
    }
    /**
     * Term used for elements (ie Elements, or Regions), used in tooltips
     *
     * Defaults to 'element'
     */
    set elementName(value) {
        this.elementNameText = value;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /**
     * Binds element resize or locked events, if one is true, enable
     * element alignment and fit operation buttons
     */
    registerStage(stage) {
        this._stage = stage;
        this.editingElement$ = combineLatest([this._stage.elementResizing$, this._stage.elementLocked$]).pipe(map$1((val) => val[0] !== null || val[1] !== null));
    }
    unlock() {
        this.editing$.next(true);
        this._stage.unlock();
    }
    cancel() {
        this.editing$.next(false);
        this._stage.cancel();
        this.restored.next();
    }
    lock() {
        this.editing$.next(false);
        this._stage.lock();
    }
    alignLeft() {
        this._stage.align(AlignmentFixtures.left);
    }
    alignRight() {
        this._stage.align(AlignmentFixtures.right);
    }
    alignTop() {
        this._stage.align(AlignmentFixtures.top);
    }
    alignBottom() {
        this._stage.align(AlignmentFixtures.bottom);
    }
    alignHorizMid() {
        this._stage.align(AlignmentFixtures.horizmid);
    }
    alignVertMid() {
        this._stage.align(AlignmentFixtures.vertmid);
    }
    fitWidth() {
        this._stage.fit(FitFixtures.width);
    }
    fitHeight() {
        this._stage.fit(FitFixtures.height);
    }
    fitAll() {
        this._stage.fit(FitFixtures.all);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TransformableElementToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TransformableElementToolbarComponent, isStandalone: true, selector: "avn-transformable-element-toolbar", inputs: { elementName: "elementName" }, outputs: { undone: "undone", redone: "redone", restored: "restored" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: { scope: 'ngx-components' },
                multi: true,
            },
        ], ngImport: i0, template: "<div class=\"wrapper\" [ngClass]=\"{ editing: editing$ | async, 'editing-element': editingElement$ | async }\" *transloco=\"let t; scope: 'ngx-components'\">\n  <div class=\"icon-group\">\n    <avn-icon\n      class=\"undo\"\n      [disabled]=\"(editing$ | async) === false\"\n      [icon]=\"'action:undo'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.UNDO')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"undone.next()\"\n    ></avn-icon>\n    <avn-icon\n      class=\"redo\"\n      [disabled]=\"(editing$ | async) === false\"\n      [icon]=\"'action:redo'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.REDO')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"redone.next()\"\n    ></avn-icon>\n  </div>\n  <div class=\"gap\"></div>\n  <div class=\"icon-group alignment\">\n    <avn-icon\n      style=\"transform: rotate(270deg)\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_top'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_LEFT')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"alignLeft()\"\n    ></avn-icon>\n    <avn-icon\n      style=\"transform: rotate(90deg)\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_center'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_HORIZ_MID')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"alignHorizMid()\"\n    ></avn-icon>\n    <avn-icon\n      style=\"transform: rotate(270deg)\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_bottom'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_RIGHT')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"alignRight()\"\n    ></avn-icon>\n  </div>\n  <div class=\"gap\"></div>\n  <div class=\"icon-group alignment\">\n    <avn-icon\n      (click)=\"alignTop()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_top'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_TOP')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"alignVertMid()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_center'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_VERT_MID')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"alignBottom()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_bottom'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_BOTTOM')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n  </div>\n  <div class=\"gap\"></div>\n  <div class=\"icon-group alignment\">\n    <avn-icon\n      (click)=\"fitWidth()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      style=\"transform: rotate(90deg)\"\n      [icon]=\"'action:expand'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.FIT_WIDTH')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"fitAll()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:aspect_ratio'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.FIT_ALL')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"fitHeight()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:expand'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.FIT_HEIGHT')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n  </div>\n  <div class=\"state-group\" *ngIf=\"(editing$ | async) === false\">\n    <avn-icon (click)=\"unlock()\" class=\"unlock\" [icon]=\"'action:lock'\" [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.UNLOCK')\" [tooltipPlacement]=\"'top'\"></avn-icon>\n  </div>\n  <div class=\"state-group\" *ngIf=\"editing$ | async\">\n    <avn-icon (click)=\"cancel()\" class=\"cancel\" [icon]=\"'action:close'\" [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.CANCEL')\" [tooltipPlacement]=\"'top'\"></avn-icon>\n    <avn-icon (click)=\"lock()\" class=\"done\" [icon]=\"'action:done'\" [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.LOCK')\" [tooltipPlacement]=\"'top'\"></avn-icon>\n  </div>\n</div>\n", styles: [":host{width:100%}:host .wrapper{display:flex;justify-content:flex-start;align-items:center;width:100%;background:var(--data-table-header-hover-background);padding:5px 3px}:host .wrapper .gap{height:21px;width:1px;border-left:1px solid rgba(255,255,255,.2)}:host .wrapper .icon-group{display:flex;justify-content:flex-start;align-items:center;padding:0 8px}:host .wrapper .icon-group:first-child{padding-left:5px;border-left:0px}:host .wrapper .icon-group avn-icon{font-size:18px!important}:host .wrapper .state-group{display:flex;justify-content:flex-start;align-items:center;padding:0 5px 0 8px;margin-left:auto}:host .wrapper button{color:var(--administrative-labels-text-stroke);margin:0;padding:0;background:none;color:none;border:none}:host .wrapper avn-icon{width:30px;height:30px;display:flex;align-items:center;justify-content:center;margin:0 1px;transition:color .15s cubic-bezier(0,0,.2,1);cursor:default}:host .wrapper avn-icon.cancel{font-size:20!important;color:var(--danger-variant)!important}:host .wrapper avn-icon.cancel:hover{color:var(--danger-base)!important}:host .wrapper avn-icon.done{font-size:20!important;color:var(--success-variant)!important}:host .wrapper avn-icon.done:hover{color:var(--success-base)!important}:host .wrapper avn-icon.unlock{font-size:18px!important}.enabled-icon,:host .wrapper avn-icon.unlock,:host .wrapper.editing .add-element,:host .wrapper.editing .undo,:host .wrapper.editing .redo,:host .wrapper.editing .done,:host .wrapper.editing .cancel,:host .wrapper.editing-element .alignment avn-icon{color:var(--main-on);cursor:pointer}.enabled-icon:hover,:host .wrapper avn-icon.unlock:hover,:host .wrapper.editing .add-element:hover,:host .wrapper.editing .undo:hover,:host .wrapper.editing .redo:hover,:host .wrapper.editing .done:hover,:host .wrapper.editing .cancel:hover,:host .wrapper.editing-element .alignment avn-icon:hover{background-color:var(--calendar-background);color:var(--primary-on)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "ngmodule", type: IconModule }, { kind: "component", type: IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }, { kind: "ngmodule", type: TooltipModule }, { kind: "directive", type: TooltipDirective, selector: "[avnTooltip]", inputs: ["avnTooltip", "tooltipName", "tooltipTemplate", "templateContext", "tooltipTheme", "tooltipPlacement", "tooltipMaxWidth", "tooltipDisabled", "tooltipTrigger", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipMouseLeaveCloseDelay", "tooltipMouseEnterOpenDelay"], outputs: ["show", "hide"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i4$1.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: ButtonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TransformableElementToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-transformable-element-toolbar', standalone: true, imports: [CommonModule, IconModule, TooltipModule, TranslocoModule, ButtonModule], changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: { scope: 'ngx-components' },
                            multi: true,
                        },
                    ], template: "<div class=\"wrapper\" [ngClass]=\"{ editing: editing$ | async, 'editing-element': editingElement$ | async }\" *transloco=\"let t; scope: 'ngx-components'\">\n  <div class=\"icon-group\">\n    <avn-icon\n      class=\"undo\"\n      [disabled]=\"(editing$ | async) === false\"\n      [icon]=\"'action:undo'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.UNDO')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"undone.next()\"\n    ></avn-icon>\n    <avn-icon\n      class=\"redo\"\n      [disabled]=\"(editing$ | async) === false\"\n      [icon]=\"'action:redo'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.REDO')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"redone.next()\"\n    ></avn-icon>\n  </div>\n  <div class=\"gap\"></div>\n  <div class=\"icon-group alignment\">\n    <avn-icon\n      style=\"transform: rotate(270deg)\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_top'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_LEFT')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"alignLeft()\"\n    ></avn-icon>\n    <avn-icon\n      style=\"transform: rotate(90deg)\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_center'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_HORIZ_MID')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"alignHorizMid()\"\n    ></avn-icon>\n    <avn-icon\n      style=\"transform: rotate(270deg)\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_bottom'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_RIGHT')\"\n      [tooltipPlacement]=\"'top'\"\n      (click)=\"alignRight()\"\n    ></avn-icon>\n  </div>\n  <div class=\"gap\"></div>\n  <div class=\"icon-group alignment\">\n    <avn-icon\n      (click)=\"alignTop()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_top'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_TOP')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"alignVertMid()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_center'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_VERT_MID')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"alignBottom()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:vertical_align_bottom'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.ALIGN_BOTTOM')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n  </div>\n  <div class=\"gap\"></div>\n  <div class=\"icon-group alignment\">\n    <avn-icon\n      (click)=\"fitWidth()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      style=\"transform: rotate(90deg)\"\n      [icon]=\"'action:expand'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.FIT_WIDTH')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"fitAll()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:aspect_ratio'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.FIT_ALL')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n    <avn-icon\n      (click)=\"fitHeight()\"\n      [disabled]=\"(editingElement$ | async) === false\"\n      [icon]=\"'action:expand'\"\n      [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.FIT_HEIGHT')\"\n      [tooltipPlacement]=\"'top'\"\n    ></avn-icon>\n  </div>\n  <div class=\"state-group\" *ngIf=\"(editing$ | async) === false\">\n    <avn-icon (click)=\"unlock()\" class=\"unlock\" [icon]=\"'action:lock'\" [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.UNLOCK')\" [tooltipPlacement]=\"'top'\"></avn-icon>\n  </div>\n  <div class=\"state-group\" *ngIf=\"editing$ | async\">\n    <avn-icon (click)=\"cancel()\" class=\"cancel\" [icon]=\"'action:close'\" [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.CANCEL')\" [tooltipPlacement]=\"'top'\"></avn-icon>\n    <avn-icon (click)=\"lock()\" class=\"done\" [icon]=\"'action:done'\" [avnTooltip]=\"t('ngxComponents.TRANSFORMABLE_ELEMENTS.LOCK')\" [tooltipPlacement]=\"'top'\"></avn-icon>\n  </div>\n</div>\n", styles: [":host{width:100%}:host .wrapper{display:flex;justify-content:flex-start;align-items:center;width:100%;background:var(--data-table-header-hover-background);padding:5px 3px}:host .wrapper .gap{height:21px;width:1px;border-left:1px solid rgba(255,255,255,.2)}:host .wrapper .icon-group{display:flex;justify-content:flex-start;align-items:center;padding:0 8px}:host .wrapper .icon-group:first-child{padding-left:5px;border-left:0px}:host .wrapper .icon-group avn-icon{font-size:18px!important}:host .wrapper .state-group{display:flex;justify-content:flex-start;align-items:center;padding:0 5px 0 8px;margin-left:auto}:host .wrapper button{color:var(--administrative-labels-text-stroke);margin:0;padding:0;background:none;color:none;border:none}:host .wrapper avn-icon{width:30px;height:30px;display:flex;align-items:center;justify-content:center;margin:0 1px;transition:color .15s cubic-bezier(0,0,.2,1);cursor:default}:host .wrapper avn-icon.cancel{font-size:20!important;color:var(--danger-variant)!important}:host .wrapper avn-icon.cancel:hover{color:var(--danger-base)!important}:host .wrapper avn-icon.done{font-size:20!important;color:var(--success-variant)!important}:host .wrapper avn-icon.done:hover{color:var(--success-base)!important}:host .wrapper avn-icon.unlock{font-size:18px!important}.enabled-icon,:host .wrapper avn-icon.unlock,:host .wrapper.editing .add-element,:host .wrapper.editing .undo,:host .wrapper.editing .redo,:host .wrapper.editing .done,:host .wrapper.editing .cancel,:host .wrapper.editing-element .alignment avn-icon{color:var(--main-on);cursor:pointer}.enabled-icon:hover,:host .wrapper avn-icon.unlock:hover,:host .wrapper.editing .add-element:hover,:host .wrapper.editing .undo:hover,:host .wrapper.editing .redo:hover,:host .wrapper.editing .done:hover,:host .wrapper.editing .cancel:hover,:host .wrapper.editing-element .alignment avn-icon:hover{background-color:var(--calendar-background);color:var(--primary-on)}\n"] }]
        }], propDecorators: { elementName: [{
                type: Input
            }], undone: [{
                type: Output
            }], redone: [{
                type: Output
            }], restored: [{
                type: Output
            }] } });

/**
 * Creates *preview* elements on stage from *actual* element sizes, enables
 * anchor point resizing and drag drop repositioning of elements, outputs
 * *actual* element size and position through (transformed) output subject.
 * Can have toolbar component bound to enable more controls through buttons.
 *
 * Required inputs:
 *  [elements] - list of <ITransformableElement[]> actual sizes
 *  [bounding] - the actual bounding size <IElementDimensions> of the screen
 *               that the elements will be viewed on
 *
 * Outputs:
 *  (transformed) - emits actual transformed element dimensions <ITransformableElement[]>
 *
 * TODO: Create undo/redo/restore functionality
 */
class TransformableElementStageComponent {
    /**
     * Required, used to generate preview transformable elements
     */
    set elements(elements) {
        this.elements$.next(elements);
    }
    /**
     * Required, used to define the actual bounding dimensions of the
     * final screen that the elements will be displayed on, this is not
     * the web preview size
     */
    set bounding(bounding) {
        this.boundingDimensions$.next(bounding);
    }
    /**
     * Optional, used to set default editing state
     */
    set editing(editing) {
        this.editing$.next(editing);
    }
    /**
     * Optional, toolbar component used to control elements on the stage,
     * toolbar will track events in stage to enable/disable buttons, as well
     * as feed events to the stage upon toolbar button click
     */
    set toolbar(toolbar) {
        toolbar.registerStage(this);
    }
    constructor(ngZone) {
        this.ngZone = ngZone;
        /**
         * Output of transformed elements actual size, not preview size
         */
        this.transformed = new Subject();
        /**
         * Element actual size subject
         */
        this.elements$ = new BehaviorSubject(null);
        /**
         * Element preview dimensions subject (to be fed to preview subj)
         */
        this.elementDimensions$ = new Observable();
        /**
         * Element preview dimensions subject to be used in DOM, this will be
         * updated by changes to the store, and also changes to live resize
         */
        this.elementsDimensionsPreview$ = new BehaviorSubject([]);
        /**
         * Used to track elements going through a live resize, eventually
         * emited to (transformed) output
         */
        this.resizedElements$ = new BehaviorSubject([]);
        /**
         * Used to define current anchor positions, updated with changes
         * to store and resize
         */
        this.anchorPositions$ = new BehaviorSubject([]);
        /**
         * Used to define which anchors should be shown, updated by element
         * hover, lock, etc
         */
        this.showAnchor$ = new Observable(null);
        /**
         * Used to set css classes and update visuals based on lock state
         */
        this.editing$ = new BehaviorSubject(false);
        /**
         * Used to track changes to the actual bounding dimensions setter
         */
        this.boundingDimensions$ = new BehaviorSubject(null);
        this.elementResizing$ = new BehaviorSubject(null);
        this.elementDragging$ = new BehaviorSubject(false);
        this.elementHovering$ = new BehaviorSubject(null);
        this.elementLocked$ = new BehaviorSubject(null);
        this.anchorNames = Object.values(AnchorNames);
        this.anchorLocks = AnchorLocks;
        this._resize$ = new BehaviorSubject(null);
        this._componentDestroyed$ = new Subject();
        /**
         * Generates the internal bounding box for the elements based off
         * the actual DOM wrapper and the bounding [dimensions] input
         */
        this._getWrapperDimensions = (boundingDimensions) => {
            const isLandscape = boundingDimensions.width > boundingDimensions.height;
            const ratio = boundingDimensions.width / boundingDimensions.height;
            const width = this.wrapperElement.nativeElement.offsetWidth;
            const height = isLandscape ? width / ratio : width * ratio;
            return {
                width: width,
                height: height,
            };
        };
    }
    ngOnInit() {
        if (this.elements$.getValue() === null) {
            this._throwMissingReqDeps('elements');
        }
        if (this.boundingDimensions$.getValue() === null) {
            this._throwMissingReqDeps('bounding');
        }
        // Define element preview dimensions to be used in ui based off
        // changes to elements input, bounding input and wrapper resize
        this.elementDimensions$ = combineLatest([this.elements$, this.boundingDimensions$, this._resize$]).pipe(distinctUntilChanged$1(), map$1(([elements, boundingDimensions, _]) => this._definePreviewElementsDimensions(elements, boundingDimensions)));
        // Send preview dimensions to preview subject, preview subject
        // will be fed new events during anchor resize to change visuals
        // while the actual element dimensions in the store remain the
        // same until resizing is complete, so they are split here
        this.elementDimensions$.pipe(takeUntil$1(this._componentDestroyed$)).subscribe(this.elementsDimensionsPreview$);
        // Track element dimensions changes to set new anchor positions
        this.elementDimensions$
            .pipe(map$1((elements) => elements.map((element) => element.anchors)), takeUntil$1(this._componentDestroyed$))
            .subscribe(this.anchorPositions$);
        // Define which anchors should be shown, based off the current
        // hovered, locked or resized elements
        this.showAnchor$ = combineLatest([this.elementHovering$, this.elementResizing$, this.elementLocked$]).pipe(distinctUntilChanged$1(), map$1(([hoveredElementIndex, anchorInfo, lockedElement]) => {
            const shownAnchors = {};
            if (lockedElement !== null) {
                shownAnchors[lockedElement] = anchorInfo ? [AnchorNames[anchorInfo.anchor]] : this.anchorNames;
            }
            else if (hoveredElementIndex !== null) {
                shownAnchors[hoveredElementIndex] = anchorInfo ? [AnchorNames[anchorInfo.anchor]] : this.anchorNames;
            }
            return shownAnchors;
        }));
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    onWrapperResize(event) {
        this.ngZone.run(() => {
            this._resize$.next({ width: event.width, height: event.height });
        });
    }
    onAnchorDragMoved(event, elementIndex, anchor) {
        const { widthChange, heightChange, topChange, leftChange } = this._getDimensionsChangeFromAnchorDragDistance(event.distance.x, event.distance.y, anchor);
        // Create preview element sizes from the original values before dragging
        // started, not the current, since those update during the drag
        const newPreviewElements = this._definePreviewElementsDimensions(this.elements$.getValue(), this.boundingDimensions$.getValue());
        const currentElement = newPreviewElements[elementIndex];
        const updatedElement = {
            ...currentElement,
            width: currentElement.width + widthChange,
            height: currentElement.height + heightChange,
            top: currentElement.top + topChange,
            left: currentElement.left + leftChange,
        };
        newPreviewElements[elementIndex] = updatedElement;
        // Set element preview sizes which updates visuals live
        this.elementsDimensionsPreview$.next(newPreviewElements);
        // Create actual element sizes
        const newElements = [...this.elements$.getValue()];
        const { anchors, ...updatedTransformableElement } = updatedElement;
        const newElementActualSize = this._defineActualElementDimensions(updatedTransformableElement);
        newElements[elementIndex] = {
            ...newElements[elementIndex],
            ...newElementActualSize,
        };
        this.resizedElements$.next(newElements);
    }
    onAnchorDragStart(index, anchor) {
        this.elementResizing$.next({ index, anchor });
    }
    onAnchorDragEnd() {
        this.elementDragging$.next(null);
        this.elementResizing$.next(null);
        this.elementHovering$.next(null);
        this._emitTransformedElements(this.resizedElements$.getValue());
    }
    onElementDragStart(index) {
        this.elementLocked$.next(index);
        this.elementDragging$.next(true);
    }
    onElementDragDropped(event, elementIndex) {
        const { x: leftChange, y: topChange } = event.source.getFreeDragPosition();
        const newElementActualPosition = this._defineActualElementPosition({
            top: this.domElements.toArray()[elementIndex].nativeElement.offsetTop + topChange,
            left: this.domElements.toArray()[elementIndex].nativeElement.offsetLeft + leftChange,
        });
        const newElements = [...this.elements$.getValue()];
        newElements[elementIndex].top = newElementActualPosition.top;
        newElements[elementIndex].left = newElementActualPosition.left;
        this.elementDragging$.next(false);
        this._emitTransformedElements(newElements);
    }
    onElementLocked(index) {
        this.elementLocked$.next(index);
    }
    onElementUnlocked() {
        this.elementLocked$.next(null);
    }
    isInArray(array, val) {
        return array.some((v) => v === val);
    }
    cancel() {
        this.lock();
    }
    unlock() {
        this.editing$.next(true);
    }
    lock() {
        this.editing$.next(false);
        this.elementHovering$.next(null);
        this.elementResizing$.next(null);
        this.elementLocked$.next(null);
    }
    align(where) {
        const elementIndex = this.elementLocked$.getValue();
        let newTop, newLeft;
        switch (where) {
            case AlignmentFixtures.top:
                newTop = 0;
                newLeft = this.domElements.toArray()[elementIndex].nativeElement.offsetLeft;
                break;
            case AlignmentFixtures.left:
                newTop = this.domElements.toArray()[elementIndex].nativeElement.offsetTop;
                newLeft = 0;
                break;
            case AlignmentFixtures.right:
                newTop = this.domElements.toArray()[elementIndex].nativeElement.offsetTop;
                newLeft = this.wrapperElement.nativeElement.offsetWidth - this.domElements.toArray()[elementIndex].nativeElement.offsetWidth;
                break;
            case AlignmentFixtures.bottom:
                newTop = this.wrapperElement.nativeElement.offsetHeight - this.domElements.toArray()[elementIndex].nativeElement.offsetHeight;
                newLeft = this.domElements.toArray()[elementIndex].nativeElement.offsetLeft;
                break;
            case AlignmentFixtures.horizmid:
                newTop = this.domElements.toArray()[elementIndex].nativeElement.offsetTop;
                newLeft = Math.round((this.wrapperElement.nativeElement.offsetWidth - this.domElements.toArray()[elementIndex].nativeElement.offsetWidth) / 2);
                break;
            case AlignmentFixtures.vertmid:
                newTop = (this.wrapperElement.nativeElement.offsetHeight - this.domElements.toArray()[elementIndex].nativeElement.offsetHeight) / 2;
                newLeft = this.domElements.toArray()[elementIndex].nativeElement.offsetLeft;
                break;
        }
        const newElementActualPosition = this._defineActualElementPosition({
            top: newTop || 0,
            left: newLeft || 0,
        });
        const newElements = [...this.elements$.getValue()];
        newElements[elementIndex].top = newElementActualPosition.top;
        newElements[elementIndex].left = newElementActualPosition.left;
        this._emitTransformedElements(newElements);
    }
    fit(what) {
        const elementIndex = this.elementLocked$.getValue();
        let newTop, newLeft, newWidth, newHeight;
        switch (what) {
            case FitFixtures.width:
                newTop = this.domElements.toArray()[elementIndex].nativeElement.offsetTop;
                newLeft = 0;
                newWidth = this.wrapperElement.nativeElement.offsetWidth;
                newHeight = this.domElements.toArray()[elementIndex].nativeElement.offsetHeight;
                break;
            case FitFixtures.height:
                newTop = 0;
                newLeft = this.domElements.toArray()[elementIndex].nativeElement.offsetLeft;
                newWidth = this.domElements.toArray()[elementIndex].nativeElement.offsetWidth;
                newHeight = this.wrapperElement.nativeElement.offsetHeight;
                break;
            case FitFixtures.all:
                newTop = 0;
                newLeft = 0;
                newWidth = this.wrapperElement.nativeElement.offsetWidth;
                newHeight = this.wrapperElement.nativeElement.offsetHeight;
                break;
        }
        const newElementActualPosition = this._defineActualElementDimensions({
            top: newTop || 0,
            left: newLeft || 0,
            width: newWidth || 0,
            height: newHeight || 0,
        });
        const newElements = [...this.elements$.getValue()];
        newElements[elementIndex].top = newElementActualPosition.top;
        newElements[elementIndex].left = newElementActualPosition.left;
        newElements[elementIndex].width = newElementActualPosition.width;
        newElements[elementIndex].height = newElementActualPosition.height;
        this._emitTransformedElements(newElements);
    }
    _emitTransformedElements(elements) {
        this.transformed.next(elements);
    }
    /**
     * Reverts a preview size back to an actual element size
     */
    _defineActualElementSize(element) {
        const boundingDimensions = this.boundingDimensions$.getValue();
        const { width: wrapperWidth, height: wrapperHeight } = this._getWrapperDimensions(boundingDimensions);
        return {
            ...element,
            width: Math.round(element.width * (boundingDimensions.height / wrapperHeight)),
            height: Math.round(element.height * (boundingDimensions.width / wrapperWidth)),
        };
    }
    /**
     * Reverts a preview position back to an actual element position
     */
    _defineActualElementPosition(element) {
        const boundingDimensions = this.boundingDimensions$.getValue();
        const { width: wrapperWidth, height: wrapperHeight } = this._getWrapperDimensions(boundingDimensions);
        return {
            ...element,
            top: Math.round(element.top * (boundingDimensions.height / wrapperHeight)),
            left: Math.round(element.left * (boundingDimensions.width / wrapperWidth)),
        };
    }
    /**
     * Defines both size and position of actual element from preview element
     */
    _defineActualElementDimensions(element) {
        const newElementActualSize = this._defineActualElementSize(element);
        const newElementActualPosition = this._defineActualElementPosition(element);
        return {
            ...element,
            width: newElementActualSize.width,
            height: newElementActualSize.height,
            top: newElementActualPosition.top,
            left: newElementActualPosition.left,
        };
    }
    /**
     * Converts actual element size and positions to preview sizes and positions for DOM
     */
    _definePreviewElementsDimensions(elements, boundingDimensions) {
        const { width: wrapperWidth, height: wrapperHeight } = this._getWrapperDimensions(boundingDimensions);
        if (wrapperWidth === 0 || wrapperHeight === 0)
            return [];
        return elements.map((element) => {
            const elementDimensions = {
                top: Math.round(wrapperHeight * (element.top / boundingDimensions.height)),
                left: Math.round(wrapperWidth * (element.left / boundingDimensions.width)),
                width: Math.round(wrapperWidth / (boundingDimensions.width / element.width)),
                height: Math.round(wrapperHeight / (boundingDimensions.height / element.height)),
            };
            const anchors = this._defineAnchorPositions(elementDimensions);
            return {
                ...elementDimensions,
                asset: element.asset,
                anchors,
            };
        });
    }
    /**
     * Defines the positions of anchors absolutely within the stage
     * based off the element properties
     */
    _defineAnchorPositions(element) {
        const anchorPaddingSize = 5;
        return {
            top: {
                top: element.top - anchorPaddingSize,
                left: element.left + element.width / 2 - anchorPaddingSize,
            },
            left: {
                top: element.top + element.height / 2 - anchorPaddingSize,
                left: element.left - 5,
            },
            bottom: {
                top: element.top + element.height - anchorPaddingSize,
                left: element.left + element.width / 2 - anchorPaddingSize,
            },
            right: {
                top: element.top + element.height / 2 - anchorPaddingSize,
                left: element.left + element.width - anchorPaddingSize,
            },
            topright: {
                top: element.top - anchorPaddingSize,
                left: element.left + element.width - anchorPaddingSize,
            },
            topleft: {
                top: element.top - anchorPaddingSize,
                left: element.left - anchorPaddingSize,
            },
            bottomright: {
                top: element.top + element.height - anchorPaddingSize,
                left: element.left + element.width - anchorPaddingSize,
            },
            bottomleft: {
                top: element.top + element.height - anchorPaddingSize,
                left: element.left - anchorPaddingSize,
            },
        };
    }
    /**
     * Gathers changes on dimensions from given x and y drag distances
     */
    _getDimensionsChangeFromAnchorDragDistance(x, y, anchor) {
        let widthChange = 0, heightChange = 0, topChange = 0, leftChange = 0;
        switch (anchor) {
            case AnchorNames.top:
                heightChange = -y;
                topChange = y;
                break;
            case AnchorNames.bottom:
                heightChange = y;
                break;
            case AnchorNames.left:
                widthChange = -x;
                leftChange = x;
                break;
            case AnchorNames.right:
                widthChange = x;
                break;
            case AnchorNames.topright:
                widthChange = x;
                heightChange = -y;
                topChange = y;
                break;
            case AnchorNames.topleft:
                widthChange = -x;
                leftChange = x;
                heightChange = -y;
                topChange = y;
                break;
            case AnchorNames.bottomleft:
                heightChange = y;
                widthChange = -x;
                leftChange = x;
                break;
            case AnchorNames.bottomright:
                heightChange = y;
                widthChange = x;
                break;
        }
        return {
            widthChange,
            heightChange,
            topChange,
            leftChange,
        };
    }
    /**
     * Throws error with message explaining a dep is required by comp
     */
    _throwMissingReqDeps(type) {
        throw new Error('Input [' + type + '] required by <avn-transformable-element-stage>');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TransformableElementStageComponent, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: TransformableElementStageComponent, isStandalone: true, selector: "avn-transformable-element-stage", inputs: { elements: "elements", bounding: "bounding", editing: "editing", toolbar: "toolbar" }, outputs: { transformed: "transformed" }, viewQueries: [{ propertyName: "wrapperElement", first: true, predicate: ["wrapper"], descendants: true, static: true }, { propertyName: "domElements", predicate: ["element"], descendants: true }], ngImport: i0, template: "<div\n  #wrapper\n  class=\"wrapper\"\n  [ngClass]=\"{ editing: (editing$ | async) === true, resizing: (elementResizing$ | async) !== null, dragging: (elementDragging$ | async) }\"\n  (avnResize)=\"onWrapperResize($event)\"\n  [debounceTime]=\"0\"\n  [emitInitialEvent]=\"true\"\n>\n  <div\n    #element\n    cdkDrag\n    cdkDragBoundary=\".wrapper\"\n    (cdkDragStarted)=\"onElementDragStart(i)\"\n    (cdkDragEnded)=\"onElementDragDropped($event, i)\"\n    class=\"element\"\n    *ngFor=\"let element of elementsDimensionsPreview$ | async; let i = index\"\n    [ngClass]=\"{ resizing: (elementResizing$ | async) === i, locked: (elementLocked$ | async) === i }\"\n    [style.top.px]=\"element?.top\"\n    [style.left.px]=\"element?.left\"\n    [style.width.px]=\"element?.width\"\n    [style.height.px]=\"element?.height\"\n    [ngStyle]=\"{ backgroundImage: element?.asset ? 'url(' + element?.asset.url + ')' : 'none' }\"\n  >\n    <div class=\"drag-handle\" cdkDragHandle (mouseenter)=\"elementHovering$.next(i)\" (click)=\"onElementLocked(i)\"></div>\n    <div class=\"border top\"></div>\n    <div class=\"border left\"></div>\n    <div class=\"border right\"></div>\n    <div class=\"border bottom\"></div>\n  </div>\n  <div class=\"resize-blocker\"></div>\n  <ng-container *ngFor=\"let anchorSet of anchorPositions$ | async; let a = index\">\n    <ng-container *ngIf=\"showAnchor$ | async as showAnchor\">\n      <ng-container *ngFor=\"let anchorName of anchorNames\">\n        <div style=\"font-size: 11px; top: -180px; position: absolute; width: 600px; z-index: 100; background: #000; display: none\">\n          <b>show anchors:</b><br />\n          {{ showAnchor | json }}<br />\n          <b>resize:</b> <br />\n          {{ (elementsDimensionsPreview$ | async)[elementHovering$ | async] | json }}<br />\n          <b>locked el</b> <br />\n          {{ elementLocked$ | async | json }}<br />\n        </div>\n        <div\n          *ngIf=\"showAnchor[a] && isInArray(showAnchor[a], anchorName)\"\n          class=\"anchor {{ anchorName }}\"\n          cdkDrag\n          cdkDragBoundary=\".wrapper\"\n          (cdkDragMoved)=\"onAnchorDragMoved($event, a, anchorName)\"\n          (cdkDragStarted)=\"onAnchorDragStart(a, anchorName)\"\n          (cdkDragReleased)=\"onAnchorDragEnd()\"\n          [cdkDragLockAxis]=\"anchorLocks[anchorName]\"\n          [style.top.px]=\"anchorSet?.[anchorName].top\"\n          [style.left.px]=\"anchorSet?.[anchorName].left\"\n        ></div>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [":host{position:relative;width:100%;height:100%;z-index:1;display:block;overflow:visible;pointer-events:none}:host .wrapper{width:100%;height:100%;z-index:1;display:block;position:relative;overflow:visible}:host .wrapper .resize-blocker{width:100%;height:100%;z-index:8;opacity:0;display:none;position:absolute;top:0;left:0}:host .wrapper .element{position:absolute;background:#000;background-repeat:no-repeat;background-position:center;background-size:100% 100%}:host .wrapper .element .drag-handle{width:calc(100% - 10px);height:calc(100% - 10px);margin:5px 0 0 5px;padding:0;cursor:grab}:host .wrapper .element .drag-handle:active{cursor:grabbing}:host .wrapper .element .border{background-color:var(--administrative-labels-text-stroke);position:absolute}:host .wrapper .element .border.top{width:100%;height:1px;top:0;left:0}:host .wrapper .element .border.left{width:1px;height:100%;top:0;left:0}:host .wrapper .element .border.bottom{width:100%;height:1px;bottom:0;left:0}:host .wrapper .element .border.right{width:1px;height:100%;top:0;right:0}:host .wrapper .element:hover .border{background-color:var(--secondary-base)!important;z-index:8}:host .wrapper .element:hover .anchor,:host .wrapper .element:hover .border{display:block}:host .wrapper .element.resizing{z-index:9!important}:host .wrapper .element.resizing .border{z-index:8;background-color:var(--secondary-base)!important}:host .wrapper .element.locked .border{z-index:8;background-color:var(--secondary-base)!important}:host .wrapper .anchor{width:10px;height:10px;background:#fff;border:1px solid var(--secondary-base);cursor:pointer;position:absolute;z-index:11}:host .wrapper .anchor.top{cursor:ns-resize}:host .wrapper .anchor.left{cursor:ew-resize}:host .wrapper .anchor.bottom{cursor:ns-resize}:host .wrapper .anchor.right{cursor:ew-resize}:host .wrapper .anchor.topleft{cursor:nwse-resize}:host .wrapper .anchor.topright{cursor:nesw-resize}:host .wrapper .anchor.bottomright{cursor:nwse-resize}:host .wrapper .anchor.bottomleft{cursor:nesw-resize}:host .wrapper .anchor:hover{background-color:var(--secondary-base)}:host .wrapper.dragging .anchor{display:none!important}:host .wrapper.resizing .resize-blocker{display:block}:host .wrapper.editing{pointer-events:all!important}:host .wrapper.editing .element .border{background-color:#fff9}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$2.JsonPipe, name: "json" }, { kind: "ngmodule", type: DragDropModule }, { kind: "directive", type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i4.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "ngmodule", type: CoreModule }, { kind: "directive", type: ResizeDirective, selector: "[avnResize]", inputs: ["debounceTime", "emitInitialEvent"], outputs: ["avnResize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: TransformableElementStageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-transformable-element-stage', standalone: true, imports: [CommonModule, DragDropModule, CoreModule], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  #wrapper\n  class=\"wrapper\"\n  [ngClass]=\"{ editing: (editing$ | async) === true, resizing: (elementResizing$ | async) !== null, dragging: (elementDragging$ | async) }\"\n  (avnResize)=\"onWrapperResize($event)\"\n  [debounceTime]=\"0\"\n  [emitInitialEvent]=\"true\"\n>\n  <div\n    #element\n    cdkDrag\n    cdkDragBoundary=\".wrapper\"\n    (cdkDragStarted)=\"onElementDragStart(i)\"\n    (cdkDragEnded)=\"onElementDragDropped($event, i)\"\n    class=\"element\"\n    *ngFor=\"let element of elementsDimensionsPreview$ | async; let i = index\"\n    [ngClass]=\"{ resizing: (elementResizing$ | async) === i, locked: (elementLocked$ | async) === i }\"\n    [style.top.px]=\"element?.top\"\n    [style.left.px]=\"element?.left\"\n    [style.width.px]=\"element?.width\"\n    [style.height.px]=\"element?.height\"\n    [ngStyle]=\"{ backgroundImage: element?.asset ? 'url(' + element?.asset.url + ')' : 'none' }\"\n  >\n    <div class=\"drag-handle\" cdkDragHandle (mouseenter)=\"elementHovering$.next(i)\" (click)=\"onElementLocked(i)\"></div>\n    <div class=\"border top\"></div>\n    <div class=\"border left\"></div>\n    <div class=\"border right\"></div>\n    <div class=\"border bottom\"></div>\n  </div>\n  <div class=\"resize-blocker\"></div>\n  <ng-container *ngFor=\"let anchorSet of anchorPositions$ | async; let a = index\">\n    <ng-container *ngIf=\"showAnchor$ | async as showAnchor\">\n      <ng-container *ngFor=\"let anchorName of anchorNames\">\n        <div style=\"font-size: 11px; top: -180px; position: absolute; width: 600px; z-index: 100; background: #000; display: none\">\n          <b>show anchors:</b><br />\n          {{ showAnchor | json }}<br />\n          <b>resize:</b> <br />\n          {{ (elementsDimensionsPreview$ | async)[elementHovering$ | async] | json }}<br />\n          <b>locked el</b> <br />\n          {{ elementLocked$ | async | json }}<br />\n        </div>\n        <div\n          *ngIf=\"showAnchor[a] && isInArray(showAnchor[a], anchorName)\"\n          class=\"anchor {{ anchorName }}\"\n          cdkDrag\n          cdkDragBoundary=\".wrapper\"\n          (cdkDragMoved)=\"onAnchorDragMoved($event, a, anchorName)\"\n          (cdkDragStarted)=\"onAnchorDragStart(a, anchorName)\"\n          (cdkDragReleased)=\"onAnchorDragEnd()\"\n          [cdkDragLockAxis]=\"anchorLocks[anchorName]\"\n          [style.top.px]=\"anchorSet?.[anchorName].top\"\n          [style.left.px]=\"anchorSet?.[anchorName].left\"\n        ></div>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [":host{position:relative;width:100%;height:100%;z-index:1;display:block;overflow:visible;pointer-events:none}:host .wrapper{width:100%;height:100%;z-index:1;display:block;position:relative;overflow:visible}:host .wrapper .resize-blocker{width:100%;height:100%;z-index:8;opacity:0;display:none;position:absolute;top:0;left:0}:host .wrapper .element{position:absolute;background:#000;background-repeat:no-repeat;background-position:center;background-size:100% 100%}:host .wrapper .element .drag-handle{width:calc(100% - 10px);height:calc(100% - 10px);margin:5px 0 0 5px;padding:0;cursor:grab}:host .wrapper .element .drag-handle:active{cursor:grabbing}:host .wrapper .element .border{background-color:var(--administrative-labels-text-stroke);position:absolute}:host .wrapper .element .border.top{width:100%;height:1px;top:0;left:0}:host .wrapper .element .border.left{width:1px;height:100%;top:0;left:0}:host .wrapper .element .border.bottom{width:100%;height:1px;bottom:0;left:0}:host .wrapper .element .border.right{width:1px;height:100%;top:0;right:0}:host .wrapper .element:hover .border{background-color:var(--secondary-base)!important;z-index:8}:host .wrapper .element:hover .anchor,:host .wrapper .element:hover .border{display:block}:host .wrapper .element.resizing{z-index:9!important}:host .wrapper .element.resizing .border{z-index:8;background-color:var(--secondary-base)!important}:host .wrapper .element.locked .border{z-index:8;background-color:var(--secondary-base)!important}:host .wrapper .anchor{width:10px;height:10px;background:#fff;border:1px solid var(--secondary-base);cursor:pointer;position:absolute;z-index:11}:host .wrapper .anchor.top{cursor:ns-resize}:host .wrapper .anchor.left{cursor:ew-resize}:host .wrapper .anchor.bottom{cursor:ns-resize}:host .wrapper .anchor.right{cursor:ew-resize}:host .wrapper .anchor.topleft{cursor:nwse-resize}:host .wrapper .anchor.topright{cursor:nesw-resize}:host .wrapper .anchor.bottomright{cursor:nwse-resize}:host .wrapper .anchor.bottomleft{cursor:nesw-resize}:host .wrapper .anchor:hover{background-color:var(--secondary-base)}:host .wrapper.dragging .anchor{display:none!important}:host .wrapper.resizing .resize-blocker{display:block}:host .wrapper.editing{pointer-events:all!important}:host .wrapper.editing .element .border{background-color:#fff9}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }]; }, propDecorators: { wrapperElement: [{
                type: ViewChild,
                args: ['wrapper', { static: true }]
            }], domElements: [{
                type: ViewChildren,
                args: ['element']
            }], elements: [{
                type: Input
            }], bounding: [{
                type: Input
            }], editing: [{
                type: Input
            }], toolbar: [{
                type: Input
            }], transformed: [{
                type: Output
            }] } });

var DockRegions;
(function (DockRegions) {
    DockRegions["verticalLeft"] = "vertical-left";
    DockRegions["verticalRight"] = "vertical-right";
    DockRegions["horizontalTop"] = "horizontal-top";
    DockRegions["horizontalBottom"] = "horizontal-bottom";
    DockRegions["center"] = "center";
})(DockRegions || (DockRegions = {}));
var CollisionTypes;
(function (CollisionTypes) {
    CollisionTypes["right"] = "right";
    CollisionTypes["left"] = "left";
    CollisionTypes["bottom"] = "bottom";
    CollisionTypes["top"] = "top";
})(CollisionTypes || (CollisionTypes = {}));
const DEFAULT_DOCK_STATE = {
    stack: new Map(),
    activeItem: undefined,
    dockTargetId: '123',
    containerRect: undefined,
};
const MIN_HEIGHT = 200;

class DockService {
    constructor() {
        this.zIndex = 10;
        // dock board properties
        this.width = 1;
        this.height = 1;
        this._presets = [];
    }
    static { this.gridSize = 25; }
    set presets(items) {
        this._presets = items;
    }
    get presets() {
        return this._presets;
    }
    static gridNumber(n) {
        return Math.round(n / DockService.gridSize) * DockService.gridSize;
    }
    // convert an arbitrary number to grid number of lesser edge
    static gridNumberMax(n) {
        const g = DockService.gridNumber(n);
        return g >= n ? g : g + DockService.gridSize;
    }
    // convert an arbitrary number to grid number of bigger edge
    static gridNumberNext(n) {
        return DockService.gridNumber(n) + DockService.gridSize;
    }
    static gridNumberPrev(n) {
        return DockService.gridNumber(n) - DockService.gridSize;
    }
    /**
     * Create an ItemDock object.
     */
    createItemDock(tabs, props = {}, boardId) {
        return {
            id: `dock${this.getUniqueId()}`,
            tabs,
            activeTabIndex: 0,
            left: DockService.gridNumber('left' in props ? props.left : 300),
            top: DockService.gridNumber('top' in props ? props.top : 300),
            width: DockService.gridNumber('width' in props ? props.width : (50 * this.width) / 100),
            height: DockService.gridNumber('height' in props ? props.height : (60 * this.height) / 100),
            bottom: 0,
            right: 0,
            minWidth: 0,
            isBusy: false,
            targetId: undefined,
            orientation: '',
            collidingDocks: [],
            boardId,
        };
    }
    /**
     * Generate a unique ID.
     */
    getUniqueId() {
        return Math.floor(new Date().valueOf() * Math.random()).toString();
    }
    /**
     * Gets the next available zIndex value.
     */
    getZIndex() {
        return ++this.zIndex;
    }
    /**
     * Observes the size changes of an element using the ResizeObserver API.
     */
    observeElementSize(element) {
        const resizeSubject = new Subject();
        // Create a ResizeObserver and associate it with the target element
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { top, left, width, height } = entry.contentRect;
                resizeSubject.next({ width, height, top, left });
            }
        });
        // Start observing the target element
        resizeObserver.observe(element);
        // Return the observable that emits width and height changes
        return resizeSubject.asObservable();
    }
    /**
     * Detects collisions between a target dock and an array of other docks based on their coordinates.
     */
    detectCollision(dock, otherDocks) {
        const { top: targetTop, bottom: targetBottom, right: targetRight } = dock;
        const proximity = 10;
        const collidingDocks = otherDocks.filter((otherDock) => {
            if (otherDock.id !== dock.id) {
                const { bottom: otherBottom, left: otherLeft, right: otherRight } = otherDock;
                return Math.abs(targetRight - otherRight) < proximity || Math.abs(targetRight - otherLeft) < proximity || Math.abs(targetTop - otherBottom) < proximity;
            }
            return false;
        });
        return collidingDocks.map((collision) => {
            const collisionTypes = [];
            if (Math.abs(targetRight - collision.right) < proximity) {
                collisionTypes.push(CollisionTypes.right);
            }
            if (Math.abs(targetRight - collision.left) < proximity) {
                collisionTypes.push(CollisionTypes.left);
            }
            if (Math.abs(targetBottom - collision.top) < proximity) {
                collisionTypes.push(CollisionTypes.top);
            }
            return { types: collisionTypes, dockId: collision.id };
        });
    }
    /**
     * Retrieves an HTML element by its ID.
     */
    getElementById(id) {
        return document.getElementById(`${id}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class DockStore extends ComponentStore {
    isTargetDock$(dockId) {
        return this.selectActiveItem$.pipe(map((item) => item?.targetId === dockId));
    }
    selectDocksByBoard(boardId) {
        return this.selectDocks$.pipe(map((items) => items.filter((item) => item.boardId === boardId)));
    }
    constructor(dockService) {
        // initial state
        super(DEFAULT_DOCK_STATE);
        this.dockService = dockService;
        /** Contains ids of files currently in a cancelled state */
        this.cancelledFileIdsSubject = new BehaviorSubject([]);
        /** Selector */
        this.selectStack$ = this.select((state) => state.stack);
        this.selectActiveItem$ = this.select((state) => state.activeItem);
        this.selectDocks$ = this.select(this.selectStack$, (stack) => Array.from(stack.values()).flat());
        this.selectDockTargetId$ = this.select((state) => state.dockTargetId);
        this.selectContainerRect$ = this.select((state) => state.containerRect);
        this.selectMinWidth$ = this.select(this.selectDocks$, (docks) => {
            const minWidthArray = docks.map((dock) => dock.minWidth);
            return Math.max(...minWidthArray);
        });
        this.updateContainerRect = this.updater((state, containerRect) => {
            return {
                ...state,
                containerRect,
            };
        });
        this.updateDock = this.updater((state, dock) => {
            const stack = new Map(state.stack);
            const docks = Array.from(stack.get(dock.boardId));
            const index = docks.findIndex((item) => item.id === dock.id);
            if (index !== -1) {
                // If the object with the ID is found, replace it with the new object
                docks[index] = dock;
            }
            stack.set(dock.boardId, docks);
            return {
                ...state,
                stack,
            };
        });
        this.deleteDock = this.updater((state, dock) => {
            const stack = new Map(state.stack);
            const docks = stack.get(dock.boardId).filter((itemDock) => itemDock.id !== dock.id);
            if (docks.length > 0) {
                stack.set(dock.boardId, docks);
            }
            else {
                stack.delete(dock.boardId);
            }
            // Return the updated state with the modified stack.
            return {
                ...state,
                stack,
            };
        });
        this.updateActiveItem = this.updater((state, item) => {
            return {
                ...state,
                activeItem: item,
            };
        });
        this.updateStack = this.updater((state, stack) => {
            return {
                ...state,
                stack,
            };
        });
        this.updateTargetDock = this.updater((state, event) => {
            const targetedDock = this.findDockBasedOnMouseEvent(state.stack, event, state.containerRect);
            const activeItem = { ...state.activeItem };
            activeItem.targetId = targetedDock?.id;
            activeItem.orientation = activeItem.height > MIN_HEIGHT ? this.getMousePosition(event, activeItem.targetId) : DockRegions.center;
            return {
                ...state,
                activeItem,
            };
        });
        this.addStackItem = this.updater((state, payload) => {
            const item = this.dockService.createItemDock(payload.tabs.concat(), payload.props, payload.boardId);
            const stack = new Map(state.stack);
            stack.set(payload.boardId, [item]);
            return {
                ...state,
                stack,
            };
        });
        this.dropDock = this.updater((state, payload) => {
            const stack = new Map(state.stack);
            const activeItem = { ...state.activeItem };
            const docks = Array.from(stack.values()).flat();
            const targetedDock = docks.find((dock) => dock.id === activeItem.targetId);
            const parent = payload.parent.id === targetedDock?.id ? targetedDock : payload.parent;
            this.updateActiveItemPosition(activeItem, targetedDock, payload.mouseEvent, state.containerRect);
            this.removeTabFromParent(parent, payload.tabIndex);
            this.updateStackBasedOnParentTabs(parent, stack);
            let tabs = [];
            if (activeItem.orientation === 'center' && targetedDock?.tabs) {
                tabs = targetedDock.tabs;
            }
            activeItem.tabs = activeItem.tabs.concat(tabs);
            activeItem.boardId = targetedDock ? targetedDock.boardId : parent.boardId;
            const items = stack.get(activeItem.boardId);
            if (activeItem.tabs?.length > 1) {
                targetedDock.tabs = activeItem.tabs;
            }
            else {
                stack.set(activeItem.boardId, [...items, activeItem]);
            }
            const updatedDocks = Array.from(stack.values()).flat();
            this.updateCollisions(updatedDocks);
            return {
                ...state,
                stack,
                activeItem: undefined,
            };
        });
    }
    /**
     * Updates the stack based on the parent tabs.
     */
    updateStackBasedOnParentTabs(parent, stack) {
        // delete docks items with no tabs
        if (parent.tabs.length === 0) {
            const items = stack.get(parent.boardId).filter((value) => value.id !== parent.id);
            stack.set(parent.boardId, items);
        }
        else {
            stack.get(parent.boardId).map((dock) => (dock.id === parent.id ? parent : dock));
        }
    }
    /**
     * Remove a tab from the parent dock at the specified index.
     */
    removeTabFromParent(parent, tabIndex) {
        parent.tabs.splice(tabIndex, 1);
        if (parent.activeTabIndex === tabIndex && parent.activeTabIndex >= parent.tabs.length) {
            parent.activeTabIndex--;
        }
    }
    /**
     * Updates the position and dimensions of the active item based on the target dock.
     */
    updateActiveItemPosition(activeItem, targetDock, mouseEvent, containerRect) {
        if (!targetDock) {
            const delta = { x: mouseEvent.clientX, y: mouseEvent.clientY };
            this.adjustItemPositionWithinBounds(activeItem, delta, containerRect);
            return;
        }
        const offset = cloneDeep({
            top: targetDock.top,
            width: targetDock.width,
            height: targetDock.height,
            left: targetDock.left,
            bottom: targetDock.bottom,
            right: targetDock.right,
            transform: targetDock.transform,
        });
        const halfHeight = offset.height / 2;
        const halfWidth = offset.width / 2;
        switch (activeItem.orientation) {
            case DockRegions.verticalLeft:
                activeItem.left = offset.left;
                activeItem.width = halfWidth;
                targetDock.left = offset.left + halfWidth;
                targetDock.width = halfWidth;
                break;
            case DockRegions.verticalRight:
                activeItem.left = offset.left + halfWidth;
                activeItem.top = offset.top;
                activeItem.width = halfWidth;
                activeItem.height = offset.height;
                targetDock.width = halfWidth;
                break;
            case DockRegions.horizontalTop:
                activeItem.left = offset.left;
                activeItem.top = offset.top;
                activeItem.height = halfHeight;
                activeItem.width = offset.width;
                activeItem.bottom = activeItem.top + activeItem.height;
                activeItem.right = activeItem.left + activeItem.width;
                targetDock.top = offset.top + halfHeight;
                targetDock.height = halfHeight;
                break;
            case DockRegions.horizontalBottom:
                activeItem.top = offset.top + halfHeight;
                activeItem.height = halfHeight;
                activeItem.left = offset.left;
                activeItem.width = offset.width;
                activeItem.bottom = activeItem.top + halfHeight;
                activeItem.right = activeItem.left + activeItem.width;
                targetDock.height = halfHeight;
                targetDock.bottom = targetDock.top + halfHeight;
                break;
            default:
                return;
        }
    }
    /**
     * Find the dock based on the mouse event and container rectangle.
     */
    findDockBasedOnMouseEvent(stack, event, containerRect) {
        const docks = Array.from(stack.values()).flat();
        const dockFound = docks.find((dock) => this.isEventWithinDock(event, dock, containerRect));
        return dockFound;
    }
    updateCollisions(docks) {
        docks.forEach((dock) => {
            dock.collidingDocks = this.dockService.detectCollision(dock, docks);
        });
    }
    /**
     * Get the dock region based on the mouse position within an element.
     */
    getMousePosition(event, dockId) {
        if (!dockId)
            return '';
        const { height, width, left, top } = document.getElementById(dockId).getBoundingClientRect();
        const mouseX = event.clientX - left;
        const mouseY = event.clientY - top;
        if (mouseX <= width * 0.15) {
            return DockRegions.verticalLeft;
        }
        else if (mouseX >= width * 0.85) {
            return DockRegions.verticalRight;
        }
        else if (mouseY < height * 0.15) {
            return DockRegions.horizontalTop;
        }
        else if (mouseY > height * 0.85) {
            return DockRegions.horizontalBottom;
        }
        return DockRegions.center;
    }
    /**
     * Adjusts the position and dimensions of an item to ensure it remains within the specified boundaries.
     */
    adjustItemPositionWithinBounds(dock, delta, containerRect) {
        /**
         * Calculates the top and left positions of the active dock relative to the container rectangle.
         */
        dock.top = delta.y - containerRect.top;
        dock.left = delta.x - containerRect.left;
        /**
         * Calculates the new bottom position of the active dock by adding its top position and height.
         */
        const newBottom = dock.top + dock.height;
        /**
         * Defines the bottom boundary as the difference between the container's bottom and its top coordinates.
         */
        const bottomBoundary = containerRect.bottom - containerRect.y;
        /**
         * Adjusts the height of the active dock if its new bottom position exceeds the bottom boundary.
         * Reduces the height by the difference between newBottom and bottomBoundary, plus an additional 4 units.
         */
        if (newBottom > bottomBoundary) {
            dock.height = dock.height - (newBottom - bottomBoundary) - 4;
        }
        if (dock.left < 0) {
            dock.left = 0;
        }
        /**
         * Updates the bottom, right, and width properties of the active item based on the modified values.
         */
        dock.bottom = dock.top + dock.height;
        dock.right = dock.left + dock.width;
        /**
         * Adjusts the width of the active dock if its new right position exceeds the right boundary.
         * Reduces the width by the difference between dock right and right boundary (width), plus an additional 4 units.
         */
        if (dock.right > containerRect.width) {
            dock.right = dock.right - (dock.right - containerRect.width) - 4;
            dock.width = dock.right - dock.left;
        }
    }
    /**
     * Check whether the event occurred roughly inside (or above) the element.
     */
    isEventWithinDock(event, rect, containerRect) {
        if (!rect) {
            return;
        }
        // mouse needs to be relative to dock layout container
        const mouseX = event.clientX - containerRect.x;
        const mouseY = event.clientY - containerRect.y;
        return mouseX >= rect.left && mouseX <= rect.right && mouseY >= rect.top && mouseY <= rect.bottom;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockStore, deps: [{ token: DockService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: DockService }]; } });

/**
 * Injection token for use in the dock container that allows to inject the input
 * config.
 */
const DOCK_MESSAGE_CONFIG = new InjectionToken('DOCK_CONFIG');
/**
 * defaults for the dock settings.
 */
const DEFAULT_DOCK_MESSAGE_CONFIG = {
    tabWithoutTitle: 'No title',
};

class DockComponent {
    set setItem(item) {
        this.item = item;
    }
    get dragHandleRightElement() {
        return this.dragHandleRight?.nativeElement;
    }
    get dragHandleCornerElement() {
        return this.dragHandleCorner?.nativeElement;
    }
    get dragHandleBottomElement() {
        return this.dragHandleBottom?.nativeElement;
    }
    constructor(dockService, store, element, renderer, ngZone, dockMessageConfig) {
        this.dockService = dockService;
        this.store = store;
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.dockMessageConfig = dockMessageConfig;
        this.show = true;
        this.style = {};
        this.minWidth = 0;
        this.tabsOverlapping = false;
        this.activeItem$ = this.store.selectActiveItem$;
        this.containerRect$ = this.store.selectContainerRect$;
        this.selectMinWidth$ = this.store.selectMinWidth$;
        this._componentDestroyed$ = new Subject();
        this.element = element.nativeElement;
        const sizeChanges$ = dockService.observeElementSize(this.element);
        // reposition resize handles
        sizeChanges$.pipe(takeUntil(this._componentDestroyed$)).subscribe(() => {
            this.item.bottom = this.item.top + this.item.height;
            this.item.right = this.item.left + this.item.width;
            this.setAllHandleTransform();
        });
    }
    ngOnInit() {
        this.docks$ = this.store.selectDocks$;
        this.selectMinWidth$.pipe(takeUntil(this._componentDestroyed$)).subscribe((minWidth) => {
            this.minWidth = minWidth;
        });
    }
    ngAfterViewInit() {
        this.isTargetDock$ = this.store.isTargetDock$(this.item.id);
        if (this.tabsContainerRef) {
            const tabsContainerSizeChanges$ = this.dockService.observeElementSize(this.tabsContainerRef.nativeElement);
            tabsContainerSizeChanges$
                .pipe(map((value) => value.width), filter((width) => width > 0), distinctUntilChanged(), takeUntil(this._componentDestroyed$))
                .subscribe((width) => {
                // distance in pixels to make sure UI styles are not affected by minWidth when dock is resized
                const safeDistance = 10;
                this.item.minWidth = width + this.actionButtonsContainerRef.nativeElement.clientWidth + safeDistance;
            });
        }
        this.setAllHandleTransform();
    }
    /**
     * Removes a tab from the given ItemDock object based on the provided index.
     * Updates the activeTabIndex if the removed tab was the active tab.
     */
    removeTab(item, index, event) {
        event.preventDefault();
        const wasActiveTab = index === item.activeTabIndex;
        item.tabs.splice(index, 1);
        if (wasActiveTab && item.tabs.length >= index) {
            item.activeTabIndex = item.tabs.length - 1;
        }
        else if (item.activeTabIndex > index) {
            item.activeTabIndex -= 1;
        }
    }
    /**
     * Handles the drag start event for a tab within an ItemDock object.
     */
    onDragStart(e, dock, tab, tabIndex) {
        this.renderer.setStyle(e.source.element.nativeElement, 'position', 'absolute');
        this.setzIndex(e.source.element.nativeElement);
        const currentTab = dock.tabs[tabIndex];
        const { top, left, width, height } = dock;
        const item = this.dockService.createItemDock([currentTab], { top, left, width, height });
        item.isBusy = true;
        item.boardId = dock.boardId;
        this.store.updateActiveItem(item);
    }
    onDragMove(e, parent, tab) {
        parent.tabs.forEach((item) => {
            if (item.component.dockKey !== tab.component.dockKey) {
                const currentTabDiv = document.getElementById(`tab${item.component.dockKey}`);
                this.tabsOverlapping = this.isMouseEventWithinDiv(e.event, currentTabDiv);
            }
        });
    }
    onDragEnd(e, parent, tab, tabIndex) {
        let overlappingTab = undefined;
        let overlappingTabIndex = undefined;
        parent.tabs?.forEach((item, index) => {
            if (item.component.dockKey !== tab.component.dockKey) {
                const currentTabDiv = document.getElementById(`tab${item.component.dockKey}`);
                if (this.isMouseEventWithinDiv(e.event, currentTabDiv)) {
                    overlappingTab = item;
                    overlappingTabIndex = index;
                }
            }
        });
        if (overlappingTab !== undefined && overlappingTabIndex !== undefined) {
            this.store.updateActiveItem(null);
            this.store.updateDock({ ...this.item, tabs: [] });
            setTimeout(() => {
                const updatedTabs = this.switchElements(parent.tabs, tabIndex, overlappingTabIndex);
                this.store.updateDock({ ...this.item, tabs: updatedTabs });
            }, 100);
            return;
        }
        const mouseEvent = e.event;
        this.store.dropDock({ parent, tabIndex, mouseEvent });
        this.renderer.setStyle(e.source.element.nativeElement, 'transform', 'unset');
        this.renderer.setStyle(e.source.element.nativeElement, 'position', 'relative');
        this.setzIndex(this.element);
    }
    updateActiveTabIndex(item, index) {
        item.activeTabIndex = index;
    }
    onClose() {
        this.store.deleteDock(this.item);
    }
    /**
     * Checks if a tab is active based on the given active item, current item, and tab index.
     */
    isTabActive(activeItem, currentItem, i) {
        if (activeItem && !activeItem.isMaximized) {
            if (activeItem.isBusy) {
                return currentItem.tabs[i]?.component === activeItem.tabs[0]?.component;
            }
            else {
                return currentItem.activeTabIndex === i;
            }
        }
        return false;
    }
    /**
     * Restores the size and position of an item
     */
    restoreSize(item, containerRect) {
        item.isMaximized = false;
        this.resizePanel(item, containerRect);
    }
    /**
     * Handles the maximize event for an item in the dock.
     */
    onMaximize(item, containerRect) {
        item.infoResize = {
            top: this.element.offsetTop,
            left: this.element.offsetLeft,
            height: this.element.offsetHeight,
            width: this.element.offsetWidth,
            transform: this.getTransformValue(this.element),
        };
        item.transform = '';
        item.isMaximized = true;
        this.store.updateActiveItem(item);
        this.resizePanel(item, containerRect);
    }
    /**
     * Resizes the panel based on the provided itemDock object.
     */
    resizePanel(itemDock, containerRect) {
        const { isMaximized, infoResize } = itemDock;
        const dockTarget = document.getElementById(itemDock.id);
        if (isMaximized) {
            dockTarget.style.transform = itemDock.transform;
            this.setElementDimensions({ ...this.getLayoutOffset(containerRect) }, itemDock);
            this.setzIndex(dockTarget);
        }
        else {
            dockTarget.style.transform = itemDock.infoResize.transform;
            this.setElementDimensions(infoResize, itemDock);
            this.store.updateActiveItem(null);
        }
    }
    /**
     * Sets the dimensions (top, left, width, and height) of the element based on the provided resize information.
     */
    setElementDimensions(resizeInfo, itemDock) {
        const { top, left, width, height } = resizeInfo;
        itemDock.top = top;
        itemDock.left = left;
        itemDock.width = width;
        itemDock.height = height;
    }
    /**
     * Gets the transform value from the specified HTMLElement.
     */
    getTransformValue(element) {
        const computedStyle = window.getComputedStyle(element);
        return computedStyle.transform;
    }
    /**
     * Handles the drag move event for a drag handle element.
     */
    dragMove(cdk, dock, collisions, dragHandle, container, axis) {
        cdk.event.stopPropagation();
        this.ngZone.runOutsideAngular(() => {
            this.resize(dragHandle, dock, collisions, container, axis);
        });
    }
    /**
     * Resizes the target element based on the dimensions of the drag handle element.
     */
    resize(dragHandle, target, docks, container, axis) {
        const dragRect = dragHandle.getBoundingClientRect();
        const targetRect = { ...target };
        const { top, left } = document.getElementById(target.id).getBoundingClientRect();
        const width = targetRect.width;
        const height = targetRect.height;
        // Lock axis that should not be resized when dragging horizontally, vertically or both
        const newWidth = axis !== 'y' ? dragRect.left - left + dragRect.width : targetRect.width;
        const newHeight = axis !== 'x' ? dragRect.y - top : targetRect.height;
        // minWidth limit exceeded
        if (newWidth <= target.minWidth) {
            this.setAllHandleTransform();
            return;
        }
        const widthRatio = newWidth / width;
        const heightRatio = newHeight / height;
        const widthGrowth = Math.abs(newWidth - width);
        const heightGrowth = Math.abs(newHeight - height);
        if (!target.collidingDocks || target.collidingDocks.length === 0) {
            target.collidingDocks = this.dockService.detectCollision(target, docks);
        }
        // propagate size changes to colliding docks
        for (const dockCollision of target.collidingDocks) {
            const collision = docks.find((dock) => dock.id === dockCollision.dockId);
            const collisionTypes = target.collidingDocks.find((item) => item.dockId === collision.id).types;
            const hasRight = collisionTypes.includes(CollisionTypes.right);
            const hasLeft = collisionTypes.includes(CollisionTypes.left);
            const hasTop = collisionTypes.includes(CollisionTypes.top);
            if (axis !== 'y') {
                const widthAdjustment = widthRatio > 1 ? widthGrowth : -widthGrowth;
                const newCollisionWidth = collision.width + (hasRight ? widthAdjustment : -widthAdjustment);
                // minWidth limit exceeded
                const collisionHasAnotherLeft = collision.collidingDocks
                    .map((item) => item.types)
                    .flat()
                    .includes(CollisionTypes.left);
                if ((hasLeft || collisionHasAnotherLeft) && (newCollisionWidth <= this.minWidth || newCollisionWidth + this.minWidth >= container.width)) {
                    this.setAllHandleTransform();
                    return;
                }
                this.propagateWidthChanges(collision, widthAdjustment, newCollisionWidth, !hasRight);
            }
            if (axis !== 'x') {
                if (hasRight && hasTop) {
                    this.propagateHeightChanges(collision, heightRatio, heightGrowth);
                }
            }
            this.store.updateDock(collision);
        }
        target.height = newHeight;
        target.width = newWidth;
        target.right = target.left + target.width;
        target.bottom = target.top + target.height;
        this.setzIndex(this.element);
        this.setAllHandleTransform();
    }
    /**
     * Propagates the width changes to the collision item based on the width ratio, growth in pixels, and whether to reverse the propagation.
     */
    propagateWidthChanges(collision, widthAdjustment, newWidth, reversePropagation) {
        if (reversePropagation) {
            collision.left = collision.left + widthAdjustment;
        }
        collision.width = newWidth;
    }
    /**
     * Propagates changes in height to a collision object based on a given height ratio and growth in pixels.
     */
    propagateHeightChanges(collision, heightRatio, growthInPixels) {
        if (heightRatio > 1) {
            // target increases height, collision increases top and decreases height
            collision.top = collision.top + growthInPixels;
            collision.height = collision.height - growthInPixels;
        }
        else {
            // target decreases height, collision decreases top and increases height
            collision.top = collision.top - growthInPixels;
            collision.height = collision.height + growthInPixels;
        }
    }
    /**
     * Sets the transform style of a drag handle element based on the target rectangle and position.
     */
    setHandleTransform(dragHandle, targetRect, position) {
        if (!dragHandle) {
            return;
        }
        const dragRect = dragHandle.getBoundingClientRect();
        const translateX = targetRect.width - dragRect.width;
        const translateY = targetRect.height - dragRect.height;
        switch (position) {
            case 'x':
                dragHandle.style.transform = `translateX(${translateX}px)`;
                break;
            case 'y':
                dragHandle.style.transform = `translateY(${translateY}px)`;
                break;
            case 'both':
                dragHandle.style.transform = `translate(${translateX}px, ${translateY}px)`;
                break;
            default:
                break;
        }
    }
    /**
     * Sets the transform style of all handle elements based on the target rectangle.
     */
    setAllHandleTransform() {
        const rect = this.element.getBoundingClientRect();
        this.setHandleTransform(this.dragHandleCornerElement, rect, 'both');
        this.setHandleTransform(this.dragHandleRightElement, rect, 'x');
        this.setHandleTransform(this.dragHandleBottomElement, rect, 'y');
    }
    /**
     * Checks if a tab is being dragged
     */
    isDraggingTab(activeItem, tab) {
        return activeItem?.isBusy && !activeItem?.isMaximized && activeItem?.tabs[0].component === tab.component;
    }
    /**
     * Checks if the given active item has a target orientation matching the provided orientation
     * for a specific dock ID.
     * Adds a preview before the user drops a dock item into that region.
     */
    getDockRegion(activeItem, dockId) {
        return activeItem && !activeItem.isMaximized && activeItem.targetId === dockId ? activeItem.orientation : '';
    }
    isMouseEventWithinDiv(event, element) {
        const { clientX, clientY } = event;
        const elementRect = element.getBoundingClientRect();
        const isXWithin = clientX >= elementRect.left && clientX <= elementRect.right;
        const isYWithin = clientY >= elementRect.top && clientY <= elementRect.bottom;
        return isXWithin && isYWithin;
    }
    setzIndex(element) {
        this.renderer.setStyle(element, 'z-index', this.dockService.getZIndex());
    }
    getLayoutOffset(rect) {
        return {
            width: rect.width,
            height: rect.height,
            bottom: rect.bottom,
            right: rect.right,
            top: 0,
            left: 0,
        };
    }
    /** switch elements position in an array */
    switchElements(arr, index1, index2) {
        // Check if the provided indices are within the array's bounds
        if (index1 >= 0 && index1 < arr.length && index2 >= 0 && index2 < arr.length) {
            // Use a temporary variable to swap the elements
            const temp = arr[index1];
            arr[index1] = arr[index2];
            arr[index2] = temp;
        }
        // Return the modified or unchanged array
        return arr;
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockComponent, deps: [{ token: DockService }, { token: DockStore }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.NgZone }, { token: DOCK_MESSAGE_CONFIG }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DockComponent, isStandalone: true, selector: "avn-dock", inputs: { setItem: "setItem" }, providers: [
            {
                provide: DOCK_MESSAGE_CONFIG,
                useValue: DEFAULT_DOCK_MESSAGE_CONFIG,
            },
        ], viewQueries: [{ propertyName: "dragHandleRight", first: true, predicate: ["dragHandleRight"], descendants: true }, { propertyName: "dragHandleCorner", first: true, predicate: ["dragHandleCorner"], descendants: true }, { propertyName: "dragHandleBottom", first: true, predicate: ["dragHandleBottom"], descendants: true }, { propertyName: "tabsContainerRef", first: true, predicate: ["tabsContainerRef"], descendants: true }, { propertyName: "actionButtonsContainerRef", first: true, predicate: ["actionButtonsContainerRef"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"item?.tabs?.length\" [ngStyle]=\"style\">\n  <div slot=\"drag-handle\" class=\"dock-tabs-container\" cdkDragHandle>\n    <div #tabsContainerRef class=\"dock-tabs\">\n      <div\n        *ngFor=\"let tab of item.tabs; let i = index\"\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        class=\"dock-tab\"\n        draggable=\"true\"\n        [class.active-dock-tab]=\"(item.activeTabIndex === i | applyFunction: isTabActive:[item, i]:this) || (activeItem$ | async | applyFunction: isDraggingTab:[tab])\"\n        [id]=\"'tab' + tab.component.dockKey\"\n        (cdkDragEnded)=\"onDragEnd($event, item, tab, i)\"\n        (cdkDragStarted)=\"onDragStart($event, item, tab, i)\"\n        (cdkDragMoved)=\"onDragMove($event, item, tab)\"\n        (click)=\"updateActiveTabIndex(item, i)\"\n      >\n        <div *ngIf=\"activeItem$ | async | applyFunction: isDraggingTab:[tab]\" class=\"mouse-shadow\"></div>\n        <div class=\"tab-title\">\n          <span>{{ tab.component?.dockTitle || 'Tab ' + (i + 1) }}</span>\n        </div>\n        <div class=\"remove-tab\" (click)=\"removeTab(item, i, $event)\"></div>\n      </div>\n    </div>\n    <div class=\"tab-preview\" *ngIf=\"(activeItem$ | async | applyFunction: getDockRegion:[item.id]) === 'center'\"></div>\n    <div #actionButtonsContainerRef class=\"action-buttons-container\" *ngIf=\"containerRect$ | async as containerRect\">\n      <avn-button *ngIf=\"(activeItem$ | async)?.isMaximized\" [icon]=\"'action:close_fullscreen'\" [size]=\"'small'\" (click)=\"restoreSize(item, containerRect)\"></avn-button>\n      <avn-button *ngIf=\"!(activeItem$ | async)?.isMaximized\" [icon]=\"'action:open_in_full'\" [size]=\"'small'\" (click)=\"onMaximize(item, containerRect)\"></avn-button>\n      <avn-button [icon]=\"'action:close'\" [size]=\"'small'\" (click)=\"onClose()\"></avn-button>\n    </div>\n  </div>\n\n  <ng-container *ngFor=\"let tab of item.tabs; let i = index\">\n    <div\n      class=\"dock-component\"\n      draggable=\"false\"\n      avnScroll\n      [style.width]=\"item.width\"\n      (mousedown)=\"$event.stopPropagation()\"\n      [class.hide]=\"i !== item.activeTabIndex\"\n      [class.tab-overlap]=\"tabsOverlapping\"\n      [id]=\"'component' + tab.component.dockKey\"\n      [ngClass]=\"activeItem$ | async | applyFunction: getDockRegion:[item.id]\"\n    >\n      <ng-container *ngComponentOutlet=\"tab.component\"></ng-container>\n    </div>\n  </ng-container>\n</ng-container>\n<!-- draggable axis  -->\n<ng-container *ngIf=\"containerRect$ | async as container\">\n  <ng-container *ngIf=\"docks$ | async as docks\">\n    <ng-container *ngIf=\"!(activeItem$ | async)?.isMaximized\">\n      <span\n        #dragHandleRight\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        cdkDragLockAxis=\"x\"\n        class=\"dragHandle right\"\n        (cdkDragMoved)=\"dragMove($event, item, docks, dragHandleRight, container, 'x')\"\n      >\n      </span>\n      <span\n        #dragHandleCorner\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        class=\"dragHandle corner\"\n        [cdkDragLockAxis]=\"'lockAxis'\"\n        (cdkDragMoved)=\"dragMove($event, item, docks, dragHandleCorner, container, 'both')\"\n      ></span>\n      <span\n        #dragHandleBottom\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        cdkDragLockAxis=\"y\"\n        class=\"dragHandle bottom\"\n        (cdkDragMoved)=\"dragMove($event, item, docks, dragHandleBottom, container, 'y')\"\n      >\n      </span>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", styles: [":host{min-width:100px;min-height:100px;transition:opacity .2s;display:flex;flex-direction:column;border:1px solid #cfd1d8;overflow:visible;background-color:var(--van-gray-6);position:absolute}:host.target .target-screen{display:block}:host.target .remove-dock:hover:before,:host.target .remove-dock:hover:after{background-color:#ff5f57;border:1px solid #df453f}.target-screen{display:none;position:absolute;left:0;top:0;width:100%;height:100%;background:#08b8bb;box-shadow:0 0 20px #16494a inset;opacity:.5}.mouse-shadow{display:block;position:absolute!important;pointer-events:none;width:20px;height:20px;background:radial-gradient(yellow,transparent);background-size:20px;background-position:-20px}.tab-title{margin-right:var(--space-base)}.remove-tab{padding:0!important;width:11px;height:11px;transition:.2s;cursor:pointer}.remove-tab:hover:before,.remove-tab:hover:after{background-color:var(--danger-base)}.remove-tab:before,.remove-tab:after{position:absolute;content:\"\";height:11px;width:2px;background-color:var(--ribbon-on)}.remove-tab:before{transform:rotate(45deg)}.remove-tab:after{transform:rotate(-45deg)}.dock-bar{cursor:move;padding:var(--space-sm);font-weight:400;min-height:30px}.cdk-drag-handle{cursor:move}.dock-tabs-container:has(.tab-preview){grid-template-columns:min-content min-content auto}.dock-tabs-container{display:grid;grid-template-columns:min-content auto;align-content:flex-end;height:40px;background-color:var(--ribbon-background);color:var(--ribbon-on);overflow:auto}.dock-tabs-container .action-buttons-container{justify-content:flex-end;display:inline-flex;gap:var(--space-xs);margin:0 var(--space-xs) 0 auto;order:2}.dock-tabs-container .action-buttons-container ::ng-deep avn-button button{background-color:var(--ribbon-background)}.dock-tabs-container .action-buttons-container ::ng-deep avn-button button.disabled{opacity:.3;cursor:not-allowed}.dock-tabs-container .action-buttons-container ::ng-deep avn-button button:hover:not(.disabled),.dock-tabs-container .action-buttons-container ::ng-deep avn-button button.toggled{background-color:var(--ribbon-variant-background);color:var(--ribbon-variant-on)}.dock-tabs-container .action-buttons-container ::ng-deep .pinned button{background-color:var(--ribbon-variant-background);color:var(--ribbon-variant-on)}.dock-tabs-container .tab-preview{display:inline-flex;margin-top:var(--space-xs);border-radius:3px 4px 0 0;background-color:var(--form-control-border);width:90px;height:34px}.dock-tabs-container .dock-tabs{white-space:nowrap;width:100%;margin-top:var(--space-xs)}.dock-tabs-container .dock-tabs .dock-tab{min-width:70px;z-index:9;display:flex}.dock-tabs-container .dock-tabs>div.dock-tab{cursor:pointer;display:inline-flex;-webkit-user-select:none;user-select:none;font-size:12px;font-weight:400;font-family:Helvetica,Arial,sans-serif;padding:var(--space-sm);border-top:1px solid #d0d1d9;border-right:1px solid #d0d1d9;border-radius:3px 4px 0 0}.dock-tabs-container .dock-tabs>div.dock-tab.active-dock-tab{background-color:var(--form-control-background);color:var(--ribbon-on);font-weight:bolder;border-bottom:2px solid var(--primary-base)}.dock-tabs-container .dock-tabs>div.dock-tab.active-dock-tab:before{content:\"\";position:absolute;right:100%;bottom:0;border-bottom:1px solid #fff}.dock-component{display:inline-block;flex:1;overflow:auto;padding:12px;position:relative;background:var(--form-control-background);box-sizing:border-box;color:var(--ribbon-on);width:inherit!important;height:inherit!important}.dock-component.hide{display:none;display:none!important}.center:not(.tab-overlap){background:var(--main-variant-background)}.vertical-right:not(.tab-overlap){background:linear-gradient(to left,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.vertical-left:not(.tab-overlap){background:linear-gradient(to right,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.horizontal-top:not(.tab-overlap){background:linear-gradient(to bottom,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.horizontal-bottom:not(.tab-overlap){background:linear-gradient(to top,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.dragHandle{position:absolute}.dragHandle:not(:hover){border:1px solid rgb(207,209,216)}.dragHandle:hover{background-color:var(--primary-base)}.dragHandle.corner{width:15px;height:15px;cursor:nwse-resize;border:none}.dragHandle.right{width:2px;height:100%;cursor:ew-resize;z-index:3}.dragHandle.bottom{height:2px;width:100%;cursor:n-resize;z-index:3}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "ngmodule", type: DragDropModule }, { kind: "directive", type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i4.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "ngmodule", type: ButtonModule }, { kind: "component", type: ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition", "iconTheme", "fullWidth"], outputs: ["actioned"] }, { kind: "ngmodule", type: CoreModule }, { kind: "directive", type: ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dock', standalone: true, imports: [CommonModule, DragDropModule, ButtonModule, CoreModule], providers: [
                        {
                            provide: DOCK_MESSAGE_CONFIG,
                            useValue: DEFAULT_DOCK_MESSAGE_CONFIG,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"item?.tabs?.length\" [ngStyle]=\"style\">\n  <div slot=\"drag-handle\" class=\"dock-tabs-container\" cdkDragHandle>\n    <div #tabsContainerRef class=\"dock-tabs\">\n      <div\n        *ngFor=\"let tab of item.tabs; let i = index\"\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        class=\"dock-tab\"\n        draggable=\"true\"\n        [class.active-dock-tab]=\"(item.activeTabIndex === i | applyFunction: isTabActive:[item, i]:this) || (activeItem$ | async | applyFunction: isDraggingTab:[tab])\"\n        [id]=\"'tab' + tab.component.dockKey\"\n        (cdkDragEnded)=\"onDragEnd($event, item, tab, i)\"\n        (cdkDragStarted)=\"onDragStart($event, item, tab, i)\"\n        (cdkDragMoved)=\"onDragMove($event, item, tab)\"\n        (click)=\"updateActiveTabIndex(item, i)\"\n      >\n        <div *ngIf=\"activeItem$ | async | applyFunction: isDraggingTab:[tab]\" class=\"mouse-shadow\"></div>\n        <div class=\"tab-title\">\n          <span>{{ tab.component?.dockTitle || 'Tab ' + (i + 1) }}</span>\n        </div>\n        <div class=\"remove-tab\" (click)=\"removeTab(item, i, $event)\"></div>\n      </div>\n    </div>\n    <div class=\"tab-preview\" *ngIf=\"(activeItem$ | async | applyFunction: getDockRegion:[item.id]) === 'center'\"></div>\n    <div #actionButtonsContainerRef class=\"action-buttons-container\" *ngIf=\"containerRect$ | async as containerRect\">\n      <avn-button *ngIf=\"(activeItem$ | async)?.isMaximized\" [icon]=\"'action:close_fullscreen'\" [size]=\"'small'\" (click)=\"restoreSize(item, containerRect)\"></avn-button>\n      <avn-button *ngIf=\"!(activeItem$ | async)?.isMaximized\" [icon]=\"'action:open_in_full'\" [size]=\"'small'\" (click)=\"onMaximize(item, containerRect)\"></avn-button>\n      <avn-button [icon]=\"'action:close'\" [size]=\"'small'\" (click)=\"onClose()\"></avn-button>\n    </div>\n  </div>\n\n  <ng-container *ngFor=\"let tab of item.tabs; let i = index\">\n    <div\n      class=\"dock-component\"\n      draggable=\"false\"\n      avnScroll\n      [style.width]=\"item.width\"\n      (mousedown)=\"$event.stopPropagation()\"\n      [class.hide]=\"i !== item.activeTabIndex\"\n      [class.tab-overlap]=\"tabsOverlapping\"\n      [id]=\"'component' + tab.component.dockKey\"\n      [ngClass]=\"activeItem$ | async | applyFunction: getDockRegion:[item.id]\"\n    >\n      <ng-container *ngComponentOutlet=\"tab.component\"></ng-container>\n    </div>\n  </ng-container>\n</ng-container>\n<!-- draggable axis  -->\n<ng-container *ngIf=\"containerRect$ | async as container\">\n  <ng-container *ngIf=\"docks$ | async as docks\">\n    <ng-container *ngIf=\"!(activeItem$ | async)?.isMaximized\">\n      <span\n        #dragHandleRight\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        cdkDragLockAxis=\"x\"\n        class=\"dragHandle right\"\n        (cdkDragMoved)=\"dragMove($event, item, docks, dragHandleRight, container, 'x')\"\n      >\n      </span>\n      <span\n        #dragHandleCorner\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        class=\"dragHandle corner\"\n        [cdkDragLockAxis]=\"'lockAxis'\"\n        (cdkDragMoved)=\"dragMove($event, item, docks, dragHandleCorner, container, 'both')\"\n      ></span>\n      <span\n        #dragHandleBottom\n        cdkDrag\n        cdkDragBoundary=\"avn-dock-layout\"\n        cdkDragLockAxis=\"y\"\n        class=\"dragHandle bottom\"\n        (cdkDragMoved)=\"dragMove($event, item, docks, dragHandleBottom, container, 'y')\"\n      >\n      </span>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", styles: [":host{min-width:100px;min-height:100px;transition:opacity .2s;display:flex;flex-direction:column;border:1px solid #cfd1d8;overflow:visible;background-color:var(--van-gray-6);position:absolute}:host.target .target-screen{display:block}:host.target .remove-dock:hover:before,:host.target .remove-dock:hover:after{background-color:#ff5f57;border:1px solid #df453f}.target-screen{display:none;position:absolute;left:0;top:0;width:100%;height:100%;background:#08b8bb;box-shadow:0 0 20px #16494a inset;opacity:.5}.mouse-shadow{display:block;position:absolute!important;pointer-events:none;width:20px;height:20px;background:radial-gradient(yellow,transparent);background-size:20px;background-position:-20px}.tab-title{margin-right:var(--space-base)}.remove-tab{padding:0!important;width:11px;height:11px;transition:.2s;cursor:pointer}.remove-tab:hover:before,.remove-tab:hover:after{background-color:var(--danger-base)}.remove-tab:before,.remove-tab:after{position:absolute;content:\"\";height:11px;width:2px;background-color:var(--ribbon-on)}.remove-tab:before{transform:rotate(45deg)}.remove-tab:after{transform:rotate(-45deg)}.dock-bar{cursor:move;padding:var(--space-sm);font-weight:400;min-height:30px}.cdk-drag-handle{cursor:move}.dock-tabs-container:has(.tab-preview){grid-template-columns:min-content min-content auto}.dock-tabs-container{display:grid;grid-template-columns:min-content auto;align-content:flex-end;height:40px;background-color:var(--ribbon-background);color:var(--ribbon-on);overflow:auto}.dock-tabs-container .action-buttons-container{justify-content:flex-end;display:inline-flex;gap:var(--space-xs);margin:0 var(--space-xs) 0 auto;order:2}.dock-tabs-container .action-buttons-container ::ng-deep avn-button button{background-color:var(--ribbon-background)}.dock-tabs-container .action-buttons-container ::ng-deep avn-button button.disabled{opacity:.3;cursor:not-allowed}.dock-tabs-container .action-buttons-container ::ng-deep avn-button button:hover:not(.disabled),.dock-tabs-container .action-buttons-container ::ng-deep avn-button button.toggled{background-color:var(--ribbon-variant-background);color:var(--ribbon-variant-on)}.dock-tabs-container .action-buttons-container ::ng-deep .pinned button{background-color:var(--ribbon-variant-background);color:var(--ribbon-variant-on)}.dock-tabs-container .tab-preview{display:inline-flex;margin-top:var(--space-xs);border-radius:3px 4px 0 0;background-color:var(--form-control-border);width:90px;height:34px}.dock-tabs-container .dock-tabs{white-space:nowrap;width:100%;margin-top:var(--space-xs)}.dock-tabs-container .dock-tabs .dock-tab{min-width:70px;z-index:9;display:flex}.dock-tabs-container .dock-tabs>div.dock-tab{cursor:pointer;display:inline-flex;-webkit-user-select:none;user-select:none;font-size:12px;font-weight:400;font-family:Helvetica,Arial,sans-serif;padding:var(--space-sm);border-top:1px solid #d0d1d9;border-right:1px solid #d0d1d9;border-radius:3px 4px 0 0}.dock-tabs-container .dock-tabs>div.dock-tab.active-dock-tab{background-color:var(--form-control-background);color:var(--ribbon-on);font-weight:bolder;border-bottom:2px solid var(--primary-base)}.dock-tabs-container .dock-tabs>div.dock-tab.active-dock-tab:before{content:\"\";position:absolute;right:100%;bottom:0;border-bottom:1px solid #fff}.dock-component{display:inline-block;flex:1;overflow:auto;padding:12px;position:relative;background:var(--form-control-background);box-sizing:border-box;color:var(--ribbon-on);width:inherit!important;height:inherit!important}.dock-component.hide{display:none;display:none!important}.center:not(.tab-overlap){background:var(--main-variant-background)}.vertical-right:not(.tab-overlap){background:linear-gradient(to left,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.vertical-left:not(.tab-overlap){background:linear-gradient(to right,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.horizontal-top:not(.tab-overlap){background:linear-gradient(to bottom,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.horizontal-bottom:not(.tab-overlap){background:linear-gradient(to top,var(--main-variant-background) 50%,var(--form-control-background) 50%)}.dragHandle{position:absolute}.dragHandle:not(:hover){border:1px solid rgb(207,209,216)}.dragHandle:hover{background-color:var(--primary-base)}.dragHandle.corner{width:15px;height:15px;cursor:nwse-resize;border:none}.dragHandle.right{width:2px;height:100%;cursor:ew-resize;z-index:3}.dragHandle.bottom{height:2px;width:100%;cursor:n-resize;z-index:3}\n"] }]
        }], ctorParameters: function () { return [{ type: DockService }, { type: DockStore }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCK_MESSAGE_CONFIG]
                }] }]; }, propDecorators: { dragHandleRight: [{
                type: ViewChild,
                args: ['dragHandleRight']
            }], dragHandleCorner: [{
                type: ViewChild,
                args: ['dragHandleCorner']
            }], dragHandleBottom: [{
                type: ViewChild,
                args: ['dragHandleBottom']
            }], tabsContainerRef: [{
                type: ViewChild,
                args: ['tabsContainerRef']
            }], actionButtonsContainerRef: [{
                type: ViewChild,
                args: ['actionButtonsContainerRef']
            }], setItem: [{
                type: Input
            }] } });

class DockBoardComponent {
    constructor(dockService, renderer2, element, store) {
        this.dockService = dockService;
        this.renderer2 = renderer2;
        this.store = store;
        this.activeItem$ = this.store.selectActiveItem$;
        this.element = element.nativeElement;
    }
    ngOnInit() {
        this.configureBoardId();
        if (this.preset) {
            if (!this.dockService.presets) {
                this.dockService.presets = [];
            }
            this.dockService.presets.push(this.preset);
            this.loadPreset(this.preset);
        }
        this.docks$ = this.store.selectDocksByBoard(this.boardId);
    }
    /**
     * Loads the specified preset in the GUI menu.
     * @param {DockPreset} preset - The preset to load.
     */
    loadPreset(preset) {
        this.loadStackFrom(preset);
    }
    loadStackFrom(preset) {
        const areas = [];
        preset.docks.forEach((dock) => {
            const { left: _left, top: _top, width: _width, height: _height } = dock;
            const ww = this.dockService.width;
            const wh = this.dockService.height;
            const left = (_left * ww) / 100;
            const top = (_top * wh) / 100;
            const width = (_width * ww) / 100;
            const height = (_height * wh) / 100;
            const right = left + width;
            const bottom = top + height;
            areas.push({ left, top, right, bottom });
            this.store.addStackItem({
                boardId: preset.name,
                tabs: dock.array
                    ? dock.array
                    : [
                        {
                            component: dock.component,
                        },
                    ],
                props: {
                    left,
                    top,
                    width: DockService.gridNumberPrev(width),
                    height: _top + _height === 100 ? DockService.gridNumberPrev(wh) - top : DockService.gridNumberPrev(bottom) - top,
                },
            });
        });
    }
    /**
     * Configures the unique ID for the board element.
     */
    configureBoardId() {
        const boardId = this.preset.name;
        this.element.id = boardId;
        this.boardId = boardId;
    }
    /**
     * Ensures that the dragged element remains visually on top of other elements while being dragged.
     */
    onDragStart(cdk) {
        this.setZIndex(cdk.source.element.nativeElement);
    }
    /**
     * Checks the visibility of a dock based on the activeItem parameter.
     */
    isDockHidden(activeItem, dockId) {
        return activeItem?.isMaximized && dockId !== activeItem?.id;
    }
    /**
     * Handle the drag end event, when the user stops dragging a dock-item.
     */
    onDragEnd(e, dock) {
        const rect = e.source.element.nativeElement;
        dock.top = rect.offsetTop;
        dock.left = rect.offsetLeft;
        dock.bottom = dock.top + dock.height;
        dock.right = dock.left + dock.width;
        dock.collidingDocks = [];
        const dockComponent = this.dockComponents.find((component) => component.item.id === dock.id);
        dockComponent.setAllHandleTransform();
    }
    ngOnDestroy() {
        this.dockMenu = null;
        this.dockMap = null;
        this.dockService.presets = null;
    }
    /**
     * Sets the z-index of an element.
     * @param {HTMLElement} element - The element to set the z-index for.
     * @param {number} [zIndex] - The z-index value. If not provided, a new z-index will be obtained from the `dockService`.
     */
    setZIndex(element, zIndex) {
        zIndex = this.dockService.getZIndex();
        this.renderer2.setStyle(element, 'z-index', zIndex);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockBoardComponent, deps: [{ token: DockService }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: DockStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DockBoardComponent, isStandalone: true, selector: "avn-dock-board", inputs: { preset: "preset", dockMap: "dockMap", dockMenu: "dockMenu" }, viewQueries: [{ propertyName: "dockComponents", predicate: DockComponent, descendants: true }], ngImport: i0, template: "<avn-dock\n  *ngFor=\"let dock of docks$ | async\"\n  cdkDrag\n  class=\"dock-panel\"\n  cdkDragBoundary=\"avn-dock-layout\"\n  [style.top.px]=\"dock.top\"\n  [style.left.px]=\"dock.left\"\n  [style.height.px]=\"dock.height\"\n  [style.width.px]=\"dock.width\"\n  [setItem]=\"dock\"\n  [id]=\"dock.id\"\n  [hidden]=\"activeItem$ | async | applyFunction: isDockHidden:[dock.id]\"\n  (cdkDragStarted)=\"onDragStart($event)\"\n  (cdkDragEnded)=\"onDragEnd($event, dock)\"\n></avn-dock>\n", styles: [".dock-panel{width:inherit;height:inherit}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "ngmodule", type: DragDropModule }, { kind: "directive", type: i4.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "ngmodule", type: CoreModule }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }, { kind: "component", type: DockComponent, selector: "avn-dock", inputs: ["setItem"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockBoardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dock-board', standalone: true, imports: [CommonModule, DragDropModule, CoreModule, DockComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-dock\n  *ngFor=\"let dock of docks$ | async\"\n  cdkDrag\n  class=\"dock-panel\"\n  cdkDragBoundary=\"avn-dock-layout\"\n  [style.top.px]=\"dock.top\"\n  [style.left.px]=\"dock.left\"\n  [style.height.px]=\"dock.height\"\n  [style.width.px]=\"dock.width\"\n  [setItem]=\"dock\"\n  [id]=\"dock.id\"\n  [hidden]=\"activeItem$ | async | applyFunction: isDockHidden:[dock.id]\"\n  (cdkDragStarted)=\"onDragStart($event)\"\n  (cdkDragEnded)=\"onDragEnd($event, dock)\"\n></avn-dock>\n", styles: [".dock-panel{width:inherit;height:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: DockService }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: DockStore }]; }, propDecorators: { dockComponents: [{
                type: ViewChildren,
                args: [DockComponent]
            }], preset: [{
                type: Input
            }], dockMap: [{
                type: Input
            }], dockMenu: [{
                type: Input
            }] } });

/**
 * Component that manages the dock layout.
 */
class DockLayoutComponent {
    set components(components) {
        [this.menu, this.dockMap] = this.createMenuAndMap(components);
    }
    constructor(dockService, element, dockStore) {
        this.dockService = dockService;
        this.element = element;
        this.dockStore = dockStore;
        this.menu = null;
        this.dockMap = null;
        this.docks$ = this.dockStore.selectDocks$;
        this._componentDestroyed$ = new Subject();
    }
    ngAfterViewInit() {
        // keep track of mouse event in  order to detect target dock item
        fromEvent(this.element.nativeElement, 'mousemove')
            .pipe(withLatestFrom(this.dockStore.selectActiveItem$), filter(([, activeItem]) => !!activeItem), takeUntil(this._componentDestroyed$))
            .subscribe(([event]) => this.dockStore.updateTargetDock(event));
        const sizeChanges$ = this.dockService.observeElementSize(this.element.nativeElement);
        sizeChanges$
            .pipe(withLatestFrom(this.dockStore.selectStack$), debounceTime(100), takeUntil(this._componentDestroyed$))
            .subscribe(([offset, stack]) => {
            this.updateDockItemStyles(offset, stack);
        });
    }
    isDimensionDefined(docks) {
        if (docks.length === 0) {
            return false;
        }
        return docks.some((dock) => !isNaN(dock.width) || !isNaN(dock.height));
    }
    ngOnDestroy() {
        this._componentDestroyed$.next();
        this._componentDestroyed$.complete();
    }
    /**
     * Updates the style properties of items in the stack based on the layout offset.
     */
    updateDockItemStyles(layoutOffset, stack) {
        const updatedStack = new Map();
        const boardNumber = stack.size;
        let index = 0;
        for (const [key, items] of stack.entries()) {
            const updatedItems = items.map((item) => {
                return {
                    ...item,
                    width: item.width || layoutOffset.width / boardNumber,
                    height: item.height || layoutOffset.height,
                    top: item.top || layoutOffset.top / boardNumber,
                    left: item.left || layoutOffset.width - (layoutOffset.width / boardNumber) * (boardNumber - index),
                    right: item.right || layoutOffset.left + layoutOffset.width * ((boardNumber - index) / boardNumber),
                    bottom: item.bottom || item.top + item.height,
                };
            });
            updatedStack.set(key, updatedItems);
            index++;
        }
        this.dockStore.updateStack(updatedStack);
        this.dockStore.updateContainerRect(document.querySelector('avn-dock-layout').getBoundingClientRect());
    }
    /**
     * Creates a menu and map from an array of wrapper components.
     */
    createMenuAndMap(wrapperComponents) {
        const dockMap = {};
        const menu = wrapperComponents.map((item) => {
            dockMap[item.dockKey] = {
                component: item,
            };
            return {
                key: item.dockKey,
                name: item.dockTitle,
            };
        });
        return [menu, dockMap];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockLayoutComponent, deps: [{ token: DockService }, { token: i0.ElementRef }, { token: DockStore }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.4", type: DockLayoutComponent, isStandalone: true, selector: "avn-dock-layout", inputs: { components: "components", presets: "presets" }, ngImport: i0, template: "<div class=\"boundary-container\" *ngIf=\"menu && dockMap\">\n  <ng-container *ngFor=\"let board of presets; let i = index\">\n    <avn-dock-board\n    \t[hidden]=\"!(docks$ | async | applyFunction:isDimensionDefined)\"\n      [id]=\"board.name\"\n      [dockMap]=\"dockMap\"\n      [dockMenu]=\"menu\"\n      [preset]=\"board\">\n  </avn-dock-board>\n  </ng-container>\n</div>\n", styles: [":host{display:block;width:100%;height:100%}:host .boundary-container{display:flex}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "ngmodule", type: CoreModule }, { kind: "pipe", type: ApplyFunctionPipe, name: "applyFunction" }, { kind: "component", type: DockBoardComponent, selector: "avn-dock-board", inputs: ["preset", "dockMap", "dockMenu"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.4", ngImport: i0, type: DockLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-dock-layout', standalone: true, imports: [CommonModule, CoreModule, DockBoardComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"boundary-container\" *ngIf=\"menu && dockMap\">\n  <ng-container *ngFor=\"let board of presets; let i = index\">\n    <avn-dock-board\n    \t[hidden]=\"!(docks$ | async | applyFunction:isDimensionDefined)\"\n      [id]=\"board.name\"\n      [dockMap]=\"dockMap\"\n      [dockMenu]=\"menu\"\n      [preset]=\"board\">\n  </avn-dock-board>\n  </ng-container>\n</div>\n", styles: [":host{display:block;width:100%;height:100%}:host .boundary-container{display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: DockService }, { type: i0.ElementRef }, { type: DockStore }]; }, propDecorators: { components: [{
                type: Input
            }], presets: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ASYNC_DATA_CONFIG, ASYNC_DATA_ERROR_HANDLER, AVAILABLE_THEMES, AccordionComponent, AccordionModule, AccordionPanelComponent, ActionBarComponent, ActionBarItemPriority, ActionBarModule, AlignmentFixtures, AnalyticsDirective, AnalyticsModule, AnalyticsService, AnchorLocks, AnchorNames, ApiRequestState, ApplyFunctionPipe, AsyncDataDirective, AsyncDataModule, AsyncDataService, AutocompleteComponent, AutocompleteModule, AvatarComponent, AvatarModule, BackgroundDirective, BadgeComponent, BadgeModule, BottomSheetContainerComponent, BreadcrumbComponent, BreadcrumbsComponent, BrowserWindowRef, ButtonColorType, ButtonComponent, ButtonModule, CALENDAR_CONFIG, CalendarComponent, CalendarModule, CardAlternateContentComponent, CardComponent, CardContentComponent, CardModule, CarouselComponent, CarouselItemDirective, CarouselModule, CarouselType, CheckboxComponent, CheckboxGroupComponent, CheckboxGroupModule, CheckboxModule, ColorSetsService, ConcatStringPipe, ConnectedElementComponent, ConnectedElementModule, ContextMenuComponent, ContextMenuDirective, ContextMenuModule, ContextMenuPlacementTypes, ContextMenuService, ContextMenuTriggerTypes, CoreModule, CountIconComponent, DATE_FORMAT_LONG, DATE_FORMAT_MEDIUM, DATE_FORMAT_SHORT, DATE_TIME_FORMAT_LONG, DATE_TIME_FORMAT_LONG_SECS, DATE_TIME_FORMAT_MEDIUM, DATE_TIME_FORMAT_MEDIUM_SECS, DATE_TIME_FORMAT_SHORT, DATE_TIME_FORMAT_SHORT_SECS, DATE_TIME_OPTIONS, DEFAULT_ASYNC_DATA_CONFIG, DEFAULT_CALENDAR_CONFIG, DEFAULT_DATE_TIME_OPTIONS, DEFAULT_FILE_UPLOADER_STATE, DEFAULT_FORM_CONTROL_VALIDATION_OPTIONS, DEFAULT_LAYOUT_SETTINGS, DEFAULT_MEDIA_BREAKPOINT_CONFIG, DEFAULT_OPTION_HEIGHT, DEFAULT_SCROLL_OPTIONS, DEFAULT_SKELETON_TEMPLATE_CONFIG, DEFAULT_SLIDE_DIALOG_CONFIG, DEFAULT_STANDARD_DIALOG_CONFIG, DEFAULT_TABS_CONFIG, DEFAULT_TASK_PANEL_SETTINGS, DEFAULT_THEME, DEFAULT_THEME_CONFIG, DEFAULT_THEME_PROVIDERS, DEFAULT_TIMELINE_ITEM_TYPE, DEFAULT_TOAST_SETTINGS, DataTableActionsComponent, DataTableComponent, DataTableModule, DataTableNotificationMessageComponent, DataTableSelectionMode, DateFormatPipe, DateLocaleService, DefaultFileUploaderTableColumnsConfig, DetailContentComponent, DetailFooterComponent, DetailHeaderComponent, DetailLayoutComponent, DetailViewDirective, DialogContentComponent, DialogFooterComponent, DialogHeaderComponent, DialogLayoutComponent, DimensionsProviderService, DockLayoutComponent, DragAndDropDirective, DragDirective, DragDropElementOriginDirective, DragDropElementTargetDirective, DragDropFileTargetDirective, DrawerContentComponent, DrawerFooterComponent, DrawerHeaderComponent, DrawerLayoutComponent, DropdownComponent, DropdownModule, DropdownTriggerDirective, EmptyDataMessageComponent, EmptyDataMessageModule, FORM_CONTROL_VALIDATION_OPTIONS, FabButtonDirective, FabSpeedDialComponent, FabSpeedDialModule, FabToggleDirective, FallbackImageDirective, FieldMatcherDirective, FileDataTableColumns, FilePickerDirective, FileSizePipe, FileStatus, FileUploaderComponent, FileUploaderModule, FileUploaderStore, FileUploaderTableColumnField, FitFixtures, FocalModalDirective, FormControlComponent, FormFieldComponent, FormFieldErrorComponent, FormFieldHintComponent, FormFieldModule, GOOGLE_ANALYTICS_CONFIGURATION, GOOGLE_ANALYTICS_DIMENSIONS_PROVIDER, GOOGLE_ANALYTICS_METRICS_PROVIDER, GoogleAnalyticsService, GridComponent, GridElementDirective, GridListComponent, GridListHeaderComponent, GridListHeaderCountTemplateDirective, GridListHeaderTemplateDirective, GridListItemTemplateDirective, GridListModule, GridSizeSelectorComponent, GridSizeSelectorModule, HamburgerComponent, HasChildClassDirective, HideForDevicesDirective, IAnalyticsEvent, IAnalyticsException, IAnalyticsPageView, IBadgeSize, ISlideButton, IStepperCancelledEvent, IStepperCompletedEvent, IStepperStepChangedEvent, IconComponent, IconModule, ImageFitStrategy, ImageRetryDirective, InfiniteScrollComponentStore, InputComponent, InputDateTimePickerComponent, InputDateTimePickerModule, InputModule, InputRegexDirective, IntegerOnlyDirective, LAYOUT_INITIAL_STATE, LAYOUT_SETTINGS, LAZY_COMPONENT_DATA, LAZY_COMPONENT_MODULES_MAP, LAZY_MODULES_PERMISSIONS_PROVIDER, LayoutComponent, LayoutDeviceBreakpoint, LayoutDeviceType, LayoutModule, LayoutStore, LazyComponentDirective, LazyComponentModule, LazyLoadingDirective, LinearLoaderComponent, LoaderComponent, LoaderIconRegistryService, LoaderModule, LoadingState, LongPressDirective, MEDIA_BREAKPOINT_CONFIG, MEDIA_BREAKPOINT_INITIAL_STATE, MODAL_CLOSE_ANIMATION, MODAL_CONFIG, MODAL_DATA, MODAL_OPEN_ANIMATION, MODAL_TYPE, MainComponent, MapToPipe, MasterDetailComponent, MasterDetailModule, MasterViewDirective, MediaAssetType, MediaBreakpointStore, MediaCardComponent, MediaCardModule, MenuCardComponent, MenuCardModule, MetricsProviderService, MockServerResultsService, ModalContainerComponent, ModalDialogType, ModalManagementService, ModalModule, ModalRef, ModalService, ModalType, MultiClickDirective, MultiInputComponent, MultiInputModule, NavComponent, NavContentDirective, NavItemComponent, NavTabBarComponent, NavTabBarItemComponent, NavTabBarResponsiveDirective, NestedPropertyPipe, NlpExpressionInputComponent, NlpExpressionInputModule, NlpExpressionParser, NlpOverlayComponent, NlpOverlayService, NlpSuggestionOverlayDirective, OVERLAY_REF, OptionComponent, OptionListComponent, OptionModule, OverlayComponent, OverlayModule, PageComponent, PanelBodyComponent, PanelComponent, PanelFooterComponent, PanelHeaderComponent, PanelModule, PassswordInputModule, PasswordIndicatorComponent, PasswordInputComponent, PasswordMessageLevel, PasswordStrength, PasswordValidationItem, PlacementTypes, ProgressSegmentComponent, ProgressbarComponent, ProgressbarModule, QueryParamDirective, RADIO_GROUP_COMPONENT, RIBBON_HEIGHT, RadioChangeEvent, RadioComponent, RadioGroupComponent, RadioModule, ResizeDirective, ResizeableLayoutComponent, ResizeableLayoutModule, ResizeableLayoutSectionDirective, ResponsiveElementDirective, RibbonActionsComponent, RibbonAlternateContentComponent, RibbonCardComponent, RibbonComponent, RibbonContentComponent, RibbonDisplayItemDirective, RibbonFacetsComponent, SCROLL_OPTIONS, SKELETON_TEMPLATE_CONFIG, SchedulerComponent, SchedulerItemType, SchedulerModule, SchedulerSyncType, ScrollDirective, ScrollService, SectionBreadcrumbComponent, SelectComponent, SelectModule, SelectedHighlightDirective, SelectedValueDisplayMode, ShowForDevicesDirective, SideNavMode, SideTabComponent, SideTabGroupComponent, SideTabLazyLoadingDirective, SideTabModule, SidebarItemComponent, SidenavComponent, SkeletonAnimateDirection, SkeletonBoneComponent, SkeletonBoneDimensionType, SkeletonBoneType, SkeletonComponent, SkeletonModule, SkeletonType, SlideDialogComponent, SlideDialogModule, SliderComponent, SliderHandlerEnum, SliderModule, SlotDirective, StandardDialogComponent, StandardToastComponent, StatusIconComponent, StepperButtonCancelDirective, StepperButtonCompleteDirective, StepperButtonNextDirective, StepperButtonPreviousDirective, StepperComponent, StepperModule, StepperStepComponent, StepperStepHeaderComponent, StepperStepLabelDirective, SummaryCardComponent, SummaryCardModule, SwitchComponent, SwitchModule, TABS_CONFIG, TASK_PANEL_RUNNING_TASKS, TASK_PANEL_SETTINGS, THEME_ASPECT, TIME_FORMAT, TIME_FORMAT_MILLISECONDS, TIME_FORMAT_SECONDS, TOAST_DATA, TOAST_SETTINGS, TOP_NAV_HEIGHT, TabComponent, TabsComponent, TabsDropdownComponent, TabsHeaderComponent, TabsModule, TabsScrollComponent, TaskPanelItemActionSlotDirective, TaskPanelItemComponent, TaskPanelItemFeedbackSlotDirective, TaskPanelItemIconSlotDirective, TaskPanelService, TestTheme, TestingFormControlValidationProvider, TestingScrollConfigProvider, TestingWindowProvider, TestingWindowProviders, TextOverFlowDirective, TextareaComponent, TextareaModule, ThemeAspect, ThemeDirective, ThemeService, ThemeShade, ThemeType, ThemifyDirective, ThemingDirective, TimeAgoPipe, TimePickerComponent, TimePickerModule, TimelineComponent, TimelineItemComponent, TimelineItemType, TimelineLayoutMode, TimelineModule, TimelineScrubberComponentV1, TimelineSyncType, TimelineV2Component, TimelineV2Module, ToSelectOptionPipe, ToastAlignmentType, ToastBaseComponent, ToastQueueComponent, ToastRef, ToastService, ToggleFullscreenDirective, TooltipComponent, TooltipDirective, TooltipModule, TopnavComponent, TopnavTitleComponent, TransformableElementStageComponent, TransformableElementToolbarComponent, TreeSidebarComponent, TreeviewComponent, TreeviewModule, TriggerTypes, WINDOW, WidgetComponent, WidgetFooterComponent, WidgetModule, WindowRef, _CdkStepLabel, avnStepperAnimations, combineDataStates, convertStringEnumToObjArray$1 as convertStringEnumToObjArray, cssVariableToThemeProperty, dataOnceReady, dataWhenReady, dateRangeValidator, dateTimeToString, detectChanges, displayTimeWithMS$1 as displayTimeWithMS, dropdownAnimations, enumToMap, fieldMatcherValidator, filterNil, formatFileSize, generateColorInformation, generateColorVariables, generateDataTableVariables, generateFormControlVariables, generateLayoutVariables, generateMapVariables, generateModalVariables, generateOtherComponentVariables, generateSelectionComponentVariables, generateSurfaceVariables, generateThemeDefaults, generateThemeShades, generateThumbnail$, getAsyncDataError, getChildrenNodesOfType, getFallbackIcon, getFirstDayOfWeek, getNextCharNotEmpty, getNodeById, getPreviousCharNotEmpty, getRootCssVariables, getScrollbarHeight, getScrollbarWidth, getShade, getTimelineDisplayTime, hasAsyncDataError, is12HourTimeLocale, isFalsy, isFileAllowed, isTruthy, msToTime$1 as msToTime, numberRangeValidator, padEndWithZero$1 as padEndWithZero, padStartWithZero$1 as padStartWithZero, padWithZeros, percentToNumber, pxToNumber, resolveForegroundColor, stringToDateTime, themePropertyToCssVariable, timeMsToTime, timeToMs$1 as timeToMs, toHexColorString, toRelativeTime, toRgbColorString, toRgbaColorString, toThemeNameDisplay, toZonedDateTime, trimLeft, trimWrapperChar, windowFactory };
